var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _context, _semanticContext, _l, _m, _n, _o, _p, _q, _r2, _s2, _t2, _u, _v2, _w2, _x, _text, _y, _z, _A, _B, _C2, _D, _cachedHashCode, _E2, _F, _G, _H, _I, _J, _K, _L, _M, _N2, _O2, _P, _Q, _R, _S2, _label, _T2, _U, _label2, _V, _W, _outermostPrecedenceReturn, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _keys, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _modeStack, _text2, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea, _Fa, _Ga, _Ha, _Ia, _Ja, _Ka, _La, _Ma, _Na, _Oa, _Pa, _Qa, _Ra, _Sa, _Ta, _Ua, _Va, _Wa, _Xa, _Ya, _Za, __a, _$a, _ab, _bb, _cb, _db, _eb, _fb, _gb, _hb, _ib, _jb, _kb, _lb, _ruleIndex, _mb, _nb, _inputStream, _ob, _overrideDecision, _overrideDecisionInputIndex, _grammarFileName, _atn, _ruleNames, _vocabulary, _pb, _qb, _rb, _sb, _tb, _ub, _vb, _wb, _xb, _yb, _grammarFileName2, _atn2, _ruleNames2, _channelNames, _modeNames, _vocabulary2, _zb, _Ab, _Bb, _Cb, _Db, _Eb, _Fb, _Gb;
import { provide, inject, defineComponent, computed, toRefs, unref, ref, reactive, h as h$3, getCurrentInstance, watch, onMounted, nextTick, onUnmounted, isRef, createElementBlock, openBlock, createElementVNode, createVNode, resolveComponent, mergeProps, renderSlot, mergeModels, useModel, createBlock, withCtx, createCommentVNode, normalizeClass, toDisplayString, withModifiers, normalizeStyle, Fragment, createTextVNode, onErrorCaptured, renderList, shallowRef, watchEffect, toRaw, defineAsyncComponent, resolveDynamicComponent, onUpdated, onBeforeMount, onBeforeUpdate } from "vue";
import { isNullOrUndefinedOrWhiteSpace, HttpClient, createHttpRequestMessage, isNullOrUndefinedOrEmptyArray, Logger, isObject as isObject$4, isString as isString$1, isFunction as isFunction$3, withInstall, renderPlaceholder, CountDownEvent, renderNamedPlaceholder } from "@vantis/shared";
import ElementPlus, { useNamespace, uploadProps, ElMessage, ElRow, ElCol, ElIcon, useFormItem, useGlobalConfig, provideGlobalConfig, ElButton, ElCard, ElSelect, ElOption, ElCascader } from "element-plus";
import { View, Dom, Angle, Point, NumberExt, GeometryUtil, Graph as Graph$2, Basecoat, CssLoader, Collection, FunctionExt, Rectangle, Cell, ModifierKey, Vector, ArrayExt, Disposable, Config, Model, ObjectExt, Node as Node$1, GraphView, Platform, Util as Util$2, BackgroundManager, Shape } from "@antv/x6";
import { useFormValidator, useFormInstanceArrayWrapper, useFormValidatorMapWrapper, useNamedFormValidator, useMultipleFormValidator, useNamedFormInstanceArrayWrapper, useNamedFormValidatorArrayWrapper, useNamedMultipleFormValidator, MultipleFormValidator, FormValidator } from "@vantis/hooks";
import { register } from "@antv/x6-vue-shape";
const __vite_glob_0_10 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get convertToFormItemRules() {
    return convertToFormItemRules;
  }
}, Symbol.toStringTag, { value: "Module" }));
const formSchemaKey = Symbol("fd:formSchema");
const provideFormSchema = (formSchema) => {
  provide(formSchemaKey, formSchema);
};
const injectFormSchema = () => {
  return inject(formSchemaKey);
};
var rn$2 = Object.defineProperty;
var Ne$2 = Object.getOwnPropertySymbols;
var vt$2 = Object.prototype.hasOwnProperty, bt$2 = Object.prototype.propertyIsEnumerable;
var mt$2 = (t2, e10, n2) => e10 in t2 ? rn$2(t2, e10, { enumerable: true, configurable: true, writable: true, value: n2 }) : t2[e10] = n2, fe$2 = (t2, e10) => {
  for (var n2 in e10 || (e10 = {}))
    vt$2.call(e10, n2) && mt$2(t2, n2, e10[n2]);
  if (Ne$2)
    for (var n2 of Ne$2(e10))
      bt$2.call(e10, n2) && mt$2(t2, n2, e10[n2]);
  return t2;
};
var Ve$2 = (t2, e10) => {
  var n2 = {};
  for (var o2 in t2)
    vt$2.call(t2, o2) && e10.indexOf(o2) < 0 && (n2[o2] = t2[o2]);
  if (t2 != null && Ne$2)
    for (var o2 of Ne$2(t2))
      e10.indexOf(o2) < 0 && bt$2.call(t2, o2) && (n2[o2] = t2[o2]);
  return n2;
};
const Bt$2 = "[vue-draggable-plus]: ";
function gn$2(t2) {
  console.warn(Bt$2 + t2);
}
function mn$2(t2) {
  console.error(Bt$2 + t2);
}
function wt$2(t2, e10, n2) {
  return n2 >= 0 && n2 < t2.length && t2.splice(n2, 0, t2.splice(e10, 1)[0]), t2;
}
function vn$2(t2) {
  return t2.replace(/-(\w)/g, (e10, n2) => n2 ? n2.toUpperCase() : "");
}
function bn$2(t2) {
  return Object.keys(t2).reduce((e10, n2) => (typeof t2[n2] != "undefined" && (e10[vn$2(n2)] = t2[n2]), e10), {});
}
function Et$2(t2, e10) {
  return Array.isArray(t2) && t2.splice(e10, 1), t2;
}
function St$2(t2, e10, n2) {
  return Array.isArray(t2) && t2.splice(e10, 0, n2), t2;
}
function yn$2(t2) {
  return typeof t2 == "undefined";
}
function wn$2(t2) {
  return typeof t2 == "string";
}
function Dt$2(t2, e10, n2) {
  const o2 = t2.children[n2];
  t2.insertBefore(e10, o2);
}
function qe$2(t2) {
  t2.parentNode && t2.parentNode.removeChild(t2);
}
function En$2(t2, e10 = document) {
  var o2;
  let n2 = null;
  return typeof (e10 == null ? void 0 : e10.querySelector) == "function" ? n2 = (o2 = e10 == null ? void 0 : e10.querySelector) == null ? void 0 : o2.call(e10, t2) : n2 = document.querySelector(t2), n2 || gn$2(`Element not found: ${t2}`), n2;
}
function Sn$2(t2, e10, n2 = null) {
  return function(...o2) {
    return t2.apply(n2, o2), e10.apply(n2, o2);
  };
}
function Dn$2(t2, e10) {
  const n2 = fe$2({}, t2);
  return Object.keys(e10).forEach((o2) => {
    n2[o2] ? n2[o2] = Sn$2(t2[o2], e10[o2]) : n2[o2] = e10[o2];
  }), n2;
}
function _n$2(t2) {
  return t2 instanceof HTMLElement;
}
function _t$2(t2, e10) {
  Object.keys(t2).forEach((n2) => {
    e10(n2, t2[n2]);
  });
}
function Tn$2(t2) {
  return t2.charCodeAt(0) === 111 && t2.charCodeAt(1) === 110 && // uppercase letter
  (t2.charCodeAt(2) > 122 || t2.charCodeAt(2) < 97);
}
const Cn$2 = Object.assign;
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Tt$2(t2, e10) {
  var n2 = Object.keys(t2);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(t2);
    e10 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(t2, r3).enumerable;
    })), n2.push.apply(n2, o2);
  }
  return n2;
}
function te$2(t2) {
  for (var e10 = 1; e10 < arguments.length; e10++) {
    var n2 = arguments[e10] != null ? arguments[e10] : {};
    e10 % 2 ? Tt$2(Object(n2), true).forEach(function(o2) {
      On$2(t2, o2, n2[o2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t2, Object.getOwnPropertyDescriptors(n2)) : Tt$2(Object(n2)).forEach(function(o2) {
      Object.defineProperty(t2, o2, Object.getOwnPropertyDescriptor(n2, o2));
    });
  }
  return t2;
}
function Xe$2(t2) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xe$2 = function(e10) {
    return typeof e10;
  } : Xe$2 = function(e10) {
    return e10 && typeof Symbol == "function" && e10.constructor === Symbol && e10 !== Symbol.prototype ? "symbol" : typeof e10;
  }, Xe$2(t2);
}
function On$2(t2, e10, n2) {
  return e10 in t2 ? Object.defineProperty(t2, e10, {
    value: n2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : t2[e10] = n2, t2;
}
function re$2() {
  return re$2 = Object.assign || function(t2) {
    for (var e10 = 1; e10 < arguments.length; e10++) {
      var n2 = arguments[e10];
      for (var o2 in n2)
        Object.prototype.hasOwnProperty.call(n2, o2) && (t2[o2] = n2[o2]);
    }
    return t2;
  }, re$2.apply(this, arguments);
}
function In$2(t2, e10) {
  if (t2 == null)
    return {};
  var n2 = {}, o2 = Object.keys(t2), r3, i2;
  for (i2 = 0; i2 < o2.length; i2++)
    r3 = o2[i2], !(e10.indexOf(r3) >= 0) && (n2[r3] = t2[r3]);
  return n2;
}
function An$2(t2, e10) {
  if (t2 == null)
    return {};
  var n2 = In$2(t2, e10), o2, r3;
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t2);
    for (r3 = 0; r3 < i2.length; r3++)
      o2 = i2[r3], !(e10.indexOf(o2) >= 0) && Object.prototype.propertyIsEnumerable.call(t2, o2) && (n2[o2] = t2[o2]);
  }
  return n2;
}
var xn$2 = "1.15.2";
function oe$2(t2) {
  if (typeof window != "undefined" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t2);
}
var ie$2 = oe$2(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ae$2 = oe$2(/Edge/i), Ct$2 = oe$2(/firefox/i), _e$2 = oe$2(/safari/i) && !oe$2(/chrome/i) && !oe$2(/android/i), kt$2 = oe$2(/iP(ad|od|hone)/i), Ht$2 = oe$2(/chrome/i) && oe$2(/android/i), Lt$2 = {
  capture: false,
  passive: false
};
function D$2(t2, e10, n2) {
  t2.addEventListener(e10, n2, !ie$2 && Lt$2);
}
function S$2(t2, e10, n2) {
  t2.removeEventListener(e10, n2, !ie$2 && Lt$2);
}
function Le$2(t2, e10) {
  if (e10) {
    if (e10[0] === ">" && (e10 = e10.substring(1)), t2)
      try {
        if (t2.matches)
          return t2.matches(e10);
        if (t2.msMatchesSelector)
          return t2.msMatchesSelector(e10);
        if (t2.webkitMatchesSelector)
          return t2.webkitMatchesSelector(e10);
      } catch (n2) {
        return false;
      }
    return false;
  }
}
function Nn$2(t2) {
  return t2.host && t2 !== document && t2.host.nodeType ? t2.host : t2.parentNode;
}
function Z$2(t2, e10, n2, o2) {
  if (t2) {
    n2 = n2 || document;
    do {
      if (e10 != null && (e10[0] === ">" ? t2.parentNode === n2 && Le$2(t2, e10) : Le$2(t2, e10)) || o2 && t2 === n2)
        return t2;
      if (t2 === n2)
        break;
    } while (t2 = Nn$2(t2));
  }
  return null;
}
var Ot$2 = /\s+/g;
function V$2(t2, e10, n2) {
  if (t2 && e10)
    if (t2.classList)
      t2.classList[n2 ? "add" : "remove"](e10);
    else {
      var o2 = (" " + t2.className + " ").replace(Ot$2, " ").replace(" " + e10 + " ", " ");
      t2.className = (o2 + (n2 ? " " + e10 : "")).replace(Ot$2, " ");
    }
}
function h$2(t2, e10, n2) {
  var o2 = t2 && t2.style;
  if (o2) {
    if (n2 === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? n2 = document.defaultView.getComputedStyle(t2, "") : t2.currentStyle && (n2 = t2.currentStyle), e10 === void 0 ? n2 : n2[e10];
    !(e10 in o2) && e10.indexOf("webkit") === -1 && (e10 = "-webkit-" + e10), o2[e10] = n2 + (typeof n2 == "string" ? "" : "px");
  }
}
function ye$2(t2, e10) {
  var n2 = "";
  if (typeof t2 == "string")
    n2 = t2;
  else
    do {
      var o2 = h$2(t2, "transform");
      o2 && o2 !== "none" && (n2 = o2 + " " + n2);
    } while (!e10 && (t2 = t2.parentNode));
  var r3 = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r3 && new r3(n2);
}
function Wt$2(t2, e10, n2) {
  if (t2) {
    var o2 = t2.getElementsByTagName(e10), r3 = 0, i2 = o2.length;
    if (n2)
      for (; r3 < i2; r3++)
        n2(o2[r3], r3);
    return o2;
  }
  return [];
}
function ee$2() {
  var t2 = document.scrollingElement;
  return t2 || document.documentElement;
}
function M$2(t2, e10, n2, o2, r3) {
  if (!(!t2.getBoundingClientRect && t2 !== window)) {
    var i2, a2, l2, s2, u2, d2, f2;
    if (t2 !== window && t2.parentNode && t2 !== ee$2() ? (i2 = t2.getBoundingClientRect(), a2 = i2.top, l2 = i2.left, s2 = i2.bottom, u2 = i2.right, d2 = i2.height, f2 = i2.width) : (a2 = 0, l2 = 0, s2 = window.innerHeight, u2 = window.innerWidth, d2 = window.innerHeight, f2 = window.innerWidth), (e10 || n2) && t2 !== window && (r3 = r3 || t2.parentNode, !ie$2))
      do
        if (r3 && r3.getBoundingClientRect && (h$2(r3, "transform") !== "none" || n2 && h$2(r3, "position") !== "static")) {
          var m2 = r3.getBoundingClientRect();
          a2 -= m2.top + parseInt(h$2(r3, "border-top-width")), l2 -= m2.left + parseInt(h$2(r3, "border-left-width")), s2 = a2 + i2.height, u2 = l2 + i2.width;
          break;
        }
      while (r3 = r3.parentNode);
    if (o2 && t2 !== window) {
      var y2 = ye$2(r3 || t2), b2 = y2 && y2.a, E2 = y2 && y2.d;
      y2 && (a2 /= E2, l2 /= b2, f2 /= b2, d2 /= E2, s2 = a2 + d2, u2 = l2 + f2);
    }
    return {
      top: a2,
      left: l2,
      bottom: s2,
      right: u2,
      width: f2,
      height: d2
    };
  }
}
function It$2(t2, e10, n2) {
  for (var o2 = ue$2(t2, true), r3 = M$2(t2)[e10]; o2; ) {
    var i2 = M$2(o2)[n2], a2 = void 0;
    if (a2 = r3 >= i2, !a2)
      return o2;
    if (o2 === ee$2())
      break;
    o2 = ue$2(o2, false);
  }
  return false;
}
function we$2(t2, e10, n2, o2) {
  for (var r3 = 0, i2 = 0, a2 = t2.children; i2 < a2.length; ) {
    if (a2[i2].style.display !== "none" && a2[i2] !== p$2.ghost && (o2 || a2[i2] !== p$2.dragged) && Z$2(a2[i2], n2.draggable, t2, false)) {
      if (r3 === e10)
        return a2[i2];
      r3++;
    }
    i2++;
  }
  return null;
}
function dt$2(t2, e10) {
  for (var n2 = t2.lastElementChild; n2 && (n2 === p$2.ghost || h$2(n2, "display") === "none" || e10 && !Le$2(n2, e10)); )
    n2 = n2.previousElementSibling;
  return n2 || null;
}
function K$2(t2, e10) {
  var n2 = 0;
  if (!t2 || !t2.parentNode)
    return -1;
  for (; t2 = t2.previousElementSibling; )
    t2.nodeName.toUpperCase() !== "TEMPLATE" && t2 !== p$2.clone && (!e10 || Le$2(t2, e10)) && n2++;
  return n2;
}
function At$2(t2) {
  var e10 = 0, n2 = 0, o2 = ee$2();
  if (t2)
    do {
      var r3 = ye$2(t2), i2 = r3.a, a2 = r3.d;
      e10 += t2.scrollLeft * i2, n2 += t2.scrollTop * a2;
    } while (t2 !== o2 && (t2 = t2.parentNode));
  return [e10, n2];
}
function Pn$2(t2, e10) {
  for (var n2 in t2)
    if (t2.hasOwnProperty(n2)) {
      for (var o2 in e10)
        if (e10.hasOwnProperty(o2) && e10[o2] === t2[n2][o2])
          return Number(n2);
    }
  return -1;
}
function ue$2(t2, e10) {
  if (!t2 || !t2.getBoundingClientRect)
    return ee$2();
  var n2 = t2, o2 = false;
  do
    if (n2.clientWidth < n2.scrollWidth || n2.clientHeight < n2.scrollHeight) {
      var r3 = h$2(n2);
      if (n2.clientWidth < n2.scrollWidth && (r3.overflowX == "auto" || r3.overflowX == "scroll") || n2.clientHeight < n2.scrollHeight && (r3.overflowY == "auto" || r3.overflowY == "scroll")) {
        if (!n2.getBoundingClientRect || n2 === document.body)
          return ee$2();
        if (o2 || e10)
          return n2;
        o2 = true;
      }
    }
  while (n2 = n2.parentNode);
  return ee$2();
}
function Mn$2(t2, e10) {
  if (t2 && e10)
    for (var n2 in e10)
      e10.hasOwnProperty(n2) && (t2[n2] = e10[n2]);
  return t2;
}
function Ke$2(t2, e10) {
  return Math.round(t2.top) === Math.round(e10.top) && Math.round(t2.left) === Math.round(e10.left) && Math.round(t2.height) === Math.round(e10.height) && Math.round(t2.width) === Math.round(e10.width);
}
var Te$2;
function Gt$2(t2, e10) {
  return function() {
    if (!Te$2) {
      var n2 = arguments, o2 = this;
      n2.length === 1 ? t2.call(o2, n2[0]) : t2.apply(o2, n2), Te$2 = setTimeout(function() {
        Te$2 = void 0;
      }, e10);
    }
  };
}
function Fn$2() {
  clearTimeout(Te$2), Te$2 = void 0;
}
function jt$2(t2, e10, n2) {
  t2.scrollLeft += e10, t2.scrollTop += n2;
}
function zt$2(t2) {
  var e10 = window.Polymer, n2 = window.jQuery || window.Zepto;
  return e10 && e10.dom ? e10.dom(t2).cloneNode(true) : n2 ? n2(t2).clone(true)[0] : t2.cloneNode(true);
}
function Ut$2(t2, e10, n2) {
  var o2 = {};
  return Array.from(t2.children).forEach(function(r3) {
    var i2, a2, l2, s2;
    if (!(!Z$2(r3, e10.draggable, t2, false) || r3.animated || r3 === n2)) {
      var u2 = M$2(r3);
      o2.left = Math.min((i2 = o2.left) !== null && i2 !== void 0 ? i2 : 1 / 0, u2.left), o2.top = Math.min((a2 = o2.top) !== null && a2 !== void 0 ? a2 : 1 / 0, u2.top), o2.right = Math.max((l2 = o2.right) !== null && l2 !== void 0 ? l2 : -1 / 0, u2.right), o2.bottom = Math.max((s2 = o2.bottom) !== null && s2 !== void 0 ? s2 : -1 / 0, u2.bottom);
    }
  }), o2.width = o2.right - o2.left, o2.height = o2.bottom - o2.top, o2.x = o2.left, o2.y = o2.top, o2;
}
var q$2 = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Rn$2() {
  var t2 = [], e10;
  return {
    captureAnimationState: function() {
      if (t2 = [], !!this.options.animation) {
        var o2 = [].slice.call(this.el.children);
        o2.forEach(function(r3) {
          if (!(h$2(r3, "display") === "none" || r3 === p$2.ghost)) {
            t2.push({
              target: r3,
              rect: M$2(r3)
            });
            var i2 = te$2({}, t2[t2.length - 1].rect);
            if (r3.thisAnimationDuration) {
              var a2 = ye$2(r3, true);
              a2 && (i2.top -= a2.f, i2.left -= a2.e);
            }
            r3.fromRect = i2;
          }
        });
      }
    },
    addAnimationState: function(o2) {
      t2.push(o2);
    },
    removeAnimationState: function(o2) {
      t2.splice(Pn$2(t2, {
        target: o2
      }), 1);
    },
    animateAll: function(o2) {
      var r3 = this;
      if (!this.options.animation) {
        clearTimeout(e10), typeof o2 == "function" && o2();
        return;
      }
      var i2 = false, a2 = 0;
      t2.forEach(function(l2) {
        var s2 = 0, u2 = l2.target, d2 = u2.fromRect, f2 = M$2(u2), m2 = u2.prevFromRect, y2 = u2.prevToRect, b2 = l2.rect, E2 = ye$2(u2, true);
        E2 && (f2.top -= E2.f, f2.left -= E2.e), u2.toRect = f2, u2.thisAnimationDuration && Ke$2(m2, f2) && !Ke$2(d2, f2) && // Make sure animatingRect is on line between toRect & fromRect
        (b2.top - f2.top) / (b2.left - f2.left) === (d2.top - f2.top) / (d2.left - f2.left) && (s2 = Yn$2(b2, m2, y2, r3.options)), Ke$2(f2, d2) || (u2.prevFromRect = d2, u2.prevToRect = f2, s2 || (s2 = r3.options.animation), r3.animate(u2, b2, f2, s2)), s2 && (i2 = true, a2 = Math.max(a2, s2), clearTimeout(u2.animationResetTimer), u2.animationResetTimer = setTimeout(function() {
          u2.animationTime = 0, u2.prevFromRect = null, u2.fromRect = null, u2.prevToRect = null, u2.thisAnimationDuration = null;
        }, s2), u2.thisAnimationDuration = s2);
      }), clearTimeout(e10), i2 ? e10 = setTimeout(function() {
        typeof o2 == "function" && o2();
      }, a2) : typeof o2 == "function" && o2(), t2 = [];
    },
    animate: function(o2, r3, i2, a2) {
      if (a2) {
        h$2(o2, "transition", ""), h$2(o2, "transform", "");
        var l2 = ye$2(this.el), s2 = l2 && l2.a, u2 = l2 && l2.d, d2 = (r3.left - i2.left) / (s2 || 1), f2 = (r3.top - i2.top) / (u2 || 1);
        o2.animatingX = !!d2, o2.animatingY = !!f2, h$2(o2, "transform", "translate3d(" + d2 + "px," + f2 + "px,0)"), this.forRepaintDummy = Xn$2(o2), h$2(o2, "transition", "transform " + a2 + "ms" + (this.options.easing ? " " + this.options.easing : "")), h$2(o2, "transform", "translate3d(0,0,0)"), typeof o2.animated == "number" && clearTimeout(o2.animated), o2.animated = setTimeout(function() {
          h$2(o2, "transition", ""), h$2(o2, "transform", ""), o2.animated = false, o2.animatingX = false, o2.animatingY = false;
        }, a2);
      }
    }
  };
}
function Xn$2(t2) {
  return t2.offsetWidth;
}
function Yn$2(t2, e10, n2, o2) {
  return Math.sqrt(Math.pow(e10.top - t2.top, 2) + Math.pow(e10.left - t2.left, 2)) / Math.sqrt(Math.pow(e10.top - n2.top, 2) + Math.pow(e10.left - n2.left, 2)) * o2.animation;
}
var ge$2 = [], Je$2 = {
  initializeByDefault: true
}, xe$2 = {
  mount: function(e10) {
    for (var n2 in Je$2)
      Je$2.hasOwnProperty(n2) && !(n2 in e10) && (e10[n2] = Je$2[n2]);
    ge$2.forEach(function(o2) {
      if (o2.pluginName === e10.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e10.pluginName, " more than once");
    }), ge$2.push(e10);
  },
  pluginEvent: function(e10, n2, o2) {
    var r3 = this;
    this.eventCanceled = false, o2.cancel = function() {
      r3.eventCanceled = true;
    };
    var i2 = e10 + "Global";
    ge$2.forEach(function(a2) {
      n2[a2.pluginName] && (n2[a2.pluginName][i2] && n2[a2.pluginName][i2](te$2({
        sortable: n2
      }, o2)), n2.options[a2.pluginName] && n2[a2.pluginName][e10] && n2[a2.pluginName][e10](te$2({
        sortable: n2
      }, o2)));
    });
  },
  initializePlugins: function(e10, n2, o2, r3) {
    ge$2.forEach(function(l2) {
      var s2 = l2.pluginName;
      if (!(!e10.options[s2] && !l2.initializeByDefault)) {
        var u2 = new l2(e10, n2, e10.options);
        u2.sortable = e10, u2.options = e10.options, e10[s2] = u2, re$2(o2, u2.defaults);
      }
    });
    for (var i2 in e10.options)
      if (e10.options.hasOwnProperty(i2)) {
        var a2 = this.modifyOption(e10, i2, e10.options[i2]);
        typeof a2 != "undefined" && (e10.options[i2] = a2);
      }
  },
  getEventProperties: function(e10, n2) {
    var o2 = {};
    return ge$2.forEach(function(r3) {
      typeof r3.eventProperties == "function" && re$2(o2, r3.eventProperties.call(n2[r3.pluginName], e10));
    }), o2;
  },
  modifyOption: function(e10, n2, o2) {
    var r3;
    return ge$2.forEach(function(i2) {
      e10[i2.pluginName] && i2.optionListeners && typeof i2.optionListeners[n2] == "function" && (r3 = i2.optionListeners[n2].call(e10[i2.pluginName], o2));
    }), r3;
  }
};
function Bn$2(t2) {
  var e10 = t2.sortable, n2 = t2.rootEl, o2 = t2.name, r3 = t2.targetEl, i2 = t2.cloneEl, a2 = t2.toEl, l2 = t2.fromEl, s2 = t2.oldIndex, u2 = t2.newIndex, d2 = t2.oldDraggableIndex, f2 = t2.newDraggableIndex, m2 = t2.originalEvent, y2 = t2.putSortable, b2 = t2.extraEventProperties;
  if (e10 = e10 || n2 && n2[q$2], !!e10) {
    var E2, k2 = e10.options, H2 = "on" + o2.charAt(0).toUpperCase() + o2.substr(1);
    window.CustomEvent && !ie$2 && !Ae$2 ? E2 = new CustomEvent(o2, {
      bubbles: true,
      cancelable: true
    }) : (E2 = document.createEvent("Event"), E2.initEvent(o2, true, true)), E2.to = a2 || n2, E2.from = l2 || n2, E2.item = r3 || n2, E2.clone = i2, E2.oldIndex = s2, E2.newIndex = u2, E2.oldDraggableIndex = d2, E2.newDraggableIndex = f2, E2.originalEvent = m2, E2.pullMode = y2 ? y2.lastPutMode : void 0;
    var F2 = te$2(te$2({}, b2), xe$2.getEventProperties(o2, e10));
    for (var x2 in F2)
      E2[x2] = F2[x2];
    n2 && n2.dispatchEvent(E2), k2[H2] && k2[H2].call(e10, E2);
  }
}
var kn$2 = ["evt"], G$2 = function(e10, n2) {
  var o2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r3 = o2.evt, i2 = An$2(o2, kn$2);
  xe$2.pluginEvent.bind(p$2)(e10, n2, te$2({
    dragEl: c$2,
    parentEl: A$2,
    ghostEl: g$2,
    rootEl: T$2,
    nextEl: pe$2,
    lastDownEl: Ye$2,
    cloneEl: O$2,
    cloneHidden: se$2,
    dragStarted: Ee$2,
    putSortable: R$2,
    activeSortable: p$2.active,
    originalEvent: r3,
    oldIndex: be$2,
    oldDraggableIndex: Ce$2,
    newIndex: $$2,
    newDraggableIndex: le$2,
    hideGhostForTarget: Kt$2,
    unhideGhostForTarget: Jt$2,
    cloneNowHidden: function() {
      se$2 = true;
    },
    cloneNowShown: function() {
      se$2 = false;
    },
    dispatchSortableEvent: function(l2) {
      W$2({
        sortable: n2,
        name: l2,
        originalEvent: r3
      });
    }
  }, i2));
};
function W$2(t2) {
  Bn$2(te$2({
    putSortable: R$2,
    cloneEl: O$2,
    targetEl: c$2,
    rootEl: T$2,
    oldIndex: be$2,
    oldDraggableIndex: Ce$2,
    newIndex: $$2,
    newDraggableIndex: le$2
  }, t2));
}
var c$2, A$2, g$2, T$2, pe$2, Ye$2, O$2, se$2, be$2, $$2, Ce$2, le$2, Pe$2, R$2, ve$2 = false, We$2 = false, Ge$2 = [], de$2, J$2, Ze$2, Qe$2, xt$2, Nt$2, Ee$2, me$2, Oe$2, Ie$2 = false, Me$2 = false, Be$2, B$2, et$2 = [], at$2 = false, je$2 = [], Ue$2 = typeof document != "undefined", Fe$2 = kt$2, Pt$2 = Ae$2 || ie$2 ? "cssFloat" : "float", Hn$2 = Ue$2 && !Ht$2 && !kt$2 && "draggable" in document.createElement("div"), Vt$2 = function() {
  if (Ue$2) {
    if (ie$2)
      return false;
    var t2 = document.createElement("x");
    return t2.style.cssText = "pointer-events:auto", t2.style.pointerEvents === "auto";
  }
}(), $t$2 = function(e10, n2) {
  var o2 = h$2(e10), r3 = parseInt(o2.width) - parseInt(o2.paddingLeft) - parseInt(o2.paddingRight) - parseInt(o2.borderLeftWidth) - parseInt(o2.borderRightWidth), i2 = we$2(e10, 0, n2), a2 = we$2(e10, 1, n2), l2 = i2 && h$2(i2), s2 = a2 && h$2(a2), u2 = l2 && parseInt(l2.marginLeft) + parseInt(l2.marginRight) + M$2(i2).width, d2 = s2 && parseInt(s2.marginLeft) + parseInt(s2.marginRight) + M$2(a2).width;
  if (o2.display === "flex")
    return o2.flexDirection === "column" || o2.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (o2.display === "grid")
    return o2.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i2 && l2.float && l2.float !== "none") {
    var f2 = l2.float === "left" ? "left" : "right";
    return a2 && (s2.clear === "both" || s2.clear === f2) ? "vertical" : "horizontal";
  }
  return i2 && (l2.display === "block" || l2.display === "flex" || l2.display === "table" || l2.display === "grid" || u2 >= r3 && o2[Pt$2] === "none" || a2 && o2[Pt$2] === "none" && u2 + d2 > r3) ? "vertical" : "horizontal";
}, Ln$2 = function(e10, n2, o2) {
  var r3 = o2 ? e10.left : e10.top, i2 = o2 ? e10.right : e10.bottom, a2 = o2 ? e10.width : e10.height, l2 = o2 ? n2.left : n2.top, s2 = o2 ? n2.right : n2.bottom, u2 = o2 ? n2.width : n2.height;
  return r3 === l2 || i2 === s2 || r3 + a2 / 2 === l2 + u2 / 2;
}, Wn$2 = function(e10, n2) {
  var o2;
  return Ge$2.some(function(r3) {
    var i2 = r3[q$2].options.emptyInsertThreshold;
    if (!(!i2 || dt$2(r3))) {
      var a2 = M$2(r3), l2 = e10 >= a2.left - i2 && e10 <= a2.right + i2, s2 = n2 >= a2.top - i2 && n2 <= a2.bottom + i2;
      if (l2 && s2)
        return o2 = r3;
    }
  }), o2;
}, qt$2 = function(e10) {
  function n2(i2, a2) {
    return function(l2, s2, u2, d2) {
      var f2 = l2.options.group.name && s2.options.group.name && l2.options.group.name === s2.options.group.name;
      if (i2 == null && (a2 || f2))
        return true;
      if (i2 == null || i2 === false)
        return false;
      if (a2 && i2 === "clone")
        return i2;
      if (typeof i2 == "function")
        return n2(i2(l2, s2, u2, d2), a2)(l2, s2, u2, d2);
      var m2 = (a2 ? l2 : s2).options.group.name;
      return i2 === true || typeof i2 == "string" && i2 === m2 || i2.join && i2.indexOf(m2) > -1;
    };
  }
  var o2 = {}, r3 = e10.group;
  (!r3 || Xe$2(r3) != "object") && (r3 = {
    name: r3
  }), o2.name = r3.name, o2.checkPull = n2(r3.pull, true), o2.checkPut = n2(r3.put), o2.revertClone = r3.revertClone, e10.group = o2;
}, Kt$2 = function() {
  !Vt$2 && g$2 && h$2(g$2, "display", "none");
}, Jt$2 = function() {
  !Vt$2 && g$2 && h$2(g$2, "display", "");
};
Ue$2 && !Ht$2 && document.addEventListener("click", function(t2) {
  if (We$2)
    return t2.preventDefault(), t2.stopPropagation && t2.stopPropagation(), t2.stopImmediatePropagation && t2.stopImmediatePropagation(), We$2 = false, false;
}, true);
var he$2 = function(e10) {
  if (c$2) {
    e10 = e10.touches ? e10.touches[0] : e10;
    var n2 = Wn$2(e10.clientX, e10.clientY);
    if (n2) {
      var o2 = {};
      for (var r3 in e10)
        e10.hasOwnProperty(r3) && (o2[r3] = e10[r3]);
      o2.target = o2.rootEl = n2, o2.preventDefault = void 0, o2.stopPropagation = void 0, n2[q$2]._onDragOver(o2);
    }
  }
}, Gn$2 = function(e10) {
  c$2 && c$2.parentNode[q$2]._isOutsideThisEl(e10.target);
};
function p$2(t2, e10) {
  if (!(t2 && t2.nodeType && t2.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t2));
  this.el = t2, this.options = e10 = re$2({}, e10), t2[q$2] = this;
  var n2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t2.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function() {
      return $t$2(t2, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function(a2, l2) {
      a2.setData("Text", l2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: p$2.supportPointer !== false && "PointerEvent" in window && !_e$2,
    emptyInsertThreshold: 5
  };
  xe$2.initializePlugins(this, t2, n2);
  for (var o2 in n2)
    !(o2 in e10) && (e10[o2] = n2[o2]);
  qt$2(e10);
  for (var r3 in this)
    r3.charAt(0) === "_" && typeof this[r3] == "function" && (this[r3] = this[r3].bind(this));
  this.nativeDraggable = e10.forceFallback ? false : Hn$2, this.nativeDraggable && (this.options.touchStartThreshold = 1), e10.supportPointer ? D$2(t2, "pointerdown", this._onTapStart) : (D$2(t2, "mousedown", this._onTapStart), D$2(t2, "touchstart", this._onTapStart)), this.nativeDraggable && (D$2(t2, "dragover", this), D$2(t2, "dragenter", this)), Ge$2.push(this.el), e10.store && e10.store.get && this.sort(e10.store.get(this) || []), re$2(this, Rn$2());
}
p$2.prototype = /** @lends Sortable.prototype */
{
  constructor: p$2,
  _isOutsideThisEl: function(e10) {
    !this.el.contains(e10) && e10 !== this.el && (me$2 = null);
  },
  _getDirection: function(e10, n2) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e10, n2, c$2) : this.options.direction;
  },
  _onTapStart: function(e10) {
    if (e10.cancelable) {
      var n2 = this, o2 = this.el, r3 = this.options, i2 = r3.preventOnFilter, a2 = e10.type, l2 = e10.touches && e10.touches[0] || e10.pointerType && e10.pointerType === "touch" && e10, s2 = (l2 || e10).target, u2 = e10.target.shadowRoot && (e10.path && e10.path[0] || e10.composedPath && e10.composedPath()[0]) || s2, d2 = r3.filter;
      if (Jn$2(o2), !c$2 && !(/mousedown|pointerdown/.test(a2) && e10.button !== 0 || r3.disabled) && !u2.isContentEditable && !(!this.nativeDraggable && _e$2 && s2 && s2.tagName.toUpperCase() === "SELECT") && (s2 = Z$2(s2, r3.draggable, o2, false), !(s2 && s2.animated) && Ye$2 !== s2)) {
        if (be$2 = K$2(s2), Ce$2 = K$2(s2, r3.draggable), typeof d2 == "function") {
          if (d2.call(this, e10, s2, this)) {
            W$2({
              sortable: n2,
              rootEl: u2,
              name: "filter",
              targetEl: s2,
              toEl: o2,
              fromEl: o2
            }), G$2("filter", n2, {
              evt: e10
            }), i2 && e10.cancelable && e10.preventDefault();
            return;
          }
        } else if (d2 && (d2 = d2.split(",").some(function(f2) {
          if (f2 = Z$2(u2, f2.trim(), o2, false), f2)
            return W$2({
              sortable: n2,
              rootEl: f2,
              name: "filter",
              targetEl: s2,
              fromEl: o2,
              toEl: o2
            }), G$2("filter", n2, {
              evt: e10
            }), true;
        }), d2)) {
          i2 && e10.cancelable && e10.preventDefault();
          return;
        }
        r3.handle && !Z$2(u2, r3.handle, o2, false) || this._prepareDragStart(e10, l2, s2);
      }
    }
  },
  _prepareDragStart: function(e10, n2, o2) {
    var r3 = this, i2 = r3.el, a2 = r3.options, l2 = i2.ownerDocument, s2;
    if (o2 && !c$2 && o2.parentNode === i2) {
      var u2 = M$2(o2);
      if (T$2 = i2, c$2 = o2, A$2 = c$2.parentNode, pe$2 = c$2.nextSibling, Ye$2 = o2, Pe$2 = a2.group, p$2.dragged = c$2, de$2 = {
        target: c$2,
        clientX: (n2 || e10).clientX,
        clientY: (n2 || e10).clientY
      }, xt$2 = de$2.clientX - u2.left, Nt$2 = de$2.clientY - u2.top, this._lastX = (n2 || e10).clientX, this._lastY = (n2 || e10).clientY, c$2.style["will-change"] = "all", s2 = function() {
        if (G$2("delayEnded", r3, {
          evt: e10
        }), p$2.eventCanceled) {
          r3._onDrop();
          return;
        }
        r3._disableDelayedDragEvents(), !Ct$2 && r3.nativeDraggable && (c$2.draggable = true), r3._triggerDragStart(e10, n2), W$2({
          sortable: r3,
          name: "choose",
          originalEvent: e10
        }), V$2(c$2, a2.chosenClass, true);
      }, a2.ignore.split(",").forEach(function(d2) {
        Wt$2(c$2, d2.trim(), tt$2);
      }), D$2(l2, "dragover", he$2), D$2(l2, "mousemove", he$2), D$2(l2, "touchmove", he$2), D$2(l2, "mouseup", r3._onDrop), D$2(l2, "touchend", r3._onDrop), D$2(l2, "touchcancel", r3._onDrop), Ct$2 && this.nativeDraggable && (this.options.touchStartThreshold = 4, c$2.draggable = true), G$2("delayStart", this, {
        evt: e10
      }), a2.delay && (!a2.delayOnTouchOnly || n2) && (!this.nativeDraggable || !(Ae$2 || ie$2))) {
        if (p$2.eventCanceled) {
          this._onDrop();
          return;
        }
        D$2(l2, "mouseup", r3._disableDelayedDrag), D$2(l2, "touchend", r3._disableDelayedDrag), D$2(l2, "touchcancel", r3._disableDelayedDrag), D$2(l2, "mousemove", r3._delayedDragTouchMoveHandler), D$2(l2, "touchmove", r3._delayedDragTouchMoveHandler), a2.supportPointer && D$2(l2, "pointermove", r3._delayedDragTouchMoveHandler), r3._dragStartTimer = setTimeout(s2, a2.delay);
      } else
        s2();
    }
  },
  _delayedDragTouchMoveHandler: function(e10) {
    var n2 = e10.touches ? e10.touches[0] : e10;
    Math.max(Math.abs(n2.clientX - this._lastX), Math.abs(n2.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    c$2 && tt$2(c$2), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e10 = this.el.ownerDocument;
    S$2(e10, "mouseup", this._disableDelayedDrag), S$2(e10, "touchend", this._disableDelayedDrag), S$2(e10, "touchcancel", this._disableDelayedDrag), S$2(e10, "mousemove", this._delayedDragTouchMoveHandler), S$2(e10, "touchmove", this._delayedDragTouchMoveHandler), S$2(e10, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e10, n2) {
    n2 = n2 || e10.pointerType == "touch" && e10, !this.nativeDraggable || n2 ? this.options.supportPointer ? D$2(document, "pointermove", this._onTouchMove) : n2 ? D$2(document, "touchmove", this._onTouchMove) : D$2(document, "mousemove", this._onTouchMove) : (D$2(c$2, "dragend", this), D$2(T$2, "dragstart", this._onDragStart));
    try {
      document.selection ? ke$2(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch (o2) {
    }
  },
  _dragStarted: function(e10, n2) {
    if (ve$2 = false, T$2 && c$2) {
      G$2("dragStarted", this, {
        evt: n2
      }), this.nativeDraggable && D$2(document, "dragover", Gn$2);
      var o2 = this.options;
      !e10 && V$2(c$2, o2.dragClass, false), V$2(c$2, o2.ghostClass, true), p$2.active = this, e10 && this._appendGhost(), W$2({
        sortable: this,
        name: "start",
        originalEvent: n2
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (J$2) {
      this._lastX = J$2.clientX, this._lastY = J$2.clientY, Kt$2();
      for (var e10 = document.elementFromPoint(J$2.clientX, J$2.clientY), n2 = e10; e10 && e10.shadowRoot && (e10 = e10.shadowRoot.elementFromPoint(J$2.clientX, J$2.clientY), e10 !== n2); )
        n2 = e10;
      if (c$2.parentNode[q$2]._isOutsideThisEl(e10), n2)
        do {
          if (n2[q$2]) {
            var o2 = void 0;
            if (o2 = n2[q$2]._onDragOver({
              clientX: J$2.clientX,
              clientY: J$2.clientY,
              target: e10,
              rootEl: n2
            }), o2 && !this.options.dragoverBubble)
              break;
          }
          e10 = n2;
        } while (n2 = n2.parentNode);
      Jt$2();
    }
  },
  _onTouchMove: function(e10) {
    if (de$2) {
      var n2 = this.options, o2 = n2.fallbackTolerance, r3 = n2.fallbackOffset, i2 = e10.touches ? e10.touches[0] : e10, a2 = g$2 && ye$2(g$2, true), l2 = g$2 && a2 && a2.a, s2 = g$2 && a2 && a2.d, u2 = Fe$2 && B$2 && At$2(B$2), d2 = (i2.clientX - de$2.clientX + r3.x) / (l2 || 1) + (u2 ? u2[0] - et$2[0] : 0) / (l2 || 1), f2 = (i2.clientY - de$2.clientY + r3.y) / (s2 || 1) + (u2 ? u2[1] - et$2[1] : 0) / (s2 || 1);
      if (!p$2.active && !ve$2) {
        if (o2 && Math.max(Math.abs(i2.clientX - this._lastX), Math.abs(i2.clientY - this._lastY)) < o2)
          return;
        this._onDragStart(e10, true);
      }
      if (g$2) {
        a2 ? (a2.e += d2 - (Ze$2 || 0), a2.f += f2 - (Qe$2 || 0)) : a2 = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d2,
          f: f2
        };
        var m2 = "matrix(".concat(a2.a, ",").concat(a2.b, ",").concat(a2.c, ",").concat(a2.d, ",").concat(a2.e, ",").concat(a2.f, ")");
        h$2(g$2, "webkitTransform", m2), h$2(g$2, "mozTransform", m2), h$2(g$2, "msTransform", m2), h$2(g$2, "transform", m2), Ze$2 = d2, Qe$2 = f2, J$2 = i2;
      }
      e10.cancelable && e10.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!g$2) {
      var e10 = this.options.fallbackOnBody ? document.body : T$2, n2 = M$2(c$2, true, Fe$2, true, e10), o2 = this.options;
      if (Fe$2) {
        for (B$2 = e10; h$2(B$2, "position") === "static" && h$2(B$2, "transform") === "none" && B$2 !== document; )
          B$2 = B$2.parentNode;
        B$2 !== document.body && B$2 !== document.documentElement ? (B$2 === document && (B$2 = ee$2()), n2.top += B$2.scrollTop, n2.left += B$2.scrollLeft) : B$2 = ee$2(), et$2 = At$2(B$2);
      }
      g$2 = c$2.cloneNode(true), V$2(g$2, o2.ghostClass, false), V$2(g$2, o2.fallbackClass, true), V$2(g$2, o2.dragClass, true), h$2(g$2, "transition", ""), h$2(g$2, "transform", ""), h$2(g$2, "box-sizing", "border-box"), h$2(g$2, "margin", 0), h$2(g$2, "top", n2.top), h$2(g$2, "left", n2.left), h$2(g$2, "width", n2.width), h$2(g$2, "height", n2.height), h$2(g$2, "opacity", "0.8"), h$2(g$2, "position", Fe$2 ? "absolute" : "fixed"), h$2(g$2, "zIndex", "100000"), h$2(g$2, "pointerEvents", "none"), p$2.ghost = g$2, e10.appendChild(g$2), h$2(g$2, "transform-origin", xt$2 / parseInt(g$2.style.width) * 100 + "% " + Nt$2 / parseInt(g$2.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e10, n2) {
    var o2 = this, r3 = e10.dataTransfer, i2 = o2.options;
    if (G$2("dragStart", this, {
      evt: e10
    }), p$2.eventCanceled) {
      this._onDrop();
      return;
    }
    G$2("setupClone", this), p$2.eventCanceled || (O$2 = zt$2(c$2), O$2.removeAttribute("id"), O$2.draggable = false, O$2.style["will-change"] = "", this._hideClone(), V$2(O$2, this.options.chosenClass, false), p$2.clone = O$2), o2.cloneId = ke$2(function() {
      G$2("clone", o2), !p$2.eventCanceled && (o2.options.removeCloneOnHide || T$2.insertBefore(O$2, c$2), o2._hideClone(), W$2({
        sortable: o2,
        name: "clone"
      }));
    }), !n2 && V$2(c$2, i2.dragClass, true), n2 ? (We$2 = true, o2._loopId = setInterval(o2._emulateDragOver, 50)) : (S$2(document, "mouseup", o2._onDrop), S$2(document, "touchend", o2._onDrop), S$2(document, "touchcancel", o2._onDrop), r3 && (r3.effectAllowed = "move", i2.setData && i2.setData.call(o2, r3, c$2)), D$2(document, "drop", o2), h$2(c$2, "transform", "translateZ(0)")), ve$2 = true, o2._dragStartId = ke$2(o2._dragStarted.bind(o2, n2, e10)), D$2(document, "selectstart", o2), Ee$2 = true, _e$2 && h$2(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e10) {
    var n2 = this.el, o2 = e10.target, r3, i2, a2, l2 = this.options, s2 = l2.group, u2 = p$2.active, d2 = Pe$2 === s2, f2 = l2.sort, m2 = R$2 || u2, y2, b2 = this, E2 = false;
    if (at$2)
      return;
    function k2(ce2, nn2) {
      G$2(ce2, b2, te$2({
        evt: e10,
        isOwner: d2,
        axis: y2 ? "vertical" : "horizontal",
        revert: a2,
        dragRect: r3,
        targetRect: i2,
        canSort: f2,
        fromSortable: m2,
        target: o2,
        completed: F2,
        onMove: function(gt2, on2) {
          return Re$2(T$2, n2, c$2, r3, gt2, M$2(gt2), e10, on2);
        },
        changed: x2
      }, nn2));
    }
    function H2() {
      k2("dragOverAnimationCapture"), b2.captureAnimationState(), b2 !== m2 && m2.captureAnimationState();
    }
    function F2(ce2) {
      return k2("dragOverCompleted", {
        insertion: ce2
      }), ce2 && (d2 ? u2._hideClone() : u2._showClone(b2), b2 !== m2 && (V$2(c$2, R$2 ? R$2.options.ghostClass : u2.options.ghostClass, false), V$2(c$2, l2.ghostClass, true)), R$2 !== b2 && b2 !== p$2.active ? R$2 = b2 : b2 === p$2.active && R$2 && (R$2 = null), m2 === b2 && (b2._ignoreWhileAnimating = o2), b2.animateAll(function() {
        k2("dragOverAnimationComplete"), b2._ignoreWhileAnimating = null;
      }), b2 !== m2 && (m2.animateAll(), m2._ignoreWhileAnimating = null)), (o2 === c$2 && !c$2.animated || o2 === n2 && !o2.animated) && (me$2 = null), !l2.dragoverBubble && !e10.rootEl && o2 !== document && (c$2.parentNode[q$2]._isOutsideThisEl(e10.target), !ce2 && he$2(e10)), !l2.dragoverBubble && e10.stopPropagation && e10.stopPropagation(), E2 = true;
    }
    function x2() {
      $$2 = K$2(c$2), le$2 = K$2(c$2, l2.draggable), W$2({
        sortable: b2,
        name: "change",
        toEl: n2,
        newIndex: $$2,
        newDraggableIndex: le$2,
        originalEvent: e10
      });
    }
    if (e10.preventDefault !== void 0 && e10.cancelable && e10.preventDefault(), o2 = Z$2(o2, l2.draggable, n2, true), k2("dragOver"), p$2.eventCanceled)
      return E2;
    if (c$2.contains(e10.target) || o2.animated && o2.animatingX && o2.animatingY || b2._ignoreWhileAnimating === o2)
      return F2(false);
    if (We$2 = false, u2 && !l2.disabled && (d2 ? f2 || (a2 = A$2 !== T$2) : R$2 === this || (this.lastPutMode = Pe$2.checkPull(this, u2, c$2, e10)) && s2.checkPut(this, u2, c$2, e10))) {
      if (y2 = this._getDirection(e10, o2) === "vertical", r3 = M$2(c$2), k2("dragOverValid"), p$2.eventCanceled)
        return E2;
      if (a2)
        return A$2 = T$2, H2(), this._hideClone(), k2("revert"), p$2.eventCanceled || (pe$2 ? T$2.insertBefore(c$2, pe$2) : T$2.appendChild(c$2)), F2(true);
      var L2 = dt$2(n2, l2.draggable);
      if (!L2 || Vn$2(e10, y2, this) && !L2.animated) {
        if (L2 === c$2)
          return F2(false);
        if (L2 && n2 === e10.target && (o2 = L2), o2 && (i2 = M$2(o2)), Re$2(T$2, n2, c$2, r3, o2, i2, e10, !!o2) !== false)
          return H2(), L2 && L2.nextSibling ? n2.insertBefore(c$2, L2.nextSibling) : n2.appendChild(c$2), A$2 = n2, x2(), F2(true);
      } else if (L2 && Un$2(e10, y2, this)) {
        var ne2 = we$2(n2, 0, l2, true);
        if (ne2 === c$2)
          return F2(false);
        if (o2 = ne2, i2 = M$2(o2), Re$2(T$2, n2, c$2, r3, o2, i2, e10, false) !== false)
          return H2(), n2.insertBefore(c$2, ne2), A$2 = n2, x2(), F2(true);
      } else if (o2.parentNode === n2) {
        i2 = M$2(o2);
        var j2 = 0, Q2, v2 = c$2.parentNode !== n2, w2 = !Ln$2(c$2.animated && c$2.toRect || r3, o2.animated && o2.toRect || i2, y2), N2 = y2 ? "top" : "left", I2 = It$2(o2, "top", "top") || It$2(c$2, "top", "top"), _2 = I2 ? I2.scrollTop : void 0;
        me$2 !== o2 && (Q2 = i2[N2], Ie$2 = false, Me$2 = !w2 && l2.invertSwap || v2), j2 = $n$2(e10, o2, i2, y2, w2 ? 1 : l2.swapThreshold, l2.invertedSwapThreshold == null ? l2.swapThreshold : l2.invertedSwapThreshold, Me$2, me$2 === o2);
        var C2;
        if (j2 !== 0) {
          var X2 = K$2(c$2);
          do
            X2 -= j2, C2 = A$2.children[X2];
          while (C2 && (h$2(C2, "display") === "none" || C2 === g$2));
        }
        if (j2 === 0 || C2 === o2)
          return F2(false);
        me$2 = o2, Oe$2 = j2;
        var Y2 = o2.nextElementSibling, z2 = false;
        z2 = j2 === 1;
        var ae2 = Re$2(T$2, n2, c$2, r3, o2, i2, e10, z2);
        if (ae2 !== false)
          return (ae2 === 1 || ae2 === -1) && (z2 = ae2 === 1), at$2 = true, setTimeout(zn$2, 30), H2(), z2 && !Y2 ? n2.appendChild(c$2) : o2.parentNode.insertBefore(c$2, z2 ? Y2 : o2), I2 && jt$2(I2, 0, _2 - I2.scrollTop), A$2 = c$2.parentNode, Q2 !== void 0 && !Me$2 && (Be$2 = Math.abs(Q2 - M$2(o2)[N2])), x2(), F2(true);
      }
      if (n2.contains(c$2))
        return F2(false);
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    S$2(document, "mousemove", this._onTouchMove), S$2(document, "touchmove", this._onTouchMove), S$2(document, "pointermove", this._onTouchMove), S$2(document, "dragover", he$2), S$2(document, "mousemove", he$2), S$2(document, "touchmove", he$2);
  },
  _offUpEvents: function() {
    var e10 = this.el.ownerDocument;
    S$2(e10, "mouseup", this._onDrop), S$2(e10, "touchend", this._onDrop), S$2(e10, "pointerup", this._onDrop), S$2(e10, "touchcancel", this._onDrop), S$2(document, "selectstart", this);
  },
  _onDrop: function(e10) {
    var n2 = this.el, o2 = this.options;
    if ($$2 = K$2(c$2), le$2 = K$2(c$2, o2.draggable), G$2("drop", this, {
      evt: e10
    }), A$2 = c$2 && c$2.parentNode, $$2 = K$2(c$2), le$2 = K$2(c$2, o2.draggable), p$2.eventCanceled) {
      this._nulling();
      return;
    }
    ve$2 = false, Me$2 = false, Ie$2 = false, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), lt$2(this.cloneId), lt$2(this._dragStartId), this.nativeDraggable && (S$2(document, "drop", this), S$2(n2, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), _e$2 && h$2(document.body, "user-select", ""), h$2(c$2, "transform", ""), e10 && (Ee$2 && (e10.cancelable && e10.preventDefault(), !o2.dropBubble && e10.stopPropagation()), g$2 && g$2.parentNode && g$2.parentNode.removeChild(g$2), (T$2 === A$2 || R$2 && R$2.lastPutMode !== "clone") && O$2 && O$2.parentNode && O$2.parentNode.removeChild(O$2), c$2 && (this.nativeDraggable && S$2(c$2, "dragend", this), tt$2(c$2), c$2.style["will-change"] = "", Ee$2 && !ve$2 && V$2(c$2, R$2 ? R$2.options.ghostClass : this.options.ghostClass, false), V$2(c$2, this.options.chosenClass, false), W$2({
      sortable: this,
      name: "unchoose",
      toEl: A$2,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e10
    }), T$2 !== A$2 ? ($$2 >= 0 && (W$2({
      rootEl: A$2,
      name: "add",
      toEl: A$2,
      fromEl: T$2,
      originalEvent: e10
    }), W$2({
      sortable: this,
      name: "remove",
      toEl: A$2,
      originalEvent: e10
    }), W$2({
      rootEl: A$2,
      name: "sort",
      toEl: A$2,
      fromEl: T$2,
      originalEvent: e10
    }), W$2({
      sortable: this,
      name: "sort",
      toEl: A$2,
      originalEvent: e10
    })), R$2 && R$2.save()) : $$2 !== be$2 && $$2 >= 0 && (W$2({
      sortable: this,
      name: "update",
      toEl: A$2,
      originalEvent: e10
    }), W$2({
      sortable: this,
      name: "sort",
      toEl: A$2,
      originalEvent: e10
    })), p$2.active && (($$2 == null || $$2 === -1) && ($$2 = be$2, le$2 = Ce$2), W$2({
      sortable: this,
      name: "end",
      toEl: A$2,
      originalEvent: e10
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    G$2("nulling", this), T$2 = c$2 = A$2 = g$2 = pe$2 = O$2 = Ye$2 = se$2 = de$2 = J$2 = Ee$2 = $$2 = le$2 = be$2 = Ce$2 = me$2 = Oe$2 = R$2 = Pe$2 = p$2.dragged = p$2.ghost = p$2.clone = p$2.active = null, je$2.forEach(function(e10) {
      e10.checked = true;
    }), je$2.length = Ze$2 = Qe$2 = 0;
  },
  handleEvent: function(e10) {
    switch (e10.type) {
      case "drop":
      case "dragend":
        this._onDrop(e10);
        break;
      case "dragenter":
      case "dragover":
        c$2 && (this._onDragOver(e10), jn$2(e10));
        break;
      case "selectstart":
        e10.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e10 = [], n2, o2 = this.el.children, r3 = 0, i2 = o2.length, a2 = this.options; r3 < i2; r3++)
      n2 = o2[r3], Z$2(n2, a2.draggable, this.el, false) && e10.push(n2.getAttribute(a2.dataIdAttr) || Kn$2(n2));
    return e10;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e10, n2) {
    var o2 = {}, r3 = this.el;
    this.toArray().forEach(function(i2, a2) {
      var l2 = r3.children[a2];
      Z$2(l2, this.options.draggable, r3, false) && (o2[i2] = l2);
    }, this), n2 && this.captureAnimationState(), e10.forEach(function(i2) {
      o2[i2] && (r3.removeChild(o2[i2]), r3.appendChild(o2[i2]));
    }), n2 && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e10 = this.options.store;
    e10 && e10.set && e10.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e10, n2) {
    return Z$2(e10, n2 || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e10, n2) {
    var o2 = this.options;
    if (n2 === void 0)
      return o2[e10];
    var r3 = xe$2.modifyOption(this, e10, n2);
    typeof r3 != "undefined" ? o2[e10] = r3 : o2[e10] = n2, e10 === "group" && qt$2(o2);
  },
  /**
   * Destroy
   */
  destroy: function() {
    G$2("destroy", this);
    var e10 = this.el;
    e10[q$2] = null, S$2(e10, "mousedown", this._onTapStart), S$2(e10, "touchstart", this._onTapStart), S$2(e10, "pointerdown", this._onTapStart), this.nativeDraggable && (S$2(e10, "dragover", this), S$2(e10, "dragenter", this)), Array.prototype.forEach.call(e10.querySelectorAll("[draggable]"), function(n2) {
      n2.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Ge$2.splice(Ge$2.indexOf(this.el), 1), this.el = e10 = null;
  },
  _hideClone: function() {
    if (!se$2) {
      if (G$2("hideClone", this), p$2.eventCanceled)
        return;
      h$2(O$2, "display", "none"), this.options.removeCloneOnHide && O$2.parentNode && O$2.parentNode.removeChild(O$2), se$2 = true;
    }
  },
  _showClone: function(e10) {
    if (e10.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (se$2) {
      if (G$2("showClone", this), p$2.eventCanceled)
        return;
      c$2.parentNode == T$2 && !this.options.group.revertClone ? T$2.insertBefore(O$2, c$2) : pe$2 ? T$2.insertBefore(O$2, pe$2) : T$2.appendChild(O$2), this.options.group.revertClone && this.animate(c$2, O$2), h$2(O$2, "display", ""), se$2 = false;
    }
  }
};
function jn$2(t2) {
  t2.dataTransfer && (t2.dataTransfer.dropEffect = "move"), t2.cancelable && t2.preventDefault();
}
function Re$2(t2, e10, n2, o2, r3, i2, a2, l2) {
  var s2, u2 = t2[q$2], d2 = u2.options.onMove, f2;
  return window.CustomEvent && !ie$2 && !Ae$2 ? s2 = new CustomEvent("move", {
    bubbles: true,
    cancelable: true
  }) : (s2 = document.createEvent("Event"), s2.initEvent("move", true, true)), s2.to = e10, s2.from = t2, s2.dragged = n2, s2.draggedRect = o2, s2.related = r3 || e10, s2.relatedRect = i2 || M$2(e10), s2.willInsertAfter = l2, s2.originalEvent = a2, t2.dispatchEvent(s2), d2 && (f2 = d2.call(u2, s2, a2)), f2;
}
function tt$2(t2) {
  t2.draggable = false;
}
function zn$2() {
  at$2 = false;
}
function Un$2(t2, e10, n2) {
  var o2 = M$2(we$2(n2.el, 0, n2.options, true)), r3 = Ut$2(n2.el, n2.options, g$2), i2 = 10;
  return e10 ? t2.clientX < r3.left - i2 || t2.clientY < o2.top && t2.clientX < o2.right : t2.clientY < r3.top - i2 || t2.clientY < o2.bottom && t2.clientX < o2.left;
}
function Vn$2(t2, e10, n2) {
  var o2 = M$2(dt$2(n2.el, n2.options.draggable)), r3 = Ut$2(n2.el, n2.options, g$2), i2 = 10;
  return e10 ? t2.clientX > r3.right + i2 || t2.clientY > o2.bottom && t2.clientX > o2.left : t2.clientY > r3.bottom + i2 || t2.clientX > o2.right && t2.clientY > o2.top;
}
function $n$2(t2, e10, n2, o2, r3, i2, a2, l2) {
  var s2 = o2 ? t2.clientY : t2.clientX, u2 = o2 ? n2.height : n2.width, d2 = o2 ? n2.top : n2.left, f2 = o2 ? n2.bottom : n2.right, m2 = false;
  if (!a2) {
    if (l2 && Be$2 < u2 * r3) {
      if (!Ie$2 && (Oe$2 === 1 ? s2 > d2 + u2 * i2 / 2 : s2 < f2 - u2 * i2 / 2) && (Ie$2 = true), Ie$2)
        m2 = true;
      else if (Oe$2 === 1 ? s2 < d2 + Be$2 : s2 > f2 - Be$2)
        return -Oe$2;
    } else if (s2 > d2 + u2 * (1 - r3) / 2 && s2 < f2 - u2 * (1 - r3) / 2)
      return qn$2(e10);
  }
  return m2 = m2 || a2, m2 && (s2 < d2 + u2 * i2 / 2 || s2 > f2 - u2 * i2 / 2) ? s2 > d2 + u2 / 2 ? 1 : -1 : 0;
}
function qn$2(t2) {
  return K$2(c$2) < K$2(t2) ? 1 : -1;
}
function Kn$2(t2) {
  for (var e10 = t2.tagName + t2.className + t2.src + t2.href + t2.textContent, n2 = e10.length, o2 = 0; n2--; )
    o2 += e10.charCodeAt(n2);
  return o2.toString(36);
}
function Jn$2(t2) {
  je$2.length = 0;
  for (var e10 = t2.getElementsByTagName("input"), n2 = e10.length; n2--; ) {
    var o2 = e10[n2];
    o2.checked && je$2.push(o2);
  }
}
function ke$2(t2) {
  return setTimeout(t2, 0);
}
function lt$2(t2) {
  return clearTimeout(t2);
}
Ue$2 && D$2(document, "touchmove", function(t2) {
  (p$2.active || ve$2) && t2.cancelable && t2.preventDefault();
});
p$2.utils = {
  on: D$2,
  off: S$2,
  css: h$2,
  find: Wt$2,
  is: function(e10, n2) {
    return !!Z$2(e10, n2, e10, false);
  },
  extend: Mn$2,
  throttle: Gt$2,
  closest: Z$2,
  toggleClass: V$2,
  clone: zt$2,
  index: K$2,
  nextTick: ke$2,
  cancelNextTick: lt$2,
  detectDirection: $t$2,
  getChild: we$2
};
p$2.get = function(t2) {
  return t2[q$2];
};
p$2.mount = function() {
  for (var t2 = arguments.length, e10 = new Array(t2), n2 = 0; n2 < t2; n2++)
    e10[n2] = arguments[n2];
  e10[0].constructor === Array && (e10 = e10[0]), e10.forEach(function(o2) {
    if (!o2.prototype || !o2.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(o2));
    o2.utils && (p$2.utils = te$2(te$2({}, p$2.utils), o2.utils)), xe$2.mount(o2);
  });
};
p$2.create = function(t2, e10) {
  return new p$2(t2, e10);
};
p$2.version = xn$2;
var P$2 = [], Se$2, st$2, ut$2 = false, nt$2, ot$2, ze$2, De$2;
function Zn$2() {
  function t2() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var e10 in this)
      e10.charAt(0) === "_" && typeof this[e10] == "function" && (this[e10] = this[e10].bind(this));
  }
  return t2.prototype = {
    dragStarted: function(n2) {
      var o2 = n2.originalEvent;
      this.sortable.nativeDraggable ? D$2(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? D$2(document, "pointermove", this._handleFallbackAutoScroll) : o2.touches ? D$2(document, "touchmove", this._handleFallbackAutoScroll) : D$2(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(n2) {
      var o2 = n2.originalEvent;
      !this.options.dragOverBubble && !o2.rootEl && this._handleAutoScroll(o2);
    },
    drop: function() {
      this.sortable.nativeDraggable ? S$2(document, "dragover", this._handleAutoScroll) : (S$2(document, "pointermove", this._handleFallbackAutoScroll), S$2(document, "touchmove", this._handleFallbackAutoScroll), S$2(document, "mousemove", this._handleFallbackAutoScroll)), Mt$2(), He$2(), Fn$2();
    },
    nulling: function() {
      ze$2 = st$2 = Se$2 = ut$2 = De$2 = nt$2 = ot$2 = null, P$2.length = 0;
    },
    _handleFallbackAutoScroll: function(n2) {
      this._handleAutoScroll(n2, true);
    },
    _handleAutoScroll: function(n2, o2) {
      var r3 = this, i2 = (n2.touches ? n2.touches[0] : n2).clientX, a2 = (n2.touches ? n2.touches[0] : n2).clientY, l2 = document.elementFromPoint(i2, a2);
      if (ze$2 = n2, o2 || this.options.forceAutoScrollFallback || Ae$2 || ie$2 || _e$2) {
        rt$2(n2, this.options, l2, o2);
        var s2 = ue$2(l2, true);
        ut$2 && (!De$2 || i2 !== nt$2 || a2 !== ot$2) && (De$2 && Mt$2(), De$2 = setInterval(function() {
          var u2 = ue$2(document.elementFromPoint(i2, a2), true);
          u2 !== s2 && (s2 = u2, He$2()), rt$2(n2, r3.options, u2, o2);
        }, 10), nt$2 = i2, ot$2 = a2);
      } else {
        if (!this.options.bubbleScroll || ue$2(l2, true) === ee$2()) {
          He$2();
          return;
        }
        rt$2(n2, this.options, ue$2(l2, false), false);
      }
    }
  }, re$2(t2, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function He$2() {
  P$2.forEach(function(t2) {
    clearInterval(t2.pid);
  }), P$2 = [];
}
function Mt$2() {
  clearInterval(De$2);
}
var rt$2 = Gt$2(function(t2, e10, n2, o2) {
  if (e10.scroll) {
    var r3 = (t2.touches ? t2.touches[0] : t2).clientX, i2 = (t2.touches ? t2.touches[0] : t2).clientY, a2 = e10.scrollSensitivity, l2 = e10.scrollSpeed, s2 = ee$2(), u2 = false, d2;
    st$2 !== n2 && (st$2 = n2, He$2(), Se$2 = e10.scroll, d2 = e10.scrollFn, Se$2 === true && (Se$2 = ue$2(n2, true)));
    var f2 = 0, m2 = Se$2;
    do {
      var y2 = m2, b2 = M$2(y2), E2 = b2.top, k2 = b2.bottom, H2 = b2.left, F2 = b2.right, x2 = b2.width, L2 = b2.height, ne2 = void 0, j2 = void 0, Q2 = y2.scrollWidth, v2 = y2.scrollHeight, w2 = h$2(y2), N2 = y2.scrollLeft, I2 = y2.scrollTop;
      y2 === s2 ? (ne2 = x2 < Q2 && (w2.overflowX === "auto" || w2.overflowX === "scroll" || w2.overflowX === "visible"), j2 = L2 < v2 && (w2.overflowY === "auto" || w2.overflowY === "scroll" || w2.overflowY === "visible")) : (ne2 = x2 < Q2 && (w2.overflowX === "auto" || w2.overflowX === "scroll"), j2 = L2 < v2 && (w2.overflowY === "auto" || w2.overflowY === "scroll"));
      var _2 = ne2 && (Math.abs(F2 - r3) <= a2 && N2 + x2 < Q2) - (Math.abs(H2 - r3) <= a2 && !!N2), C2 = j2 && (Math.abs(k2 - i2) <= a2 && I2 + L2 < v2) - (Math.abs(E2 - i2) <= a2 && !!I2);
      if (!P$2[f2])
        for (var X2 = 0; X2 <= f2; X2++)
          P$2[X2] || (P$2[X2] = {});
      (P$2[f2].vx != _2 || P$2[f2].vy != C2 || P$2[f2].el !== y2) && (P$2[f2].el = y2, P$2[f2].vx = _2, P$2[f2].vy = C2, clearInterval(P$2[f2].pid), (_2 != 0 || C2 != 0) && (u2 = true, P$2[f2].pid = setInterval((function() {
        o2 && this.layer === 0 && p$2.active._onTouchMove(ze$2);
        var Y2 = P$2[this.layer].vy ? P$2[this.layer].vy * l2 : 0, z2 = P$2[this.layer].vx ? P$2[this.layer].vx * l2 : 0;
        typeof d2 == "function" && d2.call(p$2.dragged.parentNode[q$2], z2, Y2, t2, ze$2, P$2[this.layer].el) !== "continue" || jt$2(P$2[this.layer].el, z2, Y2);
      }).bind({
        layer: f2
      }), 24))), f2++;
    } while (e10.bubbleScroll && m2 !== s2 && (m2 = ue$2(m2, false)));
    ut$2 = u2;
  }
}, 30), Zt$2 = function(e10) {
  var n2 = e10.originalEvent, o2 = e10.putSortable, r3 = e10.dragEl, i2 = e10.activeSortable, a2 = e10.dispatchSortableEvent, l2 = e10.hideGhostForTarget, s2 = e10.unhideGhostForTarget;
  if (n2) {
    var u2 = o2 || i2;
    l2();
    var d2 = n2.changedTouches && n2.changedTouches.length ? n2.changedTouches[0] : n2, f2 = document.elementFromPoint(d2.clientX, d2.clientY);
    s2(), u2 && !u2.el.contains(f2) && (a2("spill"), this.onSpill({
      dragEl: r3,
      putSortable: o2
    }));
  }
};
function ht$2() {
}
ht$2.prototype = {
  startIndex: null,
  dragStart: function(e10) {
    var n2 = e10.oldDraggableIndex;
    this.startIndex = n2;
  },
  onSpill: function(e10) {
    var n2 = e10.dragEl, o2 = e10.putSortable;
    this.sortable.captureAnimationState(), o2 && o2.captureAnimationState();
    var r3 = we$2(this.sortable.el, this.startIndex, this.options);
    r3 ? this.sortable.el.insertBefore(n2, r3) : this.sortable.el.appendChild(n2), this.sortable.animateAll(), o2 && o2.animateAll();
  },
  drop: Zt$2
};
re$2(ht$2, {
  pluginName: "revertOnSpill"
});
function pt$2() {
}
pt$2.prototype = {
  onSpill: function(e10) {
    var n2 = e10.dragEl, o2 = e10.putSortable, r3 = o2 || this.sortable;
    r3.captureAnimationState(), n2.parentNode && n2.parentNode.removeChild(n2), r3.animateAll();
  },
  drop: Zt$2
};
re$2(pt$2, {
  pluginName: "removeOnSpill"
});
p$2.mount(new Zn$2());
p$2.mount(pt$2, ht$2);
function Qn$2(t2) {
  return t2 == null ? t2 : JSON.parse(JSON.stringify(t2));
}
function eo$2(t2) {
  getCurrentInstance() && onUnmounted(t2);
}
function to$1(t2) {
  getCurrentInstance() ? onMounted(t2) : nextTick(t2);
}
let Qt$2 = null, en$2 = null;
function Ft$2(t2 = null, e10 = null) {
  Qt$2 = t2, en$2 = e10;
}
function no$2() {
  return {
    data: Qt$2,
    clonedData: en$2
  };
}
const Rt$2 = Symbol("cloneElement");
function tn$2(...t2) {
  var j2, Q2;
  const e10 = (j2 = getCurrentInstance()) == null ? void 0 : j2.proxy;
  let n2 = null;
  const o2 = t2[0];
  let [, r3, i2] = t2;
  Array.isArray(unref(r3)) || (i2 = r3, r3 = null);
  let a2 = null;
  const {
    immediate: l2 = true,
    clone: s2 = Qn$2,
    customUpdate: u2
  } = (Q2 = unref(i2)) != null ? Q2 : {};
  function d2(v2) {
    var X2;
    const { from: w2, oldIndex: N2, item: I2 } = v2;
    n2 = Array.from(w2.childNodes);
    const _2 = unref((X2 = unref(r3)) == null ? void 0 : X2[N2]), C2 = s2(_2);
    Ft$2(_2, C2), I2[Rt$2] = C2;
  }
  function f2(v2) {
    const w2 = v2.item[Rt$2];
    if (!yn$2(w2)) {
      if (qe$2(v2.item), isRef(r3)) {
        const N2 = [...unref(r3)];
        r3.value = St$2(N2, v2.newDraggableIndex, w2);
        return;
      }
      St$2(unref(r3), v2.newDraggableIndex, w2);
    }
  }
  function m2(v2) {
    const { from: w2, item: N2, oldIndex: I2, oldDraggableIndex: _2, pullMode: C2, clone: X2 } = v2;
    if (Dt$2(w2, N2, I2), C2 === "clone") {
      qe$2(X2);
      return;
    }
    if (isRef(r3)) {
      const Y2 = [...unref(r3)];
      r3.value = Et$2(Y2, _2);
      return;
    }
    Et$2(unref(r3), _2);
  }
  function y2(v2) {
    if (u2) {
      u2(v2);
      return;
    }
    const { from: w2, item: N2, oldIndex: I2, newIndex: _2 } = v2;
    if (qe$2(N2), Dt$2(w2, N2, I2), isRef(r3)) {
      const C2 = [...unref(r3)];
      r3.value = wt$2(C2, I2, _2);
      return;
    }
    wt$2(unref(r3), I2, _2);
  }
  function b2(v2) {
    const { newIndex: w2, oldIndex: N2, from: I2, to: _2 } = v2;
    let C2 = null;
    const X2 = w2 === N2 && I2 === _2;
    try {
      if (X2) {
        let Y2 = null;
        n2 == null || n2.some((z2, ae2) => {
          if (Y2 && (n2 == null ? void 0 : n2.length) !== _2.childNodes.length)
            return I2.insertBefore(Y2, z2.nextSibling), true;
          const ce2 = _2.childNodes[ae2];
          Y2 = _2 == null ? void 0 : _2.replaceChild(z2, ce2);
        });
      }
    } catch (Y2) {
      C2 = Y2;
    } finally {
      n2 = null;
    }
    nextTick(() => {
      if (Ft$2(), C2)
        throw C2;
    });
  }
  const E2 = {
    onUpdate: y2,
    onStart: d2,
    onAdd: f2,
    onRemove: m2,
    onEnd: b2
  };
  function k2(v2) {
    const w2 = unref(o2);
    return v2 || (v2 = wn$2(w2) ? En$2(w2, e10 == null ? void 0 : e10.$el) : w2), v2 && !_n$2(v2) && (v2 = v2.$el), v2 || mn$2("Root element not found"), v2;
  }
  function H2() {
    var I2;
    const _2 = (I2 = unref(i2)) != null ? I2 : {}, { immediate: v2, clone: w2 } = _2, N2 = Ve$2(_2, ["immediate", "clone"]);
    return _t$2(N2, (C2, X2) => {
      Tn$2(C2) && (N2[C2] = (Y2, ...z2) => {
        const ae2 = no$2();
        return Cn$2(Y2, ae2), X2(Y2, ...z2);
      });
    }), Dn$2(
      r3 === null ? {} : E2,
      N2
    );
  }
  const F2 = (v2) => {
    v2 = k2(v2), a2 && x2.destroy(), a2 = new p$2(v2, H2());
  };
  watch(
    () => i2,
    () => {
      a2 && _t$2(H2(), (v2, w2) => {
        a2 == null || a2.option(v2, w2);
      });
    },
    { deep: true }
  );
  const x2 = {
    option: (v2, w2) => a2 == null ? void 0 : a2.option(v2, w2),
    destroy: () => {
      a2 == null || a2.destroy(), a2 = null;
    },
    save: () => a2 == null ? void 0 : a2.save(),
    toArray: () => a2 == null ? void 0 : a2.toArray(),
    closest: (...v2) => a2 == null ? void 0 : a2.closest(...v2)
  }, L2 = () => x2 == null ? void 0 : x2.option("disabled", true), ne2 = () => x2 == null ? void 0 : x2.option("disabled", false);
  return to$1(() => {
    l2 && F2();
  }), eo$2(x2.destroy), fe$2({ start: F2, pause: L2, resume: ne2 }, x2);
}
const ct$2 = [
  "update",
  "start",
  "add",
  "remove",
  "choose",
  "unchoose",
  "end",
  "sort",
  "filter",
  "clone",
  "move",
  "change"
], oo$2 = [
  "clone",
  "animation",
  "ghostClass",
  "group",
  "sort",
  "disabled",
  "store",
  "handle",
  "draggable",
  "swapThreshold",
  "invertSwap",
  "invertedSwapThreshold",
  "removeCloneOnHide",
  "direction",
  "chosenClass",
  "dragClass",
  "ignore",
  "filter",
  "preventOnFilter",
  "easing",
  "setData",
  "dropBubble",
  "dragoverBubble",
  "dataIdAttr",
  "delay",
  "delayOnTouchOnly",
  "touchStartThreshold",
  "forceFallback",
  "fallbackClass",
  "fallbackOnBody",
  "fallbackTolerance",
  "fallbackOffset",
  "supportPointer",
  "emptyInsertThreshold",
  "scroll",
  "forceAutoScrollFallback",
  "scrollSensitivity",
  "scrollSpeed",
  "bubbleScroll",
  "modelValue",
  "tag",
  "target",
  "customUpdate",
  ...ct$2.map((t2) => `on${t2.replace(/^\S/, (e10) => e10.toUpperCase())}`)
], lo$2 = defineComponent({
  name: "VueDraggable",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: oo$2,
  emits: ["update:modelValue", ...ct$2],
  setup(t2, { slots: e10, emit: n2, expose: o2, attrs: r3 }) {
    const i2 = ct$2.reduce((d2, f2) => {
      const m2 = `on${f2.replace(/^\S/, (y2) => y2.toUpperCase())}`;
      return d2[m2] = (...y2) => n2(f2, ...y2), d2;
    }, {}), a2 = computed(() => {
      const y2 = toRefs(t2), { modelValue: d2 } = y2, f2 = Ve$2(y2, ["modelValue"]), m2 = Object.entries(f2).reduce((b2, [E2, k2]) => {
        const H2 = unref(k2);
        return H2 !== void 0 && (b2[E2] = H2), b2;
      }, {});
      return fe$2(fe$2({}, i2), bn$2(fe$2(fe$2({}, r3), m2)));
    }), l2 = computed({
      get: () => t2.modelValue,
      set: (d2) => n2("update:modelValue", d2)
    }), s2 = ref(), u2 = reactive(
      tn$2(t2.target || s2, l2, a2)
    );
    return o2(u2), () => {
      var d2;
      return h$3(t2.tag || "div", { ref: s2 }, (d2 = e10 == null ? void 0 : e10.default) == null ? void 0 : d2.call(e10, u2));
    };
  }
});
const defaultComponentConfigs = /* @__PURE__ */ new Map([
  ["BasicComponents", [
    {
      size: "default",
      type: "primary",
      __config__: {
        tag: "el-button",
        span: 24,
        formItemWrapper: true
      },
      __slot__: {
        default: "button"
      }
    }
  ]],
  ["Data", [
    {
      __config__: {
        tag: "el-table",
        formItemWrapper: true,
        showLabel: false,
        span: 24
      },
      height: "100%",
      maxHeight: 2e3,
      size: "default",
      __slot__: {
        default: []
      }
    }
  ]],
  ["FromComponents", [
    {
      // 组件的自定义配置
      __config__: {
        showInList: false,
        label: "SingleLineOfText",
        showLabel: true,
        tag: "el-input",
        span: 24
      },
      // 组件的插槽属性
      // 其余的为可直接写在组件标签上的属性
      placeholder: "PleaseEnter"
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        label: "inputNumber",
        showLabel: true,
        tag: "el-input-number",
        span: 24,
        required: false,
        autocomplete: false
      },
      placeholder: "",
      step: 1,
      controls: true,
      stepStrictly: false,
      controlsPosition: "",
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        componentKey: "MultilineText",
        label: "MultilineText",
        labelWidth: null,
        showLabel: true,
        tag: "el-input",
        required: false,
        span: 24,
        autocomplete: false
      },
      type: "textarea",
      placeholder: "PleaseEnter",
      autosize: {
        minRows: 4,
        maxRows: 4
      },
      style: { width: "100%" },
      showWordLimit: false,
      readonly: false,
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "PasswordText",
        label: "PasswordText",
        showLabel: true,
        labelWidth: null,
        tag: "el-input",
        span: 24,
        autocomplete: false,
        required: false
      },
      type: "password",
      placeholder: "PleaseEnter",
      showPassword: true,
      style: { width: "100%" },
      clearable: true,
      maxlength: null,
      showWordLimit: false,
      readonly: false,
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        label: "DropDownList",
        showLabel: true,
        labelWidth: null,
        tag: "el-select",
        span: 24,
        required: false
      },
      __slot__: {
        default: {
          optionTag: "el-option"
        }
      },
      loading: false,
      placeholder: "请选择",
      style: { width: "100%" },
      clearable: true,
      disabled: false,
      filterable: false,
      multiple: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        label: "RadioGroup",
        labelWidth: null,
        showLabel: true,
        tag: "el-radio-group",
        span: 24
      },
      __slot__: {
        optionTag: "el-radio"
      },
      style: {},
      size: "default",
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        label: "CheckboxGroup",
        tag: "el-checkbox-group",
        dataValueType: "number",
        span: 24,
        showLabel: true,
        required: false,
        border: false
      },
      __slot__: {
        optionTag: "el-checkbox"
      },
      style: {},
      size: "default",
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "DatePicker",
        label: "DatePicker",
        tag: "el-date-picker",
        showLabel: true,
        labelWidth: null,
        span: 24,
        required: false,
        autocomplete: false
      },
      placeholder: "PleaseSelect",
      type: "date",
      style: { width: "100%" },
      disabled: false,
      clearable: true,
      format: "YYYY-MM-DD",
      valueFormat: "YYYY-MM-DD HH:mm:ss",
      readonly: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "TimePicker",
        label: "TimePicker",
        tag: "el-time-picker",
        span: 24,
        showLabel: true,
        labelWidth: null,
        required: false,
        autocomplete: false
      },
      placeholder: "PleaseSelect",
      style: { width: "100%" },
      disabled: false,
      clearable: true,
      format: "HH:mm:ss",
      valueFormat: "HH:mm:ss"
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "Switch",
        label: "Switch",
        tag: "el-switch",
        span: 24,
        showLabel: true,
        labelWidth: null,
        required: false,
        autocomplete: false
      },
      style: {},
      disabled: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "Slider",
        label: "Slider",
        tag: "el-slider",
        span: 24,
        showLabel: true,
        labelWidth: null,
        required: false,
        autocomplete: false,
        document: "https://element-plus.gitee.io/#/zh-CN/component/slider"
      },
      disabled: false,
      min: 0,
      max: 100,
      step: 1,
      showStops: false,
      range: false
    },
    {
      __config__: {
        showInList: false,
        isShowCellHeader: true,
        componentKey: "Rate",
        label: "Rate",
        tag: "el-rate",
        span: 24,
        showLabel: true,
        labelWidth: null,
        required: false,
        autocomplete: false
      },
      style: {},
      max: 5,
      allowHalf: false,
      showText: false,
      showScore: false,
      disabled: false
    },
    {
      __config__: {
        componentKey: "Upload",
        label: "Upload",
        tag: "el-upload",
        showLabel: true,
        labelWidth: null,
        required: false,
        span: 24,
        autocomplete: false,
        showTip: false,
        buttonText: "点击上传",
        fileSize: 2,
        sizeUnit: "MB"
      },
      __slot__: {},
      action: "/api/FlowEngineAttachment/Upload",
      downUrl: "/process/api/VHR75Attachment/DownLoad/{{id}}",
      disabled: false,
      accept: "",
      name: "files",
      multiple: false
    }
  ]],
  [
    "FlowComponents",
    [
      {
        __config__: {
          componentKey: "ApproveButton",
          label: "ApproveButton",
          showLabel: false,
          labelWidth: null,
          tag: "el-button",
          span: 24,
          additionalData: [{ key: "processOperation", value: "Approved" }],
          flag: "Predefined",
          submit: true,
          autoSubmit: true,
          purpose: "agreed",
          action: "/process/api/processNode/finish"
        },
        __slot__: {
          default: "Agree"
        },
        type: "primary",
        icon: "",
        round: false,
        size: "default",
        plain: false,
        circle: false,
        disabled: false
      },
      {
        __config__: {
          componentKey: "NotApproveButton",
          label: "NotApproveButton",
          showLabel: false,
          labelWidth: null,
          tag: "el-button",
          buttonType: "submit",
          span: 24,
          formItemWrapper: true,
          additionalData: [{ key: "processOperation", value: "NotApproved" }],
          submit: true,
          autoSubmit: true,
          action: "/process/api/processNode/finish",
          purpose: "disagreed"
        },
        __slot__: {
          default: "Reject"
        },
        type: "warning",
        icon: "",
        round: false,
        size: "default",
        plain: false,
        circle: false,
        disabled: false
      },
      {
        __config__: {
          label: "DoneButton",
          showLabel: false,
          labelWidth: null,
          tag: "el-button",
          span: 24,
          submit: true,
          autoSubmit: true,
          action: "/process/api/processNode/finish",
          formItemWrapper: true,
          purpose: "finish"
        },
        __slot__: {
          default: "Finished"
        },
        type: "primary",
        icon: "",
        round: false,
        size: "default",
        plain: false,
        circle: false,
        disabled: false
      },
      {
        __config__: {
          label: "ReturnButton",
          showLabel: false,
          labelWidth: null,
          tag: "el-button",
          span: 24,
          submit: true,
          autoSubmit: true,
          action: "/process/api/processNode/finish",
          formItemWrapper: true,
          purpose: "return",
          additionalData: [{ key: "processOperation", value: "Return" }]
        },
        __slot__: {
          default: "Return"
        },
        type: "primary",
        icon: "",
        round: false,
        size: "default",
        plain: false,
        circle: false,
        disabled: false
      },
      {
        __config__: {
          label: "StartNewProcess",
          showLabel: false,
          labelWidth: null,
          tag: "el-button",
          span: 24,
          submit: true,
          autoSubmit: true,
          action: "/process/api/Process/StartNewProcess",
          formItemWrapper: true,
          purpose: "startNewProcess"
        },
        __slot__: {
          default: "StartProcess"
        },
        type: "primary",
        icon: "",
        round: false,
        size: "default",
        plain: false,
        circle: false,
        disabled: false
      }
    ]
  ]
]);
var RenderMode = /* @__PURE__ */ ((RenderMode2) => {
  RenderMode2["mini"] = "mini";
  RenderMode2["normalWithFormItem"] = "normalWithFormItem";
  RenderMode2["normalWithoutFormItem"] = "normalWithoutFormItem";
  RenderMode2["design"] = "design";
  RenderMode2["simple"] = "simple";
  return RenderMode2;
})(RenderMode || {});
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var commonjsBrowser = {};
var v1$1 = {};
var rng$1 = {};
Object.defineProperty(rng$1, "__esModule", {
  value: true
});
rng$1.default = rng;
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
var stringify$1 = {};
var validate$1 = {};
var regex = {};
Object.defineProperty(regex, "__esModule", {
  value: true
});
regex.default = void 0;
var _default$c = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
regex.default = _default$c;
Object.defineProperty(validate$1, "__esModule", {
  value: true
});
validate$1.default = void 0;
var _regex = _interopRequireDefault$8(regex);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function validate(uuid) {
  return typeof uuid === "string" && _regex.default.test(uuid);
}
var _default$b = validate;
validate$1.default = _default$b;
Object.defineProperty(stringify$1, "__esModule", {
  value: true
});
stringify$1.default = void 0;
stringify$1.unsafeStringify = unsafeStringify;
var _validate$2 = _interopRequireDefault$7(validate$1);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const byteToHex = [];
for (let i2 = 0; i2 < 256; ++i2) {
  byteToHex.push((i2 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset);
  if (!(0, _validate$2.default)(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var _default$a = stringify;
stringify$1.default = _default$a;
Object.defineProperty(v1$1, "__esModule", {
  value: true
});
v1$1.default = void 0;
var _rng$1 = _interopRequireDefault$6(rng$1);
var _stringify$2 = stringify$1;
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
let _nodeId;
let _clockseq;
let _lastMSecs = 0;
let _lastNSecs = 0;
function v1(options, buf, offset) {
  let i2 = buf && offset || 0;
  const b2 = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== void 0 ? options.clockseq : _clockseq;
  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng$1.default)();
    if (node == null) {
      node = _nodeId = [seedBytes[0] | 1, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
    }
  }
  let msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  let nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  const dt2 = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt2 < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt2 < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  const tl2 = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b2[i2++] = tl2 >>> 24 & 255;
  b2[i2++] = tl2 >>> 16 & 255;
  b2[i2++] = tl2 >>> 8 & 255;
  b2[i2++] = tl2 & 255;
  const tmh = msecs / 4294967296 * 1e4 & 268435455;
  b2[i2++] = tmh >>> 8 & 255;
  b2[i2++] = tmh & 255;
  b2[i2++] = tmh >>> 24 & 15 | 16;
  b2[i2++] = tmh >>> 16 & 255;
  b2[i2++] = clockseq >>> 8 | 128;
  b2[i2++] = clockseq & 255;
  for (let n2 = 0; n2 < 6; ++n2) {
    b2[i2 + n2] = node[n2];
  }
  return buf || (0, _stringify$2.unsafeStringify)(b2);
}
var _default$9 = v1;
v1$1.default = _default$9;
var v3$1 = {};
var v35$1 = {};
var parse$1 = {};
Object.defineProperty(parse$1, "__esModule", {
  value: true
});
parse$1.default = void 0;
var _validate$1 = _interopRequireDefault$5(validate$1);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function parse(uuid) {
  if (!(0, _validate$1.default)(uuid)) {
    throw TypeError("Invalid UUID");
  }
  let v2;
  const arr = new Uint8Array(16);
  arr[0] = (v2 = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v2 >>> 16 & 255;
  arr[2] = v2 >>> 8 & 255;
  arr[3] = v2 & 255;
  arr[4] = (v2 = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v2 & 255;
  arr[6] = (v2 = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v2 & 255;
  arr[8] = (v2 = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v2 & 255;
  arr[10] = (v2 = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v2 / 4294967296 & 255;
  arr[12] = v2 >>> 24 & 255;
  arr[13] = v2 >>> 16 & 255;
  arr[14] = v2 >>> 8 & 255;
  arr[15] = v2 & 255;
  return arr;
}
var _default$8 = parse;
parse$1.default = _default$8;
Object.defineProperty(v35$1, "__esModule", {
  value: true
});
v35$1.URL = v35$1.DNS = void 0;
v35$1.default = v35;
var _stringify$1 = stringify$1;
var _parse = _interopRequireDefault$4(parse$1);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  const bytes = [];
  for (let i2 = 0; i2 < str.length; ++i2) {
    bytes.push(str.charCodeAt(i2));
  }
  return bytes;
}
const DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
v35$1.DNS = DNS;
const URL$1 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
v35$1.URL = URL$1;
function v35(name, version2, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace === "string") {
      namespace = (0, _parse.default)(namespace);
    }
    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (let i2 = 0; i2 < 16; ++i2) {
        buf[offset + i2] = bytes[i2];
      }
      return buf;
    }
    return (0, _stringify$1.unsafeStringify)(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL$1;
  return generateUUID;
}
var md5$1 = {};
Object.defineProperty(md5$1, "__esModule", {
  value: true
});
md5$1.default = void 0;
function md5(bytes) {
  if (typeof bytes === "string") {
    const msg = unescape(encodeURIComponent(bytes));
    bytes = new Uint8Array(msg.length);
    for (let i2 = 0; i2 < msg.length; ++i2) {
      bytes[i2] = msg.charCodeAt(i2);
    }
  }
  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = "0123456789abcdef";
  for (let i2 = 0; i2 < length32; i2 += 8) {
    const x2 = input[i2 >> 5] >>> i2 % 32 & 255;
    const hex2 = parseInt(hexTab.charAt(x2 >>> 4 & 15) + hexTab.charAt(x2 & 15), 16);
    output.push(hex2);
  }
  return output;
}
function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
function wordsToMd5(x2, len) {
  x2[len >> 5] |= 128 << len % 32;
  x2[getOutputLength(len) - 1] = len;
  let a2 = 1732584193;
  let b2 = -271733879;
  let c3 = -1732584194;
  let d2 = 271733878;
  for (let i2 = 0; i2 < x2.length; i2 += 16) {
    const olda = a2;
    const oldb = b2;
    const oldc = c3;
    const oldd = d2;
    a2 = md5ff(a2, b2, c3, d2, x2[i2], 7, -680876936);
    d2 = md5ff(d2, a2, b2, c3, x2[i2 + 1], 12, -389564586);
    c3 = md5ff(c3, d2, a2, b2, x2[i2 + 2], 17, 606105819);
    b2 = md5ff(b2, c3, d2, a2, x2[i2 + 3], 22, -1044525330);
    a2 = md5ff(a2, b2, c3, d2, x2[i2 + 4], 7, -176418897);
    d2 = md5ff(d2, a2, b2, c3, x2[i2 + 5], 12, 1200080426);
    c3 = md5ff(c3, d2, a2, b2, x2[i2 + 6], 17, -1473231341);
    b2 = md5ff(b2, c3, d2, a2, x2[i2 + 7], 22, -45705983);
    a2 = md5ff(a2, b2, c3, d2, x2[i2 + 8], 7, 1770035416);
    d2 = md5ff(d2, a2, b2, c3, x2[i2 + 9], 12, -1958414417);
    c3 = md5ff(c3, d2, a2, b2, x2[i2 + 10], 17, -42063);
    b2 = md5ff(b2, c3, d2, a2, x2[i2 + 11], 22, -1990404162);
    a2 = md5ff(a2, b2, c3, d2, x2[i2 + 12], 7, 1804603682);
    d2 = md5ff(d2, a2, b2, c3, x2[i2 + 13], 12, -40341101);
    c3 = md5ff(c3, d2, a2, b2, x2[i2 + 14], 17, -1502002290);
    b2 = md5ff(b2, c3, d2, a2, x2[i2 + 15], 22, 1236535329);
    a2 = md5gg(a2, b2, c3, d2, x2[i2 + 1], 5, -165796510);
    d2 = md5gg(d2, a2, b2, c3, x2[i2 + 6], 9, -1069501632);
    c3 = md5gg(c3, d2, a2, b2, x2[i2 + 11], 14, 643717713);
    b2 = md5gg(b2, c3, d2, a2, x2[i2], 20, -373897302);
    a2 = md5gg(a2, b2, c3, d2, x2[i2 + 5], 5, -701558691);
    d2 = md5gg(d2, a2, b2, c3, x2[i2 + 10], 9, 38016083);
    c3 = md5gg(c3, d2, a2, b2, x2[i2 + 15], 14, -660478335);
    b2 = md5gg(b2, c3, d2, a2, x2[i2 + 4], 20, -405537848);
    a2 = md5gg(a2, b2, c3, d2, x2[i2 + 9], 5, 568446438);
    d2 = md5gg(d2, a2, b2, c3, x2[i2 + 14], 9, -1019803690);
    c3 = md5gg(c3, d2, a2, b2, x2[i2 + 3], 14, -187363961);
    b2 = md5gg(b2, c3, d2, a2, x2[i2 + 8], 20, 1163531501);
    a2 = md5gg(a2, b2, c3, d2, x2[i2 + 13], 5, -1444681467);
    d2 = md5gg(d2, a2, b2, c3, x2[i2 + 2], 9, -51403784);
    c3 = md5gg(c3, d2, a2, b2, x2[i2 + 7], 14, 1735328473);
    b2 = md5gg(b2, c3, d2, a2, x2[i2 + 12], 20, -1926607734);
    a2 = md5hh(a2, b2, c3, d2, x2[i2 + 5], 4, -378558);
    d2 = md5hh(d2, a2, b2, c3, x2[i2 + 8], 11, -2022574463);
    c3 = md5hh(c3, d2, a2, b2, x2[i2 + 11], 16, 1839030562);
    b2 = md5hh(b2, c3, d2, a2, x2[i2 + 14], 23, -35309556);
    a2 = md5hh(a2, b2, c3, d2, x2[i2 + 1], 4, -1530992060);
    d2 = md5hh(d2, a2, b2, c3, x2[i2 + 4], 11, 1272893353);
    c3 = md5hh(c3, d2, a2, b2, x2[i2 + 7], 16, -155497632);
    b2 = md5hh(b2, c3, d2, a2, x2[i2 + 10], 23, -1094730640);
    a2 = md5hh(a2, b2, c3, d2, x2[i2 + 13], 4, 681279174);
    d2 = md5hh(d2, a2, b2, c3, x2[i2], 11, -358537222);
    c3 = md5hh(c3, d2, a2, b2, x2[i2 + 3], 16, -722521979);
    b2 = md5hh(b2, c3, d2, a2, x2[i2 + 6], 23, 76029189);
    a2 = md5hh(a2, b2, c3, d2, x2[i2 + 9], 4, -640364487);
    d2 = md5hh(d2, a2, b2, c3, x2[i2 + 12], 11, -421815835);
    c3 = md5hh(c3, d2, a2, b2, x2[i2 + 15], 16, 530742520);
    b2 = md5hh(b2, c3, d2, a2, x2[i2 + 2], 23, -995338651);
    a2 = md5ii(a2, b2, c3, d2, x2[i2], 6, -198630844);
    d2 = md5ii(d2, a2, b2, c3, x2[i2 + 7], 10, 1126891415);
    c3 = md5ii(c3, d2, a2, b2, x2[i2 + 14], 15, -1416354905);
    b2 = md5ii(b2, c3, d2, a2, x2[i2 + 5], 21, -57434055);
    a2 = md5ii(a2, b2, c3, d2, x2[i2 + 12], 6, 1700485571);
    d2 = md5ii(d2, a2, b2, c3, x2[i2 + 3], 10, -1894986606);
    c3 = md5ii(c3, d2, a2, b2, x2[i2 + 10], 15, -1051523);
    b2 = md5ii(b2, c3, d2, a2, x2[i2 + 1], 21, -2054922799);
    a2 = md5ii(a2, b2, c3, d2, x2[i2 + 8], 6, 1873313359);
    d2 = md5ii(d2, a2, b2, c3, x2[i2 + 15], 10, -30611744);
    c3 = md5ii(c3, d2, a2, b2, x2[i2 + 6], 15, -1560198380);
    b2 = md5ii(b2, c3, d2, a2, x2[i2 + 13], 21, 1309151649);
    a2 = md5ii(a2, b2, c3, d2, x2[i2 + 4], 6, -145523070);
    d2 = md5ii(d2, a2, b2, c3, x2[i2 + 11], 10, -1120210379);
    c3 = md5ii(c3, d2, a2, b2, x2[i2 + 2], 15, 718787259);
    b2 = md5ii(b2, c3, d2, a2, x2[i2 + 9], 21, -343485551);
    a2 = safeAdd(a2, olda);
    b2 = safeAdd(b2, oldb);
    c3 = safeAdd(c3, oldc);
    d2 = safeAdd(d2, oldd);
  }
  return [a2, b2, c3, d2];
}
function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }
  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));
  for (let i2 = 0; i2 < length8; i2 += 8) {
    output[i2 >> 5] |= (input[i2 / 8] & 255) << i2 % 32;
  }
  return output;
}
function safeAdd(x2, y2) {
  const lsw = (x2 & 65535) + (y2 & 65535);
  const msw = (x2 >> 16) + (y2 >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
function md5cmn(q2, a2, b2, x2, s2, t2) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a2, q2), safeAdd(x2, t2)), s2), b2);
}
function md5ff(a2, b2, c3, d2, x2, s2, t2) {
  return md5cmn(b2 & c3 | ~b2 & d2, a2, b2, x2, s2, t2);
}
function md5gg(a2, b2, c3, d2, x2, s2, t2) {
  return md5cmn(b2 & d2 | c3 & ~d2, a2, b2, x2, s2, t2);
}
function md5hh(a2, b2, c3, d2, x2, s2, t2) {
  return md5cmn(b2 ^ c3 ^ d2, a2, b2, x2, s2, t2);
}
function md5ii(a2, b2, c3, d2, x2, s2, t2) {
  return md5cmn(c3 ^ (b2 | ~d2), a2, b2, x2, s2, t2);
}
var _default$7 = md5;
md5$1.default = _default$7;
Object.defineProperty(v3$1, "__esModule", {
  value: true
});
v3$1.default = void 0;
var _v$2 = _interopRequireDefault$3(v35$1);
var _md = _interopRequireDefault$3(md5$1);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const v3 = (0, _v$2.default)("v3", 48, _md.default);
var _default$6 = v3;
v3$1.default = _default$6;
var v4$1 = {};
var native = {};
Object.defineProperty(native, "__esModule", {
  value: true
});
native.default = void 0;
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default$5 = {
  randomUUID
};
native.default = _default$5;
Object.defineProperty(v4$1, "__esModule", {
  value: true
});
v4$1.default = void 0;
var _native = _interopRequireDefault$2(native);
var _rng = _interopRequireDefault$2(rng$1);
var _stringify = stringify$1;
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || _rng.default)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (let i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return (0, _stringify.unsafeStringify)(rnds);
}
var _default$4 = v4;
v4$1.default = _default$4;
var v5$1 = {};
var sha1$1 = {};
Object.defineProperty(sha1$1, "__esModule", {
  value: true
});
sha1$1.default = void 0;
function f$2(s2, x2, y2, z2) {
  switch (s2) {
    case 0:
      return x2 & y2 ^ ~x2 & z2;
    case 1:
      return x2 ^ y2 ^ z2;
    case 2:
      return x2 & y2 ^ x2 & z2 ^ y2 & z2;
    case 3:
      return x2 ^ y2 ^ z2;
  }
}
function ROTL(x2, n2) {
  return x2 << n2 | x2 >>> 32 - n2;
}
function sha1(bytes) {
  const K2 = [1518500249, 1859775393, 2400959708, 3395469782];
  const H2 = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof bytes === "string") {
    const msg = unescape(encodeURIComponent(bytes));
    bytes = [];
    for (let i2 = 0; i2 < msg.length; ++i2) {
      bytes.push(msg.charCodeAt(i2));
    }
  } else if (!Array.isArray(bytes)) {
    bytes = Array.prototype.slice.call(bytes);
  }
  bytes.push(128);
  const l2 = bytes.length / 4 + 2;
  const N2 = Math.ceil(l2 / 16);
  const M2 = new Array(N2);
  for (let i2 = 0; i2 < N2; ++i2) {
    const arr = new Uint32Array(16);
    for (let j2 = 0; j2 < 16; ++j2) {
      arr[j2] = bytes[i2 * 64 + j2 * 4] << 24 | bytes[i2 * 64 + j2 * 4 + 1] << 16 | bytes[i2 * 64 + j2 * 4 + 2] << 8 | bytes[i2 * 64 + j2 * 4 + 3];
    }
    M2[i2] = arr;
  }
  M2[N2 - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M2[N2 - 1][14] = Math.floor(M2[N2 - 1][14]);
  M2[N2 - 1][15] = (bytes.length - 1) * 8 & 4294967295;
  for (let i2 = 0; i2 < N2; ++i2) {
    const W2 = new Uint32Array(80);
    for (let t2 = 0; t2 < 16; ++t2) {
      W2[t2] = M2[i2][t2];
    }
    for (let t2 = 16; t2 < 80; ++t2) {
      W2[t2] = ROTL(W2[t2 - 3] ^ W2[t2 - 8] ^ W2[t2 - 14] ^ W2[t2 - 16], 1);
    }
    let a2 = H2[0];
    let b2 = H2[1];
    let c3 = H2[2];
    let d2 = H2[3];
    let e10 = H2[4];
    for (let t2 = 0; t2 < 80; ++t2) {
      const s2 = Math.floor(t2 / 20);
      const T2 = ROTL(a2, 5) + f$2(s2, b2, c3, d2) + e10 + K2[s2] + W2[t2] >>> 0;
      e10 = d2;
      d2 = c3;
      c3 = ROTL(b2, 30) >>> 0;
      b2 = a2;
      a2 = T2;
    }
    H2[0] = H2[0] + a2 >>> 0;
    H2[1] = H2[1] + b2 >>> 0;
    H2[2] = H2[2] + c3 >>> 0;
    H2[3] = H2[3] + d2 >>> 0;
    H2[4] = H2[4] + e10 >>> 0;
  }
  return [H2[0] >> 24 & 255, H2[0] >> 16 & 255, H2[0] >> 8 & 255, H2[0] & 255, H2[1] >> 24 & 255, H2[1] >> 16 & 255, H2[1] >> 8 & 255, H2[1] & 255, H2[2] >> 24 & 255, H2[2] >> 16 & 255, H2[2] >> 8 & 255, H2[2] & 255, H2[3] >> 24 & 255, H2[3] >> 16 & 255, H2[3] >> 8 & 255, H2[3] & 255, H2[4] >> 24 & 255, H2[4] >> 16 & 255, H2[4] >> 8 & 255, H2[4] & 255];
}
var _default$3 = sha1;
sha1$1.default = _default$3;
Object.defineProperty(v5$1, "__esModule", {
  value: true
});
v5$1.default = void 0;
var _v$1 = _interopRequireDefault$1(v35$1);
var _sha = _interopRequireDefault$1(sha1$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const v5 = (0, _v$1.default)("v5", 80, _sha.default);
var _default$2 = v5;
v5$1.default = _default$2;
var nil = {};
Object.defineProperty(nil, "__esModule", {
  value: true
});
nil.default = void 0;
var _default$1 = "00000000-0000-0000-0000-000000000000";
nil.default = _default$1;
var version$1 = {};
Object.defineProperty(version$1, "__esModule", {
  value: true
});
version$1.default = void 0;
var _validate = _interopRequireDefault(validate$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError("Invalid UUID");
  }
  return parseInt(uuid.slice(14, 15), 16);
}
var _default = version;
version$1.default = _default;
(function(exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "NIL", {
    enumerable: true,
    get: function get2() {
      return _nil.default;
    }
  });
  Object.defineProperty(exports, "parse", {
    enumerable: true,
    get: function get2() {
      return _parse2.default;
    }
  });
  Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function get2() {
      return _stringify2.default;
    }
  });
  Object.defineProperty(exports, "v1", {
    enumerable: true,
    get: function get2() {
      return _v3.default;
    }
  });
  Object.defineProperty(exports, "v3", {
    enumerable: true,
    get: function get2() {
      return _v22.default;
    }
  });
  Object.defineProperty(exports, "v4", {
    enumerable: true,
    get: function get2() {
      return _v32.default;
    }
  });
  Object.defineProperty(exports, "v5", {
    enumerable: true,
    get: function get2() {
      return _v4.default;
    }
  });
  Object.defineProperty(exports, "validate", {
    enumerable: true,
    get: function get2() {
      return _validate2.default;
    }
  });
  Object.defineProperty(exports, "version", {
    enumerable: true,
    get: function get2() {
      return _version.default;
    }
  });
  var _v3 = _interopRequireDefault2(v1$1);
  var _v22 = _interopRequireDefault2(v3$1);
  var _v32 = _interopRequireDefault2(v4$1);
  var _v4 = _interopRequireDefault2(v5$1);
  var _nil = _interopRequireDefault2(nil);
  var _version = _interopRequireDefault2(version$1);
  var _validate2 = _interopRequireDefault2(validate$1);
  var _stringify2 = _interopRequireDefault2(stringify$1);
  var _parse2 = _interopRequireDefault2(parse$1);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
})(commonjsBrowser);
function Converter$1(srcAlphabet, dstAlphabet) {
  if (!srcAlphabet || !dstAlphabet || !srcAlphabet.length || !dstAlphabet.length) {
    throw new Error("Bad alphabet");
  }
  this.srcAlphabet = srcAlphabet;
  this.dstAlphabet = dstAlphabet;
}
Converter$1.prototype.convert = function(number4) {
  var i2, divide, newlen, numberMap = {}, fromBase = this.srcAlphabet.length, toBase = this.dstAlphabet.length, length = number4.length, result = typeof number4 === "string" ? "" : [];
  if (!this.isValid(number4)) {
    throw new Error('Number "' + number4 + '" contains of non-alphabetic digits (' + this.srcAlphabet + ")");
  }
  if (this.srcAlphabet === this.dstAlphabet) {
    return number4;
  }
  for (i2 = 0; i2 < length; i2++) {
    numberMap[i2] = this.srcAlphabet.indexOf(number4[i2]);
  }
  do {
    divide = 0;
    newlen = 0;
    for (i2 = 0; i2 < length; i2++) {
      divide = divide * fromBase + numberMap[i2];
      if (divide >= toBase) {
        numberMap[newlen++] = parseInt(divide / toBase, 10);
        divide = divide % toBase;
      } else if (newlen > 0) {
        numberMap[newlen++] = 0;
      }
    }
    length = newlen;
    result = this.dstAlphabet.slice(divide, divide + 1).concat(result);
  } while (newlen !== 0);
  return result;
};
Converter$1.prototype.isValid = function(number4) {
  var i2 = 0;
  for (; i2 < number4.length; ++i2) {
    if (this.srcAlphabet.indexOf(number4[i2]) === -1) {
      return false;
    }
  }
  return true;
};
var converter = Converter$1;
var Converter = converter;
function anyBase$1(srcAlphabet, dstAlphabet) {
  var converter2 = new Converter(srcAlphabet, dstAlphabet);
  return function(number4) {
    return converter2.convert(number4);
  };
}
anyBase$1.BIN = "01";
anyBase$1.OCT = "01234567";
anyBase$1.DEC = "0123456789";
anyBase$1.HEX = "0123456789abcdef";
var anyBase_1 = anyBase$1;
const { v4: uuidV4, validate: uuidValidate } = commonjsBrowser;
const anyBase = anyBase_1;
const constants = {
  cookieBase90: "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&'()*+-./:<=>?@[]^_`{|}~",
  flickrBase58: "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ",
  uuid25Base36: "0123456789abcdefghijklmnopqrstuvwxyz"
};
const baseOptions = {
  consistentLength: true
};
let toFlickr;
const shortenUUID = (longId, translator, paddingParams) => {
  const translated = translator(longId.toLowerCase().replace(/-/g, ""));
  if (!paddingParams || !paddingParams.consistentLength) return translated;
  return translated.padStart(
    paddingParams.shortIdLength,
    paddingParams.paddingChar
  );
};
const enlargeUUID = (shortId, translator) => {
  const uu1 = translator(shortId).padStart(32, "0");
  const m2 = uu1.match(/(\w{8})(\w{4})(\w{4})(\w{4})(\w{12})/);
  return [m2[1], m2[2], m2[3], m2[4], m2[5]].join("-");
};
const getShortIdLength = (alphabetLength) => Math.ceil(Math.log(2 ** 128) / Math.log(alphabetLength));
var shortUuid = (() => {
  const makeConvertor = (toAlphabet, options) => {
    const useAlphabet = toAlphabet || constants.flickrBase58;
    const selectedOptions = { ...baseOptions, ...options };
    if ([...new Set(Array.from(useAlphabet))].length !== useAlphabet.length) {
      throw new Error("The provided Alphabet has duplicate characters resulting in unreliable results");
    }
    const shortIdLength = getShortIdLength(useAlphabet.length);
    const paddingParams = {
      shortIdLength,
      consistentLength: selectedOptions.consistentLength,
      paddingChar: useAlphabet[0]
    };
    const fromHex = anyBase(anyBase.HEX, useAlphabet);
    const toHex = anyBase(useAlphabet, anyBase.HEX);
    const generate = () => shortenUUID(uuidV4(), fromHex, paddingParams);
    const validate2 = (shortId, rigorous = false) => {
      if (!shortId || typeof shortId !== "string") return false;
      const isCorrectLength = selectedOptions.consistentLength ? shortId.length === shortIdLength : shortId.length <= shortIdLength;
      const onlyAlphabet = shortId.split("").every((letter) => useAlphabet.includes(letter));
      if (rigorous === false) return isCorrectLength && onlyAlphabet;
      return isCorrectLength && onlyAlphabet && uuidValidate(enlargeUUID(shortId, toHex));
    };
    const translator = {
      alphabet: useAlphabet,
      fromUUID: (uuid) => shortenUUID(uuid, fromHex, paddingParams),
      maxLength: shortIdLength,
      generate,
      new: generate,
      toUUID: (shortUuid2) => enlargeUUID(shortUuid2, toHex),
      uuid: uuidV4,
      validate: validate2
    };
    Object.freeze(translator);
    return translator;
  };
  makeConvertor.constants = constants;
  makeConvertor.uuid = uuidV4;
  makeConvertor.generate = () => {
    if (!toFlickr) {
      toFlickr = makeConvertor(constants.flickrBase58).generate;
    }
    return toFlickr();
  };
  return makeConvertor;
})();
const isFormItem = (schema) => {
  var _a3;
  return !isNullOrUndefinedOrWhiteSpace((_a3 = schema.__config__) == null ? void 0 : _a3.label) || schema.__config__.formItemWrapper;
};
const createSlotBuildContext = (context, slotConfig, slotName) => {
  let parentVModels = context.parentVModels;
  if (parentVModels) {
    parentVModels = [...parentVModels];
  } else {
    parentVModels = [];
  }
  if (!isNullOrUndefinedOrWhiteSpace(context.schema.__vModel__)) {
    parentVModels.push(context.schema.__vModel__);
  }
  let formModel = context.formModel;
  let slotBuildContext = {
    ...context,
    formModel,
    slotConfig,
    slotName,
    parentVModels
  };
  slotBuildContext.key = void 0;
  return slotBuildContext;
};
const createBuildContext = (slotBuildContext, index2) => {
  var _a3;
  let formModel = slotBuildContext.formModel;
  let config = index2 !== void 0 ? slotBuildContext.slotConfig[index2] : slotBuildContext.slotConfig;
  if (!isNullOrUndefinedOrWhiteSpace(config.__vModel__)) {
    let lastVModel = (_a3 = slotBuildContext.parentVModels) == null ? void 0 : _a3.last();
    if (lastVModel) {
      formModel = formModel == null ? void 0 : formModel[lastVModel];
    }
  }
  let buildContext = { ...slotBuildContext };
  buildContext.slotConfig = void 0;
  buildContext.schema = config;
  buildContext.formModel = formModel;
  if (slotBuildContext.parentVModels) {
    buildContext.parentVModels = [...slotBuildContext.parentVModels];
  }
  return buildContext;
};
const ensureSchemaId = (context) => {
  if (!context.schema.__runtime__) {
    context.schema.__runtime__ = {};
  }
  if (isNullOrUndefinedOrWhiteSpace(context.schema.__runtime__.id)) {
    context.schema.__runtime__.id = shortUuid.uuid();
  }
  return context.schema.__runtime__.id;
};
const ensureSetupFlags = (context) => {
  if (!context.globalContext.__runtime__) {
    context.globalContext.__runtime__ = {};
  }
  if (!context.globalContext.__runtime__.setupFlags) {
    context.globalContext.__runtime__.setupFlags = [];
  }
  return context.globalContext.__runtime__.setupFlags;
};
const canExecuteSetup = (context) => {
  const id2 = ensureSchemaId(context);
  const setupFlags = ensureSetupFlags(context);
  return !setupFlags.includes(id2);
};
const setSetupFlag = (context) => {
  const id2 = ensureSchemaId(context);
  const setupFlags = ensureSetupFlags(context);
  return setupFlags.push(id2);
};
const setRedundancyValue = (context, value) => {
  context.formModel["redundancy-" + context.schema.__vModel__] = value;
};
const removeRedundancyValue = (context) => {
  delete context.formModel["redundancy-" + context.schema.__vModel__];
};
const getRedundancyName = (vModel) => {
  return "redundancy-" + vModel;
};
/*! Element Plus Icons Vue v2.3.1 */
var add_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "AddLocation",
  __name: "add-location",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 384h96a32 32 0 1 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0z"
      })
    ]));
  }
});
var add_location_default = add_location_vue_vue_type_script_setup_true_lang_default;
var aim_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Aim",
  __name: "aim",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 96a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V128a32 32 0 0 1 32-32m0 576a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V704a32 32 0 0 1 32-32M96 512a32 32 0 0 1 32-32h192a32 32 0 0 1 0 64H128a32 32 0 0 1-32-32m576 0a32 32 0 0 1 32-32h192a32 32 0 1 1 0 64H704a32 32 0 0 1-32-32"
      })
    ]));
  }
});
var aim_default = aim_vue_vue_type_script_setup_true_lang_default;
var alarm_clock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "AlarmClock",
  __name: "alarm-clock",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 832a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m292.288 824.576 55.424 32-48 83.136a32 32 0 1 1-55.424-32zm439.424 0-55.424 32 48 83.136a32 32 0 1 0 55.424-32zM512 512h160a32 32 0 1 1 0 64H480a32 32 0 0 1-32-32V320a32 32 0 0 1 64 0zM90.496 312.256A160 160 0 0 1 312.32 90.496l-46.848 46.848a96 96 0 0 0-128 128L90.56 312.256zm835.264 0A160 160 0 0 0 704 90.496l46.848 46.848a96 96 0 0 1 128 128z"
      })
    ]));
  }
});
var alarm_clock_default = alarm_clock_vue_vue_type_script_setup_true_lang_default;
var apple_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Apple",
  __name: "apple",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M599.872 203.776a189.44 189.44 0 0 1 64.384-4.672l2.624.128c31.168 1.024 51.2 4.096 79.488 16.32 37.632 16.128 74.496 45.056 111.488 89.344 96.384 115.264 82.752 372.8-34.752 521.728-7.68 9.728-32 41.6-30.72 39.936a426.624 426.624 0 0 1-30.08 35.776c-31.232 32.576-65.28 49.216-110.08 50.048-31.36.64-53.568-5.312-84.288-18.752l-6.528-2.88c-20.992-9.216-30.592-11.904-47.296-11.904-18.112 0-28.608 2.88-51.136 12.672l-6.464 2.816c-28.416 12.224-48.32 18.048-76.16 19.2-74.112 2.752-116.928-38.08-180.672-132.16-96.64-142.08-132.608-349.312-55.04-486.4 46.272-81.92 129.92-133.632 220.672-135.04 32.832-.576 60.288 6.848 99.648 22.72 27.136 10.88 34.752 13.76 37.376 14.272 16.256-20.16 27.776-36.992 34.56-50.24 13.568-26.304 27.2-59.968 40.704-100.8a32 32 0 1 1 60.8 20.224c-12.608 37.888-25.408 70.4-38.528 97.664zm-51.52 78.08c-14.528 17.792-31.808 37.376-51.904 58.816a32 32 0 1 1-46.72-43.776l12.288-13.248c-28.032-11.2-61.248-26.688-95.68-26.112-70.4 1.088-135.296 41.6-171.648 105.792C121.6 492.608 176 684.16 247.296 788.992c34.816 51.328 76.352 108.992 130.944 106.944 52.48-2.112 72.32-34.688 135.872-34.688 63.552 0 81.28 34.688 136.96 33.536 56.448-1.088 75.776-39.04 126.848-103.872 107.904-136.768 107.904-362.752 35.776-449.088-72.192-86.272-124.672-84.096-151.68-85.12-41.472-4.288-81.6 12.544-113.664 25.152z"
      })
    ]));
  }
});
var apple_default = apple_vue_vue_type_script_setup_true_lang_default;
var arrow_down_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowDownBold",
  __name: "arrow-down-bold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});
var arrow_down_bold_default = arrow_down_bold_vue_vue_type_script_setup_true_lang_default;
var arrow_down_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowDown",
  __name: "arrow-down",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
      })
    ]));
  }
});
var arrow_down_default = arrow_down_vue_vue_type_script_setup_true_lang_default;
var arrow_left_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowLeftBold",
  __name: "arrow-left-bold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0z"
      })
    ]));
  }
});
var arrow_left_bold_default = arrow_left_bold_vue_vue_type_script_setup_true_lang_default;
var arrow_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowLeft",
  __name: "arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"
      })
    ]));
  }
});
var arrow_left_default = arrow_left_vue_vue_type_script_setup_true_lang_default;
var arrow_right_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowRightBold",
  __name: "arrow-right-bold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z"
      })
    ]));
  }
});
var arrow_right_bold_default = arrow_right_bold_vue_vue_type_script_setup_true_lang_default;
var arrow_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowRight",
  __name: "arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
      })
    ]));
  }
});
var arrow_right_default = arrow_right_vue_vue_type_script_setup_true_lang_default;
var arrow_up_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowUpBold",
  __name: "arrow-up-bold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496z"
      })
    ]));
  }
});
var arrow_up_bold_default = arrow_up_bold_vue_vue_type_script_setup_true_lang_default;
var arrow_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ArrowUp",
  __name: "arrow-up",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"
      })
    ]));
  }
});
var arrow_up_default = arrow_up_vue_vue_type_script_setup_true_lang_default;
var avatar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Avatar",
  __name: "avatar",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M628.736 528.896A416 416 0 0 1 928 928H96a415.872 415.872 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"
      })
    ]));
  }
});
var avatar_default = avatar_vue_vue_type_script_setup_true_lang_default;
var back_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Back",
  __name: "back",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312z"
      })
    ]));
  }
});
var back_default = back_vue_vue_type_script_setup_true_lang_default;
var baseball_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Baseball",
  __name: "baseball",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M195.2 828.8a448 448 0 1 1 633.6-633.6 448 448 0 0 1-633.6 633.6zm45.248-45.248a384 384 0 1 0 543.104-543.104 384 384 0 0 0-543.104 543.104"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M497.472 96.896c22.784 4.672 44.416 9.472 64.896 14.528a256.128 256.128 0 0 0 350.208 350.208c5.056 20.48 9.856 42.112 14.528 64.896A320.128 320.128 0 0 1 497.472 96.896zM108.48 491.904a320.128 320.128 0 0 1 423.616 423.68c-23.04-3.648-44.992-7.424-65.728-11.52a256.128 256.128 0 0 0-346.496-346.432 1736.64 1736.64 0 0 1-11.392-65.728z"
      })
    ]));
  }
});
var baseball_default = baseball_vue_vue_type_script_setup_true_lang_default;
var basketball_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Basketball",
  __name: "basketball",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M778.752 788.224a382.464 382.464 0 0 0 116.032-245.632 256.512 256.512 0 0 0-241.728-13.952 762.88 762.88 0 0 1 125.696 259.584zm-55.04 44.224a699.648 699.648 0 0 0-125.056-269.632 256.128 256.128 0 0 0-56.064 331.968 382.72 382.72 0 0 0 181.12-62.336m-254.08 61.248A320.128 320.128 0 0 1 557.76 513.6a715.84 715.84 0 0 0-48.192-48.128 320.128 320.128 0 0 1-379.264 88.384 382.4 382.4 0 0 0 110.144 229.696 382.4 382.4 0 0 0 229.184 110.08zM129.28 481.088a256.128 256.128 0 0 0 331.072-56.448 699.648 699.648 0 0 0-268.8-124.352 382.656 382.656 0 0 0-62.272 180.8m106.56-235.84a762.88 762.88 0 0 1 258.688 125.056 256.512 256.512 0 0 0-13.44-241.088A382.464 382.464 0 0 0 235.84 245.248zm318.08-114.944c40.576 89.536 37.76 193.92-8.448 281.344a779.84 779.84 0 0 1 66.176 66.112 320.832 320.832 0 0 1 282.112-8.128 382.4 382.4 0 0 0-110.144-229.12 382.4 382.4 0 0 0-229.632-110.208zM828.8 828.8a448 448 0 1 1-633.6-633.6 448 448 0 0 1 633.6 633.6"
      })
    ]));
  }
});
var basketball_default = basketball_vue_vue_type_script_setup_true_lang_default;
var bell_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "BellFilled",
  __name: "bell-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 832a128 128 0 0 1-256 0zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448c0-154.88 110.08-284.16 256.32-313.6a64 64 0 1 1 127.36 0A320.128 320.128 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8z"
      })
    ]));
  }
});
var bell_filled_default = bell_filled_vue_vue_type_script_setup_true_lang_default;
var bell_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Bell",
  __name: "bell",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a64 64 0 0 1 64 64v64H448v-64a64 64 0 0 1 64-64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 768h512V448a256 256 0 1 0-512 0zm256-640a320 320 0 0 1 320 320v384H192V448a320 320 0 0 1 320-320"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M96 768h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32m352 128h128a64 64 0 0 1-128 0"
      })
    ]));
  }
});
var bell_default = bell_vue_vue_type_script_setup_true_lang_default;
var bicycle_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Bicycle",
  __name: "bicycle",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 672h320q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 192a32 32 0 0 1 0-64h160a32 32 0 0 1 31.04 24.256l96 384a32 32 0 0 1-62.08 15.488L615.04 192zM96 384a32 32 0 0 1 0-64h128a32 32 0 0 1 30.336 21.888l64 192a32 32 0 1 1-60.672 20.224L200.96 384z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m373.376 599.808-42.752-47.616 320-288 42.752 47.616z"
      })
    ]));
  }
});
var bicycle_default = bicycle_vue_vue_type_script_setup_true_lang_default;
var bottom_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "BottomLeft",
  __name: "bottom-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 768h416a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V352a32 32 0 0 1 64 0z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M246.656 822.656a32 32 0 0 1-45.312-45.312l544-544a32 32 0 0 1 45.312 45.312l-544 544z"
      })
    ]));
  }
});
var bottom_left_default = bottom_left_vue_vue_type_script_setup_true_lang_default;
var bottom_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "BottomRight",
  __name: "bottom-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 768a32 32 0 1 0 0 64h448a32 32 0 0 0 32-32V352a32 32 0 0 0-64 0v416z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M777.344 822.656a32 32 0 0 0 45.312-45.312l-544-544a32 32 0 0 0-45.312 45.312z"
      })
    ]));
  }
});
var bottom_right_default = bottom_right_vue_vue_type_script_setup_true_lang_default;
var bottom_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Bottom",
  __name: "bottom",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 805.888V168a32 32 0 1 0-64 0v637.888L246.656 557.952a30.72 30.72 0 0 0-45.312 0 35.52 35.52 0 0 0 0 48.064l288 306.048a30.72 30.72 0 0 0 45.312 0l288-306.048a35.52 35.52 0 0 0 0-48 30.72 30.72 0 0 0-45.312 0L544 805.824z"
      })
    ]));
  }
});
var bottom_default = bottom_vue_vue_type_script_setup_true_lang_default;
var bowl_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Bowl",
  __name: "bowl",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M714.432 704a351.744 351.744 0 0 0 148.16-256H161.408a351.744 351.744 0 0 0 148.16 256zM288 766.592A415.68 415.68 0 0 1 96 416a32 32 0 0 1 32-32h768a32 32 0 0 1 32 32 415.68 415.68 0 0 1-192 350.592V832a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64zM493.248 320h-90.496l254.4-254.4a32 32 0 1 1 45.248 45.248zm187.328 0h-128l269.696-155.712a32 32 0 0 1 32 55.424zM352 768v64h320v-64z"
      })
    ]));
  }
});
var bowl_default = bowl_vue_vue_type_script_setup_true_lang_default;
var box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Box",
  __name: "box",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M317.056 128 128 344.064V896h768V344.064L706.944 128zm-14.528-64h418.944a32 32 0 0 1 24.064 10.88l206.528 236.096A32 32 0 0 1 960 332.032V928a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V332.032a32 32 0 0 1 7.936-21.12L278.4 75.008A32 32 0 0 1 302.528 64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M64 320h896v64H64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 327.872V640h128V327.872L526.08 128h-28.16zM448 64h128l64 256v352a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V320z"
      })
    ]));
  }
});
var box_default = box_vue_vue_type_script_setup_true_lang_default;
var briefcase_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Briefcase",
  __name: "briefcase",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M320 320V128h384v192h192v192H128V320zM128 576h768v320H128zm256-256h256.064V192H384z"
      })
    ]));
  }
});
var briefcase_default = briefcase_vue_vue_type_script_setup_true_lang_default;
var brush_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "BrushFilled",
  __name: "brush-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M608 704v160a96 96 0 0 1-192 0V704h-96a128 128 0 0 1-128-128h640a128 128 0 0 1-128 128zM192 512V128.064h640V512z"
      })
    ]));
  }
});
var brush_filled_default = brush_filled_vue_vue_type_script_setup_true_lang_default;
var brush_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Brush",
  __name: "brush",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M896 448H128v192a64 64 0 0 0 64 64h192v192h256V704h192a64 64 0 0 0 64-64zm-770.752-64c0-47.552 5.248-90.24 15.552-128 14.72-54.016 42.496-107.392 83.2-160h417.28l-15.36 70.336L736 96h211.2c-24.832 42.88-41.92 96.256-51.2 160a663.872 663.872 0 0 0-6.144 128H960v256a128 128 0 0 1-128 128H704v160a32 32 0 0 1-32 32H352a32 32 0 0 1-32-32V768H192A128 128 0 0 1 64 640V384h61.248zm64 0h636.544c-2.048-45.824.256-91.584 6.848-137.216 4.48-30.848 10.688-59.776 18.688-86.784h-96.64l-221.12 141.248L561.92 160H256.512c-25.856 37.888-43.776 75.456-53.952 112.832-8.768 32.064-13.248 69.12-13.312 111.168z"
      })
    ]));
  }
});
var brush_default = brush_vue_vue_type_script_setup_true_lang_default;
var burger_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Burger",
  __name: "burger",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 512a32 32 0 0 0-32 32v64a32 32 0 0 0 30.08 32H864a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm736-58.56A96 96 0 0 1 960 544v64a96 96 0 0 1-51.968 85.312L855.36 833.6a96 96 0 0 1-89.856 62.272H258.496A96 96 0 0 1 168.64 833.6l-52.608-140.224A96 96 0 0 1 64 608v-64a96 96 0 0 1 64-90.56V448a384 384 0 1 1 768 5.44M832 448a320 320 0 0 0-640 0zM512 704H188.352l40.192 107.136a32 32 0 0 0 29.952 20.736h507.008a32 32 0 0 0 29.952-20.736L835.648 704z"
      })
    ]));
  }
});
var burger_default = burger_vue_vue_type_script_setup_true_lang_default;
var calendar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Calendar",
  __name: "calendar",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 384v512h768V192H768v32a32 32 0 1 1-64 0v-32H320v32a32 32 0 0 1-64 0v-32H128v128h768v64zm192-256h384V96a32 32 0 1 1 64 0v32h160a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h160V96a32 32 0 0 1 64 0zm-32 384h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64"
      })
    ]));
  }
});
var calendar_default = calendar_vue_vue_type_script_setup_true_lang_default;
var camera_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CameraFilled",
  __name: "camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 224a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h704a64 64 0 0 0 64-64V288a64 64 0 0 0-64-64H748.416l-46.464-92.672A64 64 0 0 0 644.736 96H379.328a64 64 0 0 0-57.216 35.392L275.776 224zm352 435.2a115.2 115.2 0 1 0 0-230.4 115.2 115.2 0 0 0 0 230.4m0 140.8a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      })
    ]));
  }
});
var camera_filled_default = camera_filled_vue_vue_type_script_setup_true_lang_default;
var camera_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Camera",
  __name: "camera",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M896 256H128v576h768zm-199.424-64-32.064-64h-304.96l-32 64zM96 192h160l46.336-92.608A64 64 0 0 1 359.552 64h304.96a64 64 0 0 1 57.216 35.328L768.192 192H928a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32m416 512a160 160 0 1 0 0-320 160 160 0 0 0 0 320m0 64a224 224 0 1 1 0-448 224 224 0 0 1 0 448"
      })
    ]));
  }
});
var camera_default = camera_vue_vue_type_script_setup_true_lang_default;
var caret_bottom_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CaretBottom",
  __name: "caret-bottom",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m192 384 320 384 320-384z"
      })
    ]));
  }
});
var caret_bottom_default = caret_bottom_vue_vue_type_script_setup_true_lang_default;
var caret_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CaretLeft",
  __name: "caret-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M672 192 288 511.936 672 832z"
      })
    ]));
  }
});
var caret_left_default = caret_left_vue_vue_type_script_setup_true_lang_default;
var caret_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CaretRight",
  __name: "caret-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 192v640l384-320.064z"
      })
    ]));
  }
});
var caret_right_default = caret_right_vue_vue_type_script_setup_true_lang_default;
var caret_top_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CaretTop",
  __name: "caret-top",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 320 192 704h639.936z"
      })
    ]));
  }
});
var caret_top_default = caret_top_vue_vue_type_script_setup_true_lang_default;
var cellphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Cellphone",
  __name: "cellphone",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 128a64 64 0 0 0-64 64v640a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h512a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V192A128 128 0 0 1 256 64m128 128h256a32 32 0 1 1 0 64H384a32 32 0 0 1 0-64m128 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
      })
    ]));
  }
});
var cellphone_default = cellphone_vue_vue_type_script_setup_true_lang_default;
var chat_dot_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatDotRound",
  __name: "chat-dot-round",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.056 461.056 0 0 1-206.912-48.384l-175.616 58.56z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 563.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
      })
    ]));
  }
});
var chat_dot_round_default = chat_dot_round_vue_vue_type_script_setup_true_lang_default;
var chat_dot_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatDotSquare",
  __name: "chat-dot-square",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 499.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4zm192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4zm-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4z"
      })
    ]));
  }
});
var chat_dot_square_default = chat_dot_square_vue_vue_type_script_setup_true_lang_default;
var chat_line_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatLineRound",
  __name: "chat-line-round",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.056 461.056 0 0 1-206.912-48.384l-175.616 58.56z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 576h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m32-192h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
      })
    ]));
  }
});
var chat_line_round_default = chat_line_round_vue_vue_type_script_setup_true_lang_default;
var chat_line_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatLineSquare",
  __name: "chat-line-square",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 826.88 273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 512h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m0-192h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
      })
    ]));
  }
});
var chat_line_square_default = chat_line_square_vue_vue_type_script_setup_true_lang_default;
var chat_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatRound",
  __name: "chat-round",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m174.72 855.68 130.048-43.392 23.424 11.392C382.4 849.984 444.352 864 512 864c223.744 0 384-159.872 384-352 0-192.832-159.104-352-384-352S128 319.168 128 512a341.12 341.12 0 0 0 69.248 204.288l21.632 28.8-44.16 110.528zm-45.248 82.56A32 32 0 0 1 89.6 896l56.512-141.248A405.12 405.12 0 0 1 64 512C64 299.904 235.648 96 512 96s448 203.904 448 416-173.44 416-448 416c-79.68 0-150.848-17.152-211.712-46.72l-170.88 56.96z"
      })
    ]));
  }
});
var chat_round_default = chat_round_vue_vue_type_script_setup_true_lang_default;
var chat_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChatSquare",
  __name: "chat-square",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
      })
    ]));
  }
});
var chat_square_default = chat_square_vue_vue_type_script_setup_true_lang_default;
var check_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Check",
  __name: "check",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"
      })
    ]));
  }
});
var check_default = check_vue_vue_type_script_setup_true_lang_default;
var checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Checked",
  __name: "checked",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 192h160v736H160V192h160.064v64H704zM311.616 537.28l-45.312 45.248L447.36 763.52l316.8-316.8-45.312-45.184L447.36 673.024zM384 192V96h256v96z"
      })
    ]));
  }
});
var checked_default = checked_vue_vue_type_script_setup_true_lang_default;
var cherry_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Cherry",
  __name: "cherry",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M261.056 449.6c13.824-69.696 34.88-128.96 63.36-177.728 23.744-40.832 61.12-88.64 112.256-143.872H320a32 32 0 0 1 0-64h384a32 32 0 1 1 0 64H554.752c14.912 39.168 41.344 86.592 79.552 141.76 47.36 68.48 84.8 106.752 106.304 114.304a224 224 0 1 1-84.992 14.784c-22.656-22.912-47.04-53.76-73.92-92.608-38.848-56.128-67.008-105.792-84.352-149.312-55.296 58.24-94.528 107.52-117.76 147.2-23.168 39.744-41.088 88.768-53.568 147.072a224.064 224.064 0 1 1-64.96-1.6zM288 832a160 160 0 1 0 0-320 160 160 0 0 0 0 320m448-64a160 160 0 1 0 0-320 160 160 0 0 0 0 320"
      })
    ]));
  }
});
var cherry_default = cherry_vue_vue_type_script_setup_true_lang_default;
var chicken_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Chicken",
  __name: "chicken",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M349.952 716.992 478.72 588.16a106.688 106.688 0 0 1-26.176-19.072 106.688 106.688 0 0 1-19.072-26.176L304.704 671.744c.768 3.072 1.472 6.144 2.048 9.216l2.048 31.936 31.872 1.984c3.136.64 6.208 1.28 9.28 2.112zm57.344 33.152a128 128 0 1 1-216.32 114.432l-1.92-32-32-1.92a128 128 0 1 1 114.432-216.32L416.64 469.248c-2.432-101.44 58.112-239.104 149.056-330.048 107.328-107.328 231.296-85.504 316.8 0 85.44 85.44 107.328 209.408 0 316.8-91.008 90.88-228.672 151.424-330.112 149.056L407.296 750.08zm90.496-226.304c49.536 49.536 233.344-7.04 339.392-113.088 78.208-78.208 63.232-163.072 0-226.304-63.168-63.232-148.032-78.208-226.24 0C504.896 290.496 448.32 474.368 497.792 523.84M244.864 708.928a64 64 0 1 0-59.84 59.84l56.32-3.52zm8.064 127.68a64 64 0 1 0 59.84-59.84l-56.32 3.52-3.52 56.32z"
      })
    ]));
  }
});
var chicken_default = chicken_vue_vue_type_script_setup_true_lang_default;
var chrome_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ChromeFilled",
  __name: "chrome-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M938.67 512.01c0-44.59-6.82-87.6-19.54-128H682.67a212.372 212.372 0 0 1 42.67 128c.06 38.71-10.45 76.7-30.42 109.87l-182.91 316.8c235.65-.01 426.66-191.02 426.66-426.67z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M576.79 401.63a127.92 127.92 0 0 0-63.56-17.6c-22.36-.22-44.39 5.43-63.89 16.38s-35.79 26.82-47.25 46.02a128.005 128.005 0 0 0-2.16 127.44l1.24 2.13a127.906 127.906 0 0 0 46.36 46.61 127.907 127.907 0 0 0 63.38 17.44c22.29.2 44.24-5.43 63.68-16.33a127.94 127.94 0 0 0 47.16-45.79v-.01l1.11-1.92a127.984 127.984 0 0 0 .29-127.46 127.957 127.957 0 0 0-46.36-46.91"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M394.45 333.96A213.336 213.336 0 0 1 512 298.67h369.58A426.503 426.503 0 0 0 512 85.34a425.598 425.598 0 0 0-171.74 35.98 425.644 425.644 0 0 0-142.62 102.22l118.14 204.63a213.397 213.397 0 0 1 78.67-94.21m117.56 604.72H512zm-97.25-236.73a213.284 213.284 0 0 1-89.54-86.81L142.48 298.6c-36.35 62.81-57.13 135.68-57.13 213.42 0 203.81 142.93 374.22 333.95 416.55h.04l118.19-204.71a213.315 213.315 0 0 1-122.77-21.91z"
      })
    ]));
  }
});
var chrome_filled_default = chrome_filled_vue_vue_type_script_setup_true_lang_default;
var circle_check_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CircleCheckFilled",
  __name: "circle-check-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
      })
    ]));
  }
});
var circle_check_filled_default = circle_check_filled_vue_vue_type_script_setup_true_lang_default;
var circle_check_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CircleCheck",
  __name: "circle-check",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752l265.344-265.408z"
      })
    ]));
  }
});
var circle_check_default = circle_check_vue_vue_type_script_setup_true_lang_default;
var circle_close_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CircleCloseFilled",
  __name: "circle-close-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z"
      })
    ]));
  }
});
var circle_close_filled_default = circle_close_filled_vue_vue_type_script_setup_true_lang_default;
var circle_close_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CircleClose",
  __name: "circle-close",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});
var circle_close_default = circle_close_vue_vue_type_script_setup_true_lang_default;
var circle_plus_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CirclePlusFilled",
  __name: "circle-plus-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-38.4 409.6H326.4a38.4 38.4 0 1 0 0 76.8h147.2v147.2a38.4 38.4 0 0 0 76.8 0V550.4h147.2a38.4 38.4 0 0 0 0-76.8H550.4V326.4a38.4 38.4 0 1 0-76.8 0v147.2z"
      })
    ]));
  }
});
var circle_plus_filled_default = circle_plus_filled_vue_vue_type_script_setup_true_lang_default;
var circle_plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CirclePlus",
  __name: "circle-plus",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 672V352a32 32 0 1 1 64 0v320a32 32 0 0 1-64 0"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});
var circle_plus_default = circle_plus_vue_vue_type_script_setup_true_lang_default;
var clock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Clock",
  __name: "clock",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 256a32 32 0 0 1 32 32v256a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 512h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32"
      })
    ]));
  }
});
var clock_default = clock_vue_vue_type_script_setup_true_lang_default;
var close_bold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CloseBold",
  __name: "close-bold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});
var close_bold_default = close_bold_vue_vue_type_script_setup_true_lang_default;
var close_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Close",
  __name: "close",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ]));
  }
});
var close_default = close_vue_vue_type_script_setup_true_lang_default;
var cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Cloudy",
  __name: "cloudy",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M598.4 831.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 831.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 381.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
      })
    ]));
  }
});
var cloudy_default = cloudy_vue_vue_type_script_setup_true_lang_default;
var coffee_cup_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CoffeeCup",
  __name: "coffee-cup",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 192a192 192 0 1 1-8 383.808A256.128 256.128 0 0 1 512 768H320A256 256 0 0 1 64 512V160a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v256a128 128 0 1 0 0-256M96 832h640a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-640v320a192 192 0 0 0 192 192h192a192 192 0 0 0 192-192V192z"
      })
    ]));
  }
});
var coffee_cup_default = coffee_cup_vue_vue_type_script_setup_true_lang_default;
var coffee_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Coffee",
  __name: "coffee",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M822.592 192h14.272a32 32 0 0 1 31.616 26.752l21.312 128A32 32 0 0 1 858.24 384h-49.344l-39.04 546.304A32 32 0 0 1 737.92 960H285.824a32 32 0 0 1-32-29.696L214.912 384H165.76a32 32 0 0 1-31.552-37.248l21.312-128A32 32 0 0 1 187.136 192h14.016l-6.72-93.696A32 32 0 0 1 226.368 64h571.008a32 32 0 0 1 31.936 34.304zm-64.128 0 4.544-64H260.736l4.544 64h493.184m-548.16 128H820.48l-10.688-64H214.208l-10.688 64h6.784m68.736 64 36.544 512H708.16l36.544-512z"
      })
    ]));
  }
});
var coffee_default = coffee_vue_vue_type_script_setup_true_lang_default;
var coin_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Coin",
  __name: "coin",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m161.92 580.736 29.888 58.88C171.328 659.776 160 681.728 160 704c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 615.808 928 657.664 928 704c0 129.728-188.544 224-416 224S96 833.728 96 704c0-46.592 24.32-88.576 65.92-123.264z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m161.92 388.736 29.888 58.88C171.328 467.84 160 489.792 160 512c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 423.808 928 465.664 928 512c0 129.728-188.544 224-416 224S96 641.728 96 512c0-46.592 24.32-88.576 65.92-123.264z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 544c-227.456 0-416-94.272-416-224S284.544 96 512 96s416 94.272 416 224-188.544 224-416 224m0-64c196.672 0 352-77.696 352-160S708.672 160 512 160s-352 77.696-352 160 155.328 160 352 160"
      })
    ]));
  }
});
var coin_default = coin_vue_vue_type_script_setup_true_lang_default;
var cold_drink_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ColdDrink",
  __name: "cold-drink",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 64a192 192 0 1 1-69.952 370.88L480 725.376V896h96a32 32 0 1 1 0 64H320a32 32 0 1 1 0-64h96V725.376L76.8 273.536a64 64 0 0 1-12.8-38.4v-10.688a32 32 0 0 1 32-32h71.808l-65.536-83.84a32 32 0 0 1 50.432-39.424l96.256 123.264h337.728A192.064 192.064 0 0 1 768 64M656.896 192.448H800a32 32 0 0 1 32 32v10.624a64 64 0 0 1-12.8 38.4l-80.448 107.2a128 128 0 1 0-81.92-188.16v-.064zm-357.888 64 129.472 165.76a32 32 0 0 1-50.432 39.36l-160.256-205.12H144l304 404.928 304-404.928z"
      })
    ]));
  }
});
var cold_drink_default = cold_drink_vue_vue_type_script_setup_true_lang_default;
var collection_tag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CollectionTag",
  __name: "collection-tag",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 128v698.88l196.032-156.864a96 96 0 0 1 119.936 0L768 826.816V128zm-32-64h576a32 32 0 0 1 32 32v797.44a32 32 0 0 1-51.968 24.96L531.968 720a32 32 0 0 0-39.936 0L243.968 918.4A32 32 0 0 1 192 893.44V96a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var collection_tag_default = collection_tag_vue_vue_type_script_setup_true_lang_default;
var collection_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Collection",
  __name: "collection",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 736h640V128H256a64 64 0 0 0-64 64zm64-672h608a32 32 0 0 1 32 32v672a32 32 0 0 1-32 32H160l-32 57.536V192A128 128 0 0 1 256 64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M240 800a48 48 0 1 0 0 96h592v-96zm0-64h656v160a64 64 0 0 1-64 64H240a112 112 0 0 1 0-224m144-608v250.88l96-76.8 96 76.8V128zm-64-64h320v381.44a32 32 0 0 1-51.968 24.96L480 384l-108.032 86.4A32 32 0 0 1 320 445.44z"
      })
    ]));
  }
});
var collection_default = collection_vue_vue_type_script_setup_true_lang_default;
var comment_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Comment",
  __name: "comment",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112M128 128v640h192v160l224-160h352V128z"
      })
    ]));
  }
});
var comment_default = comment_vue_vue_type_script_setup_true_lang_default;
var compass_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Compass",
  __name: "compass",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M725.888 315.008C676.48 428.672 624 513.28 568.576 568.64c-55.424 55.424-139.968 107.904-253.568 157.312a12.8 12.8 0 0 1-16.896-16.832c49.536-113.728 102.016-198.272 157.312-253.632 55.36-55.296 139.904-107.776 253.632-157.312a12.8 12.8 0 0 1 16.832 16.832"
      })
    ]));
  }
});
var compass_default = compass_vue_vue_type_script_setup_true_lang_default;
var connection_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Connection",
  __name: "connection",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 384v64H448a128 128 0 0 0-128 128v128a128 128 0 0 0 128 128h320a128 128 0 0 0 128-128V576a128 128 0 0 0-64-110.848V394.88c74.56 26.368 128 97.472 128 181.056v128a192 192 0 0 1-192 192H448a192 192 0 0 1-192-192V576a192 192 0 0 1 192-192z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 640v-64h192a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v128a128 128 0 0 0 64 110.848v70.272A192.064 192.064 0 0 1 64 448V320a192 192 0 0 1 192-192h320a192 192 0 0 1 192 192v128a192 192 0 0 1-192 192z"
      })
    ]));
  }
});
var connection_default = connection_vue_vue_type_script_setup_true_lang_default;
var coordinate_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Coordinate",
  __name: "coordinate",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 512h64v320h-64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 896h640a64 64 0 0 0-64-64H256a64 64 0 0 0-64 64m64-128h512a128 128 0 0 1 128 128v64H128v-64a128 128 0 0 1 128-128m256-256a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      })
    ]));
  }
});
var coordinate_default = coordinate_vue_vue_type_script_setup_true_lang_default;
var copy_document_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CopyDocument",
  __name: "copy-document",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64"
      })
    ]));
  }
});
var copy_document_default = copy_document_vue_vue_type_script_setup_true_lang_default;
var cpu_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Cpu",
  __name: "cpu",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M320 256a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h384a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128H320a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m-320 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 896a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m160 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m-320 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32M64 512a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0-160a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0 320a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m896-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0 320a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32"
      })
    ]));
  }
});
var cpu_default = cpu_vue_vue_type_script_setup_true_lang_default;
var credit_card_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "CreditCard",
  __name: "credit-card",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M896 324.096c0-42.368-2.496-55.296-9.536-68.48a52.352 52.352 0 0 0-22.144-22.08c-13.12-7.04-26.048-9.536-68.416-9.536H228.096c-42.368 0-55.296 2.496-68.48 9.536a52.352 52.352 0 0 0-22.08 22.144c-7.04 13.12-9.536 26.048-9.536 68.416v375.808c0 42.368 2.496 55.296 9.536 68.48a52.352 52.352 0 0 0 22.144 22.08c13.12 7.04 26.048 9.536 68.416 9.536h567.808c42.368 0 55.296-2.496 68.48-9.536a52.352 52.352 0 0 0 22.08-22.144c7.04-13.12 9.536-26.048 9.536-68.416zm64 0v375.808c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448-20.864 11.136-41.6 17.088-98.56 17.088H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.288 116.288 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56V324.032c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448 20.864-11.136 41.6-17.088 98.56-17.088H795.84c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384 11.136 20.864 17.088 41.6 17.088 98.56z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M64 320h896v64H64zm0 128h896v64H64zm128 192h256v64H192z"
      })
    ]));
  }
});
var credit_card_default = credit_card_vue_vue_type_script_setup_true_lang_default;
var crop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Crop",
  __name: "crop",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 768h672a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V96a32 32 0 0 1 64 0z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 224v704a32 32 0 1 1-64 0V256H96a32 32 0 0 1 0-64h704a32 32 0 0 1 32 32"
      })
    ]));
  }
});
var crop_default = crop_vue_vue_type_script_setup_true_lang_default;
var d_arrow_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DArrowLeft",
  __name: "d-arrow-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224zm256 0a29.12 29.12 0 0 1 41.728 0 30.592 30.592 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672l331.648-340.224z"
      })
    ]));
  }
});
var d_arrow_left_default = d_arrow_left_vue_vue_type_script_setup_true_lang_default;
var d_arrow_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DArrowRight",
  __name: "d-arrow-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
      })
    ]));
  }
});
var d_arrow_right_default = d_arrow_right_vue_vue_type_script_setup_true_lang_default;
var d_caret_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DCaret",
  __name: "d-caret",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m512 128 288 320H224zM224 576h576L512 896z"
      })
    ]));
  }
});
var d_caret_default = d_caret_vue_vue_type_script_setup_true_lang_default;
var data_analysis_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DataAnalysis",
  __name: "data-analysis",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m665.216 768 110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32l110.848-192H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32zM832 192H192v512h640zM352 448a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0v-64a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V416a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V352a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var data_analysis_default = data_analysis_vue_vue_type_script_setup_true_lang_default;
var data_board_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DataBoard",
  __name: "data-board",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M32 128h960v64H32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 192v512h640V192zm-64-64h768v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M322.176 960H248.32l144.64-250.56 55.424 32zm453.888 0h-73.856L576 741.44l55.424-32z"
      })
    ]));
  }
});
var data_board_default = data_board_vue_vue_type_script_setup_true_lang_default;
var data_line_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DataLine",
  __name: "data-line",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M359.168 768H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.216l110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32zM832 192H192v512h640zM342.656 534.656a32 32 0 1 1-45.312-45.312L444.992 341.76l125.44 94.08L679.04 300.032a32 32 0 1 1 49.92 39.936L581.632 524.224 451.008 426.24 342.656 534.592z"
      })
    ]));
  }
});
var data_line_default = data_line_vue_vue_type_script_setup_true_lang_default;
var delete_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DeleteFilled",
  __name: "delete-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64zm64 0h192v-64H416zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32m192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32"
      })
    ]));
  }
});
var delete_filled_default = delete_filled_vue_vue_type_script_setup_true_lang_default;
var delete_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DeleteLocation",
  __name: "delete-location",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 384h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
      })
    ]));
  }
});
var delete_location_default = delete_location_vue_vue_type_script_setup_true_lang_default;
var delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Delete",
  __name: "delete",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32zm448-64v-64H416v64zM224 896h576V256H224zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32m192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32"
      })
    ]));
  }
});
var delete_default = delete_vue_vue_type_script_setup_true_lang_default;
var dessert_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Dessert",
  __name: "dessert",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 416v-48a144 144 0 0 1 168.64-141.888 224.128 224.128 0 0 1 430.72 0A144 144 0 0 1 896 368v48a384 384 0 0 1-352 382.72V896h-64v-97.28A384 384 0 0 1 128 416m287.104-32.064h193.792a143.808 143.808 0 0 1 58.88-132.736 160.064 160.064 0 0 0-311.552 0 143.808 143.808 0 0 1 58.88 132.8zm-72.896 0a72 72 0 1 0-140.48 0h140.48m339.584 0h140.416a72 72 0 1 0-140.48 0zM512 736a320 320 0 0 0 318.4-288.064H193.6A320 320 0 0 0 512 736M384 896.064h256a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64"
      })
    ]));
  }
});
var dessert_default = dessert_vue_vue_type_script_setup_true_lang_default;
var discount_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Discount",
  __name: "discount",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 704h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0L224 318.336zm0 64v128h576V768zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});
var discount_default = discount_vue_vue_type_script_setup_true_lang_default;
var dish_dot_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DishDot",
  __name: "dish-dot",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m384.064 274.56.064-50.688A128 128 0 0 1 512.128 96c70.528 0 127.68 57.152 127.68 127.68v50.752A448.192 448.192 0 0 1 955.392 768H68.544A448.192 448.192 0 0 1 384 274.56zM96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-128h768a384 384 0 1 0-768 0m447.808-448v-32.32a63.68 63.68 0 0 0-63.68-63.68 64 64 0 0 0-64 63.936V256z"
      })
    ]));
  }
});
var dish_dot_default = dish_dot_vue_vue_type_script_setup_true_lang_default;
var dish_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Dish",
  __name: "dish",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 257.152V192h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64h-96v65.152A448 448 0 0 1 955.52 768H68.48A448 448 0 0 1 480 257.152M128 704h768a384 384 0 1 0-768 0M96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64"
      })
    ]));
  }
});
var dish_default = dish_vue_vue_type_script_setup_true_lang_default;
var document_add_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DocumentAdd",
  __name: "document-add",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m320 512V448h64v128h128v64H544v128h-64V640H352v-64z"
      })
    ]));
  }
});
var document_add_default = document_add_vue_vue_type_script_setup_true_lang_default;
var document_checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DocumentChecked",
  __name: "document-checked",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m318.4 582.144 180.992-180.992L704.64 510.4 478.4 736.64 320 578.304l45.248-45.312z"
      })
    ]));
  }
});
var document_checked_default = document_checked_vue_vue_type_script_setup_true_lang_default;
var document_copy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DocumentCopy",
  __name: "document-copy",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 320v576h576V320zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32M960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32M256 672h320v64H256zm0-192h320v64H256z"
      })
    ]));
  }
});
var document_copy_default = document_copy_vue_vue_type_script_setup_true_lang_default;
var document_delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DocumentDelete",
  __name: "document-delete",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m308.992 546.304-90.496-90.624 45.248-45.248 90.56 90.496 90.496-90.432 45.248 45.248-90.496 90.56 90.496 90.496-45.248 45.248-90.496-90.496-90.56 90.496-45.248-45.248 90.496-90.496z"
      })
    ]));
  }
});
var document_delete_default = document_delete_vue_vue_type_script_setup_true_lang_default;
var document_remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "DocumentRemove",
  __name: "document-remove",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m192 512h320v64H352z"
      })
    ]));
  }
});
var document_remove_default = document_remove_vue_vue_type_script_setup_true_lang_default;
var document_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Document",
  __name: "document",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h160v64H320zm0 384h384v64H320z"
      })
    ]));
  }
});
var document_default = document_vue_vue_type_script_setup_true_lang_default;
var download_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Download",
  __name: "download",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64z"
      })
    ]));
  }
});
var download_default = download_vue_vue_type_script_setup_true_lang_default;
var drizzling_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Drizzling",
  __name: "drizzling",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672zM959.552 480a256 256 0 0 1-256 256h-400A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M288 800h64v64h-64zm192 0h64v64h-64zm-96 96h64v64h-64zm192 0h64v64h-64zm96-96h64v64h-64z"
      })
    ]));
  }
});
var drizzling_default = drizzling_vue_vue_type_script_setup_true_lang_default;
var edit_pen_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "EditPen",
  __name: "edit-pen",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64h-448z"
      })
    ]));
  }
});
var edit_pen_default = edit_pen_vue_vue_type_script_setup_true_lang_default;
var edit_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Edit",
  __name: "edit",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m469.952 554.24 52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"
      })
    ]));
  }
});
var edit_default = edit_vue_vue_type_script_setup_true_lang_default;
var eleme_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ElemeFilled",
  __name: "eleme-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M176 64h672c61.824 0 112 50.176 112 112v672a112 112 0 0 1-112 112H176A112 112 0 0 1 64 848V176c0-61.824 50.176-112 112-112m150.528 173.568c-152.896 99.968-196.544 304.064-97.408 456.96a330.688 330.688 0 0 0 456.96 96.64c9.216-5.888 17.6-11.776 25.152-18.56a18.24 18.24 0 0 0 4.224-24.32L700.352 724.8a47.552 47.552 0 0 0-65.536-14.272A234.56 234.56 0 0 1 310.592 641.6C240 533.248 271.104 387.968 379.456 316.48a234.304 234.304 0 0 1 276.352 15.168c1.664.832 2.56 2.56 3.392 4.224 5.888 8.384 3.328 19.328-5.12 25.216L456.832 489.6a47.552 47.552 0 0 0-14.336 65.472l16 24.384c5.888 8.384 16.768 10.88 25.216 5.056l308.224-199.936a19.584 19.584 0 0 0 6.72-23.488v-.896c-4.992-9.216-10.048-17.6-15.104-26.88-99.968-151.168-304.064-194.88-456.96-95.744zM786.88 504.704l-62.208 40.32c-8.32 5.888-10.88 16.768-4.992 25.216L760 632.32c5.888 8.448 16.768 11.008 25.152 5.12l31.104-20.16a55.36 55.36 0 0 0 16-76.48l-20.224-31.04a19.52 19.52 0 0 0-25.152-5.12z"
      })
    ]));
  }
});
var eleme_filled_default = eleme_filled_vue_vue_type_script_setup_true_lang_default;
var eleme_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Eleme",
  __name: "eleme",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M300.032 188.8c174.72-113.28 408-63.36 522.24 109.44 5.76 10.56 11.52 20.16 17.28 30.72v.96a22.4 22.4 0 0 1-7.68 26.88l-352.32 228.48c-9.6 6.72-22.08 3.84-28.8-5.76l-18.24-27.84a54.336 54.336 0 0 1 16.32-74.88l225.6-146.88c9.6-6.72 12.48-19.2 5.76-28.8-.96-1.92-1.92-3.84-3.84-4.8a267.84 267.84 0 0 0-315.84-17.28c-123.84 81.6-159.36 247.68-78.72 371.52a268.096 268.096 0 0 0 370.56 78.72 54.336 54.336 0 0 1 74.88 16.32l17.28 26.88c5.76 9.6 3.84 21.12-4.8 27.84-8.64 7.68-18.24 14.4-28.8 21.12a377.92 377.92 0 0 1-522.24-110.4c-113.28-174.72-63.36-408 111.36-522.24zm526.08 305.28a22.336 22.336 0 0 1 28.8 5.76l23.04 35.52a63.232 63.232 0 0 1-18.24 87.36l-35.52 23.04c-9.6 6.72-22.08 3.84-28.8-5.76l-46.08-71.04c-6.72-9.6-3.84-22.08 5.76-28.8l71.04-46.08z"
      })
    ]));
  }
});
var eleme_default = eleme_vue_vue_type_script_setup_true_lang_default;
var element_plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ElementPlus",
  __name: "element-plus",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M839.7 734.7c0 33.3-17.9 41-17.9 41S519.7 949.8 499.2 960c-10.2 5.1-20.5 5.1-30.7 0 0 0-314.9-184.3-325.1-192-5.1-5.1-10.2-12.8-12.8-20.5V368.6c0-17.9 20.5-28.2 20.5-28.2L466 158.6c12.8-5.1 25.6-5.1 38.4 0 0 0 279 161.3 309.8 179.2 17.9 7.7 28.2 25.6 25.6 46.1-.1-5-.1 317.5-.1 350.8M714.2 371.2c-64-35.8-217.6-125.4-217.6-125.4-7.7-5.1-20.5-5.1-30.7 0L217.6 389.1s-17.9 10.2-17.9 23v297c0 5.1 5.1 12.8 7.7 17.9 7.7 5.1 256 148.5 256 148.5 7.7 5.1 17.9 5.1 25.6 0 15.4-7.7 250.9-145.9 250.9-145.9s12.8-5.1 12.8-30.7v-74.2l-276.5 169v-64c0-17.9 7.7-30.7 20.5-46.1L745 535c5.1-7.7 10.2-20.5 10.2-30.7v-66.6l-279 169v-69.1c0-15.4 5.1-30.7 17.9-38.4l220.1-128zM919 135.7c0-5.1-5.1-7.7-7.7-7.7h-58.9V66.6c0-5.1-5.1-5.1-10.2-5.1l-30.7 5.1c-5.1 0-5.1 2.6-5.1 5.1V128h-56.3c-5.1 0-5.1 5.1-7.7 5.1v38.4h69.1v64c0 5.1 5.1 5.1 10.2 5.1l30.7-5.1c5.1 0 5.1-2.6 5.1-5.1v-56.3h64l-2.5-38.4z"
      })
    ]));
  }
});
var element_plus_default = element_plus_vue_vue_type_script_setup_true_lang_default;
var expand_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Expand",
  __name: "expand",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192h768v128H128zm0 256h512v128H128zm0 256h768v128H128zm576-352 192 160-192 128z"
      })
    ]));
  }
});
var expand_default = expand_vue_vue_type_script_setup_true_lang_default;
var failed_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Failed",
  __name: "failed",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m557.248 608 135.744-135.744-45.248-45.248-135.68 135.744-135.808-135.68-45.248 45.184L466.752 608l-135.68 135.68 45.184 45.312L512 653.248l135.744 135.744 45.248-45.248L557.312 608zM704 192h160v736H160V192h160v64h384zm-320 0V96h256v96z"
      })
    ]));
  }
});
var failed_default = failed_vue_vue_type_script_setup_true_lang_default;
var female_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Female",
  __name: "female",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 640a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 640q32 0 32 32v256q0 32-32 32t-32-32V672q0-32 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 800h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
      })
    ]));
  }
});
var female_default = female_vue_vue_type_script_setup_true_lang_default;
var files_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Files",
  __name: "files",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 384v448h768V384zm-32-64h832a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32m64-128h704v64H160zm96-128h512v64H256z"
      })
    ]));
  }
});
var files_default = files_vue_vue_type_script_setup_true_lang_default;
var film_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Film",
  __name: "film",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M320 288V128h64v352h256V128h64v160h160v64H704v128h160v64H704v128h160v64H704v160h-64V544H384v352h-64V736H128v-64h192V544H128v-64h192V352H128v-64z"
      })
    ]));
  }
});
var film_default = film_vue_vue_type_script_setup_true_lang_default;
var filter_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Filter",
  __name: "filter",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 523.392V928a32 32 0 0 0 46.336 28.608l192-96A32 32 0 0 0 640 832V523.392l280.768-343.104a32 32 0 1 0-49.536-40.576l-288 352A32 32 0 0 0 576 512v300.224l-128 64V512a32 32 0 0 0-7.232-20.288L195.52 192H704a32 32 0 1 0 0-64H128a32 32 0 0 0-24.768 52.288z"
      })
    ]));
  }
});
var filter_default = filter_vue_vue_type_script_setup_true_lang_default;
var finished_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Finished",
  __name: "finished",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M280.768 753.728 691.456 167.04a32 32 0 1 1 52.416 36.672L314.24 817.472a32 32 0 0 1-45.44 7.296l-230.4-172.8a32 32 0 0 1 38.4-51.2l203.968 152.96zM736 448a32 32 0 1 1 0-64h192a32 32 0 1 1 0 64zM608 640a32 32 0 0 1 0-64h319.936a32 32 0 1 1 0 64zM480 832a32 32 0 1 1 0-64h447.936a32 32 0 1 1 0 64z"
      })
    ]));
  }
});
var finished_default = finished_vue_vue_type_script_setup_true_lang_default;
var first_aid_kit_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FirstAidKit",
  __name: "first-aid-kit",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 256a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 512h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0zM352 128v64h320v-64zm-32-64h384a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H320a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var first_aid_kit_default = first_aid_kit_vue_vue_type_script_setup_true_lang_default;
var flag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Flag",
  __name: "flag",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 128h608L736 384l160 256H288v320h-96V64h96z"
      })
    ]));
  }
});
var flag_default = flag_vue_vue_type_script_setup_true_lang_default;
var fold_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Fold",
  __name: "fold",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M896 192H128v128h768zm0 256H384v128h512zm0 256H128v128h768zM320 384 128 512l192 128z"
      })
    ]));
  }
});
var fold_default = fold_vue_vue_type_script_setup_true_lang_default;
var folder_add_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FolderAdd",
  __name: "folder-add",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m384 416V416h64v128h128v64H544v128h-64V608H352v-64z"
      })
    ]));
  }
});
var folder_add_default = folder_add_vue_vue_type_script_setup_true_lang_default;
var folder_checked_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FolderChecked",
  __name: "folder-checked",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m414.08 502.144 180.992-180.992L736.32 494.4 510.08 720.64l-158.4-158.336 45.248-45.312z"
      })
    ]));
  }
});
var folder_checked_default = folder_checked_vue_vue_type_script_setup_true_lang_default;
var folder_delete_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FolderDelete",
  __name: "folder-delete",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m370.752 448-90.496-90.496 45.248-45.248L512 530.752l90.496-90.496 45.248 45.248L557.248 576l90.496 90.496-45.248 45.248L512 621.248l-90.496 90.496-45.248-45.248z"
      })
    ]));
  }
});
var folder_delete_default = folder_delete_vue_vue_type_script_setup_true_lang_default;
var folder_opened_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FolderOpened",
  __name: "folder-opened",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M878.08 448H241.92l-96 384h636.16l96-384zM832 384v-64H485.76L357.504 192H128v448l57.92-231.744A32 32 0 0 1 216.96 384zm-24.96 512H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h287.872l128.384 128H864a32 32 0 0 1 32 32v96h23.04a32 32 0 0 1 31.04 39.744l-112 448A32 32 0 0 1 807.04 896"
      })
    ]));
  }
});
var folder_opened_default = folder_opened_vue_vue_type_script_setup_true_lang_default;
var folder_remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FolderRemove",
  __name: "folder-remove",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m256 416h320v64H352z"
      })
    ]));
  }
});
var folder_remove_default = folder_remove_vue_vue_type_script_setup_true_lang_default;
var folder_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Folder",
  __name: "folder",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var folder_default = folder_vue_vue_type_script_setup_true_lang_default;
var food_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Food",
  __name: "food",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 352.576V352a288 288 0 0 1 491.072-204.224 192 192 0 0 1 274.24 204.48 64 64 0 0 1 57.216 74.24C921.6 600.512 850.048 710.656 736 756.992V800a96 96 0 0 1-96 96H384a96 96 0 0 1-96-96v-43.008c-114.048-46.336-185.6-156.48-214.528-330.496A64 64 0 0 1 128 352.64zm64-.576h64a160 160 0 0 1 320 0h64a224 224 0 0 0-448 0m128 0h192a96 96 0 0 0-192 0m439.424 0h68.544A128.256 128.256 0 0 0 704 192c-15.36 0-29.952 2.688-43.52 7.616 11.328 18.176 20.672 37.76 27.84 58.304A64.128 64.128 0 0 1 759.424 352M672 768H352v32a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32zm-342.528-64h365.056c101.504-32.64 165.76-124.928 192.896-288H136.576c27.136 163.072 91.392 255.36 192.896 288"
      })
    ]));
  }
});
var food_default = food_vue_vue_type_script_setup_true_lang_default;
var football_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Football",
  __name: "football",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-64a384 384 0 1 0 0-768 384 384 0 0 0 0 768"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M186.816 268.288c16-16.384 31.616-31.744 46.976-46.08 17.472 30.656 39.808 58.112 65.984 81.28l-32.512 56.448a385.984 385.984 0 0 1-80.448-91.648zm653.696-5.312a385.92 385.92 0 0 1-83.776 96.96l-32.512-56.384a322.923 322.923 0 0 0 68.48-85.76c15.552 14.08 31.488 29.12 47.808 45.184zM465.984 445.248l11.136-63.104a323.584 323.584 0 0 0 69.76 0l11.136 63.104a387.968 387.968 0 0 1-92.032 0m-62.72-12.8A381.824 381.824 0 0 1 320 396.544l32-55.424a319.885 319.885 0 0 0 62.464 27.712l-11.2 63.488zm300.8-35.84a381.824 381.824 0 0 1-83.328 35.84l-11.2-63.552A319.885 319.885 0 0 0 672 341.184l32 55.424zm-520.768 364.8a385.92 385.92 0 0 1 83.968-97.28l32.512 56.32c-26.88 23.936-49.856 52.352-67.52 84.032-16-13.44-32.32-27.712-48.96-43.072zm657.536.128a1442.759 1442.759 0 0 1-49.024 43.072 321.408 321.408 0 0 0-67.584-84.16l32.512-56.32c33.216 27.456 61.696 60.352 84.096 97.408zM465.92 578.752a387.968 387.968 0 0 1 92.032 0l-11.136 63.104a323.584 323.584 0 0 0-69.76 0zm-62.72 12.8 11.2 63.552a319.885 319.885 0 0 0-62.464 27.712L320 627.392a381.824 381.824 0 0 1 83.264-35.84zm300.8 35.84-32 55.424a318.272 318.272 0 0 0-62.528-27.712l11.2-63.488c29.44 8.64 57.28 20.736 83.264 35.776z"
      })
    ]));
  }
});
var football_default = football_vue_vue_type_script_setup_true_lang_default;
var fork_spoon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ForkSpoon",
  __name: "fork-spoon",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 410.304V96a32 32 0 0 1 64 0v314.304a96 96 0 0 0 64-90.56V96a32 32 0 0 1 64 0v223.744a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.544a160 160 0 0 1-128-156.8V96a32 32 0 0 1 64 0v223.744a96 96 0 0 0 64 90.56zM672 572.48C581.184 552.128 512 446.848 512 320c0-141.44 85.952-256 192-256s192 114.56 192 256c0 126.848-69.184 232.128-160 252.48V928a32 32 0 1 1-64 0zM704 512c66.048 0 128-82.56 128-192s-61.952-192-128-192-128 82.56-128 192 61.952 192 128 192"
      })
    ]));
  }
});
var fork_spoon_default = fork_spoon_vue_vue_type_script_setup_true_lang_default;
var fries_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Fries",
  __name: "fries",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M608 224v-64a32 32 0 0 0-64 0v336h26.88A64 64 0 0 0 608 484.096zm101.12 160A64 64 0 0 0 672 395.904V384h64V224a32 32 0 1 0-64 0v160zm74.88 0a92.928 92.928 0 0 1 91.328 110.08l-60.672 323.584A96 96 0 0 1 720.32 896H303.68a96 96 0 0 1-94.336-78.336L148.672 494.08A92.928 92.928 0 0 1 240 384h-16V224a96 96 0 0 1 188.608-25.28A95.744 95.744 0 0 1 480 197.44V160a96 96 0 0 1 188.608-25.28A96 96 0 0 1 800 224v160zM670.784 512a128 128 0 0 1-99.904 48H453.12a128 128 0 0 1-99.84-48H352v-1.536a128.128 128.128 0 0 1-9.984-14.976L314.88 448H240a28.928 28.928 0 0 0-28.48 34.304L241.088 640h541.824l29.568-157.696A28.928 28.928 0 0 0 784 448h-74.88l-27.136 47.488A132.405 132.405 0 0 1 672 510.464V512zM480 288a32 32 0 0 0-64 0v196.096A64 64 0 0 0 453.12 496H480zm-128 96V224a32 32 0 0 0-64 0v160zh-37.12A64 64 0 0 1 352 395.904zm-98.88 320 19.072 101.888A32 32 0 0 0 303.68 832h416.64a32 32 0 0 0 31.488-26.112L770.88 704z"
      })
    ]));
  }
});
var fries_default = fries_vue_vue_type_script_setup_true_lang_default;
var full_screen_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "FullScreen",
  __name: "full-screen",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64l192-.192zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64z"
      })
    ]));
  }
});
var full_screen_default = full_screen_vue_vue_type_script_setup_true_lang_default;
var goblet_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "GobletFull",
  __name: "goblet-full",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 320h512c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320m503.936 64H264.064a256.128 256.128 0 0 0 495.872 0zM544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4"
      })
    ]));
  }
});
var goblet_full_default = goblet_full_vue_vue_type_script_setup_true_lang_default;
var goblet_square_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "GobletSquareFull",
  __name: "goblet-square-full",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 270.912c10.048 6.72 22.464 14.912 28.992 18.624a220.16 220.16 0 0 0 114.752 30.72c30.592 0 49.408-9.472 91.072-41.152l.64-.448c52.928-40.32 82.368-55.04 132.288-54.656 55.552.448 99.584 20.8 142.72 57.408l1.536 1.28V128H256v142.912zm.96 76.288C266.368 482.176 346.88 575.872 512 576c157.44.064 237.952-85.056 253.248-209.984a952.32 952.32 0 0 1-40.192-35.712c-32.704-27.776-63.36-41.92-101.888-42.24-31.552-.256-50.624 9.28-93.12 41.6l-.576.448c-52.096 39.616-81.024 54.208-129.792 54.208-54.784 0-100.48-13.376-142.784-37.056zM480 638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96z"
      })
    ]));
  }
});
var goblet_square_full_default = goblet_square_full_vue_vue_type_script_setup_true_lang_default;
var goblet_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "GobletSquare",
  __name: "goblet-square",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 638.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912M256 319.68c0 149.568 80 256.192 256 256.256C688.128 576 768 469.568 768 320V128H256z"
      })
    ]));
  }
});
var goblet_square_default = goblet_square_vue_vue_type_script_setup_true_lang_default;
var goblet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Goblet",
  __name: "goblet",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4M256 320a256 256 0 1 0 512 0c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320"
      })
    ]));
  }
});
var goblet_default = goblet_vue_vue_type_script_setup_true_lang_default;
var gold_medal_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "GoldMedal",
  __name: "gold-medal",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m772.13 452.84 53.86-351.81c1.32-10.01-1.17-18.68-7.49-26.02S804.35 64 795.01 64H228.99v-.01h-.06c-9.33 0-17.15 3.67-23.49 11.01s-8.83 16.01-7.49 26.02l53.87 351.89C213.54 505.73 193.59 568.09 192 640c2 90.67 33.17 166.17 93.5 226.5S421.33 957.99 512 960c90.67-2 166.17-33.17 226.5-93.5 60.33-60.34 91.49-135.83 93.5-226.5-1.59-71.94-21.56-134.32-59.87-187.16zM640.01 128h117.02l-39.01 254.02c-20.75-10.64-40.74-19.73-59.94-27.28-5.92-3-11.95-5.8-18.08-8.41V128h.01zM576 128v198.76c-13.18-2.58-26.74-4.43-40.67-5.55-8.07-.8-15.85-1.2-23.33-1.2-10.54 0-21.09.66-31.64 1.96a359.844 359.844 0 0 0-32.36 4.79V128zm-192 0h.04v218.3c-6.22 2.66-12.34 5.5-18.36 8.56-19.13 7.54-39.02 16.6-59.66 27.16L267.01 128zm308.99 692.99c-48 48-108.33 73-180.99 75.01-72.66-2.01-132.99-27.01-180.99-75.01S258.01 712.66 256 640c2.01-72.66 27.01-132.99 75.01-180.99 19.67-19.67 41.41-35.47 65.22-47.41 38.33-15.04 71.15-23.92 98.44-26.65 5.07-.41 10.2-.7 15.39-.88.63-.01 1.28-.03 1.91-.03.66 0 1.35.03 2.02.04 5.11.17 10.15.46 15.13.86 27.4 2.71 60.37 11.65 98.91 26.79 23.71 11.93 45.36 27.69 64.96 47.29 48 48 73 108.33 75.01 180.99-2.01 72.65-27.01 132.98-75.01 180.98z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 480H416v64h64v192h-64v64h192v-64h-64z"
      })
    ]));
  }
});
var gold_medal_default = gold_medal_vue_vue_type_script_setup_true_lang_default;
var goods_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "GoodsFilled",
  __name: "goods-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 352h640l64 544H128zm128 224h64V448h-64zm320 0h64V448h-64zM384 288h-64a192 192 0 1 1 384 0h-64a128 128 0 1 0-256 0"
      })
    ]));
  }
});
var goods_filled_default = goods_filled_vue_vue_type_script_setup_true_lang_default;
var goods_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Goods",
  __name: "goods",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M320 288v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4h131.072a32 32 0 0 1 31.808 28.8l57.6 576a32 32 0 0 1-31.808 35.2H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320zm64 0h256v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4zm-64 64H217.92l-51.2 512h690.56l-51.264-512H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0z"
      })
    ]));
  }
});
var goods_default = goods_vue_vue_type_script_setup_true_lang_default;
var grape_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Grape",
  __name: "grape",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 195.2a160 160 0 0 1 96 60.8 160 160 0 1 1 146.24 254.976 160 160 0 0 1-128 224 160 160 0 1 1-292.48 0 160 160 0 0 1-128-224A160 160 0 1 1 384 256a160 160 0 0 1 96-60.8V128h-64a32 32 0 0 1 0-64h192a32 32 0 0 1 0 64h-64zM512 448a96 96 0 1 0 0-192 96 96 0 0 0 0 192m-256 0a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
      })
    ]));
  }
});
var grape_default = grape_vue_vue_type_script_setup_true_lang_default;
var grid_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Grid",
  __name: "grid",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 384v256H384V384zm64 0h192v256H704zm-64 512H384V704h256zm64 0V704h192v192zm-64-768v192H384V128zm64 0h192v192H704zM320 384v256H128V384zm0 512H128V704h192zm0-768v192H128V128z"
      })
    ]));
  }
});
var grid_default = grid_vue_vue_type_script_setup_true_lang_default;
var guide_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Guide",
  __name: "guide",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 608h-64V416h64zm0 160v160a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V768h64v128h128V768zM384 608V416h64v192zm256-352h-64V128H448v128h-64V96a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "m220.8 256-71.232 80 71.168 80H768V256H220.8zm-14.4-64H800a32 32 0 0 1 32 32v224a32 32 0 0 1-32 32H206.4a32 32 0 0 1-23.936-10.752l-99.584-112a32 32 0 0 1 0-42.496l99.584-112A32 32 0 0 1 206.4 192m678.784 496-71.104 80H266.816V608h547.2l71.168 80zm-56.768-144H234.88a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h593.6a32 32 0 0 0 23.936-10.752l99.584-112a32 32 0 0 0 0-42.496l-99.584-112A32 32 0 0 0 828.48 544z"
      })
    ]));
  }
});
var guide_default = guide_vue_vue_type_script_setup_true_lang_default;
var handbag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Handbag",
  __name: "handbag",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M887.01 264.99c-6-5.99-13.67-8.99-23.01-8.99H704c-1.34-54.68-20.01-100.01-56-136s-81.32-54.66-136-56c-54.68 1.34-100.01 20.01-136 56s-54.66 81.32-56 136H160c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.67-8.99 23.01v640c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V288c0-9.35-2.99-17.02-8.99-23.01M421.5 165.5c24.32-24.34 54.49-36.84 90.5-37.5 35.99.68 66.16 13.18 90.5 37.5s36.84 54.49 37.5 90.5H384c.68-35.99 13.18-66.16 37.5-90.5M832 896H192V320h128v128h64V320h256v128h64V320h128z"
      })
    ]));
  }
});
var handbag_default = handbag_vue_vue_type_script_setup_true_lang_default;
var headset_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Headset",
  __name: "headset",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M896 529.152V512a384 384 0 1 0-768 0v17.152A128 128 0 0 1 320 640v128a128 128 0 1 1-256 0V512a448 448 0 1 1 896 0v256a128 128 0 1 1-256 0V640a128 128 0 0 1 192-110.848M896 640a64 64 0 0 0-128 0v128a64 64 0 0 0 128 0zm-768 0v128a64 64 0 0 0 128 0V640a64 64 0 1 0-128 0"
      })
    ]));
  }
});
var headset_default = headset_vue_vue_type_script_setup_true_lang_default;
var help_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "HelpFilled",
  __name: "help-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M926.784 480H701.312A192.512 192.512 0 0 0 544 322.688V97.216A416.064 416.064 0 0 1 926.784 480m0 64A416.064 416.064 0 0 1 544 926.784V701.312A192.512 192.512 0 0 0 701.312 544zM97.28 544h225.472A192.512 192.512 0 0 0 480 701.312v225.472A416.064 416.064 0 0 1 97.216 544zm0-64A416.064 416.064 0 0 1 480 97.216v225.472A192.512 192.512 0 0 0 322.688 480H97.216z"
      })
    ]));
  }
});
var help_filled_default = help_filled_vue_vue_type_script_setup_true_lang_default;
var help_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Help",
  __name: "help",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m759.936 805.248-90.944-91.008A254.912 254.912 0 0 1 512 768a254.912 254.912 0 0 1-156.992-53.76l-90.944 91.008A382.464 382.464 0 0 0 512 896c94.528 0 181.12-34.176 247.936-90.752m45.312-45.312A382.464 382.464 0 0 0 896 512c0-94.528-34.176-181.12-90.752-247.936l-91.008 90.944C747.904 398.4 768 452.864 768 512c0 59.136-20.096 113.6-53.76 156.992l91.008 90.944zm-45.312-541.184A382.464 382.464 0 0 0 512 128c-94.528 0-181.12 34.176-247.936 90.752l90.944 91.008A254.912 254.912 0 0 1 512 256c59.136 0 113.6 20.096 156.992 53.76l90.944-91.008zm-541.184 45.312A382.464 382.464 0 0 0 128 512c0 94.528 34.176 181.12 90.752 247.936l91.008-90.944A254.912 254.912 0 0 1 256 512c0-59.136 20.096-113.6 53.76-156.992zm417.28 394.496a194.56 194.56 0 0 0 22.528-22.528C686.912 602.56 704 559.232 704 512a191.232 191.232 0 0 0-67.968-146.56A191.296 191.296 0 0 0 512 320a191.232 191.232 0 0 0-146.56 67.968C337.088 421.44 320 464.768 320 512a191.232 191.232 0 0 0 67.968 146.56C421.44 686.912 464.768 704 512 704c47.296 0 90.56-17.088 124.032-45.44zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});
var help_default = help_vue_vue_type_script_setup_true_lang_default;
var hide_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Hide",
  __name: "hide",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4-6.4-6.4-12.8-9.6-22.4-9.6-9.6 0-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176C44.8 438.4 0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4 0 9.6 3.2 16 9.6 22.4 6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4Zm-646.4 528c-76.8-70.4-128-128-153.6-172.8 28.8-48 80-105.6 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4C598.4 300.8 560 288 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4Zm140.8-96c-12.8-22.4-19.2-48-19.2-76.8 0-44.8 16-83.2 48-112 32-28.8 67.2-48 112-48 28.8 0 54.4 6.4 73.6 19.2zM889.599 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6-28.8 48-80 105.6-153.6 172.8-73.6 67.2-172.8 108.8-284.8 115.2-51.2-3.2-99.2-12.8-140.8-28.8l-48 48c57.6 22.4 118.4 38.4 188.8 44.8 160-16 288-73.6 377.6-176C979.199 585.6 1024 528 1024 512s-48.001-73.6-134.401-176Z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M511.998 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2c28.8 12.8 57.6 19.2 89.6 19.2 64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112-32 28.8-67.2 48-112 48Z"
      })
    ]));
  }
});
var hide_default = hide_vue_vue_type_script_setup_true_lang_default;
var histogram_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Histogram",
  __name: "histogram",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M416 896V128h192v768zm-288 0V448h192v448zm576 0V320h192v576z"
      })
    ]));
  }
});
var histogram_default = histogram_vue_vue_type_script_setup_true_lang_default;
var home_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "HomeFilled",
  __name: "home-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 128 128 447.936V896h255.936V640H640v256h255.936V447.936z"
      })
    ]));
  }
});
var home_filled_default = home_filled_vue_vue_type_script_setup_true_lang_default;
var hot_water_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "HotWater",
  __name: "hot-water",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M273.067 477.867h477.866V409.6H273.067zm0 68.266v51.2A187.733 187.733 0 0 0 460.8 785.067h102.4a187.733 187.733 0 0 0 187.733-187.734v-51.2H273.067zm-34.134-204.8h546.134a34.133 34.133 0 0 1 34.133 34.134v221.866a256 256 0 0 1-256 256H460.8a256 256 0 0 1-256-256V375.467a34.133 34.133 0 0 1 34.133-34.134zM512 34.133a34.133 34.133 0 0 1 34.133 34.134v170.666a34.133 34.133 0 0 1-68.266 0V68.267A34.133 34.133 0 0 1 512 34.133zM375.467 102.4a34.133 34.133 0 0 1 34.133 34.133v102.4a34.133 34.133 0 0 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.134-34.133m273.066 0a34.133 34.133 0 0 1 34.134 34.133v102.4a34.133 34.133 0 1 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.133-34.133M170.667 921.668h682.666a34.133 34.133 0 1 1 0 68.267H170.667a34.133 34.133 0 1 1 0-68.267z"
      })
    ]));
  }
});
var hot_water_default = hot_water_vue_vue_type_script_setup_true_lang_default;
var house_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "House",
  __name: "house",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 413.952V896h640V413.952L512 147.328zM139.52 374.4l352-293.312a32 32 0 0 1 40.96 0l352 293.312A32 32 0 0 1 896 398.976V928a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V398.976a32 32 0 0 1 11.52-24.576"
      })
    ]));
  }
});
var house_default = house_vue_vue_type_script_setup_true_lang_default;
var ice_cream_round_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "IceCreamRound",
  __name: "ice-cream-round",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m308.352 489.344 226.304 226.304a32 32 0 0 0 45.248 0L783.552 512A192 192 0 1 0 512 240.448L308.352 444.16a32 32 0 0 0 0 45.248zm135.744 226.304L308.352 851.392a96 96 0 0 1-135.744-135.744l135.744-135.744-45.248-45.248a96 96 0 0 1 0-135.808L466.752 195.2A256 256 0 0 1 828.8 557.248L625.152 760.96a96 96 0 0 1-135.808 0l-45.248-45.248zM398.848 670.4 353.6 625.152 217.856 760.896a32 32 0 0 0 45.248 45.248zm248.96-384.64a32 32 0 0 1 0 45.248L466.624 512a32 32 0 1 1-45.184-45.248l180.992-181.056a32 32 0 0 1 45.248 0zm90.496 90.496a32 32 0 0 1 0 45.248L557.248 602.496A32 32 0 1 1 512 557.248l180.992-180.992a32 32 0 0 1 45.312 0z"
      })
    ]));
  }
});
var ice_cream_round_default = ice_cream_round_vue_vue_type_script_setup_true_lang_default;
var ice_cream_square_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "IceCreamSquare",
  __name: "ice-cream-square",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M416 640h256a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H352a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32zm192 64v160a96 96 0 0 1-192 0V704h-64a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96h320a96 96 0 0 1 96 96v448a96 96 0 0 1-96 96zm-64 0h-64v160a32 32 0 1 0 64 0z"
      })
    ]));
  }
});
var ice_cream_square_default = ice_cream_square_vue_vue_type_script_setup_true_lang_default;
var ice_cream_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "IceCream",
  __name: "ice-cream",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128.64 448a208 208 0 0 1 193.536-191.552 224 224 0 0 1 445.248 15.488A208.128 208.128 0 0 1 894.784 448H896L548.8 983.68a32 32 0 0 1-53.248.704L128 448zm64.256 0h286.208a144 144 0 0 0-286.208 0zm351.36 0h286.272a144 144 0 0 0-286.272 0zm-294.848 64 271.808 396.608L778.24 512H249.408zM511.68 352.64a207.872 207.872 0 0 1 189.184-96.192 160 160 0 0 0-314.752 5.632c52.608 12.992 97.28 46.08 125.568 90.56"
      })
    ]));
  }
});
var ice_cream_default = ice_cream_vue_vue_type_script_setup_true_lang_default;
var ice_drink_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "IceDrink",
  __name: "ice-drink",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 448v128h239.68l16.064-128zm-64 0H256.256l16.064 128H448zm64-255.36V384h247.744A256.128 256.128 0 0 0 512 192.64m-64 8.064A256.448 256.448 0 0 0 264.256 384H448zm64-72.064A320.128 320.128 0 0 1 825.472 384H896a32 32 0 1 1 0 64h-64v1.92l-56.96 454.016A64 64 0 0 1 711.552 960H312.448a64 64 0 0 1-63.488-56.064L192 449.92V448h-64a32 32 0 0 1 0-64h70.528A320.384 320.384 0 0 1 448 135.04V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H544a32 32 0 0 0-32 32zM743.68 640H280.32l32.128 256h399.104z"
      })
    ]));
  }
});
var ice_drink_default = ice_drink_vue_vue_type_script_setup_true_lang_default;
var ice_tea_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "IceTea",
  __name: "ice-tea",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M197.696 259.648a320.128 320.128 0 0 1 628.608 0A96 96 0 0 1 896 352v64a96 96 0 0 1-71.616 92.864l-49.408 395.072A64 64 0 0 1 711.488 960H312.512a64 64 0 0 1-63.488-56.064l-49.408-395.072A96 96 0 0 1 128 416v-64a96 96 0 0 1 69.696-92.352M264.064 256h495.872a256.128 256.128 0 0 0-495.872 0m495.424 256H264.512l48 384h398.976zM224 448h576a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H224a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32m160 192h64v64h-64zm192 64h64v64h-64zm-128 64h64v64h-64zm64-192h64v64h-64z"
      })
    ]));
  }
});
var ice_tea_default = ice_tea_vue_vue_type_script_setup_true_lang_default;
var info_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "InfoFilled",
  __name: "info-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
      })
    ]));
  }
});
var info_filled_default = info_filled_vue_vue_type_script_setup_true_lang_default;
var iphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Iphone",
  __name: "iphone",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 768v96.064a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V768zm0-64h576V160a64 64 0 0 0-64-64H288a64 64 0 0 0-64 64zm32 288a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h512a96 96 0 0 1 96 96v768a96 96 0 0 1-96 96zm304-144a48 48 0 1 1-96 0 48 48 0 0 1 96 0"
      })
    ]));
  }
});
var iphone_default = iphone_vue_vue_type_script_setup_true_lang_default;
var key_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Key",
  __name: "key",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 456.064V96a32 32 0 0 1 32-32.064L672 64a32 32 0 0 1 0 64H512v128h160a32 32 0 0 1 0 64H512v128a256 256 0 1 1-64 8.064M512 896a192 192 0 1 0 0-384 192 192 0 0 0 0 384"
      })
    ]));
  }
});
var key_default = key_vue_vue_type_script_setup_true_lang_default;
var knife_fork_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "KnifeFork",
  __name: "knife-fork",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 410.56V96a32 32 0 0 1 64 0v314.56A96 96 0 0 0 384 320V96a32 32 0 0 1 64 0v224a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.8A160 160 0 0 1 128 320V96a32 32 0 0 1 64 0v224a96 96 0 0 0 64 90.56m384-250.24V544h126.72c-3.328-78.72-12.928-147.968-28.608-207.744-14.336-54.528-46.848-113.344-98.112-175.872zM640 608v320a32 32 0 1 1-64 0V64h64c85.312 89.472 138.688 174.848 160 256 21.312 81.152 32 177.152 32 288z"
      })
    ]));
  }
});
var knife_fork_default = knife_fork_vue_vue_type_script_setup_true_lang_default;
var lightning_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Lightning",
  __name: "lightning",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 671.36v64.128A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 736 734.016v-64.768a192 192 0 0 0 3.328-377.92l-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 91.968 70.464 167.36 160.256 175.232z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M416 736a32 32 0 0 1-27.776-47.872l128-224a32 32 0 1 1 55.552 31.744L471.168 672H608a32 32 0 0 1 27.776 47.872l-128 224a32 32 0 1 1-55.68-31.744L552.96 736z"
      })
    ]));
  }
});
var lightning_default = lightning_vue_vue_type_script_setup_true_lang_default;
var link_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Link",
  __name: "link",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152z"
      })
    ]));
  }
});
var link_default = link_vue_vue_type_script_setup_true_lang_default;
var list_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "List",
  __name: "list",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 192h160v736H160V192h160v64h384zM288 512h448v-64H288zm0 256h448v-64H288zm96-576V96h256v96z"
      })
    ]));
  }
});
var list_default = list_vue_vue_type_script_setup_true_lang_default;
var loading_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Loading",
  __name: "loading",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
      })
    ]));
  }
});
var loading_default = loading_vue_vue_type_script_setup_true_lang_default;
var location_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "LocationFilled",
  __name: "location-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 928c23.936 0 117.504-68.352 192.064-153.152C803.456 661.888 864 535.808 864 416c0-189.632-155.84-320-352-320S160 226.368 160 416c0 120.32 60.544 246.4 159.936 359.232C394.432 859.84 488 928 512 928m0-435.2a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 140.8a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6"
      })
    ]));
  }
});
var location_filled_default = location_filled_vue_vue_type_script_setup_true_lang_default;
var location_information_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "LocationInformation",
  __name: "location-information",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
      })
    ]));
  }
});
var location_information_default = location_information_vue_vue_type_script_setup_true_lang_default;
var location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Location",
  __name: "location",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
      })
    ]));
  }
});
var location_default = location_vue_vue_type_script_setup_true_lang_default;
var lock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Lock",
  __name: "lock",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m192-160v-64a192 192 0 1 0-384 0v64zM512 64a256 256 0 0 1 256 256v128H256V320A256 256 0 0 1 512 64"
      })
    ]));
  }
});
var lock_default = lock_vue_vue_type_script_setup_true_lang_default;
var lollipop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Lollipop",
  __name: "lollipop",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M513.28 448a64 64 0 1 1 76.544 49.728A96 96 0 0 0 768 448h64a160 160 0 0 1-320 0zm-126.976-29.696a256 256 0 1 0 43.52-180.48A256 256 0 0 1 832 448h-64a192 192 0 0 0-381.696-29.696m105.664 249.472L285.696 874.048a96 96 0 0 1-135.68-135.744l206.208-206.272a320 320 0 1 1 135.744 135.744zm-54.464-36.032a321.92 321.92 0 0 1-45.248-45.248L195.2 783.552a32 32 0 1 0 45.248 45.248l197.056-197.12z"
      })
    ]));
  }
});
var lollipop_default = lollipop_vue_vue_type_script_setup_true_lang_default;
var magic_stick_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MagicStick",
  __name: "magic-stick",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64h64v192h-64zm0 576h64v192h-64zM160 480v-64h192v64zm576 0v-64h192v64zM249.856 199.04l45.248-45.184L430.848 289.6 385.6 334.848 249.856 199.104zM657.152 606.4l45.248-45.248 135.744 135.744-45.248 45.248zM114.048 923.2 68.8 877.952l316.8-316.8 45.248 45.248zM702.4 334.848 657.152 289.6l135.744-135.744 45.248 45.248z"
      })
    ]));
  }
});
var magic_stick_default = magic_stick_vue_vue_type_script_setup_true_lang_default;
var magnet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Magnet",
  __name: "magnet",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 320V192H704v320a192 192 0 1 1-384 0V192H192v128h128v64H192v128a320 320 0 0 0 640 0V384H704v-64zM640 512V128h256v384a384 384 0 1 1-768 0V128h256v384a128 128 0 1 0 256 0"
      })
    ]));
  }
});
var magnet_default = magnet_vue_vue_type_script_setup_true_lang_default;
var male_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Male",
  __name: "male",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M399.5 849.5a225 225 0 1 0 0-450 225 225 0 0 0 0 450m0 56.25a281.25 281.25 0 1 1 0-562.5 281.25 281.25 0 0 1 0 562.5m253.125-787.5h225q28.125 0 28.125 28.125T877.625 174.5h-225q-28.125 0-28.125-28.125t28.125-28.125"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M877.625 118.25q28.125 0 28.125 28.125v225q0 28.125-28.125 28.125T849.5 371.375v-225q0-28.125 28.125-28.125"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M604.813 458.9 565.1 419.131l292.613-292.668 39.825 39.824z"
      })
    ]));
  }
});
var male_default = male_vue_vue_type_script_setup_true_lang_default;
var management_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Management",
  __name: "management",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M576 128v288l96-96 96 96V128h128v768H320V128zm-448 0h128v768H128z"
      })
    ]));
  }
});
var management_default = management_vue_vue_type_script_setup_true_lang_default;
var map_location_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MapLocation",
  __name: "map-location",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256m345.6 192L960 960H672v-64H352v64H64l102.4-256zm-68.928 0H235.328l-76.8 192h706.944z"
      })
    ]));
  }
});
var map_location_default = map_location_vue_vue_type_script_setup_true_lang_default;
var medal_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Medal",
  __name: "medal",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M576 128H448v200a286.72 286.72 0 0 1 64-8c19.52 0 40.832 2.688 64 8zm64 0v219.648c24.448 9.088 50.56 20.416 78.4 33.92L757.44 128zm-256 0H266.624l39.04 253.568c27.84-13.504 53.888-24.832 78.336-33.92V128zM229.312 64h565.376a32 32 0 0 1 31.616 36.864L768 480c-113.792-64-199.104-96-256-96-56.896 0-142.208 32-256 96l-58.304-379.136A32 32 0 0 1 229.312 64"
      })
    ]));
  }
});
var medal_default = medal_vue_vue_type_script_setup_true_lang_default;
var memo_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Memo",
  __name: "memo",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 320h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M887.01 72.99C881.01 67 873.34 64 864 64H160c-9.35 0-17.02 3-23.01 8.99C131 78.99 128 86.66 128 96v832c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V96c0-9.35-3-17.02-8.99-23.01M192 896V128h96v768zm640 0H352V128h480z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 512h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32m0 192h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
      })
    ]));
  }
});
var memo_default = memo_vue_vue_type_script_setup_true_lang_default;
var menu_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Menu",
  __name: "menu",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 448a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zM160 896a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32z"
      })
    ]));
  }
});
var menu_default = menu_vue_vue_type_script_setup_true_lang_default;
var message_box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MessageBox",
  __name: "message-box",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 384h448v64H288zm96-128h256v64H384zM131.456 512H384v128h256V512h252.544L721.856 192H302.144zM896 576H704v128H320V576H128v256h768zM275.776 128h472.448a32 32 0 0 1 28.608 17.664l179.84 359.552A32 32 0 0 1 960 519.552V864a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V519.552a32 32 0 0 1 3.392-14.336l179.776-359.552A32 32 0 0 1 275.776 128z"
      })
    ]));
  }
});
var message_box_default = message_box_vue_vue_type_script_setup_true_lang_default;
var message_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Message",
  __name: "message",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224H205.056"
      })
    ]));
  }
});
var message_default = message_vue_vue_type_script_setup_true_lang_default;
var mic_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Mic",
  __name: "mic",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 704h160a64 64 0 0 0 64-64v-32h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-32a64 64 0 0 0-64-64H384a64 64 0 0 0-64 64v32h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v32a64 64 0 0 0 64 64zm64 64v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768h-96a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64h256a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128z"
      })
    ]));
  }
});
var mic_default = mic_vue_vue_type_script_setup_true_lang_default;
var microphone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Microphone",
  __name: "microphone",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 128a128 128 0 0 0-128 128v256a128 128 0 1 0 256 0V256a128 128 0 0 0-128-128m0-64a192 192 0 0 1 192 192v256a192 192 0 1 1-384 0V256A192 192 0 0 1 512 64m-32 832v-64a288 288 0 0 1-288-288v-32a32 32 0 0 1 64 0v32a224 224 0 0 0 224 224h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64z"
      })
    ]));
  }
});
var microphone_default = microphone_vue_vue_type_script_setup_true_lang_default;
var milk_tea_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MilkTea",
  __name: "milk-tea",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M416 128V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H512a32 32 0 0 0-32 32v32h320a96 96 0 0 1 11.712 191.296l-39.68 581.056A64 64 0 0 1 708.224 960H315.776a64 64 0 0 1-63.872-59.648l-39.616-581.056A96 96 0 0 1 224 128zM276.48 320l39.296 576h392.448l4.8-70.784a224.064 224.064 0 0 1 30.016-439.808L747.52 320zM224 256h576a32 32 0 1 0 0-64H224a32 32 0 0 0 0 64m493.44 503.872 21.12-309.12a160 160 0 0 0-21.12 309.12"
      })
    ]));
  }
});
var milk_tea_default = milk_tea_vue_vue_type_script_setup_true_lang_default;
var minus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Minus",
  __name: "minus",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64"
      })
    ]));
  }
});
var minus_default = minus_vue_vue_type_script_setup_true_lang_default;
var money_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Money",
  __name: "money",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 640v192h640V384H768v-64h150.976c14.272 0 19.456 1.472 24.64 4.288a29.056 29.056 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64v493.952c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H233.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096c-2.688-5.184-4.224-10.368-4.224-24.576V640z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 192H128v448h640zm64-22.976v493.952c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096C65.536 682.432 64 677.248 64 663.04V169.024c0-14.272 1.472-19.456 4.288-24.64a29.056 29.056 0 0 1 12.096-12.16C85.568 129.536 90.752 128 104.96 128h685.952c14.272 0 19.456 1.472 24.64 4.288a29.056 29.056 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 576a160 160 0 1 1 0-320 160 160 0 0 1 0 320m0-64a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
      })
    ]));
  }
});
var money_default = money_vue_vue_type_script_setup_true_lang_default;
var monitor_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Monitor",
  __name: "monitor",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 768v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768H192A128 128 0 0 1 64 640V256a128 128 0 0 1 128-128h640a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128zM192 192a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64z"
      })
    ]));
  }
});
var monitor_default = monitor_vue_vue_type_script_setup_true_lang_default;
var moon_night_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MoonNight",
  __name: "moon-night",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 512a448 448 0 0 1 215.872-383.296A384 384 0 0 0 213.76 640h188.8A448.256 448.256 0 0 1 384 512M171.136 704a448 448 0 0 1 636.992-575.296A384 384 0 0 0 499.328 704h-328.32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M32 640h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m128 128h384a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m160 127.68 224 .256a32 32 0 0 1 32 32V928a32 32 0 0 1-32 32l-224-.384a32 32 0 0 1-32-32v-.064a32 32 0 0 1 32-32z"
      })
    ]));
  }
});
var moon_night_default = moon_night_vue_vue_type_script_setup_true_lang_default;
var moon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Moon",
  __name: "moon",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M240.448 240.448a384 384 0 1 0 559.424 525.696 448 448 0 0 1-542.016-542.08 390.592 390.592 0 0 0-17.408 16.384zm181.056 362.048a384 384 0 0 0 525.632 16.384A448 448 0 1 1 405.056 76.8a384 384 0 0 0 16.448 525.696"
      })
    ]));
  }
});
var moon_default = moon_vue_vue_type_script_setup_true_lang_default;
var more_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MoreFilled",
  __name: "more-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
      })
    ]));
  }
});
var more_filled_default = more_filled_vue_vue_type_script_setup_true_lang_default;
var more_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "More",
  __name: "more",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M176 416a112 112 0 1 0 0 224 112 112 0 0 0 0-224m0 64a48 48 0 1 1 0 96 48 48 0 0 1 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96"
      })
    ]));
  }
});
var more_default = more_vue_vue_type_script_setup_true_lang_default;
var mostly_cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MostlyCloudy",
  __name: "mostly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M737.216 357.952 704 349.824l-11.776-32a192.064 192.064 0 0 0-367.424 23.04l-8.96 39.04-39.04 8.96A192.064 192.064 0 0 0 320 768h368a207.808 207.808 0 0 0 207.808-208 208.32 208.32 0 0 0-158.592-202.048m15.168-62.208A272.32 272.32 0 0 1 959.744 560a271.808 271.808 0 0 1-271.552 272H320a256 256 0 0 1-57.536-505.536 256.128 256.128 0 0 1 489.92-30.72"
      })
    ]));
  }
});
var mostly_cloudy_default = mostly_cloudy_vue_vue_type_script_setup_true_lang_default;
var mouse_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Mouse",
  __name: "mouse",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M438.144 256c-68.352 0-92.736 4.672-117.76 18.112-20.096 10.752-35.52 26.176-46.272 46.272C260.672 345.408 256 369.792 256 438.144v275.712c0 68.352 4.672 92.736 18.112 117.76 10.752 20.096 26.176 35.52 46.272 46.272C345.408 891.328 369.792 896 438.144 896h147.712c68.352 0 92.736-4.672 117.76-18.112 20.096-10.752 35.52-26.176 46.272-46.272C763.328 806.592 768 782.208 768 713.856V438.144c0-68.352-4.672-92.736-18.112-117.76a110.464 110.464 0 0 0-46.272-46.272C678.592 260.672 654.208 256 585.856 256zm0-64h147.712c85.568 0 116.608 8.96 147.904 25.6 31.36 16.768 55.872 41.344 72.576 72.64C823.104 321.536 832 352.576 832 438.08v275.84c0 85.504-8.96 116.544-25.6 147.84a174.464 174.464 0 0 1-72.64 72.576C702.464 951.104 671.424 960 585.92 960H438.08c-85.504 0-116.544-8.96-147.84-25.6a174.464 174.464 0 0 1-72.64-72.704c-16.768-31.296-25.664-62.336-25.664-147.84v-275.84c0-85.504 8.96-116.544 25.6-147.84a174.464 174.464 0 0 1 72.768-72.576c31.232-16.704 62.272-25.6 147.776-25.6z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 320q32 0 32 32v128q0 32-32 32t-32-32V352q0-32 32-32m32-96a32 32 0 0 1-64 0v-64a32 32 0 0 0-32-32h-96a32 32 0 0 1 0-64h96a96 96 0 0 1 96 96z"
      })
    ]));
  }
});
var mouse_default = mouse_vue_vue_type_script_setup_true_lang_default;
var mug_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Mug",
  __name: "mug",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M736 800V160H160v640a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64m64-544h63.552a96 96 0 0 1 96 96v224a96 96 0 0 1-96 96H800v128a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V128a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v288h63.552a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32z"
      })
    ]));
  }
});
var mug_default = mug_vue_vue_type_script_setup_true_lang_default;
var mute_notification_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "MuteNotification",
  __name: "mute-notification",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m241.216 832 63.616-64H768V448c0-42.368-10.24-82.304-28.48-117.504l46.912-47.232C815.36 331.392 832 387.84 832 448v320h96a32 32 0 1 1 0 64zm-90.24 0H96a32 32 0 1 1 0-64h96V448a320.128 320.128 0 0 1 256-313.6V128a64 64 0 1 1 128 0v6.4a319.552 319.552 0 0 1 171.648 97.088l-45.184 45.44A256 256 0 0 0 256 448v278.336L151.04 832zM448 896h128a64 64 0 0 1-128 0"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056l-704 708.544z"
      })
    ]));
  }
});
var mute_notification_default = mute_notification_vue_vue_type_script_setup_true_lang_default;
var mute_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Mute",
  __name: "mute",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m412.16 592.128-45.44 45.44A191.232 191.232 0 0 1 320 512V256a192 192 0 1 1 384 0v44.352l-64 64V256a128 128 0 1 0-256 0v256c0 30.336 10.56 58.24 28.16 80.128m51.968 38.592A128 128 0 0 0 640 512v-57.152l64-64V512a192 192 0 0 1-287.68 166.528zM314.88 779.968l46.144-46.08A222.976 222.976 0 0 0 480 768h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64h64v-64c-61.44 0-118.4-19.2-165.12-52.032M266.752 737.6A286.976 286.976 0 0 1 192 544v-32a32 32 0 0 1 64 0v32c0 56.832 21.184 108.8 56.064 148.288z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056l-704 708.544z"
      })
    ]));
  }
});
var mute_default = mute_vue_vue_type_script_setup_true_lang_default;
var no_smoking_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "NoSmoking",
  __name: "no-smoking",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M440.256 576H256v128h56.256l-64 64H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32h280.256zm143.488 128H704V583.744L775.744 512H928a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H519.744zM768 576v128h128V576zm-29.696-207.552 45.248 45.248-497.856 497.856-45.248-45.248zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
      })
    ]));
  }
});
var no_smoking_default = no_smoking_vue_vue_type_script_setup_true_lang_default;
var notebook_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Notebook",
  __name: "notebook",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M672 128h64v768h-64zM96 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
      })
    ]));
  }
});
var notebook_default = notebook_vue_vue_type_script_setup_true_lang_default;
var notification_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Notification",
  __name: "notification",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 128v64H256a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V512h64v256a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256a128 128 0 0 1 128-128z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 384a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
      })
    ]));
  }
});
var notification_default = notification_vue_vue_type_script_setup_true_lang_default;
var odometer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Odometer",
  __name: "odometer",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 512a320 320 0 1 1 640 0 32 32 0 1 1-64 0 256 256 0 1 0-512 0 32 32 0 0 1-64 0"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M570.432 627.84A96 96 0 1 1 509.568 608l60.992-187.776A32 32 0 1 1 631.424 440l-60.992 187.776zM502.08 734.464a32 32 0 1 0 19.84-60.928 32 32 0 0 0-19.84 60.928"
      })
    ]));
  }
});
var odometer_default = odometer_vue_vue_type_script_setup_true_lang_default;
var office_building_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "OfficeBuilding",
  __name: "office-building",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 128v704h384V128zm-32-64h448a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 256h256v64H256zm0 192h256v64H256zm0 192h256v64H256zm384-128h128v64H640zm0 128h128v64H640zM64 832h896v64H64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 384v448h192V384zm-32-64h256a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H608a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var office_building_default = office_building_vue_vue_type_script_setup_true_lang_default;
var open_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Open",
  __name: "open",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M694.044 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
      })
    ]));
  }
});
var open_default = open_vue_vue_type_script_setup_true_lang_default;
var operation_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Operation",
  __name: "operation",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M389.44 768a96.064 96.064 0 0 1 181.12 0H896v64H570.56a96.064 96.064 0 0 1-181.12 0H128v-64zm192-288a96.064 96.064 0 0 1 181.12 0H896v64H762.56a96.064 96.064 0 0 1-181.12 0H128v-64zm-320-288a96.064 96.064 0 0 1 181.12 0H896v64H442.56a96.064 96.064 0 0 1-181.12 0H128v-64z"
      })
    ]));
  }
});
var operation_default = operation_vue_vue_type_script_setup_true_lang_default;
var opportunity_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Opportunity",
  __name: "opportunity",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 960v-64h192.064v64zm448-544a350.656 350.656 0 0 1-128.32 271.424C665.344 719.04 640 763.776 640 813.504V832H320v-14.336c0-48-19.392-95.36-57.216-124.992a351.552 351.552 0 0 1-128.448-344.256c25.344-136.448 133.888-248.128 269.76-276.48A352.384 352.384 0 0 1 832 416m-544 32c0-132.288 75.904-224 192-224v-64c-154.432 0-256 122.752-256 288z"
      })
    ]));
  }
});
var opportunity_default = opportunity_vue_vue_type_script_setup_true_lang_default;
var orange_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Orange",
  __name: "orange",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 894.72a382.336 382.336 0 0 0 215.936-89.472L577.024 622.272c-10.24 6.016-21.248 10.688-33.024 13.696v258.688zm261.248-134.784A382.336 382.336 0 0 0 894.656 544H635.968c-3.008 11.776-7.68 22.848-13.696 33.024l182.976 182.912zM894.656 480a382.336 382.336 0 0 0-89.408-215.936L622.272 446.976c6.016 10.24 10.688 21.248 13.696 33.024h258.688zm-134.72-261.248A382.336 382.336 0 0 0 544 129.344v258.688c11.776 3.008 22.848 7.68 33.024 13.696zM480 129.344a382.336 382.336 0 0 0-215.936 89.408l182.912 182.976c10.24-6.016 21.248-10.688 33.024-13.696zm-261.248 134.72A382.336 382.336 0 0 0 129.344 480h258.688c3.008-11.776 7.68-22.848 13.696-33.024zM129.344 544a382.336 382.336 0 0 0 89.408 215.936l182.976-182.912A127.232 127.232 0 0 1 388.032 544zm134.72 261.248A382.336 382.336 0 0 0 480 894.656V635.968a127.232 127.232 0 0 1-33.024-13.696zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-384a64 64 0 1 0 0-128 64 64 0 0 0 0 128"
      })
    ]));
  }
});
var orange_default = orange_vue_vue_type_script_setup_true_lang_default;
var paperclip_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Paperclip",
  __name: "paperclip",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M602.496 240.448A192 192 0 1 1 874.048 512l-316.8 316.8A256 256 0 0 1 195.2 466.752L602.496 59.456l45.248 45.248L240.448 512A192 192 0 0 0 512 783.552l316.8-316.8a128 128 0 1 0-181.056-181.056L353.6 579.904a32 32 0 1 0 45.248 45.248l294.144-294.144 45.312 45.248L444.096 670.4a96 96 0 1 1-135.744-135.744l294.144-294.208z"
      })
    ]));
  }
});
var paperclip_default = paperclip_vue_vue_type_script_setup_true_lang_default;
var partly_cloudy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PartlyCloudy",
  __name: "partly-cloudy",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M598.4 895.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 895.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 445.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M139.84 501.888a256 256 0 1 1 417.856-277.12c-17.728 2.176-38.208 8.448-61.504 18.816A192 192 0 1 0 189.12 460.48a6003.84 6003.84 0 0 0-49.28 41.408z"
      })
    ]));
  }
});
var partly_cloudy_default = partly_cloudy_vue_vue_type_script_setup_true_lang_default;
var pear_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Pear",
  __name: "pear",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M542.336 258.816a443.255 443.255 0 0 0-9.024 25.088 32 32 0 1 1-60.8-20.032l1.088-3.328a162.688 162.688 0 0 0-122.048 131.392l-17.088 102.72-20.736 15.36C256.192 552.704 224 610.88 224 672c0 120.576 126.4 224 288 224s288-103.424 288-224c0-61.12-32.192-119.296-89.728-161.92l-20.736-15.424-17.088-102.72a162.688 162.688 0 0 0-130.112-133.12zm-40.128-66.56c7.936-15.552 16.576-30.08 25.92-43.776 23.296-33.92 49.408-59.776 78.528-77.12a32 32 0 1 1 32.704 55.04c-20.544 12.224-40.064 31.552-58.432 58.304a316.608 316.608 0 0 0-9.792 15.104 226.688 226.688 0 0 1 164.48 181.568l12.8 77.248C819.456 511.36 864 587.392 864 672c0 159.04-157.568 288-352 288S160 831.04 160 672c0-84.608 44.608-160.64 115.584-213.376l12.8-77.248a226.624 226.624 0 0 1 213.76-189.184z"
      })
    ]));
  }
});
var pear_default = pear_vue_vue_type_script_setup_true_lang_default;
var phone_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PhoneFilled",
  __name: "phone-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M199.232 125.568 90.624 379.008a32 32 0 0 0 6.784 35.2l512.384 512.384a32 32 0 0 0 35.2 6.784l253.44-108.608a32 32 0 0 0 10.048-52.032L769.6 633.92a32 32 0 0 0-36.928-5.952l-130.176 65.088-271.488-271.552 65.024-130.176a32 32 0 0 0-5.952-36.928L251.2 115.52a32 32 0 0 0-51.968 10.048z"
      })
    ]));
  }
});
var phone_filled_default = phone_filled_vue_vue_type_script_setup_true_lang_default;
var phone_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Phone",
  __name: "phone",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M79.36 432.256 591.744 944.64a32 32 0 0 0 35.2 6.784l253.44-108.544a32 32 0 0 0 9.984-52.032l-153.856-153.92a32 32 0 0 0-36.928-6.016l-69.888 34.944L358.08 394.24l35.008-69.888a32 32 0 0 0-5.952-36.928L233.152 133.568a32 32 0 0 0-52.032 10.048L72.512 397.056a32 32 0 0 0 6.784 35.2zm60.48-29.952 81.536-190.08L325.568 316.48l-24.64 49.216-20.608 41.216 32.576 32.64 271.552 271.552 32.64 32.64 41.216-20.672 49.28-24.576 104.192 104.128-190.08 81.472L139.84 402.304zM512 320v-64a256 256 0 0 1 256 256h-64a192 192 0 0 0-192-192m0-192V64a448 448 0 0 1 448 448h-64a384 384 0 0 0-384-384"
      })
    ]));
  }
});
var phone_default = phone_vue_vue_type_script_setup_true_lang_default;
var picture_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PictureFilled",
  __name: "picture-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M96 896a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32zm315.52-228.48-68.928-68.928a32 32 0 0 0-45.248 0L128 768.064h778.688l-242.112-290.56a32 32 0 0 0-49.216 0L458.752 665.408a32 32 0 0 1-47.232 2.112M256 384a96 96 0 1 0 192.064-.064A96 96 0 0 0 256 384"
      })
    ]));
  }
});
var picture_filled_default = picture_filled_vue_vue_type_script_setup_true_lang_default;
var picture_rounded_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PictureRounded",
  __name: "picture-rounded",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768m0-64a448 448 0 1 1 0 896 448 448 0 0 1 0-896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 288q64 0 64 64t-64 64q-64 0-64-64t64-64M214.656 790.656l-45.312-45.312 185.664-185.6a96 96 0 0 1 123.712-10.24l138.24 98.688a32 32 0 0 0 39.872-2.176L906.688 422.4l42.624 47.744L699.52 693.696a96 96 0 0 1-119.808 6.592l-138.24-98.752a32 32 0 0 0-41.152 3.456l-185.664 185.6z"
      })
    ]));
  }
});
var picture_rounded_default = picture_rounded_vue_vue_type_script_setup_true_lang_default;
var picture_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Picture",
  __name: "picture",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 288q64 0 64 64t-64 64q-64 0-64-64t64-64M185.408 876.992l-50.816-38.912L350.72 556.032a96 96 0 0 1 134.592-17.856l1.856 1.472 122.88 99.136a32 32 0 0 0 44.992-4.864l216-269.888 49.92 39.936-215.808 269.824-.256.32a96 96 0 0 1-135.04 14.464l-122.88-99.072-.64-.512a32 32 0 0 0-44.8 5.952z"
      })
    ]));
  }
});
var picture_default = picture_vue_vue_type_script_setup_true_lang_default;
var pie_chart_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PieChart",
  __name: "pie-chart",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 68.48v64.832A384.128 384.128 0 0 0 512 896a384.128 384.128 0 0 0 378.688-320h64.768A448.128 448.128 0 0 1 64 512 448.128 448.128 0 0 1 448 68.48z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M576 97.28V448h350.72A384.064 384.064 0 0 0 576 97.28zM512 64V33.152A448 448 0 0 1 990.848 512H512z"
      })
    ]));
  }
});
var pie_chart_default = pie_chart_vue_vue_type_script_setup_true_lang_default;
var place_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Place",
  __name: "place",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 512a32 32 0 0 1 32 32v256a32 32 0 1 1-64 0V544a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 649.088v64.96C269.76 732.352 192 771.904 192 800c0 37.696 139.904 96 320 96s320-58.304 320-96c0-28.16-77.76-67.648-192-85.952v-64.96C789.12 671.04 896 730.368 896 800c0 88.32-171.904 160-384 160s-384-71.68-384-160c0-69.696 106.88-128.96 256-150.912"
      })
    ]));
  }
});
var place_default = place_vue_vue_type_script_setup_true_lang_default;
var platform_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Platform",
  __name: "platform",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
      })
    ]));
  }
});
var platform_default = platform_vue_vue_type_script_setup_true_lang_default;
var plus_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Plus",
  __name: "plus",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64z"
      })
    ]));
  }
});
var plus_default = plus_vue_vue_type_script_setup_true_lang_default;
var pointer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Pointer",
  __name: "pointer",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M511.552 128c-35.584 0-64.384 28.8-64.384 64.448v516.48L274.048 570.88a94.272 94.272 0 0 0-112.896-3.456 44.416 44.416 0 0 0-8.96 62.208L332.8 870.4A64 64 0 0 0 384 896h512V575.232a64 64 0 0 0-45.632-61.312l-205.952-61.76A96 96 0 0 1 576 360.192V192.448C576 156.8 547.2 128 511.552 128M359.04 556.8l24.128 19.2V192.448a128.448 128.448 0 1 1 256.832 0v167.744a32 32 0 0 0 22.784 30.656l206.016 61.76A128 128 0 0 1 960 575.232V896a64 64 0 0 1-64 64H384a128 128 0 0 1-102.4-51.2L101.056 668.032A108.416 108.416 0 0 1 128 512.512a158.272 158.272 0 0 1 185.984 8.32z"
      })
    ]));
  }
});
var pointer_default = pointer_vue_vue_type_script_setup_true_lang_default;
var position_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Position",
  __name: "position",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m249.6 417.088 319.744 43.072 39.168 310.272L845.12 178.88 249.6 417.088zm-129.024 47.168a32 32 0 0 1-7.68-61.44l777.792-311.04a32 32 0 0 1 41.6 41.6l-310.336 775.68a32 32 0 0 1-61.44-7.808L512 516.992l-391.424-52.736z"
      })
    ]));
  }
});
var position_default = position_vue_vue_type_script_setup_true_lang_default;
var postcard_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Postcard",
  __name: "postcard",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 224a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32zm0-64h704a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128M288 448h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32m0 128h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});
var postcard_default = postcard_vue_vue_type_script_setup_true_lang_default;
var pouring_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Pouring",
  __name: "pouring",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672zM959.552 480a256 256 0 0 1-256 256h-400A239.808 239.808 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M224 800a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var pouring_default = pouring_vue_vue_type_script_setup_true_lang_default;
var present_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Present",
  __name: "present",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 896V640H192v-64h288V320H192v576zm64 0h288V320H544v256h288v64H544zM128 256h768v672a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M96 256h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M416 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M608 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});
var present_default = present_vue_vue_type_script_setup_true_lang_default;
var price_tag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "PriceTag",
  __name: "price-tag",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 318.336V896h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      })
    ]));
  }
});
var price_tag_default = price_tag_vue_vue_type_script_setup_true_lang_default;
var printer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Printer",
  __name: "printer",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 768H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.056 29.056 0 0 1-12.16-12.096C65.536 746.432 64 741.248 64 727.04V379.072c0-42.816 4.48-58.304 12.8-73.984 8.384-15.616 20.672-27.904 36.288-36.288 15.68-8.32 31.168-12.8 73.984-12.8H256V64h512v192h68.928c42.816 0 58.304 4.48 73.984 12.8 15.616 8.384 27.904 20.672 36.288 36.288 8.32 15.68 12.8 31.168 12.8 73.984v347.904c0 14.272-1.472 19.456-4.288 24.64a29.056 29.056 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H768v192H256zm64-192v320h384V576zm-64 128V512h512v192h128V379.072c0-29.376-1.408-36.48-5.248-43.776a23.296 23.296 0 0 0-10.048-10.048c-7.232-3.84-14.4-5.248-43.776-5.248H187.072c-29.376 0-36.48 1.408-43.776 5.248a23.296 23.296 0 0 0-10.048 10.048c-3.84 7.232-5.248 14.4-5.248 43.776V704zm64-448h384V128H320zm-64 128h64v64h-64zm128 0h64v64h-64z"
      })
    ]));
  }
});
var printer_default = printer_vue_vue_type_script_setup_true_lang_default;
var promotion_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Promotion",
  __name: "promotion",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m64 448 832-320-128 704-446.08-243.328L832 192 242.816 545.472zm256 512V657.024L512 768z"
      })
    ]));
  }
});
var promotion_default = promotion_vue_vue_type_script_setup_true_lang_default;
var quartz_watch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "QuartzWatch",
  __name: "quartz-watch",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M422.02 602.01v-.03c-6.68-5.99-14.35-8.83-23.01-8.51-8.67.32-16.17 3.66-22.5 10.02-6.33 6.36-9.5 13.7-9.5 22.02s3 15.82 8.99 22.5c8.68 8.68 19.02 11.35 31.01 8s19.49-10.85 22.5-22.5c3.01-11.65.51-22.15-7.49-31.49zM384 512c0-9.35-3-17.02-8.99-23.01-6-5.99-13.66-8.99-23.01-8.99-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.67 8.99-23.01m6.53-82.49c11.65 3.01 22.15.51 31.49-7.49h.04c5.99-6.68 8.83-14.34 8.51-23.01-.32-8.67-3.66-16.16-10.02-22.5-6.36-6.33-13.7-9.5-22.02-9.5s-15.82 3-22.5 8.99c-8.68 8.69-11.35 19.02-8 31.01 3.35 11.99 10.85 19.49 22.5 22.5zm242.94 0c11.67-3.03 19.01-10.37 22.02-22.02 3.01-11.65.51-22.15-7.49-31.49h.01c-6.68-5.99-14.18-8.99-22.5-8.99s-15.66 3.16-22.02 9.5c-6.36 6.34-9.7 13.84-10.02 22.5-.32 8.66 2.52 16.33 8.51 23.01 9.32 8.02 19.82 10.52 31.49 7.49M512 640c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01s-3-17.02-8.99-23.01c-6-5.99-13.66-8.99-23.01-8.99m183.01-151.01c-6-5.99-13.66-8.99-23.01-8.99s-17.02 3-23.01 8.99c-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99s17.02-3 23.01-8.99c5.99-6 8.99-13.67 8.99-23.01 0-9.35-3-17.02-8.99-23.01"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 512c-2-90.67-33.17-166.17-93.5-226.5-20.43-20.42-42.6-37.49-66.5-51.23V64H352v170.26c-23.9 13.74-46.07 30.81-66.5 51.24-60.33 60.33-91.49 135.83-93.5 226.5 2 90.67 33.17 166.17 93.5 226.5 20.43 20.43 42.6 37.5 66.5 51.24V960h320V789.74c23.9-13.74 46.07-30.81 66.5-51.24 60.33-60.34 91.49-135.83 93.5-226.5M416 128h192v78.69c-29.85-9.03-61.85-13.93-96-14.69-34.15.75-66.15 5.65-96 14.68zm192 768H416v-78.68c29.85 9.03 61.85 13.93 96 14.68 34.15-.75 66.15-5.65 96-14.68zm-96-128c-72.66-2.01-132.99-27.01-180.99-75.01S258.01 584.66 256 512c2.01-72.66 27.01-132.99 75.01-180.99S439.34 258.01 512 256c72.66 2.01 132.99 27.01 180.99 75.01S765.99 439.34 768 512c-2.01 72.66-27.01 132.99-75.01 180.99S584.66 765.99 512 768"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 320c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01 0 9.35 3 17.02 8.99 23.01 6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01 0-9.35-3-17.02-8.99-23.01-6-5.99-13.66-8.99-23.01-8.99m112.99 273.5c-8.66-.32-16.33 2.52-23.01 8.51-7.98 9.32-10.48 19.82-7.49 31.49s10.49 19.17 22.5 22.5 22.35.66 31.01-8v.04c5.99-6.68 8.99-14.18 8.99-22.5s-3.16-15.66-9.5-22.02-13.84-9.7-22.5-10.02"
      })
    ]));
  }
});
var quartz_watch_default = quartz_watch_vue_vue_type_script_setup_true_lang_default;
var question_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "QuestionFilled",
  __name: "question-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m23.744 191.488c-52.096 0-92.928 14.784-123.2 44.352-30.976 29.568-45.76 70.4-45.76 122.496h80.256c0-29.568 5.632-52.8 17.6-68.992 13.376-19.712 35.2-28.864 66.176-28.864 23.936 0 42.944 6.336 56.32 19.712 12.672 13.376 19.712 31.68 19.712 54.912 0 17.6-6.336 34.496-19.008 49.984l-8.448 9.856c-45.76 40.832-73.216 70.4-82.368 89.408-9.856 19.008-14.08 42.24-14.08 68.992v9.856h80.96v-9.856c0-16.896 3.52-31.68 10.56-45.76 6.336-12.672 15.488-24.64 28.16-35.2 33.792-29.568 54.208-48.576 60.544-55.616 16.896-22.528 26.048-51.392 26.048-86.592 0-42.944-14.08-76.736-42.24-101.376-28.16-25.344-65.472-37.312-111.232-37.312zm-12.672 406.208a54.272 54.272 0 0 0-38.72 14.784 49.408 49.408 0 0 0-15.488 38.016c0 15.488 4.928 28.16 15.488 38.016A54.848 54.848 0 0 0 523.072 768c15.488 0 28.16-4.928 38.72-14.784a51.52 51.52 0 0 0 16.192-38.72 51.968 51.968 0 0 0-15.488-38.016 55.936 55.936 0 0 0-39.424-14.784z"
      })
    ]));
  }
});
var question_filled_default = question_filled_vue_vue_type_script_setup_true_lang_default;
var rank_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Rank",
  __name: "rank",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m186.496 544 41.408 41.344a32 32 0 1 1-45.248 45.312l-96-96a32 32 0 0 1 0-45.312l96-96a32 32 0 1 1 45.248 45.312L186.496 480h290.816V186.432l-41.472 41.472a32 32 0 1 1-45.248-45.184l96-96.128a32 32 0 0 1 45.312 0l96 96.064a32 32 0 0 1-45.248 45.184l-41.344-41.28V480H832l-41.344-41.344a32 32 0 0 1 45.248-45.312l96 96a32 32 0 0 1 0 45.312l-96 96a32 32 0 0 1-45.248-45.312L832 544H541.312v293.44l41.344-41.28a32 32 0 1 1 45.248 45.248l-96 96a32 32 0 0 1-45.312 0l-96-96a32 32 0 1 1 45.312-45.248l41.408 41.408V544H186.496z"
      })
    ]));
  }
});
var rank_default = rank_vue_vue_type_script_setup_true_lang_default;
var reading_lamp_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ReadingLamp",
  __name: "reading-lamp",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 896h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m-44.672-768-99.52 448h608.384l-99.52-448zm-25.6-64h460.608a32 32 0 0 1 31.232 25.088l113.792 512A32 32 0 0 1 856.128 640H167.872a32 32 0 0 1-31.232-38.912l113.792-512A32 32 0 0 1 281.664 64z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M672 576q32 0 32 32v128q0 32-32 32t-32-32V608q0-32 32-32m-192-.064h64V960h-64z"
      })
    ]));
  }
});
var reading_lamp_default = reading_lamp_vue_vue_type_script_setup_true_lang_default;
var reading_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Reading",
  __name: "reading",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m512 863.36 384-54.848v-638.72L525.568 222.72a96 96 0 0 1-27.136 0L128 169.792v638.72zM137.024 106.432l370.432 52.928a32 32 0 0 0 9.088 0l370.432-52.928A64 64 0 0 1 960 169.792v638.72a64 64 0 0 1-54.976 63.36l-388.48 55.488a32 32 0 0 1-9.088 0l-388.48-55.488A64 64 0 0 1 64 808.512v-638.72a64 64 0 0 1 73.024-63.36z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 192h64v704h-64z"
      })
    ]));
  }
});
var reading_default = reading_vue_vue_type_script_setup_true_lang_default;
var refresh_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "RefreshLeft",
  __name: "refresh-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z"
      })
    ]));
  }
});
var refresh_left_default = refresh_left_vue_vue_type_script_setup_true_lang_default;
var refresh_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "RefreshRight",
  __name: "refresh-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88z"
      })
    ]));
  }
});
var refresh_right_default = refresh_right_vue_vue_type_script_setup_true_lang_default;
var refresh_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Refresh",
  __name: "refresh",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M771.776 794.88A384 384 0 0 1 128 512h64a320 320 0 0 0 555.712 216.448H654.72a32 32 0 1 1 0-64h149.056a32 32 0 0 1 32 32v148.928a32 32 0 1 1-64 0v-50.56zM276.288 295.616h92.992a32 32 0 0 1 0 64H220.16a32 32 0 0 1-32-32V178.56a32 32 0 0 1 64 0v50.56A384 384 0 0 1 896.128 512h-64a320 320 0 0 0-555.776-216.384z"
      })
    ]));
  }
});
var refresh_default = refresh_vue_vue_type_script_setup_true_lang_default;
var refrigerator_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Refrigerator",
  __name: "refrigerator",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 448h512V160a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32zm0 64v352a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V512zm32-448h448a96 96 0 0 1 96 96v704a96 96 0 0 1-96 96H288a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96m32 224h64v96h-64zm0 288h64v96h-64z"
      })
    ]));
  }
});
var refrigerator_default = refrigerator_vue_vue_type_script_setup_true_lang_default;
var remove_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "RemoveFilled",
  __name: "remove-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896M288 512a38.4 38.4 0 0 0 38.4 38.4h371.2a38.4 38.4 0 0 0 0-76.8H326.4A38.4 38.4 0 0 0 288 512"
      })
    ]));
  }
});
var remove_filled_default = remove_filled_vue_vue_type_script_setup_true_lang_default;
var remove_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Remove",
  __name: "remove",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
});
var remove_default = remove_vue_vue_type_script_setup_true_lang_default;
var right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Right",
  __name: "right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M754.752 480H160a32 32 0 1 0 0 64h594.752L521.344 777.344a32 32 0 0 0 45.312 45.312l288-288a32 32 0 0 0 0-45.312l-288-288a32 32 0 1 0-45.312 45.312z"
      })
    ]));
  }
});
var right_default = right_vue_vue_type_script_setup_true_lang_default;
var scale_to_original_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ScaleToOriginal",
  __name: "scale-to-original",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M813.176 180.706a60.235 60.235 0 0 1 60.236 60.235v481.883a60.235 60.235 0 0 1-60.236 60.235H210.824a60.235 60.235 0 0 1-60.236-60.235V240.94a60.235 60.235 0 0 1 60.236-60.235h602.352zm0-60.235H210.824A120.47 120.47 0 0 0 90.353 240.94v481.883a120.47 120.47 0 0 0 120.47 120.47h602.353a120.47 120.47 0 0 0 120.471-120.47V240.94a120.47 120.47 0 0 0-120.47-120.47zm-120.47 180.705a30.118 30.118 0 0 0-30.118 30.118v301.177a30.118 30.118 0 0 0 60.236 0V331.294a30.118 30.118 0 0 0-30.118-30.118zm-361.412 0a30.118 30.118 0 0 0-30.118 30.118v301.177a30.118 30.118 0 1 0 60.236 0V331.294a30.118 30.118 0 0 0-30.118-30.118M512 361.412a30.118 30.118 0 0 0-30.118 30.117v30.118a30.118 30.118 0 0 0 60.236 0V391.53A30.118 30.118 0 0 0 512 361.412M512 512a30.118 30.118 0 0 0-30.118 30.118v30.117a30.118 30.118 0 0 0 60.236 0v-30.117A30.118 30.118 0 0 0 512 512"
      })
    ]));
  }
});
var scale_to_original_default = scale_to_original_vue_vue_type_script_setup_true_lang_default;
var school_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "School",
  __name: "school",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 128v704h576V128zm-32-64h640a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M64 832h896v64H64zm256-640h128v96H320z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 832h256v-64a128 128 0 1 0-256 0zm128-256a192 192 0 0 1 192 192v128H320V768a192 192 0 0 1 192-192M320 384h128v96H320zm256-192h128v96H576zm0 192h128v96H576z"
      })
    ]));
  }
});
var school_default = school_vue_vue_type_script_setup_true_lang_default;
var scissor_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Scissor",
  __name: "scissor",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m512.064 578.368-106.88 152.768a160 160 0 1 1-23.36-78.208L472.96 522.56 196.864 128.256a32 32 0 1 1 52.48-36.736l393.024 561.344a160 160 0 1 1-23.36 78.208l-106.88-152.704zm54.4-189.248 208.384-297.6a32 32 0 0 1 52.48 36.736l-221.76 316.672-39.04-55.808zm-376.32 425.856a96 96 0 1 0 110.144-157.248 96 96 0 0 0-110.08 157.248zm643.84 0a96 96 0 1 0-110.08-157.248 96 96 0 0 0 110.08 157.248"
      })
    ]));
  }
});
var scissor_default = scissor_vue_vue_type_script_setup_true_lang_default;
var search_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Search",
  __name: "search",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704"
      })
    ]));
  }
});
var search_default = search_vue_vue_type_script_setup_true_lang_default;
var select_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Select",
  __name: "select",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M77.248 415.04a64 64 0 0 1 90.496 0l226.304 226.304L846.528 188.8a64 64 0 1 1 90.56 90.496l-543.04 543.04-316.8-316.8a64 64 0 0 1 0-90.496z"
      })
    ]));
  }
});
var select_default = select_vue_vue_type_script_setup_true_lang_default;
var sell_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sell",
  __name: "sell",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 483.84L768 698.496V928a32 32 0 1 1-64 0V698.496l-73.344 73.344a32 32 0 1 1-45.248-45.248l128-128a32 32 0 0 1 45.248 0l128 128a32 32 0 1 1-45.248 45.248z"
      })
    ]));
  }
});
var sell_default = sell_vue_vue_type_script_setup_true_lang_default;
var semi_select_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SemiSelect",
  __name: "semi-select",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 448h768q64 0 64 64t-64 64H128q-64 0-64-64t64-64"
      })
    ]));
  }
});
var semi_select_default = semi_select_vue_vue_type_script_setup_true_lang_default;
var service_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Service",
  __name: "service",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M864 409.6a192 192 0 0 1-37.888 349.44A256.064 256.064 0 0 1 576 960h-96a32 32 0 1 1 0-64h96a192.064 192.064 0 0 0 181.12-128H736a32 32 0 0 1-32-32V416a32 32 0 0 1 32-32h32c10.368 0 20.544.832 30.528 2.432a288 288 0 0 0-573.056 0A193.235 193.235 0 0 1 256 384h32a32 32 0 0 1 32 32v320a32 32 0 0 1-32 32h-32a192 192 0 0 1-96-358.4 352 352 0 0 1 704 0M256 448a128 128 0 1 0 0 256zm640 128a128 128 0 0 0-128-128v256a128 128 0 0 0 128-128"
      })
    ]));
  }
});
var service_default = service_vue_vue_type_script_setup_true_lang_default;
var set_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SetUp",
  __name: "set-up",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 160a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V224a64 64 0 0 0-64-64zm0-64h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V224A128 128 0 0 1 224 96"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 320h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32m160 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 640h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});
var set_up_default = set_up_vue_vue_type_script_setup_true_lang_default;
var setting_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Setting",
  __name: "setting",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M600.704 64a32 32 0 0 1 30.464 22.208l35.2 109.376c14.784 7.232 28.928 15.36 42.432 24.512l112.384-24.192a32 32 0 0 1 34.432 15.36L944.32 364.8a32 32 0 0 1-4.032 37.504l-77.12 85.12a357.12 357.12 0 0 1 0 49.024l77.12 85.248a32 32 0 0 1 4.032 37.504l-88.704 153.6a32 32 0 0 1-34.432 15.296L708.8 803.904c-13.44 9.088-27.648 17.28-42.368 24.512l-35.264 109.376A32 32 0 0 1 600.704 960H423.296a32 32 0 0 1-30.464-22.208L357.696 828.48a351.616 351.616 0 0 1-42.56-24.64l-112.32 24.256a32 32 0 0 1-34.432-15.36L79.68 659.2a32 32 0 0 1 4.032-37.504l77.12-85.248a357.12 357.12 0 0 1 0-48.896l-77.12-85.248A32 32 0 0 1 79.68 364.8l88.704-153.6a32 32 0 0 1 34.432-15.296l112.32 24.256c13.568-9.152 27.776-17.408 42.56-24.64l35.2-109.312A32 32 0 0 1 423.232 64H600.64zm-23.424 64H446.72l-36.352 113.088-24.512 11.968a294.113 294.113 0 0 0-34.816 20.096l-22.656 15.36-116.224-25.088-65.28 113.152 79.68 88.192-1.92 27.136a293.12 293.12 0 0 0 0 40.192l1.92 27.136-79.808 88.192 65.344 113.152 116.224-25.024 22.656 15.296a294.113 294.113 0 0 0 34.816 20.096l24.512 11.968L446.72 896h130.688l36.48-113.152 24.448-11.904a288.282 288.282 0 0 0 34.752-20.096l22.592-15.296 116.288 25.024 65.28-113.152-79.744-88.192 1.92-27.136a293.12 293.12 0 0 0 0-40.256l-1.92-27.136 79.808-88.128-65.344-113.152-116.288 24.96-22.592-15.232a287.616 287.616 0 0 0-34.752-20.096l-24.448-11.904L577.344 128zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384m0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256"
      })
    ]));
  }
});
var setting_default = setting_vue_vue_type_script_setup_true_lang_default;
var share_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Share",
  __name: "share",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m679.872 348.8-301.76 188.608a127.808 127.808 0 0 1 5.12 52.16l279.936 104.96a128 128 0 1 1-22.464 59.904l-279.872-104.96a128 128 0 1 1-16.64-166.272l301.696-188.608a128 128 0 1 1 33.92 54.272z"
      })
    ]));
  }
});
var share_default = share_vue_vue_type_script_setup_true_lang_default;
var ship_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Ship",
  __name: "ship",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 386.88V448h405.568a32 32 0 0 1 30.72 40.768l-76.48 267.968A192 192 0 0 1 687.168 896H336.832a192 192 0 0 1-184.64-139.264L75.648 488.768A32 32 0 0 1 106.368 448H448V117.888a32 32 0 0 1 47.36-28.096l13.888 7.616L512 96v2.88l231.68 126.4a32 32 0 0 1-2.048 57.216zm0-70.272 144.768-65.792L512 171.84zM512 512H148.864l18.24 64H856.96l18.24-64zM185.408 640l28.352 99.2A128 128 0 0 0 336.832 832h350.336a128 128 0 0 0 123.072-92.8l28.352-99.2H185.408"
      })
    ]));
  }
});
var ship_default = ship_vue_vue_type_script_setup_true_lang_default;
var shop_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Shop",
  __name: "shop",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 704h64v192H256V704h64v64h384zm188.544-152.192C894.528 559.616 896 567.616 896 576a96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0c0-8.384 1.408-16.384 3.392-24.192L192 128h640z"
      })
    ]));
  }
});
var shop_default = shop_vue_vue_type_script_setup_true_lang_default;
var shopping_bag_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ShoppingBag",
  __name: "shopping-bag",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 320v96a32 32 0 0 1-32 32h-32V320H384v128h-32a32 32 0 0 1-32-32v-96H192v576h640V320zm-384-64a192 192 0 1 1 384 0h160a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zm64 0h256a128 128 0 1 0-256 0"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 704h640v64H192z"
      })
    ]));
  }
});
var shopping_bag_default = shopping_bag_vue_vue_type_script_setup_true_lang_default;
var shopping_cart_full_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ShoppingCartFull",
  __name: "shopping-cart-full",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44l76.8 384z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M699.648 256 608 145.984 516.352 256h183.296zm-140.8-151.04a64 64 0 0 1 98.304 0L836.352 320H379.648l179.2-215.04"
      })
    ]));
  }
});
var shopping_cart_full_default = shopping_cart_full_vue_vue_type_script_setup_true_lang_default;
var shopping_cart_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ShoppingCart",
  __name: "shopping-cart",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44l76.8 384z"
      })
    ]));
  }
});
var shopping_cart_default = shopping_cart_vue_vue_type_script_setup_true_lang_default;
var shopping_trolley_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ShoppingTrolley",
  __name: "shopping-trolley",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M368 833c-13.3 0-24.5 4.5-33.5 13.5S321 866.7 321 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S415 893.3 415 880s-4.5-24.5-13.5-33.5S381.3 833 368 833m439-193c7.4 0 13.8-2.2 19.5-6.5S836 623.3 838 616l112-448c2-10-.2-19.2-6.5-27.5S929 128 919 128H96c-9.3 0-17 3-23 9s-9 13.7-9 23 3 17 9 23 13.7 9 23 9h96v576h672c9.3 0 17-3 23-9s9-13.7 9-23-3-17-9-23-13.7-9-23-9H256v-64zM256 192h622l-96 384H256zm432 641c-13.3 0-24.5 4.5-33.5 13.5S641 866.7 641 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S735 893.3 735 880s-4.5-24.5-13.5-33.5S701.3 833 688 833"
      })
    ]));
  }
});
var shopping_trolley_default = shopping_trolley_vue_vue_type_script_setup_true_lang_default;
var smoking_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Smoking",
  __name: "smoking",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 576v128h640V576zm-32-64h704a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 576h64v128h-64zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
      })
    ]));
  }
});
var smoking_default = smoking_vue_vue_type_script_setup_true_lang_default;
var soccer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Soccer",
  __name: "soccer",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M418.496 871.04 152.256 604.8c-16.512 94.016-2.368 178.624 42.944 224 44.928 44.928 129.344 58.752 223.296 42.24m72.32-18.176a573.056 573.056 0 0 0 224.832-137.216 573.12 573.12 0 0 0 137.216-224.832L533.888 171.84a578.56 578.56 0 0 0-227.52 138.496A567.68 567.68 0 0 0 170.432 532.48l320.384 320.384zM871.04 418.496c16.512-93.952 2.688-178.368-42.24-223.296-44.544-44.544-128.704-58.048-222.592-41.536zM149.952 874.048c-112.96-112.96-88.832-408.96 111.168-608.96C461.056 65.152 760.96 36.928 874.048 149.952c113.024 113.024 86.784 411.008-113.152 610.944-199.936 199.936-497.92 226.112-610.944 113.152m452.544-497.792 22.656-22.656a32 32 0 0 1 45.248 45.248l-22.656 22.656 45.248 45.248A32 32 0 1 1 647.744 512l-45.248-45.248L557.248 512l45.248 45.248a32 32 0 1 1-45.248 45.248L512 557.248l-45.248 45.248L512 647.744a32 32 0 1 1-45.248 45.248l-45.248-45.248-22.656 22.656a32 32 0 1 1-45.248-45.248l22.656-22.656-45.248-45.248A32 32 0 1 1 376.256 512l45.248 45.248L466.752 512l-45.248-45.248a32 32 0 1 1 45.248-45.248L512 466.752l45.248-45.248L512 376.256a32 32 0 0 1 45.248-45.248l45.248 45.248z"
      })
    ]));
  }
});
var soccer_default = soccer_vue_vue_type_script_setup_true_lang_default;
var sold_out_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SoldOut",
  __name: "sold-out",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 476.16a32 32 0 1 1 45.248 45.184l-128 128a32 32 0 0 1-45.248 0l-128-128a32 32 0 1 1 45.248-45.248L704 837.504V608a32 32 0 1 1 64 0v229.504l73.408-73.408z"
      })
    ]));
  }
});
var sold_out_default = sold_out_vue_vue_type_script_setup_true_lang_default;
var sort_down_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SortDown",
  __name: "sort-down",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M576 96v709.568L333.312 562.816A32 32 0 1 0 288 608l297.408 297.344A32 32 0 0 0 640 882.688V96a32 32 0 0 0-64 0"
      })
    ]));
  }
});
var sort_down_default = sort_down_vue_vue_type_script_setup_true_lang_default;
var sort_up_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SortUp",
  __name: "sort-up",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 141.248V928a32 32 0 1 0 64 0V218.56l242.688 242.688A32 32 0 1 0 736 416L438.592 118.656A32 32 0 0 0 384 141.248"
      })
    ]));
  }
});
var sort_up_default = sort_up_vue_vue_type_script_setup_true_lang_default;
var sort_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sort",
  __name: "sort",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 96a32 32 0 0 1 64 0v786.752a32 32 0 0 1-54.592 22.656L95.936 608a32 32 0 0 1 0-45.312h.128a32 32 0 0 1 45.184 0L384 805.632zm192 45.248a32 32 0 0 1 54.592-22.592L928.064 416a32 32 0 0 1 0 45.312h-.128a32 32 0 0 1-45.184 0L640 218.496V928a32 32 0 1 1-64 0V141.248z"
      })
    ]));
  }
});
var sort_default = sort_vue_vue_type_script_setup_true_lang_default;
var stamp_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Stamp",
  __name: "stamp",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M624 475.968V640h144a128 128 0 0 1 128 128H128a128 128 0 0 1 128-128h144V475.968a192 192 0 1 1 224 0M128 896v-64h768v64z"
      })
    ]));
  }
});
var stamp_default = stamp_vue_vue_type_script_setup_true_lang_default;
var star_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "StarFilled",
  __name: "star-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M283.84 867.84 512 747.776l228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72z"
      })
    ]));
  }
});
var star_filled_default = star_filled_vue_vue_type_script_setup_true_lang_default;
var star_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Star",
  __name: "star",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m512 747.84 228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72zM313.6 924.48a70.4 70.4 0 0 1-102.144-74.24l37.888-220.928L88.96 472.96A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 126.208 0l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z"
      })
    ]));
  }
});
var star_default = star_vue_vue_type_script_setup_true_lang_default;
var stopwatch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Stopwatch",
  __name: "stopwatch",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M672 234.88c-39.168 174.464-80 298.624-122.688 372.48-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
      })
    ]));
  }
});
var stopwatch_default = stopwatch_vue_vue_type_script_setup_true_lang_default;
var success_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SuccessFilled",
  __name: "success-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
      })
    ]));
  }
});
var success_filled_default = success_filled_vue_vue_type_script_setup_true_lang_default;
var sugar_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sugar",
  __name: "sugar",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m801.728 349.184 4.48 4.48a128 128 0 0 1 0 180.992L534.656 806.144a128 128 0 0 1-181.056 0l-4.48-4.48-19.392 109.696a64 64 0 0 1-108.288 34.176L78.464 802.56a64 64 0 0 1 34.176-108.288l109.76-19.328-4.544-4.544a128 128 0 0 1 0-181.056l271.488-271.488a128 128 0 0 1 181.056 0l4.48 4.48 19.392-109.504a64 64 0 0 1 108.352-34.048l142.592 143.04a64 64 0 0 1-34.24 108.16l-109.248 19.2zm-548.8 198.72h447.168v2.24l60.8-60.8a63.808 63.808 0 0 0 18.752-44.416h-426.88l-89.664 89.728a64.064 64.064 0 0 0-10.24 13.248zm0 64c2.752 4.736 6.144 9.152 10.176 13.248l135.744 135.744a64 64 0 0 0 90.496 0L638.4 611.904zm490.048-230.976L625.152 263.104a64 64 0 0 0-90.496 0L416.768 380.928zM123.712 757.312l142.976 142.976 24.32-137.6a25.6 25.6 0 0 0-29.696-29.632l-137.6 24.256zm633.6-633.344-24.32 137.472a25.6 25.6 0 0 0 29.632 29.632l137.28-24.064-142.656-143.04z"
      })
    ]));
  }
});
var sugar_default = sugar_vue_vue_type_script_setup_true_lang_default;
var suitcase_line_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SuitcaseLine",
  __name: "suitcase-line",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M922.5 229.5c-24.32-24.34-54.49-36.84-90.5-37.5H704v-64c-.68-17.98-7.02-32.98-19.01-44.99S658.01 64.66 640 64H384c-17.98.68-32.98 7.02-44.99 19.01S320.66 110 320 128v64H192c-35.99.68-66.16 13.18-90.5 37.5C77.16 253.82 64.66 283.99 64 320v448c.68 35.99 13.18 66.16 37.5 90.5s54.49 36.84 90.5 37.5h640c35.99-.68 66.16-13.18 90.5-37.5s36.84-54.49 37.5-90.5V320c-.68-35.99-13.18-66.16-37.5-90.5M384 128h256v64H384zM256 832h-64c-17.98-.68-32.98-7.02-44.99-19.01S128.66 786.01 128 768V448h128zm448 0H320V448h384zm192-64c-.68 17.98-7.02 32.98-19.01 44.99S850.01 831.34 832 832h-64V448h128zm0-384H128v-64c.69-17.98 7.02-32.98 19.01-44.99S173.99 256.66 192 256h640c17.98.69 32.98 7.02 44.99 19.01S895.34 301.99 896 320z"
      })
    ]));
  }
});
var suitcase_line_default = suitcase_line_vue_vue_type_script_setup_true_lang_default;
var suitcase_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Suitcase",
  __name: "suitcase",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M384 128v64h256v-64zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64"
      })
    ]));
  }
});
var suitcase_default = suitcase_vue_vue_type_script_setup_true_lang_default;
var sunny_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sunny",
  __name: "sunny",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0zm543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0"
      })
    ]));
  }
});
var sunny_default = sunny_vue_vue_type_script_setup_true_lang_default;
var sunrise_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sunrise",
  __name: "sunrise",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M32 768h960a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64m129.408-96a352 352 0 0 1 701.184 0h-64.32a288 288 0 0 0-572.544 0h-64.32zM512 128a32 32 0 0 1 32 32v96a32 32 0 0 1-64 0v-96a32 32 0 0 1 32-32m407.296 168.704a32 32 0 0 1 0 45.248l-67.84 67.84a32 32 0 1 1-45.248-45.248l67.84-67.84a32 32 0 0 1 45.248 0zm-814.592 0a32 32 0 0 1 45.248 0l67.84 67.84a32 32 0 1 1-45.248 45.248l-67.84-67.84a32 32 0 0 1 0-45.248"
      })
    ]));
  }
});
var sunrise_default = sunrise_vue_vue_type_script_setup_true_lang_default;
var sunset_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Sunset",
  __name: "sunset",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M82.56 640a448 448 0 1 1 858.88 0h-67.2a384 384 0 1 0-724.288 0zM32 704h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m256 128h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
      })
    ]));
  }
});
var sunset_default = sunset_vue_vue_type_script_setup_true_lang_default;
var switch_button_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SwitchButton",
  __name: "switch-button",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32"
      })
    ]));
  }
});
var switch_button_default = switch_button_vue_vue_type_script_setup_true_lang_default;
var switch_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "SwitchFilled",
  __name: "switch-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M247.47 358.4v.04c.07 19.17 7.72 37.53 21.27 51.09s31.92 21.2 51.09 21.27c39.86 0 72.41-32.6 72.41-72.4s-32.6-72.36-72.41-72.36-72.36 32.55-72.36 72.36z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M492.38 128H324.7c-52.16 0-102.19 20.73-139.08 57.61a196.655 196.655 0 0 0-57.61 139.08V698.7c-.01 25.84 5.08 51.42 14.96 75.29s24.36 45.56 42.63 63.83 39.95 32.76 63.82 42.65a196.67 196.67 0 0 0 75.28 14.98h167.68c3.03 0 5.46-2.43 5.46-5.42V133.42c.6-2.99-1.83-5.42-5.46-5.42zm-56.11 705.88H324.7c-17.76.13-35.36-3.33-51.75-10.18s-31.22-16.94-43.61-29.67c-25.3-25.35-39.81-59.1-39.81-95.32V324.69c-.13-17.75 3.33-35.35 10.17-51.74a131.695 131.695 0 0 1 29.64-43.62c25.39-25.3 59.14-39.81 95.36-39.81h111.57zm402.12-647.67a196.655 196.655 0 0 0-139.08-57.61H580.48c-3.03 0-4.82 2.43-4.82 4.82v757.16c-.6 2.99 1.79 5.42 5.42 5.42h118.23a196.69 196.69 0 0 0 139.08-57.61A196.655 196.655 0 0 0 896 699.31V325.29a196.69 196.69 0 0 0-57.61-139.08zm-111.3 441.92c-42.83 0-77.82-34.99-77.82-77.82s34.98-77.82 77.82-77.82c42.83 0 77.82 34.99 77.82 77.82s-34.99 77.82-77.82 77.82z"
      })
    ]));
  }
});
var switch_filled_default = switch_filled_vue_vue_type_script_setup_true_lang_default;
var switch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Switch",
  __name: "switch",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M118.656 438.656a32 32 0 0 1 0-45.248L416 96l4.48-3.776A32 32 0 0 1 461.248 96l3.712 4.48a32.064 32.064 0 0 1-3.712 40.832L218.56 384H928a32 32 0 1 1 0 64H141.248a32 32 0 0 1-22.592-9.344zM64 608a32 32 0 0 1 32-32h786.752a32 32 0 0 1 22.656 54.592L608 928l-4.48 3.776a32.064 32.064 0 0 1-40.832-49.024L805.632 640H96a32 32 0 0 1-32-32"
      })
    ]));
  }
});
var switch_default = switch_vue_vue_type_script_setup_true_lang_default;
var takeaway_box_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TakeawayBox",
  __name: "takeaway-box",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M832 384H192v448h640zM96 320h832V128H96zm800 64v480a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V384H64a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h896a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zM416 512h192a32 32 0 0 1 0 64H416a32 32 0 0 1 0-64"
      })
    ]));
  }
});
var takeaway_box_default = takeaway_box_vue_vue_type_script_setup_true_lang_default;
var ticket_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Ticket",
  __name: "ticket",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 832H64V640a128 128 0 1 0 0-256V192h576v160h64V192h256v192a128 128 0 1 0 0 256v192H704V672h-64zm0-416v192h64V416z"
      })
    ]));
  }
});
var ticket_default = ticket_vue_vue_type_script_setup_true_lang_default;
var tickets_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Tickets",
  __name: "tickets",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h192v64H320zm0 384h384v64H320z"
      })
    ]));
  }
});
var tickets_default = tickets_vue_vue_type_script_setup_true_lang_default;
var timer_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Timer",
  __name: "timer",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 896a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 320a32 32 0 0 1 32 32l-.512 224a32 32 0 1 1-64 0L480 352a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M448 576a64 64 0 1 0 128 0 64 64 0 1 0-128 0m96-448v128h-64V128h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64z"
      })
    ]));
  }
});
var timer_default = timer_vue_vue_type_script_setup_true_lang_default;
var toilet_paper_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ToiletPaper",
  __name: "toilet-paper",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M595.2 128H320a192 192 0 0 0-192 192v576h384V352c0-90.496 32.448-171.2 83.2-224M736 64c123.712 0 224 128.96 224 288S859.712 640 736 640H576v320H64V320A256 256 0 0 1 320 64zM576 352v224h160c84.352 0 160-97.28 160-224s-75.648-224-160-224-160 97.28-160 224"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M736 448c-35.328 0-64-43.008-64-96s28.672-96 64-96 64 43.008 64 96-28.672 96-64 96"
      })
    ]));
  }
});
var toilet_paper_default = toilet_paper_vue_vue_type_script_setup_true_lang_default;
var tools_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Tools",
  __name: "tools",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M764.416 254.72a351.68 351.68 0 0 1 86.336 149.184H960v192.064H850.752a351.68 351.68 0 0 1-86.336 149.312l54.72 94.72-166.272 96-54.592-94.72a352.64 352.64 0 0 1-172.48 0L371.136 936l-166.272-96 54.72-94.72a351.68 351.68 0 0 1-86.336-149.312H64v-192h109.248a351.68 351.68 0 0 1 86.336-149.312L204.8 160l166.208-96h.192l54.656 94.592a352.64 352.64 0 0 1 172.48 0L652.8 64h.128L819.2 160l-54.72 94.72zM704 499.968a192 192 0 1 0-384 0 192 192 0 0 0 384 0"
      })
    ]));
  }
});
var tools_default = tools_vue_vue_type_script_setup_true_lang_default;
var top_left_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TopLeft",
  __name: "top-left",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M256 256h416a32 32 0 1 0 0-64H224a32 32 0 0 0-32 32v448a32 32 0 0 0 64 0z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M246.656 201.344a32 32 0 0 0-45.312 45.312l544 544a32 32 0 0 0 45.312-45.312l-544-544z"
      })
    ]));
  }
});
var top_left_default = top_left_vue_vue_type_script_setup_true_lang_default;
var top_right_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TopRight",
  __name: "top-right",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M768 256H353.6a32 32 0 1 1 0-64H800a32 32 0 0 1 32 32v448a32 32 0 0 1-64 0z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M777.344 201.344a32 32 0 0 1 45.312 45.312l-544 544a32 32 0 0 1-45.312-45.312l544-544z"
      })
    ]));
  }
});
var top_right_default = top_right_vue_vue_type_script_setup_true_lang_default;
var top_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Top",
  __name: "top",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M572.235 205.282v600.365a30.118 30.118 0 1 1-60.235 0V205.282L292.382 438.633a28.913 28.913 0 0 1-42.646 0 33.43 33.43 0 0 1 0-45.236l271.058-288.045a28.913 28.913 0 0 1 42.647 0L834.5 393.397a33.43 33.43 0 0 1 0 45.176 28.913 28.913 0 0 1-42.647 0l-219.618-233.23z"
      })
    ]));
  }
});
var top_default = top_vue_vue_type_script_setup_true_lang_default;
var trend_charts_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TrendCharts",
  __name: "trend-charts",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 896V128h768v768zm291.712-327.296 128 102.4 180.16-201.792-47.744-42.624-139.84 156.608-128-102.4-180.16 201.792 47.744 42.624 139.84-156.608zM816 352a48 48 0 1 0-96 0 48 48 0 0 0 96 0"
      })
    ]));
  }
});
var trend_charts_default = trend_charts_vue_vue_type_script_setup_true_lang_default;
var trophy_base_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TrophyBase",
  __name: "trophy-base",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M918.4 201.6c-6.4-6.4-12.8-9.6-22.4-9.6H768V96c0-9.6-3.2-16-9.6-22.4C752 67.2 745.6 64 736 64H288c-9.6 0-16 3.2-22.4 9.6C259.2 80 256 86.4 256 96v96H128c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 16-9.6 22.4 3.2 108.8 25.6 185.6 64 224 34.4 34.4 77.56 55.65 127.65 61.99 10.91 20.44 24.78 39.25 41.95 56.41 40.86 40.86 91 65.47 150.4 71.9V768h-96c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4c6.4 6.4 12.8 9.6 22.4 9.6h256c9.6 0 16-3.2 22.4-9.6 6.4-6.4 9.6-12.8 9.6-22.4s-3.2-16-9.6-22.4c-6.4-6.4-12.8-9.6-22.4-9.6h-96V637.26c59.4-7.71 109.54-30.01 150.4-70.86 17.2-17.2 31.51-36.06 42.81-56.55 48.93-6.51 90.02-27.7 126.79-61.85 38.4-38.4 60.8-112 64-224 0-6.4-3.2-16-9.6-22.4zM256 438.4c-19.2-6.4-35.2-19.2-51.2-35.2-22.4-22.4-35.2-70.4-41.6-147.2H256zm390.4 80C608 553.6 566.4 576 512 576s-99.2-19.2-134.4-57.6C342.4 480 320 438.4 320 384V128h384v256c0 54.4-19.2 99.2-57.6 134.4m172.8-115.2c-16 16-32 25.6-51.2 35.2V256h92.8c-6.4 76.8-19.2 124.8-41.6 147.2zM768 896H256c-9.6 0-16 3.2-22.4 9.6-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4c6.4 6.4 12.8 9.6 22.4 9.6h512c9.6 0 16-3.2 22.4-9.6 6.4-6.4 9.6-12.8 9.6-22.4s-3.2-16-9.6-22.4c-6.4-6.4-12.8-9.6-22.4-9.6"
      })
    ]));
  }
});
var trophy_base_default = trophy_base_vue_vue_type_script_setup_true_lang_default;
var trophy_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Trophy",
  __name: "trophy",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 896V702.08A256.256 256.256 0 0 1 264.064 512h-32.64a96 96 0 0 1-91.968-68.416L93.632 290.88a76.8 76.8 0 0 1 73.6-98.88H256V96a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v96h88.768a76.8 76.8 0 0 1 73.6 98.88L884.48 443.52A96 96 0 0 1 792.576 512h-32.64A256.256 256.256 0 0 1 544 702.08V896h128a32 32 0 1 1 0 64H352a32 32 0 1 1 0-64zm224-448V128H320v320a192 192 0 1 0 384 0m64 0h24.576a32 32 0 0 0 30.656-22.784l45.824-152.768A12.8 12.8 0 0 0 856.768 256H768zm-512 0V256h-88.768a12.8 12.8 0 0 0-12.288 16.448l45.824 152.768A32 32 0 0 0 231.424 448z"
      })
    ]));
  }
});
var trophy_default = trophy_vue_vue_type_script_setup_true_lang_default;
var turn_off_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "TurnOff",
  __name: "turn-off",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M329.956 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
      })
    ]));
  }
});
var turn_off_default = turn_off_vue_vue_type_script_setup_true_lang_default;
var umbrella_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Umbrella",
  __name: "umbrella",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M320 768a32 32 0 1 1 64 0 64 64 0 0 0 128 0V512H64a448 448 0 1 1 896 0H576v256a128 128 0 1 1-256 0m570.688-320a384.128 384.128 0 0 0-757.376 0z"
      })
    ]));
  }
});
var umbrella_default = umbrella_vue_vue_type_script_setup_true_lang_default;
var unlock_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Unlock",
  __name: "unlock",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m178.304-295.296A192.064 192.064 0 0 0 320 320v64h352l96 38.4V448H256V320a256 256 0 0 1 493.76-95.104z"
      })
    ]));
  }
});
var unlock_default = unlock_vue_vue_type_script_setup_true_lang_default;
var upload_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "UploadFilled",
  __name: "upload-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M544 864V672h128L512 480 352 672h128v192H320v-1.6c-5.376.32-10.496 1.6-16 1.6A240 240 0 0 1 64 624c0-123.136 93.12-223.488 212.608-237.248A239.808 239.808 0 0 1 512 192a239.872 239.872 0 0 1 235.456 194.752c119.488 13.76 212.48 114.112 212.48 237.248a240 240 0 0 1-240 240c-5.376 0-10.56-1.28-16-1.6v1.6z"
      })
    ]));
  }
});
var upload_filled_default = upload_filled_vue_vue_type_script_setup_true_lang_default;
var upload_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Upload",
  __name: "upload",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-578.304V704h-64V247.296L237.248 490.048 192 444.8 508.8 128l316.8 316.8-45.312 45.248z"
      })
    ]));
  }
});
var upload_default = upload_vue_vue_type_script_setup_true_lang_default;
var user_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "UserFilled",
  __name: "user-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0m544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"
      })
    ]));
  }
});
var user_filled_default = user_filled_vue_vue_type_script_setup_true_lang_default;
var user_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "User",
  __name: "user",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0"
      })
    ]));
  }
});
var user_default = user_vue_vue_type_script_setup_true_lang_default;
var van_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Van",
  __name: "van",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128.896 736H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v96h164.544a32 32 0 0 1 31.616 27.136l54.144 352A32 32 0 0 1 922.688 736h-91.52a144 144 0 1 1-286.272 0H415.104a144 144 0 1 1-286.272 0zm23.36-64a143.872 143.872 0 0 1 239.488 0H568.32c17.088-25.6 42.24-45.376 71.744-55.808V256H128v416zm655.488 0h77.632l-19.648-128H704v64.896A144 144 0 0 1 807.744 672m48.128-192-14.72-96H704v96h151.872M688 832a80 80 0 1 0 0-160 80 80 0 0 0 0 160m-416 0a80 80 0 1 0 0-160 80 80 0 0 0 0 160"
      })
    ]));
  }
});
var van_default = van_vue_vue_type_script_setup_true_lang_default;
var video_camera_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "VideoCameraFilled",
  __name: "video-camera-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m768 576 192-64v320l-192-64v96a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V480a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zM192 768v64h384v-64zm192-480a160 160 0 0 1 320 0 160 160 0 0 1-320 0m64 0a96 96 0 1 0 192.064-.064A96 96 0 0 0 448 288m-320 32a128 128 0 1 1 256.064.064A128 128 0 0 1 128 320m64 0a64 64 0 1 0 128 0 64 64 0 0 0-128 0"
      })
    ]));
  }
});
var video_camera_filled_default = video_camera_filled_vue_vue_type_script_setup_true_lang_default;
var video_camera_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "VideoCamera",
  __name: "video-camera",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 768V256H128v512zm64-416 192-96v512l-192-96v128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 71.552v176.896l128 64V359.552zM192 320h192v64H192z"
      })
    ]));
  }
});
var video_camera_default = video_camera_vue_vue_type_script_setup_true_lang_default;
var video_pause_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "VideoPause",
  __name: "video-pause",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-96-544q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32m192 0q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32"
      })
    ]));
  }
});
var video_pause_default = video_pause_vue_vue_type_script_setup_true_lang_default;
var video_play_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "VideoPlay",
  __name: "video-play",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.616L668.608 512 464 375.616zm10.624-342.656 249.472 166.336a48 48 0 0 1 0 79.872L474.624 718.272A48 48 0 0 1 400 678.336V345.6a48 48 0 0 1 74.624-39.936z"
      })
    ]));
  }
});
var video_play_default = video_play_vue_vue_type_script_setup_true_lang_default;
var view_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "View",
  __name: "view",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160"
      })
    ]));
  }
});
var view_default = view_vue_vue_type_script_setup_true_lang_default;
var wallet_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "WalletFilled",
  __name: "wallet-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M688 512a112 112 0 1 0 0 224h208v160H128V352h768v160zm32 160h-32a48 48 0 0 1 0-96h32a48 48 0 0 1 0 96m-80-544 128 160H384z"
      })
    ]));
  }
});
var wallet_filled_default = wallet_filled_vue_vue_type_script_setup_true_lang_default;
var wallet_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Wallet",
  __name: "wallet",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M640 288h-64V128H128v704h384v32a32 32 0 0 0 32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32z"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M128 320v512h768V320zm-32-64h832a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M704 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
      })
    ]));
  }
});
var wallet_default = wallet_vue_vue_type_script_setup_true_lang_default;
var warn_triangle_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "WarnTriangleFilled",
  __name: "warn-triangle-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "xml:space": "preserve",
      style: { "enable-background": "new 0 0 1024 1024" },
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M928.99 755.83 574.6 203.25c-12.89-20.16-36.76-32.58-62.6-32.58s-49.71 12.43-62.6 32.58L95.01 755.83c-12.91 20.12-12.9 44.91.01 65.03 12.92 20.12 36.78 32.51 62.59 32.49h708.78c25.82.01 49.68-12.37 62.59-32.49 12.91-20.12 12.92-44.91.01-65.03M554.67 768h-85.33v-85.33h85.33zm0-426.67v298.66h-85.33V341.32z"
      })
    ]));
  }
});
var warn_triangle_filled_default = warn_triangle_filled_vue_vue_type_script_setup_true_lang_default;
var warning_filled_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "WarningFilled",
  __name: "warning-filled",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256m0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4"
      })
    ]));
  }
});
var warning_filled_default = warning_filled_vue_vue_type_script_setup_true_lang_default;
var warning_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Warning",
  __name: "warning",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0 48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
      })
    ]));
  }
});
var warning_default = warning_vue_vue_type_script_setup_true_lang_default;
var watch_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Watch",
  __name: "watch",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M512 768a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 352a32 32 0 0 1 32 32v160a32 32 0 0 1-64 0V384a32 32 0 0 1 32-32"
      }),
      createElementVNode("path", {
        fill: "currentColor",
        d: "M480 512h128q32 0 32 32t-32 32H480q-32 0-32-32t32-32m128-256V128H416v128h-64V64h320v192zM416 768v128h192V768h64v192H352V768z"
      })
    ]));
  }
});
var watch_default = watch_vue_vue_type_script_setup_true_lang_default;
var watermelon_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "Watermelon",
  __name: "watermelon",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m683.072 600.32-43.648 162.816-61.824-16.512 53.248-198.528L576 493.248l-158.4 158.4-45.248-45.248 158.4-158.4-55.616-55.616-198.528 53.248-16.512-61.824 162.816-43.648L282.752 200A384 384 0 0 0 824 741.248zm231.552 141.056a448 448 0 1 1-632-632l632 632"
      })
    ]));
  }
});
var watermelon_default = watermelon_vue_vue_type_script_setup_true_lang_default;
var wind_power_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "WindPower",
  __name: "wind-power",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "M160 64q32 0 32 32v832q0 32-32 32t-32-32V96q0-32 32-32m416 354.624 128-11.584V168.96l-128-11.52v261.12zm-64 5.824V151.552L320 134.08V160h-64V64l616.704 56.064A96 96 0 0 1 960 215.68v144.64a96 96 0 0 1-87.296 95.616L256 512V224h64v217.92zm256-23.232 98.88-8.96A32 32 0 0 0 896 360.32V215.68a32 32 0 0 0-29.12-31.872l-98.88-8.96z"
      })
    ]));
  }
});
var wind_power_default = wind_power_vue_vue_type_script_setup_true_lang_default;
var zoom_in_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ZoomIn",
  __name: "zoom-in",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704m-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64z"
      })
    ]));
  }
});
var zoom_in_default = zoom_in_vue_vue_type_script_setup_true_lang_default;
var zoom_out_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
  name: "ZoomOut",
  __name: "zoom-out",
  setup(__props) {
    return (_ctx, _cache) => (openBlock(), createElementBlock("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      createElementVNode("path", {
        fill: "currentColor",
        d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704M352 448h256a32 32 0 0 1 0 64H352a32 32 0 0 1 0-64"
      })
    ]));
  }
});
var zoom_out_default = zoom_out_vue_vue_type_script_setup_true_lang_default;
const ElementPlusIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AddLocation: add_location_default,
  Aim: aim_default,
  AlarmClock: alarm_clock_default,
  Apple: apple_default,
  ArrowDown: arrow_down_default,
  ArrowDownBold: arrow_down_bold_default,
  ArrowLeft: arrow_left_default,
  ArrowLeftBold: arrow_left_bold_default,
  ArrowRight: arrow_right_default,
  ArrowRightBold: arrow_right_bold_default,
  ArrowUp: arrow_up_default,
  ArrowUpBold: arrow_up_bold_default,
  Avatar: avatar_default,
  Back: back_default,
  Baseball: baseball_default,
  Basketball: basketball_default,
  Bell: bell_default,
  BellFilled: bell_filled_default,
  Bicycle: bicycle_default,
  Bottom: bottom_default,
  BottomLeft: bottom_left_default,
  BottomRight: bottom_right_default,
  Bowl: bowl_default,
  Box: box_default,
  Briefcase: briefcase_default,
  Brush: brush_default,
  BrushFilled: brush_filled_default,
  Burger: burger_default,
  Calendar: calendar_default,
  Camera: camera_default,
  CameraFilled: camera_filled_default,
  CaretBottom: caret_bottom_default,
  CaretLeft: caret_left_default,
  CaretRight: caret_right_default,
  CaretTop: caret_top_default,
  Cellphone: cellphone_default,
  ChatDotRound: chat_dot_round_default,
  ChatDotSquare: chat_dot_square_default,
  ChatLineRound: chat_line_round_default,
  ChatLineSquare: chat_line_square_default,
  ChatRound: chat_round_default,
  ChatSquare: chat_square_default,
  Check: check_default,
  Checked: checked_default,
  Cherry: cherry_default,
  Chicken: chicken_default,
  ChromeFilled: chrome_filled_default,
  CircleCheck: circle_check_default,
  CircleCheckFilled: circle_check_filled_default,
  CircleClose: circle_close_default,
  CircleCloseFilled: circle_close_filled_default,
  CirclePlus: circle_plus_default,
  CirclePlusFilled: circle_plus_filled_default,
  Clock: clock_default,
  Close: close_default,
  CloseBold: close_bold_default,
  Cloudy: cloudy_default,
  Coffee: coffee_default,
  CoffeeCup: coffee_cup_default,
  Coin: coin_default,
  ColdDrink: cold_drink_default,
  Collection: collection_default,
  CollectionTag: collection_tag_default,
  Comment: comment_default,
  Compass: compass_default,
  Connection: connection_default,
  Coordinate: coordinate_default,
  CopyDocument: copy_document_default,
  Cpu: cpu_default,
  CreditCard: credit_card_default,
  Crop: crop_default,
  DArrowLeft: d_arrow_left_default,
  DArrowRight: d_arrow_right_default,
  DCaret: d_caret_default,
  DataAnalysis: data_analysis_default,
  DataBoard: data_board_default,
  DataLine: data_line_default,
  Delete: delete_default,
  DeleteFilled: delete_filled_default,
  DeleteLocation: delete_location_default,
  Dessert: dessert_default,
  Discount: discount_default,
  Dish: dish_default,
  DishDot: dish_dot_default,
  Document: document_default,
  DocumentAdd: document_add_default,
  DocumentChecked: document_checked_default,
  DocumentCopy: document_copy_default,
  DocumentDelete: document_delete_default,
  DocumentRemove: document_remove_default,
  Download: download_default,
  Drizzling: drizzling_default,
  Edit: edit_default,
  EditPen: edit_pen_default,
  Eleme: eleme_default,
  ElemeFilled: eleme_filled_default,
  ElementPlus: element_plus_default,
  Expand: expand_default,
  Failed: failed_default,
  Female: female_default,
  Files: files_default,
  Film: film_default,
  Filter: filter_default,
  Finished: finished_default,
  FirstAidKit: first_aid_kit_default,
  Flag: flag_default,
  Fold: fold_default,
  Folder: folder_default,
  FolderAdd: folder_add_default,
  FolderChecked: folder_checked_default,
  FolderDelete: folder_delete_default,
  FolderOpened: folder_opened_default,
  FolderRemove: folder_remove_default,
  Food: food_default,
  Football: football_default,
  ForkSpoon: fork_spoon_default,
  Fries: fries_default,
  FullScreen: full_screen_default,
  Goblet: goblet_default,
  GobletFull: goblet_full_default,
  GobletSquare: goblet_square_default,
  GobletSquareFull: goblet_square_full_default,
  GoldMedal: gold_medal_default,
  Goods: goods_default,
  GoodsFilled: goods_filled_default,
  Grape: grape_default,
  Grid: grid_default,
  Guide: guide_default,
  Handbag: handbag_default,
  Headset: headset_default,
  Help: help_default,
  HelpFilled: help_filled_default,
  Hide: hide_default,
  Histogram: histogram_default,
  HomeFilled: home_filled_default,
  HotWater: hot_water_default,
  House: house_default,
  IceCream: ice_cream_default,
  IceCreamRound: ice_cream_round_default,
  IceCreamSquare: ice_cream_square_default,
  IceDrink: ice_drink_default,
  IceTea: ice_tea_default,
  InfoFilled: info_filled_default,
  Iphone: iphone_default,
  Key: key_default,
  KnifeFork: knife_fork_default,
  Lightning: lightning_default,
  Link: link_default,
  List: list_default,
  Loading: loading_default,
  Location: location_default,
  LocationFilled: location_filled_default,
  LocationInformation: location_information_default,
  Lock: lock_default,
  Lollipop: lollipop_default,
  MagicStick: magic_stick_default,
  Magnet: magnet_default,
  Male: male_default,
  Management: management_default,
  MapLocation: map_location_default,
  Medal: medal_default,
  Memo: memo_default,
  Menu: menu_default,
  Message: message_default,
  MessageBox: message_box_default,
  Mic: mic_default,
  Microphone: microphone_default,
  MilkTea: milk_tea_default,
  Minus: minus_default,
  Money: money_default,
  Monitor: monitor_default,
  Moon: moon_default,
  MoonNight: moon_night_default,
  More: more_default,
  MoreFilled: more_filled_default,
  MostlyCloudy: mostly_cloudy_default,
  Mouse: mouse_default,
  Mug: mug_default,
  Mute: mute_default,
  MuteNotification: mute_notification_default,
  NoSmoking: no_smoking_default,
  Notebook: notebook_default,
  Notification: notification_default,
  Odometer: odometer_default,
  OfficeBuilding: office_building_default,
  Open: open_default,
  Operation: operation_default,
  Opportunity: opportunity_default,
  Orange: orange_default,
  Paperclip: paperclip_default,
  PartlyCloudy: partly_cloudy_default,
  Pear: pear_default,
  Phone: phone_default,
  PhoneFilled: phone_filled_default,
  Picture: picture_default,
  PictureFilled: picture_filled_default,
  PictureRounded: picture_rounded_default,
  PieChart: pie_chart_default,
  Place: place_default,
  Platform: platform_default,
  Plus: plus_default,
  Pointer: pointer_default,
  Position: position_default,
  Postcard: postcard_default,
  Pouring: pouring_default,
  Present: present_default,
  PriceTag: price_tag_default,
  Printer: printer_default,
  Promotion: promotion_default,
  QuartzWatch: quartz_watch_default,
  QuestionFilled: question_filled_default,
  Rank: rank_default,
  Reading: reading_default,
  ReadingLamp: reading_lamp_default,
  Refresh: refresh_default,
  RefreshLeft: refresh_left_default,
  RefreshRight: refresh_right_default,
  Refrigerator: refrigerator_default,
  Remove: remove_default,
  RemoveFilled: remove_filled_default,
  Right: right_default,
  ScaleToOriginal: scale_to_original_default,
  School: school_default,
  Scissor: scissor_default,
  Search: search_default,
  Select: select_default,
  Sell: sell_default,
  SemiSelect: semi_select_default,
  Service: service_default,
  SetUp: set_up_default,
  Setting: setting_default,
  Share: share_default,
  Ship: ship_default,
  Shop: shop_default,
  ShoppingBag: shopping_bag_default,
  ShoppingCart: shopping_cart_default,
  ShoppingCartFull: shopping_cart_full_default,
  ShoppingTrolley: shopping_trolley_default,
  Smoking: smoking_default,
  Soccer: soccer_default,
  SoldOut: sold_out_default,
  Sort: sort_default,
  SortDown: sort_down_default,
  SortUp: sort_up_default,
  Stamp: stamp_default,
  Star: star_default,
  StarFilled: star_filled_default,
  Stopwatch: stopwatch_default,
  SuccessFilled: success_filled_default,
  Sugar: sugar_default,
  Suitcase: suitcase_default,
  SuitcaseLine: suitcase_line_default,
  Sunny: sunny_default,
  Sunrise: sunrise_default,
  Sunset: sunset_default,
  Switch: switch_default,
  SwitchButton: switch_button_default,
  SwitchFilled: switch_filled_default,
  TakeawayBox: takeaway_box_default,
  Ticket: ticket_default,
  Tickets: tickets_default,
  Timer: timer_default,
  ToiletPaper: toilet_paper_default,
  Tools: tools_default,
  Top: top_default,
  TopLeft: top_left_default,
  TopRight: top_right_default,
  TrendCharts: trend_charts_default,
  Trophy: trophy_default,
  TrophyBase: trophy_base_default,
  TurnOff: turn_off_default,
  Umbrella: umbrella_default,
  Unlock: unlock_default,
  Upload: upload_default,
  UploadFilled: upload_filled_default,
  User: user_default,
  UserFilled: user_filled_default,
  Van: van_default,
  VideoCamera: video_camera_default,
  VideoCameraFilled: video_camera_filled_default,
  VideoPause: video_pause_default,
  VideoPlay: video_play_default,
  View: view_default,
  Wallet: wallet_default,
  WalletFilled: wallet_filled_default,
  WarnTriangleFilled: warn_triangle_filled_default,
  Warning: warning_default,
  WarningFilled: warning_filled_default,
  Watch: watch_default,
  Watermelon: watermelon_default,
  WindPower: wind_power_default,
  ZoomIn: zoom_in_default,
  ZoomOut: zoom_out_default
}, Symbol.toStringTag, { value: "Module" }));
class ValidatorAdapterBase {
  constructor() {
    __publicField(this, "defaultName");
    // protected ensureHasRuleItems(ruleItems:RuleItem[]){
    //     if(ruleItems.length == 0){
    //         ruleItems.push({options:{messages:{}}});
    //     }
    // }
    __publicField(this, "formatRegExp", /%[sdj%]/g);
    this.defaultName = "ValidatorAdapter";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    throw new Error("Abstract method must be implemented.");
  }
  format(template, ...args) {
    let i2 = 0;
    const len = args.length;
    if (typeof template === "function") {
      return template.apply(null, args);
    }
    let str = template.replace(this.formatRegExp, (x2) => {
      if (x2 === "%%") {
        return "%";
      }
      if (i2 >= len) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i2++]);
        case "%d":
          return Number(args[i2++]);
        case "%j":
          try {
            return JSON.stringify(args[i2++]);
          } catch (_2) {
            return "[Circular]";
          }
        default:
          return x2;
      }
    });
    return str;
  }
}
const __vite_glob_0_8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ValidatorAdapterBase
}, Symbol.toStringTag, { value: "Module" }));
class ComparerValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    __publicField(this, "defaultMessage", "");
    this.defaultName = "ComparerValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    let ruleItem = {};
    ruleItem.validator = (rule, value, callback, source, options) => {
      let rightField = validatorDescriptor.settings.rightFieldId;
      let right = source[rightField];
      if (!this.compare(value, right, validatorDescriptor.operator)) {
        let message = this.defaultMessage ?? t2(this.defaultName);
        message = this.format(message, rule.fullField, rightField);
        callback(message);
      }
    };
    ruleItems.push(ruleItem);
  }
  compare(left, right, operator) {
    switch (operator) {
      case "==":
        return left == right;
      case "!=":
        return right != right;
      case ">":
        return left > left;
      case "<":
        return left < right;
      case ">=":
        return left >= right;
      case "<=":
        return left <= right;
    }
    return false;
  }
}
const adapter$8 = new ComparerValidatorAdapter();
const __vite_glob_0_0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$8
}, Symbol.toStringTag, { value: "Module" }));
class EmailValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "PleaseEnterValidEmail";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      pattern: "[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?",
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
}
const adapter$7 = new EmailValidatorAdapter();
const __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$7
}, Symbol.toStringTag, { value: "Module" }));
class LengthRangeValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "LengthRangeValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      min: validatorDescriptor.settings.min,
      max: validatorDescriptor.settings.max,
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
  // private adaptMessageForString(ruleItem: RuleItem, validatorDescriptor: any, t: any) {
  //     if (ruleItem.options!.messages!.string == undefined) {
  //         ruleItem.options!.messages!.string = {};
  //     }
  //     let stringMessage = ruleItem.options!.messages!.string;
  //     stringMessage.max = (fieldName?: string, max?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, max);
  //     };
  //     stringMessage.min = (fieldName?: string, min?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, min);
  //     };
  //     stringMessage.range = (fieldName?: string, min?: number, max?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, min, max);
  //     };
  // }
  //
  // private adaptMessageForArray(ruleItem: RuleItem, validatorDescriptor: any, t: any) {
  //     if (ruleItem.options!.messages!.array == undefined) {
  //         ruleItem.options!.messages!.array = {};
  //     }
  //     let arrayMessage = ruleItem.options!.messages!.array;
  //     arrayMessage.max = (fieldName?: string, max?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, max);
  //     };
  //     arrayMessage.min = (fieldName?: string, min?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, min);
  //     };
  //     arrayMessage.range = (fieldName?: string, min?: number, max?: number) => {
  //         let rawString = validatorDescriptor.message ?? t(this.defaultName);
  //         return this.format(rawString, fieldName, min, max);
  //     };
  // }
}
const adapter$6 = new LengthRangeValidatorAdapter();
const __vite_glob_0_2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$6
}, Symbol.toStringTag, { value: "Module" }));
class PhoneNumberValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "PleaseEnterValidPhoneNumber";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      pattern: "^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$",
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
}
const adapter$5 = new PhoneNumberValidatorAdapter();
const __vite_glob_0_3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$5
}, Symbol.toStringTag, { value: "Module" }));
class RegexpValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "RegexpValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      pattern: validatorDescriptor.settings.pattern,
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
}
const adapter$4 = new RegexpValidatorAdapter();
const __vite_glob_0_4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  RegexpValidatorAdapter,
  default: adapter$4
}, Symbol.toStringTag, { value: "Module" }));
class RemoteValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    __publicField(this, "httpClient", new HttpClient());
    this.defaultName = "RemoteValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    let ruleItem = {};
    ruleItem.asyncValidator = async (rule, value, callback, source, options) => {
      const httpRequestMessage = createHttpRequestMessage({
        method: validatorDescriptor.settings.method,
        url: validatorDescriptor.settings.url,
        bodyPath: validatorDescriptor.settings.dataPath
      }, source);
      let result = await this.httpClient.send(httpRequestMessage);
      if (!result) {
        callback(validatorDescriptor.message);
      }
    };
    ruleItems.push(ruleItem);
  }
}
const adapter$3 = new RemoteValidatorAdapter();
const __vite_glob_0_5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$3
}, Symbol.toStringTag, { value: "Module" }));
class RequiredValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "RequiredValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      required: true,
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
  getErrorMessage(fieldName, message, t2) {
    return message ?? t2(this.defaultName);
  }
}
const adapter$2 = new RequiredValidatorAdapter();
const __vite_glob_0_6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$2
}, Symbol.toStringTag, { value: "Module" }));
class TypeValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "TypeValidator";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    let ruleItem = {};
    this.adaptRuleItem(ruleItem, validatorDescriptor, t2);
    ruleItems.push(ruleItem);
  }
  adaptRuleItem(ruleItem, validatorDescriptor, t2) {
    var _a3, _b3;
    const type4 = validatorDescriptor.settings.type;
    ruleItem.message = isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message;
    switch (type4) {
      case "boolean":
        ruleItem.type = "boolean";
        break;
      case "number":
        ruleItem.type = "number";
        break;
      case "datetime":
        ruleItem.type = "date";
        break;
      default:
        ruleItem.type = "string";
    }
  }
  // private getErrorMessage(fieldName:string|undefined,type:string|undefined,message:any, t:any){
  //     let rawString= message??t(this.defaultName);
  //     return this.format(rawString,fieldName);
  // }
}
const adapter$1 = new TypeValidatorAdapter();
const __vite_glob_0_7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter$1
}, Symbol.toStringTag, { value: "Module" }));
class ValueRangeValidatorAdapter extends ValidatorAdapterBase {
  constructor() {
    super();
    this.defaultName = "valueRange";
  }
  adapt(ruleItems, validatorDescriptor, t2) {
    var _a3, _b3;
    let ruleItem = {
      min: validatorDescriptor.settings.min,
      max: validatorDescriptor.settings.max,
      message: isNullOrUndefinedOrWhiteSpace((_a3 = validatorDescriptor.settings) == null ? void 0 : _a3.message) ? void 0 : (_b3 = validatorDescriptor.settings) == null ? void 0 : _b3.message
    };
    ruleItems.push(ruleItem);
  }
}
const adapter = new ValueRangeValidatorAdapter();
const __vite_glob_0_9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: adapter
}, Symbol.toStringTag, { value: "Module" }));
const modules = /* @__PURE__ */ Object.assign({ "./ComparerValidatorAdapter.ts": __vite_glob_0_0, "./EmailValidatorAdapter.ts": __vite_glob_0_1, "./LengthRangeValidatorAdapter.ts": __vite_glob_0_2, "./PhoneNumberValidatorAdapter.ts": __vite_glob_0_3, "./RegexpValidatorAdapter.ts": __vite_glob_0_4, "./RemoteValidatorAdapter.ts": __vite_glob_0_5, "./RequiredValidatorAdapter.ts": __vite_glob_0_6, "./TypeValidatorAdapter.ts": __vite_glob_0_7, "./ValidatorAdapterBase.ts": __vite_glob_0_8, "./ValueRangeValidatorAdapter.ts": __vite_glob_0_9, "./formItemRulesAdapter.ts": __vite_glob_0_10 });
const adapters = /* @__PURE__ */ new Map();
for (let key in modules) {
  let tag = key.replace(/^\.\/(.*)\.\w+$/, "$1").replace("slots/", "");
  tag = tag.substring(0, tag.length - "Adapter".length);
  let module = modules[key];
  adapters.set(tag, module.default);
}
function convertToRuleItems(validatorDescriptors, t2) {
  if (validatorDescriptors && validatorDescriptors.length == 0) {
    return [];
  }
  let ruleItems = [];
  let adapter2;
  for (let validatorDescriptor of validatorDescriptors) {
    adapter2 = adapters.get(validatorDescriptor.componentCode);
    if (adapter2) {
      adapter2.adapt(ruleItems, validatorDescriptor, t2);
    }
  }
  return ruleItems;
}
const convertToFormItemRules = (t2, tag, validatorDescriptors) => {
  if (isNullOrUndefinedOrWhiteSpace(tag) || isNullOrUndefinedOrEmptyArray(validatorDescriptors)) {
    return [];
  }
  let ruleItems = convertToRuleItems(validatorDescriptors, t2);
  return ruleItems.map((ri2) => {
    return { ...ri2, trigger: ["blur", "change"] };
  });
};
var DEFAULT_ICON_CONFIGS = {
  size: "1em",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  rtl: false,
  theme: "outline",
  colors: {
    outline: {
      fill: "#333",
      background: "transparent"
    },
    filled: {
      fill: "#333",
      background: "#FFF"
    },
    twoTone: {
      fill: "#333",
      twoTone: "#2F88FF"
    },
    multiColor: {
      outStrokeColor: "#333",
      outFillColor: "#2F88FF",
      innerStrokeColor: "#FFF",
      innerFillColor: "#43CCF8"
    }
  },
  prefix: "i"
};
function guid() {
  return "icon-" + ((1 + Math.random()) * 4294967296 | 0).toString(16).substring(1);
}
function IconConverter(id2, icon, config) {
  var fill = typeof icon.fill === "string" ? [icon.fill] : icon.fill || [];
  var colors = [];
  var theme = icon.theme || config.theme;
  switch (theme) {
    case "outline":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("none");
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("none");
      break;
    case "filled":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push("#FFF");
      colors.push("#FFF");
      break;
    case "two-tone":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.twoTone.twoTone);
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.twoTone.twoTone);
      break;
    case "multi-color":
      colors.push(typeof fill[0] === "string" ? fill[0] : "currentColor");
      colors.push(typeof fill[1] === "string" ? fill[1] : config.colors.multiColor.outFillColor);
      colors.push(typeof fill[2] === "string" ? fill[2] : config.colors.multiColor.innerStrokeColor);
      colors.push(typeof fill[3] === "string" ? fill[3] : config.colors.multiColor.innerFillColor);
      break;
  }
  return {
    size: icon.size || config.size,
    strokeWidth: icon.strokeWidth || config.strokeWidth,
    strokeLinecap: icon.strokeLinecap || config.strokeLinecap,
    strokeLinejoin: icon.strokeLinejoin || config.strokeLinejoin,
    colors,
    id: id2
  };
}
var IconContext = Symbol("icon-context");
function IconWrapper(name, rtl, render) {
  var options = {
    name: "icon-" + name,
    props: ["size", "strokeWidth", "strokeLinecap", "strokeLinejoin", "theme", "fill", "spin"],
    setup: function setup(props) {
      var id2 = guid();
      var ICON_CONFIGS = inject(IconContext, DEFAULT_ICON_CONFIGS);
      return function() {
        var size = props.size, strokeWidth = props.strokeWidth, strokeLinecap = props.strokeLinecap, strokeLinejoin = props.strokeLinejoin, theme = props.theme, fill = props.fill, spin = props.spin;
        var svgProps = IconConverter(id2, {
          size,
          strokeWidth,
          strokeLinecap,
          strokeLinejoin,
          theme,
          fill
        }, ICON_CONFIGS);
        var cls = [ICON_CONFIGS.prefix + "-icon"];
        cls.push(ICON_CONFIGS.prefix + "-icon-" + name);
        if (rtl && ICON_CONFIGS.rtl) {
          cls.push(ICON_CONFIGS.prefix + "-icon-rtl");
        }
        if (spin) {
          cls.push(ICON_CONFIGS.prefix + "-icon-spin");
        }
        return createVNode("span", {
          "class": cls.join(" ")
        }, [render(svgProps)]);
      };
    }
  };
  return options;
}
const AddTextTwo = IconWrapper("add-text-two", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("circle", {
    "cx": "24",
    "cy": "24",
    "r": "20",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), createVNode("path", {
    "d": "M32 16H16",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M24 34V16",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const CalendarDot = IconWrapper("calendar-dot", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("rect", {
    "x": "4",
    "y": "4",
    "width": "40",
    "height": "40",
    "rx": "2",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M4 14H44",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("line", {
    "x1": "44",
    "y1": "11",
    "x2": "44",
    "y2": "23",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M12 22H16",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M22 22H26",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M32 22H36",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M12 29H16",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M22 29H26",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M32 29H36",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M12 36H16",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M22 36H26",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M32 36H36",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("line", {
    "x1": "4",
    "y1": "11",
    "x2": "4",
    "y2": "23",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const Checkbox = IconWrapper("checkbox", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M39 6H9C7.34315 6 6 7.34315 6 9V39C6 40.6569 7.34315 42 9 42H39C40.6569 42 42 40.6569 42 39V9C42 7.34315 40.6569 6 39 6Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), createVNode("path", {
    "d": "M32 16H16V32H32V16Z",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const ClickTap = IconWrapper("click-tap", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M15 26V15C15 13.3431 16.3431 12 18 12C19.6569 12 21 13.3431 21 15V26",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M39 25V31.5C39 37.8513 33.8513 43 27.5 43H26.5C20.1487 43 15 37.8513 15 31.5V25",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M21 29V27.1058V24C21 22.3431 22.3431 21 24 21C25.6569 21 27 22.3431 27 24V27.1818V29",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M27 29V27.1058V24C27 22.3431 28.3431 21 30 21C31.6569 21 33 22.3431 33 24V27.1818V29",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M33 29V27.1058V24C33 22.3431 34.3431 21 36 21C37.6569 21 39 22.3431 39 24V27.1818V29",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M28 15C28 13.9489 27.8378 12.9357 27.5371 11.9839C27.2008 10.9195 26.6913 9.93208 26.0415 9.0547C24.2198 6.59472 21.2961 5 18 5C14.7039 5 11.7802 6.59472 9.95847 9.0547C9.30873 9.93208 8.79916 10.9195 8.46286 11.9839C8.16217 12.9357 8 13.9489 8 15",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null)]);
});
const Components = IconWrapper("components", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M17 11L24 4L31 11L24 18L17 11Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M30 25L37 18L44 25L37 32L30 25Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M17 37L24 30L31 37L24 44L17 37Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M4 24L11 17L18 24L11 31L4 24Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const DropDownList = IconWrapper("drop-down-list", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M40 28L24 40L8 28",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M8 10H40",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M8 18H40",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null)]);
});
const FigmaComponent = IconWrapper("figma-component", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M17 12L24 5L31 12L24 19L17 12Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M17 36L24 29L31 36L24 43L17 36Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M29 24L36 17L43 24L36 31L29 24Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M5 24L12 17L19 24L12 31L5 24Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const FiveKey = IconWrapper("five-key", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("rect", {
    "x": "6",
    "y": "6",
    "width": "36",
    "height": "36",
    "rx": "3",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M29 14.0093H20V21.0341C20 21 22 20 25 20C28 20 29 22.0339 29 26C29 29.9661 28 33 24 33C21 33 20 31 20 29.0078",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const HandDrag = IconWrapper("hand-drag", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M9.58303 27.1824C7.86719 28.3542 7.00928 30.2934 7.00928 33.0002C7.00928 37.0602 12.0001 44.0002 16.5006 44.0002C21.001 44.0002 23.6111 44.0002 28.016 44.0002C32.421 44.0002 35.0965 40.1495 35.0965 37.0602C35.0965 32.9069 35.0965 28.7536 35.0965 24.6002C35.0965 22.8072 33.6456 21.3522 31.8525 21.3472C30.0659 21.3422 28.6135 22.7865 28.6085 24.5731C28.6085 24.5761 28.6085 24.5791 28.6085 24.5821V24.6836",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M10.9814 29.4453V7.66246C10.9814 5.88568 12.4218 4.44531 14.1986 4.44531C15.9754 4.44531 17.4157 5.88568 17.4157 7.66246V23.6479",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M17.4155 24.0001V19.8076C17.4155 18.2589 18.671 17.0034 20.2197 17.0034C21.7684 17.0034 23.0239 18.2589 23.0239 19.8076V24.4272",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M23 24.6583V21.8076C23 20.2589 24.2555 19.0034 25.8042 19.0034C27.3529 19.0034 28.6084 20.2589 28.6084 21.8076V25.0034",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M11 8H41",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M36 12.5L37.6667 11L41 8L37.6667 5L36 3.5",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const InsertTable = IconWrapper("insert-table", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M39.3 6H8.7C7.20883 6 6 7.20883 6 8.7V39.3C6 40.7912 7.20883 42 8.7 42H39.3C40.7912 42 42 40.7912 42 39.3V8.7C42 7.20883 40.7912 6 39.3 6Z",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), createVNode("path", {
    "d": "M18 6V42",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M30 6V42",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M6 18H42",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), createVNode("path", {
    "d": "M6 30H42",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null)]);
});
const RadioTwo = IconWrapper("radio-two", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("circle", {
    "cx": "24",
    "cy": "24",
    "r": "20",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth
  }, null), createVNode("circle", {
    "cx": "24",
    "cy": "24",
    "r": "8",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const Star = IconWrapper("star", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M23.9986 5L17.8856 17.4776L4 19.4911L14.0589 29.3251L11.6544 43L23.9986 36.4192L36.3454 43L33.9586 29.3251L44 19.4911L30.1913 17.4776L23.9986 5Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const SwitchButton = IconWrapper("switch-button", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M36 4H12C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20H36C40.4183 20 44 16.4183 44 12C44 7.58172 40.4183 4 36 4Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M36 28H12C7.58172 28 4 31.5817 4 36C4 40.4183 7.58172 44 12 44H36C40.4183 44 44 40.4183 44 36C44 31.5817 40.4183 28 36 28Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M36 14C37.1046 14 38 13.1046 38 12C38 10.8954 37.1046 10 36 10C34.8954 10 34 10.8954 34 12C34 13.1046 34.8954 14 36 14Z",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M12 38C13.1046 38 14 37.1046 14 36C14 34.8954 13.1046 34 12 34C10.8954 34 10 34.8954 10 36C10 37.1046 10.8954 38 12 38Z",
    "fill": props.colors[3],
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const Time = IconWrapper("time", true, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("path", {
    "d": "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    "fill": props.colors[1],
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M24.0084 12.0001L24.0072 24.0089L32.4866 32.4883",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)]);
});
const Upload = IconWrapper("upload", false, function(props) {
  return createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [createVNode("mask", {
    "id": props.id + "04cec2fa",
    "maskUnits": "userSpaceOnUse",
    "x": "0",
    "y": "0",
    "width": "48",
    "height": "48",
    "style": {
      maskType: "alpha"
    }
  }, [createVNode("path", {
    "d": "M48 0H0V48H48V0Z",
    "fill": props.colors[2]
  }, null)]), createVNode("g", {
    "mask": "url(#" + props.id + "04cec2fa)"
  }, [createVNode("path", {
    "d": "M6 24.0083V42H42V24",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M33 15L24 6L15 15",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), createVNode("path", {
    "d": "M23.9917 32V6",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)])]);
});
class DefaultComponentBuilder {
  constructor(supportsSlots = ["default"]) {
    __publicField(this, "supportSlots");
    __publicField(this, "logger", new Logger("DefaultComponentBuilder"));
    this.supportSlots = supportsSlots;
  }
  getComponentIcon(context) {
    let icon = FigmaComponent;
    switch (context.schema.__config__.tag) {
      case "el-input":
        icon = AddTextTwo;
        break;
      case "el-input-number":
        icon = FiveKey;
        break;
      case "el-select":
        icon = DropDownList;
        break;
      case "el-radio-group":
        icon = RadioTwo;
        break;
      case "el-checkbox-group":
        icon = Checkbox;
        break;
      case "el-date-picker":
        icon = CalendarDot;
        break;
      case "el-time-picker":
        icon = Time;
        break;
      case "el-switch":
        icon = SwitchButton;
        break;
      case "el-slider":
        icon = HandDrag;
        break;
      case "el-rate":
        icon = Star;
        break;
      case "el-upload":
        icon = Upload;
        break;
      case "el-button":
        icon = ClickTap;
        break;
      case "el-table":
        icon = InsertTable;
        break;
    }
    return h$3(icon, { theme: "outline", size: 15, fill: "#333" });
  }
  buildProps(context) {
    let props = {};
    Object.keys(context.schema).forEach((key) => {
      if (key === "__config__" || key === "__slot__" || key === "__methods__" || key === "__vModel__" || key == "__runtime__") {
        return;
      }
      if (key === "placeholder") {
        props[key] = context.t(context.schema[key]);
      } else {
        props[key] = context.schema[key];
      }
    });
    return props;
  }
  buildSlots(context) {
    return this.buildNamedSlots(context, this.supportSlots);
  }
  buildSetup(context, props) {
  }
  ensureOnceExecuteSetup(context, props) {
    if (canExecuteSetup(context)) {
      this.buildSetup(context, props);
      setSetupFlag(context);
    }
  }
  buildNamedSlots(context, slotNames) {
    let slots = {};
    const slotConfigs = context.schema.__slot__;
    if (!slotConfigs) {
      return;
    }
    for (let slotName of slotNames) {
      let slotConfig = this.getSlotConfig(slotConfigs, slotName);
      if (slotConfig === void 0) {
        continue;
      }
      let slotBuildContext = createSlotBuildContext(context, slotConfig, slotName);
      let slotFunction = this.buildNamedSlot(slotBuildContext);
      if (slotFunction) {
        slots[slotBuildContext.slotName] = slotFunction;
      }
    }
    return slots;
  }
  isVModelSupported(component2) {
    let emits = component2.emits;
    return emits !== void 0 && emits !== null && (Array.isArray(emits) && emits.includes("update:modelValue") || isObject$4(emits) && emits.hasOwnProperty("update:modelValue"));
  }
  resolveComponent(context) {
    return resolveComponent(context.schema.__config__.tag);
  }
  isValidSlotConfig(slotConfig) {
    if (slotConfig === void 0 || slotConfig === null) {
      return false;
    }
    if (Array.isArray(slotConfig)) {
      return slotConfig.some((s2) => this.isValidSlotConfig(s2));
    }
    return isString$1(slotConfig) || this.isSlotConfigObject(slotConfig) || this.isSlotFunction(slotConfig);
  }
  isSlotFunction(slotConfig) {
    return isFunction$3(slotConfig);
  }
  isSlotConfigObject(slotConfig) {
    return isObject$4(slotConfig) && !Array.isArray(slotConfig) && Object.keys(slotConfig).length > 0;
  }
  getSlotConfig(slotConfigs, slotName = "default") {
    if (!this.supportSlots.some((n2) => n2 === slotName)) {
      return void 0;
    }
    if (slotConfigs === void 0) {
      return void 0;
    }
    let config = slotConfigs[slotName];
    if (config === void 0 && slotName === "default") {
      if (this.supportSlots.all((s2) => !slotConfigs.hasOwnProperty(s2))) {
        return slotConfigs;
      }
    }
    if (Array.isArray(config)) {
      config = config == null ? void 0 : config.filter((a2) => this.isValidSlotConfig(a2));
      return (config == null ? void 0 : config.length) > 0 ? config : void 0;
    } else {
      return this.isValidSlotConfig(config) ? config : void 0;
    }
  }
  buildNamedSlotByConfigObject(slotBuildContext, index2) {
    let buildContext = createBuildContext(slotBuildContext, index2);
    return buildComponent(buildContext);
  }
  buildNamedSlot(context) {
    if (Array.isArray(context.slotConfig)) {
      return () => {
        let vNodes = [];
        let config = void 0;
        for (let index2 = 0; index2 < context.slotConfig.length; index2++) {
          config = context.slotConfig[index2];
          if (this.isSlotConfigObject(config)) {
            vNodes.push(this.buildNamedSlotByConfigObject(context, index2));
          } else if (this.isSlotFunction(config)) {
            vNodes.push(config());
          } else {
            vNodes.push(config);
          }
        }
        return vNodes;
      };
    } else if (this.isSlotConfigObject(context.slotConfig)) {
      return () => this.buildNamedSlotByConfigObject(context);
    } else if (this.isSlotFunction(context.slotConfig)) {
      return context.slotConfig;
    } else if (isString$1(context.slotConfig)) {
      if (isNullOrUndefinedOrWhiteSpace(context.slotConfig)) {
        return void 0;
      }
      return () => context.slotConfig;
    }
    return void 0;
  }
  ///发布事件，订阅事件
  buildEvents(context) {
    var _a3;
    let props = {};
    if (this.isVModelSupported(context.component)) {
      let vModelFieldName = context.schema.__vModel__;
      if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
        props.modelValue = (_a3 = context.formModel) == null ? void 0 : _a3[vModelFieldName];
        props["onUpdate:modelValue"] = (value) => {
          context.formModel[vModelFieldName] = value;
        };
      }
    }
    const eventNames = Object.keys(context.schema.__methods__ || {});
    for (const eventName of eventNames) {
      const func = new Function("formModel", context.schema.__methods__[eventName]);
      props[eventName] = () => {
        const formModel = context.formModel;
        try {
          func(formModel);
        } catch (error) {
          this.logger.error(context.schema.__vModel__ + " 自定义事件代码运行出错", error);
        }
      };
    }
    return props;
  }
  build(context) {
    switch (context.renderMode) {
      case RenderMode.design:
        return this.buildDesignWithDrawingItem(context);
      case RenderMode.mini:
        return this.buildMini(context);
      case RenderMode.normalWithFormItem:
        return this.buildNormalWithFormItem(context);
      case RenderMode.normalWithoutFormItem:
        return this.buildNormal(context);
      case RenderMode.simple:
        return this.buildSimple(context);
      default:
        throw new Error("not support");
    }
  }
  ensureRenderKey(context) {
    if (!context.key) {
      if (context.schema.key && !isNullOrUndefinedOrWhiteSpace(context.schema.key)) {
        context.key = context.schema.key;
      }
      if (context.schema.__config__.key && !isNullOrUndefinedOrWhiteSpace(context.schema.__config__.key)) {
        context.key = context.schema.__config__.key;
      }
      context.key = ensureSchemaId(context) + ":" + context.renderMode;
    }
    return context.key;
  }
  buildNormal(context) {
    const vueComponent = this.resolveComponent(context);
    context["component"] = vueComponent;
    let props = this.buildProps(context);
    let eventProps = this.buildEvents(context);
    props = mergeProps(eventProps, props);
    this.ensureOnceExecuteSetup(context, props);
    let slots = this.buildSlots(context);
    props.key = this.ensureRenderKey(context);
    return h$3(vueComponent, props, slots);
  }
  buildMini(context) {
    let tag = context.schema.__config__.tag;
    let label = context.schema.__config__.label || tag;
    return h$3("div", { class: "components-wrapper" }, h$3(
      "div",
      { class: "components-item" },
      h$3(
        "div",
        { class: "components-body" },
        [h$3("div", { class: "components-body-icon" }, this.getComponentIcon(context)), h$3("div", { class: "components-body-text" }, context.t(label))]
      )
    ));
  }
  buildFormItemProps(context) {
    var _a3, _b3, _c3, _d3, _e3;
    context.p;
    let rules2 = convertToFormItemRules(
      context.t,
      (_a3 = context.schema.__config__) == null ? void 0 : _a3.tag,
      (_b3 = context.schema.__config__) == null ? void 0 : _b3.validatorDescriptors
    );
    let labelWidth = void 0;
    let label = void 0;
    if (((_c3 = context.schema.__config__) == null ? void 0 : _c3.showLabel) == true) {
      labelWidth = (_d3 = context.schema.__config__) == null ? void 0 : _d3.labelWidth;
      label = context.t((_e3 = context.schema.__config__) == null ? void 0 : _e3.label);
    }
    return { rules: rules2, label, labelWidth, prop: context.schema.__vModel__ };
  }
  buildNormalWithFormItem(context) {
    if (isFormItem(context.schema)) {
      return h$3(
        resolveComponent("el-form-item"),
        this.buildFormItemProps(context),
        () => this.buildNormal(context)
      );
    } else {
      return this.buildNormal(context);
    }
  }
  buildDesignWithFormItem(context) {
    if (isFormItem(context.schema)) {
      return h$3(
        resolveComponent("el-form-item"),
        this.buildFormItemProps(context),
        () => this.buildDesign(context)
      );
    } else {
      return this.buildDesign(context);
    }
  }
  buildDesignWithDrawingItem(context) {
    var _a3;
    if ((_a3 = context.schema.__runtime__) == null ? void 0 : _a3.isAutoGenerated) {
      return this.buildDesignWithFormItem(context);
    }
    const key = context.schema.__vModel__ || context.schema.__config__.tag;
    return h$3("div", { class: "drawing-item handle", key }, [
      this.buildDesignWithFormItem(context),
      h$3("span", {
        class: "drawing-item-delete",
        title: context.t("Delete"),
        dataDelete: true,
        onClick: (event) => {
          var _a4, _b3;
          event.stopPropagation();
          (_b3 = (_a4 = context.formState) == null ? void 0 : _a4.methods) == null ? void 0 : _b3.deleteComponent(context.extraData);
        }
      }, h$3(resolveComponent("el-icon"), { size: 12, dataDelete: true }, h$3(delete_default))),
      h$3(
        "span",
        {
          class: "drawing-item-copy",
          title: context.t("Copy"),
          dataCopy: true,
          onClick: (event) => {
            var _a4, _b3;
            event.stopPropagation();
            (_b3 = (_a4 = context.formState) == null ? void 0 : _a4.methods) == null ? void 0 : _b3.copyComponent(context.extraData);
          }
        },
        h$3(resolveComponent("el-icon"), { size: 12, dataCopy: true }, h$3(copy_document_default))
      )
    ]);
  }
  buildSimple(context) {
    let vueComponent = this.resolveComponent(context);
    context["component"] = vueComponent;
    let props = this.buildProps(context);
    let slots = this.buildSlots(context);
    return h$3(vueComponent, props, slots);
  }
  buildDesign(context) {
    var _a3, _b3;
    let vueComponent = this.resolveComponent(context);
    context["component"] = vueComponent;
    let props = this.buildProps(context);
    let eventProps = this.buildEvents(context);
    props = mergeProps(eventProps, props);
    this.ensureOnceExecuteSetup(context, props);
    let slots = this.buildSlots(context);
    props.key = this.ensureRenderKey(context);
    if ((_a3 = context.schema.__runtime__) == null ? void 0 : _a3.isAutoGenerated) {
      const defaultSlot = context.schema.__slot__.default || context.schema.__slot__;
      if (defaultSlot && ((_b3 = defaultSlot.__runtime__) == null ? void 0 : _b3.isActive)) {
        props.class = "form-designer-item--active";
      }
    }
    return h$3(vueComponent, props, slots);
  }
  buildWithErrorHandling(context, error) {
    return h$3(resolveComponent("el-row"), {}, () => {
      return [
        h$3(resolveComponent("el-col"), { span: 22 }, () => error.message),
        h$3(resolveComponent("el-button"), {}, () => {
        })
      ];
    });
  }
}
const _HttpDataSource = class _HttpDataSource {
  constructor(dataSourceDescriptor) {
    __publicField(this, "_httpDescriptor");
    __publicField(this, "enableCache");
    __publicField(this, "_body");
    __publicField(this, "_parameters");
    this._httpDescriptor = dataSourceDescriptor.settings.httpDescriptor;
    this.enableCache = dataSourceDescriptor.settings.enableCache;
  }
  getData() {
    if (isNullOrUndefinedOrWhiteSpace(this._httpDescriptor.url)) {
      return Promise.resolve([]);
    }
    const httpRequestMessage = createHttpRequestMessage(this._httpDescriptor);
    return _HttpDataSource.httpClient.send(httpRequestMessage);
  }
};
__publicField(_HttpDataSource, "httpClient");
let HttpDataSource = _HttpDataSource;
class FixedDataSource {
  constructor(fixedDataSourceDescriptor) {
    __publicField(this, "data");
    var _a3;
    this.data = (_a3 = fixedDataSourceDescriptor.settings) == null ? void 0 : _a3.data;
  }
  getData() {
    return new Promise((resolve, reject) => {
      resolve(this.data);
    });
  }
}
const createDataSource = (dataSourceDescriptor) => {
  switch (dataSourceDescriptor.type) {
    case "http":
      return new HttpDataSource(dataSourceDescriptor);
    case "fixed":
      return new FixedDataSource(dataSourceDescriptor);
    default:
      throw new Error(`${dataSourceDescriptor.type} not implemented.`);
  }
};
function _callSuper(t2, o2, e10) {
  return o2 = _getPrototypeOf$2(o2), _possibleConstructorReturn$1(t2, _isNativeReflectConstruct$2() ? Reflect.construct(o2, e10 || [], _getPrototypeOf$2(t2).constructor) : o2.apply(t2, e10));
}
function _construct$2(t2, e10, r3) {
  if (_isNativeReflectConstruct$2()) return Reflect.construct.apply(null, arguments);
  var o2 = [null];
  o2.push.apply(o2, e10);
  var p2 = new (t2.bind.apply(t2, o2))();
  return r3 && _setPrototypeOf$2(p2, r3.prototype), p2;
}
function _isNativeReflectConstruct$2() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!t2;
  })();
}
function ownKeys$1(e10, r3) {
  var t2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e10);
    r3 && (o2 = o2.filter(function(r4) {
      return Object.getOwnPropertyDescriptor(e10, r4).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2(e10) {
  for (var r3 = 1; r3 < arguments.length; r3++) {
    var t2 = null != arguments[r3] ? arguments[r3] : {};
    r3 % 2 ? ownKeys$1(Object(t2), true).forEach(function(r4) {
      _defineProperty$2(e10, r4, t2[r4]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(t2)) : ownKeys$1(Object(t2)).forEach(function(r4) {
      Object.defineProperty(e10, r4, Object.getOwnPropertyDescriptor(t2, r4));
    });
  }
  return e10;
}
function _toPrimitive(t2, r3) {
  if ("object" != typeof t2 || !t2) return t2;
  var e10 = t2[Symbol.toPrimitive];
  if (void 0 !== e10) {
    var i2 = e10.call(t2, r3);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t2);
}
function _toPropertyKey(t2) {
  var i2 = _toPrimitive(t2, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _typeof$3(o2) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$3(o2);
}
function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _getPrototypeOf$2(o2) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$2(o2);
}
function _setPrototypeOf$2(o2, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$2(o2, p2);
}
function _isNativeFunction$2(fn2) {
  try {
    return Function.toString.call(fn2).indexOf("[native code]") !== -1;
  } catch (e10) {
    return typeof fn2 === "function";
  }
}
function _wrapNativeSuper$2(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper$2 = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction$2(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct$2(Class2, arguments, _getPrototypeOf$2(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$2(Wrapper, Class2);
  };
  return _wrapNativeSuper$2(Class);
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) arr2[i2] = arr[i2];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (!it2) {
    if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$1(o2)) || allowArrayLike) {
      if (it2) o2 = it2;
      var i2 = 0;
      var F2 = function() {
      };
      return {
        s: F2,
        n: function() {
          if (i2 >= o2.length) return {
            done: true
          };
          return {
            done: false,
            value: o2[i2++]
          };
        },
        e: function(e10) {
          throw e10;
        },
        f: F2
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function() {
      it2 = it2.call(o2);
    },
    n: function() {
      var step = it2.next();
      normalCompletion = step.done;
      return step;
    },
    e: function(e10) {
      didErr = true;
      err = e10;
    },
    f: function() {
      try {
        if (!normalCompletion && it2.return != null) it2.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
var Hooks = /* @__PURE__ */ function() {
  function Hooks2() {
    _classCallCheck$3(this, Hooks2);
  }
  return _createClass$3(Hooks2, [{
    key: "add",
    value: (
      /**
       * @callback HookCallback
       * @this {*|Jsep} this
       * @param {Jsep} env
       * @returns: void
       */
      /**
       * Adds the given callback to the list of callbacks for the given hook.
       *
       * The callback will be invoked when the hook it is registered for is run.
       *
       * One callback function can be registered to multiple hooks and the same hook multiple times.
       *
       * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
       * @param {HookCallback|boolean} callback The callback function which is given environment variables.
       * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
       * @public
       */
      function add(name, callback, first) {
        if (typeof arguments[0] != "string") {
          for (var _name in arguments[0]) {
            this.add(_name, arguments[0][_name], arguments[1]);
          }
        } else {
          (Array.isArray(name) ? name : [name]).forEach(function(name2) {
            this[name2] = this[name2] || [];
            if (callback) {
              this[name2][first ? "unshift" : "push"](callback);
            }
          }, this);
        }
      }
    )
    /**
     * Runs a hook invoking all registered callbacks with the given environment variables.
     *
     * Callbacks will be invoked synchronously and in the order in which they were registered.
     *
     * @param {string} name The name of the hook.
     * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
     * @public
     */
  }, {
    key: "run",
    value: function run2(name, env) {
      this[name] = this[name] || [];
      this[name].forEach(function(callback) {
        callback.call(env && env.context ? env.context : env, env);
      });
    }
  }]);
}();
var Plugins = /* @__PURE__ */ function() {
  function Plugins2(jsep3) {
    _classCallCheck$3(this, Plugins2);
    this.jsep = jsep3;
    this.registered = {};
  }
  return _createClass$3(Plugins2, [{
    key: "register",
    value: function register3() {
      var _this = this;
      for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }
      plugins.forEach(function(plugin2) {
        if (_typeof$3(plugin2) !== "object" || !plugin2.name || !plugin2.init) {
          throw new Error("Invalid JSEP plugin format");
        }
        if (_this.registered[plugin2.name]) {
          return;
        }
        plugin2.init(_this.jsep);
        _this.registered[plugin2.name] = plugin2;
      });
    }
  }]);
}();
var Jsep = /* @__PURE__ */ function() {
  function Jsep2(expr) {
    _classCallCheck$3(this, Jsep2);
    this.expr = expr;
    this.index = 0;
  }
  return _createClass$3(Jsep2, [{
    key: "char",
    get: (
      // ==================== END CONFIG ============================
      /**
       * @returns {string}
       */
      function get2() {
        return this.expr.charAt(this.index);
      }
    )
    /**
     * @returns {number}
     */
  }, {
    key: "code",
    get: function get2() {
      return this.expr.charCodeAt(this.index);
    }
  }, {
    key: "throwError",
    value: (
      /**
       * throw error at index of the expression
       * @param {string} message
       * @throws
       */
      function throwError(message) {
        var error = new Error(message + " at character " + this.index);
        error.index = this.index;
        error.description = message;
        throw error;
      }
    )
    /**
     * Run a given hook
     * @param {string} name
     * @param {jsep.Expression|false} [node]
     * @returns {?jsep.Expression}
     */
  }, {
    key: "runHook",
    value: function runHook(name, node) {
      if (Jsep2.hooks[name]) {
        var env = {
          context: this,
          node
        };
        Jsep2.hooks.run(name, env);
        return env.node;
      }
      return node;
    }
    /**
     * Runs a given hook until one returns a node
     * @param {string} name
     * @returns {?jsep.Expression}
     */
  }, {
    key: "searchHook",
    value: function searchHook(name) {
      if (Jsep2.hooks[name]) {
        var env = {
          context: this
        };
        Jsep2.hooks[name].find(function(callback) {
          callback.call(env.context, env);
          return env.node;
        });
        return env.node;
      }
    }
    /**
     * Push `index` up to the next non-space character
     */
  }, {
    key: "gobbleSpaces",
    value: function gobbleSpaces() {
      var ch2 = this.code;
      while (ch2 === Jsep2.SPACE_CODE || ch2 === Jsep2.TAB_CODE || ch2 === Jsep2.LF_CODE || ch2 === Jsep2.CR_CODE) {
        ch2 = this.expr.charCodeAt(++this.index);
      }
      this.runHook("gobble-spaces");
    }
    /**
     * Top-level method to parse all expressions and returns compound or single node
     * @returns {jsep.Expression}
     */
  }, {
    key: "parse",
    value: function parse2() {
      this.runHook("before-all");
      var nodes = this.gobbleExpressions();
      var node = nodes.length === 1 ? nodes[0] : {
        type: Jsep2.COMPOUND,
        body: nodes
      };
      return this.runHook("after-all", node);
    }
    /**
     * top-level parser (but can be reused within as well)
     * @param {number} [untilICode]
     * @returns {jsep.Expression[]}
     */
  }, {
    key: "gobbleExpressions",
    value: function gobbleExpressions(untilICode) {
      var nodes = [], ch_i, node;
      while (this.index < this.expr.length) {
        ch_i = this.code;
        if (ch_i === Jsep2.SEMCOL_CODE || ch_i === Jsep2.COMMA_CODE) {
          this.index++;
        } else {
          if (node = this.gobbleExpression()) {
            nodes.push(node);
          } else if (this.index < this.expr.length) {
            if (ch_i === untilICode) {
              break;
            }
            this.throwError('Unexpected "' + this["char"] + '"');
          }
        }
      }
      return nodes;
    }
    /**
     * The main parsing function.
     * @returns {?jsep.Expression}
     */
  }, {
    key: "gobbleExpression",
    value: function gobbleExpression() {
      var node = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
      this.gobbleSpaces();
      return this.runHook("after-expression", node);
    }
    /**
     * Search for the operation portion of the string (e.g. `+`, `===`)
     * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
     * and move down from 3 to 2 to 1 character until a matching binary operation is found
     * then, return that binary operation
     * @returns {string|boolean}
     */
  }, {
    key: "gobbleBinaryOp",
    value: function gobbleBinaryOp() {
      this.gobbleSpaces();
      var to_check = this.expr.substr(this.index, Jsep2.max_binop_len);
      var tc_len = to_check.length;
      while (tc_len > 0) {
        if (Jsep2.binary_ops.hasOwnProperty(to_check) && (!Jsep2.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !Jsep2.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
          this.index += tc_len;
          return to_check;
        }
        to_check = to_check.substr(0, --tc_len);
      }
      return false;
    }
    /**
     * This function is responsible for gobbling an individual expression,
     * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
     * @returns {?jsep.BinaryExpression}
     */
  }, {
    key: "gobbleBinaryExpression",
    value: function gobbleBinaryExpression() {
      var node, biop, prec, stack, biop_info, left, right, i2, cur_biop;
      left = this.gobbleToken();
      if (!left) {
        return left;
      }
      biop = this.gobbleBinaryOp();
      if (!biop) {
        return left;
      }
      biop_info = {
        value: biop,
        prec: Jsep2.binaryPrecedence(biop),
        right_a: Jsep2.right_associative.has(biop)
      };
      right = this.gobbleToken();
      if (!right) {
        this.throwError("Expected expression after " + biop);
      }
      stack = [left, biop_info, right];
      while (biop = this.gobbleBinaryOp()) {
        prec = Jsep2.binaryPrecedence(biop);
        if (prec === 0) {
          this.index -= biop.length;
          break;
        }
        biop_info = {
          value: biop,
          prec,
          right_a: Jsep2.right_associative.has(biop)
        };
        cur_biop = biop;
        var comparePrev = function comparePrev2(prev) {
          return biop_info.right_a && prev.right_a ? prec > prev.prec : prec <= prev.prec;
        };
        while (stack.length > 2 && comparePrev(stack[stack.length - 2])) {
          right = stack.pop();
          biop = stack.pop().value;
          left = stack.pop();
          node = {
            type: Jsep2.BINARY_EXP,
            operator: biop,
            left,
            right
          };
          stack.push(node);
        }
        node = this.gobbleToken();
        if (!node) {
          this.throwError("Expected expression after " + cur_biop);
        }
        stack.push(biop_info, node);
      }
      i2 = stack.length - 1;
      node = stack[i2];
      while (i2 > 1) {
        node = {
          type: Jsep2.BINARY_EXP,
          operator: stack[i2 - 1].value,
          left: stack[i2 - 2],
          right: node
        };
        i2 -= 2;
      }
      return node;
    }
    /**
     * An individual part of a binary expression:
     * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
     * @returns {boolean|jsep.Expression}
     */
  }, {
    key: "gobbleToken",
    value: function gobbleToken() {
      var ch2, to_check, tc_len, node;
      this.gobbleSpaces();
      node = this.searchHook("gobble-token");
      if (node) {
        return this.runHook("after-token", node);
      }
      ch2 = this.code;
      if (Jsep2.isDecimalDigit(ch2) || ch2 === Jsep2.PERIOD_CODE) {
        return this.gobbleNumericLiteral();
      }
      if (ch2 === Jsep2.SQUOTE_CODE || ch2 === Jsep2.DQUOTE_CODE) {
        node = this.gobbleStringLiteral();
      } else if (ch2 === Jsep2.OBRACK_CODE) {
        node = this.gobbleArray();
      } else {
        to_check = this.expr.substr(this.index, Jsep2.max_unop_len);
        tc_len = to_check.length;
        while (tc_len > 0) {
          if (Jsep2.unary_ops.hasOwnProperty(to_check) && (!Jsep2.isIdentifierStart(this.code) || this.index + to_check.length < this.expr.length && !Jsep2.isIdentifierPart(this.expr.charCodeAt(this.index + to_check.length)))) {
            this.index += tc_len;
            var argument = this.gobbleToken();
            if (!argument) {
              this.throwError("missing unaryOp argument");
            }
            return this.runHook("after-token", {
              type: Jsep2.UNARY_EXP,
              operator: to_check,
              argument,
              prefix: true
            });
          }
          to_check = to_check.substr(0, --tc_len);
        }
        if (Jsep2.isIdentifierStart(ch2)) {
          node = this.gobbleIdentifier();
          if (Jsep2.literals.hasOwnProperty(node.name)) {
            node = {
              type: Jsep2.LITERAL,
              value: Jsep2.literals[node.name],
              raw: node.name
            };
          } else if (node.name === Jsep2.this_str) {
            node = {
              type: Jsep2.THIS_EXP
            };
          }
        } else if (ch2 === Jsep2.OPAREN_CODE) {
          node = this.gobbleGroup();
        }
      }
      if (!node) {
        return this.runHook("after-token", false);
      }
      node = this.gobbleTokenProperty(node);
      return this.runHook("after-token", node);
    }
    /**
     * Gobble properties of of identifiers/strings/arrays/groups.
     * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
     * It also gobbles function calls:
     * e.g. `Math.acos(obj.angle)`
     * @param {jsep.Expression} node
     * @returns {jsep.Expression}
     */
  }, {
    key: "gobbleTokenProperty",
    value: function gobbleTokenProperty(node) {
      this.gobbleSpaces();
      var ch2 = this.code;
      while (ch2 === Jsep2.PERIOD_CODE || ch2 === Jsep2.OBRACK_CODE || ch2 === Jsep2.OPAREN_CODE || ch2 === Jsep2.QUMARK_CODE) {
        var optional = void 0;
        if (ch2 === Jsep2.QUMARK_CODE) {
          if (this.expr.charCodeAt(this.index + 1) !== Jsep2.PERIOD_CODE) {
            break;
          }
          optional = true;
          this.index += 2;
          this.gobbleSpaces();
          ch2 = this.code;
        }
        this.index++;
        if (ch2 === Jsep2.OBRACK_CODE) {
          node = {
            type: Jsep2.MEMBER_EXP,
            computed: true,
            object: node,
            property: this.gobbleExpression()
          };
          this.gobbleSpaces();
          ch2 = this.code;
          if (ch2 !== Jsep2.CBRACK_CODE) {
            this.throwError("Unclosed [");
          }
          this.index++;
        } else if (ch2 === Jsep2.OPAREN_CODE) {
          node = {
            type: Jsep2.CALL_EXP,
            "arguments": this.gobbleArguments(Jsep2.CPAREN_CODE),
            callee: node
          };
        } else if (ch2 === Jsep2.PERIOD_CODE || optional) {
          if (optional) {
            this.index--;
          }
          this.gobbleSpaces();
          node = {
            type: Jsep2.MEMBER_EXP,
            computed: false,
            object: node,
            property: this.gobbleIdentifier()
          };
        }
        if (optional) {
          node.optional = true;
        }
        this.gobbleSpaces();
        ch2 = this.code;
      }
      return node;
    }
    /**
     * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
     * keep track of everything in the numeric literal and then calling `parseFloat` on that string
     * @returns {jsep.Literal}
     */
  }, {
    key: "gobbleNumericLiteral",
    value: function gobbleNumericLiteral() {
      var number4 = "", ch2, chCode;
      while (Jsep2.isDecimalDigit(this.code)) {
        number4 += this.expr.charAt(this.index++);
      }
      if (this.code === Jsep2.PERIOD_CODE) {
        number4 += this.expr.charAt(this.index++);
        while (Jsep2.isDecimalDigit(this.code)) {
          number4 += this.expr.charAt(this.index++);
        }
      }
      ch2 = this["char"];
      if (ch2 === "e" || ch2 === "E") {
        number4 += this.expr.charAt(this.index++);
        ch2 = this["char"];
        if (ch2 === "+" || ch2 === "-") {
          number4 += this.expr.charAt(this.index++);
        }
        while (Jsep2.isDecimalDigit(this.code)) {
          number4 += this.expr.charAt(this.index++);
        }
        if (!Jsep2.isDecimalDigit(this.expr.charCodeAt(this.index - 1))) {
          this.throwError("Expected exponent (" + number4 + this["char"] + ")");
        }
      }
      chCode = this.code;
      if (Jsep2.isIdentifierStart(chCode)) {
        this.throwError("Variable names cannot start with a number (" + number4 + this["char"] + ")");
      } else if (chCode === Jsep2.PERIOD_CODE || number4.length === 1 && number4.charCodeAt(0) === Jsep2.PERIOD_CODE) {
        this.throwError("Unexpected period");
      }
      return {
        type: Jsep2.LITERAL,
        value: parseFloat(number4),
        raw: number4
      };
    }
    /**
     * Parses a string literal, staring with single or double quotes with basic support for escape codes
     * e.g. `"hello world"`, `'this is\nJSEP'`
     * @returns {jsep.Literal}
     */
  }, {
    key: "gobbleStringLiteral",
    value: function gobbleStringLiteral() {
      var str = "";
      var startIndex = this.index;
      var quote = this.expr.charAt(this.index++);
      var closed = false;
      while (this.index < this.expr.length) {
        var ch2 = this.expr.charAt(this.index++);
        if (ch2 === quote) {
          closed = true;
          break;
        } else if (ch2 === "\\") {
          ch2 = this.expr.charAt(this.index++);
          switch (ch2) {
            case "n":
              str += "\n";
              break;
            case "r":
              str += "\r";
              break;
            case "t":
              str += "	";
              break;
            case "b":
              str += "\b";
              break;
            case "f":
              str += "\f";
              break;
            case "v":
              str += "\v";
              break;
            default:
              str += ch2;
          }
        } else {
          str += ch2;
        }
      }
      if (!closed) {
        this.throwError('Unclosed quote after "' + str + '"');
      }
      return {
        type: Jsep2.LITERAL,
        value: str,
        raw: this.expr.substring(startIndex, this.index)
      };
    }
    /**
     * Gobbles only identifiers
     * e.g.: `foo`, `_value`, `$x1`
     * Also, this function checks if that identifier is a literal:
     * (e.g. `true`, `false`, `null`) or `this`
     * @returns {jsep.Identifier}
     */
  }, {
    key: "gobbleIdentifier",
    value: function gobbleIdentifier() {
      var ch2 = this.code, start = this.index;
      if (Jsep2.isIdentifierStart(ch2)) {
        this.index++;
      } else {
        this.throwError("Unexpected " + this["char"]);
      }
      while (this.index < this.expr.length) {
        ch2 = this.code;
        if (Jsep2.isIdentifierPart(ch2)) {
          this.index++;
        } else {
          break;
        }
      }
      return {
        type: Jsep2.IDENTIFIER,
        name: this.expr.slice(start, this.index)
      };
    }
    /**
     * Gobbles a list of arguments within the context of a function call
     * or array literal. This function also assumes that the opening character
     * `(` or `[` has already been gobbled, and gobbles expressions and commas
     * until the terminator character `)` or `]` is encountered.
     * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
     * @param {number} termination
     * @returns {jsep.Expression[]}
     */
  }, {
    key: "gobbleArguments",
    value: function gobbleArguments(termination) {
      var args = [];
      var closed = false;
      var separator_count = 0;
      while (this.index < this.expr.length) {
        this.gobbleSpaces();
        var ch_i = this.code;
        if (ch_i === termination) {
          closed = true;
          this.index++;
          if (termination === Jsep2.CPAREN_CODE && separator_count && separator_count >= args.length) {
            this.throwError("Unexpected token " + String.fromCharCode(termination));
          }
          break;
        } else if (ch_i === Jsep2.COMMA_CODE) {
          this.index++;
          separator_count++;
          if (separator_count !== args.length) {
            if (termination === Jsep2.CPAREN_CODE) {
              this.throwError("Unexpected token ,");
            } else if (termination === Jsep2.CBRACK_CODE) {
              for (var arg = args.length; arg < separator_count; arg++) {
                args.push(null);
              }
            }
          }
        } else if (args.length !== separator_count && separator_count !== 0) {
          this.throwError("Expected comma");
        } else {
          var node = this.gobbleExpression();
          if (!node || node.type === Jsep2.COMPOUND) {
            this.throwError("Expected comma");
          }
          args.push(node);
        }
      }
      if (!closed) {
        this.throwError("Expected " + String.fromCharCode(termination));
      }
      return args;
    }
    /**
     * Responsible for parsing a group of things within parentheses `()`
     * that have no identifier in front (so not a function call)
     * This function assumes that it needs to gobble the opening parenthesis
     * and then tries to gobble everything within that parenthesis, assuming
     * that the next thing it should see is the close parenthesis. If not,
     * then the expression probably doesn't have a `)`
     * @returns {boolean|jsep.Expression}
     */
  }, {
    key: "gobbleGroup",
    value: function gobbleGroup() {
      this.index++;
      var nodes = this.gobbleExpressions(Jsep2.CPAREN_CODE);
      if (this.code === Jsep2.CPAREN_CODE) {
        this.index++;
        if (nodes.length === 1) {
          return nodes[0];
        } else if (!nodes.length) {
          return false;
        } else {
          return {
            type: Jsep2.SEQUENCE_EXP,
            expressions: nodes
          };
        }
      } else {
        this.throwError("Unclosed (");
      }
    }
    /**
     * Responsible for parsing Array literals `[1, 2, 3]`
     * This function assumes that it needs to gobble the opening bracket
     * and then tries to gobble the expressions as arguments.
     * @returns {jsep.ArrayExpression}
     */
  }, {
    key: "gobbleArray",
    value: function gobbleArray() {
      this.index++;
      return {
        type: Jsep2.ARRAY_EXP,
        elements: this.gobbleArguments(Jsep2.CBRACK_CODE)
      };
    }
  }], [{
    key: "version",
    get: (
      /**
       * @returns {string}
       */
      function get2() {
        return "1.3.8";
      }
    )
    /**
     * @returns {string}
     */
  }, {
    key: "toString",
    value: function toString2() {
      return "JavaScript Expression Parser (JSEP) v" + Jsep2.version;
    }
  }, {
    key: "addUnaryOp",
    value: (
      // ==================== CONFIG ================================
      /**
       * @method addUnaryOp
       * @param {string} op_name The name of the unary op to add
       * @returns {Jsep}
       */
      function addUnaryOp(op_name) {
        Jsep2.max_unop_len = Math.max(op_name.length, Jsep2.max_unop_len);
        Jsep2.unary_ops[op_name] = 1;
        return Jsep2;
      }
    )
    /**
     * @method jsep.addBinaryOp
     * @param {string} op_name The name of the binary op to add
     * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
     * @param {boolean} [isRightAssociative=false] whether operator is right-associative
     * @returns {Jsep}
     */
  }, {
    key: "addBinaryOp",
    value: function addBinaryOp(op_name, precedence, isRightAssociative) {
      Jsep2.max_binop_len = Math.max(op_name.length, Jsep2.max_binop_len);
      Jsep2.binary_ops[op_name] = precedence;
      if (isRightAssociative) {
        Jsep2.right_associative.add(op_name);
      } else {
        Jsep2.right_associative["delete"](op_name);
      }
      return Jsep2;
    }
    /**
     * @method addIdentifierChar
     * @param {string} char The additional character to treat as a valid part of an identifier
     * @returns {Jsep}
     */
  }, {
    key: "addIdentifierChar",
    value: function addIdentifierChar(_char) {
      Jsep2.additional_identifier_chars.add(_char);
      return Jsep2;
    }
    /**
     * @method addLiteral
     * @param {string} literal_name The name of the literal to add
     * @param {*} literal_value The value of the literal
     * @returns {Jsep}
     */
  }, {
    key: "addLiteral",
    value: function addLiteral(literal_name, literal_value) {
      Jsep2.literals[literal_name] = literal_value;
      return Jsep2;
    }
    /**
     * @method removeUnaryOp
     * @param {string} op_name The name of the unary op to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeUnaryOp",
    value: function removeUnaryOp(op_name) {
      delete Jsep2.unary_ops[op_name];
      if (op_name.length === Jsep2.max_unop_len) {
        Jsep2.max_unop_len = Jsep2.getMaxKeyLen(Jsep2.unary_ops);
      }
      return Jsep2;
    }
    /**
     * @method removeAllUnaryOps
     * @returns {Jsep}
     */
  }, {
    key: "removeAllUnaryOps",
    value: function removeAllUnaryOps() {
      Jsep2.unary_ops = {};
      Jsep2.max_unop_len = 0;
      return Jsep2;
    }
    /**
     * @method removeIdentifierChar
     * @param {string} char The additional character to stop treating as a valid part of an identifier
     * @returns {Jsep}
     */
  }, {
    key: "removeIdentifierChar",
    value: function removeIdentifierChar(_char2) {
      Jsep2.additional_identifier_chars["delete"](_char2);
      return Jsep2;
    }
    /**
     * @method removeBinaryOp
     * @param {string} op_name The name of the binary op to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeBinaryOp",
    value: function removeBinaryOp(op_name) {
      delete Jsep2.binary_ops[op_name];
      if (op_name.length === Jsep2.max_binop_len) {
        Jsep2.max_binop_len = Jsep2.getMaxKeyLen(Jsep2.binary_ops);
      }
      Jsep2.right_associative["delete"](op_name);
      return Jsep2;
    }
    /**
     * @method removeAllBinaryOps
     * @returns {Jsep}
     */
  }, {
    key: "removeAllBinaryOps",
    value: function removeAllBinaryOps() {
      Jsep2.binary_ops = {};
      Jsep2.max_binop_len = 0;
      return Jsep2;
    }
    /**
     * @method removeLiteral
     * @param {string} literal_name The name of the literal to remove
     * @returns {Jsep}
     */
  }, {
    key: "removeLiteral",
    value: function removeLiteral(literal_name) {
      delete Jsep2.literals[literal_name];
      return Jsep2;
    }
    /**
     * @method removeAllLiterals
     * @returns {Jsep}
     */
  }, {
    key: "removeAllLiterals",
    value: function removeAllLiterals() {
      Jsep2.literals = {};
      return Jsep2;
    }
  }, {
    key: "parse",
    value: function parse2(expr) {
      return new Jsep2(expr).parse();
    }
    /**
     * Get the longest key length of any object
     * @param {object} obj
     * @returns {number}
     */
  }, {
    key: "getMaxKeyLen",
    value: function getMaxKeyLen(obj) {
      return Math.max.apply(Math, [0].concat(_toConsumableArray(Object.keys(obj).map(function(k2) {
        return k2.length;
      }))));
    }
    /**
     * `ch` is a character code in the next three functions
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isDecimalDigit",
    value: function isDecimalDigit(ch2) {
      return ch2 >= 48 && ch2 <= 57;
    }
    /**
     * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
     * @param {string} op_val
     * @returns {number}
     */
  }, {
    key: "binaryPrecedence",
    value: function binaryPrecedence(op_val) {
      return Jsep2.binary_ops[op_val] || 0;
    }
    /**
     * Looks for start of identifier
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isIdentifierStart",
    value: function isIdentifierStart(ch2) {
      return ch2 >= 65 && ch2 <= 90 || // A...Z
      ch2 >= 97 && ch2 <= 122 || // a...z
      ch2 >= 128 && !Jsep2.binary_ops[String.fromCharCode(ch2)] || // any non-ASCII that is not an operator
      Jsep2.additional_identifier_chars.has(String.fromCharCode(ch2));
    }
    /**
     * @param {number} ch
     * @returns {boolean}
     */
  }, {
    key: "isIdentifierPart",
    value: function isIdentifierPart(ch2) {
      return Jsep2.isIdentifierStart(ch2) || Jsep2.isDecimalDigit(ch2);
    }
  }]);
}();
var hooks = new Hooks();
Object.assign(Jsep, {
  hooks,
  plugins: new Plugins(Jsep),
  // Node Types
  // ----------
  // This is the full set of types that any JSEP node can be.
  // Store them here to save space when minified
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  // '.'
  COMMA_CODE: 44,
  // ','
  SQUOTE_CODE: 39,
  // single quote
  DQUOTE_CODE: 34,
  // double quotes
  OPAREN_CODE: 40,
  // (
  CPAREN_CODE: 41,
  // )
  OBRACK_CODE: 91,
  // [
  CBRACK_CODE: 93,
  // ]
  QUMARK_CODE: 63,
  // ?
  SEMCOL_CODE: 59,
  // ;
  COLON_CODE: 58,
  // :
  // Operations
  // ----------
  // Use a quickly-accessible map to store all of the unary operators
  // Values are set to `1` (it really doesn't matter)
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  // Also use a map for the binary operations but set their values to their
  // binary precedence for quick reference (higher number = higher precedence)
  // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
  binary_ops: {
    "||": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10
  },
  // sets specific binary_ops as right-associative
  right_associative: /* @__PURE__ */ new Set(),
  // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
  additional_identifier_chars: /* @__PURE__ */ new Set(["$", "_"]),
  // Literals
  // ----------
  // Store the values to return for the various literals we may encounter
  literals: {
    "true": true,
    "false": false,
    "null": null
  },
  // Except for `this`, which is special. This could be changed to something like `'self'` as well
  this_str: "this"
});
Jsep.max_unop_len = Jsep.getMaxKeyLen(Jsep.unary_ops);
Jsep.max_binop_len = Jsep.getMaxKeyLen(Jsep.binary_ops);
var jsep = function jsep2(expr) {
  return new Jsep(expr).parse();
};
var staticMethods = Object.getOwnPropertyNames(Jsep);
staticMethods.forEach(function(m2) {
  if (jsep[m2] === void 0 && m2 !== "prototype") {
    jsep[m2] = Jsep[m2];
  }
});
jsep.Jsep = Jsep;
var CONDITIONAL_EXP = "ConditionalExpression";
var ternary = {
  name: "ternary",
  init: function init(jsep3) {
    jsep3.hooks.add("after-expression", function gobbleTernary(env) {
      if (env.node && this.code === jsep3.QUMARK_CODE) {
        this.index++;
        var test = env.node;
        var consequent = this.gobbleExpression();
        if (!consequent) {
          this.throwError("Expected expression");
        }
        this.gobbleSpaces();
        if (this.code === jsep3.COLON_CODE) {
          this.index++;
          var alternate = this.gobbleExpression();
          if (!alternate) {
            this.throwError("Expected expression");
          }
          env.node = {
            type: CONDITIONAL_EXP,
            test,
            consequent,
            alternate
          };
          if (test.operator && jsep3.binary_ops[test.operator] <= 0.9) {
            var newTest = test;
            while (newTest.right.operator && jsep3.binary_ops[newTest.right.operator] <= 0.9) {
              newTest = newTest.right;
            }
            env.node.test = newTest.right;
            newTest.right = env.node;
            env.node = test;
          }
        } else {
          this.throwError("Expected :");
        }
      }
    });
  }
};
jsep.plugins.register(ternary);
var FSLASH_CODE = 47;
var BSLASH_CODE = 92;
var index = {
  name: "regex",
  init: function init2(jsep3) {
    jsep3.hooks.add("gobble-token", function gobbleRegexLiteral(env) {
      if (this.code === FSLASH_CODE) {
        var patternIndex = ++this.index;
        var inCharSet = false;
        while (this.index < this.expr.length) {
          if (this.code === FSLASH_CODE && !inCharSet) {
            var pattern4 = this.expr.slice(patternIndex, this.index);
            var flags = "";
            while (++this.index < this.expr.length) {
              var code = this.code;
              if (code >= 97 && code <= 122 || code >= 65 && code <= 90 || code >= 48 && code <= 57) {
                flags += this["char"];
              } else {
                break;
              }
            }
            var value = void 0;
            try {
              value = new RegExp(pattern4, flags);
            } catch (e10) {
              this.throwError(e10.message);
            }
            env.node = {
              type: jsep3.LITERAL,
              value,
              raw: this.expr.slice(patternIndex - 1, this.index)
            };
            env.node = this.gobbleTokenProperty(env.node);
            return env.node;
          }
          if (this.code === jsep3.OBRACK_CODE) {
            inCharSet = true;
          } else if (inCharSet && this.code === jsep3.CBRACK_CODE) {
            inCharSet = false;
          }
          this.index += this.code === BSLASH_CODE ? 2 : 1;
        }
        this.throwError("Unclosed Regex");
      }
    });
  }
};
var PLUS_CODE = 43;
var MINUS_CODE = 45;
var plugin = {
  name: "assignment",
  assignmentOperators: /* @__PURE__ */ new Set(["=", "*=", "**=", "/=", "%=", "+=", "-=", "<<=", ">>=", ">>>=", "&=", "^=", "|="]),
  updateOperators: [PLUS_CODE, MINUS_CODE],
  assignmentPrecedence: 0.9,
  init: function init3(jsep3) {
    var updateNodeTypes = [jsep3.IDENTIFIER, jsep3.MEMBER_EXP];
    plugin.assignmentOperators.forEach(function(op2) {
      return jsep3.addBinaryOp(op2, plugin.assignmentPrecedence, true);
    });
    jsep3.hooks.add("gobble-token", function gobbleUpdatePrefix(env) {
      var _this = this;
      var code = this.code;
      if (plugin.updateOperators.some(function(c3) {
        return c3 === code && c3 === _this.expr.charCodeAt(_this.index + 1);
      })) {
        this.index += 2;
        env.node = {
          type: "UpdateExpression",
          operator: code === PLUS_CODE ? "++" : "--",
          argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
          prefix: true
        };
        if (!env.node.argument || !updateNodeTypes.includes(env.node.argument.type)) {
          this.throwError("Unexpected ".concat(env.node.operator));
        }
      }
    });
    jsep3.hooks.add("after-token", function gobbleUpdatePostfix(env) {
      var _this2 = this;
      if (env.node) {
        var code = this.code;
        if (plugin.updateOperators.some(function(c3) {
          return c3 === code && c3 === _this2.expr.charCodeAt(_this2.index + 1);
        })) {
          if (!updateNodeTypes.includes(env.node.type)) {
            this.throwError("Unexpected ".concat(env.node.operator));
          }
          this.index += 2;
          env.node = {
            type: "UpdateExpression",
            operator: code === PLUS_CODE ? "++" : "--",
            argument: env.node,
            prefix: false
          };
        }
      }
    });
    jsep3.hooks.add("after-expression", function gobbleAssignment(env) {
      if (env.node) {
        updateBinariesToAssignments(env.node);
      }
    });
    function updateBinariesToAssignments(node) {
      if (plugin.assignmentOperators.has(node.operator)) {
        node.type = "AssignmentExpression";
        updateBinariesToAssignments(node.left);
        updateBinariesToAssignments(node.right);
      } else if (!node.operator) {
        Object.values(node).forEach(function(val) {
          if (val && _typeof$3(val) === "object") {
            updateBinariesToAssignments(val);
          }
        });
      }
    }
  }
};
var hasOwnProp = Object.prototype.hasOwnProperty;
function push(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
var NewError = /* @__PURE__ */ function(_Error) {
  function NewError2(value) {
    var _this;
    _classCallCheck$3(this, NewError2);
    _this = _callSuper(this, NewError2, ['JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)']);
    _this.avoidNew = true;
    _this.value = value;
    _this.name = "NewError";
    return _this;
  }
  _inherits$1(NewError2, _Error);
  return _createClass$3(NewError2);
}(/* @__PURE__ */ _wrapNativeSuper$2(Error));
function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e10) {
      if (!e10.avoidNew) {
        throw e10;
      }
      return e10.value;
    }
  }
  if (typeof opts === "string") {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }
  var optObj = opts && _typeof$3(opts) === "object";
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || "value";
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, "wrap") ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.eval = opts.eval === void 0 ? "safe" : opts.eval;
  this.ignoreEvalErrors = typeof opts.ignoreEvalErrors === "undefined" ? false : opts.ignoreEvalErrors;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;
  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function() {
    throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
  };
  if (opts.autostart !== false) {
    var args = {
      path: optObj ? opts.path : expr
    };
    if (!optObj) {
      args.json = obj;
    } else if ("json" in opts) {
      args.json = opts.json;
    }
    var ret = this.evaluate(args);
    if (!ret || _typeof$3(ret) !== "object") {
      throw new NewError(ret);
    }
    return ret;
  }
}
JSONPath.prototype.evaluate = function(expr, json, callback, otherTypeCallback) {
  var _this2 = this;
  var currParent = this.parent, currParentProperty = this.parentProperty;
  var flatten = this.flatten, wrap = this.wrap;
  this.currResultType = this.resultType;
  this.currEval = this.eval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;
  if (expr && _typeof$3(expr) === "object" && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== "") {
      throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
    }
    if (!hasOwnProp.call(expr, "json")) {
      throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
    }
    var _expr = expr;
    json = _expr.json;
    flatten = hasOwnProp.call(expr, "flatten") ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, "resultType") ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, "sandbox") ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, "wrap") ? expr.wrap : wrap;
    this.currEval = hasOwnProp.call(expr, "eval") ? expr.eval : this.currEval;
    callback = hasOwnProp.call(expr, "callback") ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, "otherTypeCallback") ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, "parent") ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, "parentProperty") ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }
  currParent = currParent || null;
  currParentProperty = currParentProperty || null;
  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }
  if (!expr && expr !== "" || !json) {
    return void 0;
  }
  var exprList = JSONPath.toPathArray(expr);
  if (exprList[0] === "$" && exprList.length > 1) {
    exprList.shift();
  }
  this._hasParentSelector = null;
  var result = this._trace(exprList, json, ["$"], currParent, currParentProperty, callback).filter(function(ea2) {
    return ea2 && !ea2.isParentSelector;
  });
  if (!result.length) {
    return wrap ? [] : void 0;
  }
  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }
  return result.reduce(function(rslt, ea2) {
    var valOrPath = _this2._getPreferredOutput(ea2);
    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }
    return rslt;
  }, []);
};
JSONPath.prototype._getPreferredOutput = function(ea2) {
  var resultType = this.currResultType;
  switch (resultType) {
    case "all": {
      var path = Array.isArray(ea2.path) ? ea2.path : JSONPath.toPathArray(ea2.path);
      ea2.pointer = JSONPath.toPointer(path);
      ea2.path = typeof ea2.path === "string" ? ea2.path : JSONPath.toPathString(ea2.path);
      return ea2;
    }
    case "value":
    case "parent":
    case "parentProperty":
      return ea2[resultType];
    case "path":
      return JSONPath.toPathString(ea2[resultType]);
    case "pointer":
      return JSONPath.toPointer(ea2.path);
    default:
      throw new TypeError("Unknown result type");
  }
};
JSONPath.prototype._handleCallback = function(fullRetObj, callback, type4) {
  if (callback) {
    var preferredOutput = this._getPreferredOutput(fullRetObj);
    fullRetObj.path = typeof fullRetObj.path === "string" ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path);
    callback(preferredOutput, type4, fullRetObj);
  }
};
JSONPath.prototype._trace = function(expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  var _this3 = this;
  var retObj;
  if (!expr.length) {
    retObj = {
      path,
      value: val,
      parent,
      parentProperty: parentPropName,
      hasArrExpr
    };
    this._handleCallback(retObj, callback, "value");
    return retObj;
  }
  var loc = expr[0], x2 = expr.slice(1);
  var ret = [];
  function addRet(elems) {
    if (Array.isArray(elems)) {
      elems.forEach(function(t3) {
        ret.push(t3);
      });
    } else {
      ret.push(elems);
    }
  }
  if ((typeof loc !== "string" || literalPriority) && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x2, val[loc], push(path, loc), val, loc, callback, hasArrExpr));
  } else if (loc === "*") {
    this._walk(val, function(m2) {
      addRet(_this3._trace(x2, val[m2], push(path, m2), val, m2, callback, true, true));
    });
  } else if (loc === "..") {
    addRet(this._trace(x2, val, path, parent, parentPropName, callback, hasArrExpr));
    this._walk(val, function(m2) {
      if (_typeof$3(val[m2]) === "object") {
        addRet(_this3._trace(expr.slice(), val[m2], push(path, m2), val, m2, callback, true));
      }
    });
  } else if (loc === "^") {
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x2,
      isParentSelector: true
    };
  } else if (loc === "~") {
    retObj = {
      path: push(path, loc),
      value: parentPropName,
      parent,
      parentProperty: null
    };
    this._handleCallback(retObj, callback, "property");
    return retObj;
  } else if (loc === "$") {
    addRet(this._trace(x2, val, path, null, null, callback, hasArrExpr));
  } else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(loc)) {
    addRet(this._slice(loc, x2, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf("?(") === 0) {
    if (this.currEval === false) {
      throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
    }
    var safeLoc = loc.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1");
    var nested = /@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])?((?:[\0->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))(?!(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])\)\])['\]]/g.exec(safeLoc);
    if (nested) {
      this._walk(val, function(m2) {
        var npath = [nested[2]];
        var nvalue = nested[1] ? val[m2][nested[1]] : val[m2];
        var filterResults = _this3._trace(npath, nvalue, path, parent, parentPropName, callback, true);
        if (filterResults.length > 0) {
          addRet(_this3._trace(x2, val[m2], push(path, m2), val, m2, callback, true));
        }
      });
    } else {
      this._walk(val, function(m2) {
        if (_this3._eval(safeLoc, val[m2], m2, path, parent, parentPropName)) {
          addRet(_this3._trace(x2, val[m2], push(path, m2), val, m2, callback, true));
        }
      });
    }
  } else if (loc[0] === "(") {
    if (this.currEval === false) {
      throw new Error("Eval [(expr)] prevented in JSONPath expression.");
    }
    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x2), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === "@") {
    var addType = false;
    var valueType = loc.slice(1, -2);
    switch (valueType) {
      case "scalar":
        if (!val || !["object", "function"].includes(_typeof$3(val))) {
          addType = true;
        }
        break;
      case "boolean":
      case "string":
      case "undefined":
      case "function":
        if (_typeof$3(val) === valueType) {
          addType = true;
        }
        break;
      case "integer":
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }
        break;
      case "number":
        if (Number.isFinite(val)) {
          addType = true;
        }
        break;
      case "nonFinite":
        if (typeof val === "number" && !Number.isFinite(val)) {
          addType = true;
        }
        break;
      case "object":
        if (val && _typeof$3(val) === valueType) {
          addType = true;
        }
        break;
      case "array":
        if (Array.isArray(val)) {
          addType = true;
        }
        break;
      case "other":
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;
      case "null":
        if (val === null) {
          addType = true;
        }
        break;
      default:
        throw new TypeError("Unknown value type " + valueType);
    }
    if (addType) {
      retObj = {
        path,
        value: val,
        parent,
        parentProperty: parentPropName
      };
      this._handleCallback(retObj, callback, "value");
      return retObj;
    }
  } else if (loc[0] === "`" && val && hasOwnProp.call(val, loc.slice(1))) {
    var locProp = loc.slice(1);
    addRet(this._trace(x2, val[locProp], push(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(",")) {
    var parts = loc.split(",");
    var _iterator = _createForOfIteratorHelper(parts), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var part = _step.value;
        addRet(this._trace(unshift(part, x2), val, path, parent, parentPropName, callback, true));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x2, val[loc], push(path, loc), val, loc, callback, hasArrExpr, true));
  }
  if (this._hasParentSelector) {
    for (var t2 = 0; t2 < ret.length; t2++) {
      var rett = ret[t2];
      if (rett && rett.isParentSelector) {
        var tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);
        if (Array.isArray(tmp)) {
          ret[t2] = tmp[0];
          var tl2 = tmp.length;
          for (var tt2 = 1; tt2 < tl2; tt2++) {
            t2++;
            ret.splice(t2, 0, tmp[tt2]);
          }
        } else {
          ret[t2] = tmp;
        }
      }
    }
  }
  return ret;
};
JSONPath.prototype._walk = function(val, f2) {
  if (Array.isArray(val)) {
    var n2 = val.length;
    for (var i2 = 0; i2 < n2; i2++) {
      f2(i2);
    }
  } else if (val && _typeof$3(val) === "object") {
    Object.keys(val).forEach(function(m2) {
      f2(m2);
    });
  }
};
JSONPath.prototype._slice = function(loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return void 0;
  }
  var len = val.length, parts = loc.split(":"), step = parts[2] && Number.parseInt(parts[2]) || 1;
  var start = parts[0] && Number.parseInt(parts[0]) || 0, end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  var ret = [];
  for (var i2 = start; i2 < end; i2 += step) {
    var tmp = this._trace(unshift(i2, expr), val, path, parent, parentPropName, callback, true);
    tmp.forEach(function(t2) {
      ret.push(t2);
    });
  }
  return ret;
};
JSONPath.prototype._eval = function(code, _v3, _vname, path, parent, parentPropName) {
  var _this4 = this;
  this.currSandbox._$_parentProperty = parentPropName;
  this.currSandbox._$_parent = parent;
  this.currSandbox._$_property = _vname;
  this.currSandbox._$_root = this.json;
  this.currSandbox._$_v = _v3;
  var containsPath = code.includes("@path");
  if (containsPath) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
  }
  var scriptCacheKey = this.currEval + "Script:" + code;
  if (!JSONPath.cache[scriptCacheKey]) {
    var script = code.replace(/@parentProperty/g, "_$_parentProperty").replace(/@parent/g, "_$_parent").replace(/@property/g, "_$_property").replace(/@root/g, "_$_root").replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1");
    if (containsPath) {
      script = script.replace(/@path/g, "_$_path");
    }
    if (this.currEval === "safe" || this.currEval === true || this.currEval === void 0) {
      JSONPath.cache[scriptCacheKey] = new this.safeVm.Script(script);
    } else if (this.currEval === "native") {
      JSONPath.cache[scriptCacheKey] = new this.vm.Script(script);
    } else if (typeof this.currEval === "function" && this.currEval.prototype && hasOwnProp.call(this.currEval.prototype, "runInNewContext")) {
      var CurrEval = this.currEval;
      JSONPath.cache[scriptCacheKey] = new CurrEval(script);
    } else if (typeof this.currEval === "function") {
      JSONPath.cache[scriptCacheKey] = {
        runInNewContext: function runInNewContext(context) {
          return _this4.currEval(script, context);
        }
      };
    } else {
      throw new TypeError('Unknown "eval" property "'.concat(this.currEval, '"'));
    }
  }
  try {
    return JSONPath.cache[scriptCacheKey].runInNewContext(this.currSandbox);
  } catch (e10) {
    if (this.ignoreEvalErrors) {
      return false;
    }
    throw new Error("jsonPath: " + e10.message + ": " + code);
  }
};
JSONPath.cache = {};
JSONPath.toPathString = function(pathArr) {
  var x2 = pathArr, n2 = x2.length;
  var p2 = "$";
  for (var i2 = 1; i2 < n2; i2++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x2[i2])) {
      p2 += /^[\*0-9]+$/.test(x2[i2]) ? "[" + x2[i2] + "]" : "['" + x2[i2] + "']";
    }
  }
  return p2;
};
JSONPath.toPointer = function(pointer) {
  var x2 = pointer, n2 = x2.length;
  var p2 = "";
  for (var i2 = 1; i2 < n2; i2++) {
    if (!/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(x2[i2])) {
      p2 += "/" + x2[i2].toString().replace(/~/g, "~0").replace(/\//g, "~1");
    }
  }
  return p2;
};
JSONPath.toPathArray = function(expr) {
  var cache = JSONPath.cache;
  if (cache[expr]) {
    return cache[expr].concat();
  }
  var subx = [];
  var normalized = expr.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]](?!(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])\])/g, function($0, $1) {
    return "[#" + (subx.push($1) - 1) + "]";
  }).replace(/\[["']((?:[\0-&\(-\\\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)["']\]/g, function($0, prop) {
    return "['" + prop.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
  }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:[\0-Z\\-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function($0, ups) {
    return ";" + ups.split("").join(";") + ";";
  }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "");
  var exprList = normalized.split(";").map(function(exp) {
    var match = exp.match(/#([0-9]+)/);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};
var moveToAnotherArray = function moveToAnotherArray2(source, target, conditionCb) {
  var il2 = source.length;
  for (var i2 = 0; i2 < il2; i2++) {
    var item = source[i2];
    if (conditionCb(item)) {
      target.push(source.splice(i2--, 1)[0]);
    }
  }
};
jsep.plugins.register(index, plugin);
var SafeEval = {
  /**
   * @param {jsep.Expression} ast
   * @param {Record<string, any>} subs
   */
  evalAst: function evalAst(ast, subs) {
    switch (ast.type) {
      case "BinaryExpression":
      case "LogicalExpression":
        return SafeEval.evalBinaryExpression(ast, subs);
      case "Compound":
        return SafeEval.evalCompound(ast, subs);
      case "ConditionalExpression":
        return SafeEval.evalConditionalExpression(ast, subs);
      case "Identifier":
        return SafeEval.evalIdentifier(ast, subs);
      case "Literal":
        return SafeEval.evalLiteral(ast, subs);
      case "MemberExpression":
        return SafeEval.evalMemberExpression(ast, subs);
      case "UnaryExpression":
        return SafeEval.evalUnaryExpression(ast, subs);
      case "ArrayExpression":
        return SafeEval.evalArrayExpression(ast, subs);
      case "CallExpression":
        return SafeEval.evalCallExpression(ast, subs);
      case "AssignmentExpression":
        return SafeEval.evalAssignmentExpression(ast, subs);
      default:
        throw SyntaxError("Unexpected expression", ast);
    }
  },
  evalBinaryExpression: function evalBinaryExpression(ast, subs) {
    var result = {
      "||": function _2(a2, b2) {
        return a2 || b2();
      },
      "&&": function _2(a2, b2) {
        return a2 && b2();
      },
      "|": function _2(a2, b2) {
        return a2 | b2();
      },
      "^": function _2(a2, b2) {
        return a2 ^ b2();
      },
      "&": function _2(a2, b2) {
        return a2 & b2();
      },
      // eslint-disable-next-line eqeqeq
      "==": function _2(a2, b2) {
        return a2 == b2();
      },
      // eslint-disable-next-line eqeqeq
      "!=": function _2(a2, b2) {
        return a2 != b2();
      },
      "===": function _2(a2, b2) {
        return a2 === b2();
      },
      "!==": function _2(a2, b2) {
        return a2 !== b2();
      },
      "<": function _2(a2, b2) {
        return a2 < b2();
      },
      ">": function _2(a2, b2) {
        return a2 > b2();
      },
      "<=": function _2(a2, b2) {
        return a2 <= b2();
      },
      ">=": function _2(a2, b2) {
        return a2 >= b2();
      },
      "<<": function _2(a2, b2) {
        return a2 << b2();
      },
      ">>": function _2(a2, b2) {
        return a2 >> b2();
      },
      ">>>": function _2(a2, b2) {
        return a2 >>> b2();
      },
      "+": function _2(a2, b2) {
        return a2 + b2();
      },
      "-": function _2(a2, b2) {
        return a2 - b2();
      },
      "*": function _2(a2, b2) {
        return a2 * b2();
      },
      "/": function _2(a2, b2) {
        return a2 / b2();
      },
      "%": function _2(a2, b2) {
        return a2 % b2();
      }
    }[ast.operator](SafeEval.evalAst(ast.left, subs), function() {
      return SafeEval.evalAst(ast.right, subs);
    });
    return result;
  },
  evalCompound: function evalCompound(ast, subs) {
    var last;
    for (var i2 = 0; i2 < ast.body.length; i2++) {
      if (ast.body[i2].type === "Identifier" && ["var", "let", "const"].includes(ast.body[i2].name) && ast.body[i2 + 1] && ast.body[i2 + 1].type === "AssignmentExpression") {
        i2 += 1;
      }
      var expr = ast.body[i2];
      last = SafeEval.evalAst(expr, subs);
    }
    return last;
  },
  evalConditionalExpression: function evalConditionalExpression(ast, subs) {
    if (SafeEval.evalAst(ast.test, subs)) {
      return SafeEval.evalAst(ast.consequent, subs);
    }
    return SafeEval.evalAst(ast.alternate, subs);
  },
  evalIdentifier: function evalIdentifier(ast, subs) {
    if (ast.name in subs) {
      return subs[ast.name];
    }
    throw ReferenceError("".concat(ast.name, " is not defined"));
  },
  evalLiteral: function evalLiteral(ast) {
    return ast.value;
  },
  evalMemberExpression: function evalMemberExpression(ast, subs) {
    var prop = ast.computed ? SafeEval.evalAst(ast.property) : ast.property.name;
    var obj = SafeEval.evalAst(ast.object, subs);
    var result = obj[prop];
    if (typeof result === "function") {
      return result.bind(obj);
    }
    return result;
  },
  evalUnaryExpression: function evalUnaryExpression(ast, subs) {
    var result = {
      "-": function _2(a2) {
        return -SafeEval.evalAst(a2, subs);
      },
      "!": function _2(a2) {
        return !SafeEval.evalAst(a2, subs);
      },
      "~": function _2(a2) {
        return ~SafeEval.evalAst(a2, subs);
      },
      // eslint-disable-next-line no-implicit-coercion
      "+": function _2(a2) {
        return +SafeEval.evalAst(a2, subs);
      }
    }[ast.operator](ast.argument);
    return result;
  },
  evalArrayExpression: function evalArrayExpression(ast, subs) {
    return ast.elements.map(function(el2) {
      return SafeEval.evalAst(el2, subs);
    });
  },
  evalCallExpression: function evalCallExpression(ast, subs) {
    var args = ast.arguments.map(function(arg) {
      return SafeEval.evalAst(arg, subs);
    });
    var func = SafeEval.evalAst(ast.callee, subs);
    return func.apply(void 0, _toConsumableArray(args));
  },
  evalAssignmentExpression: function evalAssignmentExpression(ast, subs) {
    if (ast.left.type !== "Identifier") {
      throw SyntaxError("Invalid left-hand side in assignment");
    }
    var id2 = ast.left.name;
    var value = SafeEval.evalAst(ast.right, subs);
    subs[id2] = value;
    return subs[id2];
  }
};
var SafeScript = /* @__PURE__ */ function() {
  function SafeScript2(expr) {
    _classCallCheck$3(this, SafeScript2);
    this.code = expr;
    this.ast = jsep(this.code);
  }
  return _createClass$3(SafeScript2, [{
    key: "runInNewContext",
    value: function runInNewContext(context) {
      var keyMap = _objectSpread2({}, context);
      return SafeEval.evalAst(this.ast, keyMap);
    }
  }]);
}();
var Script = /* @__PURE__ */ function() {
  function Script2(expr) {
    _classCallCheck$3(this, Script2);
    this.code = expr;
  }
  return _createClass$3(Script2, [{
    key: "runInNewContext",
    value: function runInNewContext(context) {
      var expr = this.code;
      var keys = Object.keys(context);
      var funcs = [];
      moveToAnotherArray(keys, funcs, function(key) {
        return typeof context[key] === "function";
      });
      var values = keys.map(function(vr2) {
        return context[vr2];
      });
      var funcString = funcs.reduce(function(s2, func) {
        var fString = context[func].toString();
        if (!/function/.test(fString)) {
          fString = "function " + fString;
        }
        return "var " + func + "=" + fString + ";" + s2;
      }, "");
      expr = funcString + expr;
      if (!/(["'])use strict\1/.test(expr) && !keys.includes("arguments")) {
        expr = "var arguments = undefined;" + expr;
      }
      expr = expr.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      var lastStatementEnd = expr.lastIndexOf(";");
      var code = lastStatementEnd > -1 ? expr.slice(0, lastStatementEnd + 1) + " return " + expr.slice(lastStatementEnd + 1) : " return " + expr;
      return _construct$2(Function, keys.concat([code])).apply(void 0, _toConsumableArray(values));
    }
  }]);
}();
JSONPath.prototype.vm = {
  Script
};
JSONPath.prototype.safeVm = {
  Script: SafeScript
};
class JsonPathConverter {
  constructor(converterDescriptor) {
    __publicField(this, "labelKey");
    __publicField(this, "valueKey");
    __publicField(this, "jsonPath");
    this.labelKey = isNullOrUndefinedOrWhiteSpace(converterDescriptor.labelKey) ? void 0 : converterDescriptor.labelKey;
    this.valueKey = isNullOrUndefinedOrWhiteSpace(converterDescriptor.valueKey) ? void 0 : converterDescriptor.valueKey;
    this.jsonPath = converterDescriptor.path;
  }
  convert(input) {
    let result = isNullOrUndefinedOrWhiteSpace(this.jsonPath) ? input : JSONPath({ path: this.jsonPath, json: input });
    if (result == void 0) {
      return result;
    }
    if (Array.isArray(result)) {
      let newArray = [];
      result.forEach((item) => {
        newArray.push(this.convertItem(item));
      });
      return newArray;
    }
    return this.convertItem(result);
  }
  convertItem(item) {
    let result = { ...item };
    if (this.labelKey != void 0) {
      result["label"] = item[this.labelKey];
    }
    if (this.valueKey != void 0) {
      result["value"] = item[this.valueKey];
    }
    return result;
  }
}
const createDataConverter = (dataConverterDescriptor) => {
  if ((dataConverterDescriptor == null ? void 0 : dataConverterDescriptor.type) == void 0) {
    return void 0;
  }
  switch (dataConverterDescriptor.type) {
    case "jsonPathConverter":
      return new JsonPathConverter(dataConverterDescriptor);
    default:
      throw new Error(`${dataConverterDescriptor.type} not implemented.`);
  }
};
class DataConverter {
  convert(input, dataConverterDescriptor) {
    let converter2 = createDataConverter(dataConverterDescriptor);
    if (converter2) {
      return converter2.convert(input);
    } else {
      return input;
    }
  }
}
const dataConverter = new DataConverter();
class DataSourceManager {
  async getData(dataSourceDescriptor) {
    var _a3, _b3;
    const dataSource = createDataSource(dataSourceDescriptor);
    let data = await dataSource.getData();
    if (((_a3 = dataSourceDescriptor.settings) == null ? void 0 : _a3.dataConverter) !== void 0) {
      data = dataConverter.convert(data, (_b3 = dataSourceDescriptor.settings) == null ? void 0 : _b3.dataConverter);
    }
    return data;
  }
}
const dataSourceManager = new DataSourceManager();
const configProviderContextKey = Symbol("configProvider");
const provideVantisGlobalConfig = (configProviderContext) => {
  if (!isRef(configProviderContext)) {
    configProviderContext = ref(configProviderContext);
  }
  provide(configProviderContextKey, configProviderContext);
};
const injectVantisGlobalConfig = () => {
  return inject(configProviderContextKey);
};
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "DataSource",
  props: {
    dataSource: { type: [Object, Function] },
    dataSourceChangeToken: {},
    lazy: { type: Boolean }
  },
  setup(__props) {
    var _a3, _b3;
    const logger = new Logger("DataSource.Vue");
    const props = __props;
    const vGlobalConfig = injectVantisGlobalConfig();
    HttpDataSource.httpClient = new HttpClient((_a3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a3.axiosInstance, (_b3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _b3.axiosRequestConfig);
    const data = ref();
    const loading = ref(false);
    watch(() => {
      if (isFunction$3(props.dataSourceChangeToken)) {
        try {
          return props.dataSourceChangeToken();
        } catch (error) {
          logger.error("watch dataSourceChangeToken error", error);
        }
      }
      return props.dataSourceChangeToken;
    }, () => {
      data.value = void 0;
      loading.value = false;
      if (!props.lazy) {
        load();
      }
    }, { deep: true });
    const load = async () => {
      if (data.value != void 0) {
        return;
      }
      if (!props.dataSource) {
        console.warn("DataSource组件没有配置相关数据源");
        return;
      }
      loading.value = true;
      if (isFunction$3(props.dataSource)) {
        data.value = await props.dataSource();
      } else {
        data.value = await dataSourceManager.getData(props.dataSource);
      }
      loading.value = false;
    };
    if (!props.lazy) {
      load();
    }
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default", {
        data: data.value,
        loading: loading.value,
        load
      });
    };
  }
});
const VcDataSource = withInstall(_sfc_main$P);
class DataSourceWrapperBuilder extends DefaultComponentBuilder {
  constructor(itemsSlotName = "default", supportSlotNames = ["default"]) {
    super(supportSlotNames);
    __publicField(this, "itemsSlotName");
    this.itemsSlotName = itemsSlotName;
  }
  buildNormal(context) {
    return this.buildDataSourceComponent(context);
  }
  buildDesign(context) {
    return this.buildDataSourceComponent(context);
  }
  buildDataSourceComponent(context) {
    let dataSource = context.schema.__config__.dataSource;
    if (dataSource === void 0) {
      return super.buildNormal(context);
    }
    let props = { dataSource: () => {
      const actualDataSource = renderPlaceholder(dataSource, context.formModel);
      return dataSourceManager.getData(actualDataSource);
    }, lazy: false, dataSourceChangeToken: () => renderPlaceholder(dataSource, context.formModel) };
    let slots = this.buildDataSourceSlots(context);
    return h$3(VcDataSource, props, slots);
  }
  buildSimple(context) {
    let dataSource = context.schema.__config__.dataSource;
    if (dataSource === void 0) {
      return super.buildSimple(context);
    }
    let props = { dataSource, lazy: false };
    let slots = this.buildDataSourceSlots(context);
    return h$3(VcDataSource, props, slots);
  }
  buildDataSourceSlots(context) {
    return {
      default: (dataSource) => {
        context.data = dataSource.data;
        context.loading = dataSource.loading;
        context.load = dataSource.load;
        return this.buildByRenderMode(context);
      }
    };
  }
  buildByRenderMode(context) {
    switch (context.renderMode) {
      case RenderMode.design:
        return super.buildDesign(context);
      case RenderMode.mini:
        return super.buildMini(context);
      case RenderMode.normalWithFormItem:
        return super.buildNormal(context);
      case RenderMode.normalWithoutFormItem:
        return super.buildNormal(context);
      case RenderMode.simple:
        return super.buildSimple(context);
      default:
        return super.buildNormal(context);
    }
  }
  buildSlots(context) {
    let slots = this.buildNamedSlots(context, this.supportSlots.filter((s2) => s2 != this.itemsSlotName));
    if (!slots) {
      return;
    }
    let slotConfig = this.getSlotConfig(context.schema.__slot__, this.itemsSlotName);
    slots[this.itemsSlotName] = this.buildItemsSlot(context, slotConfig);
    return slots;
  }
  buildItemVNode(context, item, slotConfig) {
    throw new Error("not implemented");
  }
  buildItemsSlot(context, slotConfig) {
    let data = context.data;
    return () => {
      if (data) {
        let vNodes = [];
        let vNode;
        for (let item of data) {
          vNode = this.buildItemVNode(context, item, slotConfig);
          vNodes.push(vNode);
        }
        return vNodes;
      }
    };
  }
}
class ElCheckboxGroupBuilder extends DataSourceWrapperBuilder {
  constructor() {
    super("default", ["default"]);
  }
  isVModelSupported(component2) {
    return true;
  }
  buildItemVNode(context, item, slotConfig) {
    let optionTag = slotConfig.optionTag ?? "el-checkbox";
    return h$3(resolveComponent(optionTag), { label: item.label, value: item.value, disabled: item.disabled, key: item.value + ":" + optionTag });
  }
  buildEvents(context) {
    var _a3;
    let props = {};
    let vModelFieldName = context.schema.__vModel__;
    if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
      props.modelValue = (_a3 = context.formModel) == null ? void 0 : _a3[vModelFieldName];
      props["onUpdate:modelValue"] = (value) => {
        context.formModel[vModelFieldName] = value;
        let data = context.data;
        if (data) {
          const options = data.filter((item) => value.includes(item.value));
          if (options) {
            setRedundancyValue(context, options.map((item) => item.label).join(","));
          }
        }
      };
    }
    return props;
  }
}
class ElSelectBuilder extends DataSourceWrapperBuilder {
  constructor() {
    super("default", ["default", "header", "footer", "prefix", "empty", "tag", "loading"]);
  }
  isVModelSupported(component2) {
    return true;
  }
  buildEvents(context) {
    var _a3, _b3;
    let props = {};
    let vModelFieldName = context.schema.__vModel__;
    if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
      const model = (_a3 = context.formModel) == null ? void 0 : _a3[vModelFieldName];
      if (context.schema.multiple == true) {
        if (model != void 0 && !Array.isArray(model)) {
          context.formModel[vModelFieldName] = [model];
        }
      } else {
        if (Array.isArray(model)) {
          context.formModel[vModelFieldName] = model.length > 0 ? model[0] : void 0;
        }
      }
      props.modelValue = (_b3 = context.formModel) == null ? void 0 : _b3[vModelFieldName];
      props["onUpdate:modelValue"] = (value) => {
        context.formModel[vModelFieldName] = value;
        let data = context.data;
        if (data) {
          if (context.schema.multiple == true) {
            if (Array.isArray(value)) {
              const options = data.filter((item) => value.includes(item.value));
              if (options) {
                setRedundancyValue(context, options.map((item) => item.label).join(","));
              }
            }
          } else {
            const option = data.firstOrUndefined((item) => item.value == value);
            if (option) {
              setRedundancyValue(context, option.label);
            }
          }
        }
        context.emit("update:" + vModelFieldName + ":modelValue", value);
      };
      props["onClear"] = () => {
        removeRedundancyValue(context);
      };
    }
    return props;
  }
  buildDataSourceComponent(context) {
    let dataSource = context.schema.__config__.dataSource;
    if (dataSource === void 0) {
      return super.buildNormal(context);
    }
    let lazy = ElSelectBuilder.ensureDefaultItems(dataSource, context);
    let props = {
      dataSource: () => {
        const actualDataSource = renderPlaceholder(dataSource, context.formModel);
        return dataSourceManager.getData(actualDataSource);
      },
      lazy,
      dataSourceChangeToken: () => renderPlaceholder(dataSource, context.formModel)
    };
    let slots = this.buildDataSourceSlots(context);
    return h$3(VcDataSource, props, slots);
  }
  static ensureDefaultItems(dataSource, context) {
    let fieldValue = context.formModel[context.schema.__vModel__];
    if (fieldValue === void 0) {
      return true;
    }
    let lazy = false;
    if (dataSource.type !== "fixed") {
      let redundancy__vModel__ = context.formModel["redundancy-" + context.schema.__vModel__];
      if (fieldValue && redundancy__vModel__) {
        if (Array.isArray(fieldValue) && context.schema.multiple == true) {
          const labels = redundancy__vModel__.split(",");
          const items = [];
          for (let i2 = 0; i2 < fieldValue.length; i2++) {
            items.push({ label: labels.length > i2 ? labels[i2] : fieldValue[i2], value: fieldValue[i2] });
          }
          context.defaultItems = items;
        } else {
          context.defaultItems = [{ label: redundancy__vModel__, value: fieldValue }];
        }
        lazy = true;
        context.lazy = lazy;
      }
    }
    return lazy;
  }
  buildProps(context) {
    let props = super.buildProps(context);
    props.onFocus = () => context.load();
    props.loading = context.loading;
    return props;
  }
  buildItemsSlot(context, slotConfig) {
    let data = context.data;
    let defaultItems = context.defaultItems;
    let lazy = context.lazy;
    return () => {
      if (data) {
        let vNodes = [];
        let vNode;
        for (let item of data) {
          vNode = h$3(resolveComponent("el-option"), { key: item.label, value: item.value, label: item.label });
          vNodes.push(vNode);
        }
        return vNodes;
      } else if (lazy && defaultItems) {
        let vNodes = [];
        let vNode;
        for (let item of defaultItems) {
          vNode = h$3(resolveComponent("el-option"), { key: item.label, value: item.value, label: item.label });
          vNodes.push(vNode);
        }
        return vNodes;
      }
      return [];
    };
  }
  ensureRenderKey(context) {
    return super.ensureRenderKey(context) + (context.schema.multiple ? "1" : "0");
  }
}
class ElRadioGroupBuilder extends DataSourceWrapperBuilder {
  constructor() {
    super("default", ["default"]);
  }
  isVModelSupported(component2) {
    return true;
  }
  buildItemVNode(context, item, slotConfig) {
    let optionTag = slotConfig.optionTag ?? "el-option";
    return h$3(resolveComponent(optionTag), { key: item.value + ":" + optionTag, value: item.value, label: item.label, disabled: item.disabled });
  }
  buildEvents(context) {
    var _a3;
    let props = {};
    let vModelFieldName = context.schema.__vModel__;
    if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
      props.modelValue = (_a3 = context.formModel) == null ? void 0 : _a3[vModelFieldName];
      props["onUpdate:modelValue"] = (value) => {
        context.formModel[vModelFieldName] = value;
        let data = context.data;
        if (data) {
          const option = data.find((item) => value == item.value);
          if (option) {
            setRedundancyValue(context, option.label);
          }
        }
      };
    }
    return props;
  }
}
class ElInputNumberBuilder extends DefaultComponentBuilder {
  constructor() {
    super();
    this.supportSlots = ["decreaseIcon", "increaseIcon"];
  }
  buildNamedSlot(context) {
    if (context.slotName === "decreaseIcon") {
      context.slotName = "decrease-icon";
    }
    if (context.slotName === "increaseIcon") {
      context.slotName = "increase-icon";
    }
    if (isString$1(context.slotConfig)) {
      return () => h$3(resolveComponent("el-icon"), { size: 20 }, () => h$3(resolveComponent(context.slotConfig)));
    }
    return super.buildNamedSlot(context);
  }
}
class ElInputBuilder extends DefaultComponentBuilder {
  constructor() {
    super();
    this.supportSlots = ["prefix", "suffix", "prepend", "append"];
  }
  buildNamedSlot(context) {
    if (isString$1(context.slotConfig) && ["prepend", "append"].includes(context.slotName)) {
      return () => h$3(resolveComponent("el-icon"), { size: 20 }, () => h$3(resolveComponent(context.slotConfig)));
    }
    return super.buildNamedSlot(context);
  }
  ensureRenderKey(context) {
    var _a3;
    return super.ensureRenderKey(context) + ":" + ((_a3 = context.schema.__slot__) == null ? void 0 : _a3.suffix);
  }
}
class ElRowBuilder extends DefaultComponentBuilder {
  constructor() {
    super();
  }
  buildDesign(context) {
    return h$3(lo$2);
  }
}
class ElButtonBuilder extends DefaultComponentBuilder {
  buildSetup(context, props) {
    var _a3;
    if (context.renderMode == RenderMode.mini) {
      return;
    }
    let purpose = (_a3 = context.schema.__config__) == null ? void 0 : _a3.purpose;
    if (!purpose) {
      return;
    }
  }
  buildEvents(context) {
    var _a3;
    let purpose = (_a3 = context.schema.__config__) == null ? void 0 : _a3.purpose;
    let nativeType = context.schema.nativeType;
    return {
      "onClick": async (event) => {
        var _a4, _b3;
        event.preventDefault();
        if (nativeType == "button") {
          context.emit(`${purpose}Click`, context.formModel, event);
        } else if (nativeType == "reset") {
          (_a4 = context.formState) == null ? void 0 : _a4.reset();
        } else {
          await ((_b3 = context.formState) == null ? void 0 : _b3.submit(purpose, context.schema.__config__.additionalData, context.schema.__config__.action));
        }
      }
    };
  }
  buildNamedSlot(context) {
    if (context.slotName === "default") {
      if (isString$1(context.slotConfig)) {
        return () => context.t(context.slotConfig);
      }
    }
    return super.buildNamedSlot(context);
  }
}
/**
* @vue/shared v3.5.14
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
!!(process.env.NODE_ENV !== "production") ? Object.freeze({}) : {};
!!(process.env.NODE_ENV !== "production") ? Object.freeze([]) : [];
const NOOP = () => {
};
const isFunction$2 = (val) => typeof val === "function";
const isObject$3 = (val) => val !== null && typeof val === "object";
const isPromise = (val) => {
  return (isObject$3(val) || isFunction$2(val)) && isFunction$2(val.then) && isFunction$2(val.catch);
};
var freeGlobal$2 = typeof global == "object" && global && global.Object === Object && global;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$2 = freeGlobal$2 || freeSelf$1 || Function("return this")();
var Symbol$4 = root$2.Symbol;
var objectProto$4 = Object.prototype;
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
var nativeObjectToString$1 = objectProto$4.toString;
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e10) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$3 = Object.prototype;
var nativeObjectToString = objectProto$3.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
function arrayMap(array4, iteratee) {
  var index2 = -1, length = array4 == null ? 0 : array4.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array4[index2], index2, array4);
  }
  return result;
}
var isArray$2 = Array.isArray;
var symbolProto = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$2(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function isObject$2(value) {
  var type4 = typeof value;
  return value != null && (type4 == "object" || type4 == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$2["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e10) {
    }
    try {
      return func + "";
    } catch (e10) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$2 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern4 = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern4.test(toSource(value));
}
function getValue$1(object4, key) {
  return object4 == null ? void 0 : object4[key];
}
function getNative(object4, key) {
  var value = getValue$1(object4, key);
  return baseIsNative(value) ? value : void 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object4) {
  if (isArray$2(value)) {
    return false;
  }
  var type4 = typeof value;
  if (type4 == "number" || type4 == "symbol" || type4 == "boolean" || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object4 != null && value in Object(object4);
}
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
var objectProto$1 = Object.prototype;
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? void 0 : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : void 0;
}
var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$1.call(data, key);
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array4, key) {
  var length = array4.length;
  while (length--) {
    if (eq(array4[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$2, "Map");
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type4 = typeof value;
  return type4 == "string" || type4 == "number" || type4 == "symbol" || type4 == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string3) {
  var result = [];
  if (string3.charCodeAt(0) === 46) {
    result.push("");
  }
  string3.replace(rePropName, function(match, number4, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match);
  });
  return result;
});
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object4) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey(value, object4) ? [value] : stringToPath(toString$1(value));
}
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -Infinity ? "-0" : result;
}
function baseGet(object4, path) {
  path = castPath(path, object4);
  var index2 = 0, length = path.length;
  while (object4 != null && index2 < length) {
    object4 = object4[toKey(path[index2++])];
  }
  return index2 && index2 == length ? object4 : void 0;
}
function get(object4, path, defaultValue) {
  var result = object4 == null ? void 0 : baseGet(object4, path);
  return result === void 0 ? defaultValue : result;
}
const buildTranslator = (locale) => (path, option) => translate(path, option, unref(locale));
const translate = (path, option, locale) => {
  if (locale == void 0) {
    return path;
  }
  const value = get(locale.vc, path, path);
  return value ? value.replace(
    /\{(\w+)\}/g,
    (_2, key) => `${(option == null ? void 0 : option[key]) ?? `{${key}}`}`
  ) : "";
};
const buildLocaleContext = (locale) => {
  const unRefLocale = unref(locale);
  const lang = computed(() => unRefLocale == void 0 ? void 0 : unRefLocale.name);
  const localeRef = isRef(locale) ? locale : ref(locale);
  return {
    lang,
    locale: localeRef,
    t: buildTranslator(locale)
  };
};
const useLocale = (localeOverrides) => {
  {
    const globalConfig = injectVantisGlobalConfig();
    return buildLocaleContext(computed(() => {
      var _a3;
      return (_a3 = globalConfig == null ? void 0 : globalConfig.value) == null ? void 0 : _a3.locale;
    }));
  }
};
const _hoisted_1$t = { class: "el-upload__text" };
const _hoisted_2$a = { class: "el-upload__tip" };
const _hoisted_3$4 = ["src", "crossorigin"];
const _hoisted_4$3 = ["href", "download"];
const _hoisted_5$2 = ["title"];
const _hoisted_6$1 = ["onClick"];
const _hoisted_7 = ["title"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  ...{
    name: "VcUpload"
  },
  __name: "Upload",
  props: /* @__PURE__ */ mergeModels({
    ...uploadProps,
    maxSize: { type: Number, required: false },
    downUrl: { type: String },
    readonly: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const config = injectVantisGlobalConfig();
    const nsUpload = useNamespace("upload");
    const nsIcon = useNamespace("icon");
    const props = __props;
    const uploadElm = ref();
    const { t: t2 } = useLocale();
    const tips = ref("");
    const fileList = ref();
    const model = useModel(__props, "modelValue");
    fileList.value = [...model.value || []];
    !(props.disabled || props.readonly);
    const handleChange = (uploadFile, uploadFiles) => {
      var _a3;
      if (props.maxSize && props.maxSize > 0) {
        let totalSize = computeTotalSize(uploadFiles);
        if (totalSize > props.maxSize) {
          ElMessage({
            duration: 1e3,
            message: t2("GreaterThanMaxSize"),
            type: "error",
            customClass: "zIndex"
          });
          (_a3 = uploadElm.value) == null ? void 0 : _a3.handleRemove(uploadFile);
          return;
        }
      }
      props.onChange(uploadFile, uploadFiles);
    };
    const computeTotalSize = (uploadFiles) => {
      let total = 0;
      for (let uploadFile of uploadFiles) {
        total += uploadFile.size;
      }
      return total;
    };
    const handlePreview = (preview) => {
      props.onPreview(preview);
    };
    const handleRemove = (uploadFile, uploadFiles) => {
      if (uploadFile.status == "success") ;
      props.onRemove(uploadFile, uploadFiles);
    };
    const handleSuccess = (response, uploadFile, uploadFiles) => {
      countDownEvent.resolve(uploadFile.uid);
      props.onSuccess(response, uploadFile, uploadFiles);
    };
    const handleError = (error, uploadFile, uploadFiles) => {
      var _a3;
      countDownEvent.reject(uploadFile.uid, error);
      if (props.onError == NOOP) {
        (_a3 = uploadElm == null ? void 0 : uploadElm.value) == null ? void 0 : _a3.clearFiles();
        ElMessage({
          duration: 1e3,
          message: t2("UploadFailedDetails") + ":" + error,
          type: "error",
          customClass: "zIndex"
        });
      } else {
        props.onError(error, uploadFile, uploadFiles);
      }
    };
    const handleExceed = (files, uploadFiles) => {
      props.onExceed(files, uploadFiles);
    };
    const countDownEvent = new CountDownEvent();
    const handleBeforeUpload = (rawFile) => {
      countDownEvent.addCountIfNotExists(rawFile.uid);
      props.beforeUpload(rawFile);
    };
    const uploadAll = async () => {
      var _a3;
      if (!props.autoUpload) {
        (_a3 = uploadElm.value) == null ? void 0 : _a3.submit();
      }
      try {
        await countDownEvent.wait();
        return true;
      } catch {
        return false;
      }
    };
    watch(fileList, (newVal, oldVal) => {
      let uploadedFiles = newVal == null ? void 0 : newVal.filter((f2) => f2.status == "success");
      model.value = uploadedFiles == null ? void 0 : uploadedFiles.map((f2) => {
        return { name: f2.name, status: f2.status, size: f2.size, uid: f2.uid, ...f2.response, url: createDownUrl(f2) };
      });
    }, { deep: true });
    const createDownUrl = (file) => {
      var _a3;
      let downBaseUrl = (config == null ? void 0 : config.value.downBaseUrl) || "";
      if (checkHostname(props.downUrl || "")) downBaseUrl = "";
      return downBaseUrl + renderNamedPlaceholder(props.downUrl || "", { id: file.id || ((_a3 = file.response) == null ? void 0 : _a3.id) });
    };
    function checkHostname(url2) {
      let hostname = false;
      try {
        let parsedUrl = new URL(url2);
        hostname = true;
        console.log(parsedUrl);
      } catch {
      }
      return hostname;
    }
    const requestHeaders = computed(() => {
      var _a3, _b3;
      let mergeHeaders = /* @__PURE__ */ new Map();
      let pHeaders = props.headers || {};
      if (pHeaders instanceof Headers) {
        pHeaders.forEach((value, key) => mergeHeaders.set(key, value));
      } else {
        for (const [key, value] of Object.entries(pHeaders)) {
          if (value == null) continue;
          mergeHeaders.set(key, String(value));
        }
      }
      if ((_a3 = config == null ? void 0 : config.value.axiosInstance) == null ? void 0 : _a3.defaults.headers) {
        return { ...mergeHeaders, ...(_b3 = config.value.axiosInstance) == null ? void 0 : _b3.defaults.headers };
      }
      return mergeHeaders;
    });
    __expose({ uploadAll });
    return (_ctx, _cache) => {
      const _component_el_icon = resolveComponent("el-icon");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_progress = resolveComponent("el-progress");
      const _component_el_upload = resolveComponent("el-upload");
      return openBlock(), createBlock(_component_el_upload, {
        ref_key: "uploadElm",
        ref: uploadElm,
        "file-list": fileList.value,
        "onUpdate:fileList": _cache[0] || (_cache[0] = ($event) => fileList.value = $event),
        action: _ctx.action,
        headers: requestHeaders.value,
        "on-change": handleChange,
        "on-preview": handlePreview,
        "on-remove": handleRemove,
        "on-success": handleSuccess,
        "on-error": handleError,
        "on-exceed": handleExceed,
        name: _ctx.name,
        "list-type": _ctx.listType,
        drag: _ctx.drag,
        "before-upload": handleBeforeUpload,
        disabled: __props.disabled || __props.readonly
      }, {
        trigger: withCtx(() => [
          _ctx.drag ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: withCtx(() => [
                createVNode(unref(upload_filled_default))
              ]),
              _: 1
            }),
            createElementVNode("div", _hoisted_1$t, toDisplayString(unref(t2)("DropFileToUpload")), 1)
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            _ctx.listType == "picture-card" ? (openBlock(), createBlock(_component_el_icon, { key: 0 }, {
              default: withCtx(() => [
                createVNode(unref(plus_default))
              ]),
              _: 1
            })) : (openBlock(), createBlock(_component_el_button, {
              key: 1,
              crossorigin: "anonymous",
              disabled: __props.disabled,
              type: "primary"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("ClickToUpload")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          ], 64))
        ]),
        tip: withCtx(() => [
          createElementVNode("div", _hoisted_2$a, toDisplayString(tips.value), 1)
        ]),
        file: withCtx(({ file }) => [
          _ctx.listType === "picture" || file.status !== "uploading" && _ctx.listType === "picture-card" ? (openBlock(), createElementBlock("img", {
            key: 0,
            class: normalizeClass(unref(nsUpload).be("list", "item-thumbnail")),
            src: file.url,
            crossorigin: _ctx.crossorigin,
            alt: ""
          }, null, 10, _hoisted_3$4)) : createCommentVNode("", true),
          file.status === "success" && _ctx.listType !== "picture-card" ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass(unref(nsUpload).be("list", "item-info"))
          }, [
            createElementVNode("a", {
              class: normalizeClass(unref(nsUpload).be("list", "item-name")),
              href: createDownUrl(file),
              download: file.name,
              style: { "text-decoration": "underline" }
            }, [
              createVNode(_component_el_icon, {
                class: normalizeClass(unref(nsIcon).m("document"))
              }, {
                default: withCtx(() => [
                  createVNode(unref(document_default))
                ]),
                _: 1
              }, 8, ["class"]),
              createElementVNode("span", {
                class: normalizeClass(unref(nsUpload).be("list", "item-file-name")),
                title: file.name
              }, toDisplayString(file.name), 11, _hoisted_5$2)
            ], 10, _hoisted_4$3)
          ], 2)) : file.status === "uploading" || _ctx.listType !== "picture-card" ? (openBlock(), createElementBlock("div", {
            key: 2,
            class: normalizeClass(unref(nsUpload).be("list", "item-info"))
          }, [
            createElementVNode("a", {
              class: normalizeClass(unref(nsUpload).be("list", "item-name")),
              onClick: withModifiers(($event) => handlePreview(file), ["prevent"])
            }, [
              createVNode(_component_el_icon, {
                class: normalizeClass(unref(nsIcon).m("document"))
              }, {
                default: withCtx(() => [
                  createVNode(unref(document_default))
                ]),
                _: 1
              }, 8, ["class"]),
              createElementVNode("span", {
                class: normalizeClass(unref(nsUpload).be("list", "item-file-name")),
                title: file.name
              }, toDisplayString(file.name), 11, _hoisted_7)
            ], 10, _hoisted_6$1),
            file.status === "uploading" ? (openBlock(), createBlock(_component_el_progress, {
              key: 0,
              type: _ctx.listType === "picture-card" ? "circle" : "line",
              "stroke-width": _ctx.listType === "picture-card" ? 6 : 2,
              percentage: Number(file.percentage),
              style: normalizeStyle(_ctx.listType === "picture-card" ? "" : "margin-top: 0.5rem")
            }, null, 8, ["type", "stroke-width", "percentage", "style"])) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true),
          createElementVNode("label", {
            class: normalizeClass(unref(nsUpload).be("list", "item-status-label"))
          }, [
            _ctx.listType === "text" ? (openBlock(), createBlock(_component_el_icon, {
              key: 0,
              class: normalizeClass([unref(nsIcon).m("upload-success"), unref(nsIcon).m("circle-check")])
            }, {
              default: withCtx(() => [
                createVNode(unref(circle_check_default))
              ]),
              _: 1
            }, 8, ["class"])) : ["picture-card", "picture"].includes(_ctx.listType) ? (openBlock(), createBlock(_component_el_icon, {
              key: 1,
              class: normalizeClass([unref(nsIcon).m("upload-success"), unref(nsIcon).m("check")])
            }, {
              default: withCtx(() => [
                createVNode(unref(check_default))
              ]),
              _: 1
            }, 8, ["class"])) : createCommentVNode("", true)
          ], 2),
          !__props.disabled ? (openBlock(), createBlock(_component_el_icon, {
            key: 3,
            class: normalizeClass(unref(nsIcon).m("close")),
            onClick: ($event) => {
              var _a3;
              return (_a3 = uploadElm.value) == null ? void 0 : _a3.handleRemove(file);
            }
          }, {
            default: withCtx(() => [
              createVNode(unref(close_default))
            ]),
            _: 2
          }, 1032, ["class", "onClick"])) : createCommentVNode("", true),
          !__props.disabled ? (openBlock(), createElementBlock("i", {
            key: 4,
            class: normalizeClass(unref(nsIcon).m("close-tip"))
          }, toDisplayString(unref(t2)("el.upload.deleteTip")), 3)) : createCommentVNode("", true),
          _ctx.listType === "picture-card" ? (openBlock(), createElementBlock("span", {
            key: 5,
            class: normalizeClass(unref(nsUpload).be("list", "item-actions"))
          }, [
            createElementVNode("span", {
              class: normalizeClass(unref(nsUpload).be("list", "item-preview")),
              onClick: ($event) => handlePreview(file)
            }, [
              createVNode(_component_el_icon, {
                class: normalizeClass(unref(nsIcon).m("zoom-in"))
              }, {
                default: withCtx(() => [
                  createVNode(unref(zoom_in_default))
                ]),
                _: 1
              }, 8, ["class"])
            ], 10, _hoisted_8),
            !__props.disabled ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: normalizeClass(unref(nsUpload).be("list", "item-delete")),
              onClick: () => {
                var _a3;
                return (_a3 = uploadElm.value) == null ? void 0 : _a3.handleRemove(file);
              }
            }, [
              createVNode(_component_el_icon, {
                class: normalizeClass(unref(nsIcon).m("delete"))
              }, {
                default: withCtx(() => [
                  createVNode(unref(delete_default))
                ]),
                _: 1
              }, 8, ["class"])
            ], 10, _hoisted_9)) : createCommentVNode("", true)
          ], 2)) : createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["file-list", "action", "headers", "name", "list-type", "drag", "disabled"]);
    };
  }
});
class ElUploadBuilder extends DefaultComponentBuilder {
  buildSetup(context, props) {
    var _a3, _b3, _c3, _d3, _e3, _f3;
    if (context.renderMode == RenderMode.mini) {
      return;
    }
    let fieldName = context.schema.__vModel__;
    if (isNullOrUndefinedOrWhiteSpace(fieldName)) {
      return;
    }
    if (!((_a3 = context.formState) == null ? void 0 : _a3.formRefs.has(fieldName))) {
      (_b3 = context.formState) == null ? void 0 : _b3.formRefs.set(fieldName, ref());
    }
    props["ref"] = (_c3 = context.formState) == null ? void 0 : _c3.getOrCreateRef(fieldName);
    const field = (_e3 = (_d3 = context.formState) == null ? void 0 : _d3.formRefs.get(fieldName)) == null ? void 0 : _e3.value;
    field && ((_f3 = context.formState) == null ? void 0 : _f3.addSubmitFilterIfNotExists(context.schema.__vModel__, {
      before: (submitBody) => {
        return field.uploadAll();
      }
    }));
  }
  resolveComponent(context) {
    return _sfc_main$O;
  }
}
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "VTable",
  props: {
    tableSchema: {}
  },
  setup(__props) {
    const props = __props;
    const height = computed(() => props.tableSchema.height || "100%");
    const maxHeight = computed(() => props.tableSchema.maxHeight || 2e3);
    watch(height, async (newHeight) => {
      await nextTick();
      const table = document.querySelector(".el-table");
      if (table instanceof HTMLElement) {
        table.style.height = "auto";
        await nextTick();
        table.style.height = newHeight;
      }
    });
    const formatterValue = (row, column, cellValue) => {
      return cellValue;
    };
    onErrorCaptured((err) => {
      return false;
    });
    const { t: t2 } = useLocale();
    const columns = computed(() => props.tableSchema.__slot__.default.filter((i2) => i2.show === true));
    return (_ctx, _cache) => {
      const _component_el_table_column = resolveComponent("el-table-column");
      const _component_el_table = resolveComponent("el-table");
      return openBlock(), createBlock(_component_el_table, {
        data: _ctx.tableSchema.data,
        height: height.value,
        "max-height": maxHeight.value,
        border: "",
        stripe: "",
        "tooltip-effect": "light",
        size: _ctx.tableSchema.size,
        style: normalizeStyle({ width: _ctx.tableSchema.width || "100%" }),
        key: height.value
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(columns.value, (item, index2) => {
            return openBlock(), createBlock(_component_el_table_column, {
              key: index2,
              fixed: item.fixed,
              prop: item.prop,
              label: item.label ? unref(t2)(item.label) : item.prop,
              align: item.align ? item.align : "center",
              width: item.width,
              "show-overflow-tooltip": true,
              formatter: item.formatter ? item.formatter : formatterValue
            }, null, 8, ["fixed", "prop", "label", "align", "width", "formatter"]);
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "height", "max-height", "size", "style"]);
    };
  }
});
const _export_sfc$1 = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const VTable = /* @__PURE__ */ _export_sfc$1(_sfc_main$N, [["__scopeId", "data-v-b49eda6a"]]);
class ElTableBuilder extends DefaultComponentBuilder {
  buildNormal(context) {
    return this.buildTable(context);
  }
  buildTable(context) {
    const vModelFieldName = context.schema.__vModel__;
    if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
      context.schema["data"] = context.formModel[context.schema.__vModel__];
    }
    return h$3(VTable, { tableSchema: context.schema });
  }
  buildDesign(context) {
    return this.buildTable(context);
  }
  // protected buildDefaultSlot(context: IBuildContext): Function | undefined {
  //   if (!Array.isArray(context.schema?.__slot__?.default)) {
  //     return undefined
  //   }
  //   return () => {
  //     const columns = context.schema?.__slot__?.default.map((c: any) => this.buildTableColumn(c))
  //     return columns
  //   }
  // }
  //
  // protected buildTableProps(context: IBuildContext): Record<string, any> {
  //   const props = this.buildProps(context)
  //   const vModelFieldName = context.schema.__vModel__
  //   if (!isNullOrUndefinedOrWhiteSpace(vModelFieldName)) {
  //     props['data'] = context.formModel[context.schema.__vModel__]
  //   }
  //   props.key=this.ensureRenderKey(context);
  //   return props
  // }
  //
  // protected buildTableColumn(config: any) {
  //   let props: Record<string, any> = {};
  //   const fixedValues=['left','right'];
  //   Object.keys(config).forEach(key => {
  //     if (key === '__config__' || key === '__slot__' || key === '__methods__' || key === '__vModel__' || key == '__runtime__') {
  //       return
  //     }
  //     if(key=='fixed'){
  //       if(!fixedValues.includes(props[key])&&typeof props[key] != 'boolean'){
  //         return;
  //       }
  //     }
  //     props[key] = config[key]
  //   })
  //   props['key'] = config.prop
  //   return h(ElTableColumn, props);
  // }
}
class ElTimePickerBuilder extends DataSourceWrapperBuilder {
  ensureRenderKey(context) {
    return super.ensureRenderKey(context) + (context.schema.isRange ? "1" : "0");
  }
}
class ElDateTimePickerBuilder extends DataSourceWrapperBuilder {
  ensureRenderKey(context) {
    return super.ensureRenderKey(context) + (context.schema.arrowControl ? "1" : "0");
  }
}
const builderMap = {
  "el-checkbox-group": new ElCheckboxGroupBuilder(),
  "el-radio-group": new ElRadioGroupBuilder(),
  "el-select": new ElSelectBuilder(),
  "el-input-number": new ElInputNumberBuilder(),
  "el-input": new ElInputBuilder(),
  "el-row": new ElRowBuilder(),
  "el-button": new ElButtonBuilder(),
  "el-upload": new ElUploadBuilder(),
  "el-table": new ElTableBuilder(),
  "el-time-picker": new ElTimePickerBuilder(),
  "el-date-picker": new ElDateTimePickerBuilder()
  // "el-submit-button":new ElButtonBuilder()
};
const defaultBuilder = new DefaultComponentBuilder();
const getBuilder = (scheme) => {
  let builder = builderMap[scheme.__config__.tag];
  return builder ?? defaultBuilder;
};
const buildComponent = (buildContext) => {
  try {
    let builder = getBuilder(buildContext.schema);
    return builder.build(buildContext);
  } catch (error) {
    return h$3("div", getErrorMessage(error));
  }
};
const getErrorMessage = (error) => {
  if (error.message) {
    return error.message;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return "error";
  }
};
const _sfc_main$M = {
  props: ["schema", "renderMode"],
  setup(props, { slots }) {
    const { t: t2 } = useLocale();
    const globalContext = {};
    return { t: t2, globalContext };
  },
  render() {
    return buildComponent({
      schema: this.schema,
      renderMode: this.renderMode,
      formModel: void 0,
      formConfig: void 0,
      emit: this.$emit,
      t: this.t,
      globalContext: this.globalContext
    });
  }
};
const isRow = (scheme) => {
  var _a3;
  return ((_a3 = scheme.__config__) == null ? void 0 : _a3.tag) == "el-row";
};
const isCol = (scheme) => {
  var _a3;
  return ((_a3 = scheme.__config__) == null ? void 0 : _a3.tag) == "el-col";
};
const layoutDesign = (fieldSchemas) => {
  return fieldSchemas.map((f2) => createColScheme(f2));
};
const calculateRows = (fieldSchemes) => {
  var _a3, _b3;
  let elRows = [];
  let span = 0;
  let newSpan = 0;
  let row = [];
  for (let fieldScheme of fieldSchemes) {
    if (!isRow(fieldScheme)) {
      newSpan = span + (((_a3 = fieldScheme.__config__) == null ? void 0 : _a3.span) || 0);
      if (newSpan > 24) {
        elRows.push(createRowScheme(row));
        row = [fieldScheme];
        span = ((_b3 = fieldScheme.__config__) == null ? void 0 : _b3.span) || 0;
      } else {
        row.push(fieldScheme);
        span = newSpan;
      }
    } else {
      if (row.length > 0) {
        elRows.push(createRowScheme(row));
        row = [];
        span = 0;
      }
      elRows.push(layoutRow(fieldScheme));
    }
  }
  if (row.length > 0) {
    elRows.push(createRowScheme(row));
  }
  return elRows;
};
const layoutRow = (rowScheme) => {
  var _a3;
  let slot = rowScheme.__slot__;
  if (!slot) {
    return rowScheme;
  }
  let childConfigs = slot.default;
  if (!childConfigs) {
    return rowScheme;
  }
  if (!Array.isArray(childConfigs)) {
    childConfigs = [childConfigs];
  }
  let rows = calculateRows(childConfigs);
  let row = createRowScheme(rows);
  rowScheme.__slot__.default = (_a3 = row.__slot__) == null ? void 0 : _a3.default;
  return rowScheme;
};
const layoutCol = (colScheme) => {
  let slot = colScheme.__slot__;
  if (!slot) {
    return colScheme;
  }
  let childConfigs = slot.default;
  if (!childConfigs) {
    return colScheme;
  }
  if (!Array.isArray(childConfigs)) {
    if (isRow(childConfigs)) {
      colScheme.__slot__.default = layoutRow(childConfigs);
    }
  } else {
    colScheme.__slot__.default = calculateRows(childConfigs);
  }
  return colScheme;
};
const createColScheme = (scheme) => {
  var _a3, _b3, _c3, _d3;
  if (isCol(scheme)) {
    return layoutCol(scheme);
  }
  let span = ((_a3 = scheme.__config__) == null ? void 0 : _a3.span) ?? 0;
  if (isRow(scheme)) {
    scheme = layoutRow(scheme);
    span = 24;
  }
  return {
    span,
    offset: (_b3 = scheme.__config__) == null ? void 0 : _b3.offset,
    push: (_c3 = scheme.__config__) == null ? void 0 : _c3.push,
    pull: (_d3 = scheme.__config__) == null ? void 0 : _d3.pull,
    __config__: {
      tag: "el-col"
    },
    __runtime__: {
      isAutoGenerated: true
    },
    __slot__: {
      default: scheme
    }
  };
};
const createRowScheme = (scheme) => {
  if (scheme.length == 1 && isRow(scheme[0])) {
    return scheme[0];
  }
  return {
    gutter: 0,
    justify: "start",
    align: "middle",
    __config__: {
      tag: "el-row"
    },
    __runtime__: {
      isAutoGenerated: true
    },
    __slot__: {
      default: scheme.map((s2) => createColScheme(s2))
    }
  };
};
const _sfc_main$L = {
  props: ["schemas", "formState"],
  setup(props, { slots }) {
    var _a3, _b3;
    const { t: t2 } = useLocale();
    const globalContext = {};
    const vGlobalConfig = injectVantisGlobalConfig();
    adapter$3.httpClient = new HttpClient((_a3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a3.axiosInstance, (_b3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _b3.axiosRequestConfig);
    return { t: t2, globalContext };
  },
  errorCaptured(err, vm2, info) {
    console.log(err);
    return false;
  },
  render() {
    var _a3;
    let schemas = layoutDesign(this.schemas);
    let vNodes = [];
    let vNode;
    for (let i2 = 0; i2 < schemas.length; i2++) {
      let schema = schemas[i2];
      vNode = buildComponent({
        schema,
        formModel: this.formState.formModel.value,
        emit: (_a3 = this.formState) == null ? void 0 : _a3.emit,
        t: this.t,
        renderMode: RenderMode.design,
        formConfig: void 0,
        extraData: i2,
        globalContext: this.globalContext,
        formState: this.formState
      });
      if (vNode) {
        vNodes.push(vNode);
      }
    }
    return vNodes;
  }
};
typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const toString = Object.prototype.toString;
const isObject$1 = (val) => toString.call(val) === "[object Object]";
const noop = () => {
};
function computedAsync(evaluationCallback, initialState, optionsOrRef) {
  let options;
  if (isRef(optionsOrRef)) {
    options = {
      evaluating: optionsOrRef
    };
  } else {
    options = {};
  }
  const {
    lazy = false,
    evaluating = void 0,
    shallow = true,
    onError = noop
  } = options;
  const started = ref(!lazy);
  const current = shallow ? shallowRef(initialState) : ref(initialState);
  let counter = 0;
  watchEffect(async (onInvalidate) => {
    if (!started.value)
      return;
    counter++;
    const counterAtBeginning = counter;
    let hasFinished = false;
    if (evaluating) {
      Promise.resolve().then(() => {
        evaluating.value = true;
      });
    }
    try {
      const result = await evaluationCallback((cancelCallback) => {
        onInvalidate(() => {
          if (evaluating)
            evaluating.value = false;
          if (!hasFinished)
            cancelCallback();
        });
      });
      if (counterAtBeginning === counter)
        current.value = result;
    } catch (e10) {
      onError(e10);
    } finally {
      if (evaluating && counterAtBeginning === counter)
        evaluating.value = false;
      hasFinished = true;
    }
  });
  if (lazy) {
    return computed(() => {
      started.value = true;
      return current.value;
    });
  } else {
    return current;
  }
}
function useFormState(formSchema, formInstance, emit, model, onSubmit, submitBodyBuild) {
  var _a3, _b3;
  const vGlobalConfig = injectVantisGlobalConfig();
  const httpClient = new HttpClient((_a3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a3.axiosInstance, (_b3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _b3.axiosRequestConfig);
  let _onSubmit = onSubmit;
  const setOnSubmit = (submit2) => {
    _onSubmit = submit2;
  };
  let _submitBodyBuild = submitBodyBuild;
  const setSubmitBodyBuild = (submitBodyBuild2) => {
    _submitBodyBuild = submitBodyBuild2;
  };
  const formMembers = ref({});
  const formRefs = /* @__PURE__ */ new Map();
  let _formSchema = formSchema;
  let oldModel;
  const setModelValue = () => {
    var _a4;
    let modelValue = model == null ? void 0 : model.value;
    const defaultModel = (_a4 = _formSchema.formConfig) == null ? void 0 : _a4.defaultModel;
    if (!isObject$1(modelValue)) {
      modelValue = {};
    }
    if (isObject$1(defaultModel)) {
      modelValue = { ...defaultModel, ...modelValue };
    }
    model.value = modelValue;
    oldModel = JSON.parse(JSON.stringify(modelValue || {}));
  };
  setModelValue();
  const setFormSchema = (formSchema2) => {
    _formSchema = formSchema2;
    setModelValue();
  };
  const formModel = model;
  const submitFilters = /* @__PURE__ */ new Map();
  const executeSubmitBeforeFilters = async (submitBody) => {
    var _a4, _b4;
    for (let key of submitFilters.keys()) {
      let retValue = (_b4 = (_a4 = submitFilters.get(key)) == null ? void 0 : _a4.before) == null ? void 0 : _b4.call(_a4, submitBody);
      if (retValue instanceof Promise) {
        retValue = await retValue;
      }
      if (retValue === false) {
        return false;
      }
    }
    return true;
  };
  const executeSubmitSuccessfullyFilters = async (submitBody, response) => {
    var _a4, _b4;
    for (let key of submitFilters.keys()) {
      let retValue = (_b4 = (_a4 = submitFilters.get(key)) == null ? void 0 : _a4.successfully) == null ? void 0 : _b4.call(_a4, submitBody, response);
      if (retValue instanceof Promise) {
        await retValue;
      }
    }
  };
  const executeSubmitFailedFilters = async (submitBody, response, error) => {
    var _a4, _b4;
    for (let key of submitFilters.keys()) {
      let retValue = (_b4 = (_a4 = submitFilters.get(key)) == null ? void 0 : _a4.failed) == null ? void 0 : _b4.call(_a4, submitBody, response, error);
      if (retValue instanceof Promise) {
        await retValue;
      }
    }
  };
  const submit = async (purpose, additionalData, action) => {
    let submitFunc;
    if (_onSubmit) {
      submitFunc = isFunction$2(_onSubmit) ? _onSubmit : _onSubmit[purpose];
    }
    if (!submitFunc && isNullOrUndefinedOrWhiteSpace(action)) {
      return;
    }
    let form = formInstance.value;
    if (!form) {
      return;
    }
    let formData = JSON.parse(JSON.stringify(formModel.value));
    let retValue = await executeSubmitBeforeFilters(formData);
    if (!retValue) {
      return;
    }
    let response;
    try {
      let isValid = await form.validate();
      if (!isValid) {
        await executeSubmitFailedFilters(formData, response, "is invalid");
        emit("submitFailed", formData, purpose, void 0, "is invalid");
        return;
      }
      let submitBody = formData;
      if (Array.isArray(additionalData) && additionalData.length > 0) {
        for (let i2 = 0; i2 < additionalData.length; i2++) {
          submitBody[additionalData[i2].key] = additionalData[i2].value;
        }
      }
      let submitBodyBuildFunc;
      if (_submitBodyBuild) {
        submitBodyBuildFunc = isFunction$2(_submitBodyBuild) ? _submitBodyBuild : _submitBodyBuild[purpose];
      }
      if (submitBodyBuildFunc) {
        submitBody = submitBodyBuildFunc(submitBody, purpose);
      }
      if (submitFunc) {
        response = await submitFunc(submitBody, purpose);
      } else {
        response = await httpClient.send({ body: submitBody, url: action, method: "POST" });
      }
      await executeSubmitSuccessfullyFilters(formData, response);
      emit("submitSuccessfully", formData, purpose, response);
    } catch (error) {
      await executeSubmitFailedFilters(formData, response, error);
      emit("submitFailed", formData, purpose, response, error);
    }
  };
  const reset = () => {
    var _a4, _b4;
    (_a4 = formInstance.value) == null ? void 0 : _a4.resetFields();
    (_b4 = formInstance.value) == null ? void 0 : _b4.clearValidate();
    formModel.value = oldModel;
  };
  const methods = {};
  const addSubmitFilterIfNotExists = (key, submitFilter) => {
    if (submitFilters.has(key)) {
      return false;
    }
    submitFilters.set(key, submitFilter);
    return true;
  };
  const setMemberValue = (memberName, value) => {
    formMembers.value = Object.assign({}, toRaw(formMembers.value), { memberName: value });
  };
  const setDescendantMemberValue = (memberNames, value) => {
    let container = toRaw(formMembers.value);
    let root2 = container;
    for (let i2 = 0; i2 < memberNames.length - 1; i2++) {
      if (container[memberNames[i2]] == void 0) {
        container[memberNames[i2]] = {};
      }
      container = container[memberNames[i2]];
    }
    container[memberNames[memberNames.length - 1]] = value;
    formMembers.value = root2;
  };
  const getMemberValue = (memberName) => {
    return formMembers.value[memberName];
  };
  const getDescendantMemberValue = (...memberNames) => {
    let container = formMembers.value;
    for (let i2 = 0; i2 < memberNames.length; i2++) {
      container = container[memberNames[i2]];
      if (container === void 0) {
        break;
      }
    }
    return container;
  };
  const getOrCreateRef = (name) => {
    if (!formRefs.has(name)) {
      formRefs.set(name, ref());
    }
    return formRefs.get(name);
  };
  const watchStopHandleArray = [];
  const dispose = () => {
    formModel.value = void 0;
    emit = void 0;
    formMembers.value = {};
    formRefs.clear();
    for (const watchStopHandle of watchStopHandleArray) {
      watchStopHandle();
    }
  };
  const watchWrap = (watch2) => {
    watchStopHandleArray.push(watch2());
  };
  return {
    formModel,
    methods,
    formMembers,
    emit,
    setOnSubmit,
    setSubmitBodyBuild,
    setFormSchema,
    reset,
    submit,
    addSubmitFilterIfNotExists,
    setMemberValue,
    setDescendantMemberValue,
    getMemberValue,
    getDescendantMemberValue,
    //initializeMemberValue,
    // initializeDescendantMemberValue,
    getOrCreateRef,
    formInstance,
    formRefs,
    watchWrap,
    dispose
  };
}
const getDynamicConfigComponent = (widgetSchema) => {
  var _a3;
  const tag = (_a3 = widgetSchema == null ? void 0 : widgetSchema.__config__) == null ? void 0 : _a3.tag;
  switch (tag) {
    case "el-input":
      switch (widgetSchema.type) {
        case "textarea":
          return import("./ElInputMultilineText-D8DYprox.js");
        default:
          return import("./ElInputConfig-CNH-6sSq.js");
      }
    case "el-checkbox-group":
      return import("./ElCheckBoxGroupConfig-ChGPkYGA.js");
    case "el-datetime-picker":
      return import("./ElDateTimePickerConfig-Cq-bnzuT.js");
    case "el-button":
      return import("./ElButtonConfig-CWb4Pm3Y.js");
    case "el-input-number":
      return import("./ElInputNumberConfig-C-ttjT3u.js");
    case "el-radio-group":
      return import("./ElRadioGroupConfig-SRfJf3cw.js");
    case "el-rate":
      return import("./ElRateConfig-CRLdkC37.js");
    case "el-select":
      return import("./ElSelectConfig-D-XVs5xa.js");
    case "el-slider":
      return import("./ElSliderConfig-jT-aL0H5.js");
    case "el-switch":
      return import("./ElSwitchConfig-DpzJ0aeH.js");
    case "el-time-picker":
      return import("./ElTimePickerConfig-Cl_ypJ_n.js");
    case "el-date-picker":
      return import("./ElDateTimePickerConfig-Cq-bnzuT.js");
    case "el-upload":
      return import("./ElUploadConfig-DuScVzta.js");
    case "el-table":
      return import("./ElReadonlyTableConfig-DWntyjXY.js");
  }
};
const getConfigComponent = (widgetSchema) => {
  const component2 = getDynamicConfigComponent(widgetSchema);
  if (component2) {
    return defineAsyncComponent(() => component2);
  }
};
const _hoisted_1$s = { class: "field-box" };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "ComponentConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const activeData = useModel(__props, "modelValue");
    const configComponent = shallowRef();
    watch(() => {
      var _a3, _b3;
      const tag = (_b3 = (_a3 = activeData.value) == null ? void 0 : _a3.__config__) == null ? void 0 : _b3.tag;
      if (tag == "el-input") {
        return tag + ":" + activeData.value.type;
      }
      return tag;
    }, () => {
      configComponent.value = getConfigComponent(activeData.value);
    }, { immediate: true });
    onErrorCaptured((error) => {
      console.log(error);
      return false;
    });
    return (_ctx, _cache) => {
      const _component_el_form = resolveComponent("el-form");
      const _component_el_scrollbar = resolveComponent("el-scrollbar");
      return openBlock(), createElementBlock("div", _hoisted_1$s, [
        createVNode(_component_el_scrollbar, { class: "right-scrollbar" }, {
          default: withCtx(() => [
            createVNode(_component_el_form, {
              "label-width": "auto",
              size: "small"
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(resolveDynamicComponent(configComponent.value), {
                  modelValue: activeData.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => activeData.value = $event)
                }, null, 8, ["modelValue"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]);
    };
  }
});
const ComponentConfig = /* @__PURE__ */ _export_sfc$1(_sfc_main$K, [["__scopeId", "data-v-94819121"]]);
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "SizeConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const size = useModel(__props, "modelValue");
    watch(size, () => {
      if (isNullOrUndefinedOrWhiteSpace(size.value)) {
        size.value = "default";
      }
    }, { immediate: true });
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      const _component_el_radio_button = resolveComponent("el-radio-button");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      return openBlock(), createBlock(_component_el_radio_group, {
        modelValue: size.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => size.value = $event)
      }, {
        default: withCtx(() => [
          createVNode(_component_el_radio_button, {
            value: "large",
            label: unref(t2)("Large")
          }, null, 8, ["label"]),
          createVNode(_component_el_radio_button, {
            value: "default",
            label: unref(t2)("Default")
          }, null, 8, ["label"]),
          createVNode(_component_el_radio_button, {
            value: "small",
            label: unref(t2)("Small")
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const _hoisted_1$r = { class: "field-box" };
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "FormConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const formConfig = useModel(__props, "modelValue");
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      const _component_el_switch = resolveComponent("el-switch");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_radio_button = resolveComponent("el-radio-button");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      const _component_el_input_number = resolveComponent("el-input-number");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_scrollbar = resolveComponent("el-scrollbar");
      return openBlock(), createElementBlock("div", _hoisted_1$r, [
        createVNode(_component_el_scrollbar, { class: "right-scrollbar" }, {
          default: withCtx(() => [
            createVNode(_component_el_form, {
              "label-width": "auto",
              size: "small",
              model: formConfig.value
            }, {
              default: withCtx(() => [
                createVNode(_component_el_form_item, {
                  prop: "inline",
                  label: unref(t2)("Inline")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.inline,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formConfig.value.inline = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "labelPosition",
                  label: unref(t2)("LabelPosition")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: formConfig.value.labelPosition,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formConfig.value.labelPosition = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          value: "left",
                          label: unref(t2)("Left")
                        }, null, 8, ["label"]),
                        createVNode(_component_el_radio_button, {
                          value: "right",
                          label: unref(t2)("Right")
                        }, null, 8, ["label"]),
                        createVNode(_component_el_radio_button, {
                          value: "top",
                          label: unref(t2)("Top")
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "labelWith",
                  label: unref(t2)("LabelWith")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: formConfig.value.labelWidth,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => formConfig.value.labelWidth = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "size",
                  label: unref(t2)("Size")
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$J, {
                      modelValue: formConfig.value.size,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => formConfig.value.size = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "labelSuffix",
                  label: unref(t2)("LabelSuffix")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      modelValue: formConfig.value.labelSuffix,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => formConfig.value.labelSuffix = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "hideRequiredAsterisk",
                  label: unref(t2)("HideRequiredAsterisk")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.hideRequiredAsterisk,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => formConfig.value.hideRequiredAsterisk = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "requireAsteriskPosition",
                  label: unref(t2)("RequireAsteriskPosition")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: formConfig.value.requireAsteriskPosition,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => formConfig.value.requireAsteriskPosition = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          value: "left",
                          label: unref(t2)("Left")
                        }, null, 8, ["label"]),
                        createVNode(_component_el_radio_button, {
                          value: "right",
                          label: unref(t2)("Right")
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "showMessage",
                  label: unref(t2)("ShowMessage")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.showMessage,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => formConfig.value.showMessage = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "inlineMessage",
                  label: unref(t2)("InlineMessage")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.inlineMessage,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => formConfig.value.inlineMessage = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "statusIcon",
                  label: unref(t2)("StatusIcon")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.statusIcon,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => formConfig.value.statusIcon = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "validateOnRuleChange",
                  label: unref(t2)("ValidateOnRuleChange")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.validateOnRuleChange,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => formConfig.value.validateOnRuleChange = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "scrollToError",
                  label: unref(t2)("ScrollToError")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.scrollToError,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => formConfig.value.scrollToError = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                createVNode(_component_el_form_item, {
                  prop: "disabled",
                  label: unref(t2)("Disabled")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: formConfig.value.disabled,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => formConfig.value.disabled = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]);
    };
  }
});
const FormConfig = /* @__PURE__ */ _export_sfc$1(_sfc_main$I, [["__scopeId", "data-v-7d254853"]]);
const _sfc_main$H = {
  props: ["formSchema", "formState"],
  setup(props, ctx) {
    var _a3, _b3;
    const { t: t2 } = useLocale();
    const globalContext = {};
    const vGlobalConfig = injectVantisGlobalConfig();
    adapter$3.httpClient = new HttpClient((_a3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a3.axiosInstance, (_b3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _b3.axiosRequestConfig);
    return { t: t2, globalContext };
  },
  render() {
    var _a3;
    let schemas = layoutDesign(this.formSchema.widgets);
    let vNodes = [];
    let vNode;
    for (let i2 = 0; i2 < schemas.length; i2++) {
      let schema = schemas[i2];
      vNode = buildComponent({
        schema,
        formModel: this.formState.formModel.value,
        emit: (_a3 = this.formState) == null ? void 0 : _a3.emit,
        t: this.t,
        renderMode: RenderMode.normalWithFormItem,
        formConfig: this.formSchema.formConfig,
        formState: this.formState,
        globalContext: this.globalContext
      });
      if (vNode) {
        vNodes.push(vNode);
      }
    }
    return vNodes;
  }
};
var InferType = /* @__PURE__ */ ((InferType2) => {
  InferType2["String"] = "string";
  InferType2["Int"] = "int";
  InferType2["Number"] = "double";
  InferType2["Bool"] = "boolean";
  InferType2["StringArray"] = "string[]";
  InferType2["ObjectArray"] = "object[]";
  InferType2["NumberArray"] = "double[]";
  InferType2["Datetime"] = "datetime";
  InferType2["Object"] = "object";
  return InferType2;
})(InferType || {});
const getInferTypeByWidget = (control) => {
  var _a3;
  if (control == void 0) {
    return "string";
  }
  switch ((_a3 = control.__config__) == null ? void 0 : _a3.tag) {
    case "el-input-number":
    case "el-rate":
    case "el-slider":
      return "double";
    case "el-input":
      if (control.type === "number") {
        return "double";
      } else {
        return "string";
      }
    case "el-select":
    case "el-cascader":
      if (control.multiple) {
        return "string[]";
      } else {
        return "string";
      }
    case "el-checkbox-group":
      return "string[]";
    case "el-switch":
      return "boolean";
    case "el-checkbox":
      return "boolean";
    case "el-date-picker":
      if (control.type === "date" || control.type === "datetime") {
        return "datetime";
      } else {
        return "string";
      }
    case "el-radio-group":
      return "string";
    case "el-upload":
      return "object[]";
    case "el-table":
      return "object[]";
    default:
      return "string";
  }
};
const getPropertyDefinition = (fieldSchema) => {
  var _a3;
  if (isNullOrUndefinedOrWhiteSpace(fieldSchema.__vModel__)) {
    return void 0;
  }
  const inferType = getInferTypeByWidget(fieldSchema);
  let typeDefinition = {
    type: inferType
  };
  if (inferType == "string[]") {
    typeDefinition = {
      itemTypeDefinition: {
        type: "string"
      }
    };
  } else if (inferType == "object[]") {
    typeDefinition = {
      itemTypeDefinition: {
        type: "object"
      }
    };
  } else if (inferType == "double[]") {
    typeDefinition = {
      itemTypeDefinition: {
        type: "double"
        /* Number */
      }
    };
  }
  return {
    code: fieldSchema.__vModel__,
    name: fieldSchema.__config__.label,
    required: ((_a3 = fieldSchema.__config__.validatorDescriptors) == null ? void 0 : _a3.findIndex((v2) => v2.componentCode === "RequiredValidator")) > -1,
    typeDefinition,
    validatorDescriptors: fieldSchema.__config__.validatorDescriptors
  };
};
const getDataDefinition = (formSchema2) => {
  const dataDefinition = {
    "code": "view",
    //表单数据code   可默认   1
    "name": "view",
    //表单的名字  可默认  1
    "descriptions": "",
    //默认描述
    "required": true,
    //可默认   1
    "requiredErrorMessage": null,
    "defaultValue": null,
    //可默认  1
    "typeErrorMessage": null,
    "typeDefinition": {}
  };
  if (formSchema2.widgets && formSchema2.widgets.length > 0) {
    dataDefinition.typeDefinition.itemDefinitions = formSchema2.widgets.map((w2) => getPropertyDefinition(w2)).filter((p2) => p2 !== void 0);
  }
  return dataDefinition;
};
const getSchemaFromDefaultSlot = (schema, vModel) => {
  if (schema === void 0) {
    return void 0;
  }
  let defaultSlot = schema.__slot__.default || schema.__slot__;
  if (defaultSlot === void 0) {
    return void 0;
  }
  if (Array.isArray(defaultSlot)) {
    return defaultSlot.filter((p2) => p2.__vModel__ == vModel);
  }
  if (defaultSlot.__vModel__ === vModel) {
    return defaultSlot;
  }
  return void 0;
};
const getFieldSchema = (formSchema2, names) => {
  let schema = void 0;
  if (names.length == 0) {
    return void 0;
  }
  if (formSchema2.widgets && formSchema2.widgets.length > 0) {
    for (let i2 = 0; i2 < names.length; i2++) {
      if (i2 == 0) {
        schema = formSchema2.widgets.find((f2) => f2.__vModel__ === names[0]);
        if (schema == void 0) {
          return void 0;
        }
        continue;
      }
      schema = getSchemaFromDefaultSlot(schema, names[i2]);
      if (schema == void 0) {
        return void 0;
      }
    }
  }
  return schema;
};
const getFormFieldItemsForDisplay = (formSchema2, containAdditionalData) => {
  if (formSchema2 === void 0 || formSchema2.widgets === void 0) {
    return [];
  }
  const fieldItems = formSchema2.widgets.filter((w2) => !isNullOrUndefinedOrWhiteSpace(w2.__vModel__)).map((schema) => {
    return {
      label: schema.__config__.label,
      value: hasDataSource(schema) ? getRedundancyName(schema.__vModel__) : schema.__vModel__
    };
  });
  {
    const additionalDataMap = getAdditionalDataMap(formSchema2);
    for (let key of additionalDataMap.keys()) {
      fieldItems.push({ label: key, value: key });
    }
  }
  return fieldItems;
};
const getAllItems = (formSchema2) => {
  if (formSchema2 === void 0 || formSchema2.widgets === void 0) {
    return [];
  }
  const fieldItems = formSchema2.widgets.filter((w2) => !isNullOrUndefinedOrWhiteSpace(w2.__vModel__)).map((schema) => {
    return {
      label: schema.__config__.label,
      value: schema.__vModel__
    };
  });
  return fieldItems;
};
const getFormFieldsItems = (formSchema2, containAdditionalData) => {
  if (formSchema2 === void 0 || formSchema2.widgets === void 0) {
    return [];
  }
  const fieldItems = formSchema2.widgets.filter((w2) => !isNullOrUndefinedOrWhiteSpace(w2.__vModel__)).map((schema) => {
    return {
      label: schema.__config__.label,
      value: schema.__vModel__
    };
  });
  if (containAdditionalData) {
    const additionalDataMap = getAdditionalDataMap(formSchema2);
    for (let key of additionalDataMap.keys()) {
      fieldItems.push({ label: key, value: key });
    }
  }
  return fieldItems;
};
const getAdditionalDataMap = (formSchema2) => {
  const itemValues = /* @__PURE__ */ new Map();
  if (formSchema2 === void 0 || formSchema2.widgets === void 0) {
    return itemValues;
  }
  const buttons = formSchema2.widgets.filter((w2) => w2.__config__.tag == "el-button");
  for (let i2 = 0; i2 < buttons.length; i2++) {
    const additionalData = buttons[i2].__config__.additionalData;
    if (!Array.isArray(additionalData)) {
      continue;
    }
    for (let kv2 of additionalData) {
      if (!itemValues.has(kv2.key)) {
        itemValues.set(kv2.key, []);
      }
      let values = itemValues.get(kv2.key);
      if (!values.some((v2) => v2 == kv2.value)) {
        values.push(kv2.value);
      }
    }
  }
  return itemValues;
};
const hasDataSource = (widgetSchema) => {
  const dataSource = widgetSchema.__config__.dataSource;
  return dataSource && isObject$4(dataSource) && Object.keys(dataSource).length > 0;
};
const convertViewDescriptorToFormSchema = (viewDescriptor) => {
  var _a3;
  return {
    formConfig: viewDescriptor.viewSettings,
    widgets: ((_a3 = viewDescriptor.componentDescriptors) == null ? void 0 : _a3.map((c3) => {
      c3.settings.readonly = c3.readonly;
      c3.settings.disabled = c3.disabled || c3.readonly;
      return c3.settings;
    })) || []
  };
};
const convertFormSchemaToViewDescriptor = (formSchema) => {
  var _a3;
  return {
    viewSettings: formSchema.formConfig,
    componentDescriptors: (_a3 = formSchema.widgets) == null ? void 0 : _a3.map((c3) => {
      return {
        propertyName: c3.__vModel__,
        //对button 特殊处理
        readonly: !!c3.readonly,
        disabled: !!c3.disabled,
        label: c3.__config__.label,
        showInList: !!c3.__config__.showInList,
        settings: JSON.parse(JSON.stringify(c3, (key, value) => {
          if (key == "__runtime__") {
            return void 0;
          }
          return value;
        }))
      };
    }),
    dataDefinition: getDataDefinition(formSchema)
  };
};
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  ...{ name: "VcFormRender" },
  __name: "FormRender",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {},
    viewDescriptor: {},
    disabled: { type: Boolean },
    onSubmit: { type: [Object, Function] },
    submitBodyBuild: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["submitSuccessfully", "submitFailed"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const emit = __emit;
    const formSchema = computed(() => {
      if (props.formSchema != void 0) {
        return props.formSchema;
      } else if (props.viewDescriptor != void 0) {
        return convertViewDescriptorToFormSchema(props.viewDescriptor);
      } else {
        console.warn("formSchema,viewDescriptor 必须配置其一");
      }
    });
    const innerModelRef = ref(model.value || {});
    const formInstance = ref();
    const formState = useFormState(formSchema.value, formInstance, emit, innerModelRef, props.onSubmit, props.submitBodyBuild);
    watch(formSchema, () => {
      formState.setFormSchema(formSchema);
    });
    watch(() => props.onSubmit, () => {
      formState.setOnSubmit(props.onSubmit);
    });
    watch(() => props.submitBodyBuild, () => {
      formState.setSubmitBodyBuild(props.submitBodyBuild);
    });
    watch(innerModelRef, () => {
      if (model.value && innerModelRef.value) {
        Object.assign(model.value, { ...innerModelRef.value });
      }
    }, { deep: true, immediate: true });
    watch(model, () => {
      if (model.value && innerModelRef.value) {
        Object.assign(innerModelRef.value, { ...model.value });
      }
    }, { deep: true, immediate: true });
    const labelWith = computed(() => formSchema.value.formConfig.labelWidth === void 0 ? "auto" : formSchema.value.formConfig.labelWidth);
    onUnmounted(() => {
      formState.dispose();
    });
    return (_ctx, _cache) => {
      const _component_el_row = resolveComponent("el-row");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        disabled: _ctx.disabled === void 0 ? formSchema.value.formConfig.disabled : _ctx.disabled,
        "show-message": formSchema.value.formConfig.showMessage,
        inline: formSchema.value.formConfig.inline,
        "label-position": formSchema.value.formConfig.labelPosition,
        "label-width": labelWith.value,
        "label-suffix": formSchema.value.formConfig.labelSuffix,
        "hide-required-asterisk": formSchema.value.formConfig.hideRequiredAsterisk,
        "require-asterisk-position": formSchema.value.formConfig.requireAsteriskPosition,
        "inline-message": formSchema.value.formConfig.inlineMessage,
        "status-icon": formSchema.value.formConfig.statusIcon,
        "validate-on-rule-change": formSchema.value.formConfig.validateOnRuleChange,
        size: formSchema.value.formConfig.size,
        "scroll-to-error": formSchema.value.formConfig.scrollToError,
        style: { "padding": "10px" },
        model: unref(formState).formModel,
        ref_key: "formInstance",
        ref: formInstance
      }, {
        default: withCtx(() => [
          createVNode(_component_el_row, null, {
            default: withCtx(() => [
              createVNode(_sfc_main$H, {
                formSchema: formSchema.value,
                "form-state": unref(formState)
              }, null, 8, ["formSchema", "form-state"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled", "show-message", "inline", "label-position", "label-width", "label-suffix", "hide-required-asterisk", "require-asterisk-position", "inline-message", "status-icon", "validate-on-rule-change", "size", "scroll-to-error", "model"]);
    };
  }
});
const component$4 = /* @__PURE__ */ _export_sfc$1(_sfc_main$G, [["__scopeId", "data-v-84d18df6"]]);
const _hoisted_1$q = {
  class: "action-bar",
  style: { "text-align": "left" }
};
const _hoisted_2$9 = { style: { "font-size": "14px" } };
const _hoisted_3$3 = { class: "components-list" };
const _hoisted_4$2 = { class: "components-title" };
const _hoisted_5$1 = { class: "condition-tool-bar action-bar" };
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  ...{ name: "VcFormDesigner" },
  __name: "FormDesigner",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: /* @__PURE__ */ mergeModels(["submitSuccessfully", "submitFailed"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const activeSchema = ref(void 0);
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      var _a3, _b3, _c3, _d3;
      if (((_a3 = model.value) == null ? void 0 : _a3.widgets) == void 0) {
        model.value.widgets = [];
      }
      if (((_b3 = model.value) == null ? void 0 : _b3.formConfig) == void 0) {
        model.value.formConfig = {};
      }
      if (((_d3 = (_c3 = model.value) == null ? void 0 : _c3.formConfig) == null ? void 0 : _d3.defaultModel) == void 0) {
        model.value.formConfig.defaultModel = {};
      }
    };
    const deleteComponent = (index2) => {
      const widgetSchema = model.value.widgets[index2];
      if (widgetSchema) {
        model.value.widgets.splice(index2, 1);
        if (!isNullOrUndefinedOrWhiteSpace(widgetSchema.__vModel__)) {
          delete model.value.formConfig.defaultModel[widgetSchema.__vModel__];
          delete model.value.formConfig.defaultModel[`redundancy-${widgetSchema.__vModel__}`];
        }
        if (model.value.widgets.length == 0) {
          activeSchema.value = void 0;
        }
      }
    };
    const copyComponent = (index2) => {
      let clone2 = JSON.parse(JSON.stringify(model.value.widgets[index2]));
      if (!isNullOrUndefinedOrWhiteSpace(clone2.__config__.label)) {
        clone2.__vModel__ = `field${Date.now() - Date.parse("1900-1-1")}`;
        if (clone2.__runtime__) {
          delete clone2.__runtime__;
        }
      }
      model.value.widgets.splice(index2 + 1, 0, clone2);
      activeComponentConfig(clone2);
    };
    const cloneComponent = (origin) => {
      let clone2 = JSON.parse(JSON.stringify(origin));
      if (!isNullOrUndefinedOrWhiteSpace(clone2.__config__.label)) {
        clone2.__vModel__ = clone2.__vModel__ || `field${Date.now() - Date.parse("1900-1-1")}`;
      }
      return clone2;
    };
    const activeComponentConfig = (currentSchema) => {
      for (let schema of model.value.widgets) {
        if (schema == currentSchema) {
          continue;
        }
        if (schema.__runtime__) {
          if (schema.__runtime__.isActive) {
            schema.__runtime__.isActive = false;
          }
        }
      }
      if (!currentSchema.__runtime__) {
        currentSchema.__runtime__ = {};
      }
      if (!currentSchema.__runtime__.isActive) {
        currentSchema.__runtime__.isActive = true;
      }
      activeSchema.value = currentSchema;
      rightPanelName.value = "widget";
    };
    const isDelete = (originalEvent) => {
      return hasAttribute(originalEvent, "dataDelete");
    };
    const hasAttribute = (originalEvent, attributeName) => {
      let target = originalEvent == null ? void 0 : originalEvent.target;
      for (let i2 = 0; i2 < 4; i2++) {
        if (!target) {
          return false;
        }
        if (target.hasAttribute(attributeName)) {
          return true;
        }
        target = target.parentNode;
      }
      return false;
    };
    const isCopy = (originalEvent) => {
      return hasAttribute(originalEvent, "dataCopy");
    };
    const activeConfig = (e10) => {
      const index2 = e10.newIndex === void 0 || e10.newIndex == null ? e10.oldIndex : e10.newIndex;
      if (index2 === void 0 || index2 == null) {
        return;
      }
      if (e10.type === "choose") {
        const originalEvent = e10.originalEvent;
        if (originalEvent) {
          if (isDelete(originalEvent)) {
            deleteComponent(index2);
            return;
          } else if (isCopy(originalEvent)) {
            copyComponent(index2);
            return;
          }
        }
      }
      activeComponentConfig(model.value.widgets[index2]);
    };
    provideFormSchema(model);
    watch(model, initialize, { immediate: true });
    const defaultModel = ref(model.value.formConfig.defaultModel);
    const formInstance = ref();
    const formState = useFormState(model.value, formInstance, emit, defaultModel);
    watch(defaultModel, () => model.value.formConfig.defaultModel = defaultModel.value, { immediate: true, deep: true });
    formState.methods.deleteComponent = deleteComponent;
    formState.methods.copyComponent = copyComponent;
    const rightPanelName = ref("form");
    const labelWith = computed(() => model.value.formConfig.labelWidth === void 0 ? "auto" : model.value.formConfig.labelWidth);
    const isPreview = ref(false);
    const { t: t2 } = useLocale();
    const addComponentToLast = (schema) => {
      const cloneSchema = cloneComponent(schema);
      model.value.widgets.push(cloneSchema);
      activeComponentConfig(cloneSchema);
    };
    onUnmounted(() => {
      formState.dispose();
    });
    const clear = () => {
      model.value.widgets = [];
      rightPanelName.value = "form";
      activeSchema.value = void 0;
    };
    return (_ctx, _cache) => {
      const _component_el_scrollbar = resolveComponent("el-scrollbar");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_dialog = resolveComponent("el-dialog");
      const _component_el_row = resolveComponent("el-row");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_tabs = resolveComponent("el-tabs");
      return openBlock(), createBlock(_component_el_row, null, {
        default: withCtx(() => [
          createVNode(_component_el_col, {
            span: 3,
            class: "left-panel"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1$q, [
                createElementVNode("span", _hoisted_2$9, toDisplayString(unref(t2)("ComponentList")), 1)
              ]),
              createVNode(_component_el_scrollbar, { class: "left-scrollbar" }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_3$3, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(defaultComponentConfigs).entries(), (componentGroups) => {
                      return openBlock(), createElementBlock("div", {
                        key: componentGroups[0]
                      }, [
                        createElementVNode("div", _hoisted_4$2, [
                          createVNode(unref(Components), {
                            theme: "outline",
                            size: "15",
                            fill: "#333"
                          }),
                          createTextVNode(" " + toDisplayString(unref(t2)(componentGroups[0])), 1)
                        ]),
                        createVNode(unref(lo$2), {
                          group: { name: "componentsGroup", pull: "clone", put: false },
                          "model-value": componentGroups[1],
                          sort: false,
                          clone: cloneComponent,
                          class: "components-draggable"
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(componentGroups[1], (item, index2) => {
                              return openBlock(), createBlock(_sfc_main$M, {
                                onClick: () => addComponentToLast(item),
                                key: item.__config__.tag + "_" + index2,
                                schema: item,
                                "render-mode": "mini"
                              }, null, 8, ["onClick", "schema"]);
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["model-value"])
                      ]);
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_el_col, {
            span: 14,
            class: "center-panel"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_5$1, [
                createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _cache[0] || (_cache[0] = ($event) => isPreview.value = true)
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("Preview")), 1)
                  ]),
                  _: 1
                }),
                createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: clear
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("Clear")), 1)
                  ]),
                  _: 1
                })
              ]),
              isPreview.value ? (openBlock(), createBlock(_component_el_dialog, {
                key: 0,
                modelValue: isPreview.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isPreview.value = $event)
              }, {
                default: withCtx(() => [
                  isPreview.value ? (openBlock(), createBlock(component$4, {
                    key: 0,
                    "form-schema": model.value,
                    modelValue: unref(formState).formModel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => unref(formState).formModel.value = $event)
                  }, null, 8, ["form-schema", "modelValue"])) : createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])) : createCommentVNode("", true),
              createVNode(_component_el_scrollbar, {
                always: "always",
                class: "center-scrollbar"
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_form, {
                    "show-message": model.value.formConfig.showMessage,
                    inline: model.value.formConfig.inline,
                    "label-position": model.value.formConfig.labelPosition,
                    "label-width": labelWith.value,
                    "label-suffix": model.value.formConfig.labelSuffix,
                    "hide-required-asterisk": model.value.formConfig.hideRequiredAsterisk,
                    "require-asterisk-position": model.value.formConfig.requireAsteriskPosition,
                    "inline-message": model.value.formConfig.inlineMessage,
                    "status-icon": model.value.formConfig.statusIcon,
                    "validate-on-rule-change": model.value.formConfig.validateOnRuleChange,
                    size: model.value.formConfig.size,
                    "scroll-to-error": model.value.formConfig.scrollToError,
                    style: { "padding": "10px" },
                    model: unref(formState).formModel,
                    disabled: model.value.formConfig.disabled,
                    ref_key: "formInstance",
                    ref: formInstance
                  }, {
                    default: withCtx(() => [
                      createVNode(unref(lo$2), {
                        animation: 340,
                        modelValue: model.value.widgets,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => model.value.widgets = $event),
                        class: "drawing-board",
                        group: "componentsGroup",
                        onAdd: activeConfig,
                        "on-choose": activeConfig,
                        target: ".cols"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_row, { class: "cols" }, {
                            default: withCtx(() => [
                              model.value.widgets && model.value.widgets.length > 0 ? (openBlock(), createBlock(_sfc_main$L, {
                                key: 0,
                                schemas: model.value.widgets,
                                "form-state": unref(formState)
                              }, null, 8, ["schemas", "form-state"])) : createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["show-message", "inline", "label-position", "label-width", "label-suffix", "hide-required-asterisk", "require-asterisk-position", "inline-message", "status-icon", "validate-on-rule-change", "size", "scroll-to-error", "model", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          createVNode(_component_el_col, {
            span: 7,
            class: "right-panel"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_tabs, {
                class: "center-tabs",
                modelValue: rightPanelName.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => rightPanelName.value = $event)
              }, {
                default: withCtx(() => [
                  model.value.widgets && model.value.widgets.length > 0 && activeSchema.value ? (openBlock(), createBlock(_component_el_tab_pane, {
                    key: 0,
                    label: unref(t2)("ComponentProperties"),
                    name: "widget"
                  }, {
                    default: withCtx(() => [
                      createVNode(ComponentConfig, {
                        modelValue: activeSchema.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => activeSchema.value = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  createVNode(_component_el_tab_pane, {
                    class: "center-tabs",
                    label: unref(t2)("FormProperties"),
                    name: "form"
                  }, {
                    default: withCtx(() => [
                      createVNode(FormConfig, {
                        modelValue: model.value.formConfig,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => model.value.formConfig = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
});
let elementInstalled = false;
const install$1 = (component2) => {
  component2.install = (app) => {
    const name = component2.name || component2.__name;
    if (!name) {
      return;
    }
    if (!elementInstalled) {
      app.use(ElementPlus);
      for (const [key, component22] of Object.entries(ElementPlusIcons)) {
        app.component(key, component22);
      }
      elementInstalled = true;
    }
    app.component(name, component2);
  };
  return component2;
};
const VcFormDesigner = install$1(_sfc_main$F);
const flowDesignerKey = Symbol("flowDesigner");
const flowDesignerConfigKey = Symbol("flowDesignerConfig");
const injectFlowDesignerModel = () => {
  return inject(flowDesignerKey);
};
const provideFlowDesignerModel = (model) => {
  return provide(flowDesignerKey, model);
};
const provideFlowDesignerConfig = (config) => {
  return provide(flowDesignerConfigKey, config);
};
const injectFlowDesignerConfig = () => {
  return inject(flowDesignerConfigKey);
};
const _hoisted_1$p = { class: "node-box__title" };
const _hoisted_2$8 = {
  key: 0,
  class: "validation-errors"
};
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "InitialNode",
  setup(__props) {
    const getNode = inject("getNode");
    const flowDesignerModel = injectFlowDesignerModel();
    const node = getNode();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const container = ref();
    onErrorCaptured((error) => {
      console.log(error);
    });
    const hasValidateErrors = computed(() => flowDesignerModel.value.hasValidateErrors(node.id));
    const errors = computed(() => flowDesignerModel.value.getValidateErrorMessages(node.id));
    const processNodeDefinition = computed(() => flowDesignerModel.value.getOrCreateNodeDefinition(node.id, "initialNode"));
    return (_ctx, _cache) => {
      var _a3;
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(["node-box node-box--initial", { "node-box--error": hasValidateErrors.value }]),
          ref_key: "container",
          ref: container
        }, [
          createElementVNode("div", _hoisted_1$p, [
            createElementVNode("span", null, toDisplayString(((_a3 = processNodeDefinition.value) == null ? void 0 : _a3.name) ?? "Initiator"), 1)
          ]),
          createVNode(unref(ElRow), { class: "node-box__context" }, {
            default: withCtx(() => [
              createVNode(unref(ElCol), {
                span: 20,
                class: "node-box__context__text"
              }, {
                default: withCtx(() => _cache[0] || (_cache[0] = [
                  createTextVNode(" Applicant ")
                ])),
                _: 1,
                __: [0]
              }),
              createVNode(unref(ElCol), { span: 4 }, {
                default: withCtx(() => [
                  createVNode(unref(ElIcon), { class: "node-box__context__arrow" }, {
                    default: withCtx(() => [
                      createVNode(unref(arrow_right_default))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2),
        hasValidateErrors.value ? (openBlock(), createElementBlock("ul", _hoisted_2$8, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(errors.value, (error, index2) => {
            return openBlock(), createElementBlock("li", {
              key: index2,
              class: "validation-errors__item"
            }, toDisplayString(error), 1);
          }), 128))
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _hoisted_1$o = { style: { "width": "100%" } };
const _hoisted_2$7 = {
  key: 0,
  class: "employee-selected-list"
};
const _hoisted_3$2 = { key: 1 };
const _hoisted_4$1 = { class: "employee-selected-list__operations" };
const _hoisted_5 = { style: { "height": "60vh", "overflow-y": "auto", "overflow-x": "hidden" } };
const _hoisted_6 = { class: "dialog-footer" };
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "EmployeeSelector",
  props: /* @__PURE__ */ mergeModels({
    multiple: { type: Boolean },
    getAllStaffs: { type: Function },
    formatter: { type: Function },
    parser: { type: Function }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const visible = ref(false);
    const close = () => {
      visible.value = false;
      if (formItem) {
        formItem.validate("blur");
      }
    };
    ref(false);
    const searchName = ref();
    const parse2 = () => {
      var _a3, _b3;
      if (props.multiple) {
        if (!selectedStaffPidArray.value) {
          return [];
        }
        const staffs = ((_a3 = staffList.value) == null ? void 0 : _a3.filter((s2) => selectedStaffPidArray.value.includes(s2.pId))) || [];
        if (!props.parser) {
          return selectedStaff.value;
        }
        return staffs.map((item) => props.parser(item));
      } else {
        if (!selectedStaffPid.value) {
          return null;
        }
        const staff = (_b3 = staffList.value) == null ? void 0 : _b3.find((s2) => selectedStaffPid.value == s2.pId);
        if (staff) {
          return props.parser ? props.parser(staff) : staff;
        } else {
          return null;
        }
      }
    };
    const confirm = () => {
      model.value = parse2();
      visible.value = false;
      if (formItem) {
        formItem.validate("change");
      }
    };
    const staffList = ref();
    const selectedStaffPidArray = ref([]);
    const selectedStaffPid = ref();
    const { formItem } = useFormItem();
    const initialize = (newValue) => {
      if (newValue) {
        if (props.multiple) {
          if (Array.isArray(newValue)) {
            const staffs = props.formatter ? newValue.map((i2) => props.formatter(i2)) : newValue;
            selectedStaffPidArray.value = staffs.map((i2) => i2.pId);
          } else {
            const staff = props.formatter ? props.formatter(newValue) : newValue;
            selectedStaffPidArray.value = [staff.pId];
          }
        } else {
          if (Array.isArray(newValue)) {
            if (newValue.length > 0) {
              selectedStaffPid.value = props.formatter ? props.formatter(newValue[0]).pId : newValue[0].pid;
            }
          } else {
            selectedStaffPid.value = props.formatter ? props.formatter(newValue).pId : newValue.pid;
          }
        }
      }
    };
    watch(model, initialize, {
      immediate: true,
      deep: true
    });
    const selectedStaff = computed(() => {
      if (!model.value) {
        return null;
      }
      if (props.multiple) {
        if (!props.formatter) {
          return Array.isArray(model.value) ? model.value : model.value;
        }
        return Array.isArray(model.value) ? model.value.map((item) => props.formatter(item)) : props.formatter(model.value);
      } else {
        const selected = Array.isArray(model.value) ? model.value.length > 0 ? model.value[0] : null : model.value;
        return selected == null ? null : props.formatter ? props.formatter(selected) : model.value;
      }
    });
    onBeforeMount(async () => {
      staffList.value = await props.getAllStaffs();
    });
    const candidate = computed(() => {
      var _a3;
      if (isNullOrUndefinedOrWhiteSpace(searchName.value)) {
        return staffList.value;
      }
      return ((_a3 = staffList.value) == null ? void 0 : _a3.filter((s2) => {
        var _a4;
        return (((_a4 = s2.fullName) == null ? void 0 : _a4.indexOf(searchName.value)) || -1) > -1;
      })) || [];
    });
    const clear = () => {
      selectedStaffPidArray.value = [];
      selectedStaffPid.value = void 0;
    };
    const removeSelected = (index2) => {
      if (props.multiple) {
        selectedStaffPidArray.value.splice(index2, 1);
      } else {
        selectedStaffPid.value = void 0;
      }
    };
    const { t: t2 } = useLocale();
    const openDialog = () => {
      visible.value = true;
    };
    const removeUser = (index2) => {
      if (Array.isArray(model.value)) {
        model.value.splice(index2, 1);
      }
      if (formItem) {
        formItem.validate("change");
      }
    };
    const clearUsers = () => {
      if (Array.isArray(model.value)) {
        model.value = [];
      } else {
        model.value = void 0;
      }
      if (formItem) {
        formItem.validate("change");
      }
    };
    const hasSelected = computed(() => {
      if (model.value) {
        if (Array.isArray(model.value)) {
          return model.value.length > 0;
        }
        return true;
      }
      return false;
    });
    const getFullNameByPid = (pId) => {
      var _a3, _b3;
      return ((_b3 = (_a3 = staffList.value) == null ? void 0 : _a3.find((s2) => s2.pId == pId)) == null ? void 0 : _b3.fullName) || pId;
    };
    return (_ctx, _cache) => {
      const _component_el_icon = resolveComponent("el-icon");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_button_group = resolveComponent("el-button-group");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_checkbox = resolveComponent("el-checkbox");
      const _component_el_checkbox_group = resolveComponent("el-checkbox-group");
      const _component_el_radio = resolveComponent("el-radio");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_row = resolveComponent("el-row");
      const _component_el_dialog = resolveComponent("el-dialog");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$o, [
          _ctx.multiple && hasSelected.value ? (openBlock(), createElementBlock("div", _hoisted_2$7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(selectedStaff.value, (item, index2) => {
              return openBlock(), createElementBlock("div", {
                class: "employee-selected-item",
                key: item.pId
              }, [
                createTextVNode(toDisplayString(item.fullName) + " ", 1),
                createVNode(_component_el_icon, {
                  onClick: () => removeUser(index2)
                }, {
                  default: withCtx(() => [
                    createVNode(unref(remove_default))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]);
            }), 128))
          ])) : hasSelected.value ? (openBlock(), createElementBlock("div", _hoisted_3$2, [
            createElementVNode("span", null, toDisplayString(selectedStaff.value.fullName), 1)
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_4$1, [
            createVNode(_component_el_button_group, { size: "small" }, {
              default: withCtx(() => [
                createVNode(_component_el_button, {
                  type: "primary",
                  onClick: withModifiers(openDialog, ["prevent", "stop"])
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("AddModifyMembers")), 1)
                  ]),
                  _: 1
                }),
                hasSelected.value ? (openBlock(), createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: clearUsers
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("Clear")), 1)
                  ]),
                  _: 1
                })) : createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        createVNode(_component_el_dialog, {
          modelValue: visible.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => visible.value = $event),
          "append-to-body": "",
          "destroy-on-close": "",
          title: unref(t2)("SelectMembers"),
          top: "5vh",
          width: "630px",
          onClose: close
        }, {
          footer: withCtx(() => [
            createElementVNode("span", _hoisted_6, [
              createVNode(_component_el_button, {
                type: "primary",
                onClick: confirm
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Confirm")), 1)
                ]),
                _: 1
              }),
              createVNode(_component_el_button, { onClick: close }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Cancel")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          default: withCtx(() => [
            createVNode(_component_el_row, {
              gutter: 10,
              justify: "center"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_col, { span: 12 }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      modelValue: searchName.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchName.value = $event),
                      placeholder: unref(t2)("SearchMembers"),
                      size: "small",
                      "prefix-icon": unref(search_default)
                    }, null, 8, ["modelValue", "placeholder", "prefix-icon"]),
                    createElementVNode("div", _hoisted_5, [
                      _ctx.multiple ? (openBlock(), createBlock(_component_el_checkbox_group, {
                        key: 0,
                        modelValue: selectedStaffPidArray.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => selectedStaffPidArray.value = $event)
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(candidate.value, (item, index2) => {
                            return openBlock(), createBlock(_component_el_checkbox, {
                              style: { "width": "100%" },
                              key: item.pId + "c",
                              value: item.pId
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_el_icon, null, {
                                  default: withCtx(() => [
                                    createVNode(unref(avatar_default))
                                  ]),
                                  _: 1
                                }),
                                createTextVNode(" " + toDisplayString(item.fullName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]);
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : (openBlock(), createBlock(_component_el_radio_group, {
                        key: 1,
                        modelValue: selectedStaffPid.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedStaffPid.value = $event)
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(candidate.value, (item, index2) => {
                            return openBlock(), createBlock(_component_el_radio, {
                              style: { "width": "100%" },
                              key: item.pId + "r",
                              value: item.pId
                            }, {
                              default: withCtx(() => [
                                createVNode(_component_el_icon, null, {
                                  default: withCtx(() => [
                                    createVNode(unref(avatar_default))
                                  ]),
                                  _: 1
                                }),
                                createTextVNode(" " + toDisplayString(item.fullName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]);
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    ])
                  ]),
                  _: 1
                }),
                createVNode(_component_el_col, { span: 12 }, {
                  default: withCtx(() => [
                    createVNode(_component_el_row, { style: { "height": "22px" } }, {
                      default: withCtx(() => [
                        createVNode(_component_el_col, { span: 16 }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("Selected")) + "（" + toDisplayString(selectedStaffPidArray.value.length) + "） ", 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_col, {
                          span: 8,
                          style: { "text-align": "right" }
                        }, {
                          default: withCtx(() => [
                            createElementVNode("a", {
                              style: { "cursor": "pointer" },
                              onClick: clear
                            }, toDisplayString(unref(t2)("Empty")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(selectedStaffPidArray.value, (item, index2) => {
                      return openBlock(), createBlock(_component_el_row, {
                        style: { "height": "32px" },
                        key: index2 + "e"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_col, { span: 16 }, {
                            default: withCtx(() => [
                              createVNode(_component_el_icon, null, {
                                default: withCtx(() => [
                                  createVNode(unref(avatar_default))
                                ]),
                                _: 1
                              }),
                              createElementVNode("span", null, toDisplayString(getFullNameByPid(item)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          createVNode(_component_el_col, {
                            span: 8,
                            style: { "text-align": "right" }
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_icon, {
                                onClick: () => removeSelected(index2)
                              }, {
                                default: withCtx(() => [
                                  createVNode(unref(remove_default))
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024);
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ], 64);
    };
  }
});
const getHandlerFinderSettingsRules = (componentCode, t2) => {
  switch (componentCode) {
    case HandlerFinderDescriptorCodes.FormDataHandlerFinder:
      return {
        userIdField: [{ required: true, message: t2("Settings_userIdField_validator_required") }]
      };
    case HandlerFinderDescriptorCodes.FixedUser:
      return {
        users: [{ type: "array", required: true, min: 1, message: t2("Settings_users_validator_required") }]
      };
    case HandlerFinderDescriptorCodes.OldSystemHandlerFinder:
      return {
        reportToType: [{ required: true, message: t2("Settings_reportToType_validator_required") }]
      };
    case HandlerFinderDescriptorCodes.EmailHandlerFinder:
      return {
        emails: [
          { type: "array", required: true, message: t2("Settings_emails_validator_required"), min: 1 },
          { type: "array", defaultField: { type: "email" } }
        ]
      };
    default:
      return void 0;
  }
};
const getHandlerFinderSettingsFormRules = (componentCode, t2) => {
  return getHandlerFinderSettingsRules(componentCode, t2);
};
const getHandlerFinderRules = (componentCode, t2) => {
  const rules2 = {
    componentCode: [{ type: "enum", required: true, message: t2("componentCode_validator_required"), enum: getAllHandlerFinderDescriptorCodes() }]
  };
  const validationRules = rulesMap.get(componentCode);
  const settingRules = validationRules || getHandlerFinderSettingsRules(componentCode, t2);
  if (settingRules) {
    rules2.settings = [{
      type: "object",
      required: true,
      message: t2("settings_validator_required"),
      fields: settingRules
    }];
  }
  return rules2;
};
const _hoisted_1$n = { class: "type_fieldset" };
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "FixedUserFinderConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      if (!model.value) {
        model.value = { users: [] };
      }
    };
    watch(model, initialize, { immediate: true });
    const { t: t2 } = useLocale();
    const { getAllStaffs } = injectFlowDesignerConfig();
    const formRules = getHandlerFinderSettingsFormRules(HandlerFinderDescriptorCodes.FixedUser, t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    const parser = (staffItemOutput) => {
      return { id: `u|${staffItemOutput.pId}`, name: staffItemOutput.fullName, staffNo: staffItemOutput.staffId };
    };
    const formater = (input) => {
      var _a3;
      return { pId: (_a3 = input.id) == null ? void 0 : _a3.substring(2), fullName: input.name, staffId: input.staffNo };
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock("fieldset", _hoisted_1$n, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("DesignatedMember")), 1),
        createVNode(_component_el_form, {
          model: model.value,
          ref_key: "formInstance",
          ref: formInstance,
          rules: unref(formRules)
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, { prop: "users" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$D, {
                  multiple: true,
                  "get-all-staffs": unref(getAllStaffs),
                  modelValue: model.value.users,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.users = $event),
                  parser,
                  formatter: formater
                }, null, 8, ["get-all-staffs", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]);
    };
  }
});
const _hoisted_1$m = { class: "type_fieldset" };
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "FormDataHandlerFinderConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const flowDesignerModel = injectFlowDesignerModel();
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      var _a3;
      if (!model.value) {
        model.value = { userIdField: "" };
      }
      if (!((_a3 = model.value) == null ? void 0 : _a3.userIdField)) {
        model.value.userIdField = "";
      }
    };
    watch(model, initialize, { immediate: true });
    const items = computed(() => getFormFieldsItems(flowDesignerModel.value.formSchema, false));
    const { t: t2 } = useLocale();
    const formRules = getHandlerFinderSettingsFormRules(HandlerFinderDescriptorCodes.FormDataHandlerFinder, t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_option = resolveComponent("el-option");
      const _component_el_select = resolveComponent("el-select");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock("fieldset", _hoisted_1$m, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("FromFormField")), 1),
        createVNode(_component_el_form, {
          model: model.value,
          "label-width": "auto",
          ref_key: "formInstance",
          ref: formInstance,
          rules: unref(formRules)
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, {
              label: unref(t2)("ApproverField"),
              prop: "userIdField"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.userIdField,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.userIdField = $event),
                  placeholder: unref(t2)("PleaseSelectApproverField"),
                  filterable: ""
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem.value,
                        label: unref(t2)(vItem.label),
                        value: vItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]);
    };
  }
});
const _hoisted_1$l = { class: "type_fieldset" };
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "PreviousNodeHandlerFinderConfig",
  setup(__props) {
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", _hoisted_1$l, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("DittoPreviousNode")), 1),
        createElementVNode("p", null, toDisplayString(unref(t2)("TheApprovalNodeIsSetAsTheSameAsThePreviousNode")), 1)
      ]);
    };
  }
});
const _hoisted_1$k = { class: "type_fieldset" };
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "ProcessStarterFinderConfig",
  setup(__props) {
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", _hoisted_1$k, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("ProcessInitiator")), 1),
        createElementVNode("p", null, toDisplayString(unref(t2)("AfterProcessInitiatorIsSetInThisApprovalNodeTheApproverIsTheInitiatorByDefault")), 1)
      ]);
    };
  }
});
const _hoisted_1$j = { class: "type_fieldset" };
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "OldSystemHandlerFinderConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const flowDesignerModel = injectFlowDesignerModel();
    const configs = injectFlowDesignerConfig();
    const items = computed(() => getFormFieldsItems(flowDesignerModel.value.formSchema, false));
    const { t: t2 } = useLocale();
    const reportTypeItems = computedAsync(async () => await (configs == null ? void 0 : configs.getAllReportTypes()));
    const reportTypeChange = (value) => {
      var _a3;
      if (reportTypeItems.value) {
        const item = (_a3 = reportTypeItems.value) == null ? void 0 : _a3.find((r3) => r3.id === value);
        if (item) {
          model.value.reportToTypeName = item.name;
        }
      }
    };
    const personalIdFieldChange = (value) => {
      if (items.value) {
        const item = items.value.find((i2) => i2.value == value);
        if (item) {
          model.value.personalIdFieldName = item.label;
        }
      }
    };
    const eventDateFieldChange = (value) => {
      if (items.value) {
        const item = items.value.find((i2) => i2.value == value);
        if (item) {
          model.value.eventDateFieldName = item.label;
        }
      }
    };
    const formRules = getHandlerFinderSettingsRules(HandlerFinderDescriptorCodes.OldSystemHandlerFinder, t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_option = resolveComponent("el-option");
      const _component_el_select = resolveComponent("el-select");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock("fieldset", _hoisted_1$j, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("OldSystemHandlerFinder")), 1),
        createVNode(_component_el_form, {
          model: model.value,
          "label-width": "auto",
          ref_key: "formInstance",
          ref: formInstance,
          rules: unref(formRules)
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, {
              label: unref(t2)("ReportToType"),
              prop: "reportToType"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.reportToType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.reportToType = $event),
                  filterable: "",
                  clearable: "",
                  onChange: reportTypeChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(reportTypeItems), (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem == null ? void 0 : vItem.id,
                        label: vItem == null ? void 0 : vItem.name,
                        value: vItem == null ? void 0 : vItem.id
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: unref(t2)("PersonalIdField"),
              prop: "personalIdField"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.personalIdField,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.personalIdField = $event),
                  "allow-create": "",
                  filterable: "",
                  clearable: "",
                  onChange: personalIdFieldChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem.value,
                        label: vItem.label,
                        value: vItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: unref(t2)("EventDateField"),
              prop: "eventDateField"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.eventDateField,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.eventDateField = $event),
                  "allow-create": "",
                  filterable: "",
                  clearable: "",
                  onChange: eventDateFieldChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem.value,
                        label: unref(t2)(vItem.label),
                        value: vItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]);
    };
  }
});
const _hoisted_1$i = { class: "type_fieldset" };
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "AllPreviousNodeOwnersConfig",
  setup(__props) {
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", _hoisted_1$i, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("AllPreviousNodeOwners")), 1),
        createElementVNode("p", null, toDisplayString(unref(t2)("AllPreviousNodeOwners")), 1)
      ]);
    };
  }
});
const _hoisted_1$h = { class: "type_fieldset" };
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "MultiReportToTypeHandlerFinderConfig",
  props: {
    "modelValue": {
      default: () => ({
        reportToType: [],
        reportToTypeName: ""
      })
    },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const flowDesignerModel = injectFlowDesignerModel();
    const configs = injectFlowDesignerConfig();
    const items = computed(() => getFormFieldsItems(flowDesignerModel.value.formSchema, false));
    const { t: t2 } = useLocale();
    const reportTypeItems = computedAsync(async () => await (configs == null ? void 0 : configs.getAllReportTypes()));
    const reportTypeChange = (value) => {
      if (reportTypeItems.value) ;
    };
    watch([() => model.value.reportToType, reportTypeItems], ([newValue]) => {
      var _a3, _b3, _c3;
      const value = newValue ?? model.value.reportToType;
      model.value.reportToTypeName = value ? ((_c3 = (_b3 = (_a3 = reportTypeItems.value) == null ? void 0 : _a3.filter((r3) => value.includes(r3.id))) == null ? void 0 : _b3.map((r3) => r3.name)) == null ? void 0 : _c3.join(",")) ?? "" : "";
    }, { immediate: true });
    const personalIdFieldChange = (value) => {
      if (items.value) {
        const item = items.value.find((i2) => i2.value == value);
        if (item) {
          model.value.personalIdFieldName = item.label;
        }
      }
    };
    const eventDateFieldChange = (value) => {
      if (items.value) {
        const item = items.value.find((i2) => i2.value == value);
        if (item) {
          model.value.eventDateFieldName = item.label;
        }
      }
    };
    const formRules = getHandlerFinderSettingsRules(HandlerFinderDescriptorCodes.MultiReportToTypeHandlerFinder, t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_option = resolveComponent("el-option");
      const _component_el_select = resolveComponent("el-select");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock("fieldset", _hoisted_1$h, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("MultiReportToTypeHandlerFinder")), 1),
        createVNode(_component_el_form, {
          model: model.value,
          "label-width": "auto",
          ref_key: "formInstance",
          ref: formInstance,
          rules: unref(formRules)
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, {
              label: unref(t2)("ReportToType"),
              prop: "reportToType"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.reportToType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.reportToType = $event),
                  multiple: "",
                  filterable: "",
                  clearable: "",
                  onChange: reportTypeChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(reportTypeItems), (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem == null ? void 0 : vItem.id,
                        label: vItem == null ? void 0 : vItem.name,
                        value: vItem == null ? void 0 : vItem.id
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: unref(t2)("PersonalIdField"),
              prop: "personalIdField"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.personalIdField,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.personalIdField = $event),
                  "allow-create": "",
                  filterable: "",
                  clearable: "",
                  onChange: personalIdFieldChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem.value,
                        label: vItem.label,
                        value: vItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: unref(t2)("EventDateField"),
              prop: "eventDateField"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  modelValue: model.value.eventDateField,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.eventDateField = $event),
                  "allow-create": "",
                  filterable: "",
                  clearable: "",
                  onChange: eventDateFieldChange
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(items.value, (vItem) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: vItem.value,
                        label: unref(t2)(vItem.label),
                        value: vItem.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]);
    };
  }
});
const _hoisted_1$g = { class: "type_fieldset" };
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "EmailHandlerFinderConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    var _a3;
    const { t: t2 } = useLocale();
    const model = useModel(__props, "modelValue");
    const emails = ref(Array.isArray((_a3 = model.value) == null ? void 0 : _a3.emails) ? model.value.emails.join(";") : "");
    watch(emails, (newValue) => {
      if (model.value) {
        model.value.emails = newValue == "" ? void 0 : newValue.split(";");
      }
    });
    const formRules = getHandlerFinderSettingsFormRules(HandlerFinderDescriptorCodes.EmailHandlerFinder, t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock("fieldset", _hoisted_1$g, [
        createElementVNode("legend", null, toDisplayString(unref(t2)("EmailHandlerFinder")), 1),
        createVNode(_component_el_form, {
          model: model.value,
          "label-width": "auto",
          ref_key: "formInstance",
          ref: formInstance,
          rules: unref(formRules)
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, {
              label: unref(t2)("Email"),
              prop: "emails"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_input, {
                  modelValue: emails.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => emails.value = $event)
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]);
    };
  }
});
var HandlerFinderDescriptorCodes = /* @__PURE__ */ ((HandlerFinderDescriptorCodes2) => {
  HandlerFinderDescriptorCodes2["PreviousNodeHandlerFinder"] = "PreviousNodeHandlerFinder";
  HandlerFinderDescriptorCodes2["ProcessStarter"] = "ProcessStarter";
  HandlerFinderDescriptorCodes2["FormDataHandlerFinder"] = "FormDataHandlerFinder";
  HandlerFinderDescriptorCodes2["FixedUser"] = "FixedUser";
  HandlerFinderDescriptorCodes2["OldSystemHandlerFinder"] = "OldSystemHandlerFinder";
  HandlerFinderDescriptorCodes2["AllPreviousNodeOwners"] = "AllPreviousNodeOwners";
  HandlerFinderDescriptorCodes2["EmailHandlerFinder"] = "EmailHandlerFinder";
  HandlerFinderDescriptorCodes2["MultiReportToTypeHandlerFinder"] = "MultiReportToTypeHandlerFinder";
  return HandlerFinderDescriptorCodes2;
})(HandlerFinderDescriptorCodes || {});
const finderMap = /* @__PURE__ */ new Map([
  ["PreviousNodeHandlerFinder", _sfc_main$A],
  ["ProcessStarter", _sfc_main$z],
  ["FormDataHandlerFinder", _sfc_main$B],
  ["FixedUser", _sfc_main$C],
  ["OldSystemHandlerFinder", _sfc_main$y],
  ["AllPreviousNodeOwners", _sfc_main$x],
  ["EmailHandlerFinder", _sfc_main$v],
  ["MultiReportToTypeHandlerFinder", _sfc_main$w]
]);
const rulesMap = /* @__PURE__ */ new Map();
const getFriendlyStringMap = /* @__PURE__ */ new Map();
const getAllHandlerFinderDescriptorCodes = () => Array.from(finderMap.keys());
const registerHandlerFinderDefinition = (componentCode, settingsConfigComponent, getFriendlyString, rules2) => {
  finderMap.set(componentCode, settingsConfigComponent);
  if (rules2) {
    rulesMap.set(componentCode, rules2);
  }
};
const getOwnerDescriptorFriendlyString = (handlerFinderDescriptor, formSchema, t2) => {
  var _a3, _b3, _c3, _d3;
  const func = getFriendlyStringMap.get(handlerFinderDescriptor.componentCode);
  if (func) {
    return func(handlerFinderDescriptor);
  }
  switch (handlerFinderDescriptor.componentCode) {
    case HandlerFinderDescriptorCodes.PreviousNodeHandlerFinder:
      return t2("PreviousNodeHandlerFinder");
    case HandlerFinderDescriptorCodes.ProcessStarter:
      return t2("ProcessStarter");
    case HandlerFinderDescriptorCodes.FormDataHandlerFinder:
      let label = "";
      const userIdField = (_a3 = handlerFinderDescriptor.settings) == null ? void 0 : _a3.userIdField;
      if (!isNullOrUndefinedOrWhiteSpace(userIdField)) {
        const names = userIdField == null ? void 0 : userIdField.split(".");
        if (names && names.length > 0) {
          const fieldSchema = getFieldSchema(formSchema, names);
          label = t2(fieldSchema.__config__.label);
        }
      }
      return t2("FormDataHandlerFinder") + ":" + label;
    case HandlerFinderDescriptorCodes.FixedUser:
      return (_d3 = (_c3 = (_b3 = handlerFinderDescriptor.settings) == null ? void 0 : _b3.users) == null ? void 0 : _c3.map((user) => user.name)) == null ? void 0 : _d3.join(",");
    case HandlerFinderDescriptorCodes.OldSystemHandlerFinder:
      handlerFinderDescriptor.settings.personalIdFieldName || handlerFinderDescriptor.settings.personalIdField;
      handlerFinderDescriptor.settings.eventDateFieldName || handlerFinderDescriptor.settings.eventDateField;
      return `${handlerFinderDescriptor.settings.reportToTypeName || handlerFinderDescriptor.settings.reportToType}`;
    case HandlerFinderDescriptorCodes.AllPreviousNodeOwners:
      return t2("AllPreviousNodeOwners");
    case HandlerFinderDescriptorCodes.EmailHandlerFinder:
      return t2("EmailHandlerFinder");
    case HandlerFinderDescriptorCodes.MultiReportToTypeHandlerFinder:
      return handlerFinderDescriptor.settings.reportToTypeName;
  }
  return "";
};
const getNodeOwnerDescriptorFriendlyString = (processNodeDefinition, formSchema, t2) => {
  var _a3, _b3;
  return (_b3 = (_a3 = processNodeDefinition.ownerFinderDescriptor) == null ? void 0 : _a3.handlerFinderDescriptors) == null ? void 0 : _b3.map((finderDescriptor) => getOwnerDescriptorFriendlyString(finderDescriptor, formSchema, t2));
};
const generateShortUUID = () => {
  return shortUuid.generate();
};
const ports = {
  groups: {
    top: {
      position: "top",
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: "#5F95FF",
          strokeWidth: 1,
          fill: "#fff",
          style: {
            visibility: "hidden"
          }
        }
      }
    },
    right: {
      position: "right",
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: "#5F95FF",
          strokeWidth: 1,
          fill: "#fff",
          style: {
            visibility: "hidden"
          }
        }
      }
    },
    bottom: {
      position: "bottom",
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: "#5F95FF",
          strokeWidth: 1,
          fill: "#fff",
          style: {
            visibility: "hidden"
          }
        }
      }
    },
    left: {
      position: "left",
      attrs: {
        circle: {
          r: 4,
          magnet: true,
          stroke: "#5F95FF",
          strokeWidth: 1,
          fill: "#fff",
          style: {
            visibility: "hidden"
          }
        }
      }
    }
  },
  items: [
    {
      group: "top",
      id: "top"
    },
    {
      group: "right",
      id: "right"
    },
    {
      group: "bottom",
      id: "bottom"
    },
    {
      group: "left",
      id: "left"
    }
  ]
};
const createNodeMetadata = (graphNodeType) => {
  graphNodeType = graphNodeType || "user-node";
  return {
    shape: graphNodeType,
    tools: [
      {
        name: "button-remove",
        args: { x: 10, y: 10 }
      }
    ],
    data: { graphNodeType },
    ports: { ...ports }
  };
};
const createStartNodeMetadata = () => {
  return {
    shape: "initial-node",
    data: { graphNodeType: "initial-node" },
    ports: { ...ports },
    x: 100,
    y: 100
  };
};
const createEdgeMetadata = () => {
  return {
    shape: "edge",
    attrs: {
      line: {
        stroke: "#A2B1C3",
        strokeWidth: 2,
        targetMarker: {
          name: "block",
          width: 12,
          height: 8
        }
      }
    }
  };
};
const convertNodeDefinitionToGraphNode = (processNodeDefinition, nodeMetadata) => {
  const graphNodeType = processNodeDefinition.nodeType == "userNode" ? "user-node" : "initial-node";
  if (nodeMetadata && isObject$1(nodeMetadata)) {
    return {
      nodeDefinitionId: processNodeDefinition.code,
      shape: graphNodeType,
      id: generateShortUUID(),
      data: { graphNodeType },
      //processNodeDefinition.code ，可能改变故只能在初次转换时使用
      ...nodeMetadata
    };
  } else {
    return {
      nodeDefinitionId: processNodeDefinition.code,
      shape: graphNodeType,
      id: generateShortUUID(),
      data: { graphNodeType }
    };
  }
};
const convertRouteDefinitionToGraphNode = (processRouteDefinition, nodeMetadata) => {
  var _a3;
  if (((_a3 = processRouteDefinition.routePolicyDescriptor) == null ? void 0 : _a3.componentCode) == "AwaysTrue") {
    return void 0;
  }
  if (nodeMetadata && isObject$1(nodeMetadata)) {
    return {
      nodeDefinitionId: "r-" + processRouteDefinition.code,
      shape: "condition-node",
      id: generateShortUUID(),
      data: { graphNodeType: "condition-node" },
      ...nodeMetadata
    };
  } else {
    return {
      nodeDefinitionId: processRouteDefinition.code,
      shape: "condition-node",
      id: generateShortUUID(),
      data: { graphNodeType: "condition-node" }
    };
  }
};
const isConditionNode$1 = (node) => {
  var _a3;
  if (node == void 0) {
    return false;
  }
  return ((_a3 = node.data) == null ? void 0 : _a3.graphNodeType) == "condition-node";
};
const isStartNode = (node) => {
  var _a3;
  if (node == void 0) {
    return false;
  }
  return ((_a3 = node.data) == null ? void 0 : _a3.graphNodeType) == "initial-node";
};
const widthPorts = (node) => {
  node.ports = { ...ports };
};
const widthRemoveButton = (node) => {
  if (!Array.isArray(node.tools)) {
    node.tools = [
      {
        name: "button-remove",
        args: { x: 10, y: 10 }
      }
    ];
  } else if (!node.tools.some((t2) => t2 == "button-remove" || isObject$1(t2) && t2.name == "button-remove")) {
    node.tools.push({
      name: "button-remove",
      args: { x: 10, y: 10 }
    });
  }
};
const _hoisted_1$f = { class: "node-box__title" };
const _hoisted_2$6 = {
  key: 0,
  class: "validation-errors"
};
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "UserNode",
  setup(__props) {
    const getNode = inject("getNode");
    const flowDesignerModel = injectFlowDesignerModel();
    const node = getNode();
    const nodeId = node.id;
    const nodeType = isStartNode(node) ? "initialNode" : "userNode";
    const processNodeDefinition = computed(() => flowDesignerModel.value.getOrCreateNodeDefinition(nodeId, nodeType));
    const formSchema = computed(() => flowDesignerModel.value.getFormSchema(nodeId));
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const { t: t2 } = useLocale();
    const ownerDescriptorFriendlyStrings = computed(() => {
      return getNodeOwnerDescriptorFriendlyString(processNodeDefinition.value, formSchema.value, t2);
    });
    watch(ownerDescriptorFriendlyStrings, (newValue) => {
      nextTick(() => {
        resizeNodeToContainerSize();
      });
    });
    const container = ref();
    const hasValidateErrors = computed(() => flowDesignerModel.value.hasValidateErrors(node.id));
    const errors = computed(() => flowDesignerModel.value.getValidateErrorMessages(node.id));
    return (_ctx, _cache) => {
      var _a3;
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          class: normalizeClass(["node-box node-box--user", { "node-box--error": hasValidateErrors.value }]),
          ref_key: "container",
          ref: container
        }, [
          createElementVNode("div", _hoisted_1$f, [
            createElementVNode("span", null, toDisplayString((_a3 = processNodeDefinition.value) == null ? void 0 : _a3.name), 1)
          ]),
          createVNode(unref(ElRow), { class: "node-box__context" }, {
            default: withCtx(() => [
              createVNode(unref(ElCol), {
                span: 20,
                class: "text"
              }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(ownerDescriptorFriendlyStrings.value, (item) => {
                    return openBlock(), createElementBlock("p", null, toDisplayString(item), 1);
                  }), 256))
                ]),
                _: 1
              }),
              createVNode(unref(ElCol), {
                span: 4,
                class: "arrow"
              }, {
                default: withCtx(() => [
                  createVNode(unref(ElIcon), { class: "arrow" }, {
                    default: withCtx(() => [
                      createVNode(unref(arrow_right_default))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2),
        hasValidateErrors.value ? (openBlock(), createElementBlock("ul", _hoisted_2$6, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(errors.value, (error, index2) => {
            return openBlock(), createElementBlock("li", {
              key: index2,
              class: "validation-errors__item"
            }, toDisplayString(error), 1);
          }), 128))
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
var __defProp$1 = Object.defineProperty;
var __name = (target, value) => __defProp$1(target, "name", { value, configurable: true });
var IntStream;
((IntStream2) => {
  IntStream2.EOF = -1;
  IntStream2.UNKNOWN_SOURCE_NAME = "<unknown>";
})(IntStream || (IntStream = {}));
var Token;
((Token2) => {
  Token2.INVALID_TYPE = 0;
  Token2.EPSILON = -2;
  Token2.MIN_USER_TOKEN_TYPE = 1;
  Token2.EOF = IntStream.EOF;
  Token2.DEFAULT_CHANNEL = 0;
  Token2.HIDDEN_CHANNEL = 1;
  Token2.MIN_USER_CHANNEL_VALUE = 2;
})(Token || (Token = {}));
var isToken = /* @__PURE__ */ __name((candidate) => {
  const token = candidate;
  return token.tokenSource !== void 0 && token.channel !== void 0;
}, "isToken");
var BitSet = (_a2 = class {
  /**
   * Creates a new bit set. All bits are initially `false`.
   *
   * @param data Optional initial data.
   */
  constructor(data) {
    __publicField(this, "data");
    if (data) {
      this.data = new Uint32Array(data.map((value) => {
        return value >>> 0;
      }));
    } else {
      this.data = new Uint32Array(1);
    }
  }
  /**
   * @returns an iterator over all set bits.
   */
  [Symbol.iterator]() {
    const length = this.data.length;
    let currentIndex = 0;
    let currentWord = this.data[currentIndex];
    const words = this.data;
    return {
      [Symbol.iterator]() {
        return this;
      },
      next: /* @__PURE__ */ __name(() => {
        while (currentIndex < length) {
          if (currentWord !== 0) {
            const t2 = currentWord & -currentWord;
            const value = (currentIndex << 5) + this.bitCount(t2 - 1);
            currentWord ^= t2;
            return { done: false, value };
          } else {
            currentIndex++;
            if (currentIndex < length) {
              currentWord = words[currentIndex];
            }
          }
        }
        return { done: true, value: void 0 };
      }, "next")
    };
  }
  /**
   * Sets a single bit or all of the bits in this `BitSet` to `false`.
   *
   * @param index the index of the bit to be cleared, or undefined to clear all bits.
   */
  clear(index2) {
    if (index2 === void 0) {
      this.data = new Uint32Array();
    } else {
      this.resize(index2);
      this.data[index2 >>> 5] &= ~(1 << index2);
    }
  }
  /**
   * Performs a logical **OR** of this bit set with the bit set argument. This bit set is modified so that a bit in it
   * has the value `true` if and only if it either already had the value `true` or the corresponding bit in the bit
   * set argument has the value `true`.
   *
   * @param set the bit set to be ORed with.
   */
  or(set) {
    const minCount = Math.min(this.data.length, set.data.length);
    for (let k2 = 0; k2 < minCount; ++k2) {
      this.data[k2] |= set.data[k2];
    }
    if (this.data.length < set.data.length) {
      this.resize((set.data.length << 5) - 1);
      const c3 = set.data.length;
      for (let k2 = minCount; k2 < c3; ++k2) {
        this.data[k2] = set.data[k2];
      }
    }
  }
  /**
   * Returns the value of the bit with the specified index. The value is `true` if the bit with the index `bitIndex`
   * is currently set in this `BitSet`; otherwise, the result is `false`.
   *
   * @param index the bit index
   *
   * @returns the value of the bit with the specified index.
   */
  get(index2) {
    if (index2 < 0) {
      throw new RangeError("index cannot be negative");
    }
    const slot = index2 >>> 5;
    if (slot >= this.data.length) {
      return false;
    }
    return (this.data[slot] & 1 << index2 % 32) !== 0;
  }
  /**
   * @returns the number of set bits.
   */
  get length() {
    let result = 0;
    const c3 = this.data.length;
    const w2 = this.data;
    for (let i2 = 0; i2 < c3; i2++) {
      result += this.bitCount(w2[i2]);
    }
    return result;
  }
  /**
   * @returns an array with indices of set bits.
   */
  values() {
    const result = new Array(this.length);
    let pos = 0;
    const length = this.data.length;
    for (let k2 = 0; k2 < length; ++k2) {
      let w2 = this.data[k2];
      while (w2 !== 0) {
        const t2 = w2 & -w2;
        result[pos++] = (k2 << 5) + this.bitCount(t2 - 1);
        w2 ^= t2;
      }
    }
    return result;
  }
  /**
   * @returns the index of the first bit that is set to `true` that occurs on or after the specified starting index.
   * If no such bit exists then undefined is returned.
   *
   * @param fromIndex the index to start checking from (inclusive)
   */
  nextSetBit(fromIndex) {
    if (fromIndex < 0) {
      throw new RangeError("index cannot be negative");
    }
    for (const index2 of this) {
      if (index2 >= fromIndex) {
        return index2;
      }
    }
    return void 0;
  }
  /**
   * Sets the bit at the specified index to `true`.
   *
   * @param index a bit index
   */
  set(index2) {
    if (index2 < 0) {
      throw new RangeError("index cannot be negative");
    }
    this.resize(index2);
    this.data[index2 >>> 5] |= 1 << index2 % 32;
  }
  /**
   * @returns a string representation of this bit set.
   */
  toString() {
    return "{" + this.values().join(", ") + "}";
  }
  resize(index2) {
    const count = index2 + 32 >>> 5;
    if (count <= this.data.length) {
      return;
    }
    const data = new Uint32Array(count);
    data.set(this.data);
    data.fill(0, this.data.length);
    this.data = data;
  }
  bitCount(v2) {
    v2 = v2 - (v2 >> 1 & 1431655765);
    v2 = (v2 & 858993459) + (v2 >> 2 & 858993459);
    v2 = v2 + (v2 >> 4) & 252645135;
    v2 = v2 + (v2 >> 8);
    v2 = v2 + (v2 >> 16);
    return v2 & 63;
  }
}, __name(_a2, "BitSet"), _a2);
var c1 = 3432918353;
var c2 = 461845907;
var r1 = 15;
var r2 = 13;
var m$2 = 5;
var n$1 = 3864292196;
var MurmurHash = (_b = class {
  constructor() {
  }
  /**
   * Initialize the hash using the specified {@code seed}.
   *
   * @param seed the seed
   *
   * @returns the intermediate hash value
   */
  static initialize(seed = _b.defaultSeed) {
    return seed;
  }
  static updateFromComparable(hash, value) {
    return this.update(hash, (value == null ? void 0 : value.hashCode()) ?? 0);
  }
  /**
   * Update the intermediate hash value for the next input {@code value}.
   *
   * @param hash The intermediate hash value.
   * @param value the value to add to the current hash.
   *
   * @returns the updated intermediate hash value
   */
  static update(hash, value) {
    value = Math.imul(value, c1);
    value = value << r1 | value >>> 32 - r1;
    value = Math.imul(value, c2);
    hash = hash ^ value;
    hash = hash << r2 | hash >>> 32 - r2;
    hash = Math.imul(hash, m$2) + n$1;
    return hash;
  }
  /**
   * Apply the final computation steps to the intermediate value {@code hash}
   * to form the final result of the MurmurHash 3 hash function.
   *
   * @param hash The intermediate hash value.
   * @param entryCount The number of values added to the hash.
   *
   * @returns the final hash result
   */
  static finish(hash, entryCount) {
    hash ^= entryCount * 4;
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 2246822507);
    hash ^= hash >>> 13;
    hash = Math.imul(hash, 3266489909);
    hash ^= hash >>> 16;
    return hash;
  }
  /**
   * An all-in-one convenience method to compute a hash for a single value.
   *
   * @param value The value to hash.
   * @param seed The seed for the hash value.
   *
   * @returns The computed hash.
   */
  static hashCode(value, seed) {
    return _b.finish(_b.update(seed ?? _b.defaultSeed, value), 1);
  }
}, __name(_b, "MurmurHash"), __publicField(_b, "defaultSeed", 701), _b);
var ObjectEqualityComparator = (_c = class {
  hashCode(obj) {
    if (obj == null) {
      return 0;
    }
    return obj.hashCode();
  }
  equals(a2, b2) {
    if (a2 == null) {
      return b2 == null;
    }
    return a2.equals(b2);
  }
}, __name(_c, "ObjectEqualityComparator"), __publicField(_c, "instance", new _c()), _c);
var DefaultEqualityComparator = (_d = class {
  hashCode(obj) {
    if (obj == null) {
      return 0;
    }
    return ObjectEqualityComparator.instance.hashCode(obj);
  }
  equals(a2, b2) {
    if (a2 == null) {
      return b2 == null;
    }
    if (typeof a2 === "string" || typeof a2 === "number") {
      return a2 === b2;
    }
    return ObjectEqualityComparator.instance.equals(a2, b2);
  }
}, __name(_d, "DefaultEqualityComparator"), __publicField(_d, "instance", new _d()), _d);
var HashSet = (_e = class {
  constructor(comparatorOrSet, initialCapacity = _e.initialCapacity) {
    // must be power of 2
    __publicField(this, "comparator");
    __publicField(this, "buckets");
    __publicField(this, "threshold");
    /** How many elements in set */
    __publicField(this, "itemCount", 0);
    if (comparatorOrSet instanceof _e) {
      this.comparator = comparatorOrSet.comparator;
      this.buckets = comparatorOrSet.buckets.slice(0);
      for (let i2 = 0; i2 < this.buckets.length; i2++) {
        const bucket = this.buckets[i2];
        if (bucket) {
          this.buckets[i2] = bucket.slice(0);
        }
      }
      this.itemCount = comparatorOrSet.itemCount;
      this.threshold = comparatorOrSet.threshold;
    } else {
      this.comparator = comparatorOrSet ?? DefaultEqualityComparator.instance;
      this.buckets = this.createBuckets(initialCapacity);
      this.threshold = Math.floor(_e.initialCapacity * _e.defaultLoadFactor);
    }
  }
  /**
   * Add `o` to set if not there; return existing value if already
   * there. This method performs the same operation as {@link #add} aside from
   * the return value.
   *
   * @param o the object to add to the set.
   *
   * @returns An existing element that equals to `o` if already in set, otherwise `o`.
   */
  getOrAdd(o2) {
    if (this.itemCount > this.threshold) {
      this.expand();
    }
    const b2 = this.getBucket(o2);
    let bucket = this.buckets[b2];
    if (!bucket) {
      bucket = [o2];
      this.buckets[b2] = bucket;
      ++this.itemCount;
      return o2;
    }
    for (const existing of bucket) {
      if (this.comparator.equals(existing, o2)) {
        return existing;
      }
    }
    bucket.push(o2);
    ++this.itemCount;
    return o2;
  }
  get(o2) {
    if (o2 == null) {
      return o2;
    }
    const b2 = this.getBucket(o2);
    const bucket = this.buckets[b2];
    if (!bucket) {
      return void 0;
    }
    for (const e10 of bucket) {
      if (this.comparator.equals(e10, o2)) {
        return e10;
      }
    }
    return void 0;
  }
  /**
   * Removes the specified element from this set if it is present.
   *
   * @param o object to be removed from this set, if present.
   *
   * @returns `true` if the set contained the specified element.
   */
  remove(o2) {
    if (o2 == null) {
      return false;
    }
    const b2 = this.getBucket(o2);
    const bucket = this.buckets[b2];
    if (!bucket) {
      return false;
    }
    for (let i2 = 0; i2 < bucket.length; i2++) {
      const existing = bucket[i2];
      if (this.comparator.equals(existing, o2)) {
        bucket.splice(i2, 1);
        --this.itemCount;
        return true;
      }
    }
    return false;
  }
  hashCode() {
    let hash = MurmurHash.initialize();
    for (const bucket of this.buckets) {
      if (bucket == null) {
        continue;
      }
      for (const o2 of bucket) {
        if (o2 == null) {
          break;
        }
        hash = MurmurHash.update(hash, this.comparator.hashCode(o2));
      }
    }
    hash = MurmurHash.finish(hash, this.size);
    return hash;
  }
  equals(o2) {
    if (o2 === this) {
      return true;
    }
    if (!(o2 instanceof _e)) {
      return false;
    }
    if (o2.size !== this.size) {
      return false;
    }
    return this.containsAll(o2);
  }
  add(t2) {
    const existing = this.getOrAdd(t2);
    return existing === t2;
  }
  contains(o2) {
    return this.containsFast(o2);
  }
  containsFast(obj) {
    if (obj == null) {
      return false;
    }
    return this.get(obj) !== void 0;
  }
  *[Symbol.iterator]() {
    yield* this.toArray();
  }
  toArray() {
    const a2 = new Array(this.size);
    let i2 = 0;
    for (const bucket of this.buckets) {
      if (bucket == null) {
        continue;
      }
      for (const o2 of bucket) {
        if (o2 == null) {
          break;
        }
        a2[i2++] = o2;
      }
    }
    return a2;
  }
  containsAll(collection) {
    if (collection instanceof _e) {
      for (const bucket of collection.buckets) {
        if (bucket == null) {
          continue;
        }
        for (const o2 of bucket) {
          if (o2 == null) {
            break;
          }
          if (!this.containsFast(o2)) {
            return false;
          }
        }
      }
    } else {
      for (const o2 of collection) {
        if (!this.containsFast(o2)) {
          return false;
        }
      }
    }
    return true;
  }
  addAll(c3) {
    let changed = false;
    for (const o2 of c3) {
      const existing = this.getOrAdd(o2);
      if (existing !== o2) {
        changed = true;
      }
    }
    return changed;
  }
  clear() {
    this.buckets = this.createBuckets(_e.initialCapacity);
    this.itemCount = 0;
    this.threshold = Math.floor(_e.initialCapacity * _e.defaultLoadFactor);
  }
  toString() {
    if (this.size === 0) {
      return "{}";
    }
    let buf = "{";
    let first = true;
    for (const bucket of this.buckets) {
      if (bucket == null) {
        continue;
      }
      for (const o2 of bucket) {
        if (o2 == null) {
          break;
        }
        if (first) {
          first = false;
        } else {
          buf += ", ";
        }
        buf += o2.toString();
      }
    }
    buf += "}";
    return buf;
  }
  toTableString() {
    let buf = "";
    for (const bucket of this.buckets) {
      if (bucket == null) {
        buf += "null\n";
        continue;
      }
      buf += "[";
      let first = true;
      for (const o2 of bucket) {
        if (first) {
          first = false;
        } else {
          buf += " ";
        }
        if (o2 == null) {
          buf += "_";
        } else {
          buf += o2.toString();
        }
      }
      buf += "]\n";
    }
    return buf;
  }
  getBucket(o2) {
    const hash = this.comparator.hashCode(o2);
    const b2 = hash & this.buckets.length - 1;
    return b2;
  }
  expand() {
    const old = this.buckets;
    const newCapacity = this.buckets.length * 2;
    const newTable = this.createBuckets(newCapacity);
    this.buckets = newTable;
    this.threshold = Math.floor(newCapacity * _e.defaultLoadFactor);
    for (const bucket of old) {
      if (!bucket) {
        continue;
      }
      for (const o2 of bucket) {
        const b2 = this.getBucket(o2);
        let newBucket = this.buckets[b2];
        if (!newBucket) {
          newBucket = [];
          this.buckets[b2] = newBucket;
        }
        newBucket.push(o2);
      }
    }
  }
  get size() {
    return this.itemCount;
  }
  get isEmpty() {
    return this.itemCount === 0;
  }
  /**
   * Return an array of `T[]` with length `capacity`.
   *
   * @param capacity the length of the array to return
   * @returns the newly constructed array
   */
  createBuckets(capacity) {
    return new Array(capacity);
  }
}, __name(_e, "HashSet"), __publicField(_e, "defaultLoadFactor", 0.75), __publicField(_e, "initialCapacity", 16), _e);
var Interval = (_f = class {
  constructor(start, stop) {
    __publicField(this, "start");
    __publicField(this, "stop");
    __publicField(this, "cachedHashCode");
    this.start = start;
    this.stop = stop;
    this.cachedHashCode = Math.imul(651 + start, 31) + stop;
  }
  /**
   * Creates a new interval from the given values.
   *
   * Interval objects are used readonly so share all with the
   * same single value a==b up to some max size. Use an array as a perfect hash.
   * Return shared object for 0..INTERVAL_POOL_MAX_VALUE or a new
   * Interval object with a..a in it.  On Java.g4, 218623 IntervalSets
   * have a..a (set with 1 element).
   *
   * @param a The start of the interval.
   * @param b The end of the interval (inclusive).
   *
   * @returns A cached or new interval.
   */
  static of(a2, b2) {
    if (a2 !== b2 || a2 < 0 || a2 > _f.INTERVAL_POOL_MAX_VALUE) {
      return new _f(a2, b2);
    }
    if (!_f.cache[a2]) {
      _f.cache[a2] = new _f(a2, a2);
    }
    return _f.cache[a2];
  }
  equals(o2) {
    return this.start === o2.start && this.stop === o2.stop;
  }
  hashCode() {
    return this.cachedHashCode;
  }
  /** Does this start completely before other? Disjoint */
  startsBeforeDisjoint(other) {
    return this.start < other.start && this.stop < other.start;
  }
  /** Does this start at or before other? Nondisjoint */
  startsBeforeNonDisjoint(other) {
    return this.start <= other.start && this.stop >= other.start;
  }
  /** Does this.start start after other.stop? May or may not be disjoint */
  startsAfter(other) {
    return this.start > other.start;
  }
  /** Does this start completely after other? Disjoint */
  startsAfterDisjoint(other) {
    return this.start > other.stop;
  }
  /** Does this start after other? NonDisjoint */
  startsAfterNonDisjoint(other) {
    return this.start > other.start && this.start <= other.stop;
  }
  /** Are both ranges disjoint? I.e., no overlap? */
  disjoint(other) {
    return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
  }
  /** Are two intervals adjacent such as 0..41 and 42..42? */
  adjacent(other) {
    return this.start === other.stop + 1 || this.stop === other.start - 1;
  }
  properlyContains(other) {
    return other.start >= this.start && other.stop <= this.stop;
  }
  /** Return the interval computed from combining this and other */
  union(other) {
    return _f.of(Math.min(this.start, other.start), Math.max(this.stop, other.stop));
  }
  /** Return the interval in common between this and o */
  intersection(other) {
    return _f.of(Math.max(this.start, other.start), Math.min(this.stop, other.stop));
  }
  /**
   * Return the interval with elements from this not in other;
   *  other must not be totally enclosed (properly contained)
   *  within this, which would result in two disjoint intervals
   *  instead of the single one returned by this method.
   */
  differenceNotProperlyContained(other) {
    let diff = null;
    if (other.startsBeforeNonDisjoint(this)) {
      diff = _f.of(Math.max(this.start, other.stop + 1), this.stop);
    } else if (other.startsAfterNonDisjoint(this)) {
      diff = _f.of(this.start, other.start - 1);
    }
    return diff;
  }
  toString() {
    return `${this.start}..${this.stop}`;
  }
  get length() {
    if (this.stop < this.start) {
      return 0;
    }
    return this.stop - this.start + 1;
  }
}, __name(_f, "Interval"), __publicField(_f, "INVALID_INTERVAL", new _f(-1, -2)), __publicField(_f, "INTERVAL_POOL_MAX_VALUE", 1e3), __publicField(_f, "cache", []), _f);
var Vocabulary = (_g = class {
  /**
   * Constructs a new instance of {@link Vocabulary} from the specified
   * literal, symbolic, and display token names.
   *
   * @param literalNames The literal names assigned to tokens, or `null`
   * if no literal names are assigned.
   * @param symbolicNames The symbolic names assigned to tokens, or
   * `null` if no symbolic names are assigned.
   * @param displayNames The display names assigned to tokens, or `null`
   * to use the values in `literalNames` and `symbolicNames` as
   * the source of display names, as described in
   * {@link #getDisplayName(int)}.
   */
  constructor(literalNames, symbolicNames, displayNames) {
    __publicField(this, "maxTokenType");
    __publicField(this, "literalNames");
    __publicField(this, "symbolicNames");
    __publicField(this, "displayNames");
    this.literalNames = literalNames ?? _g.EMPTY_NAMES;
    this.symbolicNames = symbolicNames ?? _g.EMPTY_NAMES;
    this.displayNames = displayNames ?? _g.EMPTY_NAMES;
    this.maxTokenType = Math.max(this.displayNames.length, Math.max(
      this.literalNames.length,
      this.symbolicNames.length
    )) - 1;
  }
  /**
   * Returns a {@link Vocabulary} instance from the specified set of token
   * names. This method acts as a compatibility layer for the single
   * `tokenNames` array generated by previous releases of ANTLR.
   *
   * The resulting vocabulary instance returns `null` for
   * {@link getLiteralName getLiteralName(int)} and {@link getSymbolicName getSymbolicName(int)}, and the
   * value from `tokenNames` for the display names.
   *
   * @param tokenNames The token names, or `null` if no token names are
   * available.
   * @returns A {@link Vocabulary} instance which uses `tokenNames` for
   * the display names of tokens.
   */
  static fromTokenNames(tokenNames) {
    if (tokenNames == null || tokenNames.length === 0) {
      return _g.EMPTY_VOCABULARY;
    }
    const literalNames = [...tokenNames];
    const symbolicNames = [...tokenNames];
    for (let i2 = 0; i2 < tokenNames.length; i2++) {
      const tokenName = tokenNames[i2];
      if (tokenName == null) {
        continue;
      }
      if (tokenName.length > 0) {
        const firstChar = tokenName.codePointAt(0);
        if (firstChar === 39) {
          symbolicNames[i2] = null;
          continue;
        } else if (firstChar >= 65 && firstChar <= 90) {
          literalNames[i2] = null;
          continue;
        }
      }
      literalNames[i2] = null;
      symbolicNames[i2] = null;
    }
    return new _g(literalNames, symbolicNames, tokenNames);
  }
  getMaxTokenType() {
    return this.maxTokenType;
  }
  getLiteralName(tokenType) {
    if (tokenType >= 0 && tokenType < this.literalNames.length) {
      return this.literalNames[tokenType];
    }
    return null;
  }
  getSymbolicName(tokenType) {
    if (tokenType >= 0 && tokenType < this.symbolicNames.length) {
      return this.symbolicNames[tokenType];
    }
    if (tokenType === Token.EOF) {
      return "EOF";
    }
    return null;
  }
  getDisplayName(tokenType) {
    if (tokenType >= 0 && tokenType < this.displayNames.length) {
      const displayName = this.displayNames[tokenType];
      if (displayName != null) {
        return displayName;
      }
    }
    const literalName = this.getLiteralName(tokenType);
    if (literalName != null) {
      return literalName;
    }
    const symbolicName = this.getSymbolicName(tokenType);
    if (symbolicName != null) {
      return symbolicName;
    }
    return `${tokenType}`;
  }
  getLiteralNames() {
    return this.literalNames;
  }
  getSymbolicNames() {
    return this.symbolicNames;
  }
  getDisplayNames() {
    return this.displayNames;
  }
}, __name(_g, "Vocabulary"), __publicField(_g, "EMPTY_NAMES", []), /**
 * Gets an empty {@link Vocabulary} instance.
 *
 *
 * No literal or symbol names are assigned to token types, so
 * {@link #getDisplayName(int)} returns the numeric value for all tokens
 * except {@link Token#EOF}.
 */
__publicField(_g, "EMPTY_VOCABULARY", new _g(_g.EMPTY_NAMES, _g.EMPTY_NAMES, _g.EMPTY_NAMES)), _g);
var IntervalSet = (_h = class {
  constructor(set) {
    /** The list of sorted, disjoint intervals. */
    __publicField(this, "intervals", []);
    __publicField(this, "cachedHashCode");
    if (set) {
      if (Array.isArray(set)) {
        for (const el2 of set) {
          this.addOne(el2);
        }
      } else {
        this.addSet(set);
      }
    }
  }
  /** Create a set with all ints within range [a..b] (inclusive) */
  static of(a2, b2) {
    const s2 = new _h();
    s2.addRange(a2, b2);
    return s2;
  }
  /** Combine all sets in the array and return the union of them */
  static or(sets) {
    const result = new _h();
    for (const set of sets) {
      result.addSet(set);
    }
    return result;
  }
  [Symbol.iterator]() {
    return this.intervals[Symbol.iterator]();
  }
  get(index2) {
    return this.intervals[index2];
  }
  /**
   * Returns the minimum value contained in the set if not isNil().
   *
   * @returns the minimum value contained in the set.
   */
  get minElement() {
    if (this.intervals.length === 0) {
      return Token.INVALID_TYPE;
    }
    return this.intervals[0].start;
  }
  /**
   * Returns the maximum value contained in the set if not isNil().
   *
   * @returns the maximum value contained in the set.
   */
  get maxElement() {
    if (this.intervals.length === 0) {
      return Token.INVALID_TYPE;
    }
    return this.intervals[this.intervals.length - 1].stop;
  }
  clear() {
    this.cachedHashCode = void 0;
    this.intervals = [];
  }
  /**
   * Add a single element to the set.  An isolated element is stored
   *  as a range el..el.
   */
  addOne(v2) {
    this.addInterval(new Interval(v2, v2));
  }
  /**
   * Add interval; i.e., add all integers from a to b to set.
   *  If b < a, do nothing.
   *  Keep list in sorted order (by left range value).
   *  If overlap, combine ranges. For example,
   *  If this is {1..5, 10..20}, adding 6..7 yields
   *  {1..5, 6..7, 10..20}. Adding 4..8 yields {1..8, 10..20}.
   */
  addRange(l2, h2) {
    this.addInterval(new Interval(l2, h2));
  }
  addInterval(addition) {
    this.cachedHashCode = void 0;
    if (this.intervals.length === 0) {
      this.intervals.push(addition);
    } else {
      for (let pos = 0; pos < this.intervals.length; pos++) {
        const existing = this.intervals[pos];
        if (addition.equals(existing)) {
          return;
        }
        if (addition.adjacent(existing) || !addition.disjoint(existing)) {
          const bigger = addition.union(existing);
          this.intervals[pos] = bigger;
          for (let sub = pos + 1; sub < this.intervals.length; ) {
            const next = this.intervals[sub];
            if (!bigger.adjacent(next) && bigger.disjoint(next)) {
              break;
            }
            this.intervals.splice(sub, 1);
            this.intervals[pos] = bigger.union(next);
          }
          return;
        }
        if (addition.startsBeforeDisjoint(existing)) {
          this.intervals.splice(pos, 0, addition);
          return;
        }
      }
      this.intervals.push(addition);
    }
  }
  addSet(other) {
    other.intervals.forEach((toAdd) => {
      return this.addInterval(toAdd);
    }, this);
    return this;
  }
  complementWithVocabulary(vocabulary) {
    const result = new _h();
    if (!vocabulary) {
      return result;
    }
    if (vocabulary.length === 0) {
      return result;
    }
    result.addSet(vocabulary);
    return result.subtract(this);
  }
  complement(minElement, maxElement) {
    const result = new _h();
    result.addInterval(new Interval(minElement, maxElement));
    return result.subtract(this);
  }
  /** combine all sets in the array returned the or'd value */
  or(sets) {
    const result = new _h();
    result.addSet(this);
    sets.forEach((set) => {
      return result.addSet(set);
    });
    return result;
  }
  and(other) {
    if (other.length === 0) {
      return new _h();
    }
    const myIntervals = this.intervals;
    const theirIntervals = other.intervals;
    let intersection;
    const mySize = myIntervals.length;
    const theirSize = theirIntervals.length;
    let i2 = 0;
    let j2 = 0;
    while (i2 < mySize && j2 < theirSize) {
      const mine = myIntervals[i2];
      const theirs = theirIntervals[j2];
      if (mine.startsBeforeDisjoint(theirs)) {
        i2++;
      } else if (theirs.startsBeforeDisjoint(mine)) {
        j2++;
      } else if (mine.properlyContains(theirs)) {
        if (!intersection) {
          intersection = new _h();
        }
        intersection.addInterval(mine.intersection(theirs));
        j2++;
      } else if (theirs.properlyContains(mine)) {
        if (!intersection) {
          intersection = new _h();
        }
        intersection.addInterval(mine.intersection(theirs));
        i2++;
      } else if (!mine.disjoint(theirs)) {
        if (!intersection) {
          intersection = new _h();
        }
        intersection.addInterval(mine.intersection(theirs));
        if (mine.startsAfterNonDisjoint(theirs)) {
          j2++;
        } else if (theirs.startsAfterNonDisjoint(mine)) {
          i2++;
        }
      }
    }
    if (!intersection) {
      return new _h();
    }
    return intersection;
  }
  /**
   * Compute the set difference between two interval sets. The specific
   * operation is `left - right`. If either of the input sets is
   * `null`, it is treated as though it was an empty set.
   */
  subtract(other) {
    if (this.length === 0) {
      return new _h();
    }
    const result = new _h(this);
    if (other.length === 0) {
      return result;
    }
    let resultI = 0;
    let rightI = 0;
    while (resultI < result.intervals.length && rightI < other.intervals.length) {
      const resultInterval = result.intervals[resultI];
      const rightInterval = other.intervals[rightI];
      if (rightInterval.stop < resultInterval.start) {
        rightI++;
        continue;
      }
      if (rightInterval.start > resultInterval.stop) {
        resultI++;
        continue;
      }
      let beforeCurrent;
      let afterCurrent;
      if (rightInterval.start > resultInterval.start) {
        beforeCurrent = new Interval(resultInterval.start, rightInterval.start - 1);
      }
      if (rightInterval.stop < resultInterval.stop) {
        afterCurrent = new Interval(rightInterval.stop + 1, resultInterval.stop);
      }
      if (beforeCurrent) {
        if (afterCurrent) {
          result.intervals[resultI] = beforeCurrent;
          result.intervals.splice(resultI + 1, 0, afterCurrent);
          resultI++;
          rightI++;
        } else {
          result.intervals[resultI] = beforeCurrent;
          resultI++;
        }
      } else {
        if (afterCurrent) {
          result.intervals[resultI] = afterCurrent;
          rightI++;
        } else {
          result.intervals.splice(resultI, 1);
        }
      }
    }
    return result;
  }
  contains(el2) {
    const n2 = this.intervals.length;
    let l2 = 0;
    let r3 = n2 - 1;
    while (l2 <= r3) {
      const m2 = Math.floor((l2 + r3) / 2);
      const interval = this.intervals[m2];
      if (interval.stop < el2) {
        l2 = m2 + 1;
      } else if (interval.start > el2) {
        r3 = m2 - 1;
      } else {
        return true;
      }
    }
    return false;
  }
  removeRange(toRemove) {
    this.cachedHashCode = void 0;
    if (toRemove.start === toRemove.stop) {
      this.removeOne(toRemove.start);
    } else if (this.intervals !== null) {
      let pos = 0;
      for (const existing of this.intervals) {
        if (toRemove.stop <= existing.start) {
          return;
        } else if (toRemove.start > existing.start && toRemove.stop < existing.stop) {
          this.intervals[pos] = new Interval(existing.start, toRemove.start);
          const x2 = new Interval(toRemove.stop, existing.stop);
          this.intervals.splice(pos, 0, x2);
          return;
        } else if (toRemove.start <= existing.start && toRemove.stop >= existing.stop) {
          this.intervals.splice(pos, 1);
          pos = pos - 1;
        } else if (toRemove.start < existing.stop) {
          this.intervals[pos] = new Interval(existing.start, toRemove.start);
        } else if (toRemove.stop < existing.stop) {
          this.intervals[pos] = new Interval(toRemove.stop, existing.stop);
        }
        pos += 1;
      }
    }
  }
  removeOne(value) {
    this.cachedHashCode = void 0;
    for (let i2 = 0; i2 < this.intervals.length; i2++) {
      const existing = this.intervals[i2];
      if (value < existing.start) {
        return;
      } else if (value === existing.start && value === existing.stop) {
        this.intervals.splice(i2, 1);
        return;
      } else if (value === existing.start) {
        this.intervals[i2] = new Interval(existing.start + 1, existing.stop);
        return;
      } else if (value === existing.stop) {
        this.intervals[i2] = new Interval(existing.start, existing.stop - 1);
        return;
      } else if (value < existing.stop) {
        const replace = new Interval(existing.start, value - 1);
        this.intervals[i2] = new Interval(value + 1, existing.stop);
        this.intervals.splice(i2, 0, replace);
        return;
      }
    }
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      for (const interval of this.intervals) {
        hash = MurmurHash.update(hash, interval.start);
        hash = MurmurHash.update(hash, interval.stop);
      }
      this.cachedHashCode = MurmurHash.finish(hash, this.intervals.length * 2);
    }
    return this.cachedHashCode;
  }
  /**
   * Are two IntervalSets equal? Because all intervals are sorted and disjoint, equals is a simple linear walk over
   * both lists to make sure they are the same. Interval.equals() is used by the List.equals() method to check
   * the ranges.
   */
  equals(other) {
    if (this === other) {
      return true;
    }
    if (this.intervals.length !== other.intervals.length) {
      return false;
    }
    for (let i2 = 0; i2 < this.intervals.length; i2++) {
      if (!this.intervals[i2].equals(other.intervals[i2])) {
        return false;
      }
    }
    return true;
  }
  toString(elementsAreChar) {
    if (this.intervals.length === 0) {
      return "{}";
    }
    let result = "";
    if (this.length > 1) {
      result += "{";
    }
    for (let i2 = 0; i2 < this.intervals.length; ++i2) {
      const interval = this.intervals[i2];
      const start = interval.start;
      const stop = interval.stop;
      if (start === stop) {
        if (start === Token.EOF) {
          result += "<EOF>";
        } else if (elementsAreChar) {
          result += "'" + String.fromCodePoint(start) + "'";
        } else {
          result += start;
        }
      } else {
        if (elementsAreChar) {
          result += "'" + String.fromCodePoint(start) + "'..'" + String.fromCodePoint(stop) + "'";
        } else {
          result += start + ".." + stop;
        }
      }
      if (i2 < this.intervals.length - 1) {
        result += ", ";
      }
    }
    if (this.length > 1) {
      result += "}";
    }
    return result;
  }
  toStringWithVocabulary(vocabulary) {
    if (this.intervals.length === 0) {
      return "{}";
    }
    let result = "";
    if (this.length > 1) {
      result += "{";
    }
    for (let i2 = 0; i2 < this.intervals.length; ++i2) {
      const interval = this.intervals[i2];
      const start = interval.start;
      const stop = interval.stop;
      if (start === stop) {
        if (start === Token.EOF) {
          result += "<EOF>";
        } else {
          result += this.elementName(vocabulary, start);
        }
      } else {
        for (let i22 = start; i22 <= stop; ++i22) {
          if (i22 > start) {
            result += ", ";
          }
          result += this.elementName(vocabulary, i22);
        }
      }
      if (i2 < this.intervals.length - 1) {
        result += ", ";
      }
    }
    if (this.length > 1) {
      result += "}";
    }
    return result;
  }
  toStringWithRuleNames(ruleNames) {
    if (this.intervals.length === 0) {
      return "{}";
    }
    let result = "";
    if (this.length > 1) {
      result += "{";
    }
    const vocabulary = Vocabulary.fromTokenNames(ruleNames);
    for (let i2 = 0; i2 < this.intervals.length; ++i2) {
      const interval = this.intervals[i2];
      const start = interval.start;
      const stop = interval.stop;
      if (start === stop) {
        if (start === Token.EOF) {
          result += "<EOF>";
        } else {
          result += this.elementName(vocabulary, start);
        }
      } else {
        for (let i22 = start; i22 <= stop; ++i22) {
          if (i22 > start) {
            result += ", ";
          }
          result += this.elementName(vocabulary, i22);
        }
      }
      if (i2 < this.intervals.length - 1) {
        result += ", ";
      }
    }
    if (this.length > 1) {
      result += "}";
    }
    return result;
  }
  toArray() {
    const data = [];
    for (const interval of this.intervals) {
      for (let j2 = interval.start; j2 <= interval.stop; j2++) {
        data.push(j2);
      }
    }
    return data;
  }
  /** @returns the number of elements in this set. */
  get length() {
    let result = 0;
    for (const interval of this.intervals) {
      result += interval.length;
    }
    return result;
  }
  elementName(vocabulary, token) {
    if (token === Token.EOF) {
      return "<EOF>";
    }
    if (token === Token.EPSILON) {
      return "<EPSILON>";
    }
    return vocabulary.getDisplayName(token);
  }
}, __name(_h, "IntervalSet"), _h);
var valueToString = /* @__PURE__ */ __name((v2) => {
  return v2 === null ? "null" : v2;
}, "valueToString");
var arrayToString = /* @__PURE__ */ __name((value) => {
  return Array.isArray(value) ? "[" + value.map(valueToString).join(", ") + "]" : "null";
}, "arrayToString");
var equalArrays = /* @__PURE__ */ __name((a2, b2) => {
  if (a2 === b2) {
    return true;
  }
  if (a2.length !== b2.length) {
    return false;
  }
  for (let i2 = 0; i2 < a2.length; i2++) {
    const left = a2[i2];
    const right = b2[i2];
    if (left === right) {
      continue;
    }
    if (!left || !left.equals(right)) {
      return false;
    }
  }
  return true;
}, "equalArrays");
var equalNumberArrays = /* @__PURE__ */ __name((a2, b2) => {
  if (a2 === b2) {
    return true;
  }
  if (a2.length !== b2.length) {
    return false;
  }
  for (let i2 = 0; i2 < a2.length; i2++) {
    if (a2[i2] !== b2[i2]) {
      return false;
    }
  }
  return true;
}, "equalNumberArrays");
var escapeWhitespace = /* @__PURE__ */ __name((s2, escapeSpaces = false) => {
  s2 = s2.replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r");
  if (escapeSpaces) {
    s2 = s2.replace(/ /g, "·");
  }
  return s2;
}, "escapeWhitespace");
var SemanticContext = (_i = class {
  constructor() {
    __publicField(this, "cachedHashCode");
  }
  static andContext(a2, b2) {
    if (a2 === null || a2 === _i.NONE) {
      return b2;
    }
    if (b2 === null || b2 === _i.NONE) {
      return a2;
    }
    const result = new AND(a2, b2);
    if (result.operands.length === 1) {
      return result.operands[0];
    }
    return result;
  }
  static orContext(a2, b2) {
    if (a2 === null) {
      return b2;
    }
    if (b2 === null) {
      return a2;
    }
    if (a2 === _i.NONE || b2 === _i.NONE) {
      return _i.NONE;
    }
    const result = new OR(a2, b2);
    if (result.operands.length === 1) {
      return result.operands[0];
    } else {
      return result;
    }
  }
  static filterPrecedencePredicates(set) {
    const result = [];
    for (const context of set) {
      if (context instanceof _i.PrecedencePredicate) {
        result.push(context);
      }
    }
    return result;
  }
  /**
   * Evaluate the precedence predicates for the context and reduce the result.
   *
   * @param _parser The parser instance.
   * @param _parserCallStack The current parser context object.
   * @returns The simplified semantic context after precedence predicates are
   * evaluated, which will be one of the following values.
   * - {@link NONE}: if the predicate simplifies to `true` after
   * precedence predicates are evaluated.
   * - `null`: if the predicate simplifies to `false` after
   * precedence predicates are evaluated.
   * - `this`: if the semantic context is not changed as a result of
   * precedence predicate evaluation.
   * - A non-`null` {@link SemanticContext}: the new simplified
   * semantic context after precedence predicates are evaluated.
   */
  evalPrecedence(_parser, _parserCallStack) {
    return this;
  }
}, __name(_i, "SemanticContext"), _i);
var AND = (_j = class extends SemanticContext {
  /**
   * A semantic context which is true whenever none of the contained contexts
   * is false
   */
  constructor(a2, b2) {
    super();
    __publicField(this, "operands");
    const operands = new HashSet();
    if (a2 instanceof _j) {
      a2.operands.forEach((o2) => {
        operands.add(o2);
      });
    } else {
      operands.add(a2);
    }
    if (b2 instanceof _j) {
      b2.operands.forEach((o2) => {
        operands.add(o2);
      });
    } else {
      operands.add(b2);
    }
    const precedencePredicates = SemanticContext.filterPrecedencePredicates(operands);
    if (precedencePredicates.length > 0) {
      let reduced = null;
      precedencePredicates.forEach((p2) => {
        if (reduced === null || p2.precedence < reduced.precedence) {
          reduced = p2;
        }
      });
      if (reduced) {
        operands.add(reduced);
      }
    }
    this.operands = operands.toArray();
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _j)) {
      return false;
    }
    return equalArrays(this.operands, other.operands);
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      for (const operand of this.operands) {
        hash = MurmurHash.updateFromComparable(hash, operand);
      }
      hash = MurmurHash.update(hash, 3813686060);
      this.cachedHashCode = MurmurHash.finish(hash, this.operands.length + 1);
    }
    return this.cachedHashCode;
  }
  /**
   * {@inheritDoc}
   *
   *
   * The evaluation of predicates by this context is short-circuiting, but
   * unordered.
   */
  evaluate(parser, parserCallStack) {
    for (const operand of this.operands) {
      if (!operand.evaluate(parser, parserCallStack)) {
        return false;
      }
    }
    return true;
  }
  evalPrecedence(parser, parserCallStack) {
    let differs = false;
    const operands = [];
    for (const context of this.operands) {
      const evaluated = context.evalPrecedence(parser, parserCallStack);
      differs || (differs = evaluated !== context);
      if (evaluated === null) {
        return null;
      } else if (evaluated !== SemanticContext.NONE) {
        operands.push(evaluated);
      }
    }
    if (!differs) {
      return this;
    }
    if (operands.length === 0) {
      return SemanticContext.NONE;
    }
    let result = null;
    operands.forEach((o2) => {
      result = result === null ? o2 : SemanticContext.andContext(result, o2);
    });
    return result;
  }
  toString() {
    const s2 = this.operands.map((o2) => {
      return o2.toString();
    });
    return (s2.length > 3 ? s2.slice(3) : s2).join("&&");
  }
}, __name(_j, "AND"), _j);
var OR = (_k = class extends SemanticContext {
  /**
   * A semantic context which is true whenever at least one of the contained
   * contexts is true
   */
  constructor(a2, b2) {
    super();
    __publicField(this, "operands");
    const operands = new HashSet();
    if (a2 instanceof _k) {
      a2.operands.forEach((o2) => {
        operands.add(o2);
      });
    } else {
      operands.add(a2);
    }
    if (b2 instanceof _k) {
      b2.operands.forEach((o2) => {
        operands.add(o2);
      });
    } else {
      operands.add(b2);
    }
    const precedencePredicates = SemanticContext.filterPrecedencePredicates(operands);
    if (precedencePredicates.length > 0) {
      const s2 = precedencePredicates.sort((a22, b22) => {
        return a22.compareTo(b22);
      });
      const reduced = s2[s2.length - 1];
      operands.add(reduced);
    }
    this.operands = operands.toArray();
  }
  equals(other) {
    if (this === other) {
      return true;
    } else if (!(other instanceof _k)) {
      return false;
    } else {
      return equalArrays(this.operands, other.operands);
    }
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      for (const operand of this.operands) {
        hash = MurmurHash.updateFromComparable(hash, operand);
      }
      hash = MurmurHash.update(hash, 3383313031);
      this.cachedHashCode = MurmurHash.finish(hash, this.operands.length + 1);
    }
    return this.cachedHashCode;
  }
  /**
   * The evaluation of predicates by this context is short-circuiting, but unordered.
   */
  evaluate(parser, parserCallStack) {
    for (const operand of this.operands) {
      if (operand.evaluate(parser, parserCallStack)) {
        return true;
      }
    }
    return false;
  }
  evalPrecedence(parser, parserCallStack) {
    let differs = false;
    const operands = [];
    for (const context of this.operands) {
      const evaluated = context.evalPrecedence(parser, parserCallStack);
      differs || (differs = evaluated !== context);
      if (evaluated === SemanticContext.NONE) {
        return SemanticContext.NONE;
      } else if (evaluated !== null) {
        operands.push(evaluated);
      }
    }
    if (!differs) {
      return this;
    }
    if (operands.length === 0) {
      return null;
    }
    let result = null;
    operands.forEach((o2) => {
      result = result === null ? o2 : SemanticContext.orContext(result, o2);
    });
    return result;
  }
  toString() {
    const s2 = this.operands.map((o2) => {
      return o2.toString();
    });
    return (s2.length > 3 ? s2.slice(3) : s2).join("||");
  }
}, __name(_k, "OR"), _k);
((SemanticContext2) => {
  const _Predicate = class _Predicate extends SemanticContext2 {
    // e.g., $i ref in pred
    constructor(ruleIndex, predIndex, isCtxDependent) {
      super();
      __publicField(this, "ruleIndex");
      __publicField(this, "predIndex");
      __publicField(this, "isCtxDependent");
      this.ruleIndex = ruleIndex ?? -1;
      this.predIndex = predIndex ?? -1;
      this.isCtxDependent = isCtxDependent ?? false;
    }
    evaluate(parser, outerContext) {
      const localctx = this.isCtxDependent ? outerContext : null;
      return parser.sempred(localctx, this.ruleIndex, this.predIndex);
    }
    hashCode() {
      if (this.cachedHashCode === void 0) {
        let hashCode = MurmurHash.initialize();
        hashCode = MurmurHash.update(hashCode, this.ruleIndex);
        hashCode = MurmurHash.update(hashCode, this.predIndex);
        hashCode = MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
        hashCode = MurmurHash.finish(hashCode, 3);
        this.cachedHashCode = hashCode;
      }
      return this.cachedHashCode;
    }
    equals(other) {
      if (this === other) {
        return true;
      }
      return this.ruleIndex === other.ruleIndex && this.predIndex === other.predIndex && this.isCtxDependent === other.isCtxDependent;
    }
    toString() {
      return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
    }
  };
  __name(_Predicate, "Predicate");
  let Predicate2 = _Predicate;
  SemanticContext2.Predicate = Predicate2;
  const _PrecedencePredicate = class _PrecedencePredicate extends SemanticContext2 {
    constructor(precedence) {
      super();
      __publicField(this, "precedence");
      this.precedence = precedence ?? 0;
    }
    evaluate(parser, outerContext) {
      return parser.precpred(outerContext, this.precedence);
    }
    evalPrecedence(parser, outerContext) {
      if (parser.precpred(outerContext ?? null, this.precedence)) {
        return SemanticContext2.NONE;
      }
      return null;
    }
    compareTo(other) {
      return this.precedence - other.precedence;
    }
    hashCode() {
      return 31 + this.precedence;
    }
    equals(other) {
      if (this === other) {
        return true;
      }
      return this.precedence === other.precedence;
    }
    toString() {
      return "{" + this.precedence + ">=prec}?";
    }
  };
  __name(_PrecedencePredicate, "PrecedencePredicate");
  let PrecedencePredicate = _PrecedencePredicate;
  SemanticContext2.PrecedencePredicate = PrecedencePredicate;
  SemanticContext2.NONE = new Predicate2();
})(SemanticContext || (SemanticContext = {}));
var ATNConfig = (_l = class {
  /** Never create config classes directly. Use the factory methods below. */
  constructor(c3, state, context, semanticContext) {
    /** The ATN state associated with this configuration */
    __publicField(this, "state");
    /** What alt (or lexer rule) is predicted by this configuration */
    __publicField(this, "alt");
    /**
     * We cannot execute predicates dependent upon local context unless
     * we know for sure we are in the correct context. Because there is
     * no way to do this efficiently, we simply cannot evaluate
     * dependent predicates unless we are in the rule that initially
     * invokes the ATN simulator.
     *
     * closure() tracks the depth of how far we dip into the outer context:
     * depth > 0.
     */
    __publicField(this, "reachesIntoOuterContext", false);
    // Not used in hash code.
    __publicField(this, "precedenceFilterSuppressed", false);
    __publicField(this, "cachedHashCode");
    // Shared with LexerATNConfig.
    /**
     * The syntactic context is a graph-structured stack node whose
     * path(s) to the root is the rule invocation(s)
     * chain used to arrive at the state.  The semantic context is
     * the tree of semantic predicates encountered before reaching
     * an ATN state
     */
    __privateAdd(this, _context, null);
    __privateAdd(this, _semanticContext);
    this.state = state;
    this.alt = c3.alt;
    this.context = context;
    __privateSet(this, _semanticContext, semanticContext ?? SemanticContext.NONE);
    this.reachesIntoOuterContext = c3.reachesIntoOuterContext;
    if (c3.precedenceFilterSuppressed !== void 0) {
      this.precedenceFilterSuppressed = c3.precedenceFilterSuppressed;
    }
  }
  // Not used in hash code.
  get semanticContext() {
    return __privateGet(this, _semanticContext);
  }
  static duplicate(old, semanticContext) {
    return new _l(old, old.state, old.context, semanticContext ?? old.semanticContext);
  }
  static createWithContext(state, alt, context, semanticContext) {
    return new _l({ alt }, state, context, semanticContext);
  }
  static createWithConfig(state, config, context) {
    return new _l(config, state, context ?? config.context, config.semanticContext);
  }
  static createWithSemanticContext(state, c3, semanticContext) {
    return new _l(c3, state ?? c3.state, c3.context, semanticContext);
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hashCode = MurmurHash.initialize(7);
      hashCode = MurmurHash.update(hashCode, this.state.stateNumber);
      hashCode = MurmurHash.update(hashCode, this.alt);
      hashCode = MurmurHash.updateFromComparable(hashCode, __privateGet(this, _context));
      hashCode = MurmurHash.updateFromComparable(hashCode, this.semanticContext);
      hashCode = MurmurHash.finish(hashCode, 4);
      this.cachedHashCode = hashCode;
    }
    return this.cachedHashCode;
  }
  /**
   * The stack of invoking states leading to the rule/states associated
   * with this config.  We track only those contexts pushed during
   * execution of the ATN simulator.
   */
  get context() {
    return __privateGet(this, _context);
  }
  set context(context) {
    __privateSet(this, _context, context);
    this.cachedHashCode = void 0;
  }
  /**
   * An ATN configuration is equal to another if both have
   * the same state, they predict the same alternative, and
   * syntactic/semantic contexts are the same.
   */
  equals(other) {
    if (this === other) {
      return true;
    }
    return this.state.stateNumber === other.state.stateNumber && this.alt === other.alt && (this.context === null ? other.context === null : this.context.equals(other.context)) && this.semanticContext.equals(other.semanticContext) && this.precedenceFilterSuppressed === other.precedenceFilterSuppressed;
  }
  toString(_recog, showAlt = true) {
    let alt = "";
    if (showAlt) {
      alt = "," + this.alt;
    }
    return "(" + this.state + alt + (this.context !== null ? ",[" + this.context.toString() + "]" : "") + (this.semanticContext !== SemanticContext.NONE ? "," + this.semanticContext.toString() : "") + (this.reachesIntoOuterContext ? ",up=" + this.reachesIntoOuterContext : "") + ")";
  }
}, _context = new WeakMap(), _semanticContext = new WeakMap(), __name(_l, "ATNConfig"), _l);
var ATNState = (_m = class {
  constructor() {
    __publicField(this, "stateNumber", 0);
    __publicField(this, "ruleIndex", 0);
    // at runtime, we don't have Rule objects
    __publicField(this, "epsilonOnlyTransitions", false);
    /** Used to cache lookahead during parsing, not used during construction */
    __publicField(this, "nextTokenWithinRule");
    /** Track the transitions emanating from this ATN state. */
    __publicField(this, "transitions", []);
  }
  hashCode() {
    return this.stateNumber;
  }
  equals(other) {
    return this.stateNumber === other.stateNumber;
  }
  toString() {
    return `${this.stateNumber}`;
  }
  addTransitionAtIndex(index2, transition) {
    if (this.transitions.length === 0) {
      this.epsilonOnlyTransitions = transition.isEpsilon;
    } else if (this.epsilonOnlyTransitions !== transition.isEpsilon) {
      this.epsilonOnlyTransitions = false;
    }
    this.transitions.splice(index2, 0, transition);
  }
  addTransition(transition) {
    if (this.transitions.length === 0) {
      this.epsilonOnlyTransitions = transition.isEpsilon;
    } else if (this.epsilonOnlyTransitions !== transition.isEpsilon) {
      this.epsilonOnlyTransitions = false;
    }
    this.transitions.push(transition);
  }
  setTransition(i2, e10) {
    this.transitions.splice(i2, 1, e10);
  }
  removeTransition(index2) {
    const t2 = this.transitions.splice(index2, 1);
    return t2[0];
  }
}, __name(_m, "ATNState"), __publicField(_m, "INVALID_STATE_NUMBER", -1), __publicField(_m, "INVALID_TYPE", 0), __publicField(_m, "BASIC", 1), __publicField(_m, "RULE_START", 2), __publicField(_m, "BLOCK_START", 3), __publicField(_m, "PLUS_BLOCK_START", 4), __publicField(_m, "STAR_BLOCK_START", 5), __publicField(_m, "TOKEN_START", 6), __publicField(_m, "RULE_STOP", 7), __publicField(_m, "BLOCK_END", 8), __publicField(_m, "STAR_LOOP_BACK", 9), __publicField(_m, "STAR_LOOP_ENTRY", 10), __publicField(_m, "PLUS_LOOP_BACK", 11), __publicField(_m, "LOOP_END", 12), __publicField(_m, "stateType", _m.INVALID_STATE_NUMBER), _m);
var PredictionContext = (_n = class {
  constructor(cachedHashCode) {
    __publicField(this, "cachedHashCode");
    this.cachedHashCode = cachedHashCode;
  }
  static calculateEmptyHashCode() {
    let hash = MurmurHash.initialize(31);
    hash = MurmurHash.finish(hash, 0);
    return hash;
  }
  static calculateHashCodeSingle(parent, returnState) {
    let hash = MurmurHash.initialize(31);
    hash = MurmurHash.updateFromComparable(hash, parent);
    hash = MurmurHash.update(hash, returnState);
    hash = MurmurHash.finish(hash, 2);
    return hash;
  }
  static calculateHashCodeList(parents, returnStates) {
    let hash = MurmurHash.initialize(31);
    for (const parent of parents) {
      hash = MurmurHash.updateFromComparable(hash, parent);
    }
    for (const returnState of returnStates) {
      hash = MurmurHash.update(hash, returnState);
    }
    hash = MurmurHash.finish(hash, 2 * parents.length);
    return hash;
  }
  isEmpty() {
    return false;
  }
  hasEmptyPath() {
    return this.getReturnState(this.length - 1) === _n.EMPTY_RETURN_STATE;
  }
  hashCode() {
    return this.cachedHashCode;
  }
  toString(_recog) {
    return "";
  }
}, __name(_n, "PredictionContext"), /**
 * Represents `$` in an array in full context mode, when `$`
 * doesn't mean wildcard: `$ + x = [$,x]`. Here,
 * `$` = {@link EMPTY_RETURN_STATE}.
 */
__publicField(_n, "EMPTY_RETURN_STATE", 2147483647), __publicField(_n, "traceATNSimulator", false), _n);
var SingletonPredictionContext = (_o = class extends PredictionContext {
  constructor(parent, returnState) {
    super(
      parent ? PredictionContext.calculateHashCodeSingle(parent, returnState) : PredictionContext.calculateEmptyHashCode()
    );
    __publicField(this, "parent");
    __publicField(this, "returnState");
    this.parent = parent ?? null;
    this.returnState = returnState;
  }
  getParent(_index) {
    return this.parent;
  }
  getReturnState(_index) {
    return this.returnState;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _o)) {
      return false;
    }
    if (this.hashCode() !== other.hashCode()) {
      return false;
    }
    if (this.returnState !== other.returnState) {
      return false;
    }
    if (this.parent == null) {
      return other.parent == null;
    }
    return this.parent.equals(other.parent);
  }
  toString() {
    const up = this.parent === null ? "" : this.parent.toString();
    if (up.length === 0) {
      if (this.returnState === PredictionContext.EMPTY_RETURN_STATE) {
        return "$";
      }
      return "" + this.returnState;
    } else {
      return "" + this.returnState + " " + up;
    }
  }
  get length() {
    return 1;
  }
}, __name(_o, "SingletonPredictionContext"), _o);
var EmptyPredictionContext = (_p = class extends SingletonPredictionContext {
  constructor() {
    super(void 0, PredictionContext.EMPTY_RETURN_STATE);
  }
  isEmpty() {
    return true;
  }
  getParent() {
    return null;
  }
  getReturnState() {
    return this.returnState;
  }
  equals(other) {
    return this === other;
  }
  toString() {
    return "$";
  }
}, __name(_p, "EmptyPredictionContext"), /**
 * Represents `$` in local context prediction, which means wildcard.
 * `*+x = *`.
 */
__publicField(_p, "instance", new _p()), _p);
var Transition = (_q = class {
  constructor(target) {
    /** The target of this transition. */
    __publicField(this, "target");
    this.target = target;
  }
  /**
   * Determines if the transition is an "epsilon" transition.
   *
   * The default implementation returns `false`.
   *
   * @returns `true` if traversing this transition in the ATN does not
   * consume an input symbol; otherwise, `false` if traversing this
   * transition consumes (matches) an input symbol.
   */
  get isEpsilon() {
    return false;
  }
  get label() {
    return null;
  }
  toString() {
    return "";
  }
}, __name(_q, "Transition"), __publicField(_q, "INVALID", 0), __publicField(_q, "EPSILON", 1), __publicField(_q, "RANGE", 2), __publicField(_q, "RULE", 3), __publicField(_q, "PREDICATE", 4), // e.g., {isType(input.LT(1))}
__publicField(_q, "ATOM", 5), __publicField(_q, "ACTION", 6), __publicField(_q, "SET", 7), // ~(A|B) or ~atom, wildcard, which convert to next
__publicField(_q, "NOT_SET", 8), __publicField(_q, "WILDCARD", 9), __publicField(_q, "PRECEDENCE", 10), _q);
var SetTransition = (_r2 = class extends Transition {
  constructor(target, set) {
    super(target);
    __publicField(this, "set");
    if (set) {
      this.set = set;
    } else {
      this.set = IntervalSet.of(Token.INVALID_TYPE, Token.INVALID_TYPE);
    }
  }
  get transitionType() {
    return Transition.SET;
  }
  get label() {
    return this.set;
  }
  matches(symbol, _minVocabSymbol, _maxVocabSymbol) {
    return this.set.contains(symbol);
  }
  toString() {
    return this.set.toString();
  }
}, __name(_r2, "SetTransition"), _r2);
var NotSetTransition = (_s2 = class extends SetTransition {
  get transitionType() {
    return Transition.NOT_SET;
  }
  matches(symbol, minVocabSymbol, maxVocabSymbol) {
    return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
  }
  toString() {
    return "~" + super.toString();
  }
}, __name(_s2, "NotSetTransition"), _s2);
var MapKeyEqualityComparator = (_t2 = class {
  constructor(keyComparator) {
    __publicField(this, "keyComparator");
    this.keyComparator = keyComparator;
  }
  hashCode(obj) {
    return this.keyComparator.hashCode(obj.key);
  }
  equals(a2, b2) {
    return this.keyComparator.equals(a2.key, b2.key);
  }
}, __name(_t2, "MapKeyEqualityComparator"), _t2);
var HashMap = (_u = class {
  constructor(keyComparer) {
    __publicField(this, "backingStore");
    if (keyComparer instanceof _u) {
      this.backingStore = new HashSet(keyComparer.backingStore);
    } else {
      keyComparer = keyComparer ?? DefaultEqualityComparator.instance;
      this.backingStore = new HashSet(new MapKeyEqualityComparator(keyComparer));
    }
  }
  clear() {
    this.backingStore.clear();
  }
  containsKey(key) {
    return this.backingStore.contains({ key });
  }
  get(key) {
    const bucket = this.backingStore.get({ key });
    if (!bucket) {
      return void 0;
    }
    return bucket.value;
  }
  get isEmpty() {
    return this.backingStore.isEmpty;
  }
  /**
   * Sets the value for a key in the map. If the key is not present in the map, it is added.
   * If the key is present, the value is updated and the old value is returned.
   *
   * @param key The key to set.
   * @param value The value to set.
   *
   * @returns The old value for the key, if present.
   */
  set(key, value) {
    const element = this.backingStore.get({ key, value });
    let result;
    if (!element) {
      this.backingStore.add({ key, value });
    } else {
      result = element.value;
      element.value = value;
    }
    return result;
  }
  /**
   * Sets the value for a key in the map if the key is not already present. Otherwise the value is not changed and
   * the old value is returned.
   *
   * @param key The key to set.
   * @param value The value to set.
   *
   * @returns The current value for the key, if present.
   */
  setIfAbsent(key, value) {
    const element = this.backingStore.get({ key, value });
    let result;
    if (!element) {
      this.backingStore.add({ key, value });
    } else {
      result = element.value;
    }
    return result;
  }
  keys() {
    return this.backingStore.toArray().map((bucket) => {
      return bucket.key;
    });
  }
  values() {
    return this.backingStore.toArray().map((bucket) => {
      return bucket.value;
    });
  }
  get size() {
    return this.backingStore.size;
  }
  hashCode() {
    return this.backingStore.hashCode();
  }
  equals(o2) {
    return this.backingStore.equals(o2.backingStore);
  }
}, __name(_u, "HashMap"), _u);
var TerminalNode = (_v2 = class {
  constructor(symbol) {
    __publicField(this, "parent", null);
    __publicField(this, "symbol");
    this.symbol = symbol;
  }
  getChild(_i3) {
    return null;
  }
  getSymbol() {
    return this.symbol;
  }
  getPayload() {
    return this.symbol;
  }
  getSourceInterval() {
    if (this.symbol === null) {
      return Interval.INVALID_INTERVAL;
    }
    const tokenIndex = this.symbol.tokenIndex;
    return new Interval(tokenIndex, tokenIndex);
  }
  getChildCount() {
    return 0;
  }
  accept(visitor) {
    return visitor.visitTerminal(this);
  }
  getText() {
    var _a3;
    return ((_a3 = this.symbol) == null ? void 0 : _a3.text) ?? "";
  }
  toString() {
    var _a3, _b3;
    if (((_a3 = this.symbol) == null ? void 0 : _a3.type) === Token.EOF) {
      return "<EOF>";
    } else {
      return ((_b3 = this.symbol) == null ? void 0 : _b3.text) ?? "";
    }
  }
  toStringTree() {
    return this.toString();
  }
}, __name(_v2, "TerminalNode"), _v2);
var ErrorNode = (_w2 = class extends TerminalNode {
  accept(visitor) {
    return visitor.visitErrorNode(this);
  }
}, __name(_w2, "ErrorNode"), _w2);
var CommonToken = (_x = class {
  constructor(details) {
    /**
     * These properties share a field to reduce the memory footprint of
     * {@link CommonToken}. Tokens created by a {@link CommonTokenFactory} from
     * the same source and input stream share a reference to the same
     * {@link Pair} containing these values.
     */
    __publicField(this, "source");
    __publicField(this, "tokenIndex");
    __publicField(this, "start");
    __publicField(this, "stop");
    /**
     * This is the backing field for {@link #getType} and {@link #setType}.
     */
    __publicField(this, "type");
    /**
     * The (one-based) line number on which the 1st character of this token was.
     */
    __publicField(this, "line");
    /**
     * The zero-based index of the first character position in its line.
     */
    __publicField(this, "column");
    /**
     * The token's channel.
     */
    __publicField(this, "channel");
    /**
     * This is the backing field for {@link getText} when the token text is
     * explicitly set in the constructor or via {@link setText}.
     */
    __privateAdd(this, _text);
    this.type = details.type;
    this.source = details.source;
    this.tokenIndex = details.tokenIndex ?? -1;
    this.line = details.line ?? 0;
    this.column = details.column ?? -1;
    this.channel = details.channel ?? Token.DEFAULT_CHANNEL;
    this.start = details.start ?? 0;
    this.stop = details.stop ?? 0;
    __privateSet(this, _text, details.text);
    if (details.line === void 0 && details.source[0] !== null) {
      this.line = details.source[0].line;
    }
    if (details.column === void 0 && details.source[0] !== null) {
      this.column = details.source[0].column;
    }
  }
  /**
   * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
   *
   * If `token` is also a {@link CommonToken} instance, the newly
   * constructed token will share a reference to the {@link #text} field and
   * the {@link Pair} stored in {@link source}. Otherwise, {@link text} will
   * be assigned the result of calling {@link getText}, and {@link source}
   * will be constructed from the result of {@link Token.getTokenSource} and
   * {@link Token#getInputStream}.
   *
   * @param token The token to copy.
   */
  static fromToken(token) {
    const source = [token.tokenSource, token.inputStream];
    return new _x({
      type: token.type,
      line: token.line,
      tokenIndex: token.tokenIndex,
      column: token.column,
      channel: token.channel,
      start: token.start,
      stop: token.stop,
      text: token.text,
      source
    });
  }
  /**
   * Constructs a new {@link CommonToken} with the specified token type and text.
   *
   * @param type The token type.
   * @param text The text of the token.
   */
  static fromType(type4, text) {
    return new _x({ type: type4, text, source: _x.EMPTY_SOURCE });
  }
  static fromSource(source, type4, channel, start, stop) {
    return new _x({ type: type4, channel, start, stop, source });
  }
  get tokenSource() {
    return this.source[0];
  }
  get inputStream() {
    return this.source[1];
  }
  set inputStream(input) {
    this.source[1] = input;
  }
  /**
   * Constructs a new {@link CommonToken} as a copy of another {@link Token}.
   *
   * If `oldToken` is also a {@link CommonToken} instance, the newly
   * constructed token will share a reference to the {@link text} field and
   * the {@link Pair} stored in {@link source}. Otherwise, {@link text} will
   * be assigned the result of calling {@link getText}, and {@link source}
   * will be constructed from the result of {@link Token.getTokenSource} and
   * {@link Token.getInputStream}.
   */
  clone() {
    const t2 = new _x({
      source: this.source,
      type: this.type,
      channel: this.channel,
      start: this.start,
      stop: this.stop,
      tokenIndex: this.tokenIndex,
      line: this.line,
      column: this.column,
      text: __privateGet(this, _text)
    });
    return t2;
  }
  toString(recognizer) {
    let channelStr = "";
    if (this.channel > 0) {
      channelStr = ",channel=" + this.channel;
    }
    let text = this.text;
    if (text) {
      text = text.replace(/\n/g, "\\n");
      text = text.replace(/\r/g, "\\r");
      text = text.replace(/\t/g, "\\t");
    } else {
      text = "<no text>";
    }
    let typeString = String(this.type);
    if (recognizer) {
      typeString = recognizer.vocabulary.getDisplayName(this.type) ?? "<unknown>";
    }
    return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + text + "',<" + typeString + ">" + channelStr + "," + this.line + ":" + this.column + "]";
  }
  get text() {
    if (__privateGet(this, _text) !== void 0) {
      return __privateGet(this, _text);
    }
    const input = this.inputStream;
    if (!input) {
      return void 0;
    }
    const n2 = input.size;
    if (this.start < n2 && this.stop < n2) {
      return input.getTextFromRange(this.start, this.stop);
    }
    return "<EOF>";
  }
  set text(text) {
    __privateSet(this, _text, text);
  }
  // WritableToken implementation
  setText(text) {
    __privateSet(this, _text, text);
  }
  setType(ttype) {
    this.type = ttype;
  }
  setLine(line) {
    this.line = line;
  }
  setCharPositionInLine(pos) {
    this.column = pos;
  }
  setChannel(channel) {
    this.channel = channel;
  }
  setTokenIndex(index2) {
    this.tokenIndex = index2;
  }
}, _text = new WeakMap(), __name(_x, "CommonToken"), /**
 * An empty tuple which is used as the default value of
 * {@link source} for tokens that do not have a source.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
__publicField(_x, "EMPTY_SOURCE", [null, null]), _x);
var Trees = (_y = class {
  /**
   * Print out a whole tree in LISP form. {@link getNodeText} is used on the
   * node payloads to get the text for the nodes.  Detect
   * parse trees and extract data appropriately.
   */
  static toStringTree(tree, ruleNames, recog) {
    ruleNames = ruleNames ?? null;
    if (recog) {
      ruleNames = recog.ruleNames;
    }
    let s2 = _y.getNodeText(tree, ruleNames);
    s2 = escapeWhitespace(s2, false);
    const c3 = tree.getChildCount();
    if (c3 === 0) {
      return s2;
    }
    let res = "(" + s2 + " ";
    if (c3 > 0) {
      s2 = _y.toStringTree(tree.getChild(0), ruleNames);
      res = res.concat(s2);
    }
    for (let i2 = 1; i2 < c3; i2++) {
      s2 = _y.toStringTree(tree.getChild(i2), ruleNames);
      res = res.concat(" " + s2);
    }
    res = res.concat(")");
    return res;
  }
  static getNodeText(t2, ruleNames, recog) {
    ruleNames = ruleNames ?? null;
    if (recog) {
      ruleNames = recog.ruleNames;
    }
    if (ruleNames !== null) {
      if (t2 instanceof ParserRuleContext) {
        const context = t2.ruleContext;
        const altNumber = context.getAltNumber();
        if (altNumber !== 0) {
          return ruleNames[t2.ruleIndex] + ":" + altNumber;
        }
        return ruleNames[t2.ruleIndex];
      } else if (t2 instanceof ErrorNode) {
        return t2.toString();
      } else if (t2 instanceof TerminalNode) {
        return t2.symbol.text;
      }
    }
    const payload = t2.getPayload();
    if (isToken(payload)) {
      return payload.text;
    }
    return String(t2.getPayload());
  }
  /**
   * Return ordered list of all children of this node
   */
  static getChildren(t2) {
    const list = [];
    for (let i2 = 0; i2 < t2.getChildCount(); i2++) {
      list.push(t2.getChild(i2));
    }
    return list;
  }
  /**
   * Return a list of all ancestors of this node.  The first node of
   * list is the root and the last is the parent of this node.
   */
  static getAncestors(t2) {
    if (t2.parent === null) {
      return [];
    }
    let ancestors = [];
    let p2 = t2.parent;
    while (p2 !== null) {
      ancestors = [p2].concat(ancestors);
      p2 = p2.parent;
    }
    return ancestors;
  }
  /**
   * Return true if t is u's parent or a node on path to root from u.
   */
  static isAncestorOf(t2, u2) {
    if (t2 === null || u2 === null || t2.parent === null) {
      return false;
    }
    let p2 = u2.parent;
    while (p2 !== null) {
      if (t2 === p2) {
        return true;
      }
      p2 = p2.parent;
    }
    return false;
  }
  static findAllTokenNodes(t2, ttype) {
    return _y.findAllNodes(t2, ttype, true);
  }
  static findAllRuleNodes(t2, ruleIndex) {
    return _y.findAllNodes(t2, ruleIndex, false);
  }
  static findAllNodes(t2, index2, findTokens) {
    const nodes = [];
    _y.doFindAllNodes(t2, index2, findTokens, nodes);
    return nodes;
  }
  static descendants(t2) {
    let nodes = [t2];
    for (let i2 = 0; i2 < t2.getChildCount(); i2++) {
      nodes = nodes.concat(_y.descendants(t2.getChild(i2)));
    }
    return nodes;
  }
  /**
   * Find smallest subtree of t enclosing range startTokenIndex..stopTokenIndex
   * inclusively using post order traversal. Recursive depth-first-search.
   */
  static getRootOfSubtreeEnclosingRegion(t2, startTokenIndex, stopTokenIndex) {
    const n2 = t2.getChildCount();
    for (let i2 = 0; i2 < n2; i2++) {
      const child = t2.getChild(i2);
      const r3 = this.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
      if (r3 !== null) {
        return r3;
      }
    }
    if (t2 instanceof ParserRuleContext) {
      if (startTokenIndex >= t2.start.tokenIndex && // is range fully contained in t?
      (t2.stop === null || stopTokenIndex <= t2.stop.tokenIndex)) {
        return t2;
      }
    }
    return null;
  }
  /**
   * Replace any subtree siblings of root that are completely to left
   * or right of lookahead range with a CommonToken(Token.INVALID_TYPE,"...")
   * node. The source interval for t is not altered to suit smaller range!
   *
   * WARNING: destructive to t.
   */
  static stripChildrenOutOfRange(t2, root2, startIndex, stopIndex) {
    if (t2 === null) {
      return;
    }
    for (let i2 = 0; i2 < t2.getChildCount(); i2++) {
      const child = t2.getChild(i2);
      const range3 = child.getSourceInterval();
      if (t2 instanceof ParserRuleContext && (range3.stop < startIndex || range3.start > stopIndex)) {
        if (this.isAncestorOf(child, root2)) {
          const abbrev = CommonToken.fromType(Token.INVALID_TYPE, "...");
          t2.children[i2] = new TerminalNode(abbrev);
        }
      }
    }
  }
  static doFindAllNodes(t2, index2, findTokens, nodes) {
    var _a3;
    if (findTokens && t2 instanceof TerminalNode) {
      if (((_a3 = t2.symbol) == null ? void 0 : _a3.type) === index2) {
        nodes.push(t2);
      }
    } else if (!findTokens && t2 instanceof ParserRuleContext) {
      if (t2.ruleIndex === index2) {
        nodes.push(t2);
      }
    }
    for (let i2 = 0; i2 < t2.getChildCount(); i2++) {
      _y.doFindAllNodes(t2.getChild(i2), index2, findTokens, nodes);
    }
  }
}, __name(_y, "Trees"), _y);
var ParserRuleContext = (_z = class {
  /**
   * A rule context is a record of a single rule invocation. It knows
   * which context invoked it, if any. If there is no parent context, then
   * naturally the invoking state is not valid.  The parent link
   * provides a chain upwards from the current rule invocation to the root
   * of the invocation tree, forming a stack. We actually carry no
   * information about the rule associated with this context (except
   * when parsing). We keep only the state number of the invoking state from
   * the ATN submachine that invoked this. Contrast this with the s
   * pointer inside ParserRuleContext that tracks the current state
   * being "executed" for the current rule.
   *
   * The parent contexts are useful for computing lookahead sets and
   * getting error information.
   *
   * These objects are used during parsing and prediction.
   * For the special case of parsers, we use the subclass
   * ParserRuleContext.
   */
  constructor(parent, invokingStateNumber = -1) {
    __publicField(this, "start", null);
    __publicField(this, "stop", null);
    __publicField(this, "children", []);
    /**
     * What state invoked the rule associated with this context?
     *  The "return address" is the followState of invokingState
     *  If parent is null, this should be -1 this context object represents
     *  the start rule.
     */
    __publicField(this, "invokingState");
    __publicField(this, "parent");
    this.parent = parent;
    this.invokingState = invokingStateNumber;
  }
  /** Copy a context */
  copyFrom(ctx) {
    this.parent = ctx.parent;
    this.invokingState = ctx.invokingState;
    this.children.slice(0, this.children.length);
    this.start = ctx.start;
    this.stop = ctx.stop;
    if (ctx.children) {
      ctx.children.forEach((child) => {
        if (child instanceof ErrorNode) {
          this.children.push(child);
          child.parent = this;
        }
      });
    }
  }
  // Double dispatch methods for listeners
  enterRule(_listener) {
  }
  exitRule(_listener) {
  }
  addChild(child) {
    this.children.push(child);
    return child;
  }
  /**
   * Used by enterOuterAlt to toss out a RuleContext previously added as
   * we entered a rule. If we have label, we will need to remove
   * generic ruleContext object.
   */
  removeLastChild() {
    this.children.pop();
  }
  addTokenNode(token) {
    const node = new TerminalNode(token);
    this.children.push(node);
    node.parent = this;
    return node;
  }
  addErrorNode(errorNode) {
    errorNode.parent = this;
    this.children.push(errorNode);
    return errorNode;
  }
  getChild(i2, type4) {
    if (i2 < 0 || i2 >= this.children.length) {
      return null;
    }
    if (!type4) {
      return this.children[i2];
    }
    for (const child of this.children) {
      if (child instanceof type4) {
        if (i2 === 0) {
          return child;
        } else {
          i2 -= 1;
        }
      }
    }
    return null;
  }
  getToken(ttype, i2) {
    var _a3;
    if (i2 < 0 || i2 >= this.children.length) {
      return null;
    }
    for (const child of this.children) {
      if ("symbol" in child) {
        if (((_a3 = child.symbol) == null ? void 0 : _a3.type) === ttype) {
          if (i2 === 0) {
            return child;
          } else {
            i2 -= 1;
          }
        }
      }
    }
    return null;
  }
  getTokens(ttype) {
    var _a3;
    const tokens = [];
    for (const child of this.children) {
      if ("symbol" in child) {
        if (((_a3 = child.symbol) == null ? void 0 : _a3.type) === ttype) {
          tokens.push(child);
        }
      }
    }
    return tokens;
  }
  // XXX: base the child type selection on the rule index, not the class.
  getRuleContext(index2, ctxType) {
    return this.getChild(index2, ctxType);
  }
  // XXX: base the child type selection on the rule index, not the class.
  getRuleContexts(ctxType) {
    const contexts = [];
    for (const child of this.children) {
      if (child instanceof ctxType) {
        contexts.push(child);
      }
    }
    return contexts;
  }
  getChildCount() {
    return this.children.length;
  }
  getSourceInterval() {
    if (this.start === null) {
      return Interval.INVALID_INTERVAL;
    }
    if (this.stop === null || this.stop.tokenIndex < this.start.tokenIndex) {
      return new Interval(this.start.tokenIndex, this.start.tokenIndex - 1);
    }
    return new Interval(this.start.tokenIndex, this.stop.tokenIndex);
  }
  depth() {
    let n2 = 0;
    let p2 = this;
    while (p2 !== null) {
      p2 = p2.parent;
      n2 += 1;
    }
    return n2;
  }
  /**
   * A context is empty if there is no invoking state; meaning nobody call
   * current context.
   */
  isEmpty() {
    return this.invokingState === -1;
  }
  get ruleContext() {
    return this;
  }
  get ruleIndex() {
    return -1;
  }
  getPayload() {
    return this;
  }
  getText() {
    if (this.children.length === 0) {
      return "";
    }
    return this.children.map((child) => {
      return child.getText();
    }).join("");
  }
  /**
   * For rule associated with this parse tree internal node, return
   * the outer alternative number used to match the input. Default
   * implementation does not compute nor store this alt num. Create
   * a subclass of ParserRuleContext with backing field and set
   * option contextSuperClass.
   * to set it.
   */
  getAltNumber() {
    return ATN.INVALID_ALT_NUMBER;
  }
  /**
   * Set the outer alternative number for this context node. Default
   * implementation does nothing to avoid backing field overhead for
   * trees that don't need it.  Create
   * a subclass of ParserRuleContext with backing field and set
   * option contextSuperClass.
   */
  setAltNumber(_altNumber) {
  }
  accept(visitor) {
    return visitor.visitChildren(this);
  }
  toStringTree(...args) {
    if (args.length < 2) {
      return Trees.toStringTree(this, null, args[0]);
    }
    return Trees.toStringTree(this, args[0], args[1]);
  }
  toString(ruleNames, stop) {
    ruleNames = ruleNames ?? null;
    stop = stop ?? null;
    let p2 = this;
    let s2 = "[";
    while (p2 !== null && p2 !== stop) {
      if (ruleNames === null) {
        if (!p2.isEmpty()) {
          s2 += p2.invokingState;
        }
      } else {
        const ri2 = p2.ruleIndex;
        const ruleName = ri2 >= 0 && ri2 < ruleNames.length ? ruleNames[ri2] : "" + ri2;
        s2 += ruleName;
      }
      if (p2.parent !== null && (ruleNames !== null || !p2.parent.isEmpty())) {
        s2 += " ";
      }
      p2 = p2.parent;
    }
    s2 += "]";
    return s2;
  }
}, __name(_z, "ParserRuleContext"), __publicField(_z, "empty", new _z(null)), _z);
var ArrayPredictionContext = (_A = class extends PredictionContext {
  constructor(parents, returnStates) {
    super(PredictionContext.calculateHashCodeList(parents, returnStates));
    __publicField(this, "parents", []);
    __publicField(this, "returnStates", []);
    this.parents = parents;
    this.returnStates = returnStates;
    return this;
  }
  isEmpty() {
    return this.returnStates[0] === PredictionContext.EMPTY_RETURN_STATE;
  }
  get length() {
    return this.returnStates.length;
  }
  getParent(index2) {
    return this.parents[index2];
  }
  getReturnState(index2) {
    return this.returnStates[index2];
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _A) || this.hashCode() !== other.hashCode()) {
      return false;
    }
    return equalNumberArrays(this.returnStates, other.returnStates) && equalArrays(this.parents, other.parents);
  }
  toString() {
    if (this.isEmpty()) {
      return "[]";
    }
    const entries = [];
    for (let i2 = 0; i2 < this.returnStates.length; i2++) {
      if (this.returnStates[i2] === PredictionContext.EMPTY_RETURN_STATE) {
        entries.push("$");
        continue;
      }
      entries.push(this.returnStates[i2].toString());
      if (this.parents[i2]) {
        entries.push(this.parents[i2].toString());
      } else {
        entries.push("null");
      }
    }
    return `[${entries.join(", ")}]`;
  }
}, __name(_A, "ArrayPredictionContext"), _A);
var createSingletonPredictionContext = /* @__PURE__ */ __name((parent, returnState) => {
  if (returnState === PredictionContext.EMPTY_RETURN_STATE && parent === null) {
    return EmptyPredictionContext.instance;
  } else {
    return new SingletonPredictionContext(parent, returnState);
  }
}, "createSingletonPredictionContext");
var predictionContextFromRuleContext = /* @__PURE__ */ __name((atn, outerContext) => {
  if (!outerContext) {
    outerContext = ParserRuleContext.empty;
  }
  if (!outerContext.parent || outerContext === ParserRuleContext.empty) {
    return EmptyPredictionContext.instance;
  }
  const parent = predictionContextFromRuleContext(atn, outerContext.parent);
  const state = atn.states[outerContext.invokingState];
  const transition = state.transitions[0];
  return createSingletonPredictionContext(parent, transition.followState.stateNumber);
}, "predictionContextFromRuleContext");
var getCachedPredictionContext = /* @__PURE__ */ __name((context, contextCache, visited) => {
  if (context.isEmpty()) {
    return context;
  }
  let existing = visited.get(context);
  if (existing) {
    return existing;
  }
  existing = contextCache.get(context);
  if (existing) {
    visited.set(context, existing);
    return existing;
  }
  let changed = false;
  let parents = [];
  for (let i2 = 0; i2 < parents.length; i2++) {
    const parent = getCachedPredictionContext(context.getParent(i2), contextCache, visited);
    if (changed || parent !== context.getParent(i2)) {
      if (!changed) {
        parents = [];
        for (let j2 = 0; j2 < context.length; j2++) {
          parents[j2] = context.getParent(j2);
        }
        changed = true;
      }
      parents[i2] = parent;
    }
  }
  if (!changed) {
    contextCache.add(context);
    visited.set(context, context);
    return context;
  }
  let updated;
  if (parents.length === 0) {
    updated = EmptyPredictionContext.instance;
  } else if (parents.length === 1) {
    updated = createSingletonPredictionContext(parents[0] ?? void 0, context.getReturnState(0));
  } else {
    updated = new ArrayPredictionContext(parents, context.returnStates);
  }
  contextCache.add(updated);
  visited.set(updated, updated);
  visited.set(context, updated);
  return updated;
}, "getCachedPredictionContext");
var merge = /* @__PURE__ */ __name((a2, b2, rootIsWildcard, mergeCache) => {
  if (a2 === b2 || a2.equals(b2)) {
    return a2;
  }
  if (a2 instanceof SingletonPredictionContext && b2 instanceof SingletonPredictionContext) {
    return mergeSingletons(a2, b2, rootIsWildcard, mergeCache);
  }
  if (rootIsWildcard) {
    if (a2 instanceof EmptyPredictionContext) {
      return a2;
    }
    if (b2 instanceof EmptyPredictionContext) {
      return b2;
    }
  }
  if (a2 instanceof SingletonPredictionContext) {
    a2 = new ArrayPredictionContext([a2.parent], [a2.returnState]);
  }
  if (b2 instanceof SingletonPredictionContext) {
    b2 = new ArrayPredictionContext([b2.parent], [b2.returnState]);
  }
  return mergeArrays(a2, b2, rootIsWildcard, mergeCache);
}, "merge");
var mergeArrays = /* @__PURE__ */ __name((a2, b2, rootIsWildcard, mergeCache) => {
  if (mergeCache) {
    let previous = mergeCache.get(a2, b2);
    if (previous) {
      return previous;
    }
    previous = mergeCache.get(b2, a2);
    if (previous) {
      return previous;
    }
  }
  let i2 = 0;
  let j2 = 0;
  let k2 = 0;
  let mergedReturnStates = new Array(a2.returnStates.length + b2.returnStates.length).fill(0);
  let mergedParents = new Array(a2.returnStates.length + b2.returnStates.length).fill(null);
  while (i2 < a2.returnStates.length && j2 < b2.returnStates.length) {
    const aParent = a2.parents[i2];
    const bParent = b2.parents[j2];
    if (a2.returnStates[i2] === b2.returnStates[j2]) {
      const payload = a2.returnStates[i2];
      const bothDollars = payload === PredictionContext.EMPTY_RETURN_STATE && aParent === null && bParent === null;
      const axAx = aParent !== null && bParent !== null && aParent === bParent;
      if (bothDollars || axAx) {
        mergedParents[k2] = aParent;
        mergedReturnStates[k2] = payload;
      } else {
        mergedParents[k2] = merge(aParent, bParent, rootIsWildcard, mergeCache);
        mergedReturnStates[k2] = payload;
      }
      i2 += 1;
      j2 += 1;
    } else if (a2.returnStates[i2] < b2.returnStates[j2]) {
      mergedParents[k2] = aParent;
      mergedReturnStates[k2] = a2.returnStates[i2];
      i2 += 1;
    } else {
      mergedParents[k2] = bParent;
      mergedReturnStates[k2] = b2.returnStates[j2];
      j2 += 1;
    }
    k2 += 1;
  }
  if (i2 < a2.returnStates.length) {
    for (let p2 = i2; p2 < a2.returnStates.length; p2++) {
      mergedParents[k2] = a2.parents[p2];
      mergedReturnStates[k2] = a2.returnStates[p2];
      k2 += 1;
    }
  } else {
    for (let p2 = j2; p2 < b2.returnStates.length; p2++) {
      mergedParents[k2] = b2.parents[p2];
      mergedReturnStates[k2] = b2.returnStates[p2];
      k2 += 1;
    }
  }
  if (k2 < mergedParents.length) {
    if (k2 === 1) {
      const aNew = createSingletonPredictionContext(mergedParents[0] ?? void 0, mergedReturnStates[0]);
      if (mergeCache !== null) {
        mergeCache.set(a2, b2, aNew);
      }
      return aNew;
    }
    mergedParents = mergedParents.slice(0, k2);
    mergedReturnStates = mergedReturnStates.slice(0, k2);
  }
  const merged = new ArrayPredictionContext(mergedParents, mergedReturnStates);
  if (merged.equals(a2)) {
    if (mergeCache !== null) {
      mergeCache.set(a2, b2, a2);
    }
    return a2;
  }
  if (merged.equals(b2)) {
    if (mergeCache !== null) {
      mergeCache.set(a2, b2, b2);
    }
    return b2;
  }
  combineCommonParents(mergedParents);
  if (mergeCache !== null) {
    mergeCache.set(a2, b2, merged);
  }
  return merged;
}, "mergeArrays");
var combineCommonParents = /* @__PURE__ */ __name((parents) => {
  const uniqueParents = new HashMap(ObjectEqualityComparator.instance);
  for (const parent of parents) {
    if (parent) {
      if (!uniqueParents.containsKey(parent)) {
        uniqueParents.set(parent, parent);
      }
    }
  }
  for (let q2 = 0; q2 < parents.length; q2++) {
    if (parents[q2]) {
      parents[q2] = uniqueParents.get(parents[q2]) ?? null;
    }
  }
}, "combineCommonParents");
var mergeSingletons = /* @__PURE__ */ __name((a2, b2, rootIsWildcard, mergeCache) => {
  if (mergeCache !== null) {
    let previous = mergeCache.get(a2, b2);
    if (previous !== null) {
      return previous;
    }
    previous = mergeCache.get(b2, a2);
    if (previous !== null) {
      return previous;
    }
  }
  const rootMerge = mergeRoot(a2, b2, rootIsWildcard);
  if (rootMerge !== null) {
    if (mergeCache !== null) {
      mergeCache.set(a2, b2, rootMerge);
    }
    return rootMerge;
  }
  if (a2.returnState === b2.returnState) {
    const parent = merge(a2.parent, b2.parent, rootIsWildcard, mergeCache);
    if (parent === a2.parent) {
      return a2;
    }
    if (parent === b2.parent) {
      return b2;
    }
    const spc = createSingletonPredictionContext(parent, a2.returnState);
    if (mergeCache !== null) {
      mergeCache.set(a2, b2, spc);
    }
    return spc;
  } else {
    let singleParent = null;
    if (a2 === b2 || a2.parent !== null && a2.parent.equals(b2.parent)) {
      singleParent = a2.parent;
    }
    if (singleParent !== null) {
      const payloads2 = [a2.returnState, b2.returnState];
      if (a2.returnState > b2.returnState) {
        payloads2[0] = b2.returnState;
        payloads2[1] = a2.returnState;
      }
      const parents2 = [singleParent, singleParent];
      const apc = new ArrayPredictionContext(parents2, payloads2);
      if (mergeCache !== null) {
        mergeCache.set(a2, b2, apc);
      }
      return apc;
    }
    const payloads = [a2.returnState, b2.returnState];
    let parents = [a2.parent, b2.parent];
    if (a2.returnState > b2.returnState) {
      payloads[0] = b2.returnState;
      payloads[1] = a2.returnState;
      parents = [b2.parent, a2.parent];
    }
    const aNew = new ArrayPredictionContext(parents, payloads);
    if (mergeCache !== null) {
      mergeCache.set(a2, b2, aNew);
    }
    return aNew;
  }
}, "mergeSingletons");
var mergeRoot = /* @__PURE__ */ __name((a2, b2, rootIsWildcard) => {
  if (rootIsWildcard) {
    if (a2 === EmptyPredictionContext.instance || b2 === EmptyPredictionContext.instance) {
      return EmptyPredictionContext.instance;
    }
  } else {
    if (a2 === EmptyPredictionContext.instance && b2 === EmptyPredictionContext.instance) {
      return EmptyPredictionContext.instance;
    }
    if (a2 === EmptyPredictionContext.instance) {
      const payloads = [
        b2.returnState,
        PredictionContext.EMPTY_RETURN_STATE
      ];
      const parents = [b2.parent, null];
      return new ArrayPredictionContext(parents, payloads);
    }
    if (b2 === EmptyPredictionContext.instance) {
      const payloads = [a2.returnState, PredictionContext.EMPTY_RETURN_STATE];
      const parents = [a2.parent, null];
      return new ArrayPredictionContext(parents, payloads);
    }
  }
  return null;
}, "mergeRoot");
var LL1Analyzer = (_B = class {
  constructor(atn) {
    this.atn = atn;
  }
  /**
   * Calculates the SLL(1) expected lookahead set for each outgoing transition
   * of an {@link ATNState}. The returned array has one element for each
   * outgoing transition in `s`. If the closure from transition
   * _i_ leads to a semantic predicate before matching a symbol, the
   * element at index *i* of the result will be `undefined`.
   *
   * @param s the ATN state
   * @returns the expected symbols for each outgoing transition of `s`.
   */
  getDecisionLookahead(s2) {
    const count = s2.transitions.length;
    const look = new Array(count);
    for (let alt = 0; alt < count; alt++) {
      const set = new IntervalSet();
      const lookBusy = new HashSet();
      this.doLook(
        s2.transitions[alt].target,
        void 0,
        EmptyPredictionContext.instance,
        set,
        lookBusy,
        new BitSet(),
        false,
        false
      );
      if (set.length > 0 && !set.contains(_B.hitPredicate)) {
        look[alt] = set;
      }
    }
    return look;
  }
  /**
   * Compute set of tokens that can follow `s` in the ATN in the
   * specified `ctx`.
   *
   * If `ctx` is `null` and the end of the rule containing
   * `s` is reached, {@link Token//EPSILON} is added to the result set.
   * If `ctx` is not `null` and the end of the outermost rule is
   * reached, {@link Token//EOF} is added to the result set.
   *
   * @param s the ATN state
   * @param stopState the ATN state to stop at. This can be a
   * {@link BlockEndState} to detect epsilon paths through a closure.
   * @param ctx the complete parser context, or `null` if the context
   * should be ignored
   *
   * @returns The set of tokens that can follow `s` in the ATN in the
   * specified `ctx`.
   */
  look(s2, stopState, ctx) {
    const r3 = new IntervalSet();
    const lookContext = ctx ? predictionContextFromRuleContext(this.atn, ctx) : null;
    this.doLook(s2, stopState, lookContext, r3, new HashSet(), new BitSet(), true, true);
    return r3;
  }
  /**
   * Compute set of tokens that can follow `s` in the ATN in the
   * specified `ctx`.
   *
   * If `ctx` is `null` and `stopState` or the end of the
   * rule containing `s` is reached, {@link Token//EPSILON} is added to
   * the result set. If `ctx` is not `null` and `addEOF` is
   * `true` and `stopState` or the end of the outermost rule is
   * reached, {@link Token//EOF} is added to the result set.
   *
   * @param s the ATN state.
   * @param stopState the ATN state to stop at. This can be a
   * {@link BlockEndState} to detect epsilon paths through a closure.
   * @param ctx The outer context, or `null` if the outer context should
   * not be used.
   * @param look The result lookahead set.
   * @param lookBusy A set used for preventing epsilon closures in the ATN
   * from causing a stack overflow. Outside code should pass
   * `new CustomizedSet<ATNConfig>` for this argument.
   * @param calledRuleStack A set used for preventing left recursion in the
   * ATN from causing a stack overflow. Outside code should pass
   * `new BitSet()` for this argument.
   * @param seeThruPreds `true` to true semantic predicates as
   * implicitly `true` and "see through them", otherwise `false`
   * to treat semantic predicates as opaque and add {@link hitPredicate} to the
   * result if one is encountered.
   * @param addEOF Add {@link Token//EOF} to the result if the end of the
   * outermost context is reached. This parameter has no effect if `ctx`
   * is `null`.
   */
  doLook(s2, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
    const c3 = ATNConfig.createWithContext(s2, 0, ctx);
    if (lookBusy.get(c3)) {
      return;
    }
    lookBusy.add(c3);
    if (s2 === stopState) {
      if (!ctx) {
        look.addOne(Token.EPSILON);
        return;
      } else if (ctx.isEmpty() && addEOF) {
        look.addOne(Token.EOF);
        return;
      }
    }
    if (s2.constructor.stateType === ATNState.RULE_STOP) {
      if (!ctx) {
        look.addOne(Token.EPSILON);
        return;
      } else if (ctx.isEmpty() && addEOF) {
        look.addOne(Token.EOF);
        return;
      }
      if (ctx !== EmptyPredictionContext.instance) {
        const removed = calledRuleStack.get(s2.ruleIndex);
        try {
          calledRuleStack.clear(s2.ruleIndex);
          for (let i2 = 0; i2 < ctx.length; i2++) {
            const returnState = this.atn.states[ctx.getReturnState(i2)];
            this.doLook(
              returnState,
              stopState,
              ctx.getParent(i2),
              look,
              lookBusy,
              calledRuleStack,
              seeThruPreds,
              addEOF
            );
          }
        } finally {
          if (removed) {
            calledRuleStack.set(s2.ruleIndex);
          }
        }
        return;
      }
    }
    for (const t2 of s2.transitions) {
      switch (t2.transitionType) {
        case Transition.RULE: {
          if (calledRuleStack.get(t2.target.ruleIndex)) {
            continue;
          }
          const newContext = createSingletonPredictionContext(
            ctx ?? void 0,
            t2.followState.stateNumber
          );
          try {
            calledRuleStack.set(t2.target.ruleIndex);
            this.doLook(
              t2.target,
              stopState,
              newContext,
              look,
              lookBusy,
              calledRuleStack,
              seeThruPreds,
              addEOF
            );
          } finally {
            calledRuleStack.clear(t2.target.ruleIndex);
          }
          break;
        }
        case Transition.PREDICATE:
        case Transition.PRECEDENCE: {
          if (seeThruPreds) {
            this.doLook(t2.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
          } else {
            look.addOne(_B.hitPredicate);
          }
          break;
        }
        case Transition.WILDCARD: {
          look.addRange(Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
          break;
        }
        default: {
          if (t2.isEpsilon) {
            this.doLook(t2.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
          } else {
            let set = t2.label;
            if (set) {
              if (t2 instanceof NotSetTransition) {
                set = set.complement(Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType);
              }
              look.addSet(set);
            }
          }
          break;
        }
      }
    }
  }
}, __name(_B, "LL1Analyzer"), /**
 * Special value added to the lookahead sets to indicate that we hit
 * a predicate during analysis if `seeThruPreds==false`.
 */
__publicField(_B, "hitPredicate", Token.INVALID_TYPE), _B);
var ATN = (_C2 = class {
  constructor(grammarType, maxTokenType) {
    /**
     * Used for runtime deserialization of ATNs from strings
     * The type of the ATN.
     */
    __publicField(this, "grammarType");
    /** The maximum value for any symbol recognized by a transition in the ATN. */
    __publicField(this, "maxTokenType");
    __publicField(this, "states", []);
    /**
     * Each subrule/rule is a decision point and we must track them so we
     * can go back later and build DFA predictors for them.  This includes
     * all the rules, subrules, optional blocks, ()+, ()* etc...
     */
    __publicField(this, "decisionToState", []);
    /** Maps from rule index to starting state number. */
    __publicField(this, "ruleToStartState", []);
    // Initialized by the ATN deserializer.
    /** Maps from rule index to stop state number. */
    __publicField(this, "ruleToStopState", []);
    // Initialized by the ATN deserializer.
    __publicField(this, "modeNameToStartState", /* @__PURE__ */ new Map());
    /**
     * For lexer ATNs, this maps the rule index to the resulting token type.
     * For parser ATNs, this maps the rule index to the generated bypass token
     * type if the {@link ATNDeserializationOptions//isGenerateRuleBypassTransitions}
     * deserialization option was specified; otherwise, this is `null`
     */
    __publicField(this, "ruleToTokenType", []);
    // Initialized by the ATN deserializer.
    /**
     * For lexer ATNs, this is an array of {@link LexerAction} objects which may
     * be referenced by action transitions in the ATN
     */
    __publicField(this, "lexerActions", []);
    __publicField(this, "modeToStartState", []);
    __publicField(this, "analyzer");
    this.grammarType = grammarType;
    this.maxTokenType = maxTokenType;
    this.analyzer = new LL1Analyzer(this);
  }
  /**
   * Compute the set of valid tokens that can occur starting in state `s`.
   * If `ctx` is null, the set of tokens will not include what can follow
   * the rule surrounding `s`. In other words, the set will be
   * restricted to tokens reachable staying within `s`'s rule.
   */
  nextTokens(atnState, ctx) {
    if (!ctx && atnState.nextTokenWithinRule) {
      return atnState.nextTokenWithinRule;
    }
    const next = this.analyzer.look(atnState, void 0, ctx);
    if (!ctx) {
      atnState.nextTokenWithinRule = next;
    }
    return next;
  }
  addState(state) {
    if (state) {
      state.stateNumber = this.states.length;
    }
    this.states.push(state);
  }
  removeState(state) {
    this.states[state.stateNumber] = null;
  }
  defineDecisionState(s2) {
    this.decisionToState.push(s2);
    s2.decision = this.decisionToState.length - 1;
    return s2.decision;
  }
  getDecisionState(decision) {
    if (this.decisionToState.length === 0) {
      return null;
    } else {
      return this.decisionToState[decision];
    }
  }
  getNumberOfDecisions() {
    return this.decisionToState.length;
  }
  /**
   * Computes the set of input symbols which could follow ATN state number
   * `stateNumber` in the specified full `context`. This method
   * considers the complete parser context, but does not evaluate semantic
   * predicates (i.e. all predicates encountered during the calculation are
   * assumed true). If a path in the ATN exists from the starting state to the
   * {@link RuleStopState} of the outermost context without matching any
   * symbols, {@link Token//EOF} is added to the returned set.
   *
   * If `context` is `null`, it is treated as
   * {@link ParserRuleContext//EMPTY}.
   *
   * @param stateNumber the ATN state number
   * @param context the full parse context
   *
   * @returns {IntervalSet} The set of potentially valid input symbols which could follow the
   * specified state in the specified context.
   *
   * @throws IllegalArgumentException if the ATN does not contain a state with
   * number `stateNumber`
   */
  getExpectedTokens(stateNumber, context) {
    if (stateNumber < 0 || stateNumber >= this.states.length) {
      throw new Error("Invalid state number.");
    }
    const s2 = this.states[stateNumber];
    let following = this.nextTokens(s2);
    if (!following.contains(Token.EPSILON)) {
      return following;
    }
    let ctx = context;
    const expected = new IntervalSet();
    expected.addSet(following);
    expected.removeOne(Token.EPSILON);
    while (ctx !== null && ctx.invokingState >= 0 && following.contains(Token.EPSILON)) {
      const invokingState = this.states[ctx.invokingState];
      const rt2 = invokingState.transitions[0];
      following = this.nextTokens(rt2.followState);
      expected.addSet(following);
      expected.removeOne(Token.EPSILON);
      ctx = ctx.parent;
    }
    if (following.contains(Token.EPSILON)) {
      expected.addOne(Token.EOF);
    }
    return expected;
  }
}, __name(_C2, "ATN"), __publicField(_C2, "INVALID_ALT_NUMBER", 0), /** Represents the type of recognizer an ATN applies to */
__publicField(_C2, "LEXER", 0), __publicField(_C2, "PARSER", 1), _C2);
var KeyTypeEqualityComparer = (_D = class {
  hashCode(config) {
    let hashCode = 7;
    hashCode = 31 * hashCode + config.state.stateNumber;
    hashCode = 31 * hashCode + config.alt;
    hashCode = 31 * hashCode + config.semanticContext.hashCode();
    return hashCode;
  }
  equals(a2, b2) {
    if (a2 === b2) {
      return true;
    }
    return a2.state.stateNumber === b2.state.stateNumber && a2.alt === b2.alt && a2.semanticContext.equals(b2.semanticContext);
  }
}, __name(_D, "KeyTypeEqualityComparer"), __publicField(_D, "instance", new _D()), _D);
var ATNConfigSet = (_E2 = class {
  constructor(fullCtxOrOldSet) {
    /**
     * The reason that we need this is because we don't want the hash map to use
     * the standard hash code and equals. We need all configurations with the
     * same
     * `(s,i,_,semctx)` to be equal. Unfortunately, this key effectively
     * doubles
     * the number of objects associated with ATNConfigs. The other solution is
     * to
     * use a hash table that lets us specify the equals/hashCode operation.
     * All configs but hashed by (s, i, _, pi) not including context. Wiped out
     * when we go readonly as this set becomes a DFA state
     */
    __publicField(this, "configLookup", new HashSet(KeyTypeEqualityComparer.instance));
    // Track the elements as they are added to the set; supports get(i).
    __publicField(this, "configs", []);
    __publicField(this, "uniqueAlt", 0);
    /**
     * Used in parser and lexer. In lexer, it indicates we hit a pred
     * while computing a closure operation. Don't make a DFA state from this
     */
    __publicField(this, "hasSemanticContext", false);
    __publicField(this, "dipsIntoOuterContext", false);
    /**
     * Indicates that this configuration set is part of a full context
     * LL prediction. It will be used to determine how to merge $. With SLL
     * it's a wildcard whereas it is not for LL context merge
     */
    __publicField(this, "fullCtx", false);
    /**
     * Indicates that the set of configurations is read-only. Do not
     * allow any code to manipulate the set; DFA states will point at
     * the sets and they must not change. This does not protect the other
     * fields; in particular, conflictingAlts is set after
     * we've made this readonly
     */
    __publicField(this, "readOnly", false);
    __publicField(this, "conflictingAlts", null);
    /**
     * Tracks the first config that has a rule stop state. Avoids frequent linear search for that, when adding
     * a DFA state in the lexer ATN simulator.
     */
    __publicField(this, "firstStopState");
    __privateAdd(this, _cachedHashCode, -1);
    if (fullCtxOrOldSet !== void 0) {
      if (typeof fullCtxOrOldSet === "boolean") {
        this.fullCtx = fullCtxOrOldSet ?? true;
      } else {
        const old = fullCtxOrOldSet;
        this.addAll(old.configs);
        this.uniqueAlt = old.uniqueAlt;
        this.conflictingAlts = old.conflictingAlts;
        this.hasSemanticContext = old.hasSemanticContext;
        this.dipsIntoOuterContext = old.dipsIntoOuterContext;
      }
    }
  }
  [Symbol.iterator]() {
    return this.configs[Symbol.iterator]();
  }
  /**
   * Adding a new config means merging contexts with existing configs for
   * `(s, i, pi, _)`, where `s` is the {@link ATNConfig.state}, `i` is the {@link ATNConfig.alt}, and
   * `pi` is the {@link ATNConfig.semanticContext}. We use `(s,i,pi)` as key.
   *
   * This method updates {@link dipsIntoOuterContext} and
   * {@link hasSemanticContext} when necessary.
   */
  add(config, mergeCache = null) {
    if (this.readOnly) {
      throw new Error("This set is readonly");
    }
    if (!this.firstStopState && config.state.constructor.stateType === ATNState.RULE_STOP) {
      this.firstStopState = config;
    }
    this.hasSemanticContext || (this.hasSemanticContext = config.semanticContext !== SemanticContext.NONE);
    this.dipsIntoOuterContext || (this.dipsIntoOuterContext = config.reachesIntoOuterContext);
    const existing = this.configLookup.getOrAdd(config);
    if (existing === config) {
      __privateSet(this, _cachedHashCode, -1);
      this.configs.push(config);
      return;
    }
    const rootIsWildcard = !this.fullCtx;
    const merged = merge(existing.context, config.context, rootIsWildcard, mergeCache);
    existing.reachesIntoOuterContext || (existing.reachesIntoOuterContext = config.reachesIntoOuterContext);
    existing.precedenceFilterSuppressed || (existing.precedenceFilterSuppressed = config.precedenceFilterSuppressed);
    existing.context = merged;
  }
  /** Return a List holding list of configs */
  get elements() {
    return this.configs;
  }
  /**
   * Gets the complete set of represented alternatives for the configuration set.
   *
   * @returns the set of represented alternatives in this configuration set
   */
  getAlts() {
    const alts = new BitSet();
    for (const config of this.configs) {
      alts.set(config.alt);
    }
    return alts;
  }
  getPredicates() {
    const preds = [];
    for (const config of this.configs) {
      if (config.semanticContext !== SemanticContext.NONE) {
        preds.push(config.semanticContext);
      }
    }
    return preds;
  }
  getStates() {
    const states = new HashSet();
    for (const config of this.configs) {
      states.add(config.state);
    }
    return states;
  }
  optimizeConfigs(interpreter) {
    if (this.readOnly) {
      throw new Error("This set is readonly");
    }
    if (this.configLookup.size === 0) {
      return;
    }
    for (const config of this.configs) {
      config.context = interpreter.getCachedContext(config.context);
    }
  }
  addAll(coll) {
    for (const config of coll) {
      this.add(config);
    }
    return false;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (this.fullCtx === other.fullCtx && this.uniqueAlt === other.uniqueAlt && this.conflictingAlts === other.conflictingAlts && this.hasSemanticContext === other.hasSemanticContext && this.dipsIntoOuterContext === other.dipsIntoOuterContext && equalArrays(this.configs, other.configs)) {
      return true;
    }
    return false;
  }
  hashCode() {
    if (__privateGet(this, _cachedHashCode) === -1) {
      __privateSet(this, _cachedHashCode, this.computeHashCode());
    }
    return __privateGet(this, _cachedHashCode);
  }
  get length() {
    return this.configs.length;
  }
  isEmpty() {
    return this.configs.length === 0;
  }
  contains(item) {
    if (this.configLookup === null) {
      throw new Error("This method is not implemented for readonly sets.");
    }
    return this.configLookup.contains(item);
  }
  containsFast(item) {
    if (this.configLookup === null) {
      throw new Error("This method is not implemented for readonly sets.");
    }
    return this.configLookup.contains(item);
  }
  clear() {
    if (this.readOnly) {
      throw new Error("This set is readonly");
    }
    this.configs = [];
    __privateSet(this, _cachedHashCode, -1);
    this.configLookup = new HashSet(KeyTypeEqualityComparer.instance);
  }
  setReadonly(readOnly) {
    this.readOnly = readOnly;
    if (readOnly) {
      this.configLookup = null;
    }
  }
  toString() {
    return arrayToString(this.configs) + (this.hasSemanticContext ? ",hasSemanticContext=" + this.hasSemanticContext : "") + (this.uniqueAlt !== ATN.INVALID_ALT_NUMBER ? ",uniqueAlt=" + this.uniqueAlt : "") + (this.conflictingAlts !== null ? ",conflictingAlts=" + this.conflictingAlts : "") + (this.dipsIntoOuterContext ? ",dipsIntoOuterContext" : "");
  }
  computeHashCode() {
    let hash = MurmurHash.initialize();
    this.configs.forEach((config) => {
      hash = MurmurHash.update(hash, config.hashCode());
    });
    hash = MurmurHash.finish(hash, this.configs.length);
    return hash;
  }
}, _cachedHashCode = new WeakMap(), __name(_E2, "ATNConfigSet"), _E2);
var BasicState = (_F = class extends ATNState {
}, __name(_F, "BasicState"), __publicField(_F, "stateType", ATNState.BASIC), _F);
var DecisionState = (_G = class extends ATNState {
  constructor() {
    super(...arguments);
    __publicField(this, "decision", -1);
    __publicField(this, "nonGreedy", false);
  }
}, __name(_G, "DecisionState"), _G);
var BlockStartState = (_H = class extends DecisionState {
  constructor() {
    super(...arguments);
    __publicField(this, "endState");
  }
}, __name(_H, "BlockStartState"), _H);
var BlockEndState = (_I = class extends ATNState {
  constructor() {
    super(...arguments);
    __publicField(this, "startState");
  }
}, __name(_I, "BlockEndState"), __publicField(_I, "stateType", ATNState.BLOCK_END), _I);
var LoopEndState = (_J = class extends ATNState {
  constructor() {
    super(...arguments);
    __publicField(this, "loopBackState");
  }
}, __name(_J, "LoopEndState"), __publicField(_J, "stateType", ATNState.LOOP_END), _J);
var RuleStartState = (_K = class extends ATNState {
  constructor() {
    super(...arguments);
    __publicField(this, "stopState");
    __publicField(this, "isLeftRecursiveRule", false);
  }
}, __name(_K, "RuleStartState"), __publicField(_K, "stateType", ATNState.RULE_START), _K);
var RuleStopState = (_L = class extends ATNState {
}, __name(_L, "RuleStopState"), __publicField(_L, "stateType", ATNState.RULE_STOP), _L);
var TokensStartState = (_M = class extends DecisionState {
}, __name(_M, "TokensStartState"), __publicField(_M, "stateType", ATNState.TOKEN_START), _M);
var PlusLoopbackState = (_N2 = class extends DecisionState {
}, __name(_N2, "PlusLoopbackState"), __publicField(_N2, "stateType", ATNState.PLUS_LOOP_BACK), _N2);
var StarLoopbackState = (_O2 = class extends ATNState {
}, __name(_O2, "StarLoopbackState"), __publicField(_O2, "stateType", ATNState.STAR_LOOP_BACK), _O2);
var StarLoopEntryState = (_P = class extends DecisionState {
  constructor() {
    super(...arguments);
    // This is always set during ATN deserialization
    __publicField(this, "loopBackState");
    /**
     * Indicates whether this state can benefit from a precedence DFA during SLL
     * decision making.
     *
     * This is a computed property that is calculated during ATN deserialization
     * and stored for use in {@link ParserATNSimulator} and
     * {@link ParserInterpreter}.
     *
     * @see `DFA.isPrecedenceDfa`
     */
    __publicField(this, "precedenceRuleDecision", false);
  }
}, __name(_P, "StarLoopEntryState"), __publicField(_P, "stateType", ATNState.STAR_LOOP_ENTRY), _P);
var PlusBlockStartState = (_Q = class extends BlockStartState {
  constructor() {
    super(...arguments);
    __publicField(this, "loopBackState");
  }
}, __name(_Q, "PlusBlockStartState"), __publicField(_Q, "stateType", ATNState.PLUS_BLOCK_START), _Q);
var StarBlockStartState = (_R = class extends BlockStartState {
}, __name(_R, "StarBlockStartState"), __publicField(_R, "stateType", ATNState.STAR_BLOCK_START), _R);
var BasicBlockStartState = (_S2 = class extends BlockStartState {
}, __name(_S2, "BasicBlockStartState"), __publicField(_S2, "stateType", ATNState.BLOCK_START), _S2);
var AtomTransition = (_T2 = class extends Transition {
  constructor(target, label) {
    super(target);
    /** The token type or character value; or, signifies special label. */
    __publicField(this, "labelValue");
    __privateAdd(this, _label);
    this.labelValue = label;
    __privateSet(this, _label, IntervalSet.of(label, label));
  }
  get label() {
    return __privateGet(this, _label);
  }
  get transitionType() {
    return Transition.ATOM;
  }
  matches(symbol) {
    return this.labelValue === symbol;
  }
  toString() {
    return this.labelValue.toString();
  }
}, _label = new WeakMap(), __name(_T2, "AtomTransition"), _T2);
var RuleTransition = (_U = class extends Transition {
  constructor(ruleStart, ruleIndex, precedence, followState) {
    super(ruleStart);
    __publicField(this, "ruleIndex");
    __publicField(this, "precedence");
    __publicField(this, "followState");
    this.ruleIndex = ruleIndex;
    this.precedence = precedence;
    this.followState = followState;
  }
  get isEpsilon() {
    return true;
  }
  get transitionType() {
    return Transition.RULE;
  }
  matches(_symbol, _minVocabSymbol, _maxVocabSymbol) {
    return false;
  }
}, __name(_U, "RuleTransition"), _U);
var RangeTransition = (_V = class extends Transition {
  constructor(target, start, stop) {
    super(target);
    __publicField(this, "start");
    __publicField(this, "stop");
    __privateAdd(this, _label2, new IntervalSet());
    this.start = start;
    this.stop = stop;
    __privateGet(this, _label2).addRange(start, stop);
  }
  get label() {
    return __privateGet(this, _label2);
  }
  get transitionType() {
    return Transition.RANGE;
  }
  matches(symbol, _minVocabSymbol, _maxVocabSymbol) {
    return symbol >= this.start && symbol <= this.stop;
  }
  toString() {
    return "'" + String.fromCharCode(this.start) + "'..'" + String.fromCharCode(this.stop) + "'";
  }
}, _label2 = new WeakMap(), __name(_V, "RangeTransition"), _V);
var ActionTransition = (_W = class extends Transition {
  constructor(target, ruleIndex, actionIndex, isCtxDependent) {
    super(target);
    __publicField(this, "ruleIndex");
    __publicField(this, "actionIndex");
    __publicField(this, "isCtxDependent");
    this.ruleIndex = ruleIndex;
    this.actionIndex = actionIndex ?? -1;
    this.isCtxDependent = isCtxDependent ?? false;
  }
  get isEpsilon() {
    return true;
  }
  get transitionType() {
    return Transition.ACTION;
  }
  matches(_symbol, _minVocabSymbol, _maxVocabSymbol) {
    return false;
  }
  toString() {
    return "action_" + this.ruleIndex + ":" + this.actionIndex;
  }
}, __name(_W, "ActionTransition"), _W);
var EpsilonTransition = (_X = class extends Transition {
  constructor(target, outermostPrecedenceReturn = -1) {
    super(target);
    __privateAdd(this, _outermostPrecedenceReturn);
    __privateSet(this, _outermostPrecedenceReturn, outermostPrecedenceReturn);
  }
  /**
   * @returns the rule index of a precedence rule for which this transition is
   * returning from, where the precedence value is 0; otherwise, -1.
   *
   * @see ATNConfig.isPrecedenceFilterSuppressed()
   * @see ParserATNSimulator.applyPrecedenceFilter(ATNConfigSet)
   * @since 4.4.1
   */
  get outermostPrecedenceReturn() {
    return __privateGet(this, _outermostPrecedenceReturn);
  }
  get isEpsilon() {
    return true;
  }
  get transitionType() {
    return Transition.EPSILON;
  }
  matches() {
    return false;
  }
  toString() {
    return "epsilon";
  }
}, _outermostPrecedenceReturn = new WeakMap(), __name(_X, "EpsilonTransition"), _X);
var WildcardTransition = (_Y = class extends Transition {
  get transitionType() {
    return Transition.WILDCARD;
  }
  matches(symbol, minVocabSymbol, maxVocabSymbol) {
    return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
  }
  toString() {
    return ".";
  }
}, __name(_Y, "WildcardTransition"), _Y);
var AbstractPredicateTransition = (_Z = class extends Transition {
  constructor(target) {
    super(target);
  }
}, __name(_Z, "AbstractPredicateTransition"), _Z);
var PredicateTransition = (__ = class extends AbstractPredicateTransition {
  // e.g., $i ref in pred
  constructor(target, ruleIndex, predIndex, isCtxDependent) {
    super(target);
    __publicField(this, "ruleIndex");
    __publicField(this, "predIndex");
    __publicField(this, "isCtxDependent");
    this.ruleIndex = ruleIndex;
    this.predIndex = predIndex;
    this.isCtxDependent = isCtxDependent;
  }
  get isEpsilon() {
    return true;
  }
  matches(_symbol, _minVocabSymbol, _maxVocabSymbol) {
    return false;
  }
  get transitionType() {
    return Transition.PREDICATE;
  }
  getPredicate() {
    return new SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
  }
  toString() {
    return "pred_" + this.ruleIndex + ":" + this.predIndex;
  }
}, __name(__, "PredicateTransition"), __);
var PrecedencePredicateTransition = (_$ = class extends AbstractPredicateTransition {
  constructor(target, precedence) {
    super(target);
    __publicField(this, "precedence");
    this.precedence = precedence;
  }
  get isEpsilon() {
    return true;
  }
  matches(_symbol, _minVocabSymbol, _maxVocabSymbol) {
    return false;
  }
  getPredicate() {
    return new SemanticContext.PrecedencePredicate(this.precedence);
  }
  get transitionType() {
    return Transition.PRECEDENCE;
  }
  toString() {
    return this.precedence + " >= _p";
  }
}, __name(_$, "PrecedencePredicateTransition"), _$);
var LexerActionType = {
  /** The type of a {@link LexerChannelAction} action. */
  CHANNEL: 0,
  /** The type of a {@link LexerCustomAction} action */
  CUSTOM: 1,
  /** The type of a {@link LexerModeAction} action. */
  MODE: 2,
  /** The type of a {@link LexerMoreAction} action. */
  MORE: 3,
  /** The type of a {@link LexerPopModeAction} action. */
  POP_MODE: 4,
  /** The type of a {@link LexerPushModeAction} action. */
  PUSH_MODE: 5,
  /** The type of a {@link LexerSkipAction} action. */
  SKIP: 6,
  /** The type of a {@link LexerTypeAction} action. */
  TYPE: 7
};
var LexerSkipAction = (_aa = class {
  constructor() {
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    this.actionType = LexerActionType.SKIP;
  }
  equals(obj) {
    return obj === this;
  }
  hashCode() {
    return LexerActionType.SKIP;
  }
  execute(lexer) {
    lexer.skip();
  }
  toString() {
    return "skip";
  }
}, __name(_aa, "LexerSkipAction"), /** Provides a singleton instance of this parameter-less lexer action. */
__publicField(_aa, "instance", new _aa()), _aa);
var LexerChannelAction = (_ba = class {
  constructor(channel) {
    __publicField(this, "channel");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    __publicField(this, "cachedHashCode");
    this.actionType = LexerActionType.CHANNEL;
    this.channel = channel;
  }
  /**
   * This action is implemented by calling {@link Lexer.setChannel} with the
   * value provided by {@link getChannel}.
   */
  execute(lexer) {
    lexer.channel = this.channel;
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.actionType);
      hash = MurmurHash.update(hash, this.channel);
      this.cachedHashCode = MurmurHash.finish(hash, 2);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _ba)) {
      return false;
    }
    return this.channel === other.channel;
  }
  toString() {
    return "channel(" + this.channel + ")";
  }
}, __name(_ba, "LexerChannelAction"), _ba);
var LexerCustomAction = (_ca = class {
  /**
   * Constructs a custom lexer action with the specified rule and action indexes.
   *
   * @param ruleIndex The rule index to use for calls to {@link Recognizer.action}.
   * @param actionIndex The action index to use for calls to {@link Recognizer.action}.
   */
  constructor(ruleIndex, actionIndex) {
    __publicField(this, "ruleIndex");
    __publicField(this, "actionIndex");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", true);
    __publicField(this, "cachedHashCode");
    this.actionType = LexerActionType.CUSTOM;
    this.ruleIndex = ruleIndex;
    this.actionIndex = actionIndex;
  }
  /**
   * Custom actions are implemented by calling {@link Lexer.action} with the
   * appropriate rule and action indexes.
   */
  execute(lexer) {
    lexer.action(null, this.ruleIndex, this.actionIndex);
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.actionType);
      hash = MurmurHash.update(hash, this.ruleIndex);
      hash = MurmurHash.update(hash, this.actionIndex);
      this.cachedHashCode = MurmurHash.finish(hash, 3);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _ca)) {
      return false;
    }
    return this.ruleIndex === other.ruleIndex && this.actionIndex === other.actionIndex;
  }
}, __name(_ca, "LexerCustomAction"), _ca);
var LexerMoreAction = (_da = class {
  constructor() {
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    this.actionType = LexerActionType.MORE;
  }
  equals(obj) {
    return obj === this;
  }
  hashCode() {
    return LexerActionType.MORE;
  }
  /**
   * This action is implemented by calling {@link Lexer.popMode}.
   */
  execute(lexer) {
    lexer.more();
  }
  toString() {
    return "more";
  }
}, __name(_da, "LexerMoreAction"), __publicField(_da, "instance", new _da()), _da);
var LexerTypeAction = (_ea = class {
  constructor(type4) {
    __publicField(this, "type");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    __publicField(this, "cachedHashCode");
    this.actionType = LexerActionType.TYPE;
    this.type = type4;
  }
  execute(lexer) {
    lexer.type = this.type;
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.actionType);
      hash = MurmurHash.update(hash, this.type);
      this.cachedHashCode = MurmurHash.finish(hash, 2);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _ea)) {
      return false;
    }
    return this.type === other.type;
  }
  toString() {
    return "type(" + this.type + ")";
  }
}, __name(_ea, "LexerTypeAction"), _ea);
var LexerPushModeAction = (_fa = class {
  constructor(mode2) {
    __publicField(this, "mode");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    __publicField(this, "cachedHashCode");
    this.actionType = LexerActionType.PUSH_MODE;
    this.mode = mode2;
  }
  /**
   * This action is implemented by calling {@link Lexer.pushMode} with the
   * value provided by {@link getMode}.
   */
  execute(lexer) {
    lexer.pushMode(this.mode);
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.actionType);
      hash = MurmurHash.update(hash, this.mode);
      this.cachedHashCode = MurmurHash.finish(hash, 2);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _fa)) {
      return false;
    }
    return this.mode === other.mode;
  }
  toString() {
    return "pushMode(" + this.mode + ")";
  }
}, __name(_fa, "LexerPushModeAction"), _fa);
var LexerPopModeAction = (_ga = class {
  constructor() {
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    this.actionType = LexerActionType.POP_MODE;
  }
  equals(obj) {
    return obj === this;
  }
  hashCode() {
    return LexerActionType.POP_MODE;
  }
  /**
   * This action is implemented by calling {@link Lexer//popMode}.
   */
  execute(lexer) {
    lexer.popMode();
  }
  toString() {
    return "popMode";
  }
}, __name(_ga, "LexerPopModeAction"), __publicField(_ga, "instance", new _ga()), _ga);
var LexerModeAction = (_ha = class {
  constructor(mode2) {
    __publicField(this, "mode");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    __publicField(this, "cachedHashCode");
    this.actionType = LexerActionType.MODE;
    this.mode = mode2;
  }
  /**
   * This action is implemented by calling {@link Lexer.mode} with the
   * value provided by {@link getMode}.
   */
  execute(lexer) {
    lexer.mode = this.mode;
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.actionType);
      hash = MurmurHash.update(hash, this.mode);
      this.cachedHashCode = MurmurHash.finish(hash, 2);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _ha)) {
      return false;
    }
    return this.mode === other.mode;
  }
  toString() {
    return "mode(" + this.mode + ")";
  }
}, __name(_ha, "LexerModeAction"), _ha);
var ATNDeserializer = (_ia = class {
  constructor(options) {
    __publicField(this, "data", []);
    __publicField(this, "pos", 0);
    __publicField(this, "deserializationOptions");
    __publicField(this, "actionFactories");
    if (!options) {
      options = { readOnly: false, verifyATN: true, generateRuleBypassTransitions: false };
    }
    this.deserializationOptions = options;
  }
  deserialize(data) {
    this.data = data;
    this.checkVersion();
    const atn = this.readATN();
    this.readStates(atn);
    this.readRules(atn);
    this.readModes(atn);
    const sets = [];
    this.readSets(atn, sets);
    this.readEdges(atn, sets);
    this.readDecisions(atn);
    this.readLexerActions(atn);
    this.markPrecedenceDecisions(atn);
    this.verifyATN(atn);
    if (this.deserializationOptions.generateRuleBypassTransitions && atn.grammarType === ATN.PARSER) {
      this.generateRuleBypassTransitions(atn);
      this.verifyATN(atn);
    }
    return atn;
  }
  checkVersion() {
    const version2 = this.data[this.pos++];
    if (version2 !== _ia.SERIALIZED_VERSION) {
      throw new Error("Could not deserialize ATN with version " + version2 + " (expected " + _ia.SERIALIZED_VERSION + ").");
    }
  }
  readATN() {
    const grammarType = this.data[this.pos++];
    const maxTokenType = this.data[this.pos++];
    return new ATN(grammarType, maxTokenType);
  }
  readStates(atn) {
    let j2;
    let stateNumber;
    const loopBackStateNumbers = [];
    const endStateNumbers = [];
    const stateCount = this.data[this.pos++];
    for (let i2 = 0; i2 < stateCount; i2++) {
      const stateType = this.data[this.pos++];
      if (stateType === ATNState.INVALID_TYPE) {
        atn.addState(null);
        continue;
      }
      const ruleIndex = this.data[this.pos++];
      const s2 = this.stateFactory(stateType, ruleIndex);
      if (stateType === ATNState.LOOP_END) {
        const loopBackStateNumber = this.data[this.pos++];
        loopBackStateNumbers.push([s2, loopBackStateNumber]);
      } else if (s2 instanceof BlockStartState) {
        const endStateNumber = this.data[this.pos++];
        endStateNumbers.push([s2, endStateNumber]);
      }
      atn.addState(s2);
    }
    for (j2 = 0; j2 < loopBackStateNumbers.length; j2++) {
      const pair = loopBackStateNumbers[j2];
      pair[0].loopBackState = atn.states[pair[1]] ?? void 0;
    }
    for (j2 = 0; j2 < endStateNumbers.length; j2++) {
      const pair = endStateNumbers[j2];
      pair[0].endState = atn.states[pair[1]];
    }
    const numNonGreedyStates = this.data[this.pos++];
    for (j2 = 0; j2 < numNonGreedyStates; j2++) {
      stateNumber = this.data[this.pos++];
      atn.states[stateNumber].nonGreedy = true;
    }
    const numPrecedenceStates = this.data[this.pos++];
    for (j2 = 0; j2 < numPrecedenceStates; j2++) {
      stateNumber = this.data[this.pos++];
      atn.states[stateNumber].isLeftRecursiveRule = true;
    }
  }
  readRules(atn) {
    let i2;
    const ruleCount = this.data[this.pos++];
    if (atn.grammarType === ATN.LEXER) {
      atn.ruleToTokenType = new Array(ruleCount);
      atn.ruleToTokenType.fill(0);
    }
    atn.ruleToStartState = new Array(ruleCount);
    atn.ruleToStartState.fill(null);
    for (i2 = 0; i2 < ruleCount; i2++) {
      const s2 = this.data[this.pos++];
      atn.ruleToStartState[i2] = atn.states[s2];
      if (atn.grammarType === ATN.LEXER) {
        const tokenType = this.data[this.pos++];
        atn.ruleToTokenType[i2] = tokenType;
      }
    }
    atn.ruleToStopState = new Array(ruleCount);
    atn.ruleToStopState.fill(null);
    for (i2 = 0; i2 < atn.states.length; i2++) {
      const state = atn.states[i2];
      if (!(state instanceof RuleStopState)) {
        continue;
      }
      atn.ruleToStopState[state.ruleIndex] = state;
      atn.ruleToStartState[state.ruleIndex].stopState = state;
    }
  }
  readModes(atn) {
    const modeCount = this.data[this.pos++];
    for (let i2 = 0; i2 < modeCount; i2++) {
      const s2 = this.data[this.pos++];
      atn.modeToStartState.push(atn.states[s2]);
    }
  }
  readSets(atn, sets) {
    const m2 = this.data[this.pos++];
    for (let i2 = 0; i2 < m2; i2++) {
      const intervalSet = new IntervalSet();
      sets.push(intervalSet);
      const n2 = this.data[this.pos++];
      const containsEof = this.data[this.pos++];
      if (containsEof !== 0) {
        intervalSet.addOne(-1);
      }
      for (let j2 = 0; j2 < n2; j2++) {
        const i1 = this.data[this.pos++];
        const i22 = this.data[this.pos++];
        intervalSet.addRange(i1, i22);
      }
    }
  }
  readEdges(atn, sets) {
    let i2;
    let j2;
    let state;
    let trans;
    let target;
    const edgeCount = this.data[this.pos++];
    for (i2 = 0; i2 < edgeCount; i2++) {
      const src = this.data[this.pos++];
      const trg = this.data[this.pos++];
      const ttype = this.data[this.pos++];
      const arg1 = this.data[this.pos++];
      const arg2 = this.data[this.pos++];
      const arg3 = this.data[this.pos++];
      trans = this.edgeFactory(atn, ttype, trg, arg1, arg2, arg3, sets);
      const srcState = atn.states[src];
      srcState.addTransition(trans);
    }
    for (i2 = 0; i2 < atn.states.length; i2++) {
      state = atn.states[i2];
      for (j2 = 0; j2 < state.transitions.length; j2++) {
        const t2 = state.transitions[j2];
        if (!(t2 instanceof RuleTransition)) {
          continue;
        }
        let outermostPrecedenceReturn = -1;
        if (atn.ruleToStartState[t2.target.ruleIndex].isLeftRecursiveRule) {
          if (t2.precedence === 0) {
            outermostPrecedenceReturn = t2.target.ruleIndex;
          }
        }
        trans = new EpsilonTransition(t2.followState, outermostPrecedenceReturn);
        atn.ruleToStopState[t2.target.ruleIndex].addTransition(trans);
      }
    }
    for (i2 = 0; i2 < atn.states.length; i2++) {
      state = atn.states[i2];
      if (state instanceof BlockStartState) {
        if (!state.endState) {
          throw new Error("IllegalState");
        }
        if (state.endState.startState) {
          throw new Error("IllegalState");
        }
        state.endState.startState = state;
      }
      if (state instanceof PlusLoopbackState) {
        for (j2 = 0; j2 < state.transitions.length; j2++) {
          target = state.transitions[j2].target;
          if (target instanceof PlusBlockStartState) {
            target.loopBackState = state;
          }
        }
      } else if (state instanceof StarLoopbackState) {
        for (j2 = 0; j2 < state.transitions.length; j2++) {
          target = state.transitions[j2].target;
          if (target instanceof StarLoopEntryState) {
            target.loopBackState = state;
          }
        }
      }
    }
  }
  readDecisions(atn) {
    const decisionCount = this.data[this.pos++];
    for (let i2 = 0; i2 < decisionCount; i2++) {
      const s2 = this.data[this.pos++];
      const decState = atn.states[s2];
      atn.decisionToState.push(decState);
      decState.decision = i2;
    }
  }
  readLexerActions(atn) {
    if (atn.grammarType === ATN.LEXER) {
      const count = this.data[this.pos++];
      atn.lexerActions = [];
      for (let i2 = 0; i2 < count; i2++) {
        const actionType = this.data[this.pos++];
        const data1 = this.data[this.pos++];
        const data2 = this.data[this.pos++];
        atn.lexerActions.push(this.lexerActionFactory(actionType, data1, data2));
      }
    }
  }
  generateRuleBypassTransitions(atn) {
    let i2;
    const count = atn.ruleToStartState.length;
    for (i2 = 0; i2 < count; i2++) {
      atn.ruleToTokenType[i2] = atn.maxTokenType + i2 + 1;
    }
    for (i2 = 0; i2 < count; i2++) {
      this.generateRuleBypassTransition(atn, i2);
    }
  }
  generateRuleBypassTransition(atn, idx) {
    let i2;
    let state;
    const bypassStart = new BasicBlockStartState();
    bypassStart.ruleIndex = idx;
    atn.addState(bypassStart);
    const bypassStop = new BlockEndState();
    bypassStop.ruleIndex = idx;
    atn.addState(bypassStop);
    bypassStart.endState = bypassStop;
    atn.defineDecisionState(bypassStart);
    bypassStop.startState = bypassStart;
    let excludeTransition = null;
    let endState = null;
    if (atn.ruleToStartState[idx].isLeftRecursiveRule) {
      endState = null;
      for (i2 = 0; i2 < atn.states.length; i2++) {
        state = atn.states[i2];
        if (this.stateIsEndStateFor(state, idx)) {
          endState = state;
          excludeTransition = state.loopBackState.transitions[0];
          break;
        }
      }
      if (excludeTransition === null) {
        throw new Error("Couldn't identify final state of the precedence rule prefix section.");
      }
    } else {
      endState = atn.ruleToStopState[idx];
    }
    for (i2 = 0; i2 < atn.states.length; i2++) {
      state = atn.states[i2];
      for (const transition of state.transitions) {
        if (transition === excludeTransition) {
          continue;
        }
        if (transition.target === endState) {
          transition.target = bypassStop;
        }
      }
    }
    const ruleToStartState = atn.ruleToStartState[idx];
    while (ruleToStartState.transitions.length > 0) {
      const transition = ruleToStartState.removeTransition(ruleToStartState.transitions.length - 1);
      bypassStart.addTransition(transition);
    }
    atn.ruleToStartState[idx].addTransition(new EpsilonTransition(bypassStart));
    if (endState) {
      bypassStop.addTransition(new EpsilonTransition(endState));
    }
    const matchState = new BasicState();
    atn.addState(matchState);
    matchState.addTransition(new AtomTransition(bypassStop, atn.ruleToTokenType[idx]));
    bypassStart.addTransition(new EpsilonTransition(matchState));
  }
  stateIsEndStateFor(state, idx) {
    if (state.ruleIndex !== idx) {
      return null;
    }
    if (!(state instanceof StarLoopEntryState)) {
      return null;
    }
    const maybeLoopEndState = state.transitions[state.transitions.length - 1].target;
    if (!(maybeLoopEndState instanceof LoopEndState)) {
      return null;
    }
    if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transitions[0].target instanceof RuleStopState) {
      return state;
    } else {
      return null;
    }
  }
  /**
   * Analyze the {@link StarLoopEntryState} states in the specified ATN to set
   * the {@link StarLoopEntryState} field to the correct value.
   *
   * @param atn The ATN.
   */
  markPrecedenceDecisions(atn) {
    for (const state of atn.states) {
      if (!(state instanceof StarLoopEntryState)) {
        continue;
      }
      if (atn.ruleToStartState[state.ruleIndex].isLeftRecursiveRule) {
        const maybeLoopEndState = state.transitions[state.transitions.length - 1].target;
        if (maybeLoopEndState instanceof LoopEndState) {
          if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transitions[0].target instanceof RuleStopState) {
            state.precedenceRuleDecision = true;
          }
        }
      }
    }
  }
  verifyATN(atn) {
    if (!this.deserializationOptions.verifyATN) {
      return;
    }
    for (const state of atn.states) {
      if (state === null) {
        continue;
      }
      this.checkCondition(state.epsilonOnlyTransitions || state.transitions.length <= 1);
      if (state instanceof PlusBlockStartState) {
        this.checkCondition(state.loopBackState !== null);
      } else if (state instanceof StarLoopEntryState) {
        this.checkCondition(state.loopBackState !== null);
        this.checkCondition(state.transitions.length === 2);
        if (state.transitions[0].target instanceof StarBlockStartState) {
          this.checkCondition(state.transitions[1].target instanceof LoopEndState);
          this.checkCondition(!state.nonGreedy);
        } else if (state.transitions[0].target instanceof LoopEndState) {
          this.checkCondition(state.transitions[1].target instanceof StarBlockStartState);
          this.checkCondition(state.nonGreedy);
        } else {
          throw new Error("IllegalState");
        }
      } else if (state instanceof StarLoopbackState) {
        this.checkCondition(state.transitions.length === 1);
        this.checkCondition(state.transitions[0].target instanceof StarLoopEntryState);
      } else if (state instanceof LoopEndState) {
        this.checkCondition(state.loopBackState !== null);
      } else if (state instanceof RuleStartState) {
        this.checkCondition(state.stopState !== null);
      } else if (state instanceof BlockStartState) {
        this.checkCondition(state.endState !== null);
      } else if (state instanceof BlockEndState) {
        this.checkCondition(state.startState !== null);
      } else if (state instanceof DecisionState) {
        this.checkCondition(state.transitions.length <= 1 || state.decision >= 0);
      } else {
        this.checkCondition(state.transitions.length <= 1 || state instanceof RuleStopState);
      }
    }
  }
  checkCondition(condition, message) {
    if (!condition) {
      if (message === void 0 || message === null) {
        message = "IllegalState";
      }
      throw message;
    }
  }
  edgeFactory(atn, type4, trg, arg1, arg2, arg3, sets) {
    const target = atn.states[trg];
    switch (type4) {
      case Transition.EPSILON:
        return new EpsilonTransition(target);
      case Transition.RANGE:
        return arg3 !== 0 ? new RangeTransition(target, Token.EOF, arg2) : new RangeTransition(target, arg1, arg2);
      case Transition.RULE:
        return new RuleTransition(atn.states[arg1], arg2, arg3, target);
      case Transition.PREDICATE:
        return new PredicateTransition(target, arg1, arg2, arg3 !== 0);
      case Transition.PRECEDENCE:
        return new PrecedencePredicateTransition(target, arg1);
      case Transition.ATOM:
        return arg3 !== 0 ? new AtomTransition(target, Token.EOF) : new AtomTransition(target, arg1);
      case Transition.ACTION:
        return new ActionTransition(target, arg1, arg2, arg3 !== 0);
      case Transition.SET:
        return new SetTransition(target, sets[arg1]);
      case Transition.NOT_SET:
        return new NotSetTransition(target, sets[arg1]);
      case Transition.WILDCARD:
        return new WildcardTransition(target);
      default:
        throw new Error("The specified transition type: " + type4 + " is not valid.");
    }
  }
  stateFactory(type4, ruleIndex) {
    const ctor = _ia.stateTypeMapper.get(type4);
    if (!ctor) {
      throw new Error("The specified state type " + type4 + " is not valid.");
    }
    const s2 = new ctor();
    s2.ruleIndex = ruleIndex;
    return s2;
  }
  lexerActionFactory(type4, data1, data2) {
    const factory = _ia.lexerActionFactoryMapper.get(type4);
    if (!factory) {
      throw new Error("The specified lexer action type " + type4 + " is not valid.");
    }
    return factory(data1, data2);
  }
}, __name(_ia, "ATNDeserializer"), __publicField(_ia, "SERIALIZED_VERSION", 4), __publicField(_ia, "stateTypeMapper", /* @__PURE__ */ new Map([
  [ATNState.INVALID_TYPE, void 0],
  [ATNState.BASIC, BasicState],
  [ATNState.RULE_START, RuleStartState],
  [ATNState.BLOCK_START, BasicBlockStartState],
  [ATNState.PLUS_BLOCK_START, PlusBlockStartState],
  [ATNState.STAR_BLOCK_START, StarBlockStartState],
  [ATNState.TOKEN_START, TokensStartState],
  [ATNState.RULE_STOP, RuleStopState],
  [ATNState.BLOCK_END, BlockEndState],
  [ATNState.STAR_LOOP_BACK, StarLoopbackState],
  [ATNState.STAR_LOOP_ENTRY, StarLoopEntryState],
  [ATNState.PLUS_LOOP_BACK, PlusLoopbackState],
  [ATNState.LOOP_END, LoopEndState]
])), __publicField(_ia, "lexerActionFactoryMapper", /* @__PURE__ */ new Map([
  [LexerActionType.CHANNEL, (data1) => {
    return new LexerChannelAction(data1);
  }],
  [LexerActionType.CUSTOM, (data1, data2) => {
    return new LexerCustomAction(data1, data2);
  }],
  [LexerActionType.MODE, (data1) => {
    return new LexerModeAction(data1);
  }],
  [LexerActionType.MORE, () => {
    return LexerMoreAction.instance;
  }],
  [LexerActionType.POP_MODE, () => {
    return LexerPopModeAction.instance;
  }],
  [LexerActionType.PUSH_MODE, (data1) => {
    return new LexerPushModeAction(data1);
  }],
  [LexerActionType.SKIP, () => {
    return LexerSkipAction.instance;
  }],
  [LexerActionType.TYPE, (data1) => {
    return new LexerTypeAction(data1);
  }]
])), _ia);
var OrderedHashMap = (_ja = class extends HashMap {
  constructor() {
    super(...arguments);
    __privateAdd(this, _keys, []);
  }
  clear() {
    super.clear();
    __privateSet(this, _keys, []);
  }
  get(key) {
    return super.get(key);
  }
  set(key, value) {
    const result = super.set(key, value);
    if (result === void 0) {
      __privateGet(this, _keys).push(key);
    }
    return result;
  }
  setIfAbsent(key, value) {
    const result = super.setIfAbsent(key, value);
    if (result === void 0) {
      __privateGet(this, _keys).push(key);
    }
    return result;
  }
  /**
   * @returns an iterable of the values in the map, in the order they were inserted.
   */
  values() {
    return {
      [Symbol.iterator]: () => {
        let index2 = 0;
        return {
          next: /* @__PURE__ */ __name(() => {
            if (index2 < __privateGet(this, _keys).length) {
              return {
                done: false,
                value: super.get(__privateGet(this, _keys)[index2++])
              };
            }
            return {
              done: true,
              value: void 0
            };
          }, "next")
        };
      }
    };
  }
  /**
   * @returns an iterable of the keys in the map, in the order they were inserted.
   */
  keys() {
    return __privateGet(this, _keys)[Symbol.iterator]();
  }
  equals(o2) {
    if (!(o2 instanceof _ja)) {
      return false;
    }
    return super.equals(o2);
  }
}, _keys = new WeakMap(), __name(_ja, "OrderedHashMap"), _ja);
_ka = class {
  constructor(atn) {
    __publicField(this, "atn");
    __publicField(this, "data", []);
    // Note that we use a LinkedHashMap as a set to maintain insertion order while deduplicating entries with the
    // same key.
    __publicField(this, "sets", new OrderedHashMap(ObjectEqualityComparator.instance));
    __publicField(this, "nonGreedyStates", []);
    __publicField(this, "precedenceStates", []);
    this.atn = atn;
  }
  static getSerialized(atn) {
    return new _ka(atn).serialize();
  }
  static serializeSets(data, sets) {
    data.push(sets.length);
    for (const set of sets) {
      const containsEof = set.contains(Token.EOF);
      const intervals = [...set];
      if (containsEof && intervals[0].stop === Token.EOF) {
        data.push(intervals.length - 1);
      } else {
        data.push(intervals.length);
      }
      data.push(containsEof ? 1 : 0);
      for (const interval of intervals) {
        if (interval.start === Token.EOF) {
          if (interval.stop === Token.EOF) {
            continue;
          } else {
            data.push(0);
          }
        } else {
          data.push(interval.start);
        }
        data.push(interval.stop);
      }
    }
  }
  /**
   * Serialize state descriptors, edge descriptors, and decision -> state map
   *  into list of ints.  Likely out of date, but keeping as it could be helpful:
   *
   *      SERIALIZED_VERSION
   *      UUID (2 longs)
   * 		grammar-type, (ANTLRParser.LEXER, ...)
   *  	max token type,
   *  	num states,
   *  	state-0-type ruleIndex, state-1-type ruleIndex, ... state-i-type ruleIndex optional-arg ...
   *  	num rules,
   *  	rule-1-start-state rule-1-args, rule-2-start-state  rule-2-args, ...
   *  	(args are token type,actionIndex in lexer else 0,0)
   *      num modes,
   *      mode-0-start-state, mode-1-start-state, ... (parser has 0 modes)
   *      num unicode-bmp-sets
   *      bmp-set-0-interval-count intervals, bmp-set-1-interval-count intervals, ...
   *      num unicode-smp-sets
   *      smp-set-0-interval-count intervals, smp-set-1-interval-count intervals, ...
   *	num total edges,
   *      src, trg, edge-type, edge arg1, optional edge arg2 (present always), ...
   *      num decisions,
   *      decision-0-start-state, decision-1-start-state, ...
   *
   *  Convenient to pack into unsigned shorts to make as Java string.
   */
  serialize() {
    this.addPreamble();
    const edgeCount = this.addEdges();
    this.addNonGreedyStates();
    this.addPrecedenceStates();
    this.addRuleStatesAndLexerTokenTypes();
    this.addModeStartStates();
    const setIndices = this.addSets();
    this.addEdges(edgeCount, setIndices);
    this.addDecisionStartStates();
    this.addLexerActions();
    return this.data;
  }
  addPreamble() {
    this.data.push(ATNDeserializer.SERIALIZED_VERSION);
    this.data.push(this.atn.grammarType);
    this.data.push(this.atn.maxTokenType);
  }
  addLexerActions() {
    if (this.atn.grammarType === ATN.LEXER) {
      this.data.push(this.atn.lexerActions.length);
      for (const action of this.atn.lexerActions) {
        this.data.push(action.actionType);
        switch (action.actionType) {
          case LexerActionType.CHANNEL: {
            const channel = action.channel;
            this.data.push(channel);
            this.data.push(0);
            break;
          }
          case LexerActionType.CUSTOM: {
            const ruleIndex = action.ruleIndex;
            const actionIndex = action.actionIndex;
            this.data.push(ruleIndex);
            this.data.push(actionIndex);
            break;
          }
          case LexerActionType.MODE: {
            const mode2 = action.mode;
            this.data.push(mode2);
            this.data.push(0);
            break;
          }
          case LexerActionType.MORE: {
            this.data.push(0);
            this.data.push(0);
            break;
          }
          case LexerActionType.POP_MODE: {
            this.data.push(0);
            this.data.push(0);
            break;
          }
          case LexerActionType.PUSH_MODE: {
            const mode2 = action.mode;
            this.data.push(mode2);
            this.data.push(0);
            break;
          }
          case LexerActionType.SKIP: {
            this.data.push(0);
            this.data.push(0);
            break;
          }
          case LexerActionType.TYPE: {
            const type4 = action.type;
            this.data.push(type4);
            this.data.push(0);
            break;
          }
          default: {
            throw new Error(`The specified lexer action type ${action.actionType} is not valid.`);
          }
        }
      }
    }
  }
  addDecisionStartStates() {
    this.data.push(this.atn.decisionToState.length);
    for (const decStartState of this.atn.decisionToState) {
      this.data.push(decStartState.stateNumber);
    }
  }
  addEdges(...args) {
    switch (args.length) {
      case 0: {
        let edgeCount = 0;
        this.data.push(this.atn.states.length);
        for (const s2 of this.atn.states) {
          if (s2 === null) {
            this.data.push(ATNState.INVALID_TYPE);
            continue;
          }
          const stateType = s2.constructor.stateType;
          if (s2 instanceof DecisionState && s2.nonGreedy) {
            this.nonGreedyStates.push(s2.stateNumber);
          }
          if (s2 instanceof RuleStartState && s2.isLeftRecursiveRule) {
            this.precedenceStates.push(s2.stateNumber);
          }
          this.data.push(stateType);
          this.data.push(s2.ruleIndex);
          if (s2.constructor.stateType === ATNState.LOOP_END) {
            this.data.push(s2.loopBackState.stateNumber);
          } else {
            if (s2 instanceof BlockStartState) {
              this.data.push(s2.endState.stateNumber);
            }
          }
          if (s2.constructor.stateType !== ATNState.RULE_STOP) {
            edgeCount += s2.transitions.length;
          }
          for (const t2 of s2.transitions) {
            const edgeType = t2.transitionType;
            if (edgeType === Transition.SET || edgeType === Transition.NOT_SET) {
              const st2 = t2;
              this.sets.set(st2.set, true);
            }
          }
        }
        return edgeCount;
      }
      case 2: {
        const [edgeCount, setIndices] = args;
        this.data.push(edgeCount);
        for (const s2 of this.atn.states) {
          if (s2 === null) {
            continue;
          }
          if (s2.constructor.stateType === ATNState.RULE_STOP) {
            continue;
          }
          for (const t2 of s2.transitions) {
            if (this.atn.states[t2.target.stateNumber] === null) {
              throw new Error("Cannot serialize a transition to a removed state.");
            }
            const src = s2.stateNumber;
            let trg = t2.target.stateNumber;
            const edgeType = t2.transitionType;
            let arg1 = 0;
            let arg2 = 0;
            let arg3 = 0;
            switch (edgeType) {
              case Transition.RULE: {
                trg = t2.followState.stateNumber;
                arg1 = t2.target.stateNumber;
                arg2 = t2.ruleIndex;
                arg3 = t2.precedence;
                break;
              }
              case Transition.PRECEDENCE: {
                const ppt = t2;
                arg1 = ppt.precedence;
                break;
              }
              case Transition.PREDICATE: {
                const pt2 = t2;
                arg1 = pt2.ruleIndex;
                arg2 = pt2.predIndex;
                arg3 = pt2.isCtxDependent ? 1 : 0;
                break;
              }
              case Transition.RANGE: {
                arg1 = t2.start;
                arg2 = t2.stop;
                if (arg1 === Token.EOF) {
                  arg1 = 0;
                  arg3 = 1;
                }
                break;
              }
              case Transition.ATOM: {
                arg1 = t2.labelValue;
                if (arg1 === Token.EOF) {
                  arg1 = 0;
                  arg3 = 1;
                }
                break;
              }
              case Transition.ACTION: {
                const at2 = t2;
                arg1 = at2.ruleIndex;
                arg2 = at2.actionIndex;
                arg3 = at2.isCtxDependent ? 1 : 0;
                break;
              }
              case Transition.SET: {
                arg1 = setIndices.get(t2.set);
                break;
              }
              case Transition.NOT_SET: {
                arg1 = setIndices.get(t2.set);
                break;
              }
              case Transition.WILDCARD: {
                break;
              }
            }
            this.data.push(src);
            this.data.push(trg);
            this.data.push(edgeType);
            this.data.push(arg1);
            this.data.push(arg2);
            this.data.push(arg3);
          }
        }
        break;
      }
      default: {
        throw new Error("Invalid number of arguments");
      }
    }
  }
  addSets() {
    _ka.serializeSets(this.data, [...this.sets.keys()]);
    const setIndices = new HashMap();
    let setIndex = 0;
    for (const s2 of this.sets.keys()) {
      setIndices.set(s2, setIndex++);
    }
    return setIndices;
  }
  addModeStartStates() {
    const modeCount = this.atn.modeToStartState.length;
    this.data.push(modeCount);
    if (modeCount > 0) {
      for (const modeStartState of this.atn.modeToStartState) {
        this.data.push(modeStartState.stateNumber);
      }
    }
  }
  addRuleStatesAndLexerTokenTypes() {
    const ruleCount = this.atn.ruleToStartState.length;
    this.data.push(ruleCount);
    for (let r3 = 0; r3 < ruleCount; r3++) {
      const ruleStartState = this.atn.ruleToStartState[r3];
      this.data.push(ruleStartState.stateNumber);
      if (this.atn.grammarType === ATN.LEXER) {
        this.data.push(this.atn.ruleToTokenType[r3]);
      }
    }
  }
  addPrecedenceStates() {
    this.data.push(this.precedenceStates.length);
    for (const state of this.precedenceStates) {
      this.data.push(state);
    }
  }
  addNonGreedyStates() {
    this.data.push(this.nonGreedyStates.length);
    for (const state of this.nonGreedyStates) {
      this.data.push(state);
    }
  }
}, __name(_ka, "ATNSerializer"), _ka;
var DFAState = (_la = class {
  constructor(configs) {
    __publicField(this, "stateNumber", -1);
    __publicField(this, "configs");
    /**
     * `edges[symbol]` points to target of symbol. Shift up by 1 so (-1) {@link Token.EOF} maps to `edges[0]`.
     */
    __publicField(this, "edges", []);
    __publicField(this, "isAcceptState", false);
    /**
     * If accept state, what ttype do we match or alt do we predict? This is set to {@link ATN.INVALID_ALT_NUMBER}
     * when {@link predicates} `!= null` or {@link requiresFullContext}.
     */
    __publicField(this, "prediction", -1);
    __publicField(this, "lexerActionExecutor", null);
    /**
     * Indicates that this state was created during SLL prediction that discovered a conflict between the configurations
     * in the state. Future {@link ParserATNSimulator.execATN} invocations immediately jumped doing
     * full context prediction if this field is true.
     */
    __publicField(this, "requiresFullContext", false);
    /**
     * During SLL parsing, this is a list of predicates associated with the ATN configurations of the DFA state.
     * When we have predicates, {@link requiresFullContext} is `false` since full context prediction evaluates
     * predicates on-the-fly. If this is not null, then {@link prediction} is `ATN.INVALID_ALT_NUMBER`.
     *
     * We only use these for non-{@link #requiresFullContext} but conflicting states. That
     * means we know from the context (it's $ or we don't dip into outer
     * context) that it's an ambiguity not a conflict.
     *
     * This list is computed by {@link ParserATNSimulator#predicateDFAState}.
     */
    __publicField(this, "predicates", null);
    if (configs) {
      this.configs = configs;
    }
  }
  static fromState(stateNumber) {
    const result = new _la();
    result.stateNumber = stateNumber;
    return result;
  }
  static fromConfigs(configs) {
    return new _la(configs);
  }
  static hashCode(state) {
    return state.configs.hashCode();
  }
  /**
   * Two {@link DFAState} instances are equal if their ATN configuration sets
   * are the same. This method is used to see if a state already exists.
   *
   * Because the number of alternatives and number of ATN configurations are
   * finite, there is a finite number of DFA states that can be processed.
   * This is necessary to show that the algorithm terminates.
   *
   * Cannot test the DFA state numbers here because in
   * {@link ParserATNSimulator#addDFAState} we need to know if any other state
   * exists that has this exact set of ATN configurations. The
   * {@link #stateNumber} is irrelevant.
   *
   * @param a The first {@link DFAState}.
   * @param b The second {@link DFAState}.
   *
   * @returns `true` if the two states are equal, otherwise `false`.
   */
  static equals(a2, b2) {
    return a2.configs.equals(b2.configs);
  }
  /**
   * @returns the set of all alts mentioned by all ATN configurations in this DFA state.
   */
  getAltSet() {
    const alts = /* @__PURE__ */ new Set();
    for (const config of this.configs) {
      alts.add(config.alt);
    }
    if (alts.size === 0) {
      return null;
    }
    return alts;
  }
  toString() {
    let buf = "";
    buf += this.stateNumber;
    buf += ":";
    buf += this.configs ? this.configs.toString() : "";
    if (this.isAcceptState) {
      buf += "=>";
      if (this.predicates) {
        buf += arrayToString(this.predicates);
      } else {
        buf += this.prediction;
      }
    }
    return buf.toString();
  }
}, __name(_la, "DFAState"), _la);
var ATNSimulator = (_ma = class {
  constructor(atn, sharedContextCache) {
    __publicField(this, "atn");
    /**
     * The context cache maps all PredictionContext objects that are ==
     * to a single cached copy. This cache is shared across all contexts
     * in all ATNConfigs in all DFA states.  We rebuild each ATNConfigSet
     * to use only cached nodes/graphs in addDFAState(). We don't want to
     * fill this during closure() since there are lots of contexts that
     * pop up but are not used ever again. It also greatly slows down closure().
     *
     * This cache makes a huge difference in memory and a little bit in speed.
     * For the Java grammar on java.*, it dropped the memory requirements
     * at the end from 25M to 16M. We don't store any of the full context
     * graphs in the DFA because they are limited to local context only,
     * but apparently there's a lot of repetition there as well. We optimize
     * the config contexts before storing the config set in the DFA states
     * by literally rebuilding them with cached subgraphs only.
     *
     * I tried a cache for use during closure operations, that was
     * whacked after each adaptivePredict(). It cost a little bit
     * more time I think and doesn't save on the overall footprint
     * so it's not worth the complexity.
     */
    __publicField(this, "sharedContextCache");
    this.atn = atn;
    this.sharedContextCache = sharedContextCache;
    return this;
  }
  getCachedContext(context) {
    if (!this.sharedContextCache) {
      return context;
    }
    const visited = new HashMap(ObjectEqualityComparator.instance);
    return getCachedPredictionContext(context, this.sharedContextCache, visited);
  }
}, __name(_ma, "ATNSimulator"), /** Must distinguish between missing edge and edge we know leads nowhere */
__publicField(_ma, "ERROR", DFAState.fromState(2147483647)), _ma);
_na = class {
  /** @returns new {@link AtomTransition}     */
  static createWithCodePoint(target, codePoint) {
    return _na.createWithCodePointRange(target, codePoint, codePoint);
  }
  /** @returns new {@link AtomTransition} if range represents one atom else {@link SetTransition}. */
  static createWithCodePointRange(target, codePointFrom, codePointTo) {
    return codePointFrom === codePointTo ? new AtomTransition(target, codePointFrom) : new RangeTransition(target, codePointFrom, codePointTo);
  }
}, __name(_na, "CodePointTransitions"), _na;
var DecisionInfo = (_oa = class {
  /**
   * Constructs a new instance of the {@link DecisionInfo} class to contain
   * statistics for a particular decision.
   *
   * @param decision The decision number
   */
  constructor(decision) {
    /**
     * The decision number, which is an index into {@link ATN.decisionToState}.
     */
    __publicField(this, "decision", 0);
    /**
     * The total number of times {@link ParserATNSimulator.adaptivePredict} was
     * invoked for this decision.
     */
    __publicField(this, "invocations", 0);
    /**
     * The total time spent in {@link ParserATNSimulator.adaptivePredict} for
     * this decision, in nanoseconds.
     *
     * The value of this field contains the sum of differential results obtained
     * by {@link process.hrtime()}, and is not adjusted to compensate for JIT
     * and/or garbage collection overhead. For best accuracy, use a modern Node.js
     * version that provides precise results from {@link process.hrtime()}, and
     * perform profiling in a separate process which is warmed up by parsing the
     * input prior to profiling.
     */
    __publicField(this, "timeInPrediction", 0);
    /**
     * The sum of the lookahead required for SLL prediction for this decision.
     * Note that SLL prediction is used before LL prediction for performance
     * reasons even when {@link PredictionMode.LL} or
     * {@link PredictionMode.LL_EXACT_AMBIG_DETECTION} is used.
     */
    __publicField(this, "sllTotalLook", 0);
    /**
     * Gets the minimum lookahead required for any single SLL prediction to
     * complete for this decision, by reaching a unique prediction, reaching an
     * SLL conflict state, or encountering a syntax error.
     */
    __publicField(this, "sllMinLook", 0);
    /**
     * Gets the maximum lookahead required for any single SLL prediction to
     * complete for this decision, by reaching a unique prediction, reaching an
     * SLL conflict state, or encountering a syntax error.
     */
    __publicField(this, "sllMaxLook", 0);
    /**
     * Gets the {@link LookaheadEventInfo} associated with the event where the
     * {@link sllMaxLook} value was set.
     */
    __publicField(this, "sllMaxLookEvent");
    /**
     * The sum of the lookahead required for LL prediction for this decision.
     * Note that LL prediction is only used when SLL prediction reaches a
     * conflict state.
     */
    __publicField(this, "llTotalLook", 0);
    /**
     * Gets the minimum lookahead required for any single LL prediction to
     * complete for this decision. An LL prediction completes when the algorithm
     * reaches a unique prediction, a conflict state (for
     * {@link PredictionMode.LL}, an ambiguity state (for
     * {@link PredictionMode.LL_EXACT_AMBIG_DETECTION}, or a syntax error.
     */
    __publicField(this, "llMinLook", 0);
    /**
     * Gets the maximum lookahead required for any single LL prediction to
     * complete for this decision. An LL prediction completes when the algorithm
     * reaches a unique prediction, a conflict state (for
     * {@link PredictionMode.LL}, an ambiguity state (for
     * {@link PredictionMode.LL_EXACT_AMBIG_DETECTION}, or a syntax error.
     */
    __publicField(this, "llMaxLook", 0);
    /**
     * Gets the {@link LookaheadEventInfo} associated with the event where the
     * {@link llMaxLook} value was set.
     */
    __publicField(this, "llMaxLookEvent");
    /**
     * A collection of {@link ContextSensitivityInfo} instances describing the
     * context sensitivities encountered during LL prediction for this decision.
     */
    __publicField(this, "contextSensitivities");
    /**
     * A collection of {@link DecisionEventInfo} instances describing the parse errors
     * identified during calls to {@link ParserATNSimulator.adaptivePredict} for
     * this decision.
     */
    __publicField(this, "errors");
    /**
     * A collection of {@link AmbiguityInfo} instances describing the
     * ambiguities encountered during LL prediction for this decision.
     */
    __publicField(this, "ambiguities");
    /**
     * A collection of {@link PredicateEvalInfo} instances describing the
     * results of evaluating individual predicates during prediction for this
     * decision.
     */
    __publicField(this, "predicateEvals");
    /**
     * The total number of ATN transitions required during SLL prediction for
     * this decision. An ATN transition is determined by the number of times the
     * DFA does not contain an edge that is required for prediction, resulting
     * in on-the-fly computation of that edge.
    /**
     * If DFA caching of SLL transitions is employed by the implementation, ATN
     * computation may cache the computed edge for efficient lookup during
     * future parsing of this decision. Otherwise, the SLL parsing algorithm
     * will use ATN transitions exclusively.
     *
     * @see sllDFATransitions
     * @see ParserATNSimulator.computeTargetState
     * @see LexerATNSimulator.computeTargetState
     */
    __publicField(this, "sllATNTransitions", 0);
    /**
     * The total number of DFA transitions required during SLL prediction for
     * this decision.
     *
     * If the ATN simulator implementation does not use DFA caching for SLL
     * transitions, this value will be 0.
     *
     * @see ParserATNSimulator.getExistingTargetState
     * @see LexerATNSimulator.getExistingTargetState
     */
    __publicField(this, "sllDFATransitions", 0);
    /**
     * Gets the total number of times SLL prediction completed in a conflict
     * state, resulting in fallback to LL prediction.
     *
     * Note that this value is not related to whether or not
     * {@link PredictionMode.SLL} may be used successfully with a particular
     * grammar. If the ambiguity resolution algorithm applied to the SLL
     * conflicts for this decision produce the same result as LL prediction for
     * this decision, {@link PredictionMode.SLL} would produce the same overall
     * parsing result as {@link PredictionMode.LL}.
     */
    __publicField(this, "llFallback", 0);
    /**
     * The total number of ATN transitions required during LL prediction for
     * this decision. An ATN transition is determined by the number of times the
     * DFA does not contain an edge that is required for prediction, resulting
     * in on-the-fly computation of that edge.
     *
     * If DFA caching of LL transitions is employed by the implementation, ATN
     * computation may cache the computed edge for efficient lookup during
     * future parsing of this decision. Otherwise, the LL parsing algorithm will
     * use ATN transitions exclusively.
     *
     * @see llDFATransitions
     * @see ParserATNSimulator.computeTargetState
     * @see LexerATNSimulator.computeTargetState
     */
    __publicField(this, "llATNTransitions", 0);
    /**
     * The total number of DFA transitions required during LL prediction for
     * this decision.
     *
     * If the ATN simulator implementation does not use DFA caching for LL
     * transitions, this value will be 0.
     *
     * @see ParserATNSimulator.getExistingTargetState
     * @see LexerATNSimulator.getExistingTargetState
     */
    __publicField(this, "llDFATransitions", 0);
    this.decision = decision;
    this.contextSensitivities = [];
    this.errors = [];
    this.ambiguities = [];
    this.predicateEvals = [];
  }
  toString() {
    return "{decision=" + this.decision + ", contextSensitivities=" + this.contextSensitivities.length + ", errors=" + this.errors.length + ", ambiguities=" + this.ambiguities.length + ", sllLookahead=" + this.sllTotalLook + ", sllATNTransitions=" + this.sllATNTransitions + ", sllDFATransitions=" + this.sllDFATransitions + ", llFallback=" + this.llFallback + ", llLookahead=" + this.llTotalLook + ", llATNTransitions=" + this.llATNTransitions + "}";
  }
}, __name(_oa, "DecisionInfo"), _oa);
var LexerATNConfig = (_pa = class extends ATNConfig {
  constructor(config, state, context, lexerActionExecutor) {
    super(config, state, context ?? config.context, context ? SemanticContext.NONE : config.semanticContext);
    /**
     * This is the backing field for {@link #getLexerActionExecutor}.
     */
    __publicField(this, "lexerActionExecutor");
    __publicField(this, "passedThroughNonGreedyDecision");
    this.lexerActionExecutor = context ? lexerActionExecutor : config.lexerActionExecutor ?? null;
    this.passedThroughNonGreedyDecision = _pa.checkNonGreedyDecision(config, this.state);
    return this;
  }
  static createWithExecutor(config, state, lexerActionExecutor) {
    return new _pa(config, state, config.context, lexerActionExecutor);
  }
  static createWithConfig(state, config, context) {
    return new _pa(config, state, context ?? null, config.lexerActionExecutor);
  }
  static createWithContext(state, alt, context) {
    return new _pa({ alt }, state, context, null);
  }
  static checkNonGreedyDecision(source, target) {
    return source.passedThroughNonGreedyDecision || "nonGreedy" in target && target.nonGreedy;
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hashCode = MurmurHash.initialize(7);
      hashCode = MurmurHash.update(hashCode, this.state.stateNumber);
      hashCode = MurmurHash.update(hashCode, this.alt);
      hashCode = MurmurHash.updateFromComparable(hashCode, this.context);
      hashCode = MurmurHash.updateFromComparable(hashCode, this.semanticContext);
      hashCode = MurmurHash.update(hashCode, this.passedThroughNonGreedyDecision ? 1 : 0);
      hashCode = MurmurHash.updateFromComparable(hashCode, this.lexerActionExecutor);
      hashCode = MurmurHash.finish(hashCode, 6);
      this.cachedHashCode = hashCode;
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    return this.passedThroughNonGreedyDecision === other.passedThroughNonGreedyDecision && (this.lexerActionExecutor && other.lexerActionExecutor ? this.lexerActionExecutor.equals(other.lexerActionExecutor) : !other.lexerActionExecutor) && super.equals(other);
  }
}, __name(_pa, "LexerATNConfig"), _pa);
var BaseErrorListener = (_qa = class {
  syntaxError(recognizer, offendingSymbol, line, column, msg, e10) {
  }
  reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
  }
  reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, configs) {
  }
  reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, configs) {
  }
}, __name(_qa, "BaseErrorListener"), _qa);
var ConsoleErrorListener = (_ra = class extends BaseErrorListener {
  syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, _e3) {
    console.error("line " + line + ":" + charPositionInLine + " " + msg);
  }
}, __name(_ra, "ConsoleErrorListener"), /**
 * Provides a default instance of {@link ConsoleErrorListener}.
 */
__publicField(_ra, "instance", new _ra()), _ra);
var ProxyErrorListener = (_sa = class extends BaseErrorListener {
  constructor(delegates) {
    super();
    this.delegates = delegates;
    return this;
  }
  syntaxError(recognizer, offendingSymbol, line, column, msg, e10) {
    this.delegates.forEach((d2) => {
      d2.syntaxError(recognizer, offendingSymbol, line, column, msg, e10);
    });
  }
  reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
    this.delegates.forEach((d2) => {
      d2.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
    });
  }
  reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, configs) {
    this.delegates.forEach((d2) => {
      d2.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, configs);
    });
  }
  reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, configs) {
    this.delegates.forEach((d2) => {
      d2.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, configs);
    });
  }
}, __name(_sa, "ProxyErrorListener"), _sa);
var Recognizer = (_ta = class {
  constructor() {
    __publicField(this, "interpreter");
    __publicField(this, "listeners", [ConsoleErrorListener.instance]);
    __publicField(this, "stateNumber", -1);
  }
  checkVersion(toolVersion) {
    const runtimeVersion = "4.13.1";
    if (runtimeVersion !== toolVersion) {
      console.error("ANTLR runtime and generated code versions disagree: " + runtimeVersion + "!=" + toolVersion);
    }
  }
  addErrorListener(listener) {
    this.listeners.push(listener);
  }
  removeErrorListeners() {
    this.listeners = [];
  }
  removeErrorListener(listener) {
    for (let i2 = 0; i2 < this.listeners.length; i2++) {
      if (this.listeners[i2] === listener) {
        this.listeners.splice(i2, 1);
        return;
      }
    }
  }
  getErrorListeners() {
    return this.listeners;
  }
  getTokenTypeMap() {
    const vocabulary = this.vocabulary;
    let result = _ta.tokenTypeMapCache.get(vocabulary);
    if (!result) {
      result = /* @__PURE__ */ new Map();
      for (let i2 = 0; i2 <= this.atn.maxTokenType; i2++) {
        const literalName = vocabulary.getLiteralName(i2);
        if (literalName) {
          result.set(literalName, i2);
        }
        const symbolicName = vocabulary.getSymbolicName(i2);
        if (symbolicName) {
          result.set(symbolicName, i2);
        }
      }
      result.set("EOF", Token.EOF);
      _ta.tokenTypeMapCache.set(vocabulary, result);
    }
    return result;
  }
  /**
   * Get a map from rule names to rule indexes.
   * Used for XPath and tree pattern compilation.
   */
  getRuleIndexMap() {
    const ruleNames = this.ruleNames;
    let result = _ta.ruleIndexMapCache.get(ruleNames);
    if (!result) {
      result = /* @__PURE__ */ new Map();
      ruleNames.forEach((ruleName, idx) => {
        return result.set(ruleName, idx);
      });
      _ta.ruleIndexMapCache.set(ruleNames, result);
    }
    return result;
  }
  getTokenType(tokenName) {
    const ttype = this.getTokenTypeMap().get(tokenName);
    if (ttype) {
      return ttype;
    }
    return Token.INVALID_TYPE;
  }
  /** What is the error header, normally line/character position information? */
  getErrorHeader(e10) {
    var _a3, _b3;
    const line = (_a3 = e10.offendingToken) == null ? void 0 : _a3.line;
    const column = (_b3 = e10.offendingToken) == null ? void 0 : _b3.column;
    return "line " + line + ":" + column;
  }
  get errorListenerDispatch() {
    return new ProxyErrorListener(this.listeners);
  }
  /**
   * subclass needs to override these if there are semantic predicates or actions
   * that the ATN interp needs to execute
   */
  sempred(_localctx, _ruleIndex2, _actionIndex) {
    return true;
  }
  // TODO: make localCtx an optional parameter, not optional null.
  precpred(_localctx, _precedence) {
    return true;
  }
  action(_localctx, _ruleIndex2, _actionIndex) {
  }
  get atn() {
    return this.interpreter.atn;
  }
  get state() {
    return this.stateNumber;
  }
  set state(state) {
    this.stateNumber = state;
  }
  getParseInfo() {
    return void 0;
  }
}, __name(_ta, "Recognizer"), __publicField(_ta, "EOF", -1), __publicField(_ta, "tokenTypeMapCache", /* @__PURE__ */ new Map()), __publicField(_ta, "ruleIndexMapCache", /* @__PURE__ */ new Map()), _ta);
var CommonTokenFactory = (_ua = class {
  constructor(copyText) {
    /**
     * Indicates whether {@link CommonToken.setText} should be called after
     * constructing tokens to explicitly set the text. This is useful for cases
     * where the input stream might not be able to provide arbitrary substrings
     * of text from the input after the lexer creates a token (e.g. the
     * implementation of {@link CharStream.getText} in
     * {@link UnbufferedCharStream} throws an
     * {@link UnsupportedOperationException}). Explicitly setting the token text
     * allows {@link Token.getText} to be called at any time regardless of the
     * input stream implementation.
     *
     *
     * The default value is `false` to avoid the performance and memory
     * overhead of copying text for every token unless explicitly requested.
     */
    __publicField(this, "copyText", false);
    this.copyText = copyText ?? false;
  }
  create(source, type4, text, channel, start, stop, line, column) {
    const t2 = CommonToken.fromSource(source, type4, channel, start, stop);
    t2.line = line;
    t2.column = column;
    if (text) {
      t2.text = text;
    } else if (this.copyText && source[1] !== null) {
      t2.text = source[1].getTextFromRange(start, stop);
    }
    return t2;
  }
}, __name(_ua, "CommonTokenFactory"), /**
 * The default {@link CommonTokenFactory} instance.
 *
 *
 * This token factory does not explicitly copy token text when constructing
 * tokens.
 */
__publicField(_ua, "DEFAULT", new _ua()), _ua);
var RecognitionException = (_va = class extends Error {
  constructor(params) {
    super(params.message);
    __publicField(this, "ctx");
    /**
     * The current {@link Token} when an error occurred. Since not all streams
     * support accessing symbols by index, we have to track the {@link Token}
     * instance itself
     */
    __publicField(this, "offendingToken", null);
    /**
     * Get the ATN state number the parser was in at the time the error
     * occurred. For {@link NoViableAltException} and
     * {@link LexerNoViableAltException} exceptions, this is the
     * {@link DecisionState} number. For others, it is the state whose outgoing
     * edge we couldn't match.
     */
    __publicField(this, "offendingState", -1);
    __publicField(this, "recognizer");
    __publicField(this, "input");
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, _va);
    }
    this.message = params.message;
    this.recognizer = params.recognizer;
    this.input = params.input;
    this.ctx = params.ctx;
    if (this.recognizer !== null) {
      this.offendingState = this.recognizer.state;
    }
  }
  /**
   * Gets the set of input symbols which could potentially follow the
   * previously matched symbol at the time this exception was thrown.
   *
   * If the set of expected tokens is not known and could not be computed,
   * this method returns `null`.
   *
   * @returns The set of token types that could potentially follow the current
   * state in the ATN, or `null` if the information is not available.
   */
  getExpectedTokens() {
    if (this.recognizer !== null && this.ctx !== null) {
      return this.recognizer.atn.getExpectedTokens(this.offendingState, this.ctx);
    } else {
      return null;
    }
  }
  // If the state number is not known, this method returns -1.
  toString() {
    return this.message;
  }
}, __name(_va, "RecognitionException"), _va);
var LexerNoViableAltException = (_wa = class extends RecognitionException {
  constructor(lexer, input, startIndex, deadEndConfigs) {
    super({ message: "", recognizer: lexer, input, ctx: null });
    __publicField(this, "startIndex");
    __publicField(this, "deadEndConfigs");
    this.startIndex = startIndex;
    this.deadEndConfigs = deadEndConfigs;
  }
  toString() {
    let symbol = "";
    if (this.input && this.startIndex >= 0 && this.startIndex < this.input.size) {
      symbol = this.input.getTextFromRange(this.startIndex, this.startIndex);
    }
    return `LexerNoViableAltException(${symbol})`;
  }
}, __name(_wa, "LexerNoViableAltException"), _wa);
var Lexer = (_xa = class extends Recognizer {
  constructor(input, options) {
    super();
    __publicField(this, "options", {
      minDFAEdge: 0,
      maxDFAEdge: 256,
      minCodePoint: 0,
      maxCodePoint: 1114111
    });
    /**
     * What character index in the stream did the current token start at?
     *  Needed, for example, to get the text for current token.  Set at
     *  the start of nextToken.
     */
    __publicField(this, "tokenStartCharIndex", -1);
    /** The channel number for the current token */
    __publicField(this, "channel", 0);
    /** The token type for the current token */
    __publicField(this, "type", 0);
    __publicField(this, "mode", _xa.DEFAULT_MODE);
    /** The start column of the current token (the one that was last read by `nextToken`). */
    __publicField(this, "currentTokenColumn", 0);
    /**
     * The line on which the first character of the current token (the one that was last read by `nextToken`) resides.
     */
    __publicField(this, "currentTokenStartLine", 0);
    __publicField(this, "input");
    /**
     * The goal of all lexer rules/methods is to create a token object.
     *  This is an instance variable as multiple rules may collaborate to
     *  create a single token.  nextToken will return this object after
     *  matching lexer rule(s).  If you subclass to allow multiple token
     *  emissions, then set this to the last token to be matched or
     *  something non-null so that the auto token emit mechanism will not
     *  emit another token.
     */
    __publicField(this, "token", null);
    /**
     * Once we see EOF on char stream, next token will be EOF.
     * If you have DONE : EOF ; then you see DONE EOF.
     */
    __publicField(this, "hitEOF", false);
    __publicField(this, "factory");
    __privateAdd(this, _modeStack, []);
    /**
     * The text to be used for the next token. If this is not null, then the text
     * for the next token is fixed and is not subject to change in the normal
     * workflow of the lexer.
     */
    __privateAdd(this, _text2);
    this.options = { ...this.options, ...options };
    this.input = input;
    this.factory = CommonTokenFactory.DEFAULT;
  }
  reset(seekBack = true) {
    if (seekBack) {
      this.input.seek(0);
    }
    this.token = null;
    this.type = Token.INVALID_TYPE;
    this.channel = Token.DEFAULT_CHANNEL;
    this.tokenStartCharIndex = -1;
    this.currentTokenColumn = -1;
    this.currentTokenStartLine = -1;
    __privateSet(this, _text2, void 0);
    this.hitEOF = false;
    this.mode = _xa.DEFAULT_MODE;
    __privateSet(this, _modeStack, []);
    this.interpreter.reset();
  }
  /** @returns a token from this source; i.e., match a token on the char stream. */
  nextToken() {
    if (this.input === null) {
      throw new Error("nextToken requires a non-null input stream.");
    }
    const tokenStartMarker = this.input.mark();
    try {
      while (true) {
        if (this.hitEOF) {
          this.emitEOF();
          return this.token;
        }
        this.token = null;
        this.channel = Token.DEFAULT_CHANNEL;
        this.tokenStartCharIndex = this.input.index;
        this.currentTokenColumn = this.interpreter.column;
        this.currentTokenStartLine = this.interpreter.line;
        __privateSet(this, _text2, void 0);
        let continueOuter = false;
        while (true) {
          this.type = Token.INVALID_TYPE;
          let ttype = _xa.SKIP;
          try {
            ttype = this.interpreter.match(this.input, this.mode);
          } catch (e10) {
            if (e10 instanceof LexerNoViableAltException) {
              this.notifyListeners(e10);
              this.recover(e10);
            } else {
              throw e10;
            }
          }
          if (this.input.LA(1) === Token.EOF) {
            this.hitEOF = true;
          }
          if (this.type === Token.INVALID_TYPE) {
            this.type = ttype;
          }
          if (this.type === _xa.SKIP) {
            continueOuter = true;
            break;
          }
          if (this.type !== _xa.MORE) {
            break;
          }
        }
        if (continueOuter) {
          continue;
        }
        if (this.token === null) {
          this.emit();
        }
        return this.token;
      }
    } finally {
      this.input.release(tokenStartMarker);
    }
  }
  /**
   * Instruct the lexer to skip creating a token for current lexer rule
   * and look for another token. nextToken() knows to keep looking when
   * a lexer rule finishes with token set to SKIP_TOKEN. Recall that
   * if token==null at end of any token rule, it creates one for you
   * and emits it.
   */
  skip() {
    this.type = _xa.SKIP;
  }
  more() {
    this.type = _xa.MORE;
  }
  pushMode(m2) {
    __privateGet(this, _modeStack).push(this.mode);
    this.mode = m2;
  }
  popMode() {
    if (__privateGet(this, _modeStack).length === 0) {
      throw new Error("Empty Stack");
    }
    this.mode = __privateGet(this, _modeStack).pop();
    return this.mode;
  }
  get modeStack() {
    return __privateGet(this, _modeStack);
  }
  /**
   * By default does not support multiple emits per nextToken invocation
   * for efficiency reasons. Subclass and override this method, nextToken,
   * and getToken (to push tokens into a list and pull from that list
   * rather than a single variable as this implementation does).
   */
  emitToken(token) {
    this.token = token;
  }
  /**
   * The standard method called to automatically emit a token at the
   * outermost lexical rule. The token object should point into the
   * char buffer start..stop. If there is a text override in 'text',
   * use that to set the token's text. Override this method to emit
   * custom Token objects or provide a new factory.
   */
  emit() {
    const t2 = this.factory.create(
      [this, this.input],
      this.type,
      __privateGet(this, _text2),
      this.channel,
      this.tokenStartCharIndex,
      this.getCharIndex() - 1,
      this.currentTokenStartLine,
      this.currentTokenColumn
    );
    this.emitToken(t2);
    return t2;
  }
  emitEOF() {
    const eof = this.factory.create(
      [this, this.input],
      Token.EOF,
      void 0,
      Token.DEFAULT_CHANNEL,
      this.input.index,
      this.input.index - 1,
      this.line,
      this.column
    );
    this.emitToken(eof);
    return eof;
  }
  /** What is the index of the current character of lookahead? */
  getCharIndex() {
    return this.input.index;
  }
  /**
   * Return a list of all Token objects in input char stream.
   * Forces load of all tokens. Does not include EOF token.
   */
  getAllTokens() {
    const tokens = [];
    let t2 = this.nextToken();
    while (t2.type !== Token.EOF) {
      tokens.push(t2);
      t2 = this.nextToken();
    }
    return tokens;
  }
  notifyListeners(e10) {
    const start = this.tokenStartCharIndex;
    const stop = this.input.index;
    const text = this.input.getTextFromRange(start, stop);
    const msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
    this.errorListenerDispatch.syntaxError(this, null, this.currentTokenStartLine, this.currentTokenColumn, msg, e10);
  }
  getErrorDisplay(s2) {
    return s2;
  }
  getErrorDisplayForChar(c3) {
    if (c3.charCodeAt(0) === Token.EOF) {
      return "<EOF>";
    }
    if (c3 === "\n") {
      return "\\n";
    }
    if (c3 === "	") {
      return "\\t";
    }
    if (c3 === "\r") {
      return "\\r";
    }
    return c3;
  }
  getCharErrorDisplay(c3) {
    return "'" + this.getErrorDisplayForChar(c3) + "'";
  }
  /**
   * Lexers can normally match any char in it's vocabulary after matching
   * a token, so do the easy thing and just kill a character and hope
   * it all works out. You can instead use the rule invocation stack
   * to do sophisticated error recovery if you are in a fragment rule.
   */
  recover(re2) {
    if (this.input.LA(1) !== Token.EOF) {
      if (re2 instanceof LexerNoViableAltException) {
        this.interpreter.consume(this.input);
      } else {
        this.input.consume();
      }
    }
  }
  get inputStream() {
    return this.input;
  }
  set inputStream(input) {
    this.reset(false);
    this.input = input;
  }
  set tokenFactory(factory) {
    this.factory = factory;
  }
  get tokenFactory() {
    return this.factory;
  }
  get sourceName() {
    return this.input.getSourceName();
  }
  get line() {
    return this.interpreter.line;
  }
  set line(line) {
    this.interpreter.line = line;
  }
  get column() {
    return this.interpreter.column;
  }
  set column(column) {
    this.interpreter.column = column;
  }
  get text() {
    if (__privateGet(this, _text2)) {
      return __privateGet(this, _text2);
    } else {
      return this.interpreter.getText(this.input);
    }
  }
  set text(text) {
    __privateSet(this, _text2, text);
  }
}, _modeStack = new WeakMap(), _text2 = new WeakMap(), __name(_xa, "Lexer"), __publicField(_xa, "DEFAULT_MODE", 0), __publicField(_xa, "MORE", -2), __publicField(_xa, "SKIP", -3), __publicField(_xa, "DEFAULT_TOKEN_CHANNEL", Token.DEFAULT_CHANNEL), __publicField(_xa, "HIDDEN", Token.HIDDEN_CHANNEL), _xa);
var DFASerializer = (_ya = class {
  constructor(dfa, vocabulary) {
    __publicField(this, "dfa");
    __publicField(this, "vocabulary");
    this.dfa = dfa;
    this.vocabulary = vocabulary;
  }
  toString() {
    if (!this.dfa.s0) {
      return "";
    }
    let buf = "";
    const states = this.dfa.getStates();
    for (const s2 of states) {
      let n2 = 0;
      n2 = s2.edges.length;
      for (let i2 = 0; i2 < n2; i2++) {
        const t2 = s2.edges[i2];
        if (t2 && t2.stateNumber !== 2147483647) {
          buf += this.getStateString(s2);
          const label = this.getEdgeLabel(i2);
          buf += "-";
          buf += label;
          buf += "->";
          buf += this.getStateString(t2);
          buf += "\n";
        }
      }
    }
    return buf;
  }
  getEdgeLabel(i2) {
    const name = this.vocabulary.getDisplayName(i2 - 1);
    return `${name}`;
  }
  getStateString(s2) {
    const n2 = s2.stateNumber;
    const baseStateStr = (s2.isAcceptState ? ":" : "") + "s" + n2 + (s2.requiresFullContext ? "^" : "");
    if (s2.isAcceptState) {
      if (s2.predicates !== null) {
        return `${baseStateStr}=>${s2.predicates.toString()}`;
      }
      return `${baseStateStr}=>${s2.prediction}`;
    } else {
      return `${baseStateStr}`;
    }
  }
}, __name(_ya, "DFASerializer"), _ya);
var LexerDFASerializer = (_za = class extends DFASerializer {
  constructor(dfa) {
    super(dfa, Vocabulary.EMPTY_VOCABULARY);
    __publicField(this, "getEdgeLabel", /* @__PURE__ */ __name((i2) => {
      return "'" + String.fromCharCode(i2) + "'";
    }, "getEdgeLabel"));
  }
}, __name(_za, "LexerDFASerializer"), _za);
var DFA = (_Aa = Symbol.iterator, _Ba = class {
  constructor(atnStartState, decision) {
    __publicField(this, "s0");
    __publicField(this, "decision");
    /** From which ATN state did we create this DFA? */
    __publicField(this, "atnStartState");
    /**
     * Gets whether this DFA is a precedence DFA. Precedence DFAs use a special
     * start state {@link #s0} which is not stored in {@link #states}. The
     * {@link DFAState#edges} array for this start state contains outgoing edges
     * supplying individual start states corresponding to specific precedence
     * values.
     *
     * @returns `true` if this is a precedence DFA; otherwise, `false`.
     */
    __publicField(this, "isPrecedenceDfa");
    /**
     * A mapping from an ATNConfigSet hash to a DFAState.
     * Used to quick look up the DFA state for a particular configuration set.
     */
    __publicField(this, "states", /* @__PURE__ */ new Map());
    __publicField(this, _Aa, () => {
      return this.states.values()[Symbol.iterator]();
    });
    /**
     * Get the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
      @returns The start state corresponding to the specified precedence, or
     * `null` if no start state exists for the specified precedence.
     *
     * @throws IllegalStateException if this is not a precedence DFA.
     * @see #isPrecedenceDfa
     */
    __publicField(this, "getPrecedenceStartState", /* @__PURE__ */ __name((precedence) => {
      if (!this.isPrecedenceDfa) {
        throw new Error(`Only precedence DFAs may contain a precedence start state.`);
      }
      if (!this.s0 || !this.s0.edges || precedence < 0 || precedence >= this.s0.edges.length) {
        return void 0;
      }
      return this.s0.edges[precedence];
    }, "getPrecedenceStartState"));
    /**
     * Set the start state for a specific precedence value.
     *
     * @param precedence The current precedence.
     * @param startState The start state corresponding to the specified precedence.
     */
    __publicField(this, "setPrecedenceStartState", /* @__PURE__ */ __name((precedence, startState) => {
      if (!this.isPrecedenceDfa) {
        throw new Error(`Only precedence DFAs may contain a precedence start state.`);
      }
      if (precedence < 0 || !this.s0) {
        return;
      }
      this.s0.edges[precedence] = startState;
    }, "setPrecedenceStartState"));
    this.atnStartState = atnStartState;
    this.decision = decision ?? 0;
    let precedenceDfa = false;
    if (atnStartState instanceof StarLoopEntryState) {
      if (atnStartState.precedenceRuleDecision) {
        precedenceDfa = true;
        this.s0 = DFAState.fromState(-1);
      }
    }
    this.isPrecedenceDfa = precedenceDfa;
  }
  /**
   * @returns a list of all states in this DFA, ordered by state number.
   */
  getStates() {
    const result = [...this.states.values()];
    result.sort((o1, o2) => {
      return o1.stateNumber - o2.stateNumber;
    });
    return result;
  }
  getState(state) {
    return this.states.get(state.configs.hashCode()) ?? null;
  }
  getStateForConfigs(configs) {
    return this.states.get(configs.hashCode()) ?? null;
  }
  addState(state) {
    const hash = state.configs.hashCode();
    if (this.states.has(hash)) {
      return;
    }
    this.states.set(hash, state);
    state.stateNumber = this.states.size - 1;
  }
  toString(vocabulary) {
    if (!vocabulary) {
      return this.toString(Vocabulary.EMPTY_VOCABULARY);
    }
    if (!this.s0) {
      return "";
    }
    const serializer = new DFASerializer(this, vocabulary);
    return serializer.toString() ?? "";
  }
  toLexerString() {
    if (!this.s0) {
      return "";
    }
    const serializer = new LexerDFASerializer(this);
    return serializer.toString() ?? "";
  }
  get length() {
    return this.states.size;
  }
}, __name(_Ba, "DFA"), _Ba);
var LexerIndexedCustomAction = (_Ca = class {
  constructor(offset, action) {
    __publicField(this, "offset");
    __publicField(this, "action");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", true);
    __publicField(this, "cachedHashCode");
    this.actionType = action.actionType;
    this.offset = offset;
    this.action = action;
  }
  /**
   * This method calls {@link execute} on the result of {@link getAction}
   * using the provided `lexer`.
   */
  execute(lexer) {
    this.action.execute(lexer);
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hash = MurmurHash.initialize();
      hash = MurmurHash.update(hash, this.offset);
      hash = MurmurHash.updateFromComparable(hash, this.action);
      this.cachedHashCode = MurmurHash.finish(hash, 2);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof _Ca)) {
      return false;
    }
    return this.offset === other.offset && this.action === other.action;
  }
}, __name(_Ca, "LexerIndexedCustomAction"), _Ca);
var LexerActionExecutor = (_Da = class {
  /**
   * Represents an executor for a sequence of lexer actions which traversed during
   * the matching operation of a lexer rule (token).
   *
   * The executor tracks position information for position-dependent lexer actions
   * efficiently, ensuring that actions appearing only at the end of the rule do
   * not cause bloating of the {@link DFA} created for the lexer.
   */
  constructor(lexerActions) {
    __publicField(this, "lexerActions");
    __publicField(this, "actionType");
    __publicField(this, "isPositionDependent", false);
    __publicField(this, "cachedHashCode");
    this.actionType = -1;
    this.lexerActions = lexerActions ?? [];
    return this;
  }
  /**
   * Creates a {@link LexerActionExecutor} which executes the actions for
   * the input `lexerActionExecutor` followed by a specified
   * `lexerAction`.
   *
   * @param lexerActionExecutor The executor for actions already traversed by
   * the lexer while matching a token within a particular
   * {@link LexerATNConfig}. If this is `null`, the method behaves as
   * though it were an empty executor.
   * @param lexerAction The lexer action to execute after the actions
   * specified in `lexerActionExecutor`.
   *
   * @returns {LexerActionExecutor} A {@link LexerActionExecutor} for executing the combine actions
   * of `lexerActionExecutor` and `lexerAction`.
   */
  static append(lexerActionExecutor, lexerAction) {
    if (lexerActionExecutor === null) {
      return new _Da([lexerAction]);
    }
    const lexerActions = lexerActionExecutor.lexerActions.concat([lexerAction]);
    return new _Da(lexerActions);
  }
  /**
   * Creates a {@link LexerActionExecutor} which encodes the current offset
   * for position-dependent lexer actions.
   *
   * Normally, when the executor encounters lexer actions where
   * {@link LexerAction//isPositionDependent} returns `true`, it calls
   * {@link IntStream.seek} on the input {@link CharStream} to set the input
   * position to the *end* of the current token. This behavior provides
   * for efficient DFA representation of lexer actions which appear at the end
   * of a lexer rule, even when the lexer rule matches a variable number of
   * characters.
   *
   * Prior to traversing a match transition in the ATN, the current offset
   * from the token start index is assigned to all position-dependent lexer
   * actions which have not already been assigned a fixed offset. By storing
   * the offsets relative to the token start index, the DFA representation of
   * lexer actions which appear in the middle of tokens remains efficient due
   * to sharing among tokens of the same length, regardless of their absolute
   * position in the input stream.
   *
   * If the current executor already has offsets assigned to all
   * position-dependent lexer actions, the method returns `this`.
   *
   * @param offset The current offset to assign to all position-dependent
   * lexer actions which do not already have offsets assigned.
   *
   * @returns {LexerActionExecutor} A {@link LexerActionExecutor} which stores input stream offsets
   * for all position-dependent lexer actions.
   */
  fixOffsetBeforeMatch(offset) {
    let updatedLexerActions = null;
    for (let i2 = 0; i2 < this.lexerActions.length; i2++) {
      if (this.lexerActions[i2].isPositionDependent && !(this.lexerActions[i2] instanceof LexerIndexedCustomAction)) {
        if (updatedLexerActions === null) {
          updatedLexerActions = this.lexerActions.concat([]);
        }
        updatedLexerActions[i2] = new LexerIndexedCustomAction(
          offset,
          this.lexerActions[i2]
        );
      }
    }
    if (updatedLexerActions === null) {
      return this;
    } else {
      return new _Da(updatedLexerActions);
    }
  }
  /**
   * Execute the actions encapsulated by this executor within the context of a
   * particular {@link Lexer}.
   *
   * This method calls {@link IntStream.seek} to set the position of the
   * `input` {@link CharStream} prior to calling
   * {@link LexerAction.execute} on a position-dependent action. Before the
   * method returns, the input position will be restored to the same position
   * it was in when the method was invoked.
   *
   * @param lexer The lexer instance.
   * @param input The input stream which is the source for the current token.
   * When this method is called, the current {@link IntStream.index} for
   * `input` should be the start of the following token, i.e. 1
   * character past the end of the current token.
   * @param startIndex The token start index. This value may be passed to
   * {@link IntStream.seek} to set the `input` position to the beginning
   * of the token.
   */
  execute(lexer, input, startIndex) {
    if (input === void 0 || startIndex === void 0) {
      return;
    }
    let requiresSeek = false;
    const stopIndex = input.index;
    try {
      for (const lexerAction of this.lexerActions) {
        let action = lexerAction;
        if (lexerAction instanceof LexerIndexedCustomAction) {
          const offset = lexerAction.offset;
          input.seek(startIndex + offset);
          action = lexerAction.action;
          requiresSeek = startIndex + offset !== stopIndex;
        } else if (lexerAction.isPositionDependent) {
          input.seek(stopIndex);
          requiresSeek = false;
        }
        action.execute(lexer);
      }
    } finally {
      if (requiresSeek) {
        input.seek(stopIndex);
      }
    }
  }
  hashCode() {
    if (this.cachedHashCode === void 0) {
      let hashCode = MurmurHash.initialize(7);
      for (const lexerAction of this.lexerActions) {
        hashCode = MurmurHash.update(hashCode, lexerAction.hashCode());
      }
      this.cachedHashCode = MurmurHash.finish(hashCode, this.lexerActions.length);
    }
    return this.cachedHashCode;
  }
  equals(other) {
    if (this === other) {
      return true;
    }
    if (this.cachedHashCode !== other.cachedHashCode) {
      return false;
    }
    if (this.lexerActions.length !== other.lexerActions.length) {
      return false;
    }
    return this.lexerActions.every((action, index2) => {
      return action.equals(other.lexerActions[index2]);
    });
  }
}, __name(_Da, "LexerActionExecutor"), _Da);
var OrderedHashSet = (_Ea = class extends HashSet {
  constructor() {
    super(...arguments);
    __publicField(this, "elements", []);
  }
  getOrAdd(o2) {
    const oldSize = this.size;
    const result = super.getOrAdd(o2);
    if (this.size > oldSize) {
      this.elements.push(o2);
    }
    return result;
  }
  equals(o2) {
    if (!(o2 instanceof _Ea)) {
      return false;
    }
    return super.equals(o2);
  }
  clear() {
    super.clear();
    this.elements = [];
  }
  *[Symbol.iterator]() {
    yield* this.elements;
  }
  toArray() {
    return this.elements.slice(0);
  }
}, __name(_Ea, "OrderedHashSet"), _Ea);
var OrderedATNConfigSet = (_Fa = class extends ATNConfigSet {
  constructor() {
    super();
    this.configLookup = new OrderedHashSet();
  }
}, __name(_Fa, "OrderedATNConfigSet"), _Fa);
var LexerATNSimulator = (_Ga = class extends ATNSimulator {
  /**
   * When we hit an accept state in either the DFA or the ATN, we
   * have to notify the character stream to start buffering characters
   * via {@link IntStream//mark} and record the current state. The current sim state
   * includes the current index into the input, the current line,
   * and current character position in that line. Note that the Lexer is
   * tracking the starting line and characterization of the token. These
   * variables track the "state" of the simulator when it hits an accept state.
   *
   * We track these variables separately for the DFA and ATN simulation
   * because the DFA simulation often has to fail over to the ATN
   * simulation. If the ATN simulation fails, we need the DFA to fall
   * back to its previously accepted state, if any. If the ATN succeeds,
   * then the ATN does the accept and the DFA simulator that invoked it
   * can simply return the predicted token type.
   */
  constructor(recog, atn, decisionToDFA, sharedContextCache) {
    super(atn, sharedContextCache);
    __publicField(this, "decisionToDFA");
    __publicField(this, "recognizer", null);
    /**
     * The current token's starting index into the character stream.
     *  Shared across DFA to ATN simulation in case the ATN fails and the
     *  DFA did not have a previous accept state. In this case, we use the
     *  ATN-generated exception object.
     */
    __publicField(this, "startIndex", -1);
    /** line number 1..n within the input */
    __publicField(this, "line", 1);
    /** The index of the character relative to the beginning of the line 0..n-1 */
    __publicField(this, "column", 0);
    __publicField(this, "mode", Lexer.DEFAULT_MODE);
    /** Used during DFA/ATN exec to record the most recent accept configuration info */
    __publicField(this, "prevAccept");
    __publicField(this, "options");
    /** Lookup table for lexer ATN config creation. */
    __publicField(this, "lexerATNConfigFactory");
    this.decisionToDFA = decisionToDFA;
    this.recognizer = recog;
    if (recog) {
      this.options = recog.options;
    } else {
      this.options = {
        minDFAEdge: 0,
        maxDFAEdge: 256,
        minCodePoint: 0,
        maxCodePoint: 1114111
      };
    }
  }
  match(input, mode2) {
    this.mode = mode2;
    const mark = input.mark();
    try {
      this.startIndex = input.index;
      this.prevAccept = void 0;
      const dfa = this.decisionToDFA[mode2];
      if (!dfa.s0) {
        return this.matchATN(input);
      }
      return this.execATN(input, dfa.s0);
    } finally {
      input.release(mark);
    }
  }
  reset() {
    this.prevAccept = void 0;
    this.startIndex = -1;
    this.line = 1;
    this.column = 0;
    this.mode = Lexer.DEFAULT_MODE;
  }
  clearDFA() {
    for (let d2 = 0; d2 < this.decisionToDFA.length; d2++) {
      this.decisionToDFA[d2] = new DFA(this.atn.getDecisionState(d2), d2);
    }
  }
  getDFA(mode2) {
    return this.decisionToDFA[mode2];
  }
  /** @returns the text matched so far for the current token. */
  getText(input) {
    return input.getTextFromRange(this.startIndex, input.index - 1);
  }
  consume(input) {
    const curChar = input.LA(1);
    if (curChar === "\n".charCodeAt(0)) {
      this.line += 1;
      this.column = 0;
    } else {
      this.column += 1;
    }
    input.consume();
  }
  getTokenName(tt2) {
    if (tt2 === Token.EOF) {
      return "EOF";
    } else {
      return "'" + String.fromCharCode(tt2) + "'";
    }
  }
  matchATN(input) {
    const startState = this.atn.modeToStartState[this.mode];
    this.mode;
    const s0Closure = this.computeStartState(input, startState);
    const suppressEdge = s0Closure.hasSemanticContext;
    s0Closure.hasSemanticContext = false;
    const next = this.addDFAState(s0Closure);
    if (!suppressEdge) {
      this.decisionToDFA[this.mode].s0 = next;
    }
    const predict = this.execATN(input, next);
    return predict;
  }
  execATN(input, state) {
    if (state.isAcceptState) {
      this.captureSimState(input, state);
    }
    let t2 = input.LA(1);
    while (true) {
      let target = this.getExistingTargetState(state, t2);
      if (!target) {
        target = this.computeTargetState(input, state, t2);
      }
      if (target === ATNSimulator.ERROR) {
        break;
      }
      if (t2 !== Token.EOF) {
        this.consume(input);
      }
      if (target.isAcceptState) {
        this.captureSimState(input, target);
        if (t2 === Token.EOF) {
          break;
        }
      }
      t2 = input.LA(1);
      state = target;
    }
    return this.failOrAccept(input, state.configs, t2);
  }
  /**
   * Get an existing target state for an edge in the DFA. If the target state
   * for the edge has not yet been computed or is otherwise not available,
   * this method returns `null`.
   *
   * @param s The current DFA state.
   * @param t The next input symbol.
   *
   * @returns The existing target DFA state for the given input symbol
   * `t`, or `null` if the target state for this edge is not already cached
   */
  getExistingTargetState(s2, t2) {
    if (t2 >= this.options.minDFAEdge && t2 <= this.options.maxDFAEdge) {
      const target = s2.edges[t2 - this.options.minDFAEdge];
      return target;
    }
    return void 0;
  }
  /**
   * Compute a target state for an edge in the DFA, and attempt to add the computed state and corresponding
   * edge to the DFA.
   *
   * @param input The input stream
   * @param s The current DFA state
   * @param t The next input symbol
   *
   * @returns The computed target DFA state for the given input symbol `t`.
   *          If `t` does not lead to a valid DFA state, this method returns `ERROR`.
   */
  computeTargetState(input, s2, t2) {
    const reach = new OrderedATNConfigSet();
    this.getReachableConfigSet(input, s2.configs, reach, t2);
    if (reach.length === 0) {
      if (!reach.hasSemanticContext) {
        this.addDFAEdge(s2, t2, ATNSimulator.ERROR);
      }
      return ATNSimulator.ERROR;
    }
    return this.addDFAEdge(s2, t2, null, reach);
  }
  failOrAccept(input, reach, t2) {
    var _a3;
    if ((_a3 = this.prevAccept) == null ? void 0 : _a3.dfaState) {
      const { dfaState, index: index2, line, column } = this.prevAccept;
      this.accept(input, dfaState.lexerActionExecutor, this.startIndex, index2, line, column);
      return dfaState.prediction;
    }
    if (t2 === Token.EOF && input.index === this.startIndex) {
      return Token.EOF;
    }
    throw new LexerNoViableAltException(this.recognizer, input, this.startIndex, reach);
  }
  /**
   * Given a starting configuration set, figure out all ATN configurations we can reach upon input `t`.
   * Parameter `reach` is a return parameter.
   */
  getReachableConfigSet(input, closure, reach, t2) {
    let skipAlt = ATN.INVALID_ALT_NUMBER;
    for (const cfg of closure) {
      const currentAltReachedAcceptState = cfg.alt === skipAlt;
      if (currentAltReachedAcceptState && cfg.passedThroughNonGreedyDecision) {
        continue;
      }
      for (const trans of cfg.state.transitions) {
        const target = this.getReachableTarget(trans, t2);
        if (target) {
          let lexerActionExecutor = cfg.lexerActionExecutor;
          if (lexerActionExecutor) {
            lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
          }
          const treatEofAsEpsilon = t2 === Token.EOF;
          const config = LexerATNConfig.createWithExecutor(
            cfg,
            target,
            lexerActionExecutor
          );
          if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
            skipAlt = cfg.alt;
          }
        }
      }
    }
  }
  accept(input, lexerActionExecutor, startIndex, index2, line, charPos) {
    input.seek(index2);
    this.line = line;
    this.column = charPos;
    if (lexerActionExecutor && this.recognizer) {
      lexerActionExecutor.execute(this.recognizer, input, startIndex);
    }
  }
  getReachableTarget(trans, t2) {
    if (trans.matches(t2, this.options.minCodePoint, this.options.maxCodePoint)) {
      return trans.target;
    } else {
      return void 0;
    }
  }
  computeStartState(input, p2) {
    const initialContext = EmptyPredictionContext.instance;
    const configs = new OrderedATNConfigSet();
    for (let i2 = 0; i2 < p2.transitions.length; i2++) {
      const target = p2.transitions[i2].target;
      const cfg = LexerATNConfig.createWithContext(target, i2 + 1, initialContext);
      this.closure(input, cfg, configs, false, false, false);
    }
    return configs;
  }
  /**
   * Since the alternatives within any lexer decision are ordered by
   * preference, this method stops pursuing the closure as soon as an accept
   * state is reached. After the first accept state is reached by depth-first
   * search from `config`, all other (potentially reachable) states for
   * this rule would have a lower priority.
   *
   * @returns {boolean} `true` if an accept state is reached, otherwise `false`.
   */
  closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
    let cfg = null;
    if (config.state.constructor.stateType === ATNState.RULE_STOP) {
      if (!config.context || config.context.hasEmptyPath()) {
        if (!config.context || config.context.isEmpty()) {
          configs.add(config);
          return true;
        } else {
          configs.add(LexerATNConfig.createWithConfig(config.state, config, EmptyPredictionContext.instance));
          currentAltReachedAcceptState = true;
        }
      }
      if (config.context && !config.context.isEmpty()) {
        for (let i2 = 0; i2 < config.context.length; i2++) {
          if (config.context.getReturnState(i2) !== PredictionContext.EMPTY_RETURN_STATE) {
            const newContext = config.context.getParent(i2);
            const returnState = this.atn.states[config.context.getReturnState(i2)];
            cfg = LexerATNConfig.createWithConfig(returnState, config, newContext);
            currentAltReachedAcceptState = this.closure(
              input,
              cfg,
              configs,
              currentAltReachedAcceptState,
              speculative,
              treatEofAsEpsilon
            );
          }
        }
      }
      return currentAltReachedAcceptState;
    }
    if (!config.state.epsilonOnlyTransitions) {
      if (!currentAltReachedAcceptState || !config.passedThroughNonGreedyDecision) {
        configs.add(config);
      }
    }
    for (const trans of config.state.transitions) {
      cfg = this.getEpsilonTarget(input, config, trans, configs, speculative, treatEofAsEpsilon);
      if (cfg) {
        currentAltReachedAcceptState = this.closure(
          input,
          cfg,
          configs,
          currentAltReachedAcceptState,
          speculative,
          treatEofAsEpsilon
        );
      }
    }
    return currentAltReachedAcceptState;
  }
  // side-effect: can alter configs.hasSemanticContext
  getEpsilonTarget(input, config, trans, configs, speculative, treatEofAsEpsilon) {
    if (!this.lexerATNConfigFactory) {
      this.setupATNFactoryLookup();
    }
    const factory = this.lexerATNConfigFactory[trans.transitionType];
    if (!factory) {
      return null;
    }
    return factory(input, config, trans, configs, speculative, treatEofAsEpsilon);
  }
  /**
   * Fills the lookup table for creating lexer ATN configs. This helps to avoid frequent checks of the transition
   * type, which determines the configuration of the created config.
   */
  setupATNFactoryLookup() {
    this.lexerATNConfigFactory = [];
    this.lexerATNConfigFactory[Transition.RULE] = (input, config, trans) => {
      const newContext = createSingletonPredictionContext(
        config.context ?? void 0,
        trans.followState.stateNumber
      );
      return LexerATNConfig.createWithConfig(trans.target, config, newContext);
    };
    this.lexerATNConfigFactory[Transition.PRECEDENCE] = () => {
      throw new Error("Precedence predicates are not supported in lexers.");
    };
    this.lexerATNConfigFactory[Transition.PREDICATE] = (input, config, trans, configs, speculative) => {
      const pt2 = trans;
      configs.hasSemanticContext = true;
      if (this.evaluatePredicate(input, pt2.ruleIndex, pt2.predIndex, speculative)) {
        return LexerATNConfig.createWithConfig(trans.target, config);
      }
      return null;
    };
    this.lexerATNConfigFactory[Transition.ACTION] = (input, config, trans) => {
      if (config.context === null || config.context.hasEmptyPath()) {
        const lexerActionExecutor = LexerActionExecutor.append(
          config.lexerActionExecutor,
          this.atn.lexerActions[trans.actionIndex]
        );
        return LexerATNConfig.createWithExecutor(config, trans.target, lexerActionExecutor);
      } else {
        return LexerATNConfig.createWithConfig(trans.target, config);
      }
    };
    this.lexerATNConfigFactory[Transition.EPSILON] = (input, config, trans) => {
      return LexerATNConfig.createWithConfig(trans.target, config);
    };
    const simple = /* @__PURE__ */ __name((input, config, trans, configs, speculative, treatEofAsEpsilon) => {
      if (treatEofAsEpsilon) {
        if (trans.matches(Token.EOF, this.options.minCodePoint, this.options.maxCodePoint)) {
          return LexerATNConfig.createWithConfig(trans.target, config);
        }
      }
      return null;
    }, "simple");
    this.lexerATNConfigFactory[Transition.ATOM] = simple;
    this.lexerATNConfigFactory[Transition.RANGE] = simple;
    this.lexerATNConfigFactory[Transition.SET] = simple;
  }
  /**
   * Evaluate a predicate specified in the lexer.
   *
   * If `speculative` is `true`, this method was called before
   * {@link consume} for the matched character. This method should call
   * {@link consume} before evaluating the predicate to ensure position
   * sensitive values, including {@link Lexer//getText}, {@link Lexer//getLine},
   * and {@link Lexer}, properly reflect the current
   * lexer state. This method should restore `input` and the simulator
   * to the original state before returning (i.e. undo the actions made by the
   * call to {@link consume}.
   *
   * @param input The input stream.
   * @param ruleIndex The rule containing the predicate.
   * @param predIndex The index of the predicate within the rule.
   * @param speculative `true` if the current index in `input` is
   * one character before the predicate's location.
   *
   * @returns `true` if the specified predicate evaluates to
   * `true`.
   */
  evaluatePredicate(input, ruleIndex, predIndex, speculative) {
    if (!this.recognizer) {
      return true;
    }
    if (!speculative) {
      return this.recognizer.sempred(null, ruleIndex, predIndex);
    }
    const savedColumn = this.column;
    const savedLine = this.line;
    const index2 = input.index;
    const marker = input.mark();
    try {
      this.consume(input);
      return this.recognizer.sempred(null, ruleIndex, predIndex);
    } finally {
      this.column = savedColumn;
      this.line = savedLine;
      input.seek(index2);
      input.release(marker);
    }
  }
  captureSimState(input, dfaState) {
    this.prevAccept = {
      index: input.index,
      line: this.line,
      column: this.column,
      dfaState
    };
  }
  addDFAEdge(from, tk2, to2, configs) {
    if (!to2 && configs) {
      const suppressEdge = configs.hasSemanticContext;
      configs.hasSemanticContext = false;
      to2 = this.addDFAState(configs);
      if (suppressEdge) {
        return to2;
      }
    }
    if (tk2 < this.options.minDFAEdge || tk2 > this.options.maxDFAEdge) {
      return to2;
    }
    from.edges[tk2 - this.options.minDFAEdge] = to2;
    return to2;
  }
  /**
   * Add a new DFA state if there isn't one with this set of configurations already. This method also detects
   * the first configuration containing an ATN rule stop state. Later, when traversing the DFA, we will know
   * which rule to accept.
   */
  addDFAState(configs) {
    const dfa = this.decisionToDFA[this.mode];
    const existing = dfa.getStateForConfigs(configs);
    if (existing) {
      return existing;
    }
    const proposed = DFAState.fromConfigs(configs);
    const firstConfigWithRuleStopState = configs.firstStopState;
    if (firstConfigWithRuleStopState) {
      proposed.isAcceptState = true;
      proposed.lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
      proposed.prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
    }
    configs.setReadonly(true);
    dfa.addState(proposed);
    return proposed;
  }
}, __name(_Ga, "LexerATNSimulator"), __publicField(_Ga, "debug", false), _Ga);
var ParseInfo = (_Ha = class {
  constructor(atnSimulator) {
    __publicField(this, "atnSimulator");
    this.atnSimulator = atnSimulator;
  }
  /**
   * Gets an array of {@link DecisionInfo} instances containing the profiling
   * information gathered for each decision in the ATN.
   *
   * @returns An array of {@link DecisionInfo} instances, indexed by decision
   * number.
   */
  getDecisionInfo() {
    return this.atnSimulator.getDecisionInfo();
  }
  /**
   * Gets the decision numbers for decisions that required one or more
   * full-context predictions during parsing. These are decisions for which
   * {@link DecisionInfo#llFallback} is non-zero.
   *
   * @returns A list of decision numbers which required one or more
   * full-context predictions during parsing.
   */
  getLLDecisions() {
    const decisions = this.atnSimulator.getDecisionInfo();
    const result = new Array();
    for (let i2 = 0; i2 < decisions.length; i2++) {
      const fallBack = decisions[i2].llFallback;
      if (fallBack > 0) {
        result.push(i2);
      }
    }
    return result;
  }
  /**
   * Gets the total time spent during prediction across all decisions made
   * during parsing. This value is the sum of
   * {@link DecisionInfo#timeInPrediction} for all decisions.
   */
  getTotalTimeInPrediction() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let t2 = 0;
    for (const decision of decisions) {
      t2 += decision.timeInPrediction;
    }
    return t2;
  }
  /**
   * Gets the total number of SLL lookahead operations across all decisions
   * made during parsing. This value is the sum of
   * {@link DecisionInfo#sllTotalLook} for all decisions.
   */
  getTotalSLLLookaheadOps() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let k2 = 0;
    for (const decision of decisions) {
      k2 += decision.sllTotalLook;
    }
    return k2;
  }
  /**
   * Gets the total number of LL lookahead operations across all decisions
   * made during parsing. This value is the sum of
   * {@link DecisionInfo#llTotalLook} for all decisions.
   */
  getTotalLLLookaheadOps() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let k2 = 0;
    for (const decision of decisions) {
      k2 += decision.llTotalLook;
    }
    return k2;
  }
  /**
   * Gets the total number of ATN lookahead operations for SLL prediction
   * across all decisions made during parsing.
   */
  getTotalSLLATNLookaheadOps() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let k2 = 0;
    for (const decision of decisions) {
      k2 += decision.sllATNTransitions;
    }
    return k2;
  }
  /**
   * Gets the total number of ATN lookahead operations for LL prediction
   * across all decisions made during parsing.
   */
  getTotalLLATNLookaheadOps() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let k2 = 0;
    for (const decision of decisions) {
      k2 += decision.llATNTransitions;
    }
    return k2;
  }
  /**
   * Gets the total number of ATN lookahead operations for SLL and LL
   * prediction across all decisions made during parsing.
   *
   *
   * This value is the sum of {@link #getTotalSLLATNLookaheadOps} and
   * {@link #getTotalLLATNLookaheadOps}.
   */
  getTotalATNLookaheadOps() {
    const decisions = this.atnSimulator.getDecisionInfo();
    let k2 = 0;
    for (const decision of decisions) {
      k2 += decision.sllATNTransitions;
      k2 += decision.llATNTransitions;
    }
    return k2;
  }
  getDFASize(decision) {
    if (decision === void 0) {
      let n2 = 0;
      const decisionToDFA = this.atnSimulator.decisionToDFA;
      for (let i2 = 0; i2 < decisionToDFA.length; i2++) {
        n2 += this.getDFASize(i2);
      }
      return n2;
    } else {
      const decisionToDFA = this.atnSimulator.decisionToDFA[decision];
      return decisionToDFA.length;
    }
  }
}, __name(_Ha, "ParseInfo"), _Ha);
var NoViableAltException = (_Ia = class extends RecognitionException {
  constructor(recognizer, input = null, startToken = null, offendingToken = null, deadEndConfigs = null, ctx = null) {
    ctx = ctx ?? recognizer.context;
    offendingToken = offendingToken ?? recognizer.getCurrentToken();
    startToken = startToken ?? recognizer.getCurrentToken();
    input = input ?? recognizer.inputStream;
    super({ message: "", recognizer, input, ctx });
    /** Which configurations did we try at input.index() that couldn't match input.LT(1)? */
    __publicField(this, "deadEndConfigs", null);
    /**
     * The token object at the start index; the input stream might
     * 	not be buffering tokens so get a reference to it. (At the
     *  time the error occurred, of course the stream needs to keep a
     *  buffer all of the tokens but later we might not have access to those.)
     */
    __publicField(this, "startToken");
    this.deadEndConfigs = deadEndConfigs;
    this.startToken = startToken;
    this.offendingToken = offendingToken;
  }
}, __name(_Ia, "NoViableAltException"), _Ia);
var DoubleDict = (_Ja = class {
  constructor() {
    __publicField(this, "cacheMap");
    this.cacheMap = new HashMap();
  }
  get(a2, b2) {
    const d2 = this.cacheMap.get(a2) ?? null;
    return d2 === null ? null : d2.get(b2) ?? null;
  }
  set(a2, b2, o2) {
    let d2 = this.cacheMap.get(a2);
    if (!d2) {
      d2 = new HashMap();
      this.cacheMap.set(a2, d2);
    }
    d2.set(b2, o2);
  }
}, __name(_Ja, "DoubleDict"), _Ja);
var SubsetEqualityComparer = (_Ka = class {
  hashCode(config) {
    let hashCode = MurmurHash.initialize(7);
    hashCode = MurmurHash.update(hashCode, config.state.stateNumber);
    hashCode = MurmurHash.updateFromComparable(hashCode, config.context);
    hashCode = MurmurHash.finish(hashCode, 2);
    return hashCode;
  }
  equals(a2, b2) {
    var _a3;
    return a2.state.stateNumber === b2.state.stateNumber && (((_a3 = a2.context) == null ? void 0 : _a3.equals(b2.context)) ?? true);
  }
}, __name(_Ka, "SubsetEqualityComparer"), __publicField(_Ka, "instance", new _Ka()), _Ka);
var PredictionMode = (_La = class {
  /**
   *
   *Computes the SLL prediction termination condition.
   *
   *
   *This method computes the SLL prediction termination condition for both of
   *the following cases.
   *
   * - The usual SLL+LL fallback upon SLL conflict
   * - Pure SLL without LL fallback
   *
   ***COMBINED SLL+LL PARSING**
   *
   *When LL-fallback is enabled upon SLL conflict, correct predictions are
   *ensured regardless of how the termination condition is computed by this
   *method. Due to the substantially higher cost of LL prediction, the
   *prediction should only fall back to LL when the additional lookahead
   *cannot lead to a unique SLL prediction.
   *
   *Assuming combined SLL+LL parsing, an SLL configuration set with only
   *conflicting subsets should fall back to full LL, even if the
   *configuration sets don't resolve to the same alternative (e.g.
   *`{1,2`} and `{3,4`}. If there is at least one non-conflicting
   *configuration, SLL could continue with the hopes that more lookahead will
   *resolve via one of those non-conflicting configurations.
   *
   *Here's the prediction termination rule them: SLL (for SLL+LL parsing)
   *stops when it sees only conflicting configuration subsets. In contrast,
   *full LL keeps going when there is uncertainty.
   *
   ***HEURISTIC**
   *
   *As a heuristic, we stop prediction when we see any conflicting subset
   *unless we see a state that only has one alternative associated with it.
   *The single-alt-state thing lets prediction continue upon rules like
   *(otherwise, it would admit defeat too soon):
   *
   *`[12|1|[], 6|2|[], 12|2|[]]. s : (ID | ID ID?) ';' ;`
   *
   *When the ATN simulation reaches the state before `';'`, it has a
   *DFA state that looks like: `[12|1|[], 6|2|[], 12|2|[]]`. Naturally
   *`12|1|[]` and `12|2|[]` conflict, but we cannot stop
   *processing this node because alternative to has another way to continue,
   *via `[6|2|[]]`.
   *
   *It also let's us continue for this rule:
   *
   *`[1|1|[], 1|2|[], 8|3|[]] a : A | A | A B ;`
   *
   *After matching input A, we reach the stop state for rule A, state 1.
   *State 8 is the state right before B. Clearly alternatives 1 and 2
   *conflict and no amount of further lookahead will separate the two.
   *However, alternative 3 will be able to continue and so we do not stop
   *working on this state. In the previous example, we're concerned with
   *states associated with the conflicting alternatives. Here alt 3 is not
   *associated with the conflicting configs, but since we can continue
   *looking for input reasonably, don't declare the state done.
   *
   ***PURE SLL PARSING**
   *
   *To handle pure SLL parsing, all we have to do is make sure that we
   *combine stack contexts for configurations that differ only by semantic
   *predicate. From there, we can do the usual SLL termination heuristic.
   *
   ***PREDICATES IN SLL+LL PARSING**
   *
   *SLL decisions don't evaluate predicates until after they reach DFA stop
   *states because they need to create the DFA cache that works in all
   *semantic situations. In contrast, full LL evaluates predicates collected
   *during start state computation so it can ignore predicates thereafter.
   *This means that SLL termination detection can totally ignore semantic
   *predicates.
   *
   *Implementation-wise, {@link ATNConfigSet} combines stack contexts but not
   *semantic predicate contexts so we might see two configurations like the
   *following.
   *
   *`(s, 1, x, {`), (s, 1, x', {p})}
   *
   *Before testing these configurations against others, we have to merge
   *`x` and `x'` (without modifying the existing configurations).
   *For example, we test `(x+x')==x''` when looking for conflicts in
   *the following configurations.
   *
   *`(s, 1, x, {`), (s, 1, x', {p}), (s, 2, x'', {})}
   *
   *If the configuration set has predicates (as indicated by
   *{@link ATNConfigSet//hasSemanticContext}), this algorithm makes a copy of
   *the configurations to strip out all of the predicates so that a standard
   *{@link ATNConfigSet} will merge everything ignoring predicates.
   */
  static hasSLLConflictTerminatingPrediction(mode2, configs) {
    if (_La.allConfigsInRuleStopStates(configs)) {
      return true;
    }
    if (mode2 === _La.SLL) {
      if (configs.hasSemanticContext) {
        const dup = new ATNConfigSet();
        for (let c3 of configs) {
          c3 = ATNConfig.duplicate(c3, SemanticContext.NONE);
          dup.add(c3);
        }
        configs = dup;
      }
    }
    const altSets = _La.getConflictingAltSubsets(configs);
    return _La.hasConflictingAltSet(altSets) && !_La.hasStateAssociatedWithOneAlt(configs);
  }
  /**
   * Checks if any configuration in `configs` is in a
   * {@link RuleStopState}. Configurations meeting this condition have reached
   * the end of the decision rule (local context) or end of start rule (full
   * context).
   *
   * @param configs the configuration set to test
   * @returns `true` if any configuration in `configs` is in a
   * {@link RuleStopState}, otherwise `false`
   */
  static hasConfigInRuleStopState(configs) {
    for (const c3 of configs) {
      if (c3.state instanceof RuleStopState) {
        return true;
      }
    }
    return false;
  }
  /**
   * Checks if all configurations in `configs` are in a
   * {@link RuleStopState}. Configurations meeting this condition have reached
   * the end of the decision rule (local context) or end of start rule (full
   * context).
   *
   * @param configs the configuration set to test
   * @returns `true` if all configurations in `configs` are in a
   * {@link RuleStopState}, otherwise `false`
   */
  static allConfigsInRuleStopStates(configs) {
    for (const c3 of configs) {
      if (!(c3.state instanceof RuleStopState)) {
        return false;
      }
    }
    return true;
  }
  /**
   *
   * Full LL prediction termination.
   *
   * Can we stop looking ahead during ATN simulation or is there some
   * uncertainty as to which alternative we will ultimately pick, after
   * consuming more input? Even if there are partial conflicts, we might know
   * that everything is going to resolve to the same minimum alternative. That
   * means we can stop since no more lookahead will change that fact. On the
   * other hand, there might be multiple conflicts that resolve to different
   * minimums. That means we need more look ahead to decide which of those
   * alternatives we should predict.
   *
   * The basic idea is to split the set of configurations `C`, into
   * conflicting subsets `(s, _, ctx, _)` and singleton subsets with
   * non-conflicting configurations. Two configurations conflict if they have
   * identical {@link ATNConfig.state} and {@link ATNConfig.context} values
   * but different {@link ATNConfig.alt} value, e.g. `(s, i, ctx, _)`
   * and `(s, j, ctx, _)` for `i!=j`.
   *
   * Reduce these configuration subsets to the set of possible alternatives.
   * You can compute the alternative subsets in one pass as follows:
   *
   * `A_s,ctx = {i | (s, i, ctx, _)`} for each configuration in
   * `C` holding `s` and `ctx` fixed.
   *
   * Or in pseudo-code, for each configuration `c` in `C`:
   *
   * ```
   * map[c] U= c.{@link ATNConfig.alt alt} // map hash/equals uses s and x, not
   * alt and not pred
   * ```
   *
   * The values in `map` are the set of `A_s,ctx` sets.
   *
   * If `|A_s,ctx|=1` then there is no conflict associated with
   * `s` and `ctx`.
   *
   * Reduce the subsets to singletons by choosing a minimum of each subset. If
   * the union of these alternative subsets is a singleton, then no amount of
   * more lookahead will help us. We will always pick that alternative. If,
   * however, there is more than one alternative, then we are uncertain which
   * alternative to predict and must continue looking for resolution. We may
   * or may not discover an ambiguity in the future, even if there are no
   * conflicting subsets this round.
   *
   * The biggest sin is to terminate early because it means we've made a
   * decision but were uncertain as to the eventual outcome. We haven't used
   * enough lookahead. On the other hand, announcing a conflict too late is no
   * big deal; you will still have the conflict. It's just inefficient. It
   * might even look until the end of file.
   *
   * No special consideration for semantic predicates is required because
   * predicates are evaluated on-the-fly for full LL prediction, ensuring that
   * no configuration contains a semantic context during the termination
   * check.
   *
   * **CONFLICTING CONFIGS**
   *
   * Two configurations `(s, i, x)` and `(s, j, x')`, conflict when `i!=j` but `x=x'`. Because we merge all
   * `(s, i, _)` configurations together, that means that there are at most `n` configurations associated with state
   * `s` for `n` possible alternatives in the decision. The merged stacks complicate the comparison of configuration
   * contexts `x` and `x'`. Sam checks to see if one is a subset of the other by calling merge and checking to see
   * if the merged result is either `x` or `x'`. If the `x` associated with lowest alternative `i` is the superset,
   * then `i` is the only possible prediction since the others resolve to `min(i)` as well. However, if `x` is
   * associated with `j>i` then at least one stack configuration for `j` is not in conflict with alternative `i`.
   * The algorithm should keep going, looking for more lookahead due to the uncertainty.
   *
   * For simplicity, I'm doing a equality check between `x` and `x'` that lets the algorithm continue to consume
   * lookahead longer than necessary. The reason I like the equality is of course the simplicity but also because
   * that is the test you need to detect the alternatives that are actually in conflict.
   *
   * **CONTINUE/STOP RULE**
   *
   * Continue if union of resolved alternative sets from non-conflicting and conflicting alternative subsets has more
   * than one alternative. We are uncertain about which alternative to predict.
   *
   * The complete set of alternatives, `[i for (_,i,_)]`, tells us which alternatives are still in the running for
   * the amount of input we've consumed at this point. The conflicting sets let us to strip away configurations that
   * won't lead to more states because we resolve conflicts to the configuration with a minimum alternate for the
   * conflicting set.
   *
   * **CASES**
   *
   * - no conflicts and more than 1 alternative in set => continue
   * -  `(s, 1, x)`, `(s, 2, x)`, `(s, 3, z)`, `(s', 1, y)`, `(s', 2, y)` yields non-conflicting set `{3`} U
   *   conflicting sets `min({1,2`)} U `min({1,2`)} = `{1,3`} => continue
   * - `(s, 1, x)`, `(s, 2, x)`, `(s', 1, y)`, `(s', 2, y)`, `(s'', 1, z)` yields non-conflicting set `{1`} U
   *   conflicting sets `min({1,2`)} U `min({1,2`)} = `{1`} => stop and predict 1
   * - `(s, 1, x)`, `(s, 2, x)`, `(s', 1, y)`, `(s', 2, y)` yields conflicting, reduced sets `{1`} U
   *   `{1`} = `{1`} => stop and predict 1, can announce ambiguity `{1,2`}
   * - `(s, 1, x)`, `(s, 2, x)`, `(s', 2, y)`, `(s', 3, y)` yields conflicting, reduced sets `{1`} U
   *   `{2`} = `{1,2`} => continue
   * - `(s, 1, x)`, `(s, 2, x)`, `(s', 3, y)`, `(s', 4, y)` yields conflicting, reduced sets `{1`} U
   *   `{3`} = `{1,3`} => continue
   *
   * **EXACT AMBIGUITY DETECTION**
   *
   *If all states report the same conflicting set of alternatives, then we
   *know we have the exact ambiguity set.
   *
   * `|A_*i*|>1` and `A_*i* = A_*j*` for all *i*, *j*.
   *
   * In other words, we continue examining lookahead until all `A_i` have more than one alternative and all `A_i`
   * are the same. If `A={{1,2`, {1,3}}}, then regular LL prediction would terminate because the resolved set
   * is `{1`}. To determine what the real ambiguity is, we have to know whether the ambiguity is between one and
   * two or one and three so we keep going. We can only stop prediction when we need exact ambiguity detection when
   * the sets look like `A={{1,2`}} or `{{1,2`,{1,2}}}, etc...
   */
  static resolvesToJustOneViableAlt(altSets) {
    return _La.getSingleViableAlt(altSets);
  }
  /**
   * Determines if every alternative subset in `altSets` contains more
   * than one alternative.
   *
   * @param altSets a collection of alternative subsets
   * @returns `true` if every {@link BitSet} in `altSets` has
   * {@link BitSet//cardinality cardinality} > 1, otherwise `false`
   */
  static allSubsetsConflict(altSets) {
    return !_La.hasNonConflictingAltSet(altSets);
  }
  /**
   * Determines if any single alternative subset in `altSets` contains
   * exactly one alternative.
   *
   * @param altSets a collection of alternative subsets
   * @returns `true` if `altSets` contains a {@link BitSet} with
   * {@link BitSet//cardinality cardinality} 1, otherwise `false`
   */
  static hasNonConflictingAltSet(altSets) {
    for (const alts of altSets) {
      if (alts.length === 1) {
        return true;
      }
    }
    return false;
  }
  /**
   * Determines if any single alternative subset in `altSets` contains
   * more than one alternative.
   *
   * @param altSets a collection of alternative subsets
   * @returns `true` if `altSets` contains a {@link BitSet} with
   * {@link BitSet//cardinality cardinality} > 1, otherwise `false`
   */
  static hasConflictingAltSet(altSets) {
    for (const alts of altSets) {
      if (alts.length > 1) {
        return true;
      }
    }
    return false;
  }
  /**
   * Determines if every alternative subset in `altSets` is equivalent.
   *
   * @param altSets a collection of alternative subsets
   * @returns `true` if every member of `altSets` is equal to the
   * others, otherwise `false`
   */
  static allSubsetsEqual(altSets) {
    let first = null;
    for (const alts of altSets) {
      if (first === null) {
        first = alts;
      } else if (alts !== first) {
        return false;
      }
    }
    return true;
  }
  /**
   * Returns the unique alternative predicted by all alternative subsets in
   * `altSets`. If no such alternative exists, this method returns
   * {@link ATN.INVALID_ALT_NUMBER}.
   *
   * @param altSets a collection of alternative subsets
   */
  static getUniqueAlt(altSets) {
    const all = _La.getAlts(altSets);
    if (all.length === 1) {
      return all.nextSetBit(0);
    } else {
      return ATN.INVALID_ALT_NUMBER;
    }
  }
  /**
   * Gets the complete set of represented alternatives for a collection of
   * alternative subsets. This method returns the union of each {@link BitSet}
   * in `altSets`.
   *
   * @param altSets a collection of alternative subsets
   * @returns the set of represented alternatives in `altSets`
   */
  static getAlts(altSets) {
    const all = new BitSet();
    altSets.forEach((alts) => {
      all.or(alts);
    });
    return all;
  }
  /**
   * This function gets the conflicting alt subsets from a configuration set.
   * For each configuration `c` in `configs`:
   *
   * ```
   * map[c] U= c.{@link ATNConfig.alt alt} // map hash/equals uses s and x, not
   * alt and not pred
   * ```
   */
  static getConflictingAltSubsets(configs) {
    const configToAlts = new HashMap(SubsetEqualityComparer.instance);
    for (const cfg of configs) {
      let alts = configToAlts.get(cfg);
      if (!alts) {
        alts = new BitSet();
        configToAlts.set(cfg, alts);
      }
      alts.set(cfg.alt);
    }
    return Array.from(configToAlts.values());
  }
  /**
   * Get a map from state to alt subset from a configuration set. For each configuration `c` in `configs`:
   *
   * ```
   * map[c.state] = c.alt
   * ```
   */
  static getStateToAltMap(configs) {
    const m2 = new HashMap(ObjectEqualityComparator.instance);
    for (const c3 of configs) {
      let alts = m2.get(c3.state);
      if (!alts) {
        alts = new BitSet();
        m2.set(c3.state, alts);
      }
      alts.set(c3.alt);
    }
    return m2;
  }
  static hasStateAssociatedWithOneAlt(configs) {
    const counts = {};
    for (const c3 of configs) {
      const stateNumber = c3.state.stateNumber;
      if (!counts[stateNumber]) {
        counts[stateNumber] = 0;
      }
      counts[stateNumber]++;
    }
    return Object.values(counts).some((count) => {
      return count === 1;
    });
  }
  static getSingleViableAlt(altSets) {
    let result = null;
    for (const alts of altSets) {
      const minAlt = alts.nextSetBit(0);
      if (result === null) {
        result = minAlt;
      } else if (result !== minAlt) {
        return ATN.INVALID_ALT_NUMBER;
      }
    }
    return result ?? 0;
  }
}, __name(_La, "PredictionMode"), /**
 * The SLL(*) prediction mode. This prediction mode ignores the current
 * parser context when making predictions. This is the fastest prediction
 * mode, and provides correct results for many grammars. This prediction
 * mode is more powerful than the prediction mode provided by ANTLR 3, but
 * may result in syntax errors for grammar and input combinations which are
 * not SLL.
 *
 *
 * When using this prediction mode, the parser will either return a correct
 * parse tree (i.e. the same parse tree that would be returned with the
 * {@link LL} prediction mode), or it will report a syntax error. If a
 * syntax error is encountered when using the {@link SLL} prediction mode,
 * it may be due to either an actual syntax error in the input or indicate
 * that the particular combination of grammar and input requires the more
 * powerful {@link LL} prediction abilities to complete successfully.
 *
 *
 * This prediction mode does not provide any guarantees for prediction
 * behavior for syntactically-incorrect inputs.
 */
__publicField(_La, "SLL", 0), /**
 * The LL(*) prediction mode. This prediction mode allows the current parser
 * context to be used for resolving SLL conflicts that occur during
 * prediction. This is the fastest prediction mode that guarantees correct
 * parse results for all combinations of grammars with syntactically correct
 * inputs.
 *
 *
 * When using this prediction mode, the parser will make correct decisions
 * for all syntactically-correct grammar and input combinations. However, in
 * cases where the grammar is truly ambiguous this prediction mode might not
 * report a precise answer for *exactly which* alternatives are
 * ambiguous.
 *
 *
 * This prediction mode does not provide any guarantees for prediction
 * behavior for syntactically-incorrect inputs.
 */
__publicField(_La, "LL", 1), /**
 *
 * The LL(*) prediction mode with exact ambiguity detection. In addition to
 * the correctness guarantees provided by the {@link LL} prediction mode,
 * this prediction mode instructs the prediction algorithm to determine the
 * complete and exact set of ambiguous alternatives for every ambiguous
 * decision encountered while parsing.
 *
 *
 * This prediction mode may be used for diagnosing ambiguities during
 * grammar development. Due to the performance overhead of calculating sets
 * of ambiguous alternatives, this prediction mode should be avoided when
 * the exact results are not necessary.
 *
 *
 * This prediction mode does not provide any guarantees for prediction
 * behavior for syntactically-incorrect inputs.
 */
__publicField(_La, "LL_EXACT_AMBIG_DETECTION", 2), _La);
var ParserATNSimulator = (_Ma = class extends ATNSimulator {
  constructor(recog, atn, decisionToDFA, sharedContextCache) {
    super(atn, sharedContextCache);
    /** SLL, LL, or LL + exact ambig detection? */
    __publicField(this, "predictionMode");
    __publicField(this, "decisionToDFA");
    __publicField(this, "parser");
    /**
     * Each prediction operation uses a cache for merge of prediction contexts.
     * Don't keep around as it wastes huge amounts of memory. DoubleKeyMap
     * isn't synchronized but we're ok since two threads shouldn't reuse same
     * parser/atn sim object because it can only handle one input at a time.
     * This maps graphs a and b to merged result c. (a,b)->c. We can avoid
     * the merge if we ever see a and b again.  Note that (b,a)->c should
     * also be examined during cache lookup.
     */
    __publicField(this, "mergeCache", new DoubleDict());
    // Used also in the profiling ATN simulator.
    __publicField(this, "predictionState");
    this.parser = recog;
    this.decisionToDFA = decisionToDFA;
  }
  static getUniqueAlt(configs) {
    let alt = ATN.INVALID_ALT_NUMBER;
    for (const c3 of configs) {
      if (alt === ATN.INVALID_ALT_NUMBER) {
        alt = c3.alt;
      } else if (c3.alt !== alt) {
        return ATN.INVALID_ALT_NUMBER;
      }
    }
    return alt;
  }
  reset() {
  }
  clearDFA() {
    for (let d2 = 0; d2 < this.decisionToDFA.length; d2++) {
      this.decisionToDFA[d2] = new DFA(this.atn.getDecisionState(d2), d2);
    }
  }
  // TODO: make outerContext an optional parameter, not optional null.
  adaptivePredict(input, decision, outerContext) {
    if (_Ma.debug || _Ma.traceATNSimulator) {
      console.log("adaptivePredict decision " + decision + " exec LA(1)==" + this.getLookaheadName(input) + " line " + input.LT(1).line + ":" + input.LT(1).column);
    }
    const dfa = this.decisionToDFA[decision];
    this.predictionState = {
      input,
      startIndex: input.index,
      outerContext: outerContext ?? void 0,
      dfa
    };
    const m2 = input.mark();
    const index2 = input.index;
    try {
      let s0;
      if (dfa.isPrecedenceDfa) {
        s0 = dfa.getPrecedenceStartState(this.parser.getPrecedence());
      } else {
        s0 = dfa.s0;
      }
      if (!s0) {
        if (!outerContext) {
          outerContext = ParserRuleContext.empty;
        }
        if (_Ma.debug) {
          console.log("predictATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this.parser.ruleNames));
        }
        const fullCtx = false;
        let s0_closure = this.computeStartState(dfa.atnStartState, ParserRuleContext.empty, fullCtx);
        if (dfa.isPrecedenceDfa) {
          s0_closure = this.applyPrecedenceFilter(s0_closure);
          s0 = this.addDFAState(dfa, DFAState.fromConfigs(s0_closure));
          dfa.setPrecedenceStartState(this.parser.getPrecedence(), s0);
        } else {
          s0 = this.addDFAState(dfa, DFAState.fromConfigs(s0_closure));
          dfa.s0 = s0;
        }
      }
      const alt = this.execATN(dfa, s0, input, index2, outerContext);
      if (_Ma.debug) {
        console.log("DFA after predictATN: " + dfa.toString(this.parser.vocabulary));
      }
      return alt;
    } finally {
      this.predictionState.dfa = void 0;
      this.mergeCache = new DoubleDict();
      input.seek(index2);
      input.release(m2);
    }
  }
  /**
   * Performs ATN simulation to compute a predicted alternative based
   *  upon the remaining input, but also updates the DFA cache to avoid
   *  having to traverse the ATN again for the same input sequence.
   *
   * There are some key conditions we're looking for after computing a new
   * set of ATN configs (proposed DFA state):
   *       if the set is empty, there is no viable alternative for current symbol
   *       does the state uniquely predict an alternative?
   *       does the state have a conflict that would prevent us from
   *         putting it on the work list?
   *
   * We also have some key operations to do:
   *       add an edge from previous DFA state to potentially new DFA state, D,
   *         upon current symbol but only if adding to work list, which means in all
   *         cases except no viable alternative (and possibly non-greedy decisions?)
   *       collecting predicates and adding semantic context to DFA accept states
   *       adding rule context to context-sensitive DFA accept states
   *       consuming an input symbol
   *       reporting a conflict
   *       reporting an ambiguity
   *       reporting a context sensitivity
   *       reporting insufficient predicates
   *
   * cover these cases:
   *    dead end
   *    single alt
   *    single alt + preds
   *    conflict
   *    conflict + preds
   */
  execATN(dfa, s0, input, startIndex, outerContext) {
    if (_Ma.debug || _Ma.traceATNSimulator) {
      console.log("execATN decision " + dfa.decision + ", DFA state " + s0 + ", LA(1)==" + this.getLookaheadName(input) + " line " + input.LT(1).line + ":" + input.LT(1).column);
    }
    let alt;
    let previousState = s0;
    let t2 = input.LA(1);
    while (true) {
      let nextState = this.getExistingTargetState(previousState, t2);
      if (!nextState) {
        nextState = this.computeTargetState(dfa, previousState, t2);
      }
      if (nextState === ATNSimulator.ERROR) {
        const e10 = this.noViableAlt(input, outerContext, previousState.configs, startIndex);
        input.seek(startIndex);
        alt = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(previousState.configs, outerContext);
        if (alt !== ATN.INVALID_ALT_NUMBER) {
          return alt;
        } else {
          throw e10;
        }
      }
      if (nextState.requiresFullContext && this.predictionMode !== PredictionMode.SLL) {
        let conflictingAlts = null;
        if (nextState.predicates !== null) {
          if (_Ma.debug) {
            console.log("DFA state has preds in DFA sim LL failover");
          }
          const conflictIndex = input.index;
          if (conflictIndex !== startIndex) {
            input.seek(startIndex);
          }
          conflictingAlts = this.evalSemanticContext(nextState.predicates, outerContext, true);
          if (conflictingAlts.length === 1) {
            if (_Ma.debug) {
              console.log("Full LL avoided");
            }
            return conflictingAlts.nextSetBit(0);
          }
          if (conflictIndex !== startIndex) {
            input.seek(conflictIndex);
          }
        }
        const fullCtx = true;
        const s0_closure = this.computeStartState(dfa.atnStartState, outerContext, fullCtx);
        this.reportAttemptingFullContext(dfa, conflictingAlts, nextState.configs, startIndex, input.index);
        alt = this.execATNWithFullContext(dfa, nextState, s0_closure, input, startIndex, outerContext);
        return alt;
      }
      if (nextState.isAcceptState) {
        if (nextState.predicates === null) {
          return nextState.prediction;
        }
        const stopIndex = input.index;
        input.seek(startIndex);
        const alts = this.evalSemanticContext(nextState.predicates, outerContext, true);
        if (alts.length === 0) {
          throw this.noViableAlt(input, outerContext, nextState.configs, startIndex);
        }
        if (alts.length === 1) {
          return alts.nextSetBit(0);
        }
        this.reportAmbiguity(dfa, nextState, startIndex, stopIndex, false, alts, nextState.configs);
        return alts.nextSetBit(0);
      }
      previousState = nextState;
      if (t2 !== Token.EOF) {
        input.consume();
        t2 = input.LA(1);
      }
    }
  }
  /**
   * Get an existing target state for an edge in the DFA. If the target state
   * for the edge has not yet been computed or is otherwise not available,
   * this method returns `null`.
   *
   * @param previousD The current DFA state
   * @param t The next input symbol
   * @returns The existing target DFA state for the given input symbol
   * `t`, or `null` if the target state for this edge is not
   * already cached
   */
  getExistingTargetState(previousD, t2) {
    return previousD.edges[t2 + 1];
  }
  /**
   * Compute a target state for an edge in the DFA, and attempt to add the
   * computed state and corresponding edge to the DFA.
   *
   * @param dfa The DFA
   * @param previousD The current DFA state
   * @param t The next input symbol
   *
   * @returns The computed target DFA state for the given input symbol
   * `t`. If `t` does not lead to a valid DFA state, this method
   * returns {@link ERROR
   */
  computeTargetState(dfa, previousD, t2) {
    const reach = this.computeReachSet(previousD.configs, t2, false);
    if (reach === null) {
      this.addDFAEdge(dfa, previousD, t2, ATNSimulator.ERROR);
      return ATNSimulator.ERROR;
    }
    let D2 = DFAState.fromConfigs(reach);
    const predictedAlt = _Ma.getUniqueAlt(reach);
    if (_Ma.debug) {
      const altSubSets = PredictionMode.getConflictingAltSubsets(reach);
      console.log("SLL altSubSets=" + arrayToString(altSubSets) + /*", previous=" + previousD.configs + */
      ", configs=" + reach + ", predict=" + predictedAlt + ", allSubsetsConflict=" + PredictionMode.allSubsetsConflict(altSubSets) + ", conflictingAlts=" + this.getConflictingAlts(reach));
    }
    if (predictedAlt !== ATN.INVALID_ALT_NUMBER) {
      D2.isAcceptState = true;
      D2.configs.uniqueAlt = predictedAlt;
      D2.prediction = predictedAlt;
    } else if (PredictionMode.hasSLLConflictTerminatingPrediction(this.predictionMode, reach)) {
      D2.configs.conflictingAlts = this.getConflictingAlts(reach);
      D2.requiresFullContext = true;
      D2.isAcceptState = true;
      D2.prediction = D2.configs.conflictingAlts.nextSetBit(0);
    }
    if (D2.isAcceptState && D2.configs.hasSemanticContext) {
      this.predicateDFAState(D2, this.atn.getDecisionState(dfa.decision));
      if (D2.predicates !== null) {
        D2.prediction = ATN.INVALID_ALT_NUMBER;
      }
    }
    D2 = this.addDFAEdge(dfa, previousD, t2, D2);
    return D2;
  }
  getRuleName(index2) {
    if (this.parser !== null && index2 >= 0) {
      return this.parser.ruleNames[index2];
    } else {
      return "<rule " + index2 + ">";
    }
  }
  getTokenName(t2) {
    var _a3;
    if (t2 === Token.EOF) {
      return "EOF";
    }
    const vocabulary = ((_a3 = this.parser) == null ? void 0 : _a3.vocabulary) ?? Vocabulary.EMPTY_VOCABULARY;
    const displayName = vocabulary.getDisplayName(t2);
    if (displayName === t2.toString()) {
      return displayName;
    }
    return displayName + "<" + t2 + ">";
  }
  getLookaheadName(input) {
    return this.getTokenName(input.LA(1));
  }
  /**
   * Used for debugging in adaptivePredict around execATN but I cut
   * it out for clarity now that alg. works well. We can leave this
   * "dead" code for a bit
   */
  dumpDeadEndConfigs(e10) {
    console.log("dead end configs: ");
    const decs = e10.deadEndConfigs;
    for (const c3 of decs) {
      let trans = "no edges";
      if (c3.state.transitions.length > 0) {
        const t2 = c3.state.transitions[0];
        if (t2 instanceof AtomTransition) {
          trans = "Atom " + this.getTokenName(t2.labelValue);
        } else if (t2 instanceof SetTransition) {
          const neg = t2 instanceof NotSetTransition;
          trans = (neg ? "~" : "") + "Set " + t2.label;
        }
      }
      console.error(c3.toString(this.parser, true) + ":" + trans);
    }
  }
  predicateDFAState(dfaState, decisionState) {
    const altCount = decisionState.transitions.length;
    const altsToCollectPredsFrom = this.getConflictingAltsOrUniqueAlt(dfaState.configs);
    const altToPred = this.getPredsForAmbigAlts(altsToCollectPredsFrom, dfaState.configs, altCount);
    if (altToPred !== null) {
      dfaState.predicates = this.getPredicatePredictions(altsToCollectPredsFrom, altToPred);
      dfaState.prediction = ATN.INVALID_ALT_NUMBER;
    } else {
      dfaState.prediction = altsToCollectPredsFrom.nextSetBit(0);
    }
  }
  // comes back with reach.uniqueAlt set to a valid alt
  execATNWithFullContext(dfa, D2, s0, input, startIndex, outerContext) {
    if (_Ma.debug || _Ma.traceATNSimulator) {
      console.log("execATNWithFullContext " + s0);
    }
    const fullCtx = true;
    let foundExactAmbig = false;
    let reach;
    let previous = s0;
    input.seek(startIndex);
    let t2 = input.LA(1);
    let predictedAlt = -1;
    for (; ; ) {
      reach = this.computeReachSet(previous, t2, fullCtx);
      if (reach === null) {
        const e10 = this.noViableAlt(input, outerContext, previous, startIndex);
        input.seek(startIndex);
        const alt = this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(previous, outerContext);
        if (alt !== ATN.INVALID_ALT_NUMBER) {
          return alt;
        } else {
          throw e10;
        }
      }
      const altSubSets = PredictionMode.getConflictingAltSubsets(reach);
      if (_Ma.debug) {
        console.log("LL altSubSets=" + altSubSets + ", predict=" + PredictionMode.getUniqueAlt(altSubSets) + ", resolvesToJustOneViableAlt=" + PredictionMode.resolvesToJustOneViableAlt(altSubSets));
      }
      reach.uniqueAlt = _Ma.getUniqueAlt(reach);
      if (reach.uniqueAlt !== ATN.INVALID_ALT_NUMBER) {
        predictedAlt = reach.uniqueAlt;
        break;
      } else if (this.predictionMode !== PredictionMode.LL_EXACT_AMBIG_DETECTION) {
        predictedAlt = PredictionMode.resolvesToJustOneViableAlt(altSubSets);
        if (predictedAlt !== ATN.INVALID_ALT_NUMBER) {
          break;
        }
      } else {
        if (PredictionMode.allSubsetsConflict(altSubSets) && PredictionMode.allSubsetsEqual(altSubSets)) {
          foundExactAmbig = true;
          predictedAlt = PredictionMode.getSingleViableAlt(altSubSets);
          break;
        }
      }
      previous = reach;
      if (t2 !== Token.EOF) {
        input.consume();
        t2 = input.LA(1);
      }
    }
    if (reach.uniqueAlt !== ATN.INVALID_ALT_NUMBER) {
      this.reportContextSensitivity(dfa, predictedAlt, reach, startIndex, input.index);
      return predictedAlt;
    }
    this.reportAmbiguity(dfa, D2, startIndex, input.index, foundExactAmbig, reach.getAlts(), reach);
    return predictedAlt;
  }
  computeReachSet(closure, t2, fullCtx) {
    if (_Ma.debug) {
      console.log("in computeReachSet, starting closure: " + closure);
    }
    const intermediate = new ATNConfigSet(fullCtx);
    let skippedStopStates = null;
    for (const c3 of closure) {
      if (_Ma.debug) {
        console.log("testing " + this.getTokenName(t2) + " at " + c3);
      }
      if (c3.state instanceof RuleStopState) {
        if (fullCtx || t2 === Token.EOF) {
          if (skippedStopStates === null) {
            skippedStopStates = [];
          }
          skippedStopStates.push(c3);
        }
        continue;
      }
      for (const trans of c3.state.transitions) {
        const target = this.getReachableTarget(trans, t2);
        if (target !== null) {
          const cfg = ATNConfig.createWithConfig(target, c3);
          intermediate.add(cfg, this.mergeCache);
        }
      }
    }
    let reach = null;
    if (skippedStopStates === null && t2 !== Token.EOF) {
      if (intermediate.length === 1) {
        reach = intermediate;
      } else if (_Ma.getUniqueAlt(intermediate) !== ATN.INVALID_ALT_NUMBER) {
        reach = intermediate;
      }
    }
    if (reach === null) {
      reach = new ATNConfigSet(fullCtx);
      const closureBusy = new HashSet();
      const treatEofAsEpsilon = t2 === Token.EOF;
      for (const config of intermediate) {
        this.closure(config, reach, closureBusy, false, fullCtx, treatEofAsEpsilon);
      }
    }
    if (t2 === Token.EOF) {
      reach = this.removeAllConfigsNotInRuleStopState(reach, reach === intermediate);
    }
    if (skippedStopStates !== null && (!fullCtx || !PredictionMode.hasConfigInRuleStopState(reach))) {
      for (const config of skippedStopStates) {
        reach.add(config, this.mergeCache);
      }
    }
    if (reach.length === 0) {
      return null;
    } else {
      return reach;
    }
  }
  /**
   * Return a configuration set containing only the configurations from
   * `configs` which are in a {@link RuleStopState}. If all
   * configurations in `configs` are already in a rule stop state, this
   * method simply returns `configs`.
   *
   * When `lookToEndOfRule` is true, this method uses
   * {@link ATN.nextTokens} for each configuration in `configs` which is
   * not already in a rule stop state to see if a rule stop state is reachable
   * from the configuration via epsilon-only transitions.
   *
   * @param configs the configuration set to update
   * @param lookToEndOfRule when true, this method checks for rule stop states
   * reachable by epsilon-only transitions from each configuration in
   * `configs`.
   *
   * @returns `configs` if all configurations in `configs` are in a
   * rule stop state, otherwise return a new configuration set containing only
   * the configurations from `configs` which are in a rule stop state
   */
  removeAllConfigsNotInRuleStopState(configs, lookToEndOfRule) {
    if (PredictionMode.allConfigsInRuleStopStates(configs)) {
      return configs;
    }
    const result = new ATNConfigSet(configs.fullCtx);
    for (const config of configs) {
      if (config.state instanceof RuleStopState) {
        result.add(config, this.mergeCache);
        continue;
      }
      if (lookToEndOfRule && config.state.epsilonOnlyTransitions) {
        const nextTokens = this.atn.nextTokens(config.state);
        if (nextTokens.contains(Token.EPSILON)) {
          const endOfRuleState = this.atn.ruleToStopState[config.state.ruleIndex];
          result.add(ATNConfig.createWithConfig(endOfRuleState, config), this.mergeCache);
        }
      }
    }
    return result;
  }
  computeStartState(p2, ctx, fullCtx) {
    const initialContext = predictionContextFromRuleContext(this.atn, ctx);
    const configs = new ATNConfigSet(fullCtx);
    for (let i2 = 0; i2 < p2.transitions.length; i2++) {
      const target = p2.transitions[i2].target;
      const c3 = ATNConfig.createWithContext(target, i2 + 1, initialContext);
      const closureBusy = new HashSet();
      this.closure(c3, configs, closureBusy, true, fullCtx, false);
    }
    return configs;
  }
  /**
   * This method transforms the start state computed by
   * {@link computeStartState} to the special start state used by a
   * precedence DFA for a particular precedence value. The transformation
   * process applies the following changes to the start state's configuration
   * set.
   *
   * 1. Evaluate the precedence predicates for each configuration using
   * {@link SemanticContext//evalPrecedence}.
   * 2. Remove all configurations which predict an alternative greater than
   * 1, for which another configuration that predicts alternative 1 is in the
   * same ATN state with the same prediction context. This transformation is
   * valid for the following reasons:
   * 3. The closure block cannot contain any epsilon transitions which bypass
   * the body of the closure, so all states reachable via alternative 1 are
   * part of the precedence alternatives of the transformed left-recursive
   * rule.
   * 4. The "primary" portion of a left recursive rule cannot contain an
   * epsilon transition, so the only way an alternative other than 1 can exist
   * in a state that is also reachable via alternative 1 is by nesting calls
   * to the left-recursive rule, with the outer calls not being at the
   * preferred precedence level.
   *
   *
   * The prediction context must be considered by this filter to address
   * situations like the following.
   *
   * `
   * ```
   * grammar TA;
   * prog: statement* EOF;
   * statement: letterA | statement letterA 'b' ;
   * letterA: 'a';
   * ```
   * `
   *
   * If the above grammar, the ATN state immediately before the token
   * reference `'a'` in `letterA` is reachable from the left edge
   * of both the primary and closure blocks of the left-recursive rule
   * `statement`. The prediction context associated with each of these
   * configurations distinguishes between them, and prevents the alternative
   * which stepped out to `prog` (and then back in to `statement`
   * from being eliminated by the filter.
   *
   * @param configs The configuration set computed by
   * {@link computeStartState} as the start state for the DFA.
   * @returns The transformed configuration set representing the start state
   * for a precedence DFA at a particular precedence level (determined by
   * calling {@link Parser//getPrecedence})
   */
  applyPrecedenceFilter(configs) {
    const statesFromAlt1 = [];
    const configSet = new ATNConfigSet(configs.fullCtx);
    for (const config of configs) {
      if (config.alt !== 1) {
        continue;
      }
      const updatedContext = config.semanticContext.evalPrecedence(
        this.parser,
        this.predictionState.outerContext
      );
      if (updatedContext === null) {
        continue;
      }
      statesFromAlt1[config.state.stateNumber] = config.context;
      if (updatedContext !== config.semanticContext) {
        configSet.add(ATNConfig.duplicate(config, updatedContext), this.mergeCache);
      } else {
        configSet.add(config, this.mergeCache);
      }
    }
    for (const config of configs) {
      if (config.alt === 1) {
        continue;
      }
      if (!config.precedenceFilterSuppressed) {
        const context = statesFromAlt1[config.state.stateNumber] || null;
        if (context !== null && context.equals(config.context)) {
          continue;
        }
      }
      configSet.add(config, this.mergeCache);
    }
    return configSet;
  }
  getReachableTarget(trans, ttype) {
    if (trans.matches(ttype, 0, this.atn.maxTokenType)) {
      return trans.target;
    } else {
      return null;
    }
  }
  getPredsForAmbigAlts(ambigAlts, configs, altCount) {
    let altToPred = [];
    for (const c3 of configs) {
      if (ambigAlts.get(c3.alt)) {
        altToPred[c3.alt] = SemanticContext.orContext(altToPred[c3.alt] ?? null, c3.semanticContext);
      }
    }
    let nPredAlts = 0;
    for (let i2 = 1; i2 < altCount + 1; i2++) {
      const pred = altToPred[i2] ?? null;
      if (pred === null) {
        altToPred[i2] = SemanticContext.NONE;
      } else if (pred !== SemanticContext.NONE) {
        nPredAlts += 1;
      }
    }
    if (nPredAlts === 0) {
      altToPred = null;
    }
    if (_Ma.debug) {
      console.log("getPredsForAmbigAlts result " + arrayToString(altToPred));
    }
    return altToPred;
  }
  getPredicatePredictions(ambigAlts, altToPred) {
    const pairs = [];
    let containsPredicate = false;
    for (let i2 = 1; i2 < altToPred.length; i2++) {
      const pred = altToPred[i2];
      if (ambigAlts.get(i2)) {
        pairs.push({ pred, alt: i2 });
      }
      if (pred !== SemanticContext.NONE) {
        containsPredicate = true;
      }
    }
    if (!containsPredicate) {
      return null;
    }
    return pairs;
  }
  /**
   * This method is used to improve the localization of error messages by
   * choosing an alternative rather than throwing a
   * {@link NoViableAltException} in particular prediction scenarios where the
   * {@link ERROR} state was reached during ATN simulation.
   *
   *
   * The default implementation of this method uses the following
   * algorithm to identify an ATN configuration which successfully parsed the
   * decision entry rule. Choosing such an alternative ensures that the
   * {@link ParserRuleContext} returned by the calling rule will be complete
   * and valid, and the syntax error will be reported later at a more
   * localized location.
   *
   * - If a syntactically valid path or paths reach the end of the decision rule and
   * they are semantically valid if predicated, return the min associated alt.
   * - Else, if a semantically invalid but syntactically valid path exist
   * or paths exist, return the minimum associated alt.
   *
   * - Otherwise, return {@link ATN//INVALID_ALT_NUMBER}.
   *
   *
   * In some scenarios, the algorithm described above could predict an
   * alternative which will result in a {@link FailedPredicateException} in
   * the parser. Specifically, this could occur if the *only* configuration
   * capable of successfully parsing to the end of the decision rule is
   * blocked by a semantic predicate. By choosing this alternative within
   * {@link adaptivePredict} instead of throwing a
   * {@link NoViableAltException}, the resulting
   * {@link FailedPredicateException} in the parser will identify the specific
   * predicate which is preventing the parser from successfully parsing the
   * decision rule, which helps developers identify and correct logic errors
   * in semantic predicates.
   *
   * @param configs The ATN configurations which were valid immediately before
   * the {@link ERROR} state was reached
   * @param outerContext The is the \gamma_0 initial parser context from the paper
   * or the parser stack at the instant before prediction commences.
   *
   * @returns The value to return from {@link adaptivePredict}, or
   * {@link ATN//INVALID_ALT_NUMBER} if a suitable alternative was not
   * identified and {@link adaptivePredict} should report an error instead
   */
  getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(configs, outerContext) {
    const splitConfigs = this.splitAccordingToSemanticValidity(configs, outerContext);
    const semValidConfigs = splitConfigs[0];
    const semInvalidConfigs = splitConfigs[1];
    let alt = this.getAltThatFinishedDecisionEntryRule(semValidConfigs);
    if (alt !== ATN.INVALID_ALT_NUMBER) {
      return alt;
    }
    if (semInvalidConfigs.length > 0) {
      alt = this.getAltThatFinishedDecisionEntryRule(semInvalidConfigs);
      if (alt !== ATN.INVALID_ALT_NUMBER) {
        return alt;
      }
    }
    return ATN.INVALID_ALT_NUMBER;
  }
  getAltThatFinishedDecisionEntryRule(configs) {
    const alts = [];
    for (const c3 of configs) {
      if (c3.reachesIntoOuterContext || c3.state instanceof RuleStopState && c3.context.hasEmptyPath()) {
        if (alts.indexOf(c3.alt) < 0) {
          alts.push(c3.alt);
        }
      }
    }
    if (alts.length === 0) {
      return ATN.INVALID_ALT_NUMBER;
    } else {
      return Math.min(...alts);
    }
  }
  /**
   * Walk the list of configurations and split them according to
   * those that have preds evaluating to true/false.  If no pred, assume
   * true pred and include in succeeded set.  Returns Pair of sets.
   *
   * Create a new set so as not to alter the incoming parameter.
   *
   * Assumption: the input stream has been restored to the starting point
   * prediction, which is where predicates need to evaluate.
   */
  splitAccordingToSemanticValidity(configs, outerContext) {
    const succeeded = new ATNConfigSet(configs.fullCtx);
    const failed = new ATNConfigSet(configs.fullCtx);
    for (const c3 of configs) {
      if (c3.semanticContext !== SemanticContext.NONE) {
        const predicateEvaluationResult = c3.semanticContext.evaluate(this.parser, outerContext);
        if (predicateEvaluationResult) {
          succeeded.add(c3);
        } else {
          failed.add(c3);
        }
      } else {
        succeeded.add(c3);
      }
    }
    return [succeeded, failed];
  }
  /**
   * Look through a list of predicate/alt pairs, returning alts for the
   * pairs that win. A `NONE` predicate indicates an alt containing an
   * unpredicated config which behaves as "always true." If !complete
   * then we stop at the first predicate that evaluates to true. This
   * includes pairs with null predicates.
   */
  evalSemanticContext(predPredictions, outerContext, complete) {
    const predictions = new BitSet();
    for (const pair of predPredictions) {
      if (pair.pred === SemanticContext.NONE) {
        predictions.set(pair.alt);
        if (!complete) {
          break;
        }
        continue;
      }
      const predicateEvaluationResult = pair.pred.evaluate(this.parser, outerContext);
      if (_Ma.debug || _Ma.dfaDebug) {
        console.log("eval pred " + pair + "=" + predicateEvaluationResult);
      }
      if (predicateEvaluationResult) {
        predictions.set(pair.alt);
        if (!complete) {
          break;
        }
      }
    }
    return predictions;
  }
  // TODO: If we are doing predicates, there is no point in pursuing
  //     closure operations if we reach a DFA state that uniquely predicts
  //     alternative. We will not be caching that DFA state and it is a
  //     waste to pursue the closure. Might have to advance when we do
  //     ambig detection thought :(
  //
  closure(config, configs, closureBusy, collectPredicates, fullCtx, treatEofAsEpsilon) {
    const initialDepth = 0;
    this.closureCheckingStopState(
      config,
      configs,
      closureBusy,
      collectPredicates,
      fullCtx,
      initialDepth,
      treatEofAsEpsilon
    );
  }
  closureCheckingStopState(config, configs, closureBusy, collectPredicates, fullCtx, depth, treatEofAsEpsilon) {
    if (config.state instanceof RuleStopState) {
      if (config.context && !config.context.isEmpty()) {
        for (let i2 = 0; i2 < config.context.length; i2++) {
          if (config.context.getReturnState(i2) === PredictionContext.EMPTY_RETURN_STATE) {
            if (fullCtx) {
              configs.add(
                ATNConfig.createWithConfig(
                  config.state,
                  config,
                  EmptyPredictionContext.instance
                ),
                this.mergeCache
              );
              continue;
            } else {
              if (_Ma.debug) {
                console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
              }
              this.closure_(
                config,
                configs,
                closureBusy,
                collectPredicates,
                fullCtx,
                depth,
                treatEofAsEpsilon
              );
            }
            continue;
          }
          const returnState = this.atn.states[config.context.getReturnState(i2)];
          const newContext = config.context.getParent(i2);
          const c3 = ATNConfig.createWithContext(returnState, config.alt, newContext, config.semanticContext);
          c3.reachesIntoOuterContext = config.reachesIntoOuterContext;
          this.closureCheckingStopState(
            c3,
            configs,
            closureBusy,
            collectPredicates,
            fullCtx,
            depth - 1,
            treatEofAsEpsilon
          );
        }
        return;
      } else if (fullCtx) {
        configs.add(config, this.mergeCache);
        return;
      } else {
        if (_Ma.debug) {
          console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
        }
      }
    }
    this.closure_(config, configs, closureBusy, collectPredicates, fullCtx, depth, treatEofAsEpsilon);
  }
  // Do the actual work of walking epsilon edges//
  closure_(config, configs, closureBusy, collectPredicates, fullCtx, depth, treatEofAsEpsilon) {
    var _a3, _b3, _c3;
    const p2 = config.state;
    if (!p2.epsilonOnlyTransitions) {
      configs.add(config, this.mergeCache);
    }
    for (let i2 = 0; i2 < p2.transitions.length; i2++) {
      if (i2 === 0 && this.canDropLoopEntryEdgeInLeftRecursiveRule(config)) {
        continue;
      }
      const t2 = p2.transitions[i2];
      const continueCollecting = collectPredicates && !(t2 instanceof ActionTransition);
      const c3 = this.getEpsilonTarget(config, t2, continueCollecting, depth === 0, fullCtx, treatEofAsEpsilon);
      if (c3) {
        let newDepth = depth;
        if (config.state.constructor.stateType === ATNState.RULE_STOP) {
          if (this.predictionState.dfa && ((_a3 = this.predictionState) == null ? void 0 : _a3.dfa.isPrecedenceDfa)) {
            const outermostPrecedenceReturn = t2.outermostPrecedenceReturn;
            if (outermostPrecedenceReturn === ((_c3 = (_b3 = this.predictionState) == null ? void 0 : _b3.dfa.atnStartState) == null ? void 0 : _c3.ruleIndex)) {
              c3.precedenceFilterSuppressed = true;
            }
          }
          c3.reachesIntoOuterContext = true;
          if (closureBusy.getOrAdd(c3) !== c3) {
            continue;
          }
          configs.dipsIntoOuterContext = true;
          newDepth -= 1;
          if (_Ma.debug) {
            console.log("dips into outer ctx: " + c3);
          }
        } else {
          if (!t2.isEpsilon && closureBusy.getOrAdd(c3) !== c3) {
            continue;
          }
          if (t2 instanceof RuleTransition) {
            if (newDepth >= 0) {
              newDepth += 1;
            }
          }
        }
        this.closureCheckingStopState(
          c3,
          configs,
          closureBusy,
          continueCollecting,
          fullCtx,
          newDepth,
          treatEofAsEpsilon
        );
      }
    }
  }
  canDropLoopEntryEdgeInLeftRecursiveRule(config) {
    const p2 = config.state;
    if (p2.constructor.stateType !== ATNState.STAR_LOOP_ENTRY || !config.context) {
      return false;
    }
    if (!p2.precedenceRuleDecision || config.context.isEmpty() || config.context.hasEmptyPath()) {
      return false;
    }
    const numCtxs = config.context.length;
    for (let i2 = 0; i2 < numCtxs; i2++) {
      const returnState = this.atn.states[config.context.getReturnState(i2)];
      if (returnState.ruleIndex !== p2.ruleIndex) {
        return false;
      }
    }
    const decisionStartState = p2.transitions[0].target;
    const blockEndStateNum = decisionStartState.endState.stateNumber;
    const blockEndState = this.atn.states[blockEndStateNum];
    for (let i2 = 0; i2 < numCtxs; i2++) {
      const returnStateNumber = config.context.getReturnState(i2);
      const returnState = this.atn.states[returnStateNumber];
      if (returnState.transitions.length !== 1 || !returnState.transitions[0].isEpsilon) {
        return false;
      }
      const returnStateTarget = returnState.transitions[0].target;
      if (returnState.constructor.stateType === ATNState.BLOCK_END && returnStateTarget === p2) {
        continue;
      }
      if (returnState === blockEndState) {
        continue;
      }
      if (returnStateTarget === blockEndState) {
        continue;
      }
      if (returnStateTarget.constructor.stateType === ATNState.BLOCK_END && returnStateTarget.transitions.length === 1 && returnStateTarget.transitions[0].isEpsilon && returnStateTarget.transitions[0].target === p2) {
        continue;
      }
      return false;
    }
    return true;
  }
  getEpsilonTarget(config, t2, collectPredicates, inContext, fullCtx, treatEofAsEpsilon) {
    switch (t2.transitionType) {
      case Transition.RULE: {
        return this.ruleTransition(config, t2);
      }
      case Transition.PRECEDENCE: {
        return this.precedenceTransition(
          config,
          t2,
          collectPredicates,
          inContext,
          fullCtx
        );
      }
      case Transition.PREDICATE: {
        return this.predTransition(config, t2, collectPredicates, inContext, fullCtx);
      }
      case Transition.ACTION: {
        if (_Ma.debug) {
          const at2 = t2;
          const index2 = at2.actionIndex === -1 ? 65535 : at2.actionIndex;
          console.log("ACTION edge " + at2.ruleIndex + ":" + index2);
        }
        return ATNConfig.createWithConfig(t2.target, config);
      }
      case Transition.EPSILON: {
        return ATNConfig.createWithConfig(t2.target, config);
      }
      case Transition.ATOM:
      case Transition.RANGE:
      case Transition.SET: {
        if (treatEofAsEpsilon) {
          if (t2.matches(Token.EOF, 0, 1)) {
            return ATNConfig.createWithConfig(t2.target, config);
          }
        }
        return null;
      }
      default:
        return null;
    }
  }
  precedenceTransition(config, pt2, collectPredicates, inContext, fullCtx) {
    var _a3;
    if (_Ma.debug) {
      console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt2.precedence + ">=_p, ctx dependent=true");
      if (this.parser !== null) {
        console.log("context surrounding pred is " + arrayToString(this.parser.getRuleInvocationStack()));
      }
    }
    let c3 = null;
    if (collectPredicates && inContext) {
      if (fullCtx && ((_a3 = this.predictionState) == null ? void 0 : _a3.input)) {
        const currentPosition = this.predictionState.input.index;
        this.predictionState.input.seek(this.predictionState.startIndex);
        const predSucceeds = pt2.getPredicate().evaluate(this.parser, this.predictionState.outerContext);
        this.predictionState.input.seek(currentPosition);
        if (predSucceeds) {
          c3 = ATNConfig.createWithConfig(pt2.target, config);
        }
      } else {
        const newSemCtx = SemanticContext.andContext(config.semanticContext, pt2.getPredicate());
        c3 = ATNConfig.createWithSemanticContext(pt2.target, config, newSemCtx);
      }
    } else {
      c3 = ATNConfig.createWithConfig(pt2.target, config);
    }
    if (_Ma.debug) {
      console.log("config from pred transition=" + c3);
    }
    return c3;
  }
  predTransition(config, pt2, collectPredicates, inContext, fullCtx) {
    var _a3;
    if (_Ma.debug) {
      console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt2.ruleIndex + ":" + pt2.predIndex + ", ctx dependent=" + pt2.isCtxDependent);
      if (this.parser !== null) {
        console.log("context surrounding pred is " + arrayToString(this.parser.getRuleInvocationStack()));
      }
    }
    let c3 = null;
    if (collectPredicates && (pt2.isCtxDependent && inContext || !pt2.isCtxDependent)) {
      if (fullCtx && ((_a3 = this.predictionState) == null ? void 0 : _a3.input)) {
        const currentPosition = this.predictionState.input.index;
        this.predictionState.input.seek(this.predictionState.startIndex);
        const predSucceeds = pt2.getPredicate().evaluate(this.parser, this.predictionState.outerContext);
        this.predictionState.input.seek(currentPosition);
        if (predSucceeds) {
          c3 = ATNConfig.createWithConfig(pt2.target, config);
        }
      } else {
        const newSemCtx = SemanticContext.andContext(config.semanticContext, pt2.getPredicate());
        c3 = ATNConfig.createWithSemanticContext(pt2.target, config, newSemCtx);
      }
    } else {
      c3 = ATNConfig.createWithConfig(pt2.target, config);
    }
    if (_Ma.debug) {
      console.log("config from pred transition=" + c3);
    }
    return c3;
  }
  ruleTransition(config, t2) {
    if (_Ma.debug) {
      console.log("CALL rule " + this.getRuleName(t2.target.ruleIndex) + ", ctx=" + config.context);
    }
    const returnState = t2.followState;
    const newContext = createSingletonPredictionContext(config.context ?? void 0, returnState.stateNumber);
    return ATNConfig.createWithConfig(t2.target, config, newContext);
  }
  getConflictingAlts(configs) {
    const altSets = PredictionMode.getConflictingAltSubsets(configs);
    return PredictionMode.getAlts(altSets);
  }
  /**
   * Sam pointed out a problem with the previous definition, v3, of
   * ambiguous states. If we have another state associated with conflicting
   * alternatives, we should keep going. For example, the following grammar
   *
   * s : (ID | ID ID?) ';' ;
   *
   * When the ATN simulation reaches the state before ';', it has a DFA
   * state that looks like: [12|1|[], 6|2|[], 12|2|[]]. Naturally
   * 12|1|[] and 12|2|[] conflict, but we cannot stop processing this node
   * because alternative to has another way to continue, via [6|2|[]].
   * The key is that we have a single state that has config's only associated
   * with a single alternative, 2, and crucially the state transitions
   * among the configurations are all non-epsilon transitions. That means
   * we don't consider any conflicts that include alternative 2. So, we
   * ignore the conflict between alts 1 and 2. We ignore a set of
   * conflicting alts when there is an intersection with an alternative
   * associated with a single alt state in the state -> config-list map.
   *
   * It's also the case that we might have two conflicting configurations but
   * also a 3rd nonconflicting configuration for a different alternative:
   * [1|1|[], 1|2|[], 8|3|[]]. This can come about from grammar:
   *
   * a : A | A | A B ;
   *
   * After matching input A, we reach the stop state for rule A, state 1.
   * State 8 is the state right before B. Clearly alternatives 1 and 2
   * conflict and no amount of further lookahead will separate the two.
   * However, alternative 3 will be able to continue and so we do not
   * stop working on this state. In the previous example, we're concerned
   * with states associated with the conflicting alternatives. Here alt
   * 3 is not associated with the conflicting configs, but since we can continue
   * looking for input reasonably, I don't declare the state done. We
   * ignore a set of conflicting alts when we have an alternative
   * that we still need to pursue
   */
  getConflictingAltsOrUniqueAlt(configs) {
    let conflictingAlts;
    if (configs.uniqueAlt !== ATN.INVALID_ALT_NUMBER) {
      conflictingAlts = new BitSet();
      conflictingAlts.set(configs.uniqueAlt);
    } else {
      conflictingAlts = configs.conflictingAlts;
    }
    return conflictingAlts;
  }
  noViableAlt(input, outerContext, configs, startIndex) {
    return new NoViableAltException(this.parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
  }
  /**
   * Add an edge to the DFA, if possible. This method calls
   * {@link addDFAState} to ensure the `to` state is present in the
   * DFA. If `from` is `null`, or if `t` is outside the
   * range of edges that can be represented in the DFA tables, this method
   * returns without adding the edge to the DFA.
   *
   * If `to` is `null`, this method returns `null`.
   * Otherwise, this method returns the {@link DFAState} returned by calling
   * {@link addDFAState} for the `to` state.
   *
   * @param dfa The DFA
   * @param from The source state for the edge
   * @param t The input symbol
   * @param to The target state for the edge
   *
   * @returns If `to` is `null`, this method returns `null`;
   * otherwise this method returns the result of calling {@link addDFAState}
   * on `to`
   */
  addDFAEdge(dfa, from, t2, to2) {
    if (_Ma.debug) {
      console.log("EDGE " + from + " -> " + to2 + " upon " + this.getTokenName(t2));
    }
    to2 = this.addDFAState(dfa, to2);
    if (t2 < -1 || t2 > this.atn.maxTokenType) {
      return to2;
    }
    if (_Ma.debug) {
      console.log("DFA=\n" + dfa.toString(this.parser != null ? this.parser.vocabulary : Vocabulary.EMPTY_VOCABULARY));
    }
    from.edges[t2 + 1] = to2;
    return to2;
  }
  /**
   * Add state `D` to the DFA if it is not already present, and return
   * the actual instance stored in the DFA. If a state equivalent to `D`
   * is already in the DFA, the existing state is returned. Otherwise this
   * method returns `D` after adding it to the DFA.
   *
   * If `D` is {@link ERROR}, this method returns {@link ERROR} and
   * does not change the DFA.
   *
   * @param dfa The dfa.
   * @param newState The DFA state to add.
   *
   * @returns The state stored in the DFA. This will be either the existing state if `newState` is already in
   *          the DFA, or `newState` itself if the state was not already present.
   */
  addDFAState(dfa, newState) {
    if (newState === ATNSimulator.ERROR) {
      return newState;
    }
    const existing = dfa.getState(newState);
    if (existing !== null) {
      return existing;
    }
    if (!newState.configs.readOnly) {
      newState.configs.optimizeConfigs(this);
      newState.configs.setReadonly(true);
    }
    dfa.addState(newState);
    return newState;
  }
  reportAttemptingFullContext(dfa, conflictingAlts, configs, startIndex, stopIndex) {
    if (_Ma.debug || _Ma.retryDebug) {
      const interval = new Interval(startIndex, stopIndex + 1);
      console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + configs + ", input=" + this.parser.tokenStream.getTextFromInterval(interval));
    }
    this.parser.errorListenerDispatch.reportAttemptingFullContext(
      this.parser,
      dfa,
      startIndex,
      stopIndex,
      conflictingAlts,
      configs
    );
  }
  reportContextSensitivity(dfa, prediction, configs, startIndex, stopIndex) {
    if (_Ma.debug || _Ma.retryDebug) {
      const interval = new Interval(startIndex, stopIndex + 1);
      console.log("reportContextSensitivity decision=" + dfa.decision + ":" + configs + ", input=" + this.parser.tokenStream.getTextFromInterval(interval));
    }
    this.parser.errorListenerDispatch.reportContextSensitivity(
      this.parser,
      dfa,
      startIndex,
      stopIndex,
      prediction,
      configs
    );
  }
  // If context sensitive parsing, we know it's ambiguity not conflict.
  reportAmbiguity(dfa, D2, startIndex, stopIndex, exact, ambigAlts, configs) {
    if (_Ma.debug || _Ma.retryDebug) {
      const interval = new Interval(startIndex, stopIndex + 1);
      console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this.parser.tokenStream.getTextFromInterval(interval));
    }
    this.parser.errorListenerDispatch.reportAmbiguity(
      this.parser,
      dfa,
      startIndex,
      stopIndex,
      exact,
      ambigAlts,
      configs
    );
  }
}, __name(_Ma, "ParserATNSimulator"), __publicField(_Ma, "traceATNSimulator", false), __publicField(_Ma, "debug"), __publicField(_Ma, "debugAdd", false), __publicField(_Ma, "debugClosure", false), __publicField(_Ma, "dfaDebug", false), __publicField(_Ma, "retryDebug", false), _Ma);
var PredictionContextCache = (_Na = class {
  constructor() {
    __publicField(this, "cache", new HashMap(ObjectEqualityComparator.instance));
  }
  /**
   * Add a context to the cache and return it. If the context already exists,
   * return that one instead and do not add a new context to the cache.
   * Protect shared cache from unsafe thread access.
   *
   * @param ctx tbd
   * @returns tbd
   */
  add(ctx) {
    if (ctx === EmptyPredictionContext.instance) {
      return ctx;
    }
    const existing = this.cache.get(ctx);
    if (existing) {
      return existing;
    }
    this.cache.set(ctx, ctx);
    return ctx;
  }
  get(ctx) {
    return this.cache.get(ctx);
  }
  get length() {
    return this.cache.size;
  }
}, __name(_Na, "PredictionContextCache"), _Na);
var ProfilingATNSimulator = (_Oa = class extends ParserATNSimulator {
  constructor(parser) {
    const sharedContextCache = parser.interpreter.sharedContextCache;
    super(parser, parser.interpreter.atn, parser.interpreter.decisionToDFA, sharedContextCache);
    __publicField(this, "decisions");
    __publicField(this, "numDecisions", 0);
    __publicField(this, "currentDecision", 0);
    __publicField(this, "currentState");
    /**
     * At the point of LL failover, we record how SLL would resolve the conflict so that
     *  we can determine whether or not a decision / input pair is context-sensitive.
     *  If LL gives a different result than SLL's predicted alternative, we have a
     *  context sensitivity for sure. The converse is not necessarily true, however.
     *  It's possible that after conflict resolution chooses minimum alternatives,
     *  SLL could get the same answer as LL. Regardless of whether or not the result indicates
     *  an ambiguity, it is not treated as a context sensitivity because LL prediction
     *  was not required in order to produce a correct prediction for this decision and input sequence.
     *  It may in fact still be a context sensitivity but we don't know by looking at the
     *  minimum alternatives for the current input.
     */
    __publicField(this, "conflictingAltResolvedBySLL");
    __publicField(this, "sllStopIndex", 0);
    __publicField(this, "llStopIndex", 0);
    if (sharedContextCache) {
      this.numDecisions = this.atn.decisionToState.length;
      this.decisions = new Array(this.numDecisions);
      for (let i2 = 0; i2 < this.numDecisions; i2++) {
        this.decisions[i2] = new DecisionInfo(i2);
      }
    }
  }
  adaptivePredict(input, decision, outerContext) {
    try {
      this.sllStopIndex = -1;
      this.llStopIndex = -1;
      this.currentDecision = decision;
      const start = performance.now();
      const alt = super.adaptivePredict(input, decision, outerContext);
      const stop = performance.now();
      this.decisions[decision].timeInPrediction += stop - start;
      this.decisions[decision].invocations++;
      const sllLook = this.sllStopIndex - this.predictionState.startIndex + 1;
      this.decisions[decision].sllTotalLook += sllLook;
      this.decisions[decision].sllMinLook = this.decisions[decision].sllMinLook === 0 ? sllLook : Math.min(this.decisions[decision].sllMinLook, sllLook);
      if (sllLook > this.decisions[decision].sllMaxLook) {
        this.decisions[decision].sllMaxLook = sllLook;
        this.decisions[decision].sllMaxLookEvent = {
          decision,
          configs: null,
          predictedAlt: alt,
          input,
          startIndex: this.predictionState.startIndex,
          stopIndex: this.sllStopIndex,
          fullCtx: false
        };
      }
      if (this.llStopIndex >= 0) {
        const llLook = this.llStopIndex - this.predictionState.startIndex + 1;
        this.decisions[decision].llTotalLook += llLook;
        this.decisions[decision].llMinLook = this.decisions[decision].llMinLook === 0 ? llLook : Math.min(this.decisions[decision].llMinLook, llLook);
        if (llLook > this.decisions[decision].llMaxLook) {
          this.decisions[decision].llMaxLook = llLook;
          this.decisions[decision].llMaxLookEvent = {
            decision,
            configs: null,
            predictedAlt: alt,
            input,
            startIndex: this.predictionState.startIndex,
            stopIndex: this.llStopIndex,
            fullCtx: true
          };
        }
      }
      return alt;
    } finally {
      this.currentDecision = -1;
    }
  }
  getExistingTargetState(previousD, t2) {
    this.sllStopIndex = this.predictionState.input.index;
    const existingTargetState = super.getExistingTargetState(previousD, t2);
    if (existingTargetState !== void 0) {
      this.decisions[this.currentDecision].sllDFATransitions++;
      if (existingTargetState === ATNSimulator.ERROR) {
        this.decisions[this.currentDecision].errors.push({
          decision: this.currentDecision,
          configs: previousD.configs,
          input: this.predictionState.input,
          startIndex: this.predictionState.startIndex,
          stopIndex: this.sllStopIndex,
          fullCtx: false
        });
      }
    }
    this.currentState = existingTargetState;
    return existingTargetState;
  }
  computeTargetState(dfa, previousD, t2) {
    const state = super.computeTargetState(dfa, previousD, t2);
    this.currentState = state;
    return state;
  }
  computeReachSet(closure, t2, fullCtx) {
    var _a3, _b3;
    if (fullCtx && ((_a3 = this.predictionState) == null ? void 0 : _a3.input)) {
      this.llStopIndex = this.predictionState.input.index;
    }
    const reachConfigs = super.computeReachSet(closure, t2, fullCtx);
    if ((_b3 = this.predictionState) == null ? void 0 : _b3.input) {
      if (fullCtx) {
        this.decisions[this.currentDecision].llATNTransitions++;
        if (reachConfigs === null) {
          this.decisions[this.currentDecision].errors.push({
            decision: this.currentDecision,
            configs: closure,
            input: this.predictionState.input,
            startIndex: this.predictionState.startIndex,
            stopIndex: this.sllStopIndex,
            fullCtx: true
          });
        }
      } else {
        this.decisions[this.currentDecision].sllATNTransitions++;
        if (reachConfigs === null) {
          this.decisions[this.currentDecision].errors.push({
            decision: this.currentDecision,
            configs: closure,
            input: this.predictionState.input,
            startIndex: this.predictionState.startIndex,
            stopIndex: this.sllStopIndex,
            fullCtx: false
          });
        }
      }
    }
    return reachConfigs;
  }
  reportAttemptingFullContext(dfa, conflictingAlts, configs, startIndex, stopIndex) {
    if (conflictingAlts !== null) {
      this.conflictingAltResolvedBySLL = conflictingAlts.nextSetBit(0);
    } else {
      this.conflictingAltResolvedBySLL = configs.getAlts().nextSetBit(0);
    }
    this.decisions[this.currentDecision].llFallback++;
    if (conflictingAlts) {
      super.reportAttemptingFullContext(dfa, conflictingAlts, configs, startIndex, stopIndex);
    }
  }
  reportContextSensitivity(dfa, prediction, configs, startIndex, stopIndex) {
    if (prediction !== this.conflictingAltResolvedBySLL && this.predictionState.input) {
      this.decisions[this.currentDecision].contextSensitivities.push({
        decision: this.currentDecision,
        configs,
        input: this.predictionState.input,
        startIndex,
        stopIndex,
        fullCtx: true
      });
    }
    super.reportContextSensitivity(dfa, prediction, configs, startIndex, stopIndex);
  }
  reportAmbiguity(dfa, state, startIndex, stopIndex, exact, ambigAlts, configs) {
    var _a3;
    let prediction;
    if (ambigAlts) {
      prediction = ambigAlts.nextSetBit(0);
    } else {
      prediction = configs.getAlts().nextSetBit(0);
    }
    if ((_a3 = this.predictionState) == null ? void 0 : _a3.input) {
      if (configs.fullCtx && prediction !== this.conflictingAltResolvedBySLL) {
        this.decisions[this.currentDecision].contextSensitivities.push({
          decision: this.currentDecision,
          configs,
          input: this.predictionState.input,
          startIndex,
          stopIndex,
          fullCtx: true
        });
      }
      this.decisions[this.currentDecision].ambiguities.push({
        ambigAlts,
        decision: this.currentDecision,
        configs,
        input: this.predictionState.input,
        startIndex,
        stopIndex,
        fullCtx: configs.fullCtx
      });
    }
    super.reportAmbiguity(dfa, state, startIndex, stopIndex, exact, ambigAlts, configs);
  }
  getDecisionInfo() {
    return this.decisions;
  }
  getCurrentState() {
    return this.currentState;
  }
}, __name(_Oa, "ProfilingATNSimulator"), _Oa);
var PredPrediction;
((PredPrediction2) => {
  PredPrediction2.toString = /* @__PURE__ */ __name((prediction) => {
    return `(${prediction.pred}, ${prediction.alt})`;
  }, "toString");
})(PredPrediction || (PredPrediction = {}));
var ParseCancellationException = (_Pa = class extends Error {
  constructor(e10) {
    super();
    this.cause = e10;
  }
}, __name(_Pa, "ParseCancellationException"), _Pa);
_Qa = class {
  /**
   * The structure of the data file is very simple. Everything is line based with empty lines
   * separating the different parts. For lexers the layout is:
   * token literal names:
   * ...
   *
   * token symbolic names:
   * ...
   *
   * rule names:
   * ...
   *
   * channel names:
   * ...
   *
   * mode names:
   * ...
   *
   * atn:
   * a single line with comma separated int values, enclosed in a pair of squared brackets.
   *
   * Data for a parser does not contain channel and mode names.
   */
  static parseInterpreterData(source) {
    const ruleNames = [];
    const channels = [];
    const modes = [];
    const literalNames = [];
    const symbolicNames = [];
    const lines = source.split("\n");
    let index2 = 0;
    let line = lines[index2++];
    if (line !== "token literal names:") {
      throw new Error("Unexpected data entry");
    }
    do {
      line = lines[index2++];
      if (line.length === 0) {
        break;
      }
      literalNames.push(line === "null" ? null : line);
    } while (true);
    line = lines[index2++];
    if (line !== "token symbolic names:") {
      throw new Error("Unexpected data entry");
    }
    do {
      line = lines[index2++];
      if (line.length === 0) {
        break;
      }
      symbolicNames.push(line === "null" ? null : line);
    } while (true);
    line = lines[index2++];
    if (line !== "rule names:") {
      throw new Error("Unexpected data entry");
    }
    do {
      line = lines[index2++];
      if (line.length === 0) {
        break;
      }
      ruleNames.push(line);
    } while (true);
    line = lines[index2++];
    if (line === "channel names:") {
      do {
        line = lines[index2++];
        if (line.length === 0) {
          break;
        }
        channels.push(line);
      } while (true);
      line = lines[index2++];
      if (line !== "mode names:") {
        throw new Error("Unexpected data entry");
      }
      do {
        line = lines[index2++];
        if (line.length === 0) {
          break;
        }
        modes.push(line);
      } while (true);
    }
    line = lines[index2++];
    if (line !== "atn:") {
      throw new Error("Unexpected data entry");
    }
    line = lines[index2++];
    const elements = line.split(",");
    let value;
    const serializedATN = [];
    for (let i2 = 0; i2 < elements.length; ++i2) {
      const element = elements[i2];
      if (element.startsWith("[")) {
        value = Number(element.substring(1).trim());
      } else if (element.endsWith("]")) {
        value = Number(element.substring(0, element.length - 1).trim());
      } else {
        value = Number(element.trim());
      }
      serializedATN[i2] = value;
    }
    const deserializer = new ATNDeserializer();
    return {
      atn: deserializer.deserialize(serializedATN),
      vocabulary: new Vocabulary(literalNames, symbolicNames, []),
      ruleNames,
      channels: channels.length > 0 ? channels : void 0,
      modes: modes.length > 0 ? modes : void 0
    };
  }
}, __name(_Qa, "InterpreterDataReader"), _Qa;
_Ra = class {
  visit(tree) {
    return tree.accept(this);
  }
  visitChildren(node) {
    let result = this.defaultResult();
    const n2 = node.getChildCount();
    for (let i2 = 0; i2 < n2; i2++) {
      if (!this.shouldVisitNextChild(node, result)) {
        break;
      }
      const c3 = node.getChild(i2);
      if (c3) {
        const childResult = c3.accept(this);
        result = this.aggregateResult(result, childResult);
      }
    }
    return result;
  }
  visitTerminal(_node) {
    return this.defaultResult();
  }
  visitErrorNode(_node) {
    return this.defaultResult();
  }
  defaultResult() {
    return null;
  }
  shouldVisitNextChild(_node, _currentResult) {
    return true;
  }
  aggregateResult(aggregate, nextResult) {
    return nextResult;
  }
}, __name(_Ra, "AbstractParseTreeVisitor"), _Ra;
_Sa = class {
  /**
   * Performs a walk on the given parse tree starting at the root and going down recursively
   * with depth-first search. On each node, {@link ParseTreeWalker.enterRule} is called before
   * recursively walking down into child nodes, then
   * {@link ParseTreeWalker.exitRule} is called after the recursive call to wind up.
   *
   * @param listener The listener used by the walker to process grammar rules
   * @param t The parse tree to be walked on
   */
  walk(listener, t2) {
    const errorNode = t2 instanceof ErrorNode;
    if (errorNode) {
      listener.visitErrorNode(t2);
    } else if (t2 instanceof TerminalNode) {
      listener.visitTerminal(t2);
    } else {
      const r3 = t2;
      this.enterRule(listener, r3);
      for (let i2 = 0; i2 < t2.getChildCount(); i2++) {
        this.walk(listener, t2.getChild(i2));
      }
      this.exitRule(listener, r3);
    }
  }
  /**
   * Enters a grammar rule by first triggering the generic event {@link ParseTreeListener.enterEveryRule}
   * then by triggering the event specific to the given parse tree node
   *
   * @param listener The listener responding to the trigger events
   * @param r The grammar rule containing the rule context
   */
  enterRule(listener, r3) {
    const ctx = r3.ruleContext;
    listener.enterEveryRule(ctx);
    ctx.enterRule(listener);
  }
  /**
   * Exits a grammar rule by first triggering the event specific to the given parse tree node
   * then by triggering the generic event {@link ParseTreeListener.exitEveryRule}
   *
   * @param listener The listener responding to the trigger events
   * @param r The grammar rule containing the rule context
   */
  exitRule(listener, r3) {
    const ctx = r3.ruleContext;
    ctx.exitRule(listener);
    listener.exitEveryRule(ctx);
  }
}, __name(_Sa, "ParseTreeWalker"), __publicField(_Sa, "DEFAULT", new _Sa()), _Sa;
var CharStream;
((CharStream2) => {
  CharStream2.fromString = /* @__PURE__ */ __name((str) => {
    return new CharStreamImpl(str);
  }, "fromString");
})(CharStream || (CharStream = {}));
var CharStreamImpl = (_Ta = class {
  constructor(input) {
    __publicField(this, "name", "");
    __publicField(this, "index", 0);
    __publicField(this, "data");
    const codePoints = [];
    for (const char of input) {
      codePoints.push(char.codePointAt(0));
    }
    this.data = new Uint32Array(codePoints);
  }
  /**
   * Reset the stream so that it's in the same state it was
   * when the object was created *except* the data array is not
   * touched.
   */
  reset() {
    this.index = 0;
  }
  consume() {
    if (this.index >= this.data.length) {
      throw new Error("cannot consume EOF");
    }
    this.index += 1;
  }
  LA(offset) {
    if (offset === 0) {
      return 0;
    }
    if (offset < 0) {
      offset += 1;
    }
    const pos = this.index + offset - 1;
    if (pos < 0 || pos >= this.data.length) {
      return Token.EOF;
    }
    return this.data[pos];
  }
  // mark/release do nothing; we have entire buffer
  mark() {
    return -1;
  }
  release(_marker) {
  }
  /**
   * consume() ahead until p==_index; can't just set p=_index as we must
   * update line and column. If we seek backwards, just set p
   */
  seek(index2) {
    if (index2 <= this.index) {
      this.index = index2;
      return;
    }
    this.index = Math.min(index2, this.data.length);
  }
  getTextFromRange(start, stop) {
    stop = stop ?? this.data.length - 1;
    if (stop >= this.data.length) {
      stop = this.data.length - 1;
    }
    if (start >= this.data.length) {
      return "";
    }
    return this.stringFromRange(start, stop + 1);
  }
  getTextFromInterval(interval) {
    const start = interval.start;
    let stop = interval.stop;
    if (stop >= this.data.length) {
      stop = this.data.length - 1;
    }
    if (start >= this.data.length) {
      return "";
    }
    return this.stringFromRange(start, stop + 1);
  }
  toString() {
    return this.stringFromRange(0);
  }
  get size() {
    return this.data.length;
  }
  getSourceName() {
    if (this.name) {
      return this.name;
    }
    return IntStream.UNKNOWN_SOURCE_NAME;
  }
  stringFromRange(start, stop) {
    const data = this.data.slice(start, stop);
    let result = "";
    data.forEach((value) => {
      result += String.fromCodePoint(value);
    });
    return result;
  }
}, __name(_Ta, "CharStreamImpl"), _Ta);
var isWritableToken = /* @__PURE__ */ __name((candidate) => {
  return candidate.setText !== void 0;
}, "isWritableToken");
var BufferedTokenStream = (_Ua = class {
  constructor(tokenSource) {
    /**
     * The {@link TokenSource} from which tokens for this stream are fetched.
     */
    __publicField(this, "tokenSource");
    /**
     * A collection of all tokens fetched from the token source. The list is
     * considered a complete view of the input once {@link fetchedEOF} is set
     * to `true`.
     */
    __publicField(this, "tokens", []);
    /**
     * The index into {@link tokens} of the current token (next token to
     * {@link consume}). {@link tokens}`[p]` should be
     * {@link LT LT(1)}.
     *
     * This field is set to -1 when the stream is first constructed or when
     * {@link setTokenSource} is called, indicating that the first token has
     * not yet been fetched from the token source. For additional information,
     * see the documentation of {@link IntStream} for a description of
     * Initializing Methods.
     */
    __publicField(this, "p", -1);
    /**
     * Indicates whether the {@link Token.EOF} token has been fetched from
     * {@link tokenSource} and added to {@link tokens}. This field improves
     * performance for the following cases:
     *
     * - {@link consume}: The lookahead check in {@link consume} to prevent
     * consuming the EOF symbol is optimized by checking the values of
     * {@link fetchedEOF} and {@link p} instead of calling {@link LA}.
     * - {@link fetch}: The check to prevent adding multiple EOF symbols into
     * {@link tokens} is trivial with this field.
     */
    __publicField(this, "fetchedEOF", false);
    this.tokenSource = tokenSource;
  }
  mark() {
    return 0;
  }
  release(_marker) {
  }
  reset() {
    this.seek(0);
  }
  seek(index2) {
    this.lazyInit();
    this.p = this.adjustSeekIndex(index2);
  }
  get size() {
    return this.tokens.length;
  }
  get index() {
    return this.p;
  }
  get(index2) {
    this.lazyInit();
    return this.tokens[index2];
  }
  consume() {
    let skipEofCheck = false;
    if (this.p >= 0) {
      if (this.fetchedEOF) {
        skipEofCheck = this.p < this.tokens.length - 1;
      } else {
        skipEofCheck = this.p < this.tokens.length;
      }
    } else {
      skipEofCheck = false;
    }
    if (!skipEofCheck && this.LA(1) === Token.EOF) {
      throw new Error("cannot consume EOF");
    }
    if (this.sync(this.p + 1)) {
      this.p = this.adjustSeekIndex(this.p + 1);
    }
  }
  /**
   * Make sure index `i` in tokens has a token.
   *
   * @returns {boolean} `true` if a token is located at index `i`, otherwise `false`.
   */
  sync(i2) {
    const n2 = i2 - this.tokens.length + 1;
    if (n2 > 0) {
      const fetched = this.fetch(n2);
      return fetched >= n2;
    }
    return true;
  }
  /**
   * Add `n` elements to buffer.
   *
   * @returns {number} The actual number of elements added to the buffer.
   */
  fetch(n2) {
    if (this.fetchedEOF) {
      return 0;
    }
    for (let i2 = 0; i2 < n2; i2++) {
      const t2 = this.tokenSource.nextToken();
      if (isWritableToken(t2)) {
        t2.tokenIndex = this.tokens.length;
      }
      this.tokens.push(t2);
      if (t2.type === Token.EOF) {
        this.fetchedEOF = true;
        return i2 + 1;
      }
    }
    return n2;
  }
  /** Get all tokens from start..stop, inclusively. */
  getTokens(start, stop, types2) {
    this.lazyInit();
    if (start === void 0 && stop === void 0) {
      return this.tokens;
    }
    start ?? (start = 0);
    if (stop === void 0) {
      stop = this.tokens.length - 1;
    }
    if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) {
      throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
    }
    if (start > stop) {
      return [];
    }
    if (types2 === void 0) {
      return this.tokens.slice(start, stop + 1);
    }
    const subset = [];
    if (stop >= this.tokens.length) {
      stop = this.tokens.length - 1;
    }
    for (let i2 = start; i2 < stop; i2++) {
      const t2 = this.tokens[i2];
      if (t2.type === Token.EOF) {
        subset.push(t2);
        break;
      }
      if (types2.has(t2.type)) {
        subset.push(t2);
      }
    }
    return subset;
  }
  LA(k2) {
    var _a3;
    return ((_a3 = this.LT(k2)) == null ? void 0 : _a3.type) ?? Token.INVALID_TYPE;
  }
  LB(k2) {
    if (this.p - k2 < 0) {
      return null;
    }
    return this.tokens[this.p - k2];
  }
  LT(k2) {
    this.lazyInit();
    if (k2 === 0) {
      return null;
    }
    if (k2 < 0) {
      return this.LB(-k2);
    }
    const i2 = this.p + k2 - 1;
    this.sync(i2);
    if (i2 >= this.tokens.length) {
      return this.tokens[this.tokens.length - 1];
    }
    return this.tokens[i2];
  }
  /**
   * Allowed derived classes to modify the behavior of operations which change
   * the current stream position by adjusting the target token index of a seek
   * operation. The default implementation simply returns `i`. If an
   * exception is thrown in this method, the current stream index should not be
   * changed.
   *
   * For example, {@link CommonTokenStream} overrides this method to ensure that
   * the seek target is always an on-channel token.
   *
   * @param  i The target token index.
   *
   * @returns The adjusted target token index.
   */
  adjustSeekIndex(i2) {
    return i2;
  }
  lazyInit() {
    if (this.p === -1) {
      this.setup();
    }
  }
  setup() {
    this.sync(0);
    this.p = this.adjustSeekIndex(0);
  }
  /** Reset this token stream by setting its token source. */
  setTokenSource(tokenSource) {
    this.tokenSource = tokenSource;
    this.tokens = [];
    this.p = -1;
    this.fetchedEOF = false;
  }
  /**
   * Given a starting index, return the index of the next token on channel.
   * Return i if tokens[i] is on channel. Return -1 if there are no tokens
   * on channel between i and EOF.
   */
  nextTokenOnChannel(i2, channel) {
    this.sync(i2);
    if (i2 >= this.tokens.length) {
      return -1;
    }
    let token = this.tokens[i2];
    while (token.channel !== channel) {
      if (token.type === Token.EOF) {
        return -1;
      }
      i2 += 1;
      this.sync(i2);
      token = this.tokens[i2];
    }
    return i2;
  }
  /**
   * Given a starting index, return the index of the previous token on
   * channel. Return `i` if `tokens[i]` is on channel. Return -1
   * if there are no tokens on channel between `i` and 0.
   *
   * If `i` specifies an index at or after the EOF token, the EOF token
   * index is returned. This is due to the fact that the EOF token is treated
   * as though it were on every channel.
   */
  previousTokenOnChannel(i2, channel) {
    if (i2 >= this.tokens.length) {
      return this.tokens.length - 1;
    }
    while (i2 >= 0) {
      const token = this.tokens[i2];
      if (token.type === Token.EOF || token.channel === channel) {
        return i2;
      }
      --i2;
    }
    return i2;
  }
  /**
   * Collect all tokens on specified channel to the right of
   * the current token up until we see a token on DEFAULT_TOKEN_CHANNEL or
   * EOF. If channel is -1, find any non default channel token.
   */
  getHiddenTokensToRight(tokenIndex, channel) {
    if (channel === void 0) {
      channel = -1;
    }
    this.lazyInit();
    if (tokenIndex < 0 || tokenIndex >= this.tokens.length) {
      throw new Error(`${tokenIndex} not in 0..${this.tokens.length - 1}`);
    }
    const nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, Lexer.DEFAULT_TOKEN_CHANNEL);
    const from = tokenIndex + 1;
    const to2 = nextOnChannel === -1 ? this.tokens.length - 1 : nextOnChannel;
    return this.filterForChannel(from, to2, channel);
  }
  /**
   * Collect all tokens on specified channel to the left of
   * the current token up until we see a token on DEFAULT_TOKEN_CHANNEL.
   * If channel is -1, find any non default channel token.
   */
  getHiddenTokensToLeft(tokenIndex, channel) {
    if (channel === void 0) {
      channel = -1;
    }
    this.lazyInit();
    if (tokenIndex < 0 || tokenIndex >= this.tokens.length) {
      throw new Error(`${tokenIndex} not in 0..${this.tokens.length - 1}`);
    }
    const prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, Lexer.DEFAULT_TOKEN_CHANNEL);
    if (prevOnChannel === tokenIndex - 1) {
      return void 0;
    }
    const from = prevOnChannel + 1;
    const to2 = tokenIndex - 1;
    return this.filterForChannel(from, to2, channel);
  }
  filterForChannel(left, right, channel) {
    const hidden = [];
    for (let i2 = left; i2 < right + 1; i2++) {
      const t2 = this.tokens[i2];
      if (channel === -1) {
        if (t2.channel !== Lexer.DEFAULT_TOKEN_CHANNEL) {
          hidden.push(t2);
        }
      } else if (t2.channel === channel) {
        hidden.push(t2);
      }
    }
    if (hidden.length === 0) {
      return void 0;
    }
    return hidden;
  }
  getSourceName() {
    return this.tokenSource.sourceName;
  }
  /** Get the text of all tokens in this buffer. */
  getText() {
    return this.getTextFromInterval(Interval.of(0, this.size - 1));
  }
  getTextFromInterval(interval) {
    const start = interval.start;
    let stop = interval.stop;
    if (start < 0 || stop < 0) {
      return "";
    }
    this.sync(stop);
    if (stop >= this.tokens.length) {
      stop = this.tokens.length - 1;
    }
    let result = "";
    for (let i2 = start; i2 <= stop; ++i2) {
      const t2 = this.tokens[i2];
      if (t2.type === Token.EOF) {
        break;
      }
      result += t2.text;
    }
    return result;
  }
  getTextFromContext(ctx) {
    return this.getTextFromInterval(ctx.getSourceInterval());
  }
  getTextFromRange(start, stop) {
    if (start !== null && stop !== null) {
      return this.getTextFromInterval(Interval.of(start.tokenIndex, stop.tokenIndex));
    }
    return "";
  }
  /** Get all tokens from lexer until EOF. */
  fill() {
    this.lazyInit();
    while (this.fetch(1e3) === 1e3) {
    }
  }
  setLine(line) {
    this.tokenSource.line = line;
  }
  setColumn(column) {
    this.tokenSource.column = column;
  }
}, __name(_Ua, "BufferedTokenStream"), _Ua);
var CommonTokenStream = (_Va = class extends BufferedTokenStream {
  constructor(lexer, channel) {
    super(lexer);
    /**
     * Specifies the channel to use for filtering tokens.
     *
     *
     * The default value is {@link Token.DEFAULT_CHANNEL}, which matches the
     * default channel assigned to tokens created by the lexer.
     */
    __publicField(this, "channel", Token.DEFAULT_CHANNEL);
    this.channel = channel ?? Token.DEFAULT_CHANNEL;
  }
  adjustSeekIndex(i2) {
    return this.nextTokenOnChannel(i2, this.channel);
  }
  LB(k2) {
    if (k2 === 0 || this.index - k2 < 0) {
      return null;
    }
    let i2 = this.index;
    let n2 = 1;
    while (n2 <= k2) {
      i2 = this.previousTokenOnChannel(i2 - 1, this.channel);
      n2 += 1;
    }
    if (i2 < 0) {
      return null;
    }
    return this.tokens[i2];
  }
  LT(k2) {
    this.lazyInit();
    if (k2 === 0) {
      return null;
    }
    if (k2 < 0) {
      return this.LB(-k2);
    }
    let i2 = this.index;
    let n2 = 1;
    while (n2 < k2) {
      if (this.sync(i2 + 1)) {
        i2 = this.nextTokenOnChannel(i2 + 1, this.channel);
      }
      n2 += 1;
    }
    return this.tokens[i2];
  }
  // Count EOF just once.
  getNumberOfOnChannelTokens() {
    let n2 = 0;
    this.fill();
    for (const t2 of this.tokens) {
      if (t2.channel === this.channel) {
        n2 += 1;
      }
      if (t2.type === Token.EOF) {
        break;
      }
    }
    return n2;
  }
}, __name(_Va, "CommonTokenStream"), _Va);
var XPathLexer = (_Wa = class extends Lexer {
  constructor(input) {
    super(input);
    this.interpreter = new LexerATNSimulator(this, _Wa._ATN, _Wa.decisionsToDFA, new PredictionContextCache());
  }
  get grammarFileName() {
    return "XPathLexer.g4";
  }
  get literalNames() {
    return _Wa.literalNames;
  }
  get symbolicNames() {
    return _Wa.symbolicNames;
  }
  get ruleNames() {
    return _Wa.ruleNames;
  }
  get serializedATN() {
    return _Wa._serializedATN;
  }
  get channelNames() {
    return _Wa.channelNames;
  }
  get modeNames() {
    return _Wa.modeNames;
  }
  action(localContext, ruleIndex, actionIndex) {
    switch (ruleIndex) {
      case 4:
        this.ID_action(localContext, actionIndex);
        break;
    }
  }
  ID_action(localContext, actionIndex) {
    switch (actionIndex) {
      case 0:
        const text = this.text;
        if (text.charAt(0) === text.charAt(0).toUpperCase()) {
          this.type = _Wa.TOKEN_REF;
        } else {
          this.type = _Wa.RULE_REF;
        }
        break;
    }
  }
  static get _ATN() {
    if (!_Wa.__ATN) {
      _Wa.__ATN = new ATNDeserializer().deserialize(_Wa._serializedATN);
    }
    return _Wa.__ATN;
  }
  get vocabulary() {
    return _Wa.vocabulary;
  }
}, __name(_Wa, "XPathLexer"), __publicField(_Wa, "TOKEN_REF", 1), __publicField(_Wa, "RULE_REF", 2), __publicField(_Wa, "ANYWHERE", 3), __publicField(_Wa, "ROOT", 4), __publicField(_Wa, "WILDCARD", 5), __publicField(_Wa, "BANG", 6), __publicField(_Wa, "ID", 7), __publicField(_Wa, "STRING", 8), __publicField(_Wa, "channelNames", [
  "DEFAULT_TOKEN_CHANNEL",
  "HIDDEN"
]), __publicField(_Wa, "literalNames", [
  null,
  null,
  null,
  "'//'",
  "'/'",
  "'*'",
  "'!'"
]), __publicField(_Wa, "symbolicNames", [
  null,
  "TOKEN_REF",
  "RULE_REF",
  "ANYWHERE",
  "ROOT",
  "WILDCARD",
  "BANG",
  "ID",
  "STRING"
]), __publicField(_Wa, "modeNames", [
  "DEFAULT_MODE"
]), __publicField(_Wa, "ruleNames", [
  "ANYWHERE",
  "ROOT",
  "WILDCARD",
  "BANG",
  "ID",
  "NameChar",
  "NameStartChar",
  "STRING"
]), __publicField(_Wa, "_serializedATN", [
  4,
  0,
  8,
  48,
  6,
  -1,
  2,
  0,
  7,
  0,
  2,
  1,
  7,
  1,
  2,
  2,
  7,
  2,
  2,
  3,
  7,
  3,
  2,
  4,
  7,
  4,
  2,
  5,
  7,
  5,
  2,
  6,
  7,
  6,
  2,
  7,
  7,
  7,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  1,
  1,
  1,
  1,
  2,
  1,
  2,
  1,
  3,
  1,
  3,
  1,
  4,
  1,
  4,
  5,
  4,
  29,
  8,
  4,
  10,
  4,
  12,
  4,
  32,
  9,
  4,
  1,
  4,
  1,
  4,
  1,
  5,
  1,
  5,
  1,
  6,
  1,
  6,
  1,
  7,
  1,
  7,
  5,
  7,
  42,
  8,
  7,
  10,
  7,
  12,
  7,
  45,
  9,
  7,
  1,
  7,
  1,
  7,
  1,
  43,
  0,
  8,
  1,
  3,
  3,
  4,
  5,
  5,
  7,
  6,
  9,
  7,
  11,
  0,
  13,
  0,
  15,
  8,
  1,
  0,
  2,
  784,
  0,
  0,
  8,
  14,
  27,
  48,
  57,
  65,
  90,
  95,
  95,
  97,
  122,
  127,
  159,
  170,
  170,
  173,
  173,
  181,
  181,
  186,
  186,
  192,
  214,
  216,
  246,
  248,
  705,
  710,
  721,
  736,
  740,
  748,
  748,
  750,
  750,
  768,
  884,
  886,
  887,
  890,
  893,
  895,
  895,
  902,
  902,
  904,
  906,
  908,
  908,
  910,
  929,
  931,
  1013,
  1015,
  1153,
  1155,
  1159,
  1162,
  1327,
  1329,
  1366,
  1369,
  1369,
  1376,
  1416,
  1425,
  1469,
  1471,
  1471,
  1473,
  1474,
  1476,
  1477,
  1479,
  1479,
  1488,
  1514,
  1519,
  1522,
  1536,
  1541,
  1552,
  1562,
  1564,
  1564,
  1568,
  1641,
  1646,
  1747,
  1749,
  1757,
  1759,
  1768,
  1770,
  1788,
  1791,
  1791,
  1807,
  1866,
  1869,
  1969,
  1984,
  2037,
  2042,
  2042,
  2045,
  2045,
  2048,
  2093,
  2112,
  2139,
  2144,
  2154,
  2160,
  2183,
  2185,
  2190,
  2192,
  2193,
  2200,
  2403,
  2406,
  2415,
  2417,
  2435,
  2437,
  2444,
  2447,
  2448,
  2451,
  2472,
  2474,
  2480,
  2482,
  2482,
  2486,
  2489,
  2492,
  2500,
  2503,
  2504,
  2507,
  2510,
  2519,
  2519,
  2524,
  2525,
  2527,
  2531,
  2534,
  2545,
  2556,
  2556,
  2558,
  2558,
  2561,
  2563,
  2565,
  2570,
  2575,
  2576,
  2579,
  2600,
  2602,
  2608,
  2610,
  2611,
  2613,
  2614,
  2616,
  2617,
  2620,
  2620,
  2622,
  2626,
  2631,
  2632,
  2635,
  2637,
  2641,
  2641,
  2649,
  2652,
  2654,
  2654,
  2662,
  2677,
  2689,
  2691,
  2693,
  2701,
  2703,
  2705,
  2707,
  2728,
  2730,
  2736,
  2738,
  2739,
  2741,
  2745,
  2748,
  2757,
  2759,
  2761,
  2763,
  2765,
  2768,
  2768,
  2784,
  2787,
  2790,
  2799,
  2809,
  2815,
  2817,
  2819,
  2821,
  2828,
  2831,
  2832,
  2835,
  2856,
  2858,
  2864,
  2866,
  2867,
  2869,
  2873,
  2876,
  2884,
  2887,
  2888,
  2891,
  2893,
  2901,
  2903,
  2908,
  2909,
  2911,
  2915,
  2918,
  2927,
  2929,
  2929,
  2946,
  2947,
  2949,
  2954,
  2958,
  2960,
  2962,
  2965,
  2969,
  2970,
  2972,
  2972,
  2974,
  2975,
  2979,
  2980,
  2984,
  2986,
  2990,
  3001,
  3006,
  3010,
  3014,
  3016,
  3018,
  3021,
  3024,
  3024,
  3031,
  3031,
  3046,
  3055,
  3072,
  3084,
  3086,
  3088,
  3090,
  3112,
  3114,
  3129,
  3132,
  3140,
  3142,
  3144,
  3146,
  3149,
  3157,
  3158,
  3160,
  3162,
  3165,
  3165,
  3168,
  3171,
  3174,
  3183,
  3200,
  3203,
  3205,
  3212,
  3214,
  3216,
  3218,
  3240,
  3242,
  3251,
  3253,
  3257,
  3260,
  3268,
  3270,
  3272,
  3274,
  3277,
  3285,
  3286,
  3293,
  3294,
  3296,
  3299,
  3302,
  3311,
  3313,
  3315,
  3328,
  3340,
  3342,
  3344,
  3346,
  3396,
  3398,
  3400,
  3402,
  3406,
  3412,
  3415,
  3423,
  3427,
  3430,
  3439,
  3450,
  3455,
  3457,
  3459,
  3461,
  3478,
  3482,
  3505,
  3507,
  3515,
  3517,
  3517,
  3520,
  3526,
  3530,
  3530,
  3535,
  3540,
  3542,
  3542,
  3544,
  3551,
  3558,
  3567,
  3570,
  3571,
  3585,
  3642,
  3648,
  3662,
  3664,
  3673,
  3713,
  3714,
  3716,
  3716,
  3718,
  3722,
  3724,
  3747,
  3749,
  3749,
  3751,
  3773,
  3776,
  3780,
  3782,
  3782,
  3784,
  3790,
  3792,
  3801,
  3804,
  3807,
  3840,
  3840,
  3864,
  3865,
  3872,
  3881,
  3893,
  3893,
  3895,
  3895,
  3897,
  3897,
  3902,
  3911,
  3913,
  3948,
  3953,
  3972,
  3974,
  3991,
  3993,
  4028,
  4038,
  4038,
  4096,
  4169,
  4176,
  4253,
  4256,
  4293,
  4295,
  4295,
  4301,
  4301,
  4304,
  4346,
  4348,
  4680,
  4682,
  4685,
  4688,
  4694,
  4696,
  4696,
  4698,
  4701,
  4704,
  4744,
  4746,
  4749,
  4752,
  4784,
  4786,
  4789,
  4792,
  4798,
  4800,
  4800,
  4802,
  4805,
  4808,
  4822,
  4824,
  4880,
  4882,
  4885,
  4888,
  4954,
  4957,
  4959,
  4992,
  5007,
  5024,
  5109,
  5112,
  5117,
  5121,
  5740,
  5743,
  5759,
  5761,
  5786,
  5792,
  5866,
  5870,
  5880,
  5888,
  5909,
  5919,
  5940,
  5952,
  5971,
  5984,
  5996,
  5998,
  6e3,
  6002,
  6003,
  6016,
  6099,
  6103,
  6103,
  6108,
  6109,
  6112,
  6121,
  6155,
  6169,
  6176,
  6264,
  6272,
  6314,
  6320,
  6389,
  6400,
  6430,
  6432,
  6443,
  6448,
  6459,
  6470,
  6509,
  6512,
  6516,
  6528,
  6571,
  6576,
  6601,
  6608,
  6617,
  6656,
  6683,
  6688,
  6750,
  6752,
  6780,
  6783,
  6793,
  6800,
  6809,
  6823,
  6823,
  6832,
  6845,
  6847,
  6862,
  6912,
  6988,
  6992,
  7001,
  7019,
  7027,
  7040,
  7155,
  7168,
  7223,
  7232,
  7241,
  7245,
  7293,
  7296,
  7304,
  7312,
  7354,
  7357,
  7359,
  7376,
  7378,
  7380,
  7418,
  7424,
  7957,
  7960,
  7965,
  7968,
  8005,
  8008,
  8013,
  8016,
  8023,
  8025,
  8025,
  8027,
  8027,
  8029,
  8029,
  8031,
  8061,
  8064,
  8116,
  8118,
  8124,
  8126,
  8126,
  8130,
  8132,
  8134,
  8140,
  8144,
  8147,
  8150,
  8155,
  8160,
  8172,
  8178,
  8180,
  8182,
  8188,
  8203,
  8207,
  8234,
  8238,
  8255,
  8256,
  8276,
  8276,
  8288,
  8292,
  8294,
  8303,
  8305,
  8305,
  8319,
  8319,
  8336,
  8348,
  8400,
  8412,
  8417,
  8417,
  8421,
  8432,
  8450,
  8450,
  8455,
  8455,
  8458,
  8467,
  8469,
  8469,
  8473,
  8477,
  8484,
  8484,
  8486,
  8486,
  8488,
  8488,
  8490,
  8493,
  8495,
  8505,
  8508,
  8511,
  8517,
  8521,
  8526,
  8526,
  8544,
  8584,
  11264,
  11492,
  11499,
  11507,
  11520,
  11557,
  11559,
  11559,
  11565,
  11565,
  11568,
  11623,
  11631,
  11631,
  11647,
  11670,
  11680,
  11686,
  11688,
  11694,
  11696,
  11702,
  11704,
  11710,
  11712,
  11718,
  11720,
  11726,
  11728,
  11734,
  11736,
  11742,
  11744,
  11775,
  11823,
  11823,
  12293,
  12295,
  12321,
  12335,
  12337,
  12341,
  12344,
  12348,
  12353,
  12438,
  12441,
  12442,
  12445,
  12447,
  12449,
  12538,
  12540,
  12543,
  12549,
  12591,
  12593,
  12686,
  12704,
  12735,
  12784,
  12799,
  13312,
  19903,
  19968,
  42124,
  42192,
  42237,
  42240,
  42508,
  42512,
  42539,
  42560,
  42607,
  42612,
  42621,
  42623,
  42737,
  42775,
  42783,
  42786,
  42888,
  42891,
  42954,
  42960,
  42961,
  42963,
  42963,
  42965,
  42969,
  42994,
  43047,
  43052,
  43052,
  43072,
  43123,
  43136,
  43205,
  43216,
  43225,
  43232,
  43255,
  43259,
  43259,
  43261,
  43309,
  43312,
  43347,
  43360,
  43388,
  43392,
  43456,
  43471,
  43481,
  43488,
  43518,
  43520,
  43574,
  43584,
  43597,
  43600,
  43609,
  43616,
  43638,
  43642,
  43714,
  43739,
  43741,
  43744,
  43759,
  43762,
  43766,
  43777,
  43782,
  43785,
  43790,
  43793,
  43798,
  43808,
  43814,
  43816,
  43822,
  43824,
  43866,
  43868,
  43881,
  43888,
  44010,
  44012,
  44013,
  44016,
  44025,
  44032,
  55203,
  55216,
  55238,
  55243,
  55291,
  63744,
  64109,
  64112,
  64217,
  64256,
  64262,
  64275,
  64279,
  64285,
  64296,
  64298,
  64310,
  64312,
  64316,
  64318,
  64318,
  64320,
  64321,
  64323,
  64324,
  64326,
  64433,
  64467,
  64829,
  64848,
  64911,
  64914,
  64967,
  65008,
  65019,
  65024,
  65039,
  65056,
  65071,
  65075,
  65076,
  65101,
  65103,
  65136,
  65140,
  65142,
  65276,
  65279,
  65279,
  65296,
  65305,
  65313,
  65338,
  65343,
  65343,
  65345,
  65370,
  65382,
  65470,
  65474,
  65479,
  65482,
  65487,
  65490,
  65495,
  65498,
  65500,
  65529,
  65531,
  65536,
  65547,
  65549,
  65574,
  65576,
  65594,
  65596,
  65597,
  65599,
  65613,
  65616,
  65629,
  65664,
  65786,
  65856,
  65908,
  66045,
  66045,
  66176,
  66204,
  66208,
  66256,
  66272,
  66272,
  66304,
  66335,
  66349,
  66378,
  66384,
  66426,
  66432,
  66461,
  66464,
  66499,
  66504,
  66511,
  66513,
  66517,
  66560,
  66717,
  66720,
  66729,
  66736,
  66771,
  66776,
  66811,
  66816,
  66855,
  66864,
  66915,
  66928,
  66938,
  66940,
  66954,
  66956,
  66962,
  66964,
  66965,
  66967,
  66977,
  66979,
  66993,
  66995,
  67001,
  67003,
  67004,
  67072,
  67382,
  67392,
  67413,
  67424,
  67431,
  67456,
  67461,
  67463,
  67504,
  67506,
  67514,
  67584,
  67589,
  67592,
  67592,
  67594,
  67637,
  67639,
  67640,
  67644,
  67644,
  67647,
  67669,
  67680,
  67702,
  67712,
  67742,
  67808,
  67826,
  67828,
  67829,
  67840,
  67861,
  67872,
  67897,
  67968,
  68023,
  68030,
  68031,
  68096,
  68099,
  68101,
  68102,
  68108,
  68115,
  68117,
  68119,
  68121,
  68149,
  68152,
  68154,
  68159,
  68159,
  68192,
  68220,
  68224,
  68252,
  68288,
  68295,
  68297,
  68326,
  68352,
  68405,
  68416,
  68437,
  68448,
  68466,
  68480,
  68497,
  68608,
  68680,
  68736,
  68786,
  68800,
  68850,
  68864,
  68903,
  68912,
  68921,
  69248,
  69289,
  69291,
  69292,
  69296,
  69297,
  69373,
  69404,
  69415,
  69415,
  69424,
  69456,
  69488,
  69509,
  69552,
  69572,
  69600,
  69622,
  69632,
  69702,
  69734,
  69749,
  69759,
  69818,
  69821,
  69821,
  69826,
  69826,
  69837,
  69837,
  69840,
  69864,
  69872,
  69881,
  69888,
  69940,
  69942,
  69951,
  69956,
  69959,
  69968,
  70003,
  70006,
  70006,
  70016,
  70084,
  70089,
  70092,
  70094,
  70106,
  70108,
  70108,
  70144,
  70161,
  70163,
  70199,
  70206,
  70209,
  70272,
  70278,
  70280,
  70280,
  70282,
  70285,
  70287,
  70301,
  70303,
  70312,
  70320,
  70378,
  70384,
  70393,
  70400,
  70403,
  70405,
  70412,
  70415,
  70416,
  70419,
  70440,
  70442,
  70448,
  70450,
  70451,
  70453,
  70457,
  70459,
  70468,
  70471,
  70472,
  70475,
  70477,
  70480,
  70480,
  70487,
  70487,
  70493,
  70499,
  70502,
  70508,
  70512,
  70516,
  70656,
  70730,
  70736,
  70745,
  70750,
  70753,
  70784,
  70853,
  70855,
  70855,
  70864,
  70873,
  71040,
  71093,
  71096,
  71104,
  71128,
  71133,
  71168,
  71232,
  71236,
  71236,
  71248,
  71257,
  71296,
  71352,
  71360,
  71369,
  71424,
  71450,
  71453,
  71467,
  71472,
  71481,
  71488,
  71494,
  71680,
  71738,
  71840,
  71913,
  71935,
  71942,
  71945,
  71945,
  71948,
  71955,
  71957,
  71958,
  71960,
  71989,
  71991,
  71992,
  71995,
  72003,
  72016,
  72025,
  72096,
  72103,
  72106,
  72151,
  72154,
  72161,
  72163,
  72164,
  72192,
  72254,
  72263,
  72263,
  72272,
  72345,
  72349,
  72349,
  72368,
  72440,
  72704,
  72712,
  72714,
  72758,
  72760,
  72768,
  72784,
  72793,
  72818,
  72847,
  72850,
  72871,
  72873,
  72886,
  72960,
  72966,
  72968,
  72969,
  72971,
  73014,
  73018,
  73018,
  73020,
  73021,
  73023,
  73031,
  73040,
  73049,
  73056,
  73061,
  73063,
  73064,
  73066,
  73102,
  73104,
  73105,
  73107,
  73112,
  73120,
  73129,
  73440,
  73462,
  73472,
  73488,
  73490,
  73530,
  73534,
  73538,
  73552,
  73561,
  73648,
  73648,
  73728,
  74649,
  74752,
  74862,
  74880,
  75075,
  77712,
  77808,
  77824,
  78933,
  82944,
  83526,
  92160,
  92728,
  92736,
  92766,
  92768,
  92777,
  92784,
  92862,
  92864,
  92873,
  92880,
  92909,
  92912,
  92916,
  92928,
  92982,
  92992,
  92995,
  93008,
  93017,
  93027,
  93047,
  93053,
  93071,
  93760,
  93823,
  93952,
  94026,
  94031,
  94087,
  94095,
  94111,
  94176,
  94177,
  94179,
  94180,
  94192,
  94193,
  94208,
  100343,
  100352,
  101589,
  101632,
  101640,
  110576,
  110579,
  110581,
  110587,
  110589,
  110590,
  110592,
  110882,
  110898,
  110898,
  110928,
  110930,
  110933,
  110933,
  110948,
  110951,
  110960,
  111355,
  113664,
  113770,
  113776,
  113788,
  113792,
  113800,
  113808,
  113817,
  113821,
  113822,
  113824,
  113827,
  118528,
  118573,
  118576,
  118598,
  119141,
  119145,
  119149,
  119170,
  119173,
  119179,
  119210,
  119213,
  119362,
  119364,
  119808,
  119892,
  119894,
  119964,
  119966,
  119967,
  119970,
  119970,
  119973,
  119974,
  119977,
  119980,
  119982,
  119993,
  119995,
  119995,
  119997,
  120003,
  120005,
  120069,
  120071,
  120074,
  120077,
  120084,
  120086,
  120092,
  120094,
  120121,
  120123,
  120126,
  120128,
  120132,
  120134,
  120134,
  120138,
  120144,
  120146,
  120485,
  120488,
  120512,
  120514,
  120538,
  120540,
  120570,
  120572,
  120596,
  120598,
  120628,
  120630,
  120654,
  120656,
  120686,
  120688,
  120712,
  120714,
  120744,
  120746,
  120770,
  120772,
  120779,
  120782,
  120831,
  121344,
  121398,
  121403,
  121452,
  121461,
  121461,
  121476,
  121476,
  121499,
  121503,
  121505,
  121519,
  122624,
  122654,
  122661,
  122666,
  122880,
  122886,
  122888,
  122904,
  122907,
  122913,
  122915,
  122916,
  122918,
  122922,
  122928,
  122989,
  123023,
  123023,
  123136,
  123180,
  123184,
  123197,
  123200,
  123209,
  123214,
  123214,
  123536,
  123566,
  123584,
  123641,
  124112,
  124153,
  124896,
  124902,
  124904,
  124907,
  124909,
  124910,
  124912,
  124926,
  124928,
  125124,
  125136,
  125142,
  125184,
  125259,
  125264,
  125273,
  126464,
  126467,
  126469,
  126495,
  126497,
  126498,
  126500,
  126500,
  126503,
  126503,
  126505,
  126514,
  126516,
  126519,
  126521,
  126521,
  126523,
  126523,
  126530,
  126530,
  126535,
  126535,
  126537,
  126537,
  126539,
  126539,
  126541,
  126543,
  126545,
  126546,
  126548,
  126548,
  126551,
  126551,
  126553,
  126553,
  126555,
  126555,
  126557,
  126557,
  126559,
  126559,
  126561,
  126562,
  126564,
  126564,
  126567,
  126570,
  126572,
  126578,
  126580,
  126583,
  126585,
  126588,
  126590,
  126590,
  126592,
  126601,
  126603,
  126619,
  126625,
  126627,
  126629,
  126633,
  126635,
  126651,
  130032,
  130041,
  131072,
  173791,
  173824,
  177977,
  177984,
  178205,
  178208,
  183969,
  183984,
  191456,
  194560,
  195101,
  196608,
  201546,
  201552,
  205743,
  917505,
  917505,
  917536,
  917631,
  917760,
  917999,
  662,
  0,
  65,
  90,
  97,
  122,
  170,
  170,
  181,
  181,
  186,
  186,
  192,
  214,
  216,
  246,
  248,
  705,
  710,
  721,
  736,
  740,
  748,
  748,
  750,
  750,
  880,
  884,
  886,
  887,
  890,
  893,
  895,
  895,
  902,
  902,
  904,
  906,
  908,
  908,
  910,
  929,
  931,
  1013,
  1015,
  1153,
  1162,
  1327,
  1329,
  1366,
  1369,
  1369,
  1376,
  1416,
  1488,
  1514,
  1519,
  1522,
  1568,
  1610,
  1646,
  1647,
  1649,
  1747,
  1749,
  1749,
  1765,
  1766,
  1774,
  1775,
  1786,
  1788,
  1791,
  1791,
  1808,
  1808,
  1810,
  1839,
  1869,
  1957,
  1969,
  1969,
  1994,
  2026,
  2036,
  2037,
  2042,
  2042,
  2048,
  2069,
  2074,
  2074,
  2084,
  2084,
  2088,
  2088,
  2112,
  2136,
  2144,
  2154,
  2160,
  2183,
  2185,
  2190,
  2208,
  2249,
  2308,
  2361,
  2365,
  2365,
  2384,
  2384,
  2392,
  2401,
  2417,
  2432,
  2437,
  2444,
  2447,
  2448,
  2451,
  2472,
  2474,
  2480,
  2482,
  2482,
  2486,
  2489,
  2493,
  2493,
  2510,
  2510,
  2524,
  2525,
  2527,
  2529,
  2544,
  2545,
  2556,
  2556,
  2565,
  2570,
  2575,
  2576,
  2579,
  2600,
  2602,
  2608,
  2610,
  2611,
  2613,
  2614,
  2616,
  2617,
  2649,
  2652,
  2654,
  2654,
  2674,
  2676,
  2693,
  2701,
  2703,
  2705,
  2707,
  2728,
  2730,
  2736,
  2738,
  2739,
  2741,
  2745,
  2749,
  2749,
  2768,
  2768,
  2784,
  2785,
  2809,
  2809,
  2821,
  2828,
  2831,
  2832,
  2835,
  2856,
  2858,
  2864,
  2866,
  2867,
  2869,
  2873,
  2877,
  2877,
  2908,
  2909,
  2911,
  2913,
  2929,
  2929,
  2947,
  2947,
  2949,
  2954,
  2958,
  2960,
  2962,
  2965,
  2969,
  2970,
  2972,
  2972,
  2974,
  2975,
  2979,
  2980,
  2984,
  2986,
  2990,
  3001,
  3024,
  3024,
  3077,
  3084,
  3086,
  3088,
  3090,
  3112,
  3114,
  3129,
  3133,
  3133,
  3160,
  3162,
  3165,
  3165,
  3168,
  3169,
  3200,
  3200,
  3205,
  3212,
  3214,
  3216,
  3218,
  3240,
  3242,
  3251,
  3253,
  3257,
  3261,
  3261,
  3293,
  3294,
  3296,
  3297,
  3313,
  3314,
  3332,
  3340,
  3342,
  3344,
  3346,
  3386,
  3389,
  3389,
  3406,
  3406,
  3412,
  3414,
  3423,
  3425,
  3450,
  3455,
  3461,
  3478,
  3482,
  3505,
  3507,
  3515,
  3517,
  3517,
  3520,
  3526,
  3585,
  3632,
  3634,
  3635,
  3648,
  3654,
  3713,
  3714,
  3716,
  3716,
  3718,
  3722,
  3724,
  3747,
  3749,
  3749,
  3751,
  3760,
  3762,
  3763,
  3773,
  3773,
  3776,
  3780,
  3782,
  3782,
  3804,
  3807,
  3840,
  3840,
  3904,
  3911,
  3913,
  3948,
  3976,
  3980,
  4096,
  4138,
  4159,
  4159,
  4176,
  4181,
  4186,
  4189,
  4193,
  4193,
  4197,
  4198,
  4206,
  4208,
  4213,
  4225,
  4238,
  4238,
  4256,
  4293,
  4295,
  4295,
  4301,
  4301,
  4304,
  4346,
  4348,
  4680,
  4682,
  4685,
  4688,
  4694,
  4696,
  4696,
  4698,
  4701,
  4704,
  4744,
  4746,
  4749,
  4752,
  4784,
  4786,
  4789,
  4792,
  4798,
  4800,
  4800,
  4802,
  4805,
  4808,
  4822,
  4824,
  4880,
  4882,
  4885,
  4888,
  4954,
  4992,
  5007,
  5024,
  5109,
  5112,
  5117,
  5121,
  5740,
  5743,
  5759,
  5761,
  5786,
  5792,
  5866,
  5870,
  5880,
  5888,
  5905,
  5919,
  5937,
  5952,
  5969,
  5984,
  5996,
  5998,
  6e3,
  6016,
  6067,
  6103,
  6103,
  6108,
  6108,
  6176,
  6264,
  6272,
  6276,
  6279,
  6312,
  6314,
  6314,
  6320,
  6389,
  6400,
  6430,
  6480,
  6509,
  6512,
  6516,
  6528,
  6571,
  6576,
  6601,
  6656,
  6678,
  6688,
  6740,
  6823,
  6823,
  6917,
  6963,
  6981,
  6988,
  7043,
  7072,
  7086,
  7087,
  7098,
  7141,
  7168,
  7203,
  7245,
  7247,
  7258,
  7293,
  7296,
  7304,
  7312,
  7354,
  7357,
  7359,
  7401,
  7404,
  7406,
  7411,
  7413,
  7414,
  7418,
  7418,
  7424,
  7615,
  7680,
  7957,
  7960,
  7965,
  7968,
  8005,
  8008,
  8013,
  8016,
  8023,
  8025,
  8025,
  8027,
  8027,
  8029,
  8029,
  8031,
  8061,
  8064,
  8116,
  8118,
  8124,
  8126,
  8126,
  8130,
  8132,
  8134,
  8140,
  8144,
  8147,
  8150,
  8155,
  8160,
  8172,
  8178,
  8180,
  8182,
  8188,
  8305,
  8305,
  8319,
  8319,
  8336,
  8348,
  8450,
  8450,
  8455,
  8455,
  8458,
  8467,
  8469,
  8469,
  8473,
  8477,
  8484,
  8484,
  8486,
  8486,
  8488,
  8488,
  8490,
  8493,
  8495,
  8505,
  8508,
  8511,
  8517,
  8521,
  8526,
  8526,
  8544,
  8584,
  11264,
  11492,
  11499,
  11502,
  11506,
  11507,
  11520,
  11557,
  11559,
  11559,
  11565,
  11565,
  11568,
  11623,
  11631,
  11631,
  11648,
  11670,
  11680,
  11686,
  11688,
  11694,
  11696,
  11702,
  11704,
  11710,
  11712,
  11718,
  11720,
  11726,
  11728,
  11734,
  11736,
  11742,
  11823,
  11823,
  12293,
  12295,
  12321,
  12329,
  12337,
  12341,
  12344,
  12348,
  12353,
  12438,
  12445,
  12447,
  12449,
  12538,
  12540,
  12543,
  12549,
  12591,
  12593,
  12686,
  12704,
  12735,
  12784,
  12799,
  13312,
  19903,
  19968,
  42124,
  42192,
  42237,
  42240,
  42508,
  42512,
  42527,
  42538,
  42539,
  42560,
  42606,
  42623,
  42653,
  42656,
  42735,
  42775,
  42783,
  42786,
  42888,
  42891,
  42954,
  42960,
  42961,
  42963,
  42963,
  42965,
  42969,
  42994,
  43009,
  43011,
  43013,
  43015,
  43018,
  43020,
  43042,
  43072,
  43123,
  43138,
  43187,
  43250,
  43255,
  43259,
  43259,
  43261,
  43262,
  43274,
  43301,
  43312,
  43334,
  43360,
  43388,
  43396,
  43442,
  43471,
  43471,
  43488,
  43492,
  43494,
  43503,
  43514,
  43518,
  43520,
  43560,
  43584,
  43586,
  43588,
  43595,
  43616,
  43638,
  43642,
  43642,
  43646,
  43695,
  43697,
  43697,
  43701,
  43702,
  43705,
  43709,
  43712,
  43712,
  43714,
  43714,
  43739,
  43741,
  43744,
  43754,
  43762,
  43764,
  43777,
  43782,
  43785,
  43790,
  43793,
  43798,
  43808,
  43814,
  43816,
  43822,
  43824,
  43866,
  43868,
  43881,
  43888,
  44002,
  44032,
  55203,
  55216,
  55238,
  55243,
  55291,
  63744,
  64109,
  64112,
  64217,
  64256,
  64262,
  64275,
  64279,
  64285,
  64285,
  64287,
  64296,
  64298,
  64310,
  64312,
  64316,
  64318,
  64318,
  64320,
  64321,
  64323,
  64324,
  64326,
  64433,
  64467,
  64829,
  64848,
  64911,
  64914,
  64967,
  65008,
  65019,
  65136,
  65140,
  65142,
  65276,
  65313,
  65338,
  65345,
  65370,
  65382,
  65470,
  65474,
  65479,
  65482,
  65487,
  65490,
  65495,
  65498,
  65500,
  65536,
  65547,
  65549,
  65574,
  65576,
  65594,
  65596,
  65597,
  65599,
  65613,
  65616,
  65629,
  65664,
  65786,
  65856,
  65908,
  66176,
  66204,
  66208,
  66256,
  66304,
  66335,
  66349,
  66378,
  66384,
  66421,
  66432,
  66461,
  66464,
  66499,
  66504,
  66511,
  66513,
  66517,
  66560,
  66717,
  66736,
  66771,
  66776,
  66811,
  66816,
  66855,
  66864,
  66915,
  66928,
  66938,
  66940,
  66954,
  66956,
  66962,
  66964,
  66965,
  66967,
  66977,
  66979,
  66993,
  66995,
  67001,
  67003,
  67004,
  67072,
  67382,
  67392,
  67413,
  67424,
  67431,
  67456,
  67461,
  67463,
  67504,
  67506,
  67514,
  67584,
  67589,
  67592,
  67592,
  67594,
  67637,
  67639,
  67640,
  67644,
  67644,
  67647,
  67669,
  67680,
  67702,
  67712,
  67742,
  67808,
  67826,
  67828,
  67829,
  67840,
  67861,
  67872,
  67897,
  67968,
  68023,
  68030,
  68031,
  68096,
  68096,
  68112,
  68115,
  68117,
  68119,
  68121,
  68149,
  68192,
  68220,
  68224,
  68252,
  68288,
  68295,
  68297,
  68324,
  68352,
  68405,
  68416,
  68437,
  68448,
  68466,
  68480,
  68497,
  68608,
  68680,
  68736,
  68786,
  68800,
  68850,
  68864,
  68899,
  69248,
  69289,
  69296,
  69297,
  69376,
  69404,
  69415,
  69415,
  69424,
  69445,
  69488,
  69505,
  69552,
  69572,
  69600,
  69622,
  69635,
  69687,
  69745,
  69746,
  69749,
  69749,
  69763,
  69807,
  69840,
  69864,
  69891,
  69926,
  69956,
  69956,
  69959,
  69959,
  69968,
  70002,
  70006,
  70006,
  70019,
  70066,
  70081,
  70084,
  70106,
  70106,
  70108,
  70108,
  70144,
  70161,
  70163,
  70187,
  70207,
  70208,
  70272,
  70278,
  70280,
  70280,
  70282,
  70285,
  70287,
  70301,
  70303,
  70312,
  70320,
  70366,
  70405,
  70412,
  70415,
  70416,
  70419,
  70440,
  70442,
  70448,
  70450,
  70451,
  70453,
  70457,
  70461,
  70461,
  70480,
  70480,
  70493,
  70497,
  70656,
  70708,
  70727,
  70730,
  70751,
  70753,
  70784,
  70831,
  70852,
  70853,
  70855,
  70855,
  71040,
  71086,
  71128,
  71131,
  71168,
  71215,
  71236,
  71236,
  71296,
  71338,
  71352,
  71352,
  71424,
  71450,
  71488,
  71494,
  71680,
  71723,
  71840,
  71903,
  71935,
  71942,
  71945,
  71945,
  71948,
  71955,
  71957,
  71958,
  71960,
  71983,
  71999,
  71999,
  72001,
  72001,
  72096,
  72103,
  72106,
  72144,
  72161,
  72161,
  72163,
  72163,
  72192,
  72192,
  72203,
  72242,
  72250,
  72250,
  72272,
  72272,
  72284,
  72329,
  72349,
  72349,
  72368,
  72440,
  72704,
  72712,
  72714,
  72750,
  72768,
  72768,
  72818,
  72847,
  72960,
  72966,
  72968,
  72969,
  72971,
  73008,
  73030,
  73030,
  73056,
  73061,
  73063,
  73064,
  73066,
  73097,
  73112,
  73112,
  73440,
  73458,
  73474,
  73474,
  73476,
  73488,
  73490,
  73523,
  73648,
  73648,
  73728,
  74649,
  74752,
  74862,
  74880,
  75075,
  77712,
  77808,
  77824,
  78895,
  78913,
  78918,
  82944,
  83526,
  92160,
  92728,
  92736,
  92766,
  92784,
  92862,
  92880,
  92909,
  92928,
  92975,
  92992,
  92995,
  93027,
  93047,
  93053,
  93071,
  93760,
  93823,
  93952,
  94026,
  94032,
  94032,
  94099,
  94111,
  94176,
  94177,
  94179,
  94179,
  94208,
  100343,
  100352,
  101589,
  101632,
  101640,
  110576,
  110579,
  110581,
  110587,
  110589,
  110590,
  110592,
  110882,
  110898,
  110898,
  110928,
  110930,
  110933,
  110933,
  110948,
  110951,
  110960,
  111355,
  113664,
  113770,
  113776,
  113788,
  113792,
  113800,
  113808,
  113817,
  119808,
  119892,
  119894,
  119964,
  119966,
  119967,
  119970,
  119970,
  119973,
  119974,
  119977,
  119980,
  119982,
  119993,
  119995,
  119995,
  119997,
  120003,
  120005,
  120069,
  120071,
  120074,
  120077,
  120084,
  120086,
  120092,
  120094,
  120121,
  120123,
  120126,
  120128,
  120132,
  120134,
  120134,
  120138,
  120144,
  120146,
  120485,
  120488,
  120512,
  120514,
  120538,
  120540,
  120570,
  120572,
  120596,
  120598,
  120628,
  120630,
  120654,
  120656,
  120686,
  120688,
  120712,
  120714,
  120744,
  120746,
  120770,
  120772,
  120779,
  122624,
  122654,
  122661,
  122666,
  122928,
  122989,
  123136,
  123180,
  123191,
  123197,
  123214,
  123214,
  123536,
  123565,
  123584,
  123627,
  124112,
  124139,
  124896,
  124902,
  124904,
  124907,
  124909,
  124910,
  124912,
  124926,
  124928,
  125124,
  125184,
  125251,
  125259,
  125259,
  126464,
  126467,
  126469,
  126495,
  126497,
  126498,
  126500,
  126500,
  126503,
  126503,
  126505,
  126514,
  126516,
  126519,
  126521,
  126521,
  126523,
  126523,
  126530,
  126530,
  126535,
  126535,
  126537,
  126537,
  126539,
  126539,
  126541,
  126543,
  126545,
  126546,
  126548,
  126548,
  126551,
  126551,
  126553,
  126553,
  126555,
  126555,
  126557,
  126557,
  126559,
  126559,
  126561,
  126562,
  126564,
  126564,
  126567,
  126570,
  126572,
  126578,
  126580,
  126583,
  126585,
  126588,
  126590,
  126590,
  126592,
  126601,
  126603,
  126619,
  126625,
  126627,
  126629,
  126633,
  126635,
  126651,
  131072,
  173791,
  173824,
  177977,
  177984,
  178205,
  178208,
  183969,
  183984,
  191456,
  194560,
  195101,
  196608,
  201546,
  201552,
  205743,
  47,
  0,
  1,
  1,
  0,
  0,
  0,
  0,
  3,
  1,
  0,
  0,
  0,
  0,
  5,
  1,
  0,
  0,
  0,
  0,
  7,
  1,
  0,
  0,
  0,
  0,
  9,
  1,
  0,
  0,
  0,
  0,
  15,
  1,
  0,
  0,
  0,
  1,
  17,
  1,
  0,
  0,
  0,
  3,
  20,
  1,
  0,
  0,
  0,
  5,
  22,
  1,
  0,
  0,
  0,
  7,
  24,
  1,
  0,
  0,
  0,
  9,
  26,
  1,
  0,
  0,
  0,
  11,
  35,
  1,
  0,
  0,
  0,
  13,
  37,
  1,
  0,
  0,
  0,
  15,
  39,
  1,
  0,
  0,
  0,
  17,
  18,
  5,
  47,
  0,
  0,
  18,
  19,
  5,
  47,
  0,
  0,
  19,
  2,
  1,
  0,
  0,
  0,
  20,
  21,
  5,
  47,
  0,
  0,
  21,
  4,
  1,
  0,
  0,
  0,
  22,
  23,
  5,
  42,
  0,
  0,
  23,
  6,
  1,
  0,
  0,
  0,
  24,
  25,
  5,
  33,
  0,
  0,
  25,
  8,
  1,
  0,
  0,
  0,
  26,
  30,
  3,
  13,
  6,
  0,
  27,
  29,
  3,
  11,
  5,
  0,
  28,
  27,
  1,
  0,
  0,
  0,
  29,
  32,
  1,
  0,
  0,
  0,
  30,
  28,
  1,
  0,
  0,
  0,
  30,
  31,
  1,
  0,
  0,
  0,
  31,
  33,
  1,
  0,
  0,
  0,
  32,
  30,
  1,
  0,
  0,
  0,
  33,
  34,
  6,
  4,
  0,
  0,
  34,
  10,
  1,
  0,
  0,
  0,
  35,
  36,
  7,
  0,
  0,
  0,
  36,
  12,
  1,
  0,
  0,
  0,
  37,
  38,
  7,
  1,
  0,
  0,
  38,
  14,
  1,
  0,
  0,
  0,
  39,
  43,
  5,
  39,
  0,
  0,
  40,
  42,
  9,
  0,
  0,
  0,
  41,
  40,
  1,
  0,
  0,
  0,
  42,
  45,
  1,
  0,
  0,
  0,
  43,
  44,
  1,
  0,
  0,
  0,
  43,
  41,
  1,
  0,
  0,
  0,
  44,
  46,
  1,
  0,
  0,
  0,
  45,
  43,
  1,
  0,
  0,
  0,
  46,
  47,
  5,
  39,
  0,
  0,
  47,
  16,
  1,
  0,
  0,
  0,
  3,
  0,
  30,
  43,
  1,
  1,
  4,
  0
]), __publicField(_Wa, "__ATN"), __publicField(_Wa, "vocabulary", new Vocabulary(_Wa.literalNames, _Wa.symbolicNames, [])), __publicField(_Wa, "decisionsToDFA", _Wa._ATN.decisionToState.map((ds2, index2) => {
  return new DFA(ds2, index2);
})), _Wa);
var XPathLexerErrorListener = (_Xa = class extends BaseErrorListener {
  syntaxError(_recognizer, _offendingSymbol, _line, _charPositionInLine, _msg, _e3) {
  }
}, __name(_Xa, "XPathLexerErrorListener"), _Xa);
var XPathElement = (_Ya = class {
  /**
   * Construct element like `/ID` or `ID` or `/*` etc... `nodeName` is undefined if just node
   *
   * @param nodeName The name of the node; may be undefined for any node.
   */
  constructor(nodeName) {
    __publicField(this, "invert");
    __publicField(this, "nodeName");
    this.nodeName = nodeName;
    this.invert = false;
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathElement[" + inv + this.nodeName + "]";
  }
}, __name(_Ya, "XPathElement"), _Ya);
var XPathRuleAnywhereElement = (_Za = class extends XPathElement {
  constructor(ruleName, ruleIndex) {
    super(ruleName);
    __publicField(this, "ruleIndex");
    this.ruleIndex = ruleIndex;
  }
  evaluate(t2) {
    return Trees.findAllRuleNodes(t2, this.ruleIndex);
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathRuleAnywhereElement[" + inv + this.nodeName + "]";
  }
}, __name(_Za, "XPathRuleAnywhereElement"), _Za);
var XPathRuleElement = (__a = class extends XPathElement {
  constructor(ruleName, ruleIndex) {
    super(ruleName);
    __publicField(this, "ruleIndex");
    this.ruleIndex = ruleIndex;
  }
  evaluate(t2) {
    const nodes = [];
    for (const c3 of Trees.getChildren(t2)) {
      if (c3 instanceof ParserRuleContext) {
        if (c3.ruleIndex === this.ruleIndex && !this.invert || c3.ruleIndex !== this.ruleIndex && this.invert) {
          nodes.push(c3);
        }
      }
    }
    return nodes;
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathRuleElement[" + inv + this.nodeName + "]";
  }
}, __name(__a, "XPathRuleElement"), __a);
var XPathTokenAnywhereElement = (_$a = class extends XPathElement {
  constructor(tokenName, tokenType) {
    super(tokenName);
    __publicField(this, "tokenType");
    this.tokenType = tokenType;
  }
  evaluate(t2) {
    return Trees.findAllTokenNodes(t2, this.tokenType);
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathTokenAnywhereElement[" + inv + this.nodeName + "]";
  }
}, __name(_$a, "XPathTokenAnywhereElement"), _$a);
var XPathTokenElement = (_ab = class extends XPathElement {
  constructor(tokenName, tokenType) {
    super(tokenName);
    __publicField(this, "tokenType");
    this.tokenType = tokenType;
  }
  evaluate(t2) {
    const nodes = [];
    for (const c3 of Trees.getChildren(t2)) {
      if (c3 instanceof TerminalNode && c3.symbol) {
        if (c3.symbol.type === this.tokenType && !this.invert || c3.symbol.type !== this.tokenType && this.invert) {
          nodes.push(c3);
        }
      }
    }
    return nodes;
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathTokenElement[" + inv + this.nodeName + "]";
  }
}, __name(_ab, "XPathTokenElement"), _ab);
var XPathWildcardAnywhereElement = (_bb = class extends XPathElement {
  constructor() {
    super(XPath.WILDCARD);
  }
  evaluate(t2) {
    if (this.invert) {
      return [];
    }
    return Trees.descendants(t2);
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathWildcardAnywhereElement[" + inv + this.nodeName + "]";
  }
}, __name(_bb, "XPathWildcardAnywhereElement"), _bb);
var XPathWildcardElement = (_cb = class extends XPathElement {
  constructor() {
    super(XPath.WILDCARD);
  }
  evaluate(t2) {
    const kids = [];
    if (this.invert) {
      return kids;
    }
    for (const c3 of Trees.getChildren(t2)) {
      kids.push(c3);
    }
    return kids;
  }
  toString() {
    const inv = this.invert ? "!" : "";
    return "XPathWildcardElement[" + inv + this.nodeName + "]";
  }
}, __name(_cb, "XPathWildcardElement"), _cb);
var XPath = (_db = class {
  constructor(parser, path) {
    // word for invert operator
    __publicField(this, "path");
    __publicField(this, "elements");
    __publicField(this, "parser");
    this.parser = parser;
    this.path = path;
    this.elements = this.split(path);
  }
  static findAll(tree, xpath, parser) {
    const p2 = new _db(parser, xpath);
    return p2.evaluate(tree);
  }
  // TODO: check for invalid token/rule names, bad syntax
  split(path) {
    const lexer = new XPathLexer(CharStream.fromString(path));
    lexer.recover = (e10) => {
      throw e10;
    };
    lexer.removeErrorListeners();
    lexer.addErrorListener(new XPathLexerErrorListener());
    const tokenStream = new CommonTokenStream(lexer);
    try {
      tokenStream.fill();
    } catch (e10) {
      if (e10 instanceof LexerNoViableAltException) {
        const pos = lexer.column;
        const msg = "Invalid tokens or characters at index " + pos + " in path '" + path + "' -- " + e10.message;
        throw new RangeError(msg);
      }
      throw e10;
    }
    const tokens = tokenStream.getTokens();
    const elements = [];
    const n2 = tokens.length;
    let i2 = 0;
    loop:
      while (i2 < n2) {
        const el2 = tokens[i2];
        let next;
        switch (el2.type) {
          case XPathLexer.ROOT:
          case XPathLexer.ANYWHERE:
            const anywhere = el2.type === XPathLexer.ANYWHERE;
            i2++;
            next = tokens[i2];
            const invert = next.type === XPathLexer.BANG;
            if (invert) {
              i2++;
              next = tokens[i2];
            }
            const pathElement = this.getXPathElement(next, anywhere);
            pathElement.invert = invert;
            elements.push(pathElement);
            i2++;
            break;
          case XPathLexer.TOKEN_REF:
          case XPathLexer.RULE_REF:
          case XPathLexer.WILDCARD:
            elements.push(this.getXPathElement(el2, false));
            ++i2;
            break;
          case Token.EOF:
            break loop;
          default:
            throw new Error("Unknown path element " + el2);
        }
      }
    return elements;
  }
  /**
   * Return a list of all nodes starting at `t` as root that satisfy the
   * path. The root `/` is relative to the node passed to {@link evaluate}.
   */
  evaluate(t2) {
    const dummyRoot = new ParserRuleContext(null);
    dummyRoot.addChild(t2);
    let work = /* @__PURE__ */ new Set([dummyRoot]);
    let i2 = 0;
    while (i2 < this.elements.length) {
      const next = /* @__PURE__ */ new Set();
      for (const node of work) {
        if (node.getChildCount() > 0) {
          const matching = this.elements[i2].evaluate(node);
          matching.forEach((tree) => {
            next.add(tree);
          }, next);
        }
      }
      i2++;
      work = next;
    }
    return work;
  }
  /**
   * Convert word like `*` or `ID` or `expr` to a path
   * element. `anywhere` is `true` if `//` precedes the
   * word.
   */
  getXPathElement(wordToken, anywhere) {
    if (wordToken.type === Token.EOF) {
      throw new Error("Missing path element at end of path");
    }
    const word = wordToken.text;
    if (word == null) {
      throw new Error("Expected wordToken to have text content.");
    }
    const ttype = this.parser.getTokenType(word);
    const ruleIndex = this.parser.getRuleIndex(word);
    switch (wordToken.type) {
      case XPathLexer.WILDCARD:
        return anywhere ? new XPathWildcardAnywhereElement() : new XPathWildcardElement();
      case XPathLexer.TOKEN_REF:
      case XPathLexer.STRING:
        if (ttype === Token.INVALID_TYPE) {
          throw new Error(word + " at index " + wordToken.start + " isn't a valid token name");
        }
        return anywhere ? new XPathTokenAnywhereElement(word, ttype) : new XPathTokenElement(word, ttype);
      default:
        if (ruleIndex === -1) {
          throw new Error(word + " at index " + wordToken.start + " isn't a valid rule name");
        }
        return anywhere ? new XPathRuleAnywhereElement(word, ruleIndex) : new XPathRuleElement(word, ruleIndex);
    }
  }
}, __name(_db, "XPath"), __publicField(_db, "WILDCARD", "*"), // word not operator/separator
__publicField(_db, "NOT", "!"), _db);
var Chunk = (_eb = class {
}, __name(_eb, "Chunk"), _eb);
var ParseTreeMatch = (_fb = class {
  /**
   * Constructs a new instance of {@link ParseTreeMatch} from the specified
   * parse tree and pattern.
   *
   * @param tree The parse tree to match against the pattern.
   * @param pattern The parse tree pattern.
   * @param labels A mapping from label names to collections of
   * {@link ParseTree} objects located by the tree pattern matching process.
   * @param mismatchedNode The first node which failed to match the tree
   * pattern during the matching process.
   */
  constructor(tree, pattern4, labels, mismatchedNode) {
    /**
     * This is the backing field for {@link #getTree()}.
     */
    __publicField(this, "tree");
    /**
     * This is the backing field for {@link #getPattern()}.
     */
    __publicField(this, "pattern");
    /**
     * This is the backing field for {@link #getLabels()}.
     */
    __publicField(this, "labels");
    /**
     * This is the backing field for {@link #getMismatchedNode()}.
     */
    __publicField(this, "mismatchedNode");
    this.tree = tree;
    this.pattern = pattern4;
    this.labels = labels;
    this.mismatchedNode = mismatchedNode;
  }
  /**
   * Get the last node associated with a specific `label`.
   *
   * For example, for pattern `<id:ID>`, `get("id")` returns the
   * node matched for that `ID`. If more than one node
   * matched the specified label, only the last is returned. If there is
   * no node associated with the label, this returns `null`.
   *
   * Pattern tags like `<ID>` and `<expr>` without labels are
   * considered to be labeled with `ID` and `expr`, respectively.
   *
   * @param label The label to check.
   *
   * @returns The last {@link ParseTree} to match a tag with the specified
   * label, or `null` if no parse tree matched a tag with the label.
   */
  get(label) {
    const parseTrees = this.labels.get(label);
    if (!parseTrees || parseTrees.length === 0) {
      return null;
    }
    return parseTrees[parseTrees.length - 1];
  }
  /**
   * Return all nodes matching a rule or token tag with the specified label.
   *
   * If the `label` is the name of a parser rule or token in the
   * grammar, the resulting list will contain both the parse trees matching
   * rule or tags explicitly labeled with the label and the complete set of
   * parse trees matching the labeled and unlabeled tags in the pattern for
   * the parser rule or token. For example, if `label` is `"foo"`,
   * the result will contain *all* of the following.
   *
   * - Parse tree nodes matching tags of the form `<foo:anyRuleName>` and
   * `<foo:AnyTokenName>`.
   * - Parse tree nodes matching tags of the form `<anyLabel:foo>`.
   * - Parse tree nodes matching tags of the form `<foo>`.
   *
   * @param label The label.
   *
   * @returns A collection of all {@link ParseTree} nodes matching tags with
   * the specified `label`. If no nodes matched the label, an empty list
   * is returned.
   */
  getAll(label) {
    const nodes = this.labels.get(label);
    return nodes ?? [];
  }
  /**
   * Return a mapping from label -> [list of nodes].
   *
   * The map includes special entries corresponding to the names of rules and
   * tokens referenced in tags in the original pattern. For additional
   * information, see the description of {@link getAll(String)}.
   *
   * @returns A mapping from labels to parse tree nodes. If the parse tree
   * pattern did not contain any rule or token tags, this map will be empty.
   */
  getLabels() {
    return this.labels;
  }
  /**
   * Get the node at which we first detected a mismatch.
   *
   * @returns the node at which we first detected a mismatch, or `null`
   * if the match was successful.
   */
  getMismatchedNode() {
    return this.mismatchedNode;
  }
  /**
   * Gets a value indicating whether the match operation succeeded.
   *
   * @returns `true` if the match operation succeeded; otherwise, `false`.
   */
  succeeded() {
    return !this.mismatchedNode;
  }
  /**
   * Get the tree pattern we are matching against.
   *
   * @returns The tree pattern we are matching against.
   */
  getPattern() {
    return this.pattern;
  }
  /**
   * Get the parse tree we are trying to match to a pattern.
   *
   * @returns The {@link ParseTree} we are trying to match to a pattern.
   */
  getTree() {
    return this.tree;
  }
  toString() {
    return `Match ${this.succeeded() ? "succeeded" : "failed"}; found ${this.getLabels().size} labels`;
  }
}, __name(_fb, "ParseTreeMatch"), _fb);
var ParseTreePattern = (_gb = class {
  /**
   * Construct a new instance of the {@link ParseTreePattern} class.
   *
   * @param matcher The {@link ParseTreePatternMatcher} which created this
   * tree pattern.
   * @param pattern The tree pattern in concrete syntax form.
   * @param patternRuleIndex The parser rule which serves as the root of the
   * tree pattern.
   * @param patternTree The tree pattern in {@link ParseTree} form.
   */
  constructor(matcher, pattern4, patternRuleIndex, patternTree) {
    /**
     * This is the backing field for {@link #getPatternRuleIndex()}.
     */
    __publicField(this, "patternRuleIndex");
    /**
     * This is the backing field for {@link #getPattern()}.
     */
    __publicField(this, "pattern");
    /**
     * This is the backing field for {@link #getPatternTree()}.
     */
    __publicField(this, "patternTree");
    /**
     * This is the backing field for {@link #getMatcher()}.
     */
    __publicField(this, "matcher");
    this.matcher = matcher;
    this.patternRuleIndex = patternRuleIndex;
    this.pattern = pattern4;
    this.patternTree = patternTree;
  }
  /**
   * Match a specific parse tree against this tree pattern.
   *
   * @param tree The parse tree to match against this tree pattern.
   * @returns A {@link ParseTreeMatch} object describing the result of the
   * match operation. The {@link ParseTreeMatch#succeeded()} method can be
   * used to determine whether or not the match was successful.
   */
  match(tree) {
    return this.matcher.match(tree, this);
  }
  /**
   * Determine whether or not a parse tree matches this tree pattern.
   *
   * @param tree The parse tree to match against this tree pattern.
   * @returns `true` if `tree` is a match for the current tree
   * pattern; otherwise, `false`.
   */
  matches(tree) {
    return this.matcher.match(tree, this).succeeded();
  }
  /**
   * Find all nodes using XPath and then try to match those subtrees against
   * this tree pattern.
   *
   * @param tree The {@link ParseTree} to match against this pattern.
   * @param xpath An expression matching the nodes
   *
   * @returns A collection of {@link ParseTreeMatch} objects describing the
   * successful matches. Unsuccessful matches are omitted from the result,
   * regardless of the reason for the failure.
   */
  findAll(tree, xpath) {
    const subtrees = XPath.findAll(tree, xpath, this.matcher.getParser());
    const matches = new Array();
    for (const t2 of subtrees) {
      const match = this.match(t2);
      if (match.succeeded()) {
        matches.push(match);
      }
    }
    return matches;
  }
  /**
   * Get the {@link ParseTreePatternMatcher} which created this tree pattern.
   *
   * @returns The {@link ParseTreePatternMatcher} which created this tree
   * pattern.
   */
  getMatcher() {
    return this.matcher;
  }
  /**
   * Get the tree pattern in concrete syntax form.
   *
   * @returns The tree pattern in concrete syntax form.
   */
  getPattern() {
    return this.pattern;
  }
  /**
   * Get the parser rule which serves as the outermost rule for the tree
   * pattern.
   *
   * @returns The parser rule which serves as the outermost rule for the tree
   * pattern.
   */
  getPatternRuleIndex() {
    return this.patternRuleIndex;
  }
  /**
   * Get the tree pattern as a {@link ParseTree}. The rule and token tags from
   * the pattern are present in the parse tree as terminal nodes with a symbol
   * of type {@link RuleTagToken} or {@link TokenTagToken}.
   *
   * @returns The tree pattern as a {@link ParseTree}.
   */
  getPatternTree() {
    return this.patternTree;
  }
}, __name(_gb, "ParseTreePattern"), _gb);
var InputMismatchException = (_hb = class extends RecognitionException {
  constructor(recognizer) {
    super({ message: "", recognizer, input: recognizer.inputStream, ctx: recognizer.context });
    this.offendingToken = recognizer.getCurrentToken();
  }
}, __name(_hb, "InputMismatchException"), _hb);
var FailedPredicateException = (_ib = class extends RecognitionException {
  constructor(recognizer, predicate, message = null) {
    super({
      message: formatMessage(predicate ?? "no predicate", message ?? null),
      recognizer,
      input: recognizer.inputStream,
      ctx: recognizer.context
    });
    __publicField(this, "ruleIndex", 0);
    __publicField(this, "predicateIndex", 0);
    __publicField(this, "predicate");
    const s2 = recognizer.atn.states[recognizer.state];
    const trans = s2.transitions[0];
    if (trans instanceof PredicateTransition) {
      this.ruleIndex = trans.ruleIndex;
      this.predicateIndex = trans.predIndex;
    } else {
      this.ruleIndex = 0;
      this.predicateIndex = 0;
    }
    this.predicate = predicate;
    this.offendingToken = recognizer.getCurrentToken();
  }
}, __name(_ib, "FailedPredicateException"), _ib);
var formatMessage = /* @__PURE__ */ __name((predicate, message) => {
  if (message !== null) {
    return message;
  }
  return "failed predicate: {" + predicate + "}?";
}, "formatMessage");
var DefaultErrorStrategy = (_jb = class {
  constructor() {
    /**
     * Indicates whether the error strategy is currently "recovering from an
     * error". This is used to suppress reporting multiple error messages while
     * attempting to recover from a detected syntax error.
     *
     * @see #inErrorRecoveryMode
     */
    __publicField(this, "errorRecoveryMode", false);
    /**
     * The index into the input stream where the last error occurred.
     * 	This is used to prevent infinite loops where an error is found
     *  but no token is consumed during recovery...another error is found,
     *  ad nauseam.  This is a failsafe mechanism to guarantee that at least
     *  one token/tree node is consumed for two errors.
     */
    __publicField(this, "lastErrorIndex", -1);
    __publicField(this, "lastErrorStates", new IntervalSet());
    /**
     * This field is used to propagate information about the lookahead following
     * the previous match. Since prediction prefers completing the current rule
     * to error recovery efforts, error reporting may occur later than the
     * original point where it was discoverable. The original context is used to
     * compute the true expected sets as though the reporting occurred as early
     * as possible.
     */
    __publicField(this, "nextTokensContext", null);
    __publicField(this, "nextTokenState", 0);
  }
  /**
   * The default implementation simply calls {@link endErrorCondition} to
   * ensure that the handler is not in error recovery mode.
   */
  reset(recognizer) {
    this.endErrorCondition(recognizer);
  }
  /**
   * This method is called to enter error recovery mode when a recognition
   * exception is reported.
   *
   * @param _recognizer the parser instance
   */
  beginErrorCondition(_recognizer) {
    this.errorRecoveryMode = true;
  }
  inErrorRecoveryMode(_recognizer) {
    return this.errorRecoveryMode;
  }
  /**
   * This method is called to leave error recovery mode after recovering from
   * a recognition exception.
   */
  endErrorCondition(_recognizer) {
    this.errorRecoveryMode = false;
    this.lastErrorStates = new IntervalSet();
    this.lastErrorIndex = -1;
  }
  /**
   * The default implementation simply calls {@link endErrorCondition}.
   */
  reportMatch(recognizer) {
    this.endErrorCondition(recognizer);
  }
  /**
   * The default implementation returns immediately if the handler is already
   * in error recovery mode. Otherwise, it calls {@link beginErrorCondition}
   * and dispatches the reporting task based on the runtime type of `e`
   * according to the following table.
   *
   * - {@link NoViableAltException}: Dispatches the call to {@link reportNoViableAlternative}
   * - {@link InputMismatchException}: Dispatches the call to {@link reportInputMismatch}
   * - {@link FailedPredicateException}: Dispatches the call to {@link reportFailedPredicate}
   * - All other types: calls {@link Parser.notifyErrorListeners} to report the exception
   */
  reportError(recognizer, e10) {
    if (this.inErrorRecoveryMode(recognizer)) {
      return;
    }
    this.beginErrorCondition(recognizer);
    if (e10 instanceof NoViableAltException) {
      this.reportNoViableAlternative(recognizer, e10);
    } else if (e10 instanceof InputMismatchException) {
      this.reportInputMismatch(recognizer, e10);
    } else if (e10 instanceof FailedPredicateException) {
      this.reportFailedPredicate(recognizer, e10);
    } else {
      recognizer.notifyErrorListeners(e10.message, e10.offendingToken, e10);
    }
  }
  /**
   * The default implementation resynchronizes the parser by consuming tokens
   * until we find one in the resynchronization set--loosely the set of tokens
   * that can follow the current rule.
   *
   */
  recover(recognizer, _e3) {
    var _a3, _b3;
    if (this.lastErrorIndex === ((_a3 = recognizer.inputStream) == null ? void 0 : _a3.index) && this.lastErrorStates.contains(recognizer.state)) {
      recognizer.consume();
    }
    this.lastErrorIndex = ((_b3 = recognizer.inputStream) == null ? void 0 : _b3.index) ?? 0;
    this.lastErrorStates.addOne(recognizer.state);
    const followSet = this.getErrorRecoverySet(recognizer);
    this.consumeUntil(recognizer, followSet);
  }
  /**
   * The default implementation of {@link ANTLRErrorStrategy.sync} makes sure
   * that the current lookahead symbol is consistent with what were expecting
   * at this point in the ATN. You can call this anytime but ANTLR only
   * generates code to check before subrules/loops and each iteration.
   *
   * Implements Jim Idle's magic sync mechanism in closures and optional
   * subrules. E.g.,
   *
   * ```
   * a : sync ( stuff sync )* ;
   * sync : {consume to what can follow sync} ;
   * ```
   *
   * At the start of a sub rule upon error, {@link sync} performs single
   * token deletion, if possible. If it can't do that, it bails on the current
   * rule and uses the default error recovery, which consumes until the
   * resynchronization set of the current rule.
   *
   * If the sub rule is optional (`(...)?`, `(...)*`, or block
   * with an empty alternative), then the expected set includes what follows
   * the subrule.
   *
   * During loop iteration, it consumes until it sees a token that can start a
   * sub rule or what follows loop. Yes, that is pretty aggressive. We opt to
   * stay in the loop as long as possible.
   *
   * **ORIGINS**
   *
   * Previous versions of ANTLR did a poor job of their recovery within loops.
   * A single mismatch token or missing token would force the parser to bail
   * out of the entire rules surrounding the loop. So, for rule
   *
   * ```
   * classDef : 'class' ID '{' member* '}'
   * ```
   *
   * input with an extra token between members would force the parser to
   * consume until it found the next class definition rather than the next
   * member definition of the current class.
   *
   * This functionality cost a little bit of effort because the parser has to
   * compare token set at the start of the loop and at each iteration. If for
   * some reason speed is suffering for you, you can turn off this
   * functionality by simply overriding this method as a blank { }.
   *
   */
  sync(recognizer) {
    if (this.inErrorRecoveryMode(recognizer)) {
      return;
    }
    const s2 = recognizer.atn.states[recognizer.state];
    const la2 = recognizer.tokenStream.LA(1);
    const nextTokens = recognizer.atn.nextTokens(s2);
    if (nextTokens.contains(la2)) {
      this.nextTokensContext = null;
      this.nextTokenState = ATNState.INVALID_STATE_NUMBER;
      return;
    }
    if (nextTokens.contains(Token.EPSILON)) {
      if (this.nextTokensContext === null) {
        this.nextTokensContext = recognizer.context;
        this.nextTokenState = recognizer.state;
      }
      return;
    }
    switch (s2.constructor.stateType) {
      case ATNState.BLOCK_START:
      case ATNState.STAR_BLOCK_START:
      case ATNState.PLUS_BLOCK_START:
      case ATNState.STAR_LOOP_ENTRY: {
        if (this.singleTokenDeletion(recognizer) !== null) {
          return;
        }
        throw new InputMismatchException(recognizer);
      }
      case ATNState.PLUS_LOOP_BACK:
      case ATNState.STAR_LOOP_BACK: {
        this.reportUnwantedToken(recognizer);
        const expecting = new IntervalSet();
        expecting.addSet(recognizer.getExpectedTokens());
        const whatFollowsLoopIterationOrRule = expecting.addSet(this.getErrorRecoverySet(recognizer));
        this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
        break;
      }
    }
  }
  /**
   * This is called by {@link reportError} when the exception is a
   * {@link NoViableAltException}.
   *
   * @see reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportNoViableAlternative(recognizer, e10) {
    if (e10.message.length > 0) {
      recognizer.notifyErrorListeners(e10.message, e10.offendingToken, e10);
      return;
    }
    const tokens = recognizer.tokenStream;
    let input;
    if (tokens !== null && e10.startToken) {
      if (e10.startToken.type === Token.EOF) {
        input = "<EOF>";
      } else {
        input = tokens.getTextFromRange(e10.startToken, e10.offendingToken);
      }
    } else {
      input = "<unknown input>";
    }
    const msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
    recognizer.notifyErrorListeners(msg, e10.offendingToken, e10);
  }
  /**
   * This is called by {@link reportError} when the exception is an {@link InputMismatchException}.
   *
   * @see reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportInputMismatch(recognizer, e10) {
    if (e10.message.length > 0) {
      recognizer.notifyErrorListeners(e10.message, e10.offendingToken, e10);
      return;
    }
    const msg = "mismatched input " + this.getTokenErrorDisplay(e10.offendingToken) + " expecting " + e10.getExpectedTokens().toStringWithVocabulary(recognizer.vocabulary);
    recognizer.notifyErrorListeners(msg, e10.offendingToken, e10);
  }
  /**
   * This is called by {@link reportError} when the exception is a
   * {@link FailedPredicateException}.
   *
   * @see reportError
   *
   * @param recognizer the parser instance
   * @param e the recognition exception
   */
  reportFailedPredicate(recognizer, e10) {
    const ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
    const msg = "rule " + ruleName + " " + e10.message;
    recognizer.notifyErrorListeners(msg, e10.offendingToken, e10);
  }
  /**
   * This method is called to report a syntax error which requires the removal
   * of a token from the input stream. At the time this method is called, the
   * erroneous symbol is current `LT(1)` symbol and has not yet been
   * removed from the input stream. When this method returns,
   * `recognizer` is in error recovery mode.
   *
   * This method is called when {@link singleTokenDeletion} identifies
   * single-token deletion as a viable recovery strategy for a mismatched
   * input error.
   *
   * The default implementation simply returns if the handler is already in
   * error recovery mode. Otherwise, it calls {@link beginErrorCondition} to
   * enter error recovery mode, followed by calling
   * {@link Parser.notifyErrorListeners}.
   *
   * @param recognizer the parser instance
   */
  reportUnwantedToken(recognizer) {
    if (this.inErrorRecoveryMode(recognizer)) {
      return;
    }
    this.beginErrorCondition(recognizer);
    const t2 = recognizer.getCurrentToken();
    const tokenName = this.getTokenErrorDisplay(t2);
    const expecting = this.getExpectedTokens(recognizer);
    const msg = "extraneous input " + tokenName + " expecting " + expecting.toStringWithVocabulary(recognizer.vocabulary);
    recognizer.notifyErrorListeners(msg, t2, null);
  }
  /**
   * This method is called to report a syntax error which requires the
   * insertion of a missing token into the input stream. At the time this
   * method is called, the missing token has not yet been inserted. When this
   * method returns, `recognizer` is in error recovery mode.
   *
   * This method is called when {@link singleTokenInsertion} identifies
   * single-token insertion as a viable recovery strategy for a mismatched
   * input error.
   *
   * The default implementation simply returns if the handler is already in
   * error recovery mode. Otherwise, it calls {@link beginErrorCondition} to
   * enter error recovery mode, followed by calling
   * {@link Parser.notifyErrorListeners}.
   *
   * @param recognizer the parser instance
   */
  reportMissingToken(recognizer) {
    if (this.inErrorRecoveryMode(recognizer)) {
      return;
    }
    this.beginErrorCondition(recognizer);
    const t2 = recognizer.getCurrentToken();
    const expecting = this.getExpectedTokens(recognizer);
    const msg = "missing " + expecting.toStringWithVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t2);
    recognizer.notifyErrorListeners(msg, t2, null);
  }
  /**
   * The default implementation attempts to recover from the mismatched input
   * by using single token insertion and deletion as described below. If the
   * recovery attempt fails, this method throws an
   * {@link InputMismatchException}.
   *
   * **EXTRA TOKEN** (single token deletion)
   *
   * `LA(1)` is not what we are looking for. If `LA(2)` has the
   * right token, however, then assume `LA(1)` is some extra spurious
   * token and delete it. Then consume and return the next token (which was
   * the `LA(2)` token) as the successful result of the match operation.
   *
   * This recovery strategy is implemented by {@link singleTokenDeletion}.
   *
   * **MISSING TOKEN** (single token insertion)
   *
   * If current token (at `LA(1)`) is consistent with what could come
   * after the expected `LA(1)` token, then assume the token is missing
   * and use the parser's {@link TokenFactory} to create it on the fly. The
   * "insertion" is performed by returning the created token as the successful
   * result of the match operation.
   *
   * This recovery strategy is implemented by {@link singleTokenInsertion}.
   *
   * **EXAMPLE**
   *
   * For example, Input `i=(3;` is clearly missing the `')'`. When
   * the parser returns from the nested call to `expr`, it will have
   * call chain:
   *
   * ```
   * stat -> expr -> atom
   * ```
   *
   * and it will be trying to match the `')'` at this point in the
   * derivation:
   *
   * ```
   * => ID '=' '(' INT ')' ('+' atom)* ';'
   * ^
   * ```
   *
   * The attempt to match `')'` will fail when it sees `';'` and
   * call {@link recoverInline}. To recover, it sees that `LA(1)==';'`
   * is in the set of tokens that can follow the `')'` token reference
   * in rule `atom`. It can assume that you forgot the `')'`.
   */
  recoverInline(recognizer) {
    const matchedSymbol = this.singleTokenDeletion(recognizer);
    if (matchedSymbol) {
      recognizer.consume();
      return matchedSymbol;
    }
    if (this.singleTokenInsertion(recognizer)) {
      return this.getMissingSymbol(recognizer);
    }
    throw new InputMismatchException(recognizer);
  }
  /**
   * This method implements the single-token insertion inline error recovery
   * strategy. It is called by {@link recoverInline} if the single-token
   * deletion strategy fails to recover from the mismatched input. If this
   * method returns `true`, `recognizer` will be in error recovery
   * mode.
   *
   * This method determines whether or not single-token insertion is viable by
   * checking if the `LA(1)` input symbol could be successfully matched
   * if it were instead the `LA(2)` symbol. If this method returns
   * `true`, the caller is responsible for creating and inserting a
   * token with the correct type to produce this behavior.
   *
   * @param recognizer the parser instance
   * @returns `true` if single-token insertion is a viable recovery
   * strategy for the current mismatched input, otherwise `false`
   */
  singleTokenInsertion(recognizer) {
    var _a3;
    const currentSymbolType = ((_a3 = recognizer.tokenStream) == null ? void 0 : _a3.LA(1)) ?? -1;
    const atn = recognizer.atn;
    const currentState = atn.states[recognizer.state];
    const next = currentState.transitions[0].target;
    const expectingAtLL2 = atn.nextTokens(next, recognizer.context ?? void 0);
    if (expectingAtLL2.contains(currentSymbolType)) {
      this.reportMissingToken(recognizer);
      return true;
    }
    return false;
  }
  /**
   * This method implements the single-token deletion inline error recovery
   * strategy. It is called by {@link recoverInline} to attempt to recover
   * from mismatched input. If this method returns null, the parser and error
   * handler state will not have changed. If this method returns non-null,
   * `recognizer` will *not* be in error recovery mode since the
   * returned token was a successful match.
   *
   * If the single-token deletion is successful, this method calls
   * {@link reportUnwantedToken} to report the error, followed by
   * {@link Parser.consume} to actually "delete" the extraneous token. Then,
   * before returning {@link reportMatch} is called to signal a successful
   * match.
   *
   * @param recognizer the parser instance
   * @returns the successfully matched {@link Token} instance if single-token
   * deletion successfully recovers from the mismatched input, otherwise
   * `null`
   */
  singleTokenDeletion(recognizer) {
    var _a3;
    const nextTokenType = ((_a3 = recognizer.tokenStream) == null ? void 0 : _a3.LA(2)) ?? -1;
    const expecting = this.getExpectedTokens(recognizer);
    if (expecting.contains(nextTokenType)) {
      this.reportUnwantedToken(recognizer);
      recognizer.consume();
      const matchedSymbol = recognizer.getCurrentToken();
      this.reportMatch(recognizer);
      return matchedSymbol;
    }
    return null;
  }
  /**
   * Conjure up a missing token during error recovery.
   *
   * The recognizer attempts to recover from single missing
   * symbols. But, actions might refer to that missing symbol.
   * For example, x=ID {f($x);}. The action clearly assumes
   * that there has been an identifier matched previously and that
   * $x points at that token. If that token is missing, but
   * the next token in the stream is what we want we assume that
   * this token is missing and we keep going. Because we
   * have to return some token to replace the missing token,
   * we have to conjure one up. This method gives the user control
   * over the tokens returned for missing tokens. Mostly,
   * you will want to create something special for identifier
   * tokens. For literals such as '{' and ',', the default
   * action in the parser or tree parser works. It simply creates
   * a CommonToken of the appropriate type. The text will be the token.
   * If you change what tokens must be created by the lexer,
   * override this method to create the appropriate tokens.
   */
  getMissingSymbol(recognizer) {
    var _a3;
    const currentSymbol = recognizer.getCurrentToken();
    const expecting = this.getExpectedTokens(recognizer);
    let expectedTokenType = Token.INVALID_TYPE;
    if (expecting.length !== 0) {
      expectedTokenType = expecting.minElement;
    }
    let tokenText;
    if (expectedTokenType === Token.EOF) {
      tokenText = "<missing EOF>";
    } else {
      tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
    }
    let current = currentSymbol;
    const lookBack = (_a3 = recognizer.tokenStream) == null ? void 0 : _a3.LT(-1);
    if (current.type === Token.EOF && lookBack !== null) {
      current = lookBack;
    }
    return recognizer.getTokenFactory().create(
      current.source,
      expectedTokenType,
      tokenText,
      Token.DEFAULT_CHANNEL,
      -1,
      -1,
      current.line,
      current.column
    );
  }
  getExpectedTokens(recognizer) {
    return recognizer.getExpectedTokens();
  }
  /**
   * How should a token be displayed in an error message? The default
   * is to display just the text, but during development you might
   * want to have a lot of information spit out. Override in that case
   * to use t.toString() (which, for CommonToken, dumps everything about
   * the token). This is better than forcing you to override a method in
   * your token objects because you don't have to go modify your lexer
   * so that it creates a new Java type.
   */
  getTokenErrorDisplay(t2) {
    if (t2 === null) {
      return "<no token>";
    }
    let s2 = t2.text;
    if (!s2) {
      if (t2.type === Token.EOF) {
        s2 = "<EOF>";
      } else {
        s2 = "<" + t2.type + ">";
      }
    }
    return this.escapeWSAndQuote(s2);
  }
  escapeWSAndQuote(s2) {
    s2 = s2.replace(/\n/g, "\\n");
    s2 = s2.replace(/\r/g, "\\r");
    s2 = s2.replace(/\t/g, "\\t");
    return "'" + s2 + "'";
  }
  /**
   * Compute the error recovery set for the current rule. During
   * rule invocation, the parser pushes the set of tokens that can
   * follow that rule reference on the stack; this amounts to
   * computing FIRST of what follows the rule reference in the
   * enclosing rule. See LinearApproximator.FIRST().
   * This local follow set only includes tokens
   * from within the rule; i.e., the FIRST computation done by
   * ANTLR stops at the end of a rule.
   *
   * EXAMPLE
   *
   * When you find a "no viable alt exception", the input is not
   * consistent with any of the alternatives for rule r. The best
   * thing to do is to consume tokens until you see something that
   * can legally follow a call to r//or* any rule that called r.
   * You don't want the exact set of viable next tokens because the
   * input might just be missing a token--you might consume the
   * rest of the input looking for one of the missing tokens.
   *
   * Consider grammar:
   *
   * a : '[' b ']'
   * | '(' b ')'
   * ;
   * b : c '^' INT ;
   * c : ID
   * | INT
   * ;
   *
   * At each rule invocation, the set of tokens that could follow
   * that rule is pushed on a stack. Here are the various
   * context-sensitive follow sets:
   *
   * FOLLOW(b1_in_a) = FIRST(']') = ']'
   * FOLLOW(b2_in_a) = FIRST(')') = ')'
   * FOLLOW(c_in_b) = FIRST('^') = '^'
   *
   * Upon erroneous input "[]", the call chain is
   *
   * a -> b -> c
   *
   * and, hence, the follow context stack is:
   *
   * depth follow set start of rule execution
   * 0 <EOF> a (from main())
   * 1 ']' b
   * 2 '^' c
   *
   * Notice that ')' is not included, because b would have to have
   * been called from a different context in rule a for ')' to be
   * included.
   *
   * For error recovery, we cannot consider FOLLOW(c)
   * (context-sensitive or otherwise). We need the combined set of
   * all context-sensitive FOLLOW sets--the set of all tokens that
   * could follow any reference in the call chain. We need to
   * resync to one of those tokens. Note that FOLLOW(c)='^' and if
   * we resync'd to that token, we'd consume until EOF. We need to
   * sync to context-sensitive FOLLOWs for a, b, and c: {']','^'}.
   * In this case, for input "[]", LA(1) is ']' and in the set, so we would
   * not consume anything. After printing an error, rule c would
   * return normally. Rule b would not find the required '^' though.
   * At this point, it gets a mismatched token error and throws an
   * exception (since LA(1) is not in the viable following token
   * set). The rule exception handler tries to recover, but finds
   * the same recovery set and doesn't consume anything. Rule b
   * exits normally returning to rule a. Now it finds the ']' (and
   * with the successful match exits errorRecovery mode).
   *
   * So, you can see that the parser walks up the call chain looking
   * for the token that was a member of the recovery set.
   *
   * Errors are not generated in errorRecovery mode.
   *
   * ANTLR's error recovery mechanism is based upon original ideas:
   *
   * "Algorithms + Data Structures = Programs" by Niklaus Wirth
   *
   * and
   *
   * "A note on error recovery in recursive descent parsers":
   * http://portal.acm.org/citation.cfm?id=947902.947905
   *
   * Later, Josef Grosch had some good ideas:
   *
   * "Efficient and Comfortable Error Recovery in Recursive Descent
   * Parsers":
   * ftp://www.cocolab.com/products/cocktail/doca4.ps/ell.ps.zip
   *
   * Like Grosch I implement context-sensitive FOLLOW sets that are combined
   * at run-time upon error to avoid overhead during parsing.
   */
  getErrorRecoverySet(recognizer) {
    const atn = recognizer.atn;
    let ctx = recognizer.context;
    const recoverSet = new IntervalSet();
    while (ctx !== null && ctx.invokingState >= 0) {
      const invokingState = atn.states[ctx.invokingState];
      const rt2 = invokingState.transitions[0];
      const follow = atn.nextTokens(rt2.followState);
      recoverSet.addSet(follow);
      ctx = ctx.parent;
    }
    recoverSet.removeOne(Token.EPSILON);
    return recoverSet;
  }
  /** Consume tokens until one matches the given token set. */
  consumeUntil(recognizer, set) {
    var _a3, _b3;
    let ttype = ((_a3 = recognizer.tokenStream) == null ? void 0 : _a3.LA(1)) ?? -1;
    while (ttype !== Token.EOF && !set.contains(ttype)) {
      recognizer.consume();
      ttype = ((_b3 = recognizer.tokenStream) == null ? void 0 : _b3.LA(1)) ?? -1;
    }
  }
}, __name(_jb, "DefaultErrorStrategy"), _jb);
var BailErrorStrategy = (_kb = class extends DefaultErrorStrategy {
  /**
   * Instead of recovering from exception `e`, re-throw it wrapped
   * in a {@link ParseCancellationException} so it is not caught by the
   * rule function catches. Use {@link Exception//getCause()} to get the
   * original {@link RecognitionException}.
   */
  recover(recognizer, e10) {
    throw new ParseCancellationException(e10);
  }
  /**
   * Make sure we don't attempt to recover inline; if the parser
   * successfully recovers, it won't throw an exception.
   */
  recoverInline(recognizer) {
    const exception = new InputMismatchException(recognizer);
    throw new ParseCancellationException(exception);
  }
  // Make sure we don't attempt to recover from problems in subrules.
  sync(_recognizer) {
  }
}, __name(_kb, "BailErrorStrategy"), _kb);
var ListTokenSource = (_lb = class {
  constructor(tokens, sourceName) {
    /**
     * The name of the input source. If this value is `null`, a call to
     * {@link #getSourceName} should return the source name used to create the
     * the next token in {@link #tokens} (or the previous token if the end of
     * the input has been reached).
     */
    __publicField(this, "sourceName");
    __publicField(this, "tokenFactory", CommonTokenFactory.DEFAULT);
    /**
     * The wrapped collection of {@link Token} objects to return.
     */
    __publicField(this, "tokens", []);
    /**
     * The index into {@link tokens} of token to return by the next call to
     * {@link #nextToken}. The end of the input is indicated by this value
     * being greater than or equal to the number of items in {@link #tokens}.
     */
    __publicField(this, "i", 0);
    /**
     * This field caches the EOF token for the token source.
     */
    __publicField(this, "eofToken", null);
    this.tokens = tokens;
    this.sourceName = sourceName ?? "";
  }
  get column() {
    if (this.i < this.tokens.length) {
      return this.tokens[this.i].column;
    }
    if (this.eofToken !== null) {
      return this.eofToken.column;
    }
    if (this.tokens.length > 0) {
      const lastToken = this.tokens[this.tokens.length - 1];
      const tokenText = lastToken.text;
      if (tokenText) {
        const lastNewLine = tokenText.lastIndexOf("\n");
        if (lastNewLine >= 0) {
          return tokenText.length - lastNewLine - 1;
        }
      }
      return lastToken.column + lastToken.stop - lastToken.start + 1;
    }
    return 0;
  }
  nextToken() {
    if (this.i >= this.tokens.length) {
      if (this.eofToken === null) {
        let start = -1;
        if (this.tokens.length > 0) {
          const previousStop = this.tokens[this.tokens.length - 1].stop;
          if (previousStop !== -1) {
            start = previousStop + 1;
          }
        }
        const stop = Math.max(-1, start - 1);
        this.eofToken = this.tokenFactory.create(
          [this, this.inputStream],
          Token.EOF,
          "EOF",
          Token.DEFAULT_CHANNEL,
          start,
          stop,
          this.line,
          this.column
        );
      }
      return this.eofToken;
    }
    const t2 = this.tokens[this.i];
    if (this.i === this.tokens.length - 1 && t2.type === Token.EOF) {
      this.eofToken = t2;
    }
    this.i++;
    return t2;
  }
  get line() {
    if (this.i < this.tokens.length) {
      return this.tokens[this.i].line;
    }
    if (this.eofToken !== null) {
      return this.eofToken.line;
    }
    if (this.tokens.length > 0) {
      const lastToken = this.tokens[this.tokens.length - 1];
      let line = lastToken.line;
      const tokenText = lastToken.text;
      if (tokenText) {
        for (const char of tokenText) {
          if (char === "\n") {
            line++;
          }
        }
      }
      return line;
    }
    return 1;
  }
  get inputStream() {
    if (this.i < this.tokens.length) {
      return this.tokens[this.i].inputStream;
    }
    if (this.eofToken !== null) {
      return this.eofToken.inputStream;
    }
    if (this.tokens.length > 0) {
      return this.tokens[this.tokens.length - 1].inputStream;
    }
    return null;
  }
  getSourceName() {
    if (this.sourceName !== null) {
      return this.sourceName;
    }
    const inputStream = this.inputStream;
    if (inputStream !== null) {
      return inputStream.getSourceName();
    }
    return "List";
  }
}, __name(_lb, "ListTokenSource"), _lb);
var InterpreterRuleContext = (_mb = class extends ParserRuleContext {
  constructor(ruleIndex, parent, invokingStateNumber) {
    super(parent, invokingStateNumber);
    /** This is the backing field for {@link #getRuleIndex}. */
    __privateAdd(this, _ruleIndex);
    __privateSet(this, _ruleIndex, ruleIndex);
  }
  get ruleIndex() {
    return __privateGet(this, _ruleIndex);
  }
}, _ruleIndex = new WeakMap(), __name(_mb, "InterpreterRuleContext"), _mb);
var TraceListener = (_nb = class {
  constructor(parser) {
    __publicField(this, "parser");
    this.parser = parser;
  }
  enterEveryRule(ctx) {
    var _a3, _b3;
    console.log("enter   " + this.parser.ruleNames[ctx.ruleIndex] + ", LT(1)=" + ((_b3 = (_a3 = this.parser.inputStream) == null ? void 0 : _a3.LT(1)) == null ? void 0 : _b3.text));
  }
  visitTerminal(node) {
    console.log("consume " + node.getSymbol() + " rule " + this.parser.ruleNames[this.parser.context.ruleIndex]);
  }
  exitEveryRule(ctx) {
    var _a3, _b3;
    console.log("exit    " + this.parser.ruleNames[ctx.ruleIndex] + ", LT(1)=" + ((_b3 = (_a3 = this.parser.inputStream) == null ? void 0 : _a3.LT(1)) == null ? void 0 : _b3.text));
  }
  visitErrorNode(_node) {
  }
}, __name(_nb, "TraceListener"), _nb);
var Parser = (_ob = class extends Recognizer {
  /**
   * This is all the parsing support code essentially. Most of it is error recovery stuff.
   */
  constructor(input) {
    super();
    /** For testing only. */
    __publicField(this, "printer", null);
    /**
     * Specifies whether or not the parser should construct a parse tree during
     * the parsing process. The default value is `true`.
     *
     * @see #getBuildParseTree
     * @see #setBuildParseTree
     */
    __publicField(this, "buildParseTrees", true);
    /**
     * The error handling strategy for the parser. The default value is a new
     * instance of {@link DefaultErrorStrategy}.
     *
     * @see #getErrorHandler
     * @see #setErrorHandler
     */
    __publicField(this, "errorHandler", new DefaultErrorStrategy());
    /**
     * The {@link ParserRuleContext} object for the currently executing rule.
     * This is always non-null during the parsing process.
     */
    // TODO: make private
    __publicField(this, "context", null);
    __publicField(this, "precedenceStack", []);
    /**
     * The list of {@link ParseTreeListener} listeners registered to receive
     * events during the parse.
     *
     * @see #addParseListener
     */
    __publicField(this, "parseListeners", null);
    /**
     * The number of syntax errors reported during parsing. This value is
     * incremented each time {@link #notifyErrorListeners} is called.
     */
    __publicField(this, "syntaxErrors", 0);
    /** Indicates parser has matched EOF token. See {@link #exitRule()}. */
    __publicField(this, "matchedEOF", false);
    /**
     * When {@link #setTrace}`(true)` is called, a reference to the
     * {@link TraceListener} is stored here so it can be easily removed in a
     * later call to {@link #setTrace}`(false)`. The listener itself is
     * implemented as a parser listener so this field is not directly used by
     * other parser methods.
     */
    __publicField(this, "tracer", null);
    /**
     * This field holds the deserialized {@link ATN} with bypass alternatives, created
     * lazily upon first demand. In 4.10 I changed from map<serializedATNString, ATN>
     * since we only need one per parser object and also it complicates other targets
     * that don't use ATN strings.
     *
     * @see ATNDeserializationOptions#isGenerateRuleBypassTransitions()
     */
    __publicField(this, "bypassAltsAtnCache", null);
    __privateAdd(this, _inputStream);
    this.precedenceStack.push(0);
    this.syntaxErrors = 0;
    __privateSet(this, _inputStream, input);
  }
  /** reset the parser's state */
  reset(rewindInputStream = true) {
    if (rewindInputStream) {
      this.inputStream.seek(0);
    }
    this.errorHandler.reset(this);
    this.context = null;
    this.syntaxErrors = 0;
    this.matchedEOF = false;
    this.setTrace(false);
    this.precedenceStack = [];
    this.precedenceStack.push(0);
    if (this.interpreter) {
      this.interpreter.reset();
    }
  }
  /**
   * Match current input symbol against `ttype`. If the symbol type
   * matches, {@link ANTLRErrorStrategy//reportMatch} and {@link consume} are
   * called to complete the match process.
   *
   * If the symbol type does not match,
   * {@link ANTLRErrorStrategy//recoverInline} is called on the current error
   * strategy to attempt recovery. If {@link buildParseTree} is
   * `true` and the token index of the symbol returned by
   * {@link ANTLRErrorStrategy//recoverInline} is -1, the symbol is added to
   * the parse tree by calling {@link ParserRuleContext//addErrorNode}.
   *
   * @param ttype the token type to match
   * @returns the matched symbol
   * @throws RecognitionException if the current input symbol did not match
   * `ttype` and the error strategy could not recover from the
   * mismatched symbol
   */
  match(ttype) {
    let t2 = this.getCurrentToken();
    if (t2.type === ttype) {
      if (ttype === Token.EOF) {
        this.matchedEOF = true;
      }
      this.errorHandler.reportMatch(this);
      this.consume();
    } else {
      t2 = this.errorHandler.recoverInline(this);
      if (this.buildParseTrees && t2.tokenIndex === -1) {
        this.context.addErrorNode(this.createErrorNode(this.context, t2));
      }
    }
    return t2;
  }
  /**
   * Match current input symbol as a wildcard. If the symbol type matches
   * (i.e. has a value greater than 0), {@link ANTLRErrorStrategy//reportMatch}
   * and {@link consume} are called to complete the match process.
   *
   * If the symbol type does not match,
   * {@link ANTLRErrorStrategy//recoverInline} is called on the current error
   * strategy to attempt recovery. If {@link buildParseTree} is
   * `true` and the token index of the symbol returned by
   * {@link ANTLRErrorStrategy//recoverInline} is -1, the symbol is added to
   * the parse tree by calling {@link ParserRuleContext//addErrorNode}.
   *
   * @returns the matched symbol
   * @throws RecognitionException if the current input symbol did not match
   * a wildcard and the error strategy could not recover from the mismatched
   * symbol
   */
  matchWildcard() {
    let t2 = this.getCurrentToken();
    if (t2.type > 0) {
      this.errorHandler.reportMatch(this);
      this.consume();
    } else {
      t2 = this.errorHandler.recoverInline(this);
      if (this.buildParseTrees && t2.tokenIndex === -1) {
        this.context.addErrorNode(this.createErrorNode(this.context, t2));
      }
    }
    return t2;
  }
  getParseListeners() {
    return this.parseListeners ?? [];
  }
  /**
   * Registers `listener` to receive events during the parsing process.
   *
   * To support output-preserving grammar transformations (including but not
   * limited to left-recursion removal, automated left-factoring, and
   * optimized code generation), calls to listener methods during the parse
   * may differ substantially from calls made by
   * {@link ParseTreeWalker//DEFAULT} used after the parse is complete. In
   * particular, rule entry and exit events may occur in a different order
   * during the parse than after the parser. In addition, calls to certain
   * rule entry methods may be omitted.
   *
   * With the following specific exceptions, calls to listener events are
   * deterministic*, i.e. for identical input the calls to listener
   * methods will be the same.
   *
   * - Alterations to the grammar used to generate code may change the
   * behavior of the listener calls.
   * - Alterations to the command line options passed to ANTLR 4 when
   * generating the parser may change the behavior of the listener calls.
   * - Changing the version of the ANTLR Tool used to generate the parser
   * may change the behavior of the listener calls.
   *
   * @param listener the listener to add
   *
   * @throws NullPointerException if {@code} listener is `null`
   */
  addParseListener(listener) {
    if (listener === null) {
      throw new Error("listener");
    }
    if (this.parseListeners === null) {
      this.parseListeners = [];
    }
    this.parseListeners.push(listener);
  }
  /**
   * Remove `listener` from the list of parse listeners.
   *
   * If `listener` is `null` or has not been added as a parse
   * listener, this method does nothing.
   *
   * @param listener the listener to remove
   */
  removeParseListener(listener) {
    if (this.parseListeners !== null && listener !== null) {
      const idx = this.parseListeners.indexOf(listener);
      if (idx >= 0) {
        this.parseListeners.splice(idx, 1);
      }
      if (this.parseListeners.length === 0) {
        this.parseListeners = null;
      }
    }
  }
  // Remove all parse listeners.
  removeParseListeners() {
    this.parseListeners = null;
  }
  // Notify any parse listeners of an enter rule event.
  triggerEnterRuleEvent() {
    if (this.parseListeners !== null) {
      const ctx = this.context;
      this.parseListeners.forEach((listener) => {
        listener.enterEveryRule(ctx);
        ctx.enterRule(listener);
      });
    }
  }
  /**
   * Notify any parse listeners of an exit rule event.
   *
   * @see //addParseListener
   */
  triggerExitRuleEvent() {
    if (this.parseListeners !== null) {
      const ctx = this.context;
      this.parseListeners.slice(0).reverse().forEach((listener) => {
        ctx.exitRule(listener);
        listener.exitEveryRule(ctx);
      });
    }
  }
  getTokenFactory() {
    return this.inputStream.tokenSource.tokenFactory;
  }
  // Tell our token source and error strategy about a new way to create tokens.
  setTokenFactory(factory) {
    this.inputStream.tokenSource.tokenFactory = factory;
  }
  /**
   * The preferred method of getting a tree pattern. For example, here's a
   * sample use:
   *
   * ```
   * const t = parser.expr();
   * const p = parser.compileParseTreePattern("<ID>+0", MyParser.RULE_expr);
   * const m = p.match(t);
   * const id = m.get("ID");
   * ```
   */
  compileParseTreePattern(pattern4, patternRuleIndex, lexer) {
    if (!lexer) {
      if (this.tokenStream !== null) {
        const tokenSource = this.tokenStream.tokenSource;
        if (tokenSource instanceof Lexer) {
          lexer = tokenSource;
        }
      }
    }
    if (!lexer) {
      throw new Error("Parser can't discover a lexer to use");
    }
    const m2 = new ParseTreePatternMatcher(lexer, this);
    return m2.compile(pattern4, patternRuleIndex);
  }
  /**
   * The ATN with bypass alternatives is expensive to create so we create it
   * lazily.
   *
   * @throws UnsupportedOperationException if the current parser does not
   * implement the {@link getSerializedATN()} method.
   */
  getATNWithBypassAlts() {
    const serializedAtn = this.serializedATN;
    if (serializedAtn === null) {
      throw new Error("The current parser does not support an ATN with bypass alternatives.");
    }
    if (this.bypassAltsAtnCache !== null) {
      return this.bypassAltsAtnCache;
    }
    const deserializationOptions = { readOnly: false, verifyATN: true, generateRuleBypassTransitions: true };
    this.bypassAltsAtnCache = new ATNDeserializer(deserializationOptions).deserialize(serializedAtn);
    return this.bypassAltsAtnCache;
  }
  /**
   * Gets the number of syntax errors reported during parsing. This value is
   * incremented each time {@link notifyErrorListeners} is called.
   */
  get numberOfSyntaxErrors() {
    return this.syntaxErrors;
  }
  get inputStream() {
    return __privateGet(this, _inputStream);
  }
  set inputStream(input) {
    this.tokenStream = input;
  }
  get tokenStream() {
    return __privateGet(this, _inputStream);
  }
  /** Set the token stream and reset the parser. */
  set tokenStream(input) {
    this.reset(false);
    __privateSet(this, _inputStream, input);
  }
  /**
   * Match needs to return the current input symbol, which gets put
   * into the label for the associated token ref; e.g., x=ID.
   */
  getCurrentToken() {
    return this.inputStream.LT(1);
  }
  notifyErrorListeners(msg, offendingToken, err) {
    offendingToken = offendingToken ?? null;
    err = err ?? null;
    if (offendingToken === null) {
      offendingToken = this.getCurrentToken();
    }
    this.syntaxErrors += 1;
    const line = offendingToken.line;
    const column = offendingToken.column;
    this.errorListenerDispatch.syntaxError(this, offendingToken, line, column, msg, err);
  }
  /**
   * Consume and return the {@link getCurrentToken current symbol}.
   *
   * E.g., given the following input with `A` being the current
   * lookahead symbol, this function moves the cursor to `B` and returns
   * `A`.
   *
   * ```
   * A B
   * ^
   * ```
   *
   * If the parser is not in error recovery mode, the consumed symbol is added
   * to the parse tree using {@link ParserRuleContext//addChild(Token)}, and
   * {@link ParseTreeListener//visitTerminal} is called on any parse listeners.
   * If the parser *is* in error recovery mode, the consumed symbol is
   * added to the parse tree using
   * {@link ParserRuleContext//addErrorNode(Token)}, and
   * {@link ParseTreeListener//visitErrorNode} is called on any parse
   * listeners.
   */
  consume() {
    const o2 = this.getCurrentToken();
    if (o2.type !== Token.EOF) {
      this.tokenStream.consume();
    }
    const hasListener = this.parseListeners !== null && this.parseListeners.length > 0;
    if (this.buildParseTrees || hasListener) {
      let node;
      if (this.errorHandler.inErrorRecoveryMode(this)) {
        node = this.context.addErrorNode(this.createErrorNode(this.context, o2));
      } else {
        node = this.context.addTokenNode(o2);
      }
      if (hasListener) {
        this.parseListeners.forEach((listener) => {
          if (node instanceof ErrorNode) {
            listener.visitErrorNode(node);
          } else {
            listener.visitTerminal(node);
          }
        });
      }
    }
    return o2;
  }
  addContextToParseTree() {
    var _a3;
    if ((_a3 = this.context) == null ? void 0 : _a3.parent) {
      this.context.parent.addChild(this.context);
    }
  }
  /**
   * Always called by generated parsers upon entry to a rule. Access field
   * {@link context} get the current context.
   */
  enterRule(localctx, state, _ruleIndex2) {
    this.state = state;
    this.context = localctx;
    this.context.start = this.inputStream.LT(1);
    if (this.buildParseTrees) {
      this.addContextToParseTree();
    }
    this.triggerEnterRuleEvent();
  }
  exitRule() {
    if (this.matchedEOF) {
      this.context.stop = this.inputStream.LT(1);
    } else {
      this.context.stop = this.inputStream.LT(-1);
    }
    this.triggerExitRuleEvent();
    this.state = this.context.invokingState;
    this.context = this.context.parent;
  }
  enterOuterAlt(localctx, altNum) {
    var _a3;
    localctx.setAltNumber(altNum);
    if (this.buildParseTrees && this.context !== localctx) {
      if ((_a3 = this.context) == null ? void 0 : _a3.parent) {
        this.context.parent.removeLastChild();
        this.context.parent.addChild(localctx);
      }
    }
    this.context = localctx;
  }
  /**
   * Get the precedence level for the top-most precedence rule.
   *
   * @returns The precedence level for the top-most precedence rule, or -1 if
   * the parser context is not nested within a precedence rule.
   */
  getPrecedence() {
    if (this.precedenceStack.length === 0) {
      return -1;
    }
    return this.precedenceStack[this.precedenceStack.length - 1];
  }
  enterRecursionRule(localctx, state, ruleIndex, precedence) {
    this.state = state;
    this.precedenceStack.push(precedence);
    this.context = localctx;
    this.context.start = this.inputStream.LT(1);
    this.triggerEnterRuleEvent();
  }
  /** Like {@link enterRule} but for recursive rules. */
  pushNewRecursionContext(localctx, state, _ruleIndex2) {
    const previous = this.context;
    previous.parent = localctx;
    previous.invokingState = state;
    previous.stop = this.inputStream.LT(-1);
    this.context = localctx;
    this.context.start = previous.start;
    if (this.buildParseTrees) {
      this.context.addChild(previous);
    }
    this.triggerEnterRuleEvent();
  }
  unrollRecursionContexts(parent) {
    this.precedenceStack.pop();
    this.context.stop = this.inputStream.LT(-1);
    const retCtx = this.context;
    const parseListeners = this.getParseListeners();
    if (parseListeners !== null && parseListeners.length > 0) {
      while (this.context !== parent) {
        this.triggerExitRuleEvent();
        this.context = this.context.parent;
      }
    } else {
      this.context = parent;
    }
    retCtx.parent = parent;
    if (this.buildParseTrees && parent !== null) {
      parent.addChild(retCtx);
    }
  }
  getInvokingContext(ruleIndex) {
    let ctx = this.context;
    while (ctx !== null) {
      if (ctx.ruleIndex === ruleIndex) {
        return ctx;
      }
      ctx = ctx.parent;
    }
    return null;
  }
  precpred(_localctx, precedence) {
    return precedence >= this.precedenceStack[this.precedenceStack.length - 1];
  }
  /**
   * Checks whether or not `symbol` can follow the current state in the
   * ATN. The behavior of this method is equivalent to the following, but is
   * implemented such that the complete context-sensitive follow set does not
   * need to be explicitly constructed.
   *
   * ```
   * return getExpectedTokens().contains(symbol);
   * ```
   *
   * @param symbol the symbol type to check
   * @returns `true` if `symbol` can follow the current state in
   * the ATN, otherwise `false`.
   */
  isExpectedToken(symbol) {
    const atn = this.interpreter.atn;
    let ctx = this.context;
    const s2 = atn.states[this.state];
    let following = atn.nextTokens(s2);
    if (following.contains(symbol)) {
      return true;
    }
    if (!following.contains(Token.EPSILON)) {
      return false;
    }
    while (ctx !== null && ctx.invokingState >= 0 && following.contains(Token.EPSILON)) {
      const invokingState = atn.states[ctx.invokingState];
      const rt2 = invokingState.transitions[0];
      following = atn.nextTokens(rt2.followState);
      if (following.contains(symbol)) {
        return true;
      }
      ctx = ctx.parent;
    }
    if (following.contains(Token.EPSILON) && symbol === Token.EOF) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Computes the set of input symbols which could follow the current parser
   * state and context, as given by {@link getState} and {@link getContext},
   * respectively.
   *
   * {@link ATN.getExpectedTokens ATN.getExpectedTokens(int, RuleContext)}
   */
  getExpectedTokens() {
    return this.interpreter.atn.getExpectedTokens(this.state, this.context);
  }
  getExpectedTokensWithinCurrentRule() {
    const atn = this.interpreter.atn;
    const s2 = atn.states[this.state];
    return atn.nextTokens(s2);
  }
  /** Get a rule's index (i.e., `RULE_ruleName` field) or -1 if not found. */
  getRuleIndex(ruleName) {
    return this.getRuleIndexMap().get(ruleName) ?? -1;
  }
  /**
   * @returns an array of string of the rule names in your parser instance
   * leading up to a call to the current rule. You could override if
   * you want more details such as the file/line info of where
   * in the ATN a rule is invoked.
   *
   * this is very useful for error messages.
   */
  getRuleInvocationStack(p2) {
    p2 = p2 ?? null;
    if (p2 === null) {
      p2 = this.context;
    }
    const stack = [];
    while (p2 !== null) {
      const ruleIndex = p2.ruleIndex;
      if (ruleIndex < 0) {
        stack.push("n/a");
      } else {
        stack.push(this.ruleNames[ruleIndex]);
      }
      p2 = p2.parent;
    }
    return stack;
  }
  /**
   * For debugging and other purposes.
   *
   * TODO: this differs from the Java version. Change it.
   */
  getDFAStrings() {
    return this.interpreter.decisionToDFA.toString();
  }
  /** For debugging and other purposes. */
  dumpDFA() {
    let seenOne = false;
    for (const dfa of this.interpreter.decisionToDFA) {
      if (dfa.length > 0) {
        if (seenOne) {
          console.log();
        }
        if (this.printer) {
          this.printer.println("Decision " + dfa.decision + ":");
          this.printer.print(dfa.toString(this.vocabulary));
        }
        seenOne = true;
      }
    }
  }
  getSourceName() {
    return this.inputStream.getSourceName();
  }
  getParseInfo() {
    const interp = this.interpreter;
    if (interp instanceof ProfilingATNSimulator) {
      return new ParseInfo(interp);
    }
    return void 0;
  }
  setProfile(profile) {
    const interp = this.interpreter;
    const saveMode = interp.predictionMode;
    if (profile) {
      if (!(interp instanceof ProfilingATNSimulator)) {
        this.interpreter = new ProfilingATNSimulator(this);
      }
    } else if (interp instanceof ProfilingATNSimulator) {
      const sharedContextCache = interp.sharedContextCache;
      if (sharedContextCache) {
        const sim = new ParserATNSimulator(this, this.atn, interp.decisionToDFA, sharedContextCache);
        this.interpreter = sim;
      }
    }
    this.interpreter.predictionMode = saveMode;
  }
  /**
   * During a parse is sometimes useful to listen in on the rule entry and exit
   * events as well as token matches. this is for quick and dirty debugging.
   */
  setTrace(trace) {
    if (!trace) {
      this.removeParseListener(this.tracer);
      this.tracer = null;
    } else {
      if (this.tracer !== null) {
        this.removeParseListener(this.tracer);
      }
      this.tracer = new TraceListener(this);
      this.addParseListener(this.tracer);
    }
  }
  createTerminalNode(parent, t2) {
    return new TerminalNode(t2);
  }
  createErrorNode(parent, t2) {
    return new ErrorNode(t2);
  }
}, _inputStream = new WeakMap(), __name(_ob, "Parser"), _ob);
var ParserInterpreter = (_pb = class extends Parser {
  constructor(grammarFileName, vocabulary, ruleNames, atn, input) {
    super(input);
    __publicField(this, "rootContext");
    __publicField(this, "overrideDecisionRoot", null);
    __publicField(this, "parentContextStack", []);
    __publicField(this, "overrideDecisionAlt", -1);
    __publicField(this, "overrideDecisionReached", false);
    __publicField(this, "decisionToDFA");
    __publicField(this, "sharedContextCache", new PredictionContextCache());
    __publicField(this, "pushRecursionContextStates");
    __privateAdd(this, _overrideDecision, -1);
    __privateAdd(this, _overrideDecisionInputIndex, -1);
    __privateAdd(this, _grammarFileName);
    __privateAdd(this, _atn);
    __privateAdd(this, _ruleNames);
    __privateAdd(this, _vocabulary);
    __privateSet(this, _grammarFileName, grammarFileName);
    __privateSet(this, _atn, atn);
    __privateSet(this, _ruleNames, ruleNames.slice(0));
    __privateSet(this, _vocabulary, vocabulary);
    this.pushRecursionContextStates = new BitSet();
    for (const state of atn.states) {
      if (state instanceof StarLoopEntryState && state.precedenceRuleDecision) {
        this.pushRecursionContextStates.set(state.stateNumber);
      }
    }
    this.decisionToDFA = atn.decisionToState.map((ds2, i2) => {
      return new DFA(ds2, i2);
    });
    this.interpreter = new ParserATNSimulator(this, atn, this.decisionToDFA, this.sharedContextCache);
  }
  reset() {
    super.reset();
    this.overrideDecisionReached = false;
    this.overrideDecisionRoot = null;
  }
  get atn() {
    return __privateGet(this, _atn);
  }
  get vocabulary() {
    return __privateGet(this, _vocabulary);
  }
  get ruleNames() {
    return __privateGet(this, _ruleNames);
  }
  get grammarFileName() {
    return __privateGet(this, _grammarFileName);
  }
  get atnState() {
    return __privateGet(this, _atn).states[this.state];
  }
  parse(startRuleIndex) {
    var _a3;
    const startRuleStartState = __privateGet(this, _atn).ruleToStartState[startRuleIndex];
    this.rootContext = this.createInterpreterRuleContext(null, ATNState.INVALID_STATE_NUMBER, startRuleIndex);
    if (startRuleStartState.isLeftRecursiveRule) {
      this.enterRecursionRule(this.rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
    } else {
      this.enterRule(this.rootContext, startRuleStartState.stateNumber, startRuleIndex);
    }
    while (true) {
      const p2 = this.atnState;
      switch (p2.constructor.stateType) {
        case ATNState.RULE_STOP: {
          if ((_a3 = this.context) == null ? void 0 : _a3.isEmpty()) {
            if (startRuleStartState.isLeftRecursiveRule) {
              const result = this.context;
              const parentContext = this.parentContextStack.pop();
              this.unrollRecursionContexts(parentContext[0]);
              return result;
            } else {
              this.exitRule();
              return this.rootContext;
            }
          }
          this.visitRuleStopState(p2);
          break;
        }
        default: {
          try {
            this.visitState(p2);
          } catch (e10) {
            if (e10 instanceof RecognitionException) {
              this.state = __privateGet(this, _atn).ruleToStopState[p2.ruleIndex].stateNumber;
              this.errorHandler.reportError(this, e10);
              this.recover(e10);
            } else {
              throw e10;
            }
          }
          break;
        }
      }
    }
  }
  addDecisionOverride(decision, tokenIndex, forcedAlt) {
    __privateSet(this, _overrideDecision, decision);
    __privateSet(this, _overrideDecisionInputIndex, tokenIndex);
    this.overrideDecisionAlt = forcedAlt;
  }
  get overrideDecision() {
    return __privateGet(this, _overrideDecision);
  }
  get overrideDecisionInputIndex() {
    return __privateGet(this, _overrideDecisionInputIndex);
  }
  enterRecursionRule(localctx, state, ruleIndex, precedence) {
    this.parentContextStack.push([this.context, localctx.invokingState]);
    super.enterRecursionRule(localctx, state, ruleIndex, precedence);
  }
  get serializedATN() {
    throw new Error("The ParserInterpreter does not support the serializedATN property.");
  }
  visitState(p2) {
    let predictedAlt = 1;
    if (p2 instanceof DecisionState) {
      predictedAlt = this.visitDecisionState(p2);
    }
    const transition = p2.transitions[predictedAlt - 1];
    switch (transition.transitionType) {
      case Transition.EPSILON:
        if (this.pushRecursionContextStates.get(p2.stateNumber) && !(transition.target.constructor.stateType === ATNState.LOOP_END)) {
          const parentContext = this.parentContextStack[this.parentContextStack.length - 1];
          const localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this.context.ruleIndex);
          this.pushNewRecursionContext(
            localctx,
            __privateGet(this, _atn).ruleToStartState[p2.ruleIndex].stateNumber,
            this.context.ruleIndex
          );
        }
        break;
      case Transition.ATOM:
        this.match(transition.label.minElement);
        break;
      case Transition.RANGE:
      case Transition.SET:
      case Transition.NOT_SET:
        if (!transition.matches(this.inputStream.LA(1), Token.MIN_USER_TOKEN_TYPE, 65535)) {
          this.recoverInline();
        }
        this.matchWildcard();
        break;
      case Transition.WILDCARD:
        this.matchWildcard();
        break;
      case Transition.RULE:
        const ruleStartState = transition.target;
        const ruleIndex = ruleStartState.ruleIndex;
        const newContext = this.createInterpreterRuleContext(this.context, p2.stateNumber, ruleIndex);
        if (ruleStartState.isLeftRecursiveRule) {
          this.enterRecursionRule(
            newContext,
            ruleStartState.stateNumber,
            ruleIndex,
            transition.precedence
          );
        } else {
          this.enterRule(newContext, transition.target.stateNumber, ruleIndex);
        }
        break;
      case Transition.PREDICATE:
        const predicateTransition = transition;
        if (!this.sempred(this.context, predicateTransition.ruleIndex, predicateTransition.predIndex)) {
          throw new FailedPredicateException(this);
        }
        break;
      case Transition.ACTION:
        const actionTransition = transition;
        this.action(this.context, actionTransition.ruleIndex, actionTransition.actionIndex);
        break;
      case Transition.PRECEDENCE:
        if (!this.precpred(this.context, transition.precedence)) {
          const precedence = transition.precedence;
          throw new FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
        }
        break;
      default:
        throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
    }
    this.state = transition.target.stateNumber;
  }
  visitDecisionState(p2) {
    let predictedAlt = 1;
    if (p2.transitions.length > 1) {
      this.errorHandler.sync(this);
      const decision = p2.decision;
      if (decision === __privateGet(this, _overrideDecision) && this.inputStream.index === __privateGet(this, _overrideDecisionInputIndex) && !this.overrideDecisionReached) {
        predictedAlt = this.overrideDecisionAlt;
        this.overrideDecisionReached = true;
      } else {
        predictedAlt = this.interpreter.adaptivePredict(this.inputStream, decision, this.context);
      }
    }
    return predictedAlt;
  }
  createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
    return new InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
  }
  visitRuleStopState(p2) {
    const ruleStartState = __privateGet(this, _atn).ruleToStartState[p2.ruleIndex];
    if (ruleStartState.isLeftRecursiveRule) {
      const [parentContext, state] = this.parentContextStack.pop();
      this.unrollRecursionContexts(parentContext);
      this.state = state;
    } else {
      this.exitRule();
    }
    const ruleTransition = __privateGet(this, _atn).states[this.state].transitions[0];
    this.state = ruleTransition.followState.stateNumber;
  }
  recover(e10) {
    const i2 = this.inputStream.index;
    this.errorHandler.recover(this, e10);
    if (this.inputStream.index === i2) {
      const tok = e10.offendingToken;
      if (!tok) {
        throw new Error("Expected exception to have an offending token");
      }
      const source = tok.tokenSource;
      const stream = (source == null ? void 0 : source.inputStream) ?? null;
      const sourcePair = [source, stream];
      if (e10 instanceof InputMismatchException) {
        const expectedTokens = e10.getExpectedTokens();
        if (!expectedTokens) {
          throw new Error("Expected the exception to provide expected tokens");
        }
        let expectedTokenType = Token.INVALID_TYPE;
        if (expectedTokens.length !== 0) {
          expectedTokenType = expectedTokens.minElement;
        }
        const errToken = this.getTokenFactory().create(
          sourcePair,
          expectedTokenType,
          tok.text,
          Token.DEFAULT_CHANNEL,
          -1,
          -1,
          tok.line,
          tok.column
        );
        this.context.addErrorNode(this.createErrorNode(this.context, errToken));
      } else {
        const errToken = this.getTokenFactory().create(
          sourcePair,
          Token.INVALID_TYPE,
          tok.text,
          Token.DEFAULT_CHANNEL,
          -1,
          -1,
          tok.line,
          tok.column
        );
        this.context.addErrorNode(this.createErrorNode(this.context, errToken));
      }
    }
  }
  recoverInline() {
    return this.errorHandler.recoverInline(this);
  }
}, _overrideDecision = new WeakMap(), _overrideDecisionInputIndex = new WeakMap(), _grammarFileName = new WeakMap(), _atn = new WeakMap(), _ruleNames = new WeakMap(), _vocabulary = new WeakMap(), __name(_pb, "ParserInterpreter"), _pb);
var MultiMap = (_qb = class extends Map {
  map(key, value) {
    let elementsForKey = this.get(key);
    if (!elementsForKey) {
      elementsForKey = new Array();
      this.set(key, elementsForKey);
    }
    elementsForKey.push(value);
  }
  getPairs() {
    const pairs = new Array();
    for (const key of this.keys()) {
      const keys = this.get(key) ?? [];
      for (const value of keys) {
        pairs.push([key, value]);
      }
    }
    return pairs;
  }
  toString() {
    const entries = [];
    this.forEach((value, key) => {
      entries.push(`${key}=[${value.join(", ")}]`);
    });
    return `{${entries.join(", ")}}`;
  }
}, __name(_qb, "MultiMap"), _qb);
var CannotInvokeStartRuleError = (_rb = class extends Error {
  constructor(e10) {
    super();
    this.cause = e10;
  }
}, __name(_rb, "CannotInvokeStartRuleError"), _rb);
var RuleTagToken = (_sb = class {
  constructor(ruleName, bypassTokenType, label) {
    /** The name of the label associated with the rule tag. */
    __publicField(this, "label");
    /** The name of the parser rule associated with this rule tag. */
    __publicField(this, "ruleName");
    /**
     * The token type for the current token. This is the token type assigned to
     * the bypass alternative for the rule during ATN deserialization.
     */
    __publicField(this, "bypassTokenType");
    this.ruleName = ruleName;
    this.bypassTokenType = bypassTokenType;
    this.label = label;
  }
  /**
   * Rule tag tokens are always placed on the {@link #DEFAULT_CHANNEL}.
   */
  get channel() {
    return Token.DEFAULT_CHANNEL;
  }
  /**
   * This method returns the rule tag formatted with `<` and `>`
   * delimiters.
   */
  get text() {
    if (this.label !== void 0) {
      return "<" + this.label + ":" + this.ruleName + ">";
    }
    return "<" + this.ruleName + ">";
  }
  /**
   * Rule tag tokens have types assigned according to the rule bypass
   * transitions created during ATN deserialization.
   */
  get type() {
    return this.bypassTokenType;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns 0.
   */
  get line() {
    return 0;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns -1.
   */
  get column() {
    return -1;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns -1.
   */
  get tokenIndex() {
    return -1;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns -1.
   */
  get start() {
    return -1;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns -1.
   */
  get stop() {
    return -1;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns `null`.
   */
  get tokenSource() {
    return null;
  }
  /**
   * The implementation for {@link RuleTagToken} always returns `null`.
   */
  get inputStream() {
    return null;
  }
  /**
   * The implementation for {@link RuleTagToken} returns a string of the form
   * `ruleName:bypassTokenType`.
   */
  toString() {
    return this.ruleName + ":" + this.bypassTokenType;
  }
}, __name(_sb, "RuleTagToken"), _sb);
var StartRuleDoesNotConsumeFullPatternError = (_tb = class extends Error {
}, __name(_tb, "StartRuleDoesNotConsumeFullPatternError"), _tb);
var TagChunk = (_ub = class extends Chunk {
  constructor(...args) {
    let label;
    let tag;
    if (args.length === 1) {
      tag = args[0];
    } else {
      label = args[0];
      tag = args[1];
    }
    super();
    __publicField(this, "tag");
    __publicField(this, "label");
    if (!tag) {
      throw new Error("tag cannot be null or empty");
    }
    this.label = label;
    this.tag = tag;
  }
  /**
   * @returns a text representation of the tag chunk. Labeled tags
   * are returned in the form `label:tag`, and unlabeled tags are
   * returned as just the tag name.
   */
  toString() {
    if (this.label !== void 0) {
      return this.label + ":" + this.tag;
    }
    return this.tag;
  }
}, __name(_ub, "TagChunk"), _ub);
var TextChunk = (_vb = class extends Chunk {
  /**
   * Constructs a new instance of {@link TextChunk} with the specified text.
   *
   * @param text The text of this chunk.
   */
  constructor(text) {
    super();
    __publicField(this, "text");
    this.text = text;
  }
  /**
   * @returns the result of {@link #getText()} in single quotes.
   */
  toString() {
    return "'" + this.text + "'";
  }
}, __name(_vb, "TextChunk"), _vb);
var TokenTagToken = (_wb = class extends CommonToken {
  constructor(tokenName, type4, label) {
    super({ type: type4, source: CommonToken.EMPTY_SOURCE });
    __publicField(this, "tokenName");
    /**
     * The name of the label associated with the rule tag, or undefined if this is an unlabeled rule tag.
     */
    __publicField(this, "label");
    this.tokenName = tokenName;
    this.label = label;
  }
  /**
   *
   * @returns the token tag formatted with `<` and `>` delimiters.
   */
  get text() {
    if (this.label !== void 0) {
      return "<" + this.label + ":" + this.tokenName + ">";
    }
    return "<" + this.tokenName + ">";
  }
  /**
   * @returns a string of the form `tokenName:type`.
   */
  toString() {
    return this.tokenName + ":" + this.type;
  }
}, __name(_wb, "TokenTagToken"), _wb);
var ParseTreePatternMatcher = (_xb = class {
  /**
   * Constructs a {@link ParseTreePatternMatcher} or from a {@link Lexer} and
   * {@link Parser} object. The lexer input stream is altered for tokenizing
   * the tree patterns. The parser is used as a convenient mechanism to get
   * the grammar name, plus token, rule names.
   */
  constructor(lexer, parser) {
    __publicField(this, "start", "<");
    __publicField(this, "stop", ">");
    __publicField(this, "escape", "\\");
    // e.g., \< and \> must escape BOTH!
    /**
     * This is the backing field for {@link #getLexer()}.
     */
    __publicField(this, "lexer");
    /**
     * This is the backing field for {@link #getParser()}.
     */
    __publicField(this, "parser");
    this.lexer = lexer;
    this.parser = parser;
  }
  /**
   * Set the delimiters used for marking rule and token tags within concrete
   * syntax used by the tree pattern parser.
   *
   * @param start The start delimiter.
   * @param stop The stop delimiter.
   * @param escapeLeft The escape sequence to use for escaping a start or stop delimiter.
   *
   * @throws Error if `start` is `null` or empty.
   * @throws Error if `stop` is `null` or empty.
   */
  setDelimiters(start, stop, escapeLeft) {
    if (start === null || start.length === 0) {
      throw new Error("start cannot be null or empty");
    }
    if (stop === null || stop.length === 0) {
      throw new Error("stop cannot be null or empty");
    }
    this.start = start;
    this.stop = stop;
    this.escape = escapeLeft;
  }
  matches(...args) {
    switch (args.length) {
      case 2: {
        const [tree, pattern4] = args;
        const labels = new MultiMap();
        const mismatchedNode = this.matchImpl(tree, pattern4.getPatternTree(), labels);
        return mismatchedNode === null;
      }
      case 3: {
        const [tree, pattern4, patternRuleIndex] = args;
        const p2 = this.compile(pattern4, patternRuleIndex);
        return this.matches(tree, p2);
      }
      default: {
        throw new Error("Invalid number of arguments");
      }
    }
  }
  match(...args) {
    switch (args.length) {
      case 2: {
        const [tree, pattern4] = args;
        const labels = new MultiMap();
        const mismatchedNode = this.matchImpl(tree, pattern4.getPatternTree(), labels);
        return new ParseTreeMatch(tree, pattern4, labels, mismatchedNode);
      }
      case 3: {
        const [tree, pattern4, patternRuleIndex] = args;
        const p2 = this.compile(pattern4, patternRuleIndex);
        return this.match(tree, p2);
      }
      default: {
        throw new Error("Invalid number of arguments");
      }
    }
  }
  /**
   * For repeated use of a tree pattern, compile it to a
   * {@link ParseTreePattern} using this method.
   */
  compile(pattern4, patternRuleIndex) {
    const tokenList = this.tokenize(pattern4);
    const tokenSrc = new ListTokenSource(tokenList);
    const tokens = new CommonTokenStream(tokenSrc);
    const parserInterp = new ParserInterpreter(
      this.parser.grammarFileName,
      this.parser.vocabulary,
      this.parser.ruleNames,
      this.parser.getATNWithBypassAlts(),
      tokens
    );
    parserInterp.removeErrorListeners();
    let tree = null;
    try {
      parserInterp.errorHandler = new BailErrorStrategy();
      tree = parserInterp.parse(patternRuleIndex);
    } catch (error) {
      if (error instanceof ParseCancellationException) {
        throw error.cause;
      } else if (error instanceof RecognitionException) {
        throw error;
      } else if (error instanceof Error) {
        throw new CannotInvokeStartRuleError(error);
      } else {
        throw error;
      }
    }
    if (tokens.LA(1) !== Token.EOF) {
      throw new StartRuleDoesNotConsumeFullPatternError();
    }
    return new ParseTreePattern(this, pattern4, patternRuleIndex, tree);
  }
  /**
   * Used to convert the tree pattern string into a series of tokens. The
   * input stream is reset.
   */
  getLexer() {
    return this.lexer;
  }
  /**
   * Used to collect to the grammar file name, token names, rule names for
   * used to parse the pattern into a parse tree.
   */
  getParser() {
    return this.parser;
  }
  // ---- SUPPORT CODE ----
  tokenize(pattern4) {
    const chunks = this.split(pattern4);
    const tokens = new Array();
    for (const chunk of chunks) {
      if (chunk instanceof TagChunk) {
        const tagChunk = chunk;
        const char = tagChunk.tag[0];
        if (char === char.toUpperCase()) {
          const ttype = this.parser.getTokenType(tagChunk.tag);
          if (ttype === Token.INVALID_TYPE) {
            throw new Error("Unknown token " + tagChunk.tag + " in pattern: " + pattern4);
          }
          const t2 = new TokenTagToken(tagChunk.tag, ttype, tagChunk.label);
          tokens.push(t2);
        } else {
          if (char === char.toLowerCase()) {
            const ruleIndex = this.parser.getRuleIndex(tagChunk.tag);
            if (ruleIndex === -1) {
              throw new Error("Unknown rule " + tagChunk.tag + " in pattern: " + pattern4);
            }
            const ruleImaginaryTokenType = this.parser.getATNWithBypassAlts().ruleToTokenType[ruleIndex];
            tokens.push(new RuleTagToken(tagChunk.tag, ruleImaginaryTokenType, tagChunk.label));
          } else {
            throw new Error("invalid tag: " + tagChunk.tag + " in pattern: " + pattern4);
          }
        }
      } else {
        const textChunk = chunk;
        const input = CharStream.fromString(textChunk.text);
        this.lexer.inputStream = input;
        let t2 = this.lexer.nextToken();
        while (t2.type !== Token.EOF) {
          tokens.push(t2);
          t2 = this.lexer.nextToken();
        }
      }
    }
    return tokens;
  }
  /**
   * Split `<ID> = <e:expr> ;` into 4 chunks for tokenizing by {@link #tokenize}.
   */
  split(pattern4) {
    let p2 = 0;
    const n2 = pattern4.length;
    const chunks = new Array();
    const starts = new Array();
    const stops = new Array();
    while (p2 < n2) {
      if (p2 === pattern4.indexOf(this.escape + this.start, p2)) {
        p2 += this.escape.length + this.start.length;
      } else {
        if (p2 === pattern4.indexOf(this.escape + this.stop, p2)) {
          p2 += this.escape.length + this.stop.length;
        } else {
          if (p2 === pattern4.indexOf(this.start, p2)) {
            starts.push(p2);
            p2 += this.start.length;
          } else {
            if (p2 === pattern4.indexOf(this.stop, p2)) {
              stops.push(p2);
              p2 += this.stop.length;
            } else {
              p2++;
            }
          }
        }
      }
    }
    if (starts.length > stops.length) {
      throw new Error("unterminated tag in pattern: " + pattern4);
    }
    if (starts.length < stops.length) {
      throw new Error("missing start tag in pattern: " + pattern4);
    }
    const tagCount = starts.length;
    for (let i2 = 0; i2 < tagCount; i2++) {
      if (starts[i2] >= stops[i2]) {
        throw new Error("tag delimiters out of order in pattern: " + pattern4);
      }
    }
    if (tagCount === 0) {
      const text = pattern4.substring(0, n2);
      chunks.push(new TextChunk(text));
    }
    if (tagCount > 0 && starts[0] > 0) {
      const text = pattern4.substring(0, starts[0]);
      chunks.push(new TextChunk(text));
    }
    for (let i2 = 0; i2 < tagCount; i2++) {
      const tag = pattern4.substring(starts[i2] + this.start.length, stops[i2]);
      let ruleOrToken = tag;
      let label;
      const colon = tag.indexOf(":");
      if (colon >= 0) {
        label = tag.substring(0, colon);
        ruleOrToken = tag.substring(colon + 1, tag.length);
      }
      chunks.push(new TagChunk(label, ruleOrToken));
      if (i2 + 1 < tagCount) {
        const text = pattern4.substring(stops[i2] + this.stop.length, starts[i2 + 1]);
        chunks.push(new TextChunk(text));
      }
    }
    if (tagCount > 0) {
      const afterLastTag = stops[tagCount - 1] + this.stop.length;
      if (afterLastTag < n2) {
        const text = pattern4.substring(afterLastTag, n2);
        chunks.push(new TextChunk(text));
      }
    }
    for (let i2 = 0; i2 < chunks.length; i2++) {
      const c3 = chunks[i2];
      if (c3 instanceof TextChunk) {
        const tc2 = c3;
        const unescaped = tc2.text.replaceAll(this.escape, "");
        if (unescaped.length < tc2.text.length) {
          chunks[i2] = new TextChunk(unescaped);
        }
      }
    }
    return chunks;
  }
  /**
   * Recursively walk `tree` against `patternTree`, filling
   * `match.`{@link ParseTreeMatch#labels labels}.
   *
   * @returns the first node encountered in `tree` which does not match
   * a corresponding node in `patternTree`, or `null` if the match
   * was successful. The specific node returned depends on the matching
   * algorithm used by the implementation, and may be overridden.
   */
  matchImpl(tree, patternTree, labels) {
    if (tree instanceof TerminalNode && patternTree instanceof TerminalNode) {
      const t1 = tree;
      const t2 = patternTree;
      let mismatchedNode;
      if (t1.getSymbol().type === t2.getSymbol().type) {
        if (t2.getSymbol() instanceof TokenTagToken) {
          const tokenTagToken = t2.getSymbol();
          labels.map(tokenTagToken.tokenName, tree);
          if (tokenTagToken.label !== void 0) {
            labels.map(tokenTagToken.label, tree);
          }
        } else {
          if (t1.getText() === t2.getText()) ;
          else {
            if (!mismatchedNode) {
              mismatchedNode = t1;
            }
          }
        }
      } else {
        if (!mismatchedNode) {
          mismatchedNode = t1;
        }
      }
      return mismatchedNode;
    }
    if (tree instanceof ParserRuleContext && patternTree instanceof ParserRuleContext) {
      let mismatchedNode;
      const ruleTagToken = this.getRuleTagToken(patternTree);
      if (ruleTagToken) {
        if (tree.ruleIndex === patternTree.ruleIndex) {
          labels.map(ruleTagToken.ruleName, tree);
          if (ruleTagToken.label) {
            labels.map(ruleTagToken.label, tree);
          }
        } else {
          if (!mismatchedNode) {
            mismatchedNode = tree;
          }
        }
        return mismatchedNode;
      }
      if (tree.getChildCount() !== patternTree.getChildCount()) {
        if (!mismatchedNode) {
          mismatchedNode = tree;
        }
        return mismatchedNode;
      }
      const n2 = tree.getChildCount();
      for (let i2 = 0; i2 < n2; i2++) {
        const childMatch = this.matchImpl(tree.getChild(i2), patternTree.getChild(i2), labels);
        if (childMatch) {
          return childMatch;
        }
      }
      return mismatchedNode;
    }
    return tree;
  }
  /**
   * Is `t` `(expr <expr>)` subtree?
   */
  getRuleTagToken(t2) {
    if (t2 instanceof ParserRuleContext) {
      if (t2.getChildCount() === 1 && t2.getChild(0) instanceof TerminalNode) {
        const c3 = t2.getChild(0);
        if (c3.getSymbol() instanceof RuleTagToken) {
          return c3.getSymbol();
        }
      }
    }
    return void 0;
  }
}, __name(_xb, "ParseTreePatternMatcher"), _xb);
_yb = class extends BaseErrorListener {
  constructor(exactOnly) {
    super();
    /**
     * When `true`, only exactly known ambiguities are reported.
     */
    __publicField(this, "exactOnly");
    __publicField(this, "reportAmbiguity", /* @__PURE__ */ __name((recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) => {
      var _a3;
      if (this.exactOnly && !exact) {
        return;
      }
      const decision = this.getDecisionDescription(recognizer, dfa);
      const conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
      const text = (_a3 = recognizer.tokenStream) == null ? void 0 : _a3.getTextFromInterval(Interval.of(startIndex, stopIndex));
      const message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
      recognizer.notifyErrorListeners(message, null, null);
    }, "reportAmbiguity"));
    __publicField(this, "reportAttemptingFullContext", /* @__PURE__ */ __name((recognizer, dfa, startIndex, stopIndex, _conflictingAlts, _configs) => {
      var _a3;
      const decision = this.getDecisionDescription(recognizer, dfa);
      const text = (_a3 = recognizer.tokenStream) == null ? void 0 : _a3.getTextFromInterval(Interval.of(startIndex, stopIndex));
      const message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
      recognizer.notifyErrorListeners(message, null, null);
    }, "reportAttemptingFullContext"));
    __publicField(this, "reportContextSensitivity", /* @__PURE__ */ __name((recognizer, dfa, startIndex, stopIndex, _prediction, _configs) => {
      var _a3;
      const decision = this.getDecisionDescription(recognizer, dfa);
      const text = (_a3 = recognizer.tokenStream) == null ? void 0 : _a3.getTextFromInterval(Interval.of(startIndex, stopIndex));
      const message = `reportContextSensitivity d=${decision}, input='${text}'`;
      recognizer.notifyErrorListeners(message, null, null);
    }, "reportContextSensitivity"));
    __publicField(this, "getDecisionDescription", /* @__PURE__ */ __name((recognizer, dfa) => {
      const decision = dfa.decision;
      const ruleIndex = dfa.atnStartState.ruleIndex;
      const ruleNames = recognizer.ruleNames;
      if (ruleIndex < 0 || ruleIndex >= ruleNames.length) {
        return decision.toString();
      }
      const ruleName = ruleNames[ruleIndex];
      if (ruleName.length === 0) {
        return decision.toString();
      }
      return `${decision} (${ruleName})`;
    }, "getDecisionDescription"));
    /**
     * Computes the set of conflicting or ambiguous alternatives from a
     * configuration set, if that information was not already provided by the
     * parser.
     *
     * @param reportedAlts The set of conflicting or ambiguous alternatives, as
     * reported by the parser.
     * @param configs The conflicting or ambiguous configuration set.
     * @returns Returns `reportedAlts` if it is not `null`, otherwise
     * returns the set of alternatives represented in `configs`.
     */
    __publicField(this, "getConflictingAlts", /* @__PURE__ */ __name((reportedAlts, configs) => {
      if (reportedAlts) {
        return reportedAlts;
      }
      const result = new BitSet();
      for (let i2 = 0; i2 < configs.configs.length; i2++) {
        result.set(configs.configs[i2].alt);
      }
      return result;
    }, "getConflictingAlts"));
    this.exactOnly = exactOnly ?? true;
  }
}, __name(_yb, "DiagnosticErrorListener"), _yb;
_zb = class extends Lexer {
  constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input) {
    super(input);
    __publicField(this, "decisionToDFA");
    __publicField(this, "sharedContextCache", new PredictionContextCache());
    __privateAdd(this, _grammarFileName2);
    __privateAdd(this, _atn2);
    __privateAdd(this, _ruleNames2);
    __privateAdd(this, _channelNames);
    __privateAdd(this, _modeNames);
    __privateAdd(this, _vocabulary2);
    if (atn.grammarType !== ATN.LEXER) {
      throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
    }
    __privateSet(this, _grammarFileName2, grammarFileName);
    __privateSet(this, _atn2, atn);
    __privateSet(this, _ruleNames2, ruleNames.slice(0));
    __privateSet(this, _channelNames, channelNames.slice(0));
    __privateSet(this, _modeNames, modeNames.slice(0));
    __privateSet(this, _vocabulary2, vocabulary);
    this.decisionToDFA = atn.decisionToState.map((ds2, i2) => {
      return new DFA(ds2, i2);
    });
    this.interpreter = new LexerATNSimulator(this, atn, this.decisionToDFA, this.sharedContextCache);
  }
  get atn() {
    return __privateGet(this, _atn2);
  }
  get grammarFileName() {
    return __privateGet(this, _grammarFileName2);
  }
  get ruleNames() {
    return __privateGet(this, _ruleNames2);
  }
  get channelNames() {
    return __privateGet(this, _channelNames);
  }
  get modeNames() {
    return __privateGet(this, _modeNames);
  }
  get vocabulary() {
    return __privateGet(this, _vocabulary2);
  }
  get serializedATN() {
    throw new Error("The LexerInterpreter does not support the serializedATN property.");
  }
}, _grammarFileName2 = new WeakMap(), _atn2 = new WeakMap(), _ruleNames2 = new WeakMap(), _channelNames = new WeakMap(), _modeNames = new WeakMap(), _vocabulary2 = new WeakMap(), __name(_zb, "LexerInterpreter"), _zb;
_Ab = class {
  /**
   * Gets the currently executing version of the ANTLR 4 runtime library.
   *
   * This method provides runtime access to the {@link VERSION} field, as
   * opposed to directly referencing the field as a compile-time constant.
   *
   * @returns The currently executing version of the ANTLR 4 library
   */
  static getRuntimeVersion() {
    return _Ab.VERSION;
  }
  /**
   * This method provides the ability to detect mismatches between the version
   * of ANTLR 4 used to generate a parser, the version of the ANTLR runtime a
   * parser was compiled against, and the version of the ANTLR runtime which
   * is currently executing.
   *
   * The version check is designed to detect the following two specific
   * scenarios.
   *
   * - The ANTLR Tool version used for code generation does not match the
   * currently executing runtime version.
   * - The ANTLR Runtime version referenced at the time a parser was
   * compiled does not match the currently executing runtime version.
   *
   *
   * Starting with ANTLR 4.3, the code generator emits a call to this method
   * using two constants in each generated lexer and parser: a hard-coded
   * constant indicating the version of the tool used to generate the parser
   * and a reference to the compile-time constant {@link VERSION}. At
   * runtime, this method is called during the initialization of the generated
   * parser to detect mismatched versions, and notify the registered listeners
   * prior to creating instances of the parser.
   *
   *
   * This method does not perform any detection or filtering of semantic
   * changes between tool and runtime versions. It simply checks for a
   * version match and emits an error to stderr if a difference
   * is detected.
   *
   *
   * Note that some breaking changes between releases could result in other
   * types of runtime exceptions, such as a {@link LinkageError}, prior to
   * calling this method. In these cases, the underlying version mismatch will
   * not be reported here. This method is primarily intended to
   * notify users of potential semantic changes between releases that do not
   * result in binary compatibility problems which would be detected by the
   * class loader. As with semantic changes, changes that break binary
   * compatibility between releases are mentioned in the release notes
   * accompanying the affected release.
   *
   *
   * **Additional note for target developers:** The version check
   * implemented by this class is designed to address specific compatibility
   * concerns that may arise during the execution of Java applications. Other
   * targets should consider the implementation of this method in the context
   * of that target's known execution environment, which may or may not
   * resemble the design provided for the Java target.
   *
   * @param generatingToolVersion The version of the tool used to generate a parser.
   * This value may be null when called from user code that was not generated
   * by, and does not reference, the ANTLR 4 Tool itself.
   * @param compileTimeVersion The version of the runtime the parser was
   * compiled against. This should always be passed using a direct reference
   * to {@link VERSION}.
   */
  static checkVersion(generatingToolVersion, compileTimeVersion) {
    const runtimeVersion = _Ab.VERSION;
    let runtimeConflictsWithGeneratingTool = false;
    let runtimeConflictsWithCompileTimeTool = false;
    runtimeConflictsWithGeneratingTool = runtimeVersion !== generatingToolVersion && _Ab.getMajorMinorVersion(runtimeVersion) !== _Ab.getMajorMinorVersion(generatingToolVersion);
    runtimeConflictsWithCompileTimeTool = runtimeVersion !== compileTimeVersion && _Ab.getMajorMinorVersion(runtimeVersion) !== _Ab.getMajorMinorVersion(compileTimeVersion);
    if (runtimeConflictsWithGeneratingTool) {
      console.error(`ANTLR Tool version ${generatingToolVersion} used for code generation does not match the current runtime version ${runtimeVersion}`);
    }
    if (runtimeConflictsWithCompileTimeTool) {
      console.error(`ANTLR Runtime version ${compileTimeVersion} used for parser compilation does not match the current runtime version ${runtimeVersion}`);
    }
  }
  /**
   * Gets the major and minor version numbers from a version string. For
   * details about the syntax of the input `version`.
   * E.g., from x.y.z return x.y.
   *
   * @param version The complete version string.
   * @returns A string of the form *major*.*minor* containing
   * only the major and minor components of the version string.
   */
  static getMajorMinorVersion(version2) {
    const firstDot = version2.indexOf(".");
    const secondDot = firstDot >= 0 ? version2.indexOf(".", firstDot + 1) : -1;
    const firstDash = version2.indexOf("-");
    let referenceLength = version2.length;
    if (secondDot >= 0) {
      referenceLength = Math.min(referenceLength, secondDot);
    }
    if (firstDash >= 0) {
      referenceLength = Math.min(referenceLength, firstDash);
    }
    return version2.substring(0, referenceLength);
  }
}, __name(_Ab, "RuntimeMetaData"), /**
 * A compile-time constant containing the current version of the ANTLR 4
 * runtime library.
 *
 * This compile-time constant value allows generated parsers and other
 * libraries to include a literal reference to the version of the ANTLR 4
 * runtime library the code was compiled against. At each release, we
 * change this value.
 *
 * Version numbers are assumed to have the form
 *
 * major.minor.patch.revision-suffix,
 *
 * with the individual components defined as follows.
 *
 * - major is a required non-negative integer, and is equal to `4` for ANTLR 4.
 * - minor is a required non-negative integer.
 * - patch is an optional non-negative integer. When patch is omitted, the `.` (dot) appearing before it is
 *   also omitted.
 * - revision is an optional non-negative integer, and may only be included when patch is also included.
 *   When revision is omitted, the `.` (dot) appearing before it is also omitted.
 * - suffix is an optional string. When suffix is omitted, the `-` (hyphen-minus) appearing before it is also
 *   omitted.
 */
__publicField(_Ab, "VERSION", "4.13.1"), _Ab;
_Bb = class {
  /**
   * @param tokens The token stream to modify
   */
  constructor(tokens) {
    /** Our source stream */
    __publicField(this, "tokens");
    /**
     * You may have multiple, named streams of rewrite operations.
     *  I'm calling these things "programs."
     *  Maps String (name) -> rewrite (List)
     */
    __publicField(this, "programs", /* @__PURE__ */ new Map());
    /** Map String (program name) -> Integer index */
    __publicField(this, "lastRewriteTokenIndexes");
    this.tokens = tokens;
  }
  getTokenStream() {
    return this.tokens;
  }
  /**
   * Insert the supplied text after the specified token (or token index)
   */
  insertAfter(tokenOrIndex, text, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    let index2;
    if (typeof tokenOrIndex === "number") {
      index2 = tokenOrIndex;
    } else {
      index2 = tokenOrIndex.tokenIndex;
    }
    const rewrites = this.getProgram(programName);
    const op2 = new InsertAfterOp(this.tokens, index2, rewrites.length, text);
    rewrites.push(op2);
  }
  /**
   * Insert the supplied text before the specified token (or token index)
   */
  insertBefore(tokenOrIndex, text, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    let index2;
    if (typeof tokenOrIndex === "number") {
      index2 = tokenOrIndex;
    } else {
      index2 = tokenOrIndex.tokenIndex;
    }
    const rewrites = this.getProgram(programName);
    const op2 = new InsertBeforeOp(this.tokens, index2, rewrites.length, text);
    rewrites.push(op2);
  }
  /**
   * Replace the specified token with the supplied text
   */
  replaceSingle(tokenOrIndex, text, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    this.replace(tokenOrIndex, tokenOrIndex, text, programName);
  }
  /**
   * Replace the specified range of tokens with the supplied text.
   */
  replace(from, to2, text, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    if (typeof from !== "number") {
      from = from.tokenIndex;
    }
    if (typeof to2 !== "number") {
      to2 = to2.tokenIndex;
    }
    if (from > to2 || from < 0 || to2 < 0 || to2 >= this.tokens.size) {
      throw new RangeError(`replace: range invalid: ${from}..${to2}(size=${this.tokens.size})`);
    }
    const rewrites = this.getProgram(programName);
    const op2 = new ReplaceOp(this.tokens, from, to2, rewrites.length, text);
    rewrites.push(op2);
  }
  /**
   * Delete the specified range of tokens
   */
  delete(from, to2, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    if (to2 == null) {
      to2 = from;
    }
    this.replace(from, to2, null, programName);
  }
  getProgram(name) {
    let is2 = this.programs.get(name);
    if (is2 == null) {
      is2 = this.initializeProgram(name);
    }
    return is2;
  }
  initializeProgram(name) {
    const is2 = [];
    this.programs.set(name, is2);
    return is2;
  }
  /**
   * @returns the text from the original tokens altered per the instructions given to this rewriter
   */
  getText(intervalOrProgram, programName = _Bb.DEFAULT_PROGRAM_NAME) {
    let interval;
    if (intervalOrProgram instanceof Interval) {
      interval = intervalOrProgram;
    } else {
      interval = new Interval(0, this.tokens.size - 1);
    }
    if (typeof intervalOrProgram === "string") {
      programName = intervalOrProgram;
    }
    const rewrites = this.programs.get(programName);
    let start = interval.start;
    let stop = interval.stop;
    if (stop > this.tokens.size - 1) {
      stop = this.tokens.size - 1;
    }
    if (start < 0) {
      start = 0;
    }
    if (rewrites == null || rewrites.length === 0) {
      return this.tokens.getTextFromInterval(new Interval(start, stop));
    }
    const buf = [];
    const indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
    let i2 = start;
    while (i2 <= stop && i2 < this.tokens.size) {
      const op2 = indexToOp.get(i2);
      indexToOp.delete(i2);
      const t2 = this.tokens.get(i2);
      if (op2 == null) {
        if (t2.type !== Token.EOF) {
          buf.push(String(t2.text));
        }
        i2++;
      } else {
        i2 = op2.execute(buf);
      }
    }
    if (stop === this.tokens.size - 1) {
      for (const op2 of indexToOp.values()) {
        if (op2 && op2.index >= this.tokens.size - 1) {
          buf.push(String(op2.text));
        }
      }
    }
    return buf.join("");
  }
  /**
   * @returns a map from token index to operation
   */
  reduceToSingleOperationPerIndex(rewrites) {
    for (let i2 = 0; i2 < rewrites.length; i2++) {
      const op2 = rewrites[i2];
      if (op2 == null) {
        continue;
      }
      if (!(op2 instanceof ReplaceOp)) {
        continue;
      }
      const rop = op2;
      const inserts = this.getKindOfOps(rewrites, InsertBeforeOp, i2);
      for (const iop of inserts) {
        if (iop.index === rop.index) {
          rewrites[iop.instructionIndex] = null;
          rop.text = String(iop.text) + (rop.text != null ? rop.text.toString() : "");
        } else if (iop.index > rop.index && iop.index <= rop.lastIndex) {
          rewrites[iop.instructionIndex] = null;
        }
      }
      const prevReplaces = this.getKindOfOps(rewrites, ReplaceOp, i2);
      for (const prevRop of prevReplaces) {
        if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
          rewrites[prevRop.instructionIndex] = null;
          continue;
        }
        const disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
        if (prevRop.text == null && rop.text == null && !disjoint) {
          rewrites[prevRop.instructionIndex] = null;
          rop.index = Math.min(prevRop.index, rop.index);
          rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
        } else if (!disjoint) {
          throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
        }
      }
    }
    for (let i2 = 0; i2 < rewrites.length; i2++) {
      const op2 = rewrites[i2];
      if (op2 == null) {
        continue;
      }
      if (!(op2 instanceof InsertBeforeOp)) {
        continue;
      }
      const iop = op2;
      const prevInserts = this.getKindOfOps(rewrites, InsertBeforeOp, i2);
      for (const prevIop of prevInserts) {
        if (prevIop.index === iop.index) {
          if (prevIop instanceof InsertAfterOp) {
            iop.text = this.catOpText(prevIop.text, iop.text);
            rewrites[prevIop.instructionIndex] = null;
          } else if (prevIop instanceof InsertBeforeOp) {
            iop.text = this.catOpText(iop.text, prevIop.text);
            rewrites[prevIop.instructionIndex] = null;
          }
        }
      }
      const prevReplaces = this.getKindOfOps(rewrites, ReplaceOp, i2);
      for (const rop of prevReplaces) {
        if (iop.index === rop.index) {
          rop.text = this.catOpText(iop.text, rop.text);
          rewrites[i2] = null;
          continue;
        }
        if (iop.index >= rop.index && iop.index <= rop.lastIndex) {
          throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
        }
      }
    }
    const m2 = /* @__PURE__ */ new Map();
    for (const op2 of rewrites) {
      if (op2 == null) {
        continue;
      }
      if (m2.get(op2.index) != null) {
        throw new Error("should only be one op per index");
      }
      m2.set(op2.index, op2);
    }
    return m2;
  }
  catOpText(a2, b2) {
    let x2 = "";
    let y2 = "";
    if (a2 != null) {
      x2 = a2.toString();
    }
    if (b2 != null) {
      y2 = b2.toString();
    }
    return x2 + y2;
  }
  /**
   * Get all operations before an index of a particular kind
   */
  getKindOfOps(rewrites, kind, before) {
    return rewrites.slice(0, before).filter((op2) => {
      return op2 && op2 instanceof kind;
    });
  }
}, __name(_Bb, "TokenStreamRewriter"), __publicField(_Bb, "DEFAULT_PROGRAM_NAME", "default"), __publicField(_Bb, "PROGRAM_INIT_SIZE", 100), __publicField(_Bb, "MIN_TOKEN_INDEX", 0), _Bb;
var RewriteOperation = (_Cb = class {
  constructor(tokens, index2, instructionIndex, text) {
    /** What index into rewrites List are we? */
    __publicField(this, "instructionIndex");
    /** Token buffer index. */
    __publicField(this, "index");
    __publicField(this, "text");
    __publicField(this, "tokens");
    this.tokens = tokens;
    this.instructionIndex = instructionIndex;
    this.index = index2;
    this.text = text === void 0 ? "" : text;
  }
  execute(_buf) {
    return this.index;
  }
  toString() {
    return "<RewriteOperation@" + this.tokens.get(this.index) + ':"' + this.text + '">';
  }
}, __name(_Cb, "RewriteOperation"), _Cb);
var InsertBeforeOp = (_Db = class extends RewriteOperation {
  constructor(tokens, index2, instructionIndex, text) {
    super(tokens, index2, instructionIndex, text);
  }
  /**
   * @returns the index of the next token to operate on
   */
  execute(buf) {
    if (this.text) {
      buf.push(this.text.toString());
    }
    if (this.tokens.get(this.index).type !== Token.EOF) {
      buf.push(String(this.tokens.get(this.index).text));
    }
    return this.index + 1;
  }
  toString() {
    return "<InsertBeforeOp@" + this.tokens.get(this.index) + ':"' + this.text + '">';
  }
}, __name(_Db, "InsertBeforeOp"), _Db);
var InsertAfterOp = (_Eb = class extends InsertBeforeOp {
  constructor(tokens, index2, instructionIndex, text) {
    super(tokens, index2 + 1, instructionIndex, text);
  }
  toString() {
    return "<InsertAfterOp@" + this.tokens.get(this.index) + ':"' + this.text + '">';
  }
}, __name(_Eb, "InsertAfterOp"), _Eb);
var ReplaceOp = (_Fb = class extends RewriteOperation {
  constructor(tokens, from, to2, instructionIndex, text) {
    super(tokens, from, instructionIndex, text);
    __publicField(this, "lastIndex");
    this.lastIndex = to2;
  }
  /**
   * @returns the index of the next token to operate on
   */
  execute(buf) {
    if (this.text) {
      buf.push(this.text.toString());
    }
    return this.lastIndex + 1;
  }
  toString() {
    if (this.text == null) {
      return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
    }
    return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ':"' + this.text + '">';
  }
}, __name(_Fb, "ReplaceOp"), _Fb);
_Gb = class {
  constructor(tokenSource, bufferSize) {
    __publicField(this, "tokenSource");
    /**
     * A moving window buffer of the data being scanned. While there's a marker,
     * we keep adding to buffer. Otherwise, {@link #consume consume()} resets so
     * we start filling at index 0 again.
     */
    __publicField(this, "tokens");
    /**
     * The number of tokens currently in {@link #tokens tokens}.
     *
     * This is not the buffer capacity, that's `tokens.length`.
     */
    __publicField(this, "n");
    /**
     * 0..n-1 index into {@link #tokens tokens} of next token.
     *
     * The `LT(1)` token is `tokens[p]`. If `p == n`, we are
     * out of buffered tokens.
     */
    __publicField(this, "p", 0);
    /**
     * Count up with {@link #mark mark()} and down with
     * {@link #release release()}. When we `release()` the last mark,
     * `numMarkers` reaches 0 and we reset the buffer. Copy
     * `tokens[p]..tokens[n-1]` to `tokens[0]..tokens[(n-1)-p]`.
     */
    __publicField(this, "numMarkers", 0);
    /**
     * This is the `LT(-1)` token for the current position.
     */
    __publicField(this, "lastToken");
    /**
     * When `numMarkers > 0`, this is the `LT(-1)` token for the
     * first token in {@link #tokens}. Otherwise, this is `null`.
     */
    __publicField(this, "lastTokenBufferStart");
    /**
     * Absolute token index. It's the index of the token about to be read via
     * `LT(1)`. Goes from 0 to the number of tokens in the entire stream,
     * although the stream size is unknown before the end is reached.
     *
     * This value is used to set the token indexes if the stream provides tokens
     * that implement {@link WritableToken}.
     */
    __publicField(this, "currentTokenIndex", 0);
    this.tokenSource = tokenSource;
    bufferSize = bufferSize ?? 256;
    this.tokens = new Array(bufferSize);
    this.n = 0;
    this.fill(1);
  }
  get(i2) {
    const bufferStartIndex = this.getBufferStartIndex();
    if (i2 < bufferStartIndex || i2 >= bufferStartIndex + this.n) {
      throw new Error("get(" + i2 + ") outside buffer: " + bufferStartIndex + ".." + (bufferStartIndex + this.n));
    }
    return this.tokens[i2 - bufferStartIndex];
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LT(i2) {
    if (i2 === -1) {
      return this.lastToken;
    }
    this.sync(i2);
    const index2 = this.p + i2 - 1;
    if (index2 < 0) {
      throw new Error("LT(" + i2 + ") gives negative index");
    }
    if (index2 >= this.n) {
      return this.tokens[this.n - 1];
    }
    return this.tokens[index2];
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  LA(i2) {
    return this.LT(i2).type;
  }
  getText() {
    return "";
  }
  getTextFromContext(ctx) {
    return this.getTextFromInterval(ctx.getSourceInterval());
  }
  getTextFromInterval(interval) {
    const bufferStartIndex = this.getBufferStartIndex();
    const bufferStopIndex = bufferStartIndex + this.tokens.length - 1;
    const start = interval.start;
    const stop = interval.stop;
    if (start < bufferStartIndex || stop > bufferStopIndex) {
      throw new Error("interval " + interval + " not in token buffer window: " + bufferStartIndex + ".." + bufferStopIndex);
    }
    const a2 = start - bufferStartIndex;
    const b2 = stop - bufferStartIndex;
    let result = "";
    for (let i2 = a2; i2 <= b2; i2++) {
      const t2 = this.tokens[i2];
      result += t2.text;
    }
    return result;
  }
  getTextFromRange(start, stop) {
    return this.getTextFromInterval(Interval.of(start.tokenIndex, stop.tokenIndex));
  }
  consume() {
    if (this.LA(1) === Token.EOF) {
      throw new Error("cannot consume EOF");
    }
    this.lastToken = this.tokens[this.p];
    if (this.p === this.n - 1 && this.numMarkers === 0) {
      this.n = 0;
      this.p = -1;
      this.lastTokenBufferStart = this.lastToken;
    }
    this.p++;
    this.currentTokenIndex++;
    this.sync(1);
  }
  /**
   * Return a marker that we can release later.
   *
   * The specific marker value used for this class allows for some level of
   * protection against misuse where `seek()` is called on a mark or
   * `release()` is called in the wrong order.
   */
  mark() {
    if (this.numMarkers === 0) {
      this.lastTokenBufferStart = this.lastToken;
    }
    const mark = -this.numMarkers - 1;
    this.numMarkers++;
    return mark;
  }
  release(marker) {
    const expectedMark = -this.numMarkers;
    if (marker !== expectedMark) {
      throw new Error("release() called with an invalid marker.");
    }
    this.numMarkers--;
    if (this.numMarkers === 0) {
      if (this.p > 0) {
        this.tokens.copyWithin(0, this.p, this.n);
        this.n = this.n - this.p;
        this.p = 0;
      }
      this.lastTokenBufferStart = this.lastToken;
    }
  }
  get index() {
    return this.currentTokenIndex;
  }
  seek(index2) {
    if (index2 === this.currentTokenIndex) {
      return;
    }
    if (index2 > this.currentTokenIndex) {
      this.sync(index2 - this.currentTokenIndex);
      index2 = Math.min(index2, this.getBufferStartIndex() + this.n - 1);
    }
    const bufferStartIndex = this.getBufferStartIndex();
    const i2 = index2 - bufferStartIndex;
    if (i2 < 0) {
      throw new Error("cannot seek to negative index " + index2);
    } else {
      if (i2 >= this.n) {
        throw new Error("seek to index outside buffer: " + index2 + " not in " + bufferStartIndex + ".." + (bufferStartIndex + this.n));
      }
    }
    this.p = i2;
    this.currentTokenIndex = index2;
    if (this.p === 0) {
      this.lastToken = this.lastTokenBufferStart;
    } else {
      this.lastToken = this.tokens[this.p - 1];
    }
  }
  get size() {
    throw new Error("Unbuffered stream cannot know its size");
  }
  getSourceName() {
    return this.tokenSource.sourceName;
  }
  setLine(line) {
    this.tokenSource.line = line;
  }
  setColumn(column) {
    this.tokenSource.column = column;
  }
  /**
   * Make sure we have 'need' elements from current position {@link #p p}. Last valid
   * `p` index is `tokens.length-1`.  `p+need-1` is the tokens index 'need' elements
   * ahead.  If we need 1 element, `(p+1-1)==p` must be less than `tokens.length`.
   */
  sync(want) {
    const need = this.p + want - 1 - this.n + 1;
    if (need > 0) {
      this.fill(need);
    }
  }
  /**
   * Add `n` elements to the buffer. Returns the number of tokens
   * actually added to the buffer. If the return value is less than `n`,
   * then EOF was reached before `n` tokens could be added.
   */
  fill(n2) {
    for (let i2 = 0; i2 < n2; i2++) {
      if (this.n > 0 && this.tokens[this.n - 1].type === Token.EOF) {
        return i2;
      }
      const t2 = this.tokenSource.nextToken();
      this.add(t2);
    }
    return n2;
  }
  add(t2) {
    if (this.n >= this.tokens.length) {
      this.tokens.length = this.tokens.length * 2;
    }
    if (isWritableToken(t2)) {
      t2.setTokenIndex(this.getBufferStartIndex() + this.n);
    }
    this.tokens[this.n++] = t2;
  }
  getBufferStartIndex() {
    return this.currentTokenIndex - this.p;
  }
}, __name(_Gb, "UnbufferedTokenStream"), _Gb;
const _ConditionLexer = class _ConditionLexer extends Lexer {
  constructor(input) {
    super(input);
    this.interpreter = new LexerATNSimulator(this, _ConditionLexer._ATN, _ConditionLexer.decisionsToDFA, new PredictionContextCache());
  }
  get grammarFileName() {
    return "Condition.g4";
  }
  get literalNames() {
    return _ConditionLexer.literalNames;
  }
  get symbolicNames() {
    return _ConditionLexer.symbolicNames;
  }
  get ruleNames() {
    return _ConditionLexer.ruleNames;
  }
  get serializedATN() {
    return _ConditionLexer._serializedATN;
  }
  get channelNames() {
    return _ConditionLexer.channelNames;
  }
  get modeNames() {
    return _ConditionLexer.modeNames;
  }
  static get _ATN() {
    if (!_ConditionLexer.__ATN) {
      _ConditionLexer.__ATN = new ATNDeserializer().deserialize(_ConditionLexer._serializedATN);
    }
    return _ConditionLexer.__ATN;
  }
  get vocabulary() {
    return _ConditionLexer.vocabulary;
  }
};
__publicField(_ConditionLexer, "T__0", 1);
__publicField(_ConditionLexer, "T__1", 2);
__publicField(_ConditionLexer, "T__2", 3);
__publicField(_ConditionLexer, "T__3", 4);
__publicField(_ConditionLexer, "T__4", 5);
__publicField(_ConditionLexer, "T__5", 6);
__publicField(_ConditionLexer, "T__6", 7);
__publicField(_ConditionLexer, "T__7", 8);
__publicField(_ConditionLexer, "T__8", 9);
__publicField(_ConditionLexer, "T__9", 10);
__publicField(_ConditionLexer, "T__10", 11);
__publicField(_ConditionLexer, "T__11", 12);
__publicField(_ConditionLexer, "T__12", 13);
__publicField(_ConditionLexer, "T__13", 14);
__publicField(_ConditionLexer, "T__14", 15);
__publicField(_ConditionLexer, "T__15", 16);
__publicField(_ConditionLexer, "LINECOMMENT", 17);
__publicField(_ConditionLexer, "COMMENT", 18);
__publicField(_ConditionLexer, "AND", 19);
__publicField(_ConditionLexer, "OR", 20);
__publicField(_ConditionLexer, "IN", 21);
__publicField(_ConditionLexer, "CONTAINS", 22);
__publicField(_ConditionLexer, "SUBSETOF", 23);
__publicField(_ConditionLexer, "NULL", 24);
__publicField(_ConditionLexer, "NOT", 25);
__publicField(_ConditionLexer, "FALSE", 26);
__publicField(_ConditionLexer, "TRUE", 27);
__publicField(_ConditionLexer, "ID", 28);
__publicField(_ConditionLexer, "STRING", 29);
__publicField(_ConditionLexer, "Integer", 30);
__publicField(_ConditionLexer, "BINARY", 31);
__publicField(_ConditionLexer, "FLOAT", 32);
__publicField(_ConditionLexer, "REAL", 33);
__publicField(_ConditionLexer, "S", 34);
__publicField(_ConditionLexer, "channelNames", [
  "DEFAULT_TOKEN_CHANNEL",
  "HIDDEN"
]);
__publicField(_ConditionLexer, "literalNames", [
  null,
  "'=='",
  "'='",
  "'>'",
  "'<'",
  "'<='",
  "'>='",
  "'!='",
  "','",
  "'.'",
  "'!'",
  "'{'",
  "'}'",
  "'+'",
  "'-'",
  "'('",
  "')'",
  null,
  null,
  "'&&'",
  "'||'"
]);
__publicField(_ConditionLexer, "symbolicNames", [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  "LINECOMMENT",
  "COMMENT",
  "AND",
  "OR",
  "IN",
  "CONTAINS",
  "SUBSETOF",
  "NULL",
  "NOT",
  "FALSE",
  "TRUE",
  "ID",
  "STRING",
  "Integer",
  "BINARY",
  "FLOAT",
  "REAL",
  "S"
]);
__publicField(_ConditionLexer, "modeNames", [
  "DEFAULT_MODE"
]);
__publicField(_ConditionLexer, "ruleNames", [
  "T__0",
  "T__1",
  "T__2",
  "T__3",
  "T__4",
  "T__5",
  "T__6",
  "T__7",
  "T__8",
  "T__9",
  "T__10",
  "T__11",
  "T__12",
  "T__13",
  "T__14",
  "T__15",
  "LINECOMMENT",
  "COMMENT",
  "AND",
  "OR",
  "IN",
  "CONTAINS",
  "SUBSETOF",
  "NULL",
  "NOT",
  "FALSE",
  "TRUE",
  "ID",
  "STRING",
  "Integer",
  "BINARY",
  "FLOAT",
  "REAL",
  "S",
  "DEC_DOT_DEC",
  "HEX_DIGIT",
  "DEC_DIGIT"
]);
__publicField(_ConditionLexer, "_serializedATN", [
  4,
  0,
  34,
  266,
  6,
  -1,
  2,
  0,
  7,
  0,
  2,
  1,
  7,
  1,
  2,
  2,
  7,
  2,
  2,
  3,
  7,
  3,
  2,
  4,
  7,
  4,
  2,
  5,
  7,
  5,
  2,
  6,
  7,
  6,
  2,
  7,
  7,
  7,
  2,
  8,
  7,
  8,
  2,
  9,
  7,
  9,
  2,
  10,
  7,
  10,
  2,
  11,
  7,
  11,
  2,
  12,
  7,
  12,
  2,
  13,
  7,
  13,
  2,
  14,
  7,
  14,
  2,
  15,
  7,
  15,
  2,
  16,
  7,
  16,
  2,
  17,
  7,
  17,
  2,
  18,
  7,
  18,
  2,
  19,
  7,
  19,
  2,
  20,
  7,
  20,
  2,
  21,
  7,
  21,
  2,
  22,
  7,
  22,
  2,
  23,
  7,
  23,
  2,
  24,
  7,
  24,
  2,
  25,
  7,
  25,
  2,
  26,
  7,
  26,
  2,
  27,
  7,
  27,
  2,
  28,
  7,
  28,
  2,
  29,
  7,
  29,
  2,
  30,
  7,
  30,
  2,
  31,
  7,
  31,
  2,
  32,
  7,
  32,
  2,
  33,
  7,
  33,
  2,
  34,
  7,
  34,
  2,
  35,
  7,
  35,
  2,
  36,
  7,
  36,
  1,
  0,
  1,
  0,
  1,
  0,
  1,
  1,
  1,
  1,
  1,
  2,
  1,
  2,
  1,
  3,
  1,
  3,
  1,
  4,
  1,
  4,
  1,
  4,
  1,
  5,
  1,
  5,
  1,
  5,
  1,
  6,
  1,
  6,
  1,
  6,
  1,
  7,
  1,
  7,
  1,
  8,
  1,
  8,
  1,
  9,
  1,
  9,
  1,
  10,
  1,
  10,
  1,
  11,
  1,
  11,
  1,
  12,
  1,
  12,
  1,
  13,
  1,
  13,
  1,
  14,
  1,
  14,
  1,
  15,
  1,
  15,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  5,
  16,
  116,
  8,
  16,
  10,
  16,
  12,
  16,
  119,
  9,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  5,
  17,
  130,
  8,
  17,
  10,
  17,
  12,
  17,
  133,
  9,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  18,
  1,
  18,
  1,
  18,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  20,
  1,
  20,
  1,
  20,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  21,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  22,
  1,
  23,
  1,
  23,
  1,
  23,
  1,
  23,
  1,
  23,
  1,
  24,
  1,
  24,
  1,
  24,
  1,
  24,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  25,
  1,
  26,
  1,
  26,
  1,
  26,
  1,
  26,
  1,
  26,
  1,
  27,
  1,
  27,
  5,
  27,
  189,
  8,
  27,
  10,
  27,
  12,
  27,
  192,
  9,
  27,
  1,
  28,
  1,
  28,
  1,
  28,
  1,
  28,
  5,
  28,
  198,
  8,
  28,
  10,
  28,
  12,
  28,
  201,
  9,
  28,
  1,
  28,
  1,
  28,
  1,
  29,
  4,
  29,
  206,
  8,
  29,
  11,
  29,
  12,
  29,
  207,
  1,
  30,
  1,
  30,
  1,
  30,
  5,
  30,
  213,
  8,
  30,
  10,
  30,
  12,
  30,
  216,
  9,
  30,
  1,
  31,
  1,
  31,
  1,
  32,
  1,
  32,
  3,
  32,
  222,
  8,
  32,
  1,
  32,
  1,
  32,
  3,
  32,
  226,
  8,
  32,
  1,
  32,
  4,
  32,
  229,
  8,
  32,
  11,
  32,
  12,
  32,
  230,
  1,
  33,
  1,
  33,
  1,
  33,
  1,
  33,
  1,
  34,
  4,
  34,
  238,
  8,
  34,
  11,
  34,
  12,
  34,
  239,
  1,
  34,
  1,
  34,
  4,
  34,
  244,
  8,
  34,
  11,
  34,
  12,
  34,
  245,
  1,
  34,
  4,
  34,
  249,
  8,
  34,
  11,
  34,
  12,
  34,
  250,
  1,
  34,
  1,
  34,
  1,
  34,
  1,
  34,
  4,
  34,
  257,
  8,
  34,
  11,
  34,
  12,
  34,
  258,
  3,
  34,
  261,
  8,
  34,
  1,
  35,
  1,
  35,
  1,
  36,
  1,
  36,
  2,
  117,
  131,
  0,
  37,
  1,
  1,
  3,
  2,
  5,
  3,
  7,
  4,
  9,
  5,
  11,
  6,
  13,
  7,
  15,
  8,
  17,
  9,
  19,
  10,
  21,
  11,
  23,
  12,
  25,
  13,
  27,
  14,
  29,
  15,
  31,
  16,
  33,
  17,
  35,
  18,
  37,
  19,
  39,
  20,
  41,
  21,
  43,
  22,
  45,
  23,
  47,
  24,
  49,
  25,
  51,
  26,
  53,
  27,
  55,
  28,
  57,
  29,
  59,
  30,
  61,
  31,
  63,
  32,
  65,
  33,
  67,
  34,
  69,
  0,
  71,
  0,
  73,
  0,
  1,
  0,
  22,
  2,
  0,
  73,
  73,
  105,
  105,
  2,
  0,
  78,
  78,
  110,
  110,
  2,
  0,
  67,
  67,
  99,
  99,
  2,
  0,
  79,
  79,
  111,
  111,
  2,
  0,
  84,
  84,
  116,
  116,
  2,
  0,
  65,
  65,
  97,
  97,
  2,
  0,
  73,
  73,
  110,
  110,
  2,
  0,
  83,
  83,
  115,
  115,
  2,
  0,
  85,
  85,
  117,
  117,
  2,
  0,
  66,
  66,
  98,
  98,
  2,
  0,
  69,
  69,
  101,
  101,
  2,
  0,
  70,
  70,
  102,
  102,
  2,
  0,
  76,
  76,
  108,
  108,
  2,
  0,
  82,
  82,
  114,
  114,
  3,
  0,
  65,
  90,
  95,
  95,
  97,
  122,
  4,
  0,
  48,
  57,
  65,
  90,
  95,
  95,
  97,
  122,
  1,
  0,
  34,
  34,
  2,
  0,
  88,
  88,
  120,
  120,
  2,
  0,
  43,
  43,
  45,
  45,
  3,
  0,
  9,
  10,
  13,
  13,
  32,
  32,
  3,
  0,
  48,
  57,
  65,
  70,
  97,
  102,
  1,
  0,
  48,
  57,
  278,
  0,
  1,
  1,
  0,
  0,
  0,
  0,
  3,
  1,
  0,
  0,
  0,
  0,
  5,
  1,
  0,
  0,
  0,
  0,
  7,
  1,
  0,
  0,
  0,
  0,
  9,
  1,
  0,
  0,
  0,
  0,
  11,
  1,
  0,
  0,
  0,
  0,
  13,
  1,
  0,
  0,
  0,
  0,
  15,
  1,
  0,
  0,
  0,
  0,
  17,
  1,
  0,
  0,
  0,
  0,
  19,
  1,
  0,
  0,
  0,
  0,
  21,
  1,
  0,
  0,
  0,
  0,
  23,
  1,
  0,
  0,
  0,
  0,
  25,
  1,
  0,
  0,
  0,
  0,
  27,
  1,
  0,
  0,
  0,
  0,
  29,
  1,
  0,
  0,
  0,
  0,
  31,
  1,
  0,
  0,
  0,
  0,
  33,
  1,
  0,
  0,
  0,
  0,
  35,
  1,
  0,
  0,
  0,
  0,
  37,
  1,
  0,
  0,
  0,
  0,
  39,
  1,
  0,
  0,
  0,
  0,
  41,
  1,
  0,
  0,
  0,
  0,
  43,
  1,
  0,
  0,
  0,
  0,
  45,
  1,
  0,
  0,
  0,
  0,
  47,
  1,
  0,
  0,
  0,
  0,
  49,
  1,
  0,
  0,
  0,
  0,
  51,
  1,
  0,
  0,
  0,
  0,
  53,
  1,
  0,
  0,
  0,
  0,
  55,
  1,
  0,
  0,
  0,
  0,
  57,
  1,
  0,
  0,
  0,
  0,
  59,
  1,
  0,
  0,
  0,
  0,
  61,
  1,
  0,
  0,
  0,
  0,
  63,
  1,
  0,
  0,
  0,
  0,
  65,
  1,
  0,
  0,
  0,
  0,
  67,
  1,
  0,
  0,
  0,
  1,
  75,
  1,
  0,
  0,
  0,
  3,
  78,
  1,
  0,
  0,
  0,
  5,
  80,
  1,
  0,
  0,
  0,
  7,
  82,
  1,
  0,
  0,
  0,
  9,
  84,
  1,
  0,
  0,
  0,
  11,
  87,
  1,
  0,
  0,
  0,
  13,
  90,
  1,
  0,
  0,
  0,
  15,
  93,
  1,
  0,
  0,
  0,
  17,
  95,
  1,
  0,
  0,
  0,
  19,
  97,
  1,
  0,
  0,
  0,
  21,
  99,
  1,
  0,
  0,
  0,
  23,
  101,
  1,
  0,
  0,
  0,
  25,
  103,
  1,
  0,
  0,
  0,
  27,
  105,
  1,
  0,
  0,
  0,
  29,
  107,
  1,
  0,
  0,
  0,
  31,
  109,
  1,
  0,
  0,
  0,
  33,
  111,
  1,
  0,
  0,
  0,
  35,
  124,
  1,
  0,
  0,
  0,
  37,
  139,
  1,
  0,
  0,
  0,
  39,
  142,
  1,
  0,
  0,
  0,
  41,
  145,
  1,
  0,
  0,
  0,
  43,
  148,
  1,
  0,
  0,
  0,
  45,
  157,
  1,
  0,
  0,
  0,
  47,
  166,
  1,
  0,
  0,
  0,
  49,
  171,
  1,
  0,
  0,
  0,
  51,
  175,
  1,
  0,
  0,
  0,
  53,
  181,
  1,
  0,
  0,
  0,
  55,
  186,
  1,
  0,
  0,
  0,
  57,
  193,
  1,
  0,
  0,
  0,
  59,
  205,
  1,
  0,
  0,
  0,
  61,
  209,
  1,
  0,
  0,
  0,
  63,
  217,
  1,
  0,
  0,
  0,
  65,
  221,
  1,
  0,
  0,
  0,
  67,
  232,
  1,
  0,
  0,
  0,
  69,
  260,
  1,
  0,
  0,
  0,
  71,
  262,
  1,
  0,
  0,
  0,
  73,
  264,
  1,
  0,
  0,
  0,
  75,
  76,
  5,
  61,
  0,
  0,
  76,
  77,
  5,
  61,
  0,
  0,
  77,
  2,
  1,
  0,
  0,
  0,
  78,
  79,
  5,
  61,
  0,
  0,
  79,
  4,
  1,
  0,
  0,
  0,
  80,
  81,
  5,
  62,
  0,
  0,
  81,
  6,
  1,
  0,
  0,
  0,
  82,
  83,
  5,
  60,
  0,
  0,
  83,
  8,
  1,
  0,
  0,
  0,
  84,
  85,
  5,
  60,
  0,
  0,
  85,
  86,
  5,
  61,
  0,
  0,
  86,
  10,
  1,
  0,
  0,
  0,
  87,
  88,
  5,
  62,
  0,
  0,
  88,
  89,
  5,
  61,
  0,
  0,
  89,
  12,
  1,
  0,
  0,
  0,
  90,
  91,
  5,
  33,
  0,
  0,
  91,
  92,
  5,
  61,
  0,
  0,
  92,
  14,
  1,
  0,
  0,
  0,
  93,
  94,
  5,
  44,
  0,
  0,
  94,
  16,
  1,
  0,
  0,
  0,
  95,
  96,
  5,
  46,
  0,
  0,
  96,
  18,
  1,
  0,
  0,
  0,
  97,
  98,
  5,
  33,
  0,
  0,
  98,
  20,
  1,
  0,
  0,
  0,
  99,
  100,
  5,
  123,
  0,
  0,
  100,
  22,
  1,
  0,
  0,
  0,
  101,
  102,
  5,
  125,
  0,
  0,
  102,
  24,
  1,
  0,
  0,
  0,
  103,
  104,
  5,
  43,
  0,
  0,
  104,
  26,
  1,
  0,
  0,
  0,
  105,
  106,
  5,
  45,
  0,
  0,
  106,
  28,
  1,
  0,
  0,
  0,
  107,
  108,
  5,
  40,
  0,
  0,
  108,
  30,
  1,
  0,
  0,
  0,
  109,
  110,
  5,
  41,
  0,
  0,
  110,
  32,
  1,
  0,
  0,
  0,
  111,
  112,
  5,
  45,
  0,
  0,
  112,
  113,
  5,
  45,
  0,
  0,
  113,
  117,
  1,
  0,
  0,
  0,
  114,
  116,
  9,
  0,
  0,
  0,
  115,
  114,
  1,
  0,
  0,
  0,
  116,
  119,
  1,
  0,
  0,
  0,
  117,
  118,
  1,
  0,
  0,
  0,
  117,
  115,
  1,
  0,
  0,
  0,
  118,
  120,
  1,
  0,
  0,
  0,
  119,
  117,
  1,
  0,
  0,
  0,
  120,
  121,
  5,
  10,
  0,
  0,
  121,
  122,
  1,
  0,
  0,
  0,
  122,
  123,
  6,
  16,
  0,
  0,
  123,
  34,
  1,
  0,
  0,
  0,
  124,
  125,
  5,
  47,
  0,
  0,
  125,
  126,
  5,
  42,
  0,
  0,
  126,
  127,
  5,
  32,
  0,
  0,
  127,
  131,
  1,
  0,
  0,
  0,
  128,
  130,
  9,
  0,
  0,
  0,
  129,
  128,
  1,
  0,
  0,
  0,
  130,
  133,
  1,
  0,
  0,
  0,
  131,
  132,
  1,
  0,
  0,
  0,
  131,
  129,
  1,
  0,
  0,
  0,
  132,
  134,
  1,
  0,
  0,
  0,
  133,
  131,
  1,
  0,
  0,
  0,
  134,
  135,
  5,
  42,
  0,
  0,
  135,
  136,
  5,
  47,
  0,
  0,
  136,
  137,
  1,
  0,
  0,
  0,
  137,
  138,
  6,
  17,
  0,
  0,
  138,
  36,
  1,
  0,
  0,
  0,
  139,
  140,
  5,
  38,
  0,
  0,
  140,
  141,
  5,
  38,
  0,
  0,
  141,
  38,
  1,
  0,
  0,
  0,
  142,
  143,
  5,
  124,
  0,
  0,
  143,
  144,
  5,
  124,
  0,
  0,
  144,
  40,
  1,
  0,
  0,
  0,
  145,
  146,
  7,
  0,
  0,
  0,
  146,
  147,
  7,
  1,
  0,
  0,
  147,
  42,
  1,
  0,
  0,
  0,
  148,
  149,
  7,
  2,
  0,
  0,
  149,
  150,
  7,
  3,
  0,
  0,
  150,
  151,
  7,
  1,
  0,
  0,
  151,
  152,
  7,
  4,
  0,
  0,
  152,
  153,
  7,
  5,
  0,
  0,
  153,
  154,
  7,
  6,
  0,
  0,
  154,
  155,
  7,
  1,
  0,
  0,
  155,
  156,
  7,
  7,
  0,
  0,
  156,
  44,
  1,
  0,
  0,
  0,
  157,
  158,
  7,
  7,
  0,
  0,
  158,
  159,
  7,
  8,
  0,
  0,
  159,
  160,
  7,
  9,
  0,
  0,
  160,
  161,
  7,
  7,
  0,
  0,
  161,
  162,
  7,
  10,
  0,
  0,
  162,
  163,
  7,
  4,
  0,
  0,
  163,
  164,
  7,
  3,
  0,
  0,
  164,
  165,
  7,
  11,
  0,
  0,
  165,
  46,
  1,
  0,
  0,
  0,
  166,
  167,
  7,
  1,
  0,
  0,
  167,
  168,
  7,
  8,
  0,
  0,
  168,
  169,
  7,
  12,
  0,
  0,
  169,
  170,
  7,
  12,
  0,
  0,
  170,
  48,
  1,
  0,
  0,
  0,
  171,
  172,
  7,
  1,
  0,
  0,
  172,
  173,
  7,
  3,
  0,
  0,
  173,
  174,
  7,
  4,
  0,
  0,
  174,
  50,
  1,
  0,
  0,
  0,
  175,
  176,
  7,
  11,
  0,
  0,
  176,
  177,
  7,
  5,
  0,
  0,
  177,
  178,
  7,
  12,
  0,
  0,
  178,
  179,
  7,
  7,
  0,
  0,
  179,
  180,
  7,
  10,
  0,
  0,
  180,
  52,
  1,
  0,
  0,
  0,
  181,
  182,
  7,
  4,
  0,
  0,
  182,
  183,
  7,
  13,
  0,
  0,
  183,
  184,
  7,
  8,
  0,
  0,
  184,
  185,
  7,
  10,
  0,
  0,
  185,
  54,
  1,
  0,
  0,
  0,
  186,
  190,
  7,
  14,
  0,
  0,
  187,
  189,
  7,
  15,
  0,
  0,
  188,
  187,
  1,
  0,
  0,
  0,
  189,
  192,
  1,
  0,
  0,
  0,
  190,
  188,
  1,
  0,
  0,
  0,
  190,
  191,
  1,
  0,
  0,
  0,
  191,
  56,
  1,
  0,
  0,
  0,
  192,
  190,
  1,
  0,
  0,
  0,
  193,
  199,
  5,
  34,
  0,
  0,
  194,
  198,
  8,
  16,
  0,
  0,
  195,
  196,
  5,
  34,
  0,
  0,
  196,
  198,
  5,
  34,
  0,
  0,
  197,
  194,
  1,
  0,
  0,
  0,
  197,
  195,
  1,
  0,
  0,
  0,
  198,
  201,
  1,
  0,
  0,
  0,
  199,
  197,
  1,
  0,
  0,
  0,
  199,
  200,
  1,
  0,
  0,
  0,
  200,
  202,
  1,
  0,
  0,
  0,
  201,
  199,
  1,
  0,
  0,
  0,
  202,
  203,
  5,
  34,
  0,
  0,
  203,
  58,
  1,
  0,
  0,
  0,
  204,
  206,
  3,
  73,
  36,
  0,
  205,
  204,
  1,
  0,
  0,
  0,
  206,
  207,
  1,
  0,
  0,
  0,
  207,
  205,
  1,
  0,
  0,
  0,
  207,
  208,
  1,
  0,
  0,
  0,
  208,
  60,
  1,
  0,
  0,
  0,
  209,
  210,
  5,
  48,
  0,
  0,
  210,
  214,
  7,
  17,
  0,
  0,
  211,
  213,
  3,
  71,
  35,
  0,
  212,
  211,
  1,
  0,
  0,
  0,
  213,
  216,
  1,
  0,
  0,
  0,
  214,
  212,
  1,
  0,
  0,
  0,
  214,
  215,
  1,
  0,
  0,
  0,
  215,
  62,
  1,
  0,
  0,
  0,
  216,
  214,
  1,
  0,
  0,
  0,
  217,
  218,
  3,
  69,
  34,
  0,
  218,
  64,
  1,
  0,
  0,
  0,
  219,
  222,
  3,
  59,
  29,
  0,
  220,
  222,
  3,
  69,
  34,
  0,
  221,
  219,
  1,
  0,
  0,
  0,
  221,
  220,
  1,
  0,
  0,
  0,
  222,
  223,
  1,
  0,
  0,
  0,
  223,
  225,
  7,
  10,
  0,
  0,
  224,
  226,
  7,
  18,
  0,
  0,
  225,
  224,
  1,
  0,
  0,
  0,
  225,
  226,
  1,
  0,
  0,
  0,
  226,
  228,
  1,
  0,
  0,
  0,
  227,
  229,
  3,
  73,
  36,
  0,
  228,
  227,
  1,
  0,
  0,
  0,
  229,
  230,
  1,
  0,
  0,
  0,
  230,
  228,
  1,
  0,
  0,
  0,
  230,
  231,
  1,
  0,
  0,
  0,
  231,
  66,
  1,
  0,
  0,
  0,
  232,
  233,
  7,
  19,
  0,
  0,
  233,
  234,
  1,
  0,
  0,
  0,
  234,
  235,
  6,
  33,
  0,
  0,
  235,
  68,
  1,
  0,
  0,
  0,
  236,
  238,
  3,
  73,
  36,
  0,
  237,
  236,
  1,
  0,
  0,
  0,
  238,
  239,
  1,
  0,
  0,
  0,
  239,
  237,
  1,
  0,
  0,
  0,
  239,
  240,
  1,
  0,
  0,
  0,
  240,
  241,
  1,
  0,
  0,
  0,
  241,
  243,
  5,
  46,
  0,
  0,
  242,
  244,
  3,
  73,
  36,
  0,
  243,
  242,
  1,
  0,
  0,
  0,
  244,
  245,
  1,
  0,
  0,
  0,
  245,
  243,
  1,
  0,
  0,
  0,
  245,
  246,
  1,
  0,
  0,
  0,
  246,
  261,
  1,
  0,
  0,
  0,
  247,
  249,
  3,
  73,
  36,
  0,
  248,
  247,
  1,
  0,
  0,
  0,
  249,
  250,
  1,
  0,
  0,
  0,
  250,
  248,
  1,
  0,
  0,
  0,
  250,
  251,
  1,
  0,
  0,
  0,
  251,
  252,
  1,
  0,
  0,
  0,
  252,
  253,
  5,
  46,
  0,
  0,
  253,
  261,
  1,
  0,
  0,
  0,
  254,
  256,
  5,
  46,
  0,
  0,
  255,
  257,
  3,
  73,
  36,
  0,
  256,
  255,
  1,
  0,
  0,
  0,
  257,
  258,
  1,
  0,
  0,
  0,
  258,
  256,
  1,
  0,
  0,
  0,
  258,
  259,
  1,
  0,
  0,
  0,
  259,
  261,
  1,
  0,
  0,
  0,
  260,
  237,
  1,
  0,
  0,
  0,
  260,
  248,
  1,
  0,
  0,
  0,
  260,
  254,
  1,
  0,
  0,
  0,
  261,
  70,
  1,
  0,
  0,
  0,
  262,
  263,
  7,
  20,
  0,
  0,
  263,
  72,
  1,
  0,
  0,
  0,
  264,
  265,
  7,
  21,
  0,
  0,
  265,
  74,
  1,
  0,
  0,
  0,
  16,
  0,
  117,
  131,
  190,
  197,
  199,
  207,
  214,
  221,
  225,
  230,
  239,
  245,
  250,
  258,
  260,
  1,
  6,
  0,
  0
]);
__publicField(_ConditionLexer, "__ATN");
__publicField(_ConditionLexer, "vocabulary", new Vocabulary(_ConditionLexer.literalNames, _ConditionLexer.symbolicNames, []));
__publicField(_ConditionLexer, "decisionsToDFA", _ConditionLexer._ATN.decisionToState.map((ds2, index2) => new DFA(ds2, index2)));
let ConditionLexer = _ConditionLexer;
const _ConditionParser = class _ConditionParser extends Parser {
  get grammarFileName() {
    return "Condition.g4";
  }
  get literalNames() {
    return _ConditionParser.literalNames;
  }
  get symbolicNames() {
    return _ConditionParser.symbolicNames;
  }
  get ruleNames() {
    return _ConditionParser.ruleNames;
  }
  get serializedATN() {
    return _ConditionParser._serializedATN;
  }
  createFailedPredicateException(predicate, message) {
    return new FailedPredicateException(this, predicate, message);
  }
  constructor(input) {
    super(input);
    this.interpreter = new ParserATNSimulator(this, _ConditionParser._ATN, _ConditionParser.decisionsToDFA, new PredictionContextCache());
  }
  comparisonOperator() {
    const localContext = new ComparisonOperatorContext(this.context, this.state);
    this.enterRule(localContext, 0, _ConditionParser.RULE_comparisonOperator);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 40;
        _la2 = this.tokenStream.LA(1);
        if (!((_la2 & ~31) === 0 && (1 << _la2 & 254) !== 0)) {
          this.errorHandler.recoverInline(this);
        } else {
          this.errorHandler.reportMatch(this);
          this.consume();
        }
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  expression() {
    const localContext = new ExpressionContext(this.context, this.state);
    this.enterRule(localContext, 2, _ConditionParser.RULE_expression);
    try {
      this.state = 45;
      this.errorHandler.sync(this);
      switch (this.tokenStream.LA(1)) {
        case _ConditionParser.ID:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 42;
            this.runtimeValue();
          }
          break;
        case _ConditionParser.T__12:
        case _ConditionParser.T__13:
        case _ConditionParser.NULL:
        case _ConditionParser.FALSE:
        case _ConditionParser.TRUE:
        case _ConditionParser.STRING:
        case _ConditionParser.Integer:
        case _ConditionParser.BINARY:
        case _ConditionParser.FLOAT:
        case _ConditionParser.REAL:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 43;
            this.constantExpression();
          }
          break;
        case _ConditionParser.T__10:
          this.enterOuterAlt(localContext, 3);
          {
            this.state = 44;
            this.customField();
          }
          break;
        default:
          throw new NoViableAltException(this);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  expressionList() {
    const localContext = new ExpressionListContext(this.context, this.state);
    this.enterRule(localContext, 4, _ConditionParser.RULE_expressionList);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 47;
        this.expression();
        this.state = 52;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        while (_la2 === 8) {
          {
            {
              this.state = 48;
              this.match(_ConditionParser.T__7);
              this.state = 49;
              this.expression();
            }
          }
          this.state = 54;
          this.errorHandler.sync(this);
          _la2 = this.tokenStream.LA(1);
        }
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  runtimeValue() {
    const localContext = new RuntimeValueContext(this.context, this.state);
    this.enterRule(localContext, 6, _ConditionParser.RULE_runtimeValue);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 55;
        this.match(_ConditionParser.ID);
        this.state = 60;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        while (_la2 === 9) {
          {
            {
              this.state = 56;
              this.match(_ConditionParser.T__8);
              this.state = 57;
              this.match(_ConditionParser.ID);
            }
          }
          this.state = 62;
          this.errorHandler.sync(this);
          _la2 = this.tokenStream.LA(1);
        }
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  conditionAnd() {
    const localContext = new ConditionAndContext(this.context, this.state);
    this.enterRule(localContext, 8, _ConditionParser.RULE_conditionAnd);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 63;
        this.logicalNegation();
        this.state = 68;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        while (_la2 === 19) {
          {
            {
              this.state = 64;
              this.match(_ConditionParser.AND);
              this.state = 65;
              this.logicalNegation();
            }
          }
          this.state = 70;
          this.errorHandler.sync(this);
          _la2 = this.tokenStream.LA(1);
        }
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  logicalNegation() {
    const localContext = new LogicalNegationContext(this.context, this.state);
    this.enterRule(localContext, 10, _ConditionParser.RULE_logicalNegation);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 72;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        if (_la2 === 10) {
          {
            this.state = 71;
            this.match(_ConditionParser.T__9);
          }
        }
        this.state = 74;
        this.predicate();
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  condition() {
    const localContext = new ConditionContext(this.context, this.state);
    this.enterRule(localContext, 12, _ConditionParser.RULE_condition);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 76;
        this.conditionAnd();
        this.state = 81;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        while (_la2 === 20) {
          {
            {
              this.state = 77;
              this.match(_ConditionParser.OR);
              this.state = 78;
              this.conditionAnd();
            }
          }
          this.state = 83;
          this.errorHandler.sync(this);
          _la2 = this.tokenStream.LA(1);
        }
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  customField() {
    const localContext = new CustomFieldContext(this.context, this.state);
    this.enterRule(localContext, 14, _ConditionParser.RULE_customField);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 84;
        this.match(_ConditionParser.T__10);
        this.state = 85;
        this.match(_ConditionParser.ID);
        this.state = 86;
        this.match(_ConditionParser.T__11);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  numericExpression() {
    const localContext = new NumericExpressionContext(this.context, this.state);
    this.enterRule(localContext, 16, _ConditionParser.RULE_numericExpression);
    let _la2;
    try {
      this.state = 97;
      this.errorHandler.sync(this);
      switch (this.interpreter.adaptivePredict(this.tokenStream, 8, this.context)) {
        case 1:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 89;
            this.errorHandler.sync(this);
            _la2 = this.tokenStream.LA(1);
            if (_la2 === 13 || _la2 === 14) {
              {
                this.state = 88;
                _la2 = this.tokenStream.LA(1);
                if (!(_la2 === 13 || _la2 === 14)) {
                  this.errorHandler.recoverInline(this);
                } else {
                  this.errorHandler.reportMatch(this);
                  this.consume();
                }
              }
            }
            this.state = 91;
            this.match(_ConditionParser.Integer);
          }
          break;
        case 2:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 92;
            this.match(_ConditionParser.BINARY);
          }
          break;
        case 3:
          this.enterOuterAlt(localContext, 3);
          {
            this.state = 94;
            this.errorHandler.sync(this);
            _la2 = this.tokenStream.LA(1);
            if (_la2 === 13 || _la2 === 14) {
              {
                this.state = 93;
                _la2 = this.tokenStream.LA(1);
                if (!(_la2 === 13 || _la2 === 14)) {
                  this.errorHandler.recoverInline(this);
                } else {
                  this.errorHandler.reportMatch(this);
                  this.consume();
                }
              }
            }
            this.state = 96;
            _la2 = this.tokenStream.LA(1);
            if (!(_la2 === 32 || _la2 === 33)) {
              this.errorHandler.recoverInline(this);
            } else {
              this.errorHandler.reportMatch(this);
              this.consume();
            }
          }
          break;
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  stringExpression() {
    const localContext = new StringExpressionContext(this.context, this.state);
    this.enterRule(localContext, 18, _ConditionParser.RULE_stringExpression);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 99;
        this.match(_ConditionParser.STRING);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  nullExpression() {
    const localContext = new NullExpressionContext(this.context, this.state);
    this.enterRule(localContext, 20, _ConditionParser.RULE_nullExpression);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 101;
        this.match(_ConditionParser.NULL);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  trueExpression() {
    const localContext = new TrueExpressionContext(this.context, this.state);
    this.enterRule(localContext, 22, _ConditionParser.RULE_trueExpression);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 103;
        this.match(_ConditionParser.TRUE);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  falseExpression() {
    const localContext = new FalseExpressionContext(this.context, this.state);
    this.enterRule(localContext, 24, _ConditionParser.RULE_falseExpression);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 105;
        this.match(_ConditionParser.FALSE);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  constantExpression() {
    const localContext = new ConstantExpressionContext(this.context, this.state);
    this.enterRule(localContext, 26, _ConditionParser.RULE_constantExpression);
    try {
      this.state = 112;
      this.errorHandler.sync(this);
      switch (this.tokenStream.LA(1)) {
        case _ConditionParser.STRING:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 107;
            this.stringExpression();
          }
          break;
        case _ConditionParser.T__12:
        case _ConditionParser.T__13:
        case _ConditionParser.Integer:
        case _ConditionParser.BINARY:
        case _ConditionParser.FLOAT:
        case _ConditionParser.REAL:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 108;
            this.numericExpression();
          }
          break;
        case _ConditionParser.NULL:
          this.enterOuterAlt(localContext, 3);
          {
            this.state = 109;
            this.nullExpression();
          }
          break;
        case _ConditionParser.TRUE:
          this.enterOuterAlt(localContext, 4);
          {
            this.state = 110;
            this.trueExpression();
          }
          break;
        case _ConditionParser.FALSE:
          this.enterOuterAlt(localContext, 5);
          {
            this.state = 111;
            this.falseExpression();
          }
          break;
        default:
          throw new NoViableAltException(this);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  comparisonExpression() {
    const localContext = new ComparisonExpressionContext(this.context, this.state);
    this.enterRule(localContext, 28, _ConditionParser.RULE_comparisonExpression);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 114;
        this.expression();
        this.state = 115;
        this.comparisonOperator();
        this.state = 116;
        this.expression();
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  inExpression() {
    const localContext = new InExpressionContext(this.context, this.state);
    this.enterRule(localContext, 30, _ConditionParser.RULE_inExpression);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 118;
        this.expression();
        this.state = 120;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        if (_la2 === 25) {
          {
            this.state = 119;
            this.match(_ConditionParser.NOT);
          }
        }
        this.state = 122;
        this.match(_ConditionParser.IN);
        this.state = 123;
        this.match(_ConditionParser.T__14);
        this.state = 124;
        this.expressionList();
        this.state = 125;
        this.match(_ConditionParser.T__15);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  subsetofExpression() {
    const localContext = new SubsetofExpressionContext(this.context, this.state);
    this.enterRule(localContext, 32, _ConditionParser.RULE_subsetofExpression);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 127;
        this.expression();
        this.state = 129;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        if (_la2 === 25) {
          {
            this.state = 128;
            this.match(_ConditionParser.NOT);
          }
        }
        this.state = 131;
        this.match(_ConditionParser.SUBSETOF);
        this.state = 132;
        this.match(_ConditionParser.T__14);
        this.state = 133;
        this.expressionList();
        this.state = 134;
        this.match(_ConditionParser.T__15);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  containsExpression() {
    const localContext = new ContainsExpressionContext(this.context, this.state);
    this.enterRule(localContext, 34, _ConditionParser.RULE_containsExpression);
    let _la2;
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 136;
        this.expression();
        this.state = 138;
        this.errorHandler.sync(this);
        _la2 = this.tokenStream.LA(1);
        if (_la2 === 25) {
          {
            this.state = 137;
            this.match(_ConditionParser.NOT);
          }
        }
        this.state = 140;
        this.match(_ConditionParser.CONTAINS);
        this.state = 141;
        this.match(_ConditionParser.T__14);
        this.state = 142;
        this.expressionList();
        this.state = 143;
        this.match(_ConditionParser.T__15);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  condationGroup() {
    const localContext = new CondationGroupContext(this.context, this.state);
    this.enterRule(localContext, 36, _ConditionParser.RULE_condationGroup);
    try {
      this.enterOuterAlt(localContext, 1);
      {
        this.state = 145;
        this.match(_ConditionParser.T__14);
        this.state = 146;
        this.condition();
        this.state = 147;
        this.match(_ConditionParser.T__15);
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  predicate() {
    const localContext = new PredicateContext(this.context, this.state);
    this.enterRule(localContext, 38, _ConditionParser.RULE_predicate);
    try {
      this.state = 156;
      this.errorHandler.sync(this);
      switch (this.interpreter.adaptivePredict(this.tokenStream, 13, this.context)) {
        case 1:
          this.enterOuterAlt(localContext, 1);
          {
            this.state = 149;
            this.trueExpression();
          }
          break;
        case 2:
          this.enterOuterAlt(localContext, 2);
          {
            this.state = 150;
            this.falseExpression();
          }
          break;
        case 3:
          this.enterOuterAlt(localContext, 3);
          {
            this.state = 151;
            this.comparisonExpression();
          }
          break;
        case 4:
          this.enterOuterAlt(localContext, 4);
          {
            this.state = 152;
            this.inExpression();
          }
          break;
        case 5:
          this.enterOuterAlt(localContext, 5);
          {
            this.state = 153;
            this.subsetofExpression();
          }
          break;
        case 6:
          this.enterOuterAlt(localContext, 6);
          {
            this.state = 154;
            this.containsExpression();
          }
          break;
        case 7:
          this.enterOuterAlt(localContext, 7);
          {
            this.state = 155;
            this.condationGroup();
          }
          break;
      }
    } catch (re2) {
      if (re2 instanceof RecognitionException) {
        this.errorHandler.reportError(this, re2);
        this.errorHandler.recover(this, re2);
      } else {
        throw re2;
      }
    } finally {
      this.exitRule();
    }
    return localContext;
  }
  static get _ATN() {
    if (!_ConditionParser.__ATN) {
      _ConditionParser.__ATN = new ATNDeserializer().deserialize(_ConditionParser._serializedATN);
    }
    return _ConditionParser.__ATN;
  }
  get vocabulary() {
    return _ConditionParser.vocabulary;
  }
};
__publicField(_ConditionParser, "T__0", 1);
__publicField(_ConditionParser, "T__1", 2);
__publicField(_ConditionParser, "T__2", 3);
__publicField(_ConditionParser, "T__3", 4);
__publicField(_ConditionParser, "T__4", 5);
__publicField(_ConditionParser, "T__5", 6);
__publicField(_ConditionParser, "T__6", 7);
__publicField(_ConditionParser, "T__7", 8);
__publicField(_ConditionParser, "T__8", 9);
__publicField(_ConditionParser, "T__9", 10);
__publicField(_ConditionParser, "T__10", 11);
__publicField(_ConditionParser, "T__11", 12);
__publicField(_ConditionParser, "T__12", 13);
__publicField(_ConditionParser, "T__13", 14);
__publicField(_ConditionParser, "T__14", 15);
__publicField(_ConditionParser, "T__15", 16);
__publicField(_ConditionParser, "LINECOMMENT", 17);
__publicField(_ConditionParser, "COMMENT", 18);
__publicField(_ConditionParser, "AND", 19);
__publicField(_ConditionParser, "OR", 20);
__publicField(_ConditionParser, "IN", 21);
__publicField(_ConditionParser, "CONTAINS", 22);
__publicField(_ConditionParser, "SUBSETOF", 23);
__publicField(_ConditionParser, "NULL", 24);
__publicField(_ConditionParser, "NOT", 25);
__publicField(_ConditionParser, "FALSE", 26);
__publicField(_ConditionParser, "TRUE", 27);
__publicField(_ConditionParser, "ID", 28);
__publicField(_ConditionParser, "STRING", 29);
__publicField(_ConditionParser, "Integer", 30);
__publicField(_ConditionParser, "BINARY", 31);
__publicField(_ConditionParser, "FLOAT", 32);
__publicField(_ConditionParser, "REAL", 33);
__publicField(_ConditionParser, "S", 34);
__publicField(_ConditionParser, "RULE_comparisonOperator", 0);
__publicField(_ConditionParser, "RULE_expression", 1);
__publicField(_ConditionParser, "RULE_expressionList", 2);
__publicField(_ConditionParser, "RULE_runtimeValue", 3);
__publicField(_ConditionParser, "RULE_conditionAnd", 4);
__publicField(_ConditionParser, "RULE_logicalNegation", 5);
__publicField(_ConditionParser, "RULE_condition", 6);
__publicField(_ConditionParser, "RULE_customField", 7);
__publicField(_ConditionParser, "RULE_numericExpression", 8);
__publicField(_ConditionParser, "RULE_stringExpression", 9);
__publicField(_ConditionParser, "RULE_nullExpression", 10);
__publicField(_ConditionParser, "RULE_trueExpression", 11);
__publicField(_ConditionParser, "RULE_falseExpression", 12);
__publicField(_ConditionParser, "RULE_constantExpression", 13);
__publicField(_ConditionParser, "RULE_comparisonExpression", 14);
__publicField(_ConditionParser, "RULE_inExpression", 15);
__publicField(_ConditionParser, "RULE_subsetofExpression", 16);
__publicField(_ConditionParser, "RULE_containsExpression", 17);
__publicField(_ConditionParser, "RULE_condationGroup", 18);
__publicField(_ConditionParser, "RULE_predicate", 19);
__publicField(_ConditionParser, "literalNames", [
  null,
  "'=='",
  "'='",
  "'>'",
  "'<'",
  "'<='",
  "'>='",
  "'!='",
  "','",
  "'.'",
  "'!'",
  "'{'",
  "'}'",
  "'+'",
  "'-'",
  "'('",
  "')'",
  null,
  null,
  "'&&'",
  "'||'"
]);
__publicField(_ConditionParser, "symbolicNames", [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  "LINECOMMENT",
  "COMMENT",
  "AND",
  "OR",
  "IN",
  "CONTAINS",
  "SUBSETOF",
  "NULL",
  "NOT",
  "FALSE",
  "TRUE",
  "ID",
  "STRING",
  "Integer",
  "BINARY",
  "FLOAT",
  "REAL",
  "S"
]);
__publicField(_ConditionParser, "ruleNames", [
  "comparisonOperator",
  "expression",
  "expressionList",
  "runtimeValue",
  "conditionAnd",
  "logicalNegation",
  "condition",
  "customField",
  "numericExpression",
  "stringExpression",
  "nullExpression",
  "trueExpression",
  "falseExpression",
  "constantExpression",
  "comparisonExpression",
  "inExpression",
  "subsetofExpression",
  "containsExpression",
  "condationGroup",
  "predicate"
]);
__publicField(_ConditionParser, "_serializedATN", [
  4,
  1,
  34,
  159,
  2,
  0,
  7,
  0,
  2,
  1,
  7,
  1,
  2,
  2,
  7,
  2,
  2,
  3,
  7,
  3,
  2,
  4,
  7,
  4,
  2,
  5,
  7,
  5,
  2,
  6,
  7,
  6,
  2,
  7,
  7,
  7,
  2,
  8,
  7,
  8,
  2,
  9,
  7,
  9,
  2,
  10,
  7,
  10,
  2,
  11,
  7,
  11,
  2,
  12,
  7,
  12,
  2,
  13,
  7,
  13,
  2,
  14,
  7,
  14,
  2,
  15,
  7,
  15,
  2,
  16,
  7,
  16,
  2,
  17,
  7,
  17,
  2,
  18,
  7,
  18,
  2,
  19,
  7,
  19,
  1,
  0,
  1,
  0,
  1,
  1,
  1,
  1,
  1,
  1,
  3,
  1,
  46,
  8,
  1,
  1,
  2,
  1,
  2,
  1,
  2,
  5,
  2,
  51,
  8,
  2,
  10,
  2,
  12,
  2,
  54,
  9,
  2,
  1,
  3,
  1,
  3,
  1,
  3,
  5,
  3,
  59,
  8,
  3,
  10,
  3,
  12,
  3,
  62,
  9,
  3,
  1,
  4,
  1,
  4,
  1,
  4,
  5,
  4,
  67,
  8,
  4,
  10,
  4,
  12,
  4,
  70,
  9,
  4,
  1,
  5,
  3,
  5,
  73,
  8,
  5,
  1,
  5,
  1,
  5,
  1,
  6,
  1,
  6,
  1,
  6,
  5,
  6,
  80,
  8,
  6,
  10,
  6,
  12,
  6,
  83,
  9,
  6,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  7,
  1,
  8,
  3,
  8,
  90,
  8,
  8,
  1,
  8,
  1,
  8,
  1,
  8,
  3,
  8,
  95,
  8,
  8,
  1,
  8,
  3,
  8,
  98,
  8,
  8,
  1,
  9,
  1,
  9,
  1,
  10,
  1,
  10,
  1,
  11,
  1,
  11,
  1,
  12,
  1,
  12,
  1,
  13,
  1,
  13,
  1,
  13,
  1,
  13,
  1,
  13,
  3,
  13,
  113,
  8,
  13,
  1,
  14,
  1,
  14,
  1,
  14,
  1,
  14,
  1,
  15,
  1,
  15,
  3,
  15,
  121,
  8,
  15,
  1,
  15,
  1,
  15,
  1,
  15,
  1,
  15,
  1,
  15,
  1,
  16,
  1,
  16,
  3,
  16,
  130,
  8,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  16,
  1,
  17,
  1,
  17,
  3,
  17,
  139,
  8,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  17,
  1,
  18,
  1,
  18,
  1,
  18,
  1,
  18,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  19,
  1,
  19,
  3,
  19,
  157,
  8,
  19,
  1,
  19,
  0,
  0,
  20,
  0,
  2,
  4,
  6,
  8,
  10,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  30,
  32,
  34,
  36,
  38,
  0,
  3,
  1,
  0,
  1,
  7,
  1,
  0,
  13,
  14,
  1,
  0,
  32,
  33,
  162,
  0,
  40,
  1,
  0,
  0,
  0,
  2,
  45,
  1,
  0,
  0,
  0,
  4,
  47,
  1,
  0,
  0,
  0,
  6,
  55,
  1,
  0,
  0,
  0,
  8,
  63,
  1,
  0,
  0,
  0,
  10,
  72,
  1,
  0,
  0,
  0,
  12,
  76,
  1,
  0,
  0,
  0,
  14,
  84,
  1,
  0,
  0,
  0,
  16,
  97,
  1,
  0,
  0,
  0,
  18,
  99,
  1,
  0,
  0,
  0,
  20,
  101,
  1,
  0,
  0,
  0,
  22,
  103,
  1,
  0,
  0,
  0,
  24,
  105,
  1,
  0,
  0,
  0,
  26,
  112,
  1,
  0,
  0,
  0,
  28,
  114,
  1,
  0,
  0,
  0,
  30,
  118,
  1,
  0,
  0,
  0,
  32,
  127,
  1,
  0,
  0,
  0,
  34,
  136,
  1,
  0,
  0,
  0,
  36,
  145,
  1,
  0,
  0,
  0,
  38,
  156,
  1,
  0,
  0,
  0,
  40,
  41,
  7,
  0,
  0,
  0,
  41,
  1,
  1,
  0,
  0,
  0,
  42,
  46,
  3,
  6,
  3,
  0,
  43,
  46,
  3,
  26,
  13,
  0,
  44,
  46,
  3,
  14,
  7,
  0,
  45,
  42,
  1,
  0,
  0,
  0,
  45,
  43,
  1,
  0,
  0,
  0,
  45,
  44,
  1,
  0,
  0,
  0,
  46,
  3,
  1,
  0,
  0,
  0,
  47,
  52,
  3,
  2,
  1,
  0,
  48,
  49,
  5,
  8,
  0,
  0,
  49,
  51,
  3,
  2,
  1,
  0,
  50,
  48,
  1,
  0,
  0,
  0,
  51,
  54,
  1,
  0,
  0,
  0,
  52,
  50,
  1,
  0,
  0,
  0,
  52,
  53,
  1,
  0,
  0,
  0,
  53,
  5,
  1,
  0,
  0,
  0,
  54,
  52,
  1,
  0,
  0,
  0,
  55,
  60,
  5,
  28,
  0,
  0,
  56,
  57,
  5,
  9,
  0,
  0,
  57,
  59,
  5,
  28,
  0,
  0,
  58,
  56,
  1,
  0,
  0,
  0,
  59,
  62,
  1,
  0,
  0,
  0,
  60,
  58,
  1,
  0,
  0,
  0,
  60,
  61,
  1,
  0,
  0,
  0,
  61,
  7,
  1,
  0,
  0,
  0,
  62,
  60,
  1,
  0,
  0,
  0,
  63,
  68,
  3,
  10,
  5,
  0,
  64,
  65,
  5,
  19,
  0,
  0,
  65,
  67,
  3,
  10,
  5,
  0,
  66,
  64,
  1,
  0,
  0,
  0,
  67,
  70,
  1,
  0,
  0,
  0,
  68,
  66,
  1,
  0,
  0,
  0,
  68,
  69,
  1,
  0,
  0,
  0,
  69,
  9,
  1,
  0,
  0,
  0,
  70,
  68,
  1,
  0,
  0,
  0,
  71,
  73,
  5,
  10,
  0,
  0,
  72,
  71,
  1,
  0,
  0,
  0,
  72,
  73,
  1,
  0,
  0,
  0,
  73,
  74,
  1,
  0,
  0,
  0,
  74,
  75,
  3,
  38,
  19,
  0,
  75,
  11,
  1,
  0,
  0,
  0,
  76,
  81,
  3,
  8,
  4,
  0,
  77,
  78,
  5,
  20,
  0,
  0,
  78,
  80,
  3,
  8,
  4,
  0,
  79,
  77,
  1,
  0,
  0,
  0,
  80,
  83,
  1,
  0,
  0,
  0,
  81,
  79,
  1,
  0,
  0,
  0,
  81,
  82,
  1,
  0,
  0,
  0,
  82,
  13,
  1,
  0,
  0,
  0,
  83,
  81,
  1,
  0,
  0,
  0,
  84,
  85,
  5,
  11,
  0,
  0,
  85,
  86,
  5,
  28,
  0,
  0,
  86,
  87,
  5,
  12,
  0,
  0,
  87,
  15,
  1,
  0,
  0,
  0,
  88,
  90,
  7,
  1,
  0,
  0,
  89,
  88,
  1,
  0,
  0,
  0,
  89,
  90,
  1,
  0,
  0,
  0,
  90,
  91,
  1,
  0,
  0,
  0,
  91,
  98,
  5,
  30,
  0,
  0,
  92,
  98,
  5,
  31,
  0,
  0,
  93,
  95,
  7,
  1,
  0,
  0,
  94,
  93,
  1,
  0,
  0,
  0,
  94,
  95,
  1,
  0,
  0,
  0,
  95,
  96,
  1,
  0,
  0,
  0,
  96,
  98,
  7,
  2,
  0,
  0,
  97,
  89,
  1,
  0,
  0,
  0,
  97,
  92,
  1,
  0,
  0,
  0,
  97,
  94,
  1,
  0,
  0,
  0,
  98,
  17,
  1,
  0,
  0,
  0,
  99,
  100,
  5,
  29,
  0,
  0,
  100,
  19,
  1,
  0,
  0,
  0,
  101,
  102,
  5,
  24,
  0,
  0,
  102,
  21,
  1,
  0,
  0,
  0,
  103,
  104,
  5,
  27,
  0,
  0,
  104,
  23,
  1,
  0,
  0,
  0,
  105,
  106,
  5,
  26,
  0,
  0,
  106,
  25,
  1,
  0,
  0,
  0,
  107,
  113,
  3,
  18,
  9,
  0,
  108,
  113,
  3,
  16,
  8,
  0,
  109,
  113,
  3,
  20,
  10,
  0,
  110,
  113,
  3,
  22,
  11,
  0,
  111,
  113,
  3,
  24,
  12,
  0,
  112,
  107,
  1,
  0,
  0,
  0,
  112,
  108,
  1,
  0,
  0,
  0,
  112,
  109,
  1,
  0,
  0,
  0,
  112,
  110,
  1,
  0,
  0,
  0,
  112,
  111,
  1,
  0,
  0,
  0,
  113,
  27,
  1,
  0,
  0,
  0,
  114,
  115,
  3,
  2,
  1,
  0,
  115,
  116,
  3,
  0,
  0,
  0,
  116,
  117,
  3,
  2,
  1,
  0,
  117,
  29,
  1,
  0,
  0,
  0,
  118,
  120,
  3,
  2,
  1,
  0,
  119,
  121,
  5,
  25,
  0,
  0,
  120,
  119,
  1,
  0,
  0,
  0,
  120,
  121,
  1,
  0,
  0,
  0,
  121,
  122,
  1,
  0,
  0,
  0,
  122,
  123,
  5,
  21,
  0,
  0,
  123,
  124,
  5,
  15,
  0,
  0,
  124,
  125,
  3,
  4,
  2,
  0,
  125,
  126,
  5,
  16,
  0,
  0,
  126,
  31,
  1,
  0,
  0,
  0,
  127,
  129,
  3,
  2,
  1,
  0,
  128,
  130,
  5,
  25,
  0,
  0,
  129,
  128,
  1,
  0,
  0,
  0,
  129,
  130,
  1,
  0,
  0,
  0,
  130,
  131,
  1,
  0,
  0,
  0,
  131,
  132,
  5,
  23,
  0,
  0,
  132,
  133,
  5,
  15,
  0,
  0,
  133,
  134,
  3,
  4,
  2,
  0,
  134,
  135,
  5,
  16,
  0,
  0,
  135,
  33,
  1,
  0,
  0,
  0,
  136,
  138,
  3,
  2,
  1,
  0,
  137,
  139,
  5,
  25,
  0,
  0,
  138,
  137,
  1,
  0,
  0,
  0,
  138,
  139,
  1,
  0,
  0,
  0,
  139,
  140,
  1,
  0,
  0,
  0,
  140,
  141,
  5,
  22,
  0,
  0,
  141,
  142,
  5,
  15,
  0,
  0,
  142,
  143,
  3,
  4,
  2,
  0,
  143,
  144,
  5,
  16,
  0,
  0,
  144,
  35,
  1,
  0,
  0,
  0,
  145,
  146,
  5,
  15,
  0,
  0,
  146,
  147,
  3,
  12,
  6,
  0,
  147,
  148,
  5,
  16,
  0,
  0,
  148,
  37,
  1,
  0,
  0,
  0,
  149,
  157,
  3,
  22,
  11,
  0,
  150,
  157,
  3,
  24,
  12,
  0,
  151,
  157,
  3,
  28,
  14,
  0,
  152,
  157,
  3,
  30,
  15,
  0,
  153,
  157,
  3,
  32,
  16,
  0,
  154,
  157,
  3,
  34,
  17,
  0,
  155,
  157,
  3,
  36,
  18,
  0,
  156,
  149,
  1,
  0,
  0,
  0,
  156,
  150,
  1,
  0,
  0,
  0,
  156,
  151,
  1,
  0,
  0,
  0,
  156,
  152,
  1,
  0,
  0,
  0,
  156,
  153,
  1,
  0,
  0,
  0,
  156,
  154,
  1,
  0,
  0,
  0,
  156,
  155,
  1,
  0,
  0,
  0,
  157,
  39,
  1,
  0,
  0,
  0,
  14,
  45,
  52,
  60,
  68,
  72,
  81,
  89,
  94,
  97,
  112,
  120,
  129,
  138,
  156
]);
__publicField(_ConditionParser, "__ATN");
__publicField(_ConditionParser, "vocabulary", new Vocabulary(_ConditionParser.literalNames, _ConditionParser.symbolicNames, []));
__publicField(_ConditionParser, "decisionsToDFA", _ConditionParser._ATN.decisionToState.map((ds2, index2) => new DFA(ds2, index2)));
let ConditionParser = _ConditionParser;
class ComparisonOperatorContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  get ruleIndex() {
    return ConditionParser.RULE_comparisonOperator;
  }
  accept(visitor) {
    if (visitor.visitComparisonOperator) {
      return visitor.visitComparisonOperator(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  runtimeValue() {
    return this.getRuleContext(0, RuntimeValueContext);
  }
  constantExpression() {
    return this.getRuleContext(0, ConstantExpressionContext);
  }
  customField() {
    return this.getRuleContext(0, CustomFieldContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_expression;
  }
  accept(visitor) {
    if (visitor.visitExpression) {
      return visitor.visitExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ExpressionListContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  expression(i2) {
    if (i2 === void 0) {
      return this.getRuleContexts(ExpressionContext);
    }
    return this.getRuleContext(i2, ExpressionContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_expressionList;
  }
  accept(visitor) {
    if (visitor.visitExpressionList) {
      return visitor.visitExpressionList(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class RuntimeValueContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  ID(i2) {
    if (i2 === void 0) {
      return this.getTokens(ConditionParser.ID);
    } else {
      return this.getToken(ConditionParser.ID, i2);
    }
  }
  get ruleIndex() {
    return ConditionParser.RULE_runtimeValue;
  }
  accept(visitor) {
    if (visitor.visitRuntimeValue) {
      return visitor.visitRuntimeValue(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ConditionAndContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  logicalNegation(i2) {
    if (i2 === void 0) {
      return this.getRuleContexts(LogicalNegationContext);
    }
    return this.getRuleContext(i2, LogicalNegationContext);
  }
  AND(i2) {
    if (i2 === void 0) {
      return this.getTokens(ConditionParser.AND);
    } else {
      return this.getToken(ConditionParser.AND, i2);
    }
  }
  get ruleIndex() {
    return ConditionParser.RULE_conditionAnd;
  }
  accept(visitor) {
    if (visitor.visitConditionAnd) {
      return visitor.visitConditionAnd(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class LogicalNegationContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  predicate() {
    return this.getRuleContext(0, PredicateContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_logicalNegation;
  }
  accept(visitor) {
    if (visitor.visitLogicalNegation) {
      return visitor.visitLogicalNegation(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ConditionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  conditionAnd(i2) {
    if (i2 === void 0) {
      return this.getRuleContexts(ConditionAndContext);
    }
    return this.getRuleContext(i2, ConditionAndContext);
  }
  OR(i2) {
    if (i2 === void 0) {
      return this.getTokens(ConditionParser.OR);
    } else {
      return this.getToken(ConditionParser.OR, i2);
    }
  }
  get ruleIndex() {
    return ConditionParser.RULE_condition;
  }
  accept(visitor) {
    if (visitor.visitCondition) {
      return visitor.visitCondition(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class CustomFieldContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  ID() {
    return this.getToken(ConditionParser.ID, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_customField;
  }
  accept(visitor) {
    if (visitor.visitCustomField) {
      return visitor.visitCustomField(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class NumericExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  Integer() {
    return this.getToken(ConditionParser.Integer, 0);
  }
  BINARY() {
    return this.getToken(ConditionParser.BINARY, 0);
  }
  REAL() {
    return this.getToken(ConditionParser.REAL, 0);
  }
  FLOAT() {
    return this.getToken(ConditionParser.FLOAT, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_numericExpression;
  }
  accept(visitor) {
    if (visitor.visitNumericExpression) {
      return visitor.visitNumericExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class StringExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  STRING() {
    return this.getToken(ConditionParser.STRING, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_stringExpression;
  }
  accept(visitor) {
    if (visitor.visitStringExpression) {
      return visitor.visitStringExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class NullExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  NULL() {
    return this.getToken(ConditionParser.NULL, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_nullExpression;
  }
  accept(visitor) {
    if (visitor.visitNullExpression) {
      return visitor.visitNullExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class TrueExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  TRUE() {
    return this.getToken(ConditionParser.TRUE, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_trueExpression;
  }
  accept(visitor) {
    if (visitor.visitTrueExpression) {
      return visitor.visitTrueExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FalseExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  FALSE() {
    return this.getToken(ConditionParser.FALSE, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_falseExpression;
  }
  accept(visitor) {
    if (visitor.visitFalseExpression) {
      return visitor.visitFalseExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ConstantExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  stringExpression() {
    return this.getRuleContext(0, StringExpressionContext);
  }
  numericExpression() {
    return this.getRuleContext(0, NumericExpressionContext);
  }
  nullExpression() {
    return this.getRuleContext(0, NullExpressionContext);
  }
  trueExpression() {
    return this.getRuleContext(0, TrueExpressionContext);
  }
  falseExpression() {
    return this.getRuleContext(0, FalseExpressionContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_constantExpression;
  }
  accept(visitor) {
    if (visitor.visitConstantExpression) {
      return visitor.visitConstantExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ComparisonExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  expression(i2) {
    if (i2 === void 0) {
      return this.getRuleContexts(ExpressionContext);
    }
    return this.getRuleContext(i2, ExpressionContext);
  }
  comparisonOperator() {
    return this.getRuleContext(0, ComparisonOperatorContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_comparisonExpression;
  }
  accept(visitor) {
    if (visitor.visitComparisonExpression) {
      return visitor.visitComparisonExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class InExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  expression() {
    return this.getRuleContext(0, ExpressionContext);
  }
  IN() {
    return this.getToken(ConditionParser.IN, 0);
  }
  expressionList() {
    return this.getRuleContext(0, ExpressionListContext);
  }
  NOT() {
    return this.getToken(ConditionParser.NOT, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_inExpression;
  }
  accept(visitor) {
    if (visitor.visitInExpression) {
      return visitor.visitInExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class SubsetofExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  expression() {
    return this.getRuleContext(0, ExpressionContext);
  }
  SUBSETOF() {
    return this.getToken(ConditionParser.SUBSETOF, 0);
  }
  expressionList() {
    return this.getRuleContext(0, ExpressionListContext);
  }
  NOT() {
    return this.getToken(ConditionParser.NOT, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_subsetofExpression;
  }
  accept(visitor) {
    if (visitor.visitSubsetofExpression) {
      return visitor.visitSubsetofExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class ContainsExpressionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  expression() {
    return this.getRuleContext(0, ExpressionContext);
  }
  CONTAINS() {
    return this.getToken(ConditionParser.CONTAINS, 0);
  }
  expressionList() {
    return this.getRuleContext(0, ExpressionListContext);
  }
  NOT() {
    return this.getToken(ConditionParser.NOT, 0);
  }
  get ruleIndex() {
    return ConditionParser.RULE_containsExpression;
  }
  accept(visitor) {
    if (visitor.visitContainsExpression) {
      return visitor.visitContainsExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class CondationGroupContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  condition() {
    return this.getRuleContext(0, ConditionContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_condationGroup;
  }
  accept(visitor) {
    if (visitor.visitCondationGroup) {
      return visitor.visitCondationGroup(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class PredicateContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  trueExpression() {
    return this.getRuleContext(0, TrueExpressionContext);
  }
  falseExpression() {
    return this.getRuleContext(0, FalseExpressionContext);
  }
  comparisonExpression() {
    return this.getRuleContext(0, ComparisonExpressionContext);
  }
  inExpression() {
    return this.getRuleContext(0, InExpressionContext);
  }
  subsetofExpression() {
    return this.getRuleContext(0, SubsetofExpressionContext);
  }
  containsExpression() {
    return this.getRuleContext(0, ContainsExpressionContext);
  }
  condationGroup() {
    return this.getRuleContext(0, CondationGroupContext);
  }
  get ruleIndex() {
    return ConditionParser.RULE_predicate;
  }
  accept(visitor) {
    if (visitor.visitPredicate) {
      return visitor.visitPredicate(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class VantisErrorListener {
  reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
  }
  reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, configs) {
  }
  reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, configs) {
  }
  syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e10) {
    throw new Error(msg);
  }
}
var GrammarRuleNames = /* @__PURE__ */ ((GrammarRuleNames2) => {
  GrammarRuleNames2["ExpressionList"] = "ExpressionList";
  GrammarRuleNames2["RuntimeValue"] = "RuntimeValue";
  GrammarRuleNames2["LogicalNegation"] = "LogicalNegation";
  GrammarRuleNames2["CustomField"] = "CustomField";
  GrammarRuleNames2["NumericExpression"] = "NumericExpression";
  GrammarRuleNames2["StringExpression"] = "StringExpression";
  GrammarRuleNames2["NullExpression"] = "NullExpression";
  GrammarRuleNames2["BooleanExpression"] = "BooleanExpression";
  GrammarRuleNames2["ComparisonExpression"] = "ComparisonExpression";
  GrammarRuleNames2["InExpression"] = "InExpression";
  GrammarRuleNames2["SubsetofExpression"] = "SubsetofExpression";
  GrammarRuleNames2["ContainsExpression"] = "ContainsExpression";
  GrammarRuleNames2["ConditionGroup"] = "ConditionGroup";
  GrammarRuleNames2["logicalExpression"] = "logicalExpression";
  return GrammarRuleNames2;
})(GrammarRuleNames || {});
class GrammarRule {
  constructor(ruleName) {
    __publicField(this, "ruleName");
    __publicField(this, "id");
    __publicField(this, "parent");
    this.ruleName = ruleName;
    this.id = generateShortUUID();
  }
  isRoot() {
    return this.parent === void 0;
  }
  deepClone() {
    throw new Error("not implemented");
  }
}
class Expression extends GrammarRule {
}
class ExpressionList extends GrammarRule {
  constructor(children) {
    super(
      "ExpressionList"
      /* ExpressionList */
    );
    __publicField(this, "children");
    children.forEach((c3) => c3.parent = this);
    this.children = children;
  }
  removeChildren(children) {
    const index2 = this.children.findIndex((g2) => g2.id === children.id);
    if (index2 > -1) {
      this.children.splice(index2, 1);
    }
  }
  deepClone() {
    const children = this.children.map((e10) => e10.deepClone());
    return new ExpressionList(children);
  }
}
class RuntimeValue extends Expression {
  constructor(names) {
    super(
      "RuntimeValue"
      /* RuntimeValue */
    );
    __publicField(this, "names");
    //Xander ADD
    __publicField(this, "name");
    this.names = names;
    if (names.length == 1) {
      this.name = names[0];
    } else {
      this.name = names.join(".").replace('"', "");
    }
  }
  isInvalid() {
    return !Array.isArray(this.names) || this.names.length == 0;
  }
  deepClone() {
    return new RuntimeValue(this.names);
  }
}
class LogicalNegation extends GrammarRule {
  constructor(predicate, not) {
    super(
      "LogicalNegation"
      /* LogicalNegation */
    );
    __publicField(this, "not");
    __publicField(this, "predicate");
    this.not = not;
    this.predicate = predicate;
    predicate.parent = this;
  }
  deepClone() {
    const predicate = this.predicate.deepClone();
    return new LogicalNegation(predicate, this.not);
  }
}
class Predicate extends GrammarRule {
}
class ConstantExpression extends Expression {
}
class NumericExpression extends ConstantExpression {
  constructor(value) {
    super(
      "NumericExpression"
      /* NumericExpression */
    );
    __publicField(this, "value");
    this.value = value;
  }
  deepClone() {
    return new NumericExpression(this.value);
  }
}
class StringExpression extends ConstantExpression {
  constructor(value) {
    super(
      "StringExpression"
      /* StringExpression */
    );
    __publicField(this, "value");
    this.value = value;
  }
  deepClone() {
    return new StringExpression(this.value);
  }
}
class NullExpression extends ConstantExpression {
  constructor() {
    super(
      "NullExpression"
      /* NullExpression */
    );
    __publicField(this, "value");
    this.value = null;
  }
  deepClone() {
    return new NullExpression();
  }
}
class BooleanExpression extends Predicate {
  constructor(value) {
    super(
      "BooleanExpression"
      /* BooleanExpression */
    );
    __publicField(this, "value");
    this.value = value;
  }
  deepClone() {
    return new BooleanExpression(this.value);
  }
}
class ComparisonExpression extends Predicate {
  constructor(left, right, comparisonOperator) {
    super(
      "ComparisonExpression"
      /* ComparisonExpression */
    );
    __publicField(this, "left");
    __publicField(this, "right");
    __publicField(this, "comparisonOperator");
    left.parent = this;
    right.parent = this;
    this.left = left;
    this.right = right;
    this.comparisonOperator = comparisonOperator;
  }
  deepClone() {
    return new ComparisonExpression(this.left.deepClone(), this.right.deepClone(), this.comparisonOperator);
  }
}
class InExpression extends Predicate {
  constructor(expression, expressionList, not) {
    super(
      "InExpression"
      /* InExpression */
    );
    __publicField(this, "expression");
    __publicField(this, "expressionList");
    __publicField(this, "not");
    expression.parent = this;
    expressionList.parent = this;
    this.expression = expression;
    this.expressionList = expressionList;
    this.not = not;
  }
  deepClone() {
    return new InExpression(this.expression.deepClone(), this.expressionList.deepClone(), this.not);
  }
}
class ContainsExpression extends Predicate {
  constructor(expression, expressionList, not) {
    super(
      "ContainsExpression"
      /* ContainsExpression */
    );
    __publicField(this, "expression");
    __publicField(this, "expressionList");
    __publicField(this, "not");
    expression.parent = this;
    expressionList.parent = this;
    this.expression = expression;
    this.expressionList = expressionList;
    this.not = not;
  }
  deepClone() {
    return new ContainsExpression(this.expression.deepClone(), this.expressionList.deepClone(), this.not);
  }
}
class SubsetofExpression extends Predicate {
  constructor(expression, expressionList, not) {
    super(
      "SubsetofExpression"
      /* SubsetofExpression */
    );
    __publicField(this, "expression");
    __publicField(this, "expressionList");
    __publicField(this, "not");
    expression.parent = this;
    expressionList.parent = this;
    this.expression = expression;
    this.expressionList = expressionList;
    this.not = not;
  }
  deepClone() {
    return new SubsetofExpression(this.expression.deepClone(), this.expressionList.deepClone(), this.not);
  }
}
class ConditionGroup extends Predicate {
  constructor(condition) {
    super(
      "ConditionGroup"
      /* ConditionGroup */
    );
    __publicField(this, "condition");
    condition.parent = this;
    this.condition = condition;
  }
  deepClone() {
    return new ConditionGroup(this.condition.deepClone());
  }
}
class LogicalExpression extends GrammarRule {
  constructor(left, right, logicalOperator) {
    super(
      "logicalExpression"
      /* logicalExpression */
    );
    __publicField(this, "left");
    __publicField(this, "right");
    __publicField(this, "logicalOperator");
    left.parent = this;
    if (right) {
      right.parent = this;
    }
    this.left = left;
    this.right = right;
    this.logicalOperator = logicalOperator;
  }
  deepClone() {
    var _a3;
    return new LogicalExpression(this.left.deepClone(), (_a3 = this.right) == null ? void 0 : _a3.deepClone(), this.logicalOperator);
  }
  //当需要添加移除一个logic 时作为一个整体进行处理，但是可以根据实际情况调整相关类。
}
class VantisConditionVisitor {
  visitComparisonExpression(ctx) {
    const contexts = ctx.expression();
    const left = this.visitExpression(contexts[0]);
    const right = this.visitExpression(contexts[1]);
    const op2 = ctx.comparisonOperator().getText();
    return new ComparisonExpression(left, right, op2);
  }
  visitCondationGroup(ctx) {
    const conditionContext = ctx.condition();
    const condition = this.visitCondition(conditionContext);
    return new ConditionGroup(condition);
  }
  visitCondition(ctx) {
    const conditionAndContexts = ctx.conditionAnd();
    let conditionAnd;
    const conditionAnds = [];
    conditionAndContexts.forEach((conditionAndContext) => {
      conditionAnd = this.visitConditionAnd(conditionAndContext);
      conditionAnds.push(conditionAnd);
    });
    return this.createLogicExpression(conditionAnds, "||");
  }
  createLogicExpression(grammarRules, logicalOperator) {
    if (grammarRules.length == 1) {
      return new LogicalExpression(grammarRules[0], void 0, void 0);
    } else {
      let logicalExpression = new LogicalExpression(grammarRules[0], grammarRules[1], logicalOperator);
      for (let i2 = 2; i2 < grammarRules.length; i2++) {
        logicalExpression = new LogicalExpression(logicalExpression, grammarRules[i2], logicalOperator);
      }
      return logicalExpression;
    }
  }
  visitConditionAnd(ctx) {
    const logicalNegationContexts = ctx.logicalNegation();
    let logicalNegation;
    const logicalNegations = [];
    logicalNegationContexts.forEach((logicalNegationContext) => {
      logicalNegation = this.visitLogicalNegation(logicalNegationContext);
      logicalNegations.push(logicalNegation);
    });
    return this.createLogicExpression(logicalNegations, "&&");
  }
  visitConstantExpression(ctx) {
    const stringContext = ctx.stringExpression();
    if (stringContext != void 0) {
      return this.visitStringExpression(stringContext);
    }
    const numericContext = ctx.numericExpression();
    if (numericContext != void 0) {
      return this.visitNumericExpression(numericContext);
    }
    const nullContext = ctx.nullExpression();
    if (nullContext != void 0) {
      return this.visitNullExpression(nullContext);
    }
    const falseContext = ctx.falseExpression();
    if (falseContext != void 0) {
      return this.visitFalseExpression(falseContext);
    }
    const trueContext = ctx.trueExpression();
    if (trueContext != void 0) {
      return this.visitTrueExpression(trueContext);
    }
    return new NullExpression();
  }
  visitCustomField(ctx) {
    throw new Error("customfield不支持");
  }
  visitExpression(ctx) {
    const runtimeValueContext = ctx.runtimeValue();
    if (runtimeValueContext != void 0) {
      return this.visitRuntimeValue(runtimeValueContext);
    }
    const constantExpressionContext = ctx.constantExpression();
    if (constantExpressionContext != void 0) {
      return this.visitConstantExpression(constantExpressionContext);
    }
    const customContext = ctx.customField();
    if (customContext != void 0) {
      return this.visitCustomField(customContext);
    }
    throw new Error("");
  }
  visitExpressionList(ctx) {
    const expressionContexts = ctx.expression();
    const expressions = [];
    const expressionValue = new RuntimeValue([""]);
    expressionValue.name = [];
    expressionValue.names = [];
    expressionContexts.forEach((expressionContext) => {
      const expression = this.visitExpression(expressionContext);
      if (expression.ruleName != GrammarRuleNames.RuntimeValue) {
        const val = expression.value.toString();
        expressionValue.name.push(val);
        expressionValue.names.push(val);
      }
    });
    expressions.push(expressionValue);
    return new ExpressionList(expressions);
  }
  visitFalseExpression(ctx) {
    return new BooleanExpression(false);
  }
  visitInExpression(ctx) {
    const expressionContext = ctx.expression();
    const expressionListContext = ctx.expressionList();
    const expression = this.visitExpression(expressionContext);
    const expressionList = this.visitExpressionList(expressionListContext);
    const not = ctx.NOT() != void 0;
    return new InExpression(expression, expressionList, not);
  }
  visitContainsExpression(ctx) {
    const expressionContext = ctx.expression();
    const expressionListContext = ctx.expressionList();
    const expression = this.visitExpression(expressionContext);
    const expressionList = this.visitExpressionList(expressionListContext);
    const not = ctx.NOT() != void 0;
    return new ContainsExpression(expression, expressionList, not);
  }
  visitSubsetofExpression(ctx) {
    const expressionContext = ctx.expression();
    const expressionListContext = ctx.expressionList();
    const expression = this.visitExpression(expressionContext);
    const expressionList = this.visitExpressionList(expressionListContext);
    const not = ctx.NOT() != void 0;
    return new SubsetofExpression(expression, expressionList, not);
  }
  visitLogicalNegation(ctx) {
    const predicateContext = ctx.predicate();
    const not = false;
    const predicate = this.visitPredicate(predicateContext);
    return new LogicalNegation(predicate, not);
  }
  visitNullExpression(ctx) {
    return new NullExpression();
  }
  visitNumericExpression(ctx) {
    const numericString = ctx.getText();
    const numeric = Number(numericString);
    return new NumericExpression(numeric);
  }
  visitPredicate(ctx) {
    const comparisonExpressionContext = ctx.comparisonExpression();
    if (comparisonExpressionContext != void 0) {
      return this.visitComparisonExpression(comparisonExpressionContext);
    }
    const inExpressionContext = ctx.inExpression();
    if (inExpressionContext != void 0) {
      return this.visitInExpression(inExpressionContext);
    }
    const conditionGroupContext = ctx.condationGroup();
    if (conditionGroupContext != void 0) {
      return this.visitCondationGroup(conditionGroupContext);
    }
    const falseExpressionContext = ctx.falseExpression();
    if (falseExpressionContext != void 0) {
      return this.visitFalseExpression(falseExpressionContext);
    }
    const trueExpressionContext = ctx.trueExpression();
    if (trueExpressionContext != void 0) {
      return this.visitTrueExpression(trueExpressionContext);
    }
    const subsetofExpressionContext = ctx.subsetofExpression();
    if (subsetofExpressionContext != void 0) {
      return this.visitSubsetofExpression(subsetofExpressionContext);
    }
    const containsExpressionContext = ctx.containsExpression();
    if (containsExpressionContext != void 0) {
      return this.visitContainsExpression(containsExpressionContext);
    }
    return new BooleanExpression(true);
  }
  visitRuntimeValue(ctx) {
    const ids = ctx.ID();
    const names = [];
    ids.forEach((id2) => names.push(id2.getText()));
    return new RuntimeValue(names);
  }
  visitStringExpression(ctx) {
    const temp = ctx.getText();
    if (temp.startsWith('"') && temp.endsWith('"')) {
      return new StringExpression(temp.substring(1, temp.length - 1));
    }
    return new StringExpression(temp);
  }
  visitTrueExpression(ctx) {
    return new BooleanExpression(true);
  }
}
const tryGetBinaryOperatorLeft = (grammarRule) => {
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      return grammarRule.left;
    case GrammarRuleNames.InExpression:
      return grammarRule.expression;
    case GrammarRuleNames.SubsetofExpression:
      return grammarRule.expression;
    case GrammarRuleNames.ContainsExpression:
      return grammarRule.expression;
  }
  return void 0;
};
const getInferTypeByGrammarRule = (grammarRule, conditionOptions) => {
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.BooleanExpression:
      return InferType.Bool;
    case GrammarRuleNames.StringExpression:
      return InferType.String;
    case GrammarRuleNames.NumericExpression:
      return InferType.Number;
    case GrammarRuleNames.NullExpression:
      return InferType.Object;
    case GrammarRuleNames.RuntimeValue:
      const names = grammarRule.names;
      if (names.length == 0) {
        return InferType.String;
      }
      const widgetSchema = getWidgetSchema(names, conditionOptions);
      return getInferTypeByWidget(widgetSchema);
  }
  return void 0;
};
const getBinaryOperatorsByLeft = (grammarRule, t2, conditionOptions) => {
  let left = tryGetBinaryOperatorLeft(grammarRule);
  if (!left) {
    return void 0;
  }
  const leftInferType = getInferTypeByGrammarRule(left, conditionOptions);
  if (leftInferType == InferType.Bool) {
    return [
      { Name: t2("Process.Equal To"), Value: "==" },
      { Name: t2("Process.Not equal To"), Value: "!=" }
    ];
  }
  if (leftInferType == InferType.Object || leftInferType == InferType.String || leftInferType == InferType.Datetime) {
    return [
      { Name: t2("Process.Equal To"), Value: "==" },
      { Name: t2("Process.Not equal To"), Value: "!=" },
      { Name: t2("Process.In"), Value: "in" },
      { Name: t2("Process.NotIn"), Value: "not in" }
    ];
  }
  if (leftInferType == InferType.Int || leftInferType == InferType.Number) {
    return [
      { Name: t2("Process.Equal To"), Value: "==" },
      { Name: t2("Process.Not equal To"), Value: "!=" },
      { Name: t2("Process.Greater than"), Value: ">" },
      { Name: t2("Process.Greater than or equal"), Value: ">=" },
      { Name: t2("Process.Less than"), Value: "<" },
      { Name: t2("Process.Less than or equal"), Value: "<=" },
      { Name: t2("Process.In"), Value: "in" },
      { Name: t2("Process.NotIn"), Value: "not in" }
    ];
  }
  if (leftInferType == InferType.NumberArray || leftInferType == InferType.ObjectArray || leftInferType == InferType.StringArray) {
    return [
      { Name: t2("Process.Equal To"), Value: "==" },
      { Name: t2("Process.Not equal To"), Value: "!=" },
      { Name: t2("Process.Contains"), Value: "contains" },
      { Name: t2("Process.NotContains"), Value: "not contains" },
      { Name: t2("Process.Subsetof"), Value: "subsetof" },
      { Name: t2("Process.NotSubsetof"), Value: "not subsetof" }
    ];
  }
};
const getBinaryOperatorDisplayText = (operator, t2) => {
  switch (operator) {
    case "==":
      return t2("Process.Equal To");
    case "!=":
      return t2("Process.Not equal To");
    case ">":
      return t2("Process.Greater than");
    case ">=":
      return t2("Process.Greater than or equal");
    case "<":
      return t2("Process.Less than");
    case "<=":
      return t2("Process.Less than or equal");
    case "in":
      return t2("Process.In");
    case "not in":
      return t2("Process.NotIn");
    case "contains":
      return t2("Process.Contains");
    case "not contains":
      return t2("Process.NotContains");
    case "subsetof":
      return t2("Process.Subsetof");
    case "not subsetof":
      return t2("Process.NotSubsetof");
  }
  return operator;
};
const getLogicOperatorDisplayText = (operator, t2) => {
  switch (operator) {
    case "&&":
      return t2("And");
    case "||":
      return t2("Or");
  }
  return operator;
};
const changeBinaryOperator = (grammarRule, operator, conditionOptions, rulesRef) => {
  let newGrammarRule;
  const parent = grammarRule.parent;
  if (operator === "in" || operator == "not in") {
    if (grammarRule.ruleName == GrammarRuleNames.InExpression) {
      grammarRule.not = operator == "not in";
      return;
    }
    newGrammarRule = crateNewInExpressionFromBinaryExpression(grammarRule, operator);
  } else if (operator === "contains" || operator == "not contains") {
    if (grammarRule.ruleName == GrammarRuleNames.ContainsExpression) {
      grammarRule.not = operator == "not contains";
      return;
    }
    newGrammarRule = crateNewContainsExpression(grammarRule, operator);
  } else if (operator == "subsetof" || operator == "not subsetof") {
    if (grammarRule.ruleName == GrammarRuleNames.SubsetofExpression) {
      grammarRule.not = operator == "not subsetof";
      return;
    }
    newGrammarRule = createNewSubsetOfExpression(grammarRule, operator);
  } else {
    if (grammarRule.ruleName == GrammarRuleNames.ComparisonExpression) {
      grammarRule.comparisonOperator = operator;
      return;
    }
    newGrammarRule = createNewComparisonExpression(grammarRule, operator, conditionOptions);
  }
  replaceSelfFromParentOrContainer(grammarRule, newGrammarRule, parent, rulesRef);
};
const changeRuntimeValue = (runtimeValue, conditionOptions) => {
  if (runtimeValue.parent === void 0) {
    return;
  }
  const parent = runtimeValue.parent;
  const widgetSchema = getWidgetSchema(runtimeValue.names, conditionOptions);
  const inferType = getInferTypeByWidget(widgetSchema);
  switch (parent.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      const rightExpression = createConstantExpressionByInferType(inferType, void 0);
      rightExpression.parent = parent;
      parent.right = rightExpression;
      break;
    case GrammarRuleNames.ContainsExpression:
      const expressionList = new ExpressionList([]);
      expressionList.parent = parent;
      parent.expressionList = expressionList;
      break;
    case GrammarRuleNames.SubsetofExpression:
      const set = new ExpressionList([]);
      set.parent = parent;
      parent.expressionList = set;
      break;
    case GrammarRuleNames.InExpression:
      const collection = new ExpressionList([]);
      collection.parent = parent;
      parent.expressionList = collection;
      break;
  }
};
const createNewSubsetOfExpression = (grammarRule, operator) => {
  const not = operator == "not subsetof";
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      let right = grammarRule.right;
      right = right.ruleName == GrammarRuleNames.ExpressionList ? right : new ExpressionList([]);
      return new SubsetofExpression(grammarRule.left, right, not);
    case GrammarRuleNames.ContainsExpression:
      return new SubsetofExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.SubsetofExpression:
      return new SubsetofExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.InExpression:
      return new SubsetofExpression(grammarRule.expression, grammarRule.expressionList, not);
  }
  throw new Error("not support");
};
const crateNewInExpressionFromBinaryExpression = (grammarRule, operator) => {
  const not = operator == "not in";
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      let right = grammarRule.right;
      right = right.ruleName == GrammarRuleNames.ExpressionList ? right : new ExpressionList([]);
      return new InExpression(grammarRule.left, right, not);
    case GrammarRuleNames.ContainsExpression:
      return new InExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.SubsetofExpression:
      return new InExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.InExpression:
      return new InExpression(grammarRule.expression, grammarRule.expressionList, not);
  }
  throw new Error("not support");
};
const crateNewContainsExpression = (grammarRule, operator) => {
  const not = operator == "not contains";
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      let right = grammarRule.right;
      right = right.ruleName == GrammarRuleNames.ExpressionList ? right : new ExpressionList([]);
      return new ContainsExpression(grammarRule.left, right, not);
    case GrammarRuleNames.ContainsExpression:
      return new ContainsExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.SubsetofExpression:
      return new ContainsExpression(grammarRule.expression, grammarRule.expressionList, not);
    case GrammarRuleNames.InExpression:
      return new ContainsExpression(grammarRule.expression, grammarRule.expressionList, not);
  }
  throw new Error("not support");
};
const getOperatorNameByGrammarRule = (grammarRule) => {
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      return grammarRule.comparisonOperator;
    case GrammarRuleNames.SubsetofExpression:
      return grammarRule.not ? "not subsetof" : "subsetof";
    case GrammarRuleNames.InExpression:
      return grammarRule.not ? "not in" : "in";
    case GrammarRuleNames.ContainsExpression:
      return grammarRule.not ? "not contains" : "contains";
  }
  return "";
};
const createDefaultGrammarRule = (grammarRule, conditionOptions) => {
  const inferType = getInferTypeByGrammarRule(grammarRule, conditionOptions);
  return createConstantExpressionByInferType(inferType, void 0);
};
const createConstantExpressionByInferType = (inferType, value) => {
  switch (inferType) {
    case InferType.Int:
    case InferType.Number:
      return new NumericExpression(value == void 0 ? 0 : value);
    case InferType.Bool:
      return new BooleanExpression(value == void 0 ? false : value);
    case InferType.String:
    case InferType.Datetime:
      return new StringExpression(value == void 0 ? "" : value);
    case InferType.StringArray:
    case InferType.NumberArray:
    case InferType.ObjectArray:
      return new ExpressionList(value == void 0 ? [] : value);
  }
  return new StringExpression(value == void 0 ? "" : value);
};
const createNewComparisonExpression = (grammarRule, operator, conditionOptions) => {
  const createNew = (expression, expressionList) => {
    if (expression.ruleName == GrammarRuleNames.RuntimeValue) {
      const inferType = getInferTypeByGrammarRule(expression, conditionOptions);
      if (inferType == InferType.ObjectArray || inferType == InferType.StringArray || inferType == InferType.NumberArray) {
        return new ComparisonExpression(expression, expressionList, operator);
      }
    }
    const children = expressionList.children;
    const right = children.length > 0 ? children[0] : createDefaultGrammarRule(expression, conditionOptions);
    return new ComparisonExpression(expression, right, operator);
  };
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      return new ComparisonExpression(grammarRule.left, grammarRule.right, operator);
    case GrammarRuleNames.ContainsExpression:
      return createNew(grammarRule.expression, grammarRule.expressionList);
    case GrammarRuleNames.SubsetofExpression:
      return createNew(grammarRule.expression, grammarRule.expressionList);
    case GrammarRuleNames.InExpression:
      return createNew(grammarRule.expression, grammarRule.expressionList);
  }
  throw new Error("not support");
};
const replaceSelfFromParentOrContainer = (rule, newRule, parent, rulesRef) => {
  var _a3;
  if (!parent) {
    rulesRef.value = newRule;
    return;
  }
  switch (parent.ruleName) {
    case GrammarRuleNames.ExpressionList:
      const index2 = parent.children.findIndex((e10) => e10.id == rule.id);
      if (index2 > -1) {
        newRule.parent = parent;
        parent.children[index2] = newRule;
      }
      break;
    case GrammarRuleNames.logicalExpression:
      {
        const logicalExpression = parent;
        if (logicalExpression.left.id == rule.id) {
          newRule.parent = parent;
          logicalExpression.left = newRule;
        }
        if (((_a3 = logicalExpression.right) == null ? void 0 : _a3.id) == rule.id) {
          newRule.parent = parent;
          logicalExpression.right = newRule;
        }
      }
      break;
    case GrammarRuleNames.ConditionGroup:
      newRule.parent = parent;
      parent.condition = newRule;
      break;
    case GrammarRuleNames.LogicalNegation:
      newRule.parent = parent;
      parent.predicate = newRule;
      break;
    case GrammarRuleNames.ContainsExpression:
    case GrammarRuleNames.ComparisonExpression:
    case GrammarRuleNames.InExpression:
    case GrammarRuleNames.SubsetofExpression:
      throw new Error("not implemented");
    default:
      throw new Error("not implemented");
  }
};
const removeSelfFromParentOrContainer = (rule, rulesRef) => {
  if (rule.isRoot()) {
    rulesRef.value = void 0;
    return;
  }
  const parent = rule.parent;
  switch (parent.ruleName) {
    case GrammarRuleNames.ExpressionList:
      parent.removeChildren(rule);
      break;
    case GrammarRuleNames.logicalExpression:
      {
        const logicalExpression = parent;
        if (logicalExpression.left.id == rule.id) {
          if (!logicalExpression.right) {
            removeSelfFromParentOrContainer(parent, rulesRef);
            break;
          }
          logicalExpression.left = logicalExpression.right;
        }
        logicalExpression.logicalOperator = void 0;
        logicalExpression.right = void 0;
      }
      break;
    case GrammarRuleNames.LogicalNegation:
    case GrammarRuleNames.ConditionGroup:
    case GrammarRuleNames.ContainsExpression:
    case GrammarRuleNames.ComparisonExpression:
    case GrammarRuleNames.InExpression:
    case GrammarRuleNames.SubsetofExpression:
      removeSelfFromParentOrContainer(parent, rulesRef);
      break;
  }
};
const tryGetLeftRuntimeValueExpression = (expression) => {
  let parent = expression.parent;
  if (!parent) {
    return void 0;
  }
  if (parent.ruleName == GrammarRuleNames.ExpressionList) {
    return void 0;
  }
  let left = void 0;
  switch (parent.ruleName) {
    case GrammarRuleNames.ContainsExpression:
      if (parent.expressionList.id == expression.id) {
        left = parent.expression;
      }
      break;
    case GrammarRuleNames.ComparisonExpression:
      if (parent.right.id == expression.id) {
        left = parent.left;
      }
      break;
    case GrammarRuleNames.InExpression:
      if (parent.expressionList.id == expression.id) {
        left = parent.expression;
      }
      break;
    case GrammarRuleNames.SubsetofExpression:
      if (parent.expressionList.id == expression.id) {
        left = parent.expression;
      }
      break;
  }
  if ((left == null ? void 0 : left.ruleName) == GrammarRuleNames.RuntimeValue) {
    return left;
  }
  return void 0;
};
const getWidgetSchema = (names, conditionOptions) => {
  let options;
  for (let i2 = 0; i2 < names.length; i2++) {
    options = conditionOptions == null ? void 0 : conditionOptions.find((o2) => o2.value == names[i2]);
    if (options) {
      conditionOptions = options.children;
    }
  }
  return options == null ? void 0 : options.widgetSchema;
};
const getConditionOptionDisplay = (names, t2, conditionOptions) => {
  let labels = [];
  let options;
  for (let i2 = 0; i2 < names.length; i2++) {
    options = conditionOptions == null ? void 0 : conditionOptions.find((o2) => o2.value == names[i2]);
    if (options) {
      labels.push(t2(options.label));
      conditionOptions = options.children;
    }
  }
  if (!(options == null ? void 0 : options.widgetSchema)) {
    return t2("Undefined");
  }
  return labels.join(".");
};
const tryGetWidgetSchemaByBinaryRightExpression = (conditionOptions, expression) => {
  const left = tryGetLeftRuntimeValueExpression(expression);
  if (!left) {
    return void 0;
  }
  return getWidgetSchema(left.names, conditionOptions);
};
const getConstantExpressionValue = (constantExpression) => {
  switch (constantExpression.ruleName) {
    case GrammarRuleNames.StringExpression:
      return constantExpression.value;
    case GrammarRuleNames.BooleanExpression:
      return constantExpression.value;
    case GrammarRuleNames.NumericExpression:
      return constantExpression.value;
    default:
      return null;
  }
};
const setConstantExpressionValue = (constantExpression, value) => {
  switch (constantExpression.ruleName) {
    case GrammarRuleNames.StringExpression:
      constantExpression.value = value;
      break;
    case GrammarRuleNames.BooleanExpression:
      constantExpression.value = value;
      break;
    case GrammarRuleNames.NumericExpression:
      constantExpression.value = value;
      break;
    default:
      throw new Error(`not implemented`);
  }
};
const getExpressionListValue = (expressionList) => {
  if (expressionList.children.length == 0) {
    return [];
  }
  return expressionList.children.map((e10) => {
    return getConstantExpressionValue(e10);
  });
};
const getAncestorLogicExpression = (grammarRule) => {
  let rule = grammarRule;
  while (rule != void 0 && rule.ruleName != GrammarRuleNames.logicalExpression) {
    rule = rule.parent;
  }
  return rule;
};
const getRoot = (grammarRule) => {
  let root2 = grammarRule;
  while (root2.parent) {
    root2 = root2.parent;
  }
  return root2;
};
const getLeftExpressionFromBinaryExpression = (grammarRule) => {
  switch (grammarRule.ruleName) {
    case GrammarRuleNames.ComparisonExpression:
      return grammarRule.left;
    case GrammarRuleNames.ContainsExpression:
      return grammarRule.expression;
    case GrammarRuleNames.InExpression:
      return grammarRule.expression;
    case GrammarRuleNames.SubsetofExpression:
      return grammarRule.expression;
  }
  return void 0;
};
class GrammarRuleVisitorForDisplay {
  constructor(conditionOptions, t2) {
    __publicField(this, "conditionOptions");
    __publicField(this, "t");
    this.conditionOptions = conditionOptions;
    this.t = t2;
  }
  async visitGrammarRule(grammarRule) {
    if (grammarRule == void 0)
      return void 0;
    if (grammarRule.ruleName == void 0)
      return void 0;
    switch (grammarRule.ruleName) {
      case GrammarRuleNames.ConditionGroup:
        return this.visitConditionGroup(grammarRule);
      case GrammarRuleNames.BooleanExpression:
        return this.visitBooleanExpression(grammarRule);
      case GrammarRuleNames.ComparisonExpression:
        return this.visitComparisonExpression(grammarRule);
      case GrammarRuleNames.CustomField:
        throw new Error("not support");
      case GrammarRuleNames.ExpressionList:
        return this.visitExpressionList(grammarRule);
      case GrammarRuleNames.InExpression:
        return this.visitInExpression(grammarRule);
      case GrammarRuleNames.ContainsExpression:
        return this.visitContainsExpression(grammarRule);
      case GrammarRuleNames.SubsetofExpression:
        return this.visitSubsetofExpression(grammarRule);
      case GrammarRuleNames.logicalExpression:
        return this.visitLogicalExpression(grammarRule);
      case GrammarRuleNames.LogicalNegation:
        return this.visitLogicalNegation(grammarRule);
      case GrammarRuleNames.RuntimeValue:
        return this.visitRuntimeValue(grammarRule);
      case GrammarRuleNames.NullExpression:
      case GrammarRuleNames.NumericExpression:
      case GrammarRuleNames.StringExpression:
        return this.visitConstantExpression(grammarRule);
    }
  }
  async visitLogicalNegation(logicalNegation) {
    const predicate = await this.visitGrammarRule(logicalNegation.predicate);
    const hasParentheses = logicalNegation.predicate.ruleName != GrammarRuleNames.BooleanExpression && logicalNegation.predicate.ruleName != GrammarRuleNames.RuntimeValue && logicalNegation.predicate.ruleName != GrammarRuleNames.ConditionGroup;
    return logicalNegation.not ? `!${hasParentheses ? "(" : ""}${predicate}${hasParentheses ? ")" : ""}` : predicate;
  }
  async visitBinaryExpression(left, right, operator) {
    const leftDisplayString = await this.visitGrammarRule(left);
    if (leftDisplayString === void 0) {
      return void 0;
    }
    const rightDisplayString = await this.visitGrammarRule(right);
    if (rightDisplayString === void 0) {
      return void 0;
    }
    return `${leftDisplayString} ${getBinaryOperatorDisplayText(operator, this.t)} ${rightDisplayString}`;
  }
  visitComparisonExpression(comparisonExpression) {
    return this.visitBinaryExpression(comparisonExpression.left, comparisonExpression.right, comparisonExpression.comparisonOperator);
  }
  visitRuntimeValue(runtimeValue) {
    if (runtimeValue.names.length == 0) {
      return Promise.resolve(void 0);
    }
    const display = getConditionOptionDisplay(runtimeValue.names, this.t, this.conditionOptions);
    return Promise.resolve(display);
  }
  async visitConditionGroup(conditionGroup) {
    const display = await this.visitLogicalExpression(conditionGroup.condition);
    if (display === void 0) {
      return void 0;
    }
    return `( ${display} )`;
  }
  async visitLogicalExpression(logicalExpression) {
    const leftDisplay = await this.visitGrammarRule(logicalExpression.left);
    if (leftDisplay == void 0) {
      return void 0;
    }
    const rightDisplay = logicalExpression.right ? await this.visitGrammarRule(logicalExpression.right) : void 0;
    if (rightDisplay == null) {
      return leftDisplay;
    }
    const logicOperator = logicalExpression.logicalOperator ? getLogicOperatorDisplayText(logicalExpression.logicalOperator, this.t) : "";
    return `${leftDisplay} ${logicOperator} ${rightDisplay}`;
  }
  async visitConstantExpression(constantExpression) {
    var _a3, _b3, _c3;
    const fieldSchema = tryGetWidgetSchemaByBinaryRightExpression(this.conditionOptions, constantExpression);
    let value = (_a3 = getConstantExpressionValue(constantExpression)) == null ? void 0 : _a3.toString();
    if (fieldSchema && value) {
      if ((_b3 = fieldSchema.__config__) == null ? void 0 : _b3.dataSource) {
        const data = await dataSourceManager.getData(fieldSchema.__config__.dataSource);
        return (_c3 = data.find((item) => item.value == value)) == null ? void 0 : _c3.label;
      }
    }
    if (constantExpression.ruleName == GrammarRuleNames.StringExpression) {
      if (!(value == null ? void 0 : value.endsWith('"'))) {
        value = value + '"';
      }
      if (!(value == null ? void 0 : value.startsWith('"'))) {
        value = '"' + value;
      }
    }
    return value || "null";
  }
  visitBooleanExpression(booleanExpression) {
    const fieldSchema = tryGetWidgetSchemaByBinaryRightExpression(this.conditionOptions, booleanExpression);
    if (fieldSchema) {
      return booleanExpression.value ? fieldSchema.activeText || this.t("True") : fieldSchema.inactiveText || this.t("False");
    }
    return booleanExpression.value ? this.t("True") : this.t("False");
  }
  async visitExpressionList(expressionList) {
    var _a3;
    const values = getExpressionListValue(expressionList);
    if (!values || values.length == 0) {
      return "[]";
    }
    const fieldSchema = tryGetWidgetSchemaByBinaryRightExpression(this.conditionOptions, expressionList);
    if (fieldSchema && ((_a3 = fieldSchema.__config__) == null ? void 0 : _a3.dataSource)) {
      const data = await dataSourceManager.getData(fieldSchema.__config__.dataSource);
      return "[ " + data.filter((item) => values.includes(item.value)).map((item) => item.label).join(",") + " ]";
    }
    if (expressionList.children[0].ruleName == GrammarRuleNames.StringExpression) {
      return '["' + values.join('","') + '"]';
    }
    return "[" + values.join(",") + "]";
  }
  visitInExpression(inExpression) {
    const operator = inExpression.not ? "not in" : "in";
    return this.visitBinaryExpression(inExpression.expression, inExpression.expressionList, operator);
  }
  visitContainsExpression(containsExpression) {
    const operator = containsExpression.not ? "not contains" : "contains";
    return this.visitBinaryExpression(containsExpression.expression, containsExpression.expressionList, operator);
  }
  visitSubsetofExpression(subsetOfExpression) {
    const operator = subsetOfExpression.not ? "not subsetof" : "subsetof";
    return this.visitBinaryExpression(subsetOfExpression.expression, subsetOfExpression.expressionList, operator);
  }
}
class GrammarRuleVisitorForValue {
  visitGrammarRule(grammarRule) {
    if (grammarRule == void 0)
      return void 0;
    if (grammarRule.ruleName == void 0)
      return void 0;
    switch (grammarRule.ruleName) {
      case GrammarRuleNames.ConditionGroup:
        return this.visitConditionGroup(grammarRule);
      case GrammarRuleNames.BooleanExpression:
        return this.visitBooleanExpression(grammarRule);
      case GrammarRuleNames.ComparisonExpression:
        return this.visitComparisonExpression(grammarRule);
      case GrammarRuleNames.CustomField:
        throw new Error("not support");
      case GrammarRuleNames.ExpressionList:
        return this.visitExpressionList(grammarRule);
      case GrammarRuleNames.InExpression:
        return this.visitInExpression(grammarRule);
      case GrammarRuleNames.ContainsExpression:
        return this.visitContainsExpression(grammarRule);
      case GrammarRuleNames.SubsetofExpression:
        return this.visitSubsetofExpression(grammarRule);
      case GrammarRuleNames.logicalExpression:
        return this.visitLogicalExpression(grammarRule);
      case GrammarRuleNames.LogicalNegation:
        return this.visitLogicalNegation(grammarRule);
      case GrammarRuleNames.RuntimeValue:
        return this.visitRuntimeValue(grammarRule);
      case GrammarRuleNames.NullExpression:
        return this.visitNullExpression(grammarRule);
      case GrammarRuleNames.NumericExpression:
        return this.visitNumericExpression(grammarRule);
      case GrammarRuleNames.StringExpression:
        return this.visitStringExpression(grammarRule);
    }
  }
  visitConditionGroup(conditionGroup) {
    const condition = this.visitLogicalExpression(conditionGroup.condition);
    if (condition === void 0) {
      return void 0;
    }
    return `(${condition})`;
  }
  visitLogicalExpression(logicalExpression) {
    const left = this.visitGrammarRule(logicalExpression.left);
    if (left === void 0) {
      return void 0;
    }
    if (!logicalExpression.right) {
      return left;
    }
    const right = this.visitGrammarRule(logicalExpression.right);
    return `${left}${right ? ` ${logicalExpression.logicalOperator} ${right}` : ""}`;
  }
  visitBooleanExpression(booleanExpression) {
    return booleanExpression.value ? "true" : "false";
  }
  visitBinaryExpression(left, right, operator) {
    const leftValue = this.visitGrammarRule(left);
    const rightValue = this.visitGrammarRule(right);
    if (leftValue === void 0 || rightValue === void 0) {
      return void 0;
    }
    return `${leftValue} ${operator} ${rightValue}`;
  }
  visitComparisonExpression(comparisonExpression) {
    return this.visitBinaryExpression(comparisonExpression.left, comparisonExpression.right, comparisonExpression.comparisonOperator);
  }
  visitExpressionList(expressionList) {
    const value = getExpressionListValue(expressionList);
    if (!value || value.length == 0) {
      return "()";
    }
    if (expressionList.children[0].ruleName == GrammarRuleNames.StringExpression) {
      return `("${value.join('","')}")`;
    }
    return `(${value.join(",")})`;
  }
  visitInExpression(inExpression) {
    const operator = inExpression.not ? "not in" : "in";
    return this.visitBinaryExpression(inExpression.expression, inExpression.expressionList, operator);
  }
  visitContainsExpression(containsExpression) {
    const operator = containsExpression.not ? "not contains" : "contains";
    return this.visitBinaryExpression(containsExpression.expression, containsExpression.expressionList, operator);
  }
  visitSubsetofExpression(subsetOfExpression) {
    const operator = subsetOfExpression.not ? "not subsetof" : "subsetof";
    return this.visitBinaryExpression(subsetOfExpression.expression, subsetOfExpression.expressionList, operator);
  }
  visitRuntimeValue(runtimeValue) {
    if (runtimeValue.names.length == 0) {
      return void 0;
    }
    return runtimeValue.names.join(".");
  }
  visitNullExpression(nullExpression) {
    return "null";
  }
  visitNumericExpression(numericExpression) {
    return numericExpression.value.toString();
  }
  visitStringExpression(stringExpression) {
    return `"${stringExpression.value}"`;
  }
  visitLogicalNegation(logicalNegation) {
    const predicate = this.visitGrammarRule(logicalNegation.predicate);
    if (predicate === void 0) {
      return void 0;
    }
    const hasParentheses = logicalNegation.predicate.ruleName != GrammarRuleNames.BooleanExpression && logicalNegation.predicate.ruleName != GrammarRuleNames.RuntimeValue && logicalNegation.predicate.ruleName != GrammarRuleNames.ConditionGroup;
    return logicalNegation.not ? `!${hasParentheses ? "(" : ""}${predicate}${hasParentheses ? ")" : ""}` : predicate;
  }
}
const getGrammarRule = (condition) => {
  if (isNullOrUndefinedOrWhiteSpace(condition)) {
    return void 0;
  }
  let inputStream = CharStream.fromString(condition);
  let lexer = new ConditionLexer(inputStream);
  let tokenStream = new CommonTokenStream(lexer);
  let parser = new ConditionParser(tokenStream);
  parser.addErrorListener(new VantisErrorListener());
  const conditionContext = parser.condition();
  const visitor = new VantisConditionVisitor();
  return visitor.visitCondition(conditionContext);
};
const getFriendlyConditionString = async (condition, conditionOptions, t2) => {
  if (isNullOrUndefinedOrWhiteSpace(condition)) {
    return void 0;
  }
  const grammarRule = getGrammarRule(condition);
  const visitor = new GrammarRuleVisitorForDisplay(conditionOptions, t2);
  return await visitor.visitGrammarRule(grammarRule);
};
const getFriendlyConditionStringByRule = async (grammarRule, formSchema, t2) => {
  const visitor = new GrammarRuleVisitorForDisplay(formSchema, t2);
  return await visitor.visitGrammarRule(grammarRule);
};
const getConditionStringByRule = (grammarRule) => {
  const visitor = new GrammarRuleVisitorForValue();
  return visitor.visitGrammarRule(grammarRule);
};
const getRouteFriendlyString = (processRouteDefinition, conditionOptions, t2) => {
  var _a3;
  const routeCondition = (_a3 = processRouteDefinition.routePolicyDescriptor.settings) == null ? void 0 : _a3.routeCondition;
  return getFriendlyConditionString(routeCondition, conditionOptions, t2);
};
var RoutePolicyDescriptorCodes = /* @__PURE__ */ ((RoutePolicyDescriptorCodes2) => {
  RoutePolicyDescriptorCodes2["AlwaysTrue"] = "AwaysTrue";
  RoutePolicyDescriptorCodes2["Standard"] = "Standard";
  RoutePolicyDescriptorCodes2["Countersign"] = "All";
  RoutePolicyDescriptorCodes2["OrSign"] = "Any";
  RoutePolicyDescriptorCodes2["FixedQuorumDecision"] = "FixedQuorumDecision";
  RoutePolicyDescriptorCodes2["ProportionalVoting"] = "ProportionalVoting";
  return RoutePolicyDescriptorCodes2;
})(RoutePolicyDescriptorCodes || {});
const alwaysTrue$1 = {
  componentCode: "AwaysTrue",
  settings: void 0
};
const createDefaultRoutePolicyDescriptor = (policyDescriptorCode) => {
  switch (policyDescriptorCode) {
    case "All":
      return {
        componentCode: "All",
        settings: {
          routeCondition: ""
        }
      };
    case "Any":
      return {
        componentCode: "Any",
        settings: {
          routeCondition: ""
        }
      };
    case "FixedQuorumDecision":
      return {
        componentCode: "FixedQuorumDecision",
        settings: {
          routeCondition: "",
          quorumThreshold: 1
        }
      };
    case "ProportionalVoting":
      return {
        componentCode: "ProportionalVoting",
        settings: {
          routeCondition: "",
          percentage: 0.6
        }
      };
    case "Standard":
      return {
        componentCode: "Standard",
        settings: {
          routeCondition: ""
        }
      };
    case "AwaysTrue":
      return alwaysTrue$1;
  }
  throw new Error("not implemented");
};
function getFormItems(formSchema) {
  if (formSchema === void 0 || formSchema.widgets === void 0) {
    return [];
  }
  const fieldItems = formSchema.widgets.filter((w2) => !isNullOrUndefinedOrWhiteSpace(w2.__vModel__)).map((schema) => {
    return {
      label: schema.__config__.label,
      value: schema.__vModel__,
      widgetSchema: { ...schema, disabled: false, readonly: false }
    };
  });
  const additionalDataMap = getAdditionalDataMap(formSchema);
  for (let key of additionalDataMap.keys()) {
    fieldItems.push({ label: key, value: key, widgetSchema: getAdditionalDataWidgetSchema(key, additionalDataMap.get(key)) });
  }
  return fieldItems;
}
const getAdditionalDataWidgetSchema = (key, values) => {
  const items = values.map((item) => {
    return { label: item, value: item, disabled: false };
  });
  return getDefaultSelectSchema(key, items);
};
const getDefaultSelectSchema = (vModel, items) => {
  return {
    "__config__": {
      "span": 24,
      "tag": "el-select",
      "showLabel": false,
      "showInList": false,
      "label": "",
      "dataSource": {
        "type": "fixed",
        "settings": {
          "data": items
        }
      }
    },
    "__slot__": {
      "default": {
        "optionTag": "el-option"
      }
    },
    "loading": false,
    "placeholder": "",
    "clearable": true,
    "disabled": false,
    "filterable": false,
    "multiple": false,
    "__vModel__": vModel
  };
};
const getFlowConditionOptions = (formSchema) => {
  const conditionOptions = [];
  const data = {
    label: "FormData",
    value: "Data",
    children: getFormItems(formSchema)
  };
  conditionOptions.push(data);
  return conditionOptions;
};
const _hoisted_1$e = {
  key: 0,
  class: "validation-errors"
};
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "ConditionNode",
  setup(__props) {
    const container = ref();
    const getNode = inject("getNode");
    const flowDesignerModel = injectFlowDesignerModel();
    const node = getNode();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const { t: t2 } = useLocale();
    const processRouteDefinition = computed(() => flowDesignerModel.value.getOrCreateRouteDefinition(node.id));
    const formSchema = computed(() => flowDesignerModel.value.getActiveFormSchema());
    const conditionOptions = computed(() => getFlowConditionOptions(formSchema.value));
    const friendlyConditionString = ref();
    const routeCondition = computed(() => {
      var _a3, _b3;
      return (_b3 = (_a3 = processRouteDefinition.value.routePolicyDescriptor) == null ? void 0 : _a3.settings) == null ? void 0 : _b3.routeCondition;
    });
    watch(routeCondition, async (newValue) => {
      friendlyConditionString.value = await getRouteFriendlyString(processRouteDefinition.value, conditionOptions.value, t2);
      await nextTick(() => resizeNodeToContainerSize());
    }, { immediate: true });
    const routePolicyDescriptorCode = computed(() => {
      var _a3;
      return (_a3 = processRouteDefinition.value.routePolicyDescriptor) == null ? void 0 : _a3.componentCode;
    });
    const hasValidateErrors = computed(() => flowDesignerModel.value.hasValidateErrors(node.id));
    const errors = computed(() => flowDesignerModel.value.getValidateErrorMessages(node.id));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", {
          ref_key: "container",
          ref: container,
          class: normalizeClass(["node-box node-box--condition", { "node-box--error": hasValidateErrors.value }])
        }, [
          createVNode(unref(ElRow), null, {
            default: withCtx(() => [
              createVNode(unref(ElCol), { class: "node-box__title" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)(routePolicyDescriptorCode.value)), 1)
                ]),
                _: 1
              }),
              routePolicyDescriptorCode.value == unref(RoutePolicyDescriptorCodes).ProportionalVoting ? (openBlock(), createBlock(unref(ElCol), {
                key: 0,
                span: 24
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Percentage")) + ":" + toDisplayString(processRouteDefinition.value.routePolicyDescriptor.settings.percentage * 100) + "% ", 1)
                ]),
                _: 1
              })) : createCommentVNode("", true),
              routePolicyDescriptorCode.value == unref(RoutePolicyDescriptorCodes).FixedQuorumDecision ? (openBlock(), createBlock(unref(ElCol), {
                key: 1,
                span: 24
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("QuorumThreshold")) + ":" + toDisplayString(processRouteDefinition.value.routePolicyDescriptor.settings.quorumThreshold), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true),
              createVNode(unref(ElCol), {
                span: 24,
                class: "node-box__context"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(friendlyConditionString.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2),
        hasValidateErrors.value ? (openBlock(), createElementBlock("ul", _hoisted_1$e, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(errors.value, (error, index2) => {
            return openBlock(), createElementBlock("li", {
              key: index2,
              class: "validation-errors__item"
            }, toDisplayString(error), 1);
          }), 128))
        ])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
var __decorate$e = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class TransformImpl extends View {
  get model() {
    return this.graph.model;
  }
  get view() {
    return this.graph.renderer.findViewByCell(this.node);
  }
  get containerClassName() {
    return this.prefixClassName("widget-transform");
  }
  get resizeClassName() {
    return `${this.containerClassName}-resize`;
  }
  get rotateClassName() {
    return `${this.containerClassName}-rotate`;
  }
  constructor(options, node, graph) {
    super();
    this.node = node;
    this.graph = graph;
    this.options = Object.assign(Object.assign({}, Private$2.defaultOptions), options);
    this.render();
    this.startListening();
  }
  startListening() {
    this.delegateEvents({
      [`mousedown .${this.resizeClassName}`]: "startResizing",
      [`touchstart .${this.resizeClassName}`]: "startResizing",
      [`mousedown .${this.rotateClassName}`]: "startRotating",
      [`touchstart .${this.rotateClassName}`]: "startRotating"
    });
    this.model.on("*", this.update, this);
    this.graph.on("scale", this.update, this);
    this.graph.on("translate", this.update, this);
    this.node.on("removed", this.remove, this);
    this.model.on("reseted", this.remove, this);
    this.view.on("cell:knob:mousedown", this.onKnobMouseDown, this);
    this.view.on("cell:knob:mouseup", this.onKnobMouseUp, this);
  }
  stopListening() {
    this.undelegateEvents();
    this.model.off("*", this.update, this);
    this.graph.off("scale", this.update, this);
    this.graph.off("translate", this.update, this);
    this.node.off("removed", this.remove, this);
    this.model.off("reseted", this.remove, this);
    this.view.off("cell:knob:mousedown", this.onKnobMouseDown, this);
    this.view.off("cell:knob:mouseup", this.onKnobMouseUp, this);
  }
  renderHandles() {
    this.container = document.createElement("div");
    const knob = document.createElement("div");
    Dom.attr(knob, "draggable", "false");
    const rotate = knob.cloneNode(true);
    Dom.addClass(rotate, this.rotateClassName);
    const resizes = Private$2.POSITIONS.map((pos) => {
      const elem = knob.cloneNode(true);
      Dom.addClass(elem, this.resizeClassName);
      Dom.attr(elem, "data-position", pos);
      return elem;
    });
    this.empty();
    Dom.append(this.container, [...resizes, rotate]);
  }
  render() {
    this.renderHandles();
    if (this.view) {
      this.view.addClass(Private$2.NODE_CLS);
    }
    Dom.addClass(this.container, this.containerClassName);
    Dom.toggleClass(this.container, "no-orth-resize", this.options.preserveAspectRatio || !this.options.orthogonalResizing);
    Dom.toggleClass(this.container, "no-resize", !this.options.resizable);
    Dom.toggleClass(this.container, "no-rotate", !this.options.rotatable);
    if (this.options.className) {
      Dom.addClass(this.container, this.options.className);
    }
    this.graph.container.appendChild(this.container);
    return this.update();
  }
  update() {
    const ctm = this.graph.matrix();
    const bbox = this.node.getBBox();
    bbox.x *= ctm.a;
    bbox.x += ctm.e;
    bbox.y *= ctm.d;
    bbox.y += ctm.f;
    bbox.width *= ctm.a;
    bbox.height *= ctm.d;
    const angle = Angle.normalize(this.node.getAngle());
    const transform = angle !== 0 ? `rotate(${angle}deg)` : "";
    Dom.css(this.container, {
      transform,
      width: bbox.width,
      height: bbox.height,
      left: bbox.x,
      top: bbox.y
    });
    this.updateResizerDirections();
    return this;
  }
  remove() {
    if (this.view) {
      this.view.removeClass(Private$2.NODE_CLS);
    }
    return super.remove();
  }
  onKnobMouseDown() {
    this.startHandle();
  }
  onKnobMouseUp() {
    this.stopHandle();
  }
  updateResizerDirections() {
    const angle = Angle.normalize(this.node.getAngle());
    const shift = Math.floor(angle * (Private$2.DIRECTIONS.length / 360));
    if (shift !== this.prevShift) {
      const directions = Private$2.DIRECTIONS.slice(shift).concat(Private$2.DIRECTIONS.slice(0, shift));
      const className = (dir) => `${this.containerClassName}-cursor-${dir}`;
      const resizes = this.container.querySelectorAll(`.${this.resizeClassName}`);
      resizes.forEach((resize, index2) => {
        Dom.removeClass(resize, Private$2.DIRECTIONS.map((dir) => className(dir)).join(" "));
        Dom.addClass(resize, className(directions[index2]));
      });
      this.prevShift = shift;
    }
  }
  getTrueDirection(dir) {
    const angle = Angle.normalize(this.node.getAngle());
    let index2 = Private$2.POSITIONS.indexOf(dir);
    index2 += Math.floor(angle * (Private$2.POSITIONS.length / 360));
    index2 %= Private$2.POSITIONS.length;
    return Private$2.POSITIONS[index2];
  }
  toValidResizeDirection(dir) {
    return {
      top: "top-left",
      bottom: "bottom-right",
      left: "bottom-left",
      right: "top-right"
    }[dir] || dir;
  }
  startResizing(evt) {
    evt.stopPropagation();
    this.model.startBatch("resize", { cid: this.cid });
    const dir = Dom.attr(evt.target, "data-position");
    this.prepareResizing(evt, dir);
    this.startAction(evt);
  }
  prepareResizing(evt, relativeDirection) {
    const trueDirection = this.getTrueDirection(relativeDirection);
    let rx2 = 0;
    let ry2 = 0;
    relativeDirection.split("-").forEach((direction2) => {
      rx2 = { left: -1, right: 1 }[direction2] || rx2;
      ry2 = { top: -1, bottom: 1 }[direction2] || ry2;
    });
    const direction = this.toValidResizeDirection(relativeDirection);
    const selector = {
      "top-right": "bottomLeft",
      "top-left": "bottomRight",
      "bottom-left": "topRight",
      "bottom-right": "topLeft"
    }[direction];
    const angle = Angle.normalize(this.node.getAngle());
    this.setEventData(evt, {
      selector,
      direction,
      trueDirection,
      relativeDirection,
      angle,
      resizeX: rx2,
      resizeY: ry2,
      action: "resizing"
    });
  }
  startRotating(evt) {
    evt.stopPropagation();
    this.model.startBatch("rotate", { cid: this.cid });
    const center = this.node.getBBox().getCenter();
    const e10 = this.normalizeEvent(evt);
    const client = this.graph.snapToGrid(e10.clientX, e10.clientY);
    this.setEventData(evt, {
      center,
      action: "rotating",
      angle: Angle.normalize(this.node.getAngle()),
      start: Point.create(client).theta(center)
    });
    this.startAction(evt);
  }
  onMouseMove(evt) {
    const view = this.graph.findViewByCell(this.node);
    let data = this.getEventData(evt);
    if (data.action) {
      const e10 = this.normalizeEvent(evt);
      let clientX = e10.clientX;
      let clientY = e10.clientY;
      const scroller = this.graph.getPlugin("scroller");
      const restrict = this.options.restrictedResizing;
      if (restrict === true || typeof restrict === "number") {
        const factor = restrict === true ? 0 : restrict;
        const fix = scroller ? Math.max(factor, 8) : factor;
        const rect = this.graph.container.getBoundingClientRect();
        clientX = NumberExt.clamp(clientX, rect.left + fix, rect.right - fix);
        clientY = NumberExt.clamp(clientY, rect.top + fix, rect.bottom - fix);
      } else if (this.options.autoScrollOnResizing && scroller) {
        scroller.autoScroll(clientX, clientY);
      }
      const pos = this.graph.snapToGrid(clientX, clientY);
      const gridSize = this.graph.getGridSize();
      const node = this.node;
      const options = this.options;
      if (data.action === "resizing") {
        data = data;
        if (!data.resized) {
          if (view) {
            view.addClass("node-resizing");
            this.notify("node:resize", evt, view);
          }
          data.resized = true;
        }
        const currentBBox = node.getBBox();
        const requestedSize = Point.create(pos).rotate(data.angle, currentBBox.getCenter()).diff(currentBBox[data.selector]);
        let width2 = data.resizeX ? requestedSize.x * data.resizeX : currentBBox.width;
        let height = data.resizeY ? requestedSize.y * data.resizeY : currentBBox.height;
        const rawWidth = width2;
        const rawHeight = height;
        width2 = GeometryUtil.snapToGrid(width2, gridSize);
        height = GeometryUtil.snapToGrid(height, gridSize);
        width2 = Math.max(width2, options.minWidth || gridSize);
        height = Math.max(height, options.minHeight || gridSize);
        width2 = Math.min(width2, options.maxWidth || Infinity);
        height = Math.min(height, options.maxHeight || Infinity);
        if (options.preserveAspectRatio) {
          const candidateWidth = currentBBox.width * height / currentBBox.height;
          const candidateHeight = currentBBox.height * width2 / currentBBox.width;
          if (width2 < candidateWidth) {
            height = candidateHeight;
          } else {
            width2 = candidateWidth;
          }
        }
        const relativeDirection = data.relativeDirection;
        if (options.allowReverse && (rawWidth <= -width2 || rawHeight <= -height)) {
          let reverted;
          if (relativeDirection === "left") {
            if (rawWidth <= -width2) {
              reverted = "right";
            }
          } else if (relativeDirection === "right") {
            if (rawWidth <= -width2) {
              reverted = "left";
            }
          } else if (relativeDirection === "top") {
            if (rawHeight <= -height) {
              reverted = "bottom";
            }
          } else if (relativeDirection === "bottom") {
            if (rawHeight <= -height) {
              reverted = "top";
            }
          } else if (relativeDirection === "top-left") {
            if (rawWidth <= -width2 && rawHeight <= -height) {
              reverted = "bottom-right";
            } else if (rawWidth <= -width2) {
              reverted = "top-right";
            } else if (rawHeight <= -height) {
              reverted = "bottom-left";
            }
          } else if (relativeDirection === "top-right") {
            if (rawWidth <= -width2 && rawHeight <= -height) {
              reverted = "bottom-left";
            } else if (rawWidth <= -width2) {
              reverted = "top-left";
            } else if (rawHeight <= -height) {
              reverted = "bottom-right";
            }
          } else if (relativeDirection === "bottom-left") {
            if (rawWidth <= -width2 && rawHeight <= -height) {
              reverted = "top-right";
            } else if (rawWidth <= -width2) {
              reverted = "bottom-right";
            } else if (rawHeight <= -height) {
              reverted = "top-left";
            }
          } else if (relativeDirection === "bottom-right") {
            if (rawWidth <= -width2 && rawHeight <= -height) {
              reverted = "top-left";
            } else if (rawWidth <= -width2) {
              reverted = "bottom-left";
            } else if (rawHeight <= -height) {
              reverted = "top-right";
            }
          }
          const revertedDir = reverted;
          this.stopHandle();
          const handle = this.container.querySelector(`.${this.resizeClassName}[data-position="${revertedDir}"]`);
          this.startHandle(handle);
          this.prepareResizing(evt, revertedDir);
          this.onMouseMove(evt);
        }
        if (currentBBox.width !== width2 || currentBBox.height !== height) {
          const resizeOptions = {
            ui: true,
            direction: data.direction,
            relativeDirection: data.relativeDirection,
            trueDirection: data.trueDirection,
            minWidth: options.minWidth,
            minHeight: options.minHeight,
            maxWidth: options.maxWidth,
            maxHeight: options.maxHeight,
            preserveAspectRatio: options.preserveAspectRatio === true
          };
          node.resize(width2, height, resizeOptions);
          this.notify("node:resizing", evt, view);
        }
      } else if (data.action === "rotating") {
        data = data;
        if (!data.rotated) {
          if (view) {
            view.addClass("node-rotating");
            this.notify("node:rotate", evt, view);
          }
          data.rotated = true;
        }
        const currentAngle = node.getAngle();
        const theta = data.start - Point.create(pos).theta(data.center);
        let target = data.angle + theta;
        if (options.rotateGrid) {
          target = GeometryUtil.snapToGrid(target, options.rotateGrid);
        }
        target = Angle.normalize(target);
        if (currentAngle !== target) {
          node.rotate(target, { absolute: true });
          this.notify("node:rotating", evt, view);
        }
      }
    }
  }
  onMouseUp(evt) {
    const data = this.getEventData(evt);
    if (data.action) {
      this.stopAction(evt);
      this.model.stopBatch(data.action === "resizing" ? "resize" : "rotate", {
        cid: this.cid
      });
    }
  }
  startHandle(handle) {
    this.handle = handle || null;
    Dom.addClass(this.container, `${this.containerClassName}-active`);
    if (handle) {
      Dom.addClass(handle, `${this.containerClassName}-active-handle`);
      const pos = handle.getAttribute("data-position");
      if (pos) {
        const dir = Private$2.DIRECTIONS[Private$2.POSITIONS.indexOf(pos)];
        Dom.addClass(this.container, `${this.containerClassName}-cursor-${dir}`);
      }
    }
  }
  stopHandle() {
    Dom.removeClass(this.container, `${this.containerClassName}-active`);
    if (this.handle) {
      Dom.removeClass(this.handle, `${this.containerClassName}-active-handle`);
      const pos = this.handle.getAttribute("data-position");
      if (pos) {
        const dir = Private$2.DIRECTIONS[Private$2.POSITIONS.indexOf(pos)];
        Dom.removeClass(this.container, `${this.containerClassName}-cursor-${dir}`);
      }
      this.handle = null;
    }
  }
  startAction(evt) {
    this.startHandle(evt.target);
    this.graph.view.undelegateEvents();
    this.delegateDocumentEvents(Private$2.documentEvents, evt.data);
  }
  stopAction(evt) {
    this.stopHandle();
    this.undelegateDocumentEvents();
    this.graph.view.delegateEvents();
    const view = this.graph.findViewByCell(this.node);
    const data = this.getEventData(evt);
    if (view) {
      view.removeClass(`node-${data.action}`);
      if (data.action === "resizing" && data.resized) {
        this.notify("node:resized", evt, view);
      } else if (data.action === "rotating" && data.rotated) {
        this.notify("node:rotated", evt, view);
      }
    }
  }
  notify(name, evt, view, args = {}) {
    if (view) {
      const graph = view.graph;
      const e10 = graph.view.normalizeEvent(evt);
      const localPoint = graph.snapToGrid(e10.clientX, e10.clientY);
      this.trigger(name, Object.assign({
        e: e10,
        view,
        node: view.cell,
        cell: view.cell,
        x: localPoint.x,
        y: localPoint.y
      }, args));
    }
  }
  dispose() {
    this.stopListening();
    this.remove();
    this.off();
  }
}
__decorate$e([
  View.dispose()
], TransformImpl.prototype, "dispose", null);
var Private$2;
(function(Private2) {
  Private2.NODE_CLS = "has-widget-transform";
  Private2.DIRECTIONS = ["nw", "n", "ne", "e", "se", "s", "sw", "w"];
  Private2.POSITIONS = [
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
  ];
  Private2.documentEvents = {
    mousemove: "onMouseMove",
    touchmove: "onMouseMove",
    mouseup: "onMouseUp",
    touchend: "onMouseUp"
  };
  Private2.defaultOptions = {
    minWidth: 0,
    minHeight: 0,
    maxWidth: Infinity,
    maxHeight: Infinity,
    rotateGrid: 15,
    rotatable: true,
    preserveAspectRatio: false,
    orthogonalResizing: true,
    restrictedResizing: false,
    autoScrollOnResizing: true,
    allowReverse: true
  };
})(Private$2 || (Private$2 = {}));
const content$6 = `.x6-widget-transform {
  position: absolute;
  box-sizing: content-box !important;
  margin: -5px 0 0 -5px;
  padding: 4px;
  border: 1px dashed #000;
  border-radius: 5px;
  user-select: none;
  pointer-events: none;
}
.x6-widget-transform > div {
  position: absolute;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #000;
  transition: background-color 0.2s;
  pointer-events: auto;
  -webkit-user-drag: none;
  user-drag: none;
  /* stylelint-disable-line */
}
.x6-widget-transform > div:hover {
  background-color: #d3d3d3;
}
.x6-widget-transform-cursor-n {
  cursor: n-resize;
}
.x6-widget-transform-cursor-s {
  cursor: s-resize;
}
.x6-widget-transform-cursor-e {
  cursor: e-resize;
}
.x6-widget-transform-cursor-w {
  cursor: w-resize;
}
.x6-widget-transform-cursor-ne {
  cursor: ne-resize;
}
.x6-widget-transform-cursor-nw {
  cursor: nw-resize;
}
.x6-widget-transform-cursor-se {
  cursor: se-resize;
}
.x6-widget-transform-cursor-sw {
  cursor: sw-resize;
}
.x6-widget-transform-resize {
  width: 10px;
  height: 10px;
  border-radius: 6px;
}
.x6-widget-transform-resize[data-position='top-left'] {
  top: -5px;
  left: -5px;
}
.x6-widget-transform-resize[data-position='top-right'] {
  top: -5px;
  right: -5px;
}
.x6-widget-transform-resize[data-position='bottom-left'] {
  bottom: -5px;
  left: -5px;
}
.x6-widget-transform-resize[data-position='bottom-right'] {
  right: -5px;
  bottom: -5px;
}
.x6-widget-transform-resize[data-position='top'] {
  top: -5px;
  left: 50%;
  margin-left: -5px;
}
.x6-widget-transform-resize[data-position='bottom'] {
  bottom: -5px;
  left: 50%;
  margin-left: -5px;
}
.x6-widget-transform-resize[data-position='left'] {
  top: 50%;
  left: -5px;
  margin-top: -5px;
}
.x6-widget-transform-resize[data-position='right'] {
  top: 50%;
  right: -5px;
  margin-top: -5px;
}
.x6-widget-transform.prevent-aspect-ratio .x6-widget-transform-resize[data-position='top'],
.x6-widget-transform.prevent-aspect-ratio .x6-widget-transform-resize[data-position='bottom'],
.x6-widget-transform.prevent-aspect-ratio .x6-widget-transform-resize[data-position='left'],
.x6-widget-transform.prevent-aspect-ratio .x6-widget-transform-resize[data-position='right'] {
  display: none;
}
.x6-widget-transform.no-orth-resize .x6-widget-transform-resize[data-position='bottom'],
.x6-widget-transform.no-orth-resize .x6-widget-transform-resize[data-position='left'],
.x6-widget-transform.no-orth-resize .x6-widget-transform-resize[data-position='right'],
.x6-widget-transform.no-orth-resize .x6-widget-transform-resize[data-position='top'] {
  display: none;
}
.x6-widget-transform.no-resize .x6-widget-transform-resize {
  display: none;
}
.x6-widget-transform-rotate {
  top: -20px;
  left: -20px;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  cursor: crosshair;
}
.x6-widget-transform.no-rotate .x6-widget-transform-rotate {
  display: none;
}
.x6-widget-transform-active {
  border-color: transparent;
  pointer-events: all;
}
.x6-widget-transform-active > div {
  display: none;
}
.x6-widget-transform-active > .x6-widget-transform-active-handle {
  display: block;
  background-color: #808080;
}
`;
Graph$2.prototype.createTransformWidget = function(node) {
  const transform = this.getPlugin("transform");
  if (transform) {
    transform.createWidget(node);
  }
  return this;
};
Graph$2.prototype.clearTransformWidgets = function() {
  const transform = this.getPlugin("transform");
  if (transform) {
    transform.clearWidgets();
  }
  return this;
};
var __decorate$d = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Transform extends Basecoat {
  constructor(options = {}) {
    super();
    this.name = "transform";
    this.widgets = /* @__PURE__ */ new Map();
    this.disabled = false;
    this.options = options;
    CssLoader.ensure(this.name, content$6);
  }
  init(graph) {
    this.graph = graph;
    if (this.disabled) {
      return;
    }
    this.startListening();
  }
  startListening() {
    this.graph.on("node:click", this.onNodeClick, this);
    this.graph.on("blank:mousedown", this.onBlankMouseDown, this);
  }
  stopListening() {
    this.graph.off("node:click", this.onNodeClick, this);
    this.graph.off("blank:mousedown", this.onBlankMouseDown, this);
  }
  enable() {
    if (this.disabled) {
      this.disabled = false;
      this.startListening();
    }
  }
  disable() {
    if (!this.disabled) {
      this.disabled = true;
      this.stopListening();
    }
  }
  isEnabled() {
    return !this.disabled;
  }
  createWidget(node) {
    this.clearWidgets();
    const widget = this.createTransform(node);
    if (widget) {
      this.widgets.set(node, widget);
      widget.on("*", (name, args) => {
        this.trigger(name, args);
        this.graph.trigger(name, args);
      });
    }
  }
  onNodeClick({ node }) {
    this.createWidget(node);
  }
  onBlankMouseDown() {
    this.clearWidgets();
  }
  createTransform(node) {
    const options = this.getTransformOptions(node);
    if (options.resizable || options.rotatable) {
      return new TransformImpl(options, node, this.graph);
    }
    return null;
  }
  getTransformOptions(node) {
    if (!this.options.resizing) {
      this.options.resizing = {
        enabled: false
      };
    }
    if (!this.options.rotating) {
      this.options.rotating = {
        enabled: false
      };
    }
    if (typeof this.options.resizing === "boolean") {
      this.options.resizing = {
        enabled: this.options.resizing
      };
    }
    if (typeof this.options.rotating === "boolean") {
      this.options.rotating = {
        enabled: this.options.rotating
      };
    }
    const resizing = Transform.parseOptionGroup(this.graph, node, this.options.resizing);
    const rotating = Transform.parseOptionGroup(this.graph, node, this.options.rotating);
    const options = {
      resizable: !!resizing.enabled,
      minWidth: resizing.minWidth || 0,
      maxWidth: resizing.maxWidth || Number.MAX_SAFE_INTEGER,
      minHeight: resizing.minHeight || 0,
      maxHeight: resizing.maxHeight || Number.MAX_SAFE_INTEGER,
      orthogonalResizing: typeof resizing.orthogonal === "boolean" ? resizing.orthogonal : true,
      restrictedResizing: !!resizing.restrict,
      autoScrollOnResizing: typeof resizing.autoScroll === "boolean" ? resizing.autoScroll : true,
      preserveAspectRatio: !!resizing.preserveAspectRatio,
      allowReverse: typeof resizing.allowReverse === "boolean" ? resizing.allowReverse : true,
      rotatable: !!rotating.enabled,
      rotateGrid: rotating.grid || 15
    };
    return options;
  }
  clearWidgets() {
    this.widgets.forEach((widget, node) => {
      if (this.graph.getCellById(node.id)) {
        widget.dispose();
      }
    });
    this.widgets.clear();
  }
  dispose() {
    this.clearWidgets();
    this.stopListening();
    this.off();
    CssLoader.clean(this.name);
  }
}
__decorate$d([
  Basecoat.dispose()
], Transform.prototype, "dispose", null);
(function(Transform2) {
  function parseOptionGroup(graph, arg, options) {
    const result = {};
    Object.keys(options || {}).forEach((key) => {
      const val = options[key];
      result[key] = typeof val === "function" ? val.call(graph, arg) : val;
    });
    return result;
  }
  Transform2.parseOptionGroup = parseOptionGroup;
})(Transform || (Transform = {}));
var __decorate$c = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class SelectionImpl extends View {
  get graph() {
    return this.options.graph;
  }
  get boxClassName() {
    return this.prefixClassName(Private$1.classNames.box);
  }
  get $boxes() {
    return Dom.children(this.container, this.boxClassName);
  }
  get handleOptions() {
    return this.options;
  }
  constructor(options) {
    super();
    this.options = options;
    if (this.options.model) {
      this.options.collection = this.options.model.collection;
    }
    if (this.options.collection) {
      this.collection = this.options.collection;
    } else {
      this.collection = new Collection([], {
        comparator: Private$1.depthComparator
      });
      this.options.collection = this.collection;
    }
    this.boxCount = 0;
    this.createContainer();
    this.startListening();
  }
  startListening() {
    const graph = this.graph;
    const collection = this.collection;
    this.delegateEvents({
      [`mousedown .${this.boxClassName}`]: "onSelectionBoxMouseDown",
      [`touchstart .${this.boxClassName}`]: "onSelectionBoxMouseDown"
    }, true);
    graph.on("scale", this.onGraphTransformed, this);
    graph.on("translate", this.onGraphTransformed, this);
    graph.model.on("updated", this.onModelUpdated, this);
    collection.on("added", this.onCellAdded, this);
    collection.on("removed", this.onCellRemoved, this);
    collection.on("reseted", this.onReseted, this);
    collection.on("updated", this.onCollectionUpdated, this);
    collection.on("node:change:position", this.onNodePositionChanged, this);
    collection.on("cell:changed", this.onCellChanged, this);
  }
  stopListening() {
    const graph = this.graph;
    const collection = this.collection;
    this.undelegateEvents();
    graph.off("scale", this.onGraphTransformed, this);
    graph.off("translate", this.onGraphTransformed, this);
    graph.model.off("updated", this.onModelUpdated, this);
    collection.off("added", this.onCellAdded, this);
    collection.off("removed", this.onCellRemoved, this);
    collection.off("reseted", this.onReseted, this);
    collection.off("updated", this.onCollectionUpdated, this);
    collection.off("node:change:position", this.onNodePositionChanged, this);
    collection.off("cell:changed", this.onCellChanged, this);
  }
  onRemove() {
    this.stopListening();
  }
  onGraphTransformed() {
    this.updateSelectionBoxes();
  }
  onCellChanged() {
    this.updateSelectionBoxes();
  }
  onNodePositionChanged({ node, options }) {
    const { showNodeSelectionBox, pointerEvents } = this.options;
    const { ui: ui2, selection, translateBy, snapped } = options;
    const allowTranslating = (showNodeSelectionBox !== true || pointerEvents && this.getPointerEventsValue(pointerEvents) === "none") && !this.translating && !selection;
    const translateByUi = ui2 && translateBy && node.id === translateBy;
    if (allowTranslating && (translateByUi || snapped)) {
      this.translating = true;
      const current = node.position();
      const previous = node.previous("position");
      const dx2 = current.x - previous.x;
      const dy2 = current.y - previous.y;
      if (dx2 !== 0 || dy2 !== 0) {
        this.translateSelectedNodes(dx2, dy2, node, options);
      }
      this.translating = false;
    }
  }
  onModelUpdated({ removed }) {
    if (removed && removed.length) {
      this.unselect(removed);
    }
  }
  isEmpty() {
    return this.length <= 0;
  }
  isSelected(cell) {
    return this.collection.has(cell);
  }
  get length() {
    return this.collection.length;
  }
  get cells() {
    return this.collection.toArray();
  }
  select(cells, options = {}) {
    options.dryrun = true;
    const items = this.filter(Array.isArray(cells) ? cells : [cells]);
    this.collection.add(items, options);
    return this;
  }
  unselect(cells, options = {}) {
    options.dryrun = true;
    this.collection.remove(Array.isArray(cells) ? cells : [cells], options);
    return this;
  }
  reset(cells, options = {}) {
    if (cells) {
      if (options.batch) {
        const filterCells = this.filter(Array.isArray(cells) ? cells : [cells]);
        this.collection.reset(filterCells, Object.assign(Object.assign({}, options), { ui: true }));
        return this;
      }
      const prev = this.cells;
      const next = this.filter(Array.isArray(cells) ? cells : [cells]);
      const prevMap = {};
      const nextMap = {};
      prev.forEach((cell) => prevMap[cell.id] = cell);
      next.forEach((cell) => nextMap[cell.id] = cell);
      const added = [];
      const removed = [];
      next.forEach((cell) => {
        if (!prevMap[cell.id]) {
          added.push(cell);
        }
      });
      prev.forEach((cell) => {
        if (!nextMap[cell.id]) {
          removed.push(cell);
        }
      });
      if (removed.length) {
        this.unselect(removed, Object.assign(Object.assign({}, options), { ui: true }));
      }
      if (added.length) {
        this.select(added, Object.assign(Object.assign({}, options), { ui: true }));
      }
      if (removed.length === 0 && added.length === 0) {
        this.updateContainer();
      }
      return this;
    }
    return this.clean(options);
  }
  clean(options = {}) {
    if (this.length) {
      if (options.batch === false) {
        this.unselect(this.cells, options);
      } else {
        this.collection.reset([], Object.assign(Object.assign({}, options), { ui: true }));
      }
    }
    return this;
  }
  setFilter(filter) {
    this.options.filter = filter;
  }
  setContent(content2) {
    this.options.content = content2;
  }
  startSelecting(evt) {
    evt = this.normalizeEvent(evt);
    this.clean();
    let x2;
    let y2;
    const graphContainer = this.graph.container;
    if (evt.offsetX != null && evt.offsetY != null && graphContainer.contains(evt.target)) {
      x2 = evt.offsetX;
      y2 = evt.offsetY;
    } else {
      const offset = Dom.offset(graphContainer);
      const scrollLeft = graphContainer.scrollLeft;
      const scrollTop = graphContainer.scrollTop;
      x2 = evt.clientX - offset.left + window.pageXOffset + scrollLeft;
      y2 = evt.clientY - offset.top + window.pageYOffset + scrollTop;
    }
    Dom.css(this.container, {
      top: y2,
      left: x2,
      width: 1,
      height: 1
    });
    this.setEventData(evt, {
      action: "selecting",
      clientX: evt.clientX,
      clientY: evt.clientY,
      offsetX: x2,
      offsetY: y2,
      scrollerX: 0,
      scrollerY: 0,
      moving: false
    });
    this.delegateDocumentEvents(Private$1.documentEvents, evt.data);
  }
  filter(cells) {
    const filter = this.options.filter;
    return cells.filter((cell) => {
      if (Array.isArray(filter)) {
        return filter.some((item) => {
          if (typeof item === "string") {
            return cell.shape === item;
          }
          return cell.id === item.id;
        });
      }
      if (typeof filter === "function") {
        return FunctionExt.call(filter, this.graph, cell);
      }
      return true;
    });
  }
  stopSelecting(evt) {
    const graph = this.graph;
    const eventData = this.getEventData(evt);
    const action = eventData.action;
    switch (action) {
      case "selecting": {
        let width2 = Dom.width(this.container);
        let height = Dom.height(this.container);
        const offset = Dom.offset(this.container);
        const origin = graph.pageToLocal(offset.left, offset.top);
        const scale = graph.transform.getScale();
        width2 /= scale.sx;
        height /= scale.sy;
        const rect = new Rectangle(origin.x, origin.y, width2, height);
        const cells = this.getCellViewsInArea(rect).map((view) => view.cell);
        this.reset(cells, { batch: true });
        this.hideRubberband();
        break;
      }
      case "translating": {
        const client = graph.snapToGrid(evt.clientX, evt.clientY);
        if (!this.options.following) {
          const data = eventData;
          this.updateSelectedNodesPosition({
            dx: data.clientX - data.originX,
            dy: data.clientY - data.originY
          });
        }
        this.graph.model.stopBatch("move-selection");
        this.notifyBoxEvent("box:mouseup", evt, client.x, client.y);
        break;
      }
      default: {
        this.clean();
        break;
      }
    }
  }
  onMouseUp(evt) {
    const action = this.getEventData(evt).action;
    if (action) {
      this.stopSelecting(evt);
      this.undelegateDocumentEvents();
    }
  }
  onSelectionBoxMouseDown(evt) {
    if (!this.options.following) {
      evt.stopPropagation();
    }
    const e10 = this.normalizeEvent(evt);
    if (this.options.movable) {
      this.startTranslating(e10);
    }
    const activeView = this.getCellViewFromElem(e10.target);
    this.setEventData(e10, { activeView });
    const client = this.graph.snapToGrid(e10.clientX, e10.clientY);
    this.notifyBoxEvent("box:mousedown", e10, client.x, client.y);
    this.delegateDocumentEvents(Private$1.documentEvents, e10.data);
  }
  startTranslating(evt) {
    this.graph.model.startBatch("move-selection");
    const client = this.graph.snapToGrid(evt.clientX, evt.clientY);
    this.setEventData(evt, {
      action: "translating",
      clientX: client.x,
      clientY: client.y,
      originX: client.x,
      originY: client.y
    });
  }
  getRestrictArea() {
    const restrict = this.graph.options.translating.restrict;
    const area = typeof restrict === "function" ? FunctionExt.call(restrict, this.graph, null) : restrict;
    if (typeof area === "number") {
      return this.graph.transform.getGraphArea().inflate(area);
    }
    if (area === true) {
      return this.graph.transform.getGraphArea();
    }
    return area || null;
  }
  getSelectionOffset(client, data) {
    let dx2 = client.x - data.clientX;
    let dy2 = client.y - data.clientY;
    const restrict = this.getRestrictArea();
    if (restrict) {
      const cells = this.collection.toArray();
      const totalBBox = Cell.getCellsBBox(cells, { deep: true }) || Rectangle.create();
      const minDx = restrict.x - totalBBox.x;
      const minDy = restrict.y - totalBBox.y;
      const maxDx = restrict.x + restrict.width - (totalBBox.x + totalBBox.width);
      const maxDy = restrict.y + restrict.height - (totalBBox.y + totalBBox.height);
      if (dx2 < minDx) {
        dx2 = minDx;
      }
      if (dy2 < minDy) {
        dy2 = minDy;
      }
      if (maxDx < dx2) {
        dx2 = maxDx;
      }
      if (maxDy < dy2) {
        dy2 = maxDy;
      }
      if (!this.options.following) {
        const offsetX = client.x - data.originX;
        const offsetY = client.y - data.originY;
        dx2 = offsetX <= minDx || offsetX >= maxDx ? 0 : dx2;
        dy2 = offsetY <= minDy || offsetY >= maxDy ? 0 : dy2;
      }
    }
    return {
      dx: dx2,
      dy: dy2
    };
  }
  updateElementPosition(elem, dLeft, dTop) {
    const strLeft = Dom.css(elem, "left");
    const strTop = Dom.css(elem, "top");
    const left = strLeft ? parseFloat(strLeft) : 0;
    const top = strTop ? parseFloat(strTop) : 0;
    Dom.css(elem, "left", left + dLeft);
    Dom.css(elem, "top", top + dTop);
  }
  updateSelectedNodesPosition(offset) {
    const { dx: dx2, dy: dy2 } = offset;
    if (dx2 || dy2) {
      if (this.translateSelectedNodes(dx2, dy2), this.boxesUpdated) {
        if (this.collection.length > 1) {
          this.updateSelectionBoxes();
        }
      } else {
        const scale = this.graph.transform.getScale();
        for (let i2 = 0, $boxes = this.$boxes, len = $boxes.length; i2 < len; i2 += 1) {
          this.updateElementPosition($boxes[i2], dx2 * scale.sx, dy2 * scale.sy);
        }
        this.updateElementPosition(this.selectionContainer, dx2 * scale.sx, dy2 * scale.sy);
      }
    }
  }
  autoScrollGraph(x2, y2) {
    const scroller = this.graph.getPlugin("scroller");
    if (scroller) {
      return scroller.autoScroll(x2, y2);
    }
    return { scrollerX: 0, scrollerY: 0 };
  }
  adjustSelection(evt) {
    const e10 = this.normalizeEvent(evt);
    const eventData = this.getEventData(e10);
    const action = eventData.action;
    switch (action) {
      case "selecting": {
        const data = eventData;
        if (data.moving !== true) {
          Dom.appendTo(this.container, this.graph.container);
          this.showRubberband();
          data.moving = true;
        }
        const { scrollerX, scrollerY } = this.autoScrollGraph(e10.clientX, e10.clientY);
        data.scrollerX += scrollerX;
        data.scrollerY += scrollerY;
        const dx2 = e10.clientX - data.clientX + data.scrollerX;
        const dy2 = e10.clientY - data.clientY + data.scrollerY;
        const left = parseInt(Dom.css(this.container, "left") || "0", 10);
        const top = parseInt(Dom.css(this.container, "top") || "0", 10);
        Dom.css(this.container, {
          left: dx2 < 0 ? data.offsetX + dx2 : left,
          top: dy2 < 0 ? data.offsetY + dy2 : top,
          width: Math.abs(dx2),
          height: Math.abs(dy2)
        });
        break;
      }
      case "translating": {
        const client = this.graph.snapToGrid(e10.clientX, e10.clientY);
        const data = eventData;
        const offset = this.getSelectionOffset(client, data);
        if (this.options.following) {
          this.updateSelectedNodesPosition(offset);
        } else {
          this.updateContainerPosition(offset);
        }
        if (offset.dx) {
          data.clientX = client.x;
        }
        if (offset.dy) {
          data.clientY = client.y;
        }
        this.notifyBoxEvent("box:mousemove", evt, client.x, client.y);
        break;
      }
    }
    this.boxesUpdated = false;
  }
  translateSelectedNodes(dx2, dy2, exclude, otherOptions) {
    const map = {};
    const excluded = [];
    if (exclude) {
      map[exclude.id] = true;
    }
    this.collection.toArray().forEach((cell) => {
      cell.getDescendants({ deep: true }).forEach((child) => {
        map[child.id] = true;
      });
    });
    if (otherOptions && otherOptions.translateBy) {
      const currentCell = this.graph.getCellById(otherOptions.translateBy);
      if (currentCell) {
        map[currentCell.id] = true;
        currentCell.getDescendants({ deep: true }).forEach((child) => {
          map[child.id] = true;
        });
        excluded.push(currentCell);
      }
    }
    this.collection.toArray().forEach((cell) => {
      if (!map[cell.id]) {
        const options = Object.assign(Object.assign({}, otherOptions), { selection: this.cid, exclude: excluded });
        cell.translate(dx2, dy2, options);
        this.graph.model.getConnectedEdges(cell).forEach((edge) => {
          if (!map[edge.id]) {
            edge.translate(dx2, dy2, options);
            map[edge.id] = true;
          }
        });
      }
    });
  }
  getCellViewsInArea(rect) {
    const graph = this.graph;
    const options = {
      strict: this.options.strict
    };
    let views = [];
    if (this.options.rubberNode) {
      views = views.concat(graph.model.getNodesInArea(rect, options).map((node) => graph.renderer.findViewByCell(node)).filter((view) => view != null));
    }
    if (this.options.rubberEdge) {
      views = views.concat(graph.model.getEdgesInArea(rect, options).map((edge) => graph.renderer.findViewByCell(edge)).filter((view) => view != null));
    }
    return views;
  }
  notifyBoxEvent(name, e10, x2, y2) {
    const data = this.getEventData(e10);
    const view = data.activeView;
    this.trigger(name, { e: e10, view, x: x2, y: y2, cell: view.cell });
  }
  getSelectedClassName(cell) {
    return this.prefixClassName(`${cell.isNode() ? "node" : "edge"}-selected`);
  }
  addCellSelectedClassName(cell) {
    const view = this.graph.renderer.findViewByCell(cell);
    if (view) {
      view.addClass(this.getSelectedClassName(cell));
    }
  }
  removeCellUnSelectedClassName(cell) {
    const view = this.graph.renderer.findViewByCell(cell);
    if (view) {
      view.removeClass(this.getSelectedClassName(cell));
    }
  }
  destroySelectionBox(cell) {
    this.removeCellUnSelectedClassName(cell);
    if (this.canShowSelectionBox(cell)) {
      Dom.remove(this.container.querySelector(`[data-cell-id="${cell.id}"]`));
      if (this.$boxes.length === 0) {
        this.hide();
      }
      this.boxCount = Math.max(0, this.boxCount - 1);
    }
  }
  destroyAllSelectionBoxes(cells) {
    cells.forEach((cell) => this.removeCellUnSelectedClassName(cell));
    this.hide();
    Dom.remove(this.$boxes);
    this.boxCount = 0;
  }
  hide() {
    Dom.removeClass(this.container, this.prefixClassName(Private$1.classNames.rubberband));
    Dom.removeClass(this.container, this.prefixClassName(Private$1.classNames.selected));
  }
  showRubberband() {
    Dom.addClass(this.container, this.prefixClassName(Private$1.classNames.rubberband));
  }
  hideRubberband() {
    Dom.removeClass(this.container, this.prefixClassName(Private$1.classNames.rubberband));
  }
  showSelected() {
    Dom.removeAttribute(this.container, "style");
    Dom.addClass(this.container, this.prefixClassName(Private$1.classNames.selected));
  }
  createContainer() {
    this.container = document.createElement("div");
    Dom.addClass(this.container, this.prefixClassName(Private$1.classNames.root));
    if (this.options.className) {
      Dom.addClass(this.container, this.options.className);
    }
    this.selectionContainer = document.createElement("div");
    Dom.addClass(this.selectionContainer, this.prefixClassName(Private$1.classNames.inner));
    this.selectionContent = document.createElement("div");
    Dom.addClass(this.selectionContent, this.prefixClassName(Private$1.classNames.content));
    Dom.append(this.selectionContainer, this.selectionContent);
    Dom.attr(this.selectionContainer, "data-selection-length", this.collection.length);
    Dom.prepend(this.container, this.selectionContainer);
  }
  updateContainerPosition(offset) {
    if (offset.dx || offset.dy) {
      this.updateElementPosition(this.selectionContainer, offset.dx, offset.dy);
    }
  }
  updateContainer() {
    const origin = { x: Infinity, y: Infinity };
    const corner = { x: 0, y: 0 };
    const cells = this.collection.toArray().filter((cell) => this.canShowSelectionBox(cell));
    cells.forEach((cell) => {
      const view = this.graph.renderer.findViewByCell(cell);
      if (view) {
        const bbox = view.getBBox({
          useCellGeometry: true
        });
        origin.x = Math.min(origin.x, bbox.x);
        origin.y = Math.min(origin.y, bbox.y);
        corner.x = Math.max(corner.x, bbox.x + bbox.width);
        corner.y = Math.max(corner.y, bbox.y + bbox.height);
      }
    });
    Dom.css(this.selectionContainer, {
      position: "absolute",
      pointerEvents: "none",
      left: origin.x,
      top: origin.y,
      width: corner.x - origin.x,
      height: corner.y - origin.y
    });
    Dom.attr(this.selectionContainer, "data-selection-length", this.collection.length);
    const boxContent = this.options.content;
    if (boxContent) {
      if (typeof boxContent === "function") {
        const content2 = FunctionExt.call(boxContent, this.graph, this, this.selectionContent);
        if (content2) {
          this.selectionContent.innerHTML = content2;
        }
      } else {
        this.selectionContent.innerHTML = boxContent;
      }
    }
    if (this.collection.length > 0 && !this.container.parentNode) {
      Dom.appendTo(this.container, this.graph.container);
    } else if (this.collection.length <= 0 && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }
  canShowSelectionBox(cell) {
    return cell.isNode() && this.options.showNodeSelectionBox === true || cell.isEdge() && this.options.showEdgeSelectionBox === true;
  }
  getPointerEventsValue(pointerEvents) {
    return typeof pointerEvents === "string" ? pointerEvents : pointerEvents(this.cells);
  }
  createSelectionBox(cell) {
    this.addCellSelectedClassName(cell);
    if (this.canShowSelectionBox(cell)) {
      const view = this.graph.renderer.findViewByCell(cell);
      if (view) {
        const bbox = view.getBBox({
          useCellGeometry: true
        });
        const className = this.boxClassName;
        const box = document.createElement("div");
        const pointerEvents = this.options.pointerEvents;
        Dom.addClass(box, className);
        Dom.addClass(box, `${className}-${cell.isNode() ? "node" : "edge"}`);
        Dom.attr(box, "data-cell-id", cell.id);
        Dom.css(box, {
          position: "absolute",
          left: bbox.x,
          top: bbox.y,
          width: bbox.width,
          height: bbox.height,
          pointerEvents: pointerEvents ? this.getPointerEventsValue(pointerEvents) : "auto"
        });
        Dom.appendTo(box, this.container);
        this.showSelected();
        this.boxCount += 1;
      }
    }
  }
  updateSelectionBoxes() {
    if (this.collection.length > 0) {
      this.boxesUpdated = true;
      this.confirmUpdate();
    }
  }
  confirmUpdate() {
    if (this.boxCount) {
      this.hide();
      for (let i2 = 0, $boxes = this.$boxes, len = $boxes.length; i2 < len; i2 += 1) {
        const box = $boxes[i2];
        const cellId = Dom.attr(box, "data-cell-id");
        Dom.remove(box);
        this.boxCount -= 1;
        const cell = this.collection.get(cellId);
        if (cell) {
          this.createSelectionBox(cell);
        }
      }
      this.updateContainer();
    }
    return 0;
  }
  getCellViewFromElem(elem) {
    const id2 = elem.getAttribute("data-cell-id");
    if (id2) {
      const cell = this.collection.get(id2);
      if (cell) {
        return this.graph.renderer.findViewByCell(cell);
      }
    }
    return null;
  }
  onCellRemoved({ cell }) {
    this.destroySelectionBox(cell);
    this.updateContainer();
  }
  onReseted({ previous, current }) {
    this.destroyAllSelectionBoxes(previous);
    current.forEach((cell) => {
      this.listenCellRemoveEvent(cell);
      this.createSelectionBox(cell);
    });
    this.updateContainer();
  }
  onCellAdded({ cell }) {
    this.listenCellRemoveEvent(cell);
    this.createSelectionBox(cell);
    this.updateContainer();
  }
  listenCellRemoveEvent(cell) {
    cell.off("removed", this.onCellRemoved, this);
    cell.on("removed", this.onCellRemoved, this);
  }
  onCollectionUpdated({ added, removed, options }) {
    added.forEach((cell) => {
      this.trigger("cell:selected", { cell, options });
      if (cell.isNode()) {
        this.trigger("node:selected", { cell, options, node: cell });
      } else if (cell.isEdge()) {
        this.trigger("edge:selected", { cell, options, edge: cell });
      }
    });
    removed.forEach((cell) => {
      this.trigger("cell:unselected", { cell, options });
      if (cell.isNode()) {
        this.trigger("node:unselected", { cell, options, node: cell });
      } else if (cell.isEdge()) {
        this.trigger("edge:unselected", { cell, options, edge: cell });
      }
    });
    const args = {
      added,
      removed,
      options,
      selected: this.cells.filter((cell) => !!this.graph.getCellById(cell.id))
    };
    this.trigger("selection:changed", args);
  }
  // #endregion
  dispose() {
    this.clean();
    this.remove();
    this.off();
  }
}
__decorate$c([
  View.dispose()
], SelectionImpl.prototype, "dispose", null);
var Private$1;
(function(Private2) {
  const base = "widget-selection";
  Private2.classNames = {
    root: base,
    inner: `${base}-inner`,
    box: `${base}-box`,
    content: `${base}-content`,
    rubberband: `${base}-rubberband`,
    selected: `${base}-selected`
  };
  Private2.documentEvents = {
    mousemove: "adjustSelection",
    touchmove: "adjustSelection",
    mouseup: "onMouseUp",
    touchend: "onMouseUp",
    touchcancel: "onMouseUp"
  };
  function depthComparator(cell) {
    return cell.getAncestors().length;
  }
  Private2.depthComparator = depthComparator;
})(Private$1 || (Private$1 = {}));
const content$5 = `.x6-widget-selection {
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  width: 0;
  height: 0;
  touch-action: none;
}
.x6-widget-selection-rubberband {
  display: block;
  overflow: visible;
  opacity: 0.3;
}
.x6-widget-selection-selected {
  display: block;
}
.x6-widget-selection-box {
  cursor: move;
}
.x6-widget-selection-inner[data-selection-length='0'],
.x6-widget-selection-inner[data-selection-length='1'] {
  display: none;
}
.x6-widget-selection-content {
  position: absolute;
  top: 100%;
  right: -20px;
  left: -20px;
  margin-top: 30px;
  padding: 6px;
  line-height: 14px;
  text-align: center;
  border-radius: 6px;
}
.x6-widget-selection-content:empty {
  display: none;
}
.x6-widget-selection-rubberband {
  background-color: #3498db;
  border: 2px solid #2980b9;
}
.x6-widget-selection-box {
  box-sizing: content-box !important;
  margin-top: -4px;
  margin-left: -4px;
  padding-right: 4px;
  padding-bottom: 4px;
  border: 2px dashed #feb663;
  box-shadow: 2px 2px 5px #d3d3d3;
}
.x6-widget-selection-inner {
  box-sizing: content-box !important;
  margin-top: -8px;
  margin-left: -8px;
  padding-right: 12px;
  padding-bottom: 12px;
  border: 2px solid #feb663;
  box-shadow: 2px 2px 5px #d3d3d3;
}
.x6-widget-selection-content {
  color: #fff;
  font-size: 10px;
  background-color: #6a6b8a;
}
`;
Graph$2.prototype.isSelectionEnabled = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isEnabled();
  }
  return false;
};
Graph$2.prototype.enableSelection = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.enable();
  }
  return this;
};
Graph$2.prototype.disableSelection = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.disable();
  }
  return this;
};
Graph$2.prototype.toggleSelection = function(enabled) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.toggleEnabled(enabled);
  }
  return this;
};
Graph$2.prototype.isMultipleSelection = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isMultipleSelection();
  }
  return false;
};
Graph$2.prototype.enableMultipleSelection = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.enableMultipleSelection();
  }
  return this;
};
Graph$2.prototype.disableMultipleSelection = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.disableMultipleSelection();
  }
  return this;
};
Graph$2.prototype.toggleMultipleSelection = function(multiple) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.toggleMultipleSelection(multiple);
  }
  return this;
};
Graph$2.prototype.isSelectionMovable = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isSelectionMovable();
  }
  return false;
};
Graph$2.prototype.enableSelectionMovable = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.enableSelectionMovable();
  }
  return this;
};
Graph$2.prototype.disableSelectionMovable = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.disableSelectionMovable();
  }
  return this;
};
Graph$2.prototype.toggleSelectionMovable = function(movable) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.toggleSelectionMovable(movable);
  }
  return this;
};
Graph$2.prototype.isRubberbandEnabled = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isRubberbandEnabled();
  }
  return false;
};
Graph$2.prototype.enableRubberband = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.enableRubberband();
  }
  return this;
};
Graph$2.prototype.disableRubberband = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.disableRubberband();
  }
  return this;
};
Graph$2.prototype.toggleRubberband = function(enabled) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.toggleRubberband(enabled);
  }
  return this;
};
Graph$2.prototype.isStrictRubberband = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isStrictRubberband();
  }
  return false;
};
Graph$2.prototype.enableStrictRubberband = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.enableStrictRubberband();
  }
  return this;
};
Graph$2.prototype.disableStrictRubberband = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.disableStrictRubberband();
  }
  return this;
};
Graph$2.prototype.toggleStrictRubberband = function(strict) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.toggleStrictRubberband(strict);
  }
  return this;
};
Graph$2.prototype.setRubberbandModifiers = function(modifiers) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.setRubberbandModifiers(modifiers);
  }
  return this;
};
Graph$2.prototype.setSelectionFilter = function(filter) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.setSelectionFilter(filter);
  }
  return this;
};
Graph$2.prototype.setSelectionDisplayContent = function(content2) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.setSelectionDisplayContent(content2);
  }
  return this;
};
Graph$2.prototype.isSelectionEmpty = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isEmpty();
  }
  return true;
};
Graph$2.prototype.cleanSelection = function(options) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.clean(options);
  }
  return this;
};
Graph$2.prototype.resetSelection = function(cells, options) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.reset(cells, options);
  }
  return this;
};
Graph$2.prototype.getSelectedCells = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.getSelectedCells();
  }
  return [];
};
Graph$2.prototype.getSelectedCellCount = function() {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.getSelectedCellCount();
  }
  return 0;
};
Graph$2.prototype.isSelected = function(cell) {
  const selection = this.getPlugin("selection");
  if (selection) {
    return selection.isSelected(cell);
  }
  return false;
};
Graph$2.prototype.select = function(cells, options) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.select(cells, options);
  }
  return this;
};
Graph$2.prototype.unselect = function(cells, options) {
  const selection = this.getPlugin("selection");
  if (selection) {
    selection.unselect(cells, options);
  }
  return this;
};
var __decorate$b = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Selection extends Basecoat {
  get rubberbandDisabled() {
    return this.options.enabled !== true || this.options.rubberband !== true;
  }
  get disabled() {
    return this.options.enabled !== true;
  }
  get length() {
    return this.selectionImpl.length;
  }
  get cells() {
    return this.selectionImpl.cells;
  }
  constructor(options = {}) {
    super();
    this.name = "selection";
    this.movedMap = /* @__PURE__ */ new WeakMap();
    this.unselectMap = /* @__PURE__ */ new WeakMap();
    this.options = Object.assign(Object.assign({ enabled: true }, Selection.defaultOptions), options);
    CssLoader.ensure(this.name, content$5);
  }
  init(graph) {
    this.graph = graph;
    this.selectionImpl = new SelectionImpl(Object.assign(Object.assign({}, this.options), { graph }));
    this.setup();
    this.startListening();
  }
  // #region api
  isEnabled() {
    return !this.disabled;
  }
  enable() {
    if (this.disabled) {
      this.options.enabled = true;
    }
  }
  disable() {
    if (!this.disabled) {
      this.options.enabled = false;
    }
  }
  toggleEnabled(enabled) {
    if (enabled != null) {
      if (enabled !== this.isEnabled()) {
        if (enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    } else if (this.isEnabled()) {
      this.disable();
    } else {
      this.enable();
    }
    return this;
  }
  isMultipleSelection() {
    return this.isMultiple();
  }
  enableMultipleSelection() {
    this.enableMultiple();
    return this;
  }
  disableMultipleSelection() {
    this.disableMultiple();
    return this;
  }
  toggleMultipleSelection(multiple) {
    if (multiple != null) {
      if (multiple !== this.isMultipleSelection()) {
        if (multiple) {
          this.enableMultipleSelection();
        } else {
          this.disableMultipleSelection();
        }
      }
    } else if (this.isMultipleSelection()) {
      this.disableMultipleSelection();
    } else {
      this.enableMultipleSelection();
    }
    return this;
  }
  isSelectionMovable() {
    return this.options.movable !== false;
  }
  enableSelectionMovable() {
    this.selectionImpl.options.movable = true;
    return this;
  }
  disableSelectionMovable() {
    this.selectionImpl.options.movable = false;
    return this;
  }
  toggleSelectionMovable(movable) {
    if (movable != null) {
      if (movable !== this.isSelectionMovable()) {
        if (movable) {
          this.enableSelectionMovable();
        } else {
          this.disableSelectionMovable();
        }
      }
    } else if (this.isSelectionMovable()) {
      this.disableSelectionMovable();
    } else {
      this.enableSelectionMovable();
    }
    return this;
  }
  isRubberbandEnabled() {
    return !this.rubberbandDisabled;
  }
  enableRubberband() {
    if (this.rubberbandDisabled) {
      this.options.rubberband = true;
    }
    return this;
  }
  disableRubberband() {
    if (!this.rubberbandDisabled) {
      this.options.rubberband = false;
    }
    return this;
  }
  toggleRubberband(enabled) {
    if (enabled != null) {
      if (enabled !== this.isRubberbandEnabled()) {
        if (enabled) {
          this.enableRubberband();
        } else {
          this.disableRubberband();
        }
      }
    } else if (this.isRubberbandEnabled()) {
      this.disableRubberband();
    } else {
      this.enableRubberband();
    }
    return this;
  }
  isStrictRubberband() {
    return this.selectionImpl.options.strict === true;
  }
  enableStrictRubberband() {
    this.selectionImpl.options.strict = true;
    return this;
  }
  disableStrictRubberband() {
    this.selectionImpl.options.strict = false;
    return this;
  }
  toggleStrictRubberband(strict) {
    if (strict != null) {
      if (strict !== this.isStrictRubberband()) {
        if (strict) {
          this.enableStrictRubberband();
        } else {
          this.disableStrictRubberband();
        }
      }
    } else if (this.isStrictRubberband()) {
      this.disableStrictRubberband();
    } else {
      this.enableStrictRubberband();
    }
    return this;
  }
  setRubberbandModifiers(modifiers) {
    this.setModifiers(modifiers);
  }
  setSelectionFilter(filter) {
    this.setFilter(filter);
    return this;
  }
  setSelectionDisplayContent(content2) {
    this.setContent(content2);
    return this;
  }
  isEmpty() {
    return this.length <= 0;
  }
  clean(options = {}) {
    this.selectionImpl.clean(options);
    return this;
  }
  reset(cells, options = {}) {
    this.selectionImpl.reset(cells ? this.getCells(cells) : [], options);
    return this;
  }
  getSelectedCells() {
    return this.cells;
  }
  getSelectedCellCount() {
    return this.length;
  }
  isSelected(cell) {
    return this.selectionImpl.isSelected(cell);
  }
  select(cells, options = {}) {
    const selected = this.getCells(cells);
    if (selected.length) {
      if (this.isMultiple()) {
        this.selectionImpl.select(selected, options);
      } else {
        this.reset(selected.slice(0, 1), options);
      }
    }
    return this;
  }
  unselect(cells, options = {}) {
    this.selectionImpl.unselect(this.getCells(cells), options);
    return this;
  }
  // #endregion
  setup() {
    this.selectionImpl.on("*", (name, args) => {
      this.trigger(name, args);
      this.graph.trigger(name, args);
    });
  }
  startListening() {
    this.graph.on("blank:mousedown", this.onBlankMouseDown, this);
    this.graph.on("blank:click", this.onBlankClick, this);
    this.graph.on("cell:mousemove", this.onCellMouseMove, this);
    this.graph.on("cell:mouseup", this.onCellMouseUp, this);
    this.selectionImpl.on("box:mousedown", this.onBoxMouseDown, this);
  }
  stopListening() {
    this.graph.off("blank:mousedown", this.onBlankMouseDown, this);
    this.graph.off("blank:click", this.onBlankClick, this);
    this.graph.off("cell:mousemove", this.onCellMouseMove, this);
    this.graph.off("cell:mouseup", this.onCellMouseUp, this);
    this.selectionImpl.off("box:mousedown", this.onBoxMouseDown, this);
  }
  onBlankMouseDown({ e: e10 }) {
    if (!this.allowBlankMouseDown(e10)) {
      return;
    }
    const allowGraphPanning = this.graph.panning.allowPanning(e10, true);
    const scroller = this.graph.getPlugin("scroller");
    const allowScrollerPanning = scroller && scroller.allowPanning(e10, true);
    if (this.allowRubberband(e10, true) || this.allowRubberband(e10) && !allowScrollerPanning && !allowGraphPanning) {
      this.startRubberband(e10);
    }
  }
  allowBlankMouseDown(e10) {
    const eventTypes = this.options.eventTypes;
    return (eventTypes === null || eventTypes === void 0 ? void 0 : eventTypes.includes("leftMouseDown")) && e10.button === 0 || (eventTypes === null || eventTypes === void 0 ? void 0 : eventTypes.includes("mouseWheelDown")) && e10.button === 1;
  }
  onBlankClick() {
    this.clean();
  }
  allowRubberband(e10, strict) {
    return !this.rubberbandDisabled && ModifierKey.isMatch(e10, this.options.modifiers, strict);
  }
  allowMultipleSelection(e10) {
    return this.isMultiple() && ModifierKey.isMatch(e10, this.options.multipleSelectionModifiers);
  }
  onCellMouseMove({ cell }) {
    this.movedMap.set(cell, true);
  }
  onCellMouseUp({ e: e10, cell }) {
    const options = this.options;
    let disabled = this.disabled;
    if (!disabled && this.movedMap.has(cell)) {
      disabled = options.selectCellOnMoved === false;
      if (!disabled) {
        disabled = options.selectNodeOnMoved === false && cell.isNode();
      }
      if (!disabled) {
        disabled = options.selectEdgeOnMoved === false && cell.isEdge();
      }
    }
    if (!disabled) {
      if (!this.allowMultipleSelection(e10)) {
        this.reset(cell);
      } else if (this.unselectMap.has(cell)) {
        this.unselectMap.delete(cell);
      } else if (this.isSelected(cell)) {
        this.unselect(cell);
      } else {
        this.select(cell);
      }
    }
    this.movedMap.delete(cell);
  }
  onBoxMouseDown({ e: e10, cell }) {
    if (!this.disabled) {
      if (this.allowMultipleSelection(e10)) {
        this.unselect(cell);
        this.unselectMap.set(cell, true);
      }
    }
  }
  getCells(cells) {
    return (Array.isArray(cells) ? cells : [cells]).map((cell) => typeof cell === "string" ? this.graph.getCellById(cell) : cell).filter((cell) => cell != null);
  }
  startRubberband(e10) {
    if (!this.rubberbandDisabled) {
      this.selectionImpl.startSelecting(e10);
    }
    return this;
  }
  isMultiple() {
    return this.options.multiple !== false;
  }
  enableMultiple() {
    this.options.multiple = true;
    return this;
  }
  disableMultiple() {
    this.options.multiple = false;
    return this;
  }
  setModifiers(modifiers) {
    this.options.modifiers = modifiers;
    return this;
  }
  setContent(content2) {
    this.selectionImpl.setContent(content2);
    return this;
  }
  setFilter(filter) {
    this.selectionImpl.setFilter(filter);
    return this;
  }
  dispose() {
    this.stopListening();
    this.off();
    this.selectionImpl.dispose();
    CssLoader.clean(this.name);
  }
}
__decorate$b([
  Basecoat.dispose()
], Selection.prototype, "dispose", null);
(function(Selection2) {
  Selection2.defaultOptions = {
    rubberband: false,
    rubberNode: true,
    rubberEdge: false,
    pointerEvents: "auto",
    multiple: true,
    multipleSelectionModifiers: ["ctrl", "meta"],
    movable: true,
    strict: false,
    selectCellOnMoved: false,
    selectNodeOnMoved: false,
    selectEdgeOnMoved: false,
    following: true,
    content: null,
    eventTypes: ["leftMouseDown", "mouseWheelDown"]
  };
})(Selection || (Selection = {}));
var __decorate$a = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
var __rest$2 = function(s2, e10) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e10.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e10.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
class SnaplineImpl extends View {
  get model() {
    return this.graph.model;
  }
  get containerClassName() {
    return this.prefixClassName("widget-snapline");
  }
  get verticalClassName() {
    return `${this.containerClassName}-vertical`;
  }
  get horizontalClassName() {
    return `${this.containerClassName}-horizontal`;
  }
  constructor(options) {
    super();
    const { graph } = options, others = __rest$2(options, ["graph"]);
    this.graph = graph;
    this.options = Object.assign({}, others);
    this.offset = { x: 0, y: 0 };
    this.render();
    if (!this.disabled) {
      this.startListening();
    }
  }
  get disabled() {
    return this.options.enabled !== true;
  }
  enable() {
    if (this.disabled) {
      this.options.enabled = true;
      this.startListening();
    }
  }
  disable() {
    if (!this.disabled) {
      this.options.enabled = false;
      this.stopListening();
    }
  }
  setFilter(filter) {
    this.options.filter = filter;
  }
  render() {
    const container = this.containerWrapper = new Vector("svg");
    const horizontal = this.horizontal = new Vector("line");
    const vertical = this.vertical = new Vector("line");
    container.addClass(this.containerClassName);
    horizontal.addClass(this.horizontalClassName);
    vertical.addClass(this.verticalClassName);
    container.setAttribute("width", "100%");
    container.setAttribute("height", "100%");
    horizontal.setAttribute("display", "none");
    vertical.setAttribute("display", "none");
    container.append([horizontal, vertical]);
    if (this.options.className) {
      container.addClass(this.options.className);
    }
    this.container = this.containerWrapper.node;
  }
  startListening() {
    this.stopListening();
    this.graph.on("node:mousedown", this.captureCursorOffset, this);
    this.graph.on("node:mousemove", this.snapOnMoving, this);
    this.model.on("batch:stop", this.onBatchStop, this);
    this.delegateDocumentEvents({
      mouseup: "hide",
      touchend: "hide"
    });
  }
  stopListening() {
    this.graph.off("node:mousedown", this.captureCursorOffset, this);
    this.graph.off("node:mousemove", this.snapOnMoving, this);
    this.model.off("batch:stop", this.onBatchStop, this);
    this.undelegateDocumentEvents();
  }
  onBatchStop({ name, data }) {
    if (name === "resize") {
      this.snapOnResizing(data.cell, data);
    }
  }
  captureCursorOffset({ view, x: x2, y: y2 }) {
    const targetView = view.getDelegatedView();
    if (targetView && this.isNodeMovable(targetView)) {
      const pos = view.cell.getPosition();
      this.offset = {
        x: x2 - pos.x,
        y: y2 - pos.y
      };
    }
  }
  isNodeMovable(view) {
    return view && view.cell.isNode() && view.can("nodeMovable");
  }
  getRestrictArea(view) {
    const restrict = this.graph.options.translating.restrict;
    const area = typeof restrict === "function" ? FunctionExt.call(restrict, this.graph, view) : restrict;
    if (typeof area === "number") {
      return this.graph.transform.getGraphArea().inflate(area);
    }
    if (area === true) {
      return this.graph.transform.getGraphArea();
    }
    return area || null;
  }
  snapOnResizing(node, options) {
    if (this.options.resizing && !options.snapped && options.ui && options.direction && options.trueDirection) {
      const view = this.graph.renderer.findViewByCell(node);
      if (view && view.cell.isNode()) {
        const nodeBbox = node.getBBox();
        const nodeBBoxRotated = nodeBbox.bbox(node.getAngle());
        const nodeTopLeft = nodeBBoxRotated.getTopLeft();
        const nodeBottomRight = nodeBBoxRotated.getBottomRight();
        const angle = Angle.normalize(node.getAngle());
        const tolerance = this.options.tolerance || 0;
        let verticalLeft;
        let verticalTop;
        let verticalHeight;
        let horizontalTop;
        let horizontalLeft;
        let horizontalWidth;
        const snapOrigin = {
          vertical: 0,
          horizontal: 0
        };
        const direction = options.direction;
        const trueDirection = options.trueDirection;
        const relativeDirection = options.relativeDirection;
        if (trueDirection.indexOf("right") !== -1) {
          snapOrigin.vertical = nodeBottomRight.x;
        } else {
          snapOrigin.vertical = nodeTopLeft.x;
        }
        if (trueDirection.indexOf("bottom") !== -1) {
          snapOrigin.horizontal = nodeBottomRight.y;
        } else {
          snapOrigin.horizontal = nodeTopLeft.y;
        }
        this.model.getNodes().some((cell) => {
          if (this.isIgnored(node, cell)) {
            return false;
          }
          const snapBBox = cell.getBBox().bbox(cell.getAngle());
          const snapTopLeft = snapBBox.getTopLeft();
          const snapBottomRight = snapBBox.getBottomRight();
          const groups = {
            vertical: [snapTopLeft.x, snapBottomRight.x],
            horizontal: [snapTopLeft.y, snapBottomRight.y]
          };
          const distances = {};
          Object.keys(groups).forEach((k2) => {
            const key = k2;
            const list = groups[key].map((value) => ({
              position: value,
              distance: Math.abs(value - snapOrigin[key])
            })).filter((item) => item.distance <= tolerance);
            distances[key] = ArrayExt.sortBy(list, (item) => item.distance);
          });
          if (verticalLeft == null && distances.vertical.length > 0) {
            verticalLeft = distances.vertical[0].position;
            verticalTop = Math.min(nodeBBoxRotated.y, snapBBox.y);
            verticalHeight = Math.max(nodeBottomRight.y, snapBottomRight.y) - verticalTop;
          }
          if (horizontalTop == null && distances.horizontal.length > 0) {
            horizontalTop = distances.horizontal[0].position;
            horizontalLeft = Math.min(nodeBBoxRotated.x, snapBBox.x);
            horizontalWidth = Math.max(nodeBottomRight.x, snapBottomRight.x) - horizontalLeft;
          }
          return verticalLeft != null && horizontalTop != null;
        });
        this.hide();
        let dx2 = 0;
        let dy2 = 0;
        if (horizontalTop != null || verticalLeft != null) {
          if (verticalLeft != null) {
            dx2 = trueDirection.indexOf("right") !== -1 ? verticalLeft - nodeBottomRight.x : nodeTopLeft.x - verticalLeft;
          }
          if (horizontalTop != null) {
            dy2 = trueDirection.indexOf("bottom") !== -1 ? horizontalTop - nodeBottomRight.y : nodeTopLeft.y - horizontalTop;
          }
        }
        let dWidth = 0;
        let dHeight = 0;
        if (angle % 90 === 0) {
          if (angle === 90 || angle === 270) {
            dWidth = dy2;
            dHeight = dx2;
          } else {
            dWidth = dx2;
            dHeight = dy2;
          }
        } else {
          const quadrant = angle >= 0 && angle < 90 ? 1 : angle >= 90 && angle < 180 ? 4 : angle >= 180 && angle < 270 ? 3 : 2;
          if (horizontalTop != null && verticalLeft != null) {
            if (dx2 < dy2) {
              dy2 = 0;
              horizontalTop = void 0;
            } else {
              dx2 = 0;
              verticalLeft = void 0;
            }
          }
          const rad = Angle.toRad(angle % 90);
          if (dx2) {
            dWidth = quadrant === 3 ? dx2 / Math.cos(rad) : dx2 / Math.sin(rad);
          }
          if (dy2) {
            dHeight = quadrant === 3 ? dy2 / Math.cos(rad) : dy2 / Math.sin(rad);
          }
          const quadrant13 = quadrant === 1 || quadrant === 3;
          switch (relativeDirection) {
            case "top":
            case "bottom":
              dHeight = dy2 ? dy2 / (quadrant13 ? Math.cos(rad) : Math.sin(rad)) : dx2 / (quadrant13 ? Math.sin(rad) : Math.cos(rad));
              break;
            case "left":
            case "right":
              dWidth = dx2 ? dx2 / (quadrant13 ? Math.cos(rad) : Math.sin(rad)) : dy2 / (quadrant13 ? Math.sin(rad) : Math.cos(rad));
              break;
          }
        }
        switch (relativeDirection) {
          case "top":
          case "bottom":
            dWidth = 0;
            break;
          case "left":
          case "right":
            dHeight = 0;
            break;
        }
        const gridSize = this.graph.getGridSize();
        let newWidth = Math.max(nodeBbox.width + dWidth, gridSize);
        let newHeight = Math.max(nodeBbox.height + dHeight, gridSize);
        if (options.minWidth && options.minWidth > gridSize) {
          newWidth = Math.max(newWidth, options.minWidth);
        }
        if (options.minHeight && options.minHeight > gridSize) {
          newHeight = Math.max(newHeight, options.minHeight);
        }
        if (options.maxWidth) {
          newWidth = Math.min(newWidth, options.maxWidth);
        }
        if (options.maxHeight) {
          newHeight = Math.min(newHeight, options.maxHeight);
        }
        if (options.preserveAspectRatio) {
          if (dHeight < dWidth) {
            newHeight = newWidth * (nodeBbox.height / nodeBbox.width);
          } else {
            newWidth = newHeight * (nodeBbox.width / nodeBbox.height);
          }
        }
        if (newWidth !== nodeBbox.width || newHeight !== nodeBbox.height) {
          node.resize(newWidth, newHeight, {
            direction,
            relativeDirection,
            trueDirection,
            snapped: true,
            snaplines: this.cid,
            restrict: this.getRestrictArea(view)
          });
          if (verticalHeight) {
            verticalHeight += newHeight - nodeBbox.height;
          }
          if (horizontalWidth) {
            horizontalWidth += newWidth - nodeBbox.width;
          }
        }
        const newRotatedBBox = node.getBBox().bbox(angle);
        if (verticalLeft && Math.abs(newRotatedBBox.x - verticalLeft) > 1 && Math.abs(newRotatedBBox.width + newRotatedBBox.x - verticalLeft) > 1) {
          verticalLeft = void 0;
        }
        if (horizontalTop && Math.abs(newRotatedBBox.y - horizontalTop) > 1 && Math.abs(newRotatedBBox.height + newRotatedBBox.y - horizontalTop) > 1) {
          horizontalTop = void 0;
        }
        this.update({
          verticalLeft,
          verticalTop,
          verticalHeight,
          horizontalTop,
          horizontalLeft,
          horizontalWidth
        });
      }
    }
  }
  snapOnMoving({ view, e: e10, x: x2, y: y2 }) {
    const targetView = view.getEventData(e10).delegatedView || view;
    if (!this.isNodeMovable(targetView)) {
      return;
    }
    const node = targetView.cell;
    const size = node.getSize();
    const position2 = node.getPosition();
    const cellBBox = new Rectangle(x2 - this.offset.x, y2 - this.offset.y, size.width, size.height);
    const angle = node.getAngle();
    const nodeCenter = cellBBox.getCenter();
    const nodeBBoxRotated = cellBBox.bbox(angle);
    const nodeTopLeft = nodeBBoxRotated.getTopLeft();
    const nodeBottomRight = nodeBBoxRotated.getBottomRight();
    const distance = this.options.tolerance || 0;
    let verticalLeft;
    let verticalTop;
    let verticalHeight;
    let horizontalTop;
    let horizontalLeft;
    let horizontalWidth;
    let verticalFix = 0;
    let horizontalFix = 0;
    this.model.getNodes().some((targetNode) => {
      if (this.isIgnored(node, targetNode)) {
        return false;
      }
      const snapBBox = targetNode.getBBox().bbox(targetNode.getAngle());
      const snapCenter = snapBBox.getCenter();
      const snapTopLeft = snapBBox.getTopLeft();
      const snapBottomRight = snapBBox.getBottomRight();
      if (verticalLeft == null) {
        if (Math.abs(snapCenter.x - nodeCenter.x) < distance) {
          verticalLeft = snapCenter.x;
          verticalFix = 0.5;
        } else if (Math.abs(snapTopLeft.x - nodeTopLeft.x) < distance) {
          verticalLeft = snapTopLeft.x;
          verticalFix = 0;
        } else if (Math.abs(snapTopLeft.x - nodeBottomRight.x) < distance) {
          verticalLeft = snapTopLeft.x;
          verticalFix = 1;
        } else if (Math.abs(snapBottomRight.x - nodeBottomRight.x) < distance) {
          verticalLeft = snapBottomRight.x;
          verticalFix = 1;
        } else if (Math.abs(snapBottomRight.x - nodeTopLeft.x) < distance) {
          verticalLeft = snapBottomRight.x;
        }
        if (verticalLeft != null) {
          verticalTop = Math.min(nodeBBoxRotated.y, snapBBox.y);
          verticalHeight = Math.max(nodeBottomRight.y, snapBottomRight.y) - verticalTop;
        }
      }
      if (horizontalTop == null) {
        if (Math.abs(snapCenter.y - nodeCenter.y) < distance) {
          horizontalTop = snapCenter.y;
          horizontalFix = 0.5;
        } else if (Math.abs(snapTopLeft.y - nodeTopLeft.y) < distance) {
          horizontalTop = snapTopLeft.y;
        } else if (Math.abs(snapTopLeft.y - nodeBottomRight.y) < distance) {
          horizontalTop = snapTopLeft.y;
          horizontalFix = 1;
        } else if (Math.abs(snapBottomRight.y - nodeBottomRight.y) < distance) {
          horizontalTop = snapBottomRight.y;
          horizontalFix = 1;
        } else if (Math.abs(snapBottomRight.y - nodeTopLeft.y) < distance) {
          horizontalTop = snapBottomRight.y;
        }
        if (horizontalTop != null) {
          horizontalLeft = Math.min(nodeBBoxRotated.x, snapBBox.x);
          horizontalWidth = Math.max(nodeBottomRight.x, snapBottomRight.x) - horizontalLeft;
        }
      }
      return verticalLeft != null && horizontalTop != null;
    });
    this.hide();
    if (horizontalTop != null || verticalLeft != null) {
      if (horizontalTop != null) {
        nodeBBoxRotated.y = horizontalTop - horizontalFix * nodeBBoxRotated.height;
      }
      if (verticalLeft != null) {
        nodeBBoxRotated.x = verticalLeft - verticalFix * nodeBBoxRotated.width;
      }
      const newCenter = nodeBBoxRotated.getCenter();
      const newX = newCenter.x - cellBBox.width / 2;
      const newY = newCenter.y - cellBBox.height / 2;
      const dx2 = newX - position2.x;
      const dy2 = newY - position2.y;
      if (dx2 !== 0 || dy2 !== 0) {
        node.translate(dx2, dy2, {
          snapped: true,
          restrict: this.getRestrictArea(targetView)
        });
        if (horizontalWidth) {
          horizontalWidth += dx2;
        }
        if (verticalHeight) {
          verticalHeight += dy2;
        }
      }
      this.update({
        verticalLeft,
        verticalTop,
        verticalHeight,
        horizontalTop,
        horizontalLeft,
        horizontalWidth
      });
    }
  }
  isIgnored(snapNode, targetNode) {
    return targetNode.id === snapNode.id || targetNode.isDescendantOf(snapNode) || !this.filter(targetNode);
  }
  filter(node) {
    const filter = this.options.filter;
    if (Array.isArray(filter)) {
      return filter.some((item) => {
        if (typeof item === "string") {
          return node.shape === item;
        }
        return node.id === item.id;
      });
    }
    if (typeof filter === "function") {
      return FunctionExt.call(filter, this.graph, node);
    }
    return true;
  }
  update(metadata) {
    if (metadata.horizontalTop) {
      const start = this.graph.localToGraph(new Point(metadata.horizontalLeft, metadata.horizontalTop));
      const end = this.graph.localToGraph(new Point(metadata.horizontalLeft + metadata.horizontalWidth, metadata.horizontalTop));
      this.horizontal.setAttributes({
        x1: this.options.sharp ? `${start.x}` : "0",
        y1: `${start.y}`,
        x2: this.options.sharp ? `${end.x}` : "100%",
        y2: `${end.y}`,
        display: "inherit"
      });
    } else {
      this.horizontal.setAttribute("display", "none");
    }
    if (metadata.verticalLeft) {
      const start = this.graph.localToGraph(new Point(metadata.verticalLeft, metadata.verticalTop));
      const end = this.graph.localToGraph(new Point(metadata.verticalLeft, metadata.verticalTop + metadata.verticalHeight));
      this.vertical.setAttributes({
        x1: `${start.x}`,
        y1: this.options.sharp ? `${start.y}` : "0",
        x2: `${end.x}`,
        y2: this.options.sharp ? `${end.y}` : "100%",
        display: "inherit"
      });
    } else {
      this.vertical.setAttribute("display", "none");
    }
    this.show();
  }
  resetTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  show() {
    this.resetTimer();
    if (this.container.parentNode == null) {
      this.graph.container.appendChild(this.container);
    }
    return this;
  }
  hide() {
    this.resetTimer();
    this.vertical.setAttribute("display", "none");
    this.horizontal.setAttribute("display", "none");
    const clean = this.options.clean;
    const delay = typeof clean === "number" ? clean : clean !== false ? 3e3 : 0;
    if (delay > 0) {
      this.timer = window.setTimeout(() => {
        if (this.container.parentNode !== null) {
          this.unmount();
        }
      }, delay);
    }
    return this;
  }
  onRemove() {
    this.stopListening();
    this.hide();
  }
  dispose() {
    this.remove();
  }
}
__decorate$a([
  View.dispose()
], SnaplineImpl.prototype, "dispose", null);
const content$4 = `.x6-widget-snapline {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
.x6-widget-snapline-vertical,
.x6-widget-snapline-horizontal {
  stroke: #2ecc71;
  stroke-width: 1px;
}
`;
Graph$2.prototype.isSnaplineEnabled = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    return snapline.isEnabled();
  }
  return false;
};
Graph$2.prototype.enableSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.enable();
  }
  return this;
};
Graph$2.prototype.disableSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.disable();
  }
  return this;
};
Graph$2.prototype.toggleSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.toggleEnabled();
  }
  return this;
};
Graph$2.prototype.hideSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.hide();
  }
  return this;
};
Graph$2.prototype.setSnaplineFilter = function(filter) {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.setFilter(filter);
  }
  return this;
};
Graph$2.prototype.isSnaplineOnResizingEnabled = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    return snapline.isOnResizingEnabled();
  }
  return false;
};
Graph$2.prototype.enableSnaplineOnResizing = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.enableOnResizing();
  }
  return this;
};
Graph$2.prototype.disableSnaplineOnResizing = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.disableOnResizing();
  }
  return this;
};
Graph$2.prototype.toggleSnaplineOnResizing = function(enableOnResizing) {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.toggleOnResizing(enableOnResizing);
  }
  return this;
};
Graph$2.prototype.isSharpSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    return snapline.isSharp();
  }
  return false;
};
Graph$2.prototype.enableSharpSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.enableSharp();
  }
  return this;
};
Graph$2.prototype.disableSharpSnapline = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.disableSharp();
  }
  return this;
};
Graph$2.prototype.toggleSharpSnapline = function(sharp) {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.toggleSharp(sharp);
  }
  return this;
};
Graph$2.prototype.getSnaplineTolerance = function() {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    return snapline.getTolerance();
  }
};
Graph$2.prototype.setSnaplineTolerance = function(tolerance) {
  const snapline = this.getPlugin("snapline");
  if (snapline) {
    snapline.setTolerance(tolerance);
  }
  return this;
};
var __decorate$9 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Snapline extends Disposable {
  constructor(options = {}) {
    super();
    this.name = "snapline";
    this.options = Object.assign({ enabled: true, tolerance: 10 }, options);
    CssLoader.ensure(this.name, content$4);
  }
  init(graph) {
    this.snaplineImpl = new SnaplineImpl(Object.assign(Object.assign({}, this.options), { graph }));
  }
  // #region api
  isEnabled() {
    return !this.snaplineImpl.disabled;
  }
  enable() {
    this.snaplineImpl.enable();
  }
  disable() {
    this.snaplineImpl.disable();
  }
  toggleEnabled(enabled) {
    if (enabled != null) {
      if (enabled !== this.isEnabled()) {
        if (enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    } else {
      if (this.isEnabled()) {
        this.disable();
      } else {
        this.enable();
      }
      return this;
    }
  }
  hide() {
    this.snaplineImpl.hide();
    return this;
  }
  setFilter(filter) {
    this.snaplineImpl.setFilter(filter);
    return this;
  }
  isOnResizingEnabled() {
    return this.snaplineImpl.options.resizing === true;
  }
  enableOnResizing() {
    this.snaplineImpl.options.resizing = true;
    return this;
  }
  disableOnResizing() {
    this.snaplineImpl.options.resizing = false;
    return this;
  }
  toggleOnResizing(enableOnResizing) {
    if (enableOnResizing != null) {
      if (enableOnResizing !== this.isOnResizingEnabled()) {
        if (enableOnResizing) {
          this.enableOnResizing();
        } else {
          this.disableOnResizing();
        }
      }
    } else if (this.isOnResizingEnabled()) {
      this.disableOnResizing();
    } else {
      this.enableOnResizing();
    }
    return this;
  }
  isSharp() {
    return this.snaplineImpl.options.sharp === true;
  }
  enableSharp() {
    this.snaplineImpl.options.sharp = true;
    return this;
  }
  disableSharp() {
    this.snaplineImpl.options.sharp = false;
    return this;
  }
  toggleSharp(sharp) {
    if (sharp != null) {
      if (sharp !== this.isSharp()) {
        if (sharp) {
          this.enableSharp();
        } else {
          this.disableSharp();
        }
      }
    } else if (this.isSharp()) {
      this.disableSharp();
    } else {
      this.enableSharp();
    }
    return this;
  }
  getTolerance() {
    return this.snaplineImpl.options.tolerance;
  }
  setTolerance(tolerance) {
    this.snaplineImpl.options.tolerance = tolerance;
    return this;
  }
  captureCursorOffset(e10) {
    this.snaplineImpl.captureCursorOffset(e10);
  }
  snapOnMoving(args) {
    this.snaplineImpl.snapOnMoving(args);
  }
  // #endregion
  dispose() {
    this.snaplineImpl.dispose();
    CssLoader.clean(this.name);
  }
}
__decorate$9([
  Disposable.dispose()
], Snapline.prototype, "dispose", null);
var mousetrap = { exports: {} };
(function(module) {
  (function(window2, document2, undefined$1) {
    if (!window2) {
      return;
    }
    var _MAP = {
      8: "backspace",
      9: "tab",
      13: "enter",
      16: "shift",
      17: "ctrl",
      18: "alt",
      20: "capslock",
      27: "esc",
      32: "space",
      33: "pageup",
      34: "pagedown",
      35: "end",
      36: "home",
      37: "left",
      38: "up",
      39: "right",
      40: "down",
      45: "ins",
      46: "del",
      91: "meta",
      93: "meta",
      224: "meta"
    };
    var _KEYCODE_MAP = {
      106: "*",
      107: "+",
      109: "-",
      110: ".",
      111: "/",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'"
    };
    var _SHIFT_MAP = {
      "~": "`",
      "!": "1",
      "@": "2",
      "#": "3",
      "$": "4",
      "%": "5",
      "^": "6",
      "&": "7",
      "*": "8",
      "(": "9",
      ")": "0",
      "_": "-",
      "+": "=",
      ":": ";",
      '"': "'",
      "<": ",",
      ">": ".",
      "?": "/",
      "|": "\\"
    };
    var _SPECIAL_ALIASES = {
      "option": "alt",
      "command": "meta",
      "return": "enter",
      "escape": "esc",
      "plus": "+",
      "mod": /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
    };
    var _REVERSE_MAP;
    for (var i2 = 1; i2 < 20; ++i2) {
      _MAP[111 + i2] = "f" + i2;
    }
    for (i2 = 0; i2 <= 9; ++i2) {
      _MAP[i2 + 96] = i2.toString();
    }
    function _addEvent(object4, type4, callback) {
      if (object4.addEventListener) {
        object4.addEventListener(type4, callback, false);
        return;
      }
      object4.attachEvent("on" + type4, callback);
    }
    function _characterFromEvent(e10) {
      if (e10.type == "keypress") {
        var character = String.fromCharCode(e10.which);
        if (!e10.shiftKey) {
          character = character.toLowerCase();
        }
        return character;
      }
      if (_MAP[e10.which]) {
        return _MAP[e10.which];
      }
      if (_KEYCODE_MAP[e10.which]) {
        return _KEYCODE_MAP[e10.which];
      }
      return String.fromCharCode(e10.which).toLowerCase();
    }
    function _modifiersMatch(modifiers1, modifiers2) {
      return modifiers1.sort().join(",") === modifiers2.sort().join(",");
    }
    function _eventModifiers(e10) {
      var modifiers = [];
      if (e10.shiftKey) {
        modifiers.push("shift");
      }
      if (e10.altKey) {
        modifiers.push("alt");
      }
      if (e10.ctrlKey) {
        modifiers.push("ctrl");
      }
      if (e10.metaKey) {
        modifiers.push("meta");
      }
      return modifiers;
    }
    function _preventDefault(e10) {
      if (e10.preventDefault) {
        e10.preventDefault();
        return;
      }
      e10.returnValue = false;
    }
    function _stopPropagation(e10) {
      if (e10.stopPropagation) {
        e10.stopPropagation();
        return;
      }
      e10.cancelBubble = true;
    }
    function _isModifier(key) {
      return key == "shift" || key == "ctrl" || key == "alt" || key == "meta";
    }
    function _getReverseMap() {
      if (!_REVERSE_MAP) {
        _REVERSE_MAP = {};
        for (var key in _MAP) {
          if (key > 95 && key < 112) {
            continue;
          }
          if (_MAP.hasOwnProperty(key)) {
            _REVERSE_MAP[_MAP[key]] = key;
          }
        }
      }
      return _REVERSE_MAP;
    }
    function _pickBestAction(key, modifiers, action) {
      if (!action) {
        action = _getReverseMap()[key] ? "keydown" : "keypress";
      }
      if (action == "keypress" && modifiers.length) {
        action = "keydown";
      }
      return action;
    }
    function _keysFromString(combination) {
      if (combination === "+") {
        return ["+"];
      }
      combination = combination.replace(/\+{2}/g, "+plus");
      return combination.split("+");
    }
    function _getKeyInfo(combination, action) {
      var keys;
      var key;
      var i3;
      var modifiers = [];
      keys = _keysFromString(combination);
      for (i3 = 0; i3 < keys.length; ++i3) {
        key = keys[i3];
        if (_SPECIAL_ALIASES[key]) {
          key = _SPECIAL_ALIASES[key];
        }
        if (action && action != "keypress" && _SHIFT_MAP[key]) {
          key = _SHIFT_MAP[key];
          modifiers.push("shift");
        }
        if (_isModifier(key)) {
          modifiers.push(key);
        }
      }
      action = _pickBestAction(key, modifiers, action);
      return {
        key,
        modifiers,
        action
      };
    }
    function _belongsTo(element, ancestor) {
      if (element === null || element === document2) {
        return false;
      }
      if (element === ancestor) {
        return true;
      }
      return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap2(targetElement) {
      var self2 = this;
      targetElement = targetElement || document2;
      if (!(self2 instanceof Mousetrap2)) {
        return new Mousetrap2(targetElement);
      }
      self2.target = targetElement;
      self2._callbacks = {};
      self2._directMap = {};
      var _sequenceLevels = {};
      var _resetTimer;
      var _ignoreNextKeyup = false;
      var _ignoreNextKeypress = false;
      var _nextExpectedAction = false;
      function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};
        var activeSequences = false, key;
        for (key in _sequenceLevels) {
          if (doNotReset[key]) {
            activeSequences = true;
            continue;
          }
          _sequenceLevels[key] = 0;
        }
        if (!activeSequences) {
          _nextExpectedAction = false;
        }
      }
      function _getMatches(character, modifiers, e10, sequenceName, combination, level) {
        var i3;
        var callback;
        var matches = [];
        var action = e10.type;
        if (!self2._callbacks[character]) {
          return [];
        }
        if (action == "keyup" && _isModifier(character)) {
          modifiers = [character];
        }
        for (i3 = 0; i3 < self2._callbacks[character].length; ++i3) {
          callback = self2._callbacks[character][i3];
          if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
            continue;
          }
          if (action != callback.action) {
            continue;
          }
          if (action == "keypress" && !e10.metaKey && !e10.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
            var deleteCombo = !sequenceName && callback.combo == combination;
            var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
            if (deleteCombo || deleteSequence) {
              self2._callbacks[character].splice(i3, 1);
            }
            matches.push(callback);
          }
        }
        return matches;
      }
      function _fireCallback(callback, e10, combo, sequence) {
        if (self2.stopCallback(e10, e10.target || e10.srcElement, combo, sequence)) {
          return;
        }
        if (callback(e10, combo) === false) {
          _preventDefault(e10);
          _stopPropagation(e10);
        }
      }
      self2._handleKey = function(character, modifiers, e10) {
        var callbacks = _getMatches(character, modifiers, e10);
        var i3;
        var doNotReset = {};
        var maxLevel = 0;
        var processedSequenceCallback = false;
        for (i3 = 0; i3 < callbacks.length; ++i3) {
          if (callbacks[i3].seq) {
            maxLevel = Math.max(maxLevel, callbacks[i3].level);
          }
        }
        for (i3 = 0; i3 < callbacks.length; ++i3) {
          if (callbacks[i3].seq) {
            if (callbacks[i3].level != maxLevel) {
              continue;
            }
            processedSequenceCallback = true;
            doNotReset[callbacks[i3].seq] = 1;
            _fireCallback(callbacks[i3].callback, e10, callbacks[i3].combo, callbacks[i3].seq);
            continue;
          }
          if (!processedSequenceCallback) {
            _fireCallback(callbacks[i3].callback, e10, callbacks[i3].combo);
          }
        }
        var ignoreThisKeypress = e10.type == "keypress" && _ignoreNextKeypress;
        if (e10.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
          _resetSequences(doNotReset);
        }
        _ignoreNextKeypress = processedSequenceCallback && e10.type == "keydown";
      };
      function _handleKeyEvent(e10) {
        if (typeof e10.which !== "number") {
          e10.which = e10.keyCode;
        }
        var character = _characterFromEvent(e10);
        if (!character) {
          return;
        }
        if (e10.type == "keyup" && _ignoreNextKeyup === character) {
          _ignoreNextKeyup = false;
          return;
        }
        self2.handleKey(character, _eventModifiers(e10), e10);
      }
      function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1e3);
      }
      function _bindSequence(combo, keys, callback, action) {
        _sequenceLevels[combo] = 0;
        function _increaseSequence(nextAction) {
          return function() {
            _nextExpectedAction = nextAction;
            ++_sequenceLevels[combo];
            _resetSequenceTimer();
          };
        }
        function _callbackAndReset(e10) {
          _fireCallback(callback, e10, combo);
          if (action !== "keyup") {
            _ignoreNextKeyup = _characterFromEvent(e10);
          }
          setTimeout(_resetSequences, 10);
        }
        for (var i3 = 0; i3 < keys.length; ++i3) {
          var isFinal = i3 + 1 === keys.length;
          var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i3 + 1]).action);
          _bindSingle(keys[i3], wrappedCallback, action, combo, i3);
        }
      }
      function _bindSingle(combination, callback, action, sequenceName, level) {
        self2._directMap[combination + ":" + action] = callback;
        combination = combination.replace(/\s+/g, " ");
        var sequence = combination.split(" ");
        var info;
        if (sequence.length > 1) {
          _bindSequence(combination, sequence, callback, action);
          return;
        }
        info = _getKeyInfo(combination, action);
        self2._callbacks[info.key] = self2._callbacks[info.key] || [];
        _getMatches(info.key, info.modifiers, { type: info.action }, sequenceName, combination, level);
        self2._callbacks[info.key][sequenceName ? "unshift" : "push"]({
          callback,
          modifiers: info.modifiers,
          action: info.action,
          seq: sequenceName,
          level,
          combo: combination
        });
      }
      self2._bindMultiple = function(combinations, callback, action) {
        for (var i3 = 0; i3 < combinations.length; ++i3) {
          _bindSingle(combinations[i3], callback, action);
        }
      };
      _addEvent(targetElement, "keypress", _handleKeyEvent);
      _addEvent(targetElement, "keydown", _handleKeyEvent);
      _addEvent(targetElement, "keyup", _handleKeyEvent);
    }
    Mousetrap2.prototype.bind = function(keys, callback, action) {
      var self2 = this;
      keys = keys instanceof Array ? keys : [keys];
      self2._bindMultiple.call(self2, keys, callback, action);
      return self2;
    };
    Mousetrap2.prototype.unbind = function(keys, action) {
      var self2 = this;
      return self2.bind.call(self2, keys, function() {
      }, action);
    };
    Mousetrap2.prototype.trigger = function(keys, action) {
      var self2 = this;
      if (self2._directMap[keys + ":" + action]) {
        self2._directMap[keys + ":" + action]({}, keys);
      }
      return self2;
    };
    Mousetrap2.prototype.reset = function() {
      var self2 = this;
      self2._callbacks = {};
      self2._directMap = {};
      return self2;
    };
    Mousetrap2.prototype.stopCallback = function(e10, element) {
      var self2 = this;
      if ((" " + element.className + " ").indexOf(" mousetrap ") > -1) {
        return false;
      }
      if (_belongsTo(element, self2.target)) {
        return false;
      }
      if ("composedPath" in e10 && typeof e10.composedPath === "function") {
        var initialEventTarget = e10.composedPath()[0];
        if (initialEventTarget !== e10.target) {
          element = initialEventTarget;
        }
      }
      return element.tagName == "INPUT" || element.tagName == "SELECT" || element.tagName == "TEXTAREA" || element.isContentEditable;
    };
    Mousetrap2.prototype.handleKey = function() {
      var self2 = this;
      return self2._handleKey.apply(self2, arguments);
    };
    Mousetrap2.addKeycodes = function(object4) {
      for (var key in object4) {
        if (object4.hasOwnProperty(key)) {
          _MAP[key] = object4[key];
        }
      }
      _REVERSE_MAP = null;
    };
    Mousetrap2.init = function() {
      var documentMousetrap = Mousetrap2(document2);
      for (var method4 in documentMousetrap) {
        if (method4.charAt(0) !== "_") {
          Mousetrap2[method4] = /* @__PURE__ */ function(method5) {
            return function() {
              return documentMousetrap[method5].apply(documentMousetrap, arguments);
            };
          }(method4);
        }
      }
    };
    Mousetrap2.init();
    window2.Mousetrap = Mousetrap2;
    if (module.exports) {
      module.exports = Mousetrap2;
    }
  })(typeof window !== "undefined" ? window : null, typeof window !== "undefined" ? document : null);
})(mousetrap);
var mousetrapExports = mousetrap.exports;
const Mousetrap = /* @__PURE__ */ getDefaultExportFromCjs(mousetrapExports);
var __decorate$8 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class KeyboardImpl extends Disposable {
  get graph() {
    return this.options.graph;
  }
  constructor(options) {
    super();
    this.options = options;
    const scroller = this.graph.getPlugin("scroller");
    this.container = scroller ? scroller.container : this.graph.container;
    if (options.global) {
      this.target = document;
    } else {
      this.target = this.container;
      if (!this.disabled) {
        this.target.setAttribute("tabindex", "-1");
      }
      this.graph.on("cell:mouseup", this.focus, this);
      this.graph.on("blank:mouseup", this.focus, this);
    }
    this.mousetrap = KeyboardImpl.createMousetrap(this);
  }
  get disabled() {
    return this.options.enabled !== true;
  }
  enable() {
    if (this.disabled) {
      this.options.enabled = true;
      if (this.target instanceof HTMLElement) {
        this.target.setAttribute("tabindex", "-1");
      }
    }
  }
  disable() {
    if (!this.disabled) {
      this.options.enabled = false;
      if (this.target instanceof HTMLElement) {
        this.target.removeAttribute("tabindex");
      }
    }
  }
  on(keys, callback, action) {
    this.mousetrap.bind(this.getKeys(keys), callback, action);
  }
  off(keys, action) {
    this.mousetrap.unbind(this.getKeys(keys), action);
  }
  clear() {
    this.mousetrap.reset();
  }
  trigger(key, action) {
    this.mousetrap.trigger(key, action);
  }
  focus(e10) {
    const isInputEvent = this.isInputEvent(e10.e);
    if (isInputEvent) {
      return;
    }
    const target = this.target;
    target.focus({
      preventScroll: true
    });
  }
  getKeys(keys) {
    return (Array.isArray(keys) ? keys : [keys]).map((key) => this.formatkey(key));
  }
  formatkey(key) {
    const formated = key.toLocaleLowerCase().replace(/\s/g, "").replace("delete", "del").replace("cmd", "command").replace("arrowup", "up").replace("arrowright", "right").replace("arrowdown", "down").replace("arrowleft", "left");
    const formatFn = this.options.format;
    if (formatFn) {
      return FunctionExt.call(formatFn, this.graph, formated);
    }
    return formated;
  }
  isGraphEvent(e10) {
    const target = e10.target;
    const currentTarget = e10.currentTarget;
    if (target) {
      if (target === this.target || currentTarget === this.target || target === document.body) {
        return true;
      }
      return Dom.contains(this.container, target);
    }
    return false;
  }
  isInputEvent(e10) {
    var _a3;
    const target = e10.target;
    const tagName = (_a3 = target === null || target === void 0 ? void 0 : target.tagName) === null || _a3 === void 0 ? void 0 : _a3.toLowerCase();
    let isInput = ["input", "textarea"].includes(tagName);
    if (Dom.attr(target, "contenteditable") === "true") {
      isInput = true;
    }
    return isInput;
  }
  isEnabledForEvent(e10) {
    const allowed = !this.disabled && this.isGraphEvent(e10);
    const isInputEvent = this.isInputEvent(e10);
    if (allowed) {
      if (isInputEvent && (e10.key === "Backspace" || e10.key === "Delete")) {
        return false;
      }
      if (this.options.guard) {
        return FunctionExt.call(this.options.guard, this.graph, e10);
      }
    }
    return allowed;
  }
  dispose() {
    this.mousetrap.reset();
  }
}
__decorate$8([
  Disposable.dispose()
], KeyboardImpl.prototype, "dispose", null);
(function(KeyboardImpl2) {
  function createMousetrap(keyboard) {
    const mousetrap2 = new Mousetrap(keyboard.target);
    const stopCallback = mousetrap2.stopCallback;
    mousetrap2.stopCallback = (e10, elem, combo) => {
      if (keyboard.isEnabledForEvent(e10)) {
        if (stopCallback) {
          return stopCallback.call(mousetrap2, e10, elem, combo);
        }
        return false;
      }
      return true;
    };
    return mousetrap2;
  }
  KeyboardImpl2.createMousetrap = createMousetrap;
})(KeyboardImpl || (KeyboardImpl = {}));
Graph$2.prototype.isKeyboardEnabled = function() {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    return keyboard.isEnabled();
  }
  return false;
};
Graph$2.prototype.enableKeyboard = function() {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.enable();
  }
  return this;
};
Graph$2.prototype.disableKeyboard = function() {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.disable();
  }
  return this;
};
Graph$2.prototype.toggleKeyboard = function(enabled) {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.toggleEnabled(enabled);
  }
  return this;
};
Graph$2.prototype.bindKey = function(keys, callback, action) {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.bindKey(keys, callback, action);
  }
  return this;
};
Graph$2.prototype.unbindKey = function(keys, action) {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.unbindKey(keys, action);
  }
  return this;
};
Graph$2.prototype.clearKeys = function() {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.clear();
  }
  return this;
};
Graph$2.prototype.triggerKey = function(key, action) {
  const keyboard = this.getPlugin("keyboard");
  if (keyboard) {
    keyboard.trigger(key, action);
  }
  return this;
};
var __decorate$7 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Keyboard extends Disposable {
  constructor(options = {}) {
    super();
    this.name = "keyboard";
    this.options = Object.assign({ enabled: true }, options);
  }
  init(graph) {
    this.keyboardImpl = new KeyboardImpl(Object.assign(Object.assign({}, this.options), { graph }));
  }
  // #region api
  isEnabled() {
    return !this.keyboardImpl.disabled;
  }
  enable() {
    this.keyboardImpl.enable();
  }
  disable() {
    this.keyboardImpl.disable();
  }
  toggleEnabled(enabled) {
    if (enabled != null) {
      if (enabled !== this.isEnabled()) {
        if (enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    } else if (this.isEnabled()) {
      this.disable();
    } else {
      this.enable();
    }
    return this;
  }
  bindKey(keys, callback, action) {
    this.keyboardImpl.on(keys, callback, action);
    return this;
  }
  trigger(key, action) {
    this.keyboardImpl.trigger(key, action);
    return this;
  }
  clear() {
    this.keyboardImpl.clear();
    return this;
  }
  unbindKey(keys, action) {
    this.keyboardImpl.off(keys, action);
    return this;
  }
  // #endregion
  dispose() {
    this.keyboardImpl.dispose();
  }
}
__decorate$7([
  Disposable.dispose()
], Keyboard.prototype, "dispose", null);
class ClipboardImpl {
  constructor() {
    this.cells = [];
  }
  copy(cells, graph, options = {}) {
    this.options = Object.assign({}, options);
    const model = Model.isModel(graph) ? graph : graph.model;
    const cloned = model.cloneSubGraph(cells, options);
    this.cells = ArrayExt.sortBy(Object.keys(cloned).map((key) => cloned[key]), (cell) => cell.isEdge() ? 2 : 1);
    this.serialize(options);
  }
  cut(cells, graph, options = {}) {
    this.copy(cells, graph, options);
    const model = Graph$2.isGraph(graph) ? graph.model : graph;
    model.batchUpdate("cut", () => {
      cells.forEach((cell) => cell.remove());
    });
  }
  paste(graph, options = {}) {
    const localOptions = Object.assign(Object.assign({}, this.options), options);
    const { offset, edgeProps, nodeProps } = localOptions;
    let dx2 = 20;
    let dy2 = 20;
    if (offset) {
      dx2 = typeof offset === "number" ? offset : offset.dx;
      dy2 = typeof offset === "number" ? offset : offset.dy;
    }
    this.deserialize(localOptions);
    const cells = this.cells;
    cells.forEach((cell) => {
      cell.model = null;
      cell.removeProp("zIndex");
      if (dx2 || dy2) {
        cell.translate(dx2, dy2);
      }
      if (nodeProps && cell.isNode()) {
        cell.prop(nodeProps);
      }
      if (edgeProps && cell.isEdge()) {
        cell.prop(edgeProps);
      }
    });
    const model = Graph$2.isGraph(graph) ? graph.model : graph;
    model.batchUpdate("paste", () => {
      model.addCells(this.cells);
    });
    this.copy(cells, graph, options);
    return cells;
  }
  serialize(options) {
    if (options.useLocalStorage !== false) {
      Storage.save(this.cells);
    }
  }
  deserialize(options) {
    if (options.useLocalStorage) {
      const cells = Storage.fetch();
      if (cells) {
        this.cells = cells;
      }
    }
  }
  isEmpty(options = {}) {
    if (options.useLocalStorage) {
      this.deserialize(options);
    }
    return this.cells.length <= 0;
  }
  clean() {
    this.options = {};
    this.cells = [];
    Storage.clean();
  }
}
var Storage;
(function(Storage2) {
  const LOCAL_STORAGE_KEY = `${Config.prefixCls}.clipboard.cells`;
  function save(cells) {
    if (window.localStorage) {
      const data = cells.map((cell) => cell.toJSON());
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
    }
  }
  Storage2.save = save;
  function fetch2() {
    if (window.localStorage) {
      const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
      const cells = raw ? JSON.parse(raw) : [];
      if (cells) {
        return Model.fromJSON(cells);
      }
    }
  }
  Storage2.fetch = fetch2;
  function clean() {
    if (window.localStorage) {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
  }
  Storage2.clean = clean;
})(Storage || (Storage = {}));
Graph$2.prototype.isClipboardEnabled = function() {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    return clipboard.isEnabled();
  }
  return false;
};
Graph$2.prototype.enableClipboard = function() {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.enable();
  }
  return this;
};
Graph$2.prototype.disableClipboard = function() {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.disable();
  }
  return this;
};
Graph$2.prototype.toggleClipboard = function(enabled) {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.toggleEnabled(enabled);
  }
  return this;
};
Graph$2.prototype.isClipboardEmpty = function(options) {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    return clipboard.isEmpty(options);
  }
  return true;
};
Graph$2.prototype.getCellsInClipboard = function() {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    return clipboard.getCellsInClipboard();
  }
  return [];
};
Graph$2.prototype.cleanClipboard = function() {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.clean();
  }
  return this;
};
Graph$2.prototype.copy = function(cells, options) {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.copy(cells, options);
  }
  return this;
};
Graph$2.prototype.cut = function(cells, options) {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    clipboard.cut(cells, options);
  }
  return this;
};
Graph$2.prototype.paste = function(options, graph) {
  const clipboard = this.getPlugin("clipboard");
  if (clipboard) {
    return clipboard.paste(options, graph);
  }
  return [];
};
var __decorate$6 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
var __rest$1 = function(s2, e10) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e10.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e10.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
class Clipboard extends Basecoat {
  get disabled() {
    return this.options.enabled !== true;
  }
  get cells() {
    return this.clipboardImpl.cells;
  }
  constructor(options = {}) {
    super();
    this.name = "clipboard";
    this.options = Object.assign({ enabled: true }, options);
  }
  init(graph) {
    this.graph = graph;
    this.clipboardImpl = new ClipboardImpl();
    this.clipboardImpl.deserialize(this.options);
  }
  // #region api
  isEnabled() {
    return !this.disabled;
  }
  enable() {
    if (this.disabled) {
      this.options.enabled = true;
    }
  }
  disable() {
    if (!this.disabled) {
      this.options.enabled = false;
    }
  }
  toggleEnabled(enabled) {
    if (enabled != null) {
      if (enabled !== this.isEnabled()) {
        if (enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    } else if (this.isEnabled()) {
      this.disable();
    } else {
      this.enable();
    }
    return this;
  }
  isEmpty(options = {}) {
    return this.clipboardImpl.isEmpty(options);
  }
  getCellsInClipboard() {
    return this.cells;
  }
  clean(force) {
    if (!this.disabled || force) {
      this.clipboardImpl.clean();
      this.notify("clipboard:changed", { cells: [] });
    }
    return this;
  }
  copy(cells, options = {}) {
    if (!this.disabled) {
      this.clipboardImpl.copy(cells, this.graph, Object.assign(Object.assign({}, this.commonOptions), options));
      this.notify("clipboard:changed", { cells });
    }
    return this;
  }
  cut(cells, options = {}) {
    if (!this.disabled) {
      this.clipboardImpl.cut(cells, this.graph, Object.assign(Object.assign({}, this.commonOptions), options));
      this.notify("clipboard:changed", { cells });
    }
    return this;
  }
  paste(options = {}, graph = this.graph) {
    if (!this.disabled) {
      return this.clipboardImpl.paste(graph, Object.assign(Object.assign({}, this.commonOptions), options));
    }
    return [];
  }
  // #endregion
  get commonOptions() {
    const _a3 = this.options, { enabled } = _a3, others = __rest$1(_a3, ["enabled"]);
    return others;
  }
  notify(name, args) {
    this.trigger(name, args);
    this.graph.trigger(name, args);
  }
  dispose() {
    this.clean(true);
    this.off();
  }
}
__decorate$6([
  Basecoat.dispose()
], Clipboard.prototype, "dispose", null);
Graph$2.prototype.isHistoryEnabled = function() {
  const history = this.getPlugin("history");
  if (history) {
    return history.isEnabled();
  }
  return false;
};
Graph$2.prototype.enableHistory = function() {
  const history = this.getPlugin("history");
  if (history) {
    history.enable();
  }
  return this;
};
Graph$2.prototype.disableHistory = function() {
  const history = this.getPlugin("history");
  if (history) {
    history.disable();
  }
  return this;
};
Graph$2.prototype.toggleHistory = function(enabled) {
  const history = this.getPlugin("history");
  if (history) {
    history.toggleEnabled(enabled);
  }
  return this;
};
Graph$2.prototype.undo = function(options) {
  const history = this.getPlugin("history");
  if (history) {
    history.undo(options);
  }
  return this;
};
Graph$2.prototype.redo = function(options) {
  const history = this.getPlugin("history");
  if (history) {
    history.redo(options);
  }
  return this;
};
Graph$2.prototype.undoAndCancel = function(options) {
  const history = this.getPlugin("history");
  if (history) {
    history.cancel(options);
  }
  return this;
};
Graph$2.prototype.canUndo = function() {
  const history = this.getPlugin("history");
  if (history) {
    return history.canUndo();
  }
  return false;
};
Graph$2.prototype.canRedo = function() {
  const history = this.getPlugin("history");
  if (history) {
    return history.canRedo();
  }
  return false;
};
Graph$2.prototype.cleanHistory = function(options) {
  const history = this.getPlugin("history");
  if (history) {
    history.clean(options);
  }
  return this;
};
Graph$2.prototype.getHistoryStackSize = function() {
  const history = this.getPlugin("history");
  return history.getSize();
};
Graph$2.prototype.getUndoStackSize = function() {
  const history = this.getPlugin("history");
  return history.getUndoSize();
};
Graph$2.prototype.getRedoStackSize = function() {
  const history = this.getPlugin("history");
  return history.getRedoSize();
};
Graph$2.prototype.getUndoRemainSize = function() {
  const history = this.getPlugin("history");
  return history.getUndoRemainSize();
};
var __decorate$5 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class History extends Basecoat {
  constructor(options = {}) {
    super();
    this.name = "history";
    this.batchCommands = null;
    this.batchLevel = 0;
    this.lastBatchIndex = -1;
    this.freezed = false;
    this.stackSize = 0;
    this.handlers = [];
    const { stackSize = 0 } = options;
    this.stackSize = stackSize;
    this.options = Util$1.getOptions(options);
    this.validator = new History.Validator({
      history: this,
      cancelInvalid: this.options.cancelInvalid
    });
  }
  init(graph) {
    this.graph = graph;
    this.model = this.graph.model;
    this.clean();
    this.startListening();
  }
  // #region api
  isEnabled() {
    return !this.disabled;
  }
  enable() {
    if (this.disabled) {
      this.options.enabled = true;
    }
  }
  disable() {
    if (!this.disabled) {
      this.options.enabled = false;
    }
  }
  toggleEnabled(enabled) {
    if (enabled != null) {
      if (enabled !== this.isEnabled()) {
        if (enabled) {
          this.enable();
        } else {
          this.disable();
        }
      }
    } else if (this.isEnabled()) {
      this.disable();
    } else {
      this.enable();
    }
    return this;
  }
  undo(options = {}) {
    if (!this.disabled) {
      const cmd = this.undoStack.pop();
      if (cmd) {
        this.revertCommand(cmd, options);
        this.redoStack.push(cmd);
        this.notify("undo", cmd, options);
      }
    }
    return this;
  }
  redo(options = {}) {
    if (!this.disabled) {
      const cmd = this.redoStack.pop();
      if (cmd) {
        this.applyCommand(cmd, options);
        this.undoStackPush(cmd);
        this.notify("redo", cmd, options);
      }
    }
    return this;
  }
  /**
   * Same as `undo()` but does not store the undo-ed command to the
   * `redoStack`. Canceled command therefore cannot be redo-ed.
   */
  cancel(options = {}) {
    if (!this.disabled) {
      const cmd = this.undoStack.pop();
      if (cmd) {
        this.revertCommand(cmd, options);
        this.redoStack = [];
        this.notify("cancel", cmd, options);
      }
    }
    return this;
  }
  getSize() {
    return this.stackSize;
  }
  getUndoRemainSize() {
    const ul2 = this.undoStack.length;
    return this.stackSize - ul2;
  }
  getUndoSize() {
    return this.undoStack.length;
  }
  getRedoSize() {
    return this.redoStack.length;
  }
  canUndo() {
    return !this.disabled && this.undoStack.length > 0;
  }
  canRedo() {
    return !this.disabled && this.redoStack.length > 0;
  }
  clean(options = {}) {
    this.undoStack = [];
    this.redoStack = [];
    this.notify("clean", null, options);
    return this;
  }
  // #endregion
  get disabled() {
    return this.options.enabled !== true;
  }
  validate(events, ...callbacks) {
    this.validator.validate(events, ...callbacks);
    return this;
  }
  startListening() {
    this.model.on("batch:start", this.initBatchCommand, this);
    this.model.on("batch:stop", this.storeBatchCommand, this);
    if (this.options.eventNames) {
      this.options.eventNames.forEach((name, index2) => {
        this.handlers[index2] = this.addCommand.bind(this, name);
        this.model.on(name, this.handlers[index2]);
      });
    }
    this.validator.on("invalid", (args) => this.trigger("invalid", args));
  }
  stopListening() {
    this.model.off("batch:start", this.initBatchCommand, this);
    this.model.off("batch:stop", this.storeBatchCommand, this);
    if (this.options.eventNames) {
      this.options.eventNames.forEach((name, index2) => {
        this.model.off(name, this.handlers[index2]);
      });
      this.handlers.length = 0;
    }
    this.validator.off("invalid");
  }
  createCommand(options) {
    return {
      batch: options ? options.batch : false,
      data: {}
    };
  }
  revertCommand(cmd, options) {
    this.freezed = true;
    const cmds = Array.isArray(cmd) ? Util$1.sortBatchCommands(cmd) : [cmd];
    for (let i2 = cmds.length - 1; i2 >= 0; i2 -= 1) {
      const cmd2 = cmds[i2];
      const localOptions = Object.assign(Object.assign({}, options), ObjectExt.pick(cmd2.options, this.options.revertOptionsList || []));
      this.executeCommand(cmd2, true, localOptions);
    }
    this.freezed = false;
  }
  applyCommand(cmd, options) {
    this.freezed = true;
    const cmds = Array.isArray(cmd) ? Util$1.sortBatchCommands(cmd) : [cmd];
    for (let i2 = 0; i2 < cmds.length; i2 += 1) {
      const cmd2 = cmds[i2];
      const localOptions = Object.assign(Object.assign({}, options), ObjectExt.pick(cmd2.options, this.options.applyOptionsList || []));
      this.executeCommand(cmd2, false, localOptions);
    }
    this.freezed = false;
  }
  executeCommand(cmd, revert, options) {
    const model = this.model;
    const cell = model.getCell(cmd.data.id);
    const event = cmd.event;
    if (Util$1.isAddEvent(event) && revert || Util$1.isRemoveEvent(event) && !revert) {
      cell && cell.remove(options);
    } else if (Util$1.isAddEvent(event) && !revert || Util$1.isRemoveEvent(event) && revert) {
      const data = cmd.data;
      if (data.node) {
        model.addNode(data.props, options);
      } else if (data.edge) {
        model.addEdge(data.props, options);
      }
    } else if (Util$1.isChangeEvent(event)) {
      const data = cmd.data;
      const key = data.key;
      if (key && cell) {
        const value = revert ? data.prev[key] : data.next[key];
        if (data.key === "attrs") {
          const hasUndefinedAttr = this.ensureUndefinedAttrs(value, revert ? data.next[key] : data.prev[key]);
          if (hasUndefinedAttr) {
            options.dirty = true;
          }
        }
        cell.prop(key, value, options);
      }
    } else {
      const executeCommand = this.options.executeCommand;
      if (executeCommand) {
        FunctionExt.call(executeCommand, this, cmd, revert, options);
      }
    }
  }
  addCommand(event, args) {
    if (this.freezed || this.disabled) {
      return;
    }
    const eventArgs = args;
    const options = eventArgs.options || {};
    if (options.dryrun) {
      return;
    }
    if (Util$1.isAddEvent(event) && this.options.ignoreAdd || Util$1.isRemoveEvent(event) && this.options.ignoreRemove || Util$1.isChangeEvent(event) && this.options.ignoreChange) {
      return;
    }
    const before = this.options.beforeAddCommand;
    if (before != null && FunctionExt.call(before, this, event, args) === false) {
      return;
    }
    if (event === "cell:change:*") {
      event = `cell:change:${eventArgs.key}`;
    }
    const cell = eventArgs.cell;
    const isModelChange = Model.isModel(cell);
    let cmd;
    if (this.batchCommands) {
      cmd = this.batchCommands[Math.max(this.lastBatchIndex, 0)];
      const diffId = isModelChange && !cmd.modelChange || cmd.data.id !== cell.id;
      const diffName = cmd.event !== event;
      if (this.lastBatchIndex >= 0 && (diffId || diffName)) {
        const index2 = this.batchCommands.findIndex((cmd2) => (isModelChange && cmd2.modelChange || cmd2.data.id === cell.id) && cmd2.event === event);
        if (index2 < 0 || Util$1.isAddEvent(event) || Util$1.isRemoveEvent(event)) {
          cmd = this.createCommand({ batch: true });
        } else {
          cmd = this.batchCommands[index2];
          this.batchCommands.splice(index2, 1);
        }
        this.batchCommands.push(cmd);
        this.lastBatchIndex = this.batchCommands.length - 1;
      }
    } else {
      cmd = this.createCommand({ batch: false });
    }
    if (Util$1.isAddEvent(event) || Util$1.isRemoveEvent(event)) {
      const data = cmd.data;
      cmd.event = event;
      cmd.options = options;
      data.id = cell.id;
      data.props = ObjectExt.cloneDeep(cell.toJSON());
      if (cell.isEdge()) {
        data.edge = true;
      } else if (cell.isNode()) {
        data.node = true;
      }
      return this.push(cmd, options);
    }
    if (Util$1.isChangeEvent(event)) {
      const key = args.key;
      const data = cmd.data;
      if (!cmd.batch || !cmd.event) {
        cmd.event = event;
        cmd.options = options;
        data.key = key;
        if (data.prev == null) {
          data.prev = {};
        }
        data.prev[key] = ObjectExt.cloneDeep(cell.previous(key));
        if (isModelChange) {
          cmd.modelChange = true;
        } else {
          data.id = cell.id;
        }
      }
      if (data.next == null) {
        data.next = {};
      }
      data.next[key] = ObjectExt.cloneDeep(cell.prop(key));
      return this.push(cmd, options);
    }
    const afterAddCommand = this.options.afterAddCommand;
    if (afterAddCommand) {
      FunctionExt.call(afterAddCommand, this, event, args, cmd);
    }
    this.push(cmd, options);
  }
  /**
   * Gather multiple changes into a single command. These commands could
   * be reverted with single `undo()` call. From the moment the function
   * is called every change made on model is not stored into the undoStack.
   * Changes are temporarily kept until `storeBatchCommand()` is called.
   */
  // eslint-disable-next-line
  initBatchCommand(options) {
    if (this.freezed) {
      return;
    }
    if (this.batchCommands) {
      this.batchLevel += 1;
    } else {
      this.batchCommands = [this.createCommand({ batch: true })];
      this.batchLevel = 0;
      this.lastBatchIndex = -1;
    }
  }
  /**
   * Store changes temporarily kept in the undoStack. You have to call this
   * function as many times as `initBatchCommand()` been called.
   */
  storeBatchCommand(options) {
    if (this.freezed) {
      return;
    }
    if (this.batchCommands && this.batchLevel <= 0) {
      const cmds = this.filterBatchCommand(this.batchCommands);
      if (cmds.length > 0) {
        this.redoStack = [];
        this.undoStackPush(cmds);
        this.consolidateCommands();
        this.notify("add", cmds, options);
      }
      this.batchCommands = null;
      this.lastBatchIndex = -1;
      this.batchLevel = 0;
    } else if (this.batchCommands && this.batchLevel > 0) {
      this.batchLevel -= 1;
    }
  }
  filterBatchCommand(batchCommands) {
    let cmds = batchCommands.slice();
    const result = [];
    while (cmds.length > 0) {
      const cmd = cmds.shift();
      const evt = cmd.event;
      const id2 = cmd.data.id;
      if (evt != null && (id2 != null || cmd.modelChange)) {
        if (Util$1.isAddEvent(evt)) {
          const index2 = cmds.findIndex((c3) => Util$1.isRemoveEvent(c3.event) && c3.data.id === id2);
          if (index2 >= 0) {
            cmds = cmds.filter((c3, i2) => index2 < i2 || c3.data.id !== id2);
            continue;
          }
        } else if (Util$1.isRemoveEvent(evt)) {
          const index2 = cmds.findIndex((c3) => Util$1.isAddEvent(c3.event) && c3.data.id === id2);
          if (index2 >= 0) {
            cmds.splice(index2, 1);
            continue;
          }
        } else if (Util$1.isChangeEvent(evt)) {
          const data = cmd.data;
          if (ObjectExt.isEqual(data.prev, data.next)) {
            continue;
          }
        } else ;
        result.push(cmd);
      }
    }
    return result;
  }
  notify(event, cmd, options) {
    const cmds = cmd == null ? null : Array.isArray(cmd) ? cmd : [cmd];
    this.emit(event, { cmds, options });
    this.graph.trigger(`history:${event}`, { cmds, options });
    this.emit("change", { cmds, options });
    this.graph.trigger("history:change", { cmds, options });
  }
  push(cmd, options) {
    this.redoStack = [];
    if (cmd.batch) {
      this.lastBatchIndex = Math.max(this.lastBatchIndex, 0);
      this.emit("batch", { cmd, options });
    } else {
      this.undoStackPush(cmd);
      this.consolidateCommands();
      this.notify("add", cmd, options);
    }
  }
  /**
   * Conditionally combine multiple undo items into one.
   *
   * Currently this is only used combine a `cell:changed:position` event
   * followed by multiple `cell:change:parent` and `cell:change:children`
   * events, such that a "move + embed" action can be undone in one step.
   *
   * See https://github.com/antvis/X6/issues/2421
   *
   * This is an ugly WORKAROUND. It does not solve deficiencies in the batch
   * system itself.
   */
  consolidateCommands() {
    var _a3;
    const lastCommandGroup = this.undoStack[this.undoStack.length - 1];
    const penultimateCommandGroup = this.undoStack[this.undoStack.length - 2];
    if (!Array.isArray(lastCommandGroup)) {
      return;
    }
    const eventTypes = new Set(lastCommandGroup.map((cmd) => cmd.event));
    if (eventTypes.size !== 2 || !eventTypes.has("cell:change:parent") || !eventTypes.has("cell:change:children")) {
      return;
    }
    if (!lastCommandGroup.every((cmd) => {
      var _a4;
      return cmd.batch && ((_a4 = cmd.options) === null || _a4 === void 0 ? void 0 : _a4.ui);
    })) {
      return;
    }
    if (!Array.isArray(penultimateCommandGroup) || penultimateCommandGroup.length !== 1) {
      return;
    }
    const maybePositionChange = penultimateCommandGroup[0];
    if (maybePositionChange.event !== "cell:change:position" || !((_a3 = maybePositionChange.options) === null || _a3 === void 0 ? void 0 : _a3.ui)) {
      return;
    }
    penultimateCommandGroup.push(...lastCommandGroup);
    this.undoStack.pop();
  }
  undoStackPush(cmd) {
    if (this.stackSize === 0) {
      this.undoStack.push(cmd);
      return;
    }
    if (this.undoStack.length >= this.stackSize) {
      this.undoStack.shift();
    }
    this.undoStack.push(cmd);
  }
  ensureUndefinedAttrs(newAttrs, oldAttrs) {
    let hasUndefinedAttr = false;
    if (newAttrs !== null && oldAttrs !== null && typeof newAttrs === "object" && typeof oldAttrs === "object") {
      Object.keys(oldAttrs).forEach((key) => {
        if (newAttrs[key] === void 0 && oldAttrs[key] !== void 0) {
          newAttrs[key] = void 0;
          hasUndefinedAttr = true;
        } else if (typeof newAttrs[key] === "object" && typeof oldAttrs[key] === "object") {
          hasUndefinedAttr = this.ensureUndefinedAttrs(newAttrs[key], oldAttrs[key]);
        }
      });
    }
    return hasUndefinedAttr;
  }
  dispose() {
    this.validator.dispose();
    this.clean();
    this.stopListening();
    this.off();
  }
}
__decorate$5([
  Basecoat.dispose()
], History.prototype, "dispose", null);
(function(History2) {
  class Validator extends Basecoat {
    constructor(options) {
      super();
      this.map = {};
      this.command = options.history;
      this.cancelInvalid = options.cancelInvalid !== false;
      this.command.on("add", this.onCommandAdded, this);
    }
    onCommandAdded({ cmds }) {
      return Array.isArray(cmds) ? cmds.every((cmd) => this.isValidCommand(cmd)) : this.isValidCommand(cmds);
    }
    isValidCommand(cmd) {
      if (cmd.options && cmd.options.validation === false) {
        return true;
      }
      const callbacks = cmd.event && this.map[cmd.event] || [];
      let handoverErr = null;
      callbacks.forEach((routes) => {
        let i2 = 0;
        const rollup = (err) => {
          const fn2 = routes[i2];
          i2 += 1;
          try {
            if (fn2) {
              fn2(err, cmd, rollup);
            } else {
              handoverErr = err;
              return;
            }
          } catch (err2) {
            rollup(err2);
          }
        };
        rollup(handoverErr);
      });
      if (handoverErr) {
        if (this.cancelInvalid) {
          this.command.cancel();
        }
        this.emit("invalid", { err: handoverErr });
        return false;
      }
      return true;
    }
    validate(events, ...callbacks) {
      const evts = Array.isArray(events) ? events : events.split(/\s+/);
      callbacks.forEach((callback) => {
        if (typeof callback !== "function") {
          throw new Error(`${evts.join(" ")} requires callback functions.`);
        }
      });
      evts.forEach((event) => {
        if (this.map[event] == null) {
          this.map[event] = [];
        }
        this.map[event].push(callbacks);
      });
      return this;
    }
    dispose() {
      this.command.off("add", this.onCommandAdded, this);
    }
  }
  __decorate$5([
    Basecoat.dispose()
  ], Validator.prototype, "dispose", null);
  History2.Validator = Validator;
})(History || (History = {}));
var Util$1;
(function(Util2) {
  function isAddEvent(event) {
    return event === "cell:added";
  }
  Util2.isAddEvent = isAddEvent;
  function isRemoveEvent(event) {
    return event === "cell:removed";
  }
  Util2.isRemoveEvent = isRemoveEvent;
  function isChangeEvent(event) {
    return event != null && event.startsWith("cell:change:");
  }
  Util2.isChangeEvent = isChangeEvent;
  function getOptions(options) {
    const reservedNames = [
      "cell:added",
      "cell:removed",
      "cell:change:*"
    ];
    const batchEvents = ["batch:start", "batch:stop"];
    const eventNames = options.eventNames ? options.eventNames.filter((event) => !(Util2.isChangeEvent(event) || reservedNames.includes(event) || batchEvents.includes(event))) : reservedNames;
    return Object.assign(Object.assign({ enabled: true }, options), { eventNames, applyOptionsList: options.applyOptionsList || ["propertyPath"], revertOptionsList: options.revertOptionsList || ["propertyPath"] });
  }
  Util2.getOptions = getOptions;
  function sortBatchCommands(cmds) {
    const results = [];
    for (let i2 = 0, ii2 = cmds.length; i2 < ii2; i2 += 1) {
      const cmd = cmds[i2];
      let index2 = null;
      if (Util2.isAddEvent(cmd.event)) {
        const id2 = cmd.data.id;
        for (let j2 = 0; j2 < i2; j2 += 1) {
          if (cmds[j2].data.id === id2) {
            index2 = j2;
            break;
          }
        }
      }
      if (index2 !== null) {
        results.splice(index2, 0, cmd);
      } else {
        results.push(cmd);
      }
    }
    return results;
  }
  Util2.sortBatchCommands = sortBatchCommands;
})(Util$1 || (Util$1 = {}));
const content$3 = `.x6-widget-dnd {
  position: absolute;
  top: -10000px;
  left: -10000px;
  z-index: 999999;
  display: none;
  cursor: move;
  opacity: 0.7;
  pointer-events: 'cursor';
}
.x6-widget-dnd.dragging {
  display: inline-block;
}
.x6-widget-dnd.dragging * {
  pointer-events: none !important;
}
.x6-widget-dnd .x6-graph {
  background: transparent;
  box-shadow: none;
}
`;
var __decorate$4 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Dnd extends View {
  get targetScroller() {
    const target = this.options.target;
    const scroller = target.getPlugin("scroller");
    return scroller;
  }
  get targetGraph() {
    return this.options.target;
  }
  get targetModel() {
    return this.targetGraph.model;
  }
  get snapline() {
    const target = this.options.target;
    const snapline = target.getPlugin("snapline");
    return snapline;
  }
  constructor(options) {
    super();
    this.name = "dnd";
    this.options = Object.assign(Object.assign({}, Dnd.defaults), options);
    this.init();
  }
  init() {
    CssLoader.ensure(this.name, content$3);
    this.container = document.createElement("div");
    Dom.addClass(this.container, this.prefixClassName("widget-dnd"));
    this.draggingGraph = new Graph$2(Object.assign(Object.assign({}, this.options.delegateGraphOptions), { container: document.createElement("div"), width: 1, height: 1, async: false }));
    Dom.append(this.container, this.draggingGraph.container);
  }
  start(node, evt) {
    const e10 = evt;
    e10.preventDefault();
    this.targetModel.startBatch("dnd");
    Dom.addClass(this.container, "dragging");
    Dom.appendTo(this.container, this.options.draggingContainer || document.body);
    this.sourceNode = node;
    this.prepareDragging(node, e10.clientX, e10.clientY);
    const local = this.updateNodePosition(e10.clientX, e10.clientY);
    if (this.isSnaplineEnabled()) {
      this.snapline.captureCursorOffset({
        e: e10,
        node,
        cell: node,
        view: this.draggingView,
        x: local.x,
        y: local.y
      });
      this.draggingNode.on("change:position", this.snap, this);
    }
    this.delegateDocumentEvents(Dnd.documentEvents, e10.data);
  }
  isSnaplineEnabled() {
    return this.snapline && this.snapline.isEnabled();
  }
  prepareDragging(sourceNode, clientX, clientY) {
    const draggingGraph = this.draggingGraph;
    const draggingModel = draggingGraph.model;
    const draggingNode = this.options.getDragNode(sourceNode, {
      sourceNode,
      draggingGraph,
      targetGraph: this.targetGraph
    });
    draggingNode.position(0, 0);
    let padding = 5;
    if (this.isSnaplineEnabled()) {
      padding += this.snapline.options.tolerance || 0;
    }
    if (this.isSnaplineEnabled() || this.options.scaled) {
      const scale = this.targetGraph.transform.getScale();
      draggingGraph.scale(scale.sx, scale.sy);
      padding *= Math.max(scale.sx, scale.sy);
    } else {
      draggingGraph.scale(1, 1);
    }
    this.clearDragging();
    draggingModel.resetCells([draggingNode]);
    const delegateView = draggingGraph.findViewByCell(draggingNode);
    delegateView.undelegateEvents();
    delegateView.cell.off("changed");
    draggingGraph.fitToContent({
      padding,
      allowNewOrigin: "any",
      useCellGeometry: false
    });
    const bbox = delegateView.getBBox();
    this.geometryBBox = delegateView.getBBox({ useCellGeometry: true });
    this.delta = this.geometryBBox.getTopLeft().diff(bbox.getTopLeft());
    this.draggingNode = draggingNode;
    this.draggingView = delegateView;
    this.draggingBBox = draggingNode.getBBox();
    this.padding = padding;
    this.originOffset = this.updateGraphPosition(clientX, clientY);
  }
  updateGraphPosition(clientX, clientY) {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
    const delta = this.delta;
    const nodeBBox = this.geometryBBox;
    const padding = this.padding || 5;
    const offset = {
      left: clientX - delta.x - nodeBBox.width / 2 - padding + scrollLeft,
      top: clientY - delta.y - nodeBBox.height / 2 - padding + scrollTop
    };
    if (this.draggingGraph) {
      Dom.css(this.container, {
        left: `${offset.left}px`,
        top: `${offset.top}px`
      });
    }
    return offset;
  }
  updateNodePosition(x2, y2) {
    const local = this.targetGraph.clientToLocal(x2, y2);
    const bbox = this.draggingBBox;
    local.x -= bbox.width / 2;
    local.y -= bbox.height / 2;
    this.draggingNode.position(local.x, local.y);
    return local;
  }
  snap({ cell, current, options }) {
    const node = cell;
    if (options.snapped) {
      const bbox = this.draggingBBox;
      node.position(bbox.x + options.tx, bbox.y + options.ty, { silent: true });
      this.draggingView.translate();
      node.position(current.x, current.y, { silent: true });
      this.snapOffset = {
        x: options.tx,
        y: options.ty
      };
    } else {
      this.snapOffset = null;
    }
  }
  onDragging(evt) {
    const draggingView = this.draggingView;
    if (draggingView) {
      evt.preventDefault();
      const e10 = this.normalizeEvent(evt);
      const clientX = e10.clientX;
      const clientY = e10.clientY;
      this.updateGraphPosition(clientX, clientY);
      const local = this.updateNodePosition(clientX, clientY);
      const embeddingMode = this.targetGraph.options.embedding.enabled;
      const isValidArea = (embeddingMode || this.isSnaplineEnabled()) && this.isInsideValidArea({
        x: clientX,
        y: clientY
      });
      if (embeddingMode) {
        draggingView.setEventData(e10, {
          graph: this.targetGraph,
          candidateEmbedView: this.candidateEmbedView
        });
        const data = draggingView.getEventData(e10);
        if (isValidArea) {
          draggingView.processEmbedding(e10, data);
        } else {
          draggingView.clearEmbedding(data);
        }
        this.candidateEmbedView = data.candidateEmbedView;
      }
      if (this.isSnaplineEnabled()) {
        if (isValidArea) {
          this.snapline.snapOnMoving({
            e: e10,
            view: draggingView,
            x: local.x,
            y: local.y
          });
        } else {
          this.snapline.hide();
        }
      }
    }
  }
  onDragEnd(evt) {
    const draggingNode = this.draggingNode;
    if (draggingNode) {
      const e10 = this.normalizeEvent(evt);
      const draggingView = this.draggingView;
      const draggingBBox = this.draggingBBox;
      const snapOffset = this.snapOffset;
      let x2 = draggingBBox.x;
      let y2 = draggingBBox.y;
      if (snapOffset) {
        x2 += snapOffset.x;
        y2 += snapOffset.y;
      }
      draggingNode.position(x2, y2, { silent: true });
      const ret = this.drop(draggingNode, { x: e10.clientX, y: e10.clientY });
      const callback = (node) => {
        if (node) {
          this.onDropped(draggingNode);
          if (this.targetGraph.options.embedding.enabled && draggingView) {
            draggingView.setEventData(e10, {
              cell: node,
              graph: this.targetGraph,
              candidateEmbedView: this.candidateEmbedView
            });
            draggingView.finalizeEmbedding(e10, draggingView.getEventData(e10));
          }
        } else {
          this.onDropInvalid();
        }
        this.candidateEmbedView = null;
        this.targetModel.stopBatch("dnd");
      };
      if (FunctionExt.isAsync(ret)) {
        this.undelegateDocumentEvents();
        ret.then(callback);
      } else {
        callback(ret);
      }
    }
  }
  clearDragging() {
    if (this.draggingNode) {
      this.sourceNode = null;
      this.draggingNode.remove();
      this.draggingNode = null;
      this.draggingView = null;
      this.delta = null;
      this.padding = null;
      this.snapOffset = null;
      this.originOffset = null;
      this.undelegateDocumentEvents();
    }
  }
  onDropped(draggingNode) {
    if (this.draggingNode === draggingNode) {
      this.clearDragging();
      Dom.removeClass(this.container, "dragging");
      Dom.remove(this.container);
    }
  }
  onDropInvalid() {
    const draggingNode = this.draggingNode;
    if (draggingNode) {
      this.onDropped(draggingNode);
    }
  }
  isInsideValidArea(p2) {
    let targetRect;
    let dndRect = null;
    const targetGraph = this.targetGraph;
    const targetScroller = this.targetScroller;
    if (this.options.dndContainer) {
      dndRect = this.getDropArea(this.options.dndContainer);
    }
    const isInsideDndRect = dndRect && dndRect.containsPoint(p2);
    if (targetScroller) {
      if (targetScroller.options.autoResize) {
        targetRect = this.getDropArea(targetScroller.container);
      } else {
        const outter = this.getDropArea(targetScroller.container);
        targetRect = this.getDropArea(targetGraph.container).intersectsWithRect(outter);
      }
    } else {
      targetRect = this.getDropArea(targetGraph.container);
    }
    return !isInsideDndRect && targetRect && targetRect.containsPoint(p2);
  }
  getDropArea(elem) {
    const offset = Dom.offset(elem);
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const scrollLeft = document.body.scrollLeft || document.documentElement.scrollLeft;
    return Rectangle.create({
      x: offset.left + parseInt(Dom.css(elem, "border-left-width"), 10) - scrollLeft,
      y: offset.top + parseInt(Dom.css(elem, "border-top-width"), 10) - scrollTop,
      width: elem.clientWidth,
      height: elem.clientHeight
    });
  }
  drop(draggingNode, pos) {
    if (this.isInsideValidArea(pos)) {
      const targetGraph = this.targetGraph;
      const targetModel = targetGraph.model;
      const local = targetGraph.clientToLocal(pos);
      const sourceNode = this.sourceNode;
      const droppingNode = this.options.getDropNode(draggingNode, {
        sourceNode,
        draggingNode,
        targetGraph: this.targetGraph,
        draggingGraph: this.draggingGraph
      });
      const bbox = droppingNode.getBBox();
      local.x += bbox.x - bbox.width / 2;
      local.y += bbox.y - bbox.height / 2;
      const gridSize = this.snapOffset ? 1 : targetGraph.getGridSize();
      droppingNode.position(GeometryUtil.snapToGrid(local.x, gridSize), GeometryUtil.snapToGrid(local.y, gridSize));
      droppingNode.removeZIndex();
      const validateNode2 = this.options.validateNode;
      const ret = validateNode2 ? validateNode2(droppingNode, {
        sourceNode,
        draggingNode,
        droppingNode,
        targetGraph,
        draggingGraph: this.draggingGraph
      }) : true;
      if (typeof ret === "boolean") {
        if (ret) {
          targetModel.addCell(droppingNode, { stencil: this.cid });
          return droppingNode;
        }
        return null;
      }
      return FunctionExt.toDeferredBoolean(ret).then((valid) => {
        if (valid) {
          targetModel.addCell(droppingNode, { stencil: this.cid });
          return droppingNode;
        }
        return null;
      });
    }
    return null;
  }
  onRemove() {
    if (this.draggingGraph) {
      this.draggingGraph.view.remove();
      this.draggingGraph.dispose();
    }
  }
  dispose() {
    this.remove();
    CssLoader.clean(this.name);
  }
}
__decorate$4([
  View.dispose()
], Dnd.prototype, "dispose", null);
(function(Dnd2) {
  Dnd2.defaults = {
    // animation: false,
    getDragNode: (sourceNode) => sourceNode.clone(),
    getDropNode: (draggingNode) => draggingNode.clone()
  };
  Dnd2.documentEvents = {
    mousemove: "onDragging",
    touchmove: "onDragging",
    mouseup: "onDragEnd",
    touchend: "onDragEnd",
    touchcancel: "onDragEnd"
  };
})(Dnd || (Dnd = {}));
function grid(cells, options = {}) {
  const model = Model.isModel(cells) ? cells : new Model().resetCells(cells, {
    sort: false,
    dryrun: true
  });
  const nodes = model.getNodes();
  const columns = options.columns || 1;
  const rows = Math.ceil(nodes.length / columns);
  const dx2 = options.dx || 0;
  const dy2 = options.dy || 0;
  const centre = options.center !== false;
  const resizeToFit = options.resizeToFit === true;
  const marginX = options.marginX || 0;
  const marginY = options.marginY || 0;
  const columnWidths = [];
  let columnWidth = options.columnWidth;
  if (columnWidth === "compact") {
    for (let j2 = 0; j2 < columns; j2 += 1) {
      const items = GridLayout.getNodesInColumn(nodes, j2, columns);
      columnWidths.push(GridLayout.getMaxDim(items, "width") + dx2);
    }
  } else {
    if (columnWidth == null || columnWidth === "auto") {
      columnWidth = GridLayout.getMaxDim(nodes, "width") + dx2;
    }
    for (let i2 = 0; i2 < columns; i2 += 1) {
      columnWidths.push(columnWidth);
    }
  }
  const columnLefts = GridLayout.accumulate(columnWidths, marginX);
  const rowHeights = [];
  let rowHeight = options.rowHeight;
  if (rowHeight === "compact") {
    for (let i2 = 0; i2 < rows; i2 += 1) {
      const items = GridLayout.getNodesInRow(nodes, i2, columns);
      rowHeights.push(GridLayout.getMaxDim(items, "height") + dy2);
    }
  } else {
    if (rowHeight == null || rowHeight === "auto") {
      rowHeight = GridLayout.getMaxDim(nodes, "height") + dy2;
    }
    for (let i2 = 0; i2 < rows; i2 += 1) {
      rowHeights.push(rowHeight);
    }
  }
  const rowTops = GridLayout.accumulate(rowHeights, marginY);
  model.startBatch("layout");
  nodes.forEach((node, index2) => {
    const rowIndex = index2 % columns;
    const columnIndex = Math.floor(index2 / columns);
    const columnWidth2 = columnWidths[rowIndex];
    const rowHeight2 = rowHeights[columnIndex];
    let cx2 = 0;
    let cy2 = 0;
    let size = node.getSize();
    if (resizeToFit) {
      let width2 = columnWidth2 - 2 * dx2;
      let height = rowHeight2 - 2 * dy2;
      const calcHeight = size.height * (size.width ? width2 / size.width : 1);
      const calcWidth = size.width * (size.height ? height / size.height : 1);
      if (rowHeight2 < calcHeight) {
        width2 = calcWidth;
      } else {
        height = calcHeight;
      }
      size = {
        width: width2,
        height
      };
      node.setSize(size, options);
    }
    if (centre) {
      cx2 = (columnWidth2 - size.width) / 2;
      cy2 = (rowHeight2 - size.height) / 2;
    }
    node.position(columnLefts[rowIndex] + dx2 + cx2, rowTops[columnIndex] + dy2 + cy2, options);
  });
  model.stopBatch("layout");
}
var GridLayout;
(function(GridLayout2) {
  function getMaxDim(nodes, name) {
    return nodes.reduce((memo, node) => Math.max(node === null || node === void 0 ? void 0 : node.getSize()[name], memo), 0);
  }
  GridLayout2.getMaxDim = getMaxDim;
  function getNodesInRow(nodes, rowIndex, columnCount) {
    const res = [];
    for (let i2 = columnCount * rowIndex, ii2 = i2 + columnCount; i2 < ii2; i2 += 1) {
      if (nodes[i2])
        res.push(nodes[i2]);
    }
    return res;
  }
  GridLayout2.getNodesInRow = getNodesInRow;
  function getNodesInColumn(nodes, columnIndex, columnCount) {
    const res = [];
    for (let i2 = columnIndex, ii2 = nodes.length; i2 < ii2; i2 += columnCount) {
      if (nodes[i2])
        res.push(nodes[i2]);
    }
    return res;
  }
  GridLayout2.getNodesInColumn = getNodesInColumn;
  function accumulate(items, start) {
    return items.reduce((memo, item, i2) => {
      memo.push(memo[i2] + item);
      return memo;
    }, [start || 0]);
  }
  GridLayout2.accumulate = accumulate;
})(GridLayout || (GridLayout = {}));
const content$2 = `.x6-widget-dnd {
  position: absolute;
  top: -10000px;
  left: -10000px;
  z-index: 999999;
  display: none;
  cursor: move;
  opacity: 0.7;
  pointer-events: 'cursor';
}
.x6-widget-dnd.dragging {
  display: inline-block;
}
.x6-widget-dnd.dragging * {
  pointer-events: none !important;
}
.x6-widget-dnd .x6-graph {
  background: transparent;
  box-shadow: none;
}
.x6-widget-stencil {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.x6-widget-stencil::after {
  position: absolute;
  top: 0;
  display: block;
  width: 100%;
  height: 20px;
  padding: 8px 0;
  line-height: 20px;
  text-align: center;
  opacity: 0;
  transition: top 0.1s linear, opacity 0.1s linear;
  content: ' ';
  pointer-events: none;
}
.x6-widget-stencil-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
.x6-widget-stencil .x6-node [magnet]:not([magnet='passive']) {
  pointer-events: none;
}
.x6-widget-stencil-group {
  padding: 0;
  padding-bottom: 8px;
  overflow: hidden;
  user-select: none;
}
.x6-widget-stencil-group.collapsed {
  height: auto;
  padding-bottom: 0;
}
.x6-widget-stencil-group-title {
  position: relative;
  margin-top: 0;
  margin-bottom: 0;
  padding: 4px;
  cursor: pointer;
}
.x6-widget-stencil-title,
.x6-widget-stencil-group > .x6-widget-stencil-group-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;
}
.x6-widget-stencil .unmatched {
  opacity: 0.3;
}
.x6-widget-stencil .x6-node.unmatched {
  display: none;
}
.x6-widget-stencil-group.unmatched {
  display: none;
}
.x6-widget-stencil-search-text {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  max-height: 30px;
  line-height: 30px;
  outline: 0;
}
.x6-widget-stencil.not-found::after {
  opacity: 1;
  content: attr(data-not-found-text);
}
.x6-widget-stencil.not-found.searchable::after {
  top: 30px;
}
.x6-widget-stencil.not-found.searchable.collapsable::after {
  top: 50px;
}
.x6-widget-stencil {
  color: #333;
  background: #f5f5f5;
}
.x6-widget-stencil-content {
  position: absolute;
}
.x6-widget-stencil.collapsable > .x6-widget-stencil-content {
  top: 32px;
}
.x6-widget-stencil.searchable > .x6-widget-stencil-content {
  top: 80px;
}
.x6-widget-stencil.not-found::after {
  position: absolute;
}
.x6-widget-stencil.not-found.searchable.collapsable::after {
  top: 80px;
}
.x6-widget-stencil.not-found.searchable::after {
  top: 60px;
}
.x6-widget-stencil-group {
  height: auto;
  margin-bottom: 1px;
  padding: 0;
  transition: none;
}
.x6-widget-stencil-group .x6-graph {
  background: transparent;
  box-shadow: none;
}
.x6-widget-stencil-group.collapsed {
  height: auto;
  max-height: 31px;
}
.x6-widget-stencil-title,
.x6-widget-stencil-group > .x6-widget-stencil-group-title {
  position: relative;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  padding: 0 5px 0 8px;
  color: #666;
  font-weight: 700;
  font-size: 12px;
  line-height: 32px;
  cursor: default;
  transition: all 0.3;
}
.x6-widget-stencil-title:hover,
.x6-widget-stencil-group > .x6-widget-stencil-group-title:hover {
  color: #444;
}
.x6-widget-stencil-title {
  background: #e9e9e9;
}
.x6-widget-stencil-group > .x6-widget-stencil-group-title {
  background: #ededed;
}
.x6-widget-stencil.collapsable > .x6-widget-stencil-title,
.x6-widget-stencil-group.collapsable > .x6-widget-stencil-group-title {
  padding-left: 32px;
  cursor: pointer;
}
.x6-widget-stencil.collapsable > .x6-widget-stencil-title::before,
.x6-widget-stencil-group.collapsable > .x6-widget-stencil-group-title::before {
  position: absolute;
  top: 6px;
  left: 8px;
  display: block;
  width: 18px;
  height: 18px;
  margin: 0;
  padding: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: 0 0;
  border: none;
  content: ' ';
}
.x6-widget-stencil.collapsable > .x6-widget-stencil-title::before,
.x6-widget-stencil-group.collapsable > .x6-widget-stencil-group-title::before {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNOS4zNzUuNUM0LjY4Ny41Ljg3NSA0LjMxMy44NzUgOWMwIDQuNjg4IDMuODEyIDguNSA4LjUgOC41IDQuNjg3IDAgOC41LTMuODEyIDguNS04LjUgMC00LjY4Ny0zLjgxMy04LjUtOC41LTguNXptMCAxNS44ODZDNS4zMDMgMTYuMzg2IDEuOTkgMTMuMDcyIDEuOTkgOXMzLjMxMi03LjM4NSA3LjM4NS03LjM4NVMxNi43NiA0LjkyOCAxNi43NiA5YzAgNC4wNzItMy4zMTMgNy4zODYtNy4zODUgNy4zODZ6Ii8+PHBhdGggZD0iTTEyLjc1MyA4LjQ0M0g1Ljk5N2EuNTU4LjU1OCAwIDAwMCAxLjExNmg2Ljc1NmEuNTU4LjU1OCAwIDAwMC0xLjExNnoiLz48L2c+PC9zdmc+');
  opacity: 0.4;
  transition: all 0.3s;
}
.x6-widget-stencil.collapsable > .x6-widget-stencil-title:hover::before,
.x6-widget-stencil-group.collapsable > .x6-widget-stencil-group-title:hover::before {
  opacity: 0.6;
}
.x6-widget-stencil.collapsable.collapsed > .x6-widget-stencil-title::before,
.x6-widget-stencil-group.collapsable.collapsed > .x6-widget-stencil-group-title::before {
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJub256ZXJvIj48cGF0aCBkPSJNOS4zNzUuNUM0LjY4Ny41Ljg3NSA0LjMxMy44NzUgOWMwIDQuNjg4IDMuODEyIDguNSA4LjUgOC41IDQuNjg3IDAgOC41LTMuODEyIDguNS04LjUgMC00LjY4Ny0zLjgxMy04LjUtOC41LTguNXptMCAxNS44ODZDNS4zMDMgMTYuMzg2IDEuOTkgMTMuMDcyIDEuOTkgOXMzLjMxMi03LjM4NSA3LjM4NS03LjM4NVMxNi43NiA0LjkyOCAxNi43NiA5YzAgNC4wNzItMy4zMTMgNy4zODYtNy4zODUgNy4zODZ6Ii8+PHBhdGggZD0iTTEyLjc1MyA4LjQ0M0g1Ljk5N2EuNTU4LjU1OCAwIDAwMCAxLjExNmg2Ljc1NmEuNTU4LjU1OCAwIDAwMC0xLjExNnoiLz48cGF0aCBkPSJNOC44MTcgNS42MjN2Ni43NTZhLjU1OC41NTggMCAwMDEuMTE2IDBWNS42MjNhLjU1OC41NTggMCAxMC0xLjExNiAweiIvPjwvZz48L3N2Zz4=');
  opacity: 0.4;
}
.x6-widget-stencil.collapsable.collapsed > .x6-widget-stencil-title:hover::before,
.x6-widget-stencil-group.collapsable.collapsed > .x6-widget-stencil-group-title:hover::before {
  opacity: 0.6;
}
.x6-widget-stencil input[type='search'] {
  appearance: textfield;
}
.x6-widget-stencil input[type='search']::-webkit-search-cancel-button,
.x6-widget-stencil input[type='search']::-webkit-search-decoration {
  appearance: none;
}
.x6-widget-stencil-search-text {
  display: block;
  width: 90%;
  margin: 8px 5%;
  padding-left: 8px;
  color: #333;
  background: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  outline: 0;
}
.x6-widget-stencil-search-text:focus {
  outline: 0;
}
.x6-widget-stencil::after {
  color: #808080;
  font-weight: 600;
  font-size: 12px;
  background: 0 0;
}
`;
var __decorate$3 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Stencil extends View {
  get targetScroller() {
    const target = this.options.target;
    const scroller = target.getPlugin("scroller");
    return scroller;
  }
  get targetGraph() {
    return this.options.target;
  }
  get targetModel() {
    return this.targetGraph.model;
  }
  constructor(options = {}) {
    super();
    this.name = "stencil";
    CssLoader.ensure(this.name, content$2);
    this.graphs = {};
    this.groups = {};
    this.options = Object.assign(Object.assign({}, Stencil.defaultOptions), options);
    this.init();
  }
  init() {
    this.dnd = new Dnd(this.options);
    this.onSearch = FunctionExt.debounce(this.onSearch, 200);
    this.initContainer();
    this.initSearch();
    this.initContent();
    this.initGroups();
    this.setTitle();
    this.startListening();
  }
  load(data, groupName) {
    if (Array.isArray(data)) {
      this.loadGroup(data, groupName);
    } else if (this.options.groups) {
      Object.keys(this.options.groups).forEach((groupName2) => {
        if (data[groupName2]) {
          this.loadGroup(data[groupName2], groupName2);
        }
      });
    }
    return this;
  }
  unload(data, groupName) {
    if (Array.isArray(data)) {
      this.loadGroup(data, groupName, true);
    } else if (this.options.groups) {
      Object.keys(this.options.groups).forEach((groupName2) => {
        if (data[groupName2]) {
          this.loadGroup(data[groupName2], groupName2, true);
        }
      });
    }
    return this;
  }
  toggleGroup(groupName) {
    if (this.isGroupCollapsed(groupName)) {
      this.expandGroup(groupName);
    } else {
      this.collapseGroup(groupName);
    }
    return this;
  }
  collapseGroup(groupName) {
    if (this.isGroupCollapsable(groupName)) {
      const group = this.groups[groupName];
      if (group && !this.isGroupCollapsed(groupName)) {
        this.trigger("group:collapse", { name: groupName });
        Dom.addClass(group, "collapsed");
      }
    }
    return this;
  }
  expandGroup(groupName) {
    if (this.isGroupCollapsable(groupName)) {
      const group = this.groups[groupName];
      if (group && this.isGroupCollapsed(groupName)) {
        this.trigger("group:expand", { name: groupName });
        Dom.removeClass(group, "collapsed");
      }
    }
    return this;
  }
  isGroupCollapsable(groupName) {
    const group = this.groups[groupName];
    return Dom.hasClass(group, "collapsable");
  }
  isGroupCollapsed(groupName) {
    const group = this.groups[groupName];
    return group && Dom.hasClass(group, "collapsed");
  }
  collapseGroups() {
    Object.keys(this.groups).forEach((groupName) => this.collapseGroup(groupName));
    return this;
  }
  expandGroups() {
    Object.keys(this.groups).forEach((groupName) => this.expandGroup(groupName));
    return this;
  }
  resizeGroup(groupName, size) {
    const graph = this.graphs[groupName];
    if (graph) {
      graph.resize(size.width, size.height);
    }
    return this;
  }
  addGroup(group) {
    const groups = Array.isArray(group) ? group : [group];
    if (this.options.groups) {
      this.options.groups.push(...groups);
    } else {
      this.options.groups = groups;
    }
    groups.forEach((group2) => this.initGroup(group2));
  }
  removeGroup(groupName) {
    const groupNames = Array.isArray(groupName) ? groupName : [groupName];
    if (this.options.groups) {
      this.options.groups = this.options.groups.filter((group) => !groupNames.includes(group.name));
      groupNames.forEach((groupName2) => {
        const graph = this.graphs[groupName2];
        this.unregisterGraphEvents(graph);
        graph.dispose();
        delete this.graphs[groupName2];
        const elem = this.groups[groupName2];
        Dom.remove(elem);
        delete this.groups[groupName2];
      });
    }
  }
  // #endregion
  initContainer() {
    this.container = document.createElement("div");
    Dom.addClass(this.container, this.prefixClassName(ClassNames.base));
    Dom.attr(this.container, "data-not-found-text", this.options.notFoundText || "No matches found");
  }
  initContent() {
    this.content = document.createElement("div");
    Dom.addClass(this.content, this.prefixClassName(ClassNames.content));
    Dom.appendTo(this.content, this.container);
  }
  initSearch() {
    if (this.options.search) {
      Dom.addClass(this.container, "searchable");
      Dom.append(this.container, this.renderSearch());
    }
  }
  initGroup(group) {
    const globalGraphOptions = this.options.stencilGraphOptions || {};
    const groupElem = document.createElement("div");
    Dom.addClass(groupElem, this.prefixClassName(ClassNames.group));
    Dom.attr(groupElem, "data-name", group.name);
    if (group.collapsable == null && this.options.collapsable || group.collapsable !== false) {
      Dom.addClass(groupElem, "collapsable");
    }
    Dom.toggleClass(groupElem, "collapsed", group.collapsed === true);
    const title = document.createElement("h3");
    Dom.addClass(title, this.prefixClassName(ClassNames.groupTitle));
    title.innerHTML = group.title || group.name;
    const content2 = document.createElement("div");
    Dom.addClass(content2, this.prefixClassName(ClassNames.groupContent));
    const graphOptionsInGroup = group.graphOptions;
    const graph = new Graph$2(Object.assign(Object.assign(Object.assign({}, globalGraphOptions), graphOptionsInGroup), { container: document.createElement("div"), model: globalGraphOptions.model || new Model(), width: group.graphWidth || this.options.stencilGraphWidth, height: group.graphHeight || this.options.stencilGraphHeight, interacting: false, preventDefaultBlankAction: false }));
    this.registerGraphEvents(graph);
    Dom.append(content2, graph.container);
    Dom.append(groupElem, [title, content2]);
    Dom.appendTo(groupElem, this.content);
    this.groups[group.name] = groupElem;
    this.graphs[group.name] = graph;
  }
  initGroups() {
    this.clearGroups();
    this.setCollapsableState();
    if (this.options.groups && this.options.groups.length) {
      this.options.groups.forEach((group) => {
        this.initGroup(group);
      });
    } else {
      const globalGraphOptions = this.options.stencilGraphOptions || {};
      const graph = new Graph$2(Object.assign(Object.assign({}, globalGraphOptions), { container: document.createElement("div"), model: globalGraphOptions.model || new Model(), width: this.options.stencilGraphWidth, height: this.options.stencilGraphHeight, interacting: false, preventDefaultBlankAction: false }));
      Dom.append(this.content, graph.container);
      this.graphs[Private.defaultGroupName] = graph;
    }
  }
  setCollapsableState() {
    this.options.collapsable = this.options.collapsable && this.options.groups && this.options.groups.some((group) => group.collapsable !== false);
    if (this.options.collapsable) {
      Dom.addClass(this.container, "collapsable");
      const collapsed = this.options.groups && this.options.groups.every((group) => group.collapsed || group.collapsable === false);
      if (collapsed) {
        Dom.addClass(this.container, "collapsed");
      } else {
        Dom.removeClass(this.container, "collapsed");
      }
    } else {
      Dom.removeClass(this.container, "collapsable");
    }
  }
  setTitle() {
    const title = document.createElement("div");
    Dom.addClass(title, this.prefixClassName(ClassNames.title));
    title.innerHTML = this.options.title;
    Dom.appendTo(title, this.container);
  }
  renderSearch() {
    const elem = document.createElement("div");
    Dom.addClass(elem, this.prefixClassName(ClassNames.search));
    const input = document.createElement("input");
    Dom.attr(input, {
      type: "search",
      placeholder: this.options.placeholder || "Search"
    });
    Dom.addClass(input, this.prefixClassName(ClassNames.searchText));
    Dom.append(elem, input);
    return elem;
  }
  startListening() {
    const title = this.prefixClassName(ClassNames.title);
    const searchText = this.prefixClassName(ClassNames.searchText);
    const groupTitle = this.prefixClassName(ClassNames.groupTitle);
    this.delegateEvents({
      [`click .${title}`]: "onTitleClick",
      [`touchstart .${title}`]: "onTitleClick",
      [`click .${groupTitle}`]: "onGroupTitleClick",
      [`touchstart .${groupTitle}`]: "onGroupTitleClick",
      [`input .${searchText}`]: "onSearch",
      [`focusin .${searchText}`]: "onSearchFocusIn",
      [`focusout .${searchText}`]: "onSearchFocusOut"
    });
  }
  stopListening() {
    this.undelegateEvents();
  }
  registerGraphEvents(graph) {
    graph.on("cell:mousedown", this.onDragStart, this);
  }
  unregisterGraphEvents(graph) {
    graph.off("cell:mousedown", this.onDragStart, this);
  }
  loadGroup(cells, groupName, reverse) {
    const model = this.getModel(groupName);
    if (model) {
      const nodes = cells.map((cell) => Node$1.isNode(cell) ? cell : Node$1.create(cell));
      if (reverse === true) {
        model.removeCells(nodes);
      } else {
        model.resetCells(nodes);
      }
    }
    const group = this.getGroup(groupName);
    let height = this.options.stencilGraphHeight;
    if (group && group.graphHeight != null) {
      height = group.graphHeight;
    }
    const layout2 = group && group.layout || this.options.layout;
    if (layout2 && model) {
      FunctionExt.call(layout2, this, model, group);
    }
    if (!height) {
      const graph = this.getGraph(groupName);
      graph.fitToContent({
        minWidth: graph.options.width,
        gridHeight: 1,
        padding: group && group.graphPadding || this.options.stencilGraphPadding || 10
      });
    }
    return this;
  }
  onDragStart(args) {
    const { e: e10, node } = args;
    const group = this.getGroupByNode(node);
    if (group && group.nodeMovable === false) {
      return;
    }
    this.dnd.start(node, e10);
  }
  filter(keyword, filter) {
    const found = Object.keys(this.graphs).reduce((memo, groupName) => {
      const graph = this.graphs[groupName];
      const name = groupName === Private.defaultGroupName ? null : groupName;
      const items = graph.model.getNodes().filter((cell) => {
        let matched = false;
        if (typeof filter === "function") {
          matched = FunctionExt.call(filter, this, cell, keyword, name, this);
        } else if (typeof filter === "boolean") {
          matched = filter;
        } else {
          matched = this.isCellMatched(cell, keyword, filter, keyword.toLowerCase() !== keyword);
        }
        const view = graph.renderer.findViewByCell(cell);
        if (view) {
          Dom.toggleClass(view.container, "unmatched", !matched);
        }
        return matched;
      });
      const found2 = items.length > 0;
      const options = this.options;
      const model = new Model();
      model.resetCells(items);
      if (options.layout) {
        FunctionExt.call(options.layout, this, model, this.getGroup(groupName));
      }
      if (this.groups[groupName]) {
        Dom.toggleClass(this.groups[groupName], "unmatched", !found2);
      }
      graph.fitToContent({
        gridWidth: 1,
        gridHeight: 1,
        padding: options.stencilGraphPadding || 10
      });
      return memo || found2;
    }, false);
    Dom.toggleClass(this.container, "not-found", !found);
  }
  isCellMatched(cell, keyword, filters, ignoreCase) {
    if (keyword && filters) {
      return Object.keys(filters).some((shape) => {
        if (shape === "*" || cell.shape === shape) {
          const filter = filters[shape];
          if (typeof filter === "boolean") {
            return filter;
          }
          const paths = Array.isArray(filter) ? filter : [filter];
          return paths.some((path) => {
            let val = cell.getPropByPath(path);
            if (val != null) {
              val = `${val}`;
              if (!ignoreCase) {
                val = val.toLowerCase();
              }
              return val.indexOf(keyword) >= 0;
            }
            return false;
          });
        }
        return false;
      });
    }
    return true;
  }
  onSearch(evt) {
    this.filter(evt.target.value, this.options.search);
  }
  onSearchFocusIn() {
    Dom.addClass(this.container, "is-focused");
  }
  onSearchFocusOut() {
    Dom.removeClass(this.container, "is-focused");
  }
  onTitleClick() {
    if (this.options.collapsable) {
      Dom.toggleClass(this.container, "collapsed");
      if (Dom.hasClass(this.container, "collapsed")) {
        this.collapseGroups();
      } else {
        this.expandGroups();
      }
    }
  }
  onGroupTitleClick(evt) {
    const group = evt.target.closest(`.${this.prefixClassName(ClassNames.group)}`);
    if (group) {
      this.toggleGroup(Dom.attr(group, "data-name") || "");
    }
    const allCollapsed = Object.keys(this.groups).every((name) => {
      const group2 = this.getGroup(name);
      const groupElem = this.groups[name];
      return group2 && group2.collapsable === false || Dom.hasClass(groupElem, "collapsed");
    });
    Dom.toggleClass(this.container, "collapsed", allCollapsed);
  }
  getModel(groupName) {
    const graph = this.getGraph(groupName);
    return graph ? graph.model : null;
  }
  getGraph(groupName) {
    return this.graphs[groupName || Private.defaultGroupName];
  }
  getGroup(groupName) {
    const groups = this.options.groups;
    if (groupName != null && groups && groups.length) {
      return groups.find((group) => group.name === groupName);
    }
    return null;
  }
  getGroupByNode(node) {
    const groups = this.options.groups;
    if (groups) {
      return groups.find((group) => {
        const model = this.getModel(group.name);
        if (model) {
          return model.has(node.id);
        }
        return false;
      });
    }
    return null;
  }
  clearGroups() {
    Object.keys(this.graphs).forEach((groupName) => {
      const graph = this.graphs[groupName];
      this.unregisterGraphEvents(graph);
      graph.dispose();
    });
    Object.keys(this.groups).forEach((groupName) => {
      const elem = this.groups[groupName];
      Dom.remove(elem);
    });
    this.graphs = {};
    this.groups = {};
  }
  onRemove() {
    this.clearGroups();
    this.dnd.remove();
    this.stopListening();
    this.undelegateDocumentEvents();
  }
  dispose() {
    this.remove();
    CssLoader.clean(this.name);
  }
}
__decorate$3([
  View.dispose()
], Stencil.prototype, "dispose", null);
(function(Stencil2) {
  Stencil2.defaultOptions = Object.assign({ stencilGraphWidth: 200, stencilGraphHeight: 800, title: "Stencil", collapsable: false, placeholder: "Search", notFoundText: "No matches found", layout(model, group) {
    const options = {
      columnWidth: this.options.stencilGraphWidth / 2 - 10,
      columns: 2,
      rowHeight: 80,
      resizeToFit: false,
      dx: 10,
      dy: 10
    };
    grid(model, Object.assign(Object.assign(Object.assign({}, options), this.options.layoutOptions), group ? group.layoutOptions : {}));
  } }, Dnd.defaults);
})(Stencil || (Stencil = {}));
var ClassNames;
(function(ClassNames2) {
  ClassNames2.base = "widget-stencil";
  ClassNames2.title = `${ClassNames2.base}-title`;
  ClassNames2.search = `${ClassNames2.base}-search`;
  ClassNames2.searchText = `${ClassNames2.search}-text`;
  ClassNames2.content = `${ClassNames2.base}-content`;
  ClassNames2.group = `${ClassNames2.base}-group`;
  ClassNames2.groupTitle = `${ClassNames2.group}-title`;
  ClassNames2.groupContent = `${ClassNames2.group}-content`;
})(ClassNames || (ClassNames = {}));
var Private;
(function(Private2) {
  Private2.defaultGroupName = "__default__";
})(Private || (Private = {}));
const registerVueNode = (vueShapeDescriptor) => {
  var _a3;
  const appContext = (_a3 = getCurrentInstance()) == null ? void 0 : _a3.appContext;
  const elementGlobalConfig = useGlobalConfig();
  if (elementGlobalConfig.value == void 0) {
    elementGlobalConfig.value = {};
  }
  const component2 = vueShapeDescriptor.config.component;
  vueShapeDescriptor.config.component = {
    setup() {
      var _a4;
      provideGlobalConfig(elementGlobalConfig);
      if (appContext) {
        const instance = getCurrentInstance();
        if (instance) {
          instance.appContext = appContext;
        }
      }
      (_a4 = vueShapeDescriptor.setup) == null ? void 0 : _a4.call(vueShapeDescriptor);
    },
    errorCaptured(error) {
      console.error(error);
    },
    render() {
      var _a4;
      const props = ((_a4 = vueShapeDescriptor.buildProps) == null ? void 0 : _a4.call(vueShapeDescriptor)) || {};
      return h$3(component2, props);
    }
  };
  register(vueShapeDescriptor.config);
};
var __decorate$2 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
var __rest = function(s2, e10) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e10.indexOf(p2) < 0)
    t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e10.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
class ScrollerImpl extends View {
  get graph() {
    return this.options.graph;
  }
  get model() {
    return this.graph.model;
  }
  constructor(options) {
    super();
    this.padding = { left: 0, top: 0, right: 0, bottom: 0 };
    this.options = ScrollerImpl.getOptions(options);
    this.onUpdate = FunctionExt.debounce(this.onUpdate, 200);
    const scale = this.graph.transform.getScale();
    this.sx = scale.sx;
    this.sy = scale.sy;
    const width2 = this.options.width || this.graph.options.width;
    const height = this.options.height || this.graph.options.height;
    this.container = document.createElement("div");
    Dom.addClass(this.container, this.prefixClassName(ScrollerImpl.containerClass));
    Dom.css(this.container, { width: width2, height });
    if (this.options.pageVisible) {
      Dom.addClass(this.container, this.prefixClassName(ScrollerImpl.pagedClass));
    }
    if (this.options.className) {
      Dom.addClass(this.container, this.options.className);
    }
    const graphContainer = this.graph.container;
    if (graphContainer.parentNode) {
      Dom.before(graphContainer, this.container);
    }
    this.content = document.createElement("div");
    Dom.addClass(this.content, this.prefixClassName(ScrollerImpl.contentClass));
    Dom.css(this.content, {
      width: this.graph.options.width,
      height: this.graph.options.height
    });
    this.background = document.createElement("div");
    Dom.addClass(this.background, this.prefixClassName(ScrollerImpl.backgroundClass));
    Dom.append(this.content, this.background);
    if (!this.options.pageVisible) {
      Dom.append(this.content, this.graph.view.grid);
    }
    Dom.append(this.content, graphContainer);
    Dom.appendTo(this.content, this.container);
    this.startListening();
    if (!this.options.pageVisible) {
      this.graph.grid.update();
    }
    this.backgroundManager = new ScrollerImpl.Background(this);
    if (!this.options.autoResize) {
      this.update();
    }
  }
  startListening() {
    const graph = this.graph;
    const model = this.model;
    graph.on("scale", this.onScale, this);
    graph.on("resize", this.onResize, this);
    graph.on("before:print", this.storeScrollPosition, this);
    graph.on("before:export", this.storeScrollPosition, this);
    graph.on("after:print", this.restoreScrollPosition, this);
    graph.on("after:export", this.restoreScrollPosition, this);
    model.on("reseted", this.onUpdate, this);
    model.on("cell:added", this.onUpdate, this);
    model.on("cell:removed", this.onUpdate, this);
    model.on("cell:changed", this.onUpdate, this);
    this.delegateBackgroundEvents();
  }
  stopListening() {
    const graph = this.graph;
    const model = this.model;
    graph.off("scale", this.onScale, this);
    graph.off("resize", this.onResize, this);
    graph.off("beforeprint", this.storeScrollPosition, this);
    graph.off("beforeexport", this.storeScrollPosition, this);
    graph.off("afterprint", this.restoreScrollPosition, this);
    graph.off("afterexport", this.restoreScrollPosition, this);
    model.off("reseted", this.onUpdate, this);
    model.off("cell:added", this.onUpdate, this);
    model.off("cell:removed", this.onUpdate, this);
    model.off("cell:changed", this.onUpdate, this);
    this.undelegateBackgroundEvents();
  }
  enableAutoResize() {
    this.options.autoResize = true;
  }
  disableAutoResize() {
    this.options.autoResize = false;
  }
  onUpdate() {
    if (this.options.autoResize) {
      this.update();
    }
  }
  delegateBackgroundEvents(events) {
    const evts = events || GraphView.events;
    this.delegatedHandlers = Object.keys(evts).reduce((memo, name) => {
      const handler = evts[name];
      if (name.indexOf(" ") === -1) {
        if (typeof handler === "function") {
          memo[name] = handler;
        } else {
          let method4 = this.graph.view[handler];
          if (typeof method4 === "function") {
            method4 = method4.bind(this.graph.view);
            memo[name] = method4;
          }
        }
      }
      return memo;
    }, {});
    this.onBackgroundEvent = this.onBackgroundEvent.bind(this);
    Object.keys(this.delegatedHandlers).forEach((name) => {
      this.delegateEvent(name, {
        guarded: false
      }, this.onBackgroundEvent);
    });
  }
  undelegateBackgroundEvents() {
    Object.keys(this.delegatedHandlers).forEach((name) => {
      this.undelegateEvent(name, this.onBackgroundEvent);
    });
  }
  onBackgroundEvent(e10) {
    let valid = false;
    const target = e10.target;
    if (!this.options.pageVisible) {
      const view = this.graph.view;
      valid = view.background === target || view.grid === target;
    } else if (this.options.background) {
      valid = this.background === target;
    } else {
      valid = this.content === target;
    }
    if (valid) {
      const handler = this.delegatedHandlers[e10.type];
      if (typeof handler === "function") {
        handler.apply(this.graph, arguments);
      }
    }
  }
  onResize() {
    if (this.cachedCenterPoint) {
      this.centerPoint(this.cachedCenterPoint.x, this.cachedCenterPoint.y);
      this.updatePageBreak();
    }
  }
  onScale({ sx: sx2, sy: sy2, ox: ox2, oy: oy2 }) {
    this.updateScale(sx2, sy2);
    if (ox2 || oy2) {
      this.centerPoint(ox2, oy2);
      this.updatePageBreak();
    }
    const autoResizeOptions = this.options.autoResizeOptions;
    if (typeof autoResizeOptions === "function") {
      this.update();
    }
  }
  storeScrollPosition() {
    this.cachedScrollLeft = this.container.scrollLeft;
    this.cachedScrollTop = this.container.scrollTop;
  }
  restoreScrollPosition() {
    this.container.scrollLeft = this.cachedScrollLeft;
    this.container.scrollTop = this.cachedScrollTop;
    this.cachedScrollLeft = null;
    this.cachedScrollTop = null;
  }
  storeClientSize() {
    this.cachedClientSize = {
      width: this.container.clientWidth,
      height: this.container.clientHeight
    };
  }
  restoreClientSize() {
    this.cachedClientSize = null;
  }
  beforeManipulation() {
    if (Platform.IS_IE || Platform.IS_EDGE) {
      Dom.css(this.container, { visibility: "hidden" });
    }
  }
  afterManipulation() {
    if (Platform.IS_IE || Platform.IS_EDGE) {
      Dom.css(this.container, { visibility: "visible" });
    }
  }
  updatePageSize(width2, height) {
    if (width2 != null) {
      this.options.pageWidth = width2;
    }
    if (height != null) {
      this.options.pageHeight = height;
    }
    this.updatePageBreak();
  }
  updatePageBreak() {
    if (this.pageBreak && this.pageBreak.parentNode) {
      this.pageBreak.parentNode.removeChild(this.pageBreak);
    }
    this.pageBreak = null;
    if (this.options.pageVisible && this.options.pageBreak) {
      const graphWidth = this.graph.options.width;
      const graphHeight = this.graph.options.height;
      const pageWidth = this.options.pageWidth * this.sx;
      const pageHeight = this.options.pageHeight * this.sy;
      if (pageWidth === 0 || pageHeight === 0) {
        return;
      }
      if (graphWidth > pageWidth || graphHeight > pageHeight) {
        let hasPageBreak = false;
        const container = document.createElement("div");
        for (let i2 = 1, l2 = Math.floor(graphWidth / pageWidth); i2 < l2; i2 += 1) {
          const div = document.createElement("div");
          Dom.addClass(div, this.prefixClassName(`graph-pagebreak-vertical`));
          Dom.css(div, { left: i2 * pageWidth });
          Dom.appendTo(div, container);
          hasPageBreak = true;
        }
        for (let i2 = 1, l2 = Math.floor(graphHeight / pageHeight); i2 < l2; i2 += 1) {
          const div = document.createElement("div");
          Dom.addClass(div, this.prefixClassName(`graph-pagebreak-horizontal`));
          Dom.css(div, { top: i2 * pageHeight });
          Dom.appendTo(div, container);
          hasPageBreak = true;
        }
        if (hasPageBreak) {
          Dom.addClass(container, this.prefixClassName("graph-pagebreak"));
          Dom.after(this.graph.view.grid, container);
          this.pageBreak = container;
        }
      }
    }
  }
  update() {
    const size = this.getClientSize();
    this.cachedCenterPoint = this.clientToLocalPoint(size.width / 2, size.height / 2);
    let resizeOptions = this.options.autoResizeOptions;
    if (typeof resizeOptions === "function") {
      resizeOptions = FunctionExt.call(resizeOptions, this, this);
    }
    const options = Object.assign({ gridWidth: this.options.pageWidth, gridHeight: this.options.pageHeight, allowNewOrigin: "negative" }, resizeOptions);
    this.graph.fitToContent(this.getFitToContentOptions(options));
  }
  getFitToContentOptions(options) {
    const sx2 = this.sx;
    const sy2 = this.sy;
    options.gridWidth && (options.gridWidth *= sx2);
    options.gridHeight && (options.gridHeight *= sy2);
    options.minWidth && (options.minWidth *= sx2);
    options.minHeight && (options.minHeight *= sy2);
    if (typeof options.padding === "object") {
      options.padding = {
        left: (options.padding.left || 0) * sx2,
        right: (options.padding.right || 0) * sx2,
        top: (options.padding.top || 0) * sy2,
        bottom: (options.padding.bottom || 0) * sy2
      };
    } else if (typeof options.padding === "number") {
      options.padding *= sx2;
    }
    if (!this.options.autoResize) {
      options.contentArea = Rectangle.create();
    }
    return options;
  }
  updateScale(sx2, sy2) {
    const options = this.graph.options;
    const dx2 = sx2 / this.sx;
    const dy2 = sy2 / this.sy;
    this.sx = sx2;
    this.sy = sy2;
    this.graph.translate(options.x * dx2, options.y * dy2);
    this.graph.transform.resize(options.width * dx2, options.height * dy2);
  }
  scrollbarPosition(left, top) {
    if (left == null && top == null) {
      return {
        left: this.container.scrollLeft,
        top: this.container.scrollTop
      };
    }
    const prop = {};
    if (typeof left === "number") {
      prop.scrollLeft = left;
    }
    if (typeof top === "number") {
      prop.scrollTop = top;
    }
    Dom.prop(this.container, prop);
    return this;
  }
  /**
   * Try to scroll to ensure that the position (x,y) on the graph (in local
   * coordinates) is at the center of the viewport. If only one of the
   * coordinates is specified, only scroll in the specified dimension and
   * keep the other coordinate unchanged.
   */
  scrollToPoint(x2, y2) {
    const size = this.getClientSize();
    const ctm = this.graph.matrix();
    const prop = {};
    if (typeof x2 === "number") {
      prop.scrollLeft = x2 - size.width / 2 + ctm.e + (this.padding.left || 0);
    }
    if (typeof y2 === "number") {
      prop.scrollTop = y2 - size.height / 2 + ctm.f + (this.padding.top || 0);
    }
    Dom.prop(this.container, prop);
    return this;
  }
  /**
   * Try to scroll to ensure that the center of graph content is at the
   * center of the viewport.
   */
  scrollToContent() {
    const sx2 = this.sx;
    const sy2 = this.sy;
    const center = this.graph.getContentArea().getCenter();
    return this.scrollToPoint(center.x * sx2, center.y * sy2);
  }
  /**
   * Try to scroll to ensure that the center of cell is at the center of
   * the viewport.
   */
  scrollToCell(cell) {
    const sx2 = this.sx;
    const sy2 = this.sy;
    const center = cell.getBBox().getCenter();
    return this.scrollToPoint(center.x * sx2, center.y * sy2);
  }
  /**
   * The center methods are more aggressive than the scroll methods. These
   * methods position the graph so that a specific point on the graph lies
   * at the center of the viewport, adding paddings around the paper if
   * necessary (e.g. if the requested point lies in a corner of the paper).
   * This means that the requested point will always move into the center
   * of the viewport. (Use the scroll functions to avoid adding paddings
   * and only scroll the viewport as far as the graph boundary.)
   */
  /**
   * Position the center of graph to the center of the viewport.
   */
  center(optons) {
    return this.centerPoint(optons);
  }
  centerPoint(x2, y2, options) {
    const ctm = this.graph.matrix();
    const sx2 = ctm.a;
    const sy2 = ctm.d;
    const tx2 = -ctm.e;
    const ty2 = -ctm.f;
    const tWidth = tx2 + this.graph.options.width;
    const tHeight = ty2 + this.graph.options.height;
    let localOptions;
    this.storeClientSize();
    if (typeof x2 === "number" || typeof y2 === "number") {
      localOptions = options;
      const visibleCenter = this.getVisibleArea().getCenter();
      if (typeof x2 === "number") {
        x2 *= sx2;
      } else {
        x2 = visibleCenter.x;
      }
      if (typeof y2 === "number") {
        y2 *= sy2;
      } else {
        y2 = visibleCenter.y;
      }
    } else {
      localOptions = x2;
      x2 = (tx2 + tWidth) / 2;
      y2 = (ty2 + tHeight) / 2;
    }
    if (localOptions && localOptions.padding) {
      return this.positionPoint({ x: x2, y: y2 }, "50%", "50%", localOptions);
    }
    const padding = this.getPadding();
    const clientSize = this.getClientSize();
    const cx2 = clientSize.width / 2;
    const cy2 = clientSize.height / 2;
    const left = cx2 - padding.left - x2 + tx2;
    const right = cx2 - padding.right + x2 - tWidth;
    const top = cy2 - padding.top - y2 + ty2;
    const bottom = cy2 - padding.bottom + y2 - tHeight;
    this.addPadding(Math.max(left, 0), Math.max(right, 0), Math.max(top, 0), Math.max(bottom, 0));
    const result = this.scrollToPoint(x2, y2);
    this.restoreClientSize();
    return result;
  }
  centerContent(options) {
    return this.positionContent("center", options);
  }
  centerCell(cell, options) {
    return this.positionCell(cell, "center", options);
  }
  /**
   * The position methods are a more general version of the center methods.
   * They position the graph so that a specific point on the graph lies at
   * requested coordinates inside the viewport.
   */
  /**
   *
   */
  positionContent(pos, options) {
    const rect = this.graph.getContentArea(options);
    return this.positionRect(rect, pos, options);
  }
  positionCell(cell, pos, options) {
    const bbox = cell.getBBox();
    return this.positionRect(bbox, pos, options);
  }
  positionRect(rect, pos, options) {
    const bbox = Rectangle.create(rect);
    switch (pos) {
      case "center":
        return this.positionPoint(bbox.getCenter(), "50%", "50%", options);
      case "top":
        return this.positionPoint(bbox.getTopCenter(), "50%", 0, options);
      case "top-right":
        return this.positionPoint(bbox.getTopRight(), "100%", 0, options);
      case "right":
        return this.positionPoint(bbox.getRightMiddle(), "100%", "50%", options);
      case "bottom-right":
        return this.positionPoint(bbox.getBottomRight(), "100%", "100%", options);
      case "bottom":
        return this.positionPoint(bbox.getBottomCenter(), "50%", "100%", options);
      case "bottom-left":
        return this.positionPoint(bbox.getBottomLeft(), 0, "100%", options);
      case "left":
        return this.positionPoint(bbox.getLeftMiddle(), 0, "50%", options);
      case "top-left":
        return this.positionPoint(bbox.getTopLeft(), 0, 0, options);
      default:
        return this;
    }
  }
  positionPoint(point, x2, y2, options = {}) {
    const { padding: pad } = options, localOptions = __rest(options, ["padding"]);
    const padding = NumberExt.normalizeSides(pad);
    const clientRect = Rectangle.fromSize(this.getClientSize());
    const targetRect = clientRect.clone().moveAndExpand({
      x: padding.left,
      y: padding.top,
      width: -padding.right - padding.left,
      height: -padding.top - padding.bottom
    });
    x2 = NumberExt.normalizePercentage(x2, Math.max(0, targetRect.width));
    if (x2 < 0) {
      x2 = targetRect.width + x2;
    }
    y2 = NumberExt.normalizePercentage(y2, Math.max(0, targetRect.height));
    if (y2 < 0) {
      y2 = targetRect.height + y2;
    }
    const origin = targetRect.getTopLeft().translate(x2, y2);
    const diff = clientRect.getCenter().diff(origin);
    const scale = this.zoom();
    const rawDiff = diff.scale(1 / scale, 1 / scale);
    const result = Point.create(point).translate(rawDiff);
    return this.centerPoint(result.x, result.y, localOptions);
  }
  zoom(factor, options) {
    if (factor == null) {
      return this.sx;
    }
    options = options || {};
    let cx2;
    let cy2;
    const clientSize = this.getClientSize();
    const center = this.clientToLocalPoint(clientSize.width / 2, clientSize.height / 2);
    let sx2 = factor;
    let sy2 = factor;
    if (!options.absolute) {
      sx2 += this.sx;
      sy2 += this.sy;
    }
    if (options.scaleGrid) {
      sx2 = Math.round(sx2 / options.scaleGrid) * options.scaleGrid;
      sy2 = Math.round(sy2 / options.scaleGrid) * options.scaleGrid;
    }
    if (options.maxScale) {
      sx2 = Math.min(options.maxScale, sx2);
      sy2 = Math.min(options.maxScale, sy2);
    }
    if (options.minScale) {
      sx2 = Math.max(options.minScale, sx2);
      sy2 = Math.max(options.minScale, sy2);
    }
    sx2 = this.graph.transform.clampScale(sx2);
    sy2 = this.graph.transform.clampScale(sy2);
    if (options.center) {
      const fx2 = sx2 / this.sx;
      const fy2 = sy2 / this.sy;
      cx2 = options.center.x - (options.center.x - center.x) / fx2;
      cy2 = options.center.y - (options.center.y - center.y) / fy2;
    } else {
      cx2 = center.x;
      cy2 = center.y;
    }
    this.beforeManipulation();
    this.graph.transform.scale(sx2, sy2);
    this.centerPoint(cx2, cy2);
    this.afterManipulation();
    return this;
  }
  zoomToRect(rect, options = {}) {
    const area = Rectangle.create(rect);
    const graph = this.graph;
    options.contentArea = area;
    if (options.viewportArea == null) {
      const bound = this.container.getBoundingClientRect();
      options.viewportArea = {
        x: graph.options.x,
        y: graph.options.y,
        width: bound.width,
        height: bound.height
      };
    }
    this.beforeManipulation();
    graph.transform.scaleContentToFitImpl(options, false);
    const center = area.getCenter();
    this.centerPoint(center.x, center.y);
    this.afterManipulation();
    return this;
  }
  zoomToFit(options = {}) {
    return this.zoomToRect(this.graph.getContentArea(options), options);
  }
  transitionToPoint(x2, y2, options) {
    if (typeof x2 === "object") {
      options = y2;
      y2 = x2.y;
      x2 = x2.x;
    } else {
      y2 = y2;
    }
    if (options == null) {
      options = {};
    }
    let transform;
    let transformOrigin;
    const scale = this.sx;
    const targetScale = Math.max(options.scale || scale, 1e-6);
    const clientSize = this.getClientSize();
    const targetPoint = new Point(x2, y2);
    const localPoint = this.clientToLocalPoint(clientSize.width / 2, clientSize.height / 2);
    if (scale === targetScale) {
      const translate2 = localPoint.diff(targetPoint).scale(scale, scale).round();
      transform = `translate(${translate2.x}px,${translate2.y}px)`;
    } else {
      const delta = targetScale / (scale - targetScale) * targetPoint.distance(localPoint);
      const range3 = localPoint.clone().move(targetPoint, delta);
      const origin = this.localToBackgroundPoint(range3).round();
      transform = `scale(${targetScale / scale})`;
      transformOrigin = `${origin.x}px ${origin.y}px`;
    }
    const onTransitionEnd = options.onTransitionEnd;
    Dom.addClass(this.container, ScrollerImpl.transitionClassName);
    Dom.Event.off(this.content, ScrollerImpl.transitionEventName);
    Dom.Event.on(this.content, ScrollerImpl.transitionEventName, (e10) => {
      this.syncTransition(targetScale, { x: x2, y: y2 });
      if (typeof onTransitionEnd === "function") {
        FunctionExt.call(onTransitionEnd, this, e10.originalEvent);
      }
    });
    Dom.css(this.content, {
      transform,
      transformOrigin,
      transition: "transform",
      transitionDuration: options.duration || "1s",
      transitionDelay: options.delay,
      transitionTimingFunction: options.timing
    });
    return this;
  }
  syncTransition(scale, p2) {
    this.beforeManipulation();
    this.graph.scale(scale);
    this.removeTransition();
    this.centerPoint(p2.x, p2.y);
    this.afterManipulation();
    return this;
  }
  removeTransition() {
    Dom.removeClass(this.container, ScrollerImpl.transitionClassName);
    Dom.Event.off(this.content, ScrollerImpl.transitionEventName);
    Dom.css(this.content, {
      transform: "",
      transformOrigin: "",
      transition: "",
      transitionDuration: "",
      transitionDelay: "",
      transitionTimingFunction: ""
    });
    return this;
  }
  transitionToRect(rectangle, options = {}) {
    const rect = Rectangle.create(rectangle);
    const maxScale = options.maxScale || Infinity;
    const minScale = options.minScale || Number.MIN_VALUE;
    const scaleGrid = options.scaleGrid || null;
    const PIXEL_SIZE = options.visibility || 1;
    const center = options.center ? Point.create(options.center) : rect.getCenter();
    const clientSize = this.getClientSize();
    const w2 = clientSize.width * PIXEL_SIZE;
    const h2 = clientSize.height * PIXEL_SIZE;
    let scale = new Rectangle(center.x - w2 / 2, center.y - h2 / 2, w2, h2).getMaxUniformScaleToFit(rect, center);
    scale = Math.min(scale, maxScale);
    if (scaleGrid) {
      scale = Math.floor(scale / scaleGrid) * scaleGrid;
    }
    scale = Math.max(minScale, scale);
    return this.transitionToPoint(center, Object.assign({ scale }, options));
  }
  startPanning(evt) {
    const e10 = this.normalizeEvent(evt);
    this.clientX = e10.clientX;
    this.clientY = e10.clientY;
    this.trigger("pan:start", { e: e10 });
    Dom.Event.on(document.body, {
      "mousemove.panning touchmove.panning": this.pan.bind(this),
      "mouseup.panning touchend.panning": this.stopPanning.bind(this),
      "mouseleave.panning": this.stopPanning.bind(this)
    });
    Dom.Event.on(window, "mouseup.panning", this.stopPanning.bind(this));
  }
  pan(evt) {
    const e10 = this.normalizeEvent(evt);
    const dx2 = e10.clientX - this.clientX;
    const dy2 = e10.clientY - this.clientY;
    this.container.scrollTop -= dy2;
    this.container.scrollLeft -= dx2;
    this.clientX = e10.clientX;
    this.clientY = e10.clientY;
    this.trigger("panning", { e: e10 });
  }
  stopPanning(e10) {
    Dom.Event.off(document.body, ".panning");
    Dom.Event.off(window, ".panning");
    this.trigger("pan:stop", { e: e10 });
  }
  clientToLocalPoint(a2, b2) {
    let x2 = typeof a2 === "object" ? a2.x : a2;
    let y2 = typeof a2 === "object" ? a2.y : b2;
    const ctm = this.graph.matrix();
    x2 += this.container.scrollLeft - this.padding.left - ctm.e;
    y2 += this.container.scrollTop - this.padding.top - ctm.f;
    return new Point(x2 / ctm.a, y2 / ctm.d);
  }
  localToBackgroundPoint(x2, y2) {
    const p2 = typeof x2 === "object" ? Point.create(x2) : new Point(x2, y2);
    const ctm = this.graph.matrix();
    const padding = this.padding;
    return Util$2.transformPoint(p2, ctm).translate(padding.left, padding.top);
  }
  resize(width2, height) {
    let w2 = width2 != null ? width2 : this.container.offsetWidth;
    let h2 = height != null ? height : this.container.offsetHeight;
    if (typeof w2 === "number") {
      w2 = Math.round(w2);
    }
    if (typeof h2 === "number") {
      h2 = Math.round(h2);
    }
    this.options.width = w2;
    this.options.height = h2;
    Dom.css(this.container, { width: w2, height: h2 });
    this.update();
  }
  getClientSize() {
    if (this.cachedClientSize) {
      return this.cachedClientSize;
    }
    return {
      width: this.container.clientWidth,
      height: this.container.clientHeight
    };
  }
  autoScroll(clientX, clientY) {
    const buffer = 10;
    const container = this.container;
    const rect = container.getBoundingClientRect();
    let dx2 = 0;
    let dy2 = 0;
    if (clientX <= rect.left + buffer) {
      dx2 = -10;
    }
    if (clientY <= rect.top + buffer) {
      dy2 = -10;
    }
    if (clientX >= rect.right - buffer) {
      dx2 = buffer;
    }
    if (clientY >= rect.bottom - buffer) {
      dy2 = buffer;
    }
    if (dx2 !== 0) {
      container.scrollLeft += dx2;
    }
    if (dy2 !== 0) {
      container.scrollTop += dy2;
    }
    return {
      scrollerX: dx2,
      scrollerY: dy2
    };
  }
  addPadding(left, right, top, bottom) {
    let padding = this.getPadding();
    this.padding = {
      left: Math.round(padding.left + (left || 0)),
      top: Math.round(padding.top + (top || 0)),
      bottom: Math.round(padding.bottom + (bottom || 0)),
      right: Math.round(padding.right + (right || 0))
    };
    padding = this.padding;
    Dom.css(this.content, {
      width: padding.left + this.graph.options.width + padding.right,
      height: padding.top + this.graph.options.height + padding.bottom
    });
    const container = this.graph.container;
    container.style.left = `${this.padding.left}px`;
    container.style.top = `${this.padding.top}px`;
    return this;
  }
  getPadding() {
    const padding = this.options.padding;
    if (typeof padding === "function") {
      return NumberExt.normalizeSides(FunctionExt.call(padding, this, this));
    }
    return NumberExt.normalizeSides(padding);
  }
  /**
   * Returns the untransformed size and origin of the current viewport.
   */
  getVisibleArea() {
    const ctm = this.graph.matrix();
    const size = this.getClientSize();
    const box = {
      x: this.container.scrollLeft || 0,
      y: this.container.scrollTop || 0,
      width: size.width,
      height: size.height
    };
    const area = Util$2.transformRectangle(box, ctm.inverse());
    area.x -= (this.padding.left || 0) / this.sx;
    area.y -= (this.padding.top || 0) / this.sy;
    return area;
  }
  isCellVisible(cell, options = {}) {
    const bbox = cell.getBBox();
    const area = this.getVisibleArea();
    return options.strict ? area.containsRect(bbox) : area.isIntersectWithRect(bbox);
  }
  isPointVisible(point) {
    return this.getVisibleArea().containsPoint(point);
  }
  /**
   * Lock the current viewport by disabling user scrolling.
   */
  lock() {
    Dom.css(this.container, { overflow: "hidden" });
    return this;
  }
  /**
   * Enable user scrolling if previously locked.
   */
  unlock() {
    Dom.css(this.container, { overflow: "scroll" });
    return this;
  }
  onRemove() {
    this.stopListening();
  }
  dispose() {
    Dom.before(this.container, this.graph.container);
    this.remove();
  }
}
__decorate$2([
  View.dispose()
], ScrollerImpl.prototype, "dispose", null);
(function(ScrollerImpl2) {
  class Background extends BackgroundManager {
    get elem() {
      return this.scroller.background;
    }
    constructor(scroller) {
      super(scroller.graph);
      this.scroller = scroller;
      if (scroller.options.background) {
        this.draw(scroller.options.background);
      }
    }
    init() {
      this.graph.on("scale", this.update, this);
      this.graph.on("translate", this.update, this);
    }
    updateBackgroundOptions(options) {
      this.scroller.options.background = options;
    }
  }
  ScrollerImpl2.Background = Background;
})(ScrollerImpl || (ScrollerImpl = {}));
(function(ScrollerImpl2) {
  ScrollerImpl2.containerClass = "graph-scroller";
  ScrollerImpl2.panningClass = `${ScrollerImpl2.containerClass}-panning`;
  ScrollerImpl2.pannableClass = `${ScrollerImpl2.containerClass}-pannable`;
  ScrollerImpl2.pagedClass = `${ScrollerImpl2.containerClass}-paged`;
  ScrollerImpl2.contentClass = `${ScrollerImpl2.containerClass}-content`;
  ScrollerImpl2.backgroundClass = `${ScrollerImpl2.containerClass}-background`;
  ScrollerImpl2.transitionClassName = "transition-in-progress";
  ScrollerImpl2.transitionEventName = "transitionend.graph-scroller-transition";
  ScrollerImpl2.defaultOptions = {
    padding() {
      const size = this.getClientSize();
      const minWidth = Math.max(this.options.minVisibleWidth || 0, 1) || 1;
      const minHeight = Math.max(this.options.minVisibleHeight || 0, 1) || 1;
      const left = Math.max(size.width - minWidth, 0);
      const top = Math.max(size.height - minHeight, 0);
      return { left, top, right: left, bottom: top };
    },
    minVisibleWidth: 50,
    minVisibleHeight: 50,
    pageVisible: false,
    pageBreak: false,
    autoResize: true
  };
  function getOptions(options) {
    const result = ObjectExt.merge({}, ScrollerImpl2.defaultOptions, options);
    if (result.pageWidth == null) {
      result.pageWidth = options.graph.options.width;
    }
    if (result.pageHeight == null) {
      result.pageHeight = options.graph.options.height;
    }
    const graphOptions = options.graph.options;
    if (graphOptions.background && result.enabled && result.background == null) {
      result.background = graphOptions.background;
      options.graph.background.clear();
    }
    return result;
  }
  ScrollerImpl2.getOptions = getOptions;
})(ScrollerImpl || (ScrollerImpl = {}));
const content$1 = `.x6-graph-scroller {
  position: relative;
  box-sizing: border-box;
  overflow: scroll;
  outline: none;
}
.x6-graph-scroller-content {
  position: relative;
}
.x6-graph-scroller-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.x6-graph-scroller .x6-graph {
  position: absolute;
  display: inline-block;
  margin: 0;
  box-shadow: none;
}
.x6-graph-scroller .x6-graph > svg {
  display: block;
}
.x6-graph-scroller.x6-graph-scroller-paged .x6-graph {
  box-shadow: 0 0 4px 0 #eee;
}
.x6-graph-scroller.x6-graph-scroller-pannable[data-panning='false'] {
  cursor: grab;
}
.x6-graph-scroller.x6-graph-scroller-pannable[data-panning='true'] {
  cursor: grabbing;
  user-select: none;
}
.x6-graph-pagebreak {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.x6-graph-pagebreak-vertical {
  position: absolute;
  top: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 1px;
  border-left: 1px dashed #bdbdbd;
}
.x6-graph-pagebreak-horizontal {
  position: absolute;
  right: 0;
  left: 0;
  box-sizing: border-box;
  height: 1px;
  border-top: 1px dashed #bdbdbd;
}
`;
Graph$2.prototype.lockScroller = function() {
  const scroller = this.getPlugin("scroller");
  if (scroller) {
    scroller.lockScroller();
  }
  return this;
};
Graph$2.prototype.unlockScroller = function() {
  const scroller = this.getPlugin("scroller");
  if (scroller) {
    scroller.unlockScroller();
  }
  return this;
};
Graph$2.prototype.updateScroller = function() {
  const scroller = this.getPlugin("scroller");
  if (scroller) {
    scroller.updateScroller();
  }
  return this;
};
Graph$2.prototype.getScrollbarPosition = function() {
  const scroller = this.getPlugin("scroller");
  if (scroller) {
    return scroller.getScrollbarPosition();
  }
  return {
    left: 0,
    top: 0
  };
};
Graph$2.prototype.setScrollbarPosition = function(left, top) {
  const scroller = this.getPlugin("scroller");
  if (scroller) {
    scroller.setScrollbarPosition(left, top);
  }
  return this;
};
var __decorate$1 = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class Scroller extends Basecoat {
  get pannable() {
    if (this.options) {
      if (typeof this.options.pannable === "object") {
        return this.options.pannable.enabled;
      }
      return !!this.options.pannable;
    }
    return false;
  }
  get container() {
    return this.scrollerImpl.container;
  }
  constructor(options = {}) {
    super();
    this.name = "scroller";
    this.options = options;
    CssLoader.ensure(this.name, content$1);
  }
  init(graph) {
    this.graph = graph;
    const options = ScrollerImpl.getOptions(Object.assign(Object.assign({ enabled: true }, this.options), { graph }));
    this.options = options;
    this.scrollerImpl = new ScrollerImpl(options);
    this.setup();
    this.startListening();
    this.updateClassName();
    this.scrollerImpl.center();
  }
  // #region api
  resize(width2, height) {
    this.scrollerImpl.resize(width2, height);
  }
  resizePage(width2, height) {
    this.scrollerImpl.updatePageSize(width2, height);
  }
  zoom(factor, options) {
    if (typeof factor === "undefined") {
      return this.scrollerImpl.zoom();
    }
    this.scrollerImpl.zoom(factor, options);
    return this;
  }
  zoomTo(factor, options = {}) {
    this.scrollerImpl.zoom(factor, Object.assign(Object.assign({}, options), { absolute: true }));
    return this;
  }
  zoomToRect(rect, options = {}) {
    this.scrollerImpl.zoomToRect(rect, options);
    return this;
  }
  zoomToFit(options = {}) {
    this.scrollerImpl.zoomToFit(options);
    return this;
  }
  center(optons) {
    return this.centerPoint(optons);
  }
  centerPoint(x2, y2, options) {
    this.scrollerImpl.centerPoint(x2, y2, options);
    return this;
  }
  centerContent(options) {
    this.scrollerImpl.centerContent(options);
    return this;
  }
  centerCell(cell, options) {
    this.scrollerImpl.centerCell(cell, options);
    return this;
  }
  positionPoint(point, x2, y2, options = {}) {
    this.scrollerImpl.positionPoint(point, x2, y2, options);
    return this;
  }
  positionRect(rect, direction, options) {
    this.scrollerImpl.positionRect(rect, direction, options);
    return this;
  }
  positionCell(cell, direction, options) {
    this.scrollerImpl.positionCell(cell, direction, options);
    return this;
  }
  positionContent(pos, options) {
    this.scrollerImpl.positionContent(pos, options);
    return this;
  }
  drawBackground(options, onGraph) {
    if (this.graph.options.background == null || !onGraph) {
      this.scrollerImpl.backgroundManager.draw(options);
    }
    return this;
  }
  clearBackground(onGraph) {
    if (this.graph.options.background == null || !onGraph) {
      this.scrollerImpl.backgroundManager.clear();
    }
    return this;
  }
  isPannable() {
    return this.pannable;
  }
  enablePanning() {
    if (!this.pannable) {
      this.options.pannable = true;
      this.updateClassName();
    }
  }
  disablePanning() {
    if (this.pannable) {
      this.options.pannable = false;
      this.updateClassName();
    }
  }
  togglePanning(pannable) {
    if (pannable == null) {
      if (this.isPannable()) {
        this.disablePanning();
      } else {
        this.enablePanning();
      }
    } else if (pannable !== this.isPannable()) {
      if (pannable) {
        this.enablePanning();
      } else {
        this.disablePanning();
      }
    }
    return this;
  }
  lockScroller() {
    this.scrollerImpl.lock();
    return this;
  }
  unlockScroller() {
    this.scrollerImpl.unlock();
    return this;
  }
  updateScroller() {
    this.scrollerImpl.update();
    return this;
  }
  getScrollbarPosition() {
    return this.scrollerImpl.scrollbarPosition();
  }
  setScrollbarPosition(left, top) {
    this.scrollerImpl.scrollbarPosition(left, top);
    return this;
  }
  scrollToPoint(x2, y2) {
    this.scrollerImpl.scrollToPoint(x2, y2);
    return this;
  }
  scrollToContent() {
    this.scrollerImpl.scrollToContent();
    return this;
  }
  scrollToCell(cell) {
    this.scrollerImpl.scrollToCell(cell);
    return this;
  }
  transitionToPoint(x2, y2, options) {
    this.scrollerImpl.transitionToPoint(x2, y2, options);
    return this;
  }
  transitionToRect(rect, options = {}) {
    this.scrollerImpl.transitionToRect(rect, options);
    return this;
  }
  enableAutoResize() {
    this.scrollerImpl.enableAutoResize();
  }
  disableAutoResize() {
    this.scrollerImpl.disableAutoResize();
  }
  autoScroll(clientX, clientY) {
    return this.scrollerImpl.autoScroll(clientX, clientY);
  }
  clientToLocalPoint(x2, y2) {
    return this.scrollerImpl.clientToLocalPoint(x2, y2);
  }
  // #endregion
  setup() {
    this.scrollerImpl.on("*", (name, args) => {
      this.trigger(name, args);
    });
  }
  startListening() {
    let eventTypes = [];
    const pannable = this.options.pannable;
    if (typeof pannable === "object") {
      eventTypes = pannable.eventTypes || [];
    } else {
      eventTypes = ["leftMouseDown"];
    }
    if (eventTypes.includes("leftMouseDown")) {
      this.graph.on("blank:mousedown", this.preparePanning, this);
      this.graph.on("node:unhandled:mousedown", this.preparePanning, this);
      this.graph.on("edge:unhandled:mousedown", this.preparePanning, this);
    }
    if (eventTypes.includes("rightMouseDown")) {
      this.onRightMouseDown = this.onRightMouseDown.bind(this);
      Dom.Event.on(this.scrollerImpl.container, "mousedown", this.onRightMouseDown);
    }
  }
  stopListening() {
    let eventTypes = [];
    const pannable = this.options.pannable;
    if (typeof pannable === "object") {
      eventTypes = pannable.eventTypes || [];
    } else {
      eventTypes = ["leftMouseDown"];
    }
    if (eventTypes.includes("leftMouseDown")) {
      this.graph.off("blank:mousedown", this.preparePanning, this);
      this.graph.off("node:unhandled:mousedown", this.preparePanning, this);
      this.graph.off("edge:unhandled:mousedown", this.preparePanning, this);
    }
    if (eventTypes.includes("rightMouseDown")) {
      Dom.Event.off(this.scrollerImpl.container, "mousedown", this.onRightMouseDown);
    }
  }
  onRightMouseDown(e10) {
    if (e10.button === 2 && this.allowPanning(e10, true)) {
      this.updateClassName(true);
      this.scrollerImpl.startPanning(e10);
      this.scrollerImpl.once("pan:stop", () => this.updateClassName(false));
    }
  }
  preparePanning({ e: e10 }) {
    const allowPanning = this.allowPanning(e10, true);
    const selection = this.graph.getPlugin("selection");
    const allowRubberband = selection && selection.allowRubberband(e10, true);
    if (allowPanning || this.allowPanning(e10) && !allowRubberband) {
      this.updateClassName(true);
      this.scrollerImpl.startPanning(e10);
      this.scrollerImpl.once("pan:stop", () => this.updateClassName(false));
    }
  }
  allowPanning(e10, strict) {
    return this.pannable && ModifierKey.isMatch(e10, this.options.modifiers, strict);
  }
  updateClassName(isPanning) {
    const container = this.scrollerImpl.container;
    const pannable = Config.prefix("graph-scroller-pannable");
    if (this.pannable) {
      Dom.addClass(container, pannable);
      container.dataset.panning = (!!isPanning).toString();
    } else {
      Dom.removeClass(container, pannable);
    }
  }
  dispose() {
    this.scrollerImpl.dispose();
    this.stopListening();
    this.off();
    CssLoader.clean(this.name);
  }
}
__decorate$1([
  Basecoat.dispose()
], Scroller.prototype, "dispose", null);
const initialGraph = (container, stencilContainer, t2) => {
  const graph = new Graph$2({
    container,
    autoResize: true,
    grid: false,
    panning: false,
    background: {
      color: "#FFFFFF"
    },
    translating: {
      restrict: true
    },
    mousewheel: {
      enabled: true,
      zoomAtMousePosition: true,
      modifiers: "ctrl",
      minScale: 0.2,
      maxScale: 3
    },
    connecting: {
      router: "manhattan",
      connector: {
        name: "rounded",
        args: {
          radius: 8
        }
      },
      anchor: "center",
      connectionPoint: "anchor",
      allowBlank: false,
      allowMulti: false,
      snap: {
        radius: 20
      },
      createEdge: createEdge$2,
      validateConnection
    },
    highlighting: {
      magnetAdsorbed: {
        name: "stroke",
        args: {
          attrs: {
            fill: "#5F95FF",
            stroke: "#5F95FF"
          }
        }
      }
    }
  });
  graph.use(
    new Transform({
      resizing: false,
      rotating: true
    })
  ).use(
    new Selection({
      enabled: true
    })
  ).use(new Snapline()).use(new Keyboard()).use(new Clipboard()).use(new History({ enabled: true })).use(new Scroller({ enabled: true, pannable: true, autoResize: true }));
  const stencil = createStencil(graph, t2);
  stencilContainer.appendChild(stencil.container);
  initialGraphEvents(graph);
  return graph;
};
const createStencil = (graph, t2) => {
  const stencil = new Stencil({
    title: t2("ProcessGraph"),
    target: graph,
    stencilGraphWidth: 200,
    stencilGraphHeight: 0,
    collapsable: true,
    groups: [
      {
        title: t2("GraphNode"),
        name: "group1"
      }
    ],
    layoutOptions: {
      columns: 2,
      columnWidth: 80,
      rowHeight: 55
    },
    getDropNode: (node) => {
      var _a3;
      const nodeType = (_a3 = node.data) == null ? void 0 : _a3.graphNodeType;
      return createGraphNodeByNodeType(graph, nodeType);
    }
  });
  graph.createNode({
    shape: "custom-rect",
    label: t2("InitialNode"),
    attrs: {
      body: {
        rx: 20,
        ry: 26
      }
    },
    data: { graphNodeType: "initial-node" }
  });
  const userNode = graph.createNode({
    shape: "custom-rect",
    label: t2("UserNode"),
    data: { graphNodeType: "user-node" }
  });
  const conditionNode = graph.createNode({
    shape: "custom-rect",
    label: t2("Condition"),
    data: { graphNodeType: "condition-node" }
  });
  stencil.load([userNode, conditionNode], "group1");
  return stencil;
};
const createGraphNodeByNodeType = (graph, graphNodeType) => {
  return graph.createNode(createNodeMetadata(graphNodeType));
};
const createEdge$2 = () => {
  return new Shape.Edge(createEdgeMetadata());
};
const initialGraphEvents = (graph) => {
  const showPorts = (ports2, show) => {
    for (let i2 = 0, len = ports2.length; i2 < len; i2 += 1) {
      ports2[i2].style.visibility = show ? "visible" : "hidden";
    }
  };
  graph.on("node:mouseenter", () => {
    const container = document.getElementById("container");
    const ports2 = container.querySelectorAll(
      ".x6-port-body"
    );
    showPorts(ports2, true);
  });
  graph.on("node:mouseleave", () => {
    const container = document.getElementById("container");
    const ports2 = container.querySelectorAll(
      ".x6-port-body"
    );
    showPorts(ports2, false);
  });
  graph.on("edge:mouseenter", ({ cell }) => {
    cell.addTools([
      { name: "vertices" },
      {
        name: "button-remove",
        args: { distance: 0.5 }
      }
    ]);
  });
  graph.on("edge:mouseleave", ({ cell }) => {
    if (cell.hasTool("button-remove")) {
      cell.removeTool("button-remove");
    }
    if (cell.hasTool("vertices")) {
      cell.removeTool("vertices");
    }
  });
};
const isConditionNode = (cell) => {
  var _a3;
  return ((_a3 = cell.data) == null ? void 0 : _a3.graphNodeType) === "condition-node";
};
const isCompleteEdge = (edge) => {
  return edge.getSourceCell() != null && edge.getTargetCell() != null;
};
function validateConnection(args) {
  var _a3, _b3, _c3, _d3;
  const targetId = (_a3 = args.targetCell) == null ? void 0 : _a3.id;
  const sourceId = (_b3 = args.sourceCell) == null ? void 0 : _b3.id;
  if (targetId == sourceId) {
    return false;
  }
  if (!targetId || !sourceId) {
    return false;
  }
  if (isConditionNode(args.sourceCell) && isConditionNode(args.targetCell)) {
    return false;
  }
  let edges = void 0;
  if (isConditionNode(args.sourceCell)) {
    const conditionNodeId = (_c3 = args.sourceCell) == null ? void 0 : _c3.id;
    edges = this.getConnectedEdges(args.sourceCell).filter((e10) => isCompleteEdge(e10));
    if (edges.some((e10) => {
      var _a4;
      return ((_a4 = e10.getSourceCell()) == null ? void 0 : _a4.id) == conditionNodeId;
    })) {
      return false;
    }
  }
  if (isConditionNode(args.targetCell)) {
    const conditionNodeId = (_d3 = args.targetCell) == null ? void 0 : _d3.id;
    edges = this.getConnectedEdges(args.targetCell).filter((e10) => isCompleteEdge(e10));
    if (edges.some((e10) => {
      var _a4;
      return ((_a4 = e10.getTargetCell()) == null ? void 0 : _a4.id) == conditionNodeId;
    })) {
      return false;
    }
  }
  if (edges === void 0) {
    edges = this.getConnectedEdges(args.sourceCell).filter((e10) => isCompleteEdge(e10));
  }
  if (edges.some((e10) => {
    var _a4, _b4, _c4, _d4;
    return ((_a4 = e10.getSourceCell()) == null ? void 0 : _a4.id) == ((_b4 = args.targetCell) == null ? void 0 : _b4.id) && ((_c4 = e10.getTargetCell()) == null ? void 0 : _c4.id) == ((_d4 = args.sourceCell) == null ? void 0 : _d4.id);
  })) {
    return false;
  }
  return !!args.targetMagnet;
}
const registerFlowNodes = (setup, buildProps) => {
  Graph$2.registerNode(
    "custom-rect",
    {
      inherit: "rect",
      width: 66,
      height: 36,
      attrs: {
        body: {
          strokeWidth: 1,
          stroke: "#5F95FF",
          fill: "#EFF4FF"
        },
        text: {
          fontSize: 12,
          fill: "#262626"
        }
      }
    },
    true
  );
  registerVueNode({ config: { shape: "initial-node", width: 220, height: 71, component: _sfc_main$E }, setup, buildProps });
  registerVueNode({ config: { shape: "user-node", width: 220, height: 71, component: _sfc_main$u }, setup, buildProps });
  registerVueNode({ config: { shape: "condition-node", width: 220, height: 71, component: _sfc_main$t }, setup, buildProps });
};
class Base {
  constructor() {
    this.nodes = [];
    this.edges = [];
    this.combos = [];
    this.comboEdges = [];
    this.hiddenNodes = [];
    this.hiddenEdges = [];
    this.hiddenCombos = [];
    this.vedges = [];
    this.positions = [];
    this.destroyed = false;
    this.onLayoutEnd = () => {
    };
  }
  layout(data) {
    this.init(data);
    return this.execute(true);
  }
  init(data) {
    this.nodes = data.nodes || [];
    this.edges = data.edges || [];
    this.combos = data.combos || [];
    this.comboEdges = data.comboEdges || [];
    this.hiddenNodes = data.hiddenNodes || [];
    this.hiddenEdges = data.hiddenEdges || [];
    this.hiddenCombos = data.hiddenCombos || [];
    this.vedges = data.vedges || [];
  }
  execute(reloadData) {
  }
  executeWithWorker() {
  }
  getDefaultCfg() {
    return {};
  }
  updateCfg(cfg) {
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  getType() {
    return "base";
  }
  destroy() {
    this.nodes = null;
    this.edges = null;
    this.combos = null;
    this.positions = null;
    this.destroyed = true;
  }
}
const isString = (val) => typeof val === "string";
const isArray$1 = Array.isArray;
const isNumber = (val) => typeof val === "number";
const isObject = (val) => val !== null && typeof val === "object";
const clone = (target) => {
  if (target === null) {
    return target;
  }
  if (target instanceof Date) {
    return new Date(target.getTime());
  }
  if (target instanceof Array) {
    const cp2 = [];
    target.forEach((v2) => {
      cp2.push(v2);
    });
    return cp2.map((n2) => clone(n2));
  }
  if (typeof target === "object" && Object.keys(target).length) {
    const cp2 = Object.assign({}, target);
    Object.keys(cp2).forEach((k2) => {
      cp2[k2] = clone(cp2[k2]);
    });
    return cp2;
  }
  return target;
};
const getEdgeTerminal = (edge, type4) => {
  const terminal = edge[type4];
  if (isObject(terminal)) {
    return terminal.cell;
  }
  return terminal;
};
const getFunc = (value, defaultValue, func) => {
  let resultFunc;
  if (func) {
    resultFunc = func;
  } else if (isNumber(value)) {
    resultFunc = () => value;
  } else {
    resultFunc = () => defaultValue;
  }
  return resultFunc;
};
const filterOutLinks = (k2, v2) => {
  if (k2 !== "next" && k2 !== "prev") {
    return v2;
  }
};
const unlink = (entry) => {
  entry.prev.next = entry.next;
  entry.next.prev = entry.prev;
  delete entry.next;
  delete entry.prev;
};
let List$1 = class List {
  constructor() {
    const shortcut = {};
    shortcut.prev = shortcut;
    shortcut.next = shortcut.prev;
    this.shortcut = shortcut;
  }
  dequeue() {
    const shortcut = this.shortcut;
    const entry = shortcut.prev;
    if (entry && entry !== shortcut) {
      unlink(entry);
      return entry;
    }
  }
  enqueue(entry) {
    const shortcut = this.shortcut;
    if (entry.prev && entry.next) {
      unlink(entry);
    }
    entry.next = shortcut.next;
    shortcut.next.prev = entry;
    shortcut.next = entry;
    entry.prev = shortcut;
  }
  toString() {
    const strs = [];
    const sentinel = this.shortcut;
    let curr = sentinel.prev;
    while (curr !== sentinel) {
      strs.push(JSON.stringify(curr, filterOutLinks));
      curr = curr === null || curr === void 0 ? void 0 : curr.prev;
    }
    return `[${strs.join(", ")}]`;
  }
};
var GraphEnum;
(function(GraphEnum2) {
  GraphEnum2["DEFAULT_EDGE_NAME"] = "\0";
  GraphEnum2["GRAPH_NODE"] = "\0";
  GraphEnum2["EDGE_KEY_DELIM"] = "";
})(GraphEnum || (GraphEnum = {}));
function incrementOrInitEntry(map, key) {
  var val = map.get(key) || 0;
  map.set(key, val + 1);
}
function decrementOrRemoveEntry(map, key) {
  var val = map.get(key);
  if (val !== void 0) {
    val = val - 1;
    if (val > 0) {
      map.set(key, val);
    } else {
      map.delete(key);
    }
  }
}
function edgeArgsToId(isDirected, v_, w_, name) {
  var v2 = String(v_);
  var w2 = String(w_);
  if (!isDirected && v2 > w2) {
    var tmp = v2;
    v2 = w2;
    w2 = tmp;
  }
  return v2 + GraphEnum.EDGE_KEY_DELIM + w2 + GraphEnum.EDGE_KEY_DELIM + (name === void 0 ? GraphEnum.DEFAULT_EDGE_NAME : name);
}
function edgeArgsToObj(isDirected, v2, w2, name) {
  var strV = String(v2);
  var strW = String(w2);
  var edgeObj = {
    v: v2,
    w: w2
  };
  if (!isDirected && strV > strW) {
    var tmp = edgeObj.v;
    edgeObj.v = edgeObj.w;
    edgeObj.w = tmp;
  }
  if (name !== void 0) {
    edgeObj.name = name;
  }
  return edgeObj;
}
function edgeObjToId(isDirected, edgeObj) {
  return edgeArgsToId(isDirected, edgeObj.v, edgeObj.w, edgeObj.name);
}
function isFunction(obj) {
  return typeof obj === "function";
}
var nodeToJSON = function nodeToJSON2(graph) {
  return graph.nodes().map(function(n2) {
    var value = graph.node(n2);
    var parent = graph.parent(n2);
    var node = {
      id: n2,
      value,
      parent
    };
    if (node.value === void 0) {
      delete node.value;
    }
    if (node.parent === void 0) {
      delete node.parent;
    }
    return node;
  });
};
var edgeToJSON = function edgeToJSON2(graph) {
  return graph.edges().map(function(edge) {
    var value = graph.edge(edge);
    var e10 = {
      v: edge.v,
      w: edge.w,
      value,
      name: edge.name
    };
    if (e10.name === void 0) {
      delete e10.name;
    }
    if (e10.value === void 0) {
      delete e10.value;
    }
    return e10;
  });
};
var write = function write2(graph) {
  var json = {
    options: {
      directed: graph.isDirected(),
      multigraph: graph.isMultigraph(),
      compound: graph.isCompound()
    },
    nodes: nodeToJSON(graph),
    edges: edgeToJSON(graph),
    value: graph.graph()
  };
  if (json.value === void 0) {
    delete json.value;
  }
  return json;
};
var read = function read2(json) {
  var graph = new Graph$1(json.options);
  if (json.value !== void 0) {
    graph.setGraph(json.value);
  }
  json.nodes.forEach(function(entry) {
    graph.setNode(entry.id, entry.value);
    if (entry.parent) {
      graph.setParent(entry.id, entry.parent);
    }
  });
  json.edges.forEach(function(entry) {
    graph.setEdge(entry.v, entry.w, entry.value, entry.name);
  });
  return graph;
};
function ownKeys(object4, enumerableOnly) {
  var keys = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var defaultOption = {
  compound: false,
  multigraph: false,
  directed: true
};
var Graph$1 = /* @__PURE__ */ function() {
  function Graph2() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck$2(this, Graph2);
    this.directed = true;
    this.multigraph = false;
    this.compound = false;
    this.GRAPH_NODE = GraphEnum.GRAPH_NODE;
    this.label = void 0;
    this.nodeCountNum = 0;
    this.edgeCountNum = 0;
    this.defaultNodeLabelFn = function() {
      return void 0;
    };
    this.defaultEdgeLabelFn = function() {
      return void 0;
    };
    this.parentMap = void 0;
    this.childrenMap = void 0;
    this.nodesLabelMap = /* @__PURE__ */ new Map();
    this.inEdgesMap = /* @__PURE__ */ new Map();
    this.outEdgesMap = /* @__PURE__ */ new Map();
    this.predecessorsMap = /* @__PURE__ */ new Map();
    this.successorsMap = /* @__PURE__ */ new Map();
    this.edgesMap = /* @__PURE__ */ new Map();
    this.edgesLabelsMap = /* @__PURE__ */ new Map();
    this.isDirected = function() {
      return _this.directed;
    };
    this.isMultigraph = function() {
      return _this.multigraph;
    };
    this.isCompound = function() {
      return _this.compound;
    };
    this.setGraph = function(label) {
      _this.label = label;
      return _this;
    };
    this.graph = function() {
      return _this.label;
    };
    this.setDefaultNodeLabel = function(newDefault) {
      if (isFunction(newDefault)) {
        _this.defaultNodeLabelFn = newDefault;
      } else {
        _this.defaultNodeLabelFn = function() {
          return newDefault;
        };
      }
      return _this;
    };
    this.nodeCount = function() {
      return _this.nodeCountNum;
    };
    this.node = function(n2) {
      return _this.nodesLabelMap.get(n2);
    };
    this.nodes = function() {
      return Array.from(_this.nodesLabelMap.keys());
    };
    this.sources = function() {
      return _this.nodes().filter(function(n2) {
        var _this$inEdgesMap$get;
        return !((_this$inEdgesMap$get = _this.inEdgesMap.get(n2)) === null || _this$inEdgesMap$get === void 0 ? void 0 : _this$inEdgesMap$get.size);
      });
    };
    this.sinks = function() {
      return _this.nodes().filter(function(n2) {
        var _this$outEdgesMap$get;
        return !((_this$outEdgesMap$get = _this.outEdgesMap.get(n2)) === null || _this$outEdgesMap$get === void 0 ? void 0 : _this$outEdgesMap$get.size);
      });
    };
    this.setNodes = function(nodes, value) {
      nodes.map(function(node) {
        return _this.setNode(node, value);
      });
      return _this;
    };
    this.hasNode = function(node) {
      return _this.nodesLabelMap.has(node);
    };
    this.checkCompound = function() {
      if (!_this.isCompound()) {
        throw new Error("Cannot construct parent-children relations in a non-compound graph");
      }
    };
    this.parent = function(node) {
      if (_this.isCompound()) {
        var _this$parentMap;
        var parent = (_this$parentMap = _this.parentMap) === null || _this$parentMap === void 0 ? void 0 : _this$parentMap.get(node);
        if (parent !== _this.GRAPH_NODE) {
          return parent;
        }
      }
    };
    this.removeFromParentsChildList = function(node) {
      var targetParent = _this.parentMap.get(node);
      _this.childrenMap.get(targetParent).delete(node);
    };
    this.setParent = function(node, parent) {
      var _this$parentMap2, _this$childrenMap;
      _this.checkCompound();
      var realParent = parent === void 0 ? _this.GRAPH_NODE : parent;
      var checkNode = _this.parent(realParent);
      while (checkNode) {
        if (node === checkNode) {
          throw new Error("Setting " + parent + " as parent of " + node + " would create a cycle");
        }
        checkNode = _this.parent(checkNode);
      }
      if (parent) {
        _this.setNode(parent);
      }
      _this.setNode(node);
      _this.removeFromParentsChildList(node);
      (_this$parentMap2 = _this.parentMap) === null || _this$parentMap2 === void 0 ? void 0 : _this$parentMap2.set(node, realParent);
      var realParentChilren = _this.childrenMap.get(realParent);
      realParentChilren.set(node, true);
      (_this$childrenMap = _this.childrenMap) === null || _this$childrenMap === void 0 ? void 0 : _this$childrenMap.set(realParent, realParentChilren);
      return _this;
    };
    this.children = function(node) {
      var targetNode = node === void 0 ? _this.GRAPH_NODE : node;
      if (_this.isCompound()) {
        var _this$childrenMap2;
        var target = (_this$childrenMap2 = _this.childrenMap) === null || _this$childrenMap2 === void 0 ? void 0 : _this$childrenMap2.get(targetNode);
        if (target) {
          return Array.from(target.keys());
        }
        return void 0;
      }
      if (targetNode === _this.GRAPH_NODE) {
        return _this.nodes();
      }
      if (node && _this.hasNode(node)) {
        return [];
      }
    };
    this.predecessors = function(node) {
      var preds = _this.predecessorsMap.get(node);
      return preds ? Array.from(preds.keys()) : void 0;
    };
    this.successors = function(node) {
      var succs = _this.successorsMap.get(node);
      return succs ? Array.from(succs.keys()) : void 0;
    };
    this.neighbors = function(node) {
      var _this$predecessors;
      if (!_this.hasNode(node)) {
        return void 0;
      }
      return Array.from(new Set((_this$predecessors = _this.predecessors(node)) === null || _this$predecessors === void 0 ? void 0 : _this$predecessors.concat(_this.successors(node))));
    };
    this.isLeaf = function(node) {
      var _this$neighbors;
      if (_this.isDirected()) {
        var _this$successors;
        return !((_this$successors = _this.successors(node)) === null || _this$successors === void 0 ? void 0 : _this$successors.length);
      }
      return !((_this$neighbors = _this.neighbors(node)) === null || _this$neighbors === void 0 ? void 0 : _this$neighbors.length);
    };
    this.filterNodes = function(filter) {
      var directed = _this.directed, multigraph = _this.multigraph, compound = _this.compound;
      var copyGraph = new Graph2({
        directed,
        multigraph,
        compound
      });
      copyGraph.setGraph(_this.graph());
      _this.nodes().forEach(function(n2) {
        if (filter(n2)) {
          copyGraph.setNode(n2, _this.node(n2));
        }
      });
      _this.edges().forEach(function(edgeObj) {
        if (copyGraph.hasNode(edgeObj.v) && copyGraph.hasNode(edgeObj.w)) {
          copyGraph.setEdgeObj(edgeObj, _this.edge(edgeObj));
        }
      });
      if (compound) {
        var findParent = function findParent2(node) {
          var parent = _this.parent(node);
          while (parent !== void 0 && !copyGraph.hasNode(parent)) {
            parent = _this.parent(parent);
          }
          return parent;
        };
        copyGraph.nodes().forEach(function(node) {
          copyGraph.setParent(node, findParent(node));
        });
      }
      return copyGraph;
    };
    this.setDefaultEdgeLabel = function(newDefault) {
      if (isFunction(newDefault)) {
        _this.defaultEdgeLabelFn = newDefault;
      } else {
        _this.defaultEdgeLabelFn = function() {
          return newDefault;
        };
      }
      return _this;
    };
    this.edgeCount = function() {
      return _this.edgeCountNum;
    };
    this.setEdgeObj = function(edgeObj, value) {
      return _this.setEdge(edgeObj.v, edgeObj.w, value, edgeObj.name);
    };
    this.setPath = function(edges, value) {
      edges.reduce(function(v2, w2) {
        _this.setEdge(v2, w2, value);
        return w2;
      });
      return _this;
    };
    this.edgeFromArgs = function(v2, w2, name) {
      return _this.edge({
        v: v2,
        w: w2,
        name
      });
    };
    this.edge = function(edgeObj) {
      return _this.edgesLabelsMap.get(edgeObjToId(_this.isDirected(), edgeObj));
    };
    this.hasEdge = function(v2, w2, name) {
      return _this.edgesLabelsMap.has(edgeObjToId(_this.isDirected(), {
        v: v2,
        w: w2,
        name
      }));
    };
    this.removeEdgeObj = function(_ref) {
      var v2 = _ref.v, w2 = _ref.w, name = _ref.name;
      return _this.removeEdge(v2, w2, name);
    };
    this.edges = function() {
      return Array.from(_this.edgesMap.values());
    };
    this.inEdges = function(v2, u2) {
      var inV = _this.inEdgesMap.get(v2);
      if (inV) {
        return Array.from(inV.values()).filter(function(e10) {
          return !u2 || e10.v === u2;
        });
      }
      return void 0;
    };
    this.outEdges = function(w2, u2) {
      var outW = _this.outEdgesMap.get(w2);
      if (outW) {
        return Array.from(outW.values()).filter(function(e10) {
          return !u2 || e10.w === u2;
        });
      }
      return void 0;
    };
    this.nodeEdges = function(v2, w2) {
      var _this$inEdges;
      if (!_this.hasNode(v2)) {
        return void 0;
      }
      return (_this$inEdges = _this.inEdges(v2, w2)) === null || _this$inEdges === void 0 ? void 0 : _this$inEdges.concat(_this.outEdges(v2, w2));
    };
    this.toJSON = function() {
      return write(_this);
    };
    this.nodeInDegree = function(node) {
      var inEdges = _this.inEdgesMap.get(node);
      if (inEdges) {
        return inEdges.size;
      }
      return 0;
    };
    this.nodeOutDegree = function(node) {
      var outEdges = _this.outEdgesMap.get(node);
      if (outEdges) {
        return outEdges.size;
      }
      return 0;
    };
    this.nodeDegree = function(node) {
      return _this.nodeInDegree(node) + _this.nodeOutDegree(node);
    };
    this.source = function(edge) {
      return edge.v;
    };
    this.target = function(edge) {
      return edge.w;
    };
    var resultOptions = _objectSpread(_objectSpread({}, defaultOption), options);
    this.compound = resultOptions.compound;
    this.directed = resultOptions.directed;
    this.multigraph = resultOptions.multigraph;
    if (this.compound) {
      this.parentMap = /* @__PURE__ */ new Map();
      this.childrenMap = /* @__PURE__ */ new Map();
    }
  }
  _createClass$2(Graph2, [{
    key: "setNode",
    value: (
      /**
       * @description Set Node label in graph if node not in graph then create it
       * @description.zh-CN 设置节点的label，如果这个节点不在图中，则在图中创建这个节点
       * @param node
       * @param value
       * @returns
       */
      function setNode(node, value) {
        var nodesLabelMap = this.nodesLabelMap, defaultNodeLabelFn = this.defaultNodeLabelFn, isCompound = this.isCompound, parentMap = this.parentMap, childrenMap = this.childrenMap, inEdgesMap = this.inEdgesMap, outEdgesMap = this.outEdgesMap, predecessorsMap = this.predecessorsMap, successorsMap = this.successorsMap;
        if (nodesLabelMap.has(node)) {
          if (value !== void 0) {
            nodesLabelMap.set(node, value);
          }
          return this;
        }
        nodesLabelMap.set(node, value || defaultNodeLabelFn(node));
        if (isCompound()) {
          var _childrenMap$get;
          parentMap === null || parentMap === void 0 ? void 0 : parentMap.set(node, this.GRAPH_NODE);
          childrenMap === null || childrenMap === void 0 ? void 0 : childrenMap.set(node, /* @__PURE__ */ new Map());
          if (!(childrenMap === null || childrenMap === void 0 ? void 0 : childrenMap.has(this.GRAPH_NODE))) {
            childrenMap === null || childrenMap === void 0 ? void 0 : childrenMap.set(this.GRAPH_NODE, /* @__PURE__ */ new Map());
          }
          childrenMap === null || childrenMap === void 0 ? void 0 : (_childrenMap$get = childrenMap.get(this.GRAPH_NODE)) === null || _childrenMap$get === void 0 ? void 0 : _childrenMap$get.set(node, true);
        }
        [inEdgesMap, outEdgesMap, predecessorsMap, successorsMap].forEach(function(map) {
          return map.set(node, /* @__PURE__ */ new Map());
        });
        this.nodeCountNum += 1;
        return this;
      }
    )
    /**
     * @description Set nodes or add nodes in batch
     * @description.zh-CN 批量设置或者创建节点
     * @param nodes
     * @param value
     * @returns
     */
  }, {
    key: "removeNode",
    value: (
      /**
       * @description Remove node from graph
       * @description.zh-CN 将节点从图中移除
       * @param node
       * @returns
       */
      function removeNode2(node) {
        var _this2 = this;
        if (this.hasNode(node)) {
          var cleanEdge = function cleanEdge2(edgeObj) {
            _this2.removeEdge(edgeObj.v, edgeObj.w, edgeObj.name);
          };
          var inEdgesMap = this.inEdgesMap, outEdgesMap = this.outEdgesMap, predecessorsMap = this.predecessorsMap, successorsMap = this.successorsMap, nodesLabelMap = this.nodesLabelMap;
          if (this.isCompound()) {
            var _this$parentMap3, _this$children, _this$childrenMap3;
            this.removeFromParentsChildList(node);
            (_this$parentMap3 = this.parentMap) === null || _this$parentMap3 === void 0 ? void 0 : _this$parentMap3.delete(node);
            (_this$children = this.children(node)) === null || _this$children === void 0 ? void 0 : _this$children.forEach(function(n2) {
              return _this2.setParent(n2);
            });
            (_this$childrenMap3 = this.childrenMap) === null || _this$childrenMap3 === void 0 ? void 0 : _this$childrenMap3.delete(node);
          }
          var inE = inEdgesMap.get(node);
          var outE = outEdgesMap.get(node);
          Array.from(inE.values()).forEach(function(edge) {
            return cleanEdge(edge);
          });
          Array.from(outE.values()).forEach(function(edge) {
            return cleanEdge(edge);
          });
          nodesLabelMap.delete(node);
          inEdgesMap.delete(node);
          outEdgesMap.delete(node);
          predecessorsMap.delete(node);
          successorsMap.delete(node);
          this.nodeCountNum -= 1;
        }
        return this;
      }
    )
    /**
     * @description Set function that generate default label for edge, if param is non-function value then default label will always be this value;
     * @description.zh-CN 设置默认获取边Label的方法，如果传入不是函数的，那么默认label 的值只会是传入值
     * @param newDefault
     * @returns
     */
  }, {
    key: "setEdge",
    value: (
      /**
       * @description set edge value, if nodes or edges not exsit then add to graph
       * @description.zh-CN 设置边的属性，如果边或节点不存在，那么将他们加入这个图
       * @param v
       * @param w
       * @param value
       * @param name
       * @returns
       */
      function setEdge(v_, w_, value, name) {
        var _this$inEdgesMap$get2, _this$outEdgesMap$get2;
        var edgeObj = edgeArgsToObj(this.isDirected(), v_, w_, name);
        var edgeId = edgeObjToId(this.isDirected(), edgeObj);
        var v2 = edgeObj.v, w2 = edgeObj.w;
        if (this.edgesLabelsMap.has(edgeId)) {
          this.edgesLabelsMap.set(edgeId, value);
          return this;
        }
        if (name !== void 0 && !this.isMultigraph()) {
          throw new Error("Cannot set a named edge when isMultigraph = false");
        }
        this.setNode(v2);
        this.setNode(w2);
        this.edgesLabelsMap.set(edgeId, value || this.defaultEdgeLabelFn(v2, w2, name));
        Object.freeze(edgeObj);
        this.edgesMap.set(edgeId, edgeObj);
        var preds = this.predecessorsMap.get(w2);
        var succs = this.successorsMap.get(v2);
        incrementOrInitEntry(preds, v2);
        incrementOrInitEntry(succs, w2);
        (_this$inEdgesMap$get2 = this.inEdgesMap.get(w2)) === null || _this$inEdgesMap$get2 === void 0 ? void 0 : _this$inEdgesMap$get2.set(edgeId, edgeObj);
        (_this$outEdgesMap$get2 = this.outEdgesMap.get(v2)) === null || _this$outEdgesMap$get2 === void 0 ? void 0 : _this$outEdgesMap$get2.set(edgeId, edgeObj);
        this.edgeCountNum += 1;
        return this;
      }
    )
  }, {
    key: "removeEdge",
    value: (
      /**
       * @description remove a specific edge
       * @description.zh-CN 删除一条边
       * @param v
       * @param w
       * @param name
       * @returns
       */
      function removeEdge(v_, w_, name) {
        var edgeId = edgeArgsToId(this.isDirected(), v_, w_, name);
        var edgeObj = this.edgesMap.get(edgeId);
        if (edgeObj) {
          var _edgeArgsToObj = edgeArgsToObj(this.isDirected(), v_, w_, name), v2 = _edgeArgsToObj.v, w2 = _edgeArgsToObj.w;
          this.edgesLabelsMap.delete(edgeId);
          this.edgesMap.delete(edgeId);
          var preds = this.predecessorsMap.get(w2);
          var succs = this.successorsMap.get(v2);
          decrementOrRemoveEntry(preds, v2);
          decrementOrRemoveEntry(succs, w2);
          this.inEdgesMap.get(w2).delete(edgeId);
          this.outEdgesMap.get(v2).delete(edgeId);
          this.edgeCountNum -= 1;
        }
        return this;
      }
    )
    /**
     * @description remove a specific edge by edge object
     * @description.zh-CN 删除一条边
     */
  }]);
  return Graph2;
}();
Graph$1.fromJSON = read;
function _createClass$1(Constructor, protoProps, staticProps) {
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var PriorityQueue = /* @__PURE__ */ _createClass$1(function PriorityQueue2() {
  var _this = this;
  _classCallCheck$1(this, PriorityQueue2);
  this.arr = [];
  this.keyIndice = /* @__PURE__ */ new Map();
  this.size = function() {
    return _this.arr.length;
  };
  this.keys = function() {
    return _this.arr.map(function(e10) {
      return e10.key;
    });
  };
  this.has = function(key) {
    return _this.keyIndice.has(key);
  };
  this.priority = function(key) {
    var index2 = _this.keyIndice.get(key);
    if (index2 !== void 0) {
      return _this.arr[index2].priority;
    }
  };
  this.swap = function(i2, j2) {
    var arr = _this.arr, keyIndice = _this.keyIndice;
    var _ref = [arr[i2], arr[j2]], originI = _ref[0], originJ = _ref[1];
    arr[i2] = originJ;
    arr[j2] = originI;
    keyIndice.set(originI.key, j2);
    keyIndice.set(originJ.key, i2);
  };
  this.innerDecrease = function(index2) {
    var arr = _this.arr;
    var priority = arr[index2].priority;
    var parent;
    var i2 = index2;
    while (i2 !== 0) {
      var _arr$parent;
      parent = i2 >> 1;
      if (((_arr$parent = arr[parent]) === null || _arr$parent === void 0 ? void 0 : _arr$parent.priority) < priority) {
        break;
      }
      _this.swap(i2, parent);
      i2 = parent;
    }
  };
  this.heapify = function(i2) {
    var arr = _this.arr;
    var l2 = i2 << 1;
    var r3 = l2 + 1;
    var largest = i2;
    if (l2 < arr.length) {
      largest = arr[l2].priority < arr[largest].priority ? l2 : largest;
      if (r3 < arr.length) {
        largest = arr[r3].priority < arr[largest].priority ? r3 : largest;
      }
      if (largest !== i2) {
        _this.swap(i2, largest);
        _this.heapify(largest);
      }
    }
  };
  this.min = function() {
    if (_this.size() === 0) {
      throw new Error("Queue underflow");
    }
    return _this.arr[0].key;
  };
  this.add = function(key, priority) {
    var keyIndice = _this.keyIndice, arr = _this.arr;
    if (!keyIndice.has(key)) {
      var index2 = arr.length;
      keyIndice.set(key, index2);
      arr.push({
        key,
        priority
      });
      _this.innerDecrease(index2);
      return true;
    }
    return false;
  };
  this.removeMin = function() {
    _this.swap(0, _this.arr.length - 1);
    var min2 = _this.arr.pop();
    _this.keyIndice.delete(min2.key);
    _this.heapify(0);
    return min2.key;
  };
  this.decrease = function(key, priority) {
    if (!_this.has(key)) {
      throw new Error("There's no key named ".concat(key));
    }
    var index2 = _this.keyIndice.get(key);
    if (priority > _this.arr[index2].priority) {
      throw new Error("New priority is greater than current priority.Key: ".concat(key, " Old: + ").concat(_this.arr[index2].priority, " New: ").concat(priority));
    }
    _this.arr[index2].priority = priority;
    _this.innerDecrease(index2);
  };
});
var prim = function prim2(graph, weightFn) {
  var result = new Graph$1();
  var parents = /* @__PURE__ */ new Map();
  var pq = new PriorityQueue();
  var v2;
  function updateNeighbors(edge) {
    var w2 = edge.v === v2 ? edge.w : edge.v;
    var pri = pq.priority(w2);
    if (pri !== void 0) {
      var edgeWeight = weightFn(edge);
      if (edgeWeight < pri) {
        parents.set(w2, v2);
        pq.decrease(w2, edgeWeight);
      }
    }
  }
  if (graph.nodeCount() === 0) {
    return result;
  }
  graph.nodes().forEach(function(node) {
    pq.add(node, Number.POSITIVE_INFINITY);
    result.setNode(node);
  });
  pq.decrease(graph.nodes()[0], 0);
  var init4 = false;
  while (pq.size() > 0) {
    var _graph$nodeEdges;
    v2 = pq.removeMin();
    if (parents.has(v2)) {
      result.setEdge(v2, parents.get(v2));
    } else if (init4) {
      throw new Error("Input graph is not connected: " + graph.graph());
    } else {
      init4 = true;
    }
    (_graph$nodeEdges = graph.nodeEdges(v2)) === null || _graph$nodeEdges === void 0 ? void 0 : _graph$nodeEdges.forEach(updateNeighbors);
  }
  return result;
};
var components$1 = function components(graph) {
  var visited = /* @__PURE__ */ new Set();
  var resultComponents = [];
  var nodes = graph.nodes();
  nodes.forEach(function(n2) {
    var componentsArr = [];
    var waitingList = [n2];
    while (waitingList.length > 0) {
      var node = waitingList.pop();
      if (!visited.has(node)) {
        var _graph$successors, _graph$predecessors;
        visited.add(node);
        componentsArr.push(node);
        (_graph$successors = graph.successors(node)) === null || _graph$successors === void 0 ? void 0 : _graph$successors.forEach(function(n3) {
          return waitingList.push(n3);
        });
        (_graph$predecessors = graph.predecessors(node)) === null || _graph$predecessors === void 0 ? void 0 : _graph$predecessors.forEach(function(n3) {
          return waitingList.push(n3);
        });
      }
    }
    if (componentsArr.length) {
      resultComponents.push(componentsArr);
    }
  });
  return resultComponents;
};
var doDFS = function doDFS2(graph, node, postorder3, visited, navigator2, result) {
  if (!visited.includes(node)) {
    visited.push(node);
    if (!postorder3) {
      result.push(node);
    }
    navigator2(node).forEach(function(n2) {
      return doDFS2(graph, n2, postorder3, visited, navigator2, result);
    });
    if (postorder3) {
      result.push(node);
    }
  }
};
var dfs$1 = function dfs(graph, node, order2) {
  var nodes = Array.isArray(node) ? node : [node];
  var navigator2 = function navigator3(n2) {
    return graph.isDirected() ? graph.successors(n2) : graph.neighbors(n2);
  };
  var results = [];
  var visited = [];
  nodes.forEach(function(node2) {
    if (!graph.hasNode(node2)) {
      throw new Error("Graph does not have node: " + node2);
    } else {
      doDFS(graph, node2, order2 === "post", visited, navigator2, results);
    }
  });
  return results;
};
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i3 = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i3 == null) return;
  var _arr = [];
  var _n3 = true;
  var _d3 = false;
  var _s3, _e3;
  try {
    for (_i3 = _i3.call(arr); !(_n3 = (_s3 = _i3.next()).done); _n3 = true) {
      _arr.push(_s3.value);
      if (i2 && _arr.length === i2) break;
    }
  } catch (err) {
    _d3 = true;
    _e3 = err;
  } finally {
    try {
      if (!_n3 && _i3["return"] != null) _i3["return"]();
    } finally {
      if (_d3) throw _e3;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var DEFAULT_WEIGHT_FUNC$1 = function DEFAULT_WEIGHT_FUNC() {
  return 1;
};
var dijkstra = function dijkstra2(graph, source, weightFn, edgeFn) {
  return runDijkstra(graph, source, weightFn || DEFAULT_WEIGHT_FUNC$1, edgeFn || function(v2) {
    return graph.outEdges(v2);
  });
};
var runDijkstra = function runDijkstra2(graph, source, weightFn, edgeFn) {
  var results = /* @__PURE__ */ new Map();
  var pq = new PriorityQueue();
  var v2;
  var vEntry;
  var updateNeighbors = function updateNeighbors2(edge) {
    var w2 = edge.v !== v2 ? edge.v : edge.w;
    var wEntry = results.get(w2);
    var weight = weightFn(edge);
    var distance = vEntry.distance + weight;
    if (weight < 0) {
      throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + edge + " Weight: " + weight);
    }
    if (distance < wEntry.distance) {
      wEntry.distance = distance;
      wEntry.predecessor = v2;
      pq.decrease(w2, distance);
    }
  };
  graph.nodes().forEach(function(v6) {
    var distance = v6 === source ? 0 : Number.POSITIVE_INFINITY;
    results.set(v6, {
      distance
    });
    pq.add(v6, distance);
  });
  while (pq.size() > 0) {
    v2 = pq.removeMin();
    vEntry = results.get(v2);
    if (vEntry && vEntry.distance === Number.POSITIVE_INFINITY) {
      break;
    }
    edgeFn(v2).forEach(updateNeighbors);
  }
  var obj = {};
  Array.from(results.entries()).forEach(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), node = _ref2[0], e10 = _ref2[1];
    obj[String(node)] = e10;
    return obj;
  });
  return obj;
};
var dijkstraAll = function dijkstraAll2(graph, weightFn, edgeFn) {
  var map = {};
  graph.nodes().forEach(function(node) {
    map[String(node)] = dijkstra(graph, node, weightFn, edgeFn);
    return map;
  });
  return map;
};
var tarjan = function tarjan2(graph) {
  var index2 = 0;
  var stack = [];
  var visited = /* @__PURE__ */ new Map();
  var results = [];
  function dfs3(v2) {
    var _graph$successors;
    var entry = {
      onStack: true,
      lowlink: index2,
      index: index2
    };
    visited.set(v2, entry);
    index2 += 1;
    stack.push(v2);
    (_graph$successors = graph.successors(v2)) === null || _graph$successors === void 0 ? void 0 : _graph$successors.forEach(function(w3) {
      var _visited$get;
      if (!visited.has(w3)) {
        dfs3(w3);
        var wEntry2 = visited.get(w3);
        entry.lowlink = Math.min(entry.lowlink, wEntry2.lowlink);
      } else if ((_visited$get = visited.get(w3)) === null || _visited$get === void 0 ? void 0 : _visited$get.onStack) {
        var _wEntry = visited.get(w3);
        entry.lowlink = Math.min(entry.lowlink, _wEntry.index);
      }
    });
    if (entry.lowlink === entry.index) {
      var cmpt = [];
      var w2;
      do {
        w2 = stack.pop();
        var wEntry = visited.get(w2);
        wEntry.onStack = false;
        cmpt.push(w2);
      } while (v2 !== w2);
      results.push(cmpt);
    }
  }
  graph.nodes().forEach(function(v2) {
    if (!visited.has(v2)) {
      dfs3(v2);
    }
  });
  return results;
};
var findCycles = function findCycles2(graph) {
  return tarjan(graph).filter(function(cmpt) {
    return cmpt.length > 1 || cmpt.length === 1 && graph.hasEdge(cmpt[0], cmpt[0]);
  });
};
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _createClass(Constructor, protoProps, staticProps) {
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper$1(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper$1 = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction$1(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct$1(Class2, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf$1(Wrapper, Class2);
  };
  return _wrapNativeSuper$1(Class);
}
function _construct$1(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct$1 = Reflect.construct;
  } else {
    _construct$1 = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2) _setPrototypeOf$1(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct$1.apply(null, arguments);
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e10) {
    return false;
  }
}
function _isNativeFunction$1(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf$1(o2, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$1(o2, p2);
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
var CycleException = /* @__PURE__ */ function(_Error) {
  _inherits(CycleException2, _Error);
  var _super = _createSuper(CycleException2);
  function CycleException2() {
    _classCallCheck(this, CycleException2);
    return _super.apply(this, arguments);
  }
  return _createClass(CycleException2);
}(/* @__PURE__ */ _wrapNativeSuper$1(Error));
function topsort(graph) {
  var visited = /* @__PURE__ */ new Set();
  var stack = /* @__PURE__ */ new Set();
  var results = [];
  function visit(node) {
    if (stack.has(node)) {
      throw new CycleException();
    }
    if (!visited.has(node)) {
      var _graph$predecessors;
      stack.add(node);
      visited.add(node);
      (_graph$predecessors = graph.predecessors(node)) === null || _graph$predecessors === void 0 ? void 0 : _graph$predecessors.forEach(visit);
      stack.delete(node);
      results.push(node);
    }
  }
  graph.sinks().forEach(visit);
  if (visited.size !== graph.nodeCount()) {
    throw new CycleException();
  }
  return results;
}
var isAcyclic = function isAcyclic2(graph) {
  try {
    topsort(graph);
  } catch (e10) {
    if (e10 instanceof CycleException) {
      return false;
    }
    throw e10;
  }
  return true;
};
var postorder$1 = function postorder(graph, nodes) {
  return dfs$1(graph, nodes, "post");
};
var preorder$1 = function preorder(graph, nodes) {
  return dfs$1(graph, nodes, "pre");
};
var DEFAULT_WEIGHT_FUNC2 = function DEFAULT_WEIGHT_FUNC3() {
  return 1;
};
function floydWarshall(graph, weightFn, edgeFn) {
  return runFloydWarshall(graph, weightFn || DEFAULT_WEIGHT_FUNC2, edgeFn || function(v2) {
    return graph.outEdges(v2);
  });
}
function runFloydWarshall(graph, weightFn, edgeFn) {
  var results = {};
  var nodes = graph.nodes();
  nodes.forEach(function(node) {
    var v2 = String(node);
    results[v2] = {};
    results[v2][v2] = {
      distance: 0
    };
    nodes.forEach(function(w2) {
      if (node !== w2) {
        results[v2][String(w2)] = {
          distance: Number.POSITIVE_INFINITY
        };
      }
    });
    edgeFn(node).forEach(function(edge) {
      var w2 = edge.v === node ? edge.w : edge.v;
      var d2 = weightFn(edge);
      results[v2][String(w2)] = {
        distance: d2,
        predecessor: node
      };
    });
  });
  nodes.forEach(function(nodek) {
    var k2 = String(nodek);
    var rowK = results[k2];
    nodes.forEach(function(nodei) {
      var i2 = String(nodei);
      var rowI = results[i2];
      nodes.forEach(function(nodej) {
        var j2 = String(nodej);
        var ik2 = rowI[k2];
        var kj = rowK[j2];
        var ij = rowI[j2];
        var altDistance = ik2.distance + kj.distance;
        if (altDistance < ij.distance) {
          ij.distance = altDistance;
          ij.predecessor = kj.predecessor;
        }
      });
    });
  });
  return results;
}
const algorithm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  components: components$1,
  dfs: dfs$1,
  dijkstra,
  dijkstraAll,
  findCycles,
  floydWarshall,
  isAcyclic,
  postorder: postorder$1,
  preorder: preorder$1,
  prim,
  tarjan,
  topsort
}, Symbol.toStringTag, { value: "Module" }));
class List2 extends List$1 {
}
class StateGraph extends Graph$1 {
}
const DEFAULT_WEIGHT_FN = () => 1;
const greedyFAS = (g2, weightFn) => {
  var _a3;
  if (g2.nodeCount() <= 1)
    return [];
  const state = buildState(g2, weightFn || DEFAULT_WEIGHT_FN);
  const results = doGreedyFAS(state.graph, state.buckets, state.zeroIdx);
  return (_a3 = results.map((e10) => g2.outEdges(e10.v, e10.w))) === null || _a3 === void 0 ? void 0 : _a3.flat();
};
const doGreedyFAS = (g2, buckets, zeroIdx) => {
  let results = [];
  const sources = buckets[buckets.length - 1];
  const sinks = buckets[0];
  let entry;
  while (g2.nodeCount()) {
    while (entry = sinks.dequeue()) {
      removeNode(g2, buckets, zeroIdx, entry);
    }
    while (entry = sources.dequeue()) {
      removeNode(g2, buckets, zeroIdx, entry);
    }
    if (g2.nodeCount()) {
      for (let i2 = buckets.length - 2; i2 > 0; --i2) {
        entry = buckets[i2].dequeue();
        if (entry) {
          results = results.concat(removeNode(g2, buckets, zeroIdx, entry, true));
          break;
        }
      }
    }
  }
  return results;
};
const removeNode = (g2, buckets, zeroIdx, entry, collectPredecessors) => {
  var _a3, _b3;
  const results = [];
  (_a3 = g2.inEdges(entry.v)) === null || _a3 === void 0 ? void 0 : _a3.forEach((edge) => {
    const weight = g2.edge(edge);
    const uEntry = g2.node(edge.v);
    if (collectPredecessors) {
      results.push({ v: edge.v, w: edge.w, in: 0, out: 0 });
    }
    if (uEntry.out === void 0)
      uEntry.out = 0;
    uEntry.out -= weight;
    assignBucket(buckets, zeroIdx, uEntry);
  });
  (_b3 = g2.outEdges(entry.v)) === null || _b3 === void 0 ? void 0 : _b3.forEach((edge) => {
    const weight = g2.edge(edge);
    const w2 = edge.w;
    const wEntry = g2.node(w2);
    if (wEntry.in === void 0)
      wEntry.in = 0;
    wEntry.in -= weight;
    assignBucket(buckets, zeroIdx, wEntry);
  });
  g2.removeNode(entry.v);
  return collectPredecessors ? results : void 0;
};
const buildState = (g2, weightFn) => {
  const fasGraph = new StateGraph();
  let maxIn = 0;
  let maxOut = 0;
  g2.nodes().forEach((v2) => {
    fasGraph.setNode(v2, { v: v2, in: 0, out: 0 });
  });
  g2.edges().forEach((e10) => {
    const prevWeight = fasGraph.edge(e10) || 0;
    const weight = (weightFn === null || weightFn === void 0 ? void 0 : weightFn(e10)) || 1;
    const edgeWeight = prevWeight + weight;
    fasGraph.setEdge(e10.v, e10.w, edgeWeight);
    maxOut = Math.max(maxOut, fasGraph.node(e10.v).out += weight);
    maxIn = Math.max(maxIn, fasGraph.node(e10.w).in += weight);
  });
  const buckets = [];
  const rangeMax = maxOut + maxIn + 3;
  for (let i2 = 0; i2 < rangeMax; i2++) {
    buckets.push(new List2());
  }
  const zeroIdx = maxIn + 1;
  fasGraph.nodes().forEach((v2) => {
    assignBucket(buckets, zeroIdx, fasGraph.node(v2));
  });
  return { buckets, zeroIdx, graph: fasGraph };
};
const assignBucket = (buckets, zeroIdx, entry) => {
  if (!entry.out) {
    buckets[0].enqueue(entry);
  } else if (!entry["in"]) {
    buckets[buckets.length - 1].enqueue(entry);
  } else {
    buckets[entry.out - entry["in"] + zeroIdx].enqueue(entry);
  }
};
const run$2 = (g2) => {
  const weightFn = (g3) => {
    return (e10) => {
      var _a3;
      return ((_a3 = g3.edge(e10)) === null || _a3 === void 0 ? void 0 : _a3.weight) || 1;
    };
  };
  const fas = g2.graph().acyclicer === "greedy" ? greedyFAS(g2, weightFn(g2)) : dfsFAS(g2);
  fas === null || fas === void 0 ? void 0 : fas.forEach((e10) => {
    const label = g2.edge(e10);
    g2.removeEdgeObj(e10);
    label.forwardName = e10.name;
    label.reversed = true;
    g2.setEdge(e10.w, e10.v, label, `rev-${Math.random()}`);
  });
};
const dfsFAS = (g2) => {
  const fas = [];
  const stack = {};
  const visited = {};
  const dfs3 = (v2) => {
    var _a3;
    if (visited[v2]) {
      return;
    }
    visited[v2] = true;
    stack[v2] = true;
    (_a3 = g2.outEdges(v2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
      if (stack[e10.w]) {
        fas.push(e10);
      } else {
        dfs3(e10.w);
      }
    });
    delete stack[v2];
  };
  g2.nodes().forEach(dfs3);
  return fas;
};
const undo$2 = (g2) => {
  g2.edges().forEach((e10) => {
    const label = g2.edge(e10);
    if (label.reversed) {
      g2.removeEdgeObj(e10);
      const forwardName = label.forwardName;
      delete label.reversed;
      delete label.forwardName;
      g2.setEdge(e10.w, e10.v, label, forwardName);
    }
  });
};
const acyclic = { run: run$2, undo: undo$2 };
class Graph extends Graph$1 {
}
const safeSort = (valueA, valueB) => {
  return Number(valueA) - Number(valueB);
};
const addDummyNode = (g2, type4, attrs, name) => {
  let v2;
  do {
    v2 = `${name}${Math.random()}`;
  } while (g2.hasNode(v2));
  attrs.dummy = type4;
  g2.setNode(v2, attrs);
  return v2;
};
const simplify = (g2) => {
  const simplified = new Graph().setGraph(g2.graph());
  g2.nodes().forEach((v2) => {
    simplified.setNode(v2, g2.node(v2));
  });
  g2.edges().forEach((e10) => {
    const simpleLabel = simplified.edgeFromArgs(e10.v, e10.w) || { weight: 0, minlen: 1 };
    const label = g2.edge(e10);
    simplified.setEdge(e10.v, e10.w, {
      weight: simpleLabel.weight + label.weight,
      minlen: Math.max(simpleLabel.minlen, label.minlen)
    });
  });
  return simplified;
};
const asNonCompoundGraph = (g2) => {
  const simplified = new Graph({ multigraph: g2.isMultigraph() }).setGraph(g2.graph());
  g2.nodes().forEach((node) => {
    var _a3;
    if (!((_a3 = g2.children(node)) === null || _a3 === void 0 ? void 0 : _a3.length)) {
      simplified.setNode(node, g2.node(node));
    }
  });
  g2.edges().forEach((edge) => {
    simplified.setEdgeObj(edge, g2.edge(edge));
  });
  return simplified;
};
const zipObject = (keys, values) => {
  return keys === null || keys === void 0 ? void 0 : keys.reduce((obj, key, i2) => {
    obj[key] = values[i2];
    return obj;
  }, {});
};
const intersectRect = (rect, point) => {
  const x2 = Number(rect.x);
  const y2 = Number(rect.y);
  const dx2 = Number(point.x) - x2;
  const dy2 = Number(point.y) - y2;
  let w2 = Number(rect.width) / 2;
  let h2 = Number(rect.height) / 2;
  if (!dx2 && !dy2) {
    return { x: 0, y: 0 };
  }
  let sx2;
  let sy2;
  if (Math.abs(dy2) * w2 > Math.abs(dx2) * h2) {
    if (dy2 < 0) {
      h2 = -h2;
    }
    sx2 = h2 * dx2 / dy2;
    sy2 = h2;
  } else {
    if (dx2 < 0) {
      w2 = -w2;
    }
    sx2 = w2;
    sy2 = w2 * dy2 / dx2;
  }
  return { x: x2 + sx2, y: y2 + sy2 };
};
const buildLayerMatrix = (g2) => {
  const layeringNodes = [];
  const rankMax = maxRank(g2) + 1;
  for (let i2 = 0; i2 < rankMax; i2++) {
    layeringNodes.push([]);
  }
  g2.nodes().forEach((v2) => {
    const node = g2.node(v2);
    if (!node)
      return;
    const rank2 = node.rank;
    if (rank2 !== void 0 && layeringNodes[rank2]) {
      layeringNodes[rank2].push(v2);
    }
  });
  for (let i2 = 0; i2 < rankMax; i2++) {
    layeringNodes[i2] = layeringNodes[i2].sort((va2, vb2) => {
      var _a3, _b3;
      return safeSort((_a3 = g2.node(va2)) === null || _a3 === void 0 ? void 0 : _a3.order, (_b3 = g2.node(vb2)) === null || _b3 === void 0 ? void 0 : _b3.order);
    });
  }
  return layeringNodes;
};
const normalizeRanks = (g2) => {
  const nodeRanks = g2.nodes().filter((v2) => {
    var _a3;
    return ((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.rank) !== void 0;
  }).map((v2) => g2.node(v2).rank);
  const min2 = Math.min(...nodeRanks);
  g2.nodes().forEach((v2) => {
    const node = g2.node(v2);
    if (node.hasOwnProperty("rank") && min2 !== Infinity) {
      node.rank -= min2;
    }
  });
};
const removeEmptyRanks = (g2) => {
  const nodes = g2.nodes();
  const nodeRanks = nodes.filter((v2) => {
    var _a3;
    return ((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.rank) !== void 0;
  }).map((v2) => g2.node(v2).rank);
  const offset = Math.min(...nodeRanks);
  const layers = [];
  nodes.forEach((v2) => {
    var _a3;
    const rank2 = (((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.rank) || 0) - offset;
    if (!layers[rank2]) {
      layers[rank2] = [];
    }
    layers[rank2].push(v2);
  });
  let delta = 0;
  const nodeRankFactor = g2.graph().nodeRankFactor || 0;
  for (let i2 = 0; i2 < layers.length; i2++) {
    const vs2 = layers[i2];
    if (vs2 === void 0) {
      if (i2 % nodeRankFactor !== 0) {
        delta -= 1;
      }
    } else if (delta) {
      vs2 === null || vs2 === void 0 ? void 0 : vs2.forEach((v2) => {
        const node = g2.node(v2);
        if (node) {
          node.rank = node.rank || 0;
          node.rank += delta;
        }
      });
    }
  }
};
const addBorderNode$1 = (g2, prefix, rank2, order2) => {
  const node = {
    width: 0,
    height: 0
  };
  if (isNumber(rank2) && isNumber(order2)) {
    node.rank = rank2;
    node.order = order2;
  }
  return addDummyNode(g2, "border", node, prefix);
};
const maxRank = (g2) => {
  let maxRank2;
  g2.nodes().forEach((v2) => {
    var _a3;
    const rank2 = (_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.rank;
    if (rank2 !== void 0) {
      if (maxRank2 === void 0 || rank2 > maxRank2) {
        maxRank2 = rank2;
      }
    }
  });
  if (!maxRank2) {
    maxRank2 = 0;
  }
  return maxRank2;
};
const partition = (collection, fn2) => {
  const result = { lhs: [], rhs: [] };
  collection === null || collection === void 0 ? void 0 : collection.forEach((value) => {
    if (fn2(value)) {
      result.lhs.push(value);
    } else {
      result.rhs.push(value);
    }
  });
  return result;
};
const time = (name, fn2) => {
  const start = Date.now();
  try {
    return fn2();
  } finally {
    console.log(`${name} time: ${Date.now() - start}ms`);
  }
};
const notime = (name, fn2) => {
  return fn2();
};
const minBy = (array4, func) => {
  return array4.reduce((a2, b2) => {
    const valA = func(a2);
    const valB = func(b2);
    return valA > valB ? b2 : a2;
  });
};
const run$1 = (g2) => {
  g2.graph().dummyChains = [];
  g2.edges().forEach((edge) => normalizeEdge(g2, edge));
};
const normalizeEdge = (g2, e10) => {
  let v2 = e10.v;
  let vRank = g2.node(v2).rank;
  const w2 = e10.w;
  const wRank = g2.node(w2).rank;
  const name = e10.name;
  const edgeLabel = g2.edge(e10);
  const labelRank = edgeLabel.labelRank;
  if (wRank === vRank + 1)
    return;
  g2.removeEdgeObj(e10);
  const graph = g2.graph();
  let dummy;
  let attrs;
  let i2;
  for (i2 = 0, ++vRank; vRank < wRank; ++i2, ++vRank) {
    edgeLabel.points = [];
    attrs = {
      edgeLabel,
      width: 0,
      height: 0,
      edgeObj: e10,
      rank: vRank
    };
    dummy = addDummyNode(g2, "edge", attrs, "_d");
    if (vRank === labelRank) {
      attrs.width = edgeLabel.width;
      attrs.height = edgeLabel.height;
      attrs.dummy = "edge-label";
      attrs.labelpos = edgeLabel.labelpos;
    }
    g2.setEdge(v2, dummy, { weight: edgeLabel.weight }, name);
    if (i2 === 0) {
      if (!graph.dummyChains)
        graph.dummyChains = [];
      graph.dummyChains.push(dummy);
    }
    v2 = dummy;
  }
  g2.setEdge(v2, w2, { weight: edgeLabel.weight }, name);
};
const undo$1 = (g2) => {
  var _a3;
  (_a3 = g2.graph().dummyChains) === null || _a3 === void 0 ? void 0 : _a3.forEach((v2) => {
    let node = g2.node(v2);
    const origLabel = node.edgeLabel;
    let w2;
    if (node.edgeObj) {
      g2.setEdgeObj(node.edgeObj, origLabel);
    }
    let currentV = v2;
    while (node.dummy) {
      w2 = g2.successors(currentV)[0];
      g2.removeNode(currentV);
      origLabel.points.push({ x: node.x, y: node.y });
      if (node.dummy === "edge-label") {
        origLabel.x = node.x;
        origLabel.y = node.y;
        origLabel.width = node.width;
        origLabel.height = node.height;
      }
      currentV = w2;
      node = g2.node(currentV);
    }
  });
};
const normalize = { run: run$1, undo: undo$1 };
const longestPath = (g2) => {
  var _a3;
  const visited = {};
  const dfs3 = (v2) => {
    var _a4;
    const label = g2.node(v2);
    if (!label)
      return 0;
    if (visited[v2]) {
      return label.rank;
    }
    visited[v2] = true;
    let rank2;
    (_a4 = g2.outEdges(v2)) === null || _a4 === void 0 ? void 0 : _a4.forEach((edgeObj) => {
      const wRank = dfs3(edgeObj.w);
      const minLen = g2.edge(edgeObj).minlen;
      const r3 = wRank - minLen;
      if (r3) {
        if (rank2 === void 0 || r3 < rank2) {
          rank2 = r3;
        }
      }
    });
    if (!rank2) {
      rank2 = 0;
    }
    label.rank = rank2;
    return rank2;
  };
  (_a3 = g2.sources()) === null || _a3 === void 0 ? void 0 : _a3.forEach((source) => dfs3(source));
};
const longestPathWithLayer = (g2) => {
  var _a3;
  const visited = {};
  let minRank;
  const dfs3 = (v2) => {
    var _a4;
    const label = g2.node(v2);
    if (!label)
      return 0;
    if (visited[v2]) {
      return label.rank;
    }
    visited[v2] = true;
    let rank2;
    (_a4 = g2.outEdges(v2)) === null || _a4 === void 0 ? void 0 : _a4.forEach((edgeObj) => {
      const wRank = dfs3(edgeObj.w);
      const minLen = g2.edge(edgeObj).minlen;
      const r3 = wRank - minLen;
      if (r3) {
        if (rank2 === void 0 || r3 < rank2) {
          rank2 = r3;
        }
      }
    });
    if (!rank2) {
      rank2 = 0;
    }
    if (minRank === void 0 || rank2 < minRank) {
      minRank = rank2;
    }
    label.rank = rank2;
    return rank2;
  };
  (_a3 = g2.sources()) === null || _a3 === void 0 ? void 0 : _a3.forEach((source) => {
    if (g2.node(source))
      dfs3(source);
  });
  if (minRank === void 0) {
    minRank = 0;
  }
  const forwardVisited = {};
  const dfsForward = (v2, nextRank) => {
    var _a4;
    const label = g2.node(v2);
    const currRank = !isNaN(label.layer) ? label.layer : nextRank;
    if (label.rank === void 0 || label.rank < currRank) {
      label.rank = currRank;
    }
    if (forwardVisited[v2])
      return;
    forwardVisited[v2] = true;
    (_a4 = g2.outEdges(v2)) === null || _a4 === void 0 ? void 0 : _a4.map((e10) => {
      dfsForward(e10.w, currRank + g2.edge(e10).minlen);
    });
  };
  g2.nodes().forEach((n2) => {
    const label = g2.node(n2);
    if (!label)
      return;
    if (!isNaN(label.layer)) {
      dfsForward(n2, label.layer);
    } else {
      label.rank -= minRank;
    }
  });
};
const slack = (g2, e10) => {
  return g2.node(e10.w).rank - g2.node(e10.v).rank - g2.edge(e10).minlen;
};
const feasibleTree = (g2) => {
  const t2 = new Graph({ directed: false });
  const start = g2.nodes()[0];
  const size = g2.nodeCount();
  t2.setNode(start, {});
  let edge;
  let delta;
  while (tightTree(t2, g2) < size) {
    edge = findMinSlackEdge(t2, g2);
    delta = t2.hasNode(edge.v) ? slack(g2, edge) : -slack(g2, edge);
    shiftRanks(t2, g2, delta);
  }
  return t2;
};
const tightTree = (t2, g2) => {
  const dfs3 = (v2) => {
    g2.nodeEdges(v2).forEach((e10) => {
      const edgeV = e10.v;
      const w2 = v2 === edgeV ? e10.w : edgeV;
      if (!t2.hasNode(w2) && !slack(g2, e10)) {
        t2.setNode(w2, {});
        t2.setEdge(v2, w2, {});
        dfs3(w2);
      }
    });
  };
  t2.nodes().forEach(dfs3);
  return t2.nodeCount();
};
const feasibleTreeWithLayer = (g2) => {
  const t2 = new Graph({ directed: false });
  const start = g2.nodes()[0];
  const size = g2.nodes().filter((n2) => !!g2.node(n2)).length;
  t2.setNode(start, {});
  let edge;
  let delta;
  while (tightTreeWithLayer(t2, g2) < size) {
    edge = findMinSlackEdge(t2, g2);
    delta = t2.hasNode(edge.v) ? slack(g2, edge) : -slack(g2, edge);
    shiftRanks(t2, g2, delta);
  }
  return t2;
};
const tightTreeWithLayer = (t2, g2) => {
  const dfs3 = (v2) => {
    var _a3;
    (_a3 = g2.nodeEdges(v2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
      const edgeV = e10.v;
      const w2 = v2 === edgeV ? e10.w : edgeV;
      if (!t2.hasNode(w2) && (g2.node(w2).layer !== void 0 || !slack(g2, e10))) {
        t2.setNode(w2, {});
        t2.setEdge(v2, w2, {});
        dfs3(w2);
      }
    });
  };
  t2.nodes().forEach(dfs3);
  return t2.nodeCount();
};
const findMinSlackEdge = (t2, g2) => {
  return minBy(g2.edges(), (e10) => {
    if (t2.hasNode(e10.v) !== t2.hasNode(e10.w)) {
      return slack(g2, e10);
    }
    return Infinity;
  });
};
const shiftRanks = (t2, g2, delta) => {
  t2.nodes().forEach((v2) => {
    if (!g2.node(v2).rank)
      g2.node(v2).rank = 0;
    g2.node(v2).rank += delta;
  });
};
const { preorder: preorder2, postorder: postorder2 } = algorithm;
const networkSimplex = (og2) => {
  const g2 = simplify(og2);
  longestPath(g2);
  const t2 = feasibleTree(g2);
  initLowLimValues(t2);
  initCutValues(t2, g2);
  let e10;
  let f2;
  while (e10 = leaveEdge(t2)) {
    f2 = enterEdge(t2, g2, e10);
    exchangeEdges(t2, g2, e10, f2);
  }
};
const initCutValues = (t2, g2) => {
  let vs2 = postorder2(t2, t2.nodes());
  vs2 = vs2 === null || vs2 === void 0 ? void 0 : vs2.slice(0, (vs2 === null || vs2 === void 0 ? void 0 : vs2.length) - 1);
  vs2 === null || vs2 === void 0 ? void 0 : vs2.forEach((v2) => {
    assignCutValue(t2, g2, v2);
  });
};
const assignCutValue = (t2, g2, child) => {
  const childLab = t2.node(child);
  const parent = childLab.parent;
  t2.edgeFromArgs(child, parent).cutvalue = calcCutValue(t2, g2, child);
};
const calcCutValue = (t2, g2, child) => {
  var _a3;
  const childLab = t2.node(child);
  const parent = childLab.parent;
  let childIsTail = true;
  let graphEdge = g2.edgeFromArgs(child, parent);
  let cutValue = 0;
  if (!graphEdge) {
    childIsTail = false;
    graphEdge = g2.edgeFromArgs(parent, child);
  }
  cutValue = graphEdge.weight;
  (_a3 = g2.nodeEdges(child)) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
    const isOutEdge = e10.v === child;
    const other = isOutEdge ? e10.w : e10.v;
    if (other !== parent) {
      const pointsToHead = isOutEdge === childIsTail;
      const otherWeight = g2.edge(e10).weight;
      cutValue += pointsToHead ? otherWeight : -otherWeight;
      if (isTreeEdge(t2, child, other)) {
        const otherCutValue = t2.edgeFromArgs(child, other).cutvalue;
        cutValue += pointsToHead ? -otherCutValue : otherCutValue;
      }
    }
  });
  return cutValue;
};
const initLowLimValues = (tree, root2 = tree.nodes()[0]) => {
  dfsAssignLowLim(tree, {}, 1, root2);
};
const dfsAssignLowLim = (tree, visited, nextLim, v2, parent) => {
  var _a3;
  const low = nextLim;
  let useNextLim = nextLim;
  const label = tree.node(v2);
  visited[v2] = true;
  (_a3 = tree.neighbors(v2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((w2) => {
    if (!visited[w2]) {
      useNextLim = dfsAssignLowLim(tree, visited, useNextLim, w2, v2);
    }
  });
  label.low = low;
  label.lim = useNextLim++;
  if (parent) {
    label.parent = parent;
  } else {
    delete label.parent;
  }
  return useNextLim;
};
const leaveEdge = (tree) => {
  return tree.edges().find((e10) => {
    return tree.edge(e10).cutvalue < 0;
  });
};
const enterEdge = (t2, g2, edge) => {
  let v2 = edge.v;
  let w2 = edge.w;
  if (!g2.hasEdge(v2, w2)) {
    v2 = edge.w;
    w2 = edge.v;
  }
  const vLabel = t2.node(v2);
  const wLabel = t2.node(w2);
  let tailLabel = vLabel;
  let flip = false;
  if (vLabel.lim > wLabel.lim) {
    tailLabel = wLabel;
    flip = true;
  }
  const candidates = g2.edges().filter((edge2) => {
    return flip === isDescendant(t2, t2.node(edge2.v), tailLabel) && flip !== isDescendant(t2, t2.node(edge2.w), tailLabel);
  });
  return minBy(candidates, (edge2) => {
    return slack(g2, edge2);
  });
};
const exchangeEdges = (t2, g2, e10, f2) => {
  const v2 = e10.v;
  const w2 = e10.w;
  t2.removeEdge(v2, w2);
  t2.setEdge(f2.v, f2.w, {});
  initLowLimValues(t2);
  initCutValues(t2, g2);
  updateRanks(t2, g2);
};
const updateRanks = (t2, g2) => {
  const root2 = t2.nodes().find((v2) => {
    var _a3;
    return !((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.parent);
  });
  let vs2 = preorder2(t2, root2);
  vs2 = vs2 === null || vs2 === void 0 ? void 0 : vs2.slice(1);
  vs2 === null || vs2 === void 0 ? void 0 : vs2.forEach((v2) => {
    const parent = t2.node(v2).parent;
    let edge = g2.edgeFromArgs(v2, parent);
    let flipped = false;
    if (!edge) {
      edge = g2.edgeFromArgs(parent, v2);
      flipped = true;
    }
    g2.node(v2).rank = g2.node(parent).rank + (flipped ? edge.minlen : -edge.minlen);
  });
};
const isTreeEdge = (tree, u2, v2) => {
  return tree.hasEdge(u2, v2);
};
const isDescendant = (tree, vLabel, rootLabel) => {
  return rootLabel.low <= vLabel.lim && vLabel.lim <= rootLabel.lim;
};
const rank = (g2) => {
  switch (g2.graph().ranker) {
    case "network-simplex":
      networkSimplexRanker(g2);
      break;
    case "tight-tree":
      tightTreeRanker(g2);
      break;
    case "longest-path":
      longestPathRanker(g2);
      break;
    default:
      tightTreeRanker(g2);
  }
};
const longestPathRanker = longestPath;
const tightTreeRanker = (g2) => {
  longestPathWithLayer(g2);
  feasibleTreeWithLayer(g2);
};
const networkSimplexRanker = (g2) => {
  networkSimplex(g2);
};
const dfsBothOrder = (g2) => {
  var _a3;
  const result = {};
  let lim = 0;
  const dfs3 = (v2) => {
    var _a4;
    const low = lim;
    (_a4 = g2.children(v2)) === null || _a4 === void 0 ? void 0 : _a4.forEach(dfs3);
    result[v2] = { low, lim: lim++ };
  };
  (_a3 = g2.children()) === null || _a3 === void 0 ? void 0 : _a3.forEach(dfs3);
  return result;
};
const findPath = (g2, postorderNums, v2, w2) => {
  const vPath = [];
  const wPath = [];
  const low = Math.min(postorderNums[v2].low, postorderNums[w2].low);
  const lim = Math.max(postorderNums[v2].lim, postorderNums[w2].lim);
  let parent;
  let lca;
  parent = v2;
  do {
    parent = g2.parent(parent);
    vPath.push(parent);
  } while (parent && (postorderNums[parent].low > low || lim > postorderNums[parent].lim));
  lca = parent;
  parent = w2;
  while (parent && parent !== lca) {
    wPath.push(parent);
    parent = g2.parent(parent);
  }
  return { lca, path: vPath.concat(wPath.reverse()) };
};
const parentDummyChains = (g2) => {
  var _a3;
  const postorderNums = dfsBothOrder(g2);
  (_a3 = g2.graph().dummyChains) === null || _a3 === void 0 ? void 0 : _a3.forEach((startV) => {
    var _a4, _b3;
    let v2 = startV;
    let node = g2.node(v2);
    const edgeObj = node.edgeObj;
    if (!edgeObj)
      return;
    const pathData = findPath(g2, postorderNums, edgeObj.v, edgeObj.w);
    const path = pathData.path;
    const lca = pathData.lca;
    let pathIdx = 0;
    let pathV = path[pathIdx];
    let ascending = true;
    while (v2 !== edgeObj.w) {
      node = g2.node(v2);
      if (ascending) {
        while (pathV !== lca && ((_a4 = g2.node(pathV)) === null || _a4 === void 0 ? void 0 : _a4.maxRank) < node.rank) {
          pathIdx++;
          pathV = path[pathIdx];
        }
        if (pathV === lca) {
          ascending = false;
        }
      }
      if (!ascending) {
        while (pathIdx < path.length - 1 && ((_b3 = g2.node(path[pathIdx + 1])) === null || _b3 === void 0 ? void 0 : _b3.minRank) <= node.rank) {
          pathIdx++;
        }
        pathV = path[pathIdx];
      }
      g2.setParent(v2, pathV);
      v2 = g2.successors(v2)[0];
    }
  });
};
const run = (g2) => {
  var _a3;
  const root2 = addDummyNode(g2, "root", {}, "_root");
  const depths = treeDepths(g2);
  let maxDepth = Math.max(...Object.values(depths));
  if (Math.abs(maxDepth) === Infinity) {
    maxDepth = 1;
  }
  const height = maxDepth - 1;
  const nodeSep = 2 * height + 1;
  g2.graph().nestingRoot = root2;
  g2.edges().forEach((e10) => {
    g2.edge(e10).minlen *= nodeSep;
  });
  const weight = sumWeights(g2) + 1;
  (_a3 = g2.children()) === null || _a3 === void 0 ? void 0 : _a3.forEach((child) => {
    dfs2(g2, root2, nodeSep, weight, height, depths, child);
  });
  g2.graph().nodeRankFactor = nodeSep;
};
const dfs2 = (g2, root2, nodeSep, weight, height, depths, v2) => {
  const children = g2.children(v2);
  if (!(children === null || children === void 0 ? void 0 : children.length)) {
    if (v2 !== root2) {
      g2.setEdge(root2, v2, { weight: 0, minlen: nodeSep });
    }
    return;
  }
  const top = addBorderNode$1(g2, "_bt");
  const bottom = addBorderNode$1(g2, "_bb");
  const label = g2.node(v2);
  g2.setParent(top, v2);
  label.borderTop = top;
  g2.setParent(bottom, v2);
  label.borderBottom = bottom;
  children === null || children === void 0 ? void 0 : children.forEach((child) => {
    dfs2(g2, root2, nodeSep, weight, height, depths, child);
    const childNode = g2.node(child);
    const childTop = childNode.borderTop ? childNode.borderTop : child;
    const childBottom = childNode.borderBottom ? childNode.borderBottom : child;
    const thisWeight = childNode.borderTop ? weight : 2 * weight;
    const minlen = childTop !== childBottom ? 1 : height - depths[v2] + 1;
    g2.setEdge(top, childTop, {
      minlen,
      weight: thisWeight,
      nestingEdge: true
    });
    g2.setEdge(childBottom, bottom, {
      minlen,
      weight: thisWeight,
      nestingEdge: true
    });
  });
  if (!g2.parent(v2)) {
    g2.setEdge(root2, top, { weight: 0, minlen: height + depths[v2] });
  }
};
const treeDepths = (g2) => {
  var _a3;
  const depths = {};
  const dfs3 = (v2, depth) => {
    const children = g2.children(v2);
    children === null || children === void 0 ? void 0 : children.forEach((child) => dfs3(child, depth + 1));
    depths[v2] = depth;
  };
  (_a3 = g2.children()) === null || _a3 === void 0 ? void 0 : _a3.forEach((v2) => dfs3(v2, 1));
  return depths;
};
const sumWeights = (g2) => {
  let result = 0;
  g2.edges().forEach((e10) => {
    result += g2.edge(e10).weight;
  });
  return result;
};
const cleanup = (g2) => {
  const graphLabel = g2.graph();
  graphLabel.nestingRoot && g2.removeNode(graphLabel.nestingRoot);
  delete graphLabel.nestingRoot;
  g2.edges().forEach((e10) => {
    const edge = g2.edge(e10);
    if (edge.nestingEdge) {
      g2.removeEdgeObj(e10);
    }
  });
};
const nestingGraph = { run, cleanup };
const addBorderSegments = (g2) => {
  var _a3;
  const dfs3 = (v2) => {
    const children = g2.children(v2);
    const node = g2.node(v2);
    if (children === null || children === void 0 ? void 0 : children.length) {
      children.forEach((child) => dfs3(child));
    }
    if (node.hasOwnProperty("minRank")) {
      node.borderLeft = [];
      node.borderRight = [];
      for (let rank2 = node.minRank, maxRank2 = node.maxRank + 1; rank2 < maxRank2; rank2 += 1) {
        addBorderNode(g2, "borderLeft", "_bl", v2, node, rank2);
        addBorderNode(g2, "borderRight", "_br", v2, node, rank2);
      }
    }
  };
  (_a3 = g2.children()) === null || _a3 === void 0 ? void 0 : _a3.forEach((child) => dfs3(child));
};
const addBorderNode = (g2, prop, prefix, sg2, sgNode, rank2) => {
  const label = { rank: rank2, borderType: prop, width: 0, height: 0 };
  const prev = sgNode[prop][rank2 - 1];
  const curr = addDummyNode(g2, "border", label, prefix);
  sgNode[prop][rank2] = curr;
  g2.setParent(curr, sg2);
  if (prev) {
    g2.setEdge(prev, curr, { weight: 1 });
  }
};
const adjust = (g2) => {
  var _a3;
  const rankDir = (_a3 = g2.graph().rankdir) === null || _a3 === void 0 ? void 0 : _a3.toLowerCase();
  if (rankDir === "lr" || rankDir === "rl") {
    swapWidthHeight(g2);
  }
};
const undo = (g2) => {
  var _a3;
  const rankDir = (_a3 = g2.graph().rankdir) === null || _a3 === void 0 ? void 0 : _a3.toLowerCase();
  if (rankDir === "bt" || rankDir === "rl") {
    reverseY(g2);
  }
  if (rankDir === "lr" || rankDir === "rl") {
    swapXY(g2);
    swapWidthHeight(g2);
  }
};
const swapWidthHeight = (g2) => {
  g2.nodes().forEach((v2) => {
    swapWidthHeightOne(g2.node(v2));
  });
  g2.edges().forEach((e10) => {
    swapWidthHeightOne(g2.edge(e10));
  });
};
const swapWidthHeightOne = (attrs) => {
  const w2 = attrs.width;
  attrs.width = attrs.height;
  attrs.height = w2;
};
const reverseY = (g2) => {
  g2.nodes().forEach((v2) => {
    reverseYOne(g2.node(v2));
  });
  g2.edges().forEach((e10) => {
    var _a3;
    const edge = g2.edge(e10);
    (_a3 = edge.points) === null || _a3 === void 0 ? void 0 : _a3.forEach((point) => reverseYOne(point));
    if (edge.hasOwnProperty("y")) {
      reverseYOne(edge);
    }
  });
};
const reverseYOne = (attrs) => {
  if (attrs === null || attrs === void 0 ? void 0 : attrs.y) {
    attrs.y = -attrs.y;
  }
};
const swapXY = (g2) => {
  g2.nodes().forEach((v2) => {
    swapXYOne(g2.node(v2));
  });
  g2.edges().forEach((e10) => {
    var _a3;
    const edge = g2.edge(e10);
    (_a3 = edge.points) === null || _a3 === void 0 ? void 0 : _a3.forEach((point) => swapXYOne(point));
    if (edge.hasOwnProperty("x")) {
      swapXYOne(edge);
    }
  });
};
const swapXYOne = (attrs) => {
  const x2 = attrs.x;
  attrs.x = attrs.y;
  attrs.y = x2;
};
const coordinateSystem = { adjust, undo };
function isArray(value) {
  return Array.isArray(value);
}
function max(arr) {
  if (!Array.isArray(arr))
    return -Infinity;
  var length = arr.length;
  if (!length)
    return -Infinity;
  var max2 = arr[0];
  for (var i2 = 1; i2 < length; i2++) {
    max2 = Math.max(max2, arr[i2]);
  }
  return max2;
}
const min = function(arr) {
  if (!isArray(arr)) {
    return void 0;
  }
  return arr.reduce(function(prev, curr) {
    return Math.min(prev, curr);
  }, arr[0]);
};
const initOrder = (g2) => {
  const visited = {};
  const simpleNodes = g2.nodes().filter((v2) => {
    var _a3;
    return !((_a3 = g2.children(v2)) === null || _a3 === void 0 ? void 0 : _a3.length);
  });
  const nodeRanks = simpleNodes.map((v2) => g2.node(v2).rank);
  const maxRank2 = max(nodeRanks);
  const layers = [];
  for (let i2 = 0; i2 < maxRank2 + 1; i2++) {
    layers.push([]);
  }
  const dfs3 = (v2) => {
    var _a3;
    if (visited.hasOwnProperty(v2))
      return;
    visited[v2] = true;
    const node = g2.node(v2);
    if (!isNaN(node.rank)) {
      layers[node.rank].push(v2);
    }
    (_a3 = g2.successors(v2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((child) => dfs3(child));
  };
  const orderedVs = simpleNodes.sort((a2, b2) => g2.node(a2).rank - g2.node(b2).rank);
  const beforeSort = orderedVs.filter((n2) => {
    return g2.node(n2).fixorder !== void 0;
  });
  const fixOrderNodes = beforeSort.sort((a2, b2) => g2.node(a2).fixorder - g2.node(b2).fixorder);
  fixOrderNodes === null || fixOrderNodes === void 0 ? void 0 : fixOrderNodes.forEach((n2) => {
    if (!isNaN(g2.node(n2).rank)) {
      layers[g2.node(n2).rank].push(n2);
    }
    visited[n2] = true;
  });
  orderedVs === null || orderedVs === void 0 ? void 0 : orderedVs.forEach(dfs3);
  return layers;
};
const twoLayerCrossCount = (g2, northLayer, southLayer) => {
  const southPos = zipObject(southLayer, southLayer.map((v2, i2) => i2));
  const unflat = northLayer.map((v2) => {
    var _a3;
    const unsort = (_a3 = g2.outEdges(v2)) === null || _a3 === void 0 ? void 0 : _a3.map((e10) => {
      return { pos: southPos[e10.w] || 0, weight: g2.edge(e10).weight };
    });
    return unsort === null || unsort === void 0 ? void 0 : unsort.sort((a2, b2) => a2.pos - b2.pos);
  });
  const southEntries = unflat.flat().filter((entry) => entry !== void 0);
  let firstIndex = 1;
  while (firstIndex < southLayer.length)
    firstIndex <<= 1;
  const treeSize = 2 * firstIndex - 1;
  firstIndex -= 1;
  const tree = Array(treeSize).fill(0, 0, treeSize);
  let cc2 = 0;
  southEntries === null || southEntries === void 0 ? void 0 : southEntries.forEach((entry) => {
    if (entry) {
      let index2 = entry.pos + firstIndex;
      tree[index2] += entry.weight;
      let weightSum = 0;
      while (index2 > 0) {
        if (index2 % 2) {
          weightSum += tree[index2 + 1];
        }
        index2 = index2 - 1 >> 1;
        tree[index2] += entry.weight;
      }
      cc2 += entry.weight * weightSum;
    }
  });
  return cc2;
};
const crossCount = (g2, layering) => {
  let cc2 = 0;
  for (let i2 = 1; i2 < (layering === null || layering === void 0 ? void 0 : layering.length); i2 += 1) {
    cc2 += twoLayerCrossCount(g2, layering[i2 - 1], layering[i2]);
  }
  return cc2;
};
const buildLayerGraph = (g2, rank2, relationship) => {
  const root2 = createRootNode(g2);
  const result = new Graph({ compound: true }).setGraph({ root: root2 }).setDefaultNodeLabel((v2) => {
    return g2.node(v2);
  });
  g2.nodes().forEach((v2) => {
    var _a3;
    const node = g2.node(v2);
    const parent = g2.parent(v2);
    if (node.rank === rank2 || node.minRank <= rank2 && rank2 <= node.maxRank) {
      result.setNode(v2);
      result.setParent(v2, parent || root2);
      (_a3 = g2[relationship](v2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
        const u2 = e10.v === v2 ? e10.w : e10.v;
        const edge = result.edgeFromArgs(u2, v2);
        const weight = edge !== void 0 ? edge.weight : 0;
        result.setEdge(u2, v2, { weight: g2.edge(e10).weight + weight });
      });
      if (node.hasOwnProperty("minRank")) {
        result.setNode(v2, {
          borderLeft: node.borderLeft[rank2],
          borderRight: node.borderRight[rank2]
        });
      }
    }
  });
  return result;
};
const createRootNode = (g2) => {
  let v2;
  while (g2.hasNode(v2 = `_root${Math.random()}`))
    ;
  return v2;
};
const addSubgraphConstraints = (g2, cg2, vs2) => {
  const prev = {};
  let rootPrev;
  vs2 === null || vs2 === void 0 ? void 0 : vs2.forEach((v2) => {
    let child = g2.parent(v2);
    let parent;
    let prevChild;
    while (child) {
      parent = g2.parent(child);
      if (parent) {
        prevChild = prev[parent];
        prev[parent] = child;
      } else {
        prevChild = rootPrev;
        rootPrev = child;
      }
      if (prevChild && prevChild !== child) {
        cg2.setEdge(prevChild, child);
        return;
      }
      child = parent;
    }
  });
};
const barycenter = (g2, movable) => {
  return movable.map((v2) => {
    const inV = g2.inEdges(v2);
    if (!(inV === null || inV === void 0 ? void 0 : inV.length)) {
      return { v: v2 };
    }
    {
      const result = { sum: 0, weight: 0 };
      inV === null || inV === void 0 ? void 0 : inV.forEach((e10) => {
        const edge = g2.edge(e10);
        const nodeU = g2.node(e10.v);
        result.sum += edge.weight * nodeU.order;
        result.weight += edge.weight;
      });
      return {
        v: v2,
        barycenter: result.sum / result.weight,
        weight: result.weight
      };
    }
  });
};
const resolveConflicts = (entries, cg2) => {
  var _a3, _b3, _c3;
  const mappedEntries = {};
  entries === null || entries === void 0 ? void 0 : entries.forEach((entry, i2) => {
    mappedEntries[entry.v] = {
      i: i2,
      indegree: 0,
      in: [],
      out: [],
      vs: [entry.v]
    };
    const tmp = mappedEntries[entry.v];
    if (entry.barycenter !== void 0) {
      tmp.barycenter = entry.barycenter;
      tmp.weight = entry.weight;
    }
  });
  (_a3 = cg2.edges()) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
    const entryV = mappedEntries[e10.v];
    const entryW = mappedEntries[e10.w];
    if (entryV !== void 0 && entryW !== void 0) {
      entryW.indegree++;
      entryV.out.push(mappedEntries[e10.w]);
    }
  });
  const sourceSet = (_c3 = (_b3 = Object.values(mappedEntries)).filter) === null || _c3 === void 0 ? void 0 : _c3.call(_b3, (entry) => !entry.indegree);
  return doResolveConflicts(sourceSet);
};
const doResolveConflicts = (sourceSet) => {
  var _a3, _b3;
  const entries = [];
  const handleIn = (vEntry) => {
    return (uEntry) => {
      if (uEntry.merged)
        return;
      if (uEntry.barycenter === void 0 || vEntry.barycenter === void 0 || uEntry.barycenter >= vEntry.barycenter) {
        mergeEntries(vEntry, uEntry);
      }
    };
  };
  const handleOut = (vEntry) => {
    return (wEntry) => {
      wEntry["in"].push(vEntry);
      if (--wEntry.indegree === 0) {
        sourceSet.push(wEntry);
      }
    };
  };
  while (sourceSet === null || sourceSet === void 0 ? void 0 : sourceSet.length) {
    const entry = sourceSet.pop();
    entries.push(entry);
    (_a3 = entry["in"].reverse()) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => handleIn(entry)(e10));
    (_b3 = entry.out) === null || _b3 === void 0 ? void 0 : _b3.forEach((e10) => handleOut(entry)(e10));
  }
  const filtered = entries.filter((entry) => !entry.merged);
  const keys = [
    "vs",
    "i",
    "barycenter",
    "weight"
  ];
  return filtered.map((entry) => {
    const picked = {};
    keys === null || keys === void 0 ? void 0 : keys.forEach((key) => {
      if (entry[key] === void 0)
        return;
      picked[key] = entry[key];
    });
    return picked;
  });
};
const mergeEntries = (target, source) => {
  var _a3;
  let sum = 0;
  let weight = 0;
  if (target.weight) {
    sum += target.barycenter * target.weight;
    weight += target.weight;
  }
  if (source.weight) {
    sum += source.barycenter * source.weight;
    weight += source.weight;
  }
  target.vs = (_a3 = source.vs) === null || _a3 === void 0 ? void 0 : _a3.concat(target.vs);
  target.barycenter = sum / weight;
  target.weight = weight;
  target.i = Math.min(source.i, target.i);
  source.merged = true;
};
const sort = (entries, biasRight, usePrev, keepNodeOrder) => {
  const parts = partition(entries, (entry) => {
    const hasFixOrder = entry.hasOwnProperty("fixorder") && !isNaN(entry.fixorder);
    if (keepNodeOrder)
      return !hasFixOrder && entry.hasOwnProperty("barycenter");
    return hasFixOrder || entry.hasOwnProperty("barycenter");
  });
  const sortable = parts.lhs;
  const unsortable = parts.rhs.sort((a2, b2) => -a2.i - -b2.i);
  const vs2 = [];
  let sum = 0;
  let weight = 0;
  let vsIndex = 0;
  sortable === null || sortable === void 0 ? void 0 : sortable.sort(compareWithBias(!!biasRight, !!usePrev));
  vsIndex = consumeUnsortable(vs2, unsortable, vsIndex);
  sortable === null || sortable === void 0 ? void 0 : sortable.forEach((entry) => {
    var _a3;
    vsIndex += (_a3 = entry.vs) === null || _a3 === void 0 ? void 0 : _a3.length;
    vs2.push(entry.vs);
    sum += entry.barycenter * entry.weight;
    weight += entry.weight;
    vsIndex = consumeUnsortable(vs2, unsortable, vsIndex);
  });
  const result = { vs: vs2.flat() };
  if (weight) {
    result.barycenter = sum / weight;
    result.weight = weight;
  }
  return result;
};
const consumeUnsortable = (vs2, unsortable, index2) => {
  let iindex = index2;
  let last;
  while (unsortable.length && (last = unsortable[unsortable.length - 1]).i <= iindex) {
    unsortable.pop();
    vs2 === null || vs2 === void 0 ? void 0 : vs2.push(last.vs);
    iindex++;
  }
  return iindex;
};
const compareWithBias = (bias, usePrev) => {
  return (entryV, entryW) => {
    if (entryV.fixorder !== void 0 && entryW.fixorder !== void 0) {
      return entryV.fixorder - entryW.fixorder;
    }
    if (entryV.barycenter < entryW.barycenter) {
      return -1;
    }
    if (entryV.barycenter > entryW.barycenter) {
      return 1;
    }
    if (usePrev && entryV.order !== void 0 && entryW.order !== void 0) {
      if (entryV.order < entryW.order) {
        return -1;
      }
      if (entryV.order > entryW.order) {
        return 1;
      }
    }
    return !bias ? entryV.i - entryW.i : entryW.i - entryV.i;
  };
};
const sortSubgraph = (g2, v2, cg2, biasRight, usePrev, keepNodeOrder) => {
  var _a3, _b3, _c3, _d3;
  let movable = g2.children(v2);
  const node = g2.node(v2);
  const bl2 = node ? node.borderLeft : void 0;
  const br2 = node ? node.borderRight : void 0;
  const subgraphs = {};
  if (bl2) {
    movable = movable === null || movable === void 0 ? void 0 : movable.filter((w2) => {
      return w2 !== bl2 && w2 !== br2;
    });
  }
  const barycenters = barycenter(g2, movable || []);
  barycenters === null || barycenters === void 0 ? void 0 : barycenters.forEach((entry) => {
    var _a4;
    if ((_a4 = g2.children(entry.v)) === null || _a4 === void 0 ? void 0 : _a4.length) {
      const subgraphResult = sortSubgraph(g2, entry.v, cg2, biasRight, keepNodeOrder);
      subgraphs[entry.v] = subgraphResult;
      if (subgraphResult.hasOwnProperty("barycenter")) {
        mergeBarycenters(entry, subgraphResult);
      }
    }
  });
  const entries = resolveConflicts(barycenters, cg2);
  expandSubgraphs(entries, subgraphs);
  (_a3 = entries.filter((e10) => e10.vs.length > 0)) === null || _a3 === void 0 ? void 0 : _a3.forEach((e10) => {
    const node2 = g2.node(e10.vs[0]);
    if (node2) {
      e10.fixorder = node2.fixorder;
      e10.order = node2.order;
    }
  });
  const result = sort(entries, biasRight, usePrev, keepNodeOrder);
  if (bl2) {
    result.vs = [bl2, result.vs, br2].flat();
    if ((_b3 = g2.predecessors(bl2)) === null || _b3 === void 0 ? void 0 : _b3.length) {
      const blPred = g2.node(((_c3 = g2.predecessors(bl2)) === null || _c3 === void 0 ? void 0 : _c3[0]) || "");
      const brPred = g2.node(((_d3 = g2.predecessors(br2)) === null || _d3 === void 0 ? void 0 : _d3[0]) || "");
      if (!result.hasOwnProperty("barycenter")) {
        result.barycenter = 0;
        result.weight = 0;
      }
      result.barycenter = (result.barycenter * result.weight + blPred.order + brPred.order) / (result.weight + 2);
      result.weight += 2;
    }
  }
  return result;
};
const expandSubgraphs = (entries, subgraphs) => {
  entries === null || entries === void 0 ? void 0 : entries.forEach((entry) => {
    var _a3;
    const vss = (_a3 = entry.vs) === null || _a3 === void 0 ? void 0 : _a3.map((v2) => {
      if (subgraphs[v2]) {
        return subgraphs[v2].vs;
      }
      return v2;
    });
    entry.vs = vss.flat();
  });
};
const mergeBarycenters = (target, other) => {
  if (target.barycenter !== void 0) {
    target.barycenter = (target.barycenter * target.weight + other.barycenter * other.weight) / (target.weight + other.weight);
    target.weight += other.weight;
  } else {
    target.barycenter = other.barycenter;
    target.weight = other.weight;
  }
};
const order = (g2, keepNodeOrder) => {
  const mxRank = maxRank(g2);
  const range1 = [];
  const range22 = [];
  for (let i2 = 1; i2 < mxRank + 1; i2++)
    range1.push(i2);
  for (let i2 = mxRank - 1; i2 > -1; i2--)
    range22.push(i2);
  const downLayerGraphs = buildLayerGraphs(g2, range1, "inEdges");
  const upLayerGraphs = buildLayerGraphs(g2, range22, "outEdges");
  let layering = initOrder(g2);
  assignOrder(g2, layering);
  let bestCC = Number.POSITIVE_INFINITY;
  let best;
  for (let i2 = 0, lastBest = 0; lastBest < 4; ++i2, ++lastBest) {
    sweepLayerGraphs(i2 % 2 ? downLayerGraphs : upLayerGraphs, i2 % 4 >= 2, false, keepNodeOrder);
    layering = buildLayerMatrix(g2);
    const cc2 = crossCount(g2, layering);
    if (cc2 < bestCC) {
      lastBest = 0;
      best = clone(layering);
      bestCC = cc2;
    }
  }
  layering = initOrder(g2);
  assignOrder(g2, layering);
  for (let i2 = 0, lastBest = 0; lastBest < 4; ++i2, ++lastBest) {
    sweepLayerGraphs(i2 % 2 ? downLayerGraphs : upLayerGraphs, i2 % 4 >= 2, true, keepNodeOrder);
    layering = buildLayerMatrix(g2);
    const cc2 = crossCount(g2, layering);
    if (cc2 < bestCC) {
      lastBest = 0;
      best = clone(layering);
      bestCC = cc2;
    }
  }
  assignOrder(g2, best);
};
const buildLayerGraphs = (g2, ranks, relationship) => {
  return ranks.map((rank2) => {
    return buildLayerGraph(g2, rank2, relationship);
  });
};
const sweepLayerGraphs = (layerGraphs, biasRight, usePrev, keepNodeOrder) => {
  const cg2 = new Graph();
  layerGraphs === null || layerGraphs === void 0 ? void 0 : layerGraphs.forEach((lg2) => {
    var _a3;
    const root2 = lg2.graph().root;
    const sorted = sortSubgraph(lg2, root2, cg2, biasRight, usePrev, keepNodeOrder);
    for (let i2 = 0; i2 < ((_a3 = sorted.vs) === null || _a3 === void 0 ? void 0 : _a3.length) || 0; i2++) {
      const lnode = lg2.node(sorted.vs[i2]);
      if (lnode) {
        lnode.order = i2;
      }
    }
    addSubgraphConstraints(lg2, cg2, sorted.vs);
  });
};
const assignOrder = (g2, layering) => {
  layering === null || layering === void 0 ? void 0 : layering.forEach((layer) => {
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2, i2) => {
      g2.node(v2).order = i2;
    });
  });
};
class BlockGraph extends Graph$1 {
}
const findType1Conflicts = (g2, layering) => {
  const conflicts = {};
  const visitLayer = (prevLayer, layer) => {
    let k0 = 0;
    let scanPos = 0;
    const prevLayerLength = prevLayer.length;
    const lastNode = layer === null || layer === void 0 ? void 0 : layer[(layer === null || layer === void 0 ? void 0 : layer.length) - 1];
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2, i2) => {
      var _a3;
      const w2 = findOtherInnerSegmentNode(g2, v2);
      const k1 = w2 ? g2.node(w2).order : prevLayerLength;
      if (w2 || v2 === lastNode) {
        (_a3 = layer.slice(scanPos, i2 + 1)) === null || _a3 === void 0 ? void 0 : _a3.forEach((scanNode) => {
          var _a4;
          (_a4 = g2.predecessors(scanNode)) === null || _a4 === void 0 ? void 0 : _a4.forEach((u2) => {
            var _a5;
            const uLabel = g2.node(u2);
            const uPos = uLabel.order;
            if ((uPos < k0 || k1 < uPos) && !(uLabel.dummy && ((_a5 = g2.node(scanNode)) === null || _a5 === void 0 ? void 0 : _a5.dummy))) {
              addConflict(conflicts, u2, scanNode);
            }
          });
        });
        scanPos = i2 + 1;
        k0 = k1;
      }
    });
    return layer;
  };
  if (layering === null || layering === void 0 ? void 0 : layering.length) {
    layering.reduce(visitLayer);
  }
  return conflicts;
};
const findType2Conflicts = (g2, layering) => {
  const conflicts = {};
  function scan(south, southPos, southEnd, prevNorthBorder, nextNorthBorder) {
    var _a3, _b3;
    let v2;
    for (let i2 = southPos; i2 < southEnd; i2++) {
      v2 = south[i2];
      if ((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.dummy) {
        (_b3 = g2.predecessors(v2)) === null || _b3 === void 0 ? void 0 : _b3.forEach((u2) => {
          const uNode = g2.node(u2);
          if (uNode.dummy && (uNode.order < prevNorthBorder || uNode.order > nextNorthBorder)) {
            addConflict(conflicts, u2, v2);
          }
        });
      }
    }
  }
  function getScannedKey(params) {
    return JSON.stringify(params.slice(1));
  }
  function scanIfNeeded(params, scanCache) {
    const cacheKey = getScannedKey(params);
    if (scanCache.get(cacheKey))
      return;
    scan(...params);
    scanCache.set(cacheKey, true);
  }
  const visitLayer = (north, south) => {
    let prevNorthPos = -1;
    let nextNorthPos;
    let southPos = 0;
    const scanned = /* @__PURE__ */ new Map();
    south === null || south === void 0 ? void 0 : south.forEach((v2, southLookahead) => {
      var _a3;
      if (((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.dummy) === "border") {
        const predecessors = g2.predecessors(v2) || [];
        if (predecessors.length) {
          nextNorthPos = g2.node(predecessors[0]).order;
          scanIfNeeded([south, southPos, southLookahead, prevNorthPos, nextNorthPos], scanned);
          southPos = southLookahead;
          prevNorthPos = nextNorthPos;
        }
      }
      scanIfNeeded([south, southPos, south.length, nextNorthPos, north.length], scanned);
    });
    return south;
  };
  if (layering === null || layering === void 0 ? void 0 : layering.length) {
    layering.reduce(visitLayer);
  }
  return conflicts;
};
const findOtherInnerSegmentNode = (g2, v2) => {
  var _a3, _b3;
  if ((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.dummy) {
    return (_b3 = g2.predecessors(v2)) === null || _b3 === void 0 ? void 0 : _b3.find((u2) => g2.node(u2).dummy);
  }
};
const addConflict = (conflicts, v2, w2) => {
  let vv2 = v2;
  let ww2 = w2;
  if (vv2 > ww2) {
    const tmp = vv2;
    vv2 = ww2;
    ww2 = tmp;
  }
  let conflictsV = conflicts[vv2];
  if (!conflictsV) {
    conflicts[vv2] = conflictsV = {};
  }
  conflictsV[ww2] = true;
};
const hasConflict = (conflicts, v2, w2) => {
  let vv2 = v2;
  let ww2 = w2;
  if (vv2 > ww2) {
    const tmp = v2;
    vv2 = ww2;
    ww2 = tmp;
  }
  return !!conflicts[vv2];
};
const verticalAlignment = (g2, layering, conflicts, neighborFn) => {
  const root2 = {};
  const align = {};
  const pos = {};
  layering === null || layering === void 0 ? void 0 : layering.forEach((layer) => {
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2, order2) => {
      root2[v2] = v2;
      align[v2] = v2;
      pos[v2] = order2;
    });
  });
  layering === null || layering === void 0 ? void 0 : layering.forEach((layer) => {
    let prevIdx = -1;
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2) => {
      let ws2 = neighborFn(v2);
      if (ws2.length) {
        ws2 = ws2.sort((a2, b2) => pos[a2] - pos[b2]);
        const mp2 = (ws2.length - 1) / 2;
        for (let i2 = Math.floor(mp2), il2 = Math.ceil(mp2); i2 <= il2; ++i2) {
          const w2 = ws2[i2];
          if (align[v2] === v2 && prevIdx < pos[w2] && !hasConflict(conflicts, v2, w2)) {
            align[w2] = v2;
            align[v2] = root2[v2] = root2[w2];
            prevIdx = pos[w2];
          }
        }
      }
    });
  });
  return { root: root2, align };
};
const horizontalCompaction = (g2, layering, root2, align, reverseSep) => {
  var _a3;
  const xs2 = {};
  const blockG = buildBlockGraph(g2, layering, root2, reverseSep);
  const borderType = reverseSep ? "borderLeft" : "borderRight";
  const iterate = (setXsFunc, nextNodesFunc) => {
    let stack = blockG.nodes();
    let elem = stack.pop();
    const visited = {};
    while (elem) {
      if (visited[elem]) {
        setXsFunc(elem);
      } else {
        visited[elem] = true;
        stack.push(elem);
        stack = stack.concat(nextNodesFunc(elem));
      }
      elem = stack.pop();
    }
  };
  const pass1 = (elem) => {
    xs2[elem] = (blockG.inEdges(elem) || []).reduce((acc, e10) => {
      return Math.max(acc, (xs2[e10.v] || 0) + blockG.edge(e10));
    }, 0);
  };
  const pass2 = (elem) => {
    const min2 = (blockG.outEdges(elem) || []).reduce((acc, e10) => {
      return Math.min(acc, (xs2[e10.w] || 0) - blockG.edge(e10));
    }, Number.POSITIVE_INFINITY);
    const node = g2.node(elem);
    if (min2 !== Number.POSITIVE_INFINITY && node.borderType !== borderType) {
      xs2[elem] = Math.max(xs2[elem], min2);
    }
  };
  iterate(pass1, blockG.predecessors.bind(blockG));
  iterate(pass2, blockG.successors.bind(blockG));
  (_a3 = Object.values(align)) === null || _a3 === void 0 ? void 0 : _a3.forEach((v2) => {
    xs2[v2] = xs2[root2[v2]];
  });
  return xs2;
};
const buildBlockGraph = (g2, layering, root2, reverseSep) => {
  const blockGraph = new BlockGraph();
  const graphLabel = g2.graph();
  const sepFn = sep(graphLabel.nodesep, graphLabel.edgesep, reverseSep);
  layering === null || layering === void 0 ? void 0 : layering.forEach((layer) => {
    let u2;
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2) => {
      const vRoot = root2[v2];
      blockGraph.setNode(vRoot);
      if (u2) {
        const uRoot = root2[u2];
        const prevMax = blockGraph.edgeFromArgs(uRoot, vRoot);
        blockGraph.setEdge(uRoot, vRoot, Math.max(sepFn(g2, v2, u2), prevMax || 0));
      }
      u2 = v2;
    });
  });
  return blockGraph;
};
const findSmallestWidthAlignment = (g2, xss) => {
  return minBy(Object.values(xss), (xs2) => {
    var _a3;
    let max2 = Number.NEGATIVE_INFINITY;
    let min2 = Number.POSITIVE_INFINITY;
    (_a3 = Object.keys(xs2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((v2) => {
      const x2 = xs2[v2];
      const halfWidth = width(g2, v2) / 2;
      max2 = Math.max(x2 + halfWidth, max2);
      min2 = Math.min(x2 - halfWidth, min2);
    });
    return max2 - min2;
  });
};
function alignCoordinates(xss, alignTo) {
  const alignToVals = Object.values(alignTo);
  const alignToMin = min(alignToVals);
  const alignToMax = max(alignToVals);
  ["u", "d"].forEach((vert) => {
    ["l", "r"].forEach((horiz) => {
      const alignment = vert + horiz;
      const xs2 = xss[alignment];
      let delta;
      if (xs2 === alignTo)
        return;
      const xsVals = Object.values(xs2);
      delta = horiz === "l" ? alignToMin - min(xsVals) : alignToMax - max(xsVals);
      if (delta) {
        xss[alignment] = {};
        Object.keys(xs2).forEach((key) => {
          xss[alignment][key] = xs2[key] + delta;
        });
      }
    });
  });
}
const balance = (xss, align) => {
  const result = {};
  Object.keys(xss.ul).forEach((key) => {
    if (align) {
      result[key] = xss[align.toLowerCase()][key];
    } else {
      const values = Object.values(xss).map((x2) => x2[key]);
      result[key] = (values[0] + values[1]) / 2;
    }
  });
  return result;
};
const sep = (nodeSep, edgeSep, reverseSep) => {
  return (g2, v2, w2) => {
    const vLabel = g2.node(v2);
    const wLabel = g2.node(w2);
    let sum = 0;
    let delta;
    sum += vLabel.width / 2;
    if (vLabel.hasOwnProperty("labelpos")) {
      switch ((vLabel.labelpos || "").toLowerCase()) {
        case "l":
          delta = -vLabel.width / 2;
          break;
        case "r":
          delta = vLabel.width / 2;
          break;
      }
    }
    if (delta) {
      sum += reverseSep ? delta : -delta;
    }
    delta = 0;
    sum += (vLabel.dummy ? edgeSep : nodeSep) / 2;
    sum += (wLabel.dummy ? edgeSep : nodeSep) / 2;
    sum += wLabel.width / 2;
    if (wLabel.labelpos) {
      switch ((wLabel.labelpos || "").toLowerCase()) {
        case "l":
          delta = wLabel.width / 2;
          break;
        case "r":
          delta = -wLabel.width / 2;
          break;
      }
    }
    if (delta) {
      sum += reverseSep ? delta : -delta;
    }
    delta = 0;
    return sum;
  };
};
const width = (g2, v2) => g2.node(v2).width || 0;
const positionY = (g2) => {
  const layering = buildLayerMatrix(g2);
  const rankSep = g2.graph().ranksep;
  let prevY = 0;
  layering === null || layering === void 0 ? void 0 : layering.forEach((layer) => {
    const heights = layer.map((v2) => g2.node(v2).height);
    const maxHeight = Math.max(...heights, 0);
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2) => {
      g2.node(v2).y = prevY + maxHeight / 2;
    });
    prevY += maxHeight + rankSep;
  });
};
const positionX = (g2) => {
  const layering = buildLayerMatrix(g2);
  const conflicts = Object.assign(findType1Conflicts(g2, layering), findType2Conflicts(g2, layering));
  const xss = {};
  let adjustedLayering = [];
  ["u", "d"].forEach((vert) => {
    adjustedLayering = vert === "u" ? layering : Object.values(layering).reverse();
    ["l", "r"].forEach((horiz) => {
      if (horiz === "r") {
        adjustedLayering = adjustedLayering.map((inner) => Object.values(inner).reverse());
      }
      const neighborFn = (vert === "u" ? g2.predecessors : g2.successors).bind(g2);
      const align = verticalAlignment(g2, adjustedLayering, conflicts, neighborFn);
      const xs2 = horizontalCompaction(g2, adjustedLayering, align.root, align.align, horiz === "r");
      if (horiz === "r") {
        Object.keys(xs2).forEach((xsKey) => xs2[xsKey] = -xs2[xsKey]);
      }
      xss[vert + horiz] = xs2;
    });
  });
  const smallestWidth = findSmallestWidthAlignment(g2, xss);
  smallestWidth && alignCoordinates(xss, smallestWidth);
  return balance(xss, g2.graph().align);
};
const position = (g2) => {
  var _a3;
  const ng2 = asNonCompoundGraph(g2);
  positionY(ng2);
  const xs2 = positionX(ng2);
  (_a3 = Object.keys(xs2)) === null || _a3 === void 0 ? void 0 : _a3.forEach((key) => {
    ng2.node(key).x = xs2[key];
  });
};
const initDataOrder = (g2, nodeOrder) => {
  const simpleNodes = g2.nodes().filter((v2) => {
    var _a3;
    return !((_a3 = g2.children(v2)) === null || _a3 === void 0 ? void 0 : _a3.length);
  });
  const ranks = simpleNodes.map((v2) => g2.node(v2).rank);
  const maxRank2 = Math.max(...ranks);
  const layers = [];
  for (let i2 = 0; i2 < maxRank2 + 1; i2++) {
    layers[i2] = [];
  }
  nodeOrder === null || nodeOrder === void 0 ? void 0 : nodeOrder.forEach((n2) => {
    const node = g2.node(n2);
    if (!node || (node === null || node === void 0 ? void 0 : node.dummy)) {
      return;
    }
    if (!isNaN(node.rank)) {
      node.fixorder = layers[node.rank].length;
      layers[node.rank].push(n2);
    }
  });
};
const layout = (g2, opts) => {
  const time$1 = opts && opts.debugTiming ? time : notime;
  time$1("layout", () => {
    if (opts && !opts.keepNodeOrder && opts.prevGraph) {
      time$1("  inheritOrder", () => {
        inheritOrder(g2, opts.prevGraph);
      });
    }
    const layoutGraph = time$1("  buildLayoutGraph", () => {
      return buildLayoutGraph(g2);
    });
    if (!(opts && opts.edgeLabelSpace === false)) {
      time$1("  makeSpaceForEdgeLabels", () => {
        makeSpaceForEdgeLabels(layoutGraph);
      });
    }
    try {
      time$1("  runLayout", () => {
        runLayout(layoutGraph, time$1, opts);
      });
    } catch (e10) {
      if (e10.message === "Not possible to find intersection inside of the rectangle") {
        console.error("The following error may be caused by improper layer setting, please make sure your manual layer setting does not violate the graph's structure:\n", e10);
        return;
      }
      throw e10;
    }
    time$1("  updateInputGraph", () => {
      updateInputGraph(g2, layoutGraph);
    });
  });
};
const runLayout = (g2, time2, opts) => {
  time2("    removeSelfEdges", () => {
    removeSelfEdges(g2);
  });
  time2("    acyclic", () => {
    acyclic.run(g2);
  });
  time2("    nestingGraph.run", () => {
    nestingGraph.run(g2);
  });
  time2("    rank", () => {
    rank(asNonCompoundGraph(g2));
  });
  time2("    injectEdgeLabelProxies", () => {
    injectEdgeLabelProxies(g2);
  });
  time2("    removeEmptyRanks", () => {
    removeEmptyRanks(g2);
  });
  time2("    nestingGraph.cleanup", () => {
    nestingGraph.cleanup(g2);
  });
  time2("    normalizeRanks", () => {
    normalizeRanks(g2);
  });
  time2("    assignRankMinMax", () => {
    assignRankMinMax(g2);
  });
  time2("    removeEdgeLabelProxies", () => {
    removeEdgeLabelProxies(g2);
  });
  time2("    normalize.run", () => {
    normalize.run(g2);
  });
  time2("    parentDummyChains", () => {
    parentDummyChains(g2);
  });
  time2("    addBorderSegments", () => {
    addBorderSegments(g2);
  });
  if (opts && opts.keepNodeOrder) {
    time2("    initDataOrder", () => {
      initDataOrder(g2, opts.nodeOrder);
    });
  }
  time2("    order", () => {
    order(g2, opts === null || opts === void 0 ? void 0 : opts.keepNodeOrder);
  });
  time2("    insertSelfEdges", () => {
    insertSelfEdges(g2);
  });
  time2("    adjustCoordinateSystem", () => {
    coordinateSystem.adjust(g2);
  });
  time2("    position", () => {
    position(g2);
  });
  time2("    positionSelfEdges", () => {
    positionSelfEdges(g2);
  });
  time2("    removeBorderNodes", () => {
    removeBorderNodes(g2);
  });
  time2("    normalize.undo", () => {
    normalize.undo(g2);
  });
  time2("    fixupEdgeLabelCoords", () => {
    fixupEdgeLabelCoords(g2);
  });
  time2("    undoCoordinateSystem", () => {
    coordinateSystem.undo(g2);
  });
  time2("    translateGraph", () => {
    translateGraph(g2);
  });
  time2("    assignNodeIntersects", () => {
    assignNodeIntersects(g2);
  });
  time2("    reversePoints", () => {
    reversePointsForReversedEdges(g2);
  });
  time2("    acyclic.undo", () => {
    acyclic.undo(g2);
  });
};
const inheritOrder = (currG, prevG) => {
  currG.nodes().forEach((n2) => {
    const node = currG.node(n2);
    const prevNode = prevG.node(n2);
    if (prevNode !== void 0) {
      node.fixorder = prevNode._order;
      delete prevNode._order;
    } else {
      delete node.fixorder;
    }
  });
};
const updateInputGraph = (inputGraph, layoutGraph) => {
  inputGraph.nodes().forEach((v2) => {
    var _a3;
    const inputLabel = inputGraph.node(v2);
    if (inputLabel) {
      const layoutLabel = layoutGraph.node(v2);
      inputLabel.x = layoutLabel.x;
      inputLabel.y = layoutLabel.y;
      inputLabel._order = layoutLabel.order;
      inputLabel._rank = layoutLabel.rank;
      if ((_a3 = layoutGraph.children(v2)) === null || _a3 === void 0 ? void 0 : _a3.length) {
        inputLabel.width = layoutLabel.width;
        inputLabel.height = layoutLabel.height;
      }
    }
  });
  inputGraph.edges().forEach((e10) => {
    const inputLabel = inputGraph.edge(e10);
    const layoutLabel = layoutGraph.edge(e10);
    inputLabel.points = layoutLabel ? layoutLabel.points : [];
    if (layoutLabel && layoutLabel.hasOwnProperty("x")) {
      inputLabel.x = layoutLabel.x;
      inputLabel.y = layoutLabel.y;
    }
  });
  inputGraph.graph().width = layoutGraph.graph().width;
  inputGraph.graph().height = layoutGraph.graph().height;
};
const graphNumAttrs = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"];
const graphDefaults = { ranksep: 50, edgesep: 20, nodesep: 50, rankdir: "tb" };
const graphAttrs = ["acyclicer", "ranker", "rankdir", "align"];
const nodeNumAttrs = ["width", "height", "layer", "fixorder"];
const nodeDefaults = { width: 0, height: 0 };
const edgeNumAttrs = ["minlen", "weight", "width", "height", "labeloffset"];
const edgeDefaults = {
  minlen: 1,
  weight: 1,
  width: 0,
  height: 0,
  labeloffset: 10,
  labelpos: "r"
};
const edgeAttrs = ["labelpos"];
const buildLayoutGraph = (inputGraph) => {
  const g2 = new Graph({ multigraph: true, compound: true });
  const graph = canonicalize(inputGraph.graph());
  const pickedProperties = {};
  graphAttrs === null || graphAttrs === void 0 ? void 0 : graphAttrs.forEach((key) => {
    if (graph[key] !== void 0)
      pickedProperties[key] = graph[key];
  });
  g2.setGraph(Object.assign({}, graphDefaults, selectNumberAttrs(graph, graphNumAttrs), pickedProperties));
  inputGraph.nodes().forEach((v2) => {
    const node = canonicalize(inputGraph.node(v2));
    const defaultNode = Object.assign(Object.assign({}, nodeDefaults), node);
    const defaultAttrs = selectNumberAttrs(defaultNode, nodeNumAttrs);
    g2.setNode(v2, defaultAttrs);
    g2.setParent(v2, inputGraph.parent(v2));
  });
  inputGraph.edges().forEach((e10) => {
    const edge = canonicalize(inputGraph.edge(e10));
    const pickedProperties2 = {};
    edgeAttrs === null || edgeAttrs === void 0 ? void 0 : edgeAttrs.forEach((key) => {
      if (edge[key] !== void 0)
        pickedProperties2[key] = edge[key];
    });
    g2.setEdgeObj(e10, Object.assign({}, edgeDefaults, selectNumberAttrs(edge, edgeNumAttrs), pickedProperties2));
  });
  return g2;
};
const makeSpaceForEdgeLabels = (g2) => {
  const graph = g2.graph();
  if (!graph.ranksep)
    graph.ranksep = 0;
  graph.ranksep /= 2;
  g2.nodes().forEach((n2) => {
    const node = g2.node(n2);
    if (!isNaN(node.layer)) {
      if (!node.layer)
        node.layer = 0;
    }
  });
  g2.edges().forEach((e10) => {
    var _a3;
    const edge = g2.edge(e10);
    edge.minlen *= 2;
    if (((_a3 = edge.labelpos) === null || _a3 === void 0 ? void 0 : _a3.toLowerCase()) !== "c") {
      if (graph.rankdir === "TB" || graph.rankdir === "BT") {
        edge.width += edge.labeloffset;
      } else {
        edge.height += edge.labeloffset;
      }
    }
  });
};
const injectEdgeLabelProxies = (g2) => {
  g2.edges().forEach((e10) => {
    const edge = g2.edge(e10);
    if (edge.width && edge.height) {
      const v2 = g2.node(e10.v);
      const w2 = g2.node(e10.w);
      const label = {
        e: e10,
        rank: (w2.rank - v2.rank) / 2 + v2.rank
      };
      addDummyNode(g2, "edge-proxy", label, "_ep");
    }
  });
};
const assignRankMinMax = (g2) => {
  let maxRank2 = 0;
  g2.nodes().forEach((v2) => {
    var _a3, _b3;
    const node = g2.node(v2);
    if (node.borderTop) {
      node.minRank = (_a3 = g2.node(node.borderTop)) === null || _a3 === void 0 ? void 0 : _a3.rank;
      node.maxRank = (_b3 = g2.node(node.borderBottom)) === null || _b3 === void 0 ? void 0 : _b3.rank;
      maxRank2 = Math.max(maxRank2, node.maxRank || -Infinity);
    }
  });
  g2.graph().maxRank = maxRank2;
};
const removeEdgeLabelProxies = (g2) => {
  g2.nodes().forEach((v2) => {
    const node = g2.node(v2);
    if (node.dummy === "edge-proxy") {
      g2.edge(node.e).labelRank = node.rank;
      g2.removeNode(v2);
    }
  });
};
const translateGraph = (g2) => {
  let minX;
  let maxX = 0;
  let minY;
  let maxY = 0;
  const graphLabel = g2.graph();
  const marginX = graphLabel.marginx || 0;
  const marginY = graphLabel.marginy || 0;
  const getExtremes = (attrs) => {
    if (!attrs)
      return;
    const x2 = attrs.x;
    const y2 = attrs.y;
    const w2 = attrs.width;
    const h2 = attrs.height;
    if (!isNaN(x2) && !isNaN(w2)) {
      if (minX === void 0) {
        minX = x2 - w2 / 2;
      }
      minX = Math.min(minX, x2 - w2 / 2);
      maxX = Math.max(maxX, x2 + w2 / 2);
    }
    if (!isNaN(y2) && !isNaN(h2)) {
      if (minY === void 0) {
        minY = y2 - h2 / 2;
      }
      minY = Math.min(minY, y2 - h2 / 2);
      maxY = Math.max(maxY, y2 + h2 / 2);
    }
  };
  g2.nodes().forEach((v2) => {
    getExtremes(g2.node(v2));
  });
  g2.edges().forEach((e10) => {
    const edge = g2.edge(e10);
    if (edge === null || edge === void 0 ? void 0 : edge.hasOwnProperty("x")) {
      getExtremes(edge);
    }
  });
  minX -= marginX;
  minY -= marginY;
  g2.nodes().forEach((v2) => {
    const node = g2.node(v2);
    if (node) {
      node.x -= minX;
      node.y -= minY;
    }
  });
  g2.edges().forEach((e10) => {
    var _a3;
    const edge = g2.edge(e10);
    (_a3 = edge.points) === null || _a3 === void 0 ? void 0 : _a3.forEach((p2) => {
      p2.x -= minX;
      p2.y -= minY;
    });
    if (edge.hasOwnProperty("x")) {
      edge.x -= minX;
    }
    if (edge.hasOwnProperty("y")) {
      edge.y -= minY;
    }
  });
  graphLabel.width = maxX - minX + marginX;
  graphLabel.height = maxY - minY + marginY;
};
const assignNodeIntersects = (g2) => {
  g2.edges().forEach((e10) => {
    const edge = g2.edge(e10);
    const nodeV = g2.node(e10.v);
    const nodeW = g2.node(e10.w);
    let p1;
    let p2;
    if (!edge.points) {
      edge.points = [];
      p1 = nodeW;
      p2 = nodeV;
    } else {
      p1 = edge.points[0];
      p2 = edge.points[edge.points.length - 1];
    }
    edge.points.unshift(intersectRect(nodeV, p1));
    edge.points.push(intersectRect(nodeW, p2));
  });
};
const fixupEdgeLabelCoords = (g2) => {
  g2.edges().forEach((e10) => {
    const edge = g2.edge(e10);
    if (edge === null || edge === void 0 ? void 0 : edge.hasOwnProperty("x")) {
      if (edge.labelpos === "l" || edge.labelpos === "r") {
        edge.width -= edge.labeloffset;
      }
      switch (edge.labelpos) {
        case "l":
          edge.x -= edge.width / 2 + edge.labeloffset;
          break;
        case "r":
          edge.x += edge.width / 2 + edge.labeloffset;
          break;
      }
    }
  });
};
const reversePointsForReversedEdges = (g2) => {
  g2.edges().forEach((e10) => {
    var _a3;
    const edge = g2.edge(e10);
    if (edge.reversed) {
      (_a3 = edge.points) === null || _a3 === void 0 ? void 0 : _a3.reverse();
    }
  });
};
const removeBorderNodes = (g2) => {
  g2.nodes().forEach((v2) => {
    var _a3, _b3, _c3;
    if ((_a3 = g2.children(v2)) === null || _a3 === void 0 ? void 0 : _a3.length) {
      const node = g2.node(v2);
      const t2 = g2.node(node.borderTop);
      const b2 = g2.node(node.borderBottom);
      const l2 = g2.node(node.borderLeft[((_b3 = node.borderLeft) === null || _b3 === void 0 ? void 0 : _b3.length) - 1]);
      const r3 = g2.node(node.borderRight[((_c3 = node.borderRight) === null || _c3 === void 0 ? void 0 : _c3.length) - 1]);
      node.width = Math.abs((r3 === null || r3 === void 0 ? void 0 : r3.x) - (l2 === null || l2 === void 0 ? void 0 : l2.x)) || 10;
      node.height = Math.abs((b2 === null || b2 === void 0 ? void 0 : b2.y) - (t2 === null || t2 === void 0 ? void 0 : t2.y)) || 10;
      node.x = ((l2 === null || l2 === void 0 ? void 0 : l2.x) || 0) + node.width / 2;
      node.y = ((t2 === null || t2 === void 0 ? void 0 : t2.y) || 0) + node.height / 2;
    }
  });
  g2.nodes().forEach((v2) => {
    var _a3;
    if (((_a3 = g2.node(v2)) === null || _a3 === void 0 ? void 0 : _a3.dummy) === "border") {
      g2.removeNode(v2);
    }
  });
};
const removeSelfEdges = (g2) => {
  g2.edges().forEach((e10) => {
    if (e10.v === e10.w) {
      const node = g2.node(e10.v);
      if (!node.selfEdges) {
        node.selfEdges = [];
      }
      node.selfEdges.push({ e: e10, label: g2.edge(e10) });
      g2.removeEdgeObj(e10);
    }
  });
};
const insertSelfEdges = (g2) => {
  const layers = buildLayerMatrix(g2);
  layers === null || layers === void 0 ? void 0 : layers.forEach((layer) => {
    let orderShift = 0;
    layer === null || layer === void 0 ? void 0 : layer.forEach((v2, i2) => {
      var _a3;
      const node = g2.node(v2);
      node.order = i2 + orderShift;
      (_a3 = node.selfEdges) === null || _a3 === void 0 ? void 0 : _a3.forEach((selfEdge) => {
        addDummyNode(g2, "selfedge", {
          width: selfEdge.label.width,
          height: selfEdge.label.height,
          rank: node.rank,
          order: i2 + ++orderShift,
          e: selfEdge.e,
          label: selfEdge.label
        }, "_se");
      });
      delete node.selfEdges;
    });
  });
};
const positionSelfEdges = (g2) => {
  g2.nodes().forEach((v2) => {
    const node = g2.node(v2);
    if (node.dummy === "selfedge") {
      const selfNode = g2.node(node.e.v);
      const x2 = selfNode.x + selfNode.width / 2;
      const y2 = selfNode.y;
      const dx2 = node.x - x2;
      const dy2 = selfNode.height / 2;
      g2.setEdgeObj(node.e, node.label);
      g2.removeNode(v2);
      node.label.points = [
        { x: x2 + 2 * dx2 / 3, y: y2 - dy2 },
        { x: x2 + 5 * dx2 / 6, y: y2 - dy2 },
        { y: y2, x: x2 + dx2 },
        { x: x2 + 5 * dx2 / 6, y: y2 + dy2 },
        { x: x2 + 2 * dx2 / 3, y: y2 + dy2 }
      ];
      node.label.x = node.x;
      node.label.y = node.y;
    }
  });
};
const selectNumberAttrs = (obj, attrs) => {
  const pickedProperties = {};
  attrs === null || attrs === void 0 ? void 0 : attrs.forEach((key) => {
    if (obj[key] === void 0)
      return;
    pickedProperties[key] = +obj[key];
  });
  return pickedProperties;
};
const canonicalize = (attrs = {}) => {
  const newAttrs = {};
  Object.keys(attrs).forEach((k2) => {
    newAttrs[k2.toLowerCase()] = attrs[k2];
  });
  return newAttrs;
};
const dagre = {
  layout,
  util: {
    time,
    notime
  }
};
class DagreLayout extends Base {
  constructor(options) {
    super();
    this.rankdir = "TB";
    this.nodesep = 50;
    this.ranksep = 50;
    this.controlPoints = false;
    this.sortByCombo = false;
    this.edgeLabelSpace = true;
    this.radial = false;
    this.nodes = [];
    this.edges = [];
    this.onLayoutEnd = () => {
    };
    this.layoutNode = (nodeId) => {
      const self2 = this;
      const { nodes } = self2;
      const node = nodes.find((node2) => node2.id === nodeId);
      if (node) {
        const layout2 = node.layout !== false;
        return layout2;
      }
      return true;
    };
    this.updateCfg(options);
  }
  getDefaultCfg() {
    return {
      rankdir: "TB",
      align: void 0,
      nodeSize: void 0,
      nodesepFunc: void 0,
      ranksepFunc: void 0,
      nodesep: 50,
      ranksep: 50,
      controlPoints: false,
      radial: false,
      focusNode: null
      // radial 为 true 时生效，关注的节点
    };
  }
  /**
   * 执行布局
   */
  execute() {
    var _a3, _b3, _c3, _d3;
    const self2 = this;
    const { nodes, nodeSize, rankdir, combos, begin, radial, comboEdges = [], vedges = [] } = self2;
    if (!nodes)
      return;
    const edges = self2.edges || [];
    const g2 = new Graph({
      multigraph: true,
      compound: true
    });
    self2.nodeMap = {};
    const nodeComboMap = {};
    nodes.forEach((node) => {
      self2.nodeMap[node.id] = node;
      if (!node.comboId)
        return;
      nodeComboMap[node.comboId] = nodeComboMap[node.comboId] || [];
      nodeComboMap[node.comboId].push(node.id);
    });
    let sortedNodes = [];
    const visitedMap = {};
    if ((_a3 = self2.nodeOrder) === null || _a3 === void 0 ? void 0 : _a3.length) {
      self2.nodeOrder.forEach((id2) => {
        visitedMap[id2] = true;
        sortedNodes.push(self2.nodeMap[id2]);
      });
      nodes.forEach((node) => {
        if (!visitedMap[node.id])
          sortedNodes.push(node);
      });
    } else {
      sortedNodes = nodes;
    }
    let nodeSizeFunc;
    if (!nodeSize) {
      nodeSizeFunc = (d2) => {
        if (d2.size) {
          if (isArray$1(d2.size)) {
            return d2.size;
          }
          if (isObject(d2.size)) {
            return [d2.size.width || 40, d2.size.height || 40];
          }
          return [d2.size, d2.size];
        }
        return [40, 40];
      };
    } else if (isArray$1(nodeSize)) {
      nodeSizeFunc = () => nodeSize;
    } else {
      nodeSizeFunc = () => [nodeSize, nodeSize];
    }
    const ranksepfunc = getFunc(self2.ranksep, 50, self2.ranksepFunc);
    const nodesepfunc = getFunc(self2.nodesep, 50, self2.nodesepFunc);
    let horisep = nodesepfunc;
    let vertisep = ranksepfunc;
    if (rankdir === "LR" || rankdir === "RL") {
      horisep = ranksepfunc;
      vertisep = nodesepfunc;
    }
    g2.setDefaultEdgeLabel(() => ({}));
    g2.setGraph(self2);
    const comboMap = {};
    if (this.sortByCombo && combos) {
      combos.forEach((combo) => {
        comboMap[combo.id] = combo;
        if (combo.collapsed) {
          const size = nodeSizeFunc(combo);
          const verti = vertisep(combo);
          const hori = horisep(combo);
          const width2 = size[0] + 2 * hori;
          const height = size[1] + 2 * verti;
          g2.setNode(combo.id, { width: width2, height });
        }
        if (!combo.parentId)
          return;
        if (!comboMap[combo.parentId]) {
          g2.setNode(combo.parentId, {});
        }
        g2.setParent(combo.id, combo.parentId);
      });
    }
    sortedNodes.filter((node) => node.layout !== false).forEach((node) => {
      const size = nodeSizeFunc(node);
      const verti = vertisep(node);
      const hori = horisep(node);
      const width2 = size[0] + 2 * hori;
      const height = size[1] + 2 * verti;
      const layer = node.layer;
      if (isNumber(layer)) {
        g2.setNode(node.id, { width: width2, height, layer });
      } else {
        g2.setNode(node.id, { width: width2, height });
      }
      if (this.sortByCombo && node.comboId) {
        if (!comboMap[node.comboId]) {
          comboMap[node.comboId] = { id: node.comboId };
          g2.setNode(node.comboId, {});
        }
        g2.setParent(node.id, node.comboId);
      }
    });
    edges.forEach((edge) => {
      const source = getEdgeTerminal(edge, "source");
      const target = getEdgeTerminal(edge, "target");
      if (this.layoutNode(source) && this.layoutNode(target)) {
        g2.setEdge(source, target, {
          weight: edge.weight || 1
        });
      }
    });
    (_b3 = comboEdges === null || comboEdges === void 0 ? void 0 : comboEdges.concat(vedges || [])) === null || _b3 === void 0 ? void 0 : _b3.forEach((comboEdge) => {
      var _a4, _b4;
      const { source, target } = comboEdge;
      const sources = ((_a4 = comboMap[source]) === null || _a4 === void 0 ? void 0 : _a4.collapsed) ? [source] : nodeComboMap[source] || [source];
      const targets = ((_b4 = comboMap[target]) === null || _b4 === void 0 ? void 0 : _b4.collapsed) ? [target] : nodeComboMap[target] || [target];
      sources.forEach((s2) => {
        targets.forEach((t2) => {
          g2.setEdge(s2, t2, {
            weight: comboEdge.weight || 1
          });
        });
      });
    });
    let prevGraph = void 0;
    if ((_c3 = self2.preset) === null || _c3 === void 0 ? void 0 : _c3.nodes) {
      prevGraph = new Graph({
        multigraph: true,
        compound: true
      });
      self2.preset.nodes.forEach((node) => {
        prevGraph === null || prevGraph === void 0 ? void 0 : prevGraph.setNode(node.id, node);
      });
    }
    dagre.layout(g2, {
      prevGraph,
      edgeLabelSpace: self2.edgeLabelSpace,
      keepNodeOrder: Boolean(!!self2.nodeOrder),
      nodeOrder: self2.nodeOrder
    });
    const dBegin = [0, 0];
    if (begin) {
      let minX = Infinity;
      let minY = Infinity;
      g2.nodes().forEach((node) => {
        const coord = g2.node(node);
        if (minX > coord.x)
          minX = coord.x;
        if (minY > coord.y)
          minY = coord.y;
      });
      g2.edges().forEach((edge) => {
        var _a4;
        const coord = g2.edge(edge);
        (_a4 = coord.points) === null || _a4 === void 0 ? void 0 : _a4.forEach((point) => {
          if (minX > point.x)
            minX = point.x;
          if (minY > point.y)
            minY = point.y;
        });
      });
      dBegin[0] = begin[0] - minX;
      dBegin[1] = begin[1] - minY;
    }
    const isHorizontal = rankdir === "LR" || rankdir === "RL";
    if (radial) {
      const { focusNode, ranksep, getRadialPos } = this;
      const focusId = isString(focusNode) ? focusNode : focusNode === null || focusNode === void 0 ? void 0 : focusNode.id;
      const focusLayer = focusId ? (_d3 = g2.node(focusId)) === null || _d3 === void 0 ? void 0 : _d3._rank : 0;
      const layers = [];
      const dim = isHorizontal ? "y" : "x";
      const sizeDim = isHorizontal ? "height" : "width";
      let min2 = Infinity;
      let max2 = -Infinity;
      g2.nodes().forEach((node) => {
        const coord = g2.node(node);
        if (!self2.nodeMap[node])
          return;
        const currentNodesep = nodesepfunc(self2.nodeMap[node]);
        if (focusLayer === 0) {
          if (!layers[coord._rank]) {
            layers[coord._rank] = {
              nodes: [],
              totalWidth: 0,
              maxSize: -Infinity
            };
          }
          layers[coord._rank].nodes.push(node);
          layers[coord._rank].totalWidth += currentNodesep * 2 + coord[sizeDim];
          if (layers[coord._rank].maxSize < Math.max(coord.width, coord.height)) {
            layers[coord._rank].maxSize = Math.max(coord.width, coord.height);
          }
        } else {
          const diffLayer = coord._rank - focusLayer;
          if (diffLayer === 0) {
            if (!layers[diffLayer]) {
              layers[diffLayer] = {
                nodes: [],
                totalWidth: 0,
                maxSize: -Infinity
              };
            }
            layers[diffLayer].nodes.push(node);
            layers[diffLayer].totalWidth += currentNodesep * 2 + coord[sizeDim];
            if (layers[diffLayer].maxSize < Math.max(coord.width, coord.height)) {
              layers[diffLayer].maxSize = Math.max(coord.width, coord.height);
            }
          } else {
            const diffLayerAbs = Math.abs(diffLayer);
            if (!layers[diffLayerAbs]) {
              layers[diffLayerAbs] = {
                left: [],
                right: [],
                totalWidth: 0,
                maxSize: -Infinity
              };
            }
            layers[diffLayerAbs].totalWidth += currentNodesep * 2 + coord[sizeDim];
            if (layers[diffLayerAbs].maxSize < Math.max(coord.width, coord.height)) {
              layers[diffLayerAbs].maxSize = Math.max(coord.width, coord.height);
            }
            if (diffLayer < 0) {
              layers[diffLayerAbs].left.push(node);
            } else {
              layers[diffLayerAbs].right.push(node);
            }
          }
        }
        const leftPos = coord[dim] - coord[sizeDim] / 2 - currentNodesep;
        const rightPos = coord[dim] + coord[sizeDim] / 2 + currentNodesep;
        if (leftPos < min2)
          min2 = leftPos;
        if (rightPos > max2)
          max2 = rightPos;
      });
      let radius = ranksep || 50;
      const radiusMap = {};
      const rangeLength = (max2 - min2) / 0.9;
      const range3 = [
        (min2 + max2 - rangeLength) * 0.5,
        (min2 + max2 + rangeLength) * 0.5
      ];
      const processNodes = (layerNodes, radius2, propsMaxRanksep = -Infinity, arcRange = [0, 1]) => {
        let maxRanksep = propsMaxRanksep;
        layerNodes.forEach((node) => {
          const coord = g2.node(node);
          radiusMap[node] = radius2;
          const { x: newX, y: newY } = getRadialPos(coord[dim], range3, rangeLength, radius2, arcRange);
          if (!self2.nodeMap[node])
            return;
          self2.nodeMap[node].x = newX + dBegin[0];
          self2.nodeMap[node].y = newY + dBegin[1];
          self2.nodeMap[node]._order = coord._order;
          const currentNodeRanksep = ranksepfunc(self2.nodeMap[node]);
          if (maxRanksep < currentNodeRanksep)
            maxRanksep = currentNodeRanksep;
        });
        return maxRanksep;
      };
      let isFirstLevel = true;
      const lastLayerMaxNodeSize = 0;
      layers.forEach((layerNodes) => {
        var _a4, _b4, _c4, _d4, _e3, _f3, _g3;
        if (!((_a4 = layerNodes === null || layerNodes === void 0 ? void 0 : layerNodes.nodes) === null || _a4 === void 0 ? void 0 : _a4.length) && !((_b4 = layerNodes === null || layerNodes === void 0 ? void 0 : layerNodes.left) === null || _b4 === void 0 ? void 0 : _b4.length) && !((_c4 = layerNodes === null || layerNodes === void 0 ? void 0 : layerNodes.right) === null || _c4 === void 0 ? void 0 : _c4.length)) {
          return;
        }
        if (isFirstLevel && layerNodes.nodes.length === 1) {
          const nodeId = layerNodes.nodes[0];
          if (!self2.nodeMap[nodeId])
            return;
          self2.nodeMap[nodeId].x = dBegin[0];
          self2.nodeMap[nodeId].y = dBegin[1];
          radiusMap[layerNodes.nodes[0]] = 0;
          radius = ranksepfunc(self2.nodeMap[nodeId]);
          isFirstLevel = false;
          return;
        }
        radius = Math.max(radius, layerNodes.totalWidth / (2 * Math.PI));
        let maxRanksep = -Infinity;
        if (focusLayer === 0 || ((_d4 = layerNodes.nodes) === null || _d4 === void 0 ? void 0 : _d4.length)) {
          maxRanksep = processNodes(layerNodes.nodes, radius, maxRanksep, [0, 1]);
        } else {
          const leftRatio = ((_e3 = layerNodes.left) === null || _e3 === void 0 ? void 0 : _e3.length) / (((_f3 = layerNodes.left) === null || _f3 === void 0 ? void 0 : _f3.length) + ((_g3 = layerNodes.right) === null || _g3 === void 0 ? void 0 : _g3.length));
          maxRanksep = processNodes(layerNodes.left, radius, maxRanksep, [
            0,
            leftRatio
          ]);
          maxRanksep = processNodes(layerNodes.right, radius, maxRanksep, [
            leftRatio + 0.05,
            1
          ]);
        }
        radius += maxRanksep;
        isFirstLevel = false;
        lastLayerMaxNodeSize - layerNodes.maxSize;
      });
      g2.edges().forEach((edge) => {
        var _a4, _b4, _c4;
        const coord = g2.edge(edge);
        const i2 = edges.findIndex((it2) => {
          const source = getEdgeTerminal(it2, "source");
          const target = getEdgeTerminal(it2, "target");
          return source === edge.v && target === edge.w;
        });
        if (i2 <= -1)
          return;
        if (self2.edgeLabelSpace && self2.controlPoints && edges[i2].type !== "loop") {
          const otherDim = dim === "x" ? "y" : "x";
          const controlPoints = (_a4 = coord === null || coord === void 0 ? void 0 : coord.points) === null || _a4 === void 0 ? void 0 : _a4.slice(1, coord.points.length - 1);
          const newControlPoints = [];
          const sourceOtherDimValue = (_b4 = g2.node(edge.v)) === null || _b4 === void 0 ? void 0 : _b4[otherDim];
          const otherDimDist = sourceOtherDimValue - ((_c4 = g2.node(edge.w)) === null || _c4 === void 0 ? void 0 : _c4[otherDim]);
          const sourceRadius = radiusMap[edge.v];
          const radiusDist = sourceRadius - radiusMap[edge.w];
          controlPoints === null || controlPoints === void 0 ? void 0 : controlPoints.forEach((point) => {
            const cRadius = (point[otherDim] - sourceOtherDimValue) / otherDimDist * radiusDist + sourceRadius;
            const newPos = getRadialPos(point[dim], range3, rangeLength, cRadius);
            newControlPoints.push({
              x: newPos.x + dBegin[0],
              y: newPos.y + dBegin[1]
            });
          });
          edges[i2].controlPoints = newControlPoints;
        }
      });
    } else {
      const layerCoords = /* @__PURE__ */ new Set();
      const isInvert = rankdir === "BT" || rankdir === "RL";
      const layerCoordSort = isInvert ? (a2, b2) => b2 - a2 : (a2, b2) => a2 - b2;
      g2.nodes().forEach((node) => {
        const coord = g2.node(node);
        if (!coord)
          return;
        let ndata = this.nodeMap[node];
        if (!ndata) {
          ndata = combos === null || combos === void 0 ? void 0 : combos.find((it2) => it2.id === node);
        }
        if (!ndata)
          return;
        ndata.x = coord.x + dBegin[0];
        ndata.y = coord.y + dBegin[1];
        ndata._order = coord._order;
        layerCoords.add(isHorizontal ? ndata.x : ndata.y);
      });
      const layerCoordsArr = Array.from(layerCoords).sort(layerCoordSort);
      const isDifferentLayer = isHorizontal ? (point1, point2) => point1.x !== point2.x : (point1, point2) => point1.y !== point2.y;
      const filterControlPointsOutOfBoundary = isHorizontal ? (ps2, point1, point2) => {
        const max2 = Math.max(point1.y, point2.y);
        const min2 = Math.min(point1.y, point2.y);
        return ps2.filter((point) => point.y <= max2 && point.y >= min2);
      } : (ps2, point1, point2) => {
        const max2 = Math.max(point1.x, point2.x);
        const min2 = Math.min(point1.x, point2.x);
        return ps2.filter((point) => point.x <= max2 && point.x >= min2);
      };
      g2.edges().forEach((edge) => {
        var _a4;
        const coord = g2.edge(edge);
        const i2 = edges.findIndex((it2) => {
          const source = getEdgeTerminal(it2, "source");
          const target = getEdgeTerminal(it2, "target");
          return source === edge.v && target === edge.w;
        });
        if (i2 <= -1)
          return;
        if (self2.edgeLabelSpace && self2.controlPoints && edges[i2].type !== "loop") {
          (_a4 = coord === null || coord === void 0 ? void 0 : coord.points) === null || _a4 === void 0 ? void 0 : _a4.forEach((point) => {
            point.x += dBegin[0];
            point.y += dBegin[1];
          });
          const sourceNode = self2.nodeMap[edge.v];
          const targetNode = self2.nodeMap[edge.w];
          edges[i2].controlPoints = getControlPoints(coord === null || coord === void 0 ? void 0 : coord.points, sourceNode, targetNode, layerCoordsArr, isHorizontal, isDifferentLayer, filterControlPointsOutOfBoundary);
        }
      });
    }
    if (self2.onLayoutEnd)
      self2.onLayoutEnd();
    return {
      nodes,
      edges
    };
  }
  getRadialPos(dimValue, range3, rangeLength, radius, arcRange = [0, 1]) {
    let dimRatio = (dimValue - range3[0]) / rangeLength;
    dimRatio = dimRatio * (arcRange[1] - arcRange[0]) + arcRange[0];
    const angle = dimRatio * 2 * Math.PI;
    return {
      x: Math.cos(angle) * radius,
      y: Math.sin(angle) * radius
    };
  }
  getType() {
    return "dagre";
  }
}
const getControlPoints = (points, sourceNode, targetNode, layerCoordsArr, isHorizontal, isDifferentLayer, filterControlPointsOutOfBoundary) => {
  let controlPoints = (points === null || points === void 0 ? void 0 : points.slice(1, points.length - 1)) || [];
  if (sourceNode && targetNode) {
    let { x: sourceX, y: sourceY } = sourceNode;
    let { x: targetX, y: targetY } = targetNode;
    if (isHorizontal) {
      sourceX = sourceNode.y;
      sourceY = sourceNode.x;
      targetX = targetNode.y;
      targetY = targetNode.x;
    }
    if (targetY !== sourceY && sourceX !== targetX) {
      const sourceLayer = layerCoordsArr.indexOf(sourceY);
      const sourceNextLayerCoord = layerCoordsArr[sourceLayer + 1];
      if (sourceNextLayerCoord) {
        const firstControlPoint = controlPoints[0];
        const insertStartControlPoint = isHorizontal ? {
          x: (sourceY + sourceNextLayerCoord) / 2,
          y: (firstControlPoint === null || firstControlPoint === void 0 ? void 0 : firstControlPoint.y) || targetX
        } : {
          x: (firstControlPoint === null || firstControlPoint === void 0 ? void 0 : firstControlPoint.x) || targetX,
          y: (sourceY + sourceNextLayerCoord) / 2
        };
        if (!firstControlPoint || isDifferentLayer(firstControlPoint, insertStartControlPoint)) {
          controlPoints.unshift(insertStartControlPoint);
        }
      }
      const targetLayer = layerCoordsArr.indexOf(targetY);
      const layerDiff = Math.abs(targetLayer - sourceLayer);
      if (layerDiff === 1) {
        controlPoints = filterControlPointsOutOfBoundary(controlPoints, sourceNode, targetNode);
        if (!controlPoints.length) {
          controlPoints.push(isHorizontal ? {
            x: (sourceY + targetY) / 2,
            y: sourceX
          } : {
            x: sourceX,
            y: (sourceY + targetY) / 2
          });
        }
      } else if (layerDiff > 1) {
        const targetLastLayerCoord = layerCoordsArr[targetLayer - 1];
        if (targetLastLayerCoord) {
          const lastControlPoints = controlPoints[controlPoints.length - 1];
          const insertEndControlPoint = isHorizontal ? {
            x: (targetY + targetLastLayerCoord) / 2,
            y: (lastControlPoints === null || lastControlPoints === void 0 ? void 0 : lastControlPoints.y) || targetX
          } : {
            x: (lastControlPoints === null || lastControlPoints === void 0 ? void 0 : lastControlPoints.x) || sourceX,
            y: (targetY + targetLastLayerCoord) / 2
          };
          if (!lastControlPoints || isDifferentLayer(lastControlPoints, insertEndControlPoint)) {
            controlPoints.push(insertEndControlPoint);
          }
        }
      }
    }
  }
  return controlPoints;
};
var i$1, a$1, u$1, c$1;
!function(e10) {
  e10[e10.META = 0] = "META", e10[e10.NODE = 1] = "NODE", e10[e10.BRIDGE = 2] = "BRIDGE";
}(i$1 || (i$1 = {})), function(e10) {
  e10[e10.INCLUDE = 0] = "INCLUDE", e10[e10.EXCLUDE = 1] = "EXCLUDE", e10[e10.UNSPECIFIED = 2] = "UNSPECIFIED";
}(a$1 || (a$1 = {})), function(e10) {
  e10[e10.META = 0] = "META", e10[e10.CORE = 1] = "CORE", e10[e10.BRIDGE = 2] = "BRIDGE";
}(u$1 || (u$1 = {})), function(e10) {
  e10[e10.META = 0] = "META", e10[e10.OP = 1] = "OP", e10[e10.SERIES = 2] = "SERIES";
}(c$1 || (c$1 = {}));
var s$1 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function d$1(e10, n2) {
  return e10(n2 = { exports: {} }, n2.exports), n2.exports;
}
var f$1 = function() {
  this.__data__ = [], this.size = 0;
};
var h$1 = function(e10, n2) {
  return e10 === n2 || e10 != e10 && n2 != n2;
};
var l$1 = function(e10, n2) {
  for (var t2 = e10.length; t2--; ) if (h$1(e10[t2][0], n2)) return t2;
  return -1;
}, v$1 = Array.prototype.splice;
var p$1 = function(e10) {
  var n2 = this.__data__, t2 = l$1(n2, e10);
  return !(t2 < 0) && (t2 == n2.length - 1 ? n2.pop() : v$1.call(n2, t2, 1), --this.size, true);
};
var g$1 = function(e10) {
  var n2 = this.__data__, t2 = l$1(n2, e10);
  return t2 < 0 ? void 0 : n2[t2][1];
};
var y$1 = function(e10) {
  return l$1(this.__data__, e10) > -1;
};
var b$1 = function(e10, n2) {
  var t2 = this.__data__, r3 = l$1(t2, e10);
  return r3 < 0 ? (++this.size, t2.push([e10, n2])) : t2[r3][1] = n2, this;
};
function m$1(e10) {
  var n2 = -1, t2 = null == e10 ? 0 : e10.length;
  for (this.clear(); ++n2 < t2; ) {
    var r3 = e10[n2];
    this.set(r3[0], r3[1]);
  }
}
m$1.prototype.clear = f$1, m$1.prototype.delete = p$1, m$1.prototype.get = g$1, m$1.prototype.has = y$1, m$1.prototype.set = b$1;
var w$1 = m$1;
var E$1 = function() {
  this.__data__ = new w$1(), this.size = 0;
};
var _$1 = function(e10) {
  var n2 = this.__data__, t2 = n2.delete(e10);
  return this.size = n2.size, t2;
};
var j$1 = function(e10) {
  return this.__data__.get(e10);
};
var x$1 = function(e10) {
  return this.__data__.has(e10);
}, N$1 = "object" == typeof s$1 && s$1 && s$1.Object === Object && s$1, O$1 = "object" == typeof self && self && self.Object === Object && self, k$1 = N$1 || O$1 || Function("return this")(), I$1 = k$1.Symbol, S$1 = Object.prototype, M$1 = S$1.hasOwnProperty, C$1 = S$1.toString, G$1 = I$1 ? I$1.toStringTag : void 0;
var B$1 = function(e10) {
  var n2 = M$1.call(e10, G$1), t2 = e10[G$1];
  try {
    e10[G$1] = void 0;
    var r3 = true;
  } catch (e11) {
  }
  var o2 = C$1.call(e10);
  return r3 && (n2 ? e10[G$1] = t2 : delete e10[G$1]), o2;
}, A$1 = Object.prototype.toString;
var L$1 = function(e10) {
  return A$1.call(e10);
}, R$1 = I$1 ? I$1.toStringTag : void 0;
var T$1 = function(e10) {
  return null == e10 ? void 0 === e10 ? "[object Undefined]" : "[object Null]" : R$1 && R$1 in Object(e10) ? B$1(e10) : L$1(e10);
};
var D$1 = function(e10) {
  var n2 = typeof e10;
  return null != e10 && ("object" == n2 || "function" == n2);
};
var P$1, z$1 = function(e10) {
  if (!D$1(e10)) return false;
  var n2 = T$1(e10);
  return "[object Function]" == n2 || "[object GeneratorFunction]" == n2 || "[object AsyncFunction]" == n2 || "[object Proxy]" == n2;
}, F$1 = k$1["__core-js_shared__"], U$1 = (P$1 = /[^.]+$/.exec(F$1 && F$1.keys && F$1.keys.IE_PROTO || "")) ? "Symbol(src)_1." + P$1 : "";
var V$1 = function(e10) {
  return !!U$1 && U$1 in e10;
}, $$1 = Function.prototype.toString;
var H$1 = function(e10) {
  if (null != e10) {
    try {
      return $$1.call(e10);
    } catch (e11) {
    }
    try {
      return e10 + "";
    } catch (e11) {
    }
  }
  return "";
}, W$1 = /^\[object .+?Constructor\]$/, q$1 = Function.prototype, Y$1 = Object.prototype, J$1 = q$1.toString, X$1 = Y$1.hasOwnProperty, K$1 = RegExp("^" + J$1.call(X$1).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var Q$1 = function(e10) {
  return !(!D$1(e10) || V$1(e10)) && (z$1(e10) ? K$1 : W$1).test(H$1(e10));
};
var Z$1 = function(e10, n2) {
  return null == e10 ? void 0 : e10[n2];
};
var ee$1 = function(e10, n2) {
  var t2 = Z$1(e10, n2);
  return Q$1(t2) ? t2 : void 0;
}, ne$1 = ee$1(k$1, "Map"), te$1 = ee$1(Object, "create");
var re$1 = function() {
  this.__data__ = te$1 ? te$1(null) : {}, this.size = 0;
};
var oe$1 = function(e10) {
  var n2 = this.has(e10) && delete this.__data__[e10];
  return this.size -= n2 ? 1 : 0, n2;
}, ie$1 = Object.prototype.hasOwnProperty;
var ae$1 = function(e10) {
  var n2 = this.__data__;
  if (te$1) {
    var t2 = n2[e10];
    return "__lodash_hash_undefined__" === t2 ? void 0 : t2;
  }
  return ie$1.call(n2, e10) ? n2[e10] : void 0;
}, ue$1 = Object.prototype.hasOwnProperty;
var ce$1 = function(e10) {
  var n2 = this.__data__;
  return te$1 ? void 0 !== n2[e10] : ue$1.call(n2, e10);
};
var se$1 = function(e10, n2) {
  var t2 = this.__data__;
  return this.size += this.has(e10) ? 0 : 1, t2[e10] = te$1 && void 0 === n2 ? "__lodash_hash_undefined__" : n2, this;
};
function de$1(e10) {
  var n2 = -1, t2 = null == e10 ? 0 : e10.length;
  for (this.clear(); ++n2 < t2; ) {
    var r3 = e10[n2];
    this.set(r3[0], r3[1]);
  }
}
de$1.prototype.clear = re$1, de$1.prototype.delete = oe$1, de$1.prototype.get = ae$1, de$1.prototype.has = ce$1, de$1.prototype.set = se$1;
var fe$1 = de$1;
var he$1 = function() {
  this.size = 0, this.__data__ = { hash: new fe$1(), map: new (ne$1 || w$1)(), string: new fe$1() };
};
var le$1 = function(e10) {
  var n2 = typeof e10;
  return "string" == n2 || "number" == n2 || "symbol" == n2 || "boolean" == n2 ? "__proto__" !== e10 : null === e10;
};
var ve$1 = function(e10, n2) {
  var t2 = e10.__data__;
  return le$1(n2) ? t2["string" == typeof n2 ? "string" : "hash"] : t2.map;
};
var pe$1 = function(e10) {
  var n2 = ve$1(this, e10).delete(e10);
  return this.size -= n2 ? 1 : 0, n2;
};
var ge$1 = function(e10) {
  return ve$1(this, e10).get(e10);
};
var ye$1 = function(e10) {
  return ve$1(this, e10).has(e10);
};
var be$1 = function(e10, n2) {
  var t2 = ve$1(this, e10), r3 = t2.size;
  return t2.set(e10, n2), this.size += t2.size == r3 ? 0 : 1, this;
};
function me$1(e10) {
  var n2 = -1, t2 = null == e10 ? 0 : e10.length;
  for (this.clear(); ++n2 < t2; ) {
    var r3 = e10[n2];
    this.set(r3[0], r3[1]);
  }
}
me$1.prototype.clear = he$1, me$1.prototype.delete = pe$1, me$1.prototype.get = ge$1, me$1.prototype.has = ye$1, me$1.prototype.set = be$1;
var we$1 = me$1;
var Ee$1 = function(e10, n2) {
  var t2 = this.__data__;
  if (t2 instanceof w$1) {
    var r3 = t2.__data__;
    if (!ne$1 || r3.length < 199) return r3.push([e10, n2]), this.size = ++t2.size, this;
    t2 = this.__data__ = new we$1(r3);
  }
  return t2.set(e10, n2), this.size = t2.size, this;
};
function _e$1(e10) {
  var n2 = this.__data__ = new w$1(e10);
  this.size = n2.size;
}
_e$1.prototype.clear = E$1, _e$1.prototype.delete = _$1, _e$1.prototype.get = j$1, _e$1.prototype.has = x$1, _e$1.prototype.set = Ee$1;
var je$1 = _e$1;
var xe$1 = function(e10, n2) {
  for (var t2 = -1, r3 = null == e10 ? 0 : e10.length; ++t2 < r3 && false !== n2(e10[t2], t2, e10); ) ;
  return e10;
}, Ne$1 = function() {
  try {
    var e10 = ee$1(Object, "defineProperty");
    return e10({}, "", {}), e10;
  } catch (e11) {
  }
}();
var Oe$1 = function(e10, n2, t2) {
  "__proto__" == n2 && Ne$1 ? Ne$1(e10, n2, { configurable: true, enumerable: true, value: t2, writable: true }) : e10[n2] = t2;
}, ke$1 = Object.prototype.hasOwnProperty;
var Ie$1 = function(e10, n2, t2) {
  var r3 = e10[n2];
  ke$1.call(e10, n2) && h$1(r3, t2) && (void 0 !== t2 || n2 in e10) || Oe$1(e10, n2, t2);
};
var Se$1 = function(e10, n2, t2, r3) {
  var o2 = !t2;
  t2 || (t2 = {});
  for (var i2 = -1, a2 = n2.length; ++i2 < a2; ) {
    var u2 = n2[i2], c3 = void 0;
    void 0 === c3 && (c3 = e10[u2]), o2 ? Oe$1(t2, u2, c3) : Ie$1(t2, u2, c3);
  }
  return t2;
};
var Me$1 = function(e10, n2) {
  for (var t2 = -1, r3 = Array(e10); ++t2 < e10; ) r3[t2] = n2(t2);
  return r3;
};
var Ce$1 = function(e10) {
  return null != e10 && "object" == typeof e10;
};
var Ge$1 = function(e10) {
  return Ce$1(e10) && "[object Arguments]" == T$1(e10);
}, Be$1 = Object.prototype, Ae$1 = Be$1.hasOwnProperty, Le$1 = Be$1.propertyIsEnumerable, Re$1 = Ge$1(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ge$1 : function(e10) {
  return Ce$1(e10) && Ae$1.call(e10, "callee") && !Le$1.call(e10, "callee");
}, Te$1 = Array.isArray;
var De$1 = function() {
  return false;
}, Pe$1 = d$1(function(e10, n2) {
  var t2 = n2 && !n2.nodeType && n2, r3 = t2 && e10 && !e10.nodeType && e10, o2 = r3 && r3.exports === t2 ? k$1.Buffer : void 0, i2 = (o2 ? o2.isBuffer : void 0) || De$1;
  e10.exports = i2;
}), ze$1 = /^(?:0|[1-9]\d*)$/;
var Fe$1 = function(e10, n2) {
  var t2 = typeof e10;
  return !!(n2 = null == n2 ? 9007199254740991 : n2) && ("number" == t2 || "symbol" != t2 && ze$1.test(e10)) && e10 > -1 && e10 % 1 == 0 && e10 < n2;
};
var Ue$1 = function(e10) {
  return "number" == typeof e10 && e10 > -1 && e10 % 1 == 0 && e10 <= 9007199254740991;
}, Ve$1 = {};
Ve$1["[object Float32Array]"] = Ve$1["[object Float64Array]"] = Ve$1["[object Int8Array]"] = Ve$1["[object Int16Array]"] = Ve$1["[object Int32Array]"] = Ve$1["[object Uint8Array]"] = Ve$1["[object Uint8ClampedArray]"] = Ve$1["[object Uint16Array]"] = Ve$1["[object Uint32Array]"] = true, Ve$1["[object Arguments]"] = Ve$1["[object Array]"] = Ve$1["[object ArrayBuffer]"] = Ve$1["[object Boolean]"] = Ve$1["[object DataView]"] = Ve$1["[object Date]"] = Ve$1["[object Error]"] = Ve$1["[object Function]"] = Ve$1["[object Map]"] = Ve$1["[object Number]"] = Ve$1["[object Object]"] = Ve$1["[object RegExp]"] = Ve$1["[object Set]"] = Ve$1["[object String]"] = Ve$1["[object WeakMap]"] = false;
var $e$1 = function(e10) {
  return Ce$1(e10) && Ue$1(e10.length) && !!Ve$1[T$1(e10)];
};
var He$1 = function(e10) {
  return function(n2) {
    return e10(n2);
  };
}, We$1 = d$1(function(e10, n2) {
  var t2 = n2 && !n2.nodeType && n2, r3 = t2 && e10 && !e10.nodeType && e10, o2 = r3 && r3.exports === t2 && N$1.process, i2 = function() {
    try {
      var e11 = r3 && r3.require && r3.require("util").types;
      return e11 || o2 && o2.binding && o2.binding("util");
    } catch (e12) {
    }
  }();
  e10.exports = i2;
}), qe$1 = We$1 && We$1.isTypedArray, Ye$1 = qe$1 ? He$1(qe$1) : $e$1, Je$1 = Object.prototype.hasOwnProperty;
var Xe$1 = function(e10, n2) {
  var t2 = Te$1(e10), r3 = !t2 && Re$1(e10), o2 = !t2 && !r3 && Pe$1(e10), i2 = !t2 && !r3 && !o2 && Ye$1(e10), a2 = t2 || r3 || o2 || i2, u2 = a2 ? Me$1(e10.length, String) : [], c3 = u2.length;
  for (var s2 in e10) !n2 && !Je$1.call(e10, s2) || a2 && ("length" == s2 || o2 && ("offset" == s2 || "parent" == s2) || i2 && ("buffer" == s2 || "byteLength" == s2 || "byteOffset" == s2) || Fe$1(s2, c3)) || u2.push(s2);
  return u2;
}, Ke$1 = Object.prototype;
var Qe$1 = function(e10) {
  var n2 = e10 && e10.constructor;
  return e10 === ("function" == typeof n2 && n2.prototype || Ke$1);
};
var Ze$1 = function(e10, n2) {
  return function(t2) {
    return e10(n2(t2));
  };
}, en$1 = Ze$1(Object.keys, Object), nn$1 = Object.prototype.hasOwnProperty;
var tn$1 = function(e10) {
  if (!Qe$1(e10)) return en$1(e10);
  var n2 = [];
  for (var t2 in Object(e10)) nn$1.call(e10, t2) && "constructor" != t2 && n2.push(t2);
  return n2;
};
var rn$1 = function(e10) {
  return null != e10 && Ue$1(e10.length) && !z$1(e10);
};
var on$1 = function(e10) {
  return rn$1(e10) ? Xe$1(e10) : tn$1(e10);
};
var an$1 = function(e10, n2) {
  return e10 && Se$1(n2, on$1(n2), e10);
};
var un$1 = function(e10) {
  var n2 = [];
  if (null != e10) for (var t2 in Object(e10)) n2.push(t2);
  return n2;
}, cn$1 = Object.prototype.hasOwnProperty;
var sn$1 = function(e10) {
  if (!D$1(e10)) return un$1(e10);
  var n2 = Qe$1(e10), t2 = [];
  for (var r3 in e10) ("constructor" != r3 || !n2 && cn$1.call(e10, r3)) && t2.push(r3);
  return t2;
};
var dn$1 = function(e10) {
  return rn$1(e10) ? Xe$1(e10, true) : sn$1(e10);
};
var fn$1 = function(e10, n2) {
  return e10 && Se$1(n2, dn$1(n2), e10);
}, hn$1 = d$1(function(e10, n2) {
  var t2 = n2 && !n2.nodeType && n2, r3 = t2 && e10 && !e10.nodeType && e10, o2 = r3 && r3.exports === t2 ? k$1.Buffer : void 0, i2 = o2 ? o2.allocUnsafe : void 0;
  e10.exports = function(e11, n3) {
    if (n3) return e11.slice();
    var t3 = e11.length, r4 = i2 ? i2(t3) : new e11.constructor(t3);
    return e11.copy(r4), r4;
  };
});
var ln$1 = function(e10, n2) {
  var t2 = -1, r3 = e10.length;
  for (n2 || (n2 = Array(r3)); ++t2 < r3; ) n2[t2] = e10[t2];
  return n2;
};
var vn$1 = function(e10, n2) {
  for (var t2 = -1, r3 = null == e10 ? 0 : e10.length, o2 = 0, i2 = []; ++t2 < r3; ) {
    var a2 = e10[t2];
    n2(a2, t2, e10) && (i2[o2++] = a2);
  }
  return i2;
};
var pn$1 = function() {
  return [];
}, gn$1 = Object.prototype.propertyIsEnumerable, yn$1 = Object.getOwnPropertySymbols, bn$1 = yn$1 ? function(e10) {
  return null == e10 ? [] : (e10 = Object(e10), vn$1(yn$1(e10), function(n2) {
    return gn$1.call(e10, n2);
  }));
} : pn$1;
var mn$1 = function(e10, n2) {
  return Se$1(e10, bn$1(e10), n2);
};
var wn$1 = function(e10, n2) {
  for (var t2 = -1, r3 = n2.length, o2 = e10.length; ++t2 < r3; ) e10[o2 + t2] = n2[t2];
  return e10;
}, En$1 = Ze$1(Object.getPrototypeOf, Object), _n$1 = Object.getOwnPropertySymbols ? function(e10) {
  for (var n2 = []; e10; ) wn$1(n2, bn$1(e10)), e10 = En$1(e10);
  return n2;
} : pn$1;
var jn$1 = function(e10, n2) {
  return Se$1(e10, _n$1(e10), n2);
};
var xn$1 = function(e10, n2, t2) {
  var r3 = n2(e10);
  return Te$1(e10) ? r3 : wn$1(r3, t2(e10));
};
var Nn$1 = function(e10) {
  return xn$1(e10, on$1, bn$1);
};
var On$1 = function(e10) {
  return xn$1(e10, dn$1, _n$1);
}, kn$1 = ee$1(k$1, "DataView"), In$1 = ee$1(k$1, "Promise"), Sn$1 = ee$1(k$1, "Set"), Mn$1 = ee$1(k$1, "WeakMap"), Cn$1 = H$1(kn$1), Gn$1 = H$1(ne$1), Bn$1 = H$1(In$1), An$1 = H$1(Sn$1), Ln$1 = H$1(Mn$1), Rn$1 = T$1;
(kn$1 && "[object DataView]" != Rn$1(new kn$1(new ArrayBuffer(1))) || ne$1 && "[object Map]" != Rn$1(new ne$1()) || In$1 && "[object Promise]" != Rn$1(In$1.resolve()) || Sn$1 && "[object Set]" != Rn$1(new Sn$1()) || Mn$1 && "[object WeakMap]" != Rn$1(new Mn$1())) && (Rn$1 = function(e10) {
  var n2 = T$1(e10), t2 = "[object Object]" == n2 ? e10.constructor : void 0, r3 = t2 ? H$1(t2) : "";
  if (r3) switch (r3) {
    case Cn$1:
      return "[object DataView]";
    case Gn$1:
      return "[object Map]";
    case Bn$1:
      return "[object Promise]";
    case An$1:
      return "[object Set]";
    case Ln$1:
      return "[object WeakMap]";
  }
  return n2;
});
var Tn$1 = Rn$1, Dn$1 = Object.prototype.hasOwnProperty;
var Pn$1 = function(e10) {
  var n2 = e10.length, t2 = new e10.constructor(n2);
  return n2 && "string" == typeof e10[0] && Dn$1.call(e10, "index") && (t2.index = e10.index, t2.input = e10.input), t2;
}, zn$1 = k$1.Uint8Array;
var Fn$1 = function(e10) {
  var n2 = new e10.constructor(e10.byteLength);
  return new zn$1(n2).set(new zn$1(e10)), n2;
};
var Un$1 = function(e10, n2) {
  var t2 = n2 ? Fn$1(e10.buffer) : e10.buffer;
  return new e10.constructor(t2, e10.byteOffset, e10.byteLength);
}, Vn$1 = /\w*$/;
var $n$1 = function(e10) {
  var n2 = new e10.constructor(e10.source, Vn$1.exec(e10));
  return n2.lastIndex = e10.lastIndex, n2;
}, Hn$1 = I$1 ? I$1.prototype : void 0, Wn$1 = Hn$1 ? Hn$1.valueOf : void 0;
var qn$1 = function(e10) {
  return Wn$1 ? Object(Wn$1.call(e10)) : {};
};
var Yn$1 = function(e10, n2) {
  var t2 = n2 ? Fn$1(e10.buffer) : e10.buffer;
  return new e10.constructor(t2, e10.byteOffset, e10.length);
};
var Jn$1 = function(e10, n2, t2) {
  var r3 = e10.constructor;
  switch (n2) {
    case "[object ArrayBuffer]":
      return Fn$1(e10);
    case "[object Boolean]":
    case "[object Date]":
      return new r3(+e10);
    case "[object DataView]":
      return Un$1(e10, t2);
    case "[object Float32Array]":
    case "[object Float64Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object Int32Array]":
    case "[object Uint8Array]":
    case "[object Uint8ClampedArray]":
    case "[object Uint16Array]":
    case "[object Uint32Array]":
      return Yn$1(e10, t2);
    case "[object Map]":
      return new r3();
    case "[object Number]":
    case "[object String]":
      return new r3(e10);
    case "[object RegExp]":
      return $n$1(e10);
    case "[object Set]":
      return new r3();
    case "[object Symbol]":
      return qn$1(e10);
  }
}, Xn$1 = Object.create, Kn$1 = /* @__PURE__ */ function() {
  function e10() {
  }
  return function(n2) {
    if (!D$1(n2)) return {};
    if (Xn$1) return Xn$1(n2);
    e10.prototype = n2;
    var t2 = new e10();
    return e10.prototype = void 0, t2;
  };
}();
var Qn$1 = function(e10) {
  return "function" != typeof e10.constructor || Qe$1(e10) ? {} : Kn$1(En$1(e10));
};
var Zn$1 = function(e10) {
  return Ce$1(e10) && "[object Map]" == Tn$1(e10);
}, et$1 = We$1 && We$1.isMap, nt$1 = et$1 ? He$1(et$1) : Zn$1;
var tt$1 = function(e10) {
  return Ce$1(e10) && "[object Set]" == Tn$1(e10);
}, rt$1 = We$1 && We$1.isSet, ot$1 = rt$1 ? He$1(rt$1) : tt$1, it$1 = {};
it$1["[object Arguments]"] = it$1["[object Array]"] = it$1["[object ArrayBuffer]"] = it$1["[object DataView]"] = it$1["[object Boolean]"] = it$1["[object Date]"] = it$1["[object Float32Array]"] = it$1["[object Float64Array]"] = it$1["[object Int8Array]"] = it$1["[object Int16Array]"] = it$1["[object Int32Array]"] = it$1["[object Map]"] = it$1["[object Number]"] = it$1["[object Object]"] = it$1["[object RegExp]"] = it$1["[object Set]"] = it$1["[object String]"] = it$1["[object Symbol]"] = it$1["[object Uint8Array]"] = it$1["[object Uint8ClampedArray]"] = it$1["[object Uint16Array]"] = it$1["[object Uint32Array]"] = true, it$1["[object Error]"] = it$1["[object Function]"] = it$1["[object WeakMap]"] = false;
var at$1 = function e(n2, t2, r3, o2, i2, a2) {
  var u2, c3 = 1 & t2, s2 = 2 & t2, d2 = 4 & t2;
  if (void 0 !== u2) return u2;
  if (!D$1(n2)) return n2;
  var f2 = Te$1(n2);
  if (f2) {
    if (u2 = Pn$1(n2), !c3) return ln$1(n2, u2);
  } else {
    var h2 = Tn$1(n2), l2 = "[object Function]" == h2 || "[object GeneratorFunction]" == h2;
    if (Pe$1(n2)) return hn$1(n2, c3);
    if ("[object Object]" == h2 || "[object Arguments]" == h2 || l2 && !i2) {
      if (u2 = s2 || l2 ? {} : Qn$1(n2), !c3) return s2 ? jn$1(n2, fn$1(u2, n2)) : mn$1(n2, an$1(u2, n2));
    } else {
      if (!it$1[h2]) return i2 ? n2 : {};
      u2 = Jn$1(n2, h2, c3);
    }
  }
  a2 || (a2 = new je$1());
  var v2 = a2.get(n2);
  if (v2) return v2;
  a2.set(n2, u2), ot$1(n2) ? n2.forEach(function(o3) {
    u2.add(e(o3, t2, r3, o3, n2, a2));
  }) : nt$1(n2) && n2.forEach(function(o3, i3) {
    u2.set(i3, e(o3, t2, r3, i3, n2, a2));
  });
  var p2 = f2 ? void 0 : (d2 ? s2 ? On$1 : Nn$1 : s2 ? dn$1 : on$1)(n2);
  return xe$1(p2 || n2, function(o3, i3) {
    p2 && (o3 = n2[i3 = o3]), Ie$1(u2, i3, e(o3, t2, r3, i3, n2, a2));
  }), u2;
};
var ut$1 = function(e10) {
  return at$1(e10, 4);
};
var ct$1 = function(e10) {
  return function() {
    return e10;
  };
};
var st$1 = /* @__PURE__ */ function(e10) {
  return function(n2, t2, r3) {
    for (var o2 = -1, i2 = Object(n2), a2 = r3(n2), u2 = a2.length; u2--; ) {
      var c3 = a2[++o2];
      if (false === t2(i2[c3], c3, i2)) break;
    }
    return n2;
  };
}();
var dt$1 = function(e10, n2) {
  return e10 && st$1(e10, n2, on$1);
};
var ft$1 = /* @__PURE__ */ function(e10, n2) {
  return function(t2, r3) {
    if (null == t2) return t2;
    if (!rn$1(t2)) return e10(t2, r3);
    for (var o2 = t2.length, i2 = -1, a2 = Object(t2); ++i2 < o2 && false !== r3(a2[i2], i2, a2); ) ;
    return t2;
  };
}(dt$1);
var ht$1 = function(e10) {
  return e10;
};
var lt$1 = function(e10) {
  return "function" == typeof e10 ? e10 : ht$1;
};
var vt$1 = function(e10, n2) {
  return (Te$1(e10) ? xe$1 : ft$1)(e10, lt$1(n2));
}, pt$1 = vt$1;
var gt$1 = function(e10, n2) {
  var t2 = [];
  return ft$1(e10, function(e11, r3, o2) {
    n2(e11, r3, o2) && t2.push(e11);
  }), t2;
};
var yt$1 = function(e10) {
  return this.__data__.set(e10, "__lodash_hash_undefined__"), this;
};
var bt$1 = function(e10) {
  return this.__data__.has(e10);
};
function mt$1(e10) {
  var n2 = -1, t2 = null == e10 ? 0 : e10.length;
  for (this.__data__ = new we$1(); ++n2 < t2; ) this.add(e10[n2]);
}
mt$1.prototype.add = mt$1.prototype.push = yt$1, mt$1.prototype.has = bt$1;
var wt$1 = mt$1;
var Et$1 = function(e10, n2) {
  for (var t2 = -1, r3 = null == e10 ? 0 : e10.length; ++t2 < r3; ) if (n2(e10[t2], t2, e10)) return true;
  return false;
};
var _t$1 = function(e10, n2) {
  return e10.has(n2);
};
var jt$1 = function(e10, n2, t2, r3, o2, i2) {
  var a2 = 1 & t2, u2 = e10.length, c3 = n2.length;
  if (u2 != c3 && !(a2 && c3 > u2)) return false;
  var s2 = i2.get(e10), d2 = i2.get(n2);
  if (s2 && d2) return s2 == n2 && d2 == e10;
  var f2 = -1, h2 = true, l2 = 2 & t2 ? new wt$1() : void 0;
  for (i2.set(e10, n2), i2.set(n2, e10); ++f2 < u2; ) {
    var v2 = e10[f2], p2 = n2[f2];
    if (r3) var g2 = a2 ? r3(p2, v2, f2, n2, e10, i2) : r3(v2, p2, f2, e10, n2, i2);
    if (void 0 !== g2) {
      if (g2) continue;
      h2 = false;
      break;
    }
    if (l2) {
      if (!Et$1(n2, function(e11, n3) {
        if (!_t$1(l2, n3) && (v2 === e11 || o2(v2, e11, t2, r3, i2))) return l2.push(n3);
      })) {
        h2 = false;
        break;
      }
    } else if (v2 !== p2 && !o2(v2, p2, t2, r3, i2)) {
      h2 = false;
      break;
    }
  }
  return i2.delete(e10), i2.delete(n2), h2;
};
var xt$1 = function(e10) {
  var n2 = -1, t2 = Array(e10.size);
  return e10.forEach(function(e11, r3) {
    t2[++n2] = [r3, e11];
  }), t2;
};
var Nt$1 = function(e10) {
  var n2 = -1, t2 = Array(e10.size);
  return e10.forEach(function(e11) {
    t2[++n2] = e11;
  }), t2;
}, Ot$1 = I$1 ? I$1.prototype : void 0, kt$1 = Ot$1 ? Ot$1.valueOf : void 0;
var It$1 = function(e10, n2, t2, r3, o2, i2, a2) {
  switch (t2) {
    case "[object DataView]":
      if (e10.byteLength != n2.byteLength || e10.byteOffset != n2.byteOffset) return false;
      e10 = e10.buffer, n2 = n2.buffer;
    case "[object ArrayBuffer]":
      return !(e10.byteLength != n2.byteLength || !i2(new zn$1(e10), new zn$1(n2)));
    case "[object Boolean]":
    case "[object Date]":
    case "[object Number]":
      return h$1(+e10, +n2);
    case "[object Error]":
      return e10.name == n2.name && e10.message == n2.message;
    case "[object RegExp]":
    case "[object String]":
      return e10 == n2 + "";
    case "[object Map]":
      var u2 = xt$1;
    case "[object Set]":
      var c3 = 1 & r3;
      if (u2 || (u2 = Nt$1), e10.size != n2.size && !c3) return false;
      var s2 = a2.get(e10);
      if (s2) return s2 == n2;
      r3 |= 2, a2.set(e10, n2);
      var d2 = jt$1(u2(e10), u2(n2), r3, o2, i2, a2);
      return a2.delete(e10), d2;
    case "[object Symbol]":
      if (kt$1) return kt$1.call(e10) == kt$1.call(n2);
  }
  return false;
}, St$1 = Object.prototype.hasOwnProperty;
var Mt$1 = function(e10, n2, t2, r3, o2, i2) {
  var a2 = 1 & t2, u2 = Nn$1(e10), c3 = u2.length;
  if (c3 != Nn$1(n2).length && !a2) return false;
  for (var s2 = c3; s2--; ) {
    var d2 = u2[s2];
    if (!(a2 ? d2 in n2 : St$1.call(n2, d2))) return false;
  }
  var f2 = i2.get(e10), h2 = i2.get(n2);
  if (f2 && h2) return f2 == n2 && h2 == e10;
  var l2 = true;
  i2.set(e10, n2), i2.set(n2, e10);
  for (var v2 = a2; ++s2 < c3; ) {
    var p2 = e10[d2 = u2[s2]], g2 = n2[d2];
    if (r3) var y2 = a2 ? r3(g2, p2, d2, n2, e10, i2) : r3(p2, g2, d2, e10, n2, i2);
    if (!(void 0 === y2 ? p2 === g2 || o2(p2, g2, t2, r3, i2) : y2)) {
      l2 = false;
      break;
    }
    v2 || (v2 = "constructor" == d2);
  }
  if (l2 && !v2) {
    var b2 = e10.constructor, m2 = n2.constructor;
    b2 == m2 || !("constructor" in e10) || !("constructor" in n2) || "function" == typeof b2 && b2 instanceof b2 && "function" == typeof m2 && m2 instanceof m2 || (l2 = false);
  }
  return i2.delete(e10), i2.delete(n2), l2;
}, Ct$1 = Object.prototype.hasOwnProperty;
var Gt$1 = function(e10, n2, t2, r3, o2, i2) {
  var a2 = Te$1(e10), u2 = Te$1(n2), c3 = a2 ? "[object Array]" : Tn$1(e10), s2 = u2 ? "[object Array]" : Tn$1(n2), d2 = "[object Object]" == (c3 = "[object Arguments]" == c3 ? "[object Object]" : c3), f2 = "[object Object]" == (s2 = "[object Arguments]" == s2 ? "[object Object]" : s2), h2 = c3 == s2;
  if (h2 && Pe$1(e10)) {
    if (!Pe$1(n2)) return false;
    a2 = true, d2 = false;
  }
  if (h2 && !d2) return i2 || (i2 = new je$1()), a2 || Ye$1(e10) ? jt$1(e10, n2, t2, r3, o2, i2) : It$1(e10, n2, c3, t2, r3, o2, i2);
  if (!(1 & t2)) {
    var l2 = d2 && Ct$1.call(e10, "__wrapped__"), v2 = f2 && Ct$1.call(n2, "__wrapped__");
    if (l2 || v2) {
      var p2 = l2 ? e10.value() : e10, g2 = v2 ? n2.value() : n2;
      return i2 || (i2 = new je$1()), o2(p2, g2, t2, r3, i2);
    }
  }
  return !!h2 && (i2 || (i2 = new je$1()), Mt$1(e10, n2, t2, r3, o2, i2));
};
var Bt$1 = function e2(n2, t2, r3, o2, i2) {
  return n2 === t2 || (null == n2 || null == t2 || !Ce$1(n2) && !Ce$1(t2) ? n2 != n2 && t2 != t2 : Gt$1(n2, t2, r3, o2, e2, i2));
};
var At$1 = function(e10, n2, t2, r3) {
  var o2 = t2.length, i2 = o2;
  if (null == e10) return !i2;
  for (e10 = Object(e10); o2--; ) {
    var u2 = t2[o2];
    if (u2[2] ? u2[1] !== e10[u2[0]] : !(u2[0] in e10)) return false;
  }
  for (; ++o2 < i2; ) {
    var c3 = (u2 = t2[o2])[0], s2 = e10[c3], d2 = u2[1];
    if (u2[2]) {
      if (void 0 === s2 && !(c3 in e10)) return false;
    } else {
      var f2 = new je$1();
      var h2;
      if (!(void 0 === h2 ? Bt$1(d2, s2, 3, r3, f2) : h2)) return false;
    }
  }
  return true;
};
var Lt$1 = function(e10) {
  return e10 == e10 && !D$1(e10);
};
var Rt$1 = function(e10) {
  for (var n2 = on$1(e10), t2 = n2.length; t2--; ) {
    var r3 = n2[t2], o2 = e10[r3];
    n2[t2] = [r3, o2, Lt$1(o2)];
  }
  return n2;
};
var Tt$1 = function(e10, n2) {
  return function(t2) {
    return null != t2 && (t2[e10] === n2 && (void 0 !== n2 || e10 in Object(t2)));
  };
};
var Dt$1 = function(e10) {
  var n2 = Rt$1(e10);
  return 1 == n2.length && n2[0][2] ? Tt$1(n2[0][0], n2[0][1]) : function(t2) {
    return t2 === e10 || At$1(t2, e10, n2);
  };
};
var Pt$1 = function(e10) {
  return "symbol" == typeof e10 || Ce$1(e10) && "[object Symbol]" == T$1(e10);
}, zt$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ft$1 = /^\w*$/;
var Ut$1 = function(e10, n2) {
  if (Te$1(e10)) return false;
  var t2 = typeof e10;
  return !("number" != t2 && "symbol" != t2 && "boolean" != t2 && null != e10 && !Pt$1(e10)) || (Ft$1.test(e10) || !zt$1.test(e10) || null != n2 && e10 in Object(n2));
};
function Vt$1(e10, n2) {
  if ("function" != typeof e10 || null != n2 && "function" != typeof n2) throw new TypeError("Expected a function");
  var t2 = function() {
    var r3 = arguments, o2 = n2 ? n2.apply(this, r3) : r3[0], i2 = t2.cache;
    if (i2.has(o2)) return i2.get(o2);
    var a2 = e10.apply(this, r3);
    return t2.cache = i2.set(o2, a2) || i2, a2;
  };
  return t2.cache = new (Vt$1.Cache || we$1)(), t2;
}
Vt$1.Cache = we$1;
var $t$1 = Vt$1;
var Ht$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Wt$1 = /\\(\\)?/g, qt$1 = function(e10) {
  var n2 = $t$1(e10, function(e11) {
    return 500 === t2.size && t2.clear(), e11;
  }), t2 = n2.cache;
  return n2;
}(function(e10) {
  var n2 = [];
  return 46 === e10.charCodeAt(0) && n2.push(""), e10.replace(Ht$1, function(e11, t2, r3, o2) {
    n2.push(r3 ? o2.replace(Wt$1, "$1") : t2 || e11);
  }), n2;
});
var Yt$1 = function(e10, n2) {
  for (var t2 = -1, r3 = null == e10 ? 0 : e10.length, o2 = Array(r3); ++t2 < r3; ) o2[t2] = n2(e10[t2], t2, e10);
  return o2;
}, Jt$1 = I$1 ? I$1.prototype : void 0, Xt$1 = Jt$1 ? Jt$1.toString : void 0;
var Kt$1 = function e3(n2) {
  if ("string" == typeof n2) return n2;
  if (Te$1(n2)) return Yt$1(n2, e3) + "";
  if (Pt$1(n2)) return Xt$1 ? Xt$1.call(n2) : "";
  var t2 = n2 + "";
  return "0" == t2 && 1 / n2 == -Infinity ? "-0" : t2;
};
var Qt$1 = function(e10) {
  return null == e10 ? "" : Kt$1(e10);
};
var Zt$1 = function(e10, n2) {
  return Te$1(e10) ? e10 : Ut$1(e10, n2) ? [e10] : qt$1(Qt$1(e10));
};
var er$1 = function(e10) {
  if ("string" == typeof e10 || Pt$1(e10)) return e10;
  var n2 = e10 + "";
  return "0" == n2 && 1 / e10 == -Infinity ? "-0" : n2;
};
var nr$1 = function(e10, n2) {
  for (var t2 = 0, r3 = (n2 = Zt$1(n2, e10)).length; null != e10 && t2 < r3; ) e10 = e10[er$1(n2[t2++])];
  return t2 && t2 == r3 ? e10 : void 0;
};
var tr$1 = function(e10, n2, t2) {
  var r3 = null == e10 ? void 0 : nr$1(e10, n2);
  return void 0 === r3 ? t2 : r3;
};
var rr$1 = function(e10, n2) {
  return null != e10 && n2 in Object(e10);
};
var or$1 = function(e10, n2, t2) {
  for (var r3 = -1, o2 = (n2 = Zt$1(n2, e10)).length, i2 = false; ++r3 < o2; ) {
    var a2 = er$1(n2[r3]);
    if (!(i2 = null != e10 && t2(e10, a2))) break;
    e10 = e10[a2];
  }
  return i2 || ++r3 != o2 ? i2 : !!(o2 = null == e10 ? 0 : e10.length) && Ue$1(o2) && Fe$1(a2, o2) && (Te$1(e10) || Re$1(e10));
};
var ir$1 = function(e10, n2) {
  return null != e10 && or$1(e10, n2, rr$1);
};
var ar$1 = function(e10, n2) {
  return Ut$1(e10) && Lt$1(n2) ? Tt$1(er$1(e10), n2) : function(t2) {
    var r3 = tr$1(t2, e10);
    return void 0 === r3 && r3 === n2 ? ir$1(t2, e10) : Bt$1(n2, r3, 3);
  };
};
var ur$1 = function(e10) {
  return function(n2) {
    return null == n2 ? void 0 : n2[e10];
  };
};
var cr$1 = function(e10) {
  return function(n2) {
    return nr$1(n2, e10);
  };
};
var sr$1 = function(e10) {
  return Ut$1(e10) ? ur$1(er$1(e10)) : cr$1(e10);
};
var dr$1 = function(e10) {
  return "function" == typeof e10 ? e10 : null == e10 ? ht$1 : "object" == typeof e10 ? Te$1(e10) ? ar$1(e10[0], e10[1]) : Dt$1(e10) : sr$1(e10);
};
var fr$1 = function(e10, n2) {
  return (Te$1(e10) ? vn$1 : gt$1)(e10, dr$1(n2));
}, hr$1 = Object.prototype.hasOwnProperty;
var lr$1 = function(e10, n2) {
  return null != e10 && hr$1.call(e10, n2);
};
var vr$1 = function(e10, n2) {
  return null != e10 && or$1(e10, n2, lr$1);
}, pr$1 = Object.prototype.hasOwnProperty;
var gr$1 = function(e10) {
  if (null == e10) return true;
  if (rn$1(e10) && (Te$1(e10) || "string" == typeof e10 || "function" == typeof e10.splice || Pe$1(e10) || Ye$1(e10) || Re$1(e10))) return !e10.length;
  var n2 = Tn$1(e10);
  if ("[object Map]" == n2 || "[object Set]" == n2) return !e10.size;
  if (Qe$1(e10)) return !tn$1(e10).length;
  for (var t2 in e10) if (pr$1.call(e10, t2)) return false;
  return true;
};
var yr$1 = function(e10) {
  return void 0 === e10;
};
var br$1 = function(e10, n2) {
  var t2 = -1, r3 = rn$1(e10) ? Array(e10.length) : [];
  return ft$1(e10, function(e11, o2, i2) {
    r3[++t2] = n2(e11, o2, i2);
  }), r3;
};
var mr$1 = function(e10, n2) {
  return (Te$1(e10) ? Yt$1 : br$1)(e10, dr$1(n2));
};
var wr$1 = function(e10, n2, t2, r3) {
  var o2 = -1, i2 = null == e10 ? 0 : e10.length;
  for (r3 && i2 && (t2 = e10[++o2]); ++o2 < i2; ) t2 = n2(t2, e10[o2], o2, e10);
  return t2;
};
var Er$1 = function(e10, n2, t2, r3, o2) {
  return o2(e10, function(e11, o3, i2) {
    t2 = r3 ? (r3 = false, e11) : n2(t2, e11, o3, i2);
  }), t2;
};
var _r$1 = function(e10, n2, t2) {
  var r3 = Te$1(e10) ? wr$1 : Er$1, o2 = arguments.length < 3;
  return r3(e10, dr$1(n2), t2, o2, ft$1);
};
var jr$1 = function(e10) {
  return "string" == typeof e10 || !Te$1(e10) && Ce$1(e10) && "[object String]" == T$1(e10);
}, xr$1 = ur$1("length"), Nr$1 = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
var Or$1 = function(e10) {
  return Nr$1.test(e10);
}, kr$1 = "[\\ud800-\\udfff]", Ir$1 = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", Sr$1 = "\\ud83c[\\udffb-\\udfff]", Mr$1 = "[^\\ud800-\\udfff]", Cr$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", Gr$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Br$1 = "(?:" + Ir$1 + "|" + Sr$1 + ")?", Ar$1 = "[\\ufe0e\\ufe0f]?" + Br$1 + ("(?:\\u200d(?:" + [Mr$1, Cr$1, Gr$1].join("|") + ")[\\ufe0e\\ufe0f]?" + Br$1 + ")*"), Lr$1 = "(?:" + [Mr$1 + Ir$1 + "?", Ir$1, Cr$1, Gr$1, kr$1].join("|") + ")", Rr$1 = RegExp(Sr$1 + "(?=" + Sr$1 + ")|" + Lr$1 + Ar$1, "g");
var Tr$1 = function(e10) {
  for (var n2 = Rr$1.lastIndex = 0; Rr$1.test(e10); ) ++n2;
  return n2;
};
var Dr$1 = function(e10) {
  return Or$1(e10) ? Tr$1(e10) : xr$1(e10);
};
var Pr$1 = function(e10) {
  if (null == e10) return 0;
  if (rn$1(e10)) return jr$1(e10) ? Dr$1(e10) : e10.length;
  var n2 = Tn$1(e10);
  return "[object Map]" == n2 || "[object Set]" == n2 ? e10.size : tn$1(e10).length;
};
var zr$1 = function(e10, n2, t2) {
  var r3 = Te$1(e10), o2 = r3 || Pe$1(e10) || Ye$1(e10);
  if (n2 = dr$1(n2), null == t2) {
    var i2 = e10 && e10.constructor;
    t2 = o2 ? r3 ? new i2() : [] : D$1(e10) && z$1(i2) ? Kn$1(En$1(e10)) : {};
  }
  return (o2 ? xe$1 : dt$1)(e10, function(e11, r4, o3) {
    return n2(t2, e11, r4, o3);
  }), t2;
}, Fr$1 = I$1 ? I$1.isConcatSpreadable : void 0;
var Ur$1 = function(e10) {
  return Te$1(e10) || Re$1(e10) || !!(Fr$1 && e10 && e10[Fr$1]);
};
var Vr$1 = function e4(n2, t2, r3, o2, i2) {
  var a2 = -1, u2 = n2.length;
  for (r3 || (r3 = Ur$1), i2 || (i2 = []); ++a2 < u2; ) {
    var c3 = n2[a2];
    r3(c3) ? wn$1(i2, c3) : o2 || (i2[i2.length] = c3);
  }
  return i2;
};
var $r$1 = function(e10, n2, t2) {
  switch (t2.length) {
    case 0:
      return e10.call(n2);
    case 1:
      return e10.call(n2, t2[0]);
    case 2:
      return e10.call(n2, t2[0], t2[1]);
    case 3:
      return e10.call(n2, t2[0], t2[1], t2[2]);
  }
  return e10.apply(n2, t2);
}, Hr$1 = Math.max;
var Wr$1 = function(e10, n2, t2) {
  return n2 = Hr$1(void 0 === n2 ? e10.length - 1 : n2, 0), function() {
    for (var r3 = arguments, o2 = -1, i2 = Hr$1(r3.length - n2, 0), a2 = Array(i2); ++o2 < i2; ) a2[o2] = r3[n2 + o2];
    o2 = -1;
    for (var u2 = Array(n2 + 1); ++o2 < n2; ) u2[o2] = r3[o2];
    return u2[n2] = t2(a2), $r$1(e10, this, u2);
  };
}, qr$1 = Ne$1 ? function(e10, n2) {
  return Ne$1(e10, "toString", { configurable: true, enumerable: false, value: ct$1(n2), writable: true });
} : ht$1, Yr$1 = Date.now;
var Jr$1 = /* @__PURE__ */ function(e10) {
  var n2 = 0, t2 = 0;
  return function() {
    var r3 = Yr$1(), o2 = 16 - (r3 - t2);
    if (t2 = r3, o2 > 0) {
      if (++n2 >= 800) return arguments[0];
    } else n2 = 0;
    return e10.apply(void 0, arguments);
  };
}(qr$1);
var Xr$1 = function(e10, n2) {
  return Jr$1(Wr$1(e10, n2, ht$1), e10 + "");
};
var Kr$1 = function(e10, n2, t2, r3) {
  for (var o2 = e10.length, i2 = t2 + -1; ++i2 < o2; ) if (n2(e10[i2], i2, e10)) return i2;
  return -1;
};
var Qr$1 = function(e10) {
  return e10 != e10;
};
var Zr$1 = function(e10, n2, t2) {
  for (var r3 = t2 - 1, o2 = e10.length; ++r3 < o2; ) if (e10[r3] === n2) return r3;
  return -1;
};
var eo$1 = function(e10, n2, t2) {
  return n2 == n2 ? Zr$1(e10, n2, t2) : Kr$1(e10, Qr$1, t2);
};
var no$1 = function(e10, n2) {
  return !!(null == e10 ? 0 : e10.length) && eo$1(e10, n2, 0) > -1;
};
var ro$1 = function() {
}, oo$1 = Sn$1 && 1 / Nt$1(new Sn$1([, -0]))[1] == 1 / 0 ? function(e10) {
  return new Sn$1(e10);
} : ro$1;
var io$1 = function(e10, n2, t2) {
  var r3 = -1, o2 = no$1, i2 = e10.length, a2 = true, u2 = [], c3 = u2;
  if (i2 >= 200) {
    var s2 = oo$1(e10);
    if (s2) return Nt$1(s2);
    a2 = false, o2 = _t$1, c3 = new wt$1();
  } else c3 = u2;
  e: for (; ++r3 < i2; ) {
    var d2 = e10[r3], f2 = d2;
    if (d2 = 0 !== d2 ? d2 : 0, a2 && f2 == f2) {
      for (var h2 = c3.length; h2--; ) if (c3[h2] === f2) continue e;
      u2.push(d2);
    } else o2(c3, f2, t2) || (c3 !== u2 && c3.push(f2), u2.push(d2));
  }
  return u2;
};
var ao$1 = function(e10) {
  return Ce$1(e10) && rn$1(e10);
}, uo$1 = Xr$1(function(e10) {
  return io$1(Vr$1(e10, 1, ao$1, true));
});
var co$1 = function(e10, n2) {
  return Yt$1(n2, function(n3) {
    return e10[n3];
  });
};
var so$1, fo$1 = function(e10) {
  return null == e10 ? [] : co$1(e10, on$1(e10));
};
try {
  so$1 = { clone: ut$1, constant: ct$1, each: pt$1, filter: fr$1, has: vr$1, isArray: Te$1, isEmpty: gr$1, isFunction: z$1, isUndefined: yr$1, keys: on$1, map: mr$1, reduce: _r$1, size: Pr$1, transform: zr$1, union: uo$1, values: fo$1 };
} catch (e10) {
}
so$1 || (so$1 = window._);
var ho$1 = so$1, lo$1 = vo$1;
function vo$1(e10) {
  this._isDirected = !ho$1.has(e10, "directed") || e10.directed, this._isMultigraph = !!ho$1.has(e10, "multigraph") && e10.multigraph, this._isCompound = !!ho$1.has(e10, "compound") && e10.compound, this._label = void 0, this._defaultNodeLabelFn = ho$1.constant(void 0), this._defaultEdgeLabelFn = ho$1.constant(void 0), this._nodes = {}, this._isCompound && (this._parent = {}, this._children = {}, this._children["\0"] = {}), this._in = {}, this._preds = {}, this._out = {}, this._sucs = {}, this._edgeObjs = {}, this._edgeLabels = {};
}
function po$1(e10, n2) {
  e10[n2] ? e10[n2]++ : e10[n2] = 1;
}
function go$1(e10, n2) {
  --e10[n2] || delete e10[n2];
}
function yo$1(e10, n2, t2, r3) {
  var o2 = "" + n2, i2 = "" + t2;
  if (!e10 && o2 > i2) {
    var a2 = o2;
    o2 = i2, i2 = a2;
  }
  return o2 + "" + i2 + "" + (ho$1.isUndefined(r3) ? "\0" : r3);
}
function bo$1(e10, n2, t2, r3) {
  var o2 = "" + n2, i2 = "" + t2;
  if (!e10 && o2 > i2) {
    var a2 = o2;
    o2 = i2, i2 = a2;
  }
  var u2 = { v: o2, w: i2 };
  return r3 && (u2.name = r3), u2;
}
function mo$1(e10, n2) {
  return yo$1(e10, n2.v, n2.w, n2.name);
}
vo$1.prototype._nodeCount = 0, vo$1.prototype._edgeCount = 0, vo$1.prototype.isDirected = function() {
  return this._isDirected;
}, vo$1.prototype.isMultigraph = function() {
  return this._isMultigraph;
}, vo$1.prototype.isCompound = function() {
  return this._isCompound;
}, vo$1.prototype.setGraph = function(e10) {
  return this._label = e10, this;
}, vo$1.prototype.graph = function() {
  return this._label;
}, vo$1.prototype.setDefaultNodeLabel = function(e10) {
  return ho$1.isFunction(e10) || (e10 = ho$1.constant(e10)), this._defaultNodeLabelFn = e10, this;
}, vo$1.prototype.nodeCount = function() {
  return this._nodeCount;
}, vo$1.prototype.nodes = function() {
  return ho$1.keys(this._nodes);
}, vo$1.prototype.sources = function() {
  var e10 = this;
  return ho$1.filter(this.nodes(), function(n2) {
    return ho$1.isEmpty(e10._in[n2]);
  });
}, vo$1.prototype.sinks = function() {
  var e10 = this;
  return ho$1.filter(this.nodes(), function(n2) {
    return ho$1.isEmpty(e10._out[n2]);
  });
}, vo$1.prototype.setNodes = function(e10, n2) {
  var t2 = arguments, r3 = this;
  return ho$1.each(e10, function(e11) {
    t2.length > 1 ? r3.setNode(e11, n2) : r3.setNode(e11);
  }), this;
}, vo$1.prototype.setNode = function(e10, n2) {
  return ho$1.has(this._nodes, e10) ? (arguments.length > 1 && (this._nodes[e10] = n2), this) : (this._nodes[e10] = arguments.length > 1 ? n2 : this._defaultNodeLabelFn(e10), this._isCompound && (this._parent[e10] = "\0", this._children[e10] = {}, this._children["\0"][e10] = true), this._in[e10] = {}, this._preds[e10] = {}, this._out[e10] = {}, this._sucs[e10] = {}, ++this._nodeCount, this);
}, vo$1.prototype.node = function(e10) {
  return this._nodes[e10];
}, vo$1.prototype.hasNode = function(e10) {
  return ho$1.has(this._nodes, e10);
}, vo$1.prototype.removeNode = function(e10) {
  var n2 = this;
  if (ho$1.has(this._nodes, e10)) {
    var t2 = function(e11) {
      n2.removeEdge(n2._edgeObjs[e11]);
    };
    delete this._nodes[e10], this._isCompound && (this._removeFromParentsChildList(e10), delete this._parent[e10], ho$1.each(this.children(e10), function(e11) {
      n2.setParent(e11);
    }), delete this._children[e10]), ho$1.each(ho$1.keys(this._in[e10]), t2), delete this._in[e10], delete this._preds[e10], ho$1.each(ho$1.keys(this._out[e10]), t2), delete this._out[e10], delete this._sucs[e10], --this._nodeCount;
  }
  return this;
}, vo$1.prototype.setParent = function(e10, n2) {
  if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
  if (ho$1.isUndefined(n2)) n2 = "\0";
  else {
    for (var t2 = n2 += ""; !ho$1.isUndefined(t2); t2 = this.parent(t2)) if (t2 === e10) throw new Error("Setting " + n2 + " as parent of " + e10 + " would create a cycle");
    this.setNode(n2);
  }
  return this.setNode(e10), this._removeFromParentsChildList(e10), this._parent[e10] = n2, this._children[n2][e10] = true, this;
}, vo$1.prototype._removeFromParentsChildList = function(e10) {
  delete this._children[this._parent[e10]][e10];
}, vo$1.prototype.parent = function(e10) {
  if (this._isCompound) {
    var n2 = this._parent[e10];
    if ("\0" !== n2) return n2;
  }
}, vo$1.prototype.children = function(e10) {
  if (ho$1.isUndefined(e10) && (e10 = "\0"), this._isCompound) {
    var n2 = this._children[e10];
    if (n2) return ho$1.keys(n2);
  } else {
    if ("\0" === e10) return this.nodes();
    if (this.hasNode(e10)) return [];
  }
}, vo$1.prototype.predecessors = function(e10) {
  var n2 = this._preds[e10];
  if (n2) return ho$1.keys(n2);
}, vo$1.prototype.successors = function(e10) {
  var n2 = this._sucs[e10];
  if (n2) return ho$1.keys(n2);
}, vo$1.prototype.neighbors = function(e10) {
  var n2 = this.predecessors(e10);
  if (n2) return ho$1.union(n2, this.successors(e10));
}, vo$1.prototype.isLeaf = function(e10) {
  return 0 === (this.isDirected() ? this.successors(e10) : this.neighbors(e10)).length;
}, vo$1.prototype.filterNodes = function(e10) {
  var n2 = new this.constructor({ directed: this._isDirected, multigraph: this._isMultigraph, compound: this._isCompound });
  n2.setGraph(this.graph());
  var t2 = this;
  ho$1.each(this._nodes, function(t3, r4) {
    e10(r4) && n2.setNode(r4, t3);
  }), ho$1.each(this._edgeObjs, function(e11) {
    n2.hasNode(e11.v) && n2.hasNode(e11.w) && n2.setEdge(e11, t2.edge(e11));
  });
  var r3 = {};
  function o2(e11) {
    var i2 = t2.parent(e11);
    return void 0 === i2 || n2.hasNode(i2) ? (r3[e11] = i2, i2) : i2 in r3 ? r3[i2] : o2(i2);
  }
  return this._isCompound && ho$1.each(n2.nodes(), function(e11) {
    n2.setParent(e11, o2(e11));
  }), n2;
}, vo$1.prototype.setDefaultEdgeLabel = function(e10) {
  return ho$1.isFunction(e10) || (e10 = ho$1.constant(e10)), this._defaultEdgeLabelFn = e10, this;
}, vo$1.prototype.edgeCount = function() {
  return this._edgeCount;
}, vo$1.prototype.edges = function() {
  return ho$1.values(this._edgeObjs);
}, vo$1.prototype.setPath = function(e10, n2) {
  var t2 = this, r3 = arguments;
  return ho$1.reduce(e10, function(e11, o2) {
    return r3.length > 1 ? t2.setEdge(e11, o2, n2) : t2.setEdge(e11, o2), o2;
  }), this;
}, vo$1.prototype.setEdge = function() {
  var e10, n2, t2, r3, o2 = false, i2 = arguments[0];
  "object" == typeof i2 && null !== i2 && "v" in i2 ? (e10 = i2.v, n2 = i2.w, t2 = i2.name, 2 === arguments.length && (r3 = arguments[1], o2 = true)) : (e10 = i2, n2 = arguments[1], t2 = arguments[3], arguments.length > 2 && (r3 = arguments[2], o2 = true)), e10 = "" + e10, n2 = "" + n2, ho$1.isUndefined(t2) || (t2 = "" + t2);
  var a2 = yo$1(this._isDirected, e10, n2, t2);
  if (ho$1.has(this._edgeLabels, a2)) return o2 && (this._edgeLabels[a2] = r3), this;
  if (!ho$1.isUndefined(t2) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
  this.setNode(e10), this.setNode(n2), this._edgeLabels[a2] = o2 ? r3 : this._defaultEdgeLabelFn(e10, n2, t2);
  var u2 = bo$1(this._isDirected, e10, n2, t2);
  return e10 = u2.v, n2 = u2.w, Object.freeze(u2), this._edgeObjs[a2] = u2, po$1(this._preds[n2], e10), po$1(this._sucs[e10], n2), this._in[n2][a2] = u2, this._out[e10][a2] = u2, this._edgeCount++, this;
}, vo$1.prototype.edge = function(e10, n2, t2) {
  var r3 = 1 === arguments.length ? mo$1(this._isDirected, arguments[0]) : yo$1(this._isDirected, e10, n2, t2);
  return this._edgeLabels[r3];
}, vo$1.prototype.hasEdge = function(e10, n2, t2) {
  var r3 = 1 === arguments.length ? mo$1(this._isDirected, arguments[0]) : yo$1(this._isDirected, e10, n2, t2);
  return ho$1.has(this._edgeLabels, r3);
}, vo$1.prototype.removeEdge = function(e10, n2, t2) {
  var r3 = 1 === arguments.length ? mo$1(this._isDirected, arguments[0]) : yo$1(this._isDirected, e10, n2, t2), o2 = this._edgeObjs[r3];
  return o2 && (e10 = o2.v, n2 = o2.w, delete this._edgeLabels[r3], delete this._edgeObjs[r3], go$1(this._preds[n2], e10), go$1(this._sucs[e10], n2), delete this._in[n2][r3], delete this._out[e10][r3], this._edgeCount--), this;
}, vo$1.prototype.inEdges = function(e10, n2) {
  var t2 = this._in[e10];
  if (t2) {
    var r3 = ho$1.values(t2);
    return n2 ? ho$1.filter(r3, function(e11) {
      return e11.v === n2;
    }) : r3;
  }
}, vo$1.prototype.outEdges = function(e10, n2) {
  var t2 = this._out[e10];
  if (t2) {
    var r3 = ho$1.values(t2);
    return n2 ? ho$1.filter(r3, function(e11) {
      return e11.w === n2;
    }) : r3;
  }
}, vo$1.prototype.nodeEdges = function(e10, n2) {
  var t2 = this.inEdges(e10, n2);
  if (t2) return t2.concat(this.outEdges(e10, n2));
};
var wo$1 = { Graph: lo$1, version: "2.1.8" }, Eo$1 = { write: function(e10) {
  var n2 = { options: { directed: e10.isDirected(), multigraph: e10.isMultigraph(), compound: e10.isCompound() }, nodes: _o$1(e10), edges: jo$1(e10) };
  ho$1.isUndefined(e10.graph()) || (n2.value = ho$1.clone(e10.graph()));
  return n2;
}, read: function(e10) {
  var n2 = new lo$1(e10.options).setGraph(e10.value);
  return ho$1.each(e10.nodes, function(e11) {
    n2.setNode(e11.v, e11.value), e11.parent && n2.setParent(e11.v, e11.parent);
  }), ho$1.each(e10.edges, function(e11) {
    n2.setEdge({ v: e11.v, w: e11.w, name: e11.name }, e11.value);
  }), n2;
} };
function _o$1(e10) {
  return ho$1.map(e10.nodes(), function(n2) {
    var t2 = e10.node(n2), r3 = e10.parent(n2), o2 = { v: n2 };
    return ho$1.isUndefined(t2) || (o2.value = t2), ho$1.isUndefined(r3) || (o2.parent = r3), o2;
  });
}
function jo$1(e10) {
  return ho$1.map(e10.edges(), function(n2) {
    var t2 = e10.edge(n2), r3 = { v: n2.v, w: n2.w };
    return ho$1.isUndefined(n2.name) || (r3.name = n2.name), ho$1.isUndefined(t2) || (r3.value = t2), r3;
  });
}
var xo$1 = function(e10) {
  var n2, t2 = {}, r3 = [];
  function o2(r4) {
    ho$1.has(t2, r4) || (t2[r4] = true, n2.push(r4), ho$1.each(e10.successors(r4), o2), ho$1.each(e10.predecessors(r4), o2));
  }
  return ho$1.each(e10.nodes(), function(e11) {
    n2 = [], o2(e11), n2.length && r3.push(n2);
  }), r3;
};
var No$1 = Oo$1;
function Oo$1() {
  this._arr = [], this._keyIndices = {};
}
Oo$1.prototype.size = function() {
  return this._arr.length;
}, Oo$1.prototype.keys = function() {
  return this._arr.map(function(e10) {
    return e10.key;
  });
}, Oo$1.prototype.has = function(e10) {
  return ho$1.has(this._keyIndices, e10);
}, Oo$1.prototype.priority = function(e10) {
  var n2 = this._keyIndices[e10];
  if (void 0 !== n2) return this._arr[n2].priority;
}, Oo$1.prototype.min = function() {
  if (0 === this.size()) throw new Error("Queue underflow");
  return this._arr[0].key;
}, Oo$1.prototype.add = function(e10, n2) {
  var t2 = this._keyIndices;
  if (e10 = String(e10), !ho$1.has(t2, e10)) {
    var r3 = this._arr, o2 = r3.length;
    return t2[e10] = o2, r3.push({ key: e10, priority: n2 }), this._decrease(o2), true;
  }
  return false;
}, Oo$1.prototype.removeMin = function() {
  this._swap(0, this._arr.length - 1);
  var e10 = this._arr.pop();
  return delete this._keyIndices[e10.key], this._heapify(0), e10.key;
}, Oo$1.prototype.decrease = function(e10, n2) {
  var t2 = this._keyIndices[e10];
  if (n2 > this._arr[t2].priority) throw new Error("New priority is greater than current priority. Key: " + e10 + " Old: " + this._arr[t2].priority + " New: " + n2);
  this._arr[t2].priority = n2, this._decrease(t2);
}, Oo$1.prototype._heapify = function(e10) {
  var n2 = this._arr, t2 = 2 * e10, r3 = t2 + 1, o2 = e10;
  t2 < n2.length && (o2 = n2[t2].priority < n2[o2].priority ? t2 : o2, r3 < n2.length && (o2 = n2[r3].priority < n2[o2].priority ? r3 : o2), o2 !== e10 && (this._swap(e10, o2), this._heapify(o2)));
}, Oo$1.prototype._decrease = function(e10) {
  for (var n2, t2 = this._arr, r3 = t2[e10].priority; 0 !== e10 && !(t2[n2 = e10 >> 1].priority < r3); ) this._swap(e10, n2), e10 = n2;
}, Oo$1.prototype._swap = function(e10, n2) {
  var t2 = this._arr, r3 = this._keyIndices, o2 = t2[e10], i2 = t2[n2];
  t2[e10] = i2, t2[n2] = o2, r3[i2.key] = e10, r3[o2.key] = n2;
};
var ko$1 = function(e10, n2, t2, r3) {
  return function(e11, n3, t3, r4) {
    var o2, i2, a2 = {}, u2 = new No$1(), c3 = function(e12) {
      var n4 = e12.v !== o2 ? e12.v : e12.w, r5 = a2[n4], c4 = t3(e12), s2 = i2.distance + c4;
      if (c4 < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + e12 + " Weight: " + c4);
      s2 < r5.distance && (r5.distance = s2, r5.predecessor = o2, u2.decrease(n4, s2));
    };
    e11.nodes().forEach(function(e12) {
      var t4 = e12 === n3 ? 0 : Number.POSITIVE_INFINITY;
      a2[e12] = { distance: t4 }, u2.add(e12, t4);
    });
    for (; u2.size() > 0 && (o2 = u2.removeMin(), (i2 = a2[o2]).distance !== Number.POSITIVE_INFINITY); ) r4(o2).forEach(c3);
    return a2;
  }(e10, String(n2), t2 || Io$1, r3 || function(n3) {
    return e10.outEdges(n3);
  });
}, Io$1 = ho$1.constant(1);
var So$1 = function(e10, n2, t2) {
  return ho$1.transform(e10.nodes(), function(r3, o2) {
    r3[o2] = ko$1(e10, o2, n2, t2);
  }, {});
};
var Mo$1 = function(e10) {
  var n2 = 0, t2 = [], r3 = {}, o2 = [];
  function i2(a2) {
    var u2 = r3[a2] = { onStack: true, lowlink: n2, index: n2++ };
    if (t2.push(a2), e10.successors(a2).forEach(function(e11) {
      ho$1.has(r3, e11) ? r3[e11].onStack && (u2.lowlink = Math.min(u2.lowlink, r3[e11].index)) : (i2(e11), u2.lowlink = Math.min(u2.lowlink, r3[e11].lowlink));
    }), u2.lowlink === u2.index) {
      var c3, s2 = [];
      do {
        c3 = t2.pop(), r3[c3].onStack = false, s2.push(c3);
      } while (a2 !== c3);
      o2.push(s2);
    }
  }
  return e10.nodes().forEach(function(e11) {
    ho$1.has(r3, e11) || i2(e11);
  }), o2;
};
var Co$1 = function(e10) {
  return ho$1.filter(Mo$1(e10), function(n2) {
    return n2.length > 1 || 1 === n2.length && e10.hasEdge(n2[0], n2[0]);
  });
};
var Go$1 = function(e10, n2, t2) {
  return function(e11, n3, t3) {
    var r3 = {}, o2 = e11.nodes();
    return o2.forEach(function(e12) {
      r3[e12] = {}, r3[e12][e12] = { distance: 0 }, o2.forEach(function(n4) {
        e12 !== n4 && (r3[e12][n4] = { distance: Number.POSITIVE_INFINITY });
      }), t3(e12).forEach(function(t4) {
        var o3 = t4.v === e12 ? t4.w : t4.v, i2 = n3(t4);
        r3[e12][o3] = { distance: i2, predecessor: e12 };
      });
    }), o2.forEach(function(e12) {
      var n4 = r3[e12];
      o2.forEach(function(t4) {
        var i2 = r3[t4];
        o2.forEach(function(t5) {
          var r4 = i2[e12], o3 = n4[t5], a2 = i2[t5], u2 = r4.distance + o3.distance;
          u2 < a2.distance && (a2.distance = u2, a2.predecessor = o3.predecessor);
        });
      });
    }), r3;
  }(e10, n2 || Bo$1, t2 || function(n3) {
    return e10.outEdges(n3);
  });
}, Bo$1 = ho$1.constant(1);
var Ao$1 = Lo$1;
function Lo$1(e10) {
  var n2 = {}, t2 = {}, r3 = [];
  if (ho$1.each(e10.sinks(), function o2(i2) {
    if (ho$1.has(t2, i2)) throw new Ro$1();
    ho$1.has(n2, i2) || (t2[i2] = true, n2[i2] = true, ho$1.each(e10.predecessors(i2), o2), delete t2[i2], r3.push(i2));
  }), ho$1.size(n2) !== e10.nodeCount()) throw new Ro$1();
  return r3;
}
function Ro$1() {
}
Lo$1.CycleException = Ro$1, Ro$1.prototype = new Error();
var To$1 = function(e10, n2, t2) {
  ho$1.isArray(n2) || (n2 = [n2]);
  var r3 = (e10.isDirected() ? e10.successors : e10.neighbors).bind(e10), o2 = [], i2 = {};
  return ho$1.each(n2, function(n3) {
    if (!e10.hasNode(n3)) throw new Error("Graph does not have node: " + n3);
    Do$1(e10, n3, "post" === t2, i2, r3, o2);
  }), o2;
};
function Do$1(e10, n2, t2, r3, o2, i2) {
  ho$1.has(r3, n2) || (r3[n2] = true, t2 || i2.push(n2), ho$1.each(o2(n2), function(n3) {
    Do$1(e10, n3, t2, r3, o2, i2);
  }), t2 && i2.push(n2));
}
var Po$1, zo$1 = { Graph: wo$1.Graph, json: Eo$1, alg: { components: xo$1, dijkstra: ko$1, dijkstraAll: So$1, findCycles: Co$1, floydWarshall: Go$1, isAcyclic: function(e10) {
  try {
    Ao$1(e10);
  } catch (e11) {
    if (e11 instanceof Ao$1.CycleException) return false;
    throw e11;
  }
  return true;
}, postorder: function(e10, n2) {
  return To$1(e10, n2, "post");
}, preorder: function(e10, n2) {
  return To$1(e10, n2, "pre");
}, prim: function(e10, n2) {
  var t2, r3 = new lo$1(), o2 = {}, i2 = new No$1();
  function a2(e11) {
    var r4 = e11.v === t2 ? e11.w : e11.v, a3 = i2.priority(r4);
    if (void 0 !== a3) {
      var u3 = n2(e11);
      u3 < a3 && (o2[r4] = t2, i2.decrease(r4, u3));
    }
  }
  if (0 === e10.nodeCount()) return r3;
  ho$1.each(e10.nodes(), function(e11) {
    i2.add(e11, Number.POSITIVE_INFINITY), r3.setNode(e11);
  }), i2.decrease(e10.nodes()[0], 0);
  var u2 = false;
  for (; i2.size() > 0; ) {
    if (t2 = i2.removeMin(), ho$1.has(o2, t2)) r3.setEdge(t2, o2[t2]);
    else {
      if (u2) throw new Error("Input graph is not connected: " + e10);
      u2 = true;
    }
    e10.nodeEdges(t2).forEach(a2);
  }
  return r3;
}, tarjan: Mo$1, topsort: Ao$1 }, version: wo$1.version };
try {
  Po$1 = zo$1;
} catch (e10) {
}
Po$1 || (Po$1 = window.graphlib);
var Fo$1 = Po$1;
var Uo$1 = function(e10) {
  return at$1(e10, 5);
};
var Vo$1 = function(e10, n2, t2) {
  if (!D$1(t2)) return false;
  var r3 = typeof n2;
  return !!("number" == r3 ? rn$1(t2) && Fe$1(n2, t2.length) : "string" == r3 && n2 in t2) && h$1(t2[n2], e10);
}, $o$1 = Object.prototype, Ho$1 = $o$1.hasOwnProperty, Wo$1 = Xr$1(function(e10, n2) {
  e10 = Object(e10);
  var t2 = -1, r3 = n2.length, o2 = r3 > 2 ? n2[2] : void 0;
  for (o2 && Vo$1(n2[0], n2[1], o2) && (r3 = 1); ++t2 < r3; ) for (var i2 = n2[t2], a2 = dn$1(i2), u2 = -1, c3 = a2.length; ++u2 < c3; ) {
    var s2 = a2[u2], d2 = e10[s2];
    (void 0 === d2 || h$1(d2, $o$1[s2]) && !Ho$1.call(e10, s2)) && (e10[s2] = i2[s2]);
  }
  return e10;
});
var qo$1 = function(e10) {
  return function(n2, t2, r3) {
    var o2 = Object(n2);
    if (!rn$1(n2)) {
      var i2 = dr$1(t2);
      n2 = on$1(n2), t2 = function(e11) {
        return i2(o2[e11], e11, o2);
      };
    }
    var a2 = e10(n2, t2, r3);
    return a2 > -1 ? o2[i2 ? n2[a2] : a2] : void 0;
  };
}, Yo$1 = /^\s+|\s+$/g, Jo$1 = /^[-+]0x[0-9a-f]+$/i, Xo$1 = /^0b[01]+$/i, Ko$1 = /^0o[0-7]+$/i, Qo$1 = parseInt;
var Zo$1 = function(e10) {
  if ("number" == typeof e10) return e10;
  if (Pt$1(e10)) return NaN;
  if (D$1(e10)) {
    var n2 = "function" == typeof e10.valueOf ? e10.valueOf() : e10;
    e10 = D$1(n2) ? n2 + "" : n2;
  }
  if ("string" != typeof e10) return 0 === e10 ? e10 : +e10;
  e10 = e10.replace(Yo$1, "");
  var t2 = Xo$1.test(e10);
  return t2 || Ko$1.test(e10) ? Qo$1(e10.slice(2), t2 ? 2 : 8) : Jo$1.test(e10) ? NaN : +e10;
};
var ei$1 = function(e10) {
  return e10 ? Infinity === (e10 = Zo$1(e10)) || -Infinity === e10 ? 17976931348623157e292 * (e10 < 0 ? -1 : 1) : e10 == e10 ? e10 : 0 : 0 === e10 ? e10 : 0;
};
var ni$1 = function(e10) {
  var n2 = ei$1(e10), t2 = n2 % 1;
  return n2 == n2 ? t2 ? n2 - t2 : n2 : 0;
}, ti$1 = Math.max;
var ri$1 = qo$1(function(e10, n2, t2) {
  var r3 = null == e10 ? 0 : e10.length;
  if (!r3) return -1;
  var o2 = null == t2 ? 0 : ni$1(t2);
  return o2 < 0 && (o2 = ti$1(r3 + o2, 0)), Kr$1(e10, dr$1(n2), o2);
});
var oi$1 = function(e10) {
  return (null == e10 ? 0 : e10.length) ? Vr$1(e10) : [];
};
var ii$1 = function(e10, n2) {
  return null == e10 ? e10 : st$1(e10, lt$1(n2), dn$1);
};
var ai$1 = function(e10) {
  var n2 = null == e10 ? 0 : e10.length;
  return n2 ? e10[n2 - 1] : void 0;
};
var ui$1 = function(e10, n2) {
  var t2 = {};
  return n2 = dr$1(n2), dt$1(e10, function(e11, r3, o2) {
    Oe$1(t2, r3, n2(e11, r3, o2));
  }), t2;
};
var ci$1 = function(e10, n2, t2) {
  for (var r3 = -1, o2 = e10.length; ++r3 < o2; ) {
    var i2 = e10[r3], a2 = n2(i2);
    if (null != a2 && (void 0 === u2 ? a2 == a2 && !Pt$1(a2) : t2(a2, u2))) var u2 = a2, c3 = i2;
  }
  return c3;
};
var si$1 = function(e10, n2) {
  return e10 > n2;
};
var di$1 = function(e10) {
  return e10 && e10.length ? ci$1(e10, ht$1, si$1) : void 0;
};
var fi$1 = function(e10, n2, t2) {
  (void 0 !== t2 && !h$1(e10[n2], t2) || void 0 === t2 && !(n2 in e10)) && Oe$1(e10, n2, t2);
}, hi$1 = Function.prototype, li$1 = Object.prototype, vi$1 = hi$1.toString, pi$1 = li$1.hasOwnProperty, gi$1 = vi$1.call(Object);
var yi$1 = function(e10) {
  if (!Ce$1(e10) || "[object Object]" != T$1(e10)) return false;
  var n2 = En$1(e10);
  if (null === n2) return true;
  var t2 = pi$1.call(n2, "constructor") && n2.constructor;
  return "function" == typeof t2 && t2 instanceof t2 && vi$1.call(t2) == gi$1;
};
var bi$1 = function(e10, n2) {
  if (("constructor" !== n2 || "function" != typeof e10[n2]) && "__proto__" != n2) return e10[n2];
};
var mi$1 = function(e10) {
  return Se$1(e10, dn$1(e10));
};
var wi$1 = function(e10, n2, t2, r3, o2, i2, a2) {
  var u2 = bi$1(e10, t2), c3 = bi$1(n2, t2), s2 = a2.get(c3);
  if (s2) fi$1(e10, t2, s2);
  else {
    var d2 = void 0, f2 = void 0 === d2;
    if (f2) {
      var h2 = Te$1(c3), l2 = !h2 && Pe$1(c3), v2 = !h2 && !l2 && Ye$1(c3);
      d2 = c3, h2 || l2 || v2 ? Te$1(u2) ? d2 = u2 : ao$1(u2) ? d2 = ln$1(u2) : l2 ? (f2 = false, d2 = hn$1(c3, true)) : v2 ? (f2 = false, d2 = Yn$1(c3, true)) : d2 = [] : yi$1(c3) || Re$1(c3) ? (d2 = u2, Re$1(u2) ? d2 = mi$1(u2) : D$1(u2) && !z$1(u2) || (d2 = Qn$1(c3))) : f2 = false;
    }
    f2 && (a2.set(c3, d2), o2(d2, c3, r3, i2, a2), a2.delete(c3)), fi$1(e10, t2, d2);
  }
};
var Ei$1 = function e5(n2, t2, r3, o2, i2) {
  n2 !== t2 && st$1(t2, function(a2, u2) {
    if (i2 || (i2 = new je$1()), D$1(a2)) wi$1(n2, t2, u2, r3, e5, o2, i2);
    else {
      var c3 = void 0;
      void 0 === c3 && (c3 = a2), fi$1(n2, u2, c3);
    }
  }, dn$1);
};
var _i$1 = function(e10) {
  return Xr$1(function(n2, t2) {
    var r3 = -1, o2 = t2.length, i2 = o2 > 1 ? t2[o2 - 1] : void 0, a2 = o2 > 2 ? t2[2] : void 0;
    for (i2 = e10.length > 3 && "function" == typeof i2 ? (o2--, i2) : void 0, a2 && Vo$1(t2[0], t2[1], a2) && (i2 = o2 < 3 ? void 0 : i2, o2 = 1), n2 = Object(n2); ++r3 < o2; ) {
      var u2 = t2[r3];
      u2 && e10(n2, u2, r3, i2);
    }
    return n2;
  });
}(function(e10, n2, t2) {
  Ei$1(e10, n2, t2);
});
var ji$1 = function(e10, n2) {
  return e10 < n2;
};
var xi$1 = function(e10) {
  return e10 && e10.length ? ci$1(e10, ht$1, ji$1) : void 0;
};
var Ni$1 = function(e10, n2) {
  return e10 && e10.length ? ci$1(e10, dr$1(n2), ji$1) : void 0;
}, Oi$1 = function() {
  return k$1.Date.now();
};
var ki$1 = function(e10, n2, t2, r3) {
  if (!D$1(e10)) return e10;
  for (var o2 = -1, i2 = (n2 = Zt$1(n2, e10)).length, a2 = i2 - 1, u2 = e10; null != u2 && ++o2 < i2; ) {
    var c3 = er$1(n2[o2]), s2 = t2;
    if ("__proto__" === c3 || "constructor" === c3 || "prototype" === c3) return e10;
    if (o2 != a2) {
      var d2 = u2[c3];
      void 0 === (s2 = void 0) && (s2 = D$1(d2) ? d2 : Fe$1(n2[o2 + 1]) ? [] : {});
    }
    Ie$1(u2, c3, s2), u2 = u2[c3];
  }
  return e10;
};
var Ii$1 = function(e10, n2, t2) {
  for (var r3 = -1, o2 = n2.length, i2 = {}; ++r3 < o2; ) {
    var a2 = n2[r3], u2 = nr$1(e10, a2);
    t2(u2, a2) && ki$1(i2, Zt$1(a2, e10), u2);
  }
  return i2;
};
var Si$1 = function(e10, n2) {
  return Ii$1(e10, n2, function(n3, t2) {
    return ir$1(e10, t2);
  });
};
var Mi$1 = function(e10) {
  return Jr$1(Wr$1(e10, void 0, oi$1), e10 + "");
}(function(e10, n2) {
  return null == e10 ? {} : Si$1(e10, n2);
}), Ci$1 = Math.ceil, Gi$1 = Math.max;
var Bi$1 = function(e10, n2, t2, r3) {
  for (var o2 = -1, i2 = Gi$1(Ci$1((n2 - e10) / (t2 || 1)), 0), a2 = Array(i2); i2--; ) a2[++o2] = e10, e10 += t2;
  return a2;
};
var Ai$1 = /* @__PURE__ */ function(e10) {
  return function(n2, t2, r3) {
    return r3 && "number" != typeof r3 && Vo$1(n2, t2, r3) && (t2 = r3 = void 0), n2 = ei$1(n2), void 0 === t2 ? (t2 = n2, n2 = 0) : t2 = ei$1(t2), r3 = void 0 === r3 ? n2 < t2 ? 1 : -1 : ei$1(r3), Bi$1(n2, t2, r3);
  };
}();
var Li$1 = function(e10, n2) {
  var t2 = e10.length;
  for (e10.sort(n2); t2--; ) e10[t2] = e10[t2].value;
  return e10;
};
var Ri$1 = function(e10, n2) {
  if (e10 !== n2) {
    var t2 = void 0 !== e10, r3 = null === e10, o2 = e10 == e10, i2 = Pt$1(e10), a2 = void 0 !== n2, u2 = null === n2, c3 = n2 == n2, s2 = Pt$1(n2);
    if (!u2 && !s2 && !i2 && e10 > n2 || i2 && a2 && c3 && !u2 && !s2 || r3 && a2 && c3 || !t2 && c3 || !o2) return 1;
    if (!r3 && !i2 && !s2 && e10 < n2 || s2 && t2 && o2 && !r3 && !i2 || u2 && t2 && o2 || !a2 && o2 || !c3) return -1;
  }
  return 0;
};
var Ti$1 = function(e10, n2, t2) {
  for (var r3 = -1, o2 = e10.criteria, i2 = n2.criteria, a2 = o2.length, u2 = t2.length; ++r3 < a2; ) {
    var c3 = Ri$1(o2[r3], i2[r3]);
    if (c3) return r3 >= u2 ? c3 : c3 * ("desc" == t2[r3] ? -1 : 1);
  }
  return e10.index - n2.index;
};
var Di$1 = function(e10, n2, t2) {
  n2 = n2.length ? Yt$1(n2, function(e11) {
    return Te$1(e11) ? function(n3) {
      return nr$1(n3, 1 === e11.length ? e11[0] : e11);
    } : e11;
  }) : [ht$1];
  var r3 = -1;
  n2 = Yt$1(n2, He$1(dr$1));
  var o2 = br$1(e10, function(e11, t3, o3) {
    return { criteria: Yt$1(n2, function(n3) {
      return n3(e11);
    }), index: ++r3, value: e11 };
  });
  return Li$1(o2, function(e11, n3) {
    return Ti$1(e11, n3, t2);
  });
}, Pi$1 = Xr$1(function(e10, n2) {
  if (null == e10) return [];
  var t2 = n2.length;
  return t2 > 1 && Vo$1(e10, n2[0], n2[1]) ? n2 = [] : t2 > 2 && Vo$1(n2[0], n2[1], n2[2]) && (n2 = [n2[0]]), Di$1(e10, Vr$1(n2), []);
}), zi$1 = 0;
var Fi$1 = function(e10) {
  var n2 = ++zi$1;
  return Qt$1(e10) + n2;
};
var Ui$1 = function(e10, n2, t2) {
  for (var r3 = -1, o2 = e10.length, i2 = n2.length, a2 = {}; ++r3 < o2; ) {
    var u2 = r3 < i2 ? n2[r3] : void 0;
    t2(a2, e10[r3], u2);
  }
  return a2;
};
var Vi$1, $i$1 = function(e10, n2) {
  return Ui$1(e10 || [], n2 || [], Ie$1);
};
try {
  Vi$1 = { cloneDeep: Uo$1, constant: ct$1, defaults: Wo$1, each: pt$1, filter: fr$1, find: ri$1, flatten: oi$1, forEach: vt$1, forIn: ii$1, has: vr$1, isUndefined: yr$1, last: ai$1, map: mr$1, mapValues: ui$1, max: di$1, merge: _i$1, min: xi$1, minBy: Ni$1, now: Oi$1, pick: Mi$1, range: Ai$1, reduce: _r$1, sortBy: Pi$1, uniqueId: Fi$1, values: fo$1, zipObject: $i$1 };
} catch (e10) {
}
Vi$1 || (Vi$1 = window._);
var Hi$1 = Vi$1;
Fo$1.Graph;
Hi$1.constant(1);
Fo$1.Graph;
Fo$1.Graph;
Fo$1.alg.preorder;
Fo$1.alg.postorder;
Fo$1.Graph;
Fo$1.Graph;
Fo$1.Graph;
Fo$1.Graph;
Fo$1.Graph;
function _typeof$1(o2) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof$1(o2);
}
function toPrimitive(t2, r3) {
  if ("object" != _typeof$1(t2) || !t2) return t2;
  var e10 = t2[Symbol.toPrimitive];
  if (void 0 !== e10) {
    var i2 = e10.call(t2, r3);
    if ("object" != _typeof$1(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r3 ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i2 = toPrimitive(t2, "string");
  return "symbol" == _typeof$1(i2) ? i2 : i2 + "";
}
function _defineProperty(e10, r3, t2) {
  return (r3 = toPropertyKey(r3)) in e10 ? Object.defineProperty(e10, r3, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e10[r3] = t2, e10;
}
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal || freeSelf || Function("return this")();
var _root = root$1;
var root = _root;
var Symbol$3 = root.Symbol;
var _Symbol = Symbol$3;
var Symbol$2 = _Symbol;
Symbol$2 ? Symbol$2.toStringTag : void 0;
var Symbol$1 = _Symbol;
Symbol$1 ? Symbol$1.toStringTag : void 0;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types2 = freeModule && freeModule.require && freeModule.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e10) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var nodeUtil = _nodeUtilExports;
nodeUtil && nodeUtil.isTypedArray;
var regeneratorRuntime$1 = { exports: {} };
var _typeof = { exports: {} };
(function(module) {
  function _typeof2(o2) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
      return typeof o3;
    } : function(o3) {
      return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(o2);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof);
var _typeofExports = _typeof.exports;
(function(module) {
  var _typeof2 = _typeofExports["default"];
  function _regeneratorRuntime() {
    module.exports = _regeneratorRuntime = function _regeneratorRuntime2() {
      return r3;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t2, r3 = {}, e10 = Object.prototype, n2 = e10.hasOwnProperty, o2 = "function" == typeof Symbol ? Symbol : {}, i2 = o2.iterator || "@@iterator", a2 = o2.asyncIterator || "@@asyncIterator", u2 = o2.toStringTag || "@@toStringTag";
    function c3(t3, r4, e11, n3) {
      return Object.defineProperty(t3, r4, {
        value: e11,
        enumerable: !n3,
        configurable: !n3,
        writable: !n3
      });
    }
    try {
      c3({}, "");
    } catch (t3) {
      c3 = function c4(t4, r4, e11) {
        return t4[r4] = e11;
      };
    }
    function h2(r4, e11, n3, o3) {
      var i3 = e11 && e11.prototype instanceof Generator ? e11 : Generator, a3 = Object.create(i3.prototype);
      return c3(a3, "_invoke", /* @__PURE__ */ function(r5, e12, n4) {
        var o4 = 1;
        return function(i4, a4) {
          if (3 === o4) throw Error("Generator is already running");
          if (4 === o4) {
            if ("throw" === i4) throw a4;
            return {
              value: t2,
              done: true
            };
          }
          for (n4.method = i4, n4.arg = a4; ; ) {
            var u3 = n4.delegate;
            if (u3) {
              var c4 = d2(u3, n4);
              if (c4) {
                if (c4 === f2) continue;
                return c4;
              }
            }
            if ("next" === n4.method) n4.sent = n4._sent = n4.arg;
            else if ("throw" === n4.method) {
              if (1 === o4) throw o4 = 4, n4.arg;
              n4.dispatchException(n4.arg);
            } else "return" === n4.method && n4.abrupt("return", n4.arg);
            o4 = 3;
            var h3 = s2(r5, e12, n4);
            if ("normal" === h3.type) {
              if (o4 = n4.done ? 4 : 2, h3.arg === f2) continue;
              return {
                value: h3.arg,
                done: n4.done
              };
            }
            "throw" === h3.type && (o4 = 4, n4.method = "throw", n4.arg = h3.arg);
          }
        };
      }(r4, n3, new Context(o3 || [])), true), a3;
    }
    function s2(t3, r4, e11) {
      try {
        return {
          type: "normal",
          arg: t3.call(r4, e11)
        };
      } catch (t4) {
        return {
          type: "throw",
          arg: t4
        };
      }
    }
    r3.wrap = h2;
    var f2 = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var l2 = {};
    c3(l2, i2, function() {
      return this;
    });
    var p2 = Object.getPrototypeOf, y2 = p2 && p2(p2(x2([])));
    y2 && y2 !== e10 && n2.call(y2, i2) && (l2 = y2);
    var v2 = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l2);
    function g2(t3) {
      ["next", "throw", "return"].forEach(function(r4) {
        c3(t3, r4, function(t4) {
          return this._invoke(r4, t4);
        });
      });
    }
    function AsyncIterator(t3, r4) {
      function e11(o4, i3, a3, u3) {
        var c4 = s2(t3[o4], t3, i3);
        if ("throw" !== c4.type) {
          var h3 = c4.arg, f3 = h3.value;
          return f3 && "object" == _typeof2(f3) && n2.call(f3, "__await") ? r4.resolve(f3.__await).then(function(t4) {
            e11("next", t4, a3, u3);
          }, function(t4) {
            e11("throw", t4, a3, u3);
          }) : r4.resolve(f3).then(function(t4) {
            h3.value = t4, a3(h3);
          }, function(t4) {
            return e11("throw", t4, a3, u3);
          });
        }
        u3(c4.arg);
      }
      var o3;
      c3(this, "_invoke", function(t4, n3) {
        function i3() {
          return new r4(function(r5, o4) {
            e11(t4, n3, r5, o4);
          });
        }
        return o3 = o3 ? o3.then(i3, i3) : i3();
      }, true);
    }
    function d2(r4, e11) {
      var n3 = e11.method, o3 = r4.i[n3];
      if (o3 === t2) return e11.delegate = null, "throw" === n3 && r4.i["return"] && (e11.method = "return", e11.arg = t2, d2(r4, e11), "throw" === e11.method) || "return" !== n3 && (e11.method = "throw", e11.arg = new TypeError("The iterator does not provide a '" + n3 + "' method")), f2;
      var i3 = s2(o3, r4.i, e11.arg);
      if ("throw" === i3.type) return e11.method = "throw", e11.arg = i3.arg, e11.delegate = null, f2;
      var a3 = i3.arg;
      return a3 ? a3.done ? (e11[r4.r] = a3.value, e11.next = r4.n, "return" !== e11.method && (e11.method = "next", e11.arg = t2), e11.delegate = null, f2) : a3 : (e11.method = "throw", e11.arg = new TypeError("iterator result is not an object"), e11.delegate = null, f2);
    }
    function w2(t3) {
      this.tryEntries.push(t3);
    }
    function m2(r4) {
      var e11 = r4[4] || {};
      e11.type = "normal", e11.arg = t2, r4[4] = e11;
    }
    function Context(t3) {
      this.tryEntries = [[-1]], t3.forEach(w2, this), this.reset(true);
    }
    function x2(r4) {
      if (null != r4) {
        var e11 = r4[i2];
        if (e11) return e11.call(r4);
        if ("function" == typeof r4.next) return r4;
        if (!isNaN(r4.length)) {
          var o3 = -1, a3 = function e12() {
            for (; ++o3 < r4.length; ) if (n2.call(r4, o3)) return e12.value = r4[o3], e12.done = false, e12;
            return e12.value = t2, e12.done = true, e12;
          };
          return a3.next = a3;
        }
      }
      throw new TypeError(_typeof2(r4) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c3(v2, "constructor", GeneratorFunctionPrototype), c3(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c3(GeneratorFunctionPrototype, u2, "GeneratorFunction"), r3.isGeneratorFunction = function(t3) {
      var r4 = "function" == typeof t3 && t3.constructor;
      return !!r4 && (r4 === GeneratorFunction || "GeneratorFunction" === (r4.displayName || r4.name));
    }, r3.mark = function(t3) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, c3(t3, u2, "GeneratorFunction")), t3.prototype = Object.create(v2), t3;
    }, r3.awrap = function(t3) {
      return {
        __await: t3
      };
    }, g2(AsyncIterator.prototype), c3(AsyncIterator.prototype, a2, function() {
      return this;
    }), r3.AsyncIterator = AsyncIterator, r3.async = function(t3, e11, n3, o3, i3) {
      void 0 === i3 && (i3 = Promise);
      var a3 = new AsyncIterator(h2(t3, e11, n3, o3), i3);
      return r3.isGeneratorFunction(e11) ? a3 : a3.next().then(function(t4) {
        return t4.done ? t4.value : a3.next();
      });
    }, g2(v2), c3(v2, u2, "Generator"), c3(v2, i2, function() {
      return this;
    }), c3(v2, "toString", function() {
      return "[object Generator]";
    }), r3.keys = function(t3) {
      var r4 = Object(t3), e11 = [];
      for (var n3 in r4) e11.unshift(n3);
      return function t4() {
        for (; e11.length; ) if ((n3 = e11.pop()) in r4) return t4.value = n3, t4.done = false, t4;
        return t4.done = true, t4;
      };
    }, r3.values = x2, Context.prototype = {
      constructor: Context,
      reset: function reset(r4) {
        if (this.prev = this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(m2), !r4) for (var e11 in this) "t" === e11.charAt(0) && n2.call(this, e11) && !isNaN(+e11.slice(1)) && (this[e11] = t2);
      },
      stop: function stop() {
        this.done = true;
        var t3 = this.tryEntries[0][4];
        if ("throw" === t3.type) throw t3.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(r4) {
        if (this.done) throw r4;
        var e11 = this;
        function n3(t3) {
          a3.type = "throw", a3.arg = r4, e11.next = t3;
        }
        for (var o3 = e11.tryEntries.length - 1; o3 >= 0; --o3) {
          var i3 = this.tryEntries[o3], a3 = i3[4], u3 = this.prev, c4 = i3[1], h3 = i3[2];
          if (-1 === i3[0]) return n3("end"), false;
          if (!c4 && !h3) throw Error("try statement without catch or finally");
          if (null != i3[0] && i3[0] <= u3) {
            if (u3 < c4) return this.method = "next", this.arg = t2, n3(c4), true;
            if (u3 < h3) return n3(h3), false;
          }
        }
      },
      abrupt: function abrupt(t3, r4) {
        for (var e11 = this.tryEntries.length - 1; e11 >= 0; --e11) {
          var n3 = this.tryEntries[e11];
          if (n3[0] > -1 && n3[0] <= this.prev && this.prev < n3[2]) {
            var o3 = n3;
            break;
          }
        }
        o3 && ("break" === t3 || "continue" === t3) && o3[0] <= r4 && r4 <= o3[2] && (o3 = null);
        var i3 = o3 ? o3[4] : {};
        return i3.type = t3, i3.arg = r4, o3 ? (this.method = "next", this.next = o3[2], f2) : this.complete(i3);
      },
      complete: function complete(t3, r4) {
        if ("throw" === t3.type) throw t3.arg;
        return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && r4 && (this.next = r4), f2;
      },
      finish: function finish(t3) {
        for (var r4 = this.tryEntries.length - 1; r4 >= 0; --r4) {
          var e11 = this.tryEntries[r4];
          if (e11[2] === t3) return this.complete(e11[4], e11[3]), m2(e11), f2;
        }
      },
      "catch": function _catch(t3) {
        for (var r4 = this.tryEntries.length - 1; r4 >= 0; --r4) {
          var e11 = this.tryEntries[r4];
          if (e11[0] === t3) {
            var n3 = e11[4];
            if ("throw" === n3.type) {
              var o3 = n3.arg;
              m2(e11);
            }
            return o3;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(r4, e11, n3) {
        return this.delegate = {
          i: x2(r4),
          r: e11,
          n: n3
        }, "next" === this.method && (this.arg = t2), f2;
      }
    }, r3;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
var runtime = regeneratorRuntimeExports();
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var gl$1;
(function(gl2) {
  gl2[gl2["DEPTH_BUFFER_BIT"] = 256] = "DEPTH_BUFFER_BIT";
  gl2[gl2["STENCIL_BUFFER_BIT"] = 1024] = "STENCIL_BUFFER_BIT";
  gl2[gl2["COLOR_BUFFER_BIT"] = 16384] = "COLOR_BUFFER_BIT";
  gl2[gl2["POINTS"] = 0] = "POINTS";
  gl2[gl2["LINES"] = 1] = "LINES";
  gl2[gl2["LINE_LOOP"] = 2] = "LINE_LOOP";
  gl2[gl2["LINE_STRIP"] = 3] = "LINE_STRIP";
  gl2[gl2["TRIANGLES"] = 4] = "TRIANGLES";
  gl2[gl2["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
  gl2[gl2["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
  gl2[gl2["ZERO"] = 0] = "ZERO";
  gl2[gl2["ONE"] = 1] = "ONE";
  gl2[gl2["SRC_COLOR"] = 768] = "SRC_COLOR";
  gl2[gl2["ONE_MINUS_SRC_COLOR"] = 769] = "ONE_MINUS_SRC_COLOR";
  gl2[gl2["SRC_ALPHA"] = 770] = "SRC_ALPHA";
  gl2[gl2["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
  gl2[gl2["DST_ALPHA"] = 772] = "DST_ALPHA";
  gl2[gl2["ONE_MINUS_DST_ALPHA"] = 773] = "ONE_MINUS_DST_ALPHA";
  gl2[gl2["DST_COLOR"] = 774] = "DST_COLOR";
  gl2[gl2["ONE_MINUS_DST_COLOR"] = 775] = "ONE_MINUS_DST_COLOR";
  gl2[gl2["SRC_ALPHA_SATURATE"] = 776] = "SRC_ALPHA_SATURATE";
  gl2[gl2["FUNC_ADD"] = 32774] = "FUNC_ADD";
  gl2[gl2["BLEND_EQUATION"] = 32777] = "BLEND_EQUATION";
  gl2[gl2["BLEND_EQUATION_RGB"] = 32777] = "BLEND_EQUATION_RGB";
  gl2[gl2["BLEND_EQUATION_ALPHA"] = 34877] = "BLEND_EQUATION_ALPHA";
  gl2[gl2["FUNC_SUBTRACT"] = 32778] = "FUNC_SUBTRACT";
  gl2[gl2["FUNC_REVERSE_SUBTRACT"] = 32779] = "FUNC_REVERSE_SUBTRACT";
  gl2[gl2["MAX_EXT"] = 32776] = "MAX_EXT";
  gl2[gl2["MIN_EXT"] = 32775] = "MIN_EXT";
  gl2[gl2["BLEND_DST_RGB"] = 32968] = "BLEND_DST_RGB";
  gl2[gl2["BLEND_SRC_RGB"] = 32969] = "BLEND_SRC_RGB";
  gl2[gl2["BLEND_DST_ALPHA"] = 32970] = "BLEND_DST_ALPHA";
  gl2[gl2["BLEND_SRC_ALPHA"] = 32971] = "BLEND_SRC_ALPHA";
  gl2[gl2["CONSTANT_COLOR"] = 32769] = "CONSTANT_COLOR";
  gl2[gl2["ONE_MINUS_CONSTANT_COLOR"] = 32770] = "ONE_MINUS_CONSTANT_COLOR";
  gl2[gl2["CONSTANT_ALPHA"] = 32771] = "CONSTANT_ALPHA";
  gl2[gl2["ONE_MINUS_CONSTANT_ALPHA"] = 32772] = "ONE_MINUS_CONSTANT_ALPHA";
  gl2[gl2["BLEND_COLOR"] = 32773] = "BLEND_COLOR";
  gl2[gl2["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
  gl2[gl2["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
  gl2[gl2["ARRAY_BUFFER_BINDING"] = 34964] = "ARRAY_BUFFER_BINDING";
  gl2[gl2["ELEMENT_ARRAY_BUFFER_BINDING"] = 34965] = "ELEMENT_ARRAY_BUFFER_BINDING";
  gl2[gl2["STREAM_DRAW"] = 35040] = "STREAM_DRAW";
  gl2[gl2["STATIC_DRAW"] = 35044] = "STATIC_DRAW";
  gl2[gl2["DYNAMIC_DRAW"] = 35048] = "DYNAMIC_DRAW";
  gl2[gl2["BUFFER_SIZE"] = 34660] = "BUFFER_SIZE";
  gl2[gl2["BUFFER_USAGE"] = 34661] = "BUFFER_USAGE";
  gl2[gl2["CURRENT_VERTEX_ATTRIB"] = 34342] = "CURRENT_VERTEX_ATTRIB";
  gl2[gl2["FRONT"] = 1028] = "FRONT";
  gl2[gl2["BACK"] = 1029] = "BACK";
  gl2[gl2["FRONT_AND_BACK"] = 1032] = "FRONT_AND_BACK";
  gl2[gl2["CULL_FACE"] = 2884] = "CULL_FACE";
  gl2[gl2["BLEND"] = 3042] = "BLEND";
  gl2[gl2["DITHER"] = 3024] = "DITHER";
  gl2[gl2["STENCIL_TEST"] = 2960] = "STENCIL_TEST";
  gl2[gl2["DEPTH_TEST"] = 2929] = "DEPTH_TEST";
  gl2[gl2["SCISSOR_TEST"] = 3089] = "SCISSOR_TEST";
  gl2[gl2["POLYGON_OFFSET_FILL"] = 32823] = "POLYGON_OFFSET_FILL";
  gl2[gl2["SAMPLE_ALPHA_TO_COVERAGE"] = 32926] = "SAMPLE_ALPHA_TO_COVERAGE";
  gl2[gl2["SAMPLE_COVERAGE"] = 32928] = "SAMPLE_COVERAGE";
  gl2[gl2["NO_ERROR"] = 0] = "NO_ERROR";
  gl2[gl2["INVALID_ENUM"] = 1280] = "INVALID_ENUM";
  gl2[gl2["INVALID_VALUE"] = 1281] = "INVALID_VALUE";
  gl2[gl2["INVALID_OPERATION"] = 1282] = "INVALID_OPERATION";
  gl2[gl2["OUT_OF_MEMORY"] = 1285] = "OUT_OF_MEMORY";
  gl2[gl2["CW"] = 2304] = "CW";
  gl2[gl2["CCW"] = 2305] = "CCW";
  gl2[gl2["LINE_WIDTH"] = 2849] = "LINE_WIDTH";
  gl2[gl2["ALIASED_POINT_SIZE_RANGE"] = 33901] = "ALIASED_POINT_SIZE_RANGE";
  gl2[gl2["ALIASED_LINE_WIDTH_RANGE"] = 33902] = "ALIASED_LINE_WIDTH_RANGE";
  gl2[gl2["CULL_FACE_MODE"] = 2885] = "CULL_FACE_MODE";
  gl2[gl2["FRONT_FACE"] = 2886] = "FRONT_FACE";
  gl2[gl2["DEPTH_RANGE"] = 2928] = "DEPTH_RANGE";
  gl2[gl2["DEPTH_WRITEMASK"] = 2930] = "DEPTH_WRITEMASK";
  gl2[gl2["DEPTH_CLEAR_VALUE"] = 2931] = "DEPTH_CLEAR_VALUE";
  gl2[gl2["DEPTH_FUNC"] = 2932] = "DEPTH_FUNC";
  gl2[gl2["STENCIL_CLEAR_VALUE"] = 2961] = "STENCIL_CLEAR_VALUE";
  gl2[gl2["STENCIL_FUNC"] = 2962] = "STENCIL_FUNC";
  gl2[gl2["STENCIL_FAIL"] = 2964] = "STENCIL_FAIL";
  gl2[gl2["STENCIL_PASS_DEPTH_FAIL"] = 2965] = "STENCIL_PASS_DEPTH_FAIL";
  gl2[gl2["STENCIL_PASS_DEPTH_PASS"] = 2966] = "STENCIL_PASS_DEPTH_PASS";
  gl2[gl2["STENCIL_REF"] = 2967] = "STENCIL_REF";
  gl2[gl2["STENCIL_VALUE_MASK"] = 2963] = "STENCIL_VALUE_MASK";
  gl2[gl2["STENCIL_WRITEMASK"] = 2968] = "STENCIL_WRITEMASK";
  gl2[gl2["STENCIL_BACK_FUNC"] = 34816] = "STENCIL_BACK_FUNC";
  gl2[gl2["STENCIL_BACK_FAIL"] = 34817] = "STENCIL_BACK_FAIL";
  gl2[gl2["STENCIL_BACK_PASS_DEPTH_FAIL"] = 34818] = "STENCIL_BACK_PASS_DEPTH_FAIL";
  gl2[gl2["STENCIL_BACK_PASS_DEPTH_PASS"] = 34819] = "STENCIL_BACK_PASS_DEPTH_PASS";
  gl2[gl2["STENCIL_BACK_REF"] = 36003] = "STENCIL_BACK_REF";
  gl2[gl2["STENCIL_BACK_VALUE_MASK"] = 36004] = "STENCIL_BACK_VALUE_MASK";
  gl2[gl2["STENCIL_BACK_WRITEMASK"] = 36005] = "STENCIL_BACK_WRITEMASK";
  gl2[gl2["VIEWPORT"] = 2978] = "VIEWPORT";
  gl2[gl2["SCISSOR_BOX"] = 3088] = "SCISSOR_BOX";
  gl2[gl2["COLOR_CLEAR_VALUE"] = 3106] = "COLOR_CLEAR_VALUE";
  gl2[gl2["COLOR_WRITEMASK"] = 3107] = "COLOR_WRITEMASK";
  gl2[gl2["UNPACK_ALIGNMENT"] = 3317] = "UNPACK_ALIGNMENT";
  gl2[gl2["PACK_ALIGNMENT"] = 3333] = "PACK_ALIGNMENT";
  gl2[gl2["MAX_TEXTURE_SIZE"] = 3379] = "MAX_TEXTURE_SIZE";
  gl2[gl2["MAX_VIEWPORT_DIMS"] = 3386] = "MAX_VIEWPORT_DIMS";
  gl2[gl2["SUBPIXEL_BITS"] = 3408] = "SUBPIXEL_BITS";
  gl2[gl2["RED_BITS"] = 3410] = "RED_BITS";
  gl2[gl2["GREEN_BITS"] = 3411] = "GREEN_BITS";
  gl2[gl2["BLUE_BITS"] = 3412] = "BLUE_BITS";
  gl2[gl2["ALPHA_BITS"] = 3413] = "ALPHA_BITS";
  gl2[gl2["DEPTH_BITS"] = 3414] = "DEPTH_BITS";
  gl2[gl2["STENCIL_BITS"] = 3415] = "STENCIL_BITS";
  gl2[gl2["POLYGON_OFFSET_UNITS"] = 10752] = "POLYGON_OFFSET_UNITS";
  gl2[gl2["POLYGON_OFFSET_FACTOR"] = 32824] = "POLYGON_OFFSET_FACTOR";
  gl2[gl2["TEXTURE_BINDING_2D"] = 32873] = "TEXTURE_BINDING_2D";
  gl2[gl2["SAMPLE_BUFFERS"] = 32936] = "SAMPLE_BUFFERS";
  gl2[gl2["SAMPLES"] = 32937] = "SAMPLES";
  gl2[gl2["SAMPLE_COVERAGE_VALUE"] = 32938] = "SAMPLE_COVERAGE_VALUE";
  gl2[gl2["SAMPLE_COVERAGE_INVERT"] = 32939] = "SAMPLE_COVERAGE_INVERT";
  gl2[gl2["COMPRESSED_TEXTURE_FORMATS"] = 34467] = "COMPRESSED_TEXTURE_FORMATS";
  gl2[gl2["DONT_CARE"] = 4352] = "DONT_CARE";
  gl2[gl2["FASTEST"] = 4353] = "FASTEST";
  gl2[gl2["NICEST"] = 4354] = "NICEST";
  gl2[gl2["GENERATE_MIPMAP_HINT"] = 33170] = "GENERATE_MIPMAP_HINT";
  gl2[gl2["BYTE"] = 5120] = "BYTE";
  gl2[gl2["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
  gl2[gl2["SHORT"] = 5122] = "SHORT";
  gl2[gl2["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
  gl2[gl2["INT"] = 5124] = "INT";
  gl2[gl2["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
  gl2[gl2["FLOAT"] = 5126] = "FLOAT";
  gl2[gl2["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
  gl2[gl2["ALPHA"] = 6406] = "ALPHA";
  gl2[gl2["RGB"] = 6407] = "RGB";
  gl2[gl2["RGBA"] = 6408] = "RGBA";
  gl2[gl2["LUMINANCE"] = 6409] = "LUMINANCE";
  gl2[gl2["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
  gl2[gl2["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
  gl2[gl2["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
  gl2[gl2["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
  gl2[gl2["FRAGMENT_SHADER"] = 35632] = "FRAGMENT_SHADER";
  gl2[gl2["VERTEX_SHADER"] = 35633] = "VERTEX_SHADER";
  gl2[gl2["MAX_VERTEX_ATTRIBS"] = 34921] = "MAX_VERTEX_ATTRIBS";
  gl2[gl2["MAX_VERTEX_UNIFORM_VECTORS"] = 36347] = "MAX_VERTEX_UNIFORM_VECTORS";
  gl2[gl2["MAX_VARYING_VECTORS"] = 36348] = "MAX_VARYING_VECTORS";
  gl2[gl2["MAX_COMBINED_TEXTURE_IMAGE_UNITS"] = 35661] = "MAX_COMBINED_TEXTURE_IMAGE_UNITS";
  gl2[gl2["MAX_VERTEX_TEXTURE_IMAGE_UNITS"] = 35660] = "MAX_VERTEX_TEXTURE_IMAGE_UNITS";
  gl2[gl2["MAX_TEXTURE_IMAGE_UNITS"] = 34930] = "MAX_TEXTURE_IMAGE_UNITS";
  gl2[gl2["MAX_FRAGMENT_UNIFORM_VECTORS"] = 36349] = "MAX_FRAGMENT_UNIFORM_VECTORS";
  gl2[gl2["SHADER_TYPE"] = 35663] = "SHADER_TYPE";
  gl2[gl2["DELETE_STATUS"] = 35712] = "DELETE_STATUS";
  gl2[gl2["LINK_STATUS"] = 35714] = "LINK_STATUS";
  gl2[gl2["VALIDATE_STATUS"] = 35715] = "VALIDATE_STATUS";
  gl2[gl2["ATTACHED_SHADERS"] = 35717] = "ATTACHED_SHADERS";
  gl2[gl2["ACTIVE_UNIFORMS"] = 35718] = "ACTIVE_UNIFORMS";
  gl2[gl2["ACTIVE_ATTRIBUTES"] = 35721] = "ACTIVE_ATTRIBUTES";
  gl2[gl2["SHADING_LANGUAGE_VERSION"] = 35724] = "SHADING_LANGUAGE_VERSION";
  gl2[gl2["CURRENT_PROGRAM"] = 35725] = "CURRENT_PROGRAM";
  gl2[gl2["NEVER"] = 512] = "NEVER";
  gl2[gl2["LESS"] = 513] = "LESS";
  gl2[gl2["EQUAL"] = 514] = "EQUAL";
  gl2[gl2["LEQUAL"] = 515] = "LEQUAL";
  gl2[gl2["GREATER"] = 516] = "GREATER";
  gl2[gl2["NOTEQUAL"] = 517] = "NOTEQUAL";
  gl2[gl2["GEQUAL"] = 518] = "GEQUAL";
  gl2[gl2["ALWAYS"] = 519] = "ALWAYS";
  gl2[gl2["KEEP"] = 7680] = "KEEP";
  gl2[gl2["REPLACE"] = 7681] = "REPLACE";
  gl2[gl2["INCR"] = 7682] = "INCR";
  gl2[gl2["DECR"] = 7683] = "DECR";
  gl2[gl2["INVERT"] = 5386] = "INVERT";
  gl2[gl2["INCR_WRAP"] = 34055] = "INCR_WRAP";
  gl2[gl2["DECR_WRAP"] = 34056] = "DECR_WRAP";
  gl2[gl2["VENDOR"] = 7936] = "VENDOR";
  gl2[gl2["RENDERER"] = 7937] = "RENDERER";
  gl2[gl2["VERSION"] = 7938] = "VERSION";
  gl2[gl2["NEAREST"] = 9728] = "NEAREST";
  gl2[gl2["LINEAR"] = 9729] = "LINEAR";
  gl2[gl2["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
  gl2[gl2["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
  gl2[gl2["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
  gl2[gl2["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
  gl2[gl2["TEXTURE_MAG_FILTER"] = 10240] = "TEXTURE_MAG_FILTER";
  gl2[gl2["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
  gl2[gl2["TEXTURE_WRAP_S"] = 10242] = "TEXTURE_WRAP_S";
  gl2[gl2["TEXTURE_WRAP_T"] = 10243] = "TEXTURE_WRAP_T";
  gl2[gl2["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
  gl2[gl2["TEXTURE"] = 5890] = "TEXTURE";
  gl2[gl2["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
  gl2[gl2["TEXTURE_BINDING_CUBE_MAP"] = 34068] = "TEXTURE_BINDING_CUBE_MAP";
  gl2[gl2["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
  gl2[gl2["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
  gl2[gl2["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
  gl2[gl2["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
  gl2[gl2["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
  gl2[gl2["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
  gl2[gl2["MAX_CUBE_MAP_TEXTURE_SIZE"] = 34076] = "MAX_CUBE_MAP_TEXTURE_SIZE";
  gl2[gl2["TEXTURE0"] = 33984] = "TEXTURE0";
  gl2[gl2["TEXTURE1"] = 33985] = "TEXTURE1";
  gl2[gl2["TEXTURE2"] = 33986] = "TEXTURE2";
  gl2[gl2["TEXTURE3"] = 33987] = "TEXTURE3";
  gl2[gl2["TEXTURE4"] = 33988] = "TEXTURE4";
  gl2[gl2["TEXTURE5"] = 33989] = "TEXTURE5";
  gl2[gl2["TEXTURE6"] = 33990] = "TEXTURE6";
  gl2[gl2["TEXTURE7"] = 33991] = "TEXTURE7";
  gl2[gl2["TEXTURE8"] = 33992] = "TEXTURE8";
  gl2[gl2["TEXTURE9"] = 33993] = "TEXTURE9";
  gl2[gl2["TEXTURE10"] = 33994] = "TEXTURE10";
  gl2[gl2["TEXTURE11"] = 33995] = "TEXTURE11";
  gl2[gl2["TEXTURE12"] = 33996] = "TEXTURE12";
  gl2[gl2["TEXTURE13"] = 33997] = "TEXTURE13";
  gl2[gl2["TEXTURE14"] = 33998] = "TEXTURE14";
  gl2[gl2["TEXTURE15"] = 33999] = "TEXTURE15";
  gl2[gl2["TEXTURE16"] = 34e3] = "TEXTURE16";
  gl2[gl2["TEXTURE17"] = 34001] = "TEXTURE17";
  gl2[gl2["TEXTURE18"] = 34002] = "TEXTURE18";
  gl2[gl2["TEXTURE19"] = 34003] = "TEXTURE19";
  gl2[gl2["TEXTURE20"] = 34004] = "TEXTURE20";
  gl2[gl2["TEXTURE21"] = 34005] = "TEXTURE21";
  gl2[gl2["TEXTURE22"] = 34006] = "TEXTURE22";
  gl2[gl2["TEXTURE23"] = 34007] = "TEXTURE23";
  gl2[gl2["TEXTURE24"] = 34008] = "TEXTURE24";
  gl2[gl2["TEXTURE25"] = 34009] = "TEXTURE25";
  gl2[gl2["TEXTURE26"] = 34010] = "TEXTURE26";
  gl2[gl2["TEXTURE27"] = 34011] = "TEXTURE27";
  gl2[gl2["TEXTURE28"] = 34012] = "TEXTURE28";
  gl2[gl2["TEXTURE29"] = 34013] = "TEXTURE29";
  gl2[gl2["TEXTURE30"] = 34014] = "TEXTURE30";
  gl2[gl2["TEXTURE31"] = 34015] = "TEXTURE31";
  gl2[gl2["ACTIVE_TEXTURE"] = 34016] = "ACTIVE_TEXTURE";
  gl2[gl2["REPEAT"] = 10497] = "REPEAT";
  gl2[gl2["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
  gl2[gl2["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
  gl2[gl2["FLOAT_VEC2"] = 35664] = "FLOAT_VEC2";
  gl2[gl2["FLOAT_VEC3"] = 35665] = "FLOAT_VEC3";
  gl2[gl2["FLOAT_VEC4"] = 35666] = "FLOAT_VEC4";
  gl2[gl2["INT_VEC2"] = 35667] = "INT_VEC2";
  gl2[gl2["INT_VEC3"] = 35668] = "INT_VEC3";
  gl2[gl2["INT_VEC4"] = 35669] = "INT_VEC4";
  gl2[gl2["BOOL"] = 35670] = "BOOL";
  gl2[gl2["BOOL_VEC2"] = 35671] = "BOOL_VEC2";
  gl2[gl2["BOOL_VEC3"] = 35672] = "BOOL_VEC3";
  gl2[gl2["BOOL_VEC4"] = 35673] = "BOOL_VEC4";
  gl2[gl2["FLOAT_MAT2"] = 35674] = "FLOAT_MAT2";
  gl2[gl2["FLOAT_MAT3"] = 35675] = "FLOAT_MAT3";
  gl2[gl2["FLOAT_MAT4"] = 35676] = "FLOAT_MAT4";
  gl2[gl2["SAMPLER_2D"] = 35678] = "SAMPLER_2D";
  gl2[gl2["SAMPLER_CUBE"] = 35680] = "SAMPLER_CUBE";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_ENABLED"] = 34338] = "VERTEX_ATTRIB_ARRAY_ENABLED";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_SIZE"] = 34339] = "VERTEX_ATTRIB_ARRAY_SIZE";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_STRIDE"] = 34340] = "VERTEX_ATTRIB_ARRAY_STRIDE";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_TYPE"] = 34341] = "VERTEX_ATTRIB_ARRAY_TYPE";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_NORMALIZED"] = 34922] = "VERTEX_ATTRIB_ARRAY_NORMALIZED";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_POINTER"] = 34373] = "VERTEX_ATTRIB_ARRAY_POINTER";
  gl2[gl2["VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"] = 34975] = "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING";
  gl2[gl2["COMPILE_STATUS"] = 35713] = "COMPILE_STATUS";
  gl2[gl2["LOW_FLOAT"] = 36336] = "LOW_FLOAT";
  gl2[gl2["MEDIUM_FLOAT"] = 36337] = "MEDIUM_FLOAT";
  gl2[gl2["HIGH_FLOAT"] = 36338] = "HIGH_FLOAT";
  gl2[gl2["LOW_INT"] = 36339] = "LOW_INT";
  gl2[gl2["MEDIUM_INT"] = 36340] = "MEDIUM_INT";
  gl2[gl2["HIGH_INT"] = 36341] = "HIGH_INT";
  gl2[gl2["FRAMEBUFFER"] = 36160] = "FRAMEBUFFER";
  gl2[gl2["RENDERBUFFER"] = 36161] = "RENDERBUFFER";
  gl2[gl2["RGBA4"] = 32854] = "RGBA4";
  gl2[gl2["RGB5_A1"] = 32855] = "RGB5_A1";
  gl2[gl2["RGB565"] = 36194] = "RGB565";
  gl2[gl2["DEPTH_COMPONENT16"] = 33189] = "DEPTH_COMPONENT16";
  gl2[gl2["STENCIL_INDEX"] = 6401] = "STENCIL_INDEX";
  gl2[gl2["STENCIL_INDEX8"] = 36168] = "STENCIL_INDEX8";
  gl2[gl2["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
  gl2[gl2["RENDERBUFFER_WIDTH"] = 36162] = "RENDERBUFFER_WIDTH";
  gl2[gl2["RENDERBUFFER_HEIGHT"] = 36163] = "RENDERBUFFER_HEIGHT";
  gl2[gl2["RENDERBUFFER_INTERNAL_FORMAT"] = 36164] = "RENDERBUFFER_INTERNAL_FORMAT";
  gl2[gl2["RENDERBUFFER_RED_SIZE"] = 36176] = "RENDERBUFFER_RED_SIZE";
  gl2[gl2["RENDERBUFFER_GREEN_SIZE"] = 36177] = "RENDERBUFFER_GREEN_SIZE";
  gl2[gl2["RENDERBUFFER_BLUE_SIZE"] = 36178] = "RENDERBUFFER_BLUE_SIZE";
  gl2[gl2["RENDERBUFFER_ALPHA_SIZE"] = 36179] = "RENDERBUFFER_ALPHA_SIZE";
  gl2[gl2["RENDERBUFFER_DEPTH_SIZE"] = 36180] = "RENDERBUFFER_DEPTH_SIZE";
  gl2[gl2["RENDERBUFFER_STENCIL_SIZE"] = 36181] = "RENDERBUFFER_STENCIL_SIZE";
  gl2[gl2["FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE"] = 36048] = "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE";
  gl2[gl2["FRAMEBUFFER_ATTACHMENT_OBJECT_NAME"] = 36049] = "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME";
  gl2[gl2["FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL"] = 36050] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL";
  gl2[gl2["FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE"] = 36051] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE";
  gl2[gl2["COLOR_ATTACHMENT0"] = 36064] = "COLOR_ATTACHMENT0";
  gl2[gl2["DEPTH_ATTACHMENT"] = 36096] = "DEPTH_ATTACHMENT";
  gl2[gl2["STENCIL_ATTACHMENT"] = 36128] = "STENCIL_ATTACHMENT";
  gl2[gl2["DEPTH_STENCIL_ATTACHMENT"] = 33306] = "DEPTH_STENCIL_ATTACHMENT";
  gl2[gl2["NONE"] = 0] = "NONE";
  gl2[gl2["FRAMEBUFFER_COMPLETE"] = 36053] = "FRAMEBUFFER_COMPLETE";
  gl2[gl2["FRAMEBUFFER_INCOMPLETE_ATTACHMENT"] = 36054] = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
  gl2[gl2["FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"] = 36055] = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
  gl2[gl2["FRAMEBUFFER_INCOMPLETE_DIMENSIONS"] = 36057] = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
  gl2[gl2["FRAMEBUFFER_UNSUPPORTED"] = 36061] = "FRAMEBUFFER_UNSUPPORTED";
  gl2[gl2["FRAMEBUFFER_BINDING"] = 36006] = "FRAMEBUFFER_BINDING";
  gl2[gl2["RENDERBUFFER_BINDING"] = 36007] = "RENDERBUFFER_BINDING";
  gl2[gl2["MAX_RENDERBUFFER_SIZE"] = 34024] = "MAX_RENDERBUFFER_SIZE";
  gl2[gl2["INVALID_FRAMEBUFFER_OPERATION"] = 1286] = "INVALID_FRAMEBUFFER_OPERATION";
  gl2[gl2["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
  gl2[gl2["UNPACK_PREMULTIPLY_ALPHA_WEBGL"] = 37441] = "UNPACK_PREMULTIPLY_ALPHA_WEBGL";
  gl2[gl2["CONTEXT_LOST_WEBGL"] = 37442] = "CONTEXT_LOST_WEBGL";
  gl2[gl2["UNPACK_COLORSPACE_CONVERSION_WEBGL"] = 37443] = "UNPACK_COLORSPACE_CONVERSION_WEBGL";
  gl2[gl2["BROWSER_DEFAULT_WEBGL"] = 37444] = "BROWSER_DEFAULT_WEBGL";
  gl2[gl2["COPY_SRC"] = 1] = "COPY_SRC";
  gl2[gl2["COPY_DST"] = 2] = "COPY_DST";
  gl2[gl2["SAMPLED"] = 4] = "SAMPLED";
  gl2[gl2["STORAGE"] = 8] = "STORAGE";
  gl2[gl2["RENDER_ATTACHMENT"] = 16] = "RENDER_ATTACHMENT";
})(gl$1 || (gl$1 = {}));
var AST_TOKEN_TYPES;
(function(AST_TOKEN_TYPES2) {
  AST_TOKEN_TYPES2["Void"] = "Void";
  AST_TOKEN_TYPES2["Boolean"] = "Boolean";
  AST_TOKEN_TYPES2["Float"] = "Float";
  AST_TOKEN_TYPES2["Uint32"] = "Uint32";
  AST_TOKEN_TYPES2["Int32"] = "Int32";
  AST_TOKEN_TYPES2["Vector"] = "Vector";
  AST_TOKEN_TYPES2["Vector2Float"] = "vec2<f32>";
  AST_TOKEN_TYPES2["Vector3Float"] = "vec3<f32>";
  AST_TOKEN_TYPES2["Vector4Float"] = "vec4<f32>";
  AST_TOKEN_TYPES2["Vector2Boolean"] = "vec2<bool>";
  AST_TOKEN_TYPES2["Vector3Boolean"] = "vec3<bool>";
  AST_TOKEN_TYPES2["Vector4Boolean"] = "vec4<bool>";
  AST_TOKEN_TYPES2["Vector2Uint"] = "vec2<u32>";
  AST_TOKEN_TYPES2["Vector3Uint"] = "vec3<u32>";
  AST_TOKEN_TYPES2["Vector4Uint"] = "vec4<u32>";
  AST_TOKEN_TYPES2["Vector2Int"] = "vec2<i32>";
  AST_TOKEN_TYPES2["Vector3Int"] = "vec3<i32>";
  AST_TOKEN_TYPES2["Vector4Int"] = "vec4<i32>";
  AST_TOKEN_TYPES2["Matrix"] = "Matrix";
  AST_TOKEN_TYPES2["Matrix3x3Float"] = "mat3x3<f32>";
  AST_TOKEN_TYPES2["Matrix4x4Float"] = "mat4x4<i32>";
  AST_TOKEN_TYPES2["Struct"] = "Struct";
  AST_TOKEN_TYPES2["FloatArray"] = "Float[]";
  AST_TOKEN_TYPES2["Vector4FloatArray"] = "vec4<f32>[]";
})(AST_TOKEN_TYPES || (AST_TOKEN_TYPES = {}));
var AST_NODE_TYPES;
(function(AST_NODE_TYPES2) {
  AST_NODE_TYPES2["Program"] = "Program";
  AST_NODE_TYPES2["Identifier"] = "Identifier";
  AST_NODE_TYPES2["VariableDeclaration"] = "VariableDeclaration";
  AST_NODE_TYPES2["BlockStatement"] = "BlockStatement";
  AST_NODE_TYPES2["ReturnStatement"] = "ReturnStatement";
  AST_NODE_TYPES2["FunctionDeclaration"] = "FunctionDeclaration";
  AST_NODE_TYPES2["VariableDeclarator"] = "VariableDeclarator";
  AST_NODE_TYPES2["AssignmentExpression"] = "AssignmentExpression";
  AST_NODE_TYPES2["LogicalExpression"] = "LogicalExpression";
  AST_NODE_TYPES2["BinaryExpression"] = "BinaryExpression";
  AST_NODE_TYPES2["ArrayExpression"] = "ArrayExpression";
  AST_NODE_TYPES2["UnaryExpression"] = "UnaryExpression";
  AST_NODE_TYPES2["UpdateExpression"] = "UpdateExpression";
  AST_NODE_TYPES2["FunctionExpression"] = "FunctionExpression";
  AST_NODE_TYPES2["MemberExpression"] = "MemberExpression";
  AST_NODE_TYPES2["ConditionalExpression"] = "ConditionalExpression";
  AST_NODE_TYPES2["ExpressionStatement"] = "ExpressionStatement";
  AST_NODE_TYPES2["CallExpression"] = "CallExpression";
  AST_NODE_TYPES2["NumThreadStatement"] = "NumThreadStatement";
  AST_NODE_TYPES2["StorageStatement"] = "StorageStatement";
  AST_NODE_TYPES2["DoWhileStatement"] = "DoWhileStatement";
  AST_NODE_TYPES2["WhileStatement"] = "WhileStatement";
  AST_NODE_TYPES2["ForStatement"] = "ForStatement";
  AST_NODE_TYPES2["BreakStatement"] = "BreakStatement";
  AST_NODE_TYPES2["ContinueStatement"] = "ContinueStatement";
  AST_NODE_TYPES2["IfStatement"] = "IfStatement";
  AST_NODE_TYPES2["ImportedFunctionStatement"] = "ImportedFunctionStatement";
})(AST_NODE_TYPES || (AST_NODE_TYPES = {}));
var STORAGE_CLASS;
(function(STORAGE_CLASS2) {
  STORAGE_CLASS2["Input"] = "Input";
  STORAGE_CLASS2["Output"] = "Output";
  STORAGE_CLASS2["Uniform"] = "Uniform";
  STORAGE_CLASS2["Workgroup"] = "Workgroup";
  STORAGE_CLASS2["UniformConstant"] = "UniformConstant";
  STORAGE_CLASS2["Image"] = "Image";
  STORAGE_CLASS2["StorageBuffer"] = "StorageBuffer";
  STORAGE_CLASS2["Private"] = "Private";
  STORAGE_CLASS2["Function"] = "Function";
})(STORAGE_CLASS || (STORAGE_CLASS = {}));
var Target;
(function(Target2) {
  Target2["GLSL100"] = "GLSL100";
  Target2["GLSL450"] = "GLSL450";
  Target2["WGSL"] = "WGSL";
})(Target || (Target = {}));
var regl = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var isTypedArray = function(x2) {
      return x2 instanceof Uint8Array || x2 instanceof Uint16Array || x2 instanceof Uint32Array || x2 instanceof Int8Array || x2 instanceof Int16Array || x2 instanceof Int32Array || x2 instanceof Float32Array || x2 instanceof Float64Array || x2 instanceof Uint8ClampedArray;
    };
    var extend = function(base, opts) {
      var keys = Object.keys(opts);
      for (var i2 = 0; i2 < keys.length; ++i2) {
        base[keys[i2]] = opts[keys[i2]];
      }
      return base;
    };
    var endl = "\n";
    function decodeB64(str) {
      if (typeof atob !== "undefined") {
        return atob(str);
      }
      return "base64:" + str;
    }
    function raise(message) {
      var error = new Error("(regl) " + message);
      console.error(error);
      throw error;
    }
    function check(pred, message) {
      if (!pred) {
        raise(message);
      }
    }
    function encolon(message) {
      if (message) {
        return ": " + message;
      }
      return "";
    }
    function checkParameter(param, possibilities, message) {
      if (!(param in possibilities)) {
        raise("unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join());
      }
    }
    function checkIsTypedArray(data, message) {
      if (!isTypedArray(data)) {
        raise(
          "invalid parameter type" + encolon(message) + ". must be a typed array"
        );
      }
    }
    function standardTypeEh(value, type4) {
      switch (type4) {
        case "number":
          return typeof value === "number";
        case "object":
          return typeof value === "object";
        case "string":
          return typeof value === "string";
        case "boolean":
          return typeof value === "boolean";
        case "function":
          return typeof value === "function";
        case "undefined":
          return typeof value === "undefined";
        case "symbol":
          return typeof value === "symbol";
      }
    }
    function checkTypeOf(value, type4, message) {
      if (!standardTypeEh(value, type4)) {
        raise(
          "invalid parameter type" + encolon(message) + ". expected " + type4 + ", got " + typeof value
        );
      }
    }
    function checkNonNegativeInt(value, message) {
      if (!(value >= 0 && (value | 0) === value)) {
        raise("invalid parameter type, (" + value + ")" + encolon(message) + ". must be a nonnegative integer");
      }
    }
    function checkOneOf(value, list, message) {
      if (list.indexOf(value) < 0) {
        raise("invalid value" + encolon(message) + ". must be one of: " + list);
      }
    }
    var constructorKeys = [
      "gl",
      "canvas",
      "container",
      "attributes",
      "pixelRatio",
      "extensions",
      "optionalExtensions",
      "profile",
      "onDone"
    ];
    function checkConstructor(obj) {
      Object.keys(obj).forEach(function(key) {
        if (constructorKeys.indexOf(key) < 0) {
          raise('invalid regl constructor argument "' + key + '". must be one of ' + constructorKeys);
        }
      });
    }
    function leftPad(str, n2) {
      str = str + "";
      while (str.length < n2) {
        str = " " + str;
      }
      return str;
    }
    function ShaderFile() {
      this.name = "unknown";
      this.lines = [];
      this.index = {};
      this.hasErrors = false;
    }
    function ShaderLine(number4, line2) {
      this.number = number4;
      this.line = line2;
      this.errors = [];
    }
    function ShaderError(fileNumber, lineNumber, message) {
      this.file = fileNumber;
      this.line = lineNumber;
      this.message = message;
    }
    function guessCommand() {
      var error = new Error();
      var stack = (error.stack || error).toString();
      var pat = /compileProcedure.*\n\s*at.*\((.*)\)/.exec(stack);
      if (pat) {
        return pat[1];
      }
      var pat2 = /compileProcedure.*\n\s*at\s+(.*)(\n|$)/.exec(stack);
      if (pat2) {
        return pat2[1];
      }
      return "unknown";
    }
    function guessCallSite() {
      var error = new Error();
      var stack = (error.stack || error).toString();
      var pat = /at REGLCommand.*\n\s+at.*\((.*)\)/.exec(stack);
      if (pat) {
        return pat[1];
      }
      var pat2 = /at REGLCommand.*\n\s+at\s+(.*)\n/.exec(stack);
      if (pat2) {
        return pat2[1];
      }
      return "unknown";
    }
    function parseSource(source, command) {
      var lines2 = source.split("\n");
      var lineNumber = 1;
      var fileNumber = 0;
      var files = {
        unknown: new ShaderFile(),
        0: new ShaderFile()
      };
      files.unknown.name = files[0].name = command || guessCommand();
      files.unknown.lines.push(new ShaderLine(0, ""));
      for (var i2 = 0; i2 < lines2.length; ++i2) {
        var line2 = lines2[i2];
        var parts = /^\s*#\s*(\w+)\s+(.+)\s*$/.exec(line2);
        if (parts) {
          switch (parts[1]) {
            case "line":
              var lineNumberInfo = /(\d+)(\s+\d+)?/.exec(parts[2]);
              if (lineNumberInfo) {
                lineNumber = lineNumberInfo[1] | 0;
                if (lineNumberInfo[2]) {
                  fileNumber = lineNumberInfo[2] | 0;
                  if (!(fileNumber in files)) {
                    files[fileNumber] = new ShaderFile();
                  }
                }
              }
              break;
            case "define":
              var nameInfo = /SHADER_NAME(_B64)?\s+(.*)$/.exec(parts[2]);
              if (nameInfo) {
                files[fileNumber].name = nameInfo[1] ? decodeB64(nameInfo[2]) : nameInfo[2];
              }
              break;
          }
        }
        files[fileNumber].lines.push(new ShaderLine(lineNumber++, line2));
      }
      Object.keys(files).forEach(function(fileNumber2) {
        var file = files[fileNumber2];
        file.lines.forEach(function(line3) {
          file.index[line3.number] = line3;
        });
      });
      return files;
    }
    function parseErrorLog(errLog) {
      var result = [];
      errLog.split("\n").forEach(function(errMsg) {
        if (errMsg.length < 5) {
          return;
        }
        var parts = /^ERROR:\s+(\d+):(\d+):\s*(.*)$/.exec(errMsg);
        if (parts) {
          result.push(new ShaderError(
            parts[1] | 0,
            parts[2] | 0,
            parts[3].trim()
          ));
        } else if (errMsg.length > 0) {
          result.push(new ShaderError("unknown", 0, errMsg));
        }
      });
      return result;
    }
    function annotateFiles(files, errors) {
      errors.forEach(function(error) {
        var file = files[error.file];
        if (file) {
          var line2 = file.index[error.line];
          if (line2) {
            line2.errors.push(error);
            file.hasErrors = true;
            return;
          }
        }
        files.unknown.hasErrors = true;
        files.unknown.lines[0].errors.push(error);
      });
    }
    function checkShaderError(gl2, shader, source, type4, command) {
      if (!gl2.getShaderParameter(shader, gl2.COMPILE_STATUS)) {
        var errLog = gl2.getShaderInfoLog(shader);
        var typeName = type4 === gl2.FRAGMENT_SHADER ? "fragment" : "vertex";
        checkCommandType(source, "string", typeName + " shader source must be a string", command);
        var files = parseSource(source, command);
        var errors = parseErrorLog(errLog);
        annotateFiles(files, errors);
        Object.keys(files).forEach(function(fileNumber) {
          var file = files[fileNumber];
          if (!file.hasErrors) {
            return;
          }
          var strings = [""];
          var styles = [""];
          function push2(str, style) {
            strings.push(str);
            styles.push(style || "");
          }
          push2("file number " + fileNumber + ": " + file.name + "\n", "color:red;text-decoration:underline;font-weight:bold");
          file.lines.forEach(function(line2) {
            if (line2.errors.length > 0) {
              push2(leftPad(line2.number, 4) + "|  ", "background-color:yellow; font-weight:bold");
              push2(line2.line + endl, "color:red; background-color:yellow; font-weight:bold");
              var offset = 0;
              line2.errors.forEach(function(error) {
                var message = error.message;
                var token = /^\s*'(.*)'\s*:\s*(.*)$/.exec(message);
                if (token) {
                  var tokenPat = token[1];
                  message = token[2];
                  switch (tokenPat) {
                    case "assign":
                      tokenPat = "=";
                      break;
                  }
                  offset = Math.max(line2.line.indexOf(tokenPat, offset), 0);
                } else {
                  offset = 0;
                }
                push2(leftPad("| ", 6));
                push2(leftPad("^^^", offset + 3) + endl, "font-weight:bold");
                push2(leftPad("| ", 6));
                push2(message + endl, "font-weight:bold");
              });
              push2(leftPad("| ", 6) + endl);
            } else {
              push2(leftPad(line2.number, 4) + "|  ");
              push2(line2.line + endl, "color:red");
            }
          });
          if (typeof document !== "undefined" && !window.chrome) {
            styles[0] = strings.join("%c");
            console.log.apply(console, styles);
          } else {
            console.log(strings.join(""));
          }
        });
        check.raise("Error compiling " + typeName + " shader, " + files[0].name);
      }
    }
    function checkLinkError(gl2, program, fragShader, vertShader, command) {
      if (!gl2.getProgramParameter(program, gl2.LINK_STATUS)) {
        var errLog = gl2.getProgramInfoLog(program);
        var fragParse = parseSource(fragShader, command);
        var vertParse = parseSource(vertShader, command);
        var header = 'Error linking program with vertex shader, "' + vertParse[0].name + '", and fragment shader "' + fragParse[0].name + '"';
        if (typeof document !== "undefined") {
          console.log(
            "%c" + header + endl + "%c" + errLog,
            "color:red;text-decoration:underline;font-weight:bold",
            "color:red"
          );
        } else {
          console.log(header + endl + errLog);
        }
        check.raise(header);
      }
    }
    function saveCommandRef(object4) {
      object4._commandRef = guessCommand();
    }
    function saveDrawCommandInfo(opts, uniforms, attributes, stringStore) {
      saveCommandRef(opts);
      function id2(str) {
        if (str) {
          return stringStore.id(str);
        }
        return 0;
      }
      opts._fragId = id2(opts.static.frag);
      opts._vertId = id2(opts.static.vert);
      function addProps(dict, set) {
        Object.keys(set).forEach(function(u2) {
          dict[stringStore.id(u2)] = true;
        });
      }
      var uniformSet = opts._uniformSet = {};
      addProps(uniformSet, uniforms.static);
      addProps(uniformSet, uniforms.dynamic);
      var attributeSet = opts._attributeSet = {};
      addProps(attributeSet, attributes.static);
      addProps(attributeSet, attributes.dynamic);
      opts._hasCount = "count" in opts.static || "count" in opts.dynamic || "elements" in opts.static || "elements" in opts.dynamic;
    }
    function commandRaise(message, command) {
      var callSite = guessCallSite();
      raise(message + " in command " + (command || guessCommand()) + (callSite === "unknown" ? "" : " called from " + callSite));
    }
    function checkCommand(pred, message, command) {
      if (!pred) {
        commandRaise(message, command || guessCommand());
      }
    }
    function checkParameterCommand(param, possibilities, message, command) {
      if (!(param in possibilities)) {
        commandRaise(
          "unknown parameter (" + param + ")" + encolon(message) + ". possible values: " + Object.keys(possibilities).join(),
          command || guessCommand()
        );
      }
    }
    function checkCommandType(value, type4, message, command) {
      if (!standardTypeEh(value, type4)) {
        commandRaise(
          "invalid parameter type" + encolon(message) + ". expected " + type4 + ", got " + typeof value,
          command || guessCommand()
        );
      }
    }
    function checkOptional(block) {
      block();
    }
    function checkFramebufferFormat(attachment, texFormats, rbFormats) {
      if (attachment.texture) {
        checkOneOf(
          attachment.texture._texture.internalformat,
          texFormats,
          "unsupported texture format for attachment"
        );
      } else {
        checkOneOf(
          attachment.renderbuffer._renderbuffer.format,
          rbFormats,
          "unsupported renderbuffer format for attachment"
        );
      }
    }
    var GL_CLAMP_TO_EDGE = 33071;
    var GL_NEAREST = 9728;
    var GL_NEAREST_MIPMAP_NEAREST = 9984;
    var GL_LINEAR_MIPMAP_NEAREST = 9985;
    var GL_NEAREST_MIPMAP_LINEAR = 9986;
    var GL_LINEAR_MIPMAP_LINEAR = 9987;
    var GL_BYTE = 5120;
    var GL_UNSIGNED_BYTE = 5121;
    var GL_SHORT = 5122;
    var GL_UNSIGNED_SHORT = 5123;
    var GL_INT = 5124;
    var GL_UNSIGNED_INT = 5125;
    var GL_FLOAT = 5126;
    var GL_UNSIGNED_SHORT_4_4_4_4 = 32819;
    var GL_UNSIGNED_SHORT_5_5_5_1 = 32820;
    var GL_UNSIGNED_SHORT_5_6_5 = 33635;
    var GL_UNSIGNED_INT_24_8_WEBGL = 34042;
    var GL_HALF_FLOAT_OES = 36193;
    var TYPE_SIZE = {};
    TYPE_SIZE[GL_BYTE] = TYPE_SIZE[GL_UNSIGNED_BYTE] = 1;
    TYPE_SIZE[GL_SHORT] = TYPE_SIZE[GL_UNSIGNED_SHORT] = TYPE_SIZE[GL_HALF_FLOAT_OES] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_6_5] = TYPE_SIZE[GL_UNSIGNED_SHORT_4_4_4_4] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_5_5_1] = 2;
    TYPE_SIZE[GL_INT] = TYPE_SIZE[GL_UNSIGNED_INT] = TYPE_SIZE[GL_FLOAT] = TYPE_SIZE[GL_UNSIGNED_INT_24_8_WEBGL] = 4;
    function pixelSize(type4, channels) {
      if (type4 === GL_UNSIGNED_SHORT_5_5_5_1 || type4 === GL_UNSIGNED_SHORT_4_4_4_4 || type4 === GL_UNSIGNED_SHORT_5_6_5) {
        return 2;
      } else if (type4 === GL_UNSIGNED_INT_24_8_WEBGL) {
        return 4;
      } else {
        return TYPE_SIZE[type4] * channels;
      }
    }
    function isPow2(v2) {
      return !(v2 & v2 - 1) && !!v2;
    }
    function checkTexture2D(info, mipData, limits) {
      var i2;
      var w2 = mipData.width;
      var h2 = mipData.height;
      var c3 = mipData.channels;
      check(
        w2 > 0 && w2 <= limits.maxTextureSize && h2 > 0 && h2 <= limits.maxTextureSize,
        "invalid texture shape"
      );
      if (info.wrapS !== GL_CLAMP_TO_EDGE || info.wrapT !== GL_CLAMP_TO_EDGE) {
        check(
          isPow2(w2) && isPow2(h2),
          "incompatible wrap mode for texture, both width and height must be power of 2"
        );
      }
      if (mipData.mipmask === 1) {
        if (w2 !== 1 && h2 !== 1) {
          check(
            info.minFilter !== GL_NEAREST_MIPMAP_NEAREST && info.minFilter !== GL_NEAREST_MIPMAP_LINEAR && info.minFilter !== GL_LINEAR_MIPMAP_NEAREST && info.minFilter !== GL_LINEAR_MIPMAP_LINEAR,
            "min filter requires mipmap"
          );
        }
      } else {
        check(
          isPow2(w2) && isPow2(h2),
          "texture must be a square power of 2 to support mipmapping"
        );
        check(
          mipData.mipmask === (w2 << 1) - 1,
          "missing or incomplete mipmap data"
        );
      }
      if (mipData.type === GL_FLOAT) {
        if (limits.extensions.indexOf("oes_texture_float_linear") < 0) {
          check(
            info.minFilter === GL_NEAREST && info.magFilter === GL_NEAREST,
            "filter not supported, must enable oes_texture_float_linear"
          );
        }
        check(
          !info.genMipmaps,
          "mipmap generation not supported with float textures"
        );
      }
      var mipimages = mipData.images;
      for (i2 = 0; i2 < 16; ++i2) {
        if (mipimages[i2]) {
          var mw2 = w2 >> i2;
          var mh2 = h2 >> i2;
          check(mipData.mipmask & 1 << i2, "missing mipmap data");
          var img = mipimages[i2];
          check(
            img.width === mw2 && img.height === mh2,
            "invalid shape for mip images"
          );
          check(
            img.format === mipData.format && img.internalformat === mipData.internalformat && img.type === mipData.type,
            "incompatible type for mip image"
          );
          if (img.compressed) ;
          else if (img.data) {
            var rowSize = Math.ceil(pixelSize(img.type, c3) * mw2 / img.unpackAlignment) * img.unpackAlignment;
            check(
              img.data.byteLength === rowSize * mh2,
              "invalid data for image, buffer size is inconsistent with image format"
            );
          } else if (img.element) ;
          else if (img.copy) ;
        } else if (!info.genMipmaps) {
          check((mipData.mipmask & 1 << i2) === 0, "extra mipmap data");
        }
      }
      if (mipData.compressed) {
        check(
          !info.genMipmaps,
          "mipmap generation for compressed images not supported"
        );
      }
    }
    function checkTextureCube(texture, info, faces, limits) {
      var w2 = texture.width;
      var h2 = texture.height;
      var c3 = texture.channels;
      check(
        w2 > 0 && w2 <= limits.maxTextureSize && h2 > 0 && h2 <= limits.maxTextureSize,
        "invalid texture shape"
      );
      check(
        w2 === h2,
        "cube map must be square"
      );
      check(
        info.wrapS === GL_CLAMP_TO_EDGE && info.wrapT === GL_CLAMP_TO_EDGE,
        "wrap mode not supported by cube map"
      );
      for (var i2 = 0; i2 < faces.length; ++i2) {
        var face = faces[i2];
        check(
          face.width === w2 && face.height === h2,
          "inconsistent cube map face shape"
        );
        if (info.genMipmaps) {
          check(
            !face.compressed,
            "can not generate mipmap for compressed textures"
          );
          check(
            face.mipmask === 1,
            "can not specify mipmaps and generate mipmaps"
          );
        }
        var mipmaps = face.images;
        for (var j2 = 0; j2 < 16; ++j2) {
          var img = mipmaps[j2];
          if (img) {
            var mw2 = w2 >> j2;
            var mh2 = h2 >> j2;
            check(face.mipmask & 1 << j2, "missing mipmap data");
            check(
              img.width === mw2 && img.height === mh2,
              "invalid shape for mip images"
            );
            check(
              img.format === texture.format && img.internalformat === texture.internalformat && img.type === texture.type,
              "incompatible type for mip image"
            );
            if (img.compressed) ;
            else if (img.data) {
              check(
                img.data.byteLength === mw2 * mh2 * Math.max(pixelSize(img.type, c3), img.unpackAlignment),
                "invalid data for image, buffer size is inconsistent with image format"
              );
            } else if (img.element) ;
            else if (img.copy) ;
          }
        }
      }
    }
    var check$1 = extend(check, {
      optional: checkOptional,
      raise,
      commandRaise,
      command: checkCommand,
      parameter: checkParameter,
      commandParameter: checkParameterCommand,
      constructor: checkConstructor,
      type: checkTypeOf,
      commandType: checkCommandType,
      isTypedArray: checkIsTypedArray,
      nni: checkNonNegativeInt,
      oneOf: checkOneOf,
      shaderError: checkShaderError,
      linkError: checkLinkError,
      callSite: guessCallSite,
      saveCommandRef,
      saveDrawInfo: saveDrawCommandInfo,
      framebufferFormat: checkFramebufferFormat,
      guessCommand,
      texture2D: checkTexture2D,
      textureCube: checkTextureCube
    });
    var VARIABLE_COUNTER = 0;
    var DYN_FUNC = 0;
    var DYN_CONSTANT = 5;
    var DYN_ARRAY = 6;
    function DynamicVariable(type4, data) {
      this.id = VARIABLE_COUNTER++;
      this.type = type4;
      this.data = data;
    }
    function escapeStr(str) {
      return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    }
    function splitParts(str) {
      if (str.length === 0) {
        return [];
      }
      var firstChar = str.charAt(0);
      var lastChar = str.charAt(str.length - 1);
      if (str.length > 1 && firstChar === lastChar && (firstChar === '"' || firstChar === "'")) {
        return ['"' + escapeStr(str.substr(1, str.length - 2)) + '"'];
      }
      var parts = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(str);
      if (parts) {
        return splitParts(str.substr(0, parts.index)).concat(splitParts(parts[1])).concat(splitParts(str.substr(parts.index + parts[0].length)));
      }
      var subparts = str.split(".");
      if (subparts.length === 1) {
        return ['"' + escapeStr(str) + '"'];
      }
      var result = [];
      for (var i2 = 0; i2 < subparts.length; ++i2) {
        result = result.concat(splitParts(subparts[i2]));
      }
      return result;
    }
    function toAccessorString(str) {
      return "[" + splitParts(str).join("][") + "]";
    }
    function defineDynamic(type4, data) {
      return new DynamicVariable(type4, toAccessorString(data + ""));
    }
    function isDynamic(x2) {
      return typeof x2 === "function" && !x2._reglType || x2 instanceof DynamicVariable;
    }
    function unbox(x2, path) {
      if (typeof x2 === "function") {
        return new DynamicVariable(DYN_FUNC, x2);
      } else if (typeof x2 === "number" || typeof x2 === "boolean") {
        return new DynamicVariable(DYN_CONSTANT, x2);
      } else if (Array.isArray(x2)) {
        return new DynamicVariable(DYN_ARRAY, x2.map((y2, i2) => unbox(y2, path + "[" + i2 + "]")));
      } else if (x2 instanceof DynamicVariable) {
        return x2;
      }
      check$1(false, "invalid option type in uniform " + path);
    }
    var dynamic = {
      DynamicVariable,
      define: defineDynamic,
      isDynamic,
      unbox,
      accessor: toAccessorString
    };
    var raf = {
      next: typeof requestAnimationFrame === "function" ? function(cb2) {
        return requestAnimationFrame(cb2);
      } : function(cb2) {
        return setTimeout(cb2, 16);
      },
      cancel: typeof cancelAnimationFrame === "function" ? function(raf2) {
        return cancelAnimationFrame(raf2);
      } : clearTimeout
    };
    var clock = typeof performance !== "undefined" && performance.now ? function() {
      return performance.now();
    } : function() {
      return +/* @__PURE__ */ new Date();
    };
    function createStringStore() {
      var stringIds = { "": 0 };
      var stringValues = [""];
      return {
        id: function(str) {
          var result = stringIds[str];
          if (result) {
            return result;
          }
          result = stringIds[str] = stringValues.length;
          stringValues.push(str);
          return result;
        },
        str: function(id2) {
          return stringValues[id2];
        }
      };
    }
    function createCanvas(element, onDone, pixelRatio) {
      var canvas = document.createElement("canvas");
      extend(canvas.style, {
        border: 0,
        margin: 0,
        padding: 0,
        top: 0,
        left: 0
      });
      element.appendChild(canvas);
      if (element === document.body) {
        canvas.style.position = "absolute";
        extend(element.style, {
          margin: 0,
          padding: 0
        });
      }
      function resize() {
        var w2 = window.innerWidth;
        var h2 = window.innerHeight;
        if (element !== document.body) {
          var bounds = element.getBoundingClientRect();
          w2 = bounds.right - bounds.left;
          h2 = bounds.bottom - bounds.top;
        }
        canvas.width = pixelRatio * w2;
        canvas.height = pixelRatio * h2;
        extend(canvas.style, {
          width: w2 + "px",
          height: h2 + "px"
        });
      }
      var resizeObserver;
      if (element !== document.body && typeof ResizeObserver === "function") {
        resizeObserver = new ResizeObserver(function() {
          setTimeout(resize);
        });
        resizeObserver.observe(element);
      } else {
        window.addEventListener("resize", resize, false);
      }
      function onDestroy() {
        if (resizeObserver) {
          resizeObserver.disconnect();
        } else {
          window.removeEventListener("resize", resize);
        }
        element.removeChild(canvas);
      }
      resize();
      return {
        canvas,
        onDestroy
      };
    }
    function createContext(canvas, contextAttributes) {
      function get2(name) {
        try {
          return canvas.getContext(name, contextAttributes);
        } catch (e10) {
          return null;
        }
      }
      return get2("webgl") || get2("experimental-webgl") || get2("webgl-experimental");
    }
    function isHTMLElement(obj) {
      return typeof obj.nodeName === "string" && typeof obj.appendChild === "function" && typeof obj.getBoundingClientRect === "function";
    }
    function isWebGLContext(obj) {
      return typeof obj.drawArrays === "function" || typeof obj.drawElements === "function";
    }
    function parseExtensions(input) {
      if (typeof input === "string") {
        return input.split();
      }
      check$1(Array.isArray(input), "invalid extension array");
      return input;
    }
    function getElement(desc) {
      if (typeof desc === "string") {
        check$1(typeof document !== "undefined", "not supported outside of DOM");
        return document.querySelector(desc);
      }
      return desc;
    }
    function parseArgs(args_) {
      var args = args_ || {};
      var element, container, canvas, gl2;
      var contextAttributes = {};
      var extensions = [];
      var optionalExtensions = [];
      var pixelRatio = typeof window === "undefined" ? 1 : window.devicePixelRatio;
      var profile = false;
      var onDone = function(err) {
        if (err) {
          check$1.raise(err);
        }
      };
      var onDestroy = function() {
      };
      if (typeof args === "string") {
        check$1(
          typeof document !== "undefined",
          "selector queries only supported in DOM enviroments"
        );
        element = document.querySelector(args);
        check$1(element, "invalid query string for element");
      } else if (typeof args === "object") {
        if (isHTMLElement(args)) {
          element = args;
        } else if (isWebGLContext(args)) {
          gl2 = args;
          canvas = gl2.canvas;
        } else {
          check$1.constructor(args);
          if ("gl" in args) {
            gl2 = args.gl;
          } else if ("canvas" in args) {
            canvas = getElement(args.canvas);
          } else if ("container" in args) {
            container = getElement(args.container);
          }
          if ("attributes" in args) {
            contextAttributes = args.attributes;
            check$1.type(contextAttributes, "object", "invalid context attributes");
          }
          if ("extensions" in args) {
            extensions = parseExtensions(args.extensions);
          }
          if ("optionalExtensions" in args) {
            optionalExtensions = parseExtensions(args.optionalExtensions);
          }
          if ("onDone" in args) {
            check$1.type(
              args.onDone,
              "function",
              "invalid or missing onDone callback"
            );
            onDone = args.onDone;
          }
          if ("profile" in args) {
            profile = !!args.profile;
          }
          if ("pixelRatio" in args) {
            pixelRatio = +args.pixelRatio;
            check$1(pixelRatio > 0, "invalid pixel ratio");
          }
        }
      } else {
        check$1.raise("invalid arguments to regl");
      }
      if (element) {
        if (element.nodeName.toLowerCase() === "canvas") {
          canvas = element;
        } else {
          container = element;
        }
      }
      if (!gl2) {
        if (!canvas) {
          check$1(
            typeof document !== "undefined",
            "must manually specify webgl context outside of DOM environments"
          );
          var result = createCanvas(container || document.body, onDone, pixelRatio);
          if (!result) {
            return null;
          }
          canvas = result.canvas;
          onDestroy = result.onDestroy;
        }
        if (contextAttributes.premultipliedAlpha === void 0) contextAttributes.premultipliedAlpha = true;
        gl2 = createContext(canvas, contextAttributes);
      }
      if (!gl2) {
        onDestroy();
        onDone("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org");
        return null;
      }
      return {
        gl: gl2,
        canvas,
        container,
        extensions,
        optionalExtensions,
        pixelRatio,
        profile,
        onDone,
        onDestroy
      };
    }
    function createExtensionCache(gl2, config) {
      var extensions = {};
      function tryLoadExtension(name_) {
        check$1.type(name_, "string", "extension name must be string");
        var name2 = name_.toLowerCase();
        var ext;
        try {
          ext = extensions[name2] = gl2.getExtension(name2);
        } catch (e10) {
        }
        return !!ext;
      }
      for (var i2 = 0; i2 < config.extensions.length; ++i2) {
        var name = config.extensions[i2];
        if (!tryLoadExtension(name)) {
          config.onDestroy();
          config.onDone('"' + name + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser');
          return null;
        }
      }
      config.optionalExtensions.forEach(tryLoadExtension);
      return {
        extensions,
        restore: function() {
          Object.keys(extensions).forEach(function(name2) {
            if (extensions[name2] && !tryLoadExtension(name2)) {
              throw new Error("(regl): error restoring extension " + name2);
            }
          });
        }
      };
    }
    function loop(n2, f2) {
      var result = Array(n2);
      for (var i2 = 0; i2 < n2; ++i2) {
        result[i2] = f2(i2);
      }
      return result;
    }
    var GL_BYTE$1 = 5120;
    var GL_UNSIGNED_BYTE$2 = 5121;
    var GL_SHORT$1 = 5122;
    var GL_UNSIGNED_SHORT$1 = 5123;
    var GL_INT$1 = 5124;
    var GL_UNSIGNED_INT$1 = 5125;
    var GL_FLOAT$2 = 5126;
    function nextPow16(v2) {
      for (var i2 = 16; i2 <= 1 << 28; i2 *= 16) {
        if (v2 <= i2) {
          return i2;
        }
      }
      return 0;
    }
    function log2(v2) {
      var r3, shift;
      r3 = (v2 > 65535) << 4;
      v2 >>>= r3;
      shift = (v2 > 255) << 3;
      v2 >>>= shift;
      r3 |= shift;
      shift = (v2 > 15) << 2;
      v2 >>>= shift;
      r3 |= shift;
      shift = (v2 > 3) << 1;
      v2 >>>= shift;
      r3 |= shift;
      return r3 | v2 >> 1;
    }
    function createPool() {
      var bufferPool = loop(8, function() {
        return [];
      });
      function alloc(n2) {
        var sz = nextPow16(n2);
        var bin = bufferPool[log2(sz) >> 2];
        if (bin.length > 0) {
          return bin.pop();
        }
        return new ArrayBuffer(sz);
      }
      function free(buf) {
        bufferPool[log2(buf.byteLength) >> 2].push(buf);
      }
      function allocType(type4, n2) {
        var result = null;
        switch (type4) {
          case GL_BYTE$1:
            result = new Int8Array(alloc(n2), 0, n2);
            break;
          case GL_UNSIGNED_BYTE$2:
            result = new Uint8Array(alloc(n2), 0, n2);
            break;
          case GL_SHORT$1:
            result = new Int16Array(alloc(2 * n2), 0, n2);
            break;
          case GL_UNSIGNED_SHORT$1:
            result = new Uint16Array(alloc(2 * n2), 0, n2);
            break;
          case GL_INT$1:
            result = new Int32Array(alloc(4 * n2), 0, n2);
            break;
          case GL_UNSIGNED_INT$1:
            result = new Uint32Array(alloc(4 * n2), 0, n2);
            break;
          case GL_FLOAT$2:
            result = new Float32Array(alloc(4 * n2), 0, n2);
            break;
          default:
            return null;
        }
        if (result.length !== n2) {
          return result.subarray(0, n2);
        }
        return result;
      }
      function freeType(array4) {
        free(array4.buffer);
      }
      return {
        alloc,
        free,
        allocType,
        freeType
      };
    }
    var pool = createPool();
    pool.zero = createPool();
    var GL_SUBPIXEL_BITS = 3408;
    var GL_RED_BITS = 3410;
    var GL_GREEN_BITS = 3411;
    var GL_BLUE_BITS = 3412;
    var GL_ALPHA_BITS = 3413;
    var GL_DEPTH_BITS = 3414;
    var GL_STENCIL_BITS = 3415;
    var GL_ALIASED_POINT_SIZE_RANGE = 33901;
    var GL_ALIASED_LINE_WIDTH_RANGE = 33902;
    var GL_MAX_TEXTURE_SIZE = 3379;
    var GL_MAX_VIEWPORT_DIMS = 3386;
    var GL_MAX_VERTEX_ATTRIBS = 34921;
    var GL_MAX_VERTEX_UNIFORM_VECTORS = 36347;
    var GL_MAX_VARYING_VECTORS = 36348;
    var GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS = 35661;
    var GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS = 35660;
    var GL_MAX_TEXTURE_IMAGE_UNITS = 34930;
    var GL_MAX_FRAGMENT_UNIFORM_VECTORS = 36349;
    var GL_MAX_CUBE_MAP_TEXTURE_SIZE = 34076;
    var GL_MAX_RENDERBUFFER_SIZE = 34024;
    var GL_VENDOR = 7936;
    var GL_RENDERER = 7937;
    var GL_VERSION = 7938;
    var GL_SHADING_LANGUAGE_VERSION = 35724;
    var GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 34047;
    var GL_MAX_COLOR_ATTACHMENTS_WEBGL = 36063;
    var GL_MAX_DRAW_BUFFERS_WEBGL = 34852;
    var GL_TEXTURE_2D = 3553;
    var GL_TEXTURE_CUBE_MAP = 34067;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X = 34069;
    var GL_TEXTURE0 = 33984;
    var GL_RGBA = 6408;
    var GL_FLOAT$1 = 5126;
    var GL_UNSIGNED_BYTE$1 = 5121;
    var GL_FRAMEBUFFER = 36160;
    var GL_FRAMEBUFFER_COMPLETE = 36053;
    var GL_COLOR_ATTACHMENT0 = 36064;
    var GL_COLOR_BUFFER_BIT$1 = 16384;
    var wrapLimits = function(gl2, extensions) {
      var maxAnisotropic = 1;
      if (extensions.ext_texture_filter_anisotropic) {
        maxAnisotropic = gl2.getParameter(GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      }
      var maxDrawbuffers = 1;
      var maxColorAttachments = 1;
      if (extensions.webgl_draw_buffers) {
        maxDrawbuffers = gl2.getParameter(GL_MAX_DRAW_BUFFERS_WEBGL);
        maxColorAttachments = gl2.getParameter(GL_MAX_COLOR_ATTACHMENTS_WEBGL);
      }
      var readFloat = !!extensions.oes_texture_float;
      if (readFloat) {
        var readFloatTexture = gl2.createTexture();
        gl2.bindTexture(GL_TEXTURE_2D, readFloatTexture);
        gl2.texImage2D(GL_TEXTURE_2D, 0, GL_RGBA, 1, 1, 0, GL_RGBA, GL_FLOAT$1, null);
        var fbo = gl2.createFramebuffer();
        gl2.bindFramebuffer(GL_FRAMEBUFFER, fbo);
        gl2.framebufferTexture2D(GL_FRAMEBUFFER, GL_COLOR_ATTACHMENT0, GL_TEXTURE_2D, readFloatTexture, 0);
        gl2.bindTexture(GL_TEXTURE_2D, null);
        if (gl2.checkFramebufferStatus(GL_FRAMEBUFFER) !== GL_FRAMEBUFFER_COMPLETE) readFloat = false;
        else {
          gl2.viewport(0, 0, 1, 1);
          gl2.clearColor(1, 0, 0, 1);
          gl2.clear(GL_COLOR_BUFFER_BIT$1);
          var pixels = pool.allocType(GL_FLOAT$1, 4);
          gl2.readPixels(0, 0, 1, 1, GL_RGBA, GL_FLOAT$1, pixels);
          if (gl2.getError()) readFloat = false;
          else {
            gl2.deleteFramebuffer(fbo);
            gl2.deleteTexture(readFloatTexture);
            readFloat = pixels[0] === 1;
          }
          pool.freeType(pixels);
        }
      }
      var isIE = typeof navigator !== "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent));
      var npotTextureCube = true;
      if (!isIE) {
        var cubeTexture = gl2.createTexture();
        var data = pool.allocType(GL_UNSIGNED_BYTE$1, 36);
        gl2.activeTexture(GL_TEXTURE0);
        gl2.bindTexture(GL_TEXTURE_CUBE_MAP, cubeTexture);
        gl2.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X, 0, GL_RGBA, 3, 3, 0, GL_RGBA, GL_UNSIGNED_BYTE$1, data);
        pool.freeType(data);
        gl2.bindTexture(GL_TEXTURE_CUBE_MAP, null);
        gl2.deleteTexture(cubeTexture);
        npotTextureCube = !gl2.getError();
      }
      return {
        // drawing buffer bit depth
        colorBits: [
          gl2.getParameter(GL_RED_BITS),
          gl2.getParameter(GL_GREEN_BITS),
          gl2.getParameter(GL_BLUE_BITS),
          gl2.getParameter(GL_ALPHA_BITS)
        ],
        depthBits: gl2.getParameter(GL_DEPTH_BITS),
        stencilBits: gl2.getParameter(GL_STENCIL_BITS),
        subpixelBits: gl2.getParameter(GL_SUBPIXEL_BITS),
        // supported extensions
        extensions: Object.keys(extensions).filter(function(ext) {
          return !!extensions[ext];
        }),
        // max aniso samples
        maxAnisotropic,
        // max draw buffers
        maxDrawbuffers,
        maxColorAttachments,
        // point and line size ranges
        pointSizeDims: gl2.getParameter(GL_ALIASED_POINT_SIZE_RANGE),
        lineWidthDims: gl2.getParameter(GL_ALIASED_LINE_WIDTH_RANGE),
        maxViewportDims: gl2.getParameter(GL_MAX_VIEWPORT_DIMS),
        maxCombinedTextureUnits: gl2.getParameter(GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS),
        maxCubeMapSize: gl2.getParameter(GL_MAX_CUBE_MAP_TEXTURE_SIZE),
        maxRenderbufferSize: gl2.getParameter(GL_MAX_RENDERBUFFER_SIZE),
        maxTextureUnits: gl2.getParameter(GL_MAX_TEXTURE_IMAGE_UNITS),
        maxTextureSize: gl2.getParameter(GL_MAX_TEXTURE_SIZE),
        maxAttributes: gl2.getParameter(GL_MAX_VERTEX_ATTRIBS),
        maxVertexUniforms: gl2.getParameter(GL_MAX_VERTEX_UNIFORM_VECTORS),
        maxVertexTextureUnits: gl2.getParameter(GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        maxVaryingVectors: gl2.getParameter(GL_MAX_VARYING_VECTORS),
        maxFragmentUniforms: gl2.getParameter(GL_MAX_FRAGMENT_UNIFORM_VECTORS),
        // vendor info
        glsl: gl2.getParameter(GL_SHADING_LANGUAGE_VERSION),
        renderer: gl2.getParameter(GL_RENDERER),
        vendor: gl2.getParameter(GL_VENDOR),
        version: gl2.getParameter(GL_VERSION),
        // quirks
        readFloat,
        npotTextureCube
      };
    };
    function isNDArrayLike(obj) {
      return !!obj && typeof obj === "object" && Array.isArray(obj.shape) && Array.isArray(obj.stride) && typeof obj.offset === "number" && obj.shape.length === obj.stride.length && (Array.isArray(obj.data) || isTypedArray(obj.data));
    }
    var values = function(obj) {
      return Object.keys(obj).map(function(key) {
        return obj[key];
      });
    };
    var flattenUtils = {
      shape: arrayShape$1,
      flatten: flattenArray
    };
    function flatten1D(array4, nx2, out) {
      for (var i2 = 0; i2 < nx2; ++i2) {
        out[i2] = array4[i2];
      }
    }
    function flatten2D(array4, nx2, ny2, out) {
      var ptr = 0;
      for (var i2 = 0; i2 < nx2; ++i2) {
        var row = array4[i2];
        for (var j2 = 0; j2 < ny2; ++j2) {
          out[ptr++] = row[j2];
        }
      }
    }
    function flatten3D(array4, nx2, ny2, nz, out, ptr_) {
      var ptr = ptr_;
      for (var i2 = 0; i2 < nx2; ++i2) {
        var row = array4[i2];
        for (var j2 = 0; j2 < ny2; ++j2) {
          var col = row[j2];
          for (var k2 = 0; k2 < nz; ++k2) {
            out[ptr++] = col[k2];
          }
        }
      }
    }
    function flattenRec(array4, shape, level, out, ptr) {
      var stride = 1;
      for (var i2 = level + 1; i2 < shape.length; ++i2) {
        stride *= shape[i2];
      }
      var n2 = shape[level];
      if (shape.length - level === 4) {
        var nx2 = shape[level + 1];
        var ny2 = shape[level + 2];
        var nz = shape[level + 3];
        for (i2 = 0; i2 < n2; ++i2) {
          flatten3D(array4[i2], nx2, ny2, nz, out, ptr);
          ptr += stride;
        }
      } else {
        for (i2 = 0; i2 < n2; ++i2) {
          flattenRec(array4[i2], shape, level + 1, out, ptr);
          ptr += stride;
        }
      }
    }
    function flattenArray(array4, shape, type4, out_) {
      var sz = 1;
      if (shape.length) {
        for (var i2 = 0; i2 < shape.length; ++i2) {
          sz *= shape[i2];
        }
      } else {
        sz = 0;
      }
      var out = out_ || pool.allocType(type4, sz);
      switch (shape.length) {
        case 0:
          break;
        case 1:
          flatten1D(array4, shape[0], out);
          break;
        case 2:
          flatten2D(array4, shape[0], shape[1], out);
          break;
        case 3:
          flatten3D(array4, shape[0], shape[1], shape[2], out, 0);
          break;
        default:
          flattenRec(array4, shape, 0, out, 0);
      }
      return out;
    }
    function arrayShape$1(array_) {
      var shape = [];
      for (var array4 = array_; array4.length; array4 = array4[0]) {
        shape.push(array4.length);
      }
      return shape;
    }
    var arrayTypes = {
      "[object Int8Array]": 5120,
      "[object Int16Array]": 5122,
      "[object Int32Array]": 5124,
      "[object Uint8Array]": 5121,
      "[object Uint8ClampedArray]": 5121,
      "[object Uint16Array]": 5123,
      "[object Uint32Array]": 5125,
      "[object Float32Array]": 5126,
      "[object Float64Array]": 5121,
      "[object ArrayBuffer]": 5121
    };
    var int8 = 5120;
    var int16 = 5122;
    var int32 = 5124;
    var uint8 = 5121;
    var uint16 = 5123;
    var uint32 = 5125;
    var float2 = 5126;
    var float32 = 5126;
    var glTypes = {
      int8,
      int16,
      int32,
      uint8,
      uint16,
      uint32,
      float: float2,
      float32
    };
    var dynamic$1 = 35048;
    var stream = 35040;
    var usageTypes = {
      dynamic: dynamic$1,
      stream,
      "static": 35044
    };
    var arrayFlatten = flattenUtils.flatten;
    var arrayShape = flattenUtils.shape;
    var GL_STATIC_DRAW = 35044;
    var GL_STREAM_DRAW = 35040;
    var GL_UNSIGNED_BYTE$3 = 5121;
    var GL_FLOAT$3 = 5126;
    var DTYPES_SIZES = [];
    DTYPES_SIZES[5120] = 1;
    DTYPES_SIZES[5122] = 2;
    DTYPES_SIZES[5124] = 4;
    DTYPES_SIZES[5121] = 1;
    DTYPES_SIZES[5123] = 2;
    DTYPES_SIZES[5125] = 4;
    DTYPES_SIZES[5126] = 4;
    function typedArrayCode(data) {
      return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function copyArray(out, inp) {
      for (var i2 = 0; i2 < inp.length; ++i2) {
        out[i2] = inp[i2];
      }
    }
    function transpose(result, data, shapeX, shapeY, strideX, strideY, offset) {
      var ptr = 0;
      for (var i2 = 0; i2 < shapeX; ++i2) {
        for (var j2 = 0; j2 < shapeY; ++j2) {
          result[ptr++] = data[strideX * i2 + strideY * j2 + offset];
        }
      }
    }
    function wrapBufferState(gl2, stats2, config, destroyBuffer) {
      var bufferCount = 0;
      var bufferSet = {};
      function REGLBuffer(type4) {
        this.id = bufferCount++;
        this.buffer = gl2.createBuffer();
        this.type = type4;
        this.usage = GL_STATIC_DRAW;
        this.byteLength = 0;
        this.dimension = 1;
        this.dtype = GL_UNSIGNED_BYTE$3;
        this.persistentData = null;
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      REGLBuffer.prototype.bind = function() {
        gl2.bindBuffer(this.type, this.buffer);
      };
      REGLBuffer.prototype.destroy = function() {
        destroy(this);
      };
      var streamPool = [];
      function createStream(type4, data) {
        var buffer = streamPool.pop();
        if (!buffer) {
          buffer = new REGLBuffer(type4);
        }
        buffer.bind();
        initBufferFromData(buffer, data, GL_STREAM_DRAW, 0, 1, false);
        return buffer;
      }
      function destroyStream(stream$$1) {
        streamPool.push(stream$$1);
      }
      function initBufferFromTypedArray(buffer, data, usage) {
        buffer.byteLength = data.byteLength;
        gl2.bufferData(buffer.type, data, usage);
      }
      function initBufferFromData(buffer, data, usage, dtype, dimension, persist) {
        var shape;
        buffer.usage = usage;
        if (Array.isArray(data)) {
          buffer.dtype = dtype || GL_FLOAT$3;
          if (data.length > 0) {
            var flatData;
            if (Array.isArray(data[0])) {
              shape = arrayShape(data);
              var dim = 1;
              for (var i2 = 1; i2 < shape.length; ++i2) {
                dim *= shape[i2];
              }
              buffer.dimension = dim;
              flatData = arrayFlatten(data, shape, buffer.dtype);
              initBufferFromTypedArray(buffer, flatData, usage);
              if (persist) {
                buffer.persistentData = flatData;
              } else {
                pool.freeType(flatData);
              }
            } else if (typeof data[0] === "number") {
              buffer.dimension = dimension;
              var typedData = pool.allocType(buffer.dtype, data.length);
              copyArray(typedData, data);
              initBufferFromTypedArray(buffer, typedData, usage);
              if (persist) {
                buffer.persistentData = typedData;
              } else {
                pool.freeType(typedData);
              }
            } else if (isTypedArray(data[0])) {
              buffer.dimension = data[0].length;
              buffer.dtype = dtype || typedArrayCode(data[0]) || GL_FLOAT$3;
              flatData = arrayFlatten(
                data,
                [data.length, data[0].length],
                buffer.dtype
              );
              initBufferFromTypedArray(buffer, flatData, usage);
              if (persist) {
                buffer.persistentData = flatData;
              } else {
                pool.freeType(flatData);
              }
            } else {
              check$1.raise("invalid buffer data");
            }
          }
        } else if (isTypedArray(data)) {
          buffer.dtype = dtype || typedArrayCode(data);
          buffer.dimension = dimension;
          initBufferFromTypedArray(buffer, data, usage);
          if (persist) {
            buffer.persistentData = new Uint8Array(new Uint8Array(data.buffer));
          }
        } else if (isNDArrayLike(data)) {
          shape = data.shape;
          var stride = data.stride;
          var offset = data.offset;
          var shapeX = 0;
          var shapeY = 0;
          var strideX = 0;
          var strideY = 0;
          if (shape.length === 1) {
            shapeX = shape[0];
            shapeY = 1;
            strideX = stride[0];
            strideY = 0;
          } else if (shape.length === 2) {
            shapeX = shape[0];
            shapeY = shape[1];
            strideX = stride[0];
            strideY = stride[1];
          } else {
            check$1.raise("invalid shape");
          }
          buffer.dtype = dtype || typedArrayCode(data.data) || GL_FLOAT$3;
          buffer.dimension = shapeY;
          var transposeData2 = pool.allocType(buffer.dtype, shapeX * shapeY);
          transpose(
            transposeData2,
            data.data,
            shapeX,
            shapeY,
            strideX,
            strideY,
            offset
          );
          initBufferFromTypedArray(buffer, transposeData2, usage);
          if (persist) {
            buffer.persistentData = transposeData2;
          } else {
            pool.freeType(transposeData2);
          }
        } else if (data instanceof ArrayBuffer) {
          buffer.dtype = GL_UNSIGNED_BYTE$3;
          buffer.dimension = dimension;
          initBufferFromTypedArray(buffer, data, usage);
          if (persist) {
            buffer.persistentData = new Uint8Array(new Uint8Array(data));
          }
        } else {
          check$1.raise("invalid buffer data");
        }
      }
      function destroy(buffer) {
        stats2.bufferCount--;
        destroyBuffer(buffer);
        var handle = buffer.buffer;
        check$1(handle, "buffer must not be deleted already");
        gl2.deleteBuffer(handle);
        buffer.buffer = null;
        delete bufferSet[buffer.id];
      }
      function createBuffer(options, type4, deferInit, persistent) {
        stats2.bufferCount++;
        var buffer = new REGLBuffer(type4);
        bufferSet[buffer.id] = buffer;
        function reglBuffer(options2) {
          var usage = GL_STATIC_DRAW;
          var data = null;
          var byteLength = 0;
          var dtype = 0;
          var dimension = 1;
          if (Array.isArray(options2) || isTypedArray(options2) || isNDArrayLike(options2) || options2 instanceof ArrayBuffer) {
            data = options2;
          } else if (typeof options2 === "number") {
            byteLength = options2 | 0;
          } else if (options2) {
            check$1.type(
              options2,
              "object",
              "buffer arguments must be an object, a number or an array"
            );
            if ("data" in options2) {
              check$1(
                data === null || Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data),
                "invalid data for buffer"
              );
              data = options2.data;
            }
            if ("usage" in options2) {
              check$1.parameter(options2.usage, usageTypes, "invalid buffer usage");
              usage = usageTypes[options2.usage];
            }
            if ("type" in options2) {
              check$1.parameter(options2.type, glTypes, "invalid buffer type");
              dtype = glTypes[options2.type];
            }
            if ("dimension" in options2) {
              check$1.type(options2.dimension, "number", "invalid dimension");
              dimension = options2.dimension | 0;
            }
            if ("length" in options2) {
              check$1.nni(byteLength, "buffer length must be a nonnegative integer");
              byteLength = options2.length | 0;
            }
          }
          buffer.bind();
          if (!data) {
            if (byteLength) gl2.bufferData(buffer.type, byteLength, usage);
            buffer.dtype = dtype || GL_UNSIGNED_BYTE$3;
            buffer.usage = usage;
            buffer.dimension = dimension;
            buffer.byteLength = byteLength;
          } else {
            initBufferFromData(buffer, data, usage, dtype, dimension, persistent);
          }
          if (config.profile) {
            buffer.stats.size = buffer.byteLength * DTYPES_SIZES[buffer.dtype];
          }
          return reglBuffer;
        }
        function setSubData(data, offset) {
          check$1(
            offset + data.byteLength <= buffer.byteLength,
            "invalid buffer subdata call, buffer is too small.  Can't write data of size " + data.byteLength + " starting from offset " + offset + " to a buffer of size " + buffer.byteLength
          );
          gl2.bufferSubData(buffer.type, offset, data);
        }
        function subdata(data, offset_) {
          var offset = (offset_ || 0) | 0;
          var shape;
          buffer.bind();
          if (isTypedArray(data) || data instanceof ArrayBuffer) {
            setSubData(data, offset);
          } else if (Array.isArray(data)) {
            if (data.length > 0) {
              if (typeof data[0] === "number") {
                var converted = pool.allocType(buffer.dtype, data.length);
                copyArray(converted, data);
                setSubData(converted, offset);
                pool.freeType(converted);
              } else if (Array.isArray(data[0]) || isTypedArray(data[0])) {
                shape = arrayShape(data);
                var flatData = arrayFlatten(data, shape, buffer.dtype);
                setSubData(flatData, offset);
                pool.freeType(flatData);
              } else {
                check$1.raise("invalid buffer data");
              }
            }
          } else if (isNDArrayLike(data)) {
            shape = data.shape;
            var stride = data.stride;
            var shapeX = 0;
            var shapeY = 0;
            var strideX = 0;
            var strideY = 0;
            if (shape.length === 1) {
              shapeX = shape[0];
              shapeY = 1;
              strideX = stride[0];
              strideY = 0;
            } else if (shape.length === 2) {
              shapeX = shape[0];
              shapeY = shape[1];
              strideX = stride[0];
              strideY = stride[1];
            } else {
              check$1.raise("invalid shape");
            }
            var dtype = Array.isArray(data.data) ? buffer.dtype : typedArrayCode(data.data);
            var transposeData2 = pool.allocType(dtype, shapeX * shapeY);
            transpose(
              transposeData2,
              data.data,
              shapeX,
              shapeY,
              strideX,
              strideY,
              data.offset
            );
            setSubData(transposeData2, offset);
            pool.freeType(transposeData2);
          } else {
            check$1.raise("invalid data for buffer subdata");
          }
          return reglBuffer;
        }
        if (!deferInit) {
          reglBuffer(options);
        }
        reglBuffer._reglType = "buffer";
        reglBuffer._buffer = buffer;
        reglBuffer.subdata = subdata;
        if (config.profile) {
          reglBuffer.stats = buffer.stats;
        }
        reglBuffer.destroy = function() {
          destroy(buffer);
        };
        return reglBuffer;
      }
      function restoreBuffers() {
        values(bufferSet).forEach(function(buffer) {
          buffer.buffer = gl2.createBuffer();
          gl2.bindBuffer(buffer.type, buffer.buffer);
          gl2.bufferData(
            buffer.type,
            buffer.persistentData || buffer.byteLength,
            buffer.usage
          );
        });
      }
      if (config.profile) {
        stats2.getTotalBufferSize = function() {
          var total = 0;
          Object.keys(bufferSet).forEach(function(key) {
            total += bufferSet[key].stats.size;
          });
          return total;
        };
      }
      return {
        create: createBuffer,
        createStream,
        destroyStream,
        clear: function() {
          values(bufferSet).forEach(destroy);
          streamPool.forEach(destroy);
        },
        getBuffer: function(wrapper) {
          if (wrapper && wrapper._buffer instanceof REGLBuffer) {
            return wrapper._buffer;
          }
          return null;
        },
        restore: restoreBuffers,
        _initBuffer: initBufferFromData
      };
    }
    var points = 0;
    var point = 0;
    var lines = 1;
    var line = 1;
    var triangles = 4;
    var triangle = 4;
    var primTypes = {
      points,
      point,
      lines,
      line,
      triangles,
      triangle,
      "line loop": 2,
      "line strip": 3,
      "triangle strip": 5,
      "triangle fan": 6
    };
    var GL_POINTS = 0;
    var GL_LINES = 1;
    var GL_TRIANGLES = 4;
    var GL_BYTE$2 = 5120;
    var GL_UNSIGNED_BYTE$4 = 5121;
    var GL_SHORT$2 = 5122;
    var GL_UNSIGNED_SHORT$2 = 5123;
    var GL_INT$2 = 5124;
    var GL_UNSIGNED_INT$2 = 5125;
    var GL_ELEMENT_ARRAY_BUFFER = 34963;
    var GL_STREAM_DRAW$1 = 35040;
    var GL_STATIC_DRAW$1 = 35044;
    function wrapElementsState(gl2, extensions, bufferState, stats2) {
      var elementSet = {};
      var elementCount = 0;
      var elementTypes = {
        "uint8": GL_UNSIGNED_BYTE$4,
        "uint16": GL_UNSIGNED_SHORT$2
      };
      if (extensions.oes_element_index_uint) {
        elementTypes.uint32 = GL_UNSIGNED_INT$2;
      }
      function REGLElementBuffer(buffer) {
        this.id = elementCount++;
        elementSet[this.id] = this;
        this.buffer = buffer;
        this.primType = GL_TRIANGLES;
        this.vertCount = 0;
        this.type = 0;
      }
      REGLElementBuffer.prototype.bind = function() {
        this.buffer.bind();
      };
      var bufferPool = [];
      function createElementStream(data) {
        var result = bufferPool.pop();
        if (!result) {
          result = new REGLElementBuffer(bufferState.create(
            null,
            GL_ELEMENT_ARRAY_BUFFER,
            true,
            false
          )._buffer);
        }
        initElements(result, data, GL_STREAM_DRAW$1, -1, -1, 0, 0);
        return result;
      }
      function destroyElementStream(elements) {
        bufferPool.push(elements);
      }
      function initElements(elements, data, usage, prim3, count, byteLength, type4) {
        elements.buffer.bind();
        var dtype;
        if (data) {
          var predictedType = type4;
          if (!type4 && (!isTypedArray(data) || isNDArrayLike(data) && !isTypedArray(data.data))) {
            predictedType = extensions.oes_element_index_uint ? GL_UNSIGNED_INT$2 : GL_UNSIGNED_SHORT$2;
          }
          bufferState._initBuffer(
            elements.buffer,
            data,
            usage,
            predictedType,
            3
          );
        } else {
          gl2.bufferData(GL_ELEMENT_ARRAY_BUFFER, byteLength, usage);
          elements.buffer.dtype = dtype || GL_UNSIGNED_BYTE$4;
          elements.buffer.usage = usage;
          elements.buffer.dimension = 3;
          elements.buffer.byteLength = byteLength;
        }
        dtype = type4;
        if (!type4) {
          switch (elements.buffer.dtype) {
            case GL_UNSIGNED_BYTE$4:
            case GL_BYTE$2:
              dtype = GL_UNSIGNED_BYTE$4;
              break;
            case GL_UNSIGNED_SHORT$2:
            case GL_SHORT$2:
              dtype = GL_UNSIGNED_SHORT$2;
              break;
            case GL_UNSIGNED_INT$2:
            case GL_INT$2:
              dtype = GL_UNSIGNED_INT$2;
              break;
            default:
              check$1.raise("unsupported type for element array");
          }
          elements.buffer.dtype = dtype;
        }
        elements.type = dtype;
        check$1(
          dtype !== GL_UNSIGNED_INT$2 || !!extensions.oes_element_index_uint,
          "32 bit element buffers not supported, enable oes_element_index_uint first"
        );
        var vertCount = count;
        if (vertCount < 0) {
          vertCount = elements.buffer.byteLength;
          if (dtype === GL_UNSIGNED_SHORT$2) {
            vertCount >>= 1;
          } else if (dtype === GL_UNSIGNED_INT$2) {
            vertCount >>= 2;
          }
        }
        elements.vertCount = vertCount;
        var primType = prim3;
        if (prim3 < 0) {
          primType = GL_TRIANGLES;
          var dimension = elements.buffer.dimension;
          if (dimension === 1) primType = GL_POINTS;
          if (dimension === 2) primType = GL_LINES;
          if (dimension === 3) primType = GL_TRIANGLES;
        }
        elements.primType = primType;
      }
      function destroyElements(elements) {
        stats2.elementsCount--;
        check$1(elements.buffer !== null, "must not double destroy elements");
        delete elementSet[elements.id];
        elements.buffer.destroy();
        elements.buffer = null;
      }
      function createElements(options, persistent) {
        var buffer = bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true);
        var elements = new REGLElementBuffer(buffer._buffer);
        stats2.elementsCount++;
        function reglElements(options2) {
          if (!options2) {
            buffer();
            elements.primType = GL_TRIANGLES;
            elements.vertCount = 0;
            elements.type = GL_UNSIGNED_BYTE$4;
          } else if (typeof options2 === "number") {
            buffer(options2);
            elements.primType = GL_TRIANGLES;
            elements.vertCount = options2 | 0;
            elements.type = GL_UNSIGNED_BYTE$4;
          } else {
            var data = null;
            var usage = GL_STATIC_DRAW$1;
            var primType = -1;
            var vertCount = -1;
            var byteLength = 0;
            var dtype = 0;
            if (Array.isArray(options2) || isTypedArray(options2) || isNDArrayLike(options2)) {
              data = options2;
            } else {
              check$1.type(options2, "object", "invalid arguments for elements");
              if ("data" in options2) {
                data = options2.data;
                check$1(
                  Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data),
                  "invalid data for element buffer"
                );
              }
              if ("usage" in options2) {
                check$1.parameter(
                  options2.usage,
                  usageTypes,
                  "invalid element buffer usage"
                );
                usage = usageTypes[options2.usage];
              }
              if ("primitive" in options2) {
                check$1.parameter(
                  options2.primitive,
                  primTypes,
                  "invalid element buffer primitive"
                );
                primType = primTypes[options2.primitive];
              }
              if ("count" in options2) {
                check$1(
                  typeof options2.count === "number" && options2.count >= 0,
                  "invalid vertex count for elements"
                );
                vertCount = options2.count | 0;
              }
              if ("type" in options2) {
                check$1.parameter(
                  options2.type,
                  elementTypes,
                  "invalid buffer type"
                );
                dtype = elementTypes[options2.type];
              }
              if ("length" in options2) {
                byteLength = options2.length | 0;
              } else {
                byteLength = vertCount;
                if (dtype === GL_UNSIGNED_SHORT$2 || dtype === GL_SHORT$2) {
                  byteLength *= 2;
                } else if (dtype === GL_UNSIGNED_INT$2 || dtype === GL_INT$2) {
                  byteLength *= 4;
                }
              }
            }
            initElements(
              elements,
              data,
              usage,
              primType,
              vertCount,
              byteLength,
              dtype
            );
          }
          return reglElements;
        }
        reglElements(options);
        reglElements._reglType = "elements";
        reglElements._elements = elements;
        reglElements.subdata = function(data, offset) {
          buffer.subdata(data, offset);
          return reglElements;
        };
        reglElements.destroy = function() {
          destroyElements(elements);
        };
        return reglElements;
      }
      return {
        create: createElements,
        createStream: createElementStream,
        destroyStream: destroyElementStream,
        getElements: function(elements) {
          if (typeof elements === "function" && elements._elements instanceof REGLElementBuffer) {
            return elements._elements;
          }
          return null;
        },
        clear: function() {
          values(elementSet).forEach(destroyElements);
        }
      };
    }
    var FLOAT = new Float32Array(1);
    var INT = new Uint32Array(FLOAT.buffer);
    var GL_UNSIGNED_SHORT$4 = 5123;
    function convertToHalfFloat(array4) {
      var ushorts = pool.allocType(GL_UNSIGNED_SHORT$4, array4.length);
      for (var i2 = 0; i2 < array4.length; ++i2) {
        if (isNaN(array4[i2])) {
          ushorts[i2] = 65535;
        } else if (array4[i2] === Infinity) {
          ushorts[i2] = 31744;
        } else if (array4[i2] === -Infinity) {
          ushorts[i2] = 64512;
        } else {
          FLOAT[0] = array4[i2];
          var x2 = INT[0];
          var sgn = x2 >>> 31 << 15;
          var exp = (x2 << 1 >>> 24) - 127;
          var frac = x2 >> 13 & (1 << 10) - 1;
          if (exp < -24) {
            ushorts[i2] = sgn;
          } else if (exp < -14) {
            var s2 = -14 - exp;
            ushorts[i2] = sgn + (frac + (1 << 10) >> s2);
          } else if (exp > 15) {
            ushorts[i2] = sgn + 31744;
          } else {
            ushorts[i2] = sgn + (exp + 15 << 10) + frac;
          }
        }
      }
      return ushorts;
    }
    function isArrayLike(s2) {
      return Array.isArray(s2) || isTypedArray(s2);
    }
    var isPow2$1 = function(v2) {
      return !(v2 & v2 - 1) && !!v2;
    };
    var GL_COMPRESSED_TEXTURE_FORMATS = 34467;
    var GL_TEXTURE_2D$1 = 3553;
    var GL_TEXTURE_CUBE_MAP$1 = 34067;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 = 34069;
    var GL_RGBA$1 = 6408;
    var GL_ALPHA = 6406;
    var GL_RGB = 6407;
    var GL_LUMINANCE = 6409;
    var GL_LUMINANCE_ALPHA = 6410;
    var GL_RGBA4 = 32854;
    var GL_RGB5_A1 = 32855;
    var GL_RGB565 = 36194;
    var GL_UNSIGNED_SHORT_4_4_4_4$1 = 32819;
    var GL_UNSIGNED_SHORT_5_5_5_1$1 = 32820;
    var GL_UNSIGNED_SHORT_5_6_5$1 = 33635;
    var GL_UNSIGNED_INT_24_8_WEBGL$1 = 34042;
    var GL_DEPTH_COMPONENT = 6402;
    var GL_DEPTH_STENCIL = 34041;
    var GL_SRGB_EXT = 35904;
    var GL_SRGB_ALPHA_EXT = 35906;
    var GL_HALF_FLOAT_OES$1 = 36193;
    var GL_COMPRESSED_RGB_S3TC_DXT1_EXT = 33776;
    var GL_COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777;
    var GL_COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778;
    var GL_COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779;
    var GL_COMPRESSED_RGB_ATC_WEBGL = 35986;
    var GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 35987;
    var GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 34798;
    var GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 35840;
    var GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 35841;
    var GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 35842;
    var GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 35843;
    var GL_COMPRESSED_RGB_ETC1_WEBGL = 36196;
    var GL_UNSIGNED_BYTE$5 = 5121;
    var GL_UNSIGNED_SHORT$3 = 5123;
    var GL_UNSIGNED_INT$3 = 5125;
    var GL_FLOAT$4 = 5126;
    var GL_TEXTURE_WRAP_S = 10242;
    var GL_TEXTURE_WRAP_T = 10243;
    var GL_REPEAT = 10497;
    var GL_CLAMP_TO_EDGE$1 = 33071;
    var GL_MIRRORED_REPEAT = 33648;
    var GL_TEXTURE_MAG_FILTER = 10240;
    var GL_TEXTURE_MIN_FILTER = 10241;
    var GL_NEAREST$1 = 9728;
    var GL_LINEAR = 9729;
    var GL_NEAREST_MIPMAP_NEAREST$1 = 9984;
    var GL_LINEAR_MIPMAP_NEAREST$1 = 9985;
    var GL_NEAREST_MIPMAP_LINEAR$1 = 9986;
    var GL_LINEAR_MIPMAP_LINEAR$1 = 9987;
    var GL_GENERATE_MIPMAP_HINT = 33170;
    var GL_DONT_CARE = 4352;
    var GL_FASTEST = 4353;
    var GL_NICEST = 4354;
    var GL_TEXTURE_MAX_ANISOTROPY_EXT = 34046;
    var GL_UNPACK_ALIGNMENT = 3317;
    var GL_UNPACK_FLIP_Y_WEBGL = 37440;
    var GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL = 37441;
    var GL_UNPACK_COLORSPACE_CONVERSION_WEBGL = 37443;
    var GL_BROWSER_DEFAULT_WEBGL = 37444;
    var GL_TEXTURE0$1 = 33984;
    var MIPMAP_FILTERS = [
      GL_NEAREST_MIPMAP_NEAREST$1,
      GL_NEAREST_MIPMAP_LINEAR$1,
      GL_LINEAR_MIPMAP_NEAREST$1,
      GL_LINEAR_MIPMAP_LINEAR$1
    ];
    var CHANNELS_FORMAT = [
      0,
      GL_LUMINANCE,
      GL_LUMINANCE_ALPHA,
      GL_RGB,
      GL_RGBA$1
    ];
    var FORMAT_CHANNELS = {};
    FORMAT_CHANNELS[GL_LUMINANCE] = FORMAT_CHANNELS[GL_ALPHA] = FORMAT_CHANNELS[GL_DEPTH_COMPONENT] = 1;
    FORMAT_CHANNELS[GL_DEPTH_STENCIL] = FORMAT_CHANNELS[GL_LUMINANCE_ALPHA] = 2;
    FORMAT_CHANNELS[GL_RGB] = FORMAT_CHANNELS[GL_SRGB_EXT] = 3;
    FORMAT_CHANNELS[GL_RGBA$1] = FORMAT_CHANNELS[GL_SRGB_ALPHA_EXT] = 4;
    function objectName(str) {
      return "[object " + str + "]";
    }
    var CANVAS_CLASS = objectName("HTMLCanvasElement");
    var OFFSCREENCANVAS_CLASS = objectName("OffscreenCanvas");
    var CONTEXT2D_CLASS = objectName("CanvasRenderingContext2D");
    var BITMAP_CLASS = objectName("ImageBitmap");
    var IMAGE_CLASS = objectName("HTMLImageElement");
    var VIDEO_CLASS = objectName("HTMLVideoElement");
    var PIXEL_CLASSES = Object.keys(arrayTypes).concat([
      CANVAS_CLASS,
      OFFSCREENCANVAS_CLASS,
      CONTEXT2D_CLASS,
      BITMAP_CLASS,
      IMAGE_CLASS,
      VIDEO_CLASS
    ]);
    var TYPE_SIZES = [];
    TYPE_SIZES[GL_UNSIGNED_BYTE$5] = 1;
    TYPE_SIZES[GL_FLOAT$4] = 4;
    TYPE_SIZES[GL_HALF_FLOAT_OES$1] = 2;
    TYPE_SIZES[GL_UNSIGNED_SHORT$3] = 2;
    TYPE_SIZES[GL_UNSIGNED_INT$3] = 4;
    var FORMAT_SIZES_SPECIAL = [];
    FORMAT_SIZES_SPECIAL[GL_RGBA4] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB5_A1] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB565] = 2;
    FORMAT_SIZES_SPECIAL[GL_DEPTH_STENCIL] = 4;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ATC_WEBGL] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ETC1_WEBGL] = 0.5;
    function isNumericArray(arr) {
      return Array.isArray(arr) && (arr.length === 0 || typeof arr[0] === "number");
    }
    function isRectArray(arr) {
      if (!Array.isArray(arr)) {
        return false;
      }
      var width2 = arr.length;
      if (width2 === 0 || !isArrayLike(arr[0])) {
        return false;
      }
      return true;
    }
    function classString(x2) {
      return Object.prototype.toString.call(x2);
    }
    function isCanvasElement(object4) {
      return classString(object4) === CANVAS_CLASS;
    }
    function isOffscreenCanvas(object4) {
      return classString(object4) === OFFSCREENCANVAS_CLASS;
    }
    function isContext2D(object4) {
      return classString(object4) === CONTEXT2D_CLASS;
    }
    function isBitmap(object4) {
      return classString(object4) === BITMAP_CLASS;
    }
    function isImageElement(object4) {
      return classString(object4) === IMAGE_CLASS;
    }
    function isVideoElement(object4) {
      return classString(object4) === VIDEO_CLASS;
    }
    function isPixelData(object4) {
      if (!object4) {
        return false;
      }
      var className = classString(object4);
      if (PIXEL_CLASSES.indexOf(className) >= 0) {
        return true;
      }
      return isNumericArray(object4) || isRectArray(object4) || isNDArrayLike(object4);
    }
    function typedArrayCode$1(data) {
      return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function convertData(result, data) {
      var n2 = data.length;
      switch (result.type) {
        case GL_UNSIGNED_BYTE$5:
        case GL_UNSIGNED_SHORT$3:
        case GL_UNSIGNED_INT$3:
        case GL_FLOAT$4:
          var converted = pool.allocType(result.type, n2);
          converted.set(data);
          result.data = converted;
          break;
        case GL_HALF_FLOAT_OES$1:
          result.data = convertToHalfFloat(data);
          break;
        default:
          check$1.raise("unsupported texture type, must specify a typed array");
      }
    }
    function preConvert(image, n2) {
      return pool.allocType(
        image.type === GL_HALF_FLOAT_OES$1 ? GL_FLOAT$4 : image.type,
        n2
      );
    }
    function postConvert(image, data) {
      if (image.type === GL_HALF_FLOAT_OES$1) {
        image.data = convertToHalfFloat(data);
        pool.freeType(data);
      } else {
        image.data = data;
      }
    }
    function transposeData(image, array4, strideX, strideY, strideC, offset) {
      var w2 = image.width;
      var h2 = image.height;
      var c3 = image.channels;
      var n2 = w2 * h2 * c3;
      var data = preConvert(image, n2);
      var p2 = 0;
      for (var i2 = 0; i2 < h2; ++i2) {
        for (var j2 = 0; j2 < w2; ++j2) {
          for (var k2 = 0; k2 < c3; ++k2) {
            data[p2++] = array4[strideX * j2 + strideY * i2 + strideC * k2 + offset];
          }
        }
      }
      postConvert(image, data);
    }
    function getTextureSize(format2, type4, width2, height, isMipmap, isCube) {
      var s2;
      if (typeof FORMAT_SIZES_SPECIAL[format2] !== "undefined") {
        s2 = FORMAT_SIZES_SPECIAL[format2];
      } else {
        s2 = FORMAT_CHANNELS[format2] * TYPE_SIZES[type4];
      }
      if (isCube) {
        s2 *= 6;
      }
      if (isMipmap) {
        var total = 0;
        var w2 = width2;
        while (w2 >= 1) {
          total += s2 * w2 * w2;
          w2 /= 2;
        }
        return total;
      } else {
        return s2 * width2 * height;
      }
    }
    function createTextureSet(gl2, extensions, limits, reglPoll, contextState, stats2, config) {
      var mipmapHint = {
        "don't care": GL_DONT_CARE,
        "dont care": GL_DONT_CARE,
        "nice": GL_NICEST,
        "fast": GL_FASTEST
      };
      var wrapModes = {
        "repeat": GL_REPEAT,
        "clamp": GL_CLAMP_TO_EDGE$1,
        "mirror": GL_MIRRORED_REPEAT
      };
      var magFilters = {
        "nearest": GL_NEAREST$1,
        "linear": GL_LINEAR
      };
      var minFilters = extend({
        "mipmap": GL_LINEAR_MIPMAP_LINEAR$1,
        "nearest mipmap nearest": GL_NEAREST_MIPMAP_NEAREST$1,
        "linear mipmap nearest": GL_LINEAR_MIPMAP_NEAREST$1,
        "nearest mipmap linear": GL_NEAREST_MIPMAP_LINEAR$1,
        "linear mipmap linear": GL_LINEAR_MIPMAP_LINEAR$1
      }, magFilters);
      var colorSpace = {
        "none": 0,
        "browser": GL_BROWSER_DEFAULT_WEBGL
      };
      var textureTypes = {
        "uint8": GL_UNSIGNED_BYTE$5,
        "rgba4": GL_UNSIGNED_SHORT_4_4_4_4$1,
        "rgb565": GL_UNSIGNED_SHORT_5_6_5$1,
        "rgb5 a1": GL_UNSIGNED_SHORT_5_5_5_1$1
      };
      var textureFormats = {
        "alpha": GL_ALPHA,
        "luminance": GL_LUMINANCE,
        "luminance alpha": GL_LUMINANCE_ALPHA,
        "rgb": GL_RGB,
        "rgba": GL_RGBA$1,
        "rgba4": GL_RGBA4,
        "rgb5 a1": GL_RGB5_A1,
        "rgb565": GL_RGB565
      };
      var compressedTextureFormats = {};
      if (extensions.ext_srgb) {
        textureFormats.srgb = GL_SRGB_EXT;
        textureFormats.srgba = GL_SRGB_ALPHA_EXT;
      }
      if (extensions.oes_texture_float) {
        textureTypes.float32 = textureTypes.float = GL_FLOAT$4;
      }
      if (extensions.oes_texture_half_float) {
        textureTypes["float16"] = textureTypes["half float"] = GL_HALF_FLOAT_OES$1;
      }
      if (extensions.webgl_depth_texture) {
        extend(textureFormats, {
          "depth": GL_DEPTH_COMPONENT,
          "depth stencil": GL_DEPTH_STENCIL
        });
        extend(textureTypes, {
          "uint16": GL_UNSIGNED_SHORT$3,
          "uint32": GL_UNSIGNED_INT$3,
          "depth stencil": GL_UNSIGNED_INT_24_8_WEBGL$1
        });
      }
      if (extensions.webgl_compressed_texture_s3tc) {
        extend(compressedTextureFormats, {
          "rgb s3tc dxt1": GL_COMPRESSED_RGB_S3TC_DXT1_EXT,
          "rgba s3tc dxt1": GL_COMPRESSED_RGBA_S3TC_DXT1_EXT,
          "rgba s3tc dxt3": GL_COMPRESSED_RGBA_S3TC_DXT3_EXT,
          "rgba s3tc dxt5": GL_COMPRESSED_RGBA_S3TC_DXT5_EXT
        });
      }
      if (extensions.webgl_compressed_texture_atc) {
        extend(compressedTextureFormats, {
          "rgb atc": GL_COMPRESSED_RGB_ATC_WEBGL,
          "rgba atc explicit alpha": GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL,
          "rgba atc interpolated alpha": GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
        });
      }
      if (extensions.webgl_compressed_texture_pvrtc) {
        extend(compressedTextureFormats, {
          "rgb pvrtc 4bppv1": GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG,
          "rgb pvrtc 2bppv1": GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG,
          "rgba pvrtc 4bppv1": GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG,
          "rgba pvrtc 2bppv1": GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        });
      }
      if (extensions.webgl_compressed_texture_etc1) {
        compressedTextureFormats["rgb etc1"] = GL_COMPRESSED_RGB_ETC1_WEBGL;
      }
      var supportedCompressedFormats = Array.prototype.slice.call(
        gl2.getParameter(GL_COMPRESSED_TEXTURE_FORMATS)
      );
      Object.keys(compressedTextureFormats).forEach(function(name) {
        var format2 = compressedTextureFormats[name];
        if (supportedCompressedFormats.indexOf(format2) >= 0) {
          textureFormats[name] = format2;
        }
      });
      var supportedFormats = Object.keys(textureFormats);
      limits.textureFormats = supportedFormats;
      var textureFormatsInvert = [];
      Object.keys(textureFormats).forEach(function(key) {
        var val = textureFormats[key];
        textureFormatsInvert[val] = key;
      });
      var textureTypesInvert = [];
      Object.keys(textureTypes).forEach(function(key) {
        var val = textureTypes[key];
        textureTypesInvert[val] = key;
      });
      var magFiltersInvert = [];
      Object.keys(magFilters).forEach(function(key) {
        var val = magFilters[key];
        magFiltersInvert[val] = key;
      });
      var minFiltersInvert = [];
      Object.keys(minFilters).forEach(function(key) {
        var val = minFilters[key];
        minFiltersInvert[val] = key;
      });
      var wrapModesInvert = [];
      Object.keys(wrapModes).forEach(function(key) {
        var val = wrapModes[key];
        wrapModesInvert[val] = key;
      });
      var colorFormats = supportedFormats.reduce(function(color, key) {
        var glenum = textureFormats[key];
        if (glenum === GL_LUMINANCE || glenum === GL_ALPHA || glenum === GL_LUMINANCE || glenum === GL_LUMINANCE_ALPHA || glenum === GL_DEPTH_COMPONENT || glenum === GL_DEPTH_STENCIL || extensions.ext_srgb && (glenum === GL_SRGB_EXT || glenum === GL_SRGB_ALPHA_EXT)) {
          color[glenum] = glenum;
        } else if (glenum === GL_RGB5_A1 || key.indexOf("rgba") >= 0) {
          color[glenum] = GL_RGBA$1;
        } else {
          color[glenum] = GL_RGB;
        }
        return color;
      }, {});
      function TexFlags() {
        this.internalformat = GL_RGBA$1;
        this.format = GL_RGBA$1;
        this.type = GL_UNSIGNED_BYTE$5;
        this.compressed = false;
        this.premultiplyAlpha = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.colorSpace = GL_BROWSER_DEFAULT_WEBGL;
        this.width = 0;
        this.height = 0;
        this.channels = 0;
      }
      function copyFlags(result, other) {
        result.internalformat = other.internalformat;
        result.format = other.format;
        result.type = other.type;
        result.compressed = other.compressed;
        result.premultiplyAlpha = other.premultiplyAlpha;
        result.flipY = other.flipY;
        result.unpackAlignment = other.unpackAlignment;
        result.colorSpace = other.colorSpace;
        result.width = other.width;
        result.height = other.height;
        result.channels = other.channels;
      }
      function parseFlags(flags, options) {
        if (typeof options !== "object" || !options) {
          return;
        }
        if ("premultiplyAlpha" in options) {
          check$1.type(
            options.premultiplyAlpha,
            "boolean",
            "invalid premultiplyAlpha"
          );
          flags.premultiplyAlpha = options.premultiplyAlpha;
        }
        if ("flipY" in options) {
          check$1.type(
            options.flipY,
            "boolean",
            "invalid texture flip"
          );
          flags.flipY = options.flipY;
        }
        if ("alignment" in options) {
          check$1.oneOf(
            options.alignment,
            [1, 2, 4, 8],
            "invalid texture unpack alignment"
          );
          flags.unpackAlignment = options.alignment;
        }
        if ("colorSpace" in options) {
          check$1.parameter(
            options.colorSpace,
            colorSpace,
            "invalid colorSpace"
          );
          flags.colorSpace = colorSpace[options.colorSpace];
        }
        if ("type" in options) {
          var type4 = options.type;
          check$1(
            extensions.oes_texture_float || !(type4 === "float" || type4 === "float32"),
            "you must enable the OES_texture_float extension in order to use floating point textures."
          );
          check$1(
            extensions.oes_texture_half_float || !(type4 === "half float" || type4 === "float16"),
            "you must enable the OES_texture_half_float extension in order to use 16-bit floating point textures."
          );
          check$1(
            extensions.webgl_depth_texture || !(type4 === "uint16" || type4 === "uint32" || type4 === "depth stencil"),
            "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures."
          );
          check$1.parameter(
            type4,
            textureTypes,
            "invalid texture type"
          );
          flags.type = textureTypes[type4];
        }
        var w2 = flags.width;
        var h2 = flags.height;
        var c3 = flags.channels;
        var hasChannels = false;
        if ("shape" in options) {
          check$1(
            Array.isArray(options.shape) && options.shape.length >= 2,
            "shape must be an array"
          );
          w2 = options.shape[0];
          h2 = options.shape[1];
          if (options.shape.length === 3) {
            c3 = options.shape[2];
            check$1(c3 > 0 && c3 <= 4, "invalid number of channels");
            hasChannels = true;
          }
          check$1(w2 >= 0 && w2 <= limits.maxTextureSize, "invalid width");
          check$1(h2 >= 0 && h2 <= limits.maxTextureSize, "invalid height");
        } else {
          if ("radius" in options) {
            w2 = h2 = options.radius;
            check$1(w2 >= 0 && w2 <= limits.maxTextureSize, "invalid radius");
          }
          if ("width" in options) {
            w2 = options.width;
            check$1(w2 >= 0 && w2 <= limits.maxTextureSize, "invalid width");
          }
          if ("height" in options) {
            h2 = options.height;
            check$1(h2 >= 0 && h2 <= limits.maxTextureSize, "invalid height");
          }
          if ("channels" in options) {
            c3 = options.channels;
            check$1(c3 > 0 && c3 <= 4, "invalid number of channels");
            hasChannels = true;
          }
        }
        flags.width = w2 | 0;
        flags.height = h2 | 0;
        flags.channels = c3 | 0;
        var hasFormat = false;
        if ("format" in options) {
          var formatStr = options.format;
          check$1(
            extensions.webgl_depth_texture || !(formatStr === "depth" || formatStr === "depth stencil"),
            "you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures."
          );
          check$1.parameter(
            formatStr,
            textureFormats,
            "invalid texture format"
          );
          var internalformat = flags.internalformat = textureFormats[formatStr];
          flags.format = colorFormats[internalformat];
          if (formatStr in textureTypes) {
            if (!("type" in options)) {
              flags.type = textureTypes[formatStr];
            }
          }
          if (formatStr in compressedTextureFormats) {
            flags.compressed = true;
          }
          hasFormat = true;
        }
        if (!hasChannels && hasFormat) {
          flags.channels = FORMAT_CHANNELS[flags.format];
        } else if (hasChannels && !hasFormat) {
          if (flags.channels !== CHANNELS_FORMAT[flags.format]) {
            flags.format = flags.internalformat = CHANNELS_FORMAT[flags.channels];
          }
        } else if (hasFormat && hasChannels) {
          check$1(
            flags.channels === FORMAT_CHANNELS[flags.format],
            "number of channels inconsistent with specified format"
          );
        }
      }
      function setFlags(flags) {
        gl2.pixelStorei(GL_UNPACK_FLIP_Y_WEBGL, flags.flipY);
        gl2.pixelStorei(GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL, flags.premultiplyAlpha);
        gl2.pixelStorei(GL_UNPACK_COLORSPACE_CONVERSION_WEBGL, flags.colorSpace);
        gl2.pixelStorei(GL_UNPACK_ALIGNMENT, flags.unpackAlignment);
      }
      function TexImage() {
        TexFlags.call(this);
        this.xOffset = 0;
        this.yOffset = 0;
        this.data = null;
        this.needsFree = false;
        this.element = null;
        this.needsCopy = false;
      }
      function parseImage(image, options) {
        var data = null;
        if (isPixelData(options)) {
          data = options;
        } else if (options) {
          check$1.type(options, "object", "invalid pixel data type");
          parseFlags(image, options);
          if ("x" in options) {
            image.xOffset = options.x | 0;
          }
          if ("y" in options) {
            image.yOffset = options.y | 0;
          }
          if (isPixelData(options.data)) {
            data = options.data;
          }
        }
        check$1(
          !image.compressed || data instanceof Uint8Array,
          "compressed texture data must be stored in a uint8array"
        );
        if (options.copy) {
          check$1(!data, "can not specify copy and data field for the same texture");
          var viewW = contextState.viewportWidth;
          var viewH = contextState.viewportHeight;
          image.width = image.width || viewW - image.xOffset;
          image.height = image.height || viewH - image.yOffset;
          image.needsCopy = true;
          check$1(
            image.xOffset >= 0 && image.xOffset < viewW && image.yOffset >= 0 && image.yOffset < viewH && image.width > 0 && image.width <= viewW && image.height > 0 && image.height <= viewH,
            "copy texture read out of bounds"
          );
        } else if (!data) {
          image.width = image.width || 1;
          image.height = image.height || 1;
          image.channels = image.channels || 4;
        } else if (isTypedArray(data)) {
          image.channels = image.channels || 4;
          image.data = data;
          if (!("type" in options) && image.type === GL_UNSIGNED_BYTE$5) {
            image.type = typedArrayCode$1(data);
          }
        } else if (isNumericArray(data)) {
          image.channels = image.channels || 4;
          convertData(image, data);
          image.alignment = 1;
          image.needsFree = true;
        } else if (isNDArrayLike(data)) {
          var array4 = data.data;
          if (!Array.isArray(array4) && image.type === GL_UNSIGNED_BYTE$5) {
            image.type = typedArrayCode$1(array4);
          }
          var shape = data.shape;
          var stride = data.stride;
          var shapeX, shapeY, shapeC, strideX, strideY, strideC;
          if (shape.length === 3) {
            shapeC = shape[2];
            strideC = stride[2];
          } else {
            check$1(shape.length === 2, "invalid ndarray pixel data, must be 2 or 3D");
            shapeC = 1;
            strideC = 1;
          }
          shapeX = shape[0];
          shapeY = shape[1];
          strideX = stride[0];
          strideY = stride[1];
          image.alignment = 1;
          image.width = shapeX;
          image.height = shapeY;
          image.channels = shapeC;
          image.format = image.internalformat = CHANNELS_FORMAT[shapeC];
          image.needsFree = true;
          transposeData(image, array4, strideX, strideY, strideC, data.offset);
        } else if (isCanvasElement(data) || isOffscreenCanvas(data) || isContext2D(data)) {
          if (isCanvasElement(data) || isOffscreenCanvas(data)) {
            image.element = data;
          } else {
            image.element = data.canvas;
          }
          image.width = image.element.width;
          image.height = image.element.height;
          image.channels = 4;
        } else if (isBitmap(data)) {
          image.element = data;
          image.width = data.width;
          image.height = data.height;
          image.channels = 4;
        } else if (isImageElement(data)) {
          image.element = data;
          image.width = data.naturalWidth;
          image.height = data.naturalHeight;
          image.channels = 4;
        } else if (isVideoElement(data)) {
          image.element = data;
          image.width = data.videoWidth;
          image.height = data.videoHeight;
          image.channels = 4;
        } else if (isRectArray(data)) {
          var w2 = image.width || data[0].length;
          var h2 = image.height || data.length;
          var c3 = image.channels;
          if (isArrayLike(data[0][0])) {
            c3 = c3 || data[0][0].length;
          } else {
            c3 = c3 || 1;
          }
          var arrayShape2 = flattenUtils.shape(data);
          var n2 = 1;
          for (var dd2 = 0; dd2 < arrayShape2.length; ++dd2) {
            n2 *= arrayShape2[dd2];
          }
          var allocData = preConvert(image, n2);
          flattenUtils.flatten(data, arrayShape2, "", allocData);
          postConvert(image, allocData);
          image.alignment = 1;
          image.width = w2;
          image.height = h2;
          image.channels = c3;
          image.format = image.internalformat = CHANNELS_FORMAT[c3];
          image.needsFree = true;
        }
        if (image.type === GL_FLOAT$4) {
          check$1(
            limits.extensions.indexOf("oes_texture_float") >= 0,
            "oes_texture_float extension not enabled"
          );
        } else if (image.type === GL_HALF_FLOAT_OES$1) {
          check$1(
            limits.extensions.indexOf("oes_texture_half_float") >= 0,
            "oes_texture_half_float extension not enabled"
          );
        }
      }
      function setImage(info, target, miplevel) {
        var element = info.element;
        var data = info.data;
        var internalformat = info.internalformat;
        var format2 = info.format;
        var type4 = info.type;
        var width2 = info.width;
        var height = info.height;
        setFlags(info);
        if (element) {
          gl2.texImage2D(target, miplevel, format2, format2, type4, element);
        } else if (info.compressed) {
          gl2.compressedTexImage2D(target, miplevel, internalformat, width2, height, 0, data);
        } else if (info.needsCopy) {
          reglPoll();
          gl2.copyTexImage2D(
            target,
            miplevel,
            format2,
            info.xOffset,
            info.yOffset,
            width2,
            height,
            0
          );
        } else {
          gl2.texImage2D(target, miplevel, format2, width2, height, 0, format2, type4, data || null);
        }
      }
      function setSubImage(info, target, x2, y2, miplevel) {
        var element = info.element;
        var data = info.data;
        var internalformat = info.internalformat;
        var format2 = info.format;
        var type4 = info.type;
        var width2 = info.width;
        var height = info.height;
        setFlags(info);
        if (element) {
          gl2.texSubImage2D(
            target,
            miplevel,
            x2,
            y2,
            format2,
            type4,
            element
          );
        } else if (info.compressed) {
          gl2.compressedTexSubImage2D(
            target,
            miplevel,
            x2,
            y2,
            internalformat,
            width2,
            height,
            data
          );
        } else if (info.needsCopy) {
          reglPoll();
          gl2.copyTexSubImage2D(
            target,
            miplevel,
            x2,
            y2,
            info.xOffset,
            info.yOffset,
            width2,
            height
          );
        } else {
          gl2.texSubImage2D(
            target,
            miplevel,
            x2,
            y2,
            width2,
            height,
            format2,
            type4,
            data
          );
        }
      }
      var imagePool = [];
      function allocImage() {
        return imagePool.pop() || new TexImage();
      }
      function freeImage(image) {
        if (image.needsFree) {
          pool.freeType(image.data);
        }
        TexImage.call(image);
        imagePool.push(image);
      }
      function MipMap() {
        TexFlags.call(this);
        this.genMipmaps = false;
        this.mipmapHint = GL_DONT_CARE;
        this.mipmask = 0;
        this.images = Array(16);
      }
      function parseMipMapFromShape(mipmap, width2, height) {
        var img = mipmap.images[0] = allocImage();
        mipmap.mipmask = 1;
        img.width = mipmap.width = width2;
        img.height = mipmap.height = height;
        img.channels = mipmap.channels = 4;
      }
      function parseMipMapFromObject(mipmap, options) {
        var imgData = null;
        if (isPixelData(options)) {
          imgData = mipmap.images[0] = allocImage();
          copyFlags(imgData, mipmap);
          parseImage(imgData, options);
          mipmap.mipmask = 1;
        } else {
          parseFlags(mipmap, options);
          if (Array.isArray(options.mipmap)) {
            var mipData = options.mipmap;
            for (var i2 = 0; i2 < mipData.length; ++i2) {
              imgData = mipmap.images[i2] = allocImage();
              copyFlags(imgData, mipmap);
              imgData.width >>= i2;
              imgData.height >>= i2;
              parseImage(imgData, mipData[i2]);
              mipmap.mipmask |= 1 << i2;
            }
          } else {
            imgData = mipmap.images[0] = allocImage();
            copyFlags(imgData, mipmap);
            parseImage(imgData, options);
            mipmap.mipmask = 1;
          }
        }
        copyFlags(mipmap, mipmap.images[0]);
        if (mipmap.compressed && (mipmap.internalformat === GL_COMPRESSED_RGB_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT3_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT5_EXT)) {
          check$1(
            mipmap.width % 4 === 0 && mipmap.height % 4 === 0,
            "for compressed texture formats, mipmap level 0 must have width and height that are a multiple of 4"
          );
        }
      }
      function setMipMap(mipmap, target) {
        var images = mipmap.images;
        for (var i2 = 0; i2 < images.length; ++i2) {
          if (!images[i2]) {
            return;
          }
          setImage(images[i2], target, i2);
        }
      }
      var mipPool = [];
      function allocMipMap() {
        var result = mipPool.pop() || new MipMap();
        TexFlags.call(result);
        result.mipmask = 0;
        for (var i2 = 0; i2 < 16; ++i2) {
          result.images[i2] = null;
        }
        return result;
      }
      function freeMipMap(mipmap) {
        var images = mipmap.images;
        for (var i2 = 0; i2 < images.length; ++i2) {
          if (images[i2]) {
            freeImage(images[i2]);
          }
          images[i2] = null;
        }
        mipPool.push(mipmap);
      }
      function TexInfo() {
        this.minFilter = GL_NEAREST$1;
        this.magFilter = GL_NEAREST$1;
        this.wrapS = GL_CLAMP_TO_EDGE$1;
        this.wrapT = GL_CLAMP_TO_EDGE$1;
        this.anisotropic = 1;
        this.genMipmaps = false;
        this.mipmapHint = GL_DONT_CARE;
      }
      function parseTexInfo(info, options) {
        if ("min" in options) {
          var minFilter = options.min;
          check$1.parameter(minFilter, minFilters);
          info.minFilter = minFilters[minFilter];
          if (MIPMAP_FILTERS.indexOf(info.minFilter) >= 0 && !("faces" in options)) {
            info.genMipmaps = true;
          }
        }
        if ("mag" in options) {
          var magFilter = options.mag;
          check$1.parameter(magFilter, magFilters);
          info.magFilter = magFilters[magFilter];
        }
        var wrapS = info.wrapS;
        var wrapT = info.wrapT;
        if ("wrap" in options) {
          var wrap = options.wrap;
          if (typeof wrap === "string") {
            check$1.parameter(wrap, wrapModes);
            wrapS = wrapT = wrapModes[wrap];
          } else if (Array.isArray(wrap)) {
            check$1.parameter(wrap[0], wrapModes);
            check$1.parameter(wrap[1], wrapModes);
            wrapS = wrapModes[wrap[0]];
            wrapT = wrapModes[wrap[1]];
          }
        } else {
          if ("wrapS" in options) {
            var optWrapS = options.wrapS;
            check$1.parameter(optWrapS, wrapModes);
            wrapS = wrapModes[optWrapS];
          }
          if ("wrapT" in options) {
            var optWrapT = options.wrapT;
            check$1.parameter(optWrapT, wrapModes);
            wrapT = wrapModes[optWrapT];
          }
        }
        info.wrapS = wrapS;
        info.wrapT = wrapT;
        if ("anisotropic" in options) {
          var anisotropic = options.anisotropic;
          check$1(
            typeof anisotropic === "number" && anisotropic >= 1 && anisotropic <= limits.maxAnisotropic,
            "aniso samples must be between 1 and "
          );
          info.anisotropic = options.anisotropic;
        }
        if ("mipmap" in options) {
          var hasMipMap = false;
          switch (typeof options.mipmap) {
            case "string":
              check$1.parameter(
                options.mipmap,
                mipmapHint,
                "invalid mipmap hint"
              );
              info.mipmapHint = mipmapHint[options.mipmap];
              info.genMipmaps = true;
              hasMipMap = true;
              break;
            case "boolean":
              hasMipMap = info.genMipmaps = options.mipmap;
              break;
            case "object":
              check$1(Array.isArray(options.mipmap), "invalid mipmap type");
              info.genMipmaps = false;
              hasMipMap = true;
              break;
            default:
              check$1.raise("invalid mipmap type");
          }
          if (hasMipMap && !("min" in options)) {
            info.minFilter = GL_NEAREST_MIPMAP_NEAREST$1;
          }
        }
      }
      function setTexInfo(info, target) {
        gl2.texParameteri(target, GL_TEXTURE_MIN_FILTER, info.minFilter);
        gl2.texParameteri(target, GL_TEXTURE_MAG_FILTER, info.magFilter);
        gl2.texParameteri(target, GL_TEXTURE_WRAP_S, info.wrapS);
        gl2.texParameteri(target, GL_TEXTURE_WRAP_T, info.wrapT);
        if (extensions.ext_texture_filter_anisotropic) {
          gl2.texParameteri(target, GL_TEXTURE_MAX_ANISOTROPY_EXT, info.anisotropic);
        }
        if (info.genMipmaps) {
          gl2.hint(GL_GENERATE_MIPMAP_HINT, info.mipmapHint);
          gl2.generateMipmap(target);
        }
      }
      var textureCount = 0;
      var textureSet = {};
      var numTexUnits = limits.maxTextureUnits;
      var textureUnits = Array(numTexUnits).map(function() {
        return null;
      });
      function REGLTexture(target) {
        TexFlags.call(this);
        this.mipmask = 0;
        this.internalformat = GL_RGBA$1;
        this.id = textureCount++;
        this.refCount = 1;
        this.target = target;
        this.texture = gl2.createTexture();
        this.unit = -1;
        this.bindCount = 0;
        this.texInfo = new TexInfo();
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      function tempBind(texture) {
        gl2.activeTexture(GL_TEXTURE0$1);
        gl2.bindTexture(texture.target, texture.texture);
      }
      function tempRestore() {
        var prev = textureUnits[0];
        if (prev) {
          gl2.bindTexture(prev.target, prev.texture);
        } else {
          gl2.bindTexture(GL_TEXTURE_2D$1, null);
        }
      }
      function destroy(texture) {
        var handle = texture.texture;
        check$1(handle, "must not double destroy texture");
        var unit = texture.unit;
        var target = texture.target;
        if (unit >= 0) {
          gl2.activeTexture(GL_TEXTURE0$1 + unit);
          gl2.bindTexture(target, null);
          textureUnits[unit] = null;
        }
        gl2.deleteTexture(handle);
        texture.texture = null;
        texture.params = null;
        texture.pixels = null;
        texture.refCount = 0;
        delete textureSet[texture.id];
        stats2.textureCount--;
      }
      extend(REGLTexture.prototype, {
        bind: function() {
          var texture = this;
          texture.bindCount += 1;
          var unit = texture.unit;
          if (unit < 0) {
            for (var i2 = 0; i2 < numTexUnits; ++i2) {
              var other = textureUnits[i2];
              if (other) {
                if (other.bindCount > 0) {
                  continue;
                }
                other.unit = -1;
              }
              textureUnits[i2] = texture;
              unit = i2;
              break;
            }
            if (unit >= numTexUnits) {
              check$1.raise("insufficient number of texture units");
            }
            if (config.profile && stats2.maxTextureUnits < unit + 1) {
              stats2.maxTextureUnits = unit + 1;
            }
            texture.unit = unit;
            gl2.activeTexture(GL_TEXTURE0$1 + unit);
            gl2.bindTexture(texture.target, texture.texture);
          }
          return unit;
        },
        unbind: function() {
          this.bindCount -= 1;
        },
        decRef: function() {
          if (--this.refCount <= 0) {
            destroy(this);
          }
        }
      });
      function createTexture2D(a2, b2) {
        var texture = new REGLTexture(GL_TEXTURE_2D$1);
        textureSet[texture.id] = texture;
        stats2.textureCount++;
        function reglTexture2D(a3, b3) {
          var texInfo = texture.texInfo;
          TexInfo.call(texInfo);
          var mipData = allocMipMap();
          if (typeof a3 === "number") {
            if (typeof b3 === "number") {
              parseMipMapFromShape(mipData, a3 | 0, b3 | 0);
            } else {
              parseMipMapFromShape(mipData, a3 | 0, a3 | 0);
            }
          } else if (a3) {
            check$1.type(a3, "object", "invalid arguments to regl.texture");
            parseTexInfo(texInfo, a3);
            parseMipMapFromObject(mipData, a3);
          } else {
            parseMipMapFromShape(mipData, 1, 1);
          }
          if (texInfo.genMipmaps) {
            mipData.mipmask = (mipData.width << 1) - 1;
          }
          texture.mipmask = mipData.mipmask;
          copyFlags(texture, mipData);
          check$1.texture2D(texInfo, mipData, limits);
          texture.internalformat = mipData.internalformat;
          reglTexture2D.width = mipData.width;
          reglTexture2D.height = mipData.height;
          tempBind(texture);
          setMipMap(mipData, GL_TEXTURE_2D$1);
          setTexInfo(texInfo, GL_TEXTURE_2D$1);
          tempRestore();
          freeMipMap(mipData);
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              mipData.width,
              mipData.height,
              texInfo.genMipmaps,
              false
            );
          }
          reglTexture2D.format = textureFormatsInvert[texture.internalformat];
          reglTexture2D.type = textureTypesInvert[texture.type];
          reglTexture2D.mag = magFiltersInvert[texInfo.magFilter];
          reglTexture2D.min = minFiltersInvert[texInfo.minFilter];
          reglTexture2D.wrapS = wrapModesInvert[texInfo.wrapS];
          reglTexture2D.wrapT = wrapModesInvert[texInfo.wrapT];
          return reglTexture2D;
        }
        function subimage(image, x_, y_, level_) {
          check$1(!!image, "must specify image data");
          var x2 = x_ | 0;
          var y2 = y_ | 0;
          var level = level_ | 0;
          var imageData = allocImage();
          copyFlags(imageData, texture);
          imageData.width = 0;
          imageData.height = 0;
          parseImage(imageData, image);
          imageData.width = imageData.width || (texture.width >> level) - x2;
          imageData.height = imageData.height || (texture.height >> level) - y2;
          check$1(
            texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat,
            "incompatible format for texture.subimage"
          );
          check$1(
            x2 >= 0 && y2 >= 0 && x2 + imageData.width <= texture.width && y2 + imageData.height <= texture.height,
            "texture.subimage write out of bounds"
          );
          check$1(
            texture.mipmask & 1 << level,
            "missing mipmap data"
          );
          check$1(
            imageData.data || imageData.element || imageData.needsCopy,
            "missing image data"
          );
          tempBind(texture);
          setSubImage(imageData, GL_TEXTURE_2D$1, x2, y2, level);
          tempRestore();
          freeImage(imageData);
          return reglTexture2D;
        }
        function resize(w_, h_) {
          var w2 = w_ | 0;
          var h2 = h_ | 0 || w2;
          if (w2 === texture.width && h2 === texture.height) {
            return reglTexture2D;
          }
          reglTexture2D.width = texture.width = w2;
          reglTexture2D.height = texture.height = h2;
          tempBind(texture);
          for (var i2 = 0; texture.mipmask >> i2; ++i2) {
            var _w3 = w2 >> i2;
            var _h3 = h2 >> i2;
            if (!_w3 || !_h3) break;
            gl2.texImage2D(
              GL_TEXTURE_2D$1,
              i2,
              texture.format,
              _w3,
              _h3,
              0,
              texture.format,
              texture.type,
              null
            );
          }
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              w2,
              h2,
              false,
              false
            );
          }
          return reglTexture2D;
        }
        reglTexture2D(a2, b2);
        reglTexture2D.subimage = subimage;
        reglTexture2D.resize = resize;
        reglTexture2D._reglType = "texture2d";
        reglTexture2D._texture = texture;
        if (config.profile) {
          reglTexture2D.stats = texture.stats;
        }
        reglTexture2D.destroy = function() {
          texture.decRef();
        };
        return reglTexture2D;
      }
      function createTextureCube(a0, a1, a2, a3, a4, a5) {
        var texture = new REGLTexture(GL_TEXTURE_CUBE_MAP$1);
        textureSet[texture.id] = texture;
        stats2.cubeCount++;
        var faces = new Array(6);
        function reglTextureCube(a02, a12, a22, a32, a42, a52) {
          var i2;
          var texInfo = texture.texInfo;
          TexInfo.call(texInfo);
          for (i2 = 0; i2 < 6; ++i2) {
            faces[i2] = allocMipMap();
          }
          if (typeof a02 === "number" || !a02) {
            var s2 = a02 | 0 || 1;
            for (i2 = 0; i2 < 6; ++i2) {
              parseMipMapFromShape(faces[i2], s2, s2);
            }
          } else if (typeof a02 === "object") {
            if (a12) {
              parseMipMapFromObject(faces[0], a02);
              parseMipMapFromObject(faces[1], a12);
              parseMipMapFromObject(faces[2], a22);
              parseMipMapFromObject(faces[3], a32);
              parseMipMapFromObject(faces[4], a42);
              parseMipMapFromObject(faces[5], a52);
            } else {
              parseTexInfo(texInfo, a02);
              parseFlags(texture, a02);
              if ("faces" in a02) {
                var faceInput = a02.faces;
                check$1(
                  Array.isArray(faceInput) && faceInput.length === 6,
                  "cube faces must be a length 6 array"
                );
                for (i2 = 0; i2 < 6; ++i2) {
                  check$1(
                    typeof faceInput[i2] === "object" && !!faceInput[i2],
                    "invalid input for cube map face"
                  );
                  copyFlags(faces[i2], texture);
                  parseMipMapFromObject(faces[i2], faceInput[i2]);
                }
              } else {
                for (i2 = 0; i2 < 6; ++i2) {
                  parseMipMapFromObject(faces[i2], a02);
                }
              }
            }
          } else {
            check$1.raise("invalid arguments to cube map");
          }
          copyFlags(texture, faces[0]);
          if (!limits.npotTextureCube) {
            check$1(isPow2$1(texture.width) && isPow2$1(texture.height), "your browser does not support non power or two texture dimensions");
          }
          if (texInfo.genMipmaps) {
            texture.mipmask = (faces[0].width << 1) - 1;
          } else {
            texture.mipmask = faces[0].mipmask;
          }
          check$1.textureCube(texture, texInfo, faces, limits);
          texture.internalformat = faces[0].internalformat;
          reglTextureCube.width = faces[0].width;
          reglTextureCube.height = faces[0].height;
          tempBind(texture);
          for (i2 = 0; i2 < 6; ++i2) {
            setMipMap(faces[i2], GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i2);
          }
          setTexInfo(texInfo, GL_TEXTURE_CUBE_MAP$1);
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              reglTextureCube.width,
              reglTextureCube.height,
              texInfo.genMipmaps,
              true
            );
          }
          reglTextureCube.format = textureFormatsInvert[texture.internalformat];
          reglTextureCube.type = textureTypesInvert[texture.type];
          reglTextureCube.mag = magFiltersInvert[texInfo.magFilter];
          reglTextureCube.min = minFiltersInvert[texInfo.minFilter];
          reglTextureCube.wrapS = wrapModesInvert[texInfo.wrapS];
          reglTextureCube.wrapT = wrapModesInvert[texInfo.wrapT];
          for (i2 = 0; i2 < 6; ++i2) {
            freeMipMap(faces[i2]);
          }
          return reglTextureCube;
        }
        function subimage(face, image, x_, y_, level_) {
          check$1(!!image, "must specify image data");
          check$1(typeof face === "number" && face === (face | 0) && face >= 0 && face < 6, "invalid face");
          var x2 = x_ | 0;
          var y2 = y_ | 0;
          var level = level_ | 0;
          var imageData = allocImage();
          copyFlags(imageData, texture);
          imageData.width = 0;
          imageData.height = 0;
          parseImage(imageData, image);
          imageData.width = imageData.width || (texture.width >> level) - x2;
          imageData.height = imageData.height || (texture.height >> level) - y2;
          check$1(
            texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat,
            "incompatible format for texture.subimage"
          );
          check$1(
            x2 >= 0 && y2 >= 0 && x2 + imageData.width <= texture.width && y2 + imageData.height <= texture.height,
            "texture.subimage write out of bounds"
          );
          check$1(
            texture.mipmask & 1 << level,
            "missing mipmap data"
          );
          check$1(
            imageData.data || imageData.element || imageData.needsCopy,
            "missing image data"
          );
          tempBind(texture);
          setSubImage(imageData, GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + face, x2, y2, level);
          tempRestore();
          freeImage(imageData);
          return reglTextureCube;
        }
        function resize(radius_) {
          var radius = radius_ | 0;
          if (radius === texture.width) {
            return;
          }
          reglTextureCube.width = texture.width = radius;
          reglTextureCube.height = texture.height = radius;
          tempBind(texture);
          for (var i2 = 0; i2 < 6; ++i2) {
            for (var j2 = 0; texture.mipmask >> j2; ++j2) {
              gl2.texImage2D(
                GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i2,
                j2,
                texture.format,
                radius >> j2,
                radius >> j2,
                0,
                texture.format,
                texture.type,
                null
              );
            }
          }
          tempRestore();
          if (config.profile) {
            texture.stats.size = getTextureSize(
              texture.internalformat,
              texture.type,
              reglTextureCube.width,
              reglTextureCube.height,
              false,
              true
            );
          }
          return reglTextureCube;
        }
        reglTextureCube(a0, a1, a2, a3, a4, a5);
        reglTextureCube.subimage = subimage;
        reglTextureCube.resize = resize;
        reglTextureCube._reglType = "textureCube";
        reglTextureCube._texture = texture;
        if (config.profile) {
          reglTextureCube.stats = texture.stats;
        }
        reglTextureCube.destroy = function() {
          texture.decRef();
        };
        return reglTextureCube;
      }
      function destroyTextures() {
        for (var i2 = 0; i2 < numTexUnits; ++i2) {
          gl2.activeTexture(GL_TEXTURE0$1 + i2);
          gl2.bindTexture(GL_TEXTURE_2D$1, null);
          textureUnits[i2] = null;
        }
        values(textureSet).forEach(destroy);
        stats2.cubeCount = 0;
        stats2.textureCount = 0;
      }
      if (config.profile) {
        stats2.getTotalTextureSize = function() {
          var total = 0;
          Object.keys(textureSet).forEach(function(key) {
            total += textureSet[key].stats.size;
          });
          return total;
        };
      }
      function restoreTextures() {
        for (var i2 = 0; i2 < numTexUnits; ++i2) {
          var tex = textureUnits[i2];
          if (tex) {
            tex.bindCount = 0;
            tex.unit = -1;
            textureUnits[i2] = null;
          }
        }
        values(textureSet).forEach(function(texture) {
          texture.texture = gl2.createTexture();
          gl2.bindTexture(texture.target, texture.texture);
          for (var i3 = 0; i3 < 32; ++i3) {
            if ((texture.mipmask & 1 << i3) === 0) {
              continue;
            }
            if (texture.target === GL_TEXTURE_2D$1) {
              gl2.texImage2D(
                GL_TEXTURE_2D$1,
                i3,
                texture.internalformat,
                texture.width >> i3,
                texture.height >> i3,
                0,
                texture.internalformat,
                texture.type,
                null
              );
            } else {
              for (var j2 = 0; j2 < 6; ++j2) {
                gl2.texImage2D(
                  GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + j2,
                  i3,
                  texture.internalformat,
                  texture.width >> i3,
                  texture.height >> i3,
                  0,
                  texture.internalformat,
                  texture.type,
                  null
                );
              }
            }
          }
          setTexInfo(texture.texInfo, texture.target);
        });
      }
      function refreshTextures() {
        for (var i2 = 0; i2 < numTexUnits; ++i2) {
          var tex = textureUnits[i2];
          if (tex) {
            tex.bindCount = 0;
            tex.unit = -1;
            textureUnits[i2] = null;
          }
          gl2.activeTexture(GL_TEXTURE0$1 + i2);
          gl2.bindTexture(GL_TEXTURE_2D$1, null);
          gl2.bindTexture(GL_TEXTURE_CUBE_MAP$1, null);
        }
      }
      return {
        create2D: createTexture2D,
        createCube: createTextureCube,
        clear: destroyTextures,
        getTexture: function(wrapper) {
          return null;
        },
        restore: restoreTextures,
        refresh: refreshTextures
      };
    }
    var GL_RENDERBUFFER = 36161;
    var GL_RGBA4$1 = 32854;
    var GL_RGB5_A1$1 = 32855;
    var GL_RGB565$1 = 36194;
    var GL_DEPTH_COMPONENT16 = 33189;
    var GL_STENCIL_INDEX8 = 36168;
    var GL_DEPTH_STENCIL$1 = 34041;
    var GL_SRGB8_ALPHA8_EXT = 35907;
    var GL_RGBA32F_EXT = 34836;
    var GL_RGBA16F_EXT = 34842;
    var GL_RGB16F_EXT = 34843;
    var FORMAT_SIZES = [];
    FORMAT_SIZES[GL_RGBA4$1] = 2;
    FORMAT_SIZES[GL_RGB5_A1$1] = 2;
    FORMAT_SIZES[GL_RGB565$1] = 2;
    FORMAT_SIZES[GL_DEPTH_COMPONENT16] = 2;
    FORMAT_SIZES[GL_STENCIL_INDEX8] = 1;
    FORMAT_SIZES[GL_DEPTH_STENCIL$1] = 4;
    FORMAT_SIZES[GL_SRGB8_ALPHA8_EXT] = 4;
    FORMAT_SIZES[GL_RGBA32F_EXT] = 16;
    FORMAT_SIZES[GL_RGBA16F_EXT] = 8;
    FORMAT_SIZES[GL_RGB16F_EXT] = 6;
    function getRenderbufferSize(format2, width2, height) {
      return FORMAT_SIZES[format2] * width2 * height;
    }
    var wrapRenderbuffers = function(gl2, extensions, limits, stats2, config) {
      var formatTypes = {
        "rgba4": GL_RGBA4$1,
        "rgb565": GL_RGB565$1,
        "rgb5 a1": GL_RGB5_A1$1,
        "depth": GL_DEPTH_COMPONENT16,
        "stencil": GL_STENCIL_INDEX8,
        "depth stencil": GL_DEPTH_STENCIL$1
      };
      if (extensions.ext_srgb) {
        formatTypes["srgba"] = GL_SRGB8_ALPHA8_EXT;
      }
      if (extensions.ext_color_buffer_half_float) {
        formatTypes["rgba16f"] = GL_RGBA16F_EXT;
        formatTypes["rgb16f"] = GL_RGB16F_EXT;
      }
      if (extensions.webgl_color_buffer_float) {
        formatTypes["rgba32f"] = GL_RGBA32F_EXT;
      }
      var formatTypesInvert = [];
      Object.keys(formatTypes).forEach(function(key) {
        var val = formatTypes[key];
        formatTypesInvert[val] = key;
      });
      var renderbufferCount = 0;
      var renderbufferSet = {};
      function REGLRenderbuffer(renderbuffer) {
        this.id = renderbufferCount++;
        this.refCount = 1;
        this.renderbuffer = renderbuffer;
        this.format = GL_RGBA4$1;
        this.width = 0;
        this.height = 0;
        if (config.profile) {
          this.stats = { size: 0 };
        }
      }
      REGLRenderbuffer.prototype.decRef = function() {
        if (--this.refCount <= 0) {
          destroy(this);
        }
      };
      function destroy(rb2) {
        var handle = rb2.renderbuffer;
        check$1(handle, "must not double destroy renderbuffer");
        gl2.bindRenderbuffer(GL_RENDERBUFFER, null);
        gl2.deleteRenderbuffer(handle);
        rb2.renderbuffer = null;
        rb2.refCount = 0;
        delete renderbufferSet[rb2.id];
        stats2.renderbufferCount--;
      }
      function createRenderbuffer(a2, b2) {
        var renderbuffer = new REGLRenderbuffer(gl2.createRenderbuffer());
        renderbufferSet[renderbuffer.id] = renderbuffer;
        stats2.renderbufferCount++;
        function reglRenderbuffer(a3, b3) {
          var w2 = 0;
          var h2 = 0;
          var format2 = GL_RGBA4$1;
          if (typeof a3 === "object" && a3) {
            var options = a3;
            if ("shape" in options) {
              var shape = options.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid renderbuffer shape"
              );
              w2 = shape[0] | 0;
              h2 = shape[1] | 0;
            } else {
              if ("radius" in options) {
                w2 = h2 = options.radius | 0;
              }
              if ("width" in options) {
                w2 = options.width | 0;
              }
              if ("height" in options) {
                h2 = options.height | 0;
              }
            }
            if ("format" in options) {
              check$1.parameter(
                options.format,
                formatTypes,
                "invalid renderbuffer format"
              );
              format2 = formatTypes[options.format];
            }
          } else if (typeof a3 === "number") {
            w2 = a3 | 0;
            if (typeof b3 === "number") {
              h2 = b3 | 0;
            } else {
              h2 = w2;
            }
          } else if (!a3) {
            w2 = h2 = 1;
          } else {
            check$1.raise("invalid arguments to renderbuffer constructor");
          }
          check$1(
            w2 > 0 && h2 > 0 && w2 <= limits.maxRenderbufferSize && h2 <= limits.maxRenderbufferSize,
            "invalid renderbuffer size"
          );
          if (w2 === renderbuffer.width && h2 === renderbuffer.height && format2 === renderbuffer.format) {
            return;
          }
          reglRenderbuffer.width = renderbuffer.width = w2;
          reglRenderbuffer.height = renderbuffer.height = h2;
          renderbuffer.format = format2;
          gl2.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
          gl2.renderbufferStorage(GL_RENDERBUFFER, format2, w2, h2);
          check$1(
            gl2.getError() === 0,
            "invalid render buffer format"
          );
          if (config.profile) {
            renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
          }
          reglRenderbuffer.format = formatTypesInvert[renderbuffer.format];
          return reglRenderbuffer;
        }
        function resize(w_, h_) {
          var w2 = w_ | 0;
          var h2 = h_ | 0 || w2;
          if (w2 === renderbuffer.width && h2 === renderbuffer.height) {
            return reglRenderbuffer;
          }
          check$1(
            w2 > 0 && h2 > 0 && w2 <= limits.maxRenderbufferSize && h2 <= limits.maxRenderbufferSize,
            "invalid renderbuffer size"
          );
          reglRenderbuffer.width = renderbuffer.width = w2;
          reglRenderbuffer.height = renderbuffer.height = h2;
          gl2.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
          gl2.renderbufferStorage(GL_RENDERBUFFER, renderbuffer.format, w2, h2);
          check$1(
            gl2.getError() === 0,
            "invalid render buffer format"
          );
          if (config.profile) {
            renderbuffer.stats.size = getRenderbufferSize(
              renderbuffer.format,
              renderbuffer.width,
              renderbuffer.height
            );
          }
          return reglRenderbuffer;
        }
        reglRenderbuffer(a2, b2);
        reglRenderbuffer.resize = resize;
        reglRenderbuffer._reglType = "renderbuffer";
        reglRenderbuffer._renderbuffer = renderbuffer;
        if (config.profile) {
          reglRenderbuffer.stats = renderbuffer.stats;
        }
        reglRenderbuffer.destroy = function() {
          renderbuffer.decRef();
        };
        return reglRenderbuffer;
      }
      if (config.profile) {
        stats2.getTotalRenderbufferSize = function() {
          var total = 0;
          Object.keys(renderbufferSet).forEach(function(key) {
            total += renderbufferSet[key].stats.size;
          });
          return total;
        };
      }
      function restoreRenderbuffers() {
        values(renderbufferSet).forEach(function(rb2) {
          rb2.renderbuffer = gl2.createRenderbuffer();
          gl2.bindRenderbuffer(GL_RENDERBUFFER, rb2.renderbuffer);
          gl2.renderbufferStorage(GL_RENDERBUFFER, rb2.format, rb2.width, rb2.height);
        });
        gl2.bindRenderbuffer(GL_RENDERBUFFER, null);
      }
      return {
        create: createRenderbuffer,
        clear: function() {
          values(renderbufferSet).forEach(destroy);
        },
        restore: restoreRenderbuffers
      };
    };
    var GL_FRAMEBUFFER$1 = 36160;
    var GL_RENDERBUFFER$1 = 36161;
    var GL_TEXTURE_2D$2 = 3553;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 = 34069;
    var GL_COLOR_ATTACHMENT0$1 = 36064;
    var GL_DEPTH_ATTACHMENT = 36096;
    var GL_STENCIL_ATTACHMENT = 36128;
    var GL_DEPTH_STENCIL_ATTACHMENT = 33306;
    var GL_FRAMEBUFFER_COMPLETE$1 = 36053;
    var GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 36054;
    var GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 36055;
    var GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 36057;
    var GL_FRAMEBUFFER_UNSUPPORTED = 36061;
    var GL_HALF_FLOAT_OES$2 = 36193;
    var GL_UNSIGNED_BYTE$6 = 5121;
    var GL_FLOAT$5 = 5126;
    var GL_RGB$1 = 6407;
    var GL_RGBA$2 = 6408;
    var GL_DEPTH_COMPONENT$1 = 6402;
    var colorTextureFormatEnums = [
      GL_RGB$1,
      GL_RGBA$2
    ];
    var textureFormatChannels = [];
    textureFormatChannels[GL_RGBA$2] = 4;
    textureFormatChannels[GL_RGB$1] = 3;
    var textureTypeSizes = [];
    textureTypeSizes[GL_UNSIGNED_BYTE$6] = 1;
    textureTypeSizes[GL_FLOAT$5] = 4;
    textureTypeSizes[GL_HALF_FLOAT_OES$2] = 2;
    var GL_RGBA4$2 = 32854;
    var GL_RGB5_A1$2 = 32855;
    var GL_RGB565$2 = 36194;
    var GL_DEPTH_COMPONENT16$1 = 33189;
    var GL_STENCIL_INDEX8$1 = 36168;
    var GL_DEPTH_STENCIL$2 = 34041;
    var GL_SRGB8_ALPHA8_EXT$1 = 35907;
    var GL_RGBA32F_EXT$1 = 34836;
    var GL_RGBA16F_EXT$1 = 34842;
    var GL_RGB16F_EXT$1 = 34843;
    var colorRenderbufferFormatEnums = [
      GL_RGBA4$2,
      GL_RGB5_A1$2,
      GL_RGB565$2,
      GL_SRGB8_ALPHA8_EXT$1,
      GL_RGBA16F_EXT$1,
      GL_RGB16F_EXT$1,
      GL_RGBA32F_EXT$1
    ];
    var statusCode = {};
    statusCode[GL_FRAMEBUFFER_COMPLETE$1] = "complete";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT] = "incomplete attachment";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS] = "incomplete dimensions";
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT] = "incomplete, missing attachment";
    statusCode[GL_FRAMEBUFFER_UNSUPPORTED] = "unsupported";
    function wrapFBOState(gl2, extensions, limits, textureState, renderbufferState, stats2) {
      var framebufferState = {
        cur: null,
        next: null,
        dirty: false,
        setFBO: null
      };
      var colorTextureFormats = ["rgba"];
      var colorRenderbufferFormats = ["rgba4", "rgb565", "rgb5 a1"];
      if (extensions.ext_srgb) {
        colorRenderbufferFormats.push("srgba");
      }
      if (extensions.ext_color_buffer_half_float) {
        colorRenderbufferFormats.push("rgba16f", "rgb16f");
      }
      if (extensions.webgl_color_buffer_float) {
        colorRenderbufferFormats.push("rgba32f");
      }
      var colorTypes = ["uint8"];
      if (extensions.oes_texture_half_float) {
        colorTypes.push("half float", "float16");
      }
      if (extensions.oes_texture_float) {
        colorTypes.push("float", "float32");
      }
      function FramebufferAttachment(target, texture, renderbuffer) {
        this.target = target;
        this.texture = texture;
        this.renderbuffer = renderbuffer;
        var w2 = 0;
        var h2 = 0;
        if (texture) {
          w2 = texture.width;
          h2 = texture.height;
        } else if (renderbuffer) {
          w2 = renderbuffer.width;
          h2 = renderbuffer.height;
        }
        this.width = w2;
        this.height = h2;
      }
      function decRef(attachment) {
        if (attachment) {
          if (attachment.texture) {
            attachment.texture._texture.decRef();
          }
          if (attachment.renderbuffer) {
            attachment.renderbuffer._renderbuffer.decRef();
          }
        }
      }
      function incRefAndCheckShape(attachment, width2, height) {
        if (!attachment) {
          return;
        }
        if (attachment.texture) {
          var texture = attachment.texture._texture;
          var tw2 = Math.max(1, texture.width);
          var th2 = Math.max(1, texture.height);
          check$1(
            tw2 === width2 && th2 === height,
            "inconsistent width/height for supplied texture"
          );
          texture.refCount += 1;
        } else {
          var renderbuffer = attachment.renderbuffer._renderbuffer;
          check$1(
            renderbuffer.width === width2 && renderbuffer.height === height,
            "inconsistent width/height for renderbuffer"
          );
          renderbuffer.refCount += 1;
        }
      }
      function attach(location, attachment) {
        if (attachment) {
          if (attachment.texture) {
            gl2.framebufferTexture2D(
              GL_FRAMEBUFFER$1,
              location,
              attachment.target,
              attachment.texture._texture.texture,
              0
            );
          } else {
            gl2.framebufferRenderbuffer(
              GL_FRAMEBUFFER$1,
              location,
              GL_RENDERBUFFER$1,
              attachment.renderbuffer._renderbuffer.renderbuffer
            );
          }
        }
      }
      function parseAttachment(attachment) {
        var target = GL_TEXTURE_2D$2;
        var texture = null;
        var renderbuffer = null;
        var data = attachment;
        if (typeof attachment === "object") {
          data = attachment.data;
          if ("target" in attachment) {
            target = attachment.target | 0;
          }
        }
        check$1.type(data, "function", "invalid attachment data");
        var type4 = data._reglType;
        if (type4 === "texture2d") {
          texture = data;
          check$1(target === GL_TEXTURE_2D$2);
        } else if (type4 === "textureCube") {
          texture = data;
          check$1(
            target >= GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 && target < GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + 6,
            "invalid cube map target"
          );
        } else if (type4 === "renderbuffer") {
          renderbuffer = data;
          target = GL_RENDERBUFFER$1;
        } else {
          check$1.raise("invalid regl object for attachment");
        }
        return new FramebufferAttachment(target, texture, renderbuffer);
      }
      function allocAttachment(width2, height, isTexture, format2, type4) {
        if (isTexture) {
          var texture = textureState.create2D({
            width: width2,
            height,
            format: format2,
            type: type4
          });
          texture._texture.refCount = 0;
          return new FramebufferAttachment(GL_TEXTURE_2D$2, texture, null);
        } else {
          var rb2 = renderbufferState.create({
            width: width2,
            height,
            format: format2
          });
          rb2._renderbuffer.refCount = 0;
          return new FramebufferAttachment(GL_RENDERBUFFER$1, null, rb2);
        }
      }
      function unwrapAttachment(attachment) {
        return attachment && (attachment.texture || attachment.renderbuffer);
      }
      function resizeAttachment(attachment, w2, h2) {
        if (attachment) {
          if (attachment.texture) {
            attachment.texture.resize(w2, h2);
          } else if (attachment.renderbuffer) {
            attachment.renderbuffer.resize(w2, h2);
          }
          attachment.width = w2;
          attachment.height = h2;
        }
      }
      var framebufferCount = 0;
      var framebufferSet = {};
      function REGLFramebuffer() {
        this.id = framebufferCount++;
        framebufferSet[this.id] = this;
        this.framebuffer = gl2.createFramebuffer();
        this.width = 0;
        this.height = 0;
        this.colorAttachments = [];
        this.depthAttachment = null;
        this.stencilAttachment = null;
        this.depthStencilAttachment = null;
      }
      function decFBORefs(framebuffer) {
        framebuffer.colorAttachments.forEach(decRef);
        decRef(framebuffer.depthAttachment);
        decRef(framebuffer.stencilAttachment);
        decRef(framebuffer.depthStencilAttachment);
      }
      function destroy(framebuffer) {
        var handle = framebuffer.framebuffer;
        check$1(handle, "must not double destroy framebuffer");
        gl2.deleteFramebuffer(handle);
        framebuffer.framebuffer = null;
        stats2.framebufferCount--;
        delete framebufferSet[framebuffer.id];
      }
      function updateFramebuffer(framebuffer) {
        var i2;
        gl2.bindFramebuffer(GL_FRAMEBUFFER$1, framebuffer.framebuffer);
        var colorAttachments = framebuffer.colorAttachments;
        for (i2 = 0; i2 < colorAttachments.length; ++i2) {
          attach(GL_COLOR_ATTACHMENT0$1 + i2, colorAttachments[i2]);
        }
        for (i2 = colorAttachments.length; i2 < limits.maxColorAttachments; ++i2) {
          gl2.framebufferTexture2D(
            GL_FRAMEBUFFER$1,
            GL_COLOR_ATTACHMENT0$1 + i2,
            GL_TEXTURE_2D$2,
            null,
            0
          );
        }
        gl2.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_DEPTH_STENCIL_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        gl2.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_DEPTH_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        gl2.framebufferTexture2D(
          GL_FRAMEBUFFER$1,
          GL_STENCIL_ATTACHMENT,
          GL_TEXTURE_2D$2,
          null,
          0
        );
        attach(GL_DEPTH_ATTACHMENT, framebuffer.depthAttachment);
        attach(GL_STENCIL_ATTACHMENT, framebuffer.stencilAttachment);
        attach(GL_DEPTH_STENCIL_ATTACHMENT, framebuffer.depthStencilAttachment);
        var status = gl2.checkFramebufferStatus(GL_FRAMEBUFFER$1);
        if (!gl2.isContextLost() && status !== GL_FRAMEBUFFER_COMPLETE$1) {
          check$1.raise("framebuffer configuration not supported, status = " + statusCode[status]);
        }
        gl2.bindFramebuffer(GL_FRAMEBUFFER$1, framebufferState.next ? framebufferState.next.framebuffer : null);
        framebufferState.cur = framebufferState.next;
        gl2.getError();
      }
      function createFBO(a0, a1) {
        var framebuffer = new REGLFramebuffer();
        stats2.framebufferCount++;
        function reglFramebuffer(a2, b2) {
          var i2;
          check$1(
            framebufferState.next !== framebuffer,
            "can not update framebuffer which is currently in use"
          );
          var width2 = 0;
          var height = 0;
          var needsDepth = true;
          var needsStencil = true;
          var colorBuffer = null;
          var colorTexture = true;
          var colorFormat = "rgba";
          var colorType = "uint8";
          var colorCount = 1;
          var depthBuffer = null;
          var stencilBuffer = null;
          var depthStencilBuffer = null;
          var depthStencilTexture = false;
          if (typeof a2 === "number") {
            width2 = a2 | 0;
            height = b2 | 0 || width2;
          } else if (!a2) {
            width2 = height = 1;
          } else {
            check$1.type(a2, "object", "invalid arguments for framebuffer");
            var options = a2;
            if ("shape" in options) {
              var shape = options.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid shape for framebuffer"
              );
              width2 = shape[0];
              height = shape[1];
            } else {
              if ("radius" in options) {
                width2 = height = options.radius;
              }
              if ("width" in options) {
                width2 = options.width;
              }
              if ("height" in options) {
                height = options.height;
              }
            }
            if ("color" in options || "colors" in options) {
              colorBuffer = options.color || options.colors;
              if (Array.isArray(colorBuffer)) {
                check$1(
                  colorBuffer.length === 1 || extensions.webgl_draw_buffers,
                  "multiple render targets not supported"
                );
              }
            }
            if (!colorBuffer) {
              if ("colorCount" in options) {
                colorCount = options.colorCount | 0;
                check$1(colorCount > 0, "invalid color buffer count");
              }
              if ("colorTexture" in options) {
                colorTexture = !!options.colorTexture;
                colorFormat = "rgba4";
              }
              if ("colorType" in options) {
                colorType = options.colorType;
                if (!colorTexture) {
                  if (colorType === "half float" || colorType === "float16") {
                    check$1(
                      extensions.ext_color_buffer_half_float,
                      "you must enable EXT_color_buffer_half_float to use 16-bit render buffers"
                    );
                    colorFormat = "rgba16f";
                  } else if (colorType === "float" || colorType === "float32") {
                    check$1(
                      extensions.webgl_color_buffer_float,
                      "you must enable WEBGL_color_buffer_float in order to use 32-bit floating point renderbuffers"
                    );
                    colorFormat = "rgba32f";
                  }
                } else {
                  check$1(
                    extensions.oes_texture_float || !(colorType === "float" || colorType === "float32"),
                    "you must enable OES_texture_float in order to use floating point framebuffer objects"
                  );
                  check$1(
                    extensions.oes_texture_half_float || !(colorType === "half float" || colorType === "float16"),
                    "you must enable OES_texture_half_float in order to use 16-bit floating point framebuffer objects"
                  );
                }
                check$1.oneOf(colorType, colorTypes, "invalid color type");
              }
              if ("colorFormat" in options) {
                colorFormat = options.colorFormat;
                if (colorTextureFormats.indexOf(colorFormat) >= 0) {
                  colorTexture = true;
                } else if (colorRenderbufferFormats.indexOf(colorFormat) >= 0) {
                  colorTexture = false;
                } else {
                  if (colorTexture) {
                    check$1.oneOf(
                      options.colorFormat,
                      colorTextureFormats,
                      "invalid color format for texture"
                    );
                  } else {
                    check$1.oneOf(
                      options.colorFormat,
                      colorRenderbufferFormats,
                      "invalid color format for renderbuffer"
                    );
                  }
                }
              }
            }
            if ("depthTexture" in options || "depthStencilTexture" in options) {
              depthStencilTexture = !!(options.depthTexture || options.depthStencilTexture);
              check$1(
                !depthStencilTexture || extensions.webgl_depth_texture,
                "webgl_depth_texture extension not supported"
              );
            }
            if ("depth" in options) {
              if (typeof options.depth === "boolean") {
                needsDepth = options.depth;
              } else {
                depthBuffer = options.depth;
                needsStencil = false;
              }
            }
            if ("stencil" in options) {
              if (typeof options.stencil === "boolean") {
                needsStencil = options.stencil;
              } else {
                stencilBuffer = options.stencil;
                needsDepth = false;
              }
            }
            if ("depthStencil" in options) {
              if (typeof options.depthStencil === "boolean") {
                needsDepth = needsStencil = options.depthStencil;
              } else {
                depthStencilBuffer = options.depthStencil;
                needsDepth = false;
                needsStencil = false;
              }
            }
          }
          var colorAttachments = null;
          var depthAttachment = null;
          var stencilAttachment = null;
          var depthStencilAttachment = null;
          if (Array.isArray(colorBuffer)) {
            colorAttachments = colorBuffer.map(parseAttachment);
          } else if (colorBuffer) {
            colorAttachments = [parseAttachment(colorBuffer)];
          } else {
            colorAttachments = new Array(colorCount);
            for (i2 = 0; i2 < colorCount; ++i2) {
              colorAttachments[i2] = allocAttachment(
                width2,
                height,
                colorTexture,
                colorFormat,
                colorType
              );
            }
          }
          check$1(
            extensions.webgl_draw_buffers || colorAttachments.length <= 1,
            "you must enable the WEBGL_draw_buffers extension in order to use multiple color buffers."
          );
          check$1(
            colorAttachments.length <= limits.maxColorAttachments,
            "too many color attachments, not supported"
          );
          width2 = width2 || colorAttachments[0].width;
          height = height || colorAttachments[0].height;
          if (depthBuffer) {
            depthAttachment = parseAttachment(depthBuffer);
          } else if (needsDepth && !needsStencil) {
            depthAttachment = allocAttachment(
              width2,
              height,
              depthStencilTexture,
              "depth",
              "uint32"
            );
          }
          if (stencilBuffer) {
            stencilAttachment = parseAttachment(stencilBuffer);
          } else if (needsStencil && !needsDepth) {
            stencilAttachment = allocAttachment(
              width2,
              height,
              false,
              "stencil",
              "uint8"
            );
          }
          if (depthStencilBuffer) {
            depthStencilAttachment = parseAttachment(depthStencilBuffer);
          } else if (!depthBuffer && !stencilBuffer && needsStencil && needsDepth) {
            depthStencilAttachment = allocAttachment(
              width2,
              height,
              depthStencilTexture,
              "depth stencil",
              "depth stencil"
            );
          }
          check$1(
            !!depthBuffer + !!stencilBuffer + !!depthStencilBuffer <= 1,
            "invalid framebuffer configuration, can specify exactly one depth/stencil attachment"
          );
          var commonColorAttachmentSize = null;
          for (i2 = 0; i2 < colorAttachments.length; ++i2) {
            incRefAndCheckShape(colorAttachments[i2], width2, height);
            check$1(
              !colorAttachments[i2] || colorAttachments[i2].texture && colorTextureFormatEnums.indexOf(colorAttachments[i2].texture._texture.format) >= 0 || colorAttachments[i2].renderbuffer && colorRenderbufferFormatEnums.indexOf(colorAttachments[i2].renderbuffer._renderbuffer.format) >= 0,
              "framebuffer color attachment " + i2 + " is invalid"
            );
            if (colorAttachments[i2] && colorAttachments[i2].texture) {
              var colorAttachmentSize = textureFormatChannels[colorAttachments[i2].texture._texture.format] * textureTypeSizes[colorAttachments[i2].texture._texture.type];
              if (commonColorAttachmentSize === null) {
                commonColorAttachmentSize = colorAttachmentSize;
              } else {
                check$1(
                  commonColorAttachmentSize === colorAttachmentSize,
                  "all color attachments much have the same number of bits per pixel."
                );
              }
            }
          }
          incRefAndCheckShape(depthAttachment, width2, height);
          check$1(
            !depthAttachment || depthAttachment.texture && depthAttachment.texture._texture.format === GL_DEPTH_COMPONENT$1 || depthAttachment.renderbuffer && depthAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_COMPONENT16$1,
            "invalid depth attachment for framebuffer object"
          );
          incRefAndCheckShape(stencilAttachment, width2, height);
          check$1(
            !stencilAttachment || stencilAttachment.renderbuffer && stencilAttachment.renderbuffer._renderbuffer.format === GL_STENCIL_INDEX8$1,
            "invalid stencil attachment for framebuffer object"
          );
          incRefAndCheckShape(depthStencilAttachment, width2, height);
          check$1(
            !depthStencilAttachment || depthStencilAttachment.texture && depthStencilAttachment.texture._texture.format === GL_DEPTH_STENCIL$2 || depthStencilAttachment.renderbuffer && depthStencilAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_STENCIL$2,
            "invalid depth-stencil attachment for framebuffer object"
          );
          decFBORefs(framebuffer);
          framebuffer.width = width2;
          framebuffer.height = height;
          framebuffer.colorAttachments = colorAttachments;
          framebuffer.depthAttachment = depthAttachment;
          framebuffer.stencilAttachment = stencilAttachment;
          framebuffer.depthStencilAttachment = depthStencilAttachment;
          reglFramebuffer.color = colorAttachments.map(unwrapAttachment);
          reglFramebuffer.depth = unwrapAttachment(depthAttachment);
          reglFramebuffer.stencil = unwrapAttachment(stencilAttachment);
          reglFramebuffer.depthStencil = unwrapAttachment(depthStencilAttachment);
          reglFramebuffer.width = framebuffer.width;
          reglFramebuffer.height = framebuffer.height;
          updateFramebuffer(framebuffer);
          return reglFramebuffer;
        }
        function resize(w_, h_) {
          check$1(
            framebufferState.next !== framebuffer,
            "can not resize a framebuffer which is currently in use"
          );
          var w2 = Math.max(w_ | 0, 1);
          var h2 = Math.max(h_ | 0 || w2, 1);
          if (w2 === framebuffer.width && h2 === framebuffer.height) {
            return reglFramebuffer;
          }
          var colorAttachments = framebuffer.colorAttachments;
          for (var i2 = 0; i2 < colorAttachments.length; ++i2) {
            resizeAttachment(colorAttachments[i2], w2, h2);
          }
          resizeAttachment(framebuffer.depthAttachment, w2, h2);
          resizeAttachment(framebuffer.stencilAttachment, w2, h2);
          resizeAttachment(framebuffer.depthStencilAttachment, w2, h2);
          framebuffer.width = reglFramebuffer.width = w2;
          framebuffer.height = reglFramebuffer.height = h2;
          updateFramebuffer(framebuffer);
          return reglFramebuffer;
        }
        reglFramebuffer(a0, a1);
        return extend(reglFramebuffer, {
          resize,
          _reglType: "framebuffer",
          _framebuffer: framebuffer,
          destroy: function() {
            destroy(framebuffer);
            decFBORefs(framebuffer);
          },
          use: function(block) {
            framebufferState.setFBO({
              framebuffer: reglFramebuffer
            }, block);
          }
        });
      }
      function createCubeFBO(options) {
        var faces = Array(6);
        function reglFramebufferCube(a2) {
          var i2;
          check$1(
            faces.indexOf(framebufferState.next) < 0,
            "can not update framebuffer which is currently in use"
          );
          var params = {
            color: null
          };
          var radius = 0;
          var colorBuffer = null;
          var colorFormat = "rgba";
          var colorType = "uint8";
          var colorCount = 1;
          if (typeof a2 === "number") {
            radius = a2 | 0;
          } else if (!a2) {
            radius = 1;
          } else {
            check$1.type(a2, "object", "invalid arguments for framebuffer");
            var options2 = a2;
            if ("shape" in options2) {
              var shape = options2.shape;
              check$1(
                Array.isArray(shape) && shape.length >= 2,
                "invalid shape for framebuffer"
              );
              check$1(
                shape[0] === shape[1],
                "cube framebuffer must be square"
              );
              radius = shape[0];
            } else {
              if ("radius" in options2) {
                radius = options2.radius | 0;
              }
              if ("width" in options2) {
                radius = options2.width | 0;
                if ("height" in options2) {
                  check$1(options2.height === radius, "must be square");
                }
              } else if ("height" in options2) {
                radius = options2.height | 0;
              }
            }
            if ("color" in options2 || "colors" in options2) {
              colorBuffer = options2.color || options2.colors;
              if (Array.isArray(colorBuffer)) {
                check$1(
                  colorBuffer.length === 1 || extensions.webgl_draw_buffers,
                  "multiple render targets not supported"
                );
              }
            }
            if (!colorBuffer) {
              if ("colorCount" in options2) {
                colorCount = options2.colorCount | 0;
                check$1(colorCount > 0, "invalid color buffer count");
              }
              if ("colorType" in options2) {
                check$1.oneOf(
                  options2.colorType,
                  colorTypes,
                  "invalid color type"
                );
                colorType = options2.colorType;
              }
              if ("colorFormat" in options2) {
                colorFormat = options2.colorFormat;
                check$1.oneOf(
                  options2.colorFormat,
                  colorTextureFormats,
                  "invalid color format for texture"
                );
              }
            }
            if ("depth" in options2) {
              params.depth = options2.depth;
            }
            if ("stencil" in options2) {
              params.stencil = options2.stencil;
            }
            if ("depthStencil" in options2) {
              params.depthStencil = options2.depthStencil;
            }
          }
          var colorCubes;
          if (colorBuffer) {
            if (Array.isArray(colorBuffer)) {
              colorCubes = [];
              for (i2 = 0; i2 < colorBuffer.length; ++i2) {
                colorCubes[i2] = colorBuffer[i2];
              }
            } else {
              colorCubes = [colorBuffer];
            }
          } else {
            colorCubes = Array(colorCount);
            var cubeMapParams = {
              radius,
              format: colorFormat,
              type: colorType
            };
            for (i2 = 0; i2 < colorCount; ++i2) {
              colorCubes[i2] = textureState.createCube(cubeMapParams);
            }
          }
          params.color = Array(colorCubes.length);
          for (i2 = 0; i2 < colorCubes.length; ++i2) {
            var cube = colorCubes[i2];
            check$1(
              typeof cube === "function" && cube._reglType === "textureCube",
              "invalid cube map"
            );
            radius = radius || cube.width;
            check$1(
              cube.width === radius && cube.height === radius,
              "invalid cube map shape"
            );
            params.color[i2] = {
              target: GL_TEXTURE_CUBE_MAP_POSITIVE_X$2,
              data: colorCubes[i2]
            };
          }
          for (i2 = 0; i2 < 6; ++i2) {
            for (var j2 = 0; j2 < colorCubes.length; ++j2) {
              params.color[j2].target = GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + i2;
            }
            if (i2 > 0) {
              params.depth = faces[0].depth;
              params.stencil = faces[0].stencil;
              params.depthStencil = faces[0].depthStencil;
            }
            if (faces[i2]) {
              faces[i2](params);
            } else {
              faces[i2] = createFBO(params);
            }
          }
          return extend(reglFramebufferCube, {
            width: radius,
            height: radius,
            color: colorCubes
          });
        }
        function resize(radius_) {
          var i2;
          var radius = radius_ | 0;
          check$1(
            radius > 0 && radius <= limits.maxCubeMapSize,
            "invalid radius for cube fbo"
          );
          if (radius === reglFramebufferCube.width) {
            return reglFramebufferCube;
          }
          var colors = reglFramebufferCube.color;
          for (i2 = 0; i2 < colors.length; ++i2) {
            colors[i2].resize(radius);
          }
          for (i2 = 0; i2 < 6; ++i2) {
            faces[i2].resize(radius);
          }
          reglFramebufferCube.width = reglFramebufferCube.height = radius;
          return reglFramebufferCube;
        }
        reglFramebufferCube(options);
        return extend(reglFramebufferCube, {
          faces,
          resize,
          _reglType: "framebufferCube",
          destroy: function() {
            faces.forEach(function(f2) {
              f2.destroy();
            });
          }
        });
      }
      function restoreFramebuffers() {
        framebufferState.cur = null;
        framebufferState.next = null;
        framebufferState.dirty = true;
        values(framebufferSet).forEach(function(fb2) {
          fb2.framebuffer = gl2.createFramebuffer();
          updateFramebuffer(fb2);
        });
      }
      return extend(framebufferState, {
        getFramebuffer: function(object4) {
          if (typeof object4 === "function" && object4._reglType === "framebuffer") {
            var fbo = object4._framebuffer;
            if (fbo instanceof REGLFramebuffer) {
              return fbo;
            }
          }
          return null;
        },
        create: createFBO,
        createCube: createCubeFBO,
        clear: function() {
          values(framebufferSet).forEach(destroy);
        },
        restore: restoreFramebuffers
      });
    }
    var GL_FLOAT$6 = 5126;
    var GL_ARRAY_BUFFER$1 = 34962;
    function AttributeRecord() {
      this.state = 0;
      this.x = 0;
      this.y = 0;
      this.z = 0;
      this.w = 0;
      this.buffer = null;
      this.size = 0;
      this.normalized = false;
      this.type = GL_FLOAT$6;
      this.offset = 0;
      this.stride = 0;
      this.divisor = 0;
    }
    function wrapAttributeState(gl2, extensions, limits, stats2, bufferState) {
      var NUM_ATTRIBUTES = limits.maxAttributes;
      var attributeBindings = new Array(NUM_ATTRIBUTES);
      for (var i2 = 0; i2 < NUM_ATTRIBUTES; ++i2) {
        attributeBindings[i2] = new AttributeRecord();
      }
      var vaoCount = 0;
      var vaoSet = {};
      var state = {
        Record: AttributeRecord,
        scope: {},
        state: attributeBindings,
        currentVAO: null,
        targetVAO: null,
        restore: extVAO() ? restoreVAO : function() {
        },
        createVAO,
        getVAO,
        destroyBuffer,
        setVAO: extVAO() ? setVAOEXT : setVAOEmulated,
        clear: extVAO() ? destroyVAOEXT : function() {
        }
      };
      function destroyBuffer(buffer) {
        for (var i3 = 0; i3 < attributeBindings.length; ++i3) {
          var record = attributeBindings[i3];
          if (record.buffer === buffer) {
            gl2.disableVertexAttribArray(i3);
            record.buffer = null;
          }
        }
      }
      function extVAO() {
        return extensions.oes_vertex_array_object;
      }
      function extInstanced() {
        return extensions.angle_instanced_arrays;
      }
      function getVAO(vao) {
        if (typeof vao === "function" && vao._vao) {
          return vao._vao;
        }
        return null;
      }
      function setVAOEXT(vao) {
        if (vao === state.currentVAO) {
          return;
        }
        var ext = extVAO();
        if (vao) {
          ext.bindVertexArrayOES(vao.vao);
        } else {
          ext.bindVertexArrayOES(null);
        }
        state.currentVAO = vao;
      }
      function setVAOEmulated(vao) {
        if (vao === state.currentVAO) {
          return;
        }
        if (vao) {
          vao.bindAttrs();
        } else {
          var exti = extInstanced();
          for (var i3 = 0; i3 < attributeBindings.length; ++i3) {
            var binding = attributeBindings[i3];
            if (binding.buffer) {
              gl2.enableVertexAttribArray(i3);
              gl2.vertexAttribPointer(i3, binding.size, binding.type, binding.normalized, binding.stride, binding.offfset);
              if (exti && binding.divisor) {
                exti.vertexAttribDivisorANGLE(i3, binding.divisor);
              }
            } else {
              gl2.disableVertexAttribArray(i3);
              gl2.vertexAttrib4f(i3, binding.x, binding.y, binding.z, binding.w);
            }
          }
        }
        state.currentVAO = vao;
      }
      function destroyVAOEXT() {
        values(vaoSet).forEach(function(vao) {
          vao.destroy();
        });
      }
      function REGLVAO() {
        this.id = ++vaoCount;
        this.attributes = [];
        var extension = extVAO();
        if (extension) {
          this.vao = extension.createVertexArrayOES();
        } else {
          this.vao = null;
        }
        vaoSet[this.id] = this;
        this.buffers = [];
      }
      REGLVAO.prototype.bindAttrs = function() {
        var exti = extInstanced();
        var attributes = this.attributes;
        for (var i3 = 0; i3 < attributes.length; ++i3) {
          var attr = attributes[i3];
          if (attr.buffer) {
            gl2.enableVertexAttribArray(i3);
            gl2.bindBuffer(GL_ARRAY_BUFFER$1, attr.buffer.buffer);
            gl2.vertexAttribPointer(i3, attr.size, attr.type, attr.normalized, attr.stride, attr.offset);
            if (exti && attr.divisor) {
              exti.vertexAttribDivisorANGLE(i3, attr.divisor);
            }
          } else {
            gl2.disableVertexAttribArray(i3);
            gl2.vertexAttrib4f(i3, attr.x, attr.y, attr.z, attr.w);
          }
        }
        for (var j2 = attributes.length; j2 < NUM_ATTRIBUTES; ++j2) {
          gl2.disableVertexAttribArray(j2);
        }
      };
      REGLVAO.prototype.refresh = function() {
        var ext = extVAO();
        if (ext) {
          ext.bindVertexArrayOES(this.vao);
          this.bindAttrs();
          state.currentVAO = this;
        }
      };
      REGLVAO.prototype.destroy = function() {
        if (this.vao) {
          var extension = extVAO();
          if (this === state.currentVAO) {
            state.currentVAO = null;
            extension.bindVertexArrayOES(null);
          }
          extension.deleteVertexArrayOES(this.vao);
          this.vao = null;
        }
        if (vaoSet[this.id]) {
          delete vaoSet[this.id];
          stats2.vaoCount -= 1;
        }
      };
      function restoreVAO() {
        var ext = extVAO();
        if (ext) {
          values(vaoSet).forEach(function(vao) {
            vao.refresh();
          });
        }
      }
      function createVAO(_attr) {
        var vao = new REGLVAO();
        stats2.vaoCount += 1;
        function updateVAO(attributes) {
          check$1(Array.isArray(attributes), "arguments to vertex array constructor must be an array");
          check$1(attributes.length < NUM_ATTRIBUTES, "too many attributes");
          check$1(attributes.length > 0, "must specify at least one attribute");
          var bufUpdated = {};
          var nattributes = vao.attributes;
          nattributes.length = attributes.length;
          for (var i3 = 0; i3 < attributes.length; ++i3) {
            var spec = attributes[i3];
            var rec = nattributes[i3] = new AttributeRecord();
            var data = spec.data || spec;
            if (Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data)) {
              var buf;
              if (vao.buffers[i3]) {
                buf = vao.buffers[i3];
                if (isTypedArray(data) && buf._buffer.byteLength >= data.byteLength) {
                  buf.subdata(data);
                } else {
                  buf.destroy();
                  vao.buffers[i3] = null;
                }
              }
              if (!vao.buffers[i3]) {
                buf = vao.buffers[i3] = bufferState.create(spec, GL_ARRAY_BUFFER$1, false, true);
              }
              rec.buffer = bufferState.getBuffer(buf);
              rec.size = rec.buffer.dimension | 0;
              rec.normalized = false;
              rec.type = rec.buffer.dtype;
              rec.offset = 0;
              rec.stride = 0;
              rec.divisor = 0;
              rec.state = 1;
              bufUpdated[i3] = 1;
            } else if (bufferState.getBuffer(spec)) {
              rec.buffer = bufferState.getBuffer(spec);
              rec.size = rec.buffer.dimension | 0;
              rec.normalized = false;
              rec.type = rec.buffer.dtype;
              rec.offset = 0;
              rec.stride = 0;
              rec.divisor = 0;
              rec.state = 1;
            } else if (bufferState.getBuffer(spec.buffer)) {
              rec.buffer = bufferState.getBuffer(spec.buffer);
              rec.size = (+spec.size || rec.buffer.dimension) | 0;
              rec.normalized = !!spec.normalized || false;
              if ("type" in spec) {
                check$1.parameter(spec.type, glTypes, "invalid buffer type");
                rec.type = glTypes[spec.type];
              } else {
                rec.type = rec.buffer.dtype;
              }
              rec.offset = (spec.offset || 0) | 0;
              rec.stride = (spec.stride || 0) | 0;
              rec.divisor = (spec.divisor || 0) | 0;
              rec.state = 1;
              check$1(rec.size >= 1 && rec.size <= 4, "size must be between 1 and 4");
              check$1(rec.offset >= 0, "invalid offset");
              check$1(rec.stride >= 0 && rec.stride <= 255, "stride must be between 0 and 255");
              check$1(rec.divisor >= 0, "divisor must be positive");
              check$1(!rec.divisor || !!extensions.angle_instanced_arrays, "ANGLE_instanced_arrays must be enabled to use divisor");
            } else if ("x" in spec) {
              check$1(i3 > 0, "first attribute must not be a constant");
              rec.x = +spec.x || 0;
              rec.y = +spec.y || 0;
              rec.z = +spec.z || 0;
              rec.w = +spec.w || 0;
              rec.state = 2;
            } else {
              check$1(false, "invalid attribute spec for location " + i3);
            }
          }
          for (var j2 = 0; j2 < vao.buffers.length; ++j2) {
            if (!bufUpdated[j2] && vao.buffers[j2]) {
              vao.buffers[j2].destroy();
              vao.buffers[j2] = null;
            }
          }
          vao.refresh();
          return updateVAO;
        }
        updateVAO.destroy = function() {
          for (var j2 = 0; j2 < vao.buffers.length; ++j2) {
            if (vao.buffers[j2]) {
              vao.buffers[j2].destroy();
            }
          }
          vao.buffers.length = 0;
          vao.destroy();
        };
        updateVAO._vao = vao;
        updateVAO._reglType = "vao";
        return updateVAO(_attr);
      }
      return state;
    }
    var GL_FRAGMENT_SHADER = 35632;
    var GL_VERTEX_SHADER = 35633;
    var GL_ACTIVE_UNIFORMS = 35718;
    var GL_ACTIVE_ATTRIBUTES = 35721;
    function wrapShaderState(gl2, stringStore, stats2, config) {
      var fragShaders = {};
      var vertShaders = {};
      function ActiveInfo(name, id2, location, info) {
        this.name = name;
        this.id = id2;
        this.location = location;
        this.info = info;
      }
      function insertActiveInfo(list, info) {
        for (var i2 = 0; i2 < list.length; ++i2) {
          if (list[i2].id === info.id) {
            list[i2].location = info.location;
            return;
          }
        }
        list.push(info);
      }
      function getShader(type4, id2, command) {
        var cache = type4 === GL_FRAGMENT_SHADER ? fragShaders : vertShaders;
        var shader = cache[id2];
        if (!shader) {
          var source = stringStore.str(id2);
          shader = gl2.createShader(type4);
          gl2.shaderSource(shader, source);
          gl2.compileShader(shader);
          check$1.shaderError(gl2, shader, source, type4, command);
          cache[id2] = shader;
        }
        return shader;
      }
      var programCache = {};
      var programList = [];
      var PROGRAM_COUNTER = 0;
      function REGLProgram(fragId, vertId) {
        this.id = PROGRAM_COUNTER++;
        this.fragId = fragId;
        this.vertId = vertId;
        this.program = null;
        this.uniforms = [];
        this.attributes = [];
        this.refCount = 1;
        if (config.profile) {
          this.stats = {
            uniformsCount: 0,
            attributesCount: 0
          };
        }
      }
      function linkProgram(desc, command, attributeLocations) {
        var i2, info;
        var fragShader = getShader(GL_FRAGMENT_SHADER, desc.fragId);
        var vertShader = getShader(GL_VERTEX_SHADER, desc.vertId);
        var program = desc.program = gl2.createProgram();
        gl2.attachShader(program, fragShader);
        gl2.attachShader(program, vertShader);
        if (attributeLocations) {
          for (i2 = 0; i2 < attributeLocations.length; ++i2) {
            var binding = attributeLocations[i2];
            gl2.bindAttribLocation(program, binding[0], binding[1]);
          }
        }
        gl2.linkProgram(program);
        check$1.linkError(
          gl2,
          program,
          stringStore.str(desc.fragId),
          stringStore.str(desc.vertId),
          command
        );
        var numUniforms = gl2.getProgramParameter(program, GL_ACTIVE_UNIFORMS);
        if (config.profile) {
          desc.stats.uniformsCount = numUniforms;
        }
        var uniforms = desc.uniforms;
        for (i2 = 0; i2 < numUniforms; ++i2) {
          info = gl2.getActiveUniform(program, i2);
          if (info) {
            if (info.size > 1) {
              for (var j2 = 0; j2 < info.size; ++j2) {
                var name = info.name.replace("[0]", "[" + j2 + "]");
                insertActiveInfo(uniforms, new ActiveInfo(
                  name,
                  stringStore.id(name),
                  gl2.getUniformLocation(program, name),
                  info
                ));
              }
            } else {
              insertActiveInfo(uniforms, new ActiveInfo(
                info.name,
                stringStore.id(info.name),
                gl2.getUniformLocation(program, info.name),
                info
              ));
            }
          }
        }
        var numAttributes = gl2.getProgramParameter(program, GL_ACTIVE_ATTRIBUTES);
        if (config.profile) {
          desc.stats.attributesCount = numAttributes;
        }
        var attributes = desc.attributes;
        for (i2 = 0; i2 < numAttributes; ++i2) {
          info = gl2.getActiveAttrib(program, i2);
          if (info) {
            insertActiveInfo(attributes, new ActiveInfo(
              info.name,
              stringStore.id(info.name),
              gl2.getAttribLocation(program, info.name),
              info
            ));
          }
        }
      }
      if (config.profile) {
        stats2.getMaxUniformsCount = function() {
          var m2 = 0;
          programList.forEach(function(desc) {
            if (desc.stats.uniformsCount > m2) {
              m2 = desc.stats.uniformsCount;
            }
          });
          return m2;
        };
        stats2.getMaxAttributesCount = function() {
          var m2 = 0;
          programList.forEach(function(desc) {
            if (desc.stats.attributesCount > m2) {
              m2 = desc.stats.attributesCount;
            }
          });
          return m2;
        };
      }
      function restoreShaders() {
        fragShaders = {};
        vertShaders = {};
        for (var i2 = 0; i2 < programList.length; ++i2) {
          linkProgram(programList[i2], null, programList[i2].attributes.map(function(info) {
            return [info.location, info.name];
          }));
        }
      }
      return {
        clear: function() {
          var deleteShader = gl2.deleteShader.bind(gl2);
          values(fragShaders).forEach(deleteShader);
          fragShaders = {};
          values(vertShaders).forEach(deleteShader);
          vertShaders = {};
          programList.forEach(function(desc) {
            gl2.deleteProgram(desc.program);
          });
          programList.length = 0;
          programCache = {};
          stats2.shaderCount = 0;
        },
        program: function(vertId, fragId, command, attribLocations) {
          check$1.command(vertId >= 0, "missing vertex shader", command);
          check$1.command(fragId >= 0, "missing fragment shader", command);
          var cache = programCache[fragId];
          if (!cache) {
            cache = programCache[fragId] = {};
          }
          var prevProgram = cache[vertId];
          if (prevProgram) {
            prevProgram.refCount++;
            if (!attribLocations) {
              return prevProgram;
            }
          }
          var program = new REGLProgram(fragId, vertId);
          stats2.shaderCount++;
          linkProgram(program, command, attribLocations);
          if (!prevProgram) {
            cache[vertId] = program;
          }
          programList.push(program);
          return extend(program, {
            destroy: function() {
              program.refCount--;
              if (program.refCount <= 0) {
                gl2.deleteProgram(program.program);
                var idx = programList.indexOf(program);
                programList.splice(idx, 1);
                stats2.shaderCount--;
              }
              if (cache[program.vertId].refCount <= 0) {
                gl2.deleteShader(vertShaders[program.vertId]);
                delete vertShaders[program.vertId];
                delete programCache[program.fragId][program.vertId];
              }
              if (!Object.keys(programCache[program.fragId]).length) {
                gl2.deleteShader(fragShaders[program.fragId]);
                delete fragShaders[program.fragId];
                delete programCache[program.fragId];
              }
            }
          });
        },
        restore: restoreShaders,
        shader: getShader,
        frag: -1,
        vert: -1
      };
    }
    var GL_RGBA$3 = 6408;
    var GL_UNSIGNED_BYTE$7 = 5121;
    var GL_PACK_ALIGNMENT = 3333;
    var GL_FLOAT$7 = 5126;
    function wrapReadPixels(gl2, framebufferState, reglPoll, context, glAttributes, extensions, limits) {
      function readPixelsImpl(input) {
        var type4;
        if (framebufferState.next === null) {
          check$1(
            glAttributes.preserveDrawingBuffer,
            'you must create a webgl context with "preserveDrawingBuffer":true in order to read pixels from the drawing buffer'
          );
          type4 = GL_UNSIGNED_BYTE$7;
        } else {
          check$1(
            framebufferState.next.colorAttachments[0].texture !== null,
            "You cannot read from a renderbuffer"
          );
          type4 = framebufferState.next.colorAttachments[0].texture._texture.type;
          if (extensions.oes_texture_float) {
            check$1(
              type4 === GL_UNSIGNED_BYTE$7 || type4 === GL_FLOAT$7,
              "Reading from a framebuffer is only allowed for the types 'uint8' and 'float'"
            );
            if (type4 === GL_FLOAT$7) {
              check$1(limits.readFloat, "Reading 'float' values is not permitted in your browser. For a fallback, please see: https://www.npmjs.com/package/glsl-read-float");
            }
          } else {
            check$1(
              type4 === GL_UNSIGNED_BYTE$7,
              "Reading from a framebuffer is only allowed for the type 'uint8'"
            );
          }
        }
        var x2 = 0;
        var y2 = 0;
        var width2 = context.framebufferWidth;
        var height = context.framebufferHeight;
        var data = null;
        if (isTypedArray(input)) {
          data = input;
        } else if (input) {
          check$1.type(input, "object", "invalid arguments to regl.read()");
          x2 = input.x | 0;
          y2 = input.y | 0;
          check$1(
            x2 >= 0 && x2 < context.framebufferWidth,
            "invalid x offset for regl.read"
          );
          check$1(
            y2 >= 0 && y2 < context.framebufferHeight,
            "invalid y offset for regl.read"
          );
          width2 = (input.width || context.framebufferWidth - x2) | 0;
          height = (input.height || context.framebufferHeight - y2) | 0;
          data = input.data || null;
        }
        if (data) {
          if (type4 === GL_UNSIGNED_BYTE$7) {
            check$1(
              data instanceof Uint8Array,
              "buffer must be 'Uint8Array' when reading from a framebuffer of type 'uint8'"
            );
          } else if (type4 === GL_FLOAT$7) {
            check$1(
              data instanceof Float32Array,
              "buffer must be 'Float32Array' when reading from a framebuffer of type 'float'"
            );
          }
        }
        check$1(
          width2 > 0 && width2 + x2 <= context.framebufferWidth,
          "invalid width for read pixels"
        );
        check$1(
          height > 0 && height + y2 <= context.framebufferHeight,
          "invalid height for read pixels"
        );
        reglPoll();
        var size = width2 * height * 4;
        if (!data) {
          if (type4 === GL_UNSIGNED_BYTE$7) {
            data = new Uint8Array(size);
          } else if (type4 === GL_FLOAT$7) {
            data = data || new Float32Array(size);
          }
        }
        check$1.isTypedArray(data, "data buffer for regl.read() must be a typedarray");
        check$1(data.byteLength >= size, "data buffer for regl.read() too small");
        gl2.pixelStorei(GL_PACK_ALIGNMENT, 4);
        gl2.readPixels(
          x2,
          y2,
          width2,
          height,
          GL_RGBA$3,
          type4,
          data
        );
        return data;
      }
      function readPixelsFBO(options) {
        var result;
        framebufferState.setFBO({
          framebuffer: options.framebuffer
        }, function() {
          result = readPixelsImpl(options);
        });
        return result;
      }
      function readPixels(options) {
        if (!options || !("framebuffer" in options)) {
          return readPixelsImpl(options);
        } else {
          return readPixelsFBO(options);
        }
      }
      return readPixels;
    }
    function slice(x2) {
      return Array.prototype.slice.call(x2);
    }
    function join(x2) {
      return slice(x2).join("");
    }
    function createEnvironment() {
      var varCounter = 0;
      var linkedNames = [];
      var linkedValues = [];
      function link(value) {
        for (var i2 = 0; i2 < linkedValues.length; ++i2) {
          if (linkedValues[i2] === value) {
            return linkedNames[i2];
          }
        }
        var name = "g" + varCounter++;
        linkedNames.push(name);
        linkedValues.push(value);
        return name;
      }
      function block() {
        var code = [];
        function push2() {
          code.push.apply(code, slice(arguments));
        }
        var vars = [];
        function def() {
          var name = "v" + varCounter++;
          vars.push(name);
          if (arguments.length > 0) {
            code.push(name, "=");
            code.push.apply(code, slice(arguments));
            code.push(";");
          }
          return name;
        }
        return extend(push2, {
          def,
          toString: function() {
            return join([
              vars.length > 0 ? "var " + vars.join(",") + ";" : "",
              join(code)
            ]);
          }
        });
      }
      function scope() {
        var entry = block();
        var exit = block();
        var entryToString = entry.toString;
        var exitToString = exit.toString;
        function save(object4, prop) {
          exit(object4, prop, "=", entry.def(object4, prop), ";");
        }
        return extend(function() {
          entry.apply(entry, slice(arguments));
        }, {
          def: entry.def,
          entry,
          exit,
          save,
          set: function(object4, prop, value) {
            save(object4, prop);
            entry(object4, prop, "=", value, ";");
          },
          toString: function() {
            return entryToString() + exitToString();
          }
        });
      }
      function conditional() {
        var pred = join(arguments);
        var thenBlock = scope();
        var elseBlock = scope();
        var thenToString = thenBlock.toString;
        var elseToString = elseBlock.toString;
        return extend(thenBlock, {
          then: function() {
            thenBlock.apply(thenBlock, slice(arguments));
            return this;
          },
          else: function() {
            elseBlock.apply(elseBlock, slice(arguments));
            return this;
          },
          toString: function() {
            var elseClause = elseToString();
            if (elseClause) {
              elseClause = "else{" + elseClause + "}";
            }
            return join([
              "if(",
              pred,
              "){",
              thenToString(),
              "}",
              elseClause
            ]);
          }
        });
      }
      var globalBlock = block();
      var procedures = {};
      function proc(name, count) {
        var args = [];
        function arg() {
          var name2 = "a" + args.length;
          args.push(name2);
          return name2;
        }
        count = count || 0;
        for (var i2 = 0; i2 < count; ++i2) {
          arg();
        }
        var body = scope();
        var bodyToString = body.toString;
        var result = procedures[name] = extend(body, {
          arg,
          toString: function() {
            return join([
              "function(",
              args.join(),
              "){",
              bodyToString(),
              "}"
            ]);
          }
        });
        return result;
      }
      function compile() {
        var code = [
          '"use strict";',
          globalBlock,
          "return {"
        ];
        Object.keys(procedures).forEach(function(name) {
          code.push('"', name, '":', procedures[name].toString(), ",");
        });
        code.push("}");
        var src = join(code).replace(/;/g, ";\n").replace(/}/g, "}\n").replace(/{/g, "{\n");
        var proc2 = Function.apply(null, linkedNames.concat(src));
        return proc2.apply(null, linkedValues);
      }
      return {
        global: globalBlock,
        link,
        block,
        proc,
        scope,
        cond: conditional,
        compile
      };
    }
    var CUTE_COMPONENTS = "xyzw".split("");
    var GL_UNSIGNED_BYTE$8 = 5121;
    var ATTRIB_STATE_POINTER = 1;
    var ATTRIB_STATE_CONSTANT = 2;
    var DYN_FUNC$1 = 0;
    var DYN_PROP$1 = 1;
    var DYN_CONTEXT$1 = 2;
    var DYN_STATE$1 = 3;
    var DYN_THUNK = 4;
    var DYN_CONSTANT$1 = 5;
    var DYN_ARRAY$1 = 6;
    var S_DITHER = "dither";
    var S_BLEND_ENABLE = "blend.enable";
    var S_BLEND_COLOR = "blend.color";
    var S_BLEND_EQUATION = "blend.equation";
    var S_BLEND_FUNC = "blend.func";
    var S_DEPTH_ENABLE = "depth.enable";
    var S_DEPTH_FUNC = "depth.func";
    var S_DEPTH_RANGE = "depth.range";
    var S_DEPTH_MASK = "depth.mask";
    var S_COLOR_MASK = "colorMask";
    var S_CULL_ENABLE = "cull.enable";
    var S_CULL_FACE = "cull.face";
    var S_FRONT_FACE = "frontFace";
    var S_LINE_WIDTH = "lineWidth";
    var S_POLYGON_OFFSET_ENABLE = "polygonOffset.enable";
    var S_POLYGON_OFFSET_OFFSET = "polygonOffset.offset";
    var S_SAMPLE_ALPHA = "sample.alpha";
    var S_SAMPLE_ENABLE = "sample.enable";
    var S_SAMPLE_COVERAGE = "sample.coverage";
    var S_STENCIL_ENABLE = "stencil.enable";
    var S_STENCIL_MASK = "stencil.mask";
    var S_STENCIL_FUNC = "stencil.func";
    var S_STENCIL_OPFRONT = "stencil.opFront";
    var S_STENCIL_OPBACK = "stencil.opBack";
    var S_SCISSOR_ENABLE = "scissor.enable";
    var S_SCISSOR_BOX = "scissor.box";
    var S_VIEWPORT = "viewport";
    var S_PROFILE = "profile";
    var S_FRAMEBUFFER = "framebuffer";
    var S_VERT = "vert";
    var S_FRAG = "frag";
    var S_ELEMENTS = "elements";
    var S_PRIMITIVE = "primitive";
    var S_COUNT = "count";
    var S_OFFSET = "offset";
    var S_INSTANCES = "instances";
    var S_VAO = "vao";
    var SUFFIX_WIDTH = "Width";
    var SUFFIX_HEIGHT = "Height";
    var S_FRAMEBUFFER_WIDTH = S_FRAMEBUFFER + SUFFIX_WIDTH;
    var S_FRAMEBUFFER_HEIGHT = S_FRAMEBUFFER + SUFFIX_HEIGHT;
    var S_VIEWPORT_WIDTH = S_VIEWPORT + SUFFIX_WIDTH;
    var S_VIEWPORT_HEIGHT = S_VIEWPORT + SUFFIX_HEIGHT;
    var S_DRAWINGBUFFER = "drawingBuffer";
    var S_DRAWINGBUFFER_WIDTH = S_DRAWINGBUFFER + SUFFIX_WIDTH;
    var S_DRAWINGBUFFER_HEIGHT = S_DRAWINGBUFFER + SUFFIX_HEIGHT;
    var NESTED_OPTIONS = [
      S_BLEND_FUNC,
      S_BLEND_EQUATION,
      S_STENCIL_FUNC,
      S_STENCIL_OPFRONT,
      S_STENCIL_OPBACK,
      S_SAMPLE_COVERAGE,
      S_VIEWPORT,
      S_SCISSOR_BOX,
      S_POLYGON_OFFSET_OFFSET
    ];
    var GL_ARRAY_BUFFER$2 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$1 = 34963;
    var GL_FRAGMENT_SHADER$1 = 35632;
    var GL_VERTEX_SHADER$1 = 35633;
    var GL_TEXTURE_2D$3 = 3553;
    var GL_TEXTURE_CUBE_MAP$2 = 34067;
    var GL_CULL_FACE = 2884;
    var GL_BLEND = 3042;
    var GL_DITHER = 3024;
    var GL_STENCIL_TEST = 2960;
    var GL_DEPTH_TEST = 2929;
    var GL_SCISSOR_TEST = 3089;
    var GL_POLYGON_OFFSET_FILL = 32823;
    var GL_SAMPLE_ALPHA_TO_COVERAGE = 32926;
    var GL_SAMPLE_COVERAGE = 32928;
    var GL_FLOAT$8 = 5126;
    var GL_FLOAT_VEC2 = 35664;
    var GL_FLOAT_VEC3 = 35665;
    var GL_FLOAT_VEC4 = 35666;
    var GL_INT$3 = 5124;
    var GL_INT_VEC2 = 35667;
    var GL_INT_VEC3 = 35668;
    var GL_INT_VEC4 = 35669;
    var GL_BOOL = 35670;
    var GL_BOOL_VEC2 = 35671;
    var GL_BOOL_VEC3 = 35672;
    var GL_BOOL_VEC4 = 35673;
    var GL_FLOAT_MAT2 = 35674;
    var GL_FLOAT_MAT3 = 35675;
    var GL_FLOAT_MAT4 = 35676;
    var GL_SAMPLER_2D = 35678;
    var GL_SAMPLER_CUBE = 35680;
    var GL_TRIANGLES$1 = 4;
    var GL_FRONT = 1028;
    var GL_BACK = 1029;
    var GL_CW = 2304;
    var GL_CCW = 2305;
    var GL_MIN_EXT = 32775;
    var GL_MAX_EXT = 32776;
    var GL_ALWAYS = 519;
    var GL_KEEP = 7680;
    var GL_ZERO = 0;
    var GL_ONE = 1;
    var GL_FUNC_ADD = 32774;
    var GL_LESS = 513;
    var GL_FRAMEBUFFER$2 = 36160;
    var GL_COLOR_ATTACHMENT0$2 = 36064;
    var blendFuncs = {
      "0": 0,
      "1": 1,
      "zero": 0,
      "one": 1,
      "src color": 768,
      "one minus src color": 769,
      "src alpha": 770,
      "one minus src alpha": 771,
      "dst color": 774,
      "one minus dst color": 775,
      "dst alpha": 772,
      "one minus dst alpha": 773,
      "constant color": 32769,
      "one minus constant color": 32770,
      "constant alpha": 32771,
      "one minus constant alpha": 32772,
      "src alpha saturate": 776
    };
    var invalidBlendCombinations = [
      "constant color, constant alpha",
      "one minus constant color, constant alpha",
      "constant color, one minus constant alpha",
      "one minus constant color, one minus constant alpha",
      "constant alpha, constant color",
      "constant alpha, one minus constant color",
      "one minus constant alpha, constant color",
      "one minus constant alpha, one minus constant color"
    ];
    var compareFuncs = {
      "never": 512,
      "less": 513,
      "<": 513,
      "equal": 514,
      "=": 514,
      "==": 514,
      "===": 514,
      "lequal": 515,
      "<=": 515,
      "greater": 516,
      ">": 516,
      "notequal": 517,
      "!=": 517,
      "!==": 517,
      "gequal": 518,
      ">=": 518,
      "always": 519
    };
    var stencilOps = {
      "0": 0,
      "zero": 0,
      "keep": 7680,
      "replace": 7681,
      "increment": 7682,
      "decrement": 7683,
      "increment wrap": 34055,
      "decrement wrap": 34056,
      "invert": 5386
    };
    var shaderType = {
      "frag": GL_FRAGMENT_SHADER$1,
      "vert": GL_VERTEX_SHADER$1
    };
    var orientationType = {
      "cw": GL_CW,
      "ccw": GL_CCW
    };
    function isBufferArgs(x2) {
      return Array.isArray(x2) || isTypedArray(x2) || isNDArrayLike(x2);
    }
    function sortState(state) {
      return state.sort(function(a2, b2) {
        if (a2 === S_VIEWPORT) {
          return -1;
        } else if (b2 === S_VIEWPORT) {
          return 1;
        }
        return a2 < b2 ? -1 : 1;
      });
    }
    function Declaration(thisDep, contextDep, propDep, append) {
      this.thisDep = thisDep;
      this.contextDep = contextDep;
      this.propDep = propDep;
      this.append = append;
    }
    function isStatic(decl) {
      return decl && !(decl.thisDep || decl.contextDep || decl.propDep);
    }
    function createStaticDecl(append) {
      return new Declaration(false, false, false, append);
    }
    function createDynamicDecl(dyn, append) {
      var type4 = dyn.type;
      if (type4 === DYN_FUNC$1) {
        var numArgs = dyn.data.length;
        return new Declaration(
          true,
          numArgs >= 1,
          numArgs >= 2,
          append
        );
      } else if (type4 === DYN_THUNK) {
        var data = dyn.data;
        return new Declaration(
          data.thisDep,
          data.contextDep,
          data.propDep,
          append
        );
      } else if (type4 === DYN_CONSTANT$1) {
        return new Declaration(
          false,
          false,
          false,
          append
        );
      } else if (type4 === DYN_ARRAY$1) {
        var thisDep = false;
        var contextDep = false;
        var propDep = false;
        for (var i2 = 0; i2 < dyn.data.length; ++i2) {
          var subDyn = dyn.data[i2];
          if (subDyn.type === DYN_PROP$1) {
            propDep = true;
          } else if (subDyn.type === DYN_CONTEXT$1) {
            contextDep = true;
          } else if (subDyn.type === DYN_STATE$1) {
            thisDep = true;
          } else if (subDyn.type === DYN_FUNC$1) {
            thisDep = true;
            var subArgs = subDyn.data;
            if (subArgs >= 1) {
              contextDep = true;
            }
            if (subArgs >= 2) {
              propDep = true;
            }
          } else if (subDyn.type === DYN_THUNK) {
            thisDep = thisDep || subDyn.data.thisDep;
            contextDep = contextDep || subDyn.data.contextDep;
            propDep = propDep || subDyn.data.propDep;
          }
        }
        return new Declaration(
          thisDep,
          contextDep,
          propDep,
          append
        );
      } else {
        return new Declaration(
          type4 === DYN_STATE$1,
          type4 === DYN_CONTEXT$1,
          type4 === DYN_PROP$1,
          append
        );
      }
    }
    var SCOPE_DECL = new Declaration(false, false, false, function() {
    });
    function reglCore(gl2, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config) {
      var AttributeRecord2 = attributeState.Record;
      var blendEquations = {
        "add": 32774,
        "subtract": 32778,
        "reverse subtract": 32779
      };
      if (extensions.ext_blend_minmax) {
        blendEquations.min = GL_MIN_EXT;
        blendEquations.max = GL_MAX_EXT;
      }
      var extInstancing = extensions.angle_instanced_arrays;
      var extDrawBuffers = extensions.webgl_draw_buffers;
      var currentState = {
        dirty: true,
        profile: config.profile
      };
      var nextState = {};
      var GL_STATE_NAMES = [];
      var GL_FLAGS = {};
      var GL_VARIABLES = {};
      function propName(name) {
        return name.replace(".", "_");
      }
      function stateFlag(sname, cap, init4) {
        var name = propName(sname);
        GL_STATE_NAMES.push(sname);
        nextState[name] = currentState[name] = !!init4;
        GL_FLAGS[name] = cap;
      }
      function stateVariable(sname, func, init4) {
        var name = propName(sname);
        GL_STATE_NAMES.push(sname);
        if (Array.isArray(init4)) {
          currentState[name] = init4.slice();
          nextState[name] = init4.slice();
        } else {
          currentState[name] = nextState[name] = init4;
        }
        GL_VARIABLES[name] = func;
      }
      stateFlag(S_DITHER, GL_DITHER);
      stateFlag(S_BLEND_ENABLE, GL_BLEND);
      stateVariable(S_BLEND_COLOR, "blendColor", [0, 0, 0, 0]);
      stateVariable(
        S_BLEND_EQUATION,
        "blendEquationSeparate",
        [GL_FUNC_ADD, GL_FUNC_ADD]
      );
      stateVariable(
        S_BLEND_FUNC,
        "blendFuncSeparate",
        [GL_ONE, GL_ZERO, GL_ONE, GL_ZERO]
      );
      stateFlag(S_DEPTH_ENABLE, GL_DEPTH_TEST, true);
      stateVariable(S_DEPTH_FUNC, "depthFunc", GL_LESS);
      stateVariable(S_DEPTH_RANGE, "depthRange", [0, 1]);
      stateVariable(S_DEPTH_MASK, "depthMask", true);
      stateVariable(S_COLOR_MASK, S_COLOR_MASK, [true, true, true, true]);
      stateFlag(S_CULL_ENABLE, GL_CULL_FACE);
      stateVariable(S_CULL_FACE, "cullFace", GL_BACK);
      stateVariable(S_FRONT_FACE, S_FRONT_FACE, GL_CCW);
      stateVariable(S_LINE_WIDTH, S_LINE_WIDTH, 1);
      stateFlag(S_POLYGON_OFFSET_ENABLE, GL_POLYGON_OFFSET_FILL);
      stateVariable(S_POLYGON_OFFSET_OFFSET, "polygonOffset", [0, 0]);
      stateFlag(S_SAMPLE_ALPHA, GL_SAMPLE_ALPHA_TO_COVERAGE);
      stateFlag(S_SAMPLE_ENABLE, GL_SAMPLE_COVERAGE);
      stateVariable(S_SAMPLE_COVERAGE, "sampleCoverage", [1, false]);
      stateFlag(S_STENCIL_ENABLE, GL_STENCIL_TEST);
      stateVariable(S_STENCIL_MASK, "stencilMask", -1);
      stateVariable(S_STENCIL_FUNC, "stencilFunc", [GL_ALWAYS, 0, -1]);
      stateVariable(
        S_STENCIL_OPFRONT,
        "stencilOpSeparate",
        [GL_FRONT, GL_KEEP, GL_KEEP, GL_KEEP]
      );
      stateVariable(
        S_STENCIL_OPBACK,
        "stencilOpSeparate",
        [GL_BACK, GL_KEEP, GL_KEEP, GL_KEEP]
      );
      stateFlag(S_SCISSOR_ENABLE, GL_SCISSOR_TEST);
      stateVariable(
        S_SCISSOR_BOX,
        "scissor",
        [0, 0, gl2.drawingBufferWidth, gl2.drawingBufferHeight]
      );
      stateVariable(
        S_VIEWPORT,
        S_VIEWPORT,
        [0, 0, gl2.drawingBufferWidth, gl2.drawingBufferHeight]
      );
      var sharedState = {
        gl: gl2,
        context: contextState,
        strings: stringStore,
        next: nextState,
        current: currentState,
        draw: drawState,
        elements: elementState,
        buffer: bufferState,
        shader: shaderState,
        attributes: attributeState.state,
        vao: attributeState,
        uniforms: uniformState,
        framebuffer: framebufferState,
        extensions,
        timer,
        isBufferArgs
      };
      var sharedConstants = {
        primTypes,
        compareFuncs,
        blendFuncs,
        blendEquations,
        stencilOps,
        glTypes,
        orientationType
      };
      check$1.optional(function() {
        sharedState.isArrayLike = isArrayLike;
      });
      if (extDrawBuffers) {
        sharedConstants.backBuffer = [GL_BACK];
        sharedConstants.drawBuffer = loop(limits.maxDrawbuffers, function(i2) {
          if (i2 === 0) {
            return [0];
          }
          return loop(i2, function(j2) {
            return GL_COLOR_ATTACHMENT0$2 + j2;
          });
        });
      }
      var drawCallCounter = 0;
      function createREGLEnvironment() {
        var env = createEnvironment();
        var link = env.link;
        var global2 = env.global;
        env.id = drawCallCounter++;
        env.batchId = "0";
        var SHARED = link(sharedState);
        var shared = env.shared = {
          props: "a0"
        };
        Object.keys(sharedState).forEach(function(prop) {
          shared[prop] = global2.def(SHARED, ".", prop);
        });
        check$1.optional(function() {
          env.CHECK = link(check$1);
          env.commandStr = check$1.guessCommand();
          env.command = link(env.commandStr);
          env.assert = function(block, pred, message) {
            block(
              "if(!(",
              pred,
              "))",
              this.CHECK,
              ".commandRaise(",
              link(message),
              ",",
              this.command,
              ");"
            );
          };
          sharedConstants.invalidBlendCombinations = invalidBlendCombinations;
        });
        var nextVars = env.next = {};
        var currentVars = env.current = {};
        Object.keys(GL_VARIABLES).forEach(function(variable) {
          if (Array.isArray(currentState[variable])) {
            nextVars[variable] = global2.def(shared.next, ".", variable);
            currentVars[variable] = global2.def(shared.current, ".", variable);
          }
        });
        var constants2 = env.constants = {};
        Object.keys(sharedConstants).forEach(function(name) {
          constants2[name] = global2.def(JSON.stringify(sharedConstants[name]));
        });
        env.invoke = function(block, x2) {
          switch (x2.type) {
            case DYN_FUNC$1:
              var argList = [
                "this",
                shared.context,
                shared.props,
                env.batchId
              ];
              return block.def(
                link(x2.data),
                ".call(",
                argList.slice(0, Math.max(x2.data.length + 1, 4)),
                ")"
              );
            case DYN_PROP$1:
              return block.def(shared.props, x2.data);
            case DYN_CONTEXT$1:
              return block.def(shared.context, x2.data);
            case DYN_STATE$1:
              return block.def("this", x2.data);
            case DYN_THUNK:
              x2.data.append(env, block);
              return x2.data.ref;
            case DYN_CONSTANT$1:
              return x2.data.toString();
            case DYN_ARRAY$1:
              return x2.data.map(function(y2) {
                return env.invoke(block, y2);
              });
          }
        };
        env.attribCache = {};
        var scopeAttribs = {};
        env.scopeAttrib = function(name) {
          var id2 = stringStore.id(name);
          if (id2 in scopeAttribs) {
            return scopeAttribs[id2];
          }
          var binding = attributeState.scope[id2];
          if (!binding) {
            binding = attributeState.scope[id2] = new AttributeRecord2();
          }
          var result = scopeAttribs[id2] = link(binding);
          return result;
        };
        return env;
      }
      function parseProfile(options) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        var profileEnable;
        if (S_PROFILE in staticOptions) {
          var value = !!staticOptions[S_PROFILE];
          profileEnable = createStaticDecl(function(env, scope) {
            return value;
          });
          profileEnable.enable = value;
        } else if (S_PROFILE in dynamicOptions) {
          var dyn = dynamicOptions[S_PROFILE];
          profileEnable = createDynamicDecl(dyn, function(env, scope) {
            return env.invoke(scope, dyn);
          });
        }
        return profileEnable;
      }
      function parseFramebuffer(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        if (S_FRAMEBUFFER in staticOptions) {
          var framebuffer = staticOptions[S_FRAMEBUFFER];
          if (framebuffer) {
            framebuffer = framebufferState.getFramebuffer(framebuffer);
            check$1.command(framebuffer, "invalid framebuffer object");
            return createStaticDecl(function(env2, block) {
              var FRAMEBUFFER = env2.link(framebuffer);
              var shared = env2.shared;
              block.set(
                shared.framebuffer,
                ".next",
                FRAMEBUFFER
              );
              var CONTEXT = shared.context;
              block.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_WIDTH,
                FRAMEBUFFER + ".width"
              );
              block.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_HEIGHT,
                FRAMEBUFFER + ".height"
              );
              return FRAMEBUFFER;
            });
          } else {
            return createStaticDecl(function(env2, scope) {
              var shared = env2.shared;
              scope.set(
                shared.framebuffer,
                ".next",
                "null"
              );
              var CONTEXT = shared.context;
              scope.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_WIDTH,
                CONTEXT + "." + S_DRAWINGBUFFER_WIDTH
              );
              scope.set(
                CONTEXT,
                "." + S_FRAMEBUFFER_HEIGHT,
                CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT
              );
              return "null";
            });
          }
        } else if (S_FRAMEBUFFER in dynamicOptions) {
          var dyn = dynamicOptions[S_FRAMEBUFFER];
          return createDynamicDecl(dyn, function(env2, scope) {
            var FRAMEBUFFER_FUNC = env2.invoke(scope, dyn);
            var shared = env2.shared;
            var FRAMEBUFFER_STATE = shared.framebuffer;
            var FRAMEBUFFER = scope.def(
              FRAMEBUFFER_STATE,
              ".getFramebuffer(",
              FRAMEBUFFER_FUNC,
              ")"
            );
            check$1.optional(function() {
              env2.assert(
                scope,
                "!" + FRAMEBUFFER_FUNC + "||" + FRAMEBUFFER,
                "invalid framebuffer object"
              );
            });
            scope.set(
              FRAMEBUFFER_STATE,
              ".next",
              FRAMEBUFFER
            );
            var CONTEXT = shared.context;
            scope.set(
              CONTEXT,
              "." + S_FRAMEBUFFER_WIDTH,
              FRAMEBUFFER + "?" + FRAMEBUFFER + ".width:" + CONTEXT + "." + S_DRAWINGBUFFER_WIDTH
            );
            scope.set(
              CONTEXT,
              "." + S_FRAMEBUFFER_HEIGHT,
              FRAMEBUFFER + "?" + FRAMEBUFFER + ".height:" + CONTEXT + "." + S_DRAWINGBUFFER_HEIGHT
            );
            return FRAMEBUFFER;
          });
        } else {
          return null;
        }
      }
      function parseViewportScissor(options, framebuffer, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        function parseBox(param) {
          if (param in staticOptions) {
            var box = staticOptions[param];
            check$1.commandType(box, "object", "invalid " + param, env.commandStr);
            var isStatic2 = true;
            var x2 = box.x | 0;
            var y2 = box.y | 0;
            var w2, h2;
            if ("width" in box) {
              w2 = box.width | 0;
              check$1.command(w2 >= 0, "invalid " + param, env.commandStr);
            } else {
              isStatic2 = false;
            }
            if ("height" in box) {
              h2 = box.height | 0;
              check$1.command(h2 >= 0, "invalid " + param, env.commandStr);
            } else {
              isStatic2 = false;
            }
            return new Declaration(
              !isStatic2 && framebuffer && framebuffer.thisDep,
              !isStatic2 && framebuffer && framebuffer.contextDep,
              !isStatic2 && framebuffer && framebuffer.propDep,
              function(env2, scope) {
                var CONTEXT = env2.shared.context;
                var BOX_W = w2;
                if (!("width" in box)) {
                  BOX_W = scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH, "-", x2);
                }
                var BOX_H = h2;
                if (!("height" in box)) {
                  BOX_H = scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT, "-", y2);
                }
                return [x2, y2, BOX_W, BOX_H];
              }
            );
          } else if (param in dynamicOptions) {
            var dynBox = dynamicOptions[param];
            var result = createDynamicDecl(dynBox, function(env2, scope) {
              var BOX = env2.invoke(scope, dynBox);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  BOX + "&&typeof " + BOX + '==="object"',
                  "invalid " + param
                );
              });
              var CONTEXT = env2.shared.context;
              var BOX_X = scope.def(BOX, ".x|0");
              var BOX_Y = scope.def(BOX, ".y|0");
              var BOX_W = scope.def(
                '"width" in ',
                BOX,
                "?",
                BOX,
                ".width|0:",
                "(",
                CONTEXT,
                ".",
                S_FRAMEBUFFER_WIDTH,
                "-",
                BOX_X,
                ")"
              );
              var BOX_H = scope.def(
                '"height" in ',
                BOX,
                "?",
                BOX,
                ".height|0:",
                "(",
                CONTEXT,
                ".",
                S_FRAMEBUFFER_HEIGHT,
                "-",
                BOX_Y,
                ")"
              );
              check$1.optional(function() {
                env2.assert(
                  scope,
                  BOX_W + ">=0&&" + BOX_H + ">=0",
                  "invalid " + param
                );
              });
              return [BOX_X, BOX_Y, BOX_W, BOX_H];
            });
            if (framebuffer) {
              result.thisDep = result.thisDep || framebuffer.thisDep;
              result.contextDep = result.contextDep || framebuffer.contextDep;
              result.propDep = result.propDep || framebuffer.propDep;
            }
            return result;
          } else if (framebuffer) {
            return new Declaration(
              framebuffer.thisDep,
              framebuffer.contextDep,
              framebuffer.propDep,
              function(env2, scope) {
                var CONTEXT = env2.shared.context;
                return [
                  0,
                  0,
                  scope.def(CONTEXT, ".", S_FRAMEBUFFER_WIDTH),
                  scope.def(CONTEXT, ".", S_FRAMEBUFFER_HEIGHT)
                ];
              }
            );
          } else {
            return null;
          }
        }
        var viewport = parseBox(S_VIEWPORT);
        if (viewport) {
          var prevViewport = viewport;
          viewport = new Declaration(
            viewport.thisDep,
            viewport.contextDep,
            viewport.propDep,
            function(env2, scope) {
              var VIEWPORT = prevViewport.append(env2, scope);
              var CONTEXT = env2.shared.context;
              scope.set(
                CONTEXT,
                "." + S_VIEWPORT_WIDTH,
                VIEWPORT[2]
              );
              scope.set(
                CONTEXT,
                "." + S_VIEWPORT_HEIGHT,
                VIEWPORT[3]
              );
              return VIEWPORT;
            }
          );
        }
        return {
          viewport,
          scissor_box: parseBox(S_SCISSOR_BOX)
        };
      }
      function parseAttribLocations(options, attributes) {
        var staticOptions = options.static;
        var staticProgram = typeof staticOptions[S_FRAG] === "string" && typeof staticOptions[S_VERT] === "string";
        if (staticProgram) {
          if (Object.keys(attributes.dynamic).length > 0) {
            return null;
          }
          var staticAttributes = attributes.static;
          var sAttributes = Object.keys(staticAttributes);
          if (sAttributes.length > 0 && typeof staticAttributes[sAttributes[0]] === "number") {
            var bindings = [];
            for (var i2 = 0; i2 < sAttributes.length; ++i2) {
              check$1(typeof staticAttributes[sAttributes[i2]] === "number", "must specify all vertex attribute locations when using vaos");
              bindings.push([staticAttributes[sAttributes[i2]] | 0, sAttributes[i2]]);
            }
            return bindings;
          }
        }
        return null;
      }
      function parseProgram(options, env, attribLocations) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        function parseShader(name) {
          if (name in staticOptions) {
            var id2 = stringStore.id(staticOptions[name]);
            check$1.optional(function() {
              shaderState.shader(shaderType[name], id2, check$1.guessCommand());
            });
            var result = createStaticDecl(function() {
              return id2;
            });
            result.id = id2;
            return result;
          } else if (name in dynamicOptions) {
            var dyn = dynamicOptions[name];
            return createDynamicDecl(dyn, function(env2, scope) {
              var str = env2.invoke(scope, dyn);
              var id3 = scope.def(env2.shared.strings, ".id(", str, ")");
              check$1.optional(function() {
                scope(
                  env2.shared.shader,
                  ".shader(",
                  shaderType[name],
                  ",",
                  id3,
                  ",",
                  env2.command,
                  ");"
                );
              });
              return id3;
            });
          }
          return null;
        }
        var frag = parseShader(S_FRAG);
        var vert = parseShader(S_VERT);
        var program = null;
        var progVar;
        if (isStatic(frag) && isStatic(vert)) {
          program = shaderState.program(vert.id, frag.id, null, attribLocations);
          progVar = createStaticDecl(function(env2, scope) {
            return env2.link(program);
          });
        } else {
          progVar = new Declaration(
            frag && frag.thisDep || vert && vert.thisDep,
            frag && frag.contextDep || vert && vert.contextDep,
            frag && frag.propDep || vert && vert.propDep,
            function(env2, scope) {
              var SHADER_STATE = env2.shared.shader;
              var fragId;
              if (frag) {
                fragId = frag.append(env2, scope);
              } else {
                fragId = scope.def(SHADER_STATE, ".", S_FRAG);
              }
              var vertId;
              if (vert) {
                vertId = vert.append(env2, scope);
              } else {
                vertId = scope.def(SHADER_STATE, ".", S_VERT);
              }
              var progDef = SHADER_STATE + ".program(" + vertId + "," + fragId;
              check$1.optional(function() {
                progDef += "," + env2.command;
              });
              return scope.def(progDef + ")");
            }
          );
        }
        return {
          frag,
          vert,
          progVar,
          program
        };
      }
      function parseDraw(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        function parseElements() {
          if (S_ELEMENTS in staticOptions) {
            var elements2 = staticOptions[S_ELEMENTS];
            if (isBufferArgs(elements2)) {
              elements2 = elementState.getElements(elementState.create(elements2, true));
            } else if (elements2) {
              elements2 = elementState.getElements(elements2);
              check$1.command(elements2, "invalid elements", env.commandStr);
            }
            var result = createStaticDecl(function(env2, scope) {
              if (elements2) {
                var result2 = env2.link(elements2);
                env2.ELEMENTS = result2;
                return result2;
              }
              env2.ELEMENTS = null;
              return null;
            });
            result.value = elements2;
            return result;
          } else if (S_ELEMENTS in dynamicOptions) {
            var dyn = dynamicOptions[S_ELEMENTS];
            return createDynamicDecl(dyn, function(env2, scope) {
              var shared = env2.shared;
              var IS_BUFFER_ARGS = shared.isBufferArgs;
              var ELEMENT_STATE = shared.elements;
              var elementDefn = env2.invoke(scope, dyn);
              var elements3 = scope.def("null");
              var elementStream = scope.def(IS_BUFFER_ARGS, "(", elementDefn, ")");
              var ifte = env2.cond(elementStream).then(elements3, "=", ELEMENT_STATE, ".createStream(", elementDefn, ");").else(elements3, "=", ELEMENT_STATE, ".getElements(", elementDefn, ");");
              check$1.optional(function() {
                env2.assert(
                  ifte.else,
                  "!" + elementDefn + "||" + elements3,
                  "invalid elements"
                );
              });
              scope.entry(ifte);
              scope.exit(
                env2.cond(elementStream).then(ELEMENT_STATE, ".destroyStream(", elements3, ");")
              );
              env2.ELEMENTS = elements3;
              return elements3;
            });
          }
          return null;
        }
        var elements = parseElements();
        function parsePrimitive() {
          if (S_PRIMITIVE in staticOptions) {
            var primitive = staticOptions[S_PRIMITIVE];
            check$1.commandParameter(primitive, primTypes, "invalid primitve", env.commandStr);
            return createStaticDecl(function(env2, scope) {
              return primTypes[primitive];
            });
          } else if (S_PRIMITIVE in dynamicOptions) {
            var dynPrimitive = dynamicOptions[S_PRIMITIVE];
            return createDynamicDecl(dynPrimitive, function(env2, scope) {
              var PRIM_TYPES = env2.constants.primTypes;
              var prim3 = env2.invoke(scope, dynPrimitive);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  prim3 + " in " + PRIM_TYPES,
                  "invalid primitive, must be one of " + Object.keys(primTypes)
                );
              });
              return scope.def(PRIM_TYPES, "[", prim3, "]");
            });
          } else if (elements) {
            if (isStatic(elements)) {
              if (elements.value) {
                return createStaticDecl(function(env2, scope) {
                  return scope.def(env2.ELEMENTS, ".primType");
                });
              } else {
                return createStaticDecl(function() {
                  return GL_TRIANGLES$1;
                });
              }
            } else {
              return new Declaration(
                elements.thisDep,
                elements.contextDep,
                elements.propDep,
                function(env2, scope) {
                  var elements2 = env2.ELEMENTS;
                  return scope.def(elements2, "?", elements2, ".primType:", GL_TRIANGLES$1);
                }
              );
            }
          }
          return null;
        }
        function parseParam(param, isOffset) {
          if (param in staticOptions) {
            var value = staticOptions[param] | 0;
            check$1.command(!isOffset || value >= 0, "invalid " + param, env.commandStr);
            return createStaticDecl(function(env2, scope) {
              if (isOffset) {
                env2.OFFSET = value;
              }
              return value;
            });
          } else if (param in dynamicOptions) {
            var dynValue = dynamicOptions[param];
            return createDynamicDecl(dynValue, function(env2, scope) {
              var result = env2.invoke(scope, dynValue);
              if (isOffset) {
                env2.OFFSET = result;
                check$1.optional(function() {
                  env2.assert(
                    scope,
                    result + ">=0",
                    "invalid " + param
                  );
                });
              }
              return result;
            });
          } else if (isOffset && elements) {
            return createStaticDecl(function(env2, scope) {
              env2.OFFSET = "0";
              return 0;
            });
          }
          return null;
        }
        var OFFSET = parseParam(S_OFFSET, true);
        function parseVertCount() {
          if (S_COUNT in staticOptions) {
            var count = staticOptions[S_COUNT] | 0;
            check$1.command(
              typeof count === "number" && count >= 0,
              "invalid vertex count",
              env.commandStr
            );
            return createStaticDecl(function() {
              return count;
            });
          } else if (S_COUNT in dynamicOptions) {
            var dynCount = dynamicOptions[S_COUNT];
            return createDynamicDecl(dynCount, function(env2, scope) {
              var result2 = env2.invoke(scope, dynCount);
              check$1.optional(function() {
                env2.assert(
                  scope,
                  "typeof " + result2 + '==="number"&&' + result2 + ">=0&&" + result2 + "===(" + result2 + "|0)",
                  "invalid vertex count"
                );
              });
              return result2;
            });
          } else if (elements) {
            if (isStatic(elements)) {
              if (elements) {
                if (OFFSET) {
                  return new Declaration(
                    OFFSET.thisDep,
                    OFFSET.contextDep,
                    OFFSET.propDep,
                    function(env2, scope) {
                      var result2 = scope.def(
                        env2.ELEMENTS,
                        ".vertCount-",
                        env2.OFFSET
                      );
                      check$1.optional(function() {
                        env2.assert(
                          scope,
                          result2 + ">=0",
                          "invalid vertex offset/element buffer too small"
                        );
                      });
                      return result2;
                    }
                  );
                } else {
                  return createStaticDecl(function(env2, scope) {
                    return scope.def(env2.ELEMENTS, ".vertCount");
                  });
                }
              } else {
                var result = createStaticDecl(function() {
                  return -1;
                });
                check$1.optional(function() {
                  result.MISSING = true;
                });
                return result;
              }
            } else {
              var variable = new Declaration(
                elements.thisDep || OFFSET.thisDep,
                elements.contextDep || OFFSET.contextDep,
                elements.propDep || OFFSET.propDep,
                function(env2, scope) {
                  var elements2 = env2.ELEMENTS;
                  if (env2.OFFSET) {
                    return scope.def(
                      elements2,
                      "?",
                      elements2,
                      ".vertCount-",
                      env2.OFFSET,
                      ":-1"
                    );
                  }
                  return scope.def(elements2, "?", elements2, ".vertCount:-1");
                }
              );
              check$1.optional(function() {
                variable.DYNAMIC = true;
              });
              return variable;
            }
          }
          return null;
        }
        return {
          elements,
          primitive: parsePrimitive(),
          count: parseVertCount(),
          instances: parseParam(S_INSTANCES, false),
          offset: OFFSET
        };
      }
      function parseGLState(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        var STATE = {};
        GL_STATE_NAMES.forEach(function(prop) {
          var param = propName(prop);
          function parseParam(parseStatic, parseDynamic) {
            if (prop in staticOptions) {
              var value = parseStatic(staticOptions[prop]);
              STATE[param] = createStaticDecl(function() {
                return value;
              });
            } else if (prop in dynamicOptions) {
              var dyn = dynamicOptions[prop];
              STATE[param] = createDynamicDecl(dyn, function(env2, scope) {
                return parseDynamic(env2, scope, env2.invoke(scope, dyn));
              });
            }
          }
          switch (prop) {
            case S_CULL_ENABLE:
            case S_BLEND_ENABLE:
            case S_DITHER:
            case S_STENCIL_ENABLE:
            case S_DEPTH_ENABLE:
            case S_SCISSOR_ENABLE:
            case S_POLYGON_OFFSET_ENABLE:
            case S_SAMPLE_ALPHA:
            case S_SAMPLE_ENABLE:
            case S_DEPTH_MASK:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "boolean", prop, env.commandStr);
                  return value;
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value + '==="boolean"',
                      "invalid flag " + prop,
                      env2.commandStr
                    );
                  });
                  return value;
                }
              );
            case S_DEPTH_FUNC:
              return parseParam(
                function(value) {
                  check$1.commandParameter(value, compareFuncs, "invalid " + prop, env.commandStr);
                  return compareFuncs[value];
                },
                function(env2, scope, value) {
                  var COMPARE_FUNCS = env2.constants.compareFuncs;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + " in " + COMPARE_FUNCS,
                      "invalid " + prop + ", must be one of " + Object.keys(compareFuncs)
                    );
                  });
                  return scope.def(COMPARE_FUNCS, "[", value, "]");
                }
              );
            case S_DEPTH_RANGE:
              return parseParam(
                function(value) {
                  check$1.command(
                    isArrayLike(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number" && value[0] <= value[1],
                    "depth range is 2d array",
                    env.commandStr
                  );
                  return value;
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value + ")&&" + value + ".length===2&&typeof " + value + '[0]==="number"&&typeof ' + value + '[1]==="number"&&' + value + "[0]<=" + value + "[1]",
                      "depth range must be a 2d array"
                    );
                  });
                  var Z_NEAR = scope.def("+", value, "[0]");
                  var Z_FAR = scope.def("+", value, "[1]");
                  return [Z_NEAR, Z_FAR];
                }
              );
            case S_BLEND_FUNC:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "object", "blend.func", env.commandStr);
                  var srcRGB = "srcRGB" in value ? value.srcRGB : value.src;
                  var srcAlpha = "srcAlpha" in value ? value.srcAlpha : value.src;
                  var dstRGB = "dstRGB" in value ? value.dstRGB : value.dst;
                  var dstAlpha = "dstAlpha" in value ? value.dstAlpha : value.dst;
                  check$1.commandParameter(srcRGB, blendFuncs, param + ".srcRGB", env.commandStr);
                  check$1.commandParameter(srcAlpha, blendFuncs, param + ".srcAlpha", env.commandStr);
                  check$1.commandParameter(dstRGB, blendFuncs, param + ".dstRGB", env.commandStr);
                  check$1.commandParameter(dstAlpha, blendFuncs, param + ".dstAlpha", env.commandStr);
                  check$1.command(
                    invalidBlendCombinations.indexOf(srcRGB + ", " + dstRGB) === -1,
                    "unallowed blending combination (srcRGB, dstRGB) = (" + srcRGB + ", " + dstRGB + ")",
                    env.commandStr
                  );
                  return [
                    blendFuncs[srcRGB],
                    blendFuncs[dstRGB],
                    blendFuncs[srcAlpha],
                    blendFuncs[dstAlpha]
                  ];
                },
                function(env2, scope, value) {
                  var BLEND_FUNCS = env2.constants.blendFuncs;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + "&&typeof " + value + '==="object"',
                      "invalid blend func, must be an object"
                    );
                  });
                  function read3(prefix, suffix) {
                    var func = scope.def(
                      '"',
                      prefix,
                      suffix,
                      '" in ',
                      value,
                      "?",
                      value,
                      ".",
                      prefix,
                      suffix,
                      ":",
                      value,
                      ".",
                      prefix
                    );
                    check$1.optional(function() {
                      env2.assert(
                        scope,
                        func + " in " + BLEND_FUNCS,
                        "invalid " + prop + "." + prefix + suffix + ", must be one of " + Object.keys(blendFuncs)
                      );
                    });
                    return func;
                  }
                  var srcRGB = read3("src", "RGB");
                  var dstRGB = read3("dst", "RGB");
                  check$1.optional(function() {
                    var INVALID_BLEND_COMBINATIONS = env2.constants.invalidBlendCombinations;
                    env2.assert(
                      scope,
                      INVALID_BLEND_COMBINATIONS + ".indexOf(" + srcRGB + '+", "+' + dstRGB + ") === -1 ",
                      "unallowed blending combination for (srcRGB, dstRGB)"
                    );
                  });
                  var SRC_RGB = scope.def(BLEND_FUNCS, "[", srcRGB, "]");
                  var SRC_ALPHA = scope.def(BLEND_FUNCS, "[", read3("src", "Alpha"), "]");
                  var DST_RGB = scope.def(BLEND_FUNCS, "[", dstRGB, "]");
                  var DST_ALPHA = scope.def(BLEND_FUNCS, "[", read3("dst", "Alpha"), "]");
                  return [SRC_RGB, DST_RGB, SRC_ALPHA, DST_ALPHA];
                }
              );
            case S_BLEND_EQUATION:
              return parseParam(
                function(value) {
                  if (typeof value === "string") {
                    check$1.commandParameter(value, blendEquations, "invalid " + prop, env.commandStr);
                    return [
                      blendEquations[value],
                      blendEquations[value]
                    ];
                  } else if (typeof value === "object") {
                    check$1.commandParameter(
                      value.rgb,
                      blendEquations,
                      prop + ".rgb",
                      env.commandStr
                    );
                    check$1.commandParameter(
                      value.alpha,
                      blendEquations,
                      prop + ".alpha",
                      env.commandStr
                    );
                    return [
                      blendEquations[value.rgb],
                      blendEquations[value.alpha]
                    ];
                  } else {
                    check$1.commandRaise("invalid blend.equation", env.commandStr);
                  }
                },
                function(env2, scope, value) {
                  var BLEND_EQUATIONS = env2.constants.blendEquations;
                  var RGB = scope.def();
                  var ALPHA = scope.def();
                  var ifte = env2.cond("typeof ", value, '==="string"');
                  check$1.optional(function() {
                    function checkProp(block, name, value2) {
                      env2.assert(
                        block,
                        value2 + " in " + BLEND_EQUATIONS,
                        "invalid " + name + ", must be one of " + Object.keys(blendEquations)
                      );
                    }
                    checkProp(ifte.then, prop, value);
                    env2.assert(
                      ifte.else,
                      value + "&&typeof " + value + '==="object"',
                      "invalid " + prop
                    );
                    checkProp(ifte.else, prop + ".rgb", value + ".rgb");
                    checkProp(ifte.else, prop + ".alpha", value + ".alpha");
                  });
                  ifte.then(
                    RGB,
                    "=",
                    ALPHA,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value,
                    "];"
                  );
                  ifte.else(
                    RGB,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value,
                    ".rgb];",
                    ALPHA,
                    "=",
                    BLEND_EQUATIONS,
                    "[",
                    value,
                    ".alpha];"
                  );
                  scope(ifte);
                  return [RGB, ALPHA];
                }
              );
            case S_BLEND_COLOR:
              return parseParam(
                function(value) {
                  check$1.command(
                    isArrayLike(value) && value.length === 4,
                    "blend.color must be a 4d array",
                    env.commandStr
                  );
                  return loop(4, function(i2) {
                    return +value[i2];
                  });
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4",
                      "blend.color must be a 4d array"
                    );
                  });
                  return loop(4, function(i2) {
                    return scope.def("+", value, "[", i2, "]");
                  });
                }
              );
            case S_STENCIL_MASK:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "number", param, env.commandStr);
                  return value | 0;
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value + '==="number"',
                      "invalid stencil.mask"
                    );
                  });
                  return scope.def(value, "|0");
                }
              );
            case S_STENCIL_FUNC:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "object", param, env.commandStr);
                  var cmp = value.cmp || "keep";
                  var ref2 = value.ref || 0;
                  var mask = "mask" in value ? value.mask : -1;
                  check$1.commandParameter(cmp, compareFuncs, prop + ".cmp", env.commandStr);
                  check$1.commandType(ref2, "number", prop + ".ref", env.commandStr);
                  check$1.commandType(mask, "number", prop + ".mask", env.commandStr);
                  return [
                    compareFuncs[cmp],
                    ref2,
                    mask
                  ];
                },
                function(env2, scope, value) {
                  var COMPARE_FUNCS = env2.constants.compareFuncs;
                  check$1.optional(function() {
                    function assert() {
                      env2.assert(
                        scope,
                        Array.prototype.join.call(arguments, ""),
                        "invalid stencil.func"
                      );
                    }
                    assert(value + "&&typeof ", value, '==="object"');
                    assert(
                      '!("cmp" in ',
                      value,
                      ")||(",
                      value,
                      ".cmp in ",
                      COMPARE_FUNCS,
                      ")"
                    );
                  });
                  var cmp = scope.def(
                    '"cmp" in ',
                    value,
                    "?",
                    COMPARE_FUNCS,
                    "[",
                    value,
                    ".cmp]",
                    ":",
                    GL_KEEP
                  );
                  var ref2 = scope.def(value, ".ref|0");
                  var mask = scope.def(
                    '"mask" in ',
                    value,
                    "?",
                    value,
                    ".mask|0:-1"
                  );
                  return [cmp, ref2, mask];
                }
              );
            case S_STENCIL_OPFRONT:
            case S_STENCIL_OPBACK:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "object", param, env.commandStr);
                  var fail = value.fail || "keep";
                  var zfail = value.zfail || "keep";
                  var zpass = value.zpass || "keep";
                  check$1.commandParameter(fail, stencilOps, prop + ".fail", env.commandStr);
                  check$1.commandParameter(zfail, stencilOps, prop + ".zfail", env.commandStr);
                  check$1.commandParameter(zpass, stencilOps, prop + ".zpass", env.commandStr);
                  return [
                    prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                    stencilOps[fail],
                    stencilOps[zfail],
                    stencilOps[zpass]
                  ];
                },
                function(env2, scope, value) {
                  var STENCIL_OPS = env2.constants.stencilOps;
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + "&&typeof " + value + '==="object"',
                      "invalid " + prop
                    );
                  });
                  function read3(name) {
                    check$1.optional(function() {
                      env2.assert(
                        scope,
                        '!("' + name + '" in ' + value + ")||(" + value + "." + name + " in " + STENCIL_OPS + ")",
                        "invalid " + prop + "." + name + ", must be one of " + Object.keys(stencilOps)
                      );
                    });
                    return scope.def(
                      '"',
                      name,
                      '" in ',
                      value,
                      "?",
                      STENCIL_OPS,
                      "[",
                      value,
                      ".",
                      name,
                      "]:",
                      GL_KEEP
                    );
                  }
                  return [
                    prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                    read3("fail"),
                    read3("zfail"),
                    read3("zpass")
                  ];
                }
              );
            case S_POLYGON_OFFSET_OFFSET:
              return parseParam(
                function(value) {
                  check$1.commandType(value, "object", param, env.commandStr);
                  var factor = value.factor | 0;
                  var units = value.units | 0;
                  check$1.commandType(factor, "number", param + ".factor", env.commandStr);
                  check$1.commandType(units, "number", param + ".units", env.commandStr);
                  return [factor, units];
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + "&&typeof " + value + '==="object"',
                      "invalid " + prop
                    );
                  });
                  var FACTOR = scope.def(value, ".factor|0");
                  var UNITS = scope.def(value, ".units|0");
                  return [FACTOR, UNITS];
                }
              );
            case S_CULL_FACE:
              return parseParam(
                function(value) {
                  var face = 0;
                  if (value === "front") {
                    face = GL_FRONT;
                  } else if (value === "back") {
                    face = GL_BACK;
                  }
                  check$1.command(!!face, param, env.commandStr);
                  return face;
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + '==="front"||' + value + '==="back"',
                      "invalid cull.face"
                    );
                  });
                  return scope.def(value, '==="front"?', GL_FRONT, ":", GL_BACK);
                }
              );
            case S_LINE_WIDTH:
              return parseParam(
                function(value) {
                  check$1.command(
                    typeof value === "number" && value >= limits.lineWidthDims[0] && value <= limits.lineWidthDims[1],
                    "invalid line width, must be a positive number between " + limits.lineWidthDims[0] + " and " + limits.lineWidthDims[1],
                    env.commandStr
                  );
                  return value;
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      "typeof " + value + '==="number"&&' + value + ">=" + limits.lineWidthDims[0] + "&&" + value + "<=" + limits.lineWidthDims[1],
                      "invalid line width"
                    );
                  });
                  return value;
                }
              );
            case S_FRONT_FACE:
              return parseParam(
                function(value) {
                  check$1.commandParameter(value, orientationType, param, env.commandStr);
                  return orientationType[value];
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + '==="cw"||' + value + '==="ccw"',
                      "invalid frontFace, must be one of cw,ccw"
                    );
                  });
                  return scope.def(value + '==="cw"?' + GL_CW + ":" + GL_CCW);
                }
              );
            case S_COLOR_MASK:
              return parseParam(
                function(value) {
                  check$1.command(
                    isArrayLike(value) && value.length === 4,
                    "color.mask must be length 4 array",
                    env.commandStr
                  );
                  return value.map(function(v2) {
                    return !!v2;
                  });
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      env2.shared.isArrayLike + "(" + value + ")&&" + value + ".length===4",
                      "invalid color.mask"
                    );
                  });
                  return loop(4, function(i2) {
                    return "!!" + value + "[" + i2 + "]";
                  });
                }
              );
            case S_SAMPLE_COVERAGE:
              return parseParam(
                function(value) {
                  check$1.command(typeof value === "object" && value, param, env.commandStr);
                  var sampleValue = "value" in value ? value.value : 1;
                  var sampleInvert = !!value.invert;
                  check$1.command(
                    typeof sampleValue === "number" && sampleValue >= 0 && sampleValue <= 1,
                    "sample.coverage.value must be a number between 0 and 1",
                    env.commandStr
                  );
                  return [sampleValue, sampleInvert];
                },
                function(env2, scope, value) {
                  check$1.optional(function() {
                    env2.assert(
                      scope,
                      value + "&&typeof " + value + '==="object"',
                      "invalid sample.coverage"
                    );
                  });
                  var VALUE = scope.def(
                    '"value" in ',
                    value,
                    "?+",
                    value,
                    ".value:1"
                  );
                  var INVERT = scope.def("!!", value, ".invert");
                  return [VALUE, INVERT];
                }
              );
          }
        });
        return STATE;
      }
      function parseUniforms(uniforms, env) {
        var staticUniforms = uniforms.static;
        var dynamicUniforms = uniforms.dynamic;
        var UNIFORMS = {};
        Object.keys(staticUniforms).forEach(function(name) {
          var value = staticUniforms[name];
          var result;
          if (typeof value === "number" || typeof value === "boolean") {
            result = createStaticDecl(function() {
              return value;
            });
          } else if (typeof value === "function") {
            var reglType = value._reglType;
            if (reglType === "texture2d" || reglType === "textureCube") {
              result = createStaticDecl(function(env2) {
                return env2.link(value);
              });
            } else if (reglType === "framebuffer" || reglType === "framebufferCube") {
              check$1.command(
                value.color.length > 0,
                'missing color attachment for framebuffer sent to uniform "' + name + '"',
                env.commandStr
              );
              result = createStaticDecl(function(env2) {
                return env2.link(value.color[0]);
              });
            } else {
              check$1.commandRaise('invalid data for uniform "' + name + '"', env.commandStr);
            }
          } else if (isArrayLike(value)) {
            result = createStaticDecl(function(env2) {
              var ITEM = env2.global.def(
                "[",
                loop(value.length, function(i2) {
                  check$1.command(
                    typeof value[i2] === "number" || typeof value[i2] === "boolean",
                    "invalid uniform " + name,
                    env2.commandStr
                  );
                  return value[i2];
                }),
                "]"
              );
              return ITEM;
            });
          } else {
            check$1.commandRaise('invalid or missing data for uniform "' + name + '"', env.commandStr);
          }
          result.value = value;
          UNIFORMS[name] = result;
        });
        Object.keys(dynamicUniforms).forEach(function(key) {
          var dyn = dynamicUniforms[key];
          UNIFORMS[key] = createDynamicDecl(dyn, function(env2, scope) {
            return env2.invoke(scope, dyn);
          });
        });
        return UNIFORMS;
      }
      function parseAttributes(attributes, env) {
        var staticAttributes = attributes.static;
        var dynamicAttributes = attributes.dynamic;
        var attributeDefs = {};
        Object.keys(staticAttributes).forEach(function(attribute) {
          var value = staticAttributes[attribute];
          var id2 = stringStore.id(attribute);
          var record = new AttributeRecord2();
          if (isBufferArgs(value)) {
            record.state = ATTRIB_STATE_POINTER;
            record.buffer = bufferState.getBuffer(
              bufferState.create(value, GL_ARRAY_BUFFER$2, false, true)
            );
            record.type = 0;
          } else {
            var buffer = bufferState.getBuffer(value);
            if (buffer) {
              record.state = ATTRIB_STATE_POINTER;
              record.buffer = buffer;
              record.type = 0;
            } else {
              check$1.command(
                typeof value === "object" && value,
                "invalid data for attribute " + attribute,
                env.commandStr
              );
              if ("constant" in value) {
                var constant = value.constant;
                record.buffer = "null";
                record.state = ATTRIB_STATE_CONSTANT;
                if (typeof constant === "number") {
                  record.x = constant;
                } else {
                  check$1.command(
                    isArrayLike(constant) && constant.length > 0 && constant.length <= 4,
                    "invalid constant for attribute " + attribute,
                    env.commandStr
                  );
                  CUTE_COMPONENTS.forEach(function(c3, i2) {
                    if (i2 < constant.length) {
                      record[c3] = constant[i2];
                    }
                  });
                }
              } else {
                if (isBufferArgs(value.buffer)) {
                  buffer = bufferState.getBuffer(
                    bufferState.create(value.buffer, GL_ARRAY_BUFFER$2, false, true)
                  );
                } else {
                  buffer = bufferState.getBuffer(value.buffer);
                }
                check$1.command(!!buffer, 'missing buffer for attribute "' + attribute + '"', env.commandStr);
                var offset = value.offset | 0;
                check$1.command(
                  offset >= 0,
                  'invalid offset for attribute "' + attribute + '"',
                  env.commandStr
                );
                var stride = value.stride | 0;
                check$1.command(
                  stride >= 0 && stride < 256,
                  'invalid stride for attribute "' + attribute + '", must be integer betweeen [0, 255]',
                  env.commandStr
                );
                var size = value.size | 0;
                check$1.command(
                  !("size" in value) || size > 0 && size <= 4,
                  'invalid size for attribute "' + attribute + '", must be 1,2,3,4',
                  env.commandStr
                );
                var normalized = !!value.normalized;
                var type4 = 0;
                if ("type" in value) {
                  check$1.commandParameter(
                    value.type,
                    glTypes,
                    "invalid type for attribute " + attribute,
                    env.commandStr
                  );
                  type4 = glTypes[value.type];
                }
                var divisor = value.divisor | 0;
                if ("divisor" in value) {
                  check$1.command(
                    divisor === 0 || extInstancing,
                    'cannot specify divisor for attribute "' + attribute + '", instancing not supported',
                    env.commandStr
                  );
                  check$1.command(
                    divisor >= 0,
                    'invalid divisor for attribute "' + attribute + '"',
                    env.commandStr
                  );
                }
                check$1.optional(function() {
                  var command = env.commandStr;
                  var VALID_KEYS = [
                    "buffer",
                    "offset",
                    "divisor",
                    "normalized",
                    "type",
                    "size",
                    "stride"
                  ];
                  Object.keys(value).forEach(function(prop) {
                    check$1.command(
                      VALID_KEYS.indexOf(prop) >= 0,
                      'unknown parameter "' + prop + '" for attribute pointer "' + attribute + '" (valid parameters are ' + VALID_KEYS + ")",
                      command
                    );
                  });
                });
                record.buffer = buffer;
                record.state = ATTRIB_STATE_POINTER;
                record.size = size;
                record.normalized = normalized;
                record.type = type4 || buffer.dtype;
                record.offset = offset;
                record.stride = stride;
                record.divisor = divisor;
              }
            }
          }
          attributeDefs[attribute] = createStaticDecl(function(env2, scope) {
            var cache = env2.attribCache;
            if (id2 in cache) {
              return cache[id2];
            }
            var result = {
              isStream: false
            };
            Object.keys(record).forEach(function(key) {
              result[key] = record[key];
            });
            if (record.buffer) {
              result.buffer = env2.link(record.buffer);
              result.type = result.type || result.buffer + ".dtype";
            }
            cache[id2] = result;
            return result;
          });
        });
        Object.keys(dynamicAttributes).forEach(function(attribute) {
          var dyn = dynamicAttributes[attribute];
          function appendAttributeCode(env2, block) {
            var VALUE = env2.invoke(block, dyn);
            var shared = env2.shared;
            var constants2 = env2.constants;
            var IS_BUFFER_ARGS = shared.isBufferArgs;
            var BUFFER_STATE = shared.buffer;
            check$1.optional(function() {
              env2.assert(
                block,
                VALUE + "&&(typeof " + VALUE + '==="object"||typeof ' + VALUE + '==="function")&&(' + IS_BUFFER_ARGS + "(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ")||" + BUFFER_STATE + ".getBuffer(" + VALUE + ".buffer)||" + IS_BUFFER_ARGS + "(" + VALUE + '.buffer)||("constant" in ' + VALUE + "&&(typeof " + VALUE + '.constant==="number"||' + shared.isArrayLike + "(" + VALUE + ".constant))))",
                'invalid dynamic attribute "' + attribute + '"'
              );
            });
            var result = {
              isStream: block.def(false)
            };
            var defaultRecord = new AttributeRecord2();
            defaultRecord.state = ATTRIB_STATE_POINTER;
            Object.keys(defaultRecord).forEach(function(key) {
              result[key] = block.def("" + defaultRecord[key]);
            });
            var BUFFER = result.buffer;
            var TYPE = result.type;
            block(
              "if(",
              IS_BUFFER_ARGS,
              "(",
              VALUE,
              ")){",
              result.isStream,
              "=true;",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".createStream(",
              GL_ARRAY_BUFFER$2,
              ",",
              VALUE,
              ");",
              TYPE,
              "=",
              BUFFER,
              ".dtype;",
              "}else{",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".getBuffer(",
              VALUE,
              ");",
              "if(",
              BUFFER,
              "){",
              TYPE,
              "=",
              BUFFER,
              ".dtype;",
              '}else if("constant" in ',
              VALUE,
              "){",
              result.state,
              "=",
              ATTRIB_STATE_CONSTANT,
              ";",
              "if(typeof " + VALUE + '.constant === "number"){',
              result[CUTE_COMPONENTS[0]],
              "=",
              VALUE,
              ".constant;",
              CUTE_COMPONENTS.slice(1).map(function(n2) {
                return result[n2];
              }).join("="),
              "=0;",
              "}else{",
              CUTE_COMPONENTS.map(function(name, i2) {
                return result[name] + "=" + VALUE + ".constant.length>" + i2 + "?" + VALUE + ".constant[" + i2 + "]:0;";
              }).join(""),
              "}}else{",
              "if(",
              IS_BUFFER_ARGS,
              "(",
              VALUE,
              ".buffer)){",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".createStream(",
              GL_ARRAY_BUFFER$2,
              ",",
              VALUE,
              ".buffer);",
              "}else{",
              BUFFER,
              "=",
              BUFFER_STATE,
              ".getBuffer(",
              VALUE,
              ".buffer);",
              "}",
              TYPE,
              '="type" in ',
              VALUE,
              "?",
              constants2.glTypes,
              "[",
              VALUE,
              ".type]:",
              BUFFER,
              ".dtype;",
              result.normalized,
              "=!!",
              VALUE,
              ".normalized;"
            );
            function emitReadRecord(name) {
              block(result[name], "=", VALUE, ".", name, "|0;");
            }
            emitReadRecord("size");
            emitReadRecord("offset");
            emitReadRecord("stride");
            emitReadRecord("divisor");
            block("}}");
            block.exit(
              "if(",
              result.isStream,
              "){",
              BUFFER_STATE,
              ".destroyStream(",
              BUFFER,
              ");",
              "}"
            );
            return result;
          }
          attributeDefs[attribute] = createDynamicDecl(dyn, appendAttributeCode);
        });
        return attributeDefs;
      }
      function parseVAO(options, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        if (S_VAO in staticOptions) {
          var vao = staticOptions[S_VAO];
          if (vao !== null && attributeState.getVAO(vao) === null) {
            vao = attributeState.createVAO(vao);
          }
          return createStaticDecl(function(env2) {
            return env2.link(attributeState.getVAO(vao));
          });
        } else if (S_VAO in dynamicOptions) {
          var dyn = dynamicOptions[S_VAO];
          return createDynamicDecl(dyn, function(env2, scope) {
            var vaoRef = env2.invoke(scope, dyn);
            return scope.def(env2.shared.vao + ".getVAO(" + vaoRef + ")");
          });
        }
        return null;
      }
      function parseContext(context) {
        var staticContext = context.static;
        var dynamicContext = context.dynamic;
        var result = {};
        Object.keys(staticContext).forEach(function(name) {
          var value = staticContext[name];
          result[name] = createStaticDecl(function(env, scope) {
            if (typeof value === "number" || typeof value === "boolean") {
              return "" + value;
            } else {
              return env.link(value);
            }
          });
        });
        Object.keys(dynamicContext).forEach(function(name) {
          var dyn = dynamicContext[name];
          result[name] = createDynamicDecl(dyn, function(env, scope) {
            return env.invoke(scope, dyn);
          });
        });
        return result;
      }
      function parseArguments(options, attributes, uniforms, context, env) {
        var staticOptions = options.static;
        var dynamicOptions = options.dynamic;
        check$1.optional(function() {
          var KEY_NAMES = [
            S_FRAMEBUFFER,
            S_VERT,
            S_FRAG,
            S_ELEMENTS,
            S_PRIMITIVE,
            S_OFFSET,
            S_COUNT,
            S_INSTANCES,
            S_PROFILE,
            S_VAO
          ].concat(GL_STATE_NAMES);
          function checkKeys(dict) {
            Object.keys(dict).forEach(function(key) {
              check$1.command(
                KEY_NAMES.indexOf(key) >= 0,
                'unknown parameter "' + key + '"',
                env.commandStr
              );
            });
          }
          checkKeys(staticOptions);
          checkKeys(dynamicOptions);
        });
        var attribLocations = parseAttribLocations(options, attributes);
        var framebuffer = parseFramebuffer(options);
        var viewportAndScissor = parseViewportScissor(options, framebuffer, env);
        var draw = parseDraw(options, env);
        var state = parseGLState(options, env);
        var shader = parseProgram(options, env, attribLocations);
        function copyBox(name) {
          var defn = viewportAndScissor[name];
          if (defn) {
            state[name] = defn;
          }
        }
        copyBox(S_VIEWPORT);
        copyBox(propName(S_SCISSOR_BOX));
        var dirty = Object.keys(state).length > 0;
        var result = {
          framebuffer,
          draw,
          shader,
          state,
          dirty,
          scopeVAO: null,
          drawVAO: null,
          useVAO: false,
          attributes: {}
        };
        result.profile = parseProfile(options);
        result.uniforms = parseUniforms(uniforms, env);
        result.drawVAO = result.scopeVAO = parseVAO(options);
        if (!result.drawVAO && shader.program && !attribLocations && extensions.angle_instanced_arrays) {
          var useVAO = true;
          var staticBindings = shader.program.attributes.map(function(attr) {
            var binding = attributes.static[attr];
            useVAO = useVAO && !!binding;
            return binding;
          });
          if (useVAO && staticBindings.length > 0) {
            var vao = attributeState.getVAO(attributeState.createVAO(staticBindings));
            result.drawVAO = new Declaration(null, null, null, function(env2, scope) {
              return env2.link(vao);
            });
            result.useVAO = true;
          }
        }
        if (attribLocations) {
          result.useVAO = true;
        } else {
          result.attributes = parseAttributes(attributes, env);
        }
        result.context = parseContext(context);
        return result;
      }
      function emitContext(env, scope, context) {
        var shared = env.shared;
        var CONTEXT = shared.context;
        var contextEnter = env.scope();
        Object.keys(context).forEach(function(name) {
          scope.save(CONTEXT, "." + name);
          var defn = context[name];
          var value = defn.append(env, scope);
          if (Array.isArray(value)) {
            contextEnter(CONTEXT, ".", name, "=[", value.join(), "];");
          } else {
            contextEnter(CONTEXT, ".", name, "=", value, ";");
          }
        });
        scope(contextEnter);
      }
      function emitPollFramebuffer(env, scope, framebuffer, skipCheck) {
        var shared = env.shared;
        var GL = shared.gl;
        var FRAMEBUFFER_STATE = shared.framebuffer;
        var EXT_DRAW_BUFFERS;
        if (extDrawBuffers) {
          EXT_DRAW_BUFFERS = scope.def(shared.extensions, ".webgl_draw_buffers");
        }
        var constants2 = env.constants;
        var DRAW_BUFFERS = constants2.drawBuffer;
        var BACK_BUFFER = constants2.backBuffer;
        var NEXT;
        if (framebuffer) {
          NEXT = framebuffer.append(env, scope);
        } else {
          NEXT = scope.def(FRAMEBUFFER_STATE, ".next");
        }
        if (!skipCheck) {
          scope("if(", NEXT, "!==", FRAMEBUFFER_STATE, ".cur){");
        }
        scope(
          "if(",
          NEXT,
          "){",
          GL,
          ".bindFramebuffer(",
          GL_FRAMEBUFFER$2,
          ",",
          NEXT,
          ".framebuffer);"
        );
        if (extDrawBuffers) {
          scope(
            EXT_DRAW_BUFFERS,
            ".drawBuffersWEBGL(",
            DRAW_BUFFERS,
            "[",
            NEXT,
            ".colorAttachments.length]);"
          );
        }
        scope(
          "}else{",
          GL,
          ".bindFramebuffer(",
          GL_FRAMEBUFFER$2,
          ",null);"
        );
        if (extDrawBuffers) {
          scope(EXT_DRAW_BUFFERS, ".drawBuffersWEBGL(", BACK_BUFFER, ");");
        }
        scope(
          "}",
          FRAMEBUFFER_STATE,
          ".cur=",
          NEXT,
          ";"
        );
        if (!skipCheck) {
          scope("}");
        }
      }
      function emitPollState(env, scope, args) {
        var shared = env.shared;
        var GL = shared.gl;
        var CURRENT_VARS = env.current;
        var NEXT_VARS = env.next;
        var CURRENT_STATE = shared.current;
        var NEXT_STATE = shared.next;
        var block = env.cond(CURRENT_STATE, ".dirty");
        GL_STATE_NAMES.forEach(function(prop) {
          var param = propName(prop);
          if (param in args.state) {
            return;
          }
          var NEXT, CURRENT;
          if (param in NEXT_VARS) {
            NEXT = NEXT_VARS[param];
            CURRENT = CURRENT_VARS[param];
            var parts = loop(currentState[param].length, function(i2) {
              return block.def(NEXT, "[", i2, "]");
            });
            block(env.cond(parts.map(function(p2, i2) {
              return p2 + "!==" + CURRENT + "[" + i2 + "]";
            }).join("||")).then(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              parts,
              ");",
              parts.map(function(p2, i2) {
                return CURRENT + "[" + i2 + "]=" + p2;
              }).join(";"),
              ";"
            ));
          } else {
            NEXT = block.def(NEXT_STATE, ".", param);
            var ifte = env.cond(NEXT, "!==", CURRENT_STATE, ".", param);
            block(ifte);
            if (param in GL_FLAGS) {
              ifte(
                env.cond(NEXT).then(GL, ".enable(", GL_FLAGS[param], ");").else(GL, ".disable(", GL_FLAGS[param], ");"),
                CURRENT_STATE,
                ".",
                param,
                "=",
                NEXT,
                ";"
              );
            } else {
              ifte(
                GL,
                ".",
                GL_VARIABLES[param],
                "(",
                NEXT,
                ");",
                CURRENT_STATE,
                ".",
                param,
                "=",
                NEXT,
                ";"
              );
            }
          }
        });
        if (Object.keys(args.state).length === 0) {
          block(CURRENT_STATE, ".dirty=false;");
        }
        scope(block);
      }
      function emitSetOptions(env, scope, options, filter) {
        var shared = env.shared;
        var CURRENT_VARS = env.current;
        var CURRENT_STATE = shared.current;
        var GL = shared.gl;
        sortState(Object.keys(options)).forEach(function(param) {
          var defn = options[param];
          if (filter && !filter(defn)) {
            return;
          }
          var variable = defn.append(env, scope);
          if (GL_FLAGS[param]) {
            var flag = GL_FLAGS[param];
            if (isStatic(defn)) {
              if (variable) {
                scope(GL, ".enable(", flag, ");");
              } else {
                scope(GL, ".disable(", flag, ");");
              }
            } else {
              scope(env.cond(variable).then(GL, ".enable(", flag, ");").else(GL, ".disable(", flag, ");"));
            }
            scope(CURRENT_STATE, ".", param, "=", variable, ";");
          } else if (isArrayLike(variable)) {
            var CURRENT = CURRENT_VARS[param];
            scope(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              variable,
              ");",
              variable.map(function(v2, i2) {
                return CURRENT + "[" + i2 + "]=" + v2;
              }).join(";"),
              ";"
            );
          } else {
            scope(
              GL,
              ".",
              GL_VARIABLES[param],
              "(",
              variable,
              ");",
              CURRENT_STATE,
              ".",
              param,
              "=",
              variable,
              ";"
            );
          }
        });
      }
      function injectExtensions(env, scope) {
        if (extInstancing) {
          env.instancing = scope.def(
            env.shared.extensions,
            ".angle_instanced_arrays"
          );
        }
      }
      function emitProfile(env, scope, args, useScope, incrementCounter) {
        var shared = env.shared;
        var STATS = env.stats;
        var CURRENT_STATE = shared.current;
        var TIMER = shared.timer;
        var profileArg = args.profile;
        function perfCounter() {
          if (typeof performance === "undefined") {
            return "Date.now()";
          } else {
            return "performance.now()";
          }
        }
        var CPU_START, QUERY_COUNTER;
        function emitProfileStart(block) {
          CPU_START = scope.def();
          block(CPU_START, "=", perfCounter(), ";");
          if (typeof incrementCounter === "string") {
            block(STATS, ".count+=", incrementCounter, ";");
          } else {
            block(STATS, ".count++;");
          }
          if (timer) {
            if (useScope) {
              QUERY_COUNTER = scope.def();
              block(QUERY_COUNTER, "=", TIMER, ".getNumPendingQueries();");
            } else {
              block(TIMER, ".beginQuery(", STATS, ");");
            }
          }
        }
        function emitProfileEnd(block) {
          block(STATS, ".cpuTime+=", perfCounter(), "-", CPU_START, ";");
          if (timer) {
            if (useScope) {
              block(
                TIMER,
                ".pushScopeStats(",
                QUERY_COUNTER,
                ",",
                TIMER,
                ".getNumPendingQueries(),",
                STATS,
                ");"
              );
            } else {
              block(TIMER, ".endQuery();");
            }
          }
        }
        function scopeProfile(value) {
          var prev = scope.def(CURRENT_STATE, ".profile");
          scope(CURRENT_STATE, ".profile=", value, ";");
          scope.exit(CURRENT_STATE, ".profile=", prev, ";");
        }
        var USE_PROFILE;
        if (profileArg) {
          if (isStatic(profileArg)) {
            if (profileArg.enable) {
              emitProfileStart(scope);
              emitProfileEnd(scope.exit);
              scopeProfile("true");
            } else {
              scopeProfile("false");
            }
            return;
          }
          USE_PROFILE = profileArg.append(env, scope);
          scopeProfile(USE_PROFILE);
        } else {
          USE_PROFILE = scope.def(CURRENT_STATE, ".profile");
        }
        var start = env.block();
        emitProfileStart(start);
        scope("if(", USE_PROFILE, "){", start, "}");
        var end = env.block();
        emitProfileEnd(end);
        scope.exit("if(", USE_PROFILE, "){", end, "}");
      }
      function emitAttributes(env, scope, args, attributes, filter) {
        var shared = env.shared;
        function typeLength(x2) {
          switch (x2) {
            case GL_FLOAT_VEC2:
            case GL_INT_VEC2:
            case GL_BOOL_VEC2:
              return 2;
            case GL_FLOAT_VEC3:
            case GL_INT_VEC3:
            case GL_BOOL_VEC3:
              return 3;
            case GL_FLOAT_VEC4:
            case GL_INT_VEC4:
            case GL_BOOL_VEC4:
              return 4;
            default:
              return 1;
          }
        }
        function emitBindAttribute(ATTRIBUTE, size, record) {
          var GL = shared.gl;
          var LOCATION = scope.def(ATTRIBUTE, ".location");
          var BINDING = scope.def(shared.attributes, "[", LOCATION, "]");
          var STATE = record.state;
          var BUFFER = record.buffer;
          var CONST_COMPONENTS = [
            record.x,
            record.y,
            record.z,
            record.w
          ];
          var COMMON_KEYS = [
            "buffer",
            "normalized",
            "offset",
            "stride"
          ];
          function emitBuffer() {
            scope(
              "if(!",
              BINDING,
              ".buffer){",
              GL,
              ".enableVertexAttribArray(",
              LOCATION,
              ");}"
            );
            var TYPE = record.type;
            var SIZE;
            if (!record.size) {
              SIZE = size;
            } else {
              SIZE = scope.def(record.size, "||", size);
            }
            scope(
              "if(",
              BINDING,
              ".type!==",
              TYPE,
              "||",
              BINDING,
              ".size!==",
              SIZE,
              "||",
              COMMON_KEYS.map(function(key) {
                return BINDING + "." + key + "!==" + record[key];
              }).join("||"),
              "){",
              GL,
              ".bindBuffer(",
              GL_ARRAY_BUFFER$2,
              ",",
              BUFFER,
              ".buffer);",
              GL,
              ".vertexAttribPointer(",
              [
                LOCATION,
                SIZE,
                TYPE,
                record.normalized,
                record.stride,
                record.offset
              ],
              ");",
              BINDING,
              ".type=",
              TYPE,
              ";",
              BINDING,
              ".size=",
              SIZE,
              ";",
              COMMON_KEYS.map(function(key) {
                return BINDING + "." + key + "=" + record[key] + ";";
              }).join(""),
              "}"
            );
            if (extInstancing) {
              var DIVISOR = record.divisor;
              scope(
                "if(",
                BINDING,
                ".divisor!==",
                DIVISOR,
                "){",
                env.instancing,
                ".vertexAttribDivisorANGLE(",
                [LOCATION, DIVISOR],
                ");",
                BINDING,
                ".divisor=",
                DIVISOR,
                ";}"
              );
            }
          }
          function emitConstant() {
            scope(
              "if(",
              BINDING,
              ".buffer){",
              GL,
              ".disableVertexAttribArray(",
              LOCATION,
              ");",
              BINDING,
              ".buffer=null;",
              "}if(",
              CUTE_COMPONENTS.map(function(c3, i2) {
                return BINDING + "." + c3 + "!==" + CONST_COMPONENTS[i2];
              }).join("||"),
              "){",
              GL,
              ".vertexAttrib4f(",
              LOCATION,
              ",",
              CONST_COMPONENTS,
              ");",
              CUTE_COMPONENTS.map(function(c3, i2) {
                return BINDING + "." + c3 + "=" + CONST_COMPONENTS[i2] + ";";
              }).join(""),
              "}"
            );
          }
          if (STATE === ATTRIB_STATE_POINTER) {
            emitBuffer();
          } else if (STATE === ATTRIB_STATE_CONSTANT) {
            emitConstant();
          } else {
            scope("if(", STATE, "===", ATTRIB_STATE_POINTER, "){");
            emitBuffer();
            scope("}else{");
            emitConstant();
            scope("}");
          }
        }
        attributes.forEach(function(attribute) {
          var name = attribute.name;
          var arg = args.attributes[name];
          var record;
          if (arg) {
            if (!filter(arg)) {
              return;
            }
            record = arg.append(env, scope);
          } else {
            if (!filter(SCOPE_DECL)) {
              return;
            }
            var scopeAttrib = env.scopeAttrib(name);
            check$1.optional(function() {
              env.assert(
                scope,
                scopeAttrib + ".state",
                "missing attribute " + name
              );
            });
            record = {};
            Object.keys(new AttributeRecord2()).forEach(function(key) {
              record[key] = scope.def(scopeAttrib, ".", key);
            });
          }
          emitBindAttribute(
            env.link(attribute),
            typeLength(attribute.info.type),
            record
          );
        });
      }
      function emitUniforms(env, scope, args, uniforms, filter) {
        var shared = env.shared;
        var GL = shared.gl;
        var infix;
        for (var i2 = 0; i2 < uniforms.length; ++i2) {
          var uniform = uniforms[i2];
          var name = uniform.name;
          var type4 = uniform.info.type;
          var arg = args.uniforms[name];
          var UNIFORM = env.link(uniform);
          var LOCATION = UNIFORM + ".location";
          var VALUE;
          if (arg) {
            if (!filter(arg)) {
              continue;
            }
            if (isStatic(arg)) {
              var value = arg.value;
              check$1.command(
                value !== null && typeof value !== "undefined",
                'missing uniform "' + name + '"',
                env.commandStr
              );
              if (type4 === GL_SAMPLER_2D || type4 === GL_SAMPLER_CUBE) {
                check$1.command(
                  typeof value === "function" && (type4 === GL_SAMPLER_2D && (value._reglType === "texture2d" || value._reglType === "framebuffer") || type4 === GL_SAMPLER_CUBE && (value._reglType === "textureCube" || value._reglType === "framebufferCube")),
                  "invalid texture for uniform " + name,
                  env.commandStr
                );
                var TEX_VALUE = env.link(value._texture || value.color[0]._texture);
                scope(GL, ".uniform1i(", LOCATION, ",", TEX_VALUE + ".bind());");
                scope.exit(TEX_VALUE, ".unbind();");
              } else if (type4 === GL_FLOAT_MAT2 || type4 === GL_FLOAT_MAT3 || type4 === GL_FLOAT_MAT4) {
                check$1.optional(function() {
                  check$1.command(
                    isArrayLike(value),
                    "invalid matrix for uniform " + name,
                    env.commandStr
                  );
                  check$1.command(
                    type4 === GL_FLOAT_MAT2 && value.length === 4 || type4 === GL_FLOAT_MAT3 && value.length === 9 || type4 === GL_FLOAT_MAT4 && value.length === 16,
                    "invalid length for matrix uniform " + name,
                    env.commandStr
                  );
                });
                var MAT_VALUE = env.global.def("new Float32Array([" + Array.prototype.slice.call(value) + "])");
                var dim = 2;
                if (type4 === GL_FLOAT_MAT3) {
                  dim = 3;
                } else if (type4 === GL_FLOAT_MAT4) {
                  dim = 4;
                }
                scope(
                  GL,
                  ".uniformMatrix",
                  dim,
                  "fv(",
                  LOCATION,
                  ",false,",
                  MAT_VALUE,
                  ");"
                );
              } else {
                switch (type4) {
                  case GL_FLOAT$8:
                    check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                    infix = "1f";
                    break;
                  case GL_FLOAT_VEC2:
                    check$1.command(
                      isArrayLike(value) && value.length === 2,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "2f";
                    break;
                  case GL_FLOAT_VEC3:
                    check$1.command(
                      isArrayLike(value) && value.length === 3,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "3f";
                    break;
                  case GL_FLOAT_VEC4:
                    check$1.command(
                      isArrayLike(value) && value.length === 4,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "4f";
                    break;
                  case GL_BOOL:
                    check$1.commandType(value, "boolean", "uniform " + name, env.commandStr);
                    infix = "1i";
                    break;
                  case GL_INT$3:
                    check$1.commandType(value, "number", "uniform " + name, env.commandStr);
                    infix = "1i";
                    break;
                  case GL_BOOL_VEC2:
                    check$1.command(
                      isArrayLike(value) && value.length === 2,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "2i";
                    break;
                  case GL_INT_VEC2:
                    check$1.command(
                      isArrayLike(value) && value.length === 2,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "2i";
                    break;
                  case GL_BOOL_VEC3:
                    check$1.command(
                      isArrayLike(value) && value.length === 3,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "3i";
                    break;
                  case GL_INT_VEC3:
                    check$1.command(
                      isArrayLike(value) && value.length === 3,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "3i";
                    break;
                  case GL_BOOL_VEC4:
                    check$1.command(
                      isArrayLike(value) && value.length === 4,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "4i";
                    break;
                  case GL_INT_VEC4:
                    check$1.command(
                      isArrayLike(value) && value.length === 4,
                      "uniform " + name,
                      env.commandStr
                    );
                    infix = "4i";
                    break;
                }
                scope(
                  GL,
                  ".uniform",
                  infix,
                  "(",
                  LOCATION,
                  ",",
                  isArrayLike(value) ? Array.prototype.slice.call(value) : value,
                  ");"
                );
              }
              continue;
            } else {
              VALUE = arg.append(env, scope);
            }
          } else {
            if (!filter(SCOPE_DECL)) {
              continue;
            }
            VALUE = scope.def(shared.uniforms, "[", stringStore.id(name), "]");
          }
          if (type4 === GL_SAMPLER_2D) {
            check$1(!Array.isArray(VALUE), "must specify a scalar prop for textures");
            scope(
              "if(",
              VALUE,
              "&&",
              VALUE,
              '._reglType==="framebuffer"){',
              VALUE,
              "=",
              VALUE,
              ".color[0];",
              "}"
            );
          } else if (type4 === GL_SAMPLER_CUBE) {
            check$1(!Array.isArray(VALUE), "must specify a scalar prop for cube maps");
            scope(
              "if(",
              VALUE,
              "&&",
              VALUE,
              '._reglType==="framebufferCube"){',
              VALUE,
              "=",
              VALUE,
              ".color[0];",
              "}"
            );
          }
          check$1.optional(function() {
            function emitCheck(pred, message) {
              env.assert(
                scope,
                pred,
                'bad data or missing for uniform "' + name + '".  ' + message
              );
            }
            function checkType(type5) {
              check$1(!Array.isArray(VALUE), "must not specify an array type for uniform");
              emitCheck(
                "typeof " + VALUE + '==="' + type5 + '"',
                "invalid type, expected " + type5
              );
            }
            function checkVector(n2, type5) {
              if (Array.isArray(VALUE)) {
                check$1(VALUE.length === n2, "must have length " + n2);
              } else {
                emitCheck(
                  shared.isArrayLike + "(" + VALUE + ")&&" + VALUE + ".length===" + n2,
                  "invalid vector, should have length " + n2,
                  env.commandStr
                );
              }
            }
            function checkTexture(target) {
              check$1(!Array.isArray(VALUE), "must not specify a value type");
              emitCheck(
                "typeof " + VALUE + '==="function"&&' + VALUE + '._reglType==="texture' + (target === GL_TEXTURE_2D$3 ? "2d" : "Cube") + '"',
                "invalid texture type",
                env.commandStr
              );
            }
            switch (type4) {
              case GL_INT$3:
                checkType("number");
                break;
              case GL_INT_VEC2:
                checkVector(2);
                break;
              case GL_INT_VEC3:
                checkVector(3);
                break;
              case GL_INT_VEC4:
                checkVector(4);
                break;
              case GL_FLOAT$8:
                checkType("number");
                break;
              case GL_FLOAT_VEC2:
                checkVector(2);
                break;
              case GL_FLOAT_VEC3:
                checkVector(3);
                break;
              case GL_FLOAT_VEC4:
                checkVector(4);
                break;
              case GL_BOOL:
                checkType("boolean");
                break;
              case GL_BOOL_VEC2:
                checkVector(2);
                break;
              case GL_BOOL_VEC3:
                checkVector(3);
                break;
              case GL_BOOL_VEC4:
                checkVector(4);
                break;
              case GL_FLOAT_MAT2:
                checkVector(4);
                break;
              case GL_FLOAT_MAT3:
                checkVector(9);
                break;
              case GL_FLOAT_MAT4:
                checkVector(16);
                break;
              case GL_SAMPLER_2D:
                checkTexture(GL_TEXTURE_2D$3);
                break;
              case GL_SAMPLER_CUBE:
                checkTexture(GL_TEXTURE_CUBE_MAP$2);
                break;
            }
          });
          var unroll = 1;
          switch (type4) {
            case GL_SAMPLER_2D:
            case GL_SAMPLER_CUBE:
              var TEX = scope.def(VALUE, "._texture");
              scope(GL, ".uniform1i(", LOCATION, ",", TEX, ".bind());");
              scope.exit(TEX, ".unbind();");
              continue;
            case GL_INT$3:
            case GL_BOOL:
              infix = "1i";
              break;
            case GL_INT_VEC2:
            case GL_BOOL_VEC2:
              infix = "2i";
              unroll = 2;
              break;
            case GL_INT_VEC3:
            case GL_BOOL_VEC3:
              infix = "3i";
              unroll = 3;
              break;
            case GL_INT_VEC4:
            case GL_BOOL_VEC4:
              infix = "4i";
              unroll = 4;
              break;
            case GL_FLOAT$8:
              infix = "1f";
              break;
            case GL_FLOAT_VEC2:
              infix = "2f";
              unroll = 2;
              break;
            case GL_FLOAT_VEC3:
              infix = "3f";
              unroll = 3;
              break;
            case GL_FLOAT_VEC4:
              infix = "4f";
              unroll = 4;
              break;
            case GL_FLOAT_MAT2:
              infix = "Matrix2fv";
              break;
            case GL_FLOAT_MAT3:
              infix = "Matrix3fv";
              break;
            case GL_FLOAT_MAT4:
              infix = "Matrix4fv";
              break;
          }
          scope(GL, ".uniform", infix, "(", LOCATION, ",");
          if (infix.charAt(0) === "M") {
            var matSize = Math.pow(type4 - GL_FLOAT_MAT2 + 2, 2);
            var STORAGE = env.global.def("new Float32Array(", matSize, ")");
            if (Array.isArray(VALUE)) {
              scope(
                "false,(",
                loop(matSize, function(i3) {
                  return STORAGE + "[" + i3 + "]=" + VALUE[i3];
                }),
                ",",
                STORAGE,
                ")"
              );
            } else {
              scope(
                "false,(Array.isArray(",
                VALUE,
                ")||",
                VALUE,
                " instanceof Float32Array)?",
                VALUE,
                ":(",
                loop(matSize, function(i3) {
                  return STORAGE + "[" + i3 + "]=" + VALUE + "[" + i3 + "]";
                }),
                ",",
                STORAGE,
                ")"
              );
            }
          } else if (unroll > 1) {
            scope(loop(unroll, function(i3) {
              return Array.isArray(VALUE) ? VALUE[i3] : VALUE + "[" + i3 + "]";
            }));
          } else {
            check$1(!Array.isArray(VALUE), "uniform value must not be an array");
            scope(VALUE);
          }
          scope(");");
        }
      }
      function emitDraw(env, outer, inner, args) {
        var shared = env.shared;
        var GL = shared.gl;
        var DRAW_STATE = shared.draw;
        var drawOptions = args.draw;
        function emitElements() {
          var defn = drawOptions.elements;
          var ELEMENTS2;
          var scope = outer;
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              scope = inner;
            }
            ELEMENTS2 = defn.append(env, scope);
          } else {
            ELEMENTS2 = scope.def(DRAW_STATE, ".", S_ELEMENTS);
          }
          if (ELEMENTS2) {
            scope(
              "if(" + ELEMENTS2 + ")" + GL + ".bindBuffer(" + GL_ELEMENT_ARRAY_BUFFER$1 + "," + ELEMENTS2 + ".buffer.buffer);"
            );
          }
          return ELEMENTS2;
        }
        function emitCount() {
          var defn = drawOptions.count;
          var COUNT2;
          var scope = outer;
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              scope = inner;
            }
            COUNT2 = defn.append(env, scope);
            check$1.optional(function() {
              if (defn.MISSING) {
                env.assert(outer, "false", "missing vertex count");
              }
              if (defn.DYNAMIC) {
                env.assert(scope, COUNT2 + ">=0", "missing vertex count");
              }
            });
          } else {
            COUNT2 = scope.def(DRAW_STATE, ".", S_COUNT);
            check$1.optional(function() {
              env.assert(scope, COUNT2 + ">=0", "missing vertex count");
            });
          }
          return COUNT2;
        }
        var ELEMENTS = emitElements();
        function emitValue(name) {
          var defn = drawOptions[name];
          if (defn) {
            if (defn.contextDep && args.contextDynamic || defn.propDep) {
              return defn.append(env, inner);
            } else {
              return defn.append(env, outer);
            }
          } else {
            return outer.def(DRAW_STATE, ".", name);
          }
        }
        var PRIMITIVE = emitValue(S_PRIMITIVE);
        var OFFSET = emitValue(S_OFFSET);
        var COUNT = emitCount();
        if (typeof COUNT === "number") {
          if (COUNT === 0) {
            return;
          }
        } else {
          inner("if(", COUNT, "){");
          inner.exit("}");
        }
        var INSTANCES, EXT_INSTANCING;
        if (extInstancing) {
          INSTANCES = emitValue(S_INSTANCES);
          EXT_INSTANCING = env.instancing;
        }
        var ELEMENT_TYPE = ELEMENTS + ".type";
        var elementsStatic = drawOptions.elements && isStatic(drawOptions.elements);
        function emitInstancing() {
          function drawElements() {
            inner(EXT_INSTANCING, ".drawElementsInstancedANGLE(", [
              PRIMITIVE,
              COUNT,
              ELEMENT_TYPE,
              OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)",
              INSTANCES
            ], ");");
          }
          function drawArrays() {
            inner(
              EXT_INSTANCING,
              ".drawArraysInstancedANGLE(",
              [PRIMITIVE, OFFSET, COUNT, INSTANCES],
              ");"
            );
          }
          if (ELEMENTS) {
            if (!elementsStatic) {
              inner("if(", ELEMENTS, "){");
              drawElements();
              inner("}else{");
              drawArrays();
              inner("}");
            } else {
              drawElements();
            }
          } else {
            drawArrays();
          }
        }
        function emitRegular() {
          function drawElements() {
            inner(GL + ".drawElements(" + [
              PRIMITIVE,
              COUNT,
              ELEMENT_TYPE,
              OFFSET + "<<((" + ELEMENT_TYPE + "-" + GL_UNSIGNED_BYTE$8 + ")>>1)"
            ] + ");");
          }
          function drawArrays() {
            inner(GL + ".drawArrays(" + [PRIMITIVE, OFFSET, COUNT] + ");");
          }
          if (ELEMENTS) {
            if (!elementsStatic) {
              inner("if(", ELEMENTS, "){");
              drawElements();
              inner("}else{");
              drawArrays();
              inner("}");
            } else {
              drawElements();
            }
          } else {
            drawArrays();
          }
        }
        if (extInstancing && (typeof INSTANCES !== "number" || INSTANCES >= 0)) {
          if (typeof INSTANCES === "string") {
            inner("if(", INSTANCES, ">0){");
            emitInstancing();
            inner("}else if(", INSTANCES, "<0){");
            emitRegular();
            inner("}");
          } else {
            emitInstancing();
          }
        } else {
          emitRegular();
        }
      }
      function createBody(emitBody, parentEnv, args, program, count) {
        var env = createREGLEnvironment();
        var scope = env.proc("body", count);
        check$1.optional(function() {
          env.commandStr = parentEnv.commandStr;
          env.command = env.link(parentEnv.commandStr);
        });
        if (extInstancing) {
          env.instancing = scope.def(
            env.shared.extensions,
            ".angle_instanced_arrays"
          );
        }
        emitBody(env, scope, args, program);
        return env.compile().body;
      }
      function emitDrawBody(env, draw, args, program) {
        injectExtensions(env, draw);
        if (args.useVAO) {
          if (args.drawVAO) {
            draw(env.shared.vao, ".setVAO(", args.drawVAO.append(env, draw), ");");
          } else {
            draw(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
          }
        } else {
          draw(env.shared.vao, ".setVAO(null);");
          emitAttributes(env, draw, args, program.attributes, function() {
            return true;
          });
        }
        emitUniforms(env, draw, args, program.uniforms, function() {
          return true;
        });
        emitDraw(env, draw, draw, args);
      }
      function emitDrawProc(env, args) {
        var draw = env.proc("draw", 1);
        injectExtensions(env, draw);
        emitContext(env, draw, args.context);
        emitPollFramebuffer(env, draw, args.framebuffer);
        emitPollState(env, draw, args);
        emitSetOptions(env, draw, args.state);
        emitProfile(env, draw, args, false, true);
        var program = args.shader.progVar.append(env, draw);
        draw(env.shared.gl, ".useProgram(", program, ".program);");
        if (args.shader.program) {
          emitDrawBody(env, draw, args, args.shader.program);
        } else {
          draw(env.shared.vao, ".setVAO(null);");
          var drawCache = env.global.def("{}");
          var PROG_ID = draw.def(program, ".id");
          var CACHED_PROC = draw.def(drawCache, "[", PROG_ID, "]");
          draw(
            env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0);").else(
              CACHED_PROC,
              "=",
              drawCache,
              "[",
              PROG_ID,
              "]=",
              env.link(function(program2) {
                return createBody(emitDrawBody, env, args, program2, 1);
              }),
              "(",
              program,
              ");",
              CACHED_PROC,
              ".call(this,a0);"
            )
          );
        }
        if (Object.keys(args.state).length > 0) {
          draw(env.shared.current, ".dirty=true;");
        }
      }
      function emitBatchDynamicShaderBody(env, scope, args, program) {
        env.batchId = "a1";
        injectExtensions(env, scope);
        function all() {
          return true;
        }
        emitAttributes(env, scope, args, program.attributes, all);
        emitUniforms(env, scope, args, program.uniforms, all);
        emitDraw(env, scope, scope, args);
      }
      function emitBatchBody(env, scope, args, program) {
        injectExtensions(env, scope);
        var contextDynamic = args.contextDep;
        var BATCH_ID = scope.def();
        var PROP_LIST = "a0";
        var NUM_PROPS = "a1";
        var PROPS = scope.def();
        env.shared.props = PROPS;
        env.batchId = BATCH_ID;
        var outer = env.scope();
        var inner = env.scope();
        scope(
          outer.entry,
          "for(",
          BATCH_ID,
          "=0;",
          BATCH_ID,
          "<",
          NUM_PROPS,
          ";++",
          BATCH_ID,
          "){",
          PROPS,
          "=",
          PROP_LIST,
          "[",
          BATCH_ID,
          "];",
          inner,
          "}",
          outer.exit
        );
        function isInnerDefn(defn) {
          return defn.contextDep && contextDynamic || defn.propDep;
        }
        function isOuterDefn(defn) {
          return !isInnerDefn(defn);
        }
        if (args.needsContext) {
          emitContext(env, inner, args.context);
        }
        if (args.needsFramebuffer) {
          emitPollFramebuffer(env, inner, args.framebuffer);
        }
        emitSetOptions(env, inner, args.state, isInnerDefn);
        if (args.profile && isInnerDefn(args.profile)) {
          emitProfile(env, inner, args, false, true);
        }
        if (!program) {
          var progCache = env.global.def("{}");
          var PROGRAM = args.shader.progVar.append(env, inner);
          var PROG_ID = inner.def(PROGRAM, ".id");
          var CACHED_PROC = inner.def(progCache, "[", PROG_ID, "]");
          inner(
            env.shared.gl,
            ".useProgram(",
            PROGRAM,
            ".program);",
            "if(!",
            CACHED_PROC,
            "){",
            CACHED_PROC,
            "=",
            progCache,
            "[",
            PROG_ID,
            "]=",
            env.link(function(program2) {
              return createBody(
                emitBatchDynamicShaderBody,
                env,
                args,
                program2,
                2
              );
            }),
            "(",
            PROGRAM,
            ");}",
            CACHED_PROC,
            ".call(this,a0[",
            BATCH_ID,
            "],",
            BATCH_ID,
            ");"
          );
        } else {
          if (args.useVAO) {
            if (args.drawVAO) {
              if (isInnerDefn(args.drawVAO)) {
                inner(env.shared.vao, ".setVAO(", args.drawVAO.append(env, inner), ");");
              } else {
                outer(env.shared.vao, ".setVAO(", args.drawVAO.append(env, outer), ");");
              }
            } else {
              outer(env.shared.vao, ".setVAO(", env.shared.vao, ".targetVAO);");
            }
          } else {
            outer(env.shared.vao, ".setVAO(null);");
            emitAttributes(env, outer, args, program.attributes, isOuterDefn);
            emitAttributes(env, inner, args, program.attributes, isInnerDefn);
          }
          emitUniforms(env, outer, args, program.uniforms, isOuterDefn);
          emitUniforms(env, inner, args, program.uniforms, isInnerDefn);
          emitDraw(env, outer, inner, args);
        }
      }
      function emitBatchProc(env, args) {
        var batch = env.proc("batch", 2);
        env.batchId = "0";
        injectExtensions(env, batch);
        var contextDynamic = false;
        var needsContext = true;
        Object.keys(args.context).forEach(function(name) {
          contextDynamic = contextDynamic || args.context[name].propDep;
        });
        if (!contextDynamic) {
          emitContext(env, batch, args.context);
          needsContext = false;
        }
        var framebuffer = args.framebuffer;
        var needsFramebuffer = false;
        if (framebuffer) {
          if (framebuffer.propDep) {
            contextDynamic = needsFramebuffer = true;
          } else if (framebuffer.contextDep && contextDynamic) {
            needsFramebuffer = true;
          }
          if (!needsFramebuffer) {
            emitPollFramebuffer(env, batch, framebuffer);
          }
        } else {
          emitPollFramebuffer(env, batch, null);
        }
        if (args.state.viewport && args.state.viewport.propDep) {
          contextDynamic = true;
        }
        function isInnerDefn(defn) {
          return defn.contextDep && contextDynamic || defn.propDep;
        }
        emitPollState(env, batch, args);
        emitSetOptions(env, batch, args.state, function(defn) {
          return !isInnerDefn(defn);
        });
        if (!args.profile || !isInnerDefn(args.profile)) {
          emitProfile(env, batch, args, false, "a1");
        }
        args.contextDep = contextDynamic;
        args.needsContext = needsContext;
        args.needsFramebuffer = needsFramebuffer;
        var progDefn = args.shader.progVar;
        if (progDefn.contextDep && contextDynamic || progDefn.propDep) {
          emitBatchBody(
            env,
            batch,
            args,
            null
          );
        } else {
          var PROGRAM = progDefn.append(env, batch);
          batch(env.shared.gl, ".useProgram(", PROGRAM, ".program);");
          if (args.shader.program) {
            emitBatchBody(
              env,
              batch,
              args,
              args.shader.program
            );
          } else {
            batch(env.shared.vao, ".setVAO(null);");
            var batchCache = env.global.def("{}");
            var PROG_ID = batch.def(PROGRAM, ".id");
            var CACHED_PROC = batch.def(batchCache, "[", PROG_ID, "]");
            batch(
              env.cond(CACHED_PROC).then(CACHED_PROC, ".call(this,a0,a1);").else(
                CACHED_PROC,
                "=",
                batchCache,
                "[",
                PROG_ID,
                "]=",
                env.link(function(program) {
                  return createBody(emitBatchBody, env, args, program, 2);
                }),
                "(",
                PROGRAM,
                ");",
                CACHED_PROC,
                ".call(this,a0,a1);"
              )
            );
          }
        }
        if (Object.keys(args.state).length > 0) {
          batch(env.shared.current, ".dirty=true;");
        }
      }
      function emitScopeProc(env, args) {
        var scope = env.proc("scope", 3);
        env.batchId = "a2";
        var shared = env.shared;
        var CURRENT_STATE = shared.current;
        emitContext(env, scope, args.context);
        if (args.framebuffer) {
          args.framebuffer.append(env, scope);
        }
        sortState(Object.keys(args.state)).forEach(function(name) {
          var defn = args.state[name];
          var value = defn.append(env, scope);
          if (isArrayLike(value)) {
            value.forEach(function(v2, i2) {
              scope.set(env.next[name], "[" + i2 + "]", v2);
            });
          } else {
            scope.set(shared.next, "." + name, value);
          }
        });
        emitProfile(env, scope, args, true, true);
        [S_ELEMENTS, S_OFFSET, S_COUNT, S_INSTANCES, S_PRIMITIVE].forEach(
          function(opt) {
            var variable = args.draw[opt];
            if (!variable) {
              return;
            }
            scope.set(shared.draw, "." + opt, "" + variable.append(env, scope));
          }
        );
        Object.keys(args.uniforms).forEach(function(opt) {
          var value = args.uniforms[opt].append(env, scope);
          if (Array.isArray(value)) {
            value = "[" + value.join() + "]";
          }
          scope.set(
            shared.uniforms,
            "[" + stringStore.id(opt) + "]",
            value
          );
        });
        Object.keys(args.attributes).forEach(function(name) {
          var record = args.attributes[name].append(env, scope);
          var scopeAttrib = env.scopeAttrib(name);
          Object.keys(new AttributeRecord2()).forEach(function(prop) {
            scope.set(scopeAttrib, "." + prop, record[prop]);
          });
        });
        if (args.scopeVAO) {
          scope.set(shared.vao, ".targetVAO", args.scopeVAO.append(env, scope));
        }
        function saveShader(name) {
          var shader = args.shader[name];
          if (shader) {
            scope.set(shared.shader, "." + name, shader.append(env, scope));
          }
        }
        saveShader(S_VERT);
        saveShader(S_FRAG);
        if (Object.keys(args.state).length > 0) {
          scope(CURRENT_STATE, ".dirty=true;");
          scope.exit(CURRENT_STATE, ".dirty=true;");
        }
        scope("a1(", env.shared.context, ",a0,", env.batchId, ");");
      }
      function isDynamicObject(object4) {
        if (typeof object4 !== "object" || isArrayLike(object4)) {
          return;
        }
        var props = Object.keys(object4);
        for (var i2 = 0; i2 < props.length; ++i2) {
          if (dynamic.isDynamic(object4[props[i2]])) {
            return true;
          }
        }
        return false;
      }
      function splatObject(env, options, name) {
        var object4 = options.static[name];
        if (!object4 || !isDynamicObject(object4)) {
          return;
        }
        var globals = env.global;
        var keys = Object.keys(object4);
        var thisDep = false;
        var contextDep = false;
        var propDep = false;
        var objectRef = env.global.def("{}");
        keys.forEach(function(key) {
          var value = object4[key];
          if (dynamic.isDynamic(value)) {
            if (typeof value === "function") {
              value = object4[key] = dynamic.unbox(value);
            }
            var deps = createDynamicDecl(value, null);
            thisDep = thisDep || deps.thisDep;
            propDep = propDep || deps.propDep;
            contextDep = contextDep || deps.contextDep;
          } else {
            globals(objectRef, ".", key, "=");
            switch (typeof value) {
              case "number":
                globals(value);
                break;
              case "string":
                globals('"', value, '"');
                break;
              case "object":
                if (Array.isArray(value)) {
                  globals("[", value.join(), "]");
                }
                break;
              default:
                globals(env.link(value));
                break;
            }
            globals(";");
          }
        });
        function appendBlock(env2, block) {
          keys.forEach(function(key) {
            var value = object4[key];
            if (!dynamic.isDynamic(value)) {
              return;
            }
            var ref2 = env2.invoke(block, value);
            block(objectRef, ".", key, "=", ref2, ";");
          });
        }
        options.dynamic[name] = new dynamic.DynamicVariable(DYN_THUNK, {
          thisDep,
          contextDep,
          propDep,
          ref: objectRef,
          append: appendBlock
        });
        delete options.static[name];
      }
      function compileCommand(options, attributes, uniforms, context, stats2) {
        var env = createREGLEnvironment();
        env.stats = env.link(stats2);
        Object.keys(attributes.static).forEach(function(key) {
          splatObject(env, attributes, key);
        });
        NESTED_OPTIONS.forEach(function(name) {
          splatObject(env, options, name);
        });
        var args = parseArguments(options, attributes, uniforms, context, env);
        emitDrawProc(env, args);
        emitScopeProc(env, args);
        emitBatchProc(env, args);
        return extend(env.compile(), {
          destroy: function() {
            args.shader.program.destroy();
          }
        });
      }
      return {
        next: nextState,
        current: currentState,
        procs: function() {
          var env = createREGLEnvironment();
          var poll = env.proc("poll");
          var refresh = env.proc("refresh");
          var common = env.block();
          poll(common);
          refresh(common);
          var shared = env.shared;
          var GL = shared.gl;
          var NEXT_STATE = shared.next;
          var CURRENT_STATE = shared.current;
          common(CURRENT_STATE, ".dirty=false;");
          emitPollFramebuffer(env, poll);
          emitPollFramebuffer(env, refresh, null, true);
          var INSTANCING;
          if (extInstancing) {
            INSTANCING = env.link(extInstancing);
          }
          if (extensions.oes_vertex_array_object) {
            refresh(env.link(extensions.oes_vertex_array_object), ".bindVertexArrayOES(null);");
          }
          for (var i2 = 0; i2 < limits.maxAttributes; ++i2) {
            var BINDING = refresh.def(shared.attributes, "[", i2, "]");
            var ifte = env.cond(BINDING, ".buffer");
            ifte.then(
              GL,
              ".enableVertexAttribArray(",
              i2,
              ");",
              GL,
              ".bindBuffer(",
              GL_ARRAY_BUFFER$2,
              ",",
              BINDING,
              ".buffer.buffer);",
              GL,
              ".vertexAttribPointer(",
              i2,
              ",",
              BINDING,
              ".size,",
              BINDING,
              ".type,",
              BINDING,
              ".normalized,",
              BINDING,
              ".stride,",
              BINDING,
              ".offset);"
            ).else(
              GL,
              ".disableVertexAttribArray(",
              i2,
              ");",
              GL,
              ".vertexAttrib4f(",
              i2,
              ",",
              BINDING,
              ".x,",
              BINDING,
              ".y,",
              BINDING,
              ".z,",
              BINDING,
              ".w);",
              BINDING,
              ".buffer=null;"
            );
            refresh(ifte);
            if (extInstancing) {
              refresh(
                INSTANCING,
                ".vertexAttribDivisorANGLE(",
                i2,
                ",",
                BINDING,
                ".divisor);"
              );
            }
          }
          refresh(
            env.shared.vao,
            ".currentVAO=null;",
            env.shared.vao,
            ".setVAO(",
            env.shared.vao,
            ".targetVAO);"
          );
          Object.keys(GL_FLAGS).forEach(function(flag) {
            var cap = GL_FLAGS[flag];
            var NEXT = common.def(NEXT_STATE, ".", flag);
            var block = env.block();
            block(
              "if(",
              NEXT,
              "){",
              GL,
              ".enable(",
              cap,
              ")}else{",
              GL,
              ".disable(",
              cap,
              ")}",
              CURRENT_STATE,
              ".",
              flag,
              "=",
              NEXT,
              ";"
            );
            refresh(block);
            poll(
              "if(",
              NEXT,
              "!==",
              CURRENT_STATE,
              ".",
              flag,
              "){",
              block,
              "}"
            );
          });
          Object.keys(GL_VARIABLES).forEach(function(name) {
            var func = GL_VARIABLES[name];
            var init4 = currentState[name];
            var NEXT, CURRENT;
            var block = env.block();
            block(GL, ".", func, "(");
            if (isArrayLike(init4)) {
              var n2 = init4.length;
              NEXT = env.global.def(NEXT_STATE, ".", name);
              CURRENT = env.global.def(CURRENT_STATE, ".", name);
              block(
                loop(n2, function(i3) {
                  return NEXT + "[" + i3 + "]";
                }),
                ");",
                loop(n2, function(i3) {
                  return CURRENT + "[" + i3 + "]=" + NEXT + "[" + i3 + "];";
                }).join("")
              );
              poll(
                "if(",
                loop(n2, function(i3) {
                  return NEXT + "[" + i3 + "]!==" + CURRENT + "[" + i3 + "]";
                }).join("||"),
                "){",
                block,
                "}"
              );
            } else {
              NEXT = common.def(NEXT_STATE, ".", name);
              CURRENT = common.def(CURRENT_STATE, ".", name);
              block(
                NEXT,
                ");",
                CURRENT_STATE,
                ".",
                name,
                "=",
                NEXT,
                ";"
              );
              poll(
                "if(",
                NEXT,
                "!==",
                CURRENT,
                "){",
                block,
                "}"
              );
            }
            refresh(block);
          });
          return env.compile();
        }(),
        compile: compileCommand
      };
    }
    function stats() {
      return {
        vaoCount: 0,
        bufferCount: 0,
        elementsCount: 0,
        framebufferCount: 0,
        shaderCount: 0,
        textureCount: 0,
        cubeCount: 0,
        renderbufferCount: 0,
        maxTextureUnits: 0
      };
    }
    var GL_QUERY_RESULT_EXT = 34918;
    var GL_QUERY_RESULT_AVAILABLE_EXT = 34919;
    var GL_TIME_ELAPSED_EXT = 35007;
    var createTimer = function(gl2, extensions) {
      if (!extensions.ext_disjoint_timer_query) {
        return null;
      }
      var queryPool = [];
      function allocQuery() {
        return queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT();
      }
      function freeQuery(query) {
        queryPool.push(query);
      }
      var pendingQueries = [];
      function beginQuery(stats2) {
        var query = allocQuery();
        extensions.ext_disjoint_timer_query.beginQueryEXT(GL_TIME_ELAPSED_EXT, query);
        pendingQueries.push(query);
        pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats2);
      }
      function endQuery() {
        extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
      }
      function PendingStats() {
        this.startQueryIndex = -1;
        this.endQueryIndex = -1;
        this.sum = 0;
        this.stats = null;
      }
      var pendingStatsPool = [];
      function allocPendingStats() {
        return pendingStatsPool.pop() || new PendingStats();
      }
      function freePendingStats(pendingStats2) {
        pendingStatsPool.push(pendingStats2);
      }
      var pendingStats = [];
      function pushScopeStats(start, end, stats2) {
        var ps2 = allocPendingStats();
        ps2.startQueryIndex = start;
        ps2.endQueryIndex = end;
        ps2.sum = 0;
        ps2.stats = stats2;
        pendingStats.push(ps2);
      }
      var timeSum = [];
      var queryPtr = [];
      function update() {
        var ptr, i2;
        var n2 = pendingQueries.length;
        if (n2 === 0) {
          return;
        }
        queryPtr.length = Math.max(queryPtr.length, n2 + 1);
        timeSum.length = Math.max(timeSum.length, n2 + 1);
        timeSum[0] = 0;
        queryPtr[0] = 0;
        var queryTime = 0;
        ptr = 0;
        for (i2 = 0; i2 < pendingQueries.length; ++i2) {
          var query = pendingQueries[i2];
          if (extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_AVAILABLE_EXT)) {
            queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_EXT);
            freeQuery(query);
          } else {
            pendingQueries[ptr++] = query;
          }
          timeSum[i2 + 1] = queryTime;
          queryPtr[i2 + 1] = ptr;
        }
        pendingQueries.length = ptr;
        ptr = 0;
        for (i2 = 0; i2 < pendingStats.length; ++i2) {
          var stats2 = pendingStats[i2];
          var start = stats2.startQueryIndex;
          var end = stats2.endQueryIndex;
          stats2.sum += timeSum[end] - timeSum[start];
          var startPtr = queryPtr[start];
          var endPtr = queryPtr[end];
          if (endPtr === startPtr) {
            stats2.stats.gpuTime += stats2.sum / 1e6;
            freePendingStats(stats2);
          } else {
            stats2.startQueryIndex = startPtr;
            stats2.endQueryIndex = endPtr;
            pendingStats[ptr++] = stats2;
          }
        }
        pendingStats.length = ptr;
      }
      return {
        beginQuery,
        endQuery,
        pushScopeStats,
        update,
        getNumPendingQueries: function() {
          return pendingQueries.length;
        },
        clear: function() {
          queryPool.push.apply(queryPool, pendingQueries);
          for (var i2 = 0; i2 < queryPool.length; i2++) {
            extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i2]);
          }
          pendingQueries.length = 0;
          queryPool.length = 0;
        },
        restore: function() {
          pendingQueries.length = 0;
          queryPool.length = 0;
        }
      };
    };
    var GL_COLOR_BUFFER_BIT = 16384;
    var GL_DEPTH_BUFFER_BIT = 256;
    var GL_STENCIL_BUFFER_BIT = 1024;
    var GL_ARRAY_BUFFER = 34962;
    var CONTEXT_LOST_EVENT = "webglcontextlost";
    var CONTEXT_RESTORED_EVENT = "webglcontextrestored";
    var DYN_PROP = 1;
    var DYN_CONTEXT = 2;
    var DYN_STATE = 3;
    function find(haystack, needle) {
      for (var i2 = 0; i2 < haystack.length; ++i2) {
        if (haystack[i2] === needle) {
          return i2;
        }
      }
      return -1;
    }
    function wrapREGL(args) {
      var config = parseArgs(args);
      if (!config) {
        return null;
      }
      var gl2 = config.gl;
      var glAttributes = gl2.getContextAttributes();
      var contextLost = gl2.isContextLost();
      var extensionState = createExtensionCache(gl2, config);
      if (!extensionState) {
        return null;
      }
      var stringStore = createStringStore();
      var stats$$1 = stats();
      var extensions = extensionState.extensions;
      var timer = createTimer(gl2, extensions);
      var START_TIME = clock();
      var WIDTH = gl2.drawingBufferWidth;
      var HEIGHT = gl2.drawingBufferHeight;
      var contextState = {
        tick: 0,
        time: 0,
        viewportWidth: WIDTH,
        viewportHeight: HEIGHT,
        framebufferWidth: WIDTH,
        framebufferHeight: HEIGHT,
        drawingBufferWidth: WIDTH,
        drawingBufferHeight: HEIGHT,
        pixelRatio: config.pixelRatio
      };
      var uniformState = {};
      var drawState = {
        elements: null,
        primitive: 4,
        // GL_TRIANGLES
        count: -1,
        offset: 0,
        instances: -1
      };
      var limits = wrapLimits(gl2, extensions);
      var bufferState = wrapBufferState(
        gl2,
        stats$$1,
        config,
        destroyBuffer
      );
      var attributeState = wrapAttributeState(
        gl2,
        extensions,
        limits,
        stats$$1,
        bufferState
      );
      function destroyBuffer(buffer) {
        return attributeState.destroyBuffer(buffer);
      }
      var elementState = wrapElementsState(gl2, extensions, bufferState, stats$$1);
      var shaderState = wrapShaderState(gl2, stringStore, stats$$1, config);
      var textureState = createTextureSet(
        gl2,
        extensions,
        limits,
        function() {
          core.procs.poll();
        },
        contextState,
        stats$$1,
        config
      );
      var renderbufferState = wrapRenderbuffers(gl2, extensions, limits, stats$$1, config);
      var framebufferState = wrapFBOState(
        gl2,
        extensions,
        limits,
        textureState,
        renderbufferState,
        stats$$1
      );
      var core = reglCore(
        gl2,
        stringStore,
        extensions,
        limits,
        bufferState,
        elementState,
        textureState,
        framebufferState,
        uniformState,
        attributeState,
        shaderState,
        drawState,
        contextState,
        timer,
        config
      );
      var readPixels = wrapReadPixels(
        gl2,
        framebufferState,
        core.procs.poll,
        contextState,
        glAttributes,
        extensions,
        limits
      );
      var nextState = core.next;
      var canvas = gl2.canvas;
      var rafCallbacks = [];
      var lossCallbacks = [];
      var restoreCallbacks = [];
      var destroyCallbacks = [config.onDestroy];
      var activeRAF = null;
      function handleRAF() {
        if (rafCallbacks.length === 0) {
          if (timer) {
            timer.update();
          }
          activeRAF = null;
          return;
        }
        activeRAF = raf.next(handleRAF);
        poll();
        for (var i2 = rafCallbacks.length - 1; i2 >= 0; --i2) {
          var cb2 = rafCallbacks[i2];
          if (cb2) {
            cb2(contextState, null, 0);
          }
        }
        gl2.flush();
        if (timer) {
          timer.update();
        }
      }
      function startRAF() {
        if (!activeRAF && rafCallbacks.length > 0) {
          activeRAF = raf.next(handleRAF);
        }
      }
      function stopRAF() {
        if (activeRAF) {
          raf.cancel(handleRAF);
          activeRAF = null;
        }
      }
      function handleContextLoss(event) {
        event.preventDefault();
        contextLost = true;
        stopRAF();
        lossCallbacks.forEach(function(cb2) {
          cb2();
        });
      }
      function handleContextRestored(event) {
        gl2.getError();
        contextLost = false;
        extensionState.restore();
        shaderState.restore();
        bufferState.restore();
        textureState.restore();
        renderbufferState.restore();
        framebufferState.restore();
        attributeState.restore();
        if (timer) {
          timer.restore();
        }
        core.procs.refresh();
        startRAF();
        restoreCallbacks.forEach(function(cb2) {
          cb2();
        });
      }
      if (canvas) {
        canvas.addEventListener(CONTEXT_LOST_EVENT, handleContextLoss, false);
        canvas.addEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored, false);
      }
      function destroy() {
        rafCallbacks.length = 0;
        stopRAF();
        if (canvas) {
          canvas.removeEventListener(CONTEXT_LOST_EVENT, handleContextLoss);
          canvas.removeEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored);
        }
        shaderState.clear();
        framebufferState.clear();
        renderbufferState.clear();
        textureState.clear();
        elementState.clear();
        bufferState.clear();
        attributeState.clear();
        if (timer) {
          timer.clear();
        }
        destroyCallbacks.forEach(function(cb2) {
          cb2();
        });
      }
      function compileProcedure(options) {
        check$1(!!options, "invalid args to regl({...})");
        check$1.type(options, "object", "invalid args to regl({...})");
        function flattenNestedOptions(options2) {
          var result = extend({}, options2);
          delete result.uniforms;
          delete result.attributes;
          delete result.context;
          delete result.vao;
          if ("stencil" in result && result.stencil.op) {
            result.stencil.opBack = result.stencil.opFront = result.stencil.op;
            delete result.stencil.op;
          }
          function merge2(name) {
            if (name in result) {
              var child = result[name];
              delete result[name];
              Object.keys(child).forEach(function(prop) {
                result[name + "." + prop] = child[prop];
              });
            }
          }
          merge2("blend");
          merge2("depth");
          merge2("cull");
          merge2("stencil");
          merge2("polygonOffset");
          merge2("scissor");
          merge2("sample");
          if ("vao" in options2) {
            result.vao = options2.vao;
          }
          return result;
        }
        function separateDynamic(object4, useArrays) {
          var staticItems = {};
          var dynamicItems = {};
          Object.keys(object4).forEach(function(option) {
            var value = object4[option];
            if (dynamic.isDynamic(value)) {
              dynamicItems[option] = dynamic.unbox(value, option);
              return;
            } else if (useArrays && Array.isArray(value)) {
              for (var i2 = 0; i2 < value.length; ++i2) {
                if (dynamic.isDynamic(value[i2])) {
                  dynamicItems[option] = dynamic.unbox(value, option);
                  return;
                }
              }
            }
            staticItems[option] = value;
          });
          return {
            dynamic: dynamicItems,
            static: staticItems
          };
        }
        var context = separateDynamic(options.context || {}, true);
        var uniforms = separateDynamic(options.uniforms || {}, true);
        var attributes = separateDynamic(options.attributes || {}, false);
        var opts = separateDynamic(flattenNestedOptions(options), false);
        var stats$$12 = {
          gpuTime: 0,
          cpuTime: 0,
          count: 0
        };
        var compiled = core.compile(opts, attributes, uniforms, context, stats$$12);
        var draw = compiled.draw;
        var batch = compiled.batch;
        var scope = compiled.scope;
        var EMPTY_ARRAY = [];
        function reserve(count) {
          while (EMPTY_ARRAY.length < count) {
            EMPTY_ARRAY.push(null);
          }
          return EMPTY_ARRAY;
        }
        function REGLCommand(args2, body) {
          var i2;
          if (contextLost) {
            check$1.raise("context lost");
          }
          if (typeof args2 === "function") {
            return scope.call(this, null, args2, 0);
          } else if (typeof body === "function") {
            if (typeof args2 === "number") {
              for (i2 = 0; i2 < args2; ++i2) {
                scope.call(this, null, body, i2);
              }
            } else if (Array.isArray(args2)) {
              for (i2 = 0; i2 < args2.length; ++i2) {
                scope.call(this, args2[i2], body, i2);
              }
            } else {
              return scope.call(this, args2, body, 0);
            }
          } else if (typeof args2 === "number") {
            if (args2 > 0) {
              return batch.call(this, reserve(args2 | 0), args2 | 0);
            }
          } else if (Array.isArray(args2)) {
            if (args2.length) {
              return batch.call(this, args2, args2.length);
            }
          } else {
            return draw.call(this, args2);
          }
        }
        return extend(REGLCommand, {
          stats: stats$$12,
          destroy: function() {
            compiled.destroy();
          }
        });
      }
      var setFBO = framebufferState.setFBO = compileProcedure({
        framebuffer: dynamic.define.call(null, DYN_PROP, "framebuffer")
      });
      function clearImpl(_2, options) {
        var clearFlags = 0;
        core.procs.poll();
        var c3 = options.color;
        if (c3) {
          gl2.clearColor(+c3[0] || 0, +c3[1] || 0, +c3[2] || 0, +c3[3] || 0);
          clearFlags |= GL_COLOR_BUFFER_BIT;
        }
        if ("depth" in options) {
          gl2.clearDepth(+options.depth);
          clearFlags |= GL_DEPTH_BUFFER_BIT;
        }
        if ("stencil" in options) {
          gl2.clearStencil(options.stencil | 0);
          clearFlags |= GL_STENCIL_BUFFER_BIT;
        }
        check$1(!!clearFlags, "called regl.clear with no buffer specified");
        gl2.clear(clearFlags);
      }
      function clear(options) {
        check$1(
          typeof options === "object" && options,
          "regl.clear() takes an object as input"
        );
        if ("framebuffer" in options) {
          if (options.framebuffer && options.framebuffer_reglType === "framebufferCube") {
            for (var i2 = 0; i2 < 6; ++i2) {
              setFBO(extend({
                framebuffer: options.framebuffer.faces[i2]
              }, options), clearImpl);
            }
          } else {
            setFBO(options, clearImpl);
          }
        } else {
          clearImpl(null, options);
        }
      }
      function frame(cb2) {
        check$1.type(cb2, "function", "regl.frame() callback must be a function");
        rafCallbacks.push(cb2);
        function cancel() {
          var i2 = find(rafCallbacks, cb2);
          check$1(i2 >= 0, "cannot cancel a frame twice");
          function pendingCancel() {
            var index2 = find(rafCallbacks, pendingCancel);
            rafCallbacks[index2] = rafCallbacks[rafCallbacks.length - 1];
            rafCallbacks.length -= 1;
            if (rafCallbacks.length <= 0) {
              stopRAF();
            }
          }
          rafCallbacks[i2] = pendingCancel;
        }
        startRAF();
        return {
          cancel
        };
      }
      function pollViewport() {
        var viewport = nextState.viewport;
        var scissorBox = nextState.scissor_box;
        viewport[0] = viewport[1] = scissorBox[0] = scissorBox[1] = 0;
        contextState.viewportWidth = contextState.framebufferWidth = contextState.drawingBufferWidth = viewport[2] = scissorBox[2] = gl2.drawingBufferWidth;
        contextState.viewportHeight = contextState.framebufferHeight = contextState.drawingBufferHeight = viewport[3] = scissorBox[3] = gl2.drawingBufferHeight;
      }
      function poll() {
        contextState.tick += 1;
        contextState.time = now();
        pollViewport();
        core.procs.poll();
      }
      function refresh() {
        textureState.refresh();
        pollViewport();
        core.procs.refresh();
        if (timer) {
          timer.update();
        }
      }
      function now() {
        return (clock() - START_TIME) / 1e3;
      }
      refresh();
      function addListener(event, callback) {
        check$1.type(callback, "function", "listener callback must be a function");
        var callbacks;
        switch (event) {
          case "frame":
            return frame(callback);
          case "lost":
            callbacks = lossCallbacks;
            break;
          case "restore":
            callbacks = restoreCallbacks;
            break;
          case "destroy":
            callbacks = destroyCallbacks;
            break;
          default:
            check$1.raise("invalid event, must be one of frame,lost,restore,destroy");
        }
        callbacks.push(callback);
        return {
          cancel: function() {
            for (var i2 = 0; i2 < callbacks.length; ++i2) {
              if (callbacks[i2] === callback) {
                callbacks[i2] = callbacks[callbacks.length - 1];
                callbacks.pop();
                return;
              }
            }
          }
        };
      }
      var regl2 = extend(compileProcedure, {
        // Clear current FBO
        clear,
        // Short cuts for dynamic variables
        prop: dynamic.define.bind(null, DYN_PROP),
        context: dynamic.define.bind(null, DYN_CONTEXT),
        this: dynamic.define.bind(null, DYN_STATE),
        // executes an empty draw command
        draw: compileProcedure({}),
        // Resources
        buffer: function(options) {
          return bufferState.create(options, GL_ARRAY_BUFFER, false, false);
        },
        elements: function(options) {
          return elementState.create(options, false);
        },
        texture: textureState.create2D,
        cube: textureState.createCube,
        renderbuffer: renderbufferState.create,
        framebuffer: framebufferState.create,
        framebufferCube: framebufferState.createCube,
        vao: attributeState.createVAO,
        // Expose context attributes
        attributes: glAttributes,
        // Frame rendering
        frame,
        on: addListener,
        // System limits
        limits,
        hasExtension: function(name) {
          return limits.extensions.indexOf(name.toLowerCase()) >= 0;
        },
        // Read pixels
        read: readPixels,
        // Destroy regl and all associated resources
        destroy,
        // Direct GL state manipulation
        _gl: gl2,
        _refresh: refresh,
        poll: function() {
          poll();
          if (timer) {
            timer.update();
          }
        },
        // Current time
        now,
        // regl Statistics Information
        stats: stats$$1
      });
      config.onDone(null, regl2);
      return regl2;
    }
    return wrapREGL;
  });
})(regl);
var _primitiveMap, _usageMap, _dataTypeMap, _formatMap, _mipmapMap, _filterMap, _wrapModeMap, _colorSpaceMap, _depthFuncMap, _blendEquationMap, _blendFuncMap, _stencilFuncMap, _stencilOpMap, _cullFaceMap;
_primitiveMap = {}, _defineProperty(_primitiveMap, gl$1.POINTS, "points"), _defineProperty(_primitiveMap, gl$1.LINES, "lines"), _defineProperty(_primitiveMap, gl$1.LINE_LOOP, "line loop"), _defineProperty(_primitiveMap, gl$1.LINE_STRIP, "line strip"), _defineProperty(_primitiveMap, gl$1.TRIANGLES, "triangles"), _defineProperty(_primitiveMap, gl$1.TRIANGLE_FAN, "triangle fan"), _defineProperty(_primitiveMap, gl$1.TRIANGLE_STRIP, "triangle strip"), _primitiveMap;
_usageMap = {}, _defineProperty(_usageMap, gl$1.STATIC_DRAW, "static"), _defineProperty(_usageMap, gl$1.DYNAMIC_DRAW, "dynamic"), _defineProperty(_usageMap, gl$1.STREAM_DRAW, "stream"), _usageMap;
_dataTypeMap = {}, _defineProperty(_dataTypeMap, gl$1.BYTE, "int8"), _defineProperty(_dataTypeMap, gl$1.UNSIGNED_INT, "int16"), _defineProperty(_dataTypeMap, gl$1.INT, "int32"), _defineProperty(_dataTypeMap, gl$1.UNSIGNED_BYTE, "uint8"), _defineProperty(_dataTypeMap, gl$1.UNSIGNED_SHORT, "uint16"), _defineProperty(_dataTypeMap, gl$1.UNSIGNED_INT, "uint32"), _defineProperty(_dataTypeMap, gl$1.FLOAT, "float"), _dataTypeMap;
_formatMap = {}, _defineProperty(_formatMap, gl$1.ALPHA, "alpha"), _defineProperty(_formatMap, gl$1.LUMINANCE, "luminance"), _defineProperty(_formatMap, gl$1.LUMINANCE_ALPHA, "luminance alpha"), _defineProperty(_formatMap, gl$1.RGB, "rgb"), _defineProperty(_formatMap, gl$1.RGBA, "rgba"), _defineProperty(_formatMap, gl$1.RGBA4, "rgba4"), _defineProperty(_formatMap, gl$1.RGB5_A1, "rgb5 a1"), _defineProperty(_formatMap, gl$1.RGB565, "rgb565"), _defineProperty(_formatMap, gl$1.DEPTH_COMPONENT, "depth"), _defineProperty(_formatMap, gl$1.DEPTH_STENCIL, "depth stencil"), _formatMap;
_mipmapMap = {}, _defineProperty(_mipmapMap, gl$1.DONT_CARE, "dont care"), _defineProperty(_mipmapMap, gl$1.NICEST, "nice"), _defineProperty(_mipmapMap, gl$1.FASTEST, "fast"), _mipmapMap;
_filterMap = {}, _defineProperty(_filterMap, gl$1.NEAREST, "nearest"), _defineProperty(_filterMap, gl$1.LINEAR, "linear"), _defineProperty(_filterMap, gl$1.LINEAR_MIPMAP_LINEAR, "mipmap"), _defineProperty(_filterMap, gl$1.NEAREST_MIPMAP_LINEAR, "nearest mipmap linear"), _defineProperty(_filterMap, gl$1.LINEAR_MIPMAP_NEAREST, "linear mipmap nearest"), _defineProperty(_filterMap, gl$1.NEAREST_MIPMAP_NEAREST, "nearest mipmap nearest"), _filterMap;
_wrapModeMap = {}, _defineProperty(_wrapModeMap, gl$1.REPEAT, "repeat"), _defineProperty(_wrapModeMap, gl$1.CLAMP_TO_EDGE, "clamp"), _defineProperty(_wrapModeMap, gl$1.MIRRORED_REPEAT, "mirror"), _wrapModeMap;
_colorSpaceMap = {}, _defineProperty(_colorSpaceMap, gl$1.NONE, "none"), _defineProperty(_colorSpaceMap, gl$1.BROWSER_DEFAULT_WEBGL, "browser"), _colorSpaceMap;
_depthFuncMap = {}, _defineProperty(_depthFuncMap, gl$1.NEVER, "never"), _defineProperty(_depthFuncMap, gl$1.ALWAYS, "always"), _defineProperty(_depthFuncMap, gl$1.LESS, "less"), _defineProperty(_depthFuncMap, gl$1.LEQUAL, "lequal"), _defineProperty(_depthFuncMap, gl$1.GREATER, "greater"), _defineProperty(_depthFuncMap, gl$1.GEQUAL, "gequal"), _defineProperty(_depthFuncMap, gl$1.EQUAL, "equal"), _defineProperty(_depthFuncMap, gl$1.NOTEQUAL, "notequal"), _depthFuncMap;
_blendEquationMap = {}, _defineProperty(_blendEquationMap, gl$1.FUNC_ADD, "add"), _defineProperty(_blendEquationMap, gl$1.MIN_EXT, "min"), _defineProperty(_blendEquationMap, gl$1.MAX_EXT, "max"), _defineProperty(_blendEquationMap, gl$1.FUNC_SUBTRACT, "subtract"), _defineProperty(_blendEquationMap, gl$1.FUNC_REVERSE_SUBTRACT, "reverse subtract"), _blendEquationMap;
_blendFuncMap = {}, _defineProperty(_blendFuncMap, gl$1.ZERO, "zero"), _defineProperty(_blendFuncMap, gl$1.ONE, "one"), _defineProperty(_blendFuncMap, gl$1.SRC_COLOR, "src color"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_SRC_COLOR, "one minus src color"), _defineProperty(_blendFuncMap, gl$1.SRC_ALPHA, "src alpha"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_SRC_ALPHA, "one minus src alpha"), _defineProperty(_blendFuncMap, gl$1.DST_COLOR, "dst color"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_DST_COLOR, "one minus dst color"), _defineProperty(_blendFuncMap, gl$1.DST_ALPHA, "dst alpha"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_DST_ALPHA, "one minus dst alpha"), _defineProperty(_blendFuncMap, gl$1.CONSTANT_COLOR, "constant color"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_CONSTANT_COLOR, "one minus constant color"), _defineProperty(_blendFuncMap, gl$1.CONSTANT_ALPHA, "constant alpha"), _defineProperty(_blendFuncMap, gl$1.ONE_MINUS_CONSTANT_ALPHA, "one minus constant alpha"), _defineProperty(_blendFuncMap, gl$1.SRC_ALPHA_SATURATE, "src alpha saturate"), _blendFuncMap;
_stencilFuncMap = {}, _defineProperty(_stencilFuncMap, gl$1.NEVER, "never"), _defineProperty(_stencilFuncMap, gl$1.ALWAYS, "always"), _defineProperty(_stencilFuncMap, gl$1.LESS, "less"), _defineProperty(_stencilFuncMap, gl$1.LEQUAL, "lequal"), _defineProperty(_stencilFuncMap, gl$1.GREATER, "greater"), _defineProperty(_stencilFuncMap, gl$1.GEQUAL, "gequal"), _defineProperty(_stencilFuncMap, gl$1.EQUAL, "equal"), _defineProperty(_stencilFuncMap, gl$1.NOTEQUAL, "notequal"), _stencilFuncMap;
_stencilOpMap = {}, _defineProperty(_stencilOpMap, gl$1.ZERO, "zero"), _defineProperty(_stencilOpMap, gl$1.KEEP, "keep"), _defineProperty(_stencilOpMap, gl$1.REPLACE, "replace"), _defineProperty(_stencilOpMap, gl$1.INVERT, "invert"), _defineProperty(_stencilOpMap, gl$1.INCR, "increment"), _defineProperty(_stencilOpMap, gl$1.DECR, "decrement"), _defineProperty(_stencilOpMap, gl$1.INCR_WRAP, "increment wrap"), _defineProperty(_stencilOpMap, gl$1.DECR_WRAP, "decrement wrap"), _stencilOpMap;
_cullFaceMap = {}, _defineProperty(_cullFaceMap, gl$1.FRONT, "front"), _defineProperty(_cullFaceMap, gl$1.BACK, "back"), _cullFaceMap;
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
funcToString.call(Object);
(function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e10) {
        reject(e10);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e10) {
        reject(e10);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
});
(function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e10) {
        reject(e10);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e10) {
        reject(e10);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
});
const _hoisted_1$d = { class: "flow-graph-zoom" };
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "FlowGraphDesigner",
  emits: ["nodeClick", "nodeAdd", "nodeDeleted", "nodeAdded", "edgeClick", "edgeAdded", "edgeDeleted", "edgeChanged", "edgeConnected"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const flowDesignerModel = injectFlowDesignerModel();
    const onGraphEvents = (graph2) => {
      graph2.on("node:dblclick", ({ e: e10, x: x2, y: y2, node, view }) => {
        e10.stopPropagation();
        emit("nodeClick", node);
      });
      graph2.on("node:added", ({ node, index: index2, options }) => {
        emit("nodeAdded", node);
      });
      graph2.on("node:removed", ({ node, index: index2, options }) => {
        emit("nodeDeleted", node);
      });
      graph2.on("edge:dblclick", ({ e: e10, x: x2, y: y2, edge, view }) => {
        e10.stopPropagation();
        emit("edgeClick", edge);
      });
      graph2.on("edge:added", ({ edge, index: index2, options }) => {
        emit("edgeAdded", edge);
      });
      graph2.on("edge:removed", ({ edge, index: index2, options }) => {
        emit("edgeDeleted", edge);
      });
      graph2.on("edge:changed", ({ edge, options }) => {
        emit("edgeChanged", edge);
      });
      graph2.on("edge:connected", (edgeConnectedArgs) => {
        emit("edgeConnected", edgeConnectedArgs.isNew, edgeConnectedArgs.edge);
      });
    };
    const dagreLayout = new DagreLayout({
      type: "dagre",
      rankdir: "TB",
      nodesepFunc: (d2) => {
        return 100;
      },
      ranksepFunc: (d2) => {
        return 100;
      }
    });
    const layout2 = (nodes, edges) => {
      if (Array.isArray(nodes) && nodes.length > 0 && Array.isArray(edges) && edges.length > 0) {
        if (nodes.some((n2) => n2.x == void 0 || n2.y == void 0)) {
          return dagreLayout.layout({ nodes, edges });
        }
      }
      return { nodes, edges };
    };
    const populateGraph = (graph2) => {
      var _a3, _b3;
      if (flowDesignerModel) {
        flowDesignerModel.value.flowDesignerViewModel.graph = graph2;
      }
      let nodes = (_a3 = flowDesignerModel == null ? void 0 : flowDesignerModel.value.flowDesignerViewModel) == null ? void 0 : _a3.nodeMetadataArray;
      let edges = (_b3 = flowDesignerModel == null ? void 0 : flowDesignerModel.value.flowDesignerViewModel) == null ? void 0 : _b3.edgeMetadataArray;
      const layoutModel = layout2(nodes, edges);
      nodes = layoutModel.nodes;
      edges = layoutModel.edges;
      if (isNullOrUndefinedOrEmptyArray(nodes)) {
        graph2.addNode(createStartNodeMetadata());
      } else {
        nodes == null ? void 0 : nodes.forEach((node) => {
          widthPorts(node);
          if (isStartNode(node)) {
            return;
          }
          widthRemoveButton(node);
        });
        graph2.addNodes(nodes);
        if (edges && edges.length > 0) {
          edges.forEach((edge) => {
            graph2.addEdge(new Shape.Edge(edge));
          });
        }
      }
    };
    const vantisGlobalConfig = injectVantisGlobalConfig();
    const elementPlusGlobalConfig = useGlobalConfig();
    registerFlowNodes(() => {
      if (flowDesignerModel) {
        provideFlowDesignerModel(flowDesignerModel);
      }
      if (vantisGlobalConfig) {
        provideVantisGlobalConfig(vantisGlobalConfig);
      }
      if (elementPlusGlobalConfig) {
        provideGlobalConfig(elementPlusGlobalConfig);
      }
    });
    const { t: t2 } = useLocale();
    let graph;
    onMounted(() => {
      graph = initialGraph(
        document.getElementById("container"),
        document.getElementById("stencil"),
        t2
      );
      onGraphEvents(graph);
      populateGraph(graph);
    });
    const zoomOptions = {
      minScale: 0.2,
      maxScale: 3,
      scaleGrid: 0.1
    };
    const scale = ref(100);
    const zoomOut = () => {
      graph == null ? void 0 : graph.zoom(-0.2, zoomOptions);
      if (scale.value > 20) {
        scale.value = scale.value - 20;
      }
    };
    const zoomIn = () => {
      graph == null ? void 0 : graph.zoom(0.2, zoomOptions);
      if (scale.value < 300) {
        scale.value = scale.value + 20;
      }
    };
    const getGraphData = () => {
      if (!graph) {
        return void 0;
      }
      return { nodes: graph.getNodes(), edges: graph.getEdges() };
    };
    __expose({ getGraphData });
    return (_ctx, _cache) => {
      const _component_el_col = resolveComponent("el-col");
      const _component_el_icon = resolveComponent("el-icon");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_text = resolveComponent("el-text");
      const _component_el_row = resolveComponent("el-row");
      return openBlock(), createBlock(_component_el_row, {
        class: "flow-graph-designer",
        style: { "height": "100%" }
      }, {
        default: withCtx(() => [
          createVNode(_component_el_col, {
            span: 4,
            style: { "background-color": "#00bd7e", "height": "100%" }
          }, {
            default: withCtx(() => _cache[0] || (_cache[0] = [
              createElementVNode("div", { style: { "width": "100%", "height": "100%" } }, [
                createElementVNode("div", { id: "stencil" })
              ], -1)
            ])),
            _: 1,
            __: [0]
          }),
          createVNode(_component_el_col, {
            span: 20,
            style: { "height": "100%" }
          }, {
            default: withCtx(() => [
              _cache[1] || (_cache[1] = createElementVNode("div", {
                id: "container",
                style: { "width": "100%", "height": "100%", "margin-bottom": "10px", "overflow": "auto" }
              }, null, -1)),
              createElementVNode("div", _hoisted_1$d, [
                createVNode(_component_el_button, {
                  onClick: zoomOut,
                  link: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_icon, { size: "20" }, {
                      default: withCtx(() => [
                        createVNode(unref(zoom_out_default))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                createVNode(_component_el_text, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(scale.value) + "%", 1)
                  ]),
                  _: 1
                }),
                createVNode(_component_el_button, {
                  onClick: zoomIn,
                  link: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_icon, { size: "20" }, {
                      default: withCtx(() => [
                        createVNode(unref(zoom_in_default))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1,
            __: [1]
          })
        ]),
        _: 1
      });
    };
  }
});
class GrammarRuleVisitorForUI {
  constructor(grammarRulesRef, conditionOptions, t2) {
    __publicField(this, "_grammarRulesRef");
    __publicField(this, "t");
    __publicField(this, "conditionOptions");
    __publicField(this, "createAddConditionAndGroupButtons", (grammarRule) => {
      if ((grammarRule == null ? void 0 : grammarRule.ruleName) === GrammarRuleNames.RuntimeValue) {
        if (grammarRule.isInvalid()) {
          return;
        }
      }
      if ((grammarRule == null ? void 0 : grammarRule.ruleName) === GrammarRuleNames.ConditionGroup) {
        const leftLogicExpression = grammarRule.condition.left;
        const leftExpression = getLeftExpressionFromBinaryExpression(leftLogicExpression);
        if (leftExpression && leftExpression.ruleName == GrammarRuleNames.RuntimeValue) {
          if (leftExpression.isInvalid()) {
            return;
          }
        }
      }
      const that = this;
      return h$3(ElRow, { class: "condition-button-col" }, () => {
        return h$3(ElCol, { span: 24, style: "text-align:right" }, () => {
          return [
            h$3(ElButton, {
              size: "small",
              onClick: () => {
                if (grammarRule) {
                  const logicalExpression = getAncestorLogicExpression(grammarRule);
                  if (logicalExpression) {
                    const oldParent = logicalExpression.parent;
                    const emptyComparisonExpression = that.createEmptyComparisonExpression();
                    const newLogicalExpression = new LogicalExpression(toRaw(logicalExpression), emptyComparisonExpression, "&&");
                    replaceSelfFromParentOrContainer(logicalExpression, newLogicalExpression, oldParent, that._grammarRulesRef);
                  } else {
                    const root2 = getRoot(grammarRule);
                    this._grammarRulesRef.value = new LogicalExpression(toRaw(root2), that.createEmptyComparisonExpression(), "&&");
                  }
                } else {
                  if (this._grammarRulesRef.value == void 0) {
                    this._grammarRulesRef.value = that.createEmptyComparisonExpression();
                  }
                }
              }
            }, () => this.t("AddCondition")),
            h$3(ElButton, {
              size: "small",
              onClick: () => {
                if (grammarRule) {
                  const logicalExpression = getAncestorLogicExpression(grammarRule);
                  if (logicalExpression) {
                    const oldParent = logicalExpression.parent;
                    const emptyConditionGroupExpression = that.crateEmptyConditionGroup();
                    const newLogicalExpression = new LogicalExpression(toRaw(logicalExpression), emptyConditionGroupExpression, "&&");
                    replaceSelfFromParentOrContainer(logicalExpression, newLogicalExpression, oldParent, that._grammarRulesRef);
                  } else {
                    const root2 = getRoot(grammarRule);
                    this._grammarRulesRef.value = new LogicalExpression(
                      new LogicalExpression(toRaw(root2), void 0, void 0),
                      that.crateEmptyConditionGroup(),
                      "&&"
                    );
                  }
                } else {
                  if (this._grammarRulesRef.value == void 0) {
                    this._grammarRulesRef.value = that.crateEmptyConditionGroup();
                  }
                }
              }
            }, () => this.t("AddGroup"))
          ];
        });
      });
    });
    __publicField(this, "visitBinaryOperatorExpression", (left, right) => {
      const that = this;
      return h$3(ElRow, { gutter: 5, class: "binary-expression-container" }, () => {
        return [
          h$3(ElCol, { span: 7 }, () => that.visitGrammarRule(left)),
          h$3(ElCol, { span: 7 }, () => that.getBinaryOperatorSelect(left.parent)),
          h$3(ElCol, { span: 9 }, () => that.visitGrammarRule(right)),
          h$3(ElCol, { span: 1 }, () => {
            return h$3(ElIcon, {
              size: 12,
              onClick: () => {
                removeSelfFromParentOrContainer(left.parent, that._grammarRulesRef);
              }
            }, () => h$3(delete_default));
          }),
          h$3(ElCol, { span: 24 }, () => {
            return that.createAddConditionAndGroupButtons(left);
          })
        ];
      });
    });
    __publicField(this, "_globalContext", {});
    this._grammarRulesRef = grammarRulesRef;
    this.t = t2;
    this.conditionOptions = conditionOptions;
  }
  getWidgetSchema(names) {
    let conditionOptions = this.conditionOptions;
    let options;
    for (let i2 = 0; i2 < names.length; i2++) {
      options = conditionOptions == null ? void 0 : conditionOptions.find((o2) => o2.value == names[i2]);
      if (options) {
        conditionOptions = options.children;
      }
    }
    return options == null ? void 0 : options.widgetSchema;
  }
  createEmptyComparisonExpression() {
    return new ComparisonExpression(new RuntimeValue([]), new StringExpression(""), "==");
  }
  crateEmptyConditionGroup() {
    return new ConditionGroup(new LogicalExpression(this.createEmptyComparisonExpression(), void 0, void 0));
  }
  visitMain() {
    if (this._grammarRulesRef.value === void 0) {
      return this.createAddConditionAndGroupButtons();
    }
    return this.visitGrammarRule(this._grammarRulesRef.value);
  }
  visitGrammarRule(grammarRule) {
    if (grammarRule == void 0)
      return void 0;
    if (grammarRule.ruleName == void 0)
      return void 0;
    switch (grammarRule.ruleName) {
      case GrammarRuleNames.ConditionGroup:
        return this.visitConditionGroup(grammarRule);
      case GrammarRuleNames.BooleanExpression:
        return this.visitBooleanExpression(grammarRule);
      case GrammarRuleNames.ComparisonExpression:
        return this.visitComparisonExpression(grammarRule);
      case GrammarRuleNames.CustomField:
        return this.visitCustomField(grammarRule);
      case GrammarRuleNames.ExpressionList:
        return this.visitExpressionList(grammarRule);
      case GrammarRuleNames.InExpression:
        return this.visitInExpression(grammarRule);
      case GrammarRuleNames.ContainsExpression:
        return this.visitContainsExpression(grammarRule);
      case GrammarRuleNames.SubsetofExpression:
        return this.visitSubsetofExpression(grammarRule);
      case GrammarRuleNames.logicalExpression:
        return this.visitLogicalExpression(grammarRule);
      case GrammarRuleNames.LogicalNegation:
        return this.visitLogicalNegation(grammarRule);
      case GrammarRuleNames.RuntimeValue:
        return this.visitRuntimeValue(grammarRule);
      case GrammarRuleNames.NullExpression:
      case GrammarRuleNames.NumericExpression:
      case GrammarRuleNames.StringExpression:
        return this.visitConstantExpression(grammarRule);
    }
  }
  visitConditionGroup(conditionGroup) {
    const that = this;
    return h$3(ElRow, () => {
      return [
        h$3(ElCol, { span: 24 }, () => {
          return h$3(ElCard, { class: "condition-group-container" }, {
            default: () => {
              return [
                h$3(
                  "div",
                  { class: "toolbar" },
                  h$3(ElIcon, { class: "close" }, () => {
                    return h$3(close_default, { onClick: () => {
                      removeSelfFromParentOrContainer(conditionGroup, that._grammarRulesRef);
                    } });
                  })
                ),
                that.visitGrammarRule(conditionGroup.condition)
              ];
            }
            // ,
            // footer: () => {
            //   return h(ElLink, {
            //     onClick: () => {
            //       removeSelfFromParentOrContainer(conditionGroup, that._grammarRulesRef)
            //     }
            //   }, that.t('DeleteGroup'))
            // }
          });
        }),
        h$3(ElCol, { span: 24 }, () => {
          return that.createAddConditionAndGroupButtons(conditionGroup);
        })
      ];
    });
  }
  visitLogicalExpression(logicalExpression) {
    const that = this;
    return h$3(ElRow, () => {
      const cols = [];
      let col = h$3(ElCol, { span: 24 }, () => {
        return that.visitGrammarRule(logicalExpression.left);
      });
      cols.push(col);
      if (logicalExpression.logicalOperator && logicalExpression.right) {
        col = h$3(ElCol, { span: 24 }, () => that.getLogicSelect(logicalExpression));
        cols.push(col);
        col = h$3(ElCol, { span: 24 }, () => that.visitGrammarRule(logicalExpression.right));
        cols.push(col);
      }
      return cols;
    });
  }
  visitSubsetofExpression(subsetOfExpression) {
    return this.visitBinaryOperatorExpression(subsetOfExpression.expression, subsetOfExpression.expressionList);
  }
  visitLogicalNegation(logicalExpression) {
    return this.visitGrammarRule(logicalExpression.predicate);
  }
  visitBooleanExpression(booleanExpression) {
    return this.visitConstantExpression(booleanExpression);
  }
  visitComparisonExpression(comparisonExpression) {
    return this.visitBinaryOperatorExpression(comparisonExpression.left, comparisonExpression.right);
  }
  visitCustomField(customField) {
    return h$3("span", "customField not support");
  }
  visitConstantExpression(constantExpression) {
    var _a3;
    const left = tryGetLeftRuntimeValueExpression(constantExpression);
    if (!left) {
      return void 0;
    }
    let fieldSchema = this.getWidgetSchema(left.names);
    if (fieldSchema) {
      fieldSchema = {
        ...fieldSchema,
        __vModel__: void 0,
        modelValue: getConstantExpressionValue(constantExpression),
        "onUpdate:modelValue": (value) => {
          setConstantExpressionValue(constantExpression, value);
        }
      };
      return buildComponent(
        {
          schema: fieldSchema,
          formConfig: {},
          formModel: {},
          emit: (event, ...args) => {
          },
          t: this.t,
          renderMode: RenderMode.simple,
          globalContext: this._globalContext
        }
      );
    } else {
      return h$3("span", (_a3 = getConstantExpressionValue(constantExpression)) == null ? void 0 : _a3.toString());
    }
  }
  visitExpressionList(expressionList) {
    var _a3, _b3;
    let fieldSchema = tryGetWidgetSchemaByBinaryRightExpression(this.conditionOptions, expressionList);
    let modelValue = getExpressionListValue(expressionList);
    const inferType = getInferTypeByWidget(fieldSchema);
    let itemInferType = inferType;
    switch (inferType) {
      case InferType.StringArray:
        itemInferType = InferType.String;
        break;
      case InferType.NumberArray:
        itemInferType = InferType.Number;
        break;
      case InferType.ObjectArray:
        itemInferType = InferType.Object;
        break;
    }
    if (fieldSchema && ((_a3 = fieldSchema.__config__) == null ? void 0 : _a3.dataSource)) {
      return h$3(
        VcDataSource,
        { dataSource: (_b3 = fieldSchema.__config__) == null ? void 0 : _b3.dataSource, lazy: true },
        {
          default: (dataSource) => {
            const load = dataSource.load;
            return h$3(ElSelect, {
              multiple: true,
              modelValue,
              onFocus: () => load(),
              onChange: (value) => {
                if (Array.isArray(value)) {
                  if (value.length == 0) {
                    expressionList.children = [];
                  } else {
                    expressionList.children = value.map((item) => createConstantExpressionByInferType(itemInferType, item));
                  }
                }
              }
            }, {
              default: () => {
                var _a4;
                return (_a4 = dataSource.data) == null ? void 0 : _a4.map((v2) => h$3(ElOption, { key: v2.value, label: v2.label, value: v2.value }));
              }
            });
          }
        }
      );
    }
    const left = tryGetLeftRuntimeValueExpression(expressionList);
    if (!left) {
      return void 0;
    }
    left.name;
    return h$3(ElSelect, {
      multiple: true,
      allowCreate: true,
      filterable: true,
      defaultFirstOption: true,
      modelValue,
      onChange: (value) => {
        if (Array.isArray(value)) {
          if (value.length == 0) {
            expressionList.children = [];
          } else {
            expressionList.children = value.map((item) => createConstantExpressionByInferType(itemInferType, item));
          }
        }
      }
    });
  }
  visitRuntimeValue(runtimeValue) {
    const that = this;
    return h$3(ElCascader, {
      separator: ".",
      filterable: true,
      options: this.conditionOptions,
      modelValue: runtimeValue.names,
      "onUpdate:modelValue": (value) => {
        runtimeValue.name = value.join(",");
        runtimeValue.names = value;
      },
      onChange: () => {
        changeRuntimeValue(runtimeValue, that.conditionOptions);
      }
    });
  }
  getLogicSelect(logicalExpression) {
    return h$3(ElSelect, {
      modelValue: logicalExpression.logicalOperator,
      "onUpdate:modelValue": (value) => {
        logicalExpression.logicalOperator = value;
      }
    }, () => {
      return [
        h$3(ElOption, { label: this.t("And"), value: "&&" }),
        h$3(ElOption, { label: this.t("Or"), value: "||" })
      ];
    });
  }
  getBinaryOperatorSelect(grammarRule) {
    let operators = getBinaryOperatorsByLeft(grammarRule, this.t, this.conditionOptions);
    operators = operators || [];
    const operator = getOperatorNameByGrammarRule(grammarRule);
    const that = this;
    if (operator && !operators.some((op2) => op2.Value == operator)) {
      changeBinaryOperator(grammarRule, operators[0].Value, that.conditionOptions, that._grammarRulesRef);
    }
    return h$3(ElSelect, {
      onChange: (value) => {
        changeBinaryOperator(grammarRule, value, that.conditionOptions, that._grammarRulesRef);
      },
      modelValue: getOperatorNameByGrammarRule(grammarRule)
    }, () => {
      return operators.map((o2) => h$3(ElOption, {
        key: o2.Value,
        label: o2.Name,
        value: o2.Value
      }));
    });
  }
  visitInExpression(inExpression) {
    return this.visitBinaryOperatorExpression(inExpression.expression, inExpression.expressionList);
  }
  visitContainsExpression(containsExpression) {
    return this.visitBinaryOperatorExpression(containsExpression.expression, containsExpression.expressionList);
  }
  static tryGetOtherRuntimeValueFromComparisonExpression(comparisonExpression, rule) {
    const otherRule = comparisonExpression.left.id == rule.id ? comparisonExpression.right : comparisonExpression.left;
    if (otherRule.ruleName == GrammarRuleNames.RuntimeValue) {
      return otherRule;
    }
    if (otherRule.ruleName == GrammarRuleNames.LogicalNegation) ;
    return void 0;
  }
}
const _hoisted_1$c = { style: { "width": "100%" } };
const _hoisted_2$5 = { class: "affixContainer" };
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "ConditionEditor",
  props: /* @__PURE__ */ mergeModels({
    conditionOptions: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const model = useModel(__props, "modelValue");
    const grammarRule = ref();
    const { t: t2 } = useLocale();
    const tempGrammarRule = ref();
    const localeConditionOptions = computed(() => {
      const translate2 = (options) => {
        return options.map((item) => ({
          ...item,
          label: t2(item.label),
          children: item.children ? translate2(item.children) : void 0
        }));
      };
      return translate2(props.conditionOptions);
    });
    const conditionNode = computed(() => new GrammarRuleVisitorForUI(tempGrammarRule, localeConditionOptions.value, t2).visitMain());
    let prevModelValue = model.value;
    const initialize = async () => {
      if (isNullOrUndefinedOrWhiteSpace(model.value)) {
        grammarRule.value = void 0;
        prevModelValue = void 0;
        return;
      }
      if (grammarRule.value === void 0 || prevModelValue != model.value) {
        grammarRule.value = getGrammarRule(model.value);
        prevModelValue = model.value;
      }
    };
    watch(grammarRule, async () => {
      if (grammarRule.value === void 0) {
        conditionText.value = void 0;
        return;
      }
      const visitor = new GrammarRuleVisitorForDisplay(localeConditionOptions.value, t2);
      conditionText.value = await visitor.visitGrammarRule(grammarRule.value);
    }, { deep: true });
    watch(model, initialize, { immediate: true });
    const conditionVisible = ref(false);
    const { formItem } = useFormItem();
    const confirm = () => {
      if (!tempGrammarRule.value) {
        model.value = "";
        prevModelValue = model.value;
      } else {
        grammarRule.value = tempGrammarRule.value;
        try {
          model.value = getConditionStringByRule(grammarRule.value);
          prevModelValue = model.value;
        } catch (error) {
          console.error(error);
        }
      }
      conditionVisible.value = false;
      if (formItem) {
        formItem.validate("change");
      }
    };
    const cancel = () => {
      conditionVisible.value = false;
      tempGrammarRule.value = void 0;
      if (formItem) {
        formItem.validate("blur");
      }
    };
    const editCondition = () => {
      if (grammarRule.value === void 0) {
        tempGrammarRule.value = void 0;
      } else {
        tempGrammarRule.value = grammarRule.value.deepClone();
      }
      conditionVisible.value = true;
    };
    const tempConditionText = ref();
    const conditionText = ref();
    watch(tempGrammarRule, async () => {
      if (tempGrammarRule.value === void 0) {
        tempConditionText.value = void 0;
        return;
      }
      tempConditionText.value = await getFriendlyConditionStringByRule(tempGrammarRule.value, localeConditionOptions.value, t2);
    }, { deep: true });
    return (_ctx, _cache) => {
      const _component_el_button = resolveComponent("el-button");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_affix = resolveComponent("el-affix");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_main = resolveComponent("el-main");
      const _component_el_footer = resolveComponent("el-footer");
      const _component_el_container = resolveComponent("el-container");
      const _component_el_dialog = resolveComponent("el-dialog");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$c, [
          createElementVNode("div", {
            class: "condition-tool-bar",
            onClick: withModifiers(editCondition, ["stop"])
          }, [
            createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              icon: unref(edit_default)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("Edit")), 1)
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          createElementVNode("div", {
            class: "condition-text",
            onClick: withModifiers(editCondition, ["stop"])
          }, [
            createElementVNode("p", null, toDisplayString(conditionText.value), 1)
          ])
        ]),
        createVNode(_component_el_dialog, {
          modelValue: conditionVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => conditionVisible.value = $event),
          "append-to-body": true,
          title: unref(t2)("ConditionSetting"),
          top: "2vh",
          "before-close": cancel
        }, {
          default: withCtx(() => [
            createVNode(_component_el_container, { class: "condition-dialog" }, {
              default: withCtx(() => [
                createVNode(_component_el_main, { class: "condition-dialog__body" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_2$5, [
                      createVNode(_component_el_affix, {
                        target: ".affixContainer",
                        offset: 20,
                        style: { "margin-bottom": "10px" }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_input, {
                            autosize: { minRows: 2, maxRows: 10 },
                            type: "textarea",
                            "model-value": tempConditionText.value,
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }),
                      createVNode(_component_el_form, { "status-icon": false }, {
                        default: withCtx(() => [
                          createVNode(_component_el_form_item, null, {
                            default: withCtx(() => [
                              (openBlock(), createBlock(resolveDynamicComponent(conditionNode.value)))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                createVNode(_component_el_footer, { class: "condition-dialog__footer" }, {
                  default: withCtx(() => [
                    createVNode(_component_el_button, {
                      type: "primary",
                      onClick: confirm
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("Confirm")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_button, { onClick: cancel }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("Cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ], 64);
    };
  }
});
const component$3 = /* @__PURE__ */ _export_sfc$1(_sfc_main$r, [["__scopeId", "data-v-3f1e6b30"]]);
var TriggerTimingConstants = /* @__PURE__ */ ((TriggerTimingConstants2) => {
  TriggerTimingConstants2["AutoFinished"] = "NodeInstanceAutoFinishedEvent";
  TriggerTimingConstants2["Finished"] = "NodeInstanceFinishedEvent";
  TriggerTimingConstants2["Paused"] = "NodeInstancePausedEvent";
  TriggerTimingConstants2["Saved"] = "NodeInstanceSavedEvent";
  TriggerTimingConstants2["Waited"] = "NodeInstanceWaitedEvent";
  return TriggerTimingConstants2;
})(TriggerTimingConstants || {});
const triggerTimingArray = [
  "NodeInstanceWaitedEvent",
  "NodeInstanceSavedEvent",
  "NodeInstanceAutoFinishedEvent",
  "NodeInstanceFinishedEvent"
  /* Finished */
  //TriggerTimingConstants.Paused, 这个状态前端暂时没有支持，先隐藏
];
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "TriggerTimingSelector",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const { t: t2 } = useLocale();
    const model = useModel(__props, "modelValue");
    return (_ctx, _cache) => {
      const _component_el_radio_button = resolveComponent("el-radio-button");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      return openBlock(), createBlock(_component_el_radio_group, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value = $event)
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(triggerTimingArray), (value) => {
            return openBlock(), createBlock(_component_el_radio_button, {
              value,
              label: unref(t2)(value)
            }, null, 8, ["value", "label"]);
          }), 256))
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
var e6, t, n, r, o, i, a, s, u, l, c, d, f, p, h, g, v, m, y = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function b(e10) {
  return e10 && e10.__esModule && Object.prototype.hasOwnProperty.call(e10, "default") ? e10.default : e10;
}
function E(e10) {
  if (Object.prototype.hasOwnProperty.call(e10, "__esModule")) return e10;
  var t2 = e10.default;
  if ("function" == typeof t2) {
    var n2 = function e11() {
      var n3 = false;
      try {
        n3 = this instanceof e11;
      } catch {
      }
      return n3 ? Reflect.construct(t2, arguments, this.constructor) : t2.apply(this, arguments);
    };
    n2.prototype = t2.prototype;
  } else n2 = {};
  return Object.defineProperty(n2, "__esModule", { value: true }), Object.keys(e10).forEach(function(t3) {
    var r3 = Object.getOwnPropertyDescriptor(e10, t3);
    Object.defineProperty(n2, t3, r3.get ? r3 : { enumerable: true, get: function() {
      return e10[t3];
    } });
  }), n2;
}
function C() {
  return t ? e6 : (t = 1, e6 = function(e10) {
    try {
      return !!e10();
    } catch (e11) {
      return true;
    }
  });
}
function w() {
  if (r) return n;
  r = 1;
  var e10 = C();
  return n = !e10(function() {
    var e11 = (function() {
    }).bind();
    return "function" != typeof e11 || e11.hasOwnProperty("prototype");
  });
}
function D() {
  if (i) return o;
  i = 1;
  var e10 = w(), t2 = Function.prototype, n2 = t2.call, r3 = e10 && t2.bind.bind(n2, n2);
  return o = e10 ? r3 : function(e11) {
    return function() {
      return n2.apply(e11, arguments);
    };
  }, o;
}
function S() {
  if (s) return a;
  s = 1;
  var e10 = D(), t2 = e10({}.toString), n2 = e10("".slice);
  return a = function(e11) {
    return n2(t2(e11), 8, -1);
  };
}
function A() {
  if (l) return u;
  l = 1;
  var e10 = D(), t2 = C(), n2 = S(), r3 = Object, o2 = e10("".split);
  return u = t2(function() {
    return !r3("z").propertyIsEnumerable(0);
  }) ? function(e11) {
    return "String" === n2(e11) ? o2(e11, "") : r3(e11);
  } : r3;
}
function x() {
  return d ? c : (d = 1, c = function(e10) {
    return null == e10;
  });
}
function O() {
  if (p) return f;
  p = 1;
  var e10 = x(), t2 = TypeError;
  return f = function(n2) {
    if (e10(n2)) throw new t2("Can't call method on " + n2);
    return n2;
  };
}
function N() {
  if (g) return h;
  g = 1;
  var e10 = A(), t2 = O();
  return h = function(n2) {
    return e10(t2(n2));
  };
}
function B() {
  if (m) return v;
  m = 1;
  var e10 = function(e11) {
    return e11 && e11.Math === Math && e11;
  };
  return v = e10("object" == typeof globalThis && globalThis) || e10("object" == typeof window && window) || e10("object" == typeof self && self) || e10("object" == typeof y && y) || e10("object" == typeof v && v) || /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")();
}
var T, k, F, I, P, _, R, L, M, j, H, z, $, U, V, W, G, q, K, Y, X, Z, J, Q, ee, te, ne, re, oe, ie = { exports: {} };
function ae() {
  return k ? T : (k = 1, T = false);
}
function se() {
  if (I) return F;
  I = 1;
  var e10 = B(), t2 = Object.defineProperty;
  return F = function(n2, r3) {
    try {
      t2(e10, n2, { value: r3, configurable: true, writable: true });
    } catch (t3) {
      e10[n2] = r3;
    }
    return r3;
  };
}
function ue() {
  if (P) return ie.exports;
  P = 1;
  var e10 = ae(), t2 = B(), n2 = se(), r3 = "__core-js_shared__", o2 = ie.exports = t2[r3] || n2(r3, {});
  return (o2.versions || (o2.versions = [])).push({ version: "3.47.0", mode: e10 ? "pure" : "global", copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)", license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE", source: "https://github.com/zloirock/core-js" }), ie.exports;
}
function le() {
  if (R) return _;
  R = 1;
  var e10 = ue();
  return _ = function(t2, n2) {
    return e10[t2] || (e10[t2] = n2 || {});
  };
}
function ce() {
  if (M) return L;
  M = 1;
  var e10 = O(), t2 = Object;
  return L = function(n2) {
    return t2(e10(n2));
  };
}
function de() {
  if (H) return j;
  H = 1;
  var e10 = D(), t2 = ce(), n2 = e10({}.hasOwnProperty);
  return j = Object.hasOwn || function(e11, r3) {
    return n2(t2(e11), r3);
  };
}
function fe() {
  if ($) return z;
  $ = 1;
  var e10 = D(), t2 = 0, n2 = Math.random(), r3 = e10(1.1.toString);
  return z = function(e11) {
    return "Symbol(" + (void 0 === e11 ? "" : e11) + ")_" + r3(++t2 + n2, 36);
  };
}
function pe() {
  if (G) return W;
  G = 1;
  var e10, t2, n2 = B(), r3 = function() {
    if (V) return U;
    V = 1;
    var e11 = B().navigator, t3 = e11 && e11.userAgent;
    return U = t3 ? String(t3) : "";
  }(), o2 = n2.process, i2 = n2.Deno, a2 = o2 && o2.versions || i2 && i2.version, s2 = a2 && a2.v8;
  return s2 && (t2 = (e10 = s2.split("."))[0] > 0 && e10[0] < 4 ? 1 : +(e10[0] + e10[1])), !t2 && r3 && (!(e10 = r3.match(/Edge\/(\d+)/)) || e10[1] >= 74) && (e10 = r3.match(/Chrome\/(\d+)/)) && (t2 = +e10[1]), W = t2;
}
function he() {
  if (K) return q;
  K = 1;
  var e10 = pe(), t2 = C(), n2 = B().String;
  return q = !!Object.getOwnPropertySymbols && !t2(function() {
    var t3 = Symbol("symbol detection");
    return !n2(t3) || !(Object(t3) instanceof Symbol) || !Symbol.sham && e10 && e10 < 41;
  }), q;
}
function ge() {
  if (X) return Y;
  X = 1;
  var e10 = he();
  return Y = e10 && !Symbol.sham && "symbol" == typeof Symbol.iterator;
}
function ve() {
  if (J) return Z;
  J = 1;
  var e10 = B(), t2 = le(), n2 = de(), r3 = fe(), o2 = he(), i2 = ge(), a2 = e10.Symbol, s2 = t2("wks"), u2 = i2 ? a2.for || a2 : a2 && a2.withoutSetter || r3;
  return Z = function(e11) {
    return n2(s2, e11) || (s2[e11] = o2 && n2(a2, e11) ? a2[e11] : u2("Symbol." + e11)), s2[e11];
  };
}
function me() {
  if (ee) return Q;
  ee = 1;
  var e10 = "object" == typeof document && document.all;
  return Q = void 0 === e10 && void 0 !== e10 ? function(t2) {
    return "function" == typeof t2 || t2 === e10;
  } : function(e11) {
    return "function" == typeof e11;
  };
}
function ye() {
  if (ne) return te;
  ne = 1;
  var e10 = me();
  return te = function(t2) {
    return "object" == typeof t2 ? null !== t2 : e10(t2);
  };
}
function be() {
  if (oe) return re;
  oe = 1;
  var e10 = ye(), t2 = String, n2 = TypeError;
  return re = function(r3) {
    if (e10(r3)) return r3;
    throw new n2(t2(r3) + " is not an object");
  };
}
var Ee, Ce, we, De, Se = {};
function Ae() {
  if (Ce) return Ee;
  Ce = 1;
  var e10 = C();
  return Ee = !e10(function() {
    return 7 !== Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1];
  });
}
function xe() {
  if (De) return we;
  De = 1;
  var e10 = Ae(), t2 = C();
  return we = e10 && t2(function() {
    return 42 !== Object.defineProperty(function() {
    }, "prototype", { value: 42, writable: false }).prototype;
  });
}
var Oe, Ne, Be, Te, ke, Fe, Ie, Pe, _e2, Re, Le, Me, je, He, ze, $e, Ue, Ve, We, Ge, qe, Ke, Ye, Xe, Ze, Je, Qe, et, tt, nt, rt, ot, it, at, st, ut, lt, ct, dt, ft, pt, ht, gt, vt, mt, yt, bt, Et, Ct, wt, Dt, St, At, xt, Ot, Nt, Bt, Tt, kt, Ft, It, Pt, _t, Rt, Lt = {};
function Mt() {
  if (Ne) return Oe;
  Ne = 1;
  var e10 = B(), t2 = ye(), n2 = e10.document, r3 = t2(n2) && t2(n2.createElement);
  return Oe = function(e11) {
    return r3 ? n2.createElement(e11) : {};
  };
}
function jt() {
  if (Te) return Be;
  Te = 1;
  var e10 = Ae(), t2 = C(), n2 = Mt();
  return Be = !e10 && !t2(function() {
    return 7 !== Object.defineProperty(n2("div"), "a", { get: function() {
      return 7;
    } }).a;
  });
}
function Ht() {
  if (Fe) return ke;
  Fe = 1;
  var e10 = w(), t2 = Function.prototype.call;
  return ke = e10 ? t2.bind(t2) : function() {
    return t2.apply(t2, arguments);
  }, ke;
}
function zt() {
  if (Pe) return Ie;
  Pe = 1;
  var e10 = B(), t2 = me();
  return Ie = function(n2, r3) {
    return arguments.length < 2 ? (o2 = e10[n2], t2(o2) ? o2 : void 0) : e10[n2] && e10[n2][r3];
    var o2;
  }, Ie;
}
function $t() {
  if (Re) return _e2;
  Re = 1;
  var e10 = D();
  return _e2 = e10({}.isPrototypeOf);
}
function Ut() {
  if (Me) return Le;
  Me = 1;
  var e10 = zt(), t2 = me(), n2 = $t(), r3 = ge(), o2 = Object;
  return Le = r3 ? function(e11) {
    return "symbol" == typeof e11;
  } : function(r4) {
    var i2 = e10("Symbol");
    return t2(i2) && n2(i2.prototype, o2(r4));
  };
}
function Vt() {
  if (He) return je;
  He = 1;
  var e10 = String;
  return je = function(t2) {
    try {
      return e10(t2);
    } catch (e11) {
      return "Object";
    }
  };
}
function Wt() {
  if ($e) return ze;
  $e = 1;
  var e10 = me(), t2 = Vt(), n2 = TypeError;
  return ze = function(r3) {
    if (e10(r3)) return r3;
    throw new n2(t2(r3) + " is not a function");
  };
}
function Gt() {
  if (Ve) return Ue;
  Ve = 1;
  var e10 = Wt(), t2 = x();
  return Ue = function(n2, r3) {
    var o2 = n2[r3];
    return t2(o2) ? void 0 : e10(o2);
  }, Ue;
}
function qt() {
  if (Ke) return qe;
  Ke = 1;
  var e10 = Ht(), t2 = ye(), n2 = Ut(), r3 = Gt(), o2 = function() {
    if (Ge) return We;
    Ge = 1;
    var e11 = Ht(), t3 = me(), n3 = ye(), r4 = TypeError;
    return We = function(o3, i3) {
      var a3, s3;
      if ("string" === i3 && t3(a3 = o3.toString) && !n3(s3 = e11(a3, o3))) return s3;
      if (t3(a3 = o3.valueOf) && !n3(s3 = e11(a3, o3))) return s3;
      if ("string" !== i3 && t3(a3 = o3.toString) && !n3(s3 = e11(a3, o3))) return s3;
      throw new r4("Can't convert object to primitive value");
    }, We;
  }(), i2 = ve(), a2 = TypeError, s2 = i2("toPrimitive");
  return qe = function(i3, u2) {
    if (!t2(i3) || n2(i3)) return i3;
    var l2, c3 = r3(i3, s2);
    if (c3) {
      if (void 0 === u2 && (u2 = "default"), l2 = e10(c3, i3, u2), !t2(l2) || n2(l2)) return l2;
      throw new a2("Can't convert object to primitive value");
    }
    return void 0 === u2 && (u2 = "number"), o2(i3, u2);
  };
}
function Kt() {
  if (Xe) return Ye;
  Xe = 1;
  var e10 = qt(), t2 = Ut();
  return Ye = function(n2) {
    var r3 = e10(n2, "string");
    return t2(r3) ? r3 : r3 + "";
  };
}
function Yt() {
  if (Ze) return Lt;
  Ze = 1;
  var e10 = Ae(), t2 = jt(), n2 = xe(), r3 = be(), o2 = Kt(), i2 = TypeError, a2 = Object.defineProperty, s2 = Object.getOwnPropertyDescriptor, u2 = "enumerable", l2 = "configurable", c3 = "writable";
  return Lt.f = e10 ? n2 ? function(e11, t3, n3) {
    if (r3(e11), t3 = o2(t3), r3(n3), "function" == typeof e11 && "prototype" === t3 && "value" in n3 && c3 in n3 && !n3[c3]) {
      var i3 = s2(e11, t3);
      i3 && i3[c3] && (e11[t3] = n3.value, n3 = { configurable: l2 in n3 ? n3[l2] : i3[l2], enumerable: u2 in n3 ? n3[u2] : i3[u2], writable: false });
    }
    return a2(e11, t3, n3);
  } : a2 : function(e11, n3, s3) {
    if (r3(e11), n3 = o2(n3), r3(s3), t2) try {
      return a2(e11, n3, s3);
    } catch (e12) {
    }
    if ("get" in s3 || "set" in s3) throw new i2("Accessors not supported");
    return "value" in s3 && (e11[n3] = s3.value), e11;
  }, Lt;
}
function Xt() {
  if (tt) return et;
  tt = 1;
  var e10 = function() {
    if (Qe) return Je;
    Qe = 1;
    var e11 = Math.ceil, t2 = Math.floor;
    return Je = Math.trunc || function(n2) {
      var r3 = +n2;
      return (r3 > 0 ? t2 : e11)(r3);
    }, Je;
  }();
  return et = function(t2) {
    var n2 = +t2;
    return n2 != n2 || 0 === n2 ? 0 : e10(n2);
  };
}
function Zt() {
  if (it) return ot;
  it = 1;
  var e10 = Xt(), t2 = Math.min;
  return ot = function(n2) {
    var r3 = e10(n2);
    return r3 > 0 ? t2(r3, 9007199254740991) : 0;
  };
}
function Jt() {
  if (st) return at;
  st = 1;
  var e10 = Zt();
  return at = function(t2) {
    return e10(t2.length);
  };
}
function Qt() {
  if (lt) return ut;
  lt = 1;
  var e10 = N(), t2 = function() {
    if (rt) return nt;
    rt = 1;
    var e11 = Xt(), t3 = Math.max, n3 = Math.min;
    return nt = function(r4, o2) {
      var i2 = e11(r4);
      return i2 < 0 ? t3(i2 + o2, 0) : n3(i2, o2);
    }, nt;
  }(), n2 = Jt(), r3 = function(r4) {
    return function(o2, i2, a2) {
      var s2 = e10(o2), u2 = n2(s2);
      if (0 === u2) return !r4 && -1;
      var l2, c3 = t2(a2, u2);
      if (r4 && i2 != i2) {
        for (; u2 > c3; ) if ((l2 = s2[c3++]) != l2) return true;
      } else for (; u2 > c3; c3++) if ((r4 || c3 in s2) && s2[c3] === i2) return r4 || c3 || 0;
      return !r4 && -1;
    };
  };
  return ut = { includes: r3(true), indexOf: r3(false) };
}
function en() {
  return dt ? ct : (dt = 1, ct = {});
}
function tn() {
  if (pt) return ft;
  pt = 1;
  var e10 = D(), t2 = de(), n2 = N(), r3 = Qt().indexOf, o2 = en(), i2 = e10([].push);
  return ft = function(e11, a2) {
    var s2, u2 = n2(e11), l2 = 0, c3 = [];
    for (s2 in u2) !t2(o2, s2) && t2(u2, s2) && i2(c3, s2);
    for (; a2.length > l2; ) t2(u2, s2 = a2[l2++]) && (~r3(c3, s2) || i2(c3, s2));
    return c3;
  }, ft;
}
function nn() {
  return gt ? ht : (gt = 1, ht = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]);
}
function rn() {
  if (yt) return Se;
  yt = 1;
  var e10 = Ae(), t2 = xe(), n2 = Yt(), r3 = be(), o2 = N(), i2 = function() {
    if (mt) return vt;
    mt = 1;
    var e11 = tn(), t3 = nn();
    return vt = Object.keys || function(n3) {
      return e11(n3, t3);
    }, vt;
  }();
  return Se.f = e10 && !t2 ? Object.defineProperties : function(e11, t3) {
    r3(e11);
    for (var a2, s2 = o2(t3), u2 = i2(t3), l2 = u2.length, c3 = 0; l2 > c3; ) n2.f(e11, a2 = u2[c3++], s2[a2]);
    return e11;
  }, Se;
}
function on() {
  if (wt) return Ct;
  wt = 1;
  var e10 = le(), t2 = fe(), n2 = e10("keys");
  return Ct = function(e11) {
    return n2[e11] || (n2[e11] = t2(e11));
  };
}
function an() {
  if (St) return Dt;
  St = 1;
  var e10, t2 = be(), n2 = rn(), r3 = nn(), o2 = en(), i2 = function() {
    if (Et) return bt;
    Et = 1;
    var e11 = zt();
    return bt = e11("document", "documentElement");
  }(), a2 = Mt(), s2 = on(), u2 = "prototype", l2 = "script", c3 = s2("IE_PROTO"), d2 = function() {
  }, f2 = function(e11) {
    return "<" + l2 + ">" + e11 + "</" + l2 + ">";
  }, p2 = function(e11) {
    e11.write(f2("")), e11.close();
    var t3 = e11.parentWindow.Object;
    return e11 = null, t3;
  }, h2 = function() {
    try {
      e10 = new ActiveXObject("htmlfile");
    } catch (e11) {
    }
    var t3, n3, o3;
    h2 = "undefined" != typeof document ? document.domain && e10 ? p2(e10) : (n3 = a2("iframe"), o3 = "java" + l2 + ":", n3.style.display = "none", i2.appendChild(n3), n3.src = String(o3), (t3 = n3.contentWindow.document).open(), t3.write(f2("document.F=Object")), t3.close(), t3.F) : p2(e10);
    for (var s3 = r3.length; s3--; ) delete h2[u2][r3[s3]];
    return h2();
  };
  return o2[c3] = true, Dt = Object.create || function(e11, r4) {
    var o3;
    return null !== e11 ? (d2[u2] = t2(e11), o3 = new d2(), d2[u2] = null, o3[c3] = e11) : o3 = h2(), void 0 === r4 ? o3 : n2.f(o3, r4);
  }, Dt;
}
function sn() {
  return Nt ? Ot : (Nt = 1, Ot = {});
}
function un() {
  return Ft ? kt : (Ft = 1, kt = function(e10, t2) {
    return { enumerable: !(1 & e10), configurable: !(2 & e10), writable: !(4 & e10), value: t2 };
  });
}
function ln() {
  if (Pt) return It;
  Pt = 1;
  var e10 = Ae(), t2 = Yt(), n2 = un();
  return It = e10 ? function(e11, r3, o2) {
    return t2.f(e11, r3, n2(1, o2));
  } : function(e11, t3, n3) {
    return e11[t3] = n3, e11;
  };
}
function cn() {
  if (Rt) return _t;
  Rt = 1;
  var e10, t2, n2, r3 = function() {
    if (Tt) return Bt;
    Tt = 1;
    var e11 = B(), t3 = me(), n3 = e11.WeakMap;
    return Bt = t3(n3) && /native code/.test(String(n3));
  }(), o2 = B(), i2 = ye(), a2 = ln(), s2 = de(), u2 = ue(), l2 = on(), c3 = en(), d2 = "Object already initialized", f2 = o2.TypeError, p2 = o2.WeakMap;
  if (r3 || u2.state) {
    var h2 = u2.state || (u2.state = new p2());
    h2.get = h2.get, h2.has = h2.has, h2.set = h2.set, e10 = function(e11, t3) {
      if (h2.has(e11)) throw new f2(d2);
      return t3.facade = e11, h2.set(e11, t3), t3;
    }, t2 = function(e11) {
      return h2.get(e11) || {};
    }, n2 = function(e11) {
      return h2.has(e11);
    };
  } else {
    var g2 = l2("state");
    c3[g2] = true, e10 = function(e11, t3) {
      if (s2(e11, g2)) throw new f2(d2);
      return t3.facade = e11, a2(e11, g2, t3), t3;
    }, t2 = function(e11) {
      return s2(e11, g2) ? e11[g2] : {};
    }, n2 = function(e11) {
      return s2(e11, g2);
    };
  }
  return _t = { set: e10, get: t2, has: n2, enforce: function(r4) {
    return n2(r4) ? t2(r4) : e10(r4, {});
  }, getterFor: function(e11) {
    return function(n3) {
      var r4;
      if (!i2(n3) || (r4 = t2(n3)).type !== e11) throw new f2("Incompatible receiver, " + e11 + " required");
      return r4;
    };
  } };
}
var dn, fn, pn = {}, hn = {};
function gn() {
  if (fn) return pn;
  fn = 1;
  var e10 = Ae(), t2 = Ht(), n2 = function() {
    if (dn) return hn;
    dn = 1;
    var e11 = {}.propertyIsEnumerable, t3 = Object.getOwnPropertyDescriptor, n3 = t3 && !e11.call({ 1: 2 }, 1);
    return hn.f = n3 ? function(e12) {
      var n4 = t3(this, e12);
      return !!n4 && n4.enumerable;
    } : e11, hn;
  }(), r3 = un(), o2 = N(), i2 = Kt(), a2 = de(), s2 = jt(), u2 = Object.getOwnPropertyDescriptor;
  return pn.f = e10 ? u2 : function(e11, l2) {
    if (e11 = o2(e11), l2 = i2(l2), s2) try {
      return u2(e11, l2);
    } catch (e12) {
    }
    if (a2(e11, l2)) return r3(!t2(n2.f, e11, l2), e11[l2]);
  }, pn;
}
var vn, mn, yn, bn, En, Cn, wn, Dn = { exports: {} };
function Sn() {
  if (mn) return vn;
  mn = 1;
  var e10 = Ae(), t2 = de(), n2 = Function.prototype, r3 = e10 && Object.getOwnPropertyDescriptor, o2 = t2(n2, "name"), i2 = o2 && "something" === (function() {
  }).name, a2 = o2 && (!e10 || e10 && r3(n2, "name").configurable);
  return vn = { EXISTS: o2, PROPER: i2, CONFIGURABLE: a2 };
}
function An() {
  if (bn) return yn;
  bn = 1;
  var e10 = D(), t2 = me(), n2 = ue(), r3 = e10(Function.toString);
  return t2(n2.inspectSource) || (n2.inspectSource = function(e11) {
    return r3(e11);
  }), yn = n2.inspectSource;
}
function xn() {
  if (En) return Dn.exports;
  En = 1;
  var e10 = D(), t2 = C(), n2 = me(), r3 = de(), o2 = Ae(), i2 = Sn().CONFIGURABLE, a2 = An(), s2 = cn(), u2 = s2.enforce, l2 = s2.get, c3 = String, d2 = Object.defineProperty, f2 = e10("".slice), p2 = e10("".replace), h2 = e10([].join), g2 = o2 && !t2(function() {
    return 8 !== d2(function() {
    }, "length", { value: 8 }).length;
  }), v2 = String(String).split("String"), m2 = Dn.exports = function(e11, t3, n3) {
    "Symbol(" === f2(c3(t3), 0, 7) && (t3 = "[" + p2(c3(t3), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n3 && n3.getter && (t3 = "get " + t3), n3 && n3.setter && (t3 = "set " + t3), (!r3(e11, "name") || i2 && e11.name !== t3) && (o2 ? d2(e11, "name", { value: t3, configurable: true }) : e11.name = t3), g2 && n3 && r3(n3, "arity") && e11.length !== n3.arity && d2(e11, "length", { value: n3.arity });
    try {
      n3 && r3(n3, "constructor") && n3.constructor ? o2 && d2(e11, "prototype", { writable: false }) : e11.prototype && (e11.prototype = void 0);
    } catch (e12) {
    }
    var a3 = u2(e11);
    return r3(a3, "source") || (a3.source = h2(v2, "string" == typeof t3 ? t3 : "")), e11;
  };
  return Function.prototype.toString = m2(function() {
    return n2(this) && l2(this).source || a2(this);
  }, "toString"), Dn.exports;
}
function On() {
  if (wn) return Cn;
  wn = 1;
  var e10 = me(), t2 = Yt(), n2 = xn(), r3 = se();
  return Cn = function(o2, i2, a2, s2) {
    s2 || (s2 = {});
    var u2 = s2.enumerable, l2 = void 0 !== s2.name ? s2.name : i2;
    if (e10(a2) && n2(a2, l2, s2), s2.global) u2 ? o2[i2] = a2 : r3(i2, a2);
    else {
      try {
        s2.unsafe ? o2[i2] && (u2 = true) : delete o2[i2];
      } catch (e11) {
      }
      u2 ? o2[i2] = a2 : t2.f(o2, i2, { value: a2, enumerable: false, configurable: !s2.nonConfigurable, writable: !s2.nonWritable });
    }
    return o2;
  }, Cn;
}
var Nn, Bn = {};
var Tn, kn, Fn, In, Pn, _n2, Rn, Ln, Mn, jn, Hn, zn, $n, Un, Vn, Wn, Gn, qn, Kn, Yn, Xn, Zn, Jn, Qn, er, tr, nr, rr, or, ir, ar, sr, ur, lr = {};
function cr() {
  if (Fn) return kn;
  Fn = 1;
  var e10 = zt(), t2 = D(), n2 = function() {
    if (Nn) return Bn;
    Nn = 1;
    var e11 = tn(), t3 = nn().concat("length", "prototype");
    return Bn.f = Object.getOwnPropertyNames || function(n3) {
      return e11(n3, t3);
    }, Bn;
  }(), r3 = (Tn || (Tn = 1, lr.f = Object.getOwnPropertySymbols), lr), o2 = be(), i2 = t2([].concat);
  return kn = e10("Reflect", "ownKeys") || function(e11) {
    var t3 = n2.f(o2(e11)), a2 = r3.f;
    return a2 ? i2(t3, a2(e11)) : t3;
  }, kn;
}
function dr() {
  if (Pn) return In;
  Pn = 1;
  var e10 = de(), t2 = cr(), n2 = gn(), r3 = Yt();
  return In = function(o2, i2, a2) {
    for (var s2 = t2(i2), u2 = r3.f, l2 = n2.f, c3 = 0; c3 < s2.length; c3++) {
      var d2 = s2[c3];
      e10(o2, d2) || a2 && e10(a2, d2) || u2(o2, d2, l2(i2, d2));
    }
  }, In;
}
function fr() {
  if (Mn) return Ln;
  Mn = 1;
  var e10 = B(), t2 = gn().f, n2 = ln(), r3 = On(), o2 = se(), i2 = dr(), a2 = function() {
    if (Rn) return _n2;
    Rn = 1;
    var e11 = C(), t3 = me(), n3 = /#|\.prototype\./, r4 = function(n4, r5) {
      var u2 = i3[o3(n4)];
      return u2 === s2 || u2 !== a3 && (t3(r5) ? e11(r5) : !!r5);
    }, o3 = r4.normalize = function(e12) {
      return String(e12).replace(n3, ".").toLowerCase();
    }, i3 = r4.data = {}, a3 = r4.NATIVE = "N", s2 = r4.POLYFILL = "P";
    return _n2 = r4;
  }();
  return Ln = function(s2, u2) {
    var l2, c3, d2, f2, p2, h2 = s2.target, g2 = s2.global, v2 = s2.stat;
    if (l2 = g2 ? e10 : v2 ? e10[h2] || o2(h2, {}) : e10[h2] && e10[h2].prototype) for (c3 in u2) {
      if (f2 = u2[c3], d2 = s2.dontCallGetSet ? (p2 = t2(l2, c3)) && p2.value : l2[c3], !a2(g2 ? c3 : h2 + (v2 ? "." : "#") + c3, s2.forced) && void 0 !== d2) {
        if (typeof f2 == typeof d2) continue;
        i2(f2, d2);
      }
      (s2.sham || d2 && d2.sham) && n2(f2, "sham", true), r3(l2, c3, f2, s2);
    }
  };
}
function pr() {
  if ($n) return zn;
  $n = 1;
  var e10 = de(), t2 = me(), n2 = ce(), r3 = on(), o2 = function() {
    if (Hn) return jn;
    Hn = 1;
    var e11 = C();
    return jn = !e11(function() {
      function e12() {
      }
      return e12.prototype.constructor = null, Object.getPrototypeOf(new e12()) !== e12.prototype;
    }), jn;
  }(), i2 = r3("IE_PROTO"), a2 = Object, s2 = a2.prototype;
  return zn = o2 ? a2.getPrototypeOf : function(r4) {
    var o3 = n2(r4);
    if (e10(o3, i2)) return o3[i2];
    var u2 = o3.constructor;
    return t2(u2) && o3 instanceof u2 ? u2.prototype : o3 instanceof a2 ? s2 : null;
  }, zn;
}
function hr() {
  if (Vn) return Un;
  Vn = 1;
  var e10, t2, n2, r3 = C(), o2 = me(), i2 = ye(), a2 = an(), s2 = pr(), u2 = On(), l2 = ve(), c3 = ae(), d2 = l2("iterator"), f2 = false;
  return [].keys && ("next" in (n2 = [].keys()) ? (t2 = s2(s2(n2))) !== Object.prototype && (e10 = t2) : f2 = true), !i2(e10) || r3(function() {
    var t3 = {};
    return e10[d2].call(t3) !== t3;
  }) ? e10 = {} : c3 && (e10 = a2(e10)), o2(e10[d2]) || u2(e10, d2, function() {
    return this;
  }), Un = { IteratorPrototype: e10, BUGGY_SAFARI_ITERATORS: f2 };
}
function gr() {
  if (Gn) return Wn;
  Gn = 1;
  var e10 = Yt().f, t2 = de(), n2 = ve()("toStringTag");
  return Wn = function(r3, o2, i2) {
    r3 && !i2 && (r3 = r3.prototype), r3 && !t2(r3, n2) && e10(r3, n2, { configurable: true, value: o2 });
  };
}
function vr() {
  if (er) return Qn;
  er = 1;
  var e10 = function() {
    if (Jn) return Zn;
    Jn = 1;
    var e11 = ye();
    return Zn = function(t3) {
      return e11(t3) || null === t3;
    };
  }(), t2 = String, n2 = TypeError;
  return Qn = function(r3) {
    if (e10(r3)) return r3;
    throw new n2("Can't set " + t2(r3) + " as a prototype");
  };
}
function mr() {
  if (nr) return tr;
  nr = 1;
  var e10 = function() {
    if (Xn) return Yn;
    Xn = 1;
    var e11 = D(), t3 = Wt();
    return Yn = function(n3, r4, o2) {
      try {
        return e11(t3(Object.getOwnPropertyDescriptor(n3, r4)[o2]));
      } catch (e12) {
      }
    };
  }(), t2 = ye(), n2 = O(), r3 = vr();
  return tr = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var o2, i2 = false, a2 = {};
    try {
      (o2 = e10(Object.prototype, "__proto__", "set"))(a2, []), i2 = a2 instanceof Array;
    } catch (e11) {
    }
    return function(e11, a3) {
      return n2(e11), r3(a3), t2(e11) ? (i2 ? o2(e11, a3) : e11.__proto__ = a3, e11) : e11;
    };
  }() : void 0), tr;
}
function yr() {
  if (or) return rr;
  or = 1;
  var e10 = fr(), t2 = Ht(), n2 = ae(), r3 = Sn(), o2 = me(), i2 = function() {
    if (Kn) return qn;
    Kn = 1;
    var e11 = hr().IteratorPrototype, t3 = an(), n3 = un(), r4 = gr(), o3 = sn(), i3 = function() {
      return this;
    };
    return qn = function(a3, s3, u3, l3) {
      var c4 = s3 + " Iterator";
      return a3.prototype = t3(e11, { next: n3(+!l3, u3) }), r4(a3, c4, false, true), o3[c4] = i3, a3;
    };
  }(), a2 = pr(), s2 = mr(), u2 = gr(), l2 = ln(), c3 = On(), d2 = ve(), f2 = sn(), p2 = hr(), h2 = r3.PROPER, g2 = r3.CONFIGURABLE, v2 = p2.IteratorPrototype, m2 = p2.BUGGY_SAFARI_ITERATORS, y2 = d2("iterator"), b2 = "keys", E2 = "values", C2 = "entries", w2 = function() {
    return this;
  };
  return rr = function(r4, d3, p3, D2, S2, A2, x2) {
    i2(p3, d3, D2);
    var O2, N2, B2, T2 = function(e11) {
      if (e11 === S2 && _2) return _2;
      if (!m2 && e11 && e11 in I2) return I2[e11];
      switch (e11) {
        case b2:
        case E2:
        case C2:
          return function() {
            return new p3(this, e11);
          };
      }
      return function() {
        return new p3(this);
      };
    }, k2 = d3 + " Iterator", F2 = false, I2 = r4.prototype, P2 = I2[y2] || I2["@@iterator"] || S2 && I2[S2], _2 = !m2 && P2 || T2(S2), R2 = "Array" === d3 && I2.entries || P2;
    if (R2 && (O2 = a2(R2.call(new r4()))) !== Object.prototype && O2.next && (n2 || a2(O2) === v2 || (s2 ? s2(O2, v2) : o2(O2[y2]) || c3(O2, y2, w2)), u2(O2, k2, true, true), n2 && (f2[k2] = w2)), h2 && S2 === E2 && P2 && P2.name !== E2 && (!n2 && g2 ? l2(I2, "name", E2) : (F2 = true, _2 = function() {
      return t2(P2, this);
    })), S2) if (N2 = { values: T2(E2), keys: A2 ? _2 : T2(b2), entries: T2(C2) }, x2) for (B2 in N2) (m2 || F2 || !(B2 in I2)) && c3(I2, B2, N2[B2]);
    else e10({ target: d3, proto: true, forced: m2 || F2 }, N2);
    return n2 && !x2 || I2[y2] === _2 || c3(I2, y2, _2, { name: S2 }), f2[d3] = _2, N2;
  };
}
function br() {
  return ar ? ir : (ar = 1, ir = function(e10, t2) {
    return { value: e10, done: t2 };
  });
}
function Er() {
  if (ur) return sr;
  ur = 1;
  var e10 = N(), t2 = function() {
    if (xt) return At;
    xt = 1;
    var e11 = ve(), t3 = an(), n3 = Yt().f, r4 = e11("unscopables"), o3 = Array.prototype;
    return void 0 === o3[r4] && n3(o3, r4, { configurable: true, value: t3(null) }), At = function(e12) {
      o3[r4][e12] = true;
    };
  }(), n2 = sn(), r3 = cn(), o2 = Yt().f, i2 = yr(), a2 = br(), s2 = ae(), u2 = Ae(), l2 = "Array Iterator", c3 = r3.set, d2 = r3.getterFor(l2);
  sr = i2(Array, "Array", function(t3, n3) {
    c3(this, { type: l2, target: e10(t3), index: 0, kind: n3 });
  }, function() {
    var e11 = d2(this), t3 = e11.target, n3 = e11.index++;
    if (!t3 || n3 >= t3.length) return e11.target = null, a2(void 0, true);
    switch (e11.kind) {
      case "keys":
        return a2(n3, false);
      case "values":
        return a2(t3[n3], false);
    }
    return a2([n3, t3[n3]], false);
  }, "values");
  var f2 = n2.Arguments = n2.Array;
  if (t2("keys"), t2("values"), t2("entries"), !s2 && u2 && "values" !== f2.name) try {
    o2(f2, "name", { value: "values" });
  } catch (e11) {
  }
  return sr;
}
Er();
var Cr, wr, Dr, Sr, Ar, xr, Or, Nr = {};
function Br() {
  if (wr) return Cr;
  wr = 1;
  var e10 = {};
  return e10[ve()("toStringTag")] = "z", Cr = "[object z]" === String(e10);
}
function Tr() {
  if (Sr) return Dr;
  Sr = 1;
  var e10 = Br(), t2 = me(), n2 = S(), r3 = ve()("toStringTag"), o2 = Object, i2 = "Arguments" === n2(/* @__PURE__ */ function() {
    return arguments;
  }());
  return Dr = e10 ? n2 : function(e11) {
    var a2, s2, u2;
    return void 0 === e11 ? "Undefined" : null === e11 ? "Null" : "string" == typeof (s2 = function(e12, t3) {
      try {
        return e12[t3];
      } catch (e13) {
      }
    }(a2 = o2(e11), r3)) ? s2 : i2 ? n2(a2) : "Object" === (u2 = n2(a2)) && t2(a2.callee) ? "Arguments" : u2;
  }, Dr;
}
!function() {
  if (Or) return Nr;
  Or = 1;
  var e10 = Br(), t2 = On(), n2 = function() {
    if (xr) return Ar;
    xr = 1;
    var e11 = Br(), t3 = Tr();
    return Ar = e11 ? {}.toString : function() {
      return "[object " + t3(this) + "]";
    };
  }();
  e10 || t2(Object.prototype, "toString", n2, { unsafe: true });
}();
var kr, Fr, Ir, Pr, _r, Rr, Lr, Mr, jr, Hr, zr, $r, Ur, Vr = {};
function Wr() {
  if (Fr) return kr;
  Fr = 1;
  var e10 = Tr(), t2 = String;
  return kr = function(n2) {
    if ("Symbol" === e10(n2)) throw new TypeError("Cannot convert a Symbol value to a string");
    return t2(n2);
  };
}
function Gr() {
  if (Pr) return Ir;
  Pr = 1;
  var e10 = be();
  return Ir = function() {
    var t2 = e10(this), n2 = "";
    return t2.hasIndices && (n2 += "d"), t2.global && (n2 += "g"), t2.ignoreCase && (n2 += "i"), t2.multiline && (n2 += "m"), t2.dotAll && (n2 += "s"), t2.unicode && (n2 += "u"), t2.unicodeSets && (n2 += "v"), t2.sticky && (n2 += "y"), n2;
  };
}
function qr() {
  if ($r) return zr;
  $r = 1;
  var e10, t2, n2 = Ht(), r3 = D(), o2 = Wr(), i2 = Gr(), a2 = function() {
    if (Rr) return _r;
    Rr = 1;
    var e11 = C(), t3 = B().RegExp, n3 = e11(function() {
      var e12 = t3("a", "y");
      return e12.lastIndex = 2, null !== e12.exec("abcd");
    }), r4 = n3 || e11(function() {
      return !t3("a", "y").sticky;
    }), o3 = n3 || e11(function() {
      var e12 = t3("^r", "gy");
      return e12.lastIndex = 2, null !== e12.exec("str");
    });
    return _r = { BROKEN_CARET: o3, MISSED_STICKY: r4, UNSUPPORTED_Y: n3 };
  }(), s2 = le(), u2 = an(), l2 = cn().get, c3 = function() {
    if (Mr) return Lr;
    Mr = 1;
    var e11 = C(), t3 = B().RegExp;
    return Lr = e11(function() {
      var e12 = t3(".", "s");
      return !(e12.dotAll && e12.test("\n") && "s" === e12.flags);
    });
  }(), d2 = function() {
    if (Hr) return jr;
    Hr = 1;
    var e11 = C(), t3 = B().RegExp;
    return jr = e11(function() {
      var e12 = t3("(?<a>b)", "g");
      return "b" !== e12.exec("b").groups.a || "bc" !== "b".replace(e12, "$<a>c");
    });
  }(), f2 = s2("native-string-replace", String.prototype.replace), p2 = RegExp.prototype.exec, h2 = p2, g2 = r3("".charAt), v2 = r3("".indexOf), m2 = r3("".replace), y2 = r3("".slice), b2 = (t2 = /b*/g, n2(p2, e10 = /a/, "a"), n2(p2, t2, "a"), 0 !== e10.lastIndex || 0 !== t2.lastIndex), E2 = a2.BROKEN_CARET, w2 = void 0 !== /()??/.exec("")[1];
  return (b2 || w2 || E2 || c3 || d2) && (h2 = function(e11) {
    var t3, r4, a3, s3, c4, d3, C2, D2 = this, S2 = l2(D2), A2 = o2(e11), x2 = S2.raw;
    if (x2) return x2.lastIndex = D2.lastIndex, t3 = n2(h2, x2, A2), D2.lastIndex = x2.lastIndex, t3;
    var O2 = S2.groups, N2 = E2 && D2.sticky, B2 = n2(i2, D2), T2 = D2.source, k2 = 0, F2 = A2;
    if (N2 && (B2 = m2(B2, "y", ""), -1 === v2(B2, "g") && (B2 += "g"), F2 = y2(A2, D2.lastIndex), D2.lastIndex > 0 && (!D2.multiline || D2.multiline && "\n" !== g2(A2, D2.lastIndex - 1)) && (T2 = "(?: " + T2 + ")", F2 = " " + F2, k2++), r4 = new RegExp("^(?:" + T2 + ")", B2)), w2 && (r4 = new RegExp("^" + T2 + "$(?!\\s)", B2)), b2 && (a3 = D2.lastIndex), s3 = n2(p2, N2 ? r4 : D2, F2), N2 ? s3 ? (s3.input = y2(s3.input, k2), s3[0] = y2(s3[0], k2), s3.index = D2.lastIndex, D2.lastIndex += s3[0].length) : D2.lastIndex = 0 : b2 && s3 && (D2.lastIndex = D2.global ? s3.index + s3[0].length : a3), w2 && s3 && s3.length > 1 && n2(f2, s3[0], r4, function() {
      for (c4 = 1; c4 < arguments.length - 2; c4++) void 0 === arguments[c4] && (s3[c4] = void 0);
    }), s3 && O2) for (s3.groups = d3 = u2(null), c4 = 0; c4 < O2.length; c4++) d3[(C2 = O2[c4])[0]] = s3[C2[1]];
    return s3;
  }), zr = h2;
}
function Kr() {
  if (Ur) return Vr;
  Ur = 1;
  var e10 = fr(), t2 = qr();
  return e10({ target: "RegExp", proto: true, forced: /./.exec !== t2 }, { exec: t2 }), Vr;
}
Kr();
var Yr, Xr, Zr, Jr = {};
function Qr() {
  if (Xr) return Yr;
  Xr = 1;
  var e10 = D(), t2 = Xt(), n2 = Wr(), r3 = O(), o2 = e10("".charAt), i2 = e10("".charCodeAt), a2 = e10("".slice), s2 = function(e11) {
    return function(s3, u2) {
      var l2, c3, d2 = n2(r3(s3)), f2 = t2(u2), p2 = d2.length;
      return f2 < 0 || f2 >= p2 ? e11 ? "" : void 0 : (l2 = i2(d2, f2)) < 55296 || l2 > 56319 || f2 + 1 === p2 || (c3 = i2(d2, f2 + 1)) < 56320 || c3 > 57343 ? e11 ? o2(d2, f2) : l2 : e11 ? a2(d2, f2, f2 + 2) : c3 - 56320 + (l2 - 55296 << 10) + 65536;
    };
  };
  return Yr = { codeAt: s2(false), charAt: s2(true) };
}
!function() {
  if (Zr) return Jr;
  Zr = 1;
  var e10 = Qr().charAt, t2 = Wr(), n2 = cn(), r3 = yr(), o2 = br(), i2 = "String Iterator", a2 = n2.set, s2 = n2.getterFor(i2);
  r3(String, "String", function(e11) {
    a2(this, { type: i2, string: t2(e11), index: 0 });
  }, function() {
    var t3, n3 = s2(this), r4 = n3.string, i3 = n3.index;
    return i3 >= r4.length ? o2(void 0, true) : (t3 = e10(r4, i3), n3.index += t3.length, o2(t3, false));
  });
}();
var eo, to, no, ro, oo, io, ao, so, uo, lo, co, fo = {};
function po() {
  if (ro) return no;
  ro = 1;
  var e10 = Qr().charAt;
  return no = function(t2, n2, r3) {
    return n2 + (r3 ? e10(t2, n2).length : 1);
  }, no;
}
function ho() {
  if (so) return ao;
  so = 1;
  var e10 = Ht(), t2 = de(), n2 = $t(), r3 = function() {
    if (io) return oo;
    io = 1;
    var e11 = B(), t3 = C(), n3 = e11.RegExp, r4 = !t3(function() {
      var e12 = true;
      try {
        n3(".", "d");
      } catch (t5) {
        e12 = false;
      }
      var t4 = {}, r5 = "", o3 = e12 ? "dgimsy" : "gimsy", i3 = function(e13, n4) {
        Object.defineProperty(t4, e13, { get: function() {
          return r5 += n4, true;
        } });
      }, a2 = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
      for (var s2 in e12 && (a2.hasIndices = "d"), a2) i3(s2, a2[s2]);
      return Object.getOwnPropertyDescriptor(n3.prototype, "flags").get.call(t4) !== o3 || r5 !== o3;
    });
    return oo = { correct: r4 };
  }(), o2 = Gr(), i2 = RegExp.prototype;
  return ao = r3.correct ? function(e11) {
    return e11.flags;
  } : function(a2) {
    return r3.correct || !n2(i2, a2) || t2(a2, "flags") ? a2.flags : e10(o2, a2);
  };
}
!function() {
  if (co) return fo;
  co = 1;
  var e10 = Ht(), t2 = D(), n2 = function() {
    if (to) return eo;
    to = 1, Kr();
    var e11 = Ht(), t3 = On(), n3 = qr(), r4 = C(), o3 = ve(), i3 = ln(), a3 = o3("species"), s3 = RegExp.prototype;
    return eo = function(u3, l3, c4, d3) {
      var f3 = o3(u3), p2 = !r4(function() {
        var e12 = {};
        return e12[f3] = function() {
          return 7;
        }, 7 !== ""[u3](e12);
      }), h2 = p2 && !r4(function() {
        var e12 = false, t4 = /a/;
        if ("split" === u3) {
          var n4 = {};
          n4[a3] = function() {
            return t4;
          }, (t4 = { constructor: n4, flags: "" })[f3] = /./[f3];
        }
        return t4.exec = function() {
          return e12 = true, null;
        }, t4[f3](""), !e12;
      });
      if (!p2 || !h2 || c4) {
        var g2 = /./[f3], v2 = l3(f3, ""[u3], function(t4, r5, o4, i4, a4) {
          var u4 = r5.exec;
          return u4 === n3 || u4 === s3.exec ? p2 && !a4 ? { done: true, value: e11(g2, r5, o4, i4) } : { done: true, value: e11(t4, o4, r5, i4) } : { done: false };
        });
        t3(String.prototype, u3, v2[0]), t3(s3, f3, v2[1]);
      }
      d3 && i3(s3[f3], "sham", true);
    }, eo;
  }(), r3 = be(), o2 = ye(), i2 = Zt(), a2 = Wr(), s2 = O(), u2 = Gt(), l2 = po(), c3 = ho(), d2 = function() {
    if (lo) return uo;
    lo = 1;
    var e11 = Ht(), t3 = be(), n3 = me(), r4 = S(), o3 = qr(), i3 = TypeError;
    return uo = function(a3, s3) {
      var u3 = a3.exec;
      if (n3(u3)) {
        var l3 = e11(u3, a3, s3);
        return null !== l3 && t3(l3), l3;
      }
      if ("RegExp" === r4(a3)) return e11(o3, a3, s3);
      throw new i3("RegExp#exec called on incompatible receiver");
    }, uo;
  }(), f2 = t2("".indexOf);
  n2("match", function(t3, n3, p2) {
    return [function(n4) {
      var r4 = s2(this), i3 = o2(n4) ? u2(n4, t3) : void 0;
      return i3 ? e10(i3, n4, r4) : new RegExp(n4)[t3](a2(r4));
    }, function(e11) {
      var t4 = r3(this), o3 = a2(e11), s3 = p2(n3, t4, o3);
      if (s3.done) return s3.value;
      var u3 = a2(c3(t4));
      if (-1 === f2(u3, "g")) return d2(t4, o3);
      var h2 = -1 !== f2(u3, "u");
      t4.lastIndex = 0;
      for (var g2, v2 = [], m2 = 0; null !== (g2 = d2(t4, o3)); ) {
        var y2 = a2(g2[0]);
        v2[m2] = y2, "" === y2 && (t4.lastIndex = l2(o3, i2(t4.lastIndex), h2)), m2++;
      }
      return 0 === m2 ? null : v2;
    }];
  });
}();
var go, vo, mo, yo, bo, Eo, Co, wo, Do, So, Ao, xo, Oo, No, Bo, To, ko, Fo, Io, Po, _o2, Ro, Lo, Mo, jo, Ho, zo, $o = {}, Uo = {};
function Vo() {
  if (vo) return go;
  vo = 1;
  var e10 = ye(), t2 = ln();
  return go = function(n2, r3) {
    e10(r3) && "cause" in r3 && t2(n2, "cause", r3.cause);
  }, go;
}
function Wo() {
  if (wo) return Co;
  wo = 1;
  var e10 = ln(), t2 = function() {
    if (yo) return mo;
    yo = 1;
    var e11 = D(), t3 = Error, n3 = e11("".replace), r4 = String(new t3("zxcasd").stack), o2 = /\n\s*at [^:]*:[^\n]*/, i2 = o2.test(r4);
    return mo = function(e12, r5) {
      if (i2 && "string" == typeof e12 && !t3.prepareStackTrace) for (; r5--; ) e12 = n3(e12, o2, "");
      return e12;
    };
  }(), n2 = function() {
    if (Eo) return bo;
    Eo = 1;
    var e11 = C(), t3 = un();
    return bo = !e11(function() {
      var e12 = new Error("a");
      return !("stack" in e12) || (Object.defineProperty(e12, "stack", t3(1, 7)), 7 !== e12.stack);
    });
  }(), r3 = Error.captureStackTrace;
  return Co = function(o2, i2, a2, s2) {
    n2 && (r3 ? r3(o2, i2) : e10(o2, "stack", t2(a2, s2)));
  }, Co;
}
function Go() {
  if (xo) return Ao;
  xo = 1;
  var e10 = function() {
    if (So) return Do;
    So = 1;
    var e11 = S(), t3 = D();
    return Do = function(n3) {
      if ("Function" === e11(n3)) return t3(n3);
    }, Do;
  }(), t2 = Wt(), n2 = w(), r3 = e10(e10.bind);
  return Ao = function(e11, o2) {
    return t2(e11), void 0 === o2 ? e11 : n2 ? r3(e11, o2) : function() {
      return e11.apply(o2, arguments);
    };
  }, Ao;
}
function qo() {
  if (No) return Oo;
  No = 1;
  var e10 = ve(), t2 = sn(), n2 = e10("iterator"), r3 = Array.prototype;
  return Oo = function(e11) {
    return void 0 !== e11 && (t2.Array === e11 || r3[n2] === e11);
  };
}
function Ko() {
  if (To) return Bo;
  To = 1;
  var e10 = Tr(), t2 = Gt(), n2 = x(), r3 = sn(), o2 = ve()("iterator");
  return Bo = function(i2) {
    if (!n2(i2)) return t2(i2, o2) || t2(i2, "@@iterator") || r3[e10(i2)];
  };
}
function Yo() {
  if (Fo) return ko;
  Fo = 1;
  var e10 = Ht(), t2 = Wt(), n2 = be(), r3 = Vt(), o2 = Ko(), i2 = TypeError;
  return ko = function(a2, s2) {
    var u2 = arguments.length < 2 ? o2(a2) : s2;
    if (t2(u2)) return n2(e10(u2, a2));
    throw new i2(r3(a2) + " is not iterable");
  }, ko;
}
function Xo() {
  if (Po) return Io;
  Po = 1;
  var e10 = Ht(), t2 = be(), n2 = Gt();
  return Io = function(r3, o2, i2) {
    var a2, s2;
    t2(r3);
    try {
      if (!(a2 = n2(r3, "return"))) {
        if ("throw" === o2) throw i2;
        return i2;
      }
      a2 = e10(a2, r3);
    } catch (e11) {
      s2 = true, a2 = e11;
    }
    if ("throw" === o2) throw i2;
    if (s2) throw a2;
    return t2(a2), i2;
  }, Io;
}
function Zo() {
  if (Ro) return _o2;
  Ro = 1;
  var e10 = Go(), t2 = Ht(), n2 = be(), r3 = Vt(), o2 = qo(), i2 = Jt(), a2 = $t(), s2 = Yo(), u2 = Ko(), l2 = Xo(), c3 = TypeError, d2 = function(e11, t3) {
    this.stopped = e11, this.result = t3;
  }, f2 = d2.prototype;
  return _o2 = function(p2, h2, g2) {
    var v2, m2, y2, b2, E2, C2, w2, D2 = g2 && g2.that, S2 = !(!g2 || !g2.AS_ENTRIES), A2 = !(!g2 || !g2.IS_RECORD), x2 = !(!g2 || !g2.IS_ITERATOR), O2 = !(!g2 || !g2.INTERRUPTED), N2 = e10(h2, D2), B2 = function(e11) {
      return v2 && l2(v2, "normal"), new d2(true, e11);
    }, T2 = function(e11) {
      return S2 ? (n2(e11), O2 ? N2(e11[0], e11[1], B2) : N2(e11[0], e11[1])) : O2 ? N2(e11, B2) : N2(e11);
    };
    if (A2) v2 = p2.iterator;
    else if (x2) v2 = p2;
    else {
      if (!(m2 = u2(p2))) throw new c3(r3(p2) + " is not iterable");
      if (o2(m2)) {
        for (y2 = 0, b2 = i2(p2); b2 > y2; y2++) if ((E2 = T2(p2[y2])) && a2(f2, E2)) return E2;
        return new d2(false);
      }
      v2 = s2(p2, m2);
    }
    for (C2 = A2 ? p2.next : v2.next; !(w2 = t2(C2, v2)).done; ) {
      try {
        E2 = T2(w2.value);
      } catch (e11) {
        l2(v2, "throw", e11);
      }
      if ("object" == typeof E2 && E2 && a2(f2, E2)) return E2;
    }
    return new d2(false);
  }, _o2;
}
function Jo() {
  if (Mo) return Lo;
  Mo = 1;
  var e10 = Wr();
  return Lo = function(t2, n2) {
    return void 0 === t2 ? arguments.length < 2 ? "" : n2 : e10(t2);
  }, Lo;
}
function Qo() {
  return Ho || (Ho = 1, function() {
    if (jo) return Uo;
    jo = 1;
    var e10 = fr(), t2 = $t(), n2 = pr(), r3 = mr(), o2 = dr(), i2 = an(), a2 = ln(), s2 = un(), u2 = Vo(), l2 = Wo(), c3 = Zo(), d2 = Jo(), f2 = ve()("toStringTag"), p2 = Error, h2 = [].push, g2 = function(e11, o3) {
      var s3, m2 = t2(v2, this);
      r3 ? s3 = r3(new p2(), m2 ? n2(this) : v2) : (s3 = m2 ? this : i2(v2), a2(s3, f2, "Error")), void 0 !== o3 && a2(s3, "message", d2(o3)), l2(s3, g2, s3.stack, 1), arguments.length > 2 && u2(s3, arguments[2]);
      var y2 = [];
      return c3(e11, h2, { that: y2 }), a2(s3, "errors", y2), s3;
    };
    r3 ? r3(g2, p2) : o2(g2, p2, { name: true });
    var v2 = g2.prototype = i2(p2.prototype, { constructor: s2(1, g2), message: s2(1, ""), name: s2(1, "AggregateError") });
    e10({ global: true, constructor: true, arity: 2 }, { AggregateError: g2 });
  }()), $o;
}
zo || (zo = 1, Qo());
var ei, ti, ni = {};
ti || (ti = 1, function() {
  if (ei) return ni;
  ei = 1;
  var e10 = fr(), t2 = B();
  e10({ global: true, forced: t2.globalThis !== t2 }, { globalThis: t2 });
}());
var ri, oi, ii, ai, si, ui, li = {};
function ci() {
  return oi ? ri : (oi = 1, ri = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 });
}
function di() {
  if (ai) return ii;
  ai = 1;
  var e10 = Mt()("span").classList, t2 = e10 && e10.constructor && e10.constructor.prototype;
  return ii = t2 === Object.prototype ? void 0 : t2;
}
if (function() {
  if (si) return li;
  si = 1;
  var e10 = B(), t2 = ci(), n2 = di(), r3 = Er(), o2 = ln(), i2 = gr(), a2 = ve()("iterator"), s2 = r3.values, u2 = function(e11, n3) {
    if (e11) {
      if (e11[a2] !== s2) try {
        o2(e11, a2, s2);
      } catch (t3) {
        e11[a2] = s2;
      }
      if (i2(e11, n3, true), t2[n3]) {
        for (var u3 in r3) if (e11[u3] !== r3[u3]) try {
          o2(e11, u3, r3[u3]);
        } catch (t3) {
          e11[u3] = r3[u3];
        }
      }
    }
  };
  for (var l2 in t2) u2(e10[l2] && e10[l2].prototype, l2);
  u2(n2, "DOMTokenList");
}(), "undefined" == typeof global) {
  if ("ActiveXObject" in window) {
    console.error("抱歉，wangEditor V5+ 版本开始，不在支持 IE 浏览器\n Sorry, wangEditor V5+ versions do not support IE browser.");
  }
  fi(), pi();
} else global && (null === (ui = global.navigator) || void 0 === ui ? void 0 : ui.userAgent.match("QQBrowser")) && (fi(), pi());
function fi() {
  "undefined" == typeof globalThis && (window.globalThis = window);
}
function pi() {
  "undefined" == typeof AggregateError && (window.AggregateError = function(e10, t2) {
    var n2 = new Error(t2);
    return n2.errors = e10, n2;
  });
}
var hi, gi, vi, mi, yi, bi, Ei, Ci, wi, Di, Si, Ai, xi, Oi, Ni, Bi, Ti = {};
function ki() {
  if (gi) return hi;
  gi = 1;
  var e10 = function(e11) {
    return e11 && e11.Math === Math && e11;
  };
  return hi = e10("object" == typeof globalThis && globalThis) || e10("object" == typeof window && window) || e10("object" == typeof self && self) || e10("object" == typeof y && y) || e10("object" == typeof hi && hi) || /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")();
}
function Fi() {
  return mi ? vi : (mi = 1, vi = function(e10) {
    try {
      return !!e10();
    } catch (e11) {
      return true;
    }
  });
}
function Ii() {
  return bi ? yi : (bi = 1, yi = !Fi()(function() {
    var e10 = (function() {
    }).bind();
    return "function" != typeof e10 || e10.hasOwnProperty("prototype");
  }));
}
function Pi() {
  if (Ci) return Ei;
  Ci = 1;
  var e10 = Ii(), t2 = Function.prototype, n2 = t2.apply, r3 = t2.call;
  return Ei = "object" == typeof Reflect && Reflect.apply || (e10 ? r3.bind(n2) : function() {
    return r3.apply(n2, arguments);
  }), Ei;
}
function _i2() {
  if (Di) return wi;
  Di = 1;
  var e10 = Ii(), t2 = Function.prototype, n2 = t2.call, r3 = e10 && t2.bind.bind(n2, n2);
  return wi = e10 ? r3 : function(e11) {
    return function() {
      return n2.apply(e11, arguments);
    };
  }, wi;
}
function Ri() {
  if (Ai) return Si;
  Ai = 1;
  var e10 = _i2(), t2 = e10({}.toString), n2 = e10("".slice);
  return Si = function(e11) {
    return n2(t2(e11), 8, -1);
  };
}
function Li() {
  if (Oi) return xi;
  Oi = 1;
  var e10 = Ri(), t2 = _i2();
  return xi = function(n2) {
    if ("Function" === e10(n2)) return t2(n2);
  }, xi;
}
function Mi() {
  if (Bi) return Ni;
  Bi = 1;
  var e10 = "object" == typeof document && document.all;
  return Ni = void 0 === e10 && void 0 !== e10 ? function(t2) {
    return "function" == typeof t2 || t2 === e10;
  } : function(e11) {
    return "function" == typeof e11;
  };
}
var ji, Hi, zi, $i, Ui = {};
function Vi() {
  return Hi ? ji : (Hi = 1, ji = !Fi()(function() {
    return 7 !== Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1];
  }));
}
function Wi() {
  if ($i) return zi;
  $i = 1;
  var e10 = Ii(), t2 = Function.prototype.call;
  return zi = e10 ? t2.bind(t2) : function() {
    return t2.apply(t2, arguments);
  }, zi;
}
var Gi, qi, Ki, Yi, Xi, Zi, Ji, Qi, ea, ta, na, ra, oa, ia, aa, sa, ua, la, ca, da, fa, pa, ha, ga, va, ma, ya, ba, Ea, Ca, wa, Da, Sa, Aa, xa, Oa, Na, Ba = {};
function Ta() {
  if (Gi) return Ba;
  Gi = 1;
  var e10 = {}.propertyIsEnumerable, t2 = Object.getOwnPropertyDescriptor, n2 = t2 && !e10.call({ 1: 2 }, 1);
  return Ba.f = n2 ? function(e11) {
    var n3 = t2(this, e11);
    return !!n3 && n3.enumerable;
  } : e10, Ba;
}
function ka() {
  return Ki ? qi : (Ki = 1, qi = function(e10, t2) {
    return { enumerable: !(1 & e10), configurable: !(2 & e10), writable: !(4 & e10), value: t2 };
  });
}
function Fa() {
  if (Xi) return Yi;
  Xi = 1;
  var e10 = _i2(), t2 = Fi(), n2 = Ri(), r3 = Object, o2 = e10("".split);
  return Yi = t2(function() {
    return !r3("z").propertyIsEnumerable(0);
  }) ? function(e11) {
    return "String" === n2(e11) ? o2(e11, "") : r3(e11);
  } : r3;
}
function Ia() {
  return Ji ? Zi : (Ji = 1, Zi = function(e10) {
    return null == e10;
  });
}
function Pa() {
  if (ea) return Qi;
  ea = 1;
  var e10 = Ia(), t2 = TypeError;
  return Qi = function(n2) {
    if (e10(n2)) throw new t2("Can't call method on " + n2);
    return n2;
  };
}
function _a() {
  if (na) return ta;
  na = 1;
  var e10 = Fa(), t2 = Pa();
  return ta = function(n2) {
    return e10(t2(n2));
  };
}
function Ra() {
  if (oa) return ra;
  oa = 1;
  var e10 = Mi();
  return ra = function(t2) {
    return "object" == typeof t2 ? null !== t2 : e10(t2);
  };
}
function La() {
  return aa ? ia : (aa = 1, ia = {});
}
function Ma() {
  if (ua) return sa;
  ua = 1;
  var e10 = La(), t2 = ki(), n2 = Mi(), r3 = function(e11) {
    return n2(e11) ? e11 : void 0;
  };
  return sa = function(n3, o2) {
    return arguments.length < 2 ? r3(e10[n3]) || r3(t2[n3]) : e10[n3] && e10[n3][o2] || t2[n3] && t2[n3][o2];
  }, sa;
}
function ja() {
  return ca ? la : (ca = 1, la = _i2()({}.isPrototypeOf));
}
function Ha() {
  if (fa) return da;
  fa = 1;
  var e10 = ki().navigator, t2 = e10 && e10.userAgent;
  return da = t2 ? String(t2) : "";
}
function za() {
  if (ha) return pa;
  ha = 1;
  var e10, t2, n2 = ki(), r3 = Ha(), o2 = n2.process, i2 = n2.Deno, a2 = o2 && o2.versions || i2 && i2.version, s2 = a2 && a2.v8;
  return s2 && (t2 = (e10 = s2.split("."))[0] > 0 && e10[0] < 4 ? 1 : +(e10[0] + e10[1])), !t2 && r3 && (!(e10 = r3.match(/Edge\/(\d+)/)) || e10[1] >= 74) && (e10 = r3.match(/Chrome\/(\d+)/)) && (t2 = +e10[1]), pa = t2;
}
function $a() {
  if (va) return ga;
  va = 1;
  var e10 = za(), t2 = Fi(), n2 = ki().String;
  return ga = !!Object.getOwnPropertySymbols && !t2(function() {
    var t3 = Symbol("symbol detection");
    return !n2(t3) || !(Object(t3) instanceof Symbol) || !Symbol.sham && e10 && e10 < 41;
  }), ga;
}
function Ua() {
  return ya ? ma : (ya = 1, ma = $a() && !Symbol.sham && "symbol" == typeof Symbol.iterator);
}
function Va() {
  if (Ea) return ba;
  Ea = 1;
  var e10 = Ma(), t2 = Mi(), n2 = ja(), r3 = Object;
  return ba = Ua() ? function(e11) {
    return "symbol" == typeof e11;
  } : function(o2) {
    var i2 = e10("Symbol");
    return t2(i2) && n2(i2.prototype, r3(o2));
  };
}
function Wa() {
  if (wa) return Ca;
  wa = 1;
  var e10 = String;
  return Ca = function(t2) {
    try {
      return e10(t2);
    } catch (e11) {
      return "Object";
    }
  };
}
function Ga() {
  if (Sa) return Da;
  Sa = 1;
  var e10 = Mi(), t2 = Wa(), n2 = TypeError;
  return Da = function(r3) {
    if (e10(r3)) return r3;
    throw new n2(t2(r3) + " is not a function");
  };
}
function qa() {
  if (xa) return Aa;
  xa = 1;
  var e10 = Ga(), t2 = Ia();
  return Aa = function(n2, r3) {
    var o2 = n2[r3];
    return t2(o2) ? void 0 : e10(o2);
  }, Aa;
}
function Ka() {
  if (Na) return Oa;
  Na = 1;
  var e10 = Wi(), t2 = Mi(), n2 = Ra(), r3 = TypeError;
  return Oa = function(o2, i2) {
    var a2, s2;
    if ("string" === i2 && t2(a2 = o2.toString) && !n2(s2 = e10(a2, o2))) return s2;
    if (t2(a2 = o2.valueOf) && !n2(s2 = e10(a2, o2))) return s2;
    if ("string" !== i2 && t2(a2 = o2.toString) && !n2(s2 = e10(a2, o2))) return s2;
    throw new r3("Can't convert object to primitive value");
  }, Oa;
}
var Ya, Xa, Za, Ja, Qa, es, ts, ns, rs, os, is, as, ss, us, ls, cs, ds, fs, ps, hs, gs, vs, ms, ys, bs, Es, Cs, ws, Ds = { exports: {} };
function Ss() {
  return Xa ? Ya : (Xa = 1, Ya = true);
}
function As() {
  if (Ja) return Za;
  Ja = 1;
  var e10 = ki(), t2 = Object.defineProperty;
  return Za = function(n2, r3) {
    try {
      t2(e10, n2, { value: r3, configurable: true, writable: true });
    } catch (t3) {
      e10[n2] = r3;
    }
    return r3;
  };
}
function xs() {
  if (Qa) return Ds.exports;
  Qa = 1;
  var e10 = Ss(), t2 = ki(), n2 = As(), r3 = "__core-js_shared__", o2 = Ds.exports = t2[r3] || n2(r3, {});
  return (o2.versions || (o2.versions = [])).push({ version: "3.47.0", mode: e10 ? "pure" : "global", copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)", license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE", source: "https://github.com/zloirock/core-js" }), Ds.exports;
}
function Os() {
  if (ts) return es;
  ts = 1;
  var e10 = xs();
  return es = function(t2, n2) {
    return e10[t2] || (e10[t2] = n2 || {});
  };
}
function Ns() {
  if (rs) return ns;
  rs = 1;
  var e10 = Pa(), t2 = Object;
  return ns = function(n2) {
    return t2(e10(n2));
  };
}
function Bs() {
  if (is) return os;
  is = 1;
  var e10 = _i2(), t2 = Ns(), n2 = e10({}.hasOwnProperty);
  return os = Object.hasOwn || function(e11, r3) {
    return n2(t2(e11), r3);
  };
}
function Ts() {
  if (ss) return as;
  ss = 1;
  var e10 = _i2(), t2 = 0, n2 = Math.random(), r3 = e10(1.1.toString);
  return as = function(e11) {
    return "Symbol(" + (void 0 === e11 ? "" : e11) + ")_" + r3(++t2 + n2, 36);
  };
}
function ks() {
  if (ls) return us;
  ls = 1;
  var e10 = ki(), t2 = Os(), n2 = Bs(), r3 = Ts(), o2 = $a(), i2 = Ua(), a2 = e10.Symbol, s2 = t2("wks"), u2 = i2 ? a2.for || a2 : a2 && a2.withoutSetter || r3;
  return us = function(e11) {
    return n2(s2, e11) || (s2[e11] = o2 && n2(a2, e11) ? a2[e11] : u2("Symbol." + e11)), s2[e11];
  };
}
function Fs() {
  if (ds) return cs;
  ds = 1;
  var e10 = Wi(), t2 = Ra(), n2 = Va(), r3 = qa(), o2 = Ka(), i2 = TypeError, a2 = ks()("toPrimitive");
  return cs = function(s2, u2) {
    if (!t2(s2) || n2(s2)) return s2;
    var l2, c3 = r3(s2, a2);
    if (c3) {
      if (void 0 === u2 && (u2 = "default"), l2 = e10(c3, s2, u2), !t2(l2) || n2(l2)) return l2;
      throw new i2("Can't convert object to primitive value");
    }
    return void 0 === u2 && (u2 = "number"), o2(s2, u2);
  };
}
function Is() {
  if (ps) return fs;
  ps = 1;
  var e10 = Fs(), t2 = Va();
  return fs = function(n2) {
    var r3 = e10(n2, "string");
    return t2(r3) ? r3 : r3 + "";
  };
}
function Ps() {
  if (gs) return hs;
  gs = 1;
  var e10 = ki(), t2 = Ra(), n2 = e10.document, r3 = t2(n2) && t2(n2.createElement);
  return hs = function(e11) {
    return r3 ? n2.createElement(e11) : {};
  };
}
function _s() {
  if (ms) return vs;
  ms = 1;
  var e10 = Vi(), t2 = Fi(), n2 = Ps();
  return vs = !e10 && !t2(function() {
    return 7 !== Object.defineProperty(n2("div"), "a", { get: function() {
      return 7;
    } }).a;
  });
}
function Rs() {
  if (ys) return Ui;
  ys = 1;
  var e10 = Vi(), t2 = Wi(), n2 = Ta(), r3 = ka(), o2 = _a(), i2 = Is(), a2 = Bs(), s2 = _s(), u2 = Object.getOwnPropertyDescriptor;
  return Ui.f = e10 ? u2 : function(e11, l2) {
    if (e11 = o2(e11), l2 = i2(l2), s2) try {
      return u2(e11, l2);
    } catch (e12) {
    }
    if (a2(e11, l2)) return r3(!t2(n2.f, e11, l2), e11[l2]);
  }, Ui;
}
function Ls() {
  if (Es) return bs;
  Es = 1;
  var e10 = Fi(), t2 = Mi(), n2 = /#|\.prototype\./, r3 = function(n3, r4) {
    var u2 = i2[o2(n3)];
    return u2 === s2 || u2 !== a2 && (t2(r4) ? e10(r4) : !!r4);
  }, o2 = r3.normalize = function(e11) {
    return String(e11).replace(n2, ".").toLowerCase();
  }, i2 = r3.data = {}, a2 = r3.NATIVE = "N", s2 = r3.POLYFILL = "P";
  return bs = r3;
}
function Ms() {
  if (ws) return Cs;
  ws = 1;
  var e10 = Li(), t2 = Ga(), n2 = Ii(), r3 = e10(e10.bind);
  return Cs = function(e11, o2) {
    return t2(e11), void 0 === o2 ? e11 : n2 ? r3(e11, o2) : function() {
      return e11.apply(o2, arguments);
    };
  }, Cs;
}
var js, Hs, zs, $s, Us, Vs, Ws, Gs, qs, Ks, Ys, Xs, Zs, Js, Qs, eu, tu, nu, ru, ou, iu, au, su, uu, lu, cu, du, fu, pu, hu, gu, vu, mu, yu, bu, Eu, Cu, wu, Du = {};
function Su() {
  return Hs ? js : (Hs = 1, js = Vi() && Fi()(function() {
    return 42 !== Object.defineProperty(function() {
    }, "prototype", { value: 42, writable: false }).prototype;
  }));
}
function Au() {
  if ($s) return zs;
  $s = 1;
  var e10 = Ra(), t2 = String, n2 = TypeError;
  return zs = function(r3) {
    if (e10(r3)) return r3;
    throw new n2(t2(r3) + " is not an object");
  };
}
function xu() {
  if (Us) return Du;
  Us = 1;
  var e10 = Vi(), t2 = _s(), n2 = Su(), r3 = Au(), o2 = Is(), i2 = TypeError, a2 = Object.defineProperty, s2 = Object.getOwnPropertyDescriptor, u2 = "enumerable", l2 = "configurable", c3 = "writable";
  return Du.f = e10 ? n2 ? function(e11, t3, n3) {
    if (r3(e11), t3 = o2(t3), r3(n3), "function" == typeof e11 && "prototype" === t3 && "value" in n3 && c3 in n3 && !n3[c3]) {
      var i3 = s2(e11, t3);
      i3 && i3[c3] && (e11[t3] = n3.value, n3 = { configurable: l2 in n3 ? n3[l2] : i3[l2], enumerable: u2 in n3 ? n3[u2] : i3[u2], writable: false });
    }
    return a2(e11, t3, n3);
  } : a2 : function(e11, n3, s3) {
    if (r3(e11), n3 = o2(n3), r3(s3), t2) try {
      return a2(e11, n3, s3);
    } catch (e12) {
    }
    if ("get" in s3 || "set" in s3) throw new i2("Accessors not supported");
    return "value" in s3 && (e11[n3] = s3.value), e11;
  }, Du;
}
function Ou() {
  if (Ws) return Vs;
  Ws = 1;
  var e10 = Vi(), t2 = xu(), n2 = ka();
  return Vs = e10 ? function(e11, r3, o2) {
    return t2.f(e11, r3, n2(1, o2));
  } : function(e11, t3, n3) {
    return e11[t3] = n3, e11;
  };
}
function Nu() {
  if (qs) return Gs;
  qs = 1;
  var e10 = ki(), t2 = Pi(), n2 = Li(), r3 = Mi(), o2 = Rs().f, i2 = Ls(), a2 = La(), s2 = Ms(), u2 = Ou(), l2 = Bs(), c3 = function(e11) {
    var n3 = function(r4, o3, i3) {
      if (this instanceof n3) {
        switch (arguments.length) {
          case 0:
            return new e11();
          case 1:
            return new e11(r4);
          case 2:
            return new e11(r4, o3);
        }
        return new e11(r4, o3, i3);
      }
      return t2(e11, this, arguments);
    };
    return n3.prototype = e11.prototype, n3;
  };
  return Gs = function(t3, d2) {
    var f2, p2, h2, g2, v2, m2, y2, b2, E2, C2 = t3.target, w2 = t3.global, D2 = t3.stat, S2 = t3.proto, A2 = w2 ? e10 : D2 ? e10[C2] : e10[C2] && e10[C2].prototype, x2 = w2 ? a2 : a2[C2] || u2(a2, C2, {})[C2], O2 = x2.prototype;
    for (g2 in d2) p2 = !(f2 = i2(w2 ? g2 : C2 + (D2 ? "." : "#") + g2, t3.forced)) && A2 && l2(A2, g2), m2 = x2[g2], p2 && (y2 = t3.dontCallGetSet ? (E2 = o2(A2, g2)) && E2.value : A2[g2]), v2 = p2 && y2 ? y2 : d2[g2], (f2 || S2 || typeof m2 != typeof v2) && (b2 = t3.bind && p2 ? s2(v2, e10) : t3.wrap && p2 ? c3(v2) : S2 && r3(v2) ? n2(v2) : v2, (t3.sham || v2 && v2.sham || m2 && m2.sham) && u2(b2, "sham", true), u2(x2, g2, b2), S2 && (l2(a2, h2 = C2 + "Prototype") || u2(a2, h2, {}), u2(a2[h2], g2, v2), t3.real && O2 && (f2 || !O2[g2]) && u2(O2, g2, v2)));
  };
}
function Bu() {
  if (Ys) return Ks;
  Ys = 1;
  var e10 = Ri();
  return Ks = Array.isArray || function(t2) {
    return "Array" === e10(t2);
  };
}
function Tu() {
  if (Zs) return Xs;
  Zs = 1;
  var e10 = Math.ceil, t2 = Math.floor;
  return Xs = Math.trunc || function(n2) {
    var r3 = +n2;
    return (r3 > 0 ? t2 : e10)(r3);
  }, Xs;
}
function ku() {
  if (Qs) return Js;
  Qs = 1;
  var e10 = Tu();
  return Js = function(t2) {
    var n2 = +t2;
    return n2 != n2 || 0 === n2 ? 0 : e10(n2);
  };
}
function Fu() {
  if (tu) return eu;
  tu = 1;
  var e10 = ku(), t2 = Math.min;
  return eu = function(n2) {
    var r3 = e10(n2);
    return r3 > 0 ? t2(r3, 9007199254740991) : 0;
  };
}
function Iu() {
  if (ru) return nu;
  ru = 1;
  var e10 = Fu();
  return nu = function(t2) {
    return e10(t2.length);
  };
}
function Pu() {
  if (iu) return ou;
  iu = 1;
  var e10 = TypeError;
  return ou = function(t2) {
    if (t2 > 9007199254740991) throw e10("Maximum allowed index exceeded");
    return t2;
  };
}
function _u2() {
  if (su) return au;
  su = 1;
  var e10 = Vi(), t2 = xu(), n2 = ka();
  return au = function(r3, o2, i2) {
    e10 ? t2.f(r3, o2, n2(0, i2)) : r3[o2] = i2;
  };
}
function Ru() {
  if (lu) return uu;
  lu = 1;
  var e10 = {};
  return e10[ks()("toStringTag")] = "z", uu = "[object z]" === String(e10);
}
function Lu() {
  if (du) return cu;
  du = 1;
  var e10 = Ru(), t2 = Mi(), n2 = Ri(), r3 = ks()("toStringTag"), o2 = Object, i2 = "Arguments" === n2(/* @__PURE__ */ function() {
    return arguments;
  }());
  return cu = e10 ? n2 : function(e11) {
    var a2, s2, u2;
    return void 0 === e11 ? "Undefined" : null === e11 ? "Null" : "string" == typeof (s2 = function(e12, t3) {
      try {
        return e12[t3];
      } catch (e13) {
      }
    }(a2 = o2(e11), r3)) ? s2 : i2 ? n2(a2) : "Object" === (u2 = n2(a2)) && t2(a2.callee) ? "Arguments" : u2;
  }, cu;
}
function Mu() {
  if (pu) return fu;
  pu = 1;
  var e10 = _i2(), t2 = Mi(), n2 = xs(), r3 = e10(Function.toString);
  return t2(n2.inspectSource) || (n2.inspectSource = function(e11) {
    return r3(e11);
  }), fu = n2.inspectSource;
}
function ju() {
  if (gu) return hu;
  gu = 1;
  var e10 = _i2(), t2 = Fi(), n2 = Mi(), r3 = Lu(), o2 = Ma(), i2 = Mu(), a2 = function() {
  }, s2 = o2("Reflect", "construct"), u2 = /^\s*(?:class|function)\b/, l2 = e10(u2.exec), c3 = !u2.test(a2), d2 = function(e11) {
    if (!n2(e11)) return false;
    try {
      return s2(a2, [], e11), true;
    } catch (e12) {
      return false;
    }
  }, f2 = function(e11) {
    if (!n2(e11)) return false;
    switch (r3(e11)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return false;
    }
    try {
      return c3 || !!l2(u2, i2(e11));
    } catch (e12) {
      return true;
    }
  };
  return f2.sham = true, hu = !s2 || t2(function() {
    var e11;
    return d2(d2.call) || !d2(Object) || !d2(function() {
      e11 = true;
    }) || e11;
  }) ? f2 : d2;
}
function Hu() {
  if (mu) return vu;
  mu = 1;
  var e10 = Bu(), t2 = ju(), n2 = Ra(), r3 = ks()("species"), o2 = Array;
  return vu = function(i2) {
    var a2;
    return e10(i2) && (a2 = i2.constructor, (t2(a2) && (a2 === o2 || e10(a2.prototype)) || n2(a2) && null === (a2 = a2[r3])) && (a2 = void 0)), void 0 === a2 ? o2 : a2;
  }, vu;
}
function zu() {
  if (bu) return yu;
  bu = 1;
  var e10 = Hu();
  return yu = function(t2, n2) {
    return new (e10(t2))(0 === n2 ? 0 : n2);
  };
}
function $u() {
  if (Cu) return Eu;
  Cu = 1;
  var e10 = Fi(), t2 = ks(), n2 = za(), r3 = t2("species");
  return Eu = function(t3) {
    return n2 >= 51 || !e10(function() {
      var e11 = [];
      return (e11.constructor = {})[r3] = function() {
        return { foo: 1 };
      }, 1 !== e11[t3](Boolean).foo;
    });
  }, Eu;
}
var Uu, Vu, Wu = {}, Gu = {};
function qu() {
  if (Vu) return Uu;
  Vu = 1;
  var e10 = Lu(), t2 = String;
  return Uu = function(n2) {
    if ("Symbol" === e10(n2)) throw new TypeError("Cannot convert a Symbol value to a string");
    return t2(n2);
  };
}
var Ku, Yu, Xu, Zu, Ju, Qu, el, tl, nl, rl, ol, il, al, sl, ul, ll, cl, dl, fl, pl = {};
function hl() {
  if (Yu) return Ku;
  Yu = 1;
  var e10 = ku(), t2 = Math.max, n2 = Math.min;
  return Ku = function(r3, o2) {
    var i2 = e10(r3);
    return i2 < 0 ? t2(i2 + o2, 0) : n2(i2, o2);
  }, Ku;
}
function gl() {
  if (Zu) return Xu;
  Zu = 1;
  var e10 = _a(), t2 = hl(), n2 = Iu(), r3 = function(r4) {
    return function(o2, i2, a2) {
      var s2 = e10(o2), u2 = n2(s2);
      if (0 === u2) return !r4 && -1;
      var l2, c3 = t2(a2, u2);
      if (r4 && i2 != i2) {
        for (; u2 > c3; ) if ((l2 = s2[c3++]) != l2) return true;
      } else for (; u2 > c3; c3++) if ((r4 || c3 in s2) && s2[c3] === i2) return r4 || c3 || 0;
      return !r4 && -1;
    };
  };
  return Xu = { includes: r3(true), indexOf: r3(false) };
}
function vl() {
  return Qu ? Ju : (Qu = 1, Ju = {});
}
function ml() {
  if (tl) return el;
  tl = 1;
  var e10 = _i2(), t2 = Bs(), n2 = _a(), r3 = gl().indexOf, o2 = vl(), i2 = e10([].push);
  return el = function(e11, a2) {
    var s2, u2 = n2(e11), l2 = 0, c3 = [];
    for (s2 in u2) !t2(o2, s2) && t2(u2, s2) && i2(c3, s2);
    for (; a2.length > l2; ) t2(u2, s2 = a2[l2++]) && (~r3(c3, s2) || i2(c3, s2));
    return c3;
  }, el;
}
function yl() {
  return rl ? nl : (rl = 1, nl = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]);
}
function bl() {
  if (il) return ol;
  il = 1;
  var e10 = ml(), t2 = yl();
  return ol = Object.keys || function(n2) {
    return e10(n2, t2);
  }, ol;
}
function El() {
  if (al) return pl;
  al = 1;
  var e10 = Vi(), t2 = Su(), n2 = xu(), r3 = Au(), o2 = _a(), i2 = bl();
  return pl.f = e10 && !t2 ? Object.defineProperties : function(e11, t3) {
    r3(e11);
    for (var a2, s2 = o2(t3), u2 = i2(t3), l2 = u2.length, c3 = 0; l2 > c3; ) n2.f(e11, a2 = u2[c3++], s2[a2]);
    return e11;
  }, pl;
}
function Cl() {
  return ul ? sl : (ul = 1, sl = Ma()("document", "documentElement"));
}
function wl() {
  if (cl) return ll;
  cl = 1;
  var e10 = Os(), t2 = Ts(), n2 = e10("keys");
  return ll = function(e11) {
    return n2[e11] || (n2[e11] = t2(e11));
  };
}
function Dl() {
  if (fl) return dl;
  fl = 1;
  var e10, t2 = Au(), n2 = El(), r3 = yl(), o2 = vl(), i2 = Cl(), a2 = Ps(), s2 = "prototype", u2 = "script", l2 = wl()("IE_PROTO"), c3 = function() {
  }, d2 = function(e11) {
    return "<" + u2 + ">" + e11 + "</" + u2 + ">";
  }, f2 = function(e11) {
    e11.write(d2("")), e11.close();
    var t3 = e11.parentWindow.Object;
    return e11 = null, t3;
  }, p2 = function() {
    try {
      e10 = new ActiveXObject("htmlfile");
    } catch (e11) {
    }
    var t3, n3, o3;
    p2 = "undefined" != typeof document ? document.domain && e10 ? f2(e10) : (n3 = a2("iframe"), o3 = "java" + u2 + ":", n3.style.display = "none", i2.appendChild(n3), n3.src = String(o3), (t3 = n3.contentWindow.document).open(), t3.write(d2("document.F=Object")), t3.close(), t3.F) : f2(e10);
    for (var l3 = r3.length; l3--; ) delete p2[s2][r3[l3]];
    return p2();
  };
  return o2[l2] = true, dl = Object.create || function(e11, r4) {
    var o3;
    return null !== e11 ? (c3[s2] = t2(e11), o3 = new c3(), c3[s2] = null, o3[l2] = e11) : o3 = p2(), void 0 === r4 ? o3 : n2.f(o3, r4);
  }, dl;
}
var Sl, Al = {};
function xl() {
  if (Sl) return Al;
  Sl = 1;
  var e10 = ml(), t2 = yl().concat("length", "prototype");
  return Al.f = Object.getOwnPropertyNames || function(n2) {
    return e10(n2, t2);
  }, Al;
}
var Ol, Nl, Bl, Tl = {};
function kl() {
  return Nl ? Ol : (Nl = 1, Ol = _i2()([].slice));
}
function Fl() {
  if (Bl) return Tl;
  Bl = 1;
  var e10 = Ri(), t2 = _a(), n2 = xl().f, r3 = kl(), o2 = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  return Tl.f = function(i2) {
    return o2 && "Window" === e10(i2) ? function(e11) {
      try {
        return n2(e11);
      } catch (e12) {
        return r3(o2);
      }
    }(i2) : n2(t2(i2));
  }, Tl;
}
var Il, Pl, _l2, Rl, Ll, Ml = {};
function jl() {
  return Il || (Il = 1, Ml.f = Object.getOwnPropertySymbols), Ml;
}
function Hl() {
  if (_l2) return Pl;
  _l2 = 1;
  var e10 = Ou();
  return Pl = function(t2, n2, r3, o2) {
    return o2 && o2.enumerable ? t2[n2] = r3 : e10(t2, n2, r3), t2;
  };
}
function zl() {
  if (Ll) return Rl;
  Ll = 1;
  var e10 = xu();
  return Rl = function(t2, n2, r3) {
    return e10.f(t2, n2, r3);
  };
}
var $l, Ul, Vl, Wl, Gl, ql, Kl, Yl, Xl, Zl, Jl, Ql, ec, tc, nc, rc, oc = {};
function ic() {
  if ($l) return oc;
  $l = 1;
  var e10 = ks();
  return oc.f = e10, oc;
}
function ac() {
  if (Vl) return Ul;
  Vl = 1;
  var e10 = La(), t2 = Bs(), n2 = ic(), r3 = xu().f;
  return Ul = function(o2) {
    var i2 = e10.Symbol || (e10.Symbol = {});
    t2(i2, o2) || r3(i2, o2, { value: n2.f(o2) });
  };
}
function sc() {
  if (Gl) return Wl;
  Gl = 1;
  var e10 = Wi(), t2 = Ma(), n2 = ks(), r3 = Hl();
  return Wl = function() {
    var o2 = t2("Symbol"), i2 = o2 && o2.prototype, a2 = i2 && i2.valueOf, s2 = n2("toPrimitive");
    i2 && !i2[s2] && r3(i2, s2, function(t3) {
      return e10(a2, this);
    }, { arity: 1 });
  };
}
function uc() {
  if (Kl) return ql;
  Kl = 1;
  var e10 = Ru(), t2 = Lu();
  return ql = e10 ? {}.toString : function() {
    return "[object " + t2(this) + "]";
  };
}
function lc() {
  if (Xl) return Yl;
  Xl = 1;
  var e10 = Ru(), t2 = xu().f, n2 = Ou(), r3 = Bs(), o2 = uc(), i2 = ks()("toStringTag");
  return Yl = function(a2, s2, u2, l2) {
    var c3 = u2 ? a2 : a2 && a2.prototype;
    c3 && (r3(c3, i2) || t2(c3, i2, { configurable: true, value: s2 }), l2 && !e10 && n2(c3, "toString", o2));
  };
}
function cc() {
  if (Jl) return Zl;
  Jl = 1;
  var e10 = ki(), t2 = Mi(), n2 = e10.WeakMap;
  return Zl = t2(n2) && /native code/.test(String(n2));
}
function dc() {
  if (ec) return Ql;
  ec = 1;
  var e10, t2, n2, r3 = cc(), o2 = ki(), i2 = Ra(), a2 = Ou(), s2 = Bs(), u2 = xs(), l2 = wl(), c3 = vl(), d2 = "Object already initialized", f2 = o2.TypeError, p2 = o2.WeakMap;
  if (r3 || u2.state) {
    var h2 = u2.state || (u2.state = new p2());
    h2.get = h2.get, h2.has = h2.has, h2.set = h2.set, e10 = function(e11, t3) {
      if (h2.has(e11)) throw new f2(d2);
      return t3.facade = e11, h2.set(e11, t3), t3;
    }, t2 = function(e11) {
      return h2.get(e11) || {};
    }, n2 = function(e11) {
      return h2.has(e11);
    };
  } else {
    var g2 = l2("state");
    c3[g2] = true, e10 = function(e11, t3) {
      if (s2(e11, g2)) throw new f2(d2);
      return t3.facade = e11, a2(e11, g2, t3), t3;
    }, t2 = function(e11) {
      return s2(e11, g2) ? e11[g2] : {};
    }, n2 = function(e11) {
      return s2(e11, g2);
    };
  }
  return Ql = { set: e10, get: t2, has: n2, enforce: function(r4) {
    return n2(r4) ? t2(r4) : e10(r4, {});
  }, getterFor: function(e11) {
    return function(n3) {
      var r4;
      if (!i2(n3) || (r4 = t2(n3)).type !== e11) throw new f2("Incompatible receiver, " + e11 + " required");
      return r4;
    };
  } };
}
function fc() {
  if (nc) return tc;
  nc = 1;
  var e10 = Ms(), t2 = _i2(), n2 = Fa(), r3 = Ns(), o2 = Iu(), i2 = zu(), a2 = t2([].push), s2 = function(t3) {
    var s3 = 1 === t3, u2 = 2 === t3, l2 = 3 === t3, c3 = 4 === t3, d2 = 6 === t3, f2 = 7 === t3, p2 = 5 === t3 || d2;
    return function(h2, g2, v2, m2) {
      for (var y2, b2, E2 = r3(h2), C2 = n2(E2), w2 = o2(C2), D2 = e10(g2, v2), S2 = 0, A2 = m2 || i2, x2 = s3 ? A2(h2, w2) : u2 || f2 ? A2(h2, 0) : void 0; w2 > S2; S2++) if ((p2 || S2 in C2) && (b2 = D2(y2 = C2[S2], S2, E2), t3)) if (s3) x2[S2] = b2;
      else if (b2) switch (t3) {
        case 3:
          return true;
        case 5:
          return y2;
        case 6:
          return S2;
        case 2:
          a2(x2, y2);
      }
      else switch (t3) {
        case 4:
          return false;
        case 7:
          a2(x2, y2);
      }
      return d2 ? -1 : l2 || c3 ? c3 : x2;
    };
  };
  return tc = { forEach: s2(0), map: s2(1), filter: s2(2), some: s2(3), every: s2(4), find: s2(5), findIndex: s2(6), filterReject: s2(7) };
}
var pc, hc, gc, vc = {};
function mc() {
  return hc ? pc : (hc = 1, pc = $a() && !!Symbol.for && !!Symbol.keyFor);
}
var yc, bc = {};
var Ec, Cc, wc, Dc, Sc, Ac, xc, Oc = {};
function Nc() {
  if (Cc) return Ec;
  Cc = 1;
  var e10 = Ra(), t2 = dc().get;
  return Ec = function(n2) {
    if (!e10(n2)) return false;
    var r3 = t2(n2);
    return !!r3 && "RawJSON" === r3.type;
  }, Ec;
}
function Bc() {
  if (Dc) return wc;
  Dc = 1;
  var e10 = _i2(), t2 = Bs(), n2 = SyntaxError, r3 = parseInt, o2 = String.fromCharCode, i2 = e10("".charAt), a2 = e10("".slice), s2 = e10(/./.exec), u2 = { '\\"': '"', "\\\\": "\\", "\\/": "/", "\\b": "\b", "\\f": "\f", "\\n": "\n", "\\r": "\r", "\\t": "	" }, l2 = /^[\da-f]{4}$/i, c3 = /^[\u0000-\u001F]$/;
  return wc = function(e11, d2) {
    for (var f2 = true, p2 = ""; d2 < e11.length; ) {
      var h2 = i2(e11, d2);
      if ("\\" === h2) {
        var g2 = a2(e11, d2, d2 + 2);
        if (t2(u2, g2)) p2 += u2[g2], d2 += 2;
        else {
          if ("\\u" !== g2) throw new n2('Unknown escape sequence: "' + g2 + '"');
          var v2 = a2(e11, d2 += 2, d2 + 4);
          if (!s2(l2, v2)) throw new n2("Bad Unicode escape at: " + d2);
          p2 += o2(r3(v2, 16)), d2 += 4;
        }
      } else {
        if ('"' === h2) {
          f2 = false, d2++;
          break;
        }
        if (s2(c3, h2)) throw new n2("Bad control character in string literal at: " + d2);
        p2 += h2, d2++;
      }
    }
    if (f2) throw new n2("Unterminated string at: " + d2);
    return { value: p2, end: d2 };
  }, wc;
}
function Tc() {
  return Ac ? Sc : (Ac = 1, Sc = !Fi()(function() {
    var e10 = "9007199254740993", t2 = JSON.rawJSON(e10);
    return !JSON.isRawJSON(t2) || JSON.stringify(t2) !== e10;
  }));
}
var kc, Fc, Ic = {};
function Pc() {
  return Fc || (Fc = 1, function() {
    if (rc) return Gu;
    rc = 1;
    var e10 = Nu(), t2 = ki(), n2 = Wi(), r3 = _i2(), o2 = Ss(), i2 = Vi(), a2 = $a(), s2 = Fi(), u2 = Bs(), l2 = ja(), c3 = Au(), d2 = _a(), f2 = Is(), p2 = qu(), h2 = ka(), g2 = Dl(), v2 = bl(), m2 = xl(), y2 = Fl(), b2 = jl(), E2 = Rs(), C2 = xu(), w2 = El(), D2 = Ta(), S2 = Hl(), A2 = zl(), x2 = Os(), O2 = wl(), N2 = vl(), B2 = Ts(), T2 = ks(), k2 = ic(), F2 = ac(), I2 = sc(), P2 = lc(), _2 = dc(), R2 = fc().forEach, L2 = O2("hidden"), M2 = "Symbol", j2 = "prototype", H2 = _2.set, z2 = _2.getterFor(M2), $2 = Object[j2], U2 = t2.Symbol, V2 = U2 && U2[j2], W2 = t2.RangeError, G2 = t2.TypeError, q2 = t2.QObject, K2 = E2.f, Y2 = C2.f, X2 = y2.f, Z2 = D2.f, J2 = r3([].push), Q2 = x2("symbols"), ee2 = x2("op-symbols"), te2 = x2("wks"), ne2 = !q2 || !q2[j2] || !q2[j2].findChild, re2 = function(e11, t3, n3) {
      var r4 = K2($2, t3);
      r4 && delete $2[t3], Y2(e11, t3, n3), r4 && e11 !== $2 && Y2($2, t3, r4);
    }, oe2 = i2 && s2(function() {
      return 7 !== g2(Y2({}, "a", { get: function() {
        return Y2(this, "a", { value: 7 }).a;
      } })).a;
    }) ? re2 : Y2, ie2 = function(e11, t3) {
      var n3 = Q2[e11] = g2(V2);
      return H2(n3, { type: M2, tag: e11, description: t3 }), i2 || (n3.description = t3), n3;
    }, ae2 = function(e11, t3, n3) {
      e11 === $2 && ae2(ee2, t3, n3), c3(e11);
      var r4 = f2(t3);
      return c3(n3), u2(Q2, r4) ? (n3.enumerable ? (u2(e11, L2) && e11[L2][r4] && (e11[L2][r4] = false), n3 = g2(n3, { enumerable: h2(0, false) })) : (u2(e11, L2) || Y2(e11, L2, h2(1, g2(null))), e11[L2][r4] = true), oe2(e11, r4, n3)) : Y2(e11, r4, n3);
    }, se2 = function(e11, t3) {
      c3(e11);
      var r4 = d2(t3), o3 = v2(r4).concat(de2(r4));
      return R2(o3, function(t4) {
        i2 && !n2(ue2, r4, t4) || ae2(e11, t4, r4[t4]);
      }), e11;
    }, ue2 = function(e11) {
      var t3 = f2(e11), r4 = n2(Z2, this, t3);
      return !(this === $2 && u2(Q2, t3) && !u2(ee2, t3)) && (!(r4 || !u2(this, t3) || !u2(Q2, t3) || u2(this, L2) && this[L2][t3]) || r4);
    }, le2 = function(e11, t3) {
      var n3 = d2(e11), r4 = f2(t3);
      if (n3 !== $2 || !u2(Q2, r4) || u2(ee2, r4)) {
        var o3 = K2(n3, r4);
        return !o3 || !u2(Q2, r4) || u2(n3, L2) && n3[L2][r4] || (o3.enumerable = true), o3;
      }
    }, ce2 = function(e11) {
      var t3 = X2(d2(e11)), n3 = [];
      return R2(t3, function(e12) {
        u2(Q2, e12) || u2(N2, e12) || J2(n3, e12);
      }), n3;
    }, de2 = function(e11) {
      var t3 = e11 === $2, n3 = X2(t3 ? ee2 : d2(e11)), r4 = [];
      return R2(n3, function(e12) {
        !u2(Q2, e12) || t3 && !u2($2, e12) || J2(r4, Q2[e12]);
      }), r4;
    };
    a2 || (U2 = function() {
      if (l2(V2, this)) throw new G2("Symbol is not a constructor");
      var e11 = arguments.length && void 0 !== arguments[0] ? p2(arguments[0]) : void 0, r4 = B2(e11), o3 = function(e12) {
        var i3 = void 0 === this ? t2 : this;
        i3 === $2 && n2(o3, ee2, e12), u2(i3, L2) && u2(i3[L2], r4) && (i3[L2][r4] = false);
        var a3 = h2(1, e12);
        try {
          oe2(i3, r4, a3);
        } catch (e13) {
          if (!(e13 instanceof W2)) throw e13;
          re2(i3, r4, a3);
        }
      };
      return i2 && ne2 && oe2($2, r4, { configurable: true, set: o3 }), ie2(r4, e11);
    }, S2(V2 = U2[j2], "toString", function() {
      return z2(this).tag;
    }), S2(U2, "withoutSetter", function(e11) {
      return ie2(B2(e11), e11);
    }), D2.f = ue2, C2.f = ae2, w2.f = se2, E2.f = le2, m2.f = y2.f = ce2, b2.f = de2, k2.f = function(e11) {
      return ie2(T2(e11), e11);
    }, i2 && (A2(V2, "description", { configurable: true, get: function() {
      return z2(this).description;
    } }), o2 || S2($2, "propertyIsEnumerable", ue2, { unsafe: true }))), e10({ global: true, constructor: true, wrap: true, forced: !a2, sham: !a2 }, { Symbol: U2 }), R2(v2(te2), function(e11) {
      F2(e11);
    }), e10({ target: M2, stat: true, forced: !a2 }, { useSetter: function() {
      ne2 = true;
    }, useSimple: function() {
      ne2 = false;
    } }), e10({ target: "Object", stat: true, forced: !a2, sham: !i2 }, { create: function(e11, t3) {
      return void 0 === t3 ? g2(e11) : se2(g2(e11), t3);
    }, defineProperty: ae2, defineProperties: se2, getOwnPropertyDescriptor: le2 }), e10({ target: "Object", stat: true, forced: !a2 }, { getOwnPropertyNames: ce2 }), I2(), P2(U2, M2), N2[L2] = true;
  }(), function() {
    if (gc) return vc;
    gc = 1;
    var e10 = Nu(), t2 = Ma(), n2 = Bs(), r3 = qu(), o2 = Os(), i2 = mc(), a2 = o2("string-to-symbol-registry"), s2 = o2("symbol-to-string-registry");
    e10({ target: "Symbol", stat: true, forced: !i2 }, { for: function(e11) {
      var o3 = r3(e11);
      if (n2(a2, o3)) return a2[o3];
      var i3 = t2("Symbol")(o3);
      return a2[o3] = i3, s2[i3] = o3, i3;
    } });
  }(), function() {
    if (yc) return bc;
    yc = 1;
    var e10 = Nu(), t2 = Bs(), n2 = Va(), r3 = Wa(), o2 = Os(), i2 = mc(), a2 = o2("symbol-to-string-registry");
    e10({ target: "Symbol", stat: true, forced: !i2 }, { keyFor: function(e11) {
      if (!n2(e11)) throw new TypeError(r3(e11) + " is not a symbol");
      if (t2(a2, e11)) return a2[e11];
    } });
  }(), function() {
    if (xc) return Oc;
    xc = 1;
    var e10 = Nu(), t2 = Ma(), n2 = Pi(), r3 = Wi(), o2 = _i2(), i2 = Fi(), a2 = Bu(), s2 = Mi(), u2 = Nc(), l2 = Va(), c3 = Ri(), d2 = qu(), f2 = kl(), p2 = Bc(), h2 = Ts(), g2 = $a(), v2 = Tc(), m2 = String, y2 = t2("JSON", "stringify"), b2 = o2(/./.exec), E2 = o2("".charAt), C2 = o2("".charCodeAt), w2 = o2("".replace), D2 = o2("".slice), S2 = o2([].push), A2 = o2(1.1.toString), x2 = /[\uD800-\uDFFF]/g, O2 = /^[\uD800-\uDBFF]$/, N2 = /^[\uDC00-\uDFFF]$/, B2 = h2(), T2 = B2.length, k2 = !g2 || i2(function() {
      var e11 = t2("Symbol")("stringify detection");
      return "[null]" !== y2([e11]) || "{}" !== y2({ a: e11 }) || "{}" !== y2(Object(e11));
    }), F2 = i2(function() {
      return '"\\udf06\\ud834"' !== y2("\uDF06\uD834") || '"\\udead"' !== y2("\uDEAD");
    }), I2 = k2 ? function(e11, t3) {
      var o3 = f2(arguments), i3 = _2(t3);
      if (s2(i3) || void 0 !== e11 && !l2(e11)) return o3[1] = function(e12, t4) {
        if (s2(i3) && (t4 = r3(i3, this, m2(e12), t4)), !l2(t4)) return t4;
      }, n2(y2, null, o3);
    } : y2, P2 = function(e11, t3, n3) {
      var r4 = E2(n3, t3 - 1), o3 = E2(n3, t3 + 1);
      return b2(O2, e11) && !b2(N2, o3) || b2(N2, e11) && !b2(O2, r4) ? "\\u" + A2(C2(e11, 0), 16) : e11;
    }, _2 = function(e11) {
      if (s2(e11)) return e11;
      if (a2(e11)) {
        for (var t3 = e11.length, n3 = [], r4 = 0; r4 < t3; r4++) {
          var o3 = e11[r4];
          "string" == typeof o3 ? S2(n3, o3) : "number" != typeof o3 && "Number" !== c3(o3) && "String" !== c3(o3) || S2(n3, d2(o3));
        }
        var i3 = n3.length, u3 = true;
        return function(e12, t4) {
          if (u3) return u3 = false, t4;
          if (a2(this)) return t4;
          for (var r5 = 0; r5 < i3; r5++) if (n3[r5] === e12) return t4;
        };
      }
    };
    y2 && e10({ target: "JSON", stat: true, arity: 3, forced: k2 || F2 || !v2 }, { stringify: function(e11, t3, n3) {
      var o3 = _2(t3), i3 = [], a3 = I2(e11, function(e12, t4) {
        var n4 = s2(o3) ? r3(o3, this, m2(e12), t4) : t4;
        return !v2 && u2(n4) ? B2 + (S2(i3, n4.rawJSON) - 1) : n4;
      }, n3);
      if ("string" != typeof a3) return a3;
      if (F2 && (a3 = w2(a3, x2, P2)), v2) return a3;
      for (var l3 = "", c4 = a3.length, d3 = 0; d3 < c4; d3++) {
        var f3 = E2(a3, d3);
        if ('"' === f3) {
          var h3 = p2(a3, ++d3).end - 1, g3 = D2(a3, d3, h3);
          l3 += D2(g3, 0, T2) === B2 ? i3[D2(g3, T2)] : '"' + g3 + '"', d3 = h3;
        } else l3 += f3;
      }
      return l3;
    } });
  }(), function() {
    if (kc) return Ic;
    kc = 1;
    var e10 = Nu(), t2 = $a(), n2 = Fi(), r3 = jl(), o2 = Ns();
    e10({ target: "Object", stat: true, forced: !t2 || n2(function() {
      r3.f(1);
    }) }, { getOwnPropertySymbols: function(e11) {
      var t3 = r3.f;
      return t3 ? t3(o2(e11)) : [];
    } });
  }()), Wu;
}
var _c2, Rc = {};
function Lc() {
  return _c2 || (_c2 = 1, ac()("asyncDispose")), Rc;
}
var Mc;
var jc, Hc = {};
function zc() {
  return jc || (jc = 1, ac()("dispose")), Hc;
}
var $c;
var Uc;
var Vc, Wc = {};
function Gc() {
  return Vc || (Vc = 1, ac()("iterator")), Wc;
}
var qc;
var Kc;
var Yc;
var Xc;
var Zc;
var Jc;
var Qc, ed = {};
var td, nd = {};
var rd;
var od, id, ad, sd = {};
function ud() {
  return ad ? id : (ad = 1, function() {
    if (wu) return Ti;
    wu = 1;
    var e10 = Nu(), t2 = Fi(), n2 = Bu(), r3 = Ra(), o2 = Ns(), i2 = Iu(), a2 = Pu(), s2 = _u2(), u2 = zu(), l2 = $u(), c3 = ks(), d2 = za(), f2 = c3("isConcatSpreadable"), p2 = d2 >= 51 || !t2(function() {
      var e11 = [];
      return e11[f2] = false, e11.concat()[0] !== e11;
    }), h2 = function(e11) {
      if (!r3(e11)) return false;
      var t3 = e11[f2];
      return void 0 !== t3 ? !!t3 : n2(e11);
    };
    e10({ target: "Array", proto: true, arity: 1, forced: !p2 || !l2("concat") }, { concat: function(e11) {
      var t3, n3, r4, l3, c4, d3 = o2(this), f3 = u2(d3, 0), p3 = 0;
      for (t3 = -1, r4 = arguments.length; t3 < r4; t3++) if (h2(c4 = -1 === t3 ? d3 : arguments[t3])) for (l3 = i2(c4), a2(p3 + l3), n3 = 0; n3 < l3; n3++, p3++) n3 in c4 && s2(f3, p3, c4[n3]);
      else a2(p3 + 1), s2(f3, p3++, c4);
      return f3.length = p3, f3;
    } });
  }(), Pc(), Lc(), Mc || (Mc = 1, ac()("asyncIterator")), zc(), $c || ($c = 1, ac()("hasInstance")), Uc || (Uc = 1, ac()("isConcatSpreadable")), Gc(), qc || (qc = 1, ac()("match")), Kc || (Kc = 1, ac()("matchAll")), Yc || (Yc = 1, ac()("replace")), Xc || (Xc = 1, ac()("search")), Zc || (Zc = 1, ac()("species")), Jc || (Jc = 1, ac()("split")), function() {
    if (Qc) return ed;
    Qc = 1;
    var e10 = ac(), t2 = sc();
    e10("toPrimitive"), t2();
  }(), function() {
    if (td) return nd;
    td = 1;
    var e10 = Ma(), t2 = ac(), n2 = lc();
    t2("toStringTag"), n2(e10("Symbol"), "Symbol");
  }(), rd || (rd = 1, ac()("unscopables")), function() {
    if (od) return sd;
    od = 1;
    var e10 = ki();
    lc()(e10.JSON, "JSON", true);
  }(), id = La().Symbol);
}
var ld, cd, dd, fd, pd, hd, gd, vd, md, yd, bd, Ed, Cd, wd, Dd, Sd, Ad, xd, Od, Nd, Bd, Td, kd, Fd, Id, Pd, _d2, Rd, Ld, Md, jd, Hd, zd, $d = {};
function Ud() {
  return cd ? ld : (cd = 1, ld = function() {
  });
}
function Vd() {
  return fd ? dd : (fd = 1, dd = {});
}
function Wd() {
  if (hd) return pd;
  hd = 1;
  var e10 = Vi(), t2 = Bs(), n2 = Function.prototype, r3 = e10 && Object.getOwnPropertyDescriptor, o2 = t2(n2, "name"), i2 = o2 && "something" === (function() {
  }).name, a2 = o2 && (!e10 || e10 && r3(n2, "name").configurable);
  return pd = { EXISTS: o2, PROPER: i2, CONFIGURABLE: a2 };
}
function Gd() {
  return vd || (vd = 1, gd = !Fi()(function() {
    function e10() {
    }
    return e10.prototype.constructor = null, Object.getPrototypeOf(new e10()) !== e10.prototype;
  })), gd;
}
function qd() {
  if (yd) return md;
  yd = 1;
  var e10 = Bs(), t2 = Mi(), n2 = Ns(), r3 = wl(), o2 = Gd(), i2 = r3("IE_PROTO"), a2 = Object, s2 = a2.prototype;
  return md = o2 ? a2.getPrototypeOf : function(r4) {
    var o3 = n2(r4);
    if (e10(o3, i2)) return o3[i2];
    var u2 = o3.constructor;
    return t2(u2) && o3 instanceof u2 ? u2.prototype : o3 instanceof a2 ? s2 : null;
  }, md;
}
function Kd() {
  if (Ed) return bd;
  Ed = 1;
  var e10, t2, n2, r3 = Fi(), o2 = Mi(), i2 = Ra(), a2 = Dl(), s2 = qd(), u2 = Hl(), l2 = ks(), c3 = Ss(), d2 = l2("iterator"), f2 = false;
  return [].keys && ("next" in (n2 = [].keys()) ? (t2 = s2(s2(n2))) !== Object.prototype && (e10 = t2) : f2 = true), !i2(e10) || r3(function() {
    var t3 = {};
    return e10[d2].call(t3) !== t3;
  }) ? e10 = {} : c3 && (e10 = a2(e10)), o2(e10[d2]) || u2(e10, d2, function() {
    return this;
  }), bd = { IteratorPrototype: e10, BUGGY_SAFARI_ITERATORS: f2 };
}
function Yd() {
  if (wd) return Cd;
  wd = 1;
  var e10 = Kd().IteratorPrototype, t2 = Dl(), n2 = ka(), r3 = lc(), o2 = Vd(), i2 = function() {
    return this;
  };
  return Cd = function(a2, s2, u2, l2) {
    var c3 = s2 + " Iterator";
    return a2.prototype = t2(e10, { next: n2(+!l2, u2) }), r3(a2, c3, false, true), o2[c3] = i2, a2;
  };
}
function Xd() {
  if (Sd) return Dd;
  Sd = 1;
  var e10 = _i2(), t2 = Ga();
  return Dd = function(n2, r3, o2) {
    try {
      return e10(t2(Object.getOwnPropertyDescriptor(n2, r3)[o2]));
    } catch (e11) {
    }
  };
}
function Zd() {
  if (xd) return Ad;
  xd = 1;
  var e10 = Ra();
  return Ad = function(t2) {
    return e10(t2) || null === t2;
  };
}
function Jd() {
  if (Nd) return Od;
  Nd = 1;
  var e10 = Zd(), t2 = String, n2 = TypeError;
  return Od = function(r3) {
    if (e10(r3)) return r3;
    throw new n2("Can't set " + t2(r3) + " as a prototype");
  };
}
function Qd() {
  if (Td) return Bd;
  Td = 1;
  var e10 = Xd(), t2 = Ra(), n2 = Pa(), r3 = Jd();
  return Bd = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var o2, i2 = false, a2 = {};
    try {
      (o2 = e10(Object.prototype, "__proto__", "set"))(a2, []), i2 = a2 instanceof Array;
    } catch (e11) {
    }
    return function(e11, a3) {
      return n2(e11), r3(a3), t2(e11) ? (i2 ? o2(e11, a3) : e11.__proto__ = a3, e11) : e11;
    };
  }() : void 0), Bd;
}
function ef() {
  if (Fd) return kd;
  Fd = 1;
  var e10 = Nu(), t2 = Wi(), n2 = Ss(), r3 = Wd(), o2 = Mi(), i2 = Yd(), a2 = qd(), s2 = Qd(), u2 = lc(), l2 = Ou(), c3 = Hl(), d2 = ks(), f2 = Vd(), p2 = Kd(), h2 = r3.PROPER, g2 = r3.CONFIGURABLE, v2 = p2.IteratorPrototype, m2 = p2.BUGGY_SAFARI_ITERATORS, y2 = d2("iterator"), b2 = "keys", E2 = "values", C2 = "entries", w2 = function() {
    return this;
  };
  return kd = function(r4, d3, p3, D2, S2, A2, x2) {
    i2(p3, d3, D2);
    var O2, N2, B2, T2 = function(e11) {
      if (e11 === S2 && _2) return _2;
      if (!m2 && e11 && e11 in I2) return I2[e11];
      switch (e11) {
        case b2:
        case E2:
        case C2:
          return function() {
            return new p3(this, e11);
          };
      }
      return function() {
        return new p3(this);
      };
    }, k2 = d3 + " Iterator", F2 = false, I2 = r4.prototype, P2 = I2[y2] || I2["@@iterator"] || S2 && I2[S2], _2 = !m2 && P2 || T2(S2), R2 = "Array" === d3 && I2.entries || P2;
    if (R2 && (O2 = a2(R2.call(new r4()))) !== Object.prototype && O2.next && (n2 || a2(O2) === v2 || (s2 ? s2(O2, v2) : o2(O2[y2]) || c3(O2, y2, w2)), u2(O2, k2, true, true), n2 && (f2[k2] = w2)), h2 && S2 === E2 && P2 && P2.name !== E2 && (!n2 && g2 ? l2(I2, "name", E2) : (F2 = true, _2 = function() {
      return t2(P2, this);
    })), S2) if (N2 = { values: T2(E2), keys: A2 ? _2 : T2(b2), entries: T2(C2) }, x2) for (B2 in N2) (m2 || F2 || !(B2 in I2)) && c3(I2, B2, N2[B2]);
    else e10({ target: d3, proto: true, forced: m2 || F2 }, N2);
    return n2 && !x2 || I2[y2] === _2 || c3(I2, y2, _2, { name: S2 }), f2[d3] = _2, N2;
  };
}
function tf() {
  return Pd ? Id : (Pd = 1, Id = function(e10, t2) {
    return { value: e10, done: t2 };
  });
}
function nf() {
  if (Rd) return _d2;
  Rd = 1;
  var e10 = _a(), t2 = Ud(), n2 = Vd(), r3 = dc(), o2 = xu().f, i2 = ef(), a2 = tf(), s2 = Ss(), u2 = Vi(), l2 = "Array Iterator", c3 = r3.set, d2 = r3.getterFor(l2);
  _d2 = i2(Array, "Array", function(t3, n3) {
    c3(this, { type: l2, target: e10(t3), index: 0, kind: n3 });
  }, function() {
    var e11 = d2(this), t3 = e11.target, n3 = e11.index++;
    if (!t3 || n3 >= t3.length) return e11.target = null, a2(void 0, true);
    switch (e11.kind) {
      case "keys":
        return a2(n3, false);
      case "values":
        return a2(t3[n3], false);
    }
    return a2([n3, t3[n3]], false);
  }, "values");
  var f2 = n2.Arguments = n2.Array;
  if (t2("keys"), t2("values"), t2("entries"), !s2 && u2 && "values" !== f2.name) try {
    o2(f2, "name", { value: "values" });
  } catch (e11) {
  }
  return _d2;
}
function rf() {
  return Md ? Ld : (Md = 1, Ld = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 });
}
function of() {
  if (jd) return $d;
  jd = 1, nf();
  var e10 = rf(), t2 = ki(), n2 = lc(), r3 = Vd();
  for (var o2 in e10) n2(t2[o2], o2), r3[o2] = r3.Array;
  return $d;
}
function af() {
  if (zd) return Hd;
  zd = 1;
  var e10 = ud();
  return of(), Hd = e10;
}
var sf, uf = {};
var lf;
var cf;
var df, ff, pf;
function hf() {
  if (pf) return ff;
  pf = 1;
  var e10 = af();
  return function() {
    if (sf) return uf;
    sf = 1;
    var e11 = ks(), t2 = xu().f, n2 = e11("metadata"), r3 = Function.prototype;
    void 0 === r3[n2] && t2(r3, n2, { value: null });
  }(), lf || (lf = 1, Lc()), cf || (cf = 1, zc()), df || (df = 1, ac()("metadata")), ff = e10;
}
var gf, vf, mf;
function yf() {
  if (vf) return gf;
  vf = 1;
  var e10 = Ma(), t2 = _i2(), n2 = e10("Symbol"), r3 = n2.keyFor, o2 = t2(n2.prototype.valueOf);
  return gf = n2.isRegisteredSymbol || function(e11) {
    try {
      return void 0 !== r3(o2(e11));
    } catch (e12) {
      return false;
    }
  };
}
var bf, Ef, Cf;
function wf() {
  if (Ef) return bf;
  Ef = 1;
  for (var e10 = Os(), t2 = Ma(), n2 = _i2(), r3 = Va(), o2 = ks(), i2 = t2("Symbol"), a2 = i2.isWellKnownSymbol, s2 = t2("Object", "getOwnPropertyNames"), u2 = n2(i2.prototype.valueOf), l2 = e10("wks"), c3 = 0, d2 = s2(i2), f2 = d2.length; c3 < f2; c3++) try {
    var p2 = d2[c3];
    r3(i2[p2]) && o2(p2);
  } catch (e11) {
  }
  return bf = function(e11) {
    if (a2 && a2(e11)) return true;
    try {
      for (var t3 = u2(e11), n3 = 0, r4 = s2(l2), o3 = r4.length; n3 < o3; n3++) if (l2[r4[n3]] == t3) return true;
    } catch (e12) {
    }
    return false;
  }, bf;
}
var Df;
var Sf;
var Af;
var xf;
var Of;
var Nf;
var Bf;
var Tf, kf, Ff, If, Pf;
function _f2() {
  if (Ff) return kf;
  Ff = 1;
  var e10 = hf();
  return mf || (mf = 1, Nu()({ target: "Symbol", stat: true }, { isRegisteredSymbol: yf() })), Cf || (Cf = 1, Nu()({ target: "Symbol", stat: true, forced: true }, { isWellKnownSymbol: wf() })), Df || (Df = 1, ac()("customMatcher")), Sf || (Sf = 1, ac()("observable")), Af || (Af = 1, Nu()({ target: "Symbol", stat: true, name: "isRegisteredSymbol" }, { isRegistered: yf() })), xf || (xf = 1, Nu()({ target: "Symbol", stat: true, name: "isWellKnownSymbol", forced: true }, { isWellKnown: wf() })), Of || (Of = 1, ac()("matcher")), Nf || (Nf = 1, ac()("metadataKey")), Bf || (Bf = 1, ac()("patternMatch")), Tf || (Tf = 1, ac()("replaceAll")), kf = e10;
}
function Rf() {
  return Pf ? If : (Pf = 1, If = _f2());
}
var Lf, Mf, jf, Hf, zf, $f, Uf, Vf, Wf, Gf, qf, Kf, Yf, Xf = b(Rf()), Zf = {};
function Jf() {
  if (Mf) return Lf;
  Mf = 1;
  var e10 = _i2(), t2 = ku(), n2 = qu(), r3 = Pa(), o2 = e10("".charAt), i2 = e10("".charCodeAt), a2 = e10("".slice), s2 = function(e11) {
    return function(s3, u2) {
      var l2, c3, d2 = n2(r3(s3)), f2 = t2(u2), p2 = d2.length;
      return f2 < 0 || f2 >= p2 ? e11 ? "" : void 0 : (l2 = i2(d2, f2)) < 55296 || l2 > 56319 || f2 + 1 === p2 || (c3 = i2(d2, f2 + 1)) < 56320 || c3 > 57343 ? e11 ? o2(d2, f2) : l2 : e11 ? a2(d2, f2, f2 + 2) : c3 - 56320 + (l2 - 55296 << 10) + 65536;
    };
  };
  return Lf = { codeAt: s2(false), charAt: s2(true) };
}
function Qf() {
  return zf ? Hf : (zf = 1, nf(), function() {
    if (jf) return Zf;
    jf = 1;
    var e10 = Jf().charAt, t2 = qu(), n2 = dc(), r3 = ef(), o2 = tf(), i2 = "String Iterator", a2 = n2.set, s2 = n2.getterFor(i2);
    r3(String, "String", function(e11) {
      a2(this, { type: i2, string: t2(e11), index: 0 });
    }, function() {
      var t3, n3 = s2(this), r4 = n3.string, i3 = n3.index;
      return i3 >= r4.length ? o2(void 0, true) : (t3 = e10(r4, i3), n3.index += t3.length, o2(t3, false));
    });
  }(), Gc(), Hf = ic().f("iterator"));
}
function ep() {
  if (Uf) return $f;
  Uf = 1;
  var e10 = Qf();
  return of(), $f = e10;
}
function tp() {
  return Wf ? Vf : (Wf = 1, Vf = ep());
}
function np() {
  return qf ? Gf : (qf = 1, Gf = tp());
}
function rp() {
  return Yf ? Kf : (Yf = 1, Kf = np());
}
var op = b(rp());
function ip(e10) {
  return ip = "function" == typeof Xf && "symbol" == typeof op ? function(e11) {
    return typeof e11;
  } : function(e11) {
    return e11 && "function" == typeof Xf && e11.constructor === Xf && e11 !== Xf.prototype ? "symbol" : typeof e11;
  }, ip(e10);
}
var ap, sp = {};
if (function() {
  if (ap) return sp;
  ap = 1;
  var e10 = fr(), t2 = C(), n2 = N(), r3 = gn().f, o2 = Ae();
  e10({ target: "Object", stat: true, forced: !o2 || t2(function() {
    r3(1);
  }), sham: !o2 }, { getOwnPropertyDescriptor: function(e11, t3) {
    return r3(n2(e11), t3);
  } });
}(), "object" === ("undefined" == typeof global ? "undefined" : ip(global))) {
  var up = Object.getOwnPropertyDescriptor(global, "window");
  global.window && !up.set || (global.window = global, global.requestAnimationFrame = function() {
  }, global.navigator = { userAgent: "" }, global.location = { hostname: "0.0.0.0", port: 0, protocol: "http:" }, global.btoa = function() {
  }, global.crypto = { getRandomValues: function(e10) {
    return nodeCrypto.randomFillSync(e10);
  } }), null != global.document && null == global.document.getElementsByTagName && (global.document.getElementsByTagName = function() {
    return [];
  });
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function lp(e10) {
  return "[object Object]" === Object.prototype.toString.call(e10);
}
function cp(e10) {
  var t2, n2;
  return false !== lp(e10) && (void 0 === (t2 = e10.constructor) || false !== lp(n2 = t2.prototype) && false !== n2.hasOwnProperty("isPrototypeOf"));
}
function dp(e10) {
  for (var t2 = arguments.length, n2 = Array(t2 > 1 ? t2 - 1 : 0), r3 = 1; r3 < t2; r3++) n2[r3 - 1] = arguments[r3];
  throw Error("[Immer] minified error nr: " + e10 + (n2.length ? " " + n2.map(function(e11) {
    return "'" + e11 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function fp(e10) {
  return !!e10 && !!e10[Zp];
}
function pp(e10) {
  var t2;
  return !!e10 && (function(e11) {
    if (!e11 || "object" != typeof e11) return false;
    var t3 = Object.getPrototypeOf(e11);
    if (null === t3) return true;
    var n2 = Object.hasOwnProperty.call(t3, "constructor") && t3.constructor;
    return n2 === Object || "function" == typeof n2 && Function.toString.call(n2) === Jp;
  }(e10) || Array.isArray(e10) || !!e10[Xp] || !!(null === (t2 = e10.constructor) || void 0 === t2 ? void 0 : t2[Xp]) || yp(e10) || bp(e10));
}
function hp(e10, t2, n2) {
  void 0 === n2 && (n2 = false), 0 === gp(e10) ? (n2 ? Object.keys : Qp)(e10).forEach(function(r3) {
    n2 && "symbol" == typeof r3 || t2(r3, e10[r3], e10);
  }) : e10.forEach(function(n3, r3) {
    return t2(r3, n3, e10);
  });
}
function gp(e10) {
  var t2 = e10[Zp];
  return t2 ? t2.i > 3 ? t2.i - 4 : t2.i : Array.isArray(e10) ? 1 : yp(e10) ? 2 : bp(e10) ? 3 : 0;
}
function vp(e10, t2) {
  return 2 === gp(e10) ? e10.has(t2) : Object.prototype.hasOwnProperty.call(e10, t2);
}
function mp(e10, t2, n2) {
  var r3 = gp(e10);
  2 === r3 ? e10.set(t2, n2) : 3 === r3 ? e10.add(n2) : e10[t2] = n2;
}
function yp(e10) {
  return Gp && e10 instanceof Map;
}
function bp(e10) {
  return qp && e10 instanceof Set;
}
function Ep(e10) {
  return e10.o || e10.t;
}
function Cp(e10) {
  if (Array.isArray(e10)) return Array.prototype.slice.call(e10);
  var t2 = eh(e10);
  delete t2[Zp];
  for (var n2 = Qp(t2), r3 = 0; r3 < n2.length; r3++) {
    var o2 = n2[r3], i2 = t2[o2];
    false === i2.writable && (i2.writable = true, i2.configurable = true), (i2.get || i2.set) && (t2[o2] = { configurable: true, writable: true, enumerable: i2.enumerable, value: e10[o2] });
  }
  return Object.create(Object.getPrototypeOf(e10), t2);
}
function wp(e10, t2) {
  return void 0 === t2 && (t2 = false), Sp(e10) || fp(e10) || !pp(e10) || (gp(e10) > 1 && (e10.set = e10.add = e10.clear = e10.delete = Dp), Object.freeze(e10), t2 && hp(e10, function(e11, t3) {
    return wp(t3, true);
  }, true)), e10;
}
function Dp() {
  dp(2);
}
function Sp(e10) {
  return null == e10 || "object" != typeof e10 || Object.isFrozen(e10);
}
function Ap(e10) {
  var t2 = th[e10];
  return t2 || dp(18, e10), t2;
}
function xp() {
  return Vp;
}
function Op(e10, t2) {
  t2 && (Ap("Patches"), e10.u = [], e10.s = [], e10.v = t2);
}
function Np(e10) {
  Bp(e10), e10.p.forEach(kp), e10.p = null;
}
function Bp(e10) {
  e10 === Vp && (Vp = e10.l);
}
function Tp(e10) {
  return Vp = { p: [], l: Vp, h: e10, m: true, _: 0 };
}
function kp(e10) {
  var t2 = e10[Zp];
  0 === t2.i || 1 === t2.i ? t2.j() : t2.g = true;
}
function Fp(e10, t2) {
  t2._ = t2.p.length;
  var n2 = t2.p[0], r3 = void 0 !== e10 && e10 !== n2;
  return t2.h.O || Ap("ES5").S(t2, e10, r3), r3 ? (n2[Zp].P && (Np(t2), dp(4)), pp(e10) && (e10 = Ip(t2, e10), t2.l || _p2(t2, e10)), t2.u && Ap("Patches").M(n2[Zp].t, e10, t2.u, t2.s)) : e10 = Ip(t2, n2, []), Np(t2), t2.u && t2.v(t2.u, t2.s), e10 !== Yp ? e10 : void 0;
}
function Ip(e10, t2, n2) {
  if (Sp(t2)) return t2;
  var r3 = t2[Zp];
  if (!r3) return hp(t2, function(o3, i3) {
    return Pp(e10, r3, t2, o3, i3, n2);
  }, true), t2;
  if (r3.A !== e10) return t2;
  if (!r3.P) return _p2(e10, r3.t, true), r3.t;
  if (!r3.I) {
    r3.I = true, r3.A._--;
    var o2 = 4 === r3.i || 5 === r3.i ? r3.o = Cp(r3.k) : r3.o, i2 = o2, a2 = false;
    3 === r3.i && (i2 = new Set(o2), o2.clear(), a2 = true), hp(i2, function(t3, i3) {
      return Pp(e10, r3, o2, t3, i3, n2, a2);
    }), _p2(e10, o2, false), n2 && e10.u && Ap("Patches").N(r3, n2, e10.u, e10.s);
  }
  return r3.o;
}
function Pp(e10, t2, n2, r3, o2, i2, a2) {
  if (fp(o2)) {
    var s2 = Ip(e10, o2, i2 && t2 && 3 !== t2.i && !vp(t2.R, r3) ? i2.concat(r3) : void 0);
    if (mp(n2, r3, s2), !fp(s2)) return;
    e10.m = false;
  } else a2 && n2.add(o2);
  if (pp(o2) && !Sp(o2)) {
    if (!e10.h.D && e10._ < 1) return;
    Ip(e10, o2), t2 && t2.A.l || _p2(e10, o2);
  }
}
function _p2(e10, t2, n2) {
  void 0 === n2 && (n2 = false), !e10.l && e10.h.D && e10.m && wp(t2, n2);
}
function Rp(e10, t2) {
  var n2 = e10[Zp];
  return (n2 ? Ep(n2) : e10)[t2];
}
function Lp(e10, t2) {
  if (t2 in e10) for (var n2 = Object.getPrototypeOf(e10); n2; ) {
    var r3 = Object.getOwnPropertyDescriptor(n2, t2);
    if (r3) return r3;
    n2 = Object.getPrototypeOf(n2);
  }
}
function Mp(e10) {
  e10.P || (e10.P = true, e10.l && Mp(e10.l));
}
function jp(e10) {
  e10.o || (e10.o = Cp(e10.t));
}
function Hp(e10, t2, n2) {
  var r3 = yp(t2) ? Ap("MapSet").F(t2, n2) : bp(t2) ? Ap("MapSet").T(t2, n2) : e10.O ? function(e11, t3) {
    var n3 = Array.isArray(e11), r4 = { i: n3 ? 1 : 0, A: t3 ? t3.A : xp(), P: false, I: false, R: {}, l: t3, t: e11, k: null, o: null, j: null, C: false }, o2 = r4, i2 = nh;
    n3 && (o2 = [r4], i2 = rh);
    var a2 = Proxy.revocable(o2, i2), s2 = a2.revoke, u2 = a2.proxy;
    return r4.k = u2, r4.j = s2, u2;
  }(t2, n2) : Ap("ES5").J(t2, n2);
  return (n2 ? n2.A : xp()).p.push(r3), r3;
}
function zp(e10) {
  return fp(e10) || dp(22, e10), function e11(t2) {
    if (!pp(t2)) return t2;
    var n2, r3 = t2[Zp], o2 = gp(t2);
    if (r3) {
      if (!r3.P && (r3.i < 4 || !Ap("ES5").K(r3))) return r3.t;
      r3.I = true, n2 = $p(t2, o2), r3.I = false;
    } else n2 = $p(t2, o2);
    return hp(n2, function(t3, o3) {
      r3 && function(e12, t4) {
        return 2 === gp(e12) ? e12.get(t4) : e12[t4];
      }(r3.t, t3) === o3 || mp(n2, t3, e11(o3));
    }), 3 === o2 ? new Set(n2) : n2;
  }(e10);
}
function $p(e10, t2) {
  switch (t2) {
    case 2:
      return new Map(e10);
    case 3:
      return Array.from(e10);
  }
  return Cp(e10);
}
var Up, Vp, Wp = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), Gp = "undefined" != typeof Map, qp = "undefined" != typeof Set, Kp = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, Yp = Wp ? Symbol.for("immer-nothing") : ((Up = {})["immer-nothing"] = true, Up), Xp = Wp ? Symbol.for("immer-draftable") : "__$immer_draftable", Zp = Wp ? Symbol.for("immer-state") : "__$immer_state", Jp = "" + Object.prototype.constructor, Qp = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(e10) {
  return Object.getOwnPropertyNames(e10).concat(Object.getOwnPropertySymbols(e10));
} : Object.getOwnPropertyNames, eh = Object.getOwnPropertyDescriptors || function(e10) {
  var t2 = {};
  return Qp(e10).forEach(function(n2) {
    t2[n2] = Object.getOwnPropertyDescriptor(e10, n2);
  }), t2;
}, th = {}, nh = { get: function(e10, t2) {
  if (t2 === Zp) return e10;
  var n2 = Ep(e10);
  if (!vp(n2, t2)) return function(e11, t3, n3) {
    var r4, o2 = Lp(t3, n3);
    return o2 ? "value" in o2 ? o2.value : null === (r4 = o2.get) || void 0 === r4 ? void 0 : r4.call(e11.k) : void 0;
  }(e10, n2, t2);
  var r3 = n2[t2];
  return e10.I || !pp(r3) ? r3 : r3 === Rp(e10.t, t2) ? (jp(e10), e10.o[t2] = Hp(e10.A.h, r3, e10)) : r3;
}, has: function(e10, t2) {
  return t2 in Ep(e10);
}, ownKeys: function(e10) {
  return Reflect.ownKeys(Ep(e10));
}, set: function(e10, t2, n2) {
  var r3 = Lp(Ep(e10), t2);
  if (null == r3 ? void 0 : r3.set) return r3.set.call(e10.k, n2), true;
  if (!e10.P) {
    var o2 = Rp(Ep(e10), t2), i2 = null == o2 ? void 0 : o2[Zp];
    if (i2 && i2.t === n2) return e10.o[t2] = n2, e10.R[t2] = false, true;
    if (function(e11, t3) {
      return e11 === t3 ? 0 !== e11 || 1 / e11 == 1 / t3 : e11 != e11 && t3 != t3;
    }(n2, o2) && (void 0 !== n2 || vp(e10.t, t2))) return true;
    jp(e10), Mp(e10);
  }
  return e10.o[t2] === n2 && (void 0 !== n2 || t2 in e10.o) || Number.isNaN(n2) && Number.isNaN(e10.o[t2]) || (e10.o[t2] = n2, e10.R[t2] = true), true;
}, deleteProperty: function(e10, t2) {
  return void 0 !== Rp(e10.t, t2) || t2 in e10.t ? (e10.R[t2] = false, jp(e10), Mp(e10)) : delete e10.R[t2], e10.o && delete e10.o[t2], true;
}, getOwnPropertyDescriptor: function(e10, t2) {
  var n2 = Ep(e10), r3 = Reflect.getOwnPropertyDescriptor(n2, t2);
  return r3 ? { writable: true, configurable: 1 !== e10.i || "length" !== t2, enumerable: r3.enumerable, value: n2[t2] } : r3;
}, defineProperty: function() {
  dp(11);
}, getPrototypeOf: function(e10) {
  return Object.getPrototypeOf(e10.t);
}, setPrototypeOf: function() {
  dp(12);
} }, rh = {};
hp(nh, function(e10, t2) {
  rh[e10] = function() {
    return arguments[0] = arguments[0][0], t2.apply(this, arguments);
  };
}), rh.deleteProperty = function(e10, t2) {
  return rh.set.call(this, e10, t2, void 0);
}, rh.set = function(e10, t2, n2) {
  return nh.set.call(this, e10[0], t2, n2, e10[0]);
};
var oh = function() {
  function e10(e11) {
    var t3 = this;
    this.O = Kp, this.D = true, this.produce = function(e12, n2, r3) {
      if ("function" == typeof e12 && "function" != typeof n2) {
        var o2 = n2;
        n2 = e12;
        var i2 = t3;
        return function(e13) {
          var t4 = this;
          void 0 === e13 && (e13 = o2);
          for (var r4 = arguments.length, a3 = Array(r4 > 1 ? r4 - 1 : 0), s3 = 1; s3 < r4; s3++) a3[s3 - 1] = arguments[s3];
          return i2.produce(e13, function(e14) {
            var r5;
            return (r5 = n2).call.apply(r5, [t4, e14].concat(a3));
          });
        };
      }
      var a2;
      if ("function" != typeof n2 && dp(6), void 0 !== r3 && "function" != typeof r3 && dp(7), pp(e12)) {
        var s2 = Tp(t3), u2 = Hp(t3, e12, void 0), l2 = true;
        try {
          a2 = n2(u2), l2 = false;
        } finally {
          l2 ? Np(s2) : Bp(s2);
        }
        return "undefined" != typeof Promise && a2 instanceof Promise ? a2.then(function(e13) {
          return Op(s2, r3), Fp(e13, s2);
        }, function(e13) {
          throw Np(s2), e13;
        }) : (Op(s2, r3), Fp(a2, s2));
      }
      if (!e12 || "object" != typeof e12) {
        if (void 0 === (a2 = n2(e12)) && (a2 = e12), a2 === Yp && (a2 = void 0), t3.D && wp(a2, true), r3) {
          var c3 = [], d2 = [];
          Ap("Patches").M(e12, a2, c3, d2), r3(c3, d2);
        }
        return a2;
      }
      dp(21, e12);
    }, this.produceWithPatches = function(e12, n2) {
      if ("function" == typeof e12) return function(n3) {
        for (var r4 = arguments.length, o3 = Array(r4 > 1 ? r4 - 1 : 0), i3 = 1; i3 < r4; i3++) o3[i3 - 1] = arguments[i3];
        return t3.produceWithPatches(n3, function(t4) {
          return e12.apply(void 0, [t4].concat(o3));
        });
      };
      var r3, o2, i2 = t3.produce(e12, n2, function(e13, t4) {
        r3 = e13, o2 = t4;
      });
      return "undefined" != typeof Promise && i2 instanceof Promise ? i2.then(function(e13) {
        return [e13, r3, o2];
      }) : [i2, r3, o2];
    }, "boolean" == typeof (null == e11 ? void 0 : e11.useProxies) && this.setUseProxies(e11.useProxies), "boolean" == typeof (null == e11 ? void 0 : e11.autoFreeze) && this.setAutoFreeze(e11.autoFreeze);
  }
  var t2 = e10.prototype;
  return t2.createDraft = function(e11) {
    pp(e11) || dp(8), fp(e11) && (e11 = zp(e11));
    var t3 = Tp(this), n2 = Hp(this, e11, void 0);
    return n2[Zp].C = true, Bp(t3), n2;
  }, t2.finishDraft = function(e11, t3) {
    var n2 = (e11 && e11[Zp]).A;
    return Op(n2, t3), Fp(void 0, n2);
  }, t2.setAutoFreeze = function(e11) {
    this.D = e11;
  }, t2.setUseProxies = function(e11) {
    e11 && !Kp && dp(20), this.O = e11;
  }, t2.applyPatches = function(e11, t3) {
    var n2;
    for (n2 = t3.length - 1; n2 >= 0; n2--) {
      var r3 = t3[n2];
      if (0 === r3.path.length && "replace" === r3.op) {
        e11 = r3.value;
        break;
      }
    }
    n2 > -1 && (t3 = t3.slice(n2 + 1));
    var o2 = Ap("Patches").$;
    return fp(e11) ? o2(e11, t3) : this.produce(e11, function(e12) {
      return o2(e12, t3);
    });
  }, e10;
}(), ih = new oh(), ah = ih.produce;
ih.produceWithPatches.bind(ih), ih.setAutoFreeze.bind(ih), ih.setUseProxies.bind(ih), ih.applyPatches.bind(ih);
var sh = ih.createDraft.bind(ih), uh = ih.finishDraft.bind(ih);
function lh(e10, t2, n2) {
  return t2 in e10 ? Object.defineProperty(e10, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e10[t2] = n2, e10;
}
var ch = /* @__PURE__ */ new WeakMap(), dh = /* @__PURE__ */ new WeakMap(), fh = /* @__PURE__ */ new WeakMap(), ph = /* @__PURE__ */ new WeakMap(), hh = /* @__PURE__ */ new WeakMap(), gh = /* @__PURE__ */ new WeakMap(), vh = /* @__PURE__ */ new WeakMap();
function mh(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function yh(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? mh(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : mh(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
function bh(e10, t2) {
  if (null == e10) return {};
  var n2, r3, o2 = function(e11, t3) {
    if (null == e11) return {};
    var n3, r4, o3 = {}, i3 = Object.keys(e11);
    for (r4 = 0; r4 < i3.length; r4++) n3 = i3[r4], t3.indexOf(n3) >= 0 || (o3[n3] = e11[n3]);
    return o3;
  }(e10, t2);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(e10);
    for (r3 = 0; r3 < i2.length; r3++) n2 = i2[r3], t2.indexOf(n2) >= 0 || Object.prototype.propertyIsEnumerable.call(e10, n2) && (o2[n2] = e10[n2]);
  }
  return o2;
}
var Eh, Ch = function(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n2 = !t2, r3 = t2 ? Oh(e10) : e10, o2 = Eh.None, i2 = Eh.None, a2 = 0, s2 = null;
  for (var u2 of r3) {
    var l2 = u2.codePointAt(0);
    if (!l2) break;
    var c3 = jh(u2, l2);
    if ([o2, i2] = n2 ? [i2, c3] : [c3, o2], Hh(o2, Eh.ZWJ) && Hh(i2, Eh.ExtPict) && !Vh(n2 ? e10.substring(0, a2) : e10.substring(0, e10.length - a2))) break;
    if (Hh(o2, Eh.RI) && Hh(i2, Eh.RI) && !(s2 = null !== s2 ? !s2 : !!n2 || Gh(e10.substring(0, e10.length - a2)))) break;
    if (o2 !== Eh.None && i2 !== Eh.None && $h(o2, i2)) break;
    a2 += u2.length;
  }
  return a2 || 1;
}, wh = /\s/, Dh = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Sh = /['\u2018\u2019]/, Ah = (e10, t2, n2) => {
  if (n2) {
    var r3 = e10.length - t2;
    return [e10.slice(r3, e10.length), e10.slice(0, r3)];
  }
  return [e10.slice(0, t2), e10.slice(t2)];
}, xh = function e7(t2, n2) {
  var r3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  if (wh.test(t2)) return false;
  if (Sh.test(t2)) {
    var o2 = Ch(n2, r3), [i2, a2] = Ah(n2, o2, r3);
    if (e7(i2, a2, r3)) return true;
  }
  return !Dh.test(t2);
}, Oh = function* (e10) {
  for (var t2 = e10.length - 1, n2 = 0; n2 < e10.length; n2++) {
    var r3 = e10.charAt(t2 - n2);
    if (Bh(r3.charCodeAt(0))) {
      var o2 = e10.charAt(t2 - n2 - 1);
      if (Nh(o2.charCodeAt(0))) {
        yield o2 + r3, n2++;
        continue;
      }
    }
    yield r3;
  }
}, Nh = (e10) => e10 >= 55296 && e10 <= 56319, Bh = (e10) => e10 >= 56320 && e10 <= 57343;
!function(e10) {
  e10[e10.None = 0] = "None", e10[e10.Extend = 1] = "Extend", e10[e10.ZWJ = 2] = "ZWJ", e10[e10.RI = 4] = "RI", e10[e10.Prepend = 8] = "Prepend", e10[e10.SpacingMark = 16] = "SpacingMark", e10[e10.L = 32] = "L", e10[e10.V = 64] = "V", e10[e10.T = 128] = "T", e10[e10.LV = 256] = "LV", e10[e10.LVT = 512] = "LVT", e10[e10.ExtPict = 1024] = "ExtPict", e10[e10.Any = 2048] = "Any";
}(Eh || (Eh = {}));
var Th = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, kh = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, Fh = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, Ih = /^[\u1100-\u115F\uA960-\uA97C]$/, Ph = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, _h2 = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, Rh = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, Lh = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, Mh = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, jh = (e10, t2) => {
  var n2 = Eh.Any;
  return -1 !== e10.search(Th) && (n2 |= Eh.Extend), 8205 === t2 && (n2 |= Eh.ZWJ), t2 >= 127462 && t2 <= 127487 && (n2 |= Eh.RI), -1 !== e10.search(kh) && (n2 |= Eh.Prepend), -1 !== e10.search(Fh) && (n2 |= Eh.SpacingMark), -1 !== e10.search(Ih) && (n2 |= Eh.L), -1 !== e10.search(Ph) && (n2 |= Eh.V), -1 !== e10.search(_h2) && (n2 |= Eh.T), -1 !== e10.search(Rh) && (n2 |= Eh.LV), -1 !== e10.search(Lh) && (n2 |= Eh.LVT), -1 !== e10.search(Mh) && (n2 |= Eh.ExtPict), n2;
};
function Hh(e10, t2) {
  return 0 !== (e10 & t2);
}
var zh = [[Eh.L, Eh.L | Eh.V | Eh.LV | Eh.LVT], [Eh.LV | Eh.V, Eh.V | Eh.T], [Eh.LVT | Eh.T, Eh.T], [Eh.Any, Eh.Extend | Eh.ZWJ], [Eh.Any, Eh.SpacingMark], [Eh.Prepend, Eh.Any], [Eh.ZWJ, Eh.ExtPict], [Eh.RI, Eh.RI]];
function $h(e10, t2) {
  return -1 === zh.findIndex((n2) => Hh(e10, n2[0]) && Hh(t2, n2[1]));
}
var Uh = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, Vh = (e10) => -1 !== e10.search(Uh), Wh = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, Gh = (e10) => {
  var t2 = e10.match(Wh);
  return null !== t2 && t2[0].length / 2 % 2 == 1;
}, qh = (e10) => cp(e10) && ag.isNodeList(e10.children) && !eg.isEditor(e10), Kh = { isAncestor: (e10) => cp(e10) && ag.isNodeList(e10.children), isElement: qh, isElementList: (e10) => Array.isArray(e10) && e10.every((e11) => Kh.isElement(e11)), isElementProps: (e10) => void 0 !== e10.children, isElementType: function(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "type";
  return qh(e10) && e10[n2] === t2;
}, matches(e10, t2) {
  for (var n2 in t2) if ("children" !== n2 && e10[n2] !== t2[n2]) return false;
  return true;
} }, Yh = ["text"], Xh = ["text"];
function Zh(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function Jh(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Zh(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : Zh(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var Qh = /* @__PURE__ */ new WeakMap(), eg = { above(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { voids: n2 = false, mode: r3 = "lowest", at: o2 = e10.selection, match: i2 } = t2;
  if (o2) {
    var a2 = eg.path(e10, o2), s2 = "lowest" === r3;
    for (var [u2, l2] of eg.levels(e10, { at: a2, voids: n2, match: i2, reverse: s2 })) if (!Og.isText(u2) && !cg.equals(a2, l2)) return [u2, l2];
  }
}, addMark(e10, t2, n2) {
  e10.addMark(t2, n2);
}, after(e10, t2) {
  var n2, r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o2 = { anchor: eg.point(e10, t2, { edge: "end" }), focus: eg.end(e10, []) }, { distance: i2 = 1 } = r3, a2 = 0;
  for (var s2 of eg.positions(e10, Jh(Jh({}, r3), {}, { at: o2 }))) {
    if (a2 > i2) break;
    0 !== a2 && (n2 = s2), a2++;
  }
  return n2;
}, before(e10, t2) {
  var n2, r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o2 = { anchor: eg.start(e10, []), focus: eg.point(e10, t2, { edge: "start" }) }, { distance: i2 = 1 } = r3, a2 = 0;
  for (var s2 of eg.positions(e10, Jh(Jh({}, r3), {}, { at: o2, reverse: true }))) {
    if (a2 > i2) break;
    0 !== a2 && (n2 = s2), a2++;
  }
  return n2;
}, deleteBackward(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { unit: n2 = "character" } = t2;
  e10.deleteBackward(n2);
}, deleteForward(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { unit: n2 = "character" } = t2;
  e10.deleteForward(n2);
}, deleteFragment(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { direction: n2 = "forward" } = t2;
  e10.deleteFragment(n2);
}, edges: (e10, t2) => [eg.start(e10, t2), eg.end(e10, t2)], end: (e10, t2) => eg.point(e10, t2, { edge: "end" }), first(e10, t2) {
  var n2 = eg.path(e10, t2, { edge: "start" });
  return eg.node(e10, n2);
}, fragment(e10, t2) {
  var n2 = eg.range(e10, t2);
  return ag.fragment(e10, n2);
}, hasBlocks: (e10, t2) => t2.children.some((t3) => eg.isBlock(e10, t3)), hasInlines: (e10, t2) => t2.children.some((t3) => Og.isText(t3) || eg.isInline(e10, t3)), hasTexts: (e10, t2) => t2.children.every((e11) => Og.isText(e11)), insertBreak(e10) {
  e10.insertBreak();
}, insertSoftBreak(e10) {
  e10.insertSoftBreak();
}, insertFragment(e10, t2) {
  e10.insertFragment(t2);
}, insertNode(e10, t2) {
  e10.insertNode(t2);
}, insertText(e10, t2) {
  e10.insertText(t2);
}, isBlock: (e10, t2) => Kh.isElement(t2) && !e10.isInline(t2), isEditor(e10) {
  var t2 = Qh.get(e10);
  if (void 0 !== t2) return t2;
  if (!cp(e10)) return false;
  var n2 = "function" == typeof e10.addMark && "function" == typeof e10.apply && "function" == typeof e10.deleteBackward && "function" == typeof e10.deleteForward && "function" == typeof e10.deleteFragment && "function" == typeof e10.insertBreak && "function" == typeof e10.insertSoftBreak && "function" == typeof e10.insertFragment && "function" == typeof e10.insertNode && "function" == typeof e10.insertText && "function" == typeof e10.isInline && "function" == typeof e10.isVoid && "function" == typeof e10.normalizeNode && "function" == typeof e10.onChange && "function" == typeof e10.removeMark && "function" == typeof e10.getDirtyPaths && (null === e10.marks || cp(e10.marks)) && (null === e10.selection || yg.isRange(e10.selection)) && ag.isNodeList(e10.children) && lg.isOperationList(e10.operations);
  return Qh.set(e10, n2), n2;
}, isEnd(e10, t2, n2) {
  var r3 = eg.end(e10, n2);
  return hg.equals(t2, r3);
}, isEdge: (e10, t2, n2) => eg.isStart(e10, t2, n2) || eg.isEnd(e10, t2, n2), isEmpty(e10, t2) {
  var { children: n2 } = t2, [r3] = n2;
  return 0 === n2.length || 1 === n2.length && Og.isText(r3) && "" === r3.text && !e10.isVoid(t2);
}, isInline: (e10, t2) => Kh.isElement(t2) && e10.isInline(t2), isNormalizing(e10) {
  var t2 = ph.get(e10);
  return void 0 === t2 || t2;
}, isStart(e10, t2, n2) {
  if (0 !== t2.offset) return false;
  var r3 = eg.start(e10, n2);
  return hg.equals(t2, r3);
}, isVoid: (e10, t2) => Kh.isElement(t2) && e10.isVoid(t2), last(e10, t2) {
  var n2 = eg.path(e10, t2, { edge: "end" });
  return eg.node(e10, n2);
}, leaf(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r3 = eg.path(e10, t2, n2);
  return [ag.leaf(e10, r3), r3];
}, *levels(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { at: n2 = e10.selection, reverse: r3 = false, voids: o2 = false } = t2, { match: i2 } = t2;
  if (null == i2 && (i2 = () => true), n2) {
    var a2 = [], s2 = eg.path(e10, n2);
    for (var [u2, l2] of ag.levels(e10, s2)) if (i2(u2, l2) && (a2.push([u2, l2]), !o2 && eg.isVoid(e10, u2))) break;
    r3 && a2.reverse(), yield* a2;
  }
}, marks(e10) {
  var { marks: t2, selection: n2 } = e10;
  if (!n2) return null;
  if (t2) return t2;
  if (yg.isExpanded(n2)) {
    var [r3] = eg.nodes(e10, { match: Og.isText });
    if (r3) {
      var [o2] = r3;
      return bh(o2, Yh);
    }
    return {};
  }
  var { anchor: i2 } = n2, { path: a2 } = i2, [s2] = eg.leaf(e10, a2);
  if (0 === i2.offset) {
    var u2 = eg.previous(e10, { at: a2, match: Og.isText }), l2 = eg.above(e10, { match: (t3) => eg.isBlock(e10, t3) });
    if (u2 && l2) {
      var [c3, d2] = u2, [, f2] = l2;
      cg.isAncestor(f2, d2) && (s2 = c3);
    }
  }
  return bh(s2, Xh);
}, next(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { mode: n2 = "lowest", voids: r3 = false } = t2, { match: o2, at: i2 = e10.selection } = t2;
  if (i2) {
    var a2 = eg.after(e10, i2, { voids: r3 });
    if (a2) {
      var [, s2] = eg.last(e10, []), u2 = [a2.path, s2];
      if (cg.isPath(i2) && 0 === i2.length) throw new Error("Cannot get the next node from the root node!");
      if (null == o2) if (cg.isPath(i2)) {
        var [l2] = eg.parent(e10, i2);
        o2 = (e11) => l2.children.includes(e11);
      } else o2 = () => true;
      var [c3] = eg.nodes(e10, { at: u2, match: o2, mode: n2, voids: r3 });
      return c3;
    }
  }
}, node(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r3 = eg.path(e10, t2, n2);
  return [ag.get(e10, r3), r3];
}, *nodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { at: n2 = e10.selection, mode: r3 = "all", universal: o2 = false, reverse: i2 = false, voids: a2 = false } = t2, { match: s2 } = t2;
  if (s2 || (s2 = () => true), n2) {
    var u2, l2;
    if (ng.isSpan(n2)) u2 = n2[0], l2 = n2[1];
    else {
      var c3 = eg.path(e10, n2, { edge: "start" }), d2 = eg.path(e10, n2, { edge: "end" });
      u2 = i2 ? d2 : c3, l2 = i2 ? c3 : d2;
    }
    var f2, p2 = ag.nodes(e10, { reverse: i2, from: u2, to: l2, pass: (t3) => {
      var [n3] = t3;
      return !a2 && eg.isVoid(e10, n3);
    } }), h2 = [];
    for (var [g2, v2] of p2) {
      var m2 = f2 && 0 === cg.compare(v2, f2[1]);
      if ("highest" !== r3 || !m2) {
        if (s2(g2, v2)) if ("lowest" === r3 && m2) f2 = [g2, v2];
        else {
          var y2 = "lowest" === r3 ? f2 : [g2, v2];
          y2 && (o2 ? h2.push(y2) : yield y2), f2 = [g2, v2];
        }
        else if (o2 && !m2 && Og.isText(g2)) return;
      }
    }
    "lowest" === r3 && f2 && (o2 ? h2.push(f2) : yield f2), o2 && (yield* h2);
  }
}, normalize(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { force: n2 = false } = t2, r3 = (e11) => ch.get(e11) || [], o2 = (e11) => {
    var t3 = r3(e11).pop(), n3 = t3.join(",");
    return ((e12) => dh.get(e12) || /* @__PURE__ */ new Set())(e11).delete(n3), t3;
  };
  if (eg.isNormalizing(e10)) {
    if (n2) {
      var i2 = Array.from(ag.nodes(e10), (e11) => {
        var [, t3] = e11;
        return t3;
      }), a2 = new Set(i2.map((e11) => e11.join(",")));
      ch.set(e10, i2), dh.set(e10, a2);
    }
    0 !== r3(e10).length && eg.withoutNormalizing(e10, () => {
      for (var t3 of r3(e10)) if (ag.has(e10, t3)) {
        var n3 = eg.node(e10, t3), [i3, a3] = n3;
        Kh.isElement(i3) && 0 === i3.children.length && e10.normalizeNode(n3);
      }
      for (var s2 = 42 * r3(e10).length, u2 = 0; 0 !== r3(e10).length; ) {
        if (u2 > s2) throw new Error("\n            Could not completely normalize the editor after ".concat(s2, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.\n          "));
        var l2 = o2(e10);
        if (ag.has(e10, l2)) {
          var c3 = eg.node(e10, l2);
          e10.normalizeNode(c3);
        }
        u2++;
      }
    });
  }
}, parent(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r3 = eg.path(e10, t2, n2), o2 = cg.parent(r3);
  return eg.node(e10, o2);
}, path(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { depth: r3, edge: o2 } = n2;
  if (cg.isPath(t2)) {
    if ("start" === o2) {
      var [, i2] = ag.first(e10, t2);
      t2 = i2;
    } else if ("end" === o2) {
      var [, a2] = ag.last(e10, t2);
      t2 = a2;
    }
  }
  return yg.isRange(t2) && (t2 = "start" === o2 ? yg.start(t2) : "end" === o2 ? yg.end(t2) : cg.common(t2.anchor.path, t2.focus.path)), hg.isPoint(t2) && (t2 = t2.path), null != r3 && (t2 = t2.slice(0, r3)), t2;
}, hasPath: (e10, t2) => ag.has(e10, t2), pathRef(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { affinity: r3 = "forward" } = n2, o2 = { current: t2, affinity: r3, unref() {
    var { current: t3 } = o2;
    return eg.pathRefs(e10).delete(o2), o2.current = null, t3;
  } };
  return eg.pathRefs(e10).add(o2), o2;
}, pathRefs(e10) {
  var t2 = hh.get(e10);
  return t2 || (t2 = /* @__PURE__ */ new Set(), hh.set(e10, t2)), t2;
}, point(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { edge: r3 = "start" } = n2;
  if (cg.isPath(t2)) {
    var o2;
    if ("end" === r3) {
      var [, i2] = ag.last(e10, t2);
      o2 = i2;
    } else {
      var [, a2] = ag.first(e10, t2);
      o2 = a2;
    }
    var s2 = ag.get(e10, o2);
    if (!Og.isText(s2)) throw new Error("Cannot get the ".concat(r3, " point in the node at path [").concat(t2, "] because it has no ").concat(r3, " text node."));
    return { path: o2, offset: "end" === r3 ? s2.text.length : 0 };
  }
  if (yg.isRange(t2)) {
    var [u2, l2] = yg.edges(t2);
    return "start" === r3 ? u2 : l2;
  }
  return t2;
}, pointRef(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { affinity: r3 = "forward" } = n2, o2 = { current: t2, affinity: r3, unref() {
    var { current: t3 } = o2;
    return eg.pointRefs(e10).delete(o2), o2.current = null, t3;
  } };
  return eg.pointRefs(e10).add(o2), o2;
}, pointRefs(e10) {
  var t2 = gh.get(e10);
  return t2 || (t2 = /* @__PURE__ */ new Set(), gh.set(e10, t2)), t2;
}, *positions(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { at: n2 = e10.selection, unit: r3 = "offset", reverse: o2 = false, voids: i2 = false } = t2;
  if (n2) {
    var a2 = eg.range(e10, n2), [s2, u2] = yg.edges(a2), l2 = o2 ? u2 : s2, c3 = false, d2 = "", f2 = 0, p2 = 0, h2 = 0;
    for (var [g2, v2] of eg.nodes(e10, { at: n2, reverse: o2, voids: i2 })) {
      if (Kh.isElement(g2)) {
        if (!i2 && e10.isVoid(g2)) {
          yield eg.start(e10, v2);
          continue;
        }
        if (e10.isInline(g2)) continue;
        if (eg.hasInlines(e10, g2)) {
          var m2 = cg.isAncestor(v2, u2.path) ? u2 : eg.end(e10, v2), y2 = cg.isAncestor(v2, s2.path) ? s2 : eg.start(e10, v2);
          d2 = eg.string(e10, { anchor: y2, focus: m2 }, { voids: i2 }), c3 = true;
        }
      }
      if (Og.isText(g2)) {
        var b2 = cg.equals(v2, l2.path);
        for (b2 ? (p2 = o2 ? l2.offset : g2.text.length - l2.offset, h2 = l2.offset) : (p2 = g2.text.length, h2 = o2 ? p2 : 0), (b2 || c3 || "offset" === r3) && (yield { path: v2, offset: h2 }, c3 = false); ; ) {
          if (0 === f2) {
            if ("" === d2) break;
            f2 = E2(d2, r3, o2), d2 = Ah(d2, f2, o2)[1];
          }
          if (h2 = o2 ? h2 - f2 : h2 + f2, (p2 -= f2) < 0) {
            f2 = -p2;
            break;
          }
          f2 = 0, yield { path: v2, offset: h2 };
        }
      }
    }
  }
  function E2(e11, t3, n3) {
    return "character" === t3 ? Ch(e11, n3) : "word" === t3 ? function(e12) {
      for (var t4 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n4 = 0, r4 = false; e12.length > 0; ) {
        var o3 = Ch(e12, t4), [i3, a3] = Ah(e12, o3, t4);
        if (xh(i3, a3, t4)) r4 = true, n4 += o3;
        else {
          if (r4) break;
          n4 += o3;
        }
        e12 = a3;
      }
      return n4;
    }(e11, n3) : "line" === t3 || "block" === t3 ? e11.length : 1;
  }
}, previous(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { mode: n2 = "lowest", voids: r3 = false } = t2, { match: o2, at: i2 = e10.selection } = t2;
  if (i2) {
    var a2 = eg.before(e10, i2, { voids: r3 });
    if (a2) {
      var [, s2] = eg.first(e10, []), u2 = [a2.path, s2];
      if (cg.isPath(i2) && 0 === i2.length) throw new Error("Cannot get the previous node from the root node!");
      if (null == o2) if (cg.isPath(i2)) {
        var [l2] = eg.parent(e10, i2);
        o2 = (e11) => l2.children.includes(e11);
      } else o2 = () => true;
      var [c3] = eg.nodes(e10, { reverse: true, at: u2, match: o2, mode: n2, voids: r3 });
      return c3;
    }
  }
}, range: (e10, t2, n2) => yg.isRange(t2) && !n2 ? t2 : { anchor: eg.start(e10, t2), focus: eg.end(e10, n2 || t2) }, rangeRef(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { affinity: r3 = "forward" } = n2, o2 = { current: t2, affinity: r3, unref() {
    var { current: t3 } = o2;
    return eg.rangeRefs(e10).delete(o2), o2.current = null, t3;
  } };
  return eg.rangeRefs(e10).add(o2), o2;
}, rangeRefs(e10) {
  var t2 = vh.get(e10);
  return t2 || (t2 = /* @__PURE__ */ new Set(), vh.set(e10, t2)), t2;
}, removeMark(e10, t2) {
  e10.removeMark(t2);
}, setNormalizing(e10, t2) {
  ph.set(e10, t2);
}, start: (e10, t2) => eg.point(e10, t2, { edge: "start" }), string(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { voids: r3 = false } = n2, o2 = eg.range(e10, t2), [i2, a2] = yg.edges(o2), s2 = "";
  for (var [u2, l2] of eg.nodes(e10, { at: o2, match: Og.isText, voids: r3 })) {
    var c3 = u2.text;
    cg.equals(l2, a2.path) && (c3 = c3.slice(0, a2.offset)), cg.equals(l2, i2.path) && (c3 = c3.slice(i2.offset)), s2 += c3;
  }
  return s2;
}, unhangRange(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { voids: r3 = false } = n2, [o2, i2] = yg.edges(t2);
  if (0 !== o2.offset || 0 !== i2.offset || yg.isCollapsed(t2)) return t2;
  var a2 = eg.above(e10, { at: i2, match: (t3) => eg.isBlock(e10, t3) }), s2 = a2 ? a2[1] : [], u2 = { anchor: eg.start(e10, o2), focus: i2 }, l2 = true;
  for (var [c3, d2] of eg.nodes(e10, { at: u2, match: Og.isText, reverse: true, voids: r3 })) if (l2) l2 = false;
  else if ("" !== c3.text || cg.isBefore(d2, s2)) {
    i2 = { path: d2, offset: c3.text.length };
    break;
  }
  return { anchor: o2, focus: i2 };
}, void(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return eg.above(e10, Jh(Jh({}, t2), {}, { match: (t3) => eg.isVoid(e10, t3) }));
}, withoutNormalizing(e10, t2) {
  var n2 = eg.isNormalizing(e10);
  eg.setNormalizing(e10, false);
  try {
    t2();
  } finally {
    eg.setNormalizing(e10, n2);
  }
  eg.normalize(e10);
} }, ng = { isSpan: (e10) => Array.isArray(e10) && 2 === e10.length && e10.every(cg.isPath) }, rg = ["children"], og = ["text"], ig = /* @__PURE__ */ new WeakMap(), ag = { ancestor(e10, t2) {
  var n2 = ag.get(e10, t2);
  if (Og.isText(n2)) throw new Error("Cannot get the ancestor node at path [".concat(t2, "] because it refers to a text node instead: ").concat(Cg.stringify(n2)));
  return n2;
}, *ancestors(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  for (var r3 of cg.ancestors(t2, n2)) {
    var o2 = [ag.ancestor(e10, r3), r3];
    yield o2;
  }
}, child(e10, t2) {
  if (Og.isText(e10)) throw new Error("Cannot get the child of a text node: ".concat(Cg.stringify(e10)));
  var n2 = e10.children[t2];
  if (null == n2) throw new Error("Cannot get child at index `".concat(t2, "` in node: ").concat(Cg.stringify(e10)));
  return n2;
}, *children(e10, t2) {
  for (var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { reverse: r3 = false } = n2, o2 = ag.ancestor(e10, t2), { children: i2 } = o2, a2 = r3 ? i2.length - 1 : 0; r3 ? a2 >= 0 : a2 < i2.length; ) {
    var s2 = ag.child(o2, a2), u2 = t2.concat(a2);
    yield [s2, u2], a2 = r3 ? a2 - 1 : a2 + 1;
  }
}, common(e10, t2, n2) {
  var r3 = cg.common(t2, n2);
  return [ag.get(e10, r3), r3];
}, descendant(e10, t2) {
  var n2 = ag.get(e10, t2);
  if (eg.isEditor(n2)) throw new Error("Cannot get the descendant node at path [".concat(t2, "] because it refers to the root editor node instead: ").concat(Cg.stringify(n2)));
  return n2;
}, *descendants(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  for (var [n2, r3] of ag.nodes(e10, t2)) 0 !== r3.length && (yield [n2, r3]);
}, *elements(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  for (var [n2, r3] of ag.nodes(e10, t2)) Kh.isElement(n2) && (yield [n2, r3]);
}, extractProps: (e10) => Kh.isAncestor(e10) ? bh(e10, rg) : bh(e10, og), first(e10, t2) {
  for (var n2 = t2.slice(), r3 = ag.get(e10, n2); r3 && !Og.isText(r3) && 0 !== r3.children.length; ) r3 = r3.children[0], n2.push(0);
  return [r3, n2];
}, fragment(e10, t2) {
  if (Og.isText(e10)) throw new Error("Cannot get a fragment starting from a root text node: ".concat(Cg.stringify(e10)));
  var n2 = ah({ children: e10.children }, (e11) => {
    var [n3, r3] = yg.edges(t2), o2 = ag.nodes(e11, { reverse: true, pass: (e12) => {
      var [, n4] = e12;
      return !yg.includes(t2, n4);
    } });
    for (var [, i2] of o2) {
      if (!yg.includes(t2, i2)) {
        var a2 = ag.parent(e11, i2), s2 = i2[i2.length - 1];
        a2.children.splice(s2, 1);
      }
      if (cg.equals(i2, r3.path)) {
        var u2 = ag.leaf(e11, i2);
        u2.text = u2.text.slice(0, r3.offset);
      }
      if (cg.equals(i2, n3.path)) {
        var l2 = ag.leaf(e11, i2);
        l2.text = l2.text.slice(n3.offset);
      }
    }
    eg.isEditor(e11) && (e11.selection = null);
  });
  return n2.children;
}, get(e10, t2) {
  for (var n2 = e10, r3 = 0; r3 < t2.length; r3++) {
    var o2 = t2[r3];
    if (Og.isText(n2) || !n2.children[o2]) throw new Error("Cannot find a descendant at path [".concat(t2, "] in node: ").concat(Cg.stringify(e10)));
    n2 = n2.children[o2];
  }
  return n2;
}, has(e10, t2) {
  for (var n2 = e10, r3 = 0; r3 < t2.length; r3++) {
    var o2 = t2[r3];
    if (Og.isText(n2) || !n2.children[o2]) return false;
    n2 = n2.children[o2];
  }
  return true;
}, isNode: (e10) => Og.isText(e10) || Kh.isElement(e10) || eg.isEditor(e10), isNodeList(e10) {
  if (!Array.isArray(e10)) return false;
  var t2 = ig.get(e10);
  if (void 0 !== t2) return t2;
  var n2 = e10.every((e11) => ag.isNode(e11));
  return ig.set(e10, n2), n2;
}, last(e10, t2) {
  for (var n2 = t2.slice(), r3 = ag.get(e10, n2); r3 && !Og.isText(r3) && 0 !== r3.children.length; ) {
    var o2 = r3.children.length - 1;
    r3 = r3.children[o2], n2.push(o2);
  }
  return [r3, n2];
}, leaf(e10, t2) {
  var n2 = ag.get(e10, t2);
  if (!Og.isText(n2)) throw new Error("Cannot get the leaf node at path [".concat(t2, "] because it refers to a non-leaf node: ").concat(Cg.stringify(n2)));
  return n2;
}, *levels(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  for (var r3 of cg.levels(t2, n2)) {
    var o2 = ag.get(e10, r3);
    yield [o2, r3];
  }
}, matches: (e10, t2) => Kh.isElement(e10) && Kh.isElementProps(t2) && Kh.matches(e10, t2) || Og.isText(e10) && Og.isTextProps(t2) && Og.matches(e10, t2), *nodes(e10) {
  for (var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { pass: n2, reverse: r3 = false } = t2, { from: o2 = [], to: i2 } = t2, a2 = /* @__PURE__ */ new Set(), s2 = [], u2 = e10; !i2 || !(r3 ? cg.isBefore(s2, i2) : cg.isAfter(s2, i2)); ) if (a2.has(u2) || (yield [u2, s2]), a2.has(u2) || Og.isText(u2) || 0 === u2.children.length || null != n2 && false !== n2([u2, s2])) {
    if (0 === s2.length) break;
    if (!r3) {
      var l2 = cg.next(s2);
      if (ag.has(e10, l2)) {
        s2 = l2, u2 = ag.get(e10, s2);
        continue;
      }
    }
    if (r3 && 0 !== s2[s2.length - 1]) s2 = cg.previous(s2), u2 = ag.get(e10, s2);
    else s2 = cg.parent(s2), u2 = ag.get(e10, s2), a2.add(u2);
  } else {
    a2.add(u2);
    var c3 = r3 ? u2.children.length - 1 : 0;
    cg.isAncestor(s2, o2) && (c3 = o2[s2.length]), s2 = s2.concat(c3), u2 = ag.get(e10, s2);
  }
}, parent(e10, t2) {
  var n2 = cg.parent(t2), r3 = ag.get(e10, n2);
  if (Og.isText(r3)) throw new Error("Cannot get the parent of path [".concat(t2, "] because it does not exist in the root."));
  return r3;
}, string: (e10) => Og.isText(e10) ? e10.text : e10.children.map(ag.string).join(""), *texts(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  for (var [n2, r3] of ag.nodes(e10, t2)) Og.isText(n2) && (yield [n2, r3]);
} };
function sg(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function ug(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? sg(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : sg(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var lg = { isNodeOperation: (e10) => lg.isOperation(e10) && e10.type.endsWith("_node"), isOperation(e10) {
  if (!cp(e10)) return false;
  switch (e10.type) {
    case "insert_node":
    case "remove_node":
      return cg.isPath(e10.path) && ag.isNode(e10.node);
    case "insert_text":
    case "remove_text":
      return "number" == typeof e10.offset && "string" == typeof e10.text && cg.isPath(e10.path);
    case "merge_node":
      return "number" == typeof e10.position && cg.isPath(e10.path) && cp(e10.properties);
    case "move_node":
      return cg.isPath(e10.path) && cg.isPath(e10.newPath);
    case "set_node":
      return cg.isPath(e10.path) && cp(e10.properties) && cp(e10.newProperties);
    case "set_selection":
      return null === e10.properties && yg.isRange(e10.newProperties) || null === e10.newProperties && yg.isRange(e10.properties) || cp(e10.properties) && cp(e10.newProperties);
    case "split_node":
      return cg.isPath(e10.path) && "number" == typeof e10.position && cp(e10.properties);
    default:
      return false;
  }
}, isOperationList: (e10) => Array.isArray(e10) && e10.every((e11) => lg.isOperation(e11)), isSelectionOperation: (e10) => lg.isOperation(e10) && e10.type.endsWith("_selection"), isTextOperation: (e10) => lg.isOperation(e10) && e10.type.endsWith("_text"), inverse(e10) {
  switch (e10.type) {
    case "insert_node":
      return ug(ug({}, e10), {}, { type: "remove_node" });
    case "insert_text":
      return ug(ug({}, e10), {}, { type: "remove_text" });
    case "merge_node":
      return ug(ug({}, e10), {}, { type: "split_node", path: cg.previous(e10.path) });
    case "move_node":
      var { newPath: t2, path: n2 } = e10;
      if (cg.equals(t2, n2)) return e10;
      if (cg.isSibling(n2, t2)) return ug(ug({}, e10), {}, { path: t2, newPath: n2 });
      var r3 = cg.transform(n2, e10), o2 = cg.transform(cg.next(n2), e10);
      return ug(ug({}, e10), {}, { path: r3, newPath: o2 });
    case "remove_node":
      return ug(ug({}, e10), {}, { type: "insert_node" });
    case "remove_text":
      return ug(ug({}, e10), {}, { type: "insert_text" });
    case "set_node":
      var { properties: i2, newProperties: a2 } = e10;
      return ug(ug({}, e10), {}, { properties: a2, newProperties: i2 });
    case "set_selection":
      var { properties: s2, newProperties: u2 } = e10;
      return ug(ug({}, e10), {}, null == s2 ? { properties: u2, newProperties: null } : null == u2 ? { properties: null, newProperties: s2 } : { properties: u2, newProperties: s2 });
    case "split_node":
      return ug(ug({}, e10), {}, { type: "merge_node", path: cg.next(e10.path) });
  }
} }, cg = { ancestors(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { reverse: n2 = false } = t2, r3 = cg.levels(e10, t2);
  return r3 = n2 ? r3.slice(1) : r3.slice(0, -1);
}, common(e10, t2) {
  for (var n2 = [], r3 = 0; r3 < e10.length && r3 < t2.length; r3++) {
    var o2 = e10[r3];
    if (o2 !== t2[r3]) break;
    n2.push(o2);
  }
  return n2;
}, compare(e10, t2) {
  for (var n2 = Math.min(e10.length, t2.length), r3 = 0; r3 < n2; r3++) {
    if (e10[r3] < t2[r3]) return -1;
    if (e10[r3] > t2[r3]) return 1;
  }
  return 0;
}, endsAfter(e10, t2) {
  var n2 = e10.length - 1, r3 = e10.slice(0, n2), o2 = t2.slice(0, n2), i2 = e10[n2], a2 = t2[n2];
  return cg.equals(r3, o2) && i2 > a2;
}, endsAt(e10, t2) {
  var n2 = e10.length, r3 = e10.slice(0, n2), o2 = t2.slice(0, n2);
  return cg.equals(r3, o2);
}, endsBefore(e10, t2) {
  var n2 = e10.length - 1, r3 = e10.slice(0, n2), o2 = t2.slice(0, n2), i2 = e10[n2], a2 = t2[n2];
  return cg.equals(r3, o2) && i2 < a2;
}, equals: (e10, t2) => e10.length === t2.length && e10.every((e11, n2) => e11 === t2[n2]), hasPrevious: (e10) => e10[e10.length - 1] > 0, isAfter: (e10, t2) => 1 === cg.compare(e10, t2), isAncestor: (e10, t2) => e10.length < t2.length && 0 === cg.compare(e10, t2), isBefore: (e10, t2) => -1 === cg.compare(e10, t2), isChild: (e10, t2) => e10.length === t2.length + 1 && 0 === cg.compare(e10, t2), isCommon: (e10, t2) => e10.length <= t2.length && 0 === cg.compare(e10, t2), isDescendant: (e10, t2) => e10.length > t2.length && 0 === cg.compare(e10, t2), isParent: (e10, t2) => e10.length + 1 === t2.length && 0 === cg.compare(e10, t2), isPath: (e10) => Array.isArray(e10) && (0 === e10.length || "number" == typeof e10[0]), isSibling(e10, t2) {
  if (e10.length !== t2.length) return false;
  var n2 = e10.slice(0, -1), r3 = t2.slice(0, -1);
  return e10[e10.length - 1] !== t2[t2.length - 1] && cg.equals(n2, r3);
}, levels(e10) {
  for (var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { reverse: n2 = false } = t2, r3 = [], o2 = 0; o2 <= e10.length; o2++) r3.push(e10.slice(0, o2));
  return n2 && r3.reverse(), r3;
}, next(e10) {
  if (0 === e10.length) throw new Error("Cannot get the next path of a root path [".concat(e10, "], because it has no next index."));
  var t2 = e10[e10.length - 1];
  return e10.slice(0, -1).concat(t2 + 1);
}, operationCanTransformPath(e10) {
  switch (e10.type) {
    case "insert_node":
    case "remove_node":
    case "merge_node":
    case "split_node":
    case "move_node":
      return true;
    default:
      return false;
  }
}, parent(e10) {
  if (0 === e10.length) throw new Error("Cannot get the parent path of the root path [".concat(e10, "]."));
  return e10.slice(0, -1);
}, previous(e10) {
  if (0 === e10.length) throw new Error("Cannot get the previous path of a root path [".concat(e10, "], because it has no previous index."));
  var t2 = e10[e10.length - 1];
  if (t2 <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(e10, "] because it would result in a negative index."));
  return e10.slice(0, -1).concat(t2 - 1);
}, relative(e10, t2) {
  if (!cg.isAncestor(t2, e10) && !cg.equals(e10, t2)) throw new Error("Cannot get the relative path of [".concat(e10, "] inside ancestor [").concat(t2, "], because it is not above or equal to the path."));
  return e10.slice(t2.length);
}, transform(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return ah(e10, (r3) => {
    var { affinity: o2 = "forward" } = n2;
    if (e10 && 0 !== (null == e10 ? void 0 : e10.length)) {
      if (null === r3) return null;
      switch (t2.type) {
        case "insert_node":
          var { path: i2 } = t2;
          (cg.equals(i2, r3) || cg.endsBefore(i2, r3) || cg.isAncestor(i2, r3)) && (r3[i2.length - 1] += 1);
          break;
        case "remove_node":
          var { path: a2 } = t2;
          if (cg.equals(a2, r3) || cg.isAncestor(a2, r3)) return null;
          cg.endsBefore(a2, r3) && (r3[a2.length - 1] -= 1);
          break;
        case "merge_node":
          var { path: s2, position: u2 } = t2;
          cg.equals(s2, r3) || cg.endsBefore(s2, r3) ? r3[s2.length - 1] -= 1 : cg.isAncestor(s2, r3) && (r3[s2.length - 1] -= 1, r3[s2.length] += u2);
          break;
        case "split_node":
          var { path: l2, position: c3 } = t2;
          if (cg.equals(l2, r3)) {
            if ("forward" === o2) r3[r3.length - 1] += 1;
            else if ("backward" !== o2) return null;
          } else cg.endsBefore(l2, r3) ? r3[l2.length - 1] += 1 : cg.isAncestor(l2, r3) && e10[l2.length] >= c3 && (r3[l2.length - 1] += 1, r3[l2.length] -= c3);
          break;
        case "move_node":
          var { path: d2, newPath: f2 } = t2;
          if (cg.equals(d2, f2)) return;
          if (cg.isAncestor(d2, r3) || cg.equals(d2, r3)) {
            var p2 = f2.slice();
            return cg.endsBefore(d2, f2) && d2.length < f2.length && (p2[d2.length - 1] -= 1), p2.concat(r3.slice(d2.length));
          }
          cg.isSibling(d2, f2) && (cg.isAncestor(f2, r3) || cg.equals(f2, r3)) ? cg.endsBefore(d2, r3) ? r3[d2.length - 1] -= 1 : r3[d2.length - 1] += 1 : cg.endsBefore(f2, r3) || cg.equals(f2, r3) || cg.isAncestor(f2, r3) ? (cg.endsBefore(d2, r3) && (r3[d2.length - 1] -= 1), r3[f2.length - 1] += 1) : cg.endsBefore(d2, r3) && (cg.equals(f2, r3) && (r3[f2.length - 1] += 1), r3[d2.length - 1] -= 1);
      }
    }
  });
} }, dg = { transform(e10, t2) {
  var { current: n2, affinity: r3 } = e10;
  if (null != n2) {
    var o2 = cg.transform(n2, t2, { affinity: r3 });
    e10.current = o2, null == o2 && e10.unref();
  }
} };
function fg(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function pg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? fg(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : fg(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var hg = { compare(e10, t2) {
  var n2 = cg.compare(e10.path, t2.path);
  return 0 === n2 ? e10.offset < t2.offset ? -1 : e10.offset > t2.offset ? 1 : 0 : n2;
}, isAfter: (e10, t2) => 1 === hg.compare(e10, t2), isBefore: (e10, t2) => -1 === hg.compare(e10, t2), equals: (e10, t2) => e10.offset === t2.offset && cg.equals(e10.path, t2.path), isPoint: (e10) => cp(e10) && "number" == typeof e10.offset && cg.isPath(e10.path), transform(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return ah(e10, (e11) => {
    if (null === e11) return null;
    var { affinity: r3 = "forward" } = n2, { path: o2, offset: i2 } = e11;
    switch (t2.type) {
      case "insert_node":
      case "move_node":
        e11.path = cg.transform(o2, t2, n2);
        break;
      case "insert_text":
        cg.equals(t2.path, o2) && (t2.offset < i2 || t2.offset === i2 && "forward" === r3) && (e11.offset += t2.text.length);
        break;
      case "merge_node":
        cg.equals(t2.path, o2) && (e11.offset += t2.position), e11.path = cg.transform(o2, t2, n2);
        break;
      case "remove_text":
        cg.equals(t2.path, o2) && t2.offset <= i2 && (e11.offset -= Math.min(i2 - t2.offset, t2.text.length));
        break;
      case "remove_node":
        if (cg.equals(t2.path, o2) || cg.isAncestor(t2.path, o2)) return null;
        e11.path = cg.transform(o2, t2, n2);
        break;
      case "split_node":
        if (cg.equals(t2.path, o2)) {
          if (t2.position === i2 && null == r3) return null;
          (t2.position < i2 || t2.position === i2 && "forward" === r3) && (e11.offset -= t2.position, e11.path = cg.transform(o2, t2, pg(pg({}, n2), {}, { affinity: "forward" })));
        } else e11.path = cg.transform(o2, t2, n2);
    }
  });
} }, gg = { transform(e10, t2) {
  var { current: n2, affinity: r3 } = e10;
  if (null != n2) {
    var o2 = hg.transform(n2, t2, { affinity: r3 });
    e10.current = o2, null == o2 && e10.unref();
  }
} }, vg = ["anchor", "focus"];
function mg(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
var yg = { edges(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { reverse: n2 = false } = t2, { anchor: r3, focus: o2 } = e10;
  return yg.isBackward(e10) === n2 ? [r3, o2] : [o2, r3];
}, end(e10) {
  var [, t2] = yg.edges(e10);
  return t2;
}, equals: (e10, t2) => hg.equals(e10.anchor, t2.anchor) && hg.equals(e10.focus, t2.focus), includes(e10, t2) {
  if (yg.isRange(t2)) {
    if (yg.includes(e10, t2.anchor) || yg.includes(e10, t2.focus)) return true;
    var [n2, r3] = yg.edges(e10), [o2, i2] = yg.edges(t2);
    return hg.isBefore(n2, o2) && hg.isAfter(r3, i2);
  }
  var [a2, s2] = yg.edges(e10), u2 = false, l2 = false;
  return hg.isPoint(t2) ? (u2 = hg.compare(t2, a2) >= 0, l2 = hg.compare(t2, s2) <= 0) : (u2 = cg.compare(t2, a2.path) >= 0, l2 = cg.compare(t2, s2.path) <= 0), u2 && l2;
}, intersection(e10, t2) {
  var n2 = bh(e10, vg), [r3, o2] = yg.edges(e10), [i2, a2] = yg.edges(t2), s2 = hg.isBefore(r3, i2) ? i2 : r3, u2 = hg.isBefore(o2, a2) ? o2 : a2;
  return hg.isBefore(u2, s2) ? null : function(e11) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var n3 = null != arguments[t3] ? arguments[t3] : {};
      t3 % 2 ? mg(Object(n3), true).forEach(function(t4) {
        lh(e11, t4, n3[t4]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e11, Object.getOwnPropertyDescriptors(n3)) : mg(Object(n3)).forEach(function(t4) {
        Object.defineProperty(e11, t4, Object.getOwnPropertyDescriptor(n3, t4));
      });
    }
    return e11;
  }({ anchor: s2, focus: u2 }, n2);
}, isBackward(e10) {
  var { anchor: t2, focus: n2 } = e10;
  return hg.isAfter(t2, n2);
}, isCollapsed(e10) {
  var { anchor: t2, focus: n2 } = e10;
  return hg.equals(t2, n2);
}, isExpanded: (e10) => !yg.isCollapsed(e10), isForward: (e10) => !yg.isBackward(e10), isRange: (e10) => cp(e10) && hg.isPoint(e10.anchor) && hg.isPoint(e10.focus), *points(e10) {
  yield [e10.anchor, "anchor"], yield [e10.focus, "focus"];
}, start(e10) {
  var [t2] = yg.edges(e10);
  return t2;
}, transform(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return ah(e10, (e11) => {
    if (null === e11) return null;
    var r3, o2, { affinity: i2 = "inward" } = n2;
    if ("inward" === i2) {
      var a2 = yg.isCollapsed(e11);
      yg.isForward(e11) ? (r3 = "forward", o2 = a2 ? r3 : "backward") : (r3 = "backward", o2 = a2 ? r3 : "forward");
    } else "outward" === i2 ? yg.isForward(e11) ? (r3 = "backward", o2 = "forward") : (r3 = "forward", o2 = "backward") : (r3 = i2, o2 = i2);
    var s2 = hg.transform(e11.anchor, t2, { affinity: r3 }), u2 = hg.transform(e11.focus, t2, { affinity: o2 });
    if (!s2 || !u2) return null;
    e11.anchor = s2, e11.focus = u2;
  });
} }, bg = { transform(e10, t2) {
  var { current: n2, affinity: r3 } = e10;
  if (null != n2) {
    var o2 = yg.transform(n2, t2, { affinity: r3 });
    e10.current = o2, null == o2 && e10.unref();
  }
} }, Eg = void 0, Cg = { setScrubber(e10) {
  Eg = e10;
}, stringify: (e10) => JSON.stringify(e10, Eg) }, wg = (e10, t2) => {
  for (var n2 in e10) {
    var r3 = e10[n2], o2 = t2[n2];
    if (cp(r3) && cp(o2)) {
      if (!wg(r3, o2)) return false;
    } else if (Array.isArray(r3) && Array.isArray(o2)) {
      if (r3.length !== o2.length) return false;
      for (var i2 = 0; i2 < r3.length; i2++) if (r3[i2] !== o2[i2]) return false;
    } else if (r3 !== o2) return false;
  }
  for (var a2 in t2) if (void 0 === e10[a2] && void 0 !== t2[a2]) return false;
  return true;
}, Dg = ["text"], Sg = ["anchor", "focus"];
function Ag(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function xg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Ag(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : Ag(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var Og = { equals(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { loose: r3 = false } = n2;
  function o2(e11) {
    return bh(e11, Dg);
  }
  return wg(r3 ? o2(e10) : e10, r3 ? o2(t2) : t2);
}, isText: (e10) => cp(e10) && "string" == typeof e10.text, isTextList: (e10) => Array.isArray(e10) && e10.every((e11) => Og.isText(e11)), isTextProps: (e10) => void 0 !== e10.text, matches(e10, t2) {
  for (var n2 in t2) if ("text" !== n2 && (!e10.hasOwnProperty(n2) || e10[n2] !== t2[n2])) return false;
  return true;
}, decorations(e10, t2) {
  var n2 = [xg({}, e10)];
  for (var r3 of t2) {
    var o2 = bh(r3, Sg), [i2, a2] = yg.edges(r3), s2 = [], u2 = 0, l2 = i2.offset, c3 = a2.offset;
    for (var d2 of n2) {
      var { length: f2 } = d2.text, p2 = u2;
      if (u2 += f2, l2 <= p2 && u2 <= c3) Object.assign(d2, o2), s2.push(d2);
      else if (l2 !== c3 && (l2 === u2 || c3 === p2) || l2 > u2 || c3 < p2 || c3 === p2 && 0 !== p2) s2.push(d2);
      else {
        var h2 = d2, g2 = void 0, v2 = void 0;
        if (c3 < u2) {
          var m2 = c3 - p2;
          v2 = xg(xg({}, h2), {}, { text: h2.text.slice(m2) }), h2 = xg(xg({}, h2), {}, { text: h2.text.slice(0, m2) });
        }
        if (l2 > p2) {
          var y2 = l2 - p2;
          g2 = xg(xg({}, h2), {}, { text: h2.text.slice(0, y2) }), h2 = xg(xg({}, h2), {}, { text: h2.text.slice(y2) });
        }
        Object.assign(h2, o2), g2 && s2.push(g2), s2.push(h2), v2 && s2.push(v2);
      }
    }
    n2 = s2;
  }
  return n2;
} };
function Ng(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function Bg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Ng(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : Ng(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var Tg = { transform(e10, t2) {
  e10.children = sh(e10.children);
  var n2 = e10.selection && sh(e10.selection);
  try {
    n2 = ((e11, t3, n3) => {
      switch (n3.type) {
        case "insert_node":
          var { path: r3, node: o2 } = n3, i2 = ag.parent(e11, r3), a2 = r3[r3.length - 1];
          if (a2 > i2.children.length) throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r3, "] because the destination is past the end of the node."));
          if (i2.children.splice(a2, 0, o2), t3) for (var [s2, u2] of yg.points(t3)) t3[u2] = hg.transform(s2, n3);
          break;
        case "insert_text":
          var { path: l2, offset: c3, text: d2 } = n3;
          if (0 === d2.length) break;
          var f2 = ag.leaf(e11, l2), p2 = f2.text.slice(0, c3), h2 = f2.text.slice(c3);
          if (f2.text = p2 + d2 + h2, t3) for (var [g2, v2] of yg.points(t3)) t3[v2] = hg.transform(g2, n3);
          break;
        case "merge_node":
          var { path: m2 } = n3, y2 = ag.get(e11, m2), b2 = cg.previous(m2), E2 = ag.get(e11, b2), C2 = ag.parent(e11, m2), w2 = m2[m2.length - 1];
          if (Og.isText(y2) && Og.isText(E2)) E2.text += y2.text;
          else {
            if (Og.isText(y2) || Og.isText(E2)) throw new Error('Cannot apply a "merge_node" operation at path ['.concat(m2, "] to nodes of different interfaces: ").concat(Cg.stringify(y2), " ").concat(Cg.stringify(E2)));
            E2.children.push(...y2.children);
          }
          if (C2.children.splice(w2, 1), t3) for (var [D2, S2] of yg.points(t3)) t3[S2] = hg.transform(D2, n3);
          break;
        case "move_node":
          var { path: A2, newPath: x2 } = n3;
          if (cg.isAncestor(A2, x2)) throw new Error("Cannot move a path [".concat(A2, "] to new path [").concat(x2, "] because the destination is inside itself."));
          var O2 = ag.get(e11, A2), N2 = ag.parent(e11, A2), B2 = A2[A2.length - 1];
          N2.children.splice(B2, 1);
          var T2 = cg.transform(A2, n3), k2 = ag.get(e11, cg.parent(T2)), F2 = T2[T2.length - 1];
          if (k2.children.splice(F2, 0, O2), t3) for (var [I2, P2] of yg.points(t3)) t3[P2] = hg.transform(I2, n3);
          break;
        case "remove_node":
          var { path: _2 } = n3, R2 = _2[_2.length - 1];
          if (ag.parent(e11, _2).children.splice(R2, 1), t3) for (var [L2, M2] of yg.points(t3)) {
            var j2 = hg.transform(L2, n3);
            if (null != t3 && null != j2) t3[M2] = j2;
            else {
              var H2 = void 0, z2 = void 0;
              for (var [$2, U2] of ag.texts(e11)) {
                if (-1 !== cg.compare(U2, _2)) {
                  z2 = [$2, U2];
                  break;
                }
                H2 = [$2, U2];
              }
              var V2 = false;
              H2 && z2 && (V2 = cg.equals(z2[1], _2) ? !cg.hasPrevious(z2[1]) : cg.common(H2[1], _2).length < cg.common(z2[1], _2).length), H2 && !V2 ? (L2.path = H2[1], L2.offset = H2[0].text.length) : z2 ? (L2.path = z2[1], L2.offset = 0) : t3 = null;
            }
          }
          break;
        case "remove_text":
          var { path: W2, offset: G2, text: q2 } = n3;
          if (0 === q2.length) break;
          var K2 = ag.leaf(e11, W2), Y2 = K2.text.slice(0, G2), X2 = K2.text.slice(G2 + q2.length);
          if (K2.text = Y2 + X2, t3) for (var [Z2, J2] of yg.points(t3)) t3[J2] = hg.transform(Z2, n3);
          break;
        case "set_node":
          var { path: Q2, properties: ee2, newProperties: te2 } = n3;
          if (0 === Q2.length) throw new Error("Cannot set properties on the root node!");
          var ne2 = ag.get(e11, Q2);
          for (var re2 in te2) {
            if ("children" === re2 || "text" === re2) throw new Error('Cannot set the "'.concat(re2, '" property of nodes!'));
            var oe2 = te2[re2];
            null == oe2 ? delete ne2[re2] : ne2[re2] = oe2;
          }
          for (var ie2 in ee2) te2.hasOwnProperty(ie2) || delete ne2[ie2];
          break;
        case "set_selection":
          var { newProperties: ae2 } = n3;
          if (null == ae2) t3 = ae2;
          else {
            if (null == t3) {
              if (!yg.isRange(ae2)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(Cg.stringify(ae2), " when there is no current selection."));
              t3 = Bg({}, ae2);
            }
            for (var se2 in ae2) {
              var ue2 = ae2[se2];
              if (null == ue2) {
                if ("anchor" === se2 || "focus" === se2) throw new Error('Cannot remove the "'.concat(se2, '" selection property'));
                delete t3[se2];
              } else t3[se2] = ue2;
            }
          }
          break;
        case "split_node":
          var { path: le2, position: ce2, properties: de2 } = n3;
          if (0 === le2.length) throw new Error('Cannot apply a "split_node" operation at path ['.concat(le2, "] because the root node cannot be split."));
          var fe2, pe2 = ag.get(e11, le2), he2 = ag.parent(e11, le2), ge2 = le2[le2.length - 1];
          if (Og.isText(pe2)) {
            var ve2 = pe2.text.slice(0, ce2), me2 = pe2.text.slice(ce2);
            pe2.text = ve2, fe2 = Bg(Bg({}, de2), {}, { text: me2 });
          } else {
            var ye2 = pe2.children.slice(0, ce2), be2 = pe2.children.slice(ce2);
            pe2.children = ye2, fe2 = Bg(Bg({}, de2), {}, { children: be2 });
          }
          if (he2.children.splice(ge2 + 1, 0, fe2), t3) for (var [Ee2, Ce2] of yg.points(t3)) t3[Ce2] = hg.transform(Ee2, n3);
      }
      return t3;
    })(e10, n2, t2);
  } finally {
    e10.children = uh(e10.children), e10.selection = n2 ? fp(n2) ? uh(n2) : n2 : null;
  }
} }, kg = ["text"], Fg = ["children"];
function Ig(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function Pg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Ig(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : Ig(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var _g2 = { insertNodes(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  eg.withoutNormalizing(e10, () => {
    var { hanging: r3 = false, voids: o2 = false, mode: i2 = "lowest" } = n2, { at: a2, match: s2, select: u2 } = n2;
    if (ag.isNode(t2) && (t2 = [t2]), 0 !== t2.length) {
      var [l2] = t2;
      if (a2 || (a2 = e10.selection ? e10.selection : e10.children.length > 0 ? eg.end(e10, []) : [0], u2 = true), null == u2 && (u2 = false), yg.isRange(a2)) if (r3 || (a2 = eg.unhangRange(e10, a2)), yg.isCollapsed(a2)) a2 = a2.anchor;
      else {
        var [, c3] = yg.edges(a2), d2 = eg.pointRef(e10, c3);
        Wg.delete(e10, { at: a2 }), a2 = d2.unref();
      }
      if (hg.isPoint(a2)) {
        null == s2 && (s2 = Og.isText(l2) ? (e11) => Og.isText(e11) : e10.isInline(l2) ? (t3) => Og.isText(t3) || eg.isInline(e10, t3) : (t3) => eg.isBlock(e10, t3));
        var [f2] = eg.nodes(e10, { at: a2.path, match: s2, mode: i2, voids: o2 });
        if (!f2) return;
        var [, p2] = f2, h2 = eg.pathRef(e10, p2), g2 = eg.isEnd(e10, a2, p2);
        Wg.splitNodes(e10, { at: a2, match: s2, mode: i2, voids: o2 });
        var v2 = h2.unref();
        a2 = g2 ? cg.next(v2) : v2;
      }
      var m2 = cg.parent(a2), y2 = a2[a2.length - 1];
      if (o2 || !eg.void(e10, { at: m2 })) {
        for (var b2 of t2) {
          var E2 = m2.concat(y2);
          y2++, e10.apply({ type: "insert_node", path: E2, node: b2 }), a2 = cg.next(a2);
        }
        if (a2 = cg.previous(a2), u2) {
          var C2 = eg.end(e10, a2);
          C2 && Wg.select(e10, C2);
        }
      }
    }
  });
}, liftNodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { at: n2 = e10.selection, mode: r3 = "lowest", voids: o2 = false } = t2, { match: i2 } = t2;
    if (null == i2 && (i2 = cg.isPath(n2) ? Mg(e10, n2) : (t3) => eg.isBlock(e10, t3)), n2) {
      var a2 = eg.nodes(e10, { at: n2, match: i2, mode: r3, voids: o2 }), s2 = Array.from(a2, (t3) => {
        var [, n3] = t3;
        return eg.pathRef(e10, n3);
      });
      for (var u2 of s2) {
        var l2 = u2.unref();
        if (l2.length < 2) throw new Error("Cannot lift node at a path [".concat(l2, "] because it has a depth of less than `2`."));
        var c3 = eg.node(e10, cg.parent(l2)), [d2, f2] = c3, p2 = l2[l2.length - 1], { length: h2 } = d2.children;
        if (1 === h2) {
          var g2 = cg.next(f2);
          Wg.moveNodes(e10, { at: l2, to: g2, voids: o2 }), Wg.removeNodes(e10, { at: f2, voids: o2 });
        } else if (0 === p2) Wg.moveNodes(e10, { at: l2, to: f2, voids: o2 });
        else if (p2 === h2 - 1) {
          var v2 = cg.next(f2);
          Wg.moveNodes(e10, { at: l2, to: v2, voids: o2 });
        } else {
          var m2 = cg.next(l2), y2 = cg.next(f2);
          Wg.splitNodes(e10, { at: m2, voids: o2 }), Wg.moveNodes(e10, { at: l2, to: y2, voids: o2 });
        }
      }
    }
  });
}, mergeNodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { match: n2, at: r3 = e10.selection } = t2, { hanging: o2 = false, voids: i2 = false, mode: a2 = "lowest" } = t2;
    if (r3) {
      if (null == n2) if (cg.isPath(r3)) {
        var [s2] = eg.parent(e10, r3);
        n2 = (e11) => s2.children.includes(e11);
      } else n2 = (t3) => eg.isBlock(e10, t3);
      if (!o2 && yg.isRange(r3) && (r3 = eg.unhangRange(e10, r3)), yg.isRange(r3)) if (yg.isCollapsed(r3)) r3 = r3.anchor;
      else {
        var [, u2] = yg.edges(r3), l2 = eg.pointRef(e10, u2);
        Wg.delete(e10, { at: r3 }), r3 = l2.unref(), null == t2.at && Wg.select(e10, r3);
      }
      var [c3] = eg.nodes(e10, { at: r3, match: n2, voids: i2, mode: a2 }), d2 = eg.previous(e10, { at: r3, match: n2, voids: i2, mode: a2 });
      if (c3 && d2) {
        var [f2, p2] = c3, [h2, g2] = d2;
        if (0 !== p2.length && 0 !== g2.length) {
          var v2, m2, y2 = cg.next(g2), b2 = cg.common(p2, g2), E2 = cg.isSibling(p2, g2), C2 = Array.from(eg.levels(e10, { at: p2 }), (e11) => {
            var [t3] = e11;
            return t3;
          }).slice(b2.length).slice(0, -1), w2 = eg.above(e10, { at: p2, mode: "highest", match: (t3) => C2.includes(t3) && Rg(e10, t3) }), D2 = w2 && eg.pathRef(e10, w2[1]);
          if (Og.isText(f2) && Og.isText(h2)) {
            var S2 = bh(f2, kg);
            m2 = h2.text.length, v2 = S2;
          } else {
            if (!Kh.isElement(f2) || !Kh.isElement(h2)) throw new Error("Cannot merge the node at path [".concat(p2, "] with the previous sibling because it is not the same kind: ").concat(Cg.stringify(f2), " ").concat(Cg.stringify(h2)));
            S2 = bh(f2, Fg);
            m2 = h2.children.length, v2 = S2;
          }
          E2 || Wg.moveNodes(e10, { at: p2, to: y2, voids: i2 }), D2 && Wg.removeNodes(e10, { at: D2.current, voids: i2 }), Kh.isElement(h2) && eg.isEmpty(e10, h2) || Og.isText(h2) && "" === h2.text && 0 !== g2[g2.length - 1] ? Wg.removeNodes(e10, { at: g2, voids: i2 }) : e10.apply({ type: "merge_node", path: y2, position: m2, properties: v2 }), D2 && D2.unref();
        }
      }
    }
  });
}, moveNodes(e10, t2) {
  eg.withoutNormalizing(e10, () => {
    var { to: n2, at: r3 = e10.selection, mode: o2 = "lowest", voids: i2 = false } = t2, { match: a2 } = t2;
    if (r3) {
      null == a2 && (a2 = cg.isPath(r3) ? Mg(e10, r3) : (t3) => eg.isBlock(e10, t3));
      var s2 = eg.pathRef(e10, n2), u2 = eg.nodes(e10, { at: r3, match: a2, mode: o2, voids: i2 }), l2 = Array.from(u2, (t3) => {
        var [, n3] = t3;
        return eg.pathRef(e10, n3);
      });
      for (var c3 of l2) {
        var d2 = c3.unref(), f2 = s2.current;
        0 !== d2.length && e10.apply({ type: "move_node", path: d2, newPath: f2 }), s2.current && cg.isSibling(f2, d2) && cg.isAfter(f2, d2) && (s2.current = cg.next(s2.current));
      }
      s2.unref();
    }
  });
}, removeNodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { hanging: n2 = false, voids: r3 = false, mode: o2 = "lowest" } = t2, { at: i2 = e10.selection, match: a2 } = t2;
    if (i2) {
      null == a2 && (a2 = cg.isPath(i2) ? Mg(e10, i2) : (t3) => eg.isBlock(e10, t3)), !n2 && yg.isRange(i2) && (i2 = eg.unhangRange(e10, i2));
      var s2 = eg.nodes(e10, { at: i2, match: a2, mode: o2, voids: r3 }), u2 = Array.from(s2, (t3) => {
        var [, n3] = t3;
        return eg.pathRef(e10, n3);
      });
      for (var l2 of u2) {
        var c3 = l2.unref();
        if (c3) {
          var [d2] = eg.node(e10, c3);
          e10.apply({ type: "remove_node", path: c3, node: d2 });
        }
      }
    }
  });
}, setNodes(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  eg.withoutNormalizing(e10, () => {
    var { match: r3, at: o2 = e10.selection, compare: i2, merge: a2 } = n2, { hanging: s2 = false, mode: u2 = "lowest", split: l2 = false, voids: c3 = false } = n2;
    if (o2) {
      if (null == r3 && (r3 = cg.isPath(o2) ? Mg(e10, o2) : (t3) => eg.isBlock(e10, t3)), !s2 && yg.isRange(o2) && (o2 = eg.unhangRange(e10, o2)), l2 && yg.isRange(o2)) {
        if (yg.isCollapsed(o2) && eg.leaf(e10, o2.anchor)[0].text.length > 0) return;
        var d2 = eg.rangeRef(e10, o2, { affinity: "inward" }), [f2, p2] = yg.edges(o2), h2 = "lowest" === u2 ? "lowest" : "highest", g2 = eg.isEnd(e10, p2, p2.path);
        Wg.splitNodes(e10, { at: p2, match: r3, mode: h2, voids: c3, always: !g2 });
        var v2 = eg.isStart(e10, f2, f2.path);
        Wg.splitNodes(e10, { at: f2, match: r3, mode: h2, voids: c3, always: !v2 }), o2 = d2.unref(), null == n2.at && Wg.select(e10, o2);
      }
      for (var [m2, y2] of (i2 || (i2 = (e11, t3) => e11 !== t3), eg.nodes(e10, { at: o2, match: r3, mode: u2, voids: c3 }))) {
        var b2 = {}, E2 = {};
        if (0 !== y2.length) {
          var C2 = false;
          for (var w2 in t2) "children" !== w2 && "text" !== w2 && i2(t2[w2], m2[w2]) && (C2 = true, m2.hasOwnProperty(w2) && (b2[w2] = m2[w2]), a2 ? null != t2[w2] && (E2[w2] = a2(m2[w2], t2[w2])) : null != t2[w2] && (E2[w2] = t2[w2]));
          C2 && e10.apply({ type: "set_node", path: y2, properties: b2, newProperties: E2 });
        }
      }
    }
  });
}, splitNodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { mode: n2 = "lowest", voids: r3 = false } = t2, { match: o2, at: i2 = e10.selection, height: a2 = 0, always: s2 = false } = t2;
    if (null == o2 && (o2 = (t3) => eg.isBlock(e10, t3)), yg.isRange(i2) && (i2 = Lg(e10, i2)), cg.isPath(i2)) {
      var u2 = i2, l2 = eg.point(e10, u2), [c3] = eg.parent(e10, u2);
      o2 = (e11) => e11 === c3, a2 = l2.path.length - u2.length + 1, i2 = l2, s2 = true;
    }
    if (i2) {
      var d2, f2 = eg.pointRef(e10, i2, { affinity: "backward" });
      try {
        var [p2] = eg.nodes(e10, { at: i2, match: o2, mode: n2, voids: r3 });
        if (!p2) return;
        var h2 = eg.void(e10, { at: i2, mode: "highest" });
        if (!r3 && h2) {
          var [g2, v2] = h2;
          if (Kh.isElement(g2) && e10.isInline(g2)) {
            var m2 = eg.after(e10, v2);
            if (!m2) {
              var y2 = cg.next(v2);
              Wg.insertNodes(e10, { text: "" }, { at: y2, voids: r3 }), m2 = eg.point(e10, y2);
            }
            i2 = m2, s2 = true;
          }
          a2 = i2.path.length - v2.length + 1, s2 = true;
        }
        d2 = eg.pointRef(e10, i2);
        var b2 = i2.path.length - a2, [, E2] = p2, C2 = i2.path.slice(0, b2), w2 = 0 === a2 ? i2.offset : i2.path[b2] + 0;
        for (var [D2, S2] of eg.levels(e10, { at: C2, reverse: true, voids: r3 })) {
          var A2 = false;
          if (S2.length < E2.length || 0 === S2.length || !r3 && eg.isVoid(e10, D2)) break;
          var x2 = f2.current, O2 = eg.isEnd(e10, x2, S2);
          if (s2 || !f2 || !eg.isEdge(e10, x2, S2)) {
            A2 = true;
            var N2 = ag.extractProps(D2);
            e10.apply({ type: "split_node", path: S2, position: w2, properties: N2 });
          }
          w2 = S2[S2.length - 1] + (A2 || O2 ? 1 : 0);
        }
        if (null == t2.at) {
          var B2 = d2.current || eg.end(e10, []);
          Wg.select(e10, B2);
        }
      } finally {
        var T2;
        f2.unref(), null === (T2 = d2) || void 0 === T2 || T2.unref();
      }
    }
  });
}, unsetNodes(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  Array.isArray(t2) || (t2 = [t2]);
  var r3 = {};
  for (var o2 of t2) r3[o2] = null;
  Wg.setNodes(e10, r3, n2);
}, unwrapNodes(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { mode: n2 = "lowest", split: r3 = false, voids: o2 = false } = t2, { at: i2 = e10.selection, match: a2 } = t2;
    if (i2) {
      null == a2 && (a2 = cg.isPath(i2) ? Mg(e10, i2) : (t3) => eg.isBlock(e10, t3)), cg.isPath(i2) && (i2 = eg.range(e10, i2));
      var s2 = yg.isRange(i2) ? eg.rangeRef(e10, i2) : null, u2 = eg.nodes(e10, { at: i2, match: a2, mode: n2, voids: o2 }), l2 = Array.from(u2, (t3) => {
        var [, n3] = t3;
        return eg.pathRef(e10, n3);
      }).reverse(), c3 = function(t3) {
        var n3 = t3.unref(), [i3] = eg.node(e10, n3), a3 = eg.range(e10, n3);
        r3 && s2 && (a3 = yg.intersection(s2.current, a3)), Wg.liftNodes(e10, { at: a3, match: (e11) => Kh.isAncestor(i3) && i3.children.includes(e11), voids: o2 });
      };
      for (var d2 of l2) c3(d2);
      s2 && s2.unref();
    }
  });
}, wrapNodes(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  eg.withoutNormalizing(e10, () => {
    var { mode: r3 = "lowest", split: o2 = false, voids: i2 = false } = n2, { match: a2, at: s2 = e10.selection } = n2;
    if (s2) {
      if (null == a2 && (a2 = cg.isPath(s2) ? Mg(e10, s2) : e10.isInline(t2) ? (t3) => eg.isInline(e10, t3) || Og.isText(t3) : (t3) => eg.isBlock(e10, t3)), o2 && yg.isRange(s2)) {
        var [u2, l2] = yg.edges(s2), c3 = eg.rangeRef(e10, s2, { affinity: "inward" });
        Wg.splitNodes(e10, { at: l2, match: a2, voids: i2 }), Wg.splitNodes(e10, { at: u2, match: a2, voids: i2 }), s2 = c3.unref(), null == n2.at && Wg.select(e10, s2);
      }
      var d2 = Array.from(eg.nodes(e10, { at: s2, match: e10.isInline(t2) ? (t3) => eg.isBlock(e10, t3) : (e11) => eg.isEditor(e11), mode: "lowest", voids: i2 }));
      for (var [, f2] of d2) {
        var p2 = yg.isRange(s2) ? yg.intersection(s2, eg.range(e10, f2)) : s2;
        if (p2) {
          var h2 = Array.from(eg.nodes(e10, { at: p2, match: a2, mode: r3, voids: i2 }));
          if (h2.length > 0) {
            var g2 = function() {
              var [n3] = h2, r4 = h2[h2.length - 1], [, o3] = n3, [, a3] = r4;
              if (0 === o3.length && 0 === a3.length) return "continue";
              var s3 = cg.equals(o3, a3) ? cg.parent(o3) : cg.common(o3, a3), u3 = eg.range(e10, o3, a3), l3 = eg.node(e10, s3), [c4] = l3, d3 = s3.length + 1, f3 = cg.next(a3.slice(0, d3)), p3 = Pg(Pg({}, t2), {}, { children: [] });
              Wg.insertNodes(e10, p3, { at: f3, voids: i2 }), Wg.moveNodes(e10, { at: u3, match: (e11) => Kh.isAncestor(c4) && c4.children.includes(e11), to: f3.concat(0), voids: i2 });
            }();
            if ("continue" === g2) continue;
          }
        }
      }
    }
  });
} }, Rg = (e10, t2) => {
  if (Kh.isElement(t2)) {
    var n2 = t2;
    return !!eg.isVoid(e10, t2) || 1 === n2.children.length && Rg(e10, n2.children[0]);
  }
  return !eg.isEditor(t2);
}, Lg = (e10, t2) => {
  if (yg.isCollapsed(t2)) return t2.anchor;
  var [, n2] = yg.edges(t2), r3 = eg.pointRef(e10, n2);
  return Wg.delete(e10, { at: t2 }), r3.unref();
}, Mg = (e10, t2) => {
  var [n2] = eg.node(e10, t2);
  return (e11) => e11 === n2;
};
function jg(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function Hg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? jg(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : jg(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var zg = { collapse(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { edge: n2 = "anchor" } = t2, { selection: r3 } = e10;
  if (r3) {
    if ("anchor" === n2) Wg.select(e10, r3.anchor);
    else if ("focus" === n2) Wg.select(e10, r3.focus);
    else if ("start" === n2) {
      var [o2] = yg.edges(r3);
      Wg.select(e10, o2);
    } else if ("end" === n2) {
      var [, i2] = yg.edges(r3);
      Wg.select(e10, i2);
    }
  }
}, deselect(e10) {
  var { selection: t2 } = e10;
  t2 && e10.apply({ type: "set_selection", properties: t2, newProperties: null });
}, move(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { selection: n2 } = e10, { distance: r3 = 1, unit: o2 = "character", reverse: i2 = false } = t2, { edge: a2 = null } = t2;
  if (n2) {
    "start" === a2 && (a2 = yg.isBackward(n2) ? "focus" : "anchor"), "end" === a2 && (a2 = yg.isBackward(n2) ? "anchor" : "focus");
    var { anchor: s2, focus: u2 } = n2, l2 = { distance: r3, unit: o2 }, c3 = {};
    if (null == a2 || "anchor" === a2) {
      var d2 = i2 ? eg.before(e10, s2, l2) : eg.after(e10, s2, l2);
      d2 && (c3.anchor = d2);
    }
    if (null == a2 || "focus" === a2) {
      var f2 = i2 ? eg.before(e10, u2, l2) : eg.after(e10, u2, l2);
      f2 && (c3.focus = f2);
    }
    Wg.setSelection(e10, c3);
  }
}, select(e10, t2) {
  var { selection: n2 } = e10;
  if (t2 = eg.range(e10, t2), n2) Wg.setSelection(e10, t2);
  else {
    if (!yg.isRange(t2)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Cg.stringify(t2)));
    e10.apply({ type: "set_selection", properties: n2, newProperties: t2 });
  }
}, setPoint(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, { selection: r3 } = e10, { edge: o2 = "both" } = n2;
  if (r3) {
    "start" === o2 && (o2 = yg.isBackward(r3) ? "focus" : "anchor"), "end" === o2 && (o2 = yg.isBackward(r3) ? "anchor" : "focus");
    var { anchor: i2, focus: a2 } = r3, s2 = "anchor" === o2 ? i2 : a2;
    Wg.setSelection(e10, { ["anchor" === o2 ? "anchor" : "focus"]: Hg(Hg({}, s2), t2) });
  }
}, setSelection(e10, t2) {
  var { selection: n2 } = e10, r3 = {}, o2 = {};
  if (n2) {
    for (var i2 in t2) ("anchor" === i2 && null != t2.anchor && !hg.equals(t2.anchor, n2.anchor) || "focus" === i2 && null != t2.focus && !hg.equals(t2.focus, n2.focus) || "anchor" !== i2 && "focus" !== i2 && t2[i2] !== n2[i2]) && (r3[i2] = n2[i2], o2[i2] = t2[i2]);
    Object.keys(r3).length > 0 && e10.apply({ type: "set_selection", properties: r3, newProperties: o2 });
  }
} }, $g = { delete(e10) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  eg.withoutNormalizing(e10, () => {
    var { reverse: n2 = false, unit: r3 = "character", distance: o2 = 1, voids: i2 = false } = t2, { at: a2 = e10.selection, hanging: s2 = false } = t2;
    if (a2) {
      var u2 = false;
      if (yg.isRange(a2) && yg.isCollapsed(a2) && (u2 = true, a2 = a2.anchor), hg.isPoint(a2)) {
        var l2 = eg.void(e10, { at: a2, mode: "highest" });
        if (!i2 && l2) {
          var [, c3] = l2;
          a2 = c3;
        } else {
          var d2 = { unit: r3, distance: o2 };
          a2 = { anchor: a2, focus: n2 ? eg.before(e10, a2, d2) || eg.start(e10, []) : eg.after(e10, a2, d2) || eg.end(e10, []) }, s2 = true;
        }
      }
      if (cg.isPath(a2)) Wg.removeNodes(e10, { at: a2, voids: i2 });
      else if (!yg.isCollapsed(a2)) {
        if (!s2) {
          var [, f2] = yg.edges(a2), p2 = eg.end(e10, []);
          hg.equals(f2, p2) || (a2 = eg.unhangRange(e10, a2, { voids: i2 }));
        }
        var [h2, g2] = yg.edges(a2), v2 = eg.above(e10, { match: (t3) => eg.isBlock(e10, t3), at: h2, voids: i2 }), m2 = eg.above(e10, { match: (t3) => eg.isBlock(e10, t3), at: g2, voids: i2 }), y2 = v2 && m2 && !cg.equals(v2[1], m2[1]), b2 = cg.equals(h2.path, g2.path), E2 = i2 ? null : eg.void(e10, { at: h2, mode: "highest" }), C2 = i2 ? null : eg.void(e10, { at: g2, mode: "highest" });
        if (E2) {
          var w2 = eg.before(e10, h2);
          w2 && v2 && cg.isAncestor(v2[1], w2.path) && (h2 = w2);
        }
        if (C2) {
          var D2 = eg.after(e10, g2);
          D2 && m2 && cg.isAncestor(m2[1], D2.path) && (g2 = D2);
        }
        var S2, A2 = [];
        for (var x2 of eg.nodes(e10, { at: a2, voids: i2 })) {
          var [O2, N2] = x2;
          S2 && 0 === cg.compare(N2, S2) || (!i2 && eg.isVoid(e10, O2) || !cg.isCommon(N2, h2.path) && !cg.isCommon(N2, g2.path)) && (A2.push(x2), S2 = N2);
        }
        var B2 = Array.from(A2, (t3) => {
          var [, n3] = t3;
          return eg.pathRef(e10, n3);
        }), T2 = eg.pointRef(e10, h2), k2 = eg.pointRef(e10, g2), F2 = "";
        if (!b2 && !E2) {
          var I2 = T2.current, [P2] = eg.leaf(e10, I2), { path: _2 } = I2, { offset: R2 } = h2, L2 = P2.text.slice(R2);
          L2.length > 0 && (e10.apply({ type: "remove_text", path: _2, offset: R2, text: L2 }), F2 = L2);
        }
        for (var M2 of B2) {
          var j2 = M2.unref();
          Wg.removeNodes(e10, { at: j2, voids: i2 });
        }
        if (!C2) {
          var H2 = k2.current, [z2] = eg.leaf(e10, H2), { path: $2 } = H2, U2 = b2 ? h2.offset : 0, V2 = z2.text.slice(U2, g2.offset);
          V2.length > 0 && (e10.apply({ type: "remove_text", path: $2, offset: U2, text: V2 }), F2 = V2);
        }
        !b2 && y2 && k2.current && T2.current && Wg.mergeNodes(e10, { at: k2.current, hanging: true, voids: i2 }), u2 && n2 && "character" === r3 && F2.length > 1 && F2.match(/[\u0E00-\u0E7F]+/) && Wg.insertText(e10, F2.slice(0, F2.length - o2));
        var W2 = T2.unref(), G2 = k2.unref(), q2 = n2 ? W2 || G2 : G2 || W2;
        null == t2.at && q2 && Wg.select(e10, q2);
      }
    }
  });
}, insertFragment(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  eg.withoutNormalizing(e10, () => {
    var { hanging: r3 = false, voids: o2 = false } = n2, { at: i2 = e10.selection } = n2;
    if (t2.length && i2) {
      if (yg.isRange(i2)) if (r3 || (i2 = eg.unhangRange(e10, i2)), yg.isCollapsed(i2)) i2 = i2.anchor;
      else {
        var [, a2] = yg.edges(i2);
        if (!o2 && eg.void(e10, { at: a2 })) return;
        var s2 = eg.pointRef(e10, a2);
        Wg.delete(e10, { at: i2 }), i2 = s2.unref();
      }
      else cg.isPath(i2) && (i2 = eg.start(e10, i2));
      if (o2 || !eg.void(e10, { at: i2 })) {
        var u2 = eg.above(e10, { at: i2, match: (t3) => eg.isInline(e10, t3), mode: "highest", voids: o2 });
        if (u2) {
          var [, l2] = u2;
          if (eg.isEnd(e10, i2, l2)) i2 = eg.after(e10, l2);
          else if (eg.isStart(e10, i2, l2)) {
            i2 = eg.before(e10, l2);
          }
        }
        var c3 = eg.above(e10, { match: (t3) => eg.isBlock(e10, t3), at: i2, voids: o2 }), [, d2] = c3, f2 = eg.isStart(e10, i2, d2), p2 = eg.isEnd(e10, i2, d2), h2 = f2 && p2, g2 = !f2 || f2 && p2, v2 = !p2, [, m2] = ag.first({ children: t2 }, []), [, y2] = ag.last({ children: t2 }, []), b2 = [], E2 = (t3) => {
          var [n3, r4] = t3;
          return !(0 === r4.length) && (!!h2 || !(g2 && cg.isAncestor(r4, m2) && Kh.isElement(n3) && !e10.isVoid(n3) && !e10.isInline(n3)) && !(v2 && cg.isAncestor(r4, y2) && Kh.isElement(n3) && !e10.isVoid(n3) && !e10.isInline(n3)));
        };
        for (var C2 of ag.nodes({ children: t2 }, { pass: E2 })) E2(C2) && b2.push(C2);
        var w2 = [], D2 = [], S2 = [], A2 = true, x2 = false;
        for (var [O2] of b2) Kh.isElement(O2) && !e10.isInline(O2) ? (A2 = false, x2 = true, D2.push(O2)) : A2 ? w2.push(O2) : S2.push(O2);
        var [N2] = eg.nodes(e10, { at: i2, match: (t3) => Og.isText(t3) || eg.isInline(e10, t3), mode: "highest", voids: o2 }), [, B2] = N2, T2 = eg.isStart(e10, i2, B2), k2 = eg.isEnd(e10, i2, B2), F2 = eg.pathRef(e10, p2 && !S2.length ? cg.next(d2) : d2), I2 = eg.pathRef(e10, k2 ? cg.next(B2) : B2);
        Wg.splitNodes(e10, { at: i2, match: (t3) => x2 ? eg.isBlock(e10, t3) : Og.isText(t3) || eg.isInline(e10, t3), mode: x2 ? "lowest" : "highest", always: x2 && (!f2 || w2.length > 0) && (!p2 || S2.length > 0), voids: o2 });
        var P2, _2 = eg.pathRef(e10, !T2 || T2 && k2 ? cg.next(B2) : B2);
        if (Wg.insertNodes(e10, w2, { at: _2.current, match: (t3) => Og.isText(t3) || eg.isInline(e10, t3), mode: "highest", voids: o2 }), h2 && !w2.length && D2.length && !S2.length && Wg.delete(e10, { at: d2, voids: o2 }), Wg.insertNodes(e10, D2, { at: F2.current, match: (t3) => eg.isBlock(e10, t3), mode: "lowest", voids: o2 }), Wg.insertNodes(e10, S2, { at: I2.current, match: (t3) => Og.isText(t3) || eg.isInline(e10, t3), mode: "highest", voids: o2 }), !n2.at) {
          if (S2.length > 0 && I2.current ? P2 = cg.previous(I2.current) : D2.length > 0 && F2.current ? P2 = cg.previous(F2.current) : _2.current && (P2 = cg.previous(_2.current)), P2) {
            var R2 = eg.end(e10, P2);
            Wg.select(e10, R2);
          }
        }
        _2.unref(), F2.unref(), I2.unref();
      }
    }
  });
}, insertText(e10, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  eg.withoutNormalizing(e10, () => {
    var { voids: r3 = false } = n2, { at: o2 = e10.selection } = n2;
    if (o2) {
      if (cg.isPath(o2) && (o2 = eg.range(e10, o2)), yg.isRange(o2)) if (yg.isCollapsed(o2)) o2 = o2.anchor;
      else {
        var i2 = yg.end(o2);
        if (!r3 && eg.void(e10, { at: i2 })) return;
        var a2 = yg.start(o2), s2 = eg.pointRef(e10, a2), u2 = eg.pointRef(e10, i2);
        Wg.delete(e10, { at: o2, voids: r3 });
        var l2 = s2.unref(), c3 = u2.unref();
        o2 = l2 || c3, Wg.setSelection(e10, { anchor: o2, focus: o2 });
      }
      if (r3 || !eg.void(e10, { at: o2 })) {
        var { path: d2, offset: f2 } = o2;
        t2.length > 0 && e10.apply({ type: "insert_text", path: d2, offset: f2, text: t2 });
      }
    }
  });
} };
function Ug(e10, t2) {
  var n2 = Object.keys(e10);
  if (Object.getOwnPropertySymbols) {
    var r3 = Object.getOwnPropertySymbols(e10);
    t2 && (r3 = r3.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e10, t3).enumerable;
    })), n2.push.apply(n2, r3);
  }
  return n2;
}
function Vg(e10) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Ug(Object(n2), true).forEach(function(t3) {
      lh(e10, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e10, Object.getOwnPropertyDescriptors(n2)) : Ug(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e10, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e10;
}
var Wg = Vg(Vg(Vg(Vg({}, Tg), _g2), zg), $g), Gg = { isHistory: (e10) => cp(e10) && Array.isArray(e10.redos) && Array.isArray(e10.undos) && (0 === e10.redos.length || lg.isOperationList(e10.redos[0].operations)) && (0 === e10.undos.length || lg.isOperationList(e10.undos[0].operations)) }, qg = /* @__PURE__ */ new WeakMap(), Kg = /* @__PURE__ */ new WeakMap(), Yg = { isHistoryEditor: (e10) => Gg.isHistory(e10.history) && eg.isEditor(e10), isMerging: (e10) => Kg.get(e10), isSaving: (e10) => qg.get(e10), redo(e10) {
  e10.redo();
}, undo(e10) {
  e10.undo();
}, withMerging(e10, t2) {
  var n2 = Yg.isMerging(e10);
  Kg.set(e10, true), t2(), Kg.set(e10, n2);
}, withoutMerging(e10, t2) {
  var n2 = Yg.isMerging(e10);
  Kg.set(e10, false), t2(), Kg.set(e10, n2);
}, withoutSaving(e10, t2) {
  var n2 = Yg.isSaving(e10);
  qg.set(e10, false), t2(), qg.set(e10, n2);
} }, Xg = (e10) => {
  var t2 = e10, { apply: n2 } = t2;
  return t2.history = { undos: [], redos: [] }, t2.redo = () => {
    var { history: e11 } = t2, { redos: n3 } = e11;
    if (n3.length > 0) {
      var r3 = n3[n3.length - 1];
      r3.selectionBefore && Wg.setSelection(t2, r3.selectionBefore), Yg.withoutSaving(t2, () => {
        eg.withoutNormalizing(t2, () => {
          for (var e12 of r3.operations) t2.apply(e12);
        });
      }), e11.redos.pop(), t2.writeHistory("undos", r3);
    }
  }, t2.undo = () => {
    var { history: e11 } = t2, { undos: n3 } = e11;
    if (n3.length > 0) {
      var r3 = n3[n3.length - 1];
      Yg.withoutSaving(t2, () => {
        eg.withoutNormalizing(t2, () => {
          var e12 = r3.operations.map(lg.inverse).reverse();
          for (var n4 of e12) t2.apply(n4);
          r3.selectionBefore && Wg.setSelection(t2, r3.selectionBefore);
        });
      }), t2.writeHistory("redos", r3), e11.undos.pop();
    }
  }, t2.apply = (e11) => {
    var { operations: r3, history: o2 } = t2, { undos: i2 } = o2, a2 = i2[i2.length - 1], s2 = a2 && a2.operations[a2.operations.length - 1], u2 = Yg.isSaving(t2), l2 = Yg.isMerging(t2);
    if (null == u2 && (u2 = Jg(e11)), u2) {
      if (null == l2 && (l2 = null != a2 && (0 !== r3.length || Zg(e11, s2))), a2 && l2) a2.operations.push(e11);
      else {
        var c3 = { operations: [e11], selectionBefore: t2.selection };
        t2.writeHistory("undos", c3);
      }
      for (; i2.length > 100; ) i2.shift();
      o2.redos = [];
    }
    n2(e11);
  }, t2.writeHistory = (e11, n3) => {
    t2.history[e11].push(n3);
  }, t2;
}, Zg = (e10, t2) => !(!t2 || "insert_text" !== e10.type || "insert_text" !== t2.type || e10.offset !== t2.offset + t2.text.length || !cg.equals(e10.path, t2.path)) || !(!t2 || "remove_text" !== e10.type || "remove_text" !== t2.type || e10.offset + e10.text.length !== t2.offset || !cg.equals(e10.path, t2.path)), Jg = (e10, t2) => "set_selection" !== e10.type, Qg = function(e10, t2) {
  return Qg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e11, t3) {
    e11.__proto__ = t3;
  } || function(e11, t3) {
    for (var n2 in t3) Object.prototype.hasOwnProperty.call(t3, n2) && (e11[n2] = t3[n2]);
  }, Qg(e10, t2);
};
function ev(e10, t2) {
  if ("function" != typeof t2 && null !== t2) throw new TypeError("Class extends value " + String(t2) + " is not a constructor or null");
  function n2() {
    this.constructor = e10;
  }
  Qg(e10, t2), e10.prototype = null === t2 ? Object.create(t2) : (n2.prototype = t2.prototype, new n2());
}
var tv = function() {
  return tv = Object.assign || function(e10) {
    for (var t2, n2 = 1, r3 = arguments.length; n2 < r3; n2++) for (var o2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, o2) && (e10[o2] = t2[o2]);
    return e10;
  }, tv.apply(this, arguments);
};
function nv(e10, t2, n2, r3) {
  return new (n2 || (n2 = Promise))(function(o2, i2) {
    function a2(e11) {
      try {
        u2(r3.next(e11));
      } catch (e12) {
        i2(e12);
      }
    }
    function s2(e11) {
      try {
        u2(r3.throw(e11));
      } catch (e12) {
        i2(e12);
      }
    }
    function u2(e11) {
      var t3;
      e11.done ? o2(e11.value) : (t3 = e11.value, t3 instanceof n2 ? t3 : new n2(function(e12) {
        e12(t3);
      })).then(a2, s2);
    }
    u2((r3 = r3.apply(e10, t2 || [])).next());
  });
}
function rv(e10, t2) {
  var n2, r3, o2, i2 = { label: 0, sent: function() {
    if (1 & o2[0]) throw o2[1];
    return o2[1];
  }, trys: [], ops: [] }, a2 = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
  return a2.next = s2(0), a2.throw = s2(1), a2.return = s2(2), "function" == typeof Symbol && (a2[Symbol.iterator] = function() {
    return this;
  }), a2;
  function s2(s3) {
    return function(u2) {
      return function(s4) {
        if (n2) throw new TypeError("Generator is already executing.");
        for (; a2 && (a2 = 0, s4[0] && (i2 = 0)), i2; ) try {
          if (n2 = 1, r3 && (o2 = 2 & s4[0] ? r3.return : s4[0] ? r3.throw || ((o2 = r3.return) && o2.call(r3), 0) : r3.next) && !(o2 = o2.call(r3, s4[1])).done) return o2;
          switch (r3 = 0, o2 && (s4 = [2 & s4[0], o2.value]), s4[0]) {
            case 0:
            case 1:
              o2 = s4;
              break;
            case 4:
              return i2.label++, { value: s4[1], done: false };
            case 5:
              i2.label++, r3 = s4[1], s4 = [0];
              continue;
            case 7:
              s4 = i2.ops.pop(), i2.trys.pop();
              continue;
            default:
              if (!(o2 = i2.trys, (o2 = o2.length > 0 && o2[o2.length - 1]) || 6 !== s4[0] && 2 !== s4[0])) {
                i2 = 0;
                continue;
              }
              if (3 === s4[0] && (!o2 || s4[1] > o2[0] && s4[1] < o2[3])) {
                i2.label = s4[1];
                break;
              }
              if (6 === s4[0] && i2.label < o2[1]) {
                i2.label = o2[1], o2 = s4;
                break;
              }
              if (o2 && i2.label < o2[2]) {
                i2.label = o2[2], i2.ops.push(s4);
                break;
              }
              o2[2] && i2.ops.pop(), i2.trys.pop();
              continue;
          }
          s4 = t2.call(e10, i2);
        } catch (e11) {
          s4 = [6, e11], r3 = 0;
        } finally {
          n2 = o2 = 0;
        }
        if (5 & s4[0]) throw s4[1];
        return { value: s4[0] ? s4[1] : void 0, done: true };
      }([s3, u2]);
    };
  }
}
function ov(e10) {
  var t2 = "function" == typeof Symbol && Symbol.iterator, n2 = t2 && e10[t2], r3 = 0;
  if (n2) return n2.call(e10);
  if (e10 && "number" == typeof e10.length) return { next: function() {
    return e10 && r3 >= e10.length && (e10 = void 0), { value: e10 && e10[r3++], done: !e10 };
  } };
  throw new TypeError(t2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function iv(e10, t2) {
  var n2 = "function" == typeof Symbol && e10[Symbol.iterator];
  if (!n2) return e10;
  var r3, o2, i2 = n2.call(e10), a2 = [];
  try {
    for (; (void 0 === t2 || t2-- > 0) && !(r3 = i2.next()).done; ) a2.push(r3.value);
  } catch (e11) {
    o2 = { error: e11 };
  } finally {
    try {
      r3 && !r3.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (o2) throw o2.error;
    }
  }
  return a2;
}
function av(e10, t2, n2) {
  if (2 === arguments.length) for (var r3, o2 = 0, i2 = t2.length; o2 < i2; o2++) !r3 && o2 in t2 || (r3 || (r3 = Array.prototype.slice.call(t2, 0, o2)), r3[o2] = t2[o2]);
  return e10.concat(r3 || Array.prototype.slice.call(t2));
}
function sv(e10) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t2, n2 = e10[Symbol.asyncIterator];
  return n2 ? n2.call(e10) : (e10 = ov(e10), t2 = {}, r3("next"), r3("throw"), r3("return"), t2[Symbol.asyncIterator] = function() {
    return this;
  }, t2);
  function r3(n3) {
    t2[n3] = e10[n3] && function(t3) {
      return new Promise(function(r4, o2) {
        (function(e11, t4, n4, r5) {
          Promise.resolve(r5).then(function(t5) {
            e11({ value: t5, done: n4 });
          }, t4);
        })(r4, o2, (t3 = e10[n3](t3)).done, t3.value);
      });
    };
  }
}
"function" == typeof SuppressedError && SuppressedError;
var uv, lv = { exports: {} };
var cv, dv, fv = (uv || (uv = 1, function(e10, t2) {
  var n2 = "__lodash_hash_undefined__", r3 = 9007199254740991, o2 = "[object Arguments]", i2 = "[object Boolean]", a2 = "[object Date]", s2 = "[object Function]", u2 = "[object GeneratorFunction]", l2 = "[object Map]", c3 = "[object Number]", d2 = "[object Object]", f2 = "[object Promise]", p2 = "[object RegExp]", h2 = "[object Set]", g2 = "[object String]", v2 = "[object Symbol]", m2 = "[object WeakMap]", b2 = "[object ArrayBuffer]", E2 = "[object DataView]", C2 = "[object Float32Array]", w2 = "[object Float64Array]", D2 = "[object Int8Array]", S2 = "[object Int16Array]", A2 = "[object Int32Array]", x2 = "[object Uint8Array]", O2 = "[object Uint8ClampedArray]", N2 = "[object Uint16Array]", B2 = "[object Uint32Array]", T2 = /\w*$/, k2 = /^\[object .+?Constructor\]$/, F2 = /^(?:0|[1-9]\d*)$/, I2 = {};
  I2[o2] = I2["[object Array]"] = I2[b2] = I2[E2] = I2[i2] = I2[a2] = I2[C2] = I2[w2] = I2[D2] = I2[S2] = I2[A2] = I2[l2] = I2[c3] = I2[d2] = I2[p2] = I2[h2] = I2[g2] = I2[v2] = I2[x2] = I2[O2] = I2[N2] = I2[B2] = true, I2["[object Error]"] = I2[s2] = I2[m2] = false;
  var P2 = "object" == typeof y && y && y.Object === Object && y, _2 = "object" == typeof self && self && self.Object === Object && self, R2 = P2 || _2 || Function("return this")(), L2 = t2 && !t2.nodeType && t2, M2 = L2 && e10 && !e10.nodeType && e10, j2 = M2 && M2.exports === L2;
  function H2(e11, t3) {
    return e11.set(t3[0], t3[1]), e11;
  }
  function z2(e11, t3) {
    return e11.add(t3), e11;
  }
  function $2(e11, t3, n3, r4) {
    for (var o3 = -1, i3 = e11 ? e11.length : 0; ++o3 < i3; ) n3 = t3(n3, e11[o3], o3, e11);
    return n3;
  }
  function U2(e11) {
    var t3 = false;
    if (null != e11 && "function" != typeof e11.toString) try {
      t3 = !!(e11 + "");
    } catch (e12) {
    }
    return t3;
  }
  function V2(e11) {
    var t3 = -1, n3 = Array(e11.size);
    return e11.forEach(function(e12, r4) {
      n3[++t3] = [r4, e12];
    }), n3;
  }
  function W2(e11, t3) {
    return function(n3) {
      return e11(t3(n3));
    };
  }
  function G2(e11) {
    var t3 = -1, n3 = Array(e11.size);
    return e11.forEach(function(e12) {
      n3[++t3] = e12;
    }), n3;
  }
  var q2 = Array.prototype, K2 = Function.prototype, Y2 = Object.prototype, X2 = R2["__core-js_shared__"], Z2 = function() {
    var e11 = /[^.]+$/.exec(X2 && X2.keys && X2.keys.IE_PROTO || "");
    return e11 ? "Symbol(src)_1." + e11 : "";
  }(), J2 = K2.toString, Q2 = Y2.hasOwnProperty, ee2 = Y2.toString, te2 = RegExp("^" + J2.call(Q2).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ne2 = j2 ? R2.Buffer : void 0, re2 = R2.Symbol, oe2 = R2.Uint8Array, ie2 = W2(Object.getPrototypeOf, Object), ae2 = Object.create, se2 = Y2.propertyIsEnumerable, ue2 = q2.splice, le2 = Object.getOwnPropertySymbols, ce2 = ne2 ? ne2.isBuffer : void 0, de2 = W2(Object.keys, Object), fe2 = Le2(R2, "DataView"), pe2 = Le2(R2, "Map"), he2 = Le2(R2, "Promise"), ge2 = Le2(R2, "Set"), ve2 = Le2(R2, "WeakMap"), me2 = Le2(Object, "create"), ye2 = $e2(fe2), be2 = $e2(pe2), Ee2 = $e2(he2), Ce2 = $e2(ge2), we2 = $e2(ve2), De2 = re2 ? re2.prototype : void 0, Se2 = De2 ? De2.valueOf : void 0;
  function Ae2(e11) {
    var t3 = -1, n3 = e11 ? e11.length : 0;
    for (this.clear(); ++t3 < n3; ) {
      var r4 = e11[t3];
      this.set(r4[0], r4[1]);
    }
  }
  function xe2(e11) {
    var t3 = -1, n3 = e11 ? e11.length : 0;
    for (this.clear(); ++t3 < n3; ) {
      var r4 = e11[t3];
      this.set(r4[0], r4[1]);
    }
  }
  function Oe2(e11) {
    var t3 = -1, n3 = e11 ? e11.length : 0;
    for (this.clear(); ++t3 < n3; ) {
      var r4 = e11[t3];
      this.set(r4[0], r4[1]);
    }
  }
  function Ne2(e11) {
    this.__data__ = new xe2(e11);
  }
  function Be2(e11, t3) {
    var n3 = Ve2(e11) || function(e12) {
      return function(e13) {
        return /* @__PURE__ */ function(e14) {
          return !!e14 && "object" == typeof e14;
        }(e13) && We2(e13);
      }(e12) && Q2.call(e12, "callee") && (!se2.call(e12, "callee") || ee2.call(e12) == o2);
    }(e11) ? function(e12, t4) {
      for (var n4 = -1, r5 = Array(e12); ++n4 < e12; ) r5[n4] = t4(n4);
      return r5;
    }(e11.length, String) : [], r4 = n3.length, i3 = !!r4;
    for (var a3 in e11) !Q2.call(e11, a3) || i3 && ("length" == a3 || He2(a3, r4)) || n3.push(a3);
    return n3;
  }
  function Te2(e11, t3, n3) {
    var r4 = e11[t3];
    Q2.call(e11, t3) && Ue2(r4, n3) && (void 0 !== n3 || t3 in e11) || (e11[t3] = n3);
  }
  function ke2(e11, t3) {
    for (var n3 = e11.length; n3--; ) if (Ue2(e11[n3][0], t3)) return n3;
    return -1;
  }
  function Fe2(e11, t3, n3, r4, f3, m3, y2) {
    var k3;
    if (r4 && (k3 = m3 ? r4(e11, f3, m3, y2) : r4(e11)), void 0 !== k3) return k3;
    if (!Ke2(e11)) return e11;
    var F3 = Ve2(e11);
    if (F3) {
      if (k3 = function(e12) {
        var t4 = e12.length, n4 = e12.constructor(t4);
        return t4 && "string" == typeof e12[0] && Q2.call(e12, "index") && (n4.index = e12.index, n4.input = e12.input), n4;
      }(e11), !t3) return function(e12, t4) {
        var n4 = -1, r5 = e12.length;
        for (t4 || (t4 = Array(r5)); ++n4 < r5; ) t4[n4] = e12[n4];
        return t4;
      }(e11, k3);
    } else {
      var P3 = je2(e11), _3 = P3 == s2 || P3 == u2;
      if (Ge2(e11)) return function(e12, t4) {
        if (t4) return e12.slice();
        var n4 = new e12.constructor(e12.length);
        return e12.copy(n4), n4;
      }(e11, t3);
      if (P3 == d2 || P3 == o2 || _3 && !m3) {
        if (U2(e11)) return m3 ? e11 : {};
        if (k3 = function(e12) {
          return "function" != typeof e12.constructor || ze2(e12) ? {} : Ke2(t4 = ie2(e12)) ? ae2(t4) : {};
          var t4;
        }(_3 ? {} : e11), !t3) return function(e12, t4) {
          return _e3(e12, Me2(e12), t4);
        }(e11, function(e12, t4) {
          return e12 && _e3(t4, Ye2(t4), e12);
        }(k3, e11));
      } else {
        if (!I2[P3]) return m3 ? e11 : {};
        k3 = function(e12, t4, n4, r5) {
          var o3 = e12.constructor;
          switch (t4) {
            case b2:
              return Pe2(e12);
            case i2:
            case a2:
              return new o3(+e12);
            case E2:
              return function(e13, t5) {
                var n5 = t5 ? Pe2(e13.buffer) : e13.buffer;
                return new e13.constructor(n5, e13.byteOffset, e13.byteLength);
              }(e12, r5);
            case C2:
            case w2:
            case D2:
            case S2:
            case A2:
            case x2:
            case O2:
            case N2:
            case B2:
              return function(e13, t5) {
                var n5 = t5 ? Pe2(e13.buffer) : e13.buffer;
                return new e13.constructor(n5, e13.byteOffset, e13.length);
              }(e12, r5);
            case l2:
              return function(e13, t5, n5) {
                var r6 = t5 ? n5(V2(e13), true) : V2(e13);
                return $2(r6, H2, new e13.constructor());
              }(e12, r5, n4);
            case c3:
            case g2:
              return new o3(e12);
            case p2:
              return function(e13) {
                var t5 = new e13.constructor(e13.source, T2.exec(e13));
                return t5.lastIndex = e13.lastIndex, t5;
              }(e12);
            case h2:
              return function(e13, t5, n5) {
                var r6 = t5 ? n5(G2(e13), true) : G2(e13);
                return $2(r6, z2, new e13.constructor());
              }(e12, r5, n4);
            case v2:
              return function(e13) {
                return Se2 ? Object(Se2.call(e13)) : {};
              }(e12);
          }
        }(e11, P3, Fe2, t3);
      }
    }
    y2 || (y2 = new Ne2());
    var R3 = y2.get(e11);
    if (R3) return R3;
    if (y2.set(e11, k3), !F3) var L3 = n3 ? function(e12) {
      return function(e13, t4, n4) {
        var r5 = t4(e13);
        return Ve2(e13) ? r5 : function(e14, t5) {
          for (var n5 = -1, r6 = t5.length, o3 = e14.length; ++n5 < r6; ) e14[o3 + n5] = t5[n5];
          return e14;
        }(r5, n4(e13));
      }(e12, Ye2, Me2);
    }(e11) : Ye2(e11);
    return function(e12, t4) {
      for (var n4 = -1, r5 = e12 ? e12.length : 0; ++n4 < r5 && false !== t4(e12[n4], n4, e12); ) ;
    }(L3 || e11, function(o3, i3) {
      L3 && (o3 = e11[i3 = o3]), Te2(k3, i3, Fe2(o3, t3, n3, r4, i3, e11, y2));
    }), k3;
  }
  function Ie2(e11) {
    return !(!Ke2(e11) || (t3 = e11, Z2 && Z2 in t3)) && (qe2(e11) || U2(e11) ? te2 : k2).test($e2(e11));
    var t3;
  }
  function Pe2(e11) {
    var t3 = new e11.constructor(e11.byteLength);
    return new oe2(t3).set(new oe2(e11)), t3;
  }
  function _e3(e11, t3, n3, r4) {
    n3 || (n3 = {});
    for (var o3 = -1, i3 = t3.length; ++o3 < i3; ) {
      var a3 = t3[o3];
      Te2(n3, a3, e11[a3]);
    }
    return n3;
  }
  function Re2(e11, t3) {
    var n3, r4, o3 = e11.__data__;
    return ("string" == (r4 = typeof (n3 = t3)) || "number" == r4 || "symbol" == r4 || "boolean" == r4 ? "__proto__" !== n3 : null === n3) ? o3["string" == typeof t3 ? "string" : "hash"] : o3.map;
  }
  function Le2(e11, t3) {
    var n3 = function(e12, t4) {
      return null == e12 ? void 0 : e12[t4];
    }(e11, t3);
    return Ie2(n3) ? n3 : void 0;
  }
  Ae2.prototype.clear = function() {
    this.__data__ = me2 ? me2(null) : {};
  }, Ae2.prototype.delete = function(e11) {
    return this.has(e11) && delete this.__data__[e11];
  }, Ae2.prototype.get = function(e11) {
    var t3 = this.__data__;
    if (me2) {
      var r4 = t3[e11];
      return r4 === n2 ? void 0 : r4;
    }
    return Q2.call(t3, e11) ? t3[e11] : void 0;
  }, Ae2.prototype.has = function(e11) {
    var t3 = this.__data__;
    return me2 ? void 0 !== t3[e11] : Q2.call(t3, e11);
  }, Ae2.prototype.set = function(e11, t3) {
    return this.__data__[e11] = me2 && void 0 === t3 ? n2 : t3, this;
  }, xe2.prototype.clear = function() {
    this.__data__ = [];
  }, xe2.prototype.delete = function(e11) {
    var t3 = this.__data__, n3 = ke2(t3, e11);
    return !(n3 < 0 || (n3 == t3.length - 1 ? t3.pop() : ue2.call(t3, n3, 1), 0));
  }, xe2.prototype.get = function(e11) {
    var t3 = this.__data__, n3 = ke2(t3, e11);
    return n3 < 0 ? void 0 : t3[n3][1];
  }, xe2.prototype.has = function(e11) {
    return ke2(this.__data__, e11) > -1;
  }, xe2.prototype.set = function(e11, t3) {
    var n3 = this.__data__, r4 = ke2(n3, e11);
    return r4 < 0 ? n3.push([e11, t3]) : n3[r4][1] = t3, this;
  }, Oe2.prototype.clear = function() {
    this.__data__ = { hash: new Ae2(), map: new (pe2 || xe2)(), string: new Ae2() };
  }, Oe2.prototype.delete = function(e11) {
    return Re2(this, e11).delete(e11);
  }, Oe2.prototype.get = function(e11) {
    return Re2(this, e11).get(e11);
  }, Oe2.prototype.has = function(e11) {
    return Re2(this, e11).has(e11);
  }, Oe2.prototype.set = function(e11, t3) {
    return Re2(this, e11).set(e11, t3), this;
  }, Ne2.prototype.clear = function() {
    this.__data__ = new xe2();
  }, Ne2.prototype.delete = function(e11) {
    return this.__data__.delete(e11);
  }, Ne2.prototype.get = function(e11) {
    return this.__data__.get(e11);
  }, Ne2.prototype.has = function(e11) {
    return this.__data__.has(e11);
  }, Ne2.prototype.set = function(e11, t3) {
    var n3 = this.__data__;
    if (n3 instanceof xe2) {
      var r4 = n3.__data__;
      if (!pe2 || r4.length < 199) return r4.push([e11, t3]), this;
      n3 = this.__data__ = new Oe2(r4);
    }
    return n3.set(e11, t3), this;
  };
  var Me2 = le2 ? W2(le2, Object) : function() {
    return [];
  }, je2 = function(e11) {
    return ee2.call(e11);
  };
  function He2(e11, t3) {
    return !!(t3 = null == t3 ? r3 : t3) && ("number" == typeof e11 || F2.test(e11)) && e11 > -1 && e11 % 1 == 0 && e11 < t3;
  }
  function ze2(e11) {
    var t3 = e11 && e11.constructor;
    return e11 === ("function" == typeof t3 && t3.prototype || Y2);
  }
  function $e2(e11) {
    if (null != e11) {
      try {
        return J2.call(e11);
      } catch (e12) {
      }
      try {
        return e11 + "";
      } catch (e12) {
      }
    }
    return "";
  }
  function Ue2(e11, t3) {
    return e11 === t3 || e11 != e11 && t3 != t3;
  }
  (fe2 && je2(new fe2(new ArrayBuffer(1))) != E2 || pe2 && je2(new pe2()) != l2 || he2 && je2(he2.resolve()) != f2 || ge2 && je2(new ge2()) != h2 || ve2 && je2(new ve2()) != m2) && (je2 = function(e11) {
    var t3 = ee2.call(e11), n3 = t3 == d2 ? e11.constructor : void 0, r4 = n3 ? $e2(n3) : void 0;
    if (r4) switch (r4) {
      case ye2:
        return E2;
      case be2:
        return l2;
      case Ee2:
        return f2;
      case Ce2:
        return h2;
      case we2:
        return m2;
    }
    return t3;
  });
  var Ve2 = Array.isArray;
  function We2(e11) {
    return null != e11 && function(e12) {
      return "number" == typeof e12 && e12 > -1 && e12 % 1 == 0 && e12 <= r3;
    }(e11.length) && !qe2(e11);
  }
  var Ge2 = ce2 || function() {
    return false;
  };
  function qe2(e11) {
    var t3 = Ke2(e11) ? ee2.call(e11) : "";
    return t3 == s2 || t3 == u2;
  }
  function Ke2(e11) {
    var t3 = typeof e11;
    return !!e11 && ("object" == t3 || "function" == t3);
  }
  function Ye2(e11) {
    return We2(e11) ? Be2(e11) : function(e12) {
      if (!ze2(e12)) return de2(e12);
      var t3 = [];
      for (var n3 in Object(e12)) Q2.call(e12, n3) && "constructor" != n3 && t3.push(n3);
      return t3;
    }(e11);
  }
  e10.exports = function(e11) {
    return Fe2(e11, true, true);
  };
}(lv, lv.exports)), lv.exports), pv = b(fv);
var hv = function() {
  if (dv) return cv;
  dv = 1;
  var e10 = 9007199254740991, t2 = "[object Arguments]", n2 = "[object Function]", r3 = "[object GeneratorFunction]", o2 = /^(?:0|[1-9]\d*)$/;
  function i2(e11, t3) {
    for (var n3 = -1, r4 = e11 ? e11.length : 0; ++n3 < r4 && false !== t3(e11[n3], n3, e11); ) ;
    return e11;
  }
  var a2, s2, u2 = Object.prototype, l2 = u2.hasOwnProperty, c3 = u2.toString, d2 = u2.propertyIsEnumerable, f2 = (a2 = Object.keys, s2 = Object, function(e11) {
    return a2(s2(e11));
  });
  function p2(e11, n3) {
    var r4 = b2(e11) || function(e12) {
      return function(e13) {
        return /* @__PURE__ */ function(e14) {
          return !!e14 && "object" == typeof e14;
        }(e13) && E2(e13);
      }(e12) && l2.call(e12, "callee") && (!d2.call(e12, "callee") || c3.call(e12) == t2);
    }(e11) ? function(e12, t3) {
      for (var n4 = -1, r5 = Array(e12); ++n4 < e12; ) r5[n4] = t3(n4);
      return r5;
    }(e11.length, String) : [], o3 = r4.length, i3 = !!o3;
    for (var a3 in e11) !l2.call(e11, a3) || i3 && ("length" == a3 || y2(a3, o3)) || r4.push(a3);
    return r4;
  }
  var h2, g2 = (h2 = function(e11, t3) {
    return e11 && v2(e11, t3, C2);
  }, function(e11, t3) {
    if (null == e11) return e11;
    if (!E2(e11)) return h2(e11, t3);
    for (var n3 = e11.length, r4 = -1, o3 = Object(e11); ++r4 < n3 && false !== t3(o3[r4], r4, o3); ) ;
    return e11;
  }), v2 = function(e11, t3, n3) {
    for (var r4 = -1, o3 = Object(e11), i3 = n3(e11), a3 = i3.length; a3--; ) {
      var s3 = i3[++r4];
      if (false === t3(o3[s3], s3, o3)) break;
    }
    return e11;
  };
  function m2(e11) {
    if (n3 = (t3 = e11) && t3.constructor, r4 = "function" == typeof n3 && n3.prototype || u2, t3 !== r4) return f2(e11);
    var t3, n3, r4, o3 = [];
    for (var i3 in Object(e11)) l2.call(e11, i3) && "constructor" != i3 && o3.push(i3);
    return o3;
  }
  function y2(t3, n3) {
    return !!(n3 = null == n3 ? e10 : n3) && ("number" == typeof t3 || o2.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < n3;
  }
  var b2 = Array.isArray;
  function E2(t3) {
    return null != t3 && function(t4) {
      return "number" == typeof t4 && t4 > -1 && t4 % 1 == 0 && t4 <= e10;
    }(t3.length) && !function(e11) {
      var t4 = function(e12) {
        var t5 = typeof e12;
        return !!e12 && ("object" == t5 || "function" == t5);
      }(e11) ? c3.call(e11) : "";
      return t4 == n2 || t4 == r3;
    }(t3);
  }
  function C2(e11) {
    return E2(e11) ? p2(e11) : m2(e11);
  }
  function w2(e11) {
    return e11;
  }
  return cv = function(e11, t3) {
    return (b2(e11) ? i2 : g2)(e11, "function" == typeof t3 ? t3 : w2);
  };
}(), gv = b(hv), vv = {};
var mv = "created", yv = "destroyed", bv = "change", Ev = "scroll", Cv = "fullscreen", wv = "unFullScreen", Dv = "modalOrPanelShow", Sv = "modalOrPanelHide", Av = {};
function xv(e10, t2) {
  var n2 = e10.key, r3 = e10.factory, o2 = e10.config, i2 = tv(tv({}, o2), t2 || {});
  if (null != Av[n2]) throw new Error("Duplicated key '".concat(n2, "' in menu items"));
  Av[n2] = r3, function(e11, t3) {
    null != t3 && (vv[e11] = t3);
  }(n2, i2);
}
var Ov = /* @__PURE__ */ new WeakMap(), Nv = /* @__PURE__ */ new WeakMap(), Bv = /* @__PURE__ */ new WeakMap(), Tv = /* @__PURE__ */ new WeakMap(), kv = /* @__PURE__ */ new WeakMap(), Fv = /* @__PURE__ */ new WeakMap(), Iv = /* @__PURE__ */ new WeakMap(), Pv = /* @__PURE__ */ new WeakMap(), _v = /* @__PURE__ */ new WeakMap(), Rv = /* @__PURE__ */ new WeakMap(), Lv = /* @__PURE__ */ new WeakMap(), Mv = /* @__PURE__ */ new WeakMap(), jv = /* @__PURE__ */ new WeakMap(), Hv = /* @__PURE__ */ new WeakMap(), zv = /* @__PURE__ */ new WeakMap(), $v = /* @__PURE__ */ new WeakMap(), Uv = /* @__PURE__ */ new WeakMap(), Vv = /* @__PURE__ */ new WeakMap(), Wv = /* @__PURE__ */ new WeakMap(), Gv = /* @__PURE__ */ new WeakMap(), qv = /* @__PURE__ */ new WeakMap(), Kv = /* @__PURE__ */ new WeakMap(), Yv = /* @__PURE__ */ new WeakMap(), Xv = /* @__PURE__ */ new WeakMap(), Zv = /* @__PURE__ */ new WeakMap(), Jv = /* @__PURE__ */ new WeakMap(), Qv = /* @__PURE__ */ new WeakMap(), em = function(e10) {
  var t2 = e10;
  return t2.getAllMenuKeys = function() {
    var e11 = [];
    for (var t3 in Av) e11.push(t3);
    return e11;
  }, t2.getConfig = function() {
    var e11 = Rv.get(t2);
    if (null == e11) throw new Error("Can not get editor config");
    return e11;
  }, t2.getMenuConfig = function(e11) {
    var n2 = t2.getConfig().MENU_CONF;
    return (void 0 === n2 ? {} : n2)[e11] || {};
  }, t2.alert = function(e11, n2) {
    void 0 === n2 && (n2 = "info");
    var r3 = t2.getConfig().customAlert;
    r3 && r3(e11, n2);
  }, t2;
}, tm = /* @__PURE__ */ new Set(["doctype", "!doctype", "meta", "script", "style", "link", "frame", "iframe", "title", "svg"]);
function nm(e10) {
  return null !== e10 && "object" == typeof e10 && "constructor" in e10 && e10.constructor === Object;
}
function rm(e10 = {}, t2 = {}) {
  Object.keys(t2).forEach((n2) => {
    void 0 === e10[n2] ? e10[n2] = t2[n2] : nm(t2[n2]) && nm(e10[n2]) && Object.keys(t2[n2]).length > 0 && rm(e10[n2], t2[n2]);
  });
}
const om = { body: {}, addEventListener() {
}, removeEventListener() {
}, activeElement: { blur() {
}, nodeName: "" }, querySelector: () => null, querySelectorAll: () => [], getElementById: () => null, createEvent: () => ({ initEvent() {
} }), createElement: () => ({ children: [], childNodes: [], style: {}, setAttribute() {
}, getElementsByTagName: () => [] }), createElementNS: () => ({}), importNode: () => null, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" } };
function im() {
  const e10 = "undefined" != typeof document ? document : {};
  return rm(e10, om), e10;
}
const am = { document: om, navigator: { userAgent: "" }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }, history: { replaceState() {
}, pushState() {
}, go() {
}, back() {
} }, CustomEvent: function() {
  return this;
}, addEventListener() {
}, removeEventListener() {
}, getComputedStyle: () => ({ getPropertyValue: () => "" }), Image() {
}, Date() {
}, screen: {}, setTimeout() {
}, clearTimeout() {
}, matchMedia: () => ({}), requestAnimationFrame: (e10) => "undefined" == typeof setTimeout ? (e10(), null) : setTimeout(e10, 0), cancelAnimationFrame(e10) {
  "undefined" != typeof setTimeout && clearTimeout(e10);
} };
function sm() {
  const e10 = "undefined" != typeof window ? window : {};
  return rm(e10, am), e10;
}
class um extends Array {
  constructor(e10) {
    "number" == typeof e10 ? super(e10) : (super(...e10 || []), function(e11) {
      const t2 = e11.__proto__;
      Object.defineProperty(e11, "__proto__", { get: () => t2, set(e12) {
        t2.__proto__ = e12;
      } });
    }(this));
  }
}
function lm(e10 = []) {
  const t2 = [];
  return e10.forEach((e11) => {
    Array.isArray(e11) ? t2.push(...lm(e11)) : t2.push(e11);
  }), t2;
}
function cm(e10, t2) {
  return Array.prototype.filter.call(e10, t2);
}
function dm(e10) {
  return e10.toLowerCase().replace(/-(.)/g, (e11, t2) => t2.toUpperCase());
}
function fm(e10, t2) {
  const n2 = sm(), r3 = im();
  let o2 = [];
  if (!t2 && e10 instanceof um) return e10;
  if (!e10) return new um(o2);
  if ("string" == typeof e10) {
    const n3 = e10.trim();
    if (n3.indexOf("<") >= 0 && n3.indexOf(">") >= 0) {
      let e11 = "div";
      0 === n3.indexOf("<li") && (e11 = "ul"), 0 === n3.indexOf("<tr") && (e11 = "tbody"), 0 !== n3.indexOf("<td") && 0 !== n3.indexOf("<th") || (e11 = "tr"), 0 === n3.indexOf("<tbody") && (e11 = "table"), 0 === n3.indexOf("<option") && (e11 = "select");
      const t3 = r3.createElement(e11);
      t3.innerHTML = n3;
      for (let e12 = 0; e12 < t3.childNodes.length; e12 += 1) o2.push(t3.childNodes[e12]);
    } else o2 = function(e11, t3) {
      if ("string" != typeof e11) return [e11];
      const n4 = [], r4 = t3.querySelectorAll(e11);
      for (let e12 = 0; e12 < r4.length; e12 += 1) n4.push(r4[e12]);
      return n4;
    }(e10.trim(), t2 || r3);
  } else if (e10.nodeType || e10 === n2 || e10 === r3) o2.push(e10);
  else if (Array.isArray(e10)) {
    if (e10 instanceof um) return e10;
    o2 = e10;
  }
  return new um(function(e11) {
    const t3 = [];
    for (let n3 = 0; n3 < e11.length; n3 += 1) -1 === t3.indexOf(e11[n3]) && t3.push(e11[n3]);
    return t3;
  }(o2));
}
function pm(...e10) {
  const t2 = lm(e10.map((e11) => e11.split(" ")));
  return this.forEach((e11) => {
    e11.classList.add(...t2);
  }), this;
}
function hm(...e10) {
  const t2 = lm(e10.map((e11) => e11.split(" ")));
  return this.forEach((e11) => {
    e11.classList.remove(...t2);
  }), this;
}
function gm(...e10) {
  const t2 = lm(e10.map((e11) => e11.split(" ")));
  return cm(this, (e11) => t2.filter((t3) => e11.classList.contains(t3)).length > 0).length > 0;
}
function vm(e10, t2) {
  if (1 === arguments.length && "string" == typeof e10) return this[0] ? this[0].getAttribute(e10) : void 0;
  for (let n2 = 0; n2 < this.length; n2 += 1) if (2 === arguments.length) this[n2].setAttribute(e10, t2);
  else for (const t3 in e10) this[n2][t3] = e10[t3], this[n2].setAttribute(t3, e10[t3]);
  return this;
}
function mm(e10) {
  for (let t2 = 0; t2 < this.length; t2 += 1) this[t2].removeAttribute(e10);
  return this;
}
function ym(e10, t2) {
  let n2;
  if (void 0 === t2) {
    if (n2 = this[0], !n2) return;
    if (n2.dom7ElementDataStorage && e10 in n2.dom7ElementDataStorage) return n2.dom7ElementDataStorage[e10];
    const t3 = n2.getAttribute(`data-${e10}`);
    return t3 || void 0;
  }
  for (let r3 = 0; r3 < this.length; r3 += 1) n2 = this[r3], n2.dom7ElementDataStorage || (n2.dom7ElementDataStorage = {}), n2.dom7ElementDataStorage[e10] = t2;
  return this;
}
function bm() {
  const e10 = this[0];
  if (!e10) return;
  const t2 = {};
  if (e10.dataset) for (const n2 in e10.dataset) t2[n2] = e10.dataset[n2];
  else for (let n2 = 0; n2 < e10.attributes.length; n2 += 1) {
    const r3 = e10.attributes[n2];
    r3.name.indexOf("data-") >= 0 && (t2[dm(r3.name.split("data-")[1])] = r3.value);
  }
  for (const e11 in t2) "false" === t2[e11] ? t2[e11] = false : "true" === t2[e11] ? t2[e11] = true : parseFloat(t2[e11]) === 1 * t2[e11] && (t2[e11] *= 1);
  return t2;
}
function Em(e10) {
  if (void 0 === e10) {
    const e11 = this[0];
    if (!e11) return;
    if (e11.multiple && "select" === e11.nodeName.toLowerCase()) {
      const t2 = [];
      for (let n2 = 0; n2 < e11.selectedOptions.length; n2 += 1) t2.push(e11.selectedOptions[n2].value);
      return t2;
    }
    return e11.value;
  }
  for (let t2 = 0; t2 < this.length; t2 += 1) {
    const n2 = this[t2];
    if (Array.isArray(e10) && n2.multiple && "select" === n2.nodeName.toLowerCase()) for (let t3 = 0; t3 < n2.options.length; t3 += 1) n2.options[t3].selected = e10.indexOf(n2.options[t3].value) >= 0;
    else n2.value = e10;
  }
  return this;
}
function Cm(...e10) {
  let [t2, n2, r3, o2] = e10;
  function i2(e11) {
    const t3 = e11.target;
    if (!t3) return;
    const o3 = e11.target.dom7EventData || [];
    if (o3.indexOf(e11) < 0 && o3.unshift(e11), fm(t3).is(n2)) r3.apply(t3, o3);
    else {
      const e12 = fm(t3).parents();
      for (let t4 = 0; t4 < e12.length; t4 += 1) fm(e12[t4]).is(n2) && r3.apply(e12[t4], o3);
    }
  }
  function a2(e11) {
    const t3 = e11 && e11.target && e11.target.dom7EventData || [];
    t3.indexOf(e11) < 0 && t3.unshift(e11), r3.apply(this, t3);
  }
  "function" == typeof e10[1] && ([t2, r3, o2] = e10, n2 = void 0), o2 || (o2 = false);
  const s2 = t2.split(" ");
  let u2;
  for (let e11 = 0; e11 < this.length; e11 += 1) {
    const t3 = this[e11];
    if (n2) for (u2 = 0; u2 < s2.length; u2 += 1) {
      const e12 = s2[u2];
      t3.dom7LiveListeners || (t3.dom7LiveListeners = {}), t3.dom7LiveListeners[e12] || (t3.dom7LiveListeners[e12] = []), t3.dom7LiveListeners[e12].push({ listener: r3, proxyListener: i2 }), t3.addEventListener(e12, i2, o2);
    }
    else for (u2 = 0; u2 < s2.length; u2 += 1) {
      const e12 = s2[u2];
      t3.dom7Listeners || (t3.dom7Listeners = {}), t3.dom7Listeners[e12] || (t3.dom7Listeners[e12] = []), t3.dom7Listeners[e12].push({ listener: r3, proxyListener: a2 }), t3.addEventListener(e12, a2, o2);
    }
  }
  return this;
}
function wm(...e10) {
  let [t2, n2, r3, o2] = e10;
  "function" == typeof e10[1] && ([t2, r3, o2] = e10, n2 = void 0), o2 || (o2 = false);
  const i2 = t2.split(" ");
  for (let e11 = 0; e11 < i2.length; e11 += 1) {
    const t3 = i2[e11];
    for (let e12 = 0; e12 < this.length; e12 += 1) {
      const i3 = this[e12];
      let a2;
      if (!n2 && i3.dom7Listeners ? a2 = i3.dom7Listeners[t3] : n2 && i3.dom7LiveListeners && (a2 = i3.dom7LiveListeners[t3]), a2 && a2.length) for (let e13 = a2.length - 1; e13 >= 0; e13 -= 1) {
        const n3 = a2[e13];
        r3 && n3.listener === r3 || r3 && n3.listener && n3.listener.dom7proxy && n3.listener.dom7proxy === r3 ? (i3.removeEventListener(t3, n3.proxyListener, o2), a2.splice(e13, 1)) : r3 || (i3.removeEventListener(t3, n3.proxyListener, o2), a2.splice(e13, 1));
      }
    }
  }
  return this;
}
function Dm() {
  const e10 = sm();
  return this[0] === e10 ? e10.innerWidth : this.length > 0 ? parseFloat(this.css("width")) : null;
}
function Sm() {
  const e10 = sm();
  return this[0] === e10 ? e10.innerHeight : this.length > 0 ? parseFloat(this.css("height")) : null;
}
function Am() {
  if (this.length > 0) {
    const e10 = sm(), t2 = im(), n2 = this[0], r3 = n2.getBoundingClientRect(), o2 = t2.body, i2 = n2.clientTop || o2.clientTop || 0, a2 = n2.clientLeft || o2.clientLeft || 0, s2 = n2 === e10 ? e10.scrollY : n2.scrollTop, u2 = n2 === e10 ? e10.scrollX : n2.scrollLeft;
    return { top: r3.top + s2 - i2, left: r3.left + u2 - a2 };
  }
  return null;
}
function xm() {
  for (let e10 = 0; e10 < this.length; e10 += 1) this[e10].style.display = "none";
  return this;
}
function Om() {
  const e10 = sm();
  for (let t2 = 0; t2 < this.length; t2 += 1) {
    const n2 = this[t2];
    "none" === n2.style.display && (n2.style.display = ""), "none" === e10.getComputedStyle(n2, null).getPropertyValue("display") && (n2.style.display = "block");
  }
  return this;
}
function Nm(e10, t2) {
  const n2 = sm();
  let r3;
  if (1 === arguments.length) {
    if ("string" != typeof e10) {
      for (r3 = 0; r3 < this.length; r3 += 1) for (const t3 in e10) this[r3].style[t3] = e10[t3];
      return this;
    }
    if (this[0]) return n2.getComputedStyle(this[0], null).getPropertyValue(e10);
  }
  if (2 === arguments.length && "string" == typeof e10) {
    for (r3 = 0; r3 < this.length; r3 += 1) this[r3].style[e10] = t2;
    return this;
  }
  return this;
}
function Bm(e10) {
  return e10 ? (this.forEach((t2, n2) => {
    e10.apply(t2, [t2, n2]);
  }), this) : this;
}
function Tm(e10) {
  return fm(cm(this, e10));
}
function km(e10) {
  if (void 0 === e10) return this[0] ? this[0].innerHTML : null;
  for (let t2 = 0; t2 < this.length; t2 += 1) this[t2].innerHTML = e10;
  return this;
}
function Fm(e10) {
  if (void 0 === e10) return this[0] ? this[0].textContent.trim() : null;
  for (let t2 = 0; t2 < this.length; t2 += 1) this[t2].textContent = e10;
  return this;
}
function Im(e10) {
  const t2 = sm(), n2 = im(), r3 = this[0];
  let o2, i2;
  if (!r3 || void 0 === e10) return false;
  if ("string" == typeof e10) {
    if (r3.matches) return r3.matches(e10);
    if (r3.webkitMatchesSelector) return r3.webkitMatchesSelector(e10);
    if (r3.msMatchesSelector) return r3.msMatchesSelector(e10);
    for (o2 = fm(e10), i2 = 0; i2 < o2.length; i2 += 1) if (o2[i2] === r3) return true;
    return false;
  }
  if (e10 === n2) return r3 === n2;
  if (e10 === t2) return r3 === t2;
  if (e10.nodeType || e10 instanceof um) {
    for (o2 = e10.nodeType ? [e10] : e10, i2 = 0; i2 < o2.length; i2 += 1) if (o2[i2] === r3) return true;
    return false;
  }
  return false;
}
function Pm(...e10) {
  let t2;
  const n2 = im();
  for (let r3 = 0; r3 < e10.length; r3 += 1) {
    t2 = e10[r3];
    for (let e11 = 0; e11 < this.length; e11 += 1) if ("string" == typeof t2) {
      const r4 = n2.createElement("div");
      for (r4.innerHTML = t2; r4.firstChild; ) this[e11].appendChild(r4.firstChild);
    } else if (t2 instanceof um) for (let n3 = 0; n3 < t2.length; n3 += 1) this[e11].appendChild(t2[n3]);
    else this[e11].appendChild(t2);
  }
  return this;
}
function _m2(e10) {
  const t2 = im();
  let n2, r3;
  for (n2 = 0; n2 < this.length; n2 += 1) if ("string" == typeof e10) {
    const o2 = t2.createElement("div");
    for (o2.innerHTML = e10, r3 = o2.childNodes.length - 1; r3 >= 0; r3 -= 1) this[n2].insertBefore(o2.childNodes[r3], this[n2].childNodes[0]);
  } else if (e10 instanceof um) for (r3 = 0; r3 < e10.length; r3 += 1) this[n2].insertBefore(e10[r3], this[n2].childNodes[0]);
  else this[n2].insertBefore(e10, this[n2].childNodes[0]);
  return this;
}
function Rm(e10) {
  const t2 = [];
  for (let n2 = 0; n2 < this.length; n2 += 1) null !== this[n2].parentNode && (e10 ? fm(this[n2].parentNode).is(e10) && t2.push(this[n2].parentNode) : t2.push(this[n2].parentNode));
  return fm(t2);
}
function Lm(e10) {
  const t2 = [];
  for (let n2 = 0; n2 < this.length; n2 += 1) {
    let r3 = this[n2].parentNode;
    for (; r3; ) e10 ? fm(r3).is(e10) && t2.push(r3) : t2.push(r3), r3 = r3.parentNode;
  }
  return fm(t2);
}
function Mm(e10) {
  const t2 = [];
  for (let n2 = 0; n2 < this.length; n2 += 1) {
    const r3 = this[n2].querySelectorAll(e10);
    for (let e11 = 0; e11 < r3.length; e11 += 1) t2.push(r3[e11]);
  }
  return fm(t2);
}
function jm(e10) {
  const t2 = [];
  for (let n2 = 0; n2 < this.length; n2 += 1) {
    const r3 = this[n2].children;
    for (let n3 = 0; n3 < r3.length; n3 += 1) e10 && !fm(r3[n3]).is(e10) || t2.push(r3[n3]);
  }
  return fm(t2);
}
function Hm() {
  for (let e10 = 0; e10 < this.length; e10 += 1) this[e10].parentNode && this[e10].parentNode.removeChild(this[e10]);
  return this;
}
function zm() {
  for (let e10 = 0; e10 < this.length; e10 += 1) {
    const t2 = this[e10];
    if (1 === t2.nodeType) {
      for (let e11 = 0; e11 < t2.childNodes.length; e11 += 1) t2.childNodes[e11].parentNode && t2.childNodes[e11].parentNode.removeChild(t2.childNodes[e11]);
      t2.textContent = "";
    }
  }
  return this;
}
fm.fn = um.prototype;
const $m = "resize scroll".split(" ");
function Um(e10) {
  return function(...t2) {
    if (void 0 === t2[0]) {
      for (let t3 = 0; t3 < this.length; t3 += 1) $m.indexOf(e10) < 0 && (e10 in this[t3] ? this[t3][e10]() : fm(this[t3]).trigger(e10));
      return this;
    }
    return this.on(e10, ...t2);
  };
}
const Vm = Um("click"), Wm = Um("focus"), Gm = ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];
let qm = (e10 = 21) => {
  let t2 = "", n2 = crypto.getRandomValues(new Uint8Array(e10 |= 0));
  for (; e10--; ) t2 += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[63 & n2[e10]];
  return t2;
};
function Km(e10) {
  Promise.resolve().then(e10);
}
var Ym, Xm = function(e10) {
  return Object.prototype.toString.call(e10);
};
Nm && (fm.fn.css = Nm), Pm && (fm.fn.append = Pm), pm && (fm.fn.addClass = pm), hm && (fm.fn.removeClass = hm), gm && (fm.fn.hasClass = gm), Cm && (fm.fn.on = Cm), Wm && (fm.fn.focus = Wm), vm && (fm.fn.attr = vm), mm && (fm.fn.removeAttr = mm), xm && (fm.fn.hide = xm), Om && (fm.fn.show = Om), Am && (fm.fn.offset = Am), Dm && (fm.fn.width = Dm), Sm && (fm.fn.height = Sm), Rm && (fm.fn.parent = Rm), Lm && (fm.fn.parents = Lm), Im && (fm.fn.is = Im), bm && (fm.fn.dataset = bm), Em && (fm.fn.val = Em), Fm && (fm.fn.text = Fm), km && (fm.fn.html = km), jm && (fm.fn.children = jm), Hm && (fm.fn.remove = Hm), Mm && (fm.fn.find = Mm), Bm && (fm.fn.each = Bm), zm && (fm.fn.empty = zm), function(e10) {
  e10[e10.ELEMENT_NODE = 1] = "ELEMENT_NODE", e10[e10.TEXT_NODE = 3] = "TEXT_NODE", e10[e10.CDATA_SECTION_NODE = 4] = "CDATA_SECTION_NODE", e10[e10.PROCESSING_INSTRUCTION_NODE = 7] = "PROCESSING_INSTRUCTION_NODE", e10[e10.COMMENT_NODE = 8] = "COMMENT_NODE", e10[e10.DOCUMENT_NODE = 9] = "DOCUMENT_NODE", e10[e10.DOCUMENT_TYPE_NODE = 10] = "DOCUMENT_TYPE_NODE", e10[e10.DOCUMENT_FRAGMENT_NODE = 11] = "DOCUMENT_FRAGMENT_NODE";
}(Ym || (Ym = {}));
var Zm = /\[object HTML([A-Z][a-z]*)*Element\]/, Jm = function(e10) {
  return Zm.test(Xm(e10));
}, Qm = function(e10) {
  return null != e10 && "number" == typeof e10.nodeType;
}, ey = function(e10) {
  return Qm(e10) && e10.nodeType === Ym.COMMENT_NODE;
}, ty = function(e10) {
  return Qm(e10) && e10.nodeType === Ym.ELEMENT_NODE;
}, ny = function(e10) {
  return "[object Selection]" === Xm(e10);
}, ry = function(e10) {
  return Qm(e10) && e10.nodeType === Ym.TEXT_NODE;
}, oy = function(e10) {
  var t2, n2, r3;
  return null !== (t2 = window && window.document.getElementById(e10)) && void 0 !== t2 ? t2 : window && (null === (r3 = null === (n2 = window.document.activeElement) || void 0 === n2 ? void 0 : n2.shadowRoot) || void 0 === r3 ? void 0 : r3.getElementById(e10)) || null;
}, iy = function(e10, t2, n2) {
  for (var r3 = e10.childNodes, o2 = r3[t2], i2 = t2, a2 = false, s2 = false; (ey(o2) || ty(o2) && 0 === o2.childNodes.length || ty(o2) && "false" === o2.getAttribute("contenteditable")) && (!a2 || !s2); ) i2 >= r3.length ? (a2 = true, i2 = t2 - 1, n2 = "backward") : i2 < 0 ? (s2 = true, i2 = t2 + 1, n2 = "forward") : (o2 = r3[i2], t2 = i2, i2 += "forward" === n2 ? 1 : -1);
  return [o2, t2];
}, ay = function(e10, t2, n2) {
  return iv(iy(e10, t2, n2), 1)[0];
}, sy = function(e10) {
  var t2, n2, r3 = "";
  if (ry(e10) && e10.nodeValue) return e10.nodeValue;
  if (ty(e10)) {
    try {
      for (var o2 = ov(Array.from(e10.childNodes)), i2 = o2.next(); !i2.done; i2 = o2.next()) {
        var a2 = i2.value;
        r3 += sy(a2);
      }
    } catch (e11) {
      t2 = { error: e11 };
    } finally {
      try {
        i2 && !i2.done && (n2 = o2.return) && n2.call(o2);
      } finally {
        if (t2) throw t2.error;
      }
    }
    var s2 = getComputedStyle(e10).getPropertyValue("display");
    "block" !== s2 && "list" !== s2 && "table-row" !== s2 && "BR" !== e10.tagName || (r3 += "\n");
  }
  return r3;
};
function uy(e10, t2) {
  if (!Jm(e10) || "true" !== e10.dataset.slateVoid) for (var n2 = e10.childNodes, r3 = n2.length; r3 -= 1; ) {
    var o2 = n2[r3], i2 = o2.nodeType;
    ry(o2) ? t2(o2, e10) : [Ym.ELEMENT_NODE, Ym.DOCUMENT_NODE, Ym.DOCUMENT_FRAGMENT_NODE].includes(i2) && uy(o2, t2);
  }
}
function ly(e10) {
  if (0 === e10.length) return "";
  var t2 = e10[0];
  return t2.nodeType !== Ym.ELEMENT_NODE ? "" : t2.tagName.toLowerCase();
}
var cy = new RegExp(String.fromCharCode(160), "g");
function dy(e10) {
  return e10.replace(cy, " ");
}
var fy = ["span", "b", "strong", "i", "em", "s", "strike", "u", "font", "sub", "sup"], py = [];
var hy = [];
var gy = {};
function vy(e10, t2) {
  var n2 = e10.length;
  if (n2) {
    var r3 = e10[n2 - 1];
    if (Og.isText(r3)) {
      var o2 = Object.keys(r3);
      if (1 === o2.length && "text" === o2[0]) return r3.text += t2, true;
    }
  }
  return false;
}
function my(e10, t2, n2) {
  return { type: "paragraph", children: [{ text: fm(e10).text().replace(/\s+/gm, " ") }] };
}
function yy(e10, t2) {
  var n2 = function(e11, t3) {
    var n3 = [];
    if (null != e11.attr("data-w-e-is-void")) return n3;
    var r4 = e11[0].childNodes;
    return 1 === r4.length && "BR" === r4[0].nodeName ? (n3.push({ text: "" }), n3) : (r4.forEach(function(e12) {
      if (ty(e12)) {
        if ("BR" === e12.nodeName) return void (vy(n3, "\n") || n3.push({ text: "\n" }));
        var r5 = Ey(fm(e12), t3);
        Array.isArray(r5) ? r5.forEach(function(e13) {
          return n3.push(e13);
        }) : n3.push(r5);
      } else if (ry(e12)) {
        var o3 = e12.textContent || "";
        if ("" === o3.trim() && o3.indexOf("\n") >= 0) return;
        o3 && (o3 = dy(o3), vy(n3, o3) || n3.push({ text: o3 }));
      }
    }), n3);
  }(e10, t2), r3 = function(e11) {
    for (var t3 in gy) if (e11[0].matches(t3)) return gy[t3];
    return my;
  }(e10), o2 = r3(e10[0], n2, t2);
  return Array.isArray(o2) || (o2 = [o2]), o2.forEach(function(r4) {
    eg.isVoid(t2, r4) || (0 === n2.length && (r4.children = [{ text: e10.text().replace(/\s+/gm, " ") }]), hy.forEach(function(n3) {
      r4 = n3(e10[0], r4, t2);
    }));
  }), o2;
}
function by(e10, t2) {
  0 === e10.parents("pre").length && (e10[0].innerHTML = e10[0].innerHTML.replace(/\s+/gm, " ").replace(/<br>/g, "\n"));
  var n2 = e10[0].textContent || "";
  n2 = function(e11) {
    return e11.replace(/&nbsp;/g, " ").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&reg;/g, "®").replace(/&copy;/g, "©").replace(/&trade;/g, "™").replace(/&quot;/g, '"');
  }(n2);
  var r3 = { text: n2 = dy(n2) };
  return hy.forEach(function(n3) {
    r3 = n3(e10[0], r3, t2);
  }), r3;
}
function Ey(e10, t2) {
  py.forEach(function(t3) {
    var n3 = t3.selector, r4 = t3.preParseHtml;
    e10[0].matches(n3) && (e10 = fm(r4(e10[0])));
  });
  var n2 = ly(e10);
  if ("span" === n2) {
    if (e10.attr("data-w-e-type")) return yy(e10, t2);
    var r3 = e10.find("img, a").length > 0;
    if (e10[0].childNodes.length > 1 || r3) {
      var o2 = e10[0].childNodes, i2 = function(e11, t3) {
        var n3 = { text: "" };
        return hy.forEach(function(r4) {
          n3 = r4(e11[0], n3, t3);
        }), n3;
      }(fm(e10[0]), t2);
      return Array.from(o2).flatMap(function(e11) {
        var n3 = function(e12, t3, n4) {
          var r4 = e12[0];
          if (ty(r4)) {
            var o3 = Ey(e12, n4);
            return delete t3.text, Array.isArray(o3) ? o3.map(function(e13) {
              return tv(tv({}, t3), e13);
            }) : [tv(tv({}, t3), o3)];
          }
          if (ey(r4)) return null;
          var i3 = ry(r4) ? { text: r4.textContent || "" } : by(e12, n4);
          return [tv(tv({}, t3), i3)];
        }(fm(e11), i2, t2);
        return n3 || [];
      });
    }
    return by(e10, t2);
  }
  if ("code" === n2) return "pre" === ly(e10.parent()) ? yy(e10, t2) : by(e10, t2);
  if (fy.includes(n2)) {
    if (e10[0].childNodes.length > 0 && e10[0].childNodes[0].nodeType !== Node.TEXT_NODE) {
      o2 = e10[0].childNodes;
      return tv(tv({}, Ey(fm(o2[0]), t2)), by(e10, t2));
    }
    return by(e10, t2);
  }
  return yy(e10, t2);
}
function Cy(e10, t2, n2) {
  var r3 = fm(n2);
  return !!r3.attr(t2) || (r3.attr(t2, "true"), e10.on(yv, function() {
    r3.removeAttr(t2);
  }), false);
}
function wy(e10, t2) {
  void 0 === t2 && (t2 = "");
  var n2 = [];
  "" === t2 && (t2 = "<p><br></p>"), 0 !== t2.indexOf("<") && (t2 = t2.split(/\n/).map(function(e11) {
    return "<p>".concat(e11, "</p>");
  }).join(""));
  var r3 = fm("<div>".concat(t2, "</div>"));
  return Array.from(r3.children()).forEach(function(t3) {
    var r4 = Ey(fm(t3), e10);
    Array.isArray(r4) ? r4.forEach(function(e11) {
      return n2.push(e11);
    }) : n2.push(r4);
  }), n2;
}
function Dy(e10, t2) {
  return "w-e-element-".concat(e10, "-").concat(t2);
}
var Sy = [];
var Ay, xy, Oy = {};
function Ny(e10, t2, n2) {
  var r3 = n2.isInline(e10) ? "span" : "div";
  return "<".concat(r3, ">").concat(t2, "</").concat(r3, ">");
}
function By(e10, t2) {
  var n2 = e10.type, r3 = void 0 === n2 ? "" : n2, o2 = e10.children, i2 = void 0 === o2 ? [] : o2, a2 = eg.isVoid(t2, e10), s2 = "";
  a2 || (s2 = i2.map(function(e11) {
    return $y(e11, t2);
  }).join(""));
  var u2 = function(e11) {
    return Oy[e11] || Ny;
  }(r3), l2 = u2(e10, s2, t2), c3 = "";
  if (c3 = "string" == typeof l2 ? l2 : l2.html || "", a2 || Sy.forEach(function(t3) {
    return c3 = t3(e10, c3);
  }), "string" == typeof l2) return c3;
  var d2 = l2.prefix, f2 = void 0 === d2 ? "" : d2, p2 = l2.suffix, h2 = void 0 === p2 ? "" : p2;
  return f2 && (c3 = f2 + c3), h2 && (c3 += h2), c3;
}
var Ty = function() {
  if (xy) return Ay;
  xy = 1;
  var e10 = 9007199254740991, t2 = "[object Arguments]", n2 = "[object Map]", r3 = "[object Promise]", o2 = "[object Set]", i2 = "[object WeakMap]", a2 = "[object DataView]", s2 = /^\[object .+?Constructor\]$/, u2 = /^(?:0|[1-9]\d*)$/, l2 = "\\ud800-\\udfff", c3 = "\\u0300-\\u036f\\ufe20-\\ufe23", d2 = "\\u20d0-\\u20f0", f2 = "\\ufe0e\\ufe0f", p2 = "[" + l2 + "]", h2 = "[" + c3 + d2 + "]", g2 = "\\ud83c[\\udffb-\\udfff]", v2 = "[^" + l2 + "]", m2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", b2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", E2 = "\\u200d", C2 = "(?:" + h2 + "|" + g2 + ")?", w2 = "[" + f2 + "]?", D2 = w2 + C2 + ("(?:" + E2 + "(?:" + [v2, m2, b2].join("|") + ")" + w2 + C2 + ")*"), S2 = "(?:" + [v2 + h2 + "?", h2, m2, b2, p2].join("|") + ")", A2 = RegExp(g2 + "(?=" + g2 + ")|" + S2 + D2, "g"), x2 = RegExp("[" + E2 + l2 + c3 + d2 + f2 + "]"), O2 = "object" == typeof y && y && y.Object === Object && y, N2 = "object" == typeof self && self && self.Object === Object && self, B2 = O2 || N2 || Function("return this")();
  function T2(e11, t3) {
    return function(e12, t4) {
      for (var n3 = -1, r4 = e12 ? e12.length : 0, o3 = Array(r4); ++n3 < r4; ) o3[n3] = t4(e12[n3], n3, e12);
      return o3;
    }(t3, function(t4) {
      return e11[t4];
    });
  }
  function k2(e11) {
    var t3 = -1, n3 = Array(e11.size);
    return e11.forEach(function(e12, r4) {
      n3[++t3] = [r4, e12];
    }), n3;
  }
  function F2(e11) {
    var t3 = -1, n3 = Array(e11.size);
    return e11.forEach(function(e12) {
      n3[++t3] = e12;
    }), n3;
  }
  function I2(e11) {
    return function(e12) {
      return x2.test(e12);
    }(e11) ? function(e12) {
      return e12.match(A2) || [];
    }(e11) : function(e12) {
      return e12.split("");
    }(e11);
  }
  var P2, _2, R2 = Function.prototype, L2 = Object.prototype, M2 = B2["__core-js_shared__"], j2 = function() {
    var e11 = /[^.]+$/.exec(M2 && M2.keys && M2.keys.IE_PROTO || "");
    return e11 ? "Symbol(src)_1." + e11 : "";
  }(), H2 = R2.toString, z2 = L2.hasOwnProperty, $2 = L2.toString, U2 = RegExp("^" + H2.call(z2).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), V2 = B2.Symbol, W2 = V2 ? V2.iterator : void 0, G2 = L2.propertyIsEnumerable, q2 = (P2 = Object.keys, _2 = Object, function(e11) {
    return P2(_2(e11));
  }), K2 = se2(B2, "DataView"), Y2 = se2(B2, "Map"), X2 = se2(B2, "Promise"), Z2 = se2(B2, "Set"), J2 = se2(B2, "WeakMap"), Q2 = ce2(K2), ee2 = ce2(Y2), te2 = ce2(X2), ne2 = ce2(Z2), re2 = ce2(J2);
  function oe2(e11, n3) {
    var r4 = de2(e11) || function(e12) {
      return function(e13) {
        return ge2(e13) && fe2(e13);
      }(e12) && z2.call(e12, "callee") && (!G2.call(e12, "callee") || $2.call(e12) == t2);
    }(e11) ? function(e12, t3) {
      for (var n4 = -1, r5 = Array(e12); ++n4 < e12; ) r5[n4] = t3(n4);
      return r5;
    }(e11.length, String) : [], o3 = r4.length, i3 = !!o3;
    for (var a3 in e11) !z2.call(e11, a3) || i3 && ("length" == a3 || le2(a3, o3)) || r4.push(a3);
    return r4;
  }
  function ie2(e11) {
    if (!he2(e11) || function(e12) {
      return !!j2 && j2 in e12;
    }(e11)) return false;
    var t3 = pe2(e11) || function(e12) {
      var t4 = false;
      if (null != e12 && "function" != typeof e12.toString) try {
        t4 = !!(e12 + "");
      } catch (e13) {
      }
      return t4;
    }(e11) ? U2 : s2;
    return t3.test(ce2(e11));
  }
  function ae2(e11) {
    if (n3 = (t3 = e11) && t3.constructor, r4 = "function" == typeof n3 && n3.prototype || L2, t3 !== r4) return q2(e11);
    var t3, n3, r4, o3 = [];
    for (var i3 in Object(e11)) z2.call(e11, i3) && "constructor" != i3 && o3.push(i3);
    return o3;
  }
  function se2(e11, t3) {
    var n3 = function(e12, t4) {
      return null == e12 ? void 0 : e12[t4];
    }(e11, t3);
    return ie2(n3) ? n3 : void 0;
  }
  var ue2 = function(e11) {
    return $2.call(e11);
  };
  function le2(t3, n3) {
    return !!(n3 = null == n3 ? e10 : n3) && ("number" == typeof t3 || u2.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < n3;
  }
  function ce2(e11) {
    if (null != e11) {
      try {
        return H2.call(e11);
      } catch (e12) {
      }
      try {
        return e11 + "";
      } catch (e12) {
      }
    }
    return "";
  }
  (K2 && ue2(new K2(new ArrayBuffer(1))) != a2 || Y2 && ue2(new Y2()) != n2 || X2 && ue2(X2.resolve()) != r3 || Z2 && ue2(new Z2()) != o2 || J2 && ue2(new J2()) != i2) && (ue2 = function(e11) {
    var t3 = $2.call(e11), s3 = "[object Object]" == t3 ? e11.constructor : void 0, u3 = s3 ? ce2(s3) : void 0;
    if (u3) switch (u3) {
      case Q2:
        return a2;
      case ee2:
        return n2;
      case te2:
        return r3;
      case ne2:
        return o2;
      case re2:
        return i2;
    }
    return t3;
  });
  var de2 = Array.isArray;
  function fe2(t3) {
    return null != t3 && function(t4) {
      return "number" == typeof t4 && t4 > -1 && t4 % 1 == 0 && t4 <= e10;
    }(t3.length) && !pe2(t3);
  }
  function pe2(e11) {
    var t3 = he2(e11) ? $2.call(e11) : "";
    return "[object Function]" == t3 || "[object GeneratorFunction]" == t3;
  }
  function he2(e11) {
    var t3 = typeof e11;
    return !!e11 && ("object" == t3 || "function" == t3);
  }
  function ge2(e11) {
    return !!e11 && "object" == typeof e11;
  }
  function ve2(e11) {
    return e11 ? T2(e11, function(e12) {
      return fe2(e12) ? oe2(e12) : ae2(e12);
    }(e11)) : [];
  }
  return Ay = function(e11) {
    if (!e11) return [];
    if (fe2(e11)) return function(e12) {
      return "string" == typeof e12 || !de2(e12) && ge2(e12) && "[object String]" == $2.call(e12);
    }(e11) ? I2(e11) : function(e12, t4) {
      var n3 = -1, r4 = e12.length;
      for (t4 || (t4 = Array(r4)); ++n3 < r4; ) t4[n3] = e12[n3];
      return t4;
    }(e11);
    if (W2 && e11[W2]) return function(e12) {
      for (var t4, n3 = []; !(t4 = e12.next()).done; ) n3.push(t4.value);
      return n3;
    }(e11[W2]());
    var t3 = ue2(e11);
    return (t3 == n2 ? k2 : t3 == o2 ? F2 : ve2)(e11);
  }, Ay;
}(), ky = b(Ty), Fy = 0, Iy = function() {
  this.id = "".concat(Fy++);
}, Py = "undefined" != typeof navigator && /Mac OS X/.test(navigator.userAgent), _y2 = "undefined" != typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Ry = "undefined" != typeof navigator && /^((?!chrome|android).)*safari/i.test(navigator.userAgent), Ly = "undefined" != typeof navigator && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), My = "undefined" != typeof navigator && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), jy = "undefined" != typeof navigator && /Chrome/i.test(navigator.userAgent), Hy = !My && !Ly && "undefined" != typeof globalThis && globalThis.InputEvent && "function" == typeof globalThis.InputEvent.prototype.getTargetRanges, zy = { getWindow: function(e10) {
  var t2 = Yv.get(e10);
  if (!t2) throw new Error("Unable to find a host window element for this editor");
  return t2;
}, findKey: function(e10, t2) {
  var n2 = Kv.get(t2);
  return n2 || (n2 = new Iy(), Kv.set(t2, n2)), n2;
}, setNewKey: function(e10) {
  var t2 = new Iy();
  Kv.set(e10, t2);
}, findPath: function(e10, t2) {
  for (var n2 = [], r3 = t2; ; ) {
    var o2 = Uv.get(r3);
    if (null == o2) {
      if (eg.isEditor(r3)) return n2;
      break;
    }
    var i2 = $v.get(r3);
    if (null == i2) break;
    n2.unshift(i2), r3 = o2;
  }
  throw new Error("Unable to find the path for Slate node: ".concat(JSON.stringify(t2)));
}, findDocumentOrShadowRoot: function(e10) {
  if (e10.isDestroyed) return window.document;
  var t2 = zy.toDOMNode(e10, e10), n2 = t2.getRootNode();
  return "[object HTMLDocument]" !== Xm(n2) && !function(e11) {
    return "[object ShadowRoot]" === Xm(e11);
  }(n2) || null == Reflect.get(n2, "getSelection") ? t2.ownerDocument : n2;
}, getParentNode: function(e10, t2) {
  return Uv.get(t2) || null;
}, getParentsNodes: function(e10, t2) {
  for (var n2 = [], r3 = t2; r3 !== e10 && null != r3; ) {
    var o2 = zy.getParentNode(e10, r3);
    if (null == o2) break;
    n2.push(o2), r3 = o2;
  }
  return n2;
}, getTopNode: function(e10, t2) {
  var n2 = [zy.findPath(e10, t2)[0]];
  return ag.get(e10, n2);
}, toDOMNode: function(e10, t2) {
  var n2;
  if (eg.isEditor(t2)) n2 = Vv.get(e10);
  else {
    var r3 = zy.findKey(e10, t2);
    n2 = Gv.get(r3);
  }
  if (!n2) throw new Error("Cannot resolve a DOM node from Slate node: ".concat(JSON.stringify(t2)));
  return n2;
}, hasDOMNode: function(e10, t2, n2) {
  void 0 === n2 && (n2 = {});
  var r3, o2 = n2.editable, i2 = void 0 !== o2 && o2, a2 = zy.toDOMNode(e10, e10);
  try {
    r3 = ty(t2) ? t2 : t2.parentElement;
  } catch (e11) {
    if (e11 instanceof Error && !e11.message.includes('Permission denied to access property "nodeType"')) throw e11;
  }
  return !!r3 && (r3.closest("[data-slate-editor]") === a2 && (!i2 || r3.isContentEditable || !!r3.getAttribute("data-slate-zero-width")) || !!r3.getAttribute("data-slate-string"));
}, toDOMRange: function(e10, t2) {
  var n2 = t2.anchor, r3 = t2.focus, o2 = yg.isBackward(t2), i2 = zy.toDOMPoint(e10, n2), a2 = yg.isCollapsed(t2) ? i2 : zy.toDOMPoint(e10, r3), s2 = zy.getWindow(e10).document.createRange(), u2 = iv(o2 ? a2 : i2, 2), l2 = u2[0], c3 = u2[1], d2 = iv(o2 ? i2 : a2, 2), f2 = d2[0], p2 = d2[1], h2 = !!(ty(l2) ? l2 : l2.parentElement).getAttribute("data-slate-zero-width"), g2 = !!(ty(f2) ? f2 : f2.parentElement).getAttribute("data-slate-zero-width");
  return s2.setStart(l2, h2 ? 1 : c3), s2.setEnd(f2, g2 ? 1 : p2), s2;
}, toDOMPoint: function(e10, t2) {
  var n2, r3, o2, i2 = iv(eg.node(e10, t2.path), 1)[0], a2 = zy.toDOMNode(e10, i2);
  eg.void(e10, { at: t2 }) && (t2 = { path: t2.path, offset: 0 });
  var s2 = Array.from(a2.querySelectorAll("[data-slate-string], [data-slate-zero-width]")), u2 = 0;
  try {
    for (var l2 = ov(s2), c3 = l2.next(); !c3.done; c3 = l2.next()) {
      var d2 = c3.value, f2 = d2.childNodes[0];
      if (null != f2 && null != f2.textContent) {
        var p2 = f2.textContent.length, h2 = d2.getAttribute("data-slate-length"), g2 = u2 + (null == h2 ? p2 : parseInt(h2, 10));
        if (t2.offset <= g2) {
          o2 = [f2, Math.min(p2, Math.max(0, t2.offset - u2))];
          break;
        }
        u2 = g2;
      }
    }
  } catch (e11) {
    n2 = { error: e11 };
  } finally {
    try {
      c3 && !c3.done && (r3 = l2.return) && r3.call(l2);
    } finally {
      if (n2) throw n2.error;
    }
  }
  if (!o2) throw new Error("Cannot resolve a DOM point from Slate point: ".concat(JSON.stringify(t2)));
  return o2;
}, toSlateNode: function(e10, t2) {
  var n2 = ty(t2) ? t2 : t2.parentElement;
  n2 && !n2.hasAttribute("data-slate-node") && (n2 = n2.closest("[data-slate-node]"));
  var r3 = n2 ? Wv.get(n2) : null;
  if (!r3) throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n2));
  return r3;
}, findEventRange: function(e10, t2) {
  "nativeEvent" in t2 && (t2 = t2.nativeEvent);
  var n2 = t2.clientX, r3 = t2.clientY, o2 = t2.target;
  if (null == n2 || null == r3) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t2));
  var i2, a2 = zy.toSlateNode(e10, t2.target), s2 = zy.findPath(e10, a2);
  if (eg.isVoid(e10, a2)) {
    var u2 = o2.getBoundingClientRect(), l2 = e10.isInline(a2) ? n2 - u2.left < u2.left + u2.width - n2 : r3 - u2.top < u2.top + u2.height - r3, c3 = eg.point(e10, s2, { edge: l2 ? "start" : "end" }), d2 = l2 ? eg.before(e10, c3) : eg.after(e10, c3);
    if (d2) return eg.range(e10, d2);
  }
  var f2 = this.getWindow(e10).document;
  if (f2.caretRangeFromPoint) i2 = f2.caretRangeFromPoint(n2, r3);
  else {
    var p2 = f2.caretPositionFromPoint(n2, r3);
    p2 && ((i2 = f2.createRange()).setStart(p2.offsetNode, p2.offset), i2.setEnd(p2.offsetNode, p2.offset));
  }
  if (!i2) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t2));
  return zy.toSlateRange(e10, i2, { exactMatch: false, suppressThrow: false });
}, toSlateRange: function(e10, t2, n2) {
  var r3, o2, i2, a2, s2, u2 = n2.exactMatch, l2 = n2.suppressThrow;
  if ((ny(t2) ? t2.anchorNode : t2.startContainer) && (ny(t2) ? (r3 = t2.anchorNode, o2 = t2.anchorOffset, i2 = t2.focusNode, a2 = t2.focusOffset, s2 = jy && window.document.activeElement && window.document.activeElement.shadowRoot ? t2.anchorNode === t2.focusNode && t2.anchorOffset === t2.focusOffset : t2.isCollapsed) : (r3 = t2.startContainer, o2 = t2.startOffset, i2 = t2.endContainer, a2 = t2.endOffset, s2 = t2.collapsed)), null == r3 || null == i2 || null == o2 || null == a2) throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t2));
  var c3 = zy.toSlatePoint(e10, [r3, o2], { exactMatch: u2, suppressThrow: l2 });
  if (!c3) return null;
  var d2 = s2 ? c3 : zy.toSlatePoint(e10, [i2, a2], { exactMatch: u2, suppressThrow: l2 });
  if (!d2) return null;
  var f2 = { anchor: c3, focus: d2 };
  return yg.isExpanded(f2) && yg.isForward(f2) && ty(i2) && eg.void(e10, { at: f2.focus, mode: "highest" }) && (f2 = eg.unhangRange(e10, f2, { voids: true })), f2;
}, toSlatePoint: function(e10, t2, n2) {
  var r3, o2 = n2.exactMatch, i2 = n2.suppressThrow, a2 = iv(o2 ? t2 : function(e11) {
    var t3, n3 = iv(e11, 2), r4 = n3[0], o3 = n3[1];
    if (ty(r4) && r4.childNodes.length) {
      var i3 = o3 === r4.childNodes.length, a3 = i3 ? o3 - 1 : o3;
      for (r4 = (t3 = iv(iy(r4, a3, i3 ? "backward" : "forward"), 2))[0], i3 = (a3 = t3[1]) < o3; ty(r4) && r4.childNodes.length; ) {
        var s3 = i3 ? r4.childNodes.length - 1 : 0;
        r4 = ay(r4, s3, i3 ? "backward" : "forward");
      }
      o3 = i3 && null != r4.textContent ? r4.textContent.length : 0;
    }
    return [r4, o3];
  }(t2), 2), s2 = a2[0], u2 = a2[1], l2 = s2.parentNode, c3 = null, d2 = 0;
  if (l2) {
    var f2 = l2.closest('[data-slate-void="true"]'), p2 = l2.closest("[data-slate-leaf]"), h2 = null, g2 = zy.getWindow(e10);
    if (p2 && g2.document.createRange) {
      c3 = p2.closest('[data-slate-node="text"]');
      var v2 = g2.document.createRange();
      v2.setStart(c3, 0), v2.setEnd(s2, u2);
      var m2 = v2.cloneContents();
      av(av([], iv(ky(m2.querySelectorAll("[data-slate-zero-width]"))), false), iv(ky(m2.querySelectorAll("[contenteditable=false]"))), false).forEach(function(e11) {
        e11.parentNode.removeChild(e11);
      }), d2 = m2.textContent.length, h2 = c3;
    } else f2 && ((p2 = f2.querySelector("[data-slate-leaf]")) ? (c3 = p2.closest('[data-slate-node="text"]'), d2 = (h2 = p2).textContent.length, h2.querySelectorAll("[data-slate-zero-width]").forEach(function(e11) {
      d2 -= e11.textContent.length;
    })) : d2 = 1);
    h2 && d2 === h2.textContent.length && (l2.hasAttribute("data-slate-zero-width") || _y2 && (null === (r3 = h2.textContent) || void 0 === r3 ? void 0 : r3.endsWith("\n"))) && (d2 -= 1);
  }
  if (!c3) {
    if (i2) return null;
    throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t2));
  }
  var y2 = zy.toSlateNode(e10, c3);
  return { path: zy.findPath(e10, y2), offset: d2 };
}, hasRange: function(e10, t2) {
  var n2 = t2.anchor, r3 = t2.focus;
  return eg.hasPath(e10, n2.path) && eg.hasPath(e10, r3.path);
}, getNodeType: function(e10) {
  return Kh.isElement(e10) ? e10.type : "";
}, checkNodeType: function(e10, t2) {
  return this.getNodeType(e10) === t2;
}, getNodesStr: function(e10) {
  return e10.map(function(e11) {
    return ag.string(e11);
  }).join("");
}, getSelectedElems: function(e10) {
  var t2, n2, r3 = [], o2 = eg.nodes(e10, { universal: true });
  try {
    for (var i2 = ov(o2), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      var s2 = iv(a2.value, 1)[0];
      Kh.isElement(s2) && r3.push(s2);
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return r3;
}, getSelectedNodeByType: function(e10, t2) {
  var n2 = this, r3 = iv(eg.nodes(e10, { match: function(e11) {
    return n2.checkNodeType(e11, t2);
  }, universal: true }), 1), o2 = r3[0];
  return null == o2 ? null : o2[0];
}, getSelectedTextNode: function(e10) {
  var t2 = iv(eg.nodes(e10, { match: function(e11) {
    return Og.isText(e11);
  }, universal: true }), 1), n2 = t2[0];
  return null == n2 ? null : n2[0];
}, isNodeSelected: function(e10, t2) {
  var n2 = iv(eg.nodes(e10, { match: function(e11) {
    return e11 === t2;
  }, universal: true }), 1), r3 = n2[0];
  return null != r3 && iv(r3, 1)[0] === t2;
}, isSelectionAtLineEnd: function(e10, t2) {
  var n2 = e10.selection;
  return !!n2 && (eg.isEnd(e10, n2.anchor, t2) || eg.isEnd(e10, n2.focus, t2));
}, getTextarea: function(e10) {
  var t2 = Ov.get(e10);
  if (null == t2) throw new Error("Cannot find textarea instance by editor");
  return t2;
}, getToolbar: function(e10) {
  return Tv.get(e10) || null;
}, getHoverbar: function(e10) {
  return Fv.get(e10) || null;
}, normalizeContent: function(e10) {
  e10.children.forEach(function(t2, n2) {
    e10.normalizeNode([t2, [n2]]);
  });
}, getLeftLengthOfMaxLength: function(e10) {
  var t2 = e10.getConfig(), n2 = t2.maxLength, r3 = t2.onMaxLength;
  if ("number" != typeof n2 || n2 <= 0) return 1 / 0;
  var o2 = n2 - e10.getText().replace(/\r|\n|(\r\n)|(\n\r)/g, "").length;
  return o2 <= 0 && r3 && r3(e10), o2;
}, cleanExposedTexNodeInSelectionBlock: function(e10) {
  var t2, n2, r3, o2, i2 = zy.getTextarea(e10).$textArea, a2 = null == i2 ? void 0 : i2[0].childNodes;
  if (a2) try {
    for (var s2 = ov(Array.from(a2)), u2 = s2.next(); !u2.done; u2 = s2.next()) {
      var l2 = u2.value;
      if (!ry(l2)) break;
      l2.remove();
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      u2 && !u2.done && (n2 = s2.return) && n2.call(s2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  var c3 = eg.nodes(e10, { match: function(t3) {
    return !(!Kh.isElement(t3) || e10.isInline(t3));
  }, universal: true });
  try {
    for (var d2 = ov(c3), f2 = d2.next(); !f2.done; f2 = d2.next()) {
      var p2 = f2.value;
      if (null != p2) {
        var h2 = p2[0];
        uy(zy.toDOMNode(e10, h2), function(e11, t3) {
          var n3 = fm(t3);
          n3.attr("data-slate-string") || n3.attr("data-slate-zero-width") || n3.attr("data-w-e-reserve") || t3.removeChild(e11);
        });
      }
    }
  } catch (e11) {
    r3 = { error: e11 };
  } finally {
    try {
      f2 && !f2.done && (o2 = d2.return) && o2.call(d2);
    } finally {
      if (r3) throw r3.error;
    }
  }
}, isLastNode: function(e10, t2) {
  var n2 = e10.children || [];
  return n2[n2.length - 1] === t2;
}, genEmptyParagraph: function() {
  return { type: "paragraph", children: [{ text: "" }] };
}, isSelectedVoidNode: function(e10) {
  var t2, n2, r3 = eg.nodes(e10, { match: function(t3) {
    return e10.isVoid(t3);
  } }), o2 = 0;
  try {
    for (var i2 = ov(r3), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      a2.value && (o2 += 1);
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return o2 > 0;
}, isSelectedEmptyParagraph: function(e10) {
  var t2 = e10.selection;
  if (null == t2) return false;
  if (yg.isExpanded(t2)) return false;
  var n2 = zy.getSelectedNodeByType(e10, "paragraph");
  if (null === n2) return false;
  var r3 = n2.children;
  return 1 === r3.length && ("" === r3[0].text || void 0);
}, isEmptyPath: function(e10, t2) {
  var n2 = eg.node(e10, t2);
  if (null == n2) return false;
  var r3 = iv(n2, 1)[0].children;
  if (1 === r3.length && "" === r3[0].text) return true;
  return false;
} };
function $y(e10, t2) {
  return Kh.isElement(e10) ? By(e10, t2) : function(e11, t3) {
    var n2 = e11.text;
    if (null == n2) throw new Error("Current node is not slate Text ".concat(JSON.stringify(e11)));
    var r3 = n2;
    r3 = function(e12) {
      return e12.replace(/ {2}/g, " &nbsp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/®/g, "&reg;").replace(/©/g, "&copy;").replace(/™/g, "&trade;");
    }(r3);
    var o2 = zy.getParentsNodes(t3, e11).some(function(e12) {
      return "pre" === zy.getNodeType(e12);
    });
    if (o2 || (r3 = r3.replace(/\n\r|\r\n|\r|\n/g, "<br>")), o2 && (r3 = r3.replace(/&nbsp;/g, " ")), "" === r3) {
      var i2 = zy.getParentNode(null, e11);
      if (!i2 || 0 !== i2.children.length) return r3;
      r3 = "<br>";
    }
    return Sy.forEach(function(t4) {
      return r3 = t4(e11, r3);
    }), r3;
  }(e10, t2);
}
var Uy = function(e10, t2) {
  var n2 = (t2.top + t2.bottom) / 2;
  return e10.top <= n2 && e10.bottom >= n2;
}, Vy = function(e10, t2, n2) {
  var r3 = zy.toDOMRange(e10, t2).getBoundingClientRect(), o2 = zy.toDOMRange(e10, n2).getBoundingClientRect();
  return Uy(r3, o2) && Uy(o2, r3);
}, Wy = function(e10, t2) {
  var n2, r3, o2 = [];
  try {
    for (var i2 = ov(eg.levels(e10, { at: t2 })), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      var s2 = iv(a2.value, 2), u2 = s2[0], l2 = s2[1], c3 = zy.findKey(e10, u2);
      o2.push([l2, c3]);
    }
  } catch (e11) {
    n2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (r3 = i2.return) && r3.call(i2);
    } finally {
      if (n2) throw n2.error;
    }
  }
  return o2;
};
function Gy(e10, t2) {
  e10.isInline(t2) ? (e10.insertNode(t2), "link" === t2.type && e10.insertFragment([{ text: "" }])) : Wg.insertNodes(e10, t2, { mode: "highest" });
}
var qy, Ky, Yy, Xy, Zy, Jy, Qy, eb, tb, nb, rb, ob, ib, ab, sb, ub, lb, cb, db, fb, pb, hb, gb, vb, mb, yb, bb, Eb, Cb, wb, Db, Sb, Ab, xb, Ob, Nb, Bb, Tb, kb, Fb, Ib = function(e10) {
  var t2 = e10, n2 = t2.onChange, r3 = t2.insertText, o2 = t2.apply, i2 = t2.deleteBackward;
  return t2.insertText = function(e11) {
    t2.getConfig().readOnly || r3(e11);
  }, t2.apply = function(e11) {
    var n3, r4, i3, a2, s2, u2, l2, c3, d2 = [];
    switch (e11.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node":
        d2.push.apply(d2, av([], iv(Wy(t2, e11.path)), false));
        break;
      case "insert_node":
      case "remove_node":
        d2.push.apply(d2, av([], iv(Wy(t2, cg.parent(e11.path))), false));
        break;
      case "merge_node":
        var f2 = cg.previous(e11.path);
        d2.push.apply(d2, av([], iv(Wy(t2, f2)), false));
        break;
      case "move_node":
        var p2 = cg.common(cg.parent(e11.path), cg.parent(e11.newPath));
        d2.push.apply(d2, av([], iv(Wy(t2, p2)), false));
        break;
      case "set_selection":
        (null === (a2 = null === (i3 = e11.newProperties) || void 0 === i3 ? void 0 : i3.focus) || void 0 === a2 ? void 0 : a2.path) && (d2.push.apply(d2, av([], iv(Wy(t2, null === (u2 = null === (s2 = e11.newProperties) || void 0 === s2 ? void 0 : s2.focus) || void 0 === u2 ? void 0 : u2.path)), false)), d2.push.apply(d2, av([], iv(Wy(t2, null === (c3 = null === (l2 = e11.properties) || void 0 === l2 ? void 0 : l2.focus) || void 0 === c3 ? void 0 : c3.path)), false)));
    }
    o2(e11);
    try {
      for (var h2 = ov(d2), g2 = h2.next(); !g2.done; g2 = h2.next()) {
        var v2 = iv(g2.value, 2), m2 = v2[0], y2 = v2[1], b2 = iv(eg.node(t2, m2), 1)[0];
        Kv.set(b2, y2), "type" in b2 && (Hv.has(b2) && Hv.delete(b2), zv.has(b2) && zv.delete(b2));
      }
    } catch (e12) {
      n3 = { error: e12 };
    } finally {
      try {
        g2 && !g2.done && (r4 = h2.return) && r4.call(h2);
      } finally {
        if (n3) throw n3.error;
      }
    }
  }, t2.deleteBackward = function(n3) {
    if ("line" !== n3) return i2(n3);
    if (e10.selection && yg.isCollapsed(e10.selection)) {
      var r4 = eg.above(e10, { match: function(t3) {
        return eg.isBlock(e10, t3);
      }, at: e10.selection });
      if (r4) {
        var o3 = iv(r4, 2)[1], a2 = eg.range(e10, o3, e10.selection.anchor), s2 = function(e11, t3) {
          var n4 = eg.range(e11, yg.end(t3)), r5 = Array.from(eg.positions(e11, { at: t3 })), o4 = 0, i3 = r5.length, a3 = Math.floor(i3 / 2);
          if (Vy(e11, eg.range(e11, r5[o4]), n4)) return eg.range(e11, r5[o4], n4);
          if (r5.length < 2) return eg.range(e11, r5[r5.length - 1], n4);
          for (; a3 !== r5.length && a3 !== o4; ) Vy(e11, eg.range(e11, r5[a3]), n4) ? i3 = a3 : o4 = a3, a3 = Math.floor((o4 + i3) / 2);
          return eg.range(e11, r5[i3], n4);
        }(t2, a2);
        yg.isCollapsed(s2) || Wg.delete(e10, { at: s2 });
      }
    }
  }, t2.onChange = function() {
    var e11 = t2.selection;
    null != e11 && Zv.set(t2, e11), t2.emit(bv), n2();
  }, t2.handleTab = function() {
    t2.insertText("    ");
  }, t2.getHtml = function() {
    var e11 = t2.children, n3 = void 0 === e11 ? [] : e11, r4 = t2.getConfig().skipCacheTypes, o3 = void 0 === r4 ? ["list-item"] : r4;
    return n3.map(function(e12) {
      var n4 = zy.getNodeType(e12);
      if (o3.includes(n4)) return $y(e12, t2);
      var r5 = zv.get(e12);
      if (r5) return r5;
      var i3 = $y(e12, t2);
      return zv.set(e12, i3), i3;
    }).join("");
  }, t2.getText = function() {
    var e11 = t2.children;
    return (void 0 === e11 ? [] : e11).map(function(e12) {
      return ag.string(e12);
    }).join("\n");
  }, t2.getSelectionText = function() {
    var n3 = t2.selection;
    return null == n3 ? "" : eg.string(e10, n3);
  }, t2.getElemsByType = function(e11, n3) {
    var r4, o3;
    void 0 === n3 && (n3 = false);
    var i3 = [], a2 = eg.nodes(t2, { at: [], universal: true });
    try {
      for (var s2 = ov(a2), u2 = s2.next(); !u2.done; u2 = s2.next()) {
        var l2 = iv(u2.value, 1)[0];
        if (Kh.isElement(l2)) {
          if (n3 ? l2.type.indexOf(e11) >= 0 : l2.type === e11) {
            var c3 = zy.findKey(t2, l2), d2 = Dy(l2.type, c3.id);
            i3.push(tv(tv({}, l2), { id: d2 }));
          }
        }
      }
    } catch (e12) {
      r4 = { error: e12 };
    } finally {
      try {
        u2 && !u2.done && (o3 = s2.return) && o3.call(s2);
      } finally {
        if (r4) throw r4.error;
      }
    }
    return i3;
  }, t2.getElemsByTypePrefix = function(e11) {
    return t2.getElemsByType(e11, true);
  }, t2.isEmpty = function() {
    var e11 = t2.children, n3 = void 0 === e11 ? [] : e11;
    if (n3.length > 1) return false;
    var r4 = n3[0];
    if (null == r4) return true;
    if (!Kh.isElement(r4) || "paragraph" !== r4.type) return false;
    var o3 = r4.children, i3 = void 0 === o3 ? [] : o3;
    if (i3.length > 1) return false;
    var a2 = i3[0];
    return null == a2 || Og.isText(a2) && "" === a2.text;
  }, t2.clear = function() {
    Wg.delete(t2, { at: { anchor: eg.start(t2, []), focus: eg.end(t2, []) } }), 0 === t2.children.length && Wg.insertNodes(t2, [{ type: "paragraph", children: [{ text: "" }] }]);
  }, t2.getParentNode = function(e11) {
    return zy.getParentNode(t2, e11);
  }, t2.dangerouslyInsertHtml = function(e11, n3) {
    if (void 0 === e11 && (e11 = ""), void 0 === n3 && (n3 = false), e11) {
      var r4 = document.createElement("div");
      r4.innerHTML = e11;
      var o3 = Array.from(r4.childNodes);
      if (o3 = o3.filter(function(e12) {
        var t3 = e12.nodeName;
        return !!ry(e12) || !!ty(e12) && !tm.has(t3.toLowerCase());
      }), 0 !== o3.length) {
        var i3 = t2.selection;
        if (null != i3) {
          var a2 = null;
          if (zy.isSelectedEmptyParagraph(t2) && !n3) a2 = [i3.focus.path[0]];
          r4.setAttribute("hidden", "true"), document.body.appendChild(r4);
          var s2 = 0;
          o3.forEach(function(e12, n4) {
            var r5 = e12.nodeName, i4 = e12.textContent, a3 = void 0 === i4 ? "" : i4;
            if (ry(e12)) {
              if (!a3 || !a3.trim()) return;
              t2.insertNode({ text: a3 });
            } else if ("BR" !== r5) {
              var u2 = e12, l2 = false;
              if (fy.includes(r5.toLowerCase())) l2 = true;
              else for (var c3 in gy) if (u2.matches(c3)) {
                l2 = true;
                break;
              }
              if (l2) {
                var d2 = Ey(fm(u2), t2);
                return Array.isArray(d2) ? (d2.forEach(function(e13) {
                  return Gy(t2, e13);
                }), s2 += 1) : (Gy(t2, d2), s2 += 1), void (zy.isSelectedVoidNode(t2) && t2.move(1));
              }
              var f2 = window.getComputedStyle(u2).display;
              if (!zy.isSelectedEmptyParagraph(t2) && f2.indexOf("inline") < 0) {
                if (n4 >= 1) (function(e13) {
                  return "matches" in e13 && /^[ou]l$/i.test(e13.tagName) && !e13.hasAttribute("data-w-e-type");
                })(o3[n4 - 1]) && t2.insertBreak();
                t2.insertBreak();
              }
              t2.dangerouslyInsertHtml(u2.innerHTML, true);
            } else t2.insertText("\n");
          }), s2 && a2 && zy.isEmptyPath(t2, a2) && Wg.removeNodes(t2, { at: a2 }), r4.remove();
        }
      }
    }
  }, t2.setHtml = function(e11) {
    void 0 === e11 && (e11 = "");
    var n3 = t2.isDisabled(), r4 = t2.isFocused(), o3 = JSON.stringify(t2.selection);
    t2.enable(), t2.focus(), t2.clear();
    var i3 = wy(t2, null == e11 ? "" : e11);
    if (Wg.insertFragment(t2, i3), r4 || (t2.deselect(), t2.blur()), n3 && (t2.deselect(), t2.disable()), t2.isFocused()) try {
      t2.select(JSON.parse(o3));
    } catch (e12) {
      t2.select(eg.start(t2, []));
    }
  }, t2;
}, Pb = 1, _b2 = function(e10) {
  var t2 = e10;
  return t2.id = "wangEditor-".concat(Pb), Pb += 1, t2.isDestroyed = false, t2.isFullScreen = false, t2.focus = function(e11) {
    if (zy.toDOMNode(t2, t2).focus({ preventScroll: true }), Xv.set(t2, true), e11) {
      var n2 = eg.end(t2, []);
      Wg.select(t2, n2);
    } else {
      var r3 = Zv.get(t2);
      r3 ? Wg.select(t2, r3) : Wg.select(t2, eg.start(t2, []));
    }
  }, t2.isFocused = function() {
    return !!Xv.get(t2);
  }, t2.blur = function() {
    zy.toDOMNode(t2, t2).blur(), Wg.deselect(t2), Xv.set(t2, false);
  }, t2.updateView = function() {
    zy.getTextarea(t2).changeViewState();
    var e11 = zy.getToolbar(t2);
    e11 && e11.changeToolbarState();
    var n2 = zy.getHoverbar(t2);
    n2 && n2.changeHoverbarState();
  }, t2.destroy = function() {
    if (!t2.isDestroyed) {
      var e11 = zy.getTextarea(t2);
      e11.destroy(), Ov.delete(t2), Nv.delete(e11);
      var n2 = zy.getToolbar(t2);
      n2 && (n2.destroy(), Tv.delete(t2), Bv.delete(n2));
      var r3 = zy.getHoverbar(t2);
      r3 && (r3.destroy(), Fv.delete(t2), kv.delete(r3)), t2.isDestroyed = true, t2.emit(yv);
    }
  }, t2.scrollToElem = function(e11) {
    if (!t2.getConfig().scroll) {
      var n2 = "编辑器禁用了 scroll ，编辑器内容无法滚动，请自行实现该功能";
      return n2 += "\nYou has disabled editor scroll, please do this yourself", void console.warn(n2);
    }
    var r3 = fm("#".concat(e11));
    if (0 !== r3.length) {
      var o2 = r3[0];
      if (!zy.hasDOMNode(t2, o2)) {
        n2 = "Element (found by id is '".concat(e11, "') is not in editor DOM");
        return n2 += "\n 通过 id '".concat(e11, "' 找到的 element 不在 editor DOM 之内"), void console.error(n2, o2);
      }
      var i2 = zy.getTextarea(t2), a2 = i2.$textAreaContainer, s2 = i2.$scroll, u2 = r3.offset().top, l2 = a2.offset().top;
      s2[0].scrollBy({ top: u2 - l2, behavior: "smooth" });
    }
  }, t2.showProgressBar = function(e11) {
    e11 < 1 || zy.getTextarea(t2).changeProgress(e11);
  }, t2.hidePanelOrModal = function() {
    var e11 = Pv.get(t2);
    null != e11 && e11.forEach(function(e12) {
      return e12.hide();
    });
  }, t2.enable = function() {
    t2.getConfig().readOnly = false, t2.updateView();
  }, t2.disable = function() {
    t2.getConfig().readOnly = true, t2.updateView();
  }, t2.isDisabled = function() {
    return t2.getConfig().readOnly;
  }, t2.toDOMNode = function(e11) {
    return zy.toDOMNode(t2, e11);
  }, t2.fullScreen = function() {
    if (!t2.isFullScreen) {
      var e11 = null, n2 = zy.getToolbar(t2);
      n2 && (e11 = n2.$box);
      var r3 = zy.getTextarea(t2).$box.parent();
      if (e11 && e11.parent()[0] !== r3[0]) {
        throw new Error("Can not set full screen, cause toolbar DOM parent is not equal to textarea DOM parent\n不能设置全屏，因为 toolbar DOM 父节点和 textarea DOM 父节点不一致");
      }
      r3.addClass("w-e-full-screen-container");
      var o2 = r3.css("z-index");
      r3.attr("data-z-index", o2.toString()), t2.isFullScreen = true, t2.emit(Cv);
    }
  }, t2.unFullScreen = function() {
    if (t2.isFullScreen) {
      var e11 = zy.getTextarea(t2).$box.parent();
      setTimeout(function() {
        e11.removeClass("w-e-full-screen-container"), t2.isFullScreen = false, t2.emit(wv);
      }, 200);
    }
  }, t2.getEditableContainer = function() {
    return zy.getTextarea(t2).$textAreaContainer[0];
  }, t2;
}, Rb = { exports: {} }, Lb = { exports: {} };
function Mb() {
  if (Ky) return qy;
  Ky = 1;
  return qy = function(e10) {
    return null != e10;
  };
}
function jb() {
  if (Jy) return Zy;
  Jy = 1;
  var e10 = function() {
    if (Xy) return Yy;
    Xy = 1;
    var e11 = Mb(), t2 = { object: true, function: true, undefined: true };
    return Yy = function(n2) {
      return !!e11(n2) && hasOwnProperty.call(t2, typeof n2);
    };
  }();
  return Zy = function(t2) {
    if (!e10(t2)) return false;
    try {
      return !!t2.constructor && t2.constructor.prototype === t2;
    } catch (e11) {
      return false;
    }
  };
}
function Hb() {
  if (nb) return tb;
  nb = 1;
  var e10 = function() {
    if (eb) return Qy;
    eb = 1;
    var e11 = jb();
    return Qy = function(t3) {
      if ("function" != typeof t3) return false;
      if (!hasOwnProperty.call(t3, "length")) return false;
      try {
        if ("number" != typeof t3.length) return false;
        if ("function" != typeof t3.call) return false;
        if ("function" != typeof t3.apply) return false;
      } catch (e12) {
        return false;
      }
      return !e11(t3);
    };
  }(), t2 = /^\s*class[\s{/}]/, n2 = Function.prototype.toString;
  return tb = function(r3) {
    return !!e10(r3) && !t2.test(n2.call(r3));
  };
}
function zb() {
  if (cb) return lb;
  cb = 1;
  var e10 = (ub ? sb : (ub = 1, sb = function() {
  }))();
  return lb = function(t2) {
    return t2 !== e10 && null !== t2;
  }, lb;
}
function $b() {
  return hb || (hb = 1, pb = (ab ? ib : (ab = 1, ib = function() {
    try {
      return Object.keys("primitive"), true;
    } catch (e10) {
      return false;
    }
  }))() ? Object.keys : function() {
    if (fb) return db;
    fb = 1;
    var e10 = zb(), t2 = Object.keys;
    return db = function(n2) {
      return t2(e10(n2) ? Object(n2) : n2);
    };
  }()), pb;
}
function Ub() {
  if (yb) return mb;
  yb = 1;
  var e10 = $b(), t2 = function() {
    if (vb) return gb;
    vb = 1;
    var e11 = zb();
    return gb = function(t3) {
      if (!e11(t3)) throw new TypeError("Cannot use null or undefined");
      return t3;
    };
  }(), n2 = Math.max;
  return mb = function(r3, o2) {
    var i2, a2, s2, u2 = n2(arguments.length, 2);
    for (r3 = Object(t2(r3)), s2 = function(e11) {
      try {
        r3[e11] = o2[e11];
      } catch (e12) {
        i2 || (i2 = e12);
      }
    }, a2 = 1; a2 < u2; ++a2) e10(o2 = arguments[a2]).forEach(s2);
    if (void 0 !== i2) throw i2;
    return r3;
  }, mb;
}
function Vb() {
  return Eb ? bb : (Eb = 1, bb = (ob || (ob = 1, rb = function() {
    var e10, t2 = Object.assign;
    return "function" == typeof t2 && (t2(e10 = { foo: "raz" }, { bar: "dwa" }, { trzy: "trzy" }), e10.foo + e10.bar + e10.trzy === "razdwatrzy");
  }), rb)() ? Object.assign : Ub());
}
function Wb() {
  return Nb || (Nb = 1, Ob = function() {
    if (Sb) return Db;
    Sb = 1;
    var e10 = "razdwatrzy";
    return Db = function() {
      return "function" == typeof e10.contains && true === e10.contains("dwa") && false === e10.contains("foo");
    };
  }()() ? String.prototype.contains : function() {
    if (xb) return Ab;
    xb = 1;
    var e10 = String.prototype.indexOf;
    return Ab = function(t2) {
      return e10.call(this, t2, arguments[1]) > -1;
    }, Ab;
  }()), Ob;
}
function Gb() {
  if (Bb) return Lb.exports;
  Bb = 1;
  var e10 = Mb(), t2 = Hb(), n2 = Vb(), r3 = function() {
    if (wb) return Cb;
    wb = 1;
    var e11 = zb(), t3 = Array.prototype.forEach, n3 = Object.create;
    return Cb = function(r4) {
      var o3 = n3(null);
      return t3.call(arguments, function(t4) {
        e11(t4) && function(e12, t5) {
          var n4;
          for (n4 in e12) t5[n4] = e12[n4];
        }(Object(t4), o3);
      }), o3;
    }, Cb;
  }(), o2 = Wb(), i2 = Lb.exports = function(t3, i3) {
    var a2, s2, u2, l2, c3;
    return arguments.length < 2 || "string" != typeof t3 ? (l2 = i3, i3 = t3, t3 = null) : l2 = arguments[2], e10(t3) ? (a2 = o2.call(t3, "c"), s2 = o2.call(t3, "e"), u2 = o2.call(t3, "w")) : (a2 = u2 = true, s2 = false), c3 = { value: i3, configurable: a2, enumerable: s2, writable: u2 }, l2 ? n2(r3(l2), c3) : c3;
  };
  return i2.gs = function(i3, a2, s2) {
    var u2, l2, c3, d2;
    return "string" != typeof i3 ? (c3 = s2, s2 = a2, a2 = i3, i3 = null) : c3 = arguments[3], e10(a2) ? t2(a2) ? e10(s2) ? t2(s2) || (c3 = s2, s2 = void 0) : s2 = void 0 : (c3 = a2, a2 = s2 = void 0) : a2 = void 0, e10(i3) ? (u2 = o2.call(i3, "c"), l2 = o2.call(i3, "e")) : (u2 = true, l2 = false), d2 = { get: a2, set: s2, configurable: u2, enumerable: l2 }, c3 ? n2(r3(c3), d2) : d2;
  }, Lb.exports;
}
var qb = (Fb || (Fb = 1, function(e10, t2) {
  var n2, r3, o2, i2, a2, s2, u2, l2 = Gb(), c3 = (kb || (kb = 1, Tb = function(e11) {
    if ("function" != typeof e11) throw new TypeError(e11 + " is not a function");
    return e11;
  }), Tb), d2 = Function.prototype.apply, f2 = Function.prototype.call, p2 = Object.create, h2 = Object.defineProperty, g2 = Object.defineProperties, v2 = Object.prototype.hasOwnProperty, m2 = { configurable: true, enumerable: false, writable: true };
  n2 = function(e11, t3) {
    var n3;
    return c3(t3), v2.call(this, "__ee__") ? n3 = this.__ee__ : (n3 = m2.value = p2(null), h2(this, "__ee__", m2), m2.value = null), n3[e11] ? "object" == typeof n3[e11] ? n3[e11].push(t3) : n3[e11] = [n3[e11], t3] : n3[e11] = t3, this;
  }, r3 = function(e11, t3) {
    var r4, i3;
    return c3(t3), i3 = this, n2.call(this, e11, r4 = function() {
      o2.call(i3, e11, r4), d2.call(t3, this, arguments);
    }), r4.__eeOnceListener__ = t3, this;
  }, o2 = function(e11, t3) {
    var n3, r4, o3, i3;
    if (c3(t3), !v2.call(this, "__ee__")) return this;
    if (!(n3 = this.__ee__)[e11]) return this;
    if ("object" == typeof (r4 = n3[e11])) for (i3 = 0; o3 = r4[i3]; ++i3) o3 !== t3 && o3.__eeOnceListener__ !== t3 || (2 === r4.length ? n3[e11] = r4[i3 ? 0 : 1] : r4.splice(i3, 1));
    else r4 !== t3 && r4.__eeOnceListener__ !== t3 || delete n3[e11];
    return this;
  }, i2 = function(e11) {
    var t3, n3, r4, o3, i3;
    if (v2.call(this, "__ee__") && (o3 = this.__ee__[e11])) if ("object" == typeof o3) {
      for (n3 = arguments.length, i3 = new Array(n3 - 1), t3 = 1; t3 < n3; ++t3) i3[t3 - 1] = arguments[t3];
      for (o3 = o3.slice(), t3 = 0; r4 = o3[t3]; ++t3) d2.call(r4, this, i3);
    } else switch (arguments.length) {
      case 1:
        f2.call(o3, this);
        break;
      case 2:
        f2.call(o3, this, arguments[1]);
        break;
      case 3:
        f2.call(o3, this, arguments[1], arguments[2]);
        break;
      default:
        for (n3 = arguments.length, i3 = new Array(n3 - 1), t3 = 1; t3 < n3; ++t3) i3[t3 - 1] = arguments[t3];
        d2.call(o3, this, i3);
    }
  }, a2 = { on: n2, once: r3, off: o2, emit: i2 }, s2 = { on: l2(n2), once: l2(r3), off: l2(o2), emit: l2(i2) }, u2 = g2({}, s2), e10.exports = t2 = function(e11) {
    return null == e11 ? p2(u2) : g2(Object(e11), s2);
  }, t2.methods = a2;
}(Rb, Rb.exports)), Rb.exports), Kb = b(qb);
function Yb(e10) {
  var t2 = Jv.get(e10);
  return null == t2 && (t2 = Kb(), Jv.set(e10, t2)), t2;
}
var Xb = /* @__PURE__ */ new WeakMap();
function Zb(e10, t2) {
  var n2 = Xb.get(e10);
  null == n2 && (n2 = /* @__PURE__ */ new Set(), Xb.set(e10, n2)), n2.add(t2);
}
var Jb = function(e10) {
  var t2 = e10;
  return t2.on = function(e11, n2) {
    var r3 = Yb(t2);
    if (r3.on(e11, n2), "destroyed" === e11 && Zb(t2, n2), "destroyed" !== e11) {
      var o2 = function() {
        return r3.off(e11, n2);
      };
      r3.on("destroyed", o2), Zb(t2, o2);
    }
  }, t2.once = function(e11, n2) {
    Yb(t2).once(e11, n2);
  }, t2.off = function(e11, n2) {
    Yb(t2).off(e11, n2);
  }, t2.emit = function(e11) {
    for (var n2 = [], r3 = 1; r3 < arguments.length; r3++) n2[r3 - 1] = arguments[r3];
    var o2 = Yb(t2);
    if (o2.emit.apply(o2, av([e11], iv(n2), false)), "destroyed" === e11) {
      var i2 = function(e12) {
        return Xb.get(e12) || /* @__PURE__ */ new Set();
      }(t2);
      i2.forEach(function(e12) {
        return o2.off("destroyed", e12);
      }), function(e12) {
        Xb.set(e12, /* @__PURE__ */ new Set());
      }(t2);
    }
  }, t2;
}, Qb = function(e10) {
  var t2 = e10;
  return t2.setFragmentData = function(e11) {
    var n2 = t2.selection;
    if (n2) {
      var r3 = iv(yg.edges(n2), 2), o2 = r3[0], i2 = r3[1], a2 = eg.void(t2, { at: o2.path }), s2 = eg.void(t2, { at: i2.path });
      if (!yg.isCollapsed(n2) || a2) {
        var u2 = zy.toDOMRange(t2, n2), l2 = u2.cloneContents(), c3 = l2.childNodes[0];
        if (l2.childNodes.forEach(function(e12) {
          e12.textContent && "" !== e12.textContent.trim() && (c3 = e12);
        }), s2) {
          var d2 = iv(s2, 1)[0], f2 = u2.cloneRange(), p2 = zy.toDOMNode(t2, d2);
          f2.setEndAfter(p2), l2 = f2.cloneContents();
        }
        if (a2 && (c3 = l2.querySelector("[data-slate-spacer]")), Array.from(l2.querySelectorAll("[data-slate-zero-width]")).forEach(function(e12) {
          var t3 = "n" === e12.getAttribute("data-slate-zero-width");
          e12.textContent = t3 ? "\n" : "";
        }), ry(c3)) {
          var h2 = c3.ownerDocument.createElement("span");
          h2.style.whiteSpace = "pre", h2.appendChild(c3), l2.appendChild(h2), c3 = h2;
        }
        var g2 = t2.getFragment(), v2 = JSON.stringify(g2), m2 = window.btoa(encodeURIComponent(v2));
        c3.setAttribute("data-slate-fragment", m2), e11.setData("application/x-slate-fragment", m2);
        var y2 = l2.ownerDocument.createElement("div");
        return y2.appendChild(l2), y2.setAttribute("hidden", "true"), l2.ownerDocument.body.appendChild(y2), e11.setData("text/html", y2.innerHTML), e11.setData("text/plain", sy(y2)), l2.ownerDocument.body.removeChild(y2), e11;
      }
    }
  }, t2.insertData = function(e11) {
    var n2, r3, o2 = e11.getData("application/x-slate-fragment");
    if (o2) {
      var i2 = decodeURIComponent(window.atob(o2)), a2 = JSON.parse(i2);
      t2.insertFragment(a2);
    } else {
      var s2 = e11.getData("text/plain"), u2 = e11.getData("text/html");
      if (u2) t2.dangerouslyInsertHtml(u2);
      else if (s2) {
        var l2 = s2.split(/\n\r|\r\n|\r|\n/), c3 = false;
        try {
          for (var d2 = ov(l2), f2 = d2.next(); !f2.done; f2 = d2.next()) {
            var p2 = f2.value, h2 = zy.getLeftLengthOfMaxLength(t2);
            c3 && h2 > 0 && Wg.splitNodes(t2, { always: true }), t2.insertText(p2), c3 = true;
          }
        } catch (e12) {
          n2 = { error: e12 };
        } finally {
          try {
            f2 && !f2.done && (r3 = d2.return) && r3.call(d2);
          } finally {
            if (n2) throw n2.error;
          }
        }
      }
    }
  }, t2;
}, eE = function(e10) {
  var t2 = e10, n2 = t2.insertText, r3 = t2.insertNode, o2 = t2.insertFragment, i2 = t2.dangerouslyInsertHtml;
  return t2.insertText = function(e11) {
    if (t2.getConfig().maxLength) {
      var r4 = zy.getLeftLengthOfMaxLength(t2);
      r4 <= 0 || (r4 < e11.length ? n2(e11.slice(0, r4)) : n2(e11));
    } else n2(e11);
  }, t2.insertNode = function(e11) {
    if (t2.getConfig().maxLength) {
      var n3 = zy.getLeftLengthOfMaxLength(t2);
      if (!(n3 <= 0)) n3 < ag.string(e11).length || r3(e11);
    } else r3(e11);
  }, t2.insertFragment = function(e11) {
    if (t2.getConfig().maxLength) {
      if (e11.length > 0) {
        var n3 = e11[0];
        if (zy.getLeftLengthOfMaxLength(t2) < ag.string(n3).length) return;
        o2([n3]);
        for (var r4 = 1; r4 < e11.length; r4 += 1) t2.insertNode(e11[r4]);
      }
    } else o2(e11);
  }, t2.dangerouslyInsertHtml = function(e11, n3) {
    if (void 0 === e11 && (e11 = ""), void 0 === n3 && (n3 = false), e11) if (t2.getConfig().maxLength) {
      var r4 = zy.getLeftLengthOfMaxLength(t2);
      if (!(r4 <= 0)) {
        var o3 = document.createElement("div");
        o3.innerHTML = e11, r4 < Array.from(o3.childNodes).reduce(function(e12, t3) {
          var n4 = t3.nodeName;
          return t3 ? ry(t3) ? e12 + (t3.textContent || "") : ty(t3) ? tm.has(n4.toLowerCase()) ? e12 : e12 + (t3.textContent || "") : e12 : e12;
        }, "").length || i2(e11, n3);
      }
    } else i2(e11, n3);
  }, t2;
};
function tE(e10) {
  var t2 = zy.getTextarea(e10).$textAreaContainer, n2 = t2.width(), r3 = t2.height(), o2 = t2.offset();
  return { top: o2.top, left: o2.left, width: n2, height: r3 };
}
function nE(e10) {
  var t2 = { top: "0", left: "0" }, n2 = e10.selection;
  if (null == n2) return t2;
  var r3 = tE(e10);
  if (null == r3) return t2;
  var o2 = r3.top, i2 = r3.left, a2 = r3.width, s2 = r3.height, u2 = zy.toDOMRange(e10, n2).getClientRects(), l2 = u2 ? u2[0] : null;
  if (null == l2) return t2;
  var c3 = {}, d2 = l2.top - o2, f2 = l2.left - i2;
  if (f2 > a2 / 2) {
    var p2 = a2 - f2;
    c3.right = "".concat(p2 + 5, "px");
  } else c3.left = "".concat(f2 + 5, "px");
  if (d2 > s2 / 2) {
    var h2 = s2 - d2;
    c3.bottom = "".concat(h2 + 5, "px");
  } else {
    var g2 = u2[u2.length - 1], v2 = g2.top - o2 + g2.height;
    v2 < 0 && (v2 = 0), c3.top = "".concat(v2 + 5, "px");
  }
  return c3;
}
function rE(e10, t2, n2) {
  void 0 === n2 && (n2 = "modal");
  var r3 = { top: "0", left: "0" };
  if (null == e10.selection) return r3;
  var o2 = Kh.isElement(t2) && e10.isVoid(t2), i2 = Kh.isElement(t2) && e10.isInline(t2), a2 = qv.get(t2);
  if (null == a2) return r3;
  var s2 = a2.getBoundingClientRect(), u2 = s2.top, l2 = s2.left, c3 = s2.height, d2 = s2.width;
  if (o2) {
    var f2 = function(e11) {
      var t3 = [];
      t3.push(e11);
      for (var n3 = 0; t3.length > 0; ) {
        var r4 = t3.pop();
        if (null == r4) break;
        if ((n3 += 1) > 1e4) break;
        var o3 = r4.nodeName;
        if (r4.nodeType === Ym.ELEMENT_NODE) {
          var i3 = o3.toLowerCase();
          if (Gm.includes(i3) || "iframe" === i3 || "video" === i3) return r4;
          var a3 = r4.children || [], s3 = a3.length;
          if (s3) for (var u3 = s3 - 1; u3 >= 0; u3 -= 1) t3.push(a3[u3]);
        }
      }
      return null;
    }(a2);
    if (null != f2) {
      var p2 = f2.getBoundingClientRect();
      u2 = p2.top, c3 = p2.height;
    }
  }
  var h2 = tE(e10);
  if (null == h2) return r3;
  var g2 = h2.top, v2 = h2.left, m2 = h2.width, y2 = h2.height, b2 = {}, E2 = u2 - g2, C2 = l2 - v2;
  if ("bar" === n2) return b2.left = "".concat(C2, "px"), E2 > 40 ? b2.bottom = "".concat(y2 - E2 + 5, "px") : b2.top = "".concat(E2 + c3 + 5, "px"), b2;
  if ("modal" === n2) {
    if (o2 ? i2 ? C2 > (m2 - d2) / 2 ? b2.right = "".concat(m2 - C2 + 5, "px") : b2.left = "".concat(C2 + d2 + 5, "px") : b2.left = "20px" : b2.left = "".concat(C2, "px"), o2) (w2 = E2) < 0 && (w2 = 0), b2.top = "".concat(w2, "px");
    else if (E2 > (y2 - c3) / 2) b2.bottom = "".concat(y2 - E2 + 5, "px");
    else {
      var w2;
      (w2 = E2 + c3) < 0 && (w2 = 0), b2.top = "".concat(w2 + 5, "px");
    }
    return b2;
  }
  throw new Error("type '".concat(n2, "' is invalid"));
}
function oE(e10, t2) {
  Km(function() {
    var n2 = tE(e10);
    if (null != n2) {
      var r3, o2 = n2.top, i2 = n2.left, a2 = n2.width, s2 = n2.height, u2 = t2.offset(), l2 = u2.top, c3 = u2.left, d2 = t2.width(), f2 = t2.height(), p2 = l2 - o2, h2 = c3 - i2, g2 = t2.attr("style");
      if (g2.indexOf("top") >= 0) {
        if ((r3 = p2 + f2 - s2) > 0) {
          var v2 = t2.css("top"), m2 = parseInt(v2.toString(), 10) - r3;
          m2 < 0 && (m2 = 0), t2.css("top", "".concat(m2, "px"));
        }
      }
      if (g2.indexOf("bottom") >= 0 && l2 < 0) {
        var y2 = t2.css("bottom"), b2 = parseInt(y2.toString(), 10) - Math.abs(l2);
        t2.css("bottom", "".concat(b2, "px"));
      }
      if (g2.indexOf("left") >= 0) {
        if ((r3 = h2 + d2 - a2) > 0) {
          var E2 = t2.css("left"), C2 = parseInt(E2.toString(), 10) - r3;
          C2 < 0 && (C2 = 0), t2.css("left", "".concat(C2, "px"));
        }
      }
      if (g2.indexOf("right") >= 0 && c3 < 0) {
        var w2 = t2.css("right"), D2 = parseInt(w2.toString(), 10) - Math.abs(c3);
        t2.css("right", "".concat(D2, "px"));
      }
    }
  });
}
var iE, aE, sE = function(e10) {
  var t2 = e10;
  return t2.select = function(e11) {
    Wg.select(t2, e11);
  }, t2.deselect = function() {
    var n2 = t2.selection, r3 = zy.findDocumentOrShadowRoot(t2).getSelection();
    r3 && r3.rangeCount > 0 && r3.removeAllRanges(), n2 && Wg.deselect(e10);
  }, t2.move = function(t3, n2) {
    void 0 === n2 && (n2 = false), t3 && (t3 < 0 || Wg.move(e10, { distance: t3, unit: "character", reverse: n2 }));
  }, t2.moveReverse = function(e11) {
    t2.move(e11, true);
  }, t2.restoreSelection = function() {
    var e11 = Zv.get(t2);
    null != e11 && (t2.focus(), Wg.select(t2, e11));
  }, t2.getSelectionPosition = function() {
    return nE(t2);
  }, t2.getNodePosition = function(e11) {
    return rE(t2, e11);
  }, t2.isSelectedAll = function() {
    var e11 = t2.selection;
    if (null == e11) return false;
    var n2 = iv(yg.edges(e11), 2), r3 = n2[0], o2 = n2[1], i2 = iv(eg.edges(t2, []), 2), a2 = i2[0], s2 = i2[1];
    return !(!hg.equals(r3, a2) || !hg.equals(o2, s2));
  }, t2.selectAll = function() {
    var e11 = eg.start(t2, []), n2 = eg.end(t2, []);
    Wg.select(t2, { anchor: e11, focus: n2 });
  }, t2;
};
var uE = function() {
  if (aE) return iE;
  aE = 1;
  var e10 = /^\s+|\s+$/g, t2 = /^[-+]0x[0-9a-f]+$/i, n2 = /^0b[01]+$/i, r3 = /^0o[0-7]+$/i, o2 = parseInt, i2 = "object" == typeof y && y && y.Object === Object && y, a2 = "object" == typeof self && self && self.Object === Object && self, s2 = i2 || a2 || Function("return this")(), u2 = Object.prototype.toString, l2 = Math.max, c3 = Math.min, d2 = function() {
    return s2.Date.now();
  };
  function f2(e11) {
    var t3 = typeof e11;
    return !!e11 && ("object" == t3 || "function" == t3);
  }
  function p2(i3) {
    if ("number" == typeof i3) return i3;
    if (function(e11) {
      return "symbol" == typeof e11 || /* @__PURE__ */ function(e12) {
        return !!e12 && "object" == typeof e12;
      }(e11) && "[object Symbol]" == u2.call(e11);
    }(i3)) return NaN;
    if (f2(i3)) {
      var a3 = "function" == typeof i3.valueOf ? i3.valueOf() : i3;
      i3 = f2(a3) ? a3 + "" : a3;
    }
    if ("string" != typeof i3) return 0 === i3 ? i3 : +i3;
    i3 = i3.replace(e10, "");
    var s3 = n2.test(i3);
    return s3 || r3.test(i3) ? o2(i3.slice(2), s3 ? 2 : 8) : t2.test(i3) ? NaN : +i3;
  }
  return iE = function(e11, t3, n3) {
    var r4, o3, i3, a3, s3, u3, h2 = 0, g2 = false, v2 = false, m2 = true;
    if ("function" != typeof e11) throw new TypeError("Expected a function");
    function y2(t4) {
      var n4 = r4, i4 = o3;
      return r4 = o3 = void 0, h2 = t4, a3 = e11.apply(i4, n4);
    }
    function b2(e12) {
      var n4 = e12 - u3;
      return void 0 === u3 || n4 >= t3 || n4 < 0 || v2 && e12 - h2 >= i3;
    }
    function E2() {
      var e12 = d2();
      if (b2(e12)) return C2(e12);
      s3 = setTimeout(E2, function(e13) {
        var n4 = t3 - (e13 - u3);
        return v2 ? c3(n4, i3 - (e13 - h2)) : n4;
      }(e12));
    }
    function C2(e12) {
      return s3 = void 0, m2 && r4 ? y2(e12) : (r4 = o3 = void 0, a3);
    }
    function w2() {
      var e12 = d2(), n4 = b2(e12);
      if (r4 = arguments, o3 = this, u3 = e12, n4) {
        if (void 0 === s3) return function(e13) {
          return h2 = e13, s3 = setTimeout(E2, t3), g2 ? y2(e13) : a3;
        }(u3);
        if (v2) return s3 = setTimeout(E2, t3), y2(u3);
      }
      return void 0 === s3 && (s3 = setTimeout(E2, t3)), a3;
    }
    return t3 = p2(t3) || 0, f2(n3) && (g2 = !!n3.leading, i3 = (v2 = "maxWait" in n3) ? l2(p2(n3.maxWait) || 0, t3) : i3, m2 = "trailing" in n3 ? !!n3.trailing : m2), w2.cancel = function() {
      void 0 !== s3 && clearTimeout(s3), h2 = 0, r4 = u3 = o3 = s3 = void 0;
    }, w2.flush = function() {
      return void 0 === s3 ? a3 : C2(d2());
    }, w2;
  }, iE;
}(), lE = b(uE);
const cE = (e10) => "string" == typeof e10, dE = () => {
  let e10, t2;
  const n2 = new Promise((n3, r3) => {
    e10 = n3, t2 = r3;
  });
  return n2.resolve = e10, n2.reject = t2, n2;
}, fE = (e10) => null == e10 ? "" : "" + e10, pE = /###/g, hE = (e10) => e10 && e10.indexOf("###") > -1 ? e10.replace(pE, ".") : e10, gE = (e10) => !e10 || cE(e10), vE = (e10, t2, n2) => {
  const r3 = cE(t2) ? t2.split(".") : t2;
  let o2 = 0;
  for (; o2 < r3.length - 1; ) {
    if (gE(e10)) return {};
    const t3 = hE(r3[o2]);
    !e10[t3] && n2 && (e10[t3] = new n2()), e10 = Object.prototype.hasOwnProperty.call(e10, t3) ? e10[t3] : {}, ++o2;
  }
  return gE(e10) ? {} : { obj: e10, k: hE(r3[o2]) };
}, mE = (e10, t2, n2) => {
  const { obj: r3, k: o2 } = vE(e10, t2, Object);
  if (void 0 !== r3 || 1 === t2.length) return void (r3[o2] = n2);
  let i2 = t2[t2.length - 1], a2 = t2.slice(0, t2.length - 1), s2 = vE(e10, a2, Object);
  for (; void 0 === s2.obj && a2.length; ) i2 = `${a2[a2.length - 1]}.${i2}`, a2 = a2.slice(0, a2.length - 1), s2 = vE(e10, a2, Object), s2 && s2.obj && void 0 !== s2.obj[`${s2.k}.${i2}`] && (s2.obj = void 0);
  s2.obj[`${s2.k}.${i2}`] = n2;
}, yE = (e10, t2) => {
  const { obj: n2, k: r3 } = vE(e10, t2);
  if (n2) return n2[r3];
}, bE = (e10, t2, n2) => {
  for (const r3 in t2) "__proto__" !== r3 && "constructor" !== r3 && (r3 in e10 ? cE(e10[r3]) || e10[r3] instanceof String || cE(t2[r3]) || t2[r3] instanceof String ? n2 && (e10[r3] = t2[r3]) : bE(e10[r3], t2[r3], n2) : e10[r3] = t2[r3]);
  return e10;
}, EE = (e10) => e10.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var CE = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;" };
const wE = (e10) => cE(e10) ? e10.replace(/[&<>"'\/]/g, (e11) => CE[e11]) : e10;
const DE = [" ", ",", "?", "!", ";"], SE = new class {
  constructor(e10) {
    this.capacity = e10, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e10) {
    const t2 = this.regExpMap.get(e10);
    if (void 0 !== t2) return t2;
    const n2 = new RegExp(e10);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e10, n2), this.regExpQueue.push(e10), n2;
  }
}(20), AE = function(e10, t2) {
  let n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
  if (!e10) return;
  if (e10[t2]) return e10[t2];
  const r3 = t2.split(n2);
  let o2 = e10;
  for (let e11 = 0; e11 < r3.length; ) {
    if (!o2 || "object" != typeof o2) return;
    let t3, i2 = "";
    for (let a2 = e11; a2 < r3.length; ++a2) if (a2 !== e11 && (i2 += n2), i2 += r3[a2], t3 = o2[i2], void 0 !== t3) {
      if (["string", "number", "boolean"].indexOf(typeof t3) > -1 && a2 < r3.length - 1) continue;
      e11 += a2 - e11 + 1;
      break;
    }
    o2 = t3;
  }
  return o2;
}, xE = (e10) => e10 && e10.replace("_", "-"), OE = { type: "logger", log(e10) {
  this.output("log", e10);
}, warn(e10) {
  this.output("warn", e10);
}, error(e10) {
  this.output("error", e10);
}, output(e10, t2) {
  console && console[e10] && console[e10].apply(console, t2);
} };
class NE {
  constructor(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    this.init(e10, t2);
  }
  init(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    this.prefix = t2.prefix || "i18next:", this.logger = e10 || OE, this.options = t2, this.debug = t2.debug;
  }
  log() {
    for (var e10 = arguments.length, t2 = new Array(e10), n2 = 0; n2 < e10; n2++) t2[n2] = arguments[n2];
    return this.forward(t2, "log", "", true);
  }
  warn() {
    for (var e10 = arguments.length, t2 = new Array(e10), n2 = 0; n2 < e10; n2++) t2[n2] = arguments[n2];
    return this.forward(t2, "warn", "", true);
  }
  error() {
    for (var e10 = arguments.length, t2 = new Array(e10), n2 = 0; n2 < e10; n2++) t2[n2] = arguments[n2];
    return this.forward(t2, "error", "");
  }
  deprecate() {
    for (var e10 = arguments.length, t2 = new Array(e10), n2 = 0; n2 < e10; n2++) t2[n2] = arguments[n2];
    return this.forward(t2, "warn", "WARNING DEPRECATED: ", true);
  }
  forward(e10, t2, n2, r3) {
    return r3 && !this.debug ? null : (cE(e10[0]) && (e10[0] = `${n2}${this.prefix} ${e10[0]}`), this.logger[t2](e10));
  }
  create(e10) {
    return new NE(this.logger, { prefix: `${this.prefix}:${e10}:`, ...this.options });
  }
  clone(e10) {
    return (e10 = e10 || this.options).prefix = e10.prefix || this.prefix, new NE(this.logger, e10);
  }
}
var BE = new NE();
class TE {
  constructor() {
    this.observers = {};
  }
  on(e10, t2) {
    return e10.split(" ").forEach((e11) => {
      this.observers[e11] || (this.observers[e11] = /* @__PURE__ */ new Map());
      const n2 = this.observers[e11].get(t2) || 0;
      this.observers[e11].set(t2, n2 + 1);
    }), this;
  }
  off(e10, t2) {
    this.observers[e10] && (t2 ? this.observers[e10].delete(t2) : delete this.observers[e10]);
  }
  emit(e10) {
    for (var t2 = arguments.length, n2 = new Array(t2 > 1 ? t2 - 1 : 0), r3 = 1; r3 < t2; r3++) n2[r3 - 1] = arguments[r3];
    if (this.observers[e10]) {
      Array.from(this.observers[e10].entries()).forEach((e11) => {
        let [t3, r4] = e11;
        for (let e12 = 0; e12 < r4; e12++) t3(...n2);
      });
    }
    if (this.observers["*"]) {
      Array.from(this.observers["*"].entries()).forEach((t3) => {
        let [r4, o2] = t3;
        for (let t4 = 0; t4 < o2; t4++) r4.apply(r4, [e10, ...n2]);
      });
    }
  }
}
class kE extends TE {
  constructor(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { ns: ["translation"], defaultNS: "translation" };
    super(), this.data = e10 || {}, this.options = t2, void 0 === this.options.keySeparator && (this.options.keySeparator = "."), void 0 === this.options.ignoreJSONStructure && (this.options.ignoreJSONStructure = true);
  }
  addNamespaces(e10) {
    this.options.ns.indexOf(e10) < 0 && this.options.ns.push(e10);
  }
  removeNamespaces(e10) {
    const t2 = this.options.ns.indexOf(e10);
    t2 > -1 && this.options.ns.splice(t2, 1);
  }
  getResource(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    const o2 = void 0 !== r3.keySeparator ? r3.keySeparator : this.options.keySeparator, i2 = void 0 !== r3.ignoreJSONStructure ? r3.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let a2;
    e10.indexOf(".") > -1 ? a2 = e10.split(".") : (a2 = [e10, t2], n2 && (Array.isArray(n2) ? a2.push(...n2) : cE(n2) && o2 ? a2.push(...n2.split(o2)) : a2.push(n2)));
    const s2 = yE(this.data, a2);
    return !s2 && !t2 && !n2 && e10.indexOf(".") > -1 && (e10 = a2[0], t2 = a2[1], n2 = a2.slice(2).join(".")), !s2 && i2 && cE(n2) ? AE(this.data && this.data[e10] && this.data[e10][t2], n2, o2) : s2;
  }
  addResource(e10, t2, n2, r3) {
    let o2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : { silent: false };
    const i2 = void 0 !== o2.keySeparator ? o2.keySeparator : this.options.keySeparator;
    let a2 = [e10, t2];
    n2 && (a2 = a2.concat(i2 ? n2.split(i2) : n2)), e10.indexOf(".") > -1 && (a2 = e10.split("."), r3 = t2, t2 = a2[1]), this.addNamespaces(t2), mE(this.data, a2, r3), o2.silent || this.emit("added", e10, t2, n2, r3);
  }
  addResources(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : { silent: false };
    for (const r4 in n2) (cE(n2[r4]) || Array.isArray(n2[r4])) && this.addResource(e10, t2, r4, n2[r4], { silent: true });
    r3.silent || this.emit("added", e10, t2, n2);
  }
  addResourceBundle(e10, t2, n2, r3, o2) {
    let i2 = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : { silent: false, skipCopy: false }, a2 = [e10, t2];
    e10.indexOf(".") > -1 && (a2 = e10.split("."), r3 = n2, n2 = t2, t2 = a2[1]), this.addNamespaces(t2);
    let s2 = yE(this.data, a2) || {};
    i2.skipCopy || (n2 = JSON.parse(JSON.stringify(n2))), r3 ? bE(s2, n2, o2) : s2 = { ...s2, ...n2 }, mE(this.data, a2, s2), i2.silent || this.emit("added", e10, t2, n2);
  }
  removeResourceBundle(e10, t2) {
    this.hasResourceBundle(e10, t2) && delete this.data[e10][t2], this.removeNamespaces(t2), this.emit("removed", e10, t2);
  }
  hasResourceBundle(e10, t2) {
    return void 0 !== this.getResource(e10, t2);
  }
  getResourceBundle(e10, t2) {
    return t2 || (t2 = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? { ...this.getResource(e10, t2) } : this.getResource(e10, t2);
  }
  getDataByLanguage(e10) {
    return this.data[e10];
  }
  hasLanguageSomeTranslations(e10) {
    const t2 = this.getDataByLanguage(e10);
    return !!(t2 && Object.keys(t2) || []).find((e11) => t2[e11] && Object.keys(t2[e11]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var FE = { processors: {}, addPostProcessor(e10) {
  this.processors[e10.name] = e10;
}, handle(e10, t2, n2, r3, o2) {
  return e10.forEach((e11) => {
    this.processors[e11] && (t2 = this.processors[e11].process(t2, n2, r3, o2));
  }), t2;
} };
const IE = {};
class PE extends TE {
  constructor(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    super(), ((e11, t3, n2) => {
      e11.forEach((e12) => {
        t3[e12] && (n2[e12] = t3[e12]);
      });
    })(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e10, this), this.options = t2, void 0 === this.options.keySeparator && (this.options.keySeparator = "."), this.logger = BE.create("translator");
  }
  changeLanguage(e10) {
    e10 && (this.language = e10);
  }
  exists(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { interpolation: {} };
    if (null == e10) return false;
    const n2 = this.resolve(e10, t2);
    return n2 && void 0 !== n2.res;
  }
  extractFromKey(e10, t2) {
    let n2 = void 0 !== t2.nsSeparator ? t2.nsSeparator : this.options.nsSeparator;
    void 0 === n2 && (n2 = ":");
    const r3 = void 0 !== t2.keySeparator ? t2.keySeparator : this.options.keySeparator;
    let o2 = t2.ns || this.options.defaultNS || [];
    const i2 = n2 && e10.indexOf(n2) > -1, a2 = !(this.options.userDefinedKeySeparator || t2.keySeparator || this.options.userDefinedNsSeparator || t2.nsSeparator || ((e11, t3, n3) => {
      t3 = t3 || "", n3 = n3 || "";
      const r4 = DE.filter((e12) => t3.indexOf(e12) < 0 && n3.indexOf(e12) < 0);
      if (0 === r4.length) return true;
      const o3 = SE.getRegExp(`(${r4.map((e12) => "?" === e12 ? "\\?" : e12).join("|")})`);
      let i3 = !o3.test(e11);
      if (!i3) {
        const t4 = e11.indexOf(n3);
        t4 > 0 && !o3.test(e11.substring(0, t4)) && (i3 = true);
      }
      return i3;
    })(e10, n2, r3));
    if (i2 && !a2) {
      const t3 = e10.match(this.interpolator.nestingRegexp);
      if (t3 && t3.length > 0) return { key: e10, namespaces: cE(o2) ? [o2] : o2 };
      const i3 = e10.split(n2);
      (n2 !== r3 || n2 === r3 && this.options.ns.indexOf(i3[0]) > -1) && (o2 = i3.shift()), e10 = i3.join(r3);
    }
    return { key: e10, namespaces: cE(o2) ? [o2] : o2 };
  }
  translate(e10, t2, n2) {
    if ("object" != typeof t2 && this.options.overloadTranslationOptionHandler && (t2 = this.options.overloadTranslationOptionHandler(arguments)), "object" == typeof t2 && (t2 = { ...t2 }), t2 || (t2 = {}), null == e10) return "";
    Array.isArray(e10) || (e10 = [String(e10)]);
    const r3 = void 0 !== t2.returnDetails ? t2.returnDetails : this.options.returnDetails, o2 = void 0 !== t2.keySeparator ? t2.keySeparator : this.options.keySeparator, { key: i2, namespaces: a2 } = this.extractFromKey(e10[e10.length - 1], t2), s2 = a2[a2.length - 1], u2 = t2.lng || this.language, l2 = t2.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u2 && "cimode" === u2.toLowerCase()) {
      if (l2) {
        const e11 = t2.nsSeparator || this.options.nsSeparator;
        return r3 ? { res: `${s2}${e11}${i2}`, usedKey: i2, exactUsedKey: i2, usedLng: u2, usedNS: s2, usedParams: this.getUsedParamsDetails(t2) } : `${s2}${e11}${i2}`;
      }
      return r3 ? { res: i2, usedKey: i2, exactUsedKey: i2, usedLng: u2, usedNS: s2, usedParams: this.getUsedParamsDetails(t2) } : i2;
    }
    const c3 = this.resolve(e10, t2);
    let d2 = c3 && c3.res;
    const f2 = c3 && c3.usedKey || i2, p2 = c3 && c3.exactUsedKey || i2, h2 = Object.prototype.toString.apply(d2), g2 = void 0 !== t2.joinArrays ? t2.joinArrays : this.options.joinArrays, v2 = !this.i18nFormat || this.i18nFormat.handleAsObject, m2 = !cE(d2) && "boolean" != typeof d2 && "number" != typeof d2;
    if (!(v2 && d2 && m2 && ["[object Number]", "[object Function]", "[object RegExp]"].indexOf(h2) < 0) || cE(g2) && Array.isArray(d2)) if (v2 && cE(g2) && Array.isArray(d2)) d2 = d2.join(g2), d2 && (d2 = this.extendTranslation(d2, e10, t2, n2));
    else {
      let r4 = false, a3 = false;
      const l3 = void 0 !== t2.count && !cE(t2.count), f3 = PE.hasDefaultValue(t2), p3 = l3 ? this.pluralResolver.getSuffix(u2, t2.count, t2) : "", h3 = t2.ordinal && l3 ? this.pluralResolver.getSuffix(u2, t2.count, { ordinal: false }) : "", g3 = l3 && !t2.ordinal && 0 === t2.count && this.pluralResolver.shouldUseIntlApi(), v6 = g3 && t2[`defaultValue${this.options.pluralSeparator}zero`] || t2[`defaultValue${p3}`] || t2[`defaultValue${h3}`] || t2.defaultValue;
      !this.isValidLookup(d2) && f3 && (r4 = true, d2 = v6), this.isValidLookup(d2) || (a3 = true, d2 = i2);
      const m3 = (t2.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && a3 ? void 0 : d2, y2 = f3 && v6 !== d2 && this.options.updateMissing;
      if (a3 || r4 || y2) {
        if (this.logger.log(y2 ? "updateKey" : "missingKey", u2, s2, i2, y2 ? v6 : d2), o2) {
          const e12 = this.resolve(i2, { ...t2, keySeparator: false });
          e12 && e12.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let e11 = [];
        const n3 = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t2.lng || this.language);
        if ("fallback" === this.options.saveMissingTo && n3 && n3[0]) for (let t3 = 0; t3 < n3.length; t3++) e11.push(n3[t3]);
        else "all" === this.options.saveMissingTo ? e11 = this.languageUtils.toResolveHierarchy(t2.lng || this.language) : e11.push(t2.lng || this.language);
        const r5 = (e12, n4, r6) => {
          const o3 = f3 && r6 !== d2 ? r6 : m3;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(e12, s2, n4, o3, y2, t2) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(e12, s2, n4, o3, y2, t2), this.emit("missingKey", e12, s2, n4, d2);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && l3 ? e11.forEach((e12) => {
          const n4 = this.pluralResolver.getSuffixes(e12, t2);
          g3 && t2[`defaultValue${this.options.pluralSeparator}zero`] && n4.indexOf(`${this.options.pluralSeparator}zero`) < 0 && n4.push(`${this.options.pluralSeparator}zero`), n4.forEach((n5) => {
            r5([e12], i2 + n5, t2[`defaultValue${n5}`] || v6);
          });
        }) : r5(e11, i2, v6));
      }
      d2 = this.extendTranslation(d2, e10, t2, c3, n2), a3 && d2 === i2 && this.options.appendNamespaceToMissingKey && (d2 = `${s2}:${i2}`), (a3 || r4) && this.options.parseMissingKeyHandler && (d2 = "v1" !== this.options.compatibilityAPI ? this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${s2}:${i2}` : i2, r4 ? d2 : void 0) : this.options.parseMissingKeyHandler(d2));
    }
    else {
      if (!t2.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const e11 = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f2, d2, { ...t2, ns: a2 }) : `key '${i2} (${this.language})' returned an object instead of string.`;
        return r3 ? (c3.res = e11, c3.usedParams = this.getUsedParamsDetails(t2), c3) : e11;
      }
      if (o2) {
        const e11 = Array.isArray(d2), n3 = e11 ? [] : {}, r4 = e11 ? p2 : f2;
        for (const e12 in d2) if (Object.prototype.hasOwnProperty.call(d2, e12)) {
          const i3 = `${r4}${o2}${e12}`;
          n3[e12] = this.translate(i3, { ...t2, joinArrays: false, ns: a2 }), n3[e12] === i3 && (n3[e12] = d2[e12]);
        }
        d2 = n3;
      }
    }
    return r3 ? (c3.res = d2, c3.usedParams = this.getUsedParamsDetails(t2), c3) : d2;
  }
  extendTranslation(e10, t2, n2, r3, o2) {
    var i2 = this;
    if (this.i18nFormat && this.i18nFormat.parse) e10 = this.i18nFormat.parse(e10, { ...this.options.interpolation.defaultVariables, ...n2 }, n2.lng || this.language || r3.usedLng, r3.usedNS, r3.usedKey, { resolved: r3 });
    else if (!n2.skipInterpolation) {
      n2.interpolation && this.interpolator.init({ ...n2, interpolation: { ...this.options.interpolation, ...n2.interpolation } });
      const a3 = cE(e10) && (n2 && n2.interpolation && void 0 !== n2.interpolation.skipOnVariables ? n2.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let s3;
      if (a3) {
        const t3 = e10.match(this.interpolator.nestingRegexp);
        s3 = t3 && t3.length;
      }
      let u2 = n2.replace && !cE(n2.replace) ? n2.replace : n2;
      if (this.options.interpolation.defaultVariables && (u2 = { ...this.options.interpolation.defaultVariables, ...u2 }), e10 = this.interpolator.interpolate(e10, u2, n2.lng || this.language || r3.usedLng, n2), a3) {
        const t3 = e10.match(this.interpolator.nestingRegexp);
        s3 < (t3 && t3.length) && (n2.nest = false);
      }
      !n2.lng && "v1" !== this.options.compatibilityAPI && r3 && r3.res && (n2.lng = this.language || r3.usedLng), false !== n2.nest && (e10 = this.interpolator.nest(e10, function() {
        for (var e11 = arguments.length, r4 = new Array(e11), a4 = 0; a4 < e11; a4++) r4[a4] = arguments[a4];
        return o2 && o2[0] === r4[0] && !n2.context ? (i2.logger.warn(`It seems you are nesting recursively key: ${r4[0]} in key: ${t2[0]}`), null) : i2.translate(...r4, t2);
      }, n2)), n2.interpolation && this.interpolator.reset();
    }
    const a2 = n2.postProcess || this.options.postProcess, s2 = cE(a2) ? [a2] : a2;
    return null != e10 && s2 && s2.length && false !== n2.applyPostProcessor && (e10 = FE.handle(s2, e10, t2, this.options && this.options.postProcessPassResolved ? { i18nResolved: { ...r3, usedParams: this.getUsedParamsDetails(n2) }, ...n2 } : n2, this)), e10;
  }
  resolve(e10) {
    let t2, n2, r3, o2, i2, a2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return cE(e10) && (e10 = [e10]), e10.forEach((e11) => {
      if (this.isValidLookup(t2)) return;
      const s2 = this.extractFromKey(e11, a2), u2 = s2.key;
      n2 = u2;
      let l2 = s2.namespaces;
      this.options.fallbackNS && (l2 = l2.concat(this.options.fallbackNS));
      const c3 = void 0 !== a2.count && !cE(a2.count), d2 = c3 && !a2.ordinal && 0 === a2.count && this.pluralResolver.shouldUseIntlApi(), f2 = void 0 !== a2.context && (cE(a2.context) || "number" == typeof a2.context) && "" !== a2.context, p2 = a2.lngs ? a2.lngs : this.languageUtils.toResolveHierarchy(a2.lng || this.language, a2.fallbackLng);
      l2.forEach((e12) => {
        this.isValidLookup(t2) || (i2 = e12, !IE[`${p2[0]}-${e12}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(i2) && (IE[`${p2[0]}-${e12}`] = true, this.logger.warn(`key "${n2}" for languages "${p2.join(", ")}" won't get resolved as namespace "${i2}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), p2.forEach((n3) => {
          if (this.isValidLookup(t2)) return;
          o2 = n3;
          const i3 = [u2];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(i3, u2, n3, e12, a2);
          else {
            let e13;
            c3 && (e13 = this.pluralResolver.getSuffix(n3, a2.count, a2));
            const t3 = `${this.options.pluralSeparator}zero`, r4 = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (c3 && (i3.push(u2 + e13), a2.ordinal && 0 === e13.indexOf(r4) && i3.push(u2 + e13.replace(r4, this.options.pluralSeparator)), d2 && i3.push(u2 + t3)), f2) {
              const n4 = `${u2}${this.options.contextSeparator}${a2.context}`;
              i3.push(n4), c3 && (i3.push(n4 + e13), a2.ordinal && 0 === e13.indexOf(r4) && i3.push(n4 + e13.replace(r4, this.options.pluralSeparator)), d2 && i3.push(n4 + t3));
            }
          }
          let s3;
          for (; s3 = i3.pop(); ) this.isValidLookup(t2) || (r3 = s3, t2 = this.getResource(n3, e12, s3, a2));
        }));
      });
    }), { res: t2, usedKey: n2, exactUsedKey: r3, usedLng: o2, usedNS: i2 };
  }
  isValidLookup(e10) {
    return !(void 0 === e10 || !this.options.returnNull && null === e10 || !this.options.returnEmptyString && "" === e10);
  }
  getResource(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e10, t2, n2, r3) : this.resourceStore.getResource(e10, t2, n2, r3);
  }
  getUsedParamsDetails() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const t2 = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n2 = e10.replace && !cE(e10.replace);
    let r3 = n2 ? e10.replace : e10;
    if (n2 && void 0 !== e10.count && (r3.count = e10.count), this.options.interpolation.defaultVariables && (r3 = { ...this.options.interpolation.defaultVariables, ...r3 }), !n2) {
      r3 = { ...r3 };
      for (const e11 of t2) delete r3[e11];
    }
    return r3;
  }
  static hasDefaultValue(e10) {
    const t2 = "defaultValue";
    for (const n2 in e10) if (Object.prototype.hasOwnProperty.call(e10, n2) && t2 === n2.substring(0, 12) && void 0 !== e10[n2]) return true;
    return false;
  }
}
const _E = (e10) => e10.charAt(0).toUpperCase() + e10.slice(1);
class RE {
  constructor(e10) {
    this.options = e10, this.supportedLngs = this.options.supportedLngs || false, this.logger = BE.create("languageUtils");
  }
  getScriptPartFromCode(e10) {
    if (!(e10 = xE(e10)) || e10.indexOf("-") < 0) return null;
    const t2 = e10.split("-");
    return 2 === t2.length ? null : (t2.pop(), "x" === t2[t2.length - 1].toLowerCase() ? null : this.formatLanguageCode(t2.join("-")));
  }
  getLanguagePartFromCode(e10) {
    if (!(e10 = xE(e10)) || e10.indexOf("-") < 0) return e10;
    const t2 = e10.split("-");
    return this.formatLanguageCode(t2[0]);
  }
  formatLanguageCode(e10) {
    if (cE(e10) && e10.indexOf("-") > -1) {
      if ("undefined" != typeof Intl && void 0 !== Intl.getCanonicalLocales) try {
        let t3 = Intl.getCanonicalLocales(e10)[0];
        if (t3 && this.options.lowerCaseLng && (t3 = t3.toLowerCase()), t3) return t3;
      } catch (e11) {
      }
      const t2 = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n2 = e10.split("-");
      return this.options.lowerCaseLng ? n2 = n2.map((e11) => e11.toLowerCase()) : 2 === n2.length ? (n2[0] = n2[0].toLowerCase(), n2[1] = n2[1].toUpperCase(), t2.indexOf(n2[1].toLowerCase()) > -1 && (n2[1] = _E(n2[1].toLowerCase()))) : 3 === n2.length && (n2[0] = n2[0].toLowerCase(), 2 === n2[1].length && (n2[1] = n2[1].toUpperCase()), "sgn" !== n2[0] && 2 === n2[2].length && (n2[2] = n2[2].toUpperCase()), t2.indexOf(n2[1].toLowerCase()) > -1 && (n2[1] = _E(n2[1].toLowerCase())), t2.indexOf(n2[2].toLowerCase()) > -1 && (n2[2] = _E(n2[2].toLowerCase()))), n2.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e10.toLowerCase() : e10;
  }
  isSupportedCode(e10) {
    return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e10 = this.getLanguagePartFromCode(e10)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e10) > -1;
  }
  getBestMatchFromCodes(e10) {
    if (!e10) return null;
    let t2;
    return e10.forEach((e11) => {
      if (t2) return;
      const n2 = this.formatLanguageCode(e11);
      this.options.supportedLngs && !this.isSupportedCode(n2) || (t2 = n2);
    }), !t2 && this.options.supportedLngs && e10.forEach((e11) => {
      if (t2) return;
      const n2 = this.getLanguagePartFromCode(e11);
      if (this.isSupportedCode(n2)) return t2 = n2;
      t2 = this.options.supportedLngs.find((e12) => e12 === n2 ? e12 : e12.indexOf("-") < 0 && n2.indexOf("-") < 0 ? void 0 : e12.indexOf("-") > 0 && n2.indexOf("-") < 0 && e12.substring(0, e12.indexOf("-")) === n2 || 0 === e12.indexOf(n2) && n2.length > 1 ? e12 : void 0);
    }), t2 || (t2 = this.getFallbackCodes(this.options.fallbackLng)[0]), t2;
  }
  getFallbackCodes(e10, t2) {
    if (!e10) return [];
    if ("function" == typeof e10 && (e10 = e10(t2)), cE(e10) && (e10 = [e10]), Array.isArray(e10)) return e10;
    if (!t2) return e10.default || [];
    let n2 = e10[t2];
    return n2 || (n2 = e10[this.getScriptPartFromCode(t2)]), n2 || (n2 = e10[this.formatLanguageCode(t2)]), n2 || (n2 = e10[this.getLanguagePartFromCode(t2)]), n2 || (n2 = e10.default), n2 || [];
  }
  toResolveHierarchy(e10, t2) {
    const n2 = this.getFallbackCodes(t2 || this.options.fallbackLng || [], e10), r3 = [], o2 = (e11) => {
      e11 && (this.isSupportedCode(e11) ? r3.push(e11) : this.logger.warn(`rejecting language code not found in supportedLngs: ${e11}`));
    };
    return cE(e10) && (e10.indexOf("-") > -1 || e10.indexOf("_") > -1) ? ("languageOnly" !== this.options.load && o2(this.formatLanguageCode(e10)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && o2(this.getScriptPartFromCode(e10)), "currentOnly" !== this.options.load && o2(this.getLanguagePartFromCode(e10))) : cE(e10) && o2(this.formatLanguageCode(e10)), n2.forEach((e11) => {
      r3.indexOf(e11) < 0 && o2(this.formatLanguageCode(e11));
    }), r3;
  }
}
let LE = [{ lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"], nr: [1, 2], fc: 1 }, { lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"], nr: [1, 2], fc: 2 }, { lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"], nr: [1], fc: 3 }, { lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"], nr: [1, 2, 5], fc: 4 }, { lngs: ["ar"], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ["cs", "sk"], nr: [1, 2, 5], fc: 6 }, { lngs: ["csb", "pl"], nr: [1, 2, 5], fc: 7 }, { lngs: ["cy"], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ["fr"], nr: [1, 2], fc: 9 }, { lngs: ["ga"], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ["gd"], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ["is"], nr: [1, 2], fc: 12 }, { lngs: ["jv"], nr: [0, 1], fc: 13 }, { lngs: ["kw"], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ["lt"], nr: [1, 2, 10], fc: 15 }, { lngs: ["lv"], nr: [1, 2, 0], fc: 16 }, { lngs: ["mk"], nr: [1, 2], fc: 17 }, { lngs: ["mnk"], nr: [0, 1, 2], fc: 18 }, { lngs: ["mt"], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ["or"], nr: [2, 1], fc: 2 }, { lngs: ["ro"], nr: [1, 2, 20], fc: 20 }, { lngs: ["sl"], nr: [5, 1, 2, 3], fc: 21 }, { lngs: ["he", "iw"], nr: [1, 2, 20, 21], fc: 22 }], ME = { 1: (e10) => Number(e10 > 1), 2: (e10) => Number(1 != e10), 3: (e10) => 0, 4: (e10) => Number(e10 % 10 == 1 && e10 % 100 != 11 ? 0 : e10 % 10 >= 2 && e10 % 10 <= 4 && (e10 % 100 < 10 || e10 % 100 >= 20) ? 1 : 2), 5: (e10) => Number(0 == e10 ? 0 : 1 == e10 ? 1 : 2 == e10 ? 2 : e10 % 100 >= 3 && e10 % 100 <= 10 ? 3 : e10 % 100 >= 11 ? 4 : 5), 6: (e10) => Number(1 == e10 ? 0 : e10 >= 2 && e10 <= 4 ? 1 : 2), 7: (e10) => Number(1 == e10 ? 0 : e10 % 10 >= 2 && e10 % 10 <= 4 && (e10 % 100 < 10 || e10 % 100 >= 20) ? 1 : 2), 8: (e10) => Number(1 == e10 ? 0 : 2 == e10 ? 1 : 8 != e10 && 11 != e10 ? 2 : 3), 9: (e10) => Number(e10 >= 2), 10: (e10) => Number(1 == e10 ? 0 : 2 == e10 ? 1 : e10 < 7 ? 2 : e10 < 11 ? 3 : 4), 11: (e10) => Number(1 == e10 || 11 == e10 ? 0 : 2 == e10 || 12 == e10 ? 1 : e10 > 2 && e10 < 20 ? 2 : 3), 12: (e10) => Number(e10 % 10 != 1 || e10 % 100 == 11), 13: (e10) => Number(0 !== e10), 14: (e10) => Number(1 == e10 ? 0 : 2 == e10 ? 1 : 3 == e10 ? 2 : 3), 15: (e10) => Number(e10 % 10 == 1 && e10 % 100 != 11 ? 0 : e10 % 10 >= 2 && (e10 % 100 < 10 || e10 % 100 >= 20) ? 1 : 2), 16: (e10) => Number(e10 % 10 == 1 && e10 % 100 != 11 ? 0 : 0 !== e10 ? 1 : 2), 17: (e10) => Number(1 == e10 || e10 % 10 == 1 && e10 % 100 != 11 ? 0 : 1), 18: (e10) => Number(0 == e10 ? 0 : 1 == e10 ? 1 : 2), 19: (e10) => Number(1 == e10 ? 0 : 0 == e10 || e10 % 100 > 1 && e10 % 100 < 11 ? 1 : e10 % 100 > 10 && e10 % 100 < 20 ? 2 : 3), 20: (e10) => Number(1 == e10 ? 0 : 0 == e10 || e10 % 100 > 0 && e10 % 100 < 20 ? 1 : 2), 21: (e10) => Number(e10 % 100 == 1 ? 1 : e10 % 100 == 2 ? 2 : e10 % 100 == 3 || e10 % 100 == 4 ? 3 : 0), 22: (e10) => Number(1 == e10 ? 0 : 2 == e10 ? 1 : (e10 < 0 || e10 > 10) && e10 % 10 == 0 ? 2 : 3) };
const jE = ["v1", "v2", "v3"], HE = ["v4"], zE = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 };
class $E {
  constructor(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    this.languageUtils = e10, this.options = t2, this.logger = BE.create("pluralResolver"), this.options.compatibilityJSON && !HE.includes(this.options.compatibilityJSON) || "undefined" != typeof Intl && Intl.PluralRules || (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = (() => {
      const e11 = {};
      return LE.forEach((t3) => {
        t3.lngs.forEach((n2) => {
          e11[n2] = { numbers: t3.nr, plurals: ME[t3.fc] };
        });
      }), e11;
    })(), this.pluralRulesCache = {};
  }
  addRule(e10, t2) {
    this.rules[e10] = t2;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n2 = xE("dev" === e10 ? "en" : e10), r3 = t2.ordinal ? "ordinal" : "cardinal", o2 = JSON.stringify({ cleanedCode: n2, type: r3 });
      if (o2 in this.pluralRulesCache) return this.pluralRulesCache[o2];
      let i2;
      try {
        i2 = new Intl.PluralRules(n2, { type: r3 });
      } catch (n3) {
        if (!e10.match(/-|_/)) return;
        const r4 = this.languageUtils.getLanguagePartFromCode(e10);
        i2 = this.getRule(r4, t2);
      }
      return this.pluralRulesCache[o2] = i2, i2;
    }
    return this.rules[e10] || this.rules[this.languageUtils.getLanguagePartFromCode(e10)];
  }
  needsPlural(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const n2 = this.getRule(e10, t2);
    return this.shouldUseIntlApi() ? n2 && n2.resolvedOptions().pluralCategories.length > 1 : n2 && n2.numbers.length > 1;
  }
  getPluralFormsOfKey(e10, t2) {
    let n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return this.getSuffixes(e10, n2).map((e11) => `${t2}${e11}`);
  }
  getSuffixes(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const n2 = this.getRule(e10, t2);
    return n2 ? this.shouldUseIntlApi() ? n2.resolvedOptions().pluralCategories.sort((e11, t3) => zE[e11] - zE[t3]).map((e11) => `${this.options.prepend}${t2.ordinal ? `ordinal${this.options.prepend}` : ""}${e11}`) : n2.numbers.map((n3) => this.getSuffix(e10, n3, t2)) : [];
  }
  getSuffix(e10, t2) {
    let n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    const r3 = this.getRule(e10, n2);
    return r3 ? this.shouldUseIntlApi() ? `${this.options.prepend}${n2.ordinal ? `ordinal${this.options.prepend}` : ""}${r3.select(t2)}` : this.getSuffixRetroCompatible(r3, t2) : (this.logger.warn(`no plural rule found for: ${e10}`), "");
  }
  getSuffixRetroCompatible(e10, t2) {
    const n2 = e10.noAbs ? e10.plurals(t2) : e10.plurals(Math.abs(t2));
    let r3 = e10.numbers[n2];
    this.options.simplifyPluralSuffix && 2 === e10.numbers.length && 1 === e10.numbers[0] && (2 === r3 ? r3 = "plural" : 1 === r3 && (r3 = ""));
    const o2 = () => this.options.prepend && r3.toString() ? this.options.prepend + r3.toString() : r3.toString();
    return "v1" === this.options.compatibilityJSON ? 1 === r3 ? "" : "number" == typeof r3 ? `_plural_${r3.toString()}` : o2() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === e10.numbers.length && 1 === e10.numbers[0] ? o2() : this.options.prepend && n2.toString() ? this.options.prepend + n2.toString() : n2.toString();
  }
  shouldUseIntlApi() {
    return !jE.includes(this.options.compatibilityJSON);
  }
}
const UE = function(e10, t2, n2) {
  let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".", o2 = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], i2 = ((e11, t3, n3) => {
    const r4 = yE(e11, n3);
    return void 0 !== r4 ? r4 : yE(t3, n3);
  })(e10, t2, n2);
  return !i2 && o2 && cE(n2) && (i2 = AE(e10, n2, r3), void 0 === i2 && (i2 = AE(t2, n2, r3))), i2;
}, VE = (e10) => e10.replace(/\$/g, "$$$$");
class WE {
  constructor() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    this.logger = BE.create("interpolator"), this.options = e10, this.format = e10.interpolation && e10.interpolation.format || ((e11) => e11), this.init(e10);
  }
  init() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    e10.interpolation || (e10.interpolation = { escapeValue: true });
    const { escape: t2, escapeValue: n2, useRawValueToEscape: r3, prefix: o2, prefixEscaped: i2, suffix: a2, suffixEscaped: s2, formatSeparator: u2, unescapeSuffix: l2, unescapePrefix: c3, nestingPrefix: d2, nestingPrefixEscaped: f2, nestingSuffix: p2, nestingSuffixEscaped: h2, nestingOptionsSeparator: g2, maxReplaces: v2, alwaysFormat: m2 } = e10.interpolation;
    this.escape = void 0 !== t2 ? t2 : wE, this.escapeValue = void 0 === n2 || n2, this.useRawValueToEscape = void 0 !== r3 && r3, this.prefix = o2 ? EE(o2) : i2 || "{{", this.suffix = a2 ? EE(a2) : s2 || "}}", this.formatSeparator = u2 || ",", this.unescapePrefix = l2 ? "" : c3 || "-", this.unescapeSuffix = this.unescapePrefix ? "" : l2 || "", this.nestingPrefix = d2 ? EE(d2) : f2 || EE("$t("), this.nestingSuffix = p2 ? EE(p2) : h2 || EE(")"), this.nestingOptionsSeparator = g2 || ",", this.maxReplaces = v2 || 1e3, this.alwaysFormat = void 0 !== m2 && m2, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e10 = (e11, t2) => e11 && e11.source === t2 ? (e11.lastIndex = 0, e11) : new RegExp(t2, "g");
    this.regexp = e10(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e10(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e10(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e10, t2, n2, r3) {
    let o2, i2, a2;
    const s2 = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u2 = (e11) => {
      if (e11.indexOf(this.formatSeparator) < 0) {
        const o4 = UE(t2, s2, e11, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(o4, void 0, n2, { ...r3, ...t2, interpolationkey: e11 }) : o4;
      }
      const o3 = e11.split(this.formatSeparator), i3 = o3.shift().trim(), a3 = o3.join(this.formatSeparator).trim();
      return this.format(UE(t2, s2, i3, this.options.keySeparator, this.options.ignoreJSONStructure), a3, n2, { ...r3, ...t2, interpolationkey: i3 });
    };
    this.resetRegExp();
    const l2 = r3 && r3.missingInterpolationHandler || this.options.missingInterpolationHandler, c3 = r3 && r3.interpolation && void 0 !== r3.interpolation.skipOnVariables ? r3.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables, d2 = [{ regex: this.regexpUnescape, safeValue: (e11) => VE(e11) }, { regex: this.regexp, safeValue: (e11) => this.escapeValue ? VE(this.escape(e11)) : VE(e11) }];
    return d2.forEach((t3) => {
      for (a2 = 0; o2 = t3.regex.exec(e10); ) {
        const n3 = o2[1].trim();
        if (i2 = u2(n3), void 0 === i2) if ("function" == typeof l2) {
          const t4 = l2(e10, o2, r3);
          i2 = cE(t4) ? t4 : "";
        } else if (r3 && Object.prototype.hasOwnProperty.call(r3, n3)) i2 = "";
        else {
          if (c3) {
            i2 = o2[0];
            continue;
          }
          this.logger.warn(`missed to pass in variable ${n3} for interpolating ${e10}`), i2 = "";
        }
        else cE(i2) || this.useRawValueToEscape || (i2 = fE(i2));
        const s3 = t3.safeValue(i2);
        if (e10 = e10.replace(o2[0], s3), c3 ? (t3.regex.lastIndex += i2.length, t3.regex.lastIndex -= o2[0].length) : t3.regex.lastIndex = 0, a2++, a2 >= this.maxReplaces) break;
      }
    }), e10;
  }
  nest(e10, t2) {
    let n2, r3, o2, i2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    const a2 = (e11, t3) => {
      const n3 = this.nestingOptionsSeparator;
      if (e11.indexOf(n3) < 0) return e11;
      const r4 = e11.split(new RegExp(`${n3}[ ]*{`));
      let i3 = `{${r4[1]}`;
      e11 = r4[0], i3 = this.interpolate(i3, o2);
      const a3 = i3.match(/'/g), s2 = i3.match(/"/g);
      (a3 && a3.length % 2 == 0 && !s2 || s2.length % 2 != 0) && (i3 = i3.replace(/'/g, '"'));
      try {
        o2 = JSON.parse(i3), t3 && (o2 = { ...t3, ...o2 });
      } catch (t4) {
        return this.logger.warn(`failed parsing options string in nesting for key ${e11}`, t4), `${e11}${n3}${i3}`;
      }
      return o2.defaultValue && o2.defaultValue.indexOf(this.prefix) > -1 && delete o2.defaultValue, e11;
    };
    for (; n2 = this.nestingRegexp.exec(e10); ) {
      let s2 = [];
      o2 = { ...i2 }, o2 = o2.replace && !cE(o2.replace) ? o2.replace : o2, o2.applyPostProcessor = false, delete o2.defaultValue;
      let u2 = false;
      if (-1 !== n2[0].indexOf(this.formatSeparator) && !/{.*}/.test(n2[1])) {
        const e11 = n2[1].split(this.formatSeparator).map((e12) => e12.trim());
        n2[1] = e11.shift(), s2 = e11, u2 = true;
      }
      if (r3 = t2(a2.call(this, n2[1].trim(), o2), o2), r3 && n2[0] === e10 && !cE(r3)) return r3;
      cE(r3) || (r3 = fE(r3)), r3 || (this.logger.warn(`missed to resolve ${n2[1]} for nesting ${e10}`), r3 = ""), u2 && (r3 = s2.reduce((e11, t3) => this.format(e11, t3, i2.lng, { ...i2, interpolationkey: n2[1].trim() }), r3.trim())), e10 = e10.replace(n2[0], r3), this.regexp.lastIndex = 0;
    }
    return e10;
  }
}
const GE = (e10) => {
  const t2 = {};
  return (n2, r3, o2) => {
    let i2 = o2;
    o2 && o2.interpolationkey && o2.formatParams && o2.formatParams[o2.interpolationkey] && o2[o2.interpolationkey] && (i2 = { ...i2, [o2.interpolationkey]: void 0 });
    const a2 = r3 + JSON.stringify(i2);
    let s2 = t2[a2];
    return s2 || (s2 = e10(xE(r3), o2), t2[a2] = s2), s2(n2);
  };
};
class qE {
  constructor() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    this.logger = BE.create("formatter"), this.options = e10, this.formats = { number: GE((e11, t2) => {
      const n2 = new Intl.NumberFormat(e11, { ...t2 });
      return (e12) => n2.format(e12);
    }), currency: GE((e11, t2) => {
      const n2 = new Intl.NumberFormat(e11, { ...t2, style: "currency" });
      return (e12) => n2.format(e12);
    }), datetime: GE((e11, t2) => {
      const n2 = new Intl.DateTimeFormat(e11, { ...t2 });
      return (e12) => n2.format(e12);
    }), relativetime: GE((e11, t2) => {
      const n2 = new Intl.RelativeTimeFormat(e11, { ...t2 });
      return (e12) => n2.format(e12, t2.range || "day");
    }), list: GE((e11, t2) => {
      const n2 = new Intl.ListFormat(e11, { ...t2 });
      return (e12) => n2.format(e12);
    }) }, this.init(e10);
  }
  init(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { interpolation: {} };
    this.formatSeparator = t2.interpolation.formatSeparator || ",";
  }
  add(e10, t2) {
    this.formats[e10.toLowerCase().trim()] = t2;
  }
  addCached(e10, t2) {
    this.formats[e10.toLowerCase().trim()] = GE(t2);
  }
  format(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    const o2 = t2.split(this.formatSeparator);
    if (o2.length > 1 && o2[0].indexOf("(") > 1 && o2[0].indexOf(")") < 0 && o2.find((e11) => e11.indexOf(")") > -1)) {
      const e11 = o2.findIndex((e12) => e12.indexOf(")") > -1);
      o2[0] = [o2[0], ...o2.splice(1, e11)].join(this.formatSeparator);
    }
    const i2 = o2.reduce((e11, t3) => {
      const { formatName: o3, formatOptions: i3 } = ((e12) => {
        let t4 = e12.toLowerCase().trim();
        const n3 = {};
        if (e12.indexOf("(") > -1) {
          const r4 = e12.split("(");
          t4 = r4[0].toLowerCase().trim();
          const o4 = r4[1].substring(0, r4[1].length - 1);
          "currency" === t4 && o4.indexOf(":") < 0 ? n3.currency || (n3.currency = o4.trim()) : "relativetime" === t4 && o4.indexOf(":") < 0 ? n3.range || (n3.range = o4.trim()) : o4.split(";").forEach((e13) => {
            if (e13) {
              const [t5, ...r5] = e13.split(":"), o5 = r5.join(":").trim().replace(/^'+|'+$/g, ""), i4 = t5.trim();
              n3[i4] || (n3[i4] = o5), "false" === o5 && (n3[i4] = false), "true" === o5 && (n3[i4] = true), isNaN(o5) || (n3[i4] = parseInt(o5, 10));
            }
          });
        }
        return { formatName: t4, formatOptions: n3 };
      })(t3);
      if (this.formats[o3]) {
        let t4 = e11;
        try {
          const a2 = r3 && r3.formatParams && r3.formatParams[r3.interpolationkey] || {}, s2 = a2.locale || a2.lng || r3.locale || r3.lng || n2;
          t4 = this.formats[o3](e11, s2, { ...i3, ...r3, ...a2 });
        } catch (e12) {
          this.logger.warn(e12);
        }
        return t4;
      }
      return this.logger.warn(`there was no format function for ${o3}`), e11;
    }, e10);
    return i2;
  }
}
class KE extends TE {
  constructor(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
    super(), this.backend = e10, this.store = t2, this.services = n2, this.languageUtils = n2.languageUtils, this.options = r3, this.logger = BE.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = r3.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = r3.maxRetries >= 0 ? r3.maxRetries : 5, this.retryTimeout = r3.retryTimeout >= 1 ? r3.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n2, r3.backend, r3);
  }
  queueLoad(e10, t2, n2, r3) {
    const o2 = {}, i2 = {}, a2 = {}, s2 = {};
    return e10.forEach((e11) => {
      let r4 = true;
      t2.forEach((t3) => {
        const a3 = `${e11}|${t3}`;
        !n2.reload && this.store.hasResourceBundle(e11, t3) ? this.state[a3] = 2 : this.state[a3] < 0 || (1 === this.state[a3] ? void 0 === i2[a3] && (i2[a3] = true) : (this.state[a3] = 1, r4 = false, void 0 === i2[a3] && (i2[a3] = true), void 0 === o2[a3] && (o2[a3] = true), void 0 === s2[t3] && (s2[t3] = true)));
      }), r4 || (a2[e11] = true);
    }), (Object.keys(o2).length || Object.keys(i2).length) && this.queue.push({ pending: i2, pendingCount: Object.keys(i2).length, loaded: {}, errors: [], callback: r3 }), { toLoad: Object.keys(o2), pending: Object.keys(i2), toLoadLanguages: Object.keys(a2), toLoadNamespaces: Object.keys(s2) };
  }
  loaded(e10, t2, n2) {
    const r3 = e10.split("|"), o2 = r3[0], i2 = r3[1];
    t2 && this.emit("failedLoading", o2, i2, t2), !t2 && n2 && this.store.addResourceBundle(o2, i2, n2, void 0, void 0, { skipCopy: true }), this.state[e10] = t2 ? -1 : 2, t2 && n2 && (this.state[e10] = 0);
    const a2 = {};
    this.queue.forEach((n3) => {
      ((e11, t3, n4) => {
        const { obj: r4, k: o3 } = vE(e11, t3, Object);
        r4[o3] = r4[o3] || [], r4[o3].push(n4);
      })(n3.loaded, [o2], i2), ((e11, t3) => {
        void 0 !== e11.pending[t3] && (delete e11.pending[t3], e11.pendingCount--);
      })(n3, e10), t2 && n3.errors.push(t2), 0 !== n3.pendingCount || n3.done || (Object.keys(n3.loaded).forEach((e11) => {
        a2[e11] || (a2[e11] = {});
        const t3 = n3.loaded[e11];
        t3.length && t3.forEach((t4) => {
          void 0 === a2[e11][t4] && (a2[e11][t4] = true);
        });
      }), n3.done = true, n3.errors.length ? n3.callback(n3.errors) : n3.callback());
    }), this.emit("loaded", a2), this.queue = this.queue.filter((e11) => !e11.done);
  }
  read(e10, t2, n2) {
    let r3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, o2 = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.retryTimeout, i2 = arguments.length > 5 ? arguments[5] : void 0;
    if (!e10.length) return i2(null, {});
    if (this.readingCalls >= this.maxParallelReads) return void this.waitingReads.push({ lng: e10, ns: t2, fcName: n2, tried: r3, wait: o2, callback: i2 });
    this.readingCalls++;
    const a2 = (a3, s3) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const e11 = this.waitingReads.shift();
        this.read(e11.lng, e11.ns, e11.fcName, e11.tried, e11.wait, e11.callback);
      }
      a3 && s3 && r3 < this.maxRetries ? setTimeout(() => {
        this.read.call(this, e10, t2, n2, r3 + 1, 2 * o2, i2);
      }, o2) : i2(a3, s3);
    }, s2 = this.backend[n2].bind(this.backend);
    if (2 !== s2.length) return s2(e10, t2, a2);
    try {
      const n3 = s2(e10, t2);
      n3 && "function" == typeof n3.then ? n3.then((e11) => a2(null, e11)).catch(a2) : a2(null, n3);
    } catch (e11) {
      a2(e11);
    }
  }
  prepareLoading(e10, t2) {
    let n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r3 = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), r3 && r3();
    cE(e10) && (e10 = this.languageUtils.toResolveHierarchy(e10)), cE(t2) && (t2 = [t2]);
    const o2 = this.queueLoad(e10, t2, n2, r3);
    if (!o2.toLoad.length) return o2.pending.length || r3(), null;
    o2.toLoad.forEach((e11) => {
      this.loadOne(e11);
    });
  }
  load(e10, t2, n2) {
    this.prepareLoading(e10, t2, {}, n2);
  }
  reload(e10, t2, n2) {
    this.prepareLoading(e10, t2, { reload: true }, n2);
  }
  loadOne(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
    const n2 = e10.split("|"), r3 = n2[0], o2 = n2[1];
    this.read(r3, o2, "read", void 0, void 0, (n3, i2) => {
      n3 && this.logger.warn(`${t2}loading namespace ${o2} for language ${r3} failed`, n3), !n3 && i2 && this.logger.log(`${t2}loaded namespace ${o2} for language ${r3}`, i2), this.loaded(e10, n3, i2);
    });
  }
  saveMissing(e10, t2, n2, r3, o2) {
    let i2 = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {}, a2 = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t2)) this.logger.warn(`did not save key "${n2}" as the namespace "${t2}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
    else if (null != n2 && "" !== n2) {
      if (this.backend && this.backend.create) {
        const s2 = { ...i2, isUpdate: o2 }, u2 = this.backend.create.bind(this.backend);
        if (u2.length < 6) try {
          let o3;
          o3 = 5 === u2.length ? u2(e10, t2, n2, r3, s2) : u2(e10, t2, n2, r3), o3 && "function" == typeof o3.then ? o3.then((e11) => a2(null, e11)).catch(a2) : a2(null, o3);
        } catch (e11) {
          a2(e11);
        }
        else u2(e10, t2, n2, r3, a2, s2);
      }
      e10 && e10[0] && this.store.addResource(e10[0], t2, n2, r3);
    }
  }
}
const YE = () => ({ debug: false, initImmediate: true, ns: ["translation"], defaultNS: ["translation"], fallbackLng: ["dev"], fallbackNS: false, supportedLngs: false, nonExplicitSupportedLngs: false, load: "all", preload: false, simplifyPluralSuffix: true, keySeparator: ".", nsSeparator: ":", pluralSeparator: "_", contextSeparator: "_", partialBundledLanguages: false, saveMissing: false, updateMissing: false, saveMissingTo: "fallback", saveMissingPlurals: true, missingKeyHandler: false, missingInterpolationHandler: false, postProcess: false, postProcessPassResolved: false, returnNull: false, returnEmptyString: true, returnObjects: false, joinArrays: false, returnedObjectHandler: false, parseMissingKeyHandler: false, appendNamespaceToMissingKey: false, appendNamespaceToCIMode: false, overloadTranslationOptionHandler: (e10) => {
  let t2 = {};
  if ("object" == typeof e10[1] && (t2 = e10[1]), cE(e10[1]) && (t2.defaultValue = e10[1]), cE(e10[2]) && (t2.tDescription = e10[2]), "object" == typeof e10[2] || "object" == typeof e10[3]) {
    const n2 = e10[3] || e10[2];
    Object.keys(n2).forEach((e11) => {
      t2[e11] = n2[e11];
    });
  }
  return t2;
}, interpolation: { escapeValue: true, format: (e10) => e10, prefix: "{{", suffix: "}}", formatSeparator: ",", unescapePrefix: "-", nestingPrefix: "$t(", nestingSuffix: ")", nestingOptionsSeparator: ",", maxReplaces: 1e3, skipOnVariables: true } }), XE = (e10) => (cE(e10.ns) && (e10.ns = [e10.ns]), cE(e10.fallbackLng) && (e10.fallbackLng = [e10.fallbackLng]), cE(e10.fallbackNS) && (e10.fallbackNS = [e10.fallbackNS]), e10.supportedLngs && e10.supportedLngs.indexOf("cimode") < 0 && (e10.supportedLngs = e10.supportedLngs.concat(["cimode"])), e10), ZE = () => {
};
class JE extends TE {
  constructor() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t2 = arguments.length > 1 ? arguments[1] : void 0;
    var n2;
    if (super(), this.options = XE(e10), this.services = {}, this.logger = BE, this.modules = { external: [] }, n2 = this, Object.getOwnPropertyNames(Object.getPrototypeOf(n2)).forEach((e11) => {
      "function" == typeof n2[e11] && (n2[e11] = n2[e11].bind(n2));
    }), t2 && !this.isInitialized && !e10.isClone) {
      if (!this.options.initImmediate) return this.init(e10, t2), this;
      setTimeout(() => {
        this.init(e10, t2);
      }, 0);
    }
  }
  init() {
    var e10 = this;
    let t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = true, "function" == typeof t2 && (n2 = t2, t2 = {}), !t2.defaultNS && false !== t2.defaultNS && t2.ns && (cE(t2.ns) ? t2.defaultNS = t2.ns : t2.ns.indexOf("translation") < 0 && (t2.defaultNS = t2.ns[0]));
    const r3 = YE();
    this.options = { ...r3, ...this.options, ...XE(t2) }, "v1" !== this.options.compatibilityAPI && (this.options.interpolation = { ...r3.interpolation, ...this.options.interpolation }), void 0 !== t2.keySeparator && (this.options.userDefinedKeySeparator = t2.keySeparator), void 0 !== t2.nsSeparator && (this.options.userDefinedNsSeparator = t2.nsSeparator);
    const o2 = (e11) => e11 ? "function" == typeof e11 ? new e11() : e11 : null;
    if (!this.options.isClone) {
      let t3;
      this.modules.logger ? BE.init(o2(this.modules.logger), this.options) : BE.init(null, this.options), this.modules.formatter ? t3 = this.modules.formatter : "undefined" != typeof Intl && (t3 = qE);
      const n3 = new RE(this.options);
      this.store = new kE(this.options.resources, this.options);
      const i3 = this.services;
      i3.logger = BE, i3.resourceStore = this.store, i3.languageUtils = n3, i3.pluralResolver = new $E(n3, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix }), !t3 || this.options.interpolation.format && this.options.interpolation.format !== r3.interpolation.format || (i3.formatter = o2(t3), i3.formatter.init(i3, this.options), this.options.interpolation.format = i3.formatter.format.bind(i3.formatter)), i3.interpolator = new WE(this.options), i3.utils = { hasLoadedNamespace: this.hasLoadedNamespace.bind(this) }, i3.backendConnector = new KE(o2(this.modules.backend), i3.resourceStore, i3, this.options), i3.backendConnector.on("*", function(t4) {
        for (var n4 = arguments.length, r4 = new Array(n4 > 1 ? n4 - 1 : 0), o3 = 1; o3 < n4; o3++) r4[o3 - 1] = arguments[o3];
        e10.emit(t4, ...r4);
      }), this.modules.languageDetector && (i3.languageDetector = o2(this.modules.languageDetector), i3.languageDetector.init && i3.languageDetector.init(i3, this.options.detection, this.options)), this.modules.i18nFormat && (i3.i18nFormat = o2(this.modules.i18nFormat), i3.i18nFormat.init && i3.i18nFormat.init(this)), this.translator = new PE(this.services, this.options), this.translator.on("*", function(t4) {
        for (var n4 = arguments.length, r4 = new Array(n4 > 1 ? n4 - 1 : 0), o3 = 1; o3 < n4; o3++) r4[o3 - 1] = arguments[o3];
        e10.emit(t4, ...r4);
      }), this.modules.external.forEach((e11) => {
        e11.init && e11.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n2 || (n2 = ZE), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const e11 = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      e11.length > 0 && "dev" !== e11[0] && (this.options.lng = e11[0]);
    }
    this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
    ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((t3) => {
      this[t3] = function() {
        return e10.store[t3](...arguments);
      };
    });
    ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((t3) => {
      this[t3] = function() {
        return e10.store[t3](...arguments), e10;
      };
    });
    const i2 = dE(), a2 = () => {
      const e11 = (e12, t3) => {
        this.isInitializing = false, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = true, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), i2.resolve(t3), n2(e12, t3);
      };
      if (this.languages && "v1" !== this.options.compatibilityAPI && !this.isInitialized) return e11(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, e11);
    };
    return this.options.resources || !this.options.initImmediate ? a2() : setTimeout(a2, 0), i2;
  }
  loadResources(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ZE;
    const n2 = cE(e10) ? e10 : this.language;
    if ("function" == typeof e10 && (t2 = e10), !this.options.resources || this.options.partialBundledLanguages) {
      if (n2 && "cimode" === n2.toLowerCase() && (!this.options.preload || 0 === this.options.preload.length)) return t2();
      const e11 = [], r3 = (t3) => {
        if (!t3) return;
        if ("cimode" === t3) return;
        this.services.languageUtils.toResolveHierarchy(t3).forEach((t4) => {
          "cimode" !== t4 && e11.indexOf(t4) < 0 && e11.push(t4);
        });
      };
      if (n2) r3(n2);
      else {
        this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((e12) => r3(e12));
      }
      this.options.preload && this.options.preload.forEach((e12) => r3(e12)), this.services.backendConnector.load(e11, this.options.ns, (e12) => {
        e12 || this.resolvedLanguage || !this.language || this.setResolvedLanguage(this.language), t2(e12);
      });
    } else t2(null);
  }
  reloadResources(e10, t2, n2) {
    const r3 = dE();
    return "function" == typeof e10 && (n2 = e10, e10 = void 0), "function" == typeof t2 && (n2 = t2, t2 = void 0), e10 || (e10 = this.languages), t2 || (t2 = this.options.ns), n2 || (n2 = ZE), this.services.backendConnector.reload(e10, t2, (e11) => {
      r3.resolve(), n2(e11);
    }), r3;
  }
  use(e10) {
    if (!e10) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e10.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return "backend" === e10.type && (this.modules.backend = e10), ("logger" === e10.type || e10.log && e10.warn && e10.error) && (this.modules.logger = e10), "languageDetector" === e10.type && (this.modules.languageDetector = e10), "i18nFormat" === e10.type && (this.modules.i18nFormat = e10), "postProcessor" === e10.type && FE.addPostProcessor(e10), "formatter" === e10.type && (this.modules.formatter = e10), "3rdParty" === e10.type && this.modules.external.push(e10), this;
  }
  setResolvedLanguage(e10) {
    if (e10 && this.languages && !(["cimode", "dev"].indexOf(e10) > -1)) for (let e11 = 0; e11 < this.languages.length; e11++) {
      const t2 = this.languages[e11];
      if (!(["cimode", "dev"].indexOf(t2) > -1) && this.store.hasLanguageSomeTranslations(t2)) {
        this.resolvedLanguage = t2;
        break;
      }
    }
  }
  changeLanguage(e10, t2) {
    var n2 = this;
    this.isLanguageChangingTo = e10;
    const r3 = dE();
    this.emit("languageChanging", e10);
    const o2 = (e11) => {
      this.language = e11, this.languages = this.services.languageUtils.toResolveHierarchy(e11), this.resolvedLanguage = void 0, this.setResolvedLanguage(e11);
    }, i2 = (e11, i3) => {
      i3 ? (o2(i3), this.translator.changeLanguage(i3), this.isLanguageChangingTo = void 0, this.emit("languageChanged", i3), this.logger.log("languageChanged", i3)) : this.isLanguageChangingTo = void 0, r3.resolve(function() {
        return n2.t(...arguments);
      }), t2 && t2(e11, function() {
        return n2.t(...arguments);
      });
    }, a2 = (t3) => {
      e10 || t3 || !this.services.languageDetector || (t3 = []);
      const n3 = cE(t3) ? t3 : this.services.languageUtils.getBestMatchFromCodes(t3);
      n3 && (this.language || o2(n3), this.translator.language || this.translator.changeLanguage(n3), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(n3)), this.loadResources(n3, (e11) => {
        i2(e11, n3);
      });
    };
    return e10 || !this.services.languageDetector || this.services.languageDetector.async ? !e10 && this.services.languageDetector && this.services.languageDetector.async ? 0 === this.services.languageDetector.detect.length ? this.services.languageDetector.detect().then(a2) : this.services.languageDetector.detect(a2) : a2(e10) : a2(this.services.languageDetector.detect()), r3;
  }
  getFixedT(e10, t2, n2) {
    var r3 = this;
    const o2 = function(e11, t3) {
      let i2;
      if ("object" != typeof t3) {
        for (var a2 = arguments.length, s2 = new Array(a2 > 2 ? a2 - 2 : 0), u2 = 2; u2 < a2; u2++) s2[u2 - 2] = arguments[u2];
        i2 = r3.options.overloadTranslationOptionHandler([e11, t3].concat(s2));
      } else i2 = { ...t3 };
      i2.lng = i2.lng || o2.lng, i2.lngs = i2.lngs || o2.lngs, i2.ns = i2.ns || o2.ns, "" !== i2.keyPrefix && (i2.keyPrefix = i2.keyPrefix || n2 || o2.keyPrefix);
      const l2 = r3.options.keySeparator || ".";
      let c3;
      return c3 = i2.keyPrefix && Array.isArray(e11) ? e11.map((e12) => `${i2.keyPrefix}${l2}${e12}`) : i2.keyPrefix ? `${i2.keyPrefix}${l2}${e11}` : e11, r3.t(c3, i2);
    };
    return cE(e10) ? o2.lng = e10 : o2.lngs = e10, o2.ns = t2, o2.keyPrefix = n2, o2;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e10) {
    this.options.defaultNS = e10;
  }
  hasLoadedNamespace(e10) {
    let t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), false;
    if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), false;
    const n2 = t2.lng || this.resolvedLanguage || this.languages[0], r3 = !!this.options && this.options.fallbackLng, o2 = this.languages[this.languages.length - 1];
    if ("cimode" === n2.toLowerCase()) return true;
    const i2 = (e11, t3) => {
      const n3 = this.services.backendConnector.state[`${e11}|${t3}`];
      return -1 === n3 || 0 === n3 || 2 === n3;
    };
    if (t2.precheck) {
      const e11 = t2.precheck(this, i2);
      if (void 0 !== e11) return e11;
    }
    return !!this.hasResourceBundle(n2, e10) || (!(this.services.backendConnector.backend && (!this.options.resources || this.options.partialBundledLanguages)) || !(!i2(n2, e10) || r3 && !i2(o2, e10)));
  }
  loadNamespaces(e10, t2) {
    const n2 = dE();
    return this.options.ns ? (cE(e10) && (e10 = [e10]), e10.forEach((e11) => {
      this.options.ns.indexOf(e11) < 0 && this.options.ns.push(e11);
    }), this.loadResources((e11) => {
      n2.resolve(), t2 && t2(e11);
    }), n2) : (t2 && t2(), Promise.resolve());
  }
  loadLanguages(e10, t2) {
    const n2 = dE();
    cE(e10) && (e10 = [e10]);
    const r3 = this.options.preload || [], o2 = e10.filter((e11) => r3.indexOf(e11) < 0 && this.services.languageUtils.isSupportedCode(e11));
    return o2.length ? (this.options.preload = r3.concat(o2), this.loadResources((e11) => {
      n2.resolve(), t2 && t2(e11);
    }), n2) : (t2 && t2(), Promise.resolve());
  }
  dir(e10) {
    if (e10 || (e10 = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e10) return "rtl";
    const t2 = this.services && this.services.languageUtils || new RE(YE());
    return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"].indexOf(t2.getLanguagePartFromCode(e10)) > -1 || e10.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    return new JE(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, arguments.length > 1 ? arguments[1] : void 0);
  }
  cloneInstance() {
    let e10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ZE;
    const n2 = e10.forkResourceStore;
    n2 && delete e10.forkResourceStore;
    const r3 = { ...this.options, ...e10, isClone: true }, o2 = new JE(r3);
    void 0 === e10.debug && void 0 === e10.prefix || (o2.logger = o2.logger.clone(e10));
    return ["store", "services", "language"].forEach((e11) => {
      o2[e11] = this[e11];
    }), o2.services = { ...this.services }, o2.services.utils = { hasLoadedNamespace: o2.hasLoadedNamespace.bind(o2) }, n2 && (o2.store = new kE(this.store.data, r3), o2.services.resourceStore = o2.store), o2.translator = new PE(o2.services, r3), o2.translator.on("*", function(e11) {
      for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r4 = 1; r4 < t3; r4++) n3[r4 - 1] = arguments[r4];
      o2.emit(e11, ...n3);
    }), o2.init(r3, t2), o2.translator.options = r3, o2.translator.backendConnector.services.utils = { hasLoadedNamespace: o2.hasLoadedNamespace.bind(o2) }, o2;
  }
  toJSON() {
    return { options: this.options, store: this.store, language: this.language, languages: this.languages, resolvedLanguage: this.resolvedLanguage };
  }
}
const QE = JE.createInstance();
QE.createInstance = JE.createInstance, QE.createInstance, QE.dir, QE.init, QE.loadResources, QE.reloadResources, QE.use, QE.changeLanguage, QE.getFixedT, QE.t, QE.exists, QE.setDefaultNamespace, QE.hasLoadedNamespace, QE.loadNamespaces, QE.loadLanguages;
var eC = "translation";
function tC(e10, t2) {
  QE.addResourceBundle(e10, eC, t2, true, true);
}
function nC(e10) {
  QE.changeLanguage(e10);
}
function rC(e10) {
  return QE.getResourceBundle(e10, eC);
}
function oC(e10) {
  return QE.on("languageChanged", e10), function() {
    return QE.off("languageChanged", e10);
  };
}
QE.init({ lng: "zh-CN", resources: {} });
var iC = QE.t.bind(QE);
function aC(e10) {
  if (e10.removeAttr) {
    e10.removeAttr("width"), e10.removeAttr("height"), e10.removeAttr("fill"), e10.removeAttr("class"), e10.removeAttr("t"), e10.removeAttr("p-id");
    var t2 = e10.children();
    t2.length && aC(t2);
  }
}
function sC() {
  return fm('<svg viewBox="0 0 1024 1024"><path d="M498.7 655.8l-197.6-268c-8.1-10.9-0.3-26.4 13.3-26.4h395.2c13.6 0 21.4 15.4 13.3 26.4l-197.6 268c-6.6 9-20 9-26.6 0z"></path></svg>');
}
function uC() {
  return fm('<div class="w-e-bar-divider"></div>');
}
function lC(e10, t2, n2, r3, o2) {
  if (void 0 === r3 && (r3 = ""), void 0 === o2 && (o2 = false), t2) {
    if (r3) {
      var i2 = Py ? "cmd" : "ctrl";
      r3 = r3.replace("mod", i2);
    }
    if (o2) r3 && (e10.attr("data-tooltip", r3), e10.addClass("w-e-menu-tooltip-v5"), e10.addClass("tooltip-right"));
    else {
      var a2 = r3 ? "".concat(n2, "\n").concat(r3) : n2;
      e10.attr("data-tooltip", a2), e10.addClass("w-e-menu-tooltip-v5");
    }
  }
}
var cC = function() {
  function e10(e11, t2, n2) {
    void 0 === n2 && (n2 = false);
    var r3 = this;
    this.$elem = fm('<div class="w-e-bar-item"></div>'), this.$button = fm('<button type="button"></button>'), this.disabled = false, this.menu = t2;
    var o2 = t2.tag, i2 = t2.width;
    if ("button" !== o2) throw new Error("Invalid tag '".concat(o2, "', expected 'button'"));
    var a2 = t2.title, s2 = t2.hotkey, u2 = void 0 === s2 ? "" : s2, l2 = t2.iconSvg, c3 = void 0 === l2 ? "" : l2, d2 = this.$button;
    if (c3) {
      var f2 = fm(c3);
      aC(f2), d2.append(f2);
    } else d2.text(a2);
    lC(d2, c3, a2, u2, n2), n2 && c3 && d2.append(fm('<span class="title">'.concat(a2, "</span>"))), i2 && d2.css("width", "".concat(i2, "px")), d2.attr("data-menu-key", e11), this.$elem.append(d2), Km(function() {
      return r3.init();
    });
  }
  return e10.prototype.init = function() {
    var e11 = this;
    this.setActive(), this.setDisabled(), this.$button.on("click", function(t2) {
      t2.preventDefault(), SC(e11).hidePanelOrModal(), e11.disabled || (e11.exec(), e11.onButtonClick());
    });
  }, e10.prototype.exec = function() {
    var e11 = SC(this), t2 = this.menu, n2 = t2.getValue(e11);
    this.setIcon(), this.setTooltip(), t2.exec(e11, n2);
  }, e10.prototype.setActive = function() {
    var e11 = SC(this), t2 = this.$button, n2 = "active";
    this.menu.isActive(e11) ? t2.addClass(n2) : t2.removeClass(n2);
  }, e10.prototype.setDisabled = function() {
    var e11 = SC(this), t2 = this.$button, n2 = this.menu.isDisabled(e11);
    (null == e11.selection || e11.isDisabled()) && (n2 = true), this.menu.alwaysEnable && (n2 = false);
    var r3 = "disabled";
    n2 ? t2.addClass(r3) : t2.removeClass(r3), this.disabled = n2;
  }, e10.prototype.setIcon = function() {
    var e11 = SC(this), t2 = this.$button;
    if (this.menu.getIcon) {
      var n2 = this.menu.getIcon(e11);
      if (n2) {
        t2.find("svg").remove();
        var r3 = fm(n2);
        aC(r3), t2.append(r3);
      }
    }
  }, e10.prototype.setTooltip = function() {
    var e11 = SC(this), t2 = this.$button;
    if (this.menu.getTitle) {
      var n2 = this.menu.getTitle(e11), r3 = this.menu.iconSvg;
      n2 && r3 && lC(t2, r3, n2);
    }
  }, e10.prototype.changeMenuState = function() {
    this.setActive(), this.setDisabled();
  }, e10;
}(), dC = function(e10) {
  function t2(t3, n2, r3) {
    return void 0 === r3 && (r3 = false), e10.call(this, t3, n2, r3) || this;
  }
  return ev(t2, e10), t2.prototype.onButtonClick = function() {
  }, t2;
}(cC), fC = function() {
  function e10(e11) {
    this.isShow = false, this.showTime = 0, this.record(e11);
  }
  return e10.prototype.record = function(e11) {
    var t2 = Pv.get(e11);
    null == t2 && (t2 = /* @__PURE__ */ new Set(), Pv.set(e11, t2)), t2.add(this), _v.set(this, e11);
  }, e10.prototype.renderContent = function(e11) {
    var t2 = this.$elem;
    t2.empty(), t2.append(e11);
    var n2 = this.genSelfElem();
    n2 && t2.append(n2);
  }, e10.prototype.appendTo = function(e11) {
    var t2 = this.$elem;
    e11.append(t2);
  }, e10.prototype.show = function() {
    if (!this.isShow) {
      this.showTime = Date.now(), this.$elem.show(), this.isShow = true;
      var e11 = _v.get(this);
      e11 && e11.emit(Dv, this);
    }
  }, e10.prototype.hide = function() {
    if (this.isShow && !(Date.now() - this.showTime < 200)) {
      this.$elem.hide(), this.isShow = false;
      var e11 = _v.get(this);
      e11 && e11.emit(Sv);
    }
  }, e10;
}(), pC = function(e10) {
  function t2(t3) {
    var n2 = e10.call(this, t3) || this;
    return n2.type = "dropPanel", n2.$elem = fm('<div class="w-e-drop-panel"></div>'), n2;
  }
  return ev(t2, e10), t2.prototype.genSelfElem = function() {
    return null;
  }, t2;
}(fC), hC = function(e10) {
  function t2(t3, n2, r3) {
    void 0 === r3 && (r3 = false);
    var o2 = e10.call(this, t3, n2, r3) || this;
    if (o2.dropPanel = null, o2.menu = n2, n2.showDropPanel) {
      var i2 = sC();
      o2.$button.append(i2);
    }
    return o2;
  }
  return ev(t2, e10), t2.prototype.onButtonClick = function() {
    this.menu.showDropPanel && this.handleDropPanel();
  }, t2.prototype.handleDropPanel = function() {
    var e11 = this.menu;
    if (null != e11.getPanelContentElem) {
      var t3 = SC(this);
      if (null == this.dropPanel) {
        var n2 = new pC(t3), r3 = e11.getPanelContentElem(t3);
        n2.renderContent(r3), n2.appendTo(this.$elem), n2.show(), this.dropPanel = n2;
      } else {
        var o2 = this.dropPanel;
        if (o2.isShow) o2.hide();
        else {
          r3 = e11.getPanelContentElem(t3);
          o2.renderContent(r3), o2.show();
        }
      }
      var i2 = this.dropPanel;
      if (i2.isShow) {
        var a2 = this.$elem, s2 = a2.offset().left, u2 = a2.parents(".w-e-bar");
        s2 - u2.offset().left >= u2.width() / 2 ? i2.$elem.css({ left: "none", right: "0" }) : i2.$elem.css({ left: "0", right: "none" });
      }
    }
  }, t2;
}(cC), gC = function(e10) {
  function t2(t3, n2) {
    void 0 === n2 && (n2 = 0);
    var r3 = e10.call(this, t3) || this;
    r3.type = "modal", r3.$elem = fm('<div class="w-e-modal"></div>'), r3.width = 0, n2 && (r3.width = n2);
    var o2 = r3.$elem;
    return o2.on("click", function(e11) {
      return e11.stopPropagation();
    }), o2.on("keyup", function(e11) {
      "Escape" === e11.code && (r3.hide(), t3.restoreSelection());
    }), r3;
  }
  return ev(t2, e10), t2.prototype.genSelfElem = function() {
    var e11 = this, t3 = fm('<span class="btn-close">'.concat('<svg viewBox="0 0 1024 1024"><path d="M1024 896.1024l-128 128L512 640 128 1024 0 896 384 512 0 128 128 0 512 384 896.1024 0l128 128L640 512z"></path></svg>', "</span>")), n2 = _v.get(this);
    return t3.on("click", function() {
      e11.hide(), null == n2 || n2.restoreSelection();
    }), t3;
  }, t2.prototype.setStyle = function(e11) {
    var t3 = this.width, n2 = this.$elem;
    n2.attr("style", ""), t3 && n2.css("width", "".concat(t3, "px")), n2.css(e11);
  }, t2;
}(fC);
function vC(e10, t2, n2) {
  var r3 = fm('<label class="babel-container"></label>');
  r3.append("<span>".concat(e10, "</span>"));
  var o2 = fm('<input type="text" id="'.concat(t2, '" placeholder="').concat(n2 || "", '">'));
  return r3.append(o2), [r3[0], o2[0]];
}
function yC(e10, t2) {
  var n2 = fm('<div class="button-container"></div>'), r3 = fm('<button type="button" id="'.concat(e10, '">').concat(t2, "</button>"));
  return n2.append(r3), [n2[0], r3[0]];
}
var bC = function(e10) {
  function t2(t3, n2, r3) {
    void 0 === r3 && (r3 = false);
    var o2 = e10.call(this, t3, n2, r3) || this;
    return o2.$body = fm("body"), o2.modal = null, o2.menu = n2, o2;
  }
  return ev(t2, e10), t2.prototype.onButtonClick = function() {
    this.menu.showModal && this.handleModal();
  }, t2.prototype.getPosition = function() {
    var e11 = SC(this), t3 = this.menu.getModalPositionNode(e11);
    return Kh.isElement(t3) ? rE(e11, t3, "modal") : nE(e11);
  }, t2.prototype.handleModal = function() {
    var e11 = SC(this), t3 = this.menu;
    if (null == this.modal) {
      var n2 = new gC(e11, t3.modalWidth);
      this.renderAndShowModal(n2, true), this.modal = n2;
    } else {
      (n2 = this.modal).isShow ? n2.hide() : this.renderAndShowModal(n2, false);
    }
  }, t2.prototype.renderAndShowModal = function(e11, t3) {
    void 0 === t3 && (t3 = false);
    var n2 = SC(this), r3 = this.menu;
    if (null != r3.getModalContentElem) {
      var o2 = zy.getTextarea(n2), i2 = zy.getToolbar(n2), a2 = ((null == i2 ? void 0 : i2.getConfig()) || {}).modalAppendToBody, s2 = r3.getModalContentElem(n2);
      if (e11.renderContent(s2), a2) e11.setStyle({ left: "0", right: "0" });
      else {
        var u2 = this.getPosition();
        e11.setStyle(u2);
      }
      t3 && (a2 ? e11.appendTo(this.$body) : e11.appendTo(o2.$textAreaContainer)), e11.show(), a2 || oE(n2, e11.$elem), setTimeout(function() {
        n2.blur();
      });
    }
  }, t2;
}(cC);
var EC = function(e10) {
  function t2(t3, n2) {
    var r3 = e10.call(this, t3) || this;
    return r3.type = "selectList", r3.$elem = fm('<div class="w-e-select-list"></div>'), n2 && r3.$elem.css("width", "".concat(n2, "px")), r3.$elem.on("click", function(e11) {
      e11.stopPropagation();
    }), r3;
  }
  return ev(t2, e10), t2.prototype.renderList = function(e11) {
    var t3 = this.$elem;
    t3.empty();
    var n2 = fm("<ul></ul>");
    e11.forEach(function(e12) {
      var t4 = e12.value, r3 = e12.text, o2 = e12.selected, i2 = e12.styleForRenderMenuList, a2 = fm('<li data-value="'.concat(t4, '"></li>'));
      if (i2 && a2.css(i2), o2) {
        var s2 = fm('<svg viewBox="0 0 1446 1024"><path d="M574.116299 786.736392 1238.811249 48.517862C1272.390222 11.224635 1329.414799 7.827718 1366.75664 41.450462 1403.840015 74.840484 1406.731043 132.084741 1373.10189 169.433699L655.118888 966.834607C653.072421 969.716875 650.835807 972.514337 648.407938 975.210759 615.017957 1012.29409 558.292155 1015.652019 521.195664 982.250188L72.778218 578.493306C35.910826 545.297758 32.859041 488.584019 66.481825 451.242134 99.871807 414.158803 156.597563 410.800834 193.694055 444.202665L574.116299 786.736392Z"></path></svg>');
        a2.append(s2), a2.addClass("selected");
      }
      a2.append(fm('<span data-value="'.concat(t4, '">').concat(r3, "</span>"))), a2.attr("title", r3), n2.append(a2);
    }), t3.append(n2);
  }, t2.prototype.genSelfElem = function() {
    return null;
  }, t2;
}(fC);
var CC = function() {
  function e10(e11, t2, n2) {
    void 0 === n2 && (n2 = false);
    var r3 = this;
    this.$elem = fm('<div class="w-e-bar-item"></div>'), this.$button = fm('<button type="button" class="select-button"></button>'), this.disabled = false, this.selectList = null;
    var o2 = t2.tag, i2 = t2.title, a2 = t2.width, s2 = t2.iconSvg, u2 = void 0 === s2 ? "" : s2, l2 = t2.hotkey, c3 = void 0 === l2 ? "" : l2;
    if ("select" !== o2) throw new Error("Invalid tag '".concat(o2, "', expected 'select'"));
    var d2 = this.$button;
    a2 && d2.css("width", "".concat(a2, "px")), d2.attr("data-menu-key", e11), lC(d2, u2, i2, c3, n2), this.$elem.append(d2), this.menu = t2, Km(function() {
      return r3.init();
    });
  }
  return e10.prototype.init = function() {
    var e11 = this;
    this.setSelectedValue(), this.$button.on("click", function(t2) {
      t2.preventDefault(), SC(e11).hidePanelOrModal(), e11.trigger();
    });
  }, e10.prototype.trigger = function() {
    var e11 = this, t2 = SC(this);
    if (!t2.isDisabled() && !this.disabled) {
      var n2 = this.menu;
      if (null == this.selectList) {
        this.selectList = new EC(t2, n2.selectPanelWidth);
        var r3 = this.selectList, o2 = n2.getOptions(t2);
        r3.renderList(o2), r3.appendTo(this.$elem), r3.show(), r3.$elem.on("click", "li", function(t3) {
          var n3 = t3.target;
          if (null != n3) {
            t3.preventDefault();
            var r4 = fm(n3).attr("data-value");
            e11.onChange(r4);
          }
        });
      } else {
        if ((r3 = this.selectList).isShow) r3.hide();
        else {
          o2 = n2.getOptions(t2);
          r3.renderList(o2), r3.show();
        }
      }
    }
  }, e10.prototype.onChange = function(e11) {
    var t2 = SC(this), n2 = this.menu;
    n2.exec && n2.exec(t2, e11);
  }, e10.prototype.setSelectedValue = function() {
    var e11 = SC(this), t2 = this.menu, n2 = t2.getValue(e11), r3 = function(e12, t3) {
      for (var n3 = e12.length, r4 = "", o3 = 0; o3 < n3; o3++) {
        var i3 = e12[o3];
        if (i3.value === t3) {
          r4 = i3.text;
          break;
        }
      }
      return r4;
    }(t2.getOptions(e11), n2.toString()), o2 = this.$button, i2 = sC();
    o2.empty(), o2.text(r3), o2.append(i2);
  }, e10.prototype.setDisabled = function() {
    var e11 = SC(this), t2 = this.menu.isDisabled(e11), n2 = this.$button;
    (null == e11.selection || e11.isDisabled()) && (t2 = true);
    var r3 = "disabled";
    t2 ? n2.addClass(r3) : n2.removeClass(r3), this.disabled = t2;
  }, e10.prototype.changeMenuState = function() {
    this.setSelectedValue(), this.setDisabled();
  }, e10;
}(), wC = function() {
  function e10(e11) {
    this.$elem = fm('<div class="w-e-bar-item w-e-bar-item-group"></div>'), this.$container = fm('<div class="w-e-bar-item-menus-container"></div>'), this.$button = fm('<button type="button"></button>');
    var t2 = e11.key, n2 = e11.iconSvg, r3 = e11.title, o2 = this.$elem, i2 = this.$button;
    if (n2) {
      var a2 = fm(n2);
      aC(a2), i2.append(a2);
    } else i2.text(r3);
    i2.attr("data-menu-key", t2);
    var s2 = sC();
    i2.append(s2), o2.append(i2);
    var u2 = this.$container;
    o2.append(u2);
    var l2 = this.createObserver();
    this.observe(l2);
  }
  return e10.prototype.appendBarItem = function(e11) {
    var t2 = e11.$elem;
    this.$container.append(t2);
  }, e10.prototype.observe = function(e11) {
    var t2 = this.$container;
    e11.observe(t2[0], { childList: true, subtree: true, attributes: true });
  }, e10.prototype.createObserver = function() {
    var e11 = this, t2 = this.$container, n2 = this.$button, r3 = new MutationObserver(function() {
      var o2 = t2.find("button"), i2 = o2.length;
      if (0 !== i2) {
        var a2 = 0;
        o2.each(function(e12) {
          fm(e12).hasClass("disabled") && a2++;
        }), r3.disconnect(), a2 === i2 ? n2.addClass("disabled") : n2.removeClass("disabled"), e11.observe(r3);
      }
    });
    return r3;
  }, e10;
}(), DC = /* @__PURE__ */ new WeakMap();
function SC(e10) {
  var t2 = Iv.get(e10);
  if (null == t2) throw new Error("Can not get editor instance");
  return t2;
}
function AC(e10, t2, n2) {
  void 0 === n2 && (n2 = false);
  var r3 = DC.get(t2);
  if (r3) return r3;
  var o2 = t2.tag;
  if ("button" === o2) {
    var i2 = t2.showDropPanel, a2 = t2.showModal;
    r3 = i2 ? new hC(e10, t2, n2) : a2 ? new bC(e10, t2, n2) : new dC(e10, t2, n2);
  }
  if ("select" === o2 && (r3 = new CC(e10, t2, n2)), null == r3) throw new Error("Invalid tag in menu ".concat(JSON.stringify(t2)));
  return DC.set(t2, r3), r3;
}
function xC(e10, t2) {
  var n2 = e10.selection;
  return null != n2 && (!yg.isCollapsed(n2) && (!zy.getSelectedElems(e10).some(function(t3) {
    if (e10.isVoid(t3)) return true;
    var n3 = t3.type;
    return !!["pre", "code", "table"].includes(n3);
  }) && !!Og.isText(t2)));
}
var OC, NC, BC = function() {
  function e10() {
    var e11 = this;
    this.$elem = fm('<div class="w-e-bar w-e-bar-hidden w-e-hover-bar"></div>'), this.menus = {}, this.hoverbarItems = [], this.prevSelectedNode = null, this.isShow = false, this.lngListen = function() {
    }, this.changeHoverbarState = lE(function() {
      var t2 = e11.isShow, n2 = e11.getSelectedNodeAndMenuKeys() || {}, r3 = n2.node, o2 = void 0 === r3 ? null : r3, i2 = n2.menuKeys, a2 = void 0 === i2 ? [] : i2, s2 = e11.getEditorInstance();
      if (null != o2 && e11.changeItemsState(), o2 && Kh.isElement(o2) && t2) {
        var u2 = e11.isSamePath(o2, e11.prevSelectedNode);
        if (!eg.isBlock(s2, o2) && u2) return;
      }
      e11.hideAndClean(), null != o2 && (e11.registerItems(a2), e11.setPosition(o2), e11.show()), e11.prevSelectedNode = o2;
    }, 200), Km(function() {
      var t2 = e11.getEditorInstance(), n2 = e11.$elem;
      n2.on("mousedown", function(e12) {
        return e12.preventDefault();
      }, { passive: false }), zy.getTextarea(t2).$textAreaContainer.append(n2), t2.on(bv, e11.changeHoverbarState);
      var r3 = e11.hideAndClean.bind(e11);
      t2.on(Ev, r3), t2.on(Cv, r3), t2.on(wv, r3);
    }), this.lngListen = oC(function() {
      e11.menus = {}, e11.hideAndClean(), e11.getEditorInstance().deselect();
    });
  }
  return e10.prototype.getMenus = function() {
    return this.menus;
  }, e10.prototype.hideAndClean = function() {
    var e11 = this.$elem;
    e11.removeClass("w-e-bar-show").addClass("w-e-bar-hidden"), this.hoverbarItems = [], e11.empty(), this.isShow = false;
  }, e10.prototype.checkPositionBottom = function() {
    var e11 = this.$elem, t2 = false, n2 = "undefined" != typeof window ? window.innerHeight : null;
    n2 && n2 >= 360 && (n2 - e11[0].getBoundingClientRect().bottom < 360 && (t2 = true));
    t2 ? e11.addClass("w-e-bar-bottom") : e11.removeClass("w-e-bar-bottom");
  }, e10.prototype.show = function() {
    this.$elem.removeClass("w-e-bar-hidden").addClass("w-e-bar-show"), this.isShow = true, this.checkPositionBottom();
  }, e10.prototype.changeItemsState = function() {
    var e11 = this;
    Km(function() {
      e11.hoverbarItems.forEach(function(e12) {
        e12.changeMenuState();
      });
    });
  }, e10.prototype.registerItems = function(e11) {
    var t2 = this, n2 = this.$elem;
    e11.forEach(function(e12) {
      if ("|" !== e12) t2.registerSingleItem(e12);
      else {
        var r3 = uC();
        n2.append(r3);
      }
    });
  }, e10.prototype.registerSingleItem = function(e11) {
    var t2 = this.getEditorInstance(), n2 = this.menus, r3 = n2[e11];
    if (null == r3) {
      var o2 = Av[e11];
      if (null == o2) throw new Error("Not found menu item factory by key '".concat(e11, "'"));
      if ("function" != typeof o2) throw new Error("Menu item factory (key='".concat(e11, "') is not a function"));
      r3 = o2(), n2[e11] = r3;
    }
    var i2 = t2.getMenuConfig(e11);
    i2 && void 0 !== i2.iconSvg && (r3.iconSvg = i2.iconSvg);
    var a2 = AC(e11, r3);
    this.hoverbarItems.push(a2), Iv.set(a2, t2), this.$elem.append(a2.$elem);
  }, e10.prototype.setPosition = function(e11) {
    var t2 = this.getEditorInstance(), n2 = this.$elem;
    if (n2.attr("style", ""), Kh.isElement(e11)) {
      var r3 = rE(t2, e11, "bar");
      return n2.css(r3), void oE(t2, n2);
    }
    if (Og.isText(e11)) {
      r3 = nE(t2);
      return n2.css(r3), void oE(t2, n2);
    }
    throw new Error("hoverbar.setPosition error, current selected node is not elem nor text");
  }, e10.prototype.getSelectedNodeAndMenuKeys = function() {
    var e11 = this.getEditorInstance();
    if (null == e11.selection) return null;
    var t2 = this.getHoverbarKeysConf(), n2 = null, r3 = [], o2 = function(o3) {
      var i3 = t2[o3], a2 = i3.match, s2 = i3.menuKeys, u2 = void 0 === s2 ? [] : s2, l2 = a2 || function(e12, t3) {
        return zy.checkNodeType(t3, o3);
      }, c3 = iv(eg.nodes(e11, { match: function(t3) {
        return l2(e11, t3);
      }, universal: true }), 1), d2 = c3[0];
      if (null != d2) return n2 = d2[0], r3 = u2, "break";
    };
    for (var i2 in t2) {
      if ("break" === o2(i2)) break;
    }
    return null == n2 || 0 === r3.length ? null : { node: n2, menuKeys: r3 };
  }, e10.prototype.getEditorInstance = function() {
    var e11 = kv.get(this);
    if (null == e11) throw new Error("Can not get editor instance");
    return e11;
  }, e10.prototype.getHoverbarKeysConf = function() {
    var e11 = this.getEditorInstance().getConfig().hoverbarKeys, t2 = void 0 === e11 ? {} : e11, n2 = t2.text;
    return n2 && null == n2.match && (n2.match = xC), t2;
  }, e10.prototype.isSamePath = function(e11, t2) {
    if (null == e11 || null == t2) return false;
    var n2 = zy.findPath(null, e11), r3 = zy.findPath(null, t2);
    return cg.equals(n2, r3);
  }, e10.prototype.destroy = function() {
    var e11;
    this.changeHoverbarState.cancel(), this.$elem.remove(), null === (e11 = this.lngListen) || void 0 === e11 || e11.call(this), this.menus = {}, this.hoverbarItems = [], this.prevSelectedNode = null;
  }, e10;
}();
function TC() {
  if (NC) return OC;
  NC = 1;
  var e10 = "Expected a function", t2 = /^\s+|\s+$/g, n2 = /^[-+]0x[0-9a-f]+$/i, r3 = /^0b[01]+$/i, o2 = /^0o[0-7]+$/i, i2 = parseInt, a2 = "object" == typeof y && y && y.Object === Object && y, s2 = "object" == typeof self && self && self.Object === Object && self, u2 = a2 || s2 || Function("return this")(), l2 = Object.prototype.toString, c3 = Math.max, d2 = Math.min, f2 = function() {
    return u2.Date.now();
  };
  function p2(t3, n3, r4) {
    var o3, i3, a3, s3, u3, l3, p3 = 0, v2 = false, m2 = false, y2 = true;
    if ("function" != typeof t3) throw new TypeError(e10);
    function b2(e11) {
      var n4 = o3, r5 = i3;
      return o3 = i3 = void 0, p3 = e11, s3 = t3.apply(r5, n4);
    }
    function E2(e11) {
      var t4 = e11 - l3;
      return void 0 === l3 || t4 >= n3 || t4 < 0 || m2 && e11 - p3 >= a3;
    }
    function C2() {
      var e11 = f2();
      if (E2(e11)) return w2(e11);
      u3 = setTimeout(C2, function(e12) {
        var t4 = n3 - (e12 - l3);
        return m2 ? d2(t4, a3 - (e12 - p3)) : t4;
      }(e11));
    }
    function w2(e11) {
      return u3 = void 0, y2 && o3 ? b2(e11) : (o3 = i3 = void 0, s3);
    }
    function D2() {
      var e11 = f2(), t4 = E2(e11);
      if (o3 = arguments, i3 = this, l3 = e11, t4) {
        if (void 0 === u3) return function(e12) {
          return p3 = e12, u3 = setTimeout(C2, n3), v2 ? b2(e12) : s3;
        }(l3);
        if (m2) return u3 = setTimeout(C2, n3), b2(l3);
      }
      return void 0 === u3 && (u3 = setTimeout(C2, n3)), s3;
    }
    return n3 = g2(n3) || 0, h2(r4) && (v2 = !!r4.leading, a3 = (m2 = "maxWait" in r4) ? c3(g2(r4.maxWait) || 0, n3) : a3, y2 = "trailing" in r4 ? !!r4.trailing : y2), D2.cancel = function() {
      void 0 !== u3 && clearTimeout(u3), p3 = 0, o3 = l3 = i3 = u3 = void 0;
    }, D2.flush = function() {
      return void 0 === u3 ? s3 : w2(f2());
    }, D2;
  }
  function h2(e11) {
    var t3 = typeof e11;
    return !!e11 && ("object" == t3 || "function" == t3);
  }
  function g2(e11) {
    if ("number" == typeof e11) return e11;
    if (function(e12) {
      return "symbol" == typeof e12 || /* @__PURE__ */ function(e13) {
        return !!e13 && "object" == typeof e13;
      }(e12) && "[object Symbol]" == l2.call(e12);
    }(e11)) return NaN;
    if (h2(e11)) {
      var a3 = "function" == typeof e11.valueOf ? e11.valueOf() : e11;
      e11 = h2(a3) ? a3 + "" : a3;
    }
    if ("string" != typeof e11) return 0 === e11 ? e11 : +e11;
    e11 = e11.replace(t2, "");
    var s3 = r3.test(e11);
    return s3 || o2.test(e11) ? i2(e11.slice(2), s3 ? 2 : 8) : n2.test(e11) ? NaN : +e11;
  }
  return OC = function(t3, n3, r4) {
    var o3 = true, i3 = true;
    if ("function" != typeof t3) throw new TypeError(e10);
    return h2(r4) && (o3 = "leading" in r4 ? !!r4.leading : o3, i3 = "trailing" in r4 ? !!r4.trailing : i3), p2(t3, n3, { leading: o3, maxWait: n3, trailing: i3 });
  };
}
var kC = b(TC());
function FC(e10, t2) {
  return Qm(t2) && zy.hasDOMNode(e10, t2, { editable: true });
}
function IC(e10, t2) {
  if (e10.getConfig().readOnly) return false;
  var n2 = PC(e10, t2) && zy.toSlateNode(e10, t2);
  return eg.isVoid(e10, n2);
}
function PC(e10, t2) {
  return Qm(t2) && zy.hasDOMNode(e10, t2);
}
const _C = (e10) => "object" == typeof e10 && null != e10 && 1 === e10.nodeType, RC = (e10, t2) => (!t2 || "hidden" !== e10) && "visible" !== e10 && "clip" !== e10, LC = (e10, t2) => {
  if (e10.clientHeight < e10.scrollHeight || e10.clientWidth < e10.scrollWidth) {
    const n2 = getComputedStyle(e10, null);
    return RC(n2.overflowY, t2) || RC(n2.overflowX, t2) || ((e11) => {
      const t3 = ((e12) => {
        if (!e12.ownerDocument || !e12.ownerDocument.defaultView) return null;
        try {
          return e12.ownerDocument.defaultView.frameElement;
        } catch (e13) {
          return null;
        }
      })(e11);
      return !!t3 && (t3.clientHeight < e11.scrollHeight || t3.clientWidth < e11.scrollWidth);
    })(e10);
  }
  return false;
}, MC = (e10, t2, n2, r3, o2, i2, a2, s2) => i2 < e10 && a2 > t2 || i2 > e10 && a2 < t2 ? 0 : i2 <= e10 && s2 <= n2 || a2 >= t2 && s2 >= n2 ? i2 - e10 - r3 : a2 > t2 && s2 < n2 || i2 < e10 && s2 > n2 ? a2 - t2 + o2 : 0, jC = (e10) => {
  const t2 = e10.parentElement;
  return null == t2 ? e10.getRootNode().host || null : t2;
}, HC = (e10, t2) => {
  var n2, r3, o2, i2;
  if ("undefined" == typeof document) return [];
  const { scrollMode: a2, block: s2, inline: u2, boundary: l2, skipOverflowHiddenElements: c3 } = t2, d2 = "function" == typeof l2 ? l2 : (e11) => e11 !== l2;
  if (!_C(e10)) throw new TypeError("Invalid target");
  const f2 = document.scrollingElement || document.documentElement, p2 = [];
  let h2 = e10;
  for (; _C(h2) && d2(h2); ) {
    if (h2 = jC(h2), h2 === f2) {
      p2.push(h2);
      break;
    }
    null != h2 && h2 === document.body && LC(h2) && !LC(document.documentElement) || null != h2 && LC(h2, c3) && p2.push(h2);
  }
  const g2 = null != (r3 = null == (n2 = window.visualViewport) ? void 0 : n2.width) ? r3 : innerWidth, v2 = null != (i2 = null == (o2 = window.visualViewport) ? void 0 : o2.height) ? i2 : innerHeight, { scrollX: m2, scrollY: y2 } = window, { height: b2, width: E2, top: C2, right: w2, bottom: D2, left: S2 } = e10.getBoundingClientRect(), { top: A2, right: x2, bottom: O2, left: N2 } = ((e11) => {
    const t3 = window.getComputedStyle(e11);
    return { top: parseFloat(t3.scrollMarginTop) || 0, right: parseFloat(t3.scrollMarginRight) || 0, bottom: parseFloat(t3.scrollMarginBottom) || 0, left: parseFloat(t3.scrollMarginLeft) || 0 };
  })(e10);
  let B2 = "start" === s2 || "nearest" === s2 ? C2 - A2 : "end" === s2 ? D2 + O2 : C2 + b2 / 2 - A2 + O2, T2 = "center" === u2 ? S2 + E2 / 2 - N2 + x2 : "end" === u2 ? w2 + x2 : S2 - N2;
  const k2 = [];
  for (let e11 = 0; e11 < p2.length; e11++) {
    const t3 = p2[e11], { height: n3, width: r4, top: o3, right: i3, bottom: l3, left: c4 } = t3.getBoundingClientRect();
    if ("if-needed" === a2 && C2 >= 0 && S2 >= 0 && D2 <= v2 && w2 <= g2 && (t3 === f2 && !LC(t3) || C2 >= o3 && D2 <= l3 && S2 >= c4 && w2 <= i3)) return k2;
    const d3 = getComputedStyle(t3), h3 = parseInt(d3.borderLeftWidth, 10), A3 = parseInt(d3.borderTopWidth, 10), x3 = parseInt(d3.borderRightWidth, 10), O3 = parseInt(d3.borderBottomWidth, 10);
    let N3 = 0, F2 = 0;
    const I2 = "offsetWidth" in t3 ? t3.offsetWidth - t3.clientWidth - h3 - x3 : 0, P2 = "offsetHeight" in t3 ? t3.offsetHeight - t3.clientHeight - A3 - O3 : 0, _2 = "offsetWidth" in t3 ? 0 === t3.offsetWidth ? 0 : r4 / t3.offsetWidth : 0, R2 = "offsetHeight" in t3 ? 0 === t3.offsetHeight ? 0 : n3 / t3.offsetHeight : 0;
    if (f2 === t3) N3 = "start" === s2 ? B2 : "end" === s2 ? B2 - v2 : "nearest" === s2 ? MC(y2, y2 + v2, v2, A3, O3, y2 + B2, y2 + B2 + b2, b2) : B2 - v2 / 2, F2 = "start" === u2 ? T2 : "center" === u2 ? T2 - g2 / 2 : "end" === u2 ? T2 - g2 : MC(m2, m2 + g2, g2, h3, x3, m2 + T2, m2 + T2 + E2, E2), N3 = Math.max(0, N3 + y2), F2 = Math.max(0, F2 + m2);
    else {
      N3 = "start" === s2 ? B2 - o3 - A3 : "end" === s2 ? B2 - l3 + O3 + P2 : "nearest" === s2 ? MC(o3, l3, n3, A3, O3 + P2, B2, B2 + b2, b2) : B2 - (o3 + n3 / 2) + P2 / 2, F2 = "start" === u2 ? T2 - c4 - h3 : "center" === u2 ? T2 - (c4 + r4 / 2) + I2 / 2 : "end" === u2 ? T2 - i3 + x3 + I2 : MC(c4, i3, r4, h3, x3 + I2, T2, T2 + E2, E2);
      const { scrollLeft: e12, scrollTop: a3 } = t3;
      N3 = 0 === R2 ? 0 : Math.max(0, Math.min(a3 + N3 / R2, t3.scrollHeight - n3 / R2 + P2)), F2 = 0 === _2 ? 0 : Math.max(0, Math.min(e12 + F2 / _2, t3.scrollWidth - r4 / _2 + I2)), B2 += a3 - N3, T2 += e12 - F2;
    }
    k2.push({ el: t3, top: N3, left: F2 });
  }
  return k2;
};
function zC(e10, t2) {
  if (!e10.isConnected || !((e11) => {
    let t3 = e11;
    for (; t3 && t3.parentNode; ) {
      if (t3.parentNode === document) return true;
      t3 = t3.parentNode instanceof ShadowRoot ? t3.parentNode.host : t3.parentNode;
    }
    return false;
  })(e10)) return;
  const n2 = ((e11) => {
    const t3 = window.getComputedStyle(e11);
    return { top: parseFloat(t3.scrollMarginTop) || 0, right: parseFloat(t3.scrollMarginRight) || 0, bottom: parseFloat(t3.scrollMarginBottom) || 0, left: parseFloat(t3.scrollMarginLeft) || 0 };
  })(e10);
  if (((e11) => "object" == typeof e11 && "function" == typeof e11.behavior)(t2)) return t2.behavior(HC(e10, t2));
  const r3 = "boolean" == typeof t2 || null == t2 ? void 0 : t2.behavior;
  for (const { el: o2, top: i2, left: a2 } of HC(e10, ((e11) => false === e11 ? { block: "end", inline: "nearest" } : ((e12) => e12 === Object(e12) && 0 !== Object.keys(e12).length)(e11) ? e11 : { block: "start", inline: "nearest" })(t2))) {
    const e11 = i2 - n2.top + n2.bottom, t3 = a2 - n2.left + n2.right;
    o2.scroll({ top: e11, left: t3, behavior: r3 });
  }
}
function $C(e10, t2, n2) {
  void 0 === n2 && (n2 = false);
  var r3 = t2.selection, o2 = t2.getConfig(), i2 = zy.findDocumentOrShadowRoot(t2).getSelection();
  if (i2 && (!e10.isComposing || n2) && t2.isFocused()) {
    var a2 = "None" !== i2.type;
    if (r3 || a2) {
      var s2 = Vv.get(t2), u2 = false;
      if (s2.contains(i2.anchorNode) && s2.contains(i2.focusNode) && (u2 = true), a2 && u2 && r3) {
        var l2 = zy.toSlateRange(t2, i2, { exactMatch: true, suppressThrow: true });
        if (l2 && yg.equals(l2, r3)) {
          var c3 = true;
          if (yg.isCollapsed(r3)) {
            var d2 = i2.anchorNode, f2 = i2.anchorOffset;
            if (d2 === s2) {
              var p2 = s2.childNodes, h2 = void 0;
              (h2 = p2[f2]) && h2.matches("table") && (c3 = false), (h2 = p2[f2 - 1]) && h2.matches("table") && (c3 = false);
            }
          }
          if (c3) return;
        }
      }
      if (!r3 || zy.hasRange(t2, r3)) {
        e10.isUpdatingSelection = true;
        var g2 = r3 && zy.toDOMRange(t2, r3);
        if (g2) {
          yg.isBackward(r3) ? i2.setBaseAndExtent(g2.endContainer, g2.endOffset, g2.startContainer, g2.startOffset) : i2.setBaseAndExtent(g2.startContainer, g2.startOffset, g2.endContainer, g2.endOffset);
          var v2 = g2.startContainer.parentElement;
          if (!v2.closest("[data-slate-spacer]") && g2.getBoundingClientRect) {
            var m2 = g2.getBoundingClientRect.bind(g2)();
            0 === m2.top && 0 === m2.right && 0 === m2.bottom && 0 === m2.left && 0 === m2.height && 0 === m2.width || (v2.getBoundingClientRect = g2.getBoundingClientRect.bind(g2));
            var y2 = document.body;
            zC(v2, { scrollMode: "if-needed", boundary: o2.scroll && s2.parentElement || y2, block: "end", behavior: "smooth" }), delete v2.getBoundingClientRect;
          }
        } else i2.removeAllRanges();
        setTimeout(function() {
          g2 && _y2 && s2.focus(), e10.isUpdatingSelection = false;
        });
      } else t2.selection = zy.toSlateRange(t2, i2, { exactMatch: false, suppressThrow: false });
    }
  }
}
var UC = /* @__PURE__ */ new WeakMap(), VC = /* @__PURE__ */ new WeakMap();
var WC, GC = {};
var qC = function() {
  if (WC) return GC;
  WC = 1, Object.defineProperty(GC, "__esModule", { value: true });
  for (var e10 = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), t2 = { alt: "altKey", control: "ctrlKey", meta: "metaKey", shift: "shiftKey" }, n2 = { add: "+", break: "pause", cmd: "meta", command: "meta", ctl: "control", ctrl: "control", del: "delete", down: "arrowdown", esc: "escape", ins: "insert", left: "arrowleft", mod: e10 ? "meta" : "control", opt: "alt", option: "alt", return: "enter", right: "arrowright", space: " ", spacebar: " ", up: "arrowup", win: "meta", windows: "meta" }, r3 = { backspace: 8, tab: 9, enter: 13, shift: 16, control: 17, alt: 18, pause: 19, capslock: 20, escape: 27, " ": 32, pageup: 33, pagedown: 34, end: 35, home: 36, arrowleft: 37, arrowup: 38, arrowright: 39, arrowdown: 40, insert: 45, delete: 46, meta: 91, numlock: 144, scrolllock: 145, ";": 186, "=": 187, ",": 188, "-": 189, ".": 190, "/": 191, "`": 192, "[": 219, "\\": 220, "]": 221, "'": 222 }, o2 = 1; o2 < 20; o2++) r3["f" + o2] = 111 + o2;
  function i2(e11, t3, n3) {
    t3 && !("byKey" in t3) && (n3 = t3, t3 = null), Array.isArray(e11) || (e11 = [e11]);
    var r4 = e11.map(function(e12) {
      return a2(e12, t3);
    }), o3 = function(e12) {
      return r4.some(function(t4) {
        return s2(t4, e12);
      });
    };
    return null == n3 ? o3 : o3(n3);
  }
  function a2(e11, o3) {
    var i3 = o3 && o3.byKey, a3 = {}, s3 = (e11 = e11.replace("++", "+add")).split("+"), c3 = s3.length;
    for (var d2 in t2) a3[t2[d2]] = false;
    var f2 = true, p2 = false, h2 = void 0;
    try {
      for (var g2, v2 = s3[Symbol.iterator](); !(f2 = (g2 = v2.next()).done); f2 = true) {
        var m2 = g2.value, y2 = m2.endsWith("?") && m2.length > 1;
        y2 && (m2 = m2.slice(0, -1));
        var b2 = l2(m2), E2 = t2[b2];
        if (m2.length > 1 && !E2 && !n2[m2] && !r3[b2]) throw new TypeError('Unknown modifier: "' + m2 + '"');
        1 !== c3 && E2 || (i3 ? a3.key = b2 : a3.which = u2(m2)), E2 && (a3[E2] = !y2 || null);
      }
    } catch (e12) {
      p2 = true, h2 = e12;
    } finally {
      try {
        !f2 && v2.return && v2.return();
      } finally {
        if (p2) throw h2;
      }
    }
    return a3;
  }
  function s2(e11, t3) {
    for (var n3 in e11) {
      var r4 = e11[n3], o3 = void 0;
      if (null != r4 && ((null != (o3 = "key" === n3 && null != t3.key ? t3.key.toLowerCase() : "which" === n3 ? 91 === r4 && 93 === t3.which ? 91 : t3.which : t3[n3]) || false !== r4) && o3 !== r4)) return false;
    }
    return true;
  }
  function u2(e11) {
    return e11 = l2(e11), r3[e11] || e11.toUpperCase().charCodeAt(0);
  }
  function l2(e11) {
    return e11 = e11.toLowerCase(), e11 = n2[e11] || e11;
  }
  return GC.default = i2, GC.isHotkey = i2, GC.isCodeHotkey = function(e11, t3) {
    return i2(e11, t3);
  }, GC.isKeyHotkey = function(e11, t3) {
    return i2(e11, { byKey: true }, t3);
  }, GC.parseHotkey = a2, GC.compareHotkey = s2, GC.toKeyCode = u2, GC.toKeyName = l2, GC;
}(), KC = { bold: "mod+b", compose: ["down", "left", "right", "up", "backspace", "enter"], moveBackward: "left", moveForward: "right", moveWordBackward: "ctrl+left", moveWordForward: "ctrl+right", deleteBackward: "shift?+backspace", deleteForward: "shift?+delete", extendBackward: "shift+left", extendForward: "shift+right", italic: "mod+i", splitBlock: "shift?+enter", undo: "mod+z", tab: "tab", selectAll: "mod+a" }, YC = { moveLineBackward: "opt+up", moveLineForward: "opt+down", moveWordBackward: "opt+left", moveWordForward: "opt+right", deleteBackward: ["ctrl+backspace", "ctrl+h"], deleteForward: ["ctrl+delete", "ctrl+d"], deleteLineBackward: "cmd+shift?+backspace", deleteLineForward: ["cmd+shift?+delete", "ctrl+k"], deleteWordBackward: "opt+shift?+backspace", deleteWordForward: "opt+shift?+delete", extendLineBackward: "opt+shift+up", extendLineForward: "opt+shift+down", redo: "cmd+shift+z", transposeCharacter: "ctrl+t" }, XC = { deleteWordBackward: "ctrl+shift?+backspace", deleteWordForward: "ctrl+shift?+delete", redo: ["ctrl+y", "ctrl+shift+z"] }, ZC = function(e10) {
  var t2 = KC[e10], n2 = YC[e10], r3 = XC[e10], o2 = t2 && qC.isKeyHotkey(t2), i2 = n2 && qC.isKeyHotkey(n2), a2 = r3 && qC.isKeyHotkey(r3);
  return function(e11) {
    return !(!o2 || !o2(e11)) || (!!(Py && i2 && i2(e11)) || !(Py || !a2 || !a2(e11)));
  };
}, JC = { isBold: ZC("bold"), isCompose: ZC("compose"), isMoveBackward: ZC("moveBackward"), isMoveForward: ZC("moveForward"), isDeleteBackward: ZC("deleteBackward"), isDeleteForward: ZC("deleteForward"), isDeleteLineBackward: ZC("deleteLineBackward"), isDeleteLineForward: ZC("deleteLineForward"), isDeleteWordBackward: ZC("deleteWordBackward"), isDeleteWordForward: ZC("deleteWordForward"), isExtendBackward: ZC("extendBackward"), isExtendForward: ZC("extendForward"), isExtendLineBackward: ZC("extendLineBackward"), isExtendLineForward: ZC("extendLineForward"), isItalic: ZC("italic"), isMoveLineBackward: ZC("moveLineBackward"), isMoveLineForward: ZC("moveLineForward"), isMoveWordBackward: ZC("moveWordBackward"), isMoveWordForward: ZC("moveWordForward"), isRedo: ZC("redo"), isSplitBlock: ZC("splitBlock"), isTransposeCharacter: ZC("transposeCharacter"), isUndo: ZC("undo"), isTab: ZC("tab"), isSelectAll: ZC("selectAll") };
function QC(e10) {
  e10.preventDefault();
}
var ew = { beforeinput: function(e10, t2, n2) {
  var r3 = e10, o2 = n2.getConfig().readOnly;
  if (Hy && !o2 && FC(n2, r3.target)) {
    var i2 = n2.selection, a2 = r3.inputType, s2 = r3.dataTransfer || r3.data || void 0;
    if ("insertCompositionText" !== a2 && "deleteCompositionText" !== a2) {
      if (r3.preventDefault(), !a2.startsWith("delete") || a2.startsWith("deleteBy")) {
        var u2 = iv(r3.getTargetRanges(), 1)[0];
        if (u2) {
          var l2 = zy.toSlateRange(n2, u2, { exactMatch: false, suppressThrow: false });
          i2 && yg.equals(i2, l2) || Wg.select(n2, l2);
        }
      }
      if (i2 && yg.isExpanded(i2)) {
        var c3 = zy.getSelectedElems(n2), d2 = "table" === c3[0].type, f2 = "table-cell" !== c3[c3.length - 1].type;
        if (d2 && f2) return;
        if (a2.startsWith("delete")) {
          var p2 = a2.endsWith("Backward") ? "backward" : "forward";
          return void eg.deleteFragment(n2, { direction: p2 });
        }
      }
      switch (a2) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag":
          eg.deleteFragment(n2);
          break;
        case "deleteContent":
        case "deleteContentForward":
          eg.deleteForward(n2);
          break;
        case "deleteContentBackward":
          eg.deleteBackward(n2);
          break;
        case "deleteEntireSoftLine":
          eg.deleteBackward(n2, { unit: "line" }), eg.deleteForward(n2, { unit: "line" });
          break;
        case "deleteHardLineBackward":
          eg.deleteBackward(n2, { unit: "block" });
          break;
        case "deleteSoftLineBackward":
          eg.deleteBackward(n2, { unit: "line" });
          break;
        case "deleteHardLineForward":
          eg.deleteForward(n2, { unit: "block" });
          break;
        case "deleteSoftLineForward":
          eg.deleteForward(n2, { unit: "line" });
          break;
        case "deleteWordBackward":
          eg.deleteBackward(n2, { unit: "word" });
          break;
        case "deleteWordForward":
          eg.deleteForward(n2, { unit: "word" });
          break;
        case "insertLineBreak":
        case "insertParagraph":
          eg.insertBreak(n2);
          break;
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText":
          if ("insertFromPaste" === a2 && !Qv.get(n2)) break;
          "[object DataTransfer]" === Xm(s2) ? n2.insertData(s2) : "string" == typeof s2 && eg.insertText(n2, s2);
      }
    }
  }
}, blur: function(e10, t2, n2) {
  var r3 = e10, o2 = t2.isUpdatingSelection, i2 = t2.latestElement;
  if (!n2.getConfig().readOnly && !o2 && FC(n2, r3.target)) {
    var a2 = zy.findDocumentOrShadowRoot(n2);
    if (i2 !== a2.activeElement) {
      var s2 = r3.relatedTarget;
      if (!(s2 === zy.toDOMNode(n2, n2) || ty(s2) && s2.hasAttribute("data-slate-spacer"))) {
        if (null != s2 && Qm(s2) && zy.hasDOMNode(n2, s2)) {
          var u2 = zy.toSlateNode(n2, s2);
          if (Kh.isElement(u2) && !n2.isVoid(u2)) return;
        }
        if (Ry) {
          var l2 = a2.getSelection();
          null == l2 || l2.removeAllRanges();
        }
        Xv.delete(n2);
      }
    }
  }
}, focus: function(e10, t2, n2) {
  var r3 = zy.toDOMNode(n2, n2), o2 = zy.findDocumentOrShadowRoot(n2);
  t2.latestElement = o2.activeElement, _y2 && e10.target !== r3 ? r3.focus() : Xv.set(n2, true);
}, click: function(e10, t2, n2) {
  if (!n2.getConfig().readOnly && PC(n2, e10.target) && Qm(e10.target)) {
    var r3 = zy.toSlateNode(n2, e10.target), o2 = zy.findPath(n2, r3);
    if (eg.hasPath(n2, o2)) {
      if (ag.get(n2, o2) === r3) {
        var i2 = eg.start(n2, o2), a2 = eg.end(n2, o2), s2 = eg.void(n2, { at: i2 }), u2 = eg.void(n2, { at: a2 });
        if (s2 && u2 && cg.equals(s2[1], u2[1])) {
          var l2 = eg.range(n2, i2);
          Wg.select(n2, l2);
        }
      }
    }
  }
}, compositionstart: function(e10, t2, n2) {
  if (FC(n2, e10.target)) {
    var r3 = n2.selection;
    if (r3 && yg.isExpanded(r3) && (eg.deleteFragment(n2), Promise.resolve().then(function() {
      $C(t2, n2, true);
    })), n2.selection) {
      var o2 = zy.toDOMRange(n2, n2.selection).startContainer, i2 = o2.textContent || "";
      UC.set(n2, i2), VC.set(n2, o2);
    }
    t2.isComposing = true, function(e11, t3) {
      var n3;
      t3.getConfig().placeholder && t3.isEmpty() && e11.showPlaceholder && (null === (n3 = e11.$placeholder) || void 0 === n3 || n3.hide(), e11.showPlaceholder = false);
    }(t2, n2);
  }
}, compositionend: function(e10, t2, n2) {
  var r3 = e10;
  if (FC(n2, r3.target)) {
    t2.isComposing = false;
    var o2 = n2.selection;
    if (null != o2) {
      (jy || _y2) && zy.cleanExposedTexNodeInSelectionBlock(n2);
      for (var i2 = yg.isBackward(o2) ? o2.focus : o2.anchor, a2 = iv(eg.node(n2, [i2.path[0]]), 1)[0], s2 = 0; s2 < i2.path.length; s2 += 1) {
        var u2 = iv(eg.node(n2, i2.path.slice(0, s2 + 1)), 1)[0];
        if (Kh.isElement(u2) && ((Ry || _y2) && "link" === u2.type || "code" === u2.type)) {
          zy.setNewKey(a2);
          break;
        }
      }
      var l2 = r3.data;
      if (l2) {
        if (n2.getConfig().maxLength) {
          var c3 = zy.getLeftLengthOfMaxLength(n2);
          if (c3 < l2.length) {
            var d2 = zy.toDOMRange(n2, o2);
            d2.startContainer.nodeType === Node.TEXT_NODE && (d2.startContainer.textContent = UC.get(n2) || ""), c3 > 0 && eg.insertText(n2, l2.slice(0, c3)), t2.changeViewState();
          } else eg.insertText(n2, l2);
        } else {
          var f2 = zy.findDocumentOrShadowRoot(n2).getSelection();
          f2 && function(e11, t3) {
            if (yg.isCollapsed(t3)) {
              var n3 = t3.anchor, r4 = t3.focus;
              if ([2, 3].includes(n3.path.length) && [2, 3].includes(r4.path.length) && (0 === n3.offset || 0 === r4.offset)) {
                var o3 = eg.node(e11, n3.path), i3 = 0 === n3.offset ? n3.path : r4.path, a3 = [i3[0], i3[1] - 1];
                if (0 === i3[1]) return false;
                var s3 = eg.node(e11, a3);
                if (Og.isText(s3[0]) && Og.isText(o3[0])) return true;
              }
            }
          }(n2, o2) && (n2.selection = zy.toSlateRange(n2, f2, { exactMatch: false, suppressThrow: false })), eg.insertText(n2, l2);
        }
        Ry || setTimeout(function() {
          var e11 = n2.selection;
          if (null != e11) {
            var t3 = VC.get(n2);
            if (null != t3) zy.toDOMRange(n2, e11).startContainer !== t3 && (t3.textContent = UC.get(n2) || "");
          }
        });
      }
    }
  }
}, compositionupdate: function(e10, t2, n2) {
  FC(n2, e10.target) && (t2.isComposing = true);
}, keydown: function(e10, t2, n2) {
  var r3 = e10, o2 = n2.selection;
  if (!n2.getConfig().readOnly && !t2.isComposing && FC(n2, r3.target)) {
    if (function(e11, t3) {
      var n3 = Tv.get(e11), r4 = n3 && n3.getMenus(), o3 = Fv.get(e11), i3 = o3 && o3.getMenus(), a2 = tv(tv({}, r4), i3);
      for (var s2 in a2) {
        var u2 = a2[s2], l2 = u2.hotkey;
        if (l2 && qC.isHotkey(l2, t3) && !u2.isDisabled(e11)) {
          var c3 = u2.getValue(e11);
          u2.exec(e11, c3);
        }
      }
    }(n2, r3), JC.isTab(r3)) return QC(r3), void n2.handleTab();
    if (JC.isRedo(r3)) return QC(r3), void ("function" == typeof n2.redo && n2.redo());
    if (JC.isUndo(r3)) return QC(r3), void ("function" == typeof n2.undo && n2.undo());
    if (JC.isMoveLineBackward(r3)) return QC(r3), void Wg.move(n2, { unit: "line", reverse: true });
    if (JC.isMoveLineForward(r3)) return QC(r3), void Wg.move(n2, { unit: "line" });
    if (JC.isExtendLineBackward(r3)) return QC(r3), void Wg.move(n2, { unit: "line", edge: "focus", reverse: true });
    if (JC.isExtendLineForward(r3)) return QC(r3), void Wg.move(n2, { unit: "line", edge: "focus" });
    if (JC.isMoveBackward(r3)) return QC(r3), void (o2 && yg.isCollapsed(o2) ? Wg.move(n2, { reverse: true }) : Wg.collapse(n2, { edge: "start" }));
    if (JC.isMoveForward(r3)) return QC(r3), void (o2 && yg.isCollapsed(o2) ? Wg.move(n2) : Wg.collapse(n2, { edge: "end" }));
    if (JC.isMoveWordBackward(r3)) return QC(r3), o2 && yg.isExpanded(o2) && Wg.collapse(n2, { edge: "focus" }), void Wg.move(n2, { unit: "word", reverse: true });
    if (JC.isMoveWordForward(r3)) return QC(r3), o2 && yg.isExpanded(o2) && Wg.collapse(n2, { edge: "focus" }), void Wg.move(n2, { unit: "word" });
    if (JC.isSelectAll(r3)) return QC(r3), void n2.selectAll();
    if (Hy) {
      if ((jy || Ry) && o2 && (JC.isDeleteBackward(r3) || JC.isDeleteForward(r3)) && yg.isCollapsed(o2)) {
        var i2 = ag.parent(n2, o2.anchor.path);
        if (Kh.isElement(i2) && eg.isVoid(n2, i2) && eg.isInline(n2, i2)) return r3.preventDefault(), void Wg.delete(n2, { unit: "block" });
      }
    } else {
      if (JC.isBold(r3) || JC.isItalic(r3) || JC.isTransposeCharacter(r3)) return void QC(r3);
      if (JC.isSplitBlock(r3)) return QC(r3), void eg.insertBreak(n2);
      if (JC.isDeleteBackward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "backward" }) : eg.deleteBackward(n2));
      if (JC.isDeleteForward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "forward" }) : eg.deleteForward(n2));
      if (JC.isDeleteLineBackward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "backward" }) : eg.deleteBackward(n2, { unit: "line" }));
      if (JC.isDeleteLineForward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "forward" }) : eg.deleteForward(n2, { unit: "line" }));
      if (JC.isDeleteWordBackward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "backward" }) : eg.deleteBackward(n2, { unit: "word" }));
      if (JC.isDeleteWordForward(r3)) return QC(r3), void (o2 && yg.isExpanded(o2) ? eg.deleteFragment(n2, { direction: "forward" }) : eg.deleteForward(n2, { unit: "word" }));
    }
  }
}, keypress: function(e10, t2, n2) {
  if (!Hy && !n2.getConfig().readOnly && FC(n2, e10.target)) {
    e10.preventDefault();
    var r3 = e10.key;
    eg.insertText(n2, r3);
  }
}, copy: function(e10, t2, n2) {
  var r3 = e10;
  if (FC(n2, r3.target)) {
    n2.getConfig().readOnly || r3.preventDefault();
    var o2 = r3.clipboardData;
    if (null != o2) {
      n2.setFragmentData(o2);
      var i2 = n2.getConfig().customCopy;
      i2 && i2(n2, r3);
    }
  }
}, cut: function(e10, t2, n2) {
  var r3 = e10, o2 = n2.selection;
  if (!n2.getConfig().readOnly && (r3.preventDefault(), FC(n2, r3.target))) {
    var i2 = r3.clipboardData;
    if (null != i2 && (n2.setFragmentData(i2), o2)) if (yg.isExpanded(o2)) eg.deleteFragment(n2);
    else {
      var a2 = ag.parent(n2, o2.anchor.path);
      eg.isVoid(n2, a2) && Wg.delete(n2);
    }
  }
}, paste: function(e10, t2, n2) {
  Qv.set(n2, true);
  var r3 = e10;
  if (!n2.getConfig().readOnly && FC(n2, r3.target)) {
    var o2 = n2.getConfig().customPaste;
    if (o2) {
      if (false === o2(n2, r3)) return void Qv.set(n2, false);
    }
    if (Ry || !Hy || function(e11) {
      return e11.clipboardData && "" !== e11.clipboardData.getData("text/plain") && 1 === e11.clipboardData.types.length;
    }(r3)) {
      r3.preventDefault();
      var i2 = r3.clipboardData;
      null != i2 && n2.insertData(i2);
    }
  }
}, dragover: function(e10, t2, n2) {
  if (PC(n2, e10.target)) {
    var r3 = zy.toSlateNode(n2, e10.target);
    eg.isVoid(n2, r3) && e10.preventDefault();
  }
}, dragstart: function(e10, t2, n2) {
  var r3 = e10;
  if (PC(n2, r3.target) && !n2.getConfig().readOnly) {
    var o2 = zy.toSlateNode(n2, r3.target), i2 = zy.findPath(n2, o2);
    if (eg.isVoid(n2, o2) || eg.void(n2, { at: i2, voids: true })) {
      var a2 = eg.range(n2, i2);
      Wg.select(n2, a2);
    }
    var s2 = r3.dataTransfer;
    if (null != s2) zy.getSelectedNodeByType(n2, "table") || (t2.isDraggingInternally = true, n2.setFragmentData(s2));
  }
}, dragend: function(e10, t2, n2) {
  var r3 = e10;
  n2.getConfig().readOnly || t2.isDraggingInternally && PC(n2, r3.target) && (t2.isDraggingInternally = false);
}, drop: function(e10, t2, n2) {
  var r3 = e10, o2 = r3.dataTransfer;
  if (!n2.getConfig().readOnly && PC(n2, r3.target) && null != o2 && !(Hy && Ry && o2.files.length > 0)) {
    r3.preventDefault();
    var i2 = n2.selection, a2 = zy.findEventRange(n2, r3);
    Wg.select(n2, a2), t2.isDraggingInternally && (i2 && Wg.delete(n2, { at: i2 }), t2.isDraggingInternally = false), n2.insertData(o2), n2.isFocused() || n2.focus();
  }
} };
function tw(e10) {
  if (nw(e10)) {
    for (; e10 && nw(e10); ) {
      e10 = rw(e10).parent;
    }
    return null != e10 ? e10 : null;
  }
  return e10.parentNode;
}
function nw(e10) {
  return 11 === e10.nodeType;
}
function rw(e10, t2) {
  var n2, r3, o2;
  const i2 = e10;
  return null !== (n2 = i2.parent) && void 0 !== n2 || (i2.parent = null != t2 ? t2 : null), null !== (r3 = i2.firstChildNode) && void 0 !== r3 || (i2.firstChildNode = e10.firstChild), null !== (o2 = i2.lastChildNode) && void 0 !== o2 || (i2.lastChildNode = e10.lastChild), i2;
}
const ow = { createElement: function(e10, t2) {
  return document.createElement(e10, t2);
}, createElementNS: function(e10, t2, n2) {
  return document.createElementNS(e10, t2, n2);
}, createTextNode: function(e10) {
  return document.createTextNode(e10);
}, createDocumentFragment: function() {
  return rw(document.createDocumentFragment());
}, createComment: function(e10) {
  return document.createComment(e10);
}, insertBefore: function(e10, t2, n2) {
  if (nw(e10)) {
    let t3 = e10;
    for (; t3 && nw(t3); ) {
      t3 = rw(t3).parent;
    }
    e10 = null != t3 ? t3 : e10;
  }
  nw(t2) && (t2 = rw(t2, e10)), n2 && nw(n2) && (n2 = rw(n2).firstChildNode), e10.insertBefore(t2, n2);
}, removeChild: function(e10, t2) {
  e10.removeChild(t2);
}, appendChild: function(e10, t2) {
  nw(t2) && (t2 = rw(t2, e10)), e10.appendChild(t2);
}, parentNode: tw, nextSibling: function(e10) {
  var t2;
  if (nw(e10)) {
    const n2 = rw(e10), r3 = tw(n2);
    if (r3 && n2.lastChildNode) {
      const e11 = Array.from(r3.childNodes), o2 = e11.indexOf(n2.lastChildNode);
      return null !== (t2 = e11[o2 + 1]) && void 0 !== t2 ? t2 : null;
    }
    return null;
  }
  return e10.nextSibling;
}, tagName: function(e10) {
  return e10.tagName;
}, setTextContent: function(e10, t2) {
  e10.textContent = t2;
}, getTextContent: function(e10) {
  return e10.textContent;
}, isElement: function(e10) {
  return 1 === e10.nodeType;
}, isText: function(e10) {
  return 3 === e10.nodeType;
}, isComment: function(e10) {
  return 8 === e10.nodeType;
}, isDocumentFragment: nw };
function iw(e10, t2, n2, r3, o2) {
  return { sel: e10, data: t2, children: n2, text: r3, elm: o2, key: void 0 === t2 ? void 0 : t2.key };
}
const aw = Array.isArray;
function sw(e10) {
  return "string" == typeof e10 || "number" == typeof e10 || e10 instanceof String || e10 instanceof Number;
}
const uw = iw("", {}, [], void 0, void 0);
function lw(e10, t2) {
  var n2, r3;
  const o2 = e10.key === t2.key, i2 = (null === (n2 = e10.data) || void 0 === n2 ? void 0 : n2.is) === (null === (r3 = t2.data) || void 0 === r3 ? void 0 : r3.is), a2 = e10.sel === t2.sel, s2 = !(!e10.sel && e10.sel === t2.sel) || typeof e10.text == typeof t2.text;
  return a2 && o2 && i2 && s2;
}
function cw(e10, t2, n2) {
  var r3;
  const o2 = {};
  for (let i2 = t2; i2 <= n2; ++i2) {
    const t3 = null === (r3 = e10[i2]) || void 0 === r3 ? void 0 : r3.key;
    void 0 !== t3 && (o2[t3] = i2);
  }
  return o2;
}
const dw = ["create", "update", "remove", "destroy", "pre", "post"];
function fw(e10, t2, n2) {
  const r3 = { create: [], update: [], remove: [], destroy: [], pre: [], post: [] }, o2 = ow;
  for (const t3 of dw) for (const n3 of e10) {
    const e11 = n3[t3];
    void 0 !== e11 && r3[t3].push(e11);
  }
  function i2(e11) {
    const t3 = e11.id ? "#" + e11.id : "", n3 = e11.getAttribute("class"), r4 = n3 ? "." + n3.split(" ").join(".") : "";
    return iw(o2.tagName(e11).toLowerCase() + t3 + r4, {}, [], void 0, e11);
  }
  function a2(e11) {
    return iw(void 0, {}, [], void 0, e11);
  }
  function s2(e11, t3) {
    return function() {
      if (0 === --t3) {
        const t4 = o2.parentNode(e11);
        null !== t4 && o2.removeChild(t4, e11);
      }
    };
  }
  function u2(e11, t3) {
    var n3, i3, a3;
    let s3;
    const l3 = e11.data, c4 = null == l3 ? void 0 : l3.hook;
    null === (n3 = null == c4 ? void 0 : c4.init) || void 0 === n3 || n3.call(c4, e11);
    const d3 = e11.children, f3 = e11.sel;
    if ("!" === f3) null !== (i3 = e11.text) && void 0 !== i3 || (e11.text = ""), e11.elm = o2.createComment(e11.text);
    else if ("" === f3) e11.elm = o2.createTextNode(e11.text);
    else if (void 0 !== f3) {
      const n4 = f3.indexOf("#"), i4 = f3.indexOf(".", n4), p2 = n4 > 0 ? n4 : f3.length, h2 = i4 > 0 ? i4 : f3.length, g2 = -1 !== n4 || -1 !== i4 ? f3.slice(0, Math.min(p2, h2)) : f3, v2 = null == l3 ? void 0 : l3.ns, m2 = void 0 === v2 ? o2.createElement(g2, l3) : o2.createElementNS(v2, g2, l3);
      for (e11.elm = m2, p2 < h2 && m2.setAttribute("id", f3.slice(p2 + 1, h2)), i4 > 0 && m2.setAttribute("class", f3.slice(h2 + 1).replace(/\./g, " ")), s3 = 0; s3 < r3.create.length; ++s3) r3.create[s3](uw, e11);
      if (!sw(e11.text) || aw(d3) && 0 !== d3.length || o2.appendChild(m2, o2.createTextNode(e11.text)), aw(d3)) for (s3 = 0; s3 < d3.length; ++s3) {
        const e12 = d3[s3];
        null != e12 && o2.appendChild(m2, u2(e12, t3));
      }
      void 0 !== c4 && (null === (a3 = c4.create) || void 0 === a3 || a3.call(c4, uw, e11), void 0 !== c4.insert && t3.push(e11));
    } else e11.elm = o2.createTextNode(e11.text);
    return e11.elm;
  }
  function l2(e11, t3, n3, r4, i3, a3) {
    for (; r4 <= i3; ++r4) {
      const i4 = n3[r4];
      null != i4 && o2.insertBefore(e11, u2(i4, a3), t3);
    }
  }
  function c3(e11) {
    var t3, n3;
    const o3 = e11.data;
    if (void 0 !== o3) {
      null === (n3 = null === (t3 = null == o3 ? void 0 : o3.hook) || void 0 === t3 ? void 0 : t3.destroy) || void 0 === n3 || n3.call(t3, e11);
      for (let t4 = 0; t4 < r3.destroy.length; ++t4) r3.destroy[t4](e11);
      if (void 0 !== e11.children) for (let t4 = 0; t4 < e11.children.length; ++t4) {
        const n4 = e11.children[t4];
        null != n4 && "string" != typeof n4 && c3(n4);
      }
    }
  }
  function d2(e11, t3, n3, i3) {
    for (var a3, u3; n3 <= i3; ++n3) {
      let i4;
      const l3 = t3[n3];
      if (null != l3) if (void 0 !== l3.sel) {
        c3(l3), i4 = r3.remove.length + 1;
        const e12 = s2(l3.elm, i4);
        for (let t5 = 0; t5 < r3.remove.length; ++t5) r3.remove[t5](l3, e12);
        const t4 = null === (u3 = null === (a3 = null == l3 ? void 0 : l3.data) || void 0 === a3 ? void 0 : a3.hook) || void 0 === u3 ? void 0 : u3.remove;
        void 0 !== t4 ? t4(l3, e12) : e12();
      } else l3.children ? (c3(l3), d2(e11, l3.children, 0, l3.children.length - 1)) : o2.removeChild(e11, l3.elm);
    }
  }
  function f2(e11, t3, n3) {
    var i3, a3, s3, c4, p2, h2, g2, v2;
    const m2 = null === (i3 = t3.data) || void 0 === i3 ? void 0 : i3.hook;
    null === (a3 = null == m2 ? void 0 : m2.prepatch) || void 0 === a3 || a3.call(m2, e11, t3);
    const y2 = t3.elm = e11.elm;
    if (e11 === t3) return;
    if (void 0 !== t3.data || void 0 !== t3.text && t3.text !== e11.text) {
      null !== (s3 = t3.data) && void 0 !== s3 || (t3.data = {}), null !== (c4 = e11.data) && void 0 !== c4 || (e11.data = {});
      for (let n4 = 0; n4 < r3.update.length; ++n4) r3.update[n4](e11, t3);
      null === (g2 = null === (h2 = null === (p2 = t3.data) || void 0 === p2 ? void 0 : p2.hook) || void 0 === h2 ? void 0 : h2.update) || void 0 === g2 || g2.call(h2, e11, t3);
    }
    const b2 = e11.children, E2 = t3.children;
    void 0 === t3.text ? void 0 !== b2 && void 0 !== E2 ? b2 !== E2 && function(e12, t4, n4, r4) {
      let i4, a4, s4, c5, p3 = 0, h3 = 0, g3 = t4.length - 1, v6 = t4[0], m3 = t4[g3], y3 = n4.length - 1, b3 = n4[0], E3 = n4[y3];
      for (; p3 <= g3 && h3 <= y3; ) null == v6 ? v6 = t4[++p3] : null == m3 ? m3 = t4[--g3] : null == b3 ? b3 = n4[++h3] : null == E3 ? E3 = n4[--y3] : lw(v6, b3) ? (f2(v6, b3, r4), v6 = t4[++p3], b3 = n4[++h3]) : lw(m3, E3) ? (f2(m3, E3, r4), m3 = t4[--g3], E3 = n4[--y3]) : lw(v6, E3) ? (f2(v6, E3, r4), o2.insertBefore(e12, v6.elm, o2.nextSibling(m3.elm)), v6 = t4[++p3], E3 = n4[--y3]) : lw(m3, b3) ? (f2(m3, b3, r4), o2.insertBefore(e12, m3.elm, v6.elm), m3 = t4[--g3], b3 = n4[++h3]) : (void 0 === i4 && (i4 = cw(t4, p3, g3)), a4 = i4[b3.key], void 0 === a4 ? (o2.insertBefore(e12, u2(b3, r4), v6.elm), b3 = n4[++h3]) : void 0 === i4[E3.key] ? (o2.insertBefore(e12, u2(E3, r4), o2.nextSibling(m3.elm)), E3 = n4[--y3]) : (s4 = t4[a4], s4.sel !== b3.sel ? o2.insertBefore(e12, u2(b3, r4), v6.elm) : (f2(s4, b3, r4), t4[a4] = void 0, o2.insertBefore(e12, s4.elm, v6.elm)), b3 = n4[++h3]));
      h3 <= y3 && (c5 = null == n4[y3 + 1] ? null : n4[y3 + 1].elm, l2(e12, c5, n4, h3, y3, r4)), p3 <= g3 && d2(e12, t4, p3, g3);
    }(y2, b2, E2, n3) : void 0 !== E2 ? (void 0 !== e11.text && o2.setTextContent(y2, ""), l2(y2, null, E2, 0, E2.length - 1, n3)) : void 0 !== b2 ? d2(y2, b2, 0, b2.length - 1) : void 0 !== e11.text && o2.setTextContent(y2, "") : e11.text !== t3.text && (void 0 !== b2 && d2(y2, b2, 0, b2.length - 1), o2.setTextContent(y2, t3.text)), null === (v2 = null == m2 ? void 0 : m2.postpatch) || void 0 === v2 || v2.call(m2, e11, t3);
  }
  return function(e11, t3) {
    let n3, s3, l3;
    const c4 = [];
    for (n3 = 0; n3 < r3.pre.length; ++n3) r3.pre[n3]();
    for (!function(e12, t4) {
      return e12.isElement(t4);
    }(o2, e11) ? function(e12, t4) {
      return e12.isDocumentFragment(t4);
    }(o2, e11) && (e11 = a2(e11)) : e11 = i2(e11), lw(e11, t3) ? f2(e11, t3, c4) : (s3 = e11.elm, l3 = o2.parentNode(s3), u2(t3, c4), null !== l3 && (o2.insertBefore(l3, t3.elm, o2.nextSibling(s3)), d2(l3, [e11], 0, 0))), n3 = 0; n3 < c4.length; ++n3) c4[n3].data.hook.insert(c4[n3]);
    for (n3 = 0; n3 < r3.post.length; ++n3) r3.post[n3]();
    return t3;
  };
}
function pw(e10, t2, n2) {
  if (e10.ns = "http://www.w3.org/2000/svg", "foreignObject" !== n2 && void 0 !== t2) for (let e11 = 0; e11 < t2.length; ++e11) {
    const n3 = t2[e11];
    if ("string" == typeof n3) continue;
    const r3 = n3.data;
    void 0 !== r3 && pw(r3, n3.children, n3.sel);
  }
}
function hw(e10, t2, n2) {
  let r3, o2, i2, a2 = {};
  if (void 0 !== n2 ? (null !== t2 && (a2 = t2), aw(n2) ? r3 = n2 : sw(n2) ? o2 = n2.toString() : n2 && n2.sel && (r3 = [n2])) : null != t2 && (aw(t2) ? r3 = t2 : sw(t2) ? o2 = t2.toString() : t2 && t2.sel ? r3 = [t2] : a2 = t2), void 0 !== r3) for (i2 = 0; i2 < r3.length; ++i2) sw(r3[i2]) && (r3[i2] = iw(void 0, void 0, void 0, r3[i2], void 0));
  return !e10.startsWith("svg") || 3 !== e10.length && "." !== e10[3] && "#" !== e10[3] || pw(a2, r3, e10), iw(e10, a2, r3, o2, void 0);
}
function gw(e10, t2) {
  let n2;
  const r3 = t2.elm;
  let o2 = e10.data.attrs, i2 = t2.data.attrs;
  if ((o2 || i2) && o2 !== i2) {
    for (n2 in o2 = o2 || {}, i2 = i2 || {}, i2) {
      const e11 = i2[n2];
      o2[n2] !== e11 && (true === e11 ? r3.setAttribute(n2, "") : false === e11 ? r3.removeAttribute(n2) : 120 !== n2.charCodeAt(0) ? r3.setAttribute(n2, e11) : 58 === n2.charCodeAt(3) ? r3.setAttributeNS("http://www.w3.org/XML/1998/namespace", n2, e11) : 58 === n2.charCodeAt(5) ? 109 === n2.charCodeAt(1) ? r3.setAttributeNS("http://www.w3.org/2000/xmlns/", n2, e11) : r3.setAttributeNS("http://www.w3.org/1999/xlink", n2, e11) : r3.setAttribute(n2, e11));
    }
    for (n2 in o2) n2 in i2 || r3.removeAttribute(n2);
  }
}
const vw = { create: gw, update: gw };
function mw(e10, t2) {
  let n2, r3;
  const o2 = t2.elm;
  let i2 = e10.data.class, a2 = t2.data.class;
  if ((i2 || a2) && i2 !== a2) {
    for (r3 in i2 = i2 || {}, a2 = a2 || {}, i2) i2[r3] && !Object.prototype.hasOwnProperty.call(a2, r3) && o2.classList.remove(r3);
    for (r3 in a2) n2 = a2[r3], n2 !== i2[r3] && o2.classList[n2 ? "add" : "remove"](r3);
  }
}
const yw = { create: mw, update: mw }, bw = /[A-Z]/g;
function Ew(e10, t2) {
  const n2 = t2.elm;
  let r3, o2 = e10.data.dataset, i2 = t2.data.dataset;
  if (!o2 && !i2) return;
  if (o2 === i2) return;
  o2 = o2 || {}, i2 = i2 || {};
  const a2 = n2.dataset;
  for (r3 in o2) r3 in i2 || (a2 ? r3 in a2 && delete a2[r3] : n2.removeAttribute("data-" + r3.replace(bw, "-$&").toLowerCase()));
  for (r3 in i2) o2[r3] !== i2[r3] && (a2 ? a2[r3] = i2[r3] : n2.setAttribute("data-" + r3.replace(bw, "-$&").toLowerCase(), i2[r3]));
}
const Cw = { create: Ew, update: Ew };
function ww(e10, t2, n2) {
  if ("function" == typeof e10) e10.call(t2, n2, t2);
  else if ("object" == typeof e10) for (let r3 = 0; r3 < e10.length; r3++) ww(e10[r3], t2, n2);
}
function Dw(e10, t2) {
  const n2 = e10.type, r3 = t2.data.on;
  r3 && r3[n2] && ww(r3[n2], t2, e10);
}
function Sw(e10, t2) {
  const n2 = e10.data.on, r3 = e10.listener, o2 = e10.elm, i2 = t2 && t2.data.on, a2 = t2 && t2.elm;
  let s2;
  if (n2 !== i2) {
    if (n2 && r3) if (i2) for (s2 in n2) i2[s2] || o2.removeEventListener(s2, r3, false);
    else for (s2 in n2) o2.removeEventListener(s2, r3, false);
    if (i2) {
      const r4 = t2.listener = e10.listener || function e11(t3) {
        Dw(t3, e11.vnode);
      };
      if (r4.vnode = t2, n2) for (s2 in i2) n2[s2] || a2.addEventListener(s2, r4, false);
      else for (s2 in i2) a2.addEventListener(s2, r4, false);
    }
  }
}
const Aw = { create: Sw, update: Sw, destroy: Sw };
function xw(e10, t2) {
  let n2, r3, o2;
  const i2 = t2.elm;
  let a2 = e10.data.props, s2 = t2.data.props;
  if ((a2 || s2) && a2 !== s2) for (n2 in a2 = a2 || {}, s2 = s2 || {}, s2) r3 = s2[n2], o2 = a2[n2], o2 === r3 || "value" === n2 && i2[n2] === r3 || (i2[n2] = r3);
}
const Ow = { create: xw, update: xw }, Nw = "function" == typeof (null === window || void 0 === window ? void 0 : window.requestAnimationFrame) ? window.requestAnimationFrame.bind(window) : setTimeout;
let Bw = false;
function Tw(e10, t2, n2) {
  ((e11) => {
    Nw(() => {
      Nw(e11);
    });
  })(() => {
    e10[t2] = n2;
  });
}
function kw(e10, t2) {
  let n2, r3;
  const o2 = t2.elm;
  let i2 = e10.data.style, a2 = t2.data.style;
  if (!i2 && !a2) return;
  if (i2 === a2) return;
  i2 = i2 || {}, a2 = a2 || {};
  const s2 = "delayed" in i2;
  for (r3 in i2) r3 in a2 || ("-" === r3[0] && "-" === r3[1] ? o2.style.removeProperty(r3) : o2.style[r3] = "");
  for (r3 in a2) if (n2 = a2[r3], "delayed" === r3 && a2.delayed) for (const e11 in a2.delayed) n2 = a2.delayed[e11], s2 && n2 === i2.delayed[e11] || Tw(o2.style, e11, n2);
  else "remove" !== r3 && n2 !== i2[r3] && ("-" === r3[0] && "-" === r3[1] ? o2.style.setProperty(r3, n2) : o2.style[r3] = n2);
}
const Fw = { pre: function() {
  Bw = false;
}, create: kw, update: kw, destroy: function(e10) {
  let t2, n2;
  const r3 = e10.elm, o2 = e10.data.style;
  if (o2 && (t2 = o2.destroy)) for (n2 in t2) r3.style[n2] = t2[n2];
}, remove: function(e10, t2) {
  const n2 = e10.data.style;
  if (!n2 || !n2.remove) return void t2();
  let r3;
  Bw || (e10.elm.offsetLeft, Bw = true);
  const o2 = e10.elm;
  let i2 = 0;
  const a2 = n2.remove;
  let s2 = 0;
  const u2 = [];
  for (r3 in a2) u2.push(r3), o2.style[r3] = a2[r3];
  const l2 = getComputedStyle(o2)["transition-property"].split(", ");
  for (; i2 < l2.length; ++i2) -1 !== u2.indexOf(l2[i2]) && s2++;
  o2.addEventListener("transitionend", (e11) => {
    e11.target === o2 && --s2, 0 === s2 && t2();
  });
} };
function Iw(e10, t2) {
  for (const n2 of e10) null != n2 && false !== n2 && "" !== n2 && (Array.isArray(n2) ? Iw(n2, t2) : "string" == typeof n2 || "number" == typeof n2 || "boolean" == typeof n2 ? t2.push(iw(void 0, void 0, void 0, String(n2), void 0)) : t2.push(n2));
  return t2;
}
function Pw(e10, t2, ...n2) {
  const r3 = Iw(n2, []);
  return "function" == typeof e10 ? e10(t2, r3) : 1 === r3.length && !r3[0].sel && r3[0].text ? hw(e10, t2, r3[0].text) : hw(e10, t2, r3);
}
var _w = [];
var Rw, Lw, Mw = {};
function jw(e10, t2, n2) {
  return Pw(n2.isInline(e10) ? "span" : "div", null, t2);
}
function Hw(e10, t2) {
  var n2, r3 = zy.findKey(t2, e10), o2 = t2.isInline(e10), i2 = eg.isVoid(t2, e10), a2 = Dy(e10.type, r3.id), s2 = { id: a2, key: r3.id, "data-slate-node": "element", "data-slate-inline": o2 }, u2 = e10.type, l2 = e10.children, c3 = void 0 === l2 ? [] : l2, d2 = function(e11) {
    return Mw[e11] || jw;
  }(u2);
  n2 = i2 ? null : c3.map(function(n3, r4) {
    return Vw(n3, r4, e10, t2);
  });
  var f2 = d2(e10, n2, t2);
  if (i2) {
    s2["data-slate-void"] = true;
    var p2 = o2 ? "span" : "div", h2 = iv(ag.texts(e10), 1), g2 = iv(h2[0], 1)[0], v2 = Pw(p2, { "data-slate-spacer": true, style: { height: "0", color: "transparent", outline: "none", position: "absolute" } }, Vw(g2, 0, e10, t2));
    f2 = Pw(p2, { style: { position: "relative" } }, f2, v2), $v.set(g2, 0), Uv.set(g2, e10);
  }
  return null == f2.data && (f2.data = {}), Object.assign(f2.data, s2), i2 || o2 || (f2 = function(e11, t3) {
    var n3 = t3;
    return _w.forEach(function(r4) {
      n3 = r4(e11, t3);
    }), n3;
  }(e10, f2)), Km(function() {
    var t3 = oy(a2);
    null != t3 && (Gv.set(r3, t3), qv.set(e10, t3), Wv.set(t3, e10));
  }), f2;
}
function zw(e10, t2) {
  return void 0 === t2 && (t2 = false), Pw("span", { "data-slate-string": true }, t2 ? e10 + "\n" : e10);
}
function $w(e10, t2) {
  return void 0 === e10 && (e10 = 0), void 0 === t2 && (t2 = false), Pw("span", { "data-slate-zero-width": t2 ? "n" : "z", "data-slate-length": e10 }, "\uFEFF", t2 ? Pw("br", null) : null);
}
function Uw(e10, t2, n2) {
  if (null == e10.text) throw new Error("Current node is not slate Text ".concat(JSON.stringify(e10)));
  var r3 = zy.findKey(n2, e10), o2 = n2.getConfig().decorate;
  if (null == o2) throw new Error("Can not get config.decorate");
  var i2, a2 = zy.findPath(n2, e10), s2 = o2([e10, a2]), u2 = Og.decorations(e10, s2), l2 = u2.map(function(r4, o3) {
    var i3 = function(e11, t3, n3, r5, o4) {
      void 0 === t3 && (t3 = false);
      var i4 = e11.text, a3 = zy.findPath(o4, n3), s3 = cg.parent(a3);
      if (eg.isEditor(r5)) throw new Error("Text node ".concat(JSON.stringify(n3), " parent is Editor"));
      return o4.isVoid(r5) ? $w(ag.string(r5).length) : "" !== i4 || r5.children[r5.children.length - 1] !== n3 || o4.isInline(r5) || "" !== eg.string(o4, s3) ? "" === i4 ? $w() : t3 && "\n" === i4.slice(-1) ? zw(i4, true) : zw(i4) : $w(0, true);
    }(r4, o3 === u2.length - 1, e10, t2, n2);
    return i3 = function(e11, t3) {
      var n3 = t3;
      return _w.forEach(function(t4) {
        n3 = t4(e11, n3);
      }), n3;
    }(r4, i3), Pw("span", { "data-slate-leaf": true }, i3);
  }), c3 = (i2 = r3.id, "w-e-text-".concat(i2)), d2 = Pw("span", { "data-slate-node": "text", id: c3, key: r3.id }, l2);
  return Km(function() {
    var t3 = oy(c3);
    null != t3 && (Gv.set(r3, t3), qv.set(e10, t3), Wv.set(t3, e10));
  }), d2;
}
function Vw(e10, t2, n2, r3) {
  return $v.set(e10, t2), Uv.set(e10, n2), Kh.isElement(e10) ? Hw(e10, r3) : Uw(e10, n2, r3);
}
var Ww = function() {
  if (Lw) return Rw;
  Lw = 1;
  var e10, t2 = "[object Symbol]", n2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, r3 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, o2 = "\\ud800-\\udfff", i2 = "\\u0300-\\u036f\\ufe20-\\ufe23", a2 = "\\u20d0-\\u20f0", s2 = "\\u2700-\\u27bf", u2 = "a-z\\xdf-\\xf6\\xf8-\\xff", l2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", c3 = "\\ufe0e\\ufe0f", d2 = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", f2 = "['’]", p2 = "[" + o2 + "]", h2 = "[" + d2 + "]", g2 = "[" + i2 + a2 + "]", v2 = "\\d+", m2 = "[" + s2 + "]", b2 = "[" + u2 + "]", E2 = "[^" + o2 + d2 + v2 + s2 + u2 + l2 + "]", C2 = "\\ud83c[\\udffb-\\udfff]", w2 = "[^" + o2 + "]", D2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", S2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", A2 = "[" + l2 + "]", x2 = "\\u200d", O2 = "(?:" + b2 + "|" + E2 + ")", N2 = "(?:" + A2 + "|" + E2 + ")", B2 = "(?:['’](?:d|ll|m|re|s|t|ve))?", T2 = "(?:['’](?:D|LL|M|RE|S|T|VE))?", k2 = "(?:" + g2 + "|" + C2 + ")?", F2 = "[" + c3 + "]?", I2 = F2 + k2 + ("(?:" + x2 + "(?:" + [w2, D2, S2].join("|") + ")" + F2 + k2 + ")*"), P2 = "(?:" + [m2, D2, S2].join("|") + ")" + I2, _2 = "(?:" + [w2 + g2 + "?", g2, D2, S2, p2].join("|") + ")", R2 = RegExp(f2, "g"), L2 = RegExp(g2, "g"), M2 = RegExp(C2 + "(?=" + C2 + ")|" + _2 + I2, "g"), j2 = RegExp([A2 + "?" + b2 + "+" + B2 + "(?=" + [h2, A2, "$"].join("|") + ")", N2 + "+" + T2 + "(?=" + [h2, A2 + O2, "$"].join("|") + ")", A2 + "?" + O2 + "+" + B2, A2 + "+" + T2, v2, P2].join("|"), "g"), H2 = RegExp("[" + x2 + o2 + i2 + a2 + c3 + "]"), z2 = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, $2 = "object" == typeof y && y && y.Object === Object && y, U2 = "object" == typeof self && self && self.Object === Object && self, V2 = $2 || U2 || Function("return this")(), W2 = (e10 = { "À": "A", "Á": "A", "Â": "A", "Ã": "A", "Ä": "A", "Å": "A", "à": "a", "á": "a", "â": "a", "ã": "a", "ä": "a", "å": "a", "Ç": "C", "ç": "c", "Ð": "D", "ð": "d", "È": "E", "É": "E", "Ê": "E", "Ë": "E", "è": "e", "é": "e", "ê": "e", "ë": "e", "Ì": "I", "Í": "I", "Î": "I", "Ï": "I", "ì": "i", "í": "i", "î": "i", "ï": "i", "Ñ": "N", "ñ": "n", "Ò": "O", "Ó": "O", "Ô": "O", "Õ": "O", "Ö": "O", "Ø": "O", "ò": "o", "ó": "o", "ô": "o", "õ": "o", "ö": "o", "ø": "o", "Ù": "U", "Ú": "U", "Û": "U", "Ü": "U", "ù": "u", "ú": "u", "û": "u", "ü": "u", "Ý": "Y", "ý": "y", "ÿ": "y", "Æ": "Ae", "æ": "ae", "Þ": "Th", "þ": "th", "ß": "ss", "Ā": "A", "Ă": "A", "Ą": "A", "ā": "a", "ă": "a", "ą": "a", "Ć": "C", "Ĉ": "C", "Ċ": "C", "Č": "C", "ć": "c", "ĉ": "c", "ċ": "c", "č": "c", "Ď": "D", "Đ": "D", "ď": "d", "đ": "d", "Ē": "E", "Ĕ": "E", "Ė": "E", "Ę": "E", "Ě": "E", "ē": "e", "ĕ": "e", "ė": "e", "ę": "e", "ě": "e", "Ĝ": "G", "Ğ": "G", "Ġ": "G", "Ģ": "G", "ĝ": "g", "ğ": "g", "ġ": "g", "ģ": "g", "Ĥ": "H", "Ħ": "H", "ĥ": "h", "ħ": "h", "Ĩ": "I", "Ī": "I", "Ĭ": "I", "Į": "I", "İ": "I", "ĩ": "i", "ī": "i", "ĭ": "i", "į": "i", "ı": "i", "Ĵ": "J", "ĵ": "j", "Ķ": "K", "ķ": "k", "ĸ": "k", "Ĺ": "L", "Ļ": "L", "Ľ": "L", "Ŀ": "L", "Ł": "L", "ĺ": "l", "ļ": "l", "ľ": "l", "ŀ": "l", "ł": "l", "Ń": "N", "Ņ": "N", "Ň": "N", "Ŋ": "N", "ń": "n", "ņ": "n", "ň": "n", "ŋ": "n", "Ō": "O", "Ŏ": "O", "Ő": "O", "ō": "o", "ŏ": "o", "ő": "o", "Ŕ": "R", "Ŗ": "R", "Ř": "R", "ŕ": "r", "ŗ": "r", "ř": "r", "Ś": "S", "Ŝ": "S", "Ş": "S", "Š": "S", "ś": "s", "ŝ": "s", "ş": "s", "š": "s", "Ţ": "T", "Ť": "T", "Ŧ": "T", "ţ": "t", "ť": "t", "ŧ": "t", "Ũ": "U", "Ū": "U", "Ŭ": "U", "Ů": "U", "Ű": "U", "Ų": "U", "ũ": "u", "ū": "u", "ŭ": "u", "ů": "u", "ű": "u", "ų": "u", "Ŵ": "W", "ŵ": "w", "Ŷ": "Y", "ŷ": "y", "Ÿ": "Y", "Ź": "Z", "Ż": "Z", "Ž": "Z", "ź": "z", "ż": "z", "ž": "z", "Ĳ": "IJ", "ĳ": "ij", "Œ": "Oe", "œ": "oe", "ŉ": "'n", "ſ": "ss" }, function(t3) {
    return null == e10 ? void 0 : e10[t3];
  });
  function G2(e11) {
    return H2.test(e11);
  }
  function q2(e11) {
    return G2(e11) ? function(e12) {
      return e12.match(M2) || [];
    }(e11) : function(e12) {
      return e12.split("");
    }(e11);
  }
  var K2 = Object.prototype.toString, Y2 = V2.Symbol, X2 = Y2 ? Y2.prototype : void 0, Z2 = X2 ? X2.toString : void 0;
  function J2(e11) {
    if ("string" == typeof e11) return e11;
    if (function(e12) {
      return "symbol" == typeof e12 || /* @__PURE__ */ function(e13) {
        return !!e13 && "object" == typeof e13;
      }(e12) && K2.call(e12) == t2;
    }(e11)) return Z2 ? Z2.call(e11) : "";
    var n3 = e11 + "";
    return "0" == n3 && 1 / e11 == -1 / 0 ? "-0" : n3;
  }
  function Q2(e11, t3, n3) {
    var r4 = e11.length;
    return n3 = void 0 === n3 ? r4 : n3, false ? e11 : function(e12, t4, n4) {
      var r5 = -1, o3 = e12.length;
      t4 < 0 && (t4 = -t4 > o3 ? 0 : o3 + t4), (n4 = n4 > o3 ? o3 : n4) < 0 && (n4 += o3), o3 = t4 > n4 ? 0 : n4 - t4 >>> 0, t4 >>>= 0;
      for (var i3 = Array(o3); ++r5 < o3; ) i3[r5] = e12[r5 + t4];
      return i3;
    }(e11, t3, n3);
  }
  function ee2(e11) {
    return null == e11 ? "" : J2(e11);
  }
  var te2, ne2, re2 = (te2 = function(e11, t3, n3) {
    return t3 = t3.toLowerCase(), e11 + (n3 ? oe2(ee2(t3).toLowerCase()) : t3);
  }, function(e11) {
    return function(e12, t3, n3) {
      for (var r4 = -1, o3 = e12 ? e12.length : 0; ++r4 < o3; ) n3 = t3(n3, e12[r4], r4, e12);
      return n3;
    }(function(e12, t3) {
      return e12 = ee2(e12), void 0 === t3 ? function(e13) {
        return z2.test(e13);
      }(e12) ? function(e13) {
        return e13.match(j2) || [];
      }(e12) : function(e13) {
        return e13.match(n2) || [];
      }(e12) : e12.match(t3) || [];
    }(function(e12) {
      return (e12 = ee2(e12)) && e12.replace(r3, W2).replace(L2, "");
    }(e11).replace(R2, "")), te2, "");
  }), oe2 = (ne2 = "toUpperCase", function(e11) {
    var t3 = G2(e11 = ee2(e11)) ? q2(e11) : void 0, n3 = t3 ? t3[0] : e11.charAt(0), r4 = t3 ? Q2(t3, 1).join("") : e11.slice(1);
    return n3[ne2]() + r4;
  });
  return Rw = re2;
}(), Gw = b(Ww);
var qw = ["props", "attrs", "style", "dataset", "on", "hook"];
function Kw(e10) {
  var t2 = e10.data, n2 = void 0 === t2 ? {} : t2, r3 = e10.children, o2 = void 0 === r3 ? [] : r3;
  Object.keys(n2).forEach(function(t3) {
    var r4, o3, i2 = n2[t3];
    if ("key" !== t3) {
      if (!qw.includes(t3)) {
        if (t3.startsWith("data-")) {
          var a2 = t3.slice(5);
          return a2 = Gw(a2), function(e11, t4) {
            null == e11.data && (e11.data = {});
            var n3 = e11.data;
            null == n3.dataset && (n3.dataset = {});
            Object.assign(n3.dataset, t4);
          }(e10, ((r4 = {})[a2] = i2, r4)), void delete n2[t3];
        }
        !function(e11, t4) {
          null == e11.data && (e11.data = {});
          var n3 = e11.data;
          null == n3.props && (n3.props = {});
          Object.assign(n3.props, t4);
        }(e10, (o3 = {}, o3[t3] = i2, o3)), delete n2[t3];
      }
    } else e10.key = i2;
  }), o2.length > 0 && o2.forEach(function(e11) {
    "string" != typeof e11 && Kw(e11);
  });
}
function Yw(e10, t2) {
  var n2, r3, o2 = e10.$scroll, i2 = (n2 = e10.id, "w-e-textarea-".concat(n2)), a2 = t2.getConfig(), s2 = a2.readOnly, u2 = a2.autoFocus, l2 = function(e11, t3) {
    return void 0 === t3 && (t3 = false), hw("div#".concat(e11), { props: { contentEditable: !t3 } });
  }(i2, s2), c3 = t2.children || [];
  l2.children = c3.map(function(e11, n3) {
    if (Hv.has(e11)) {
      var r4 = Hv.get(e11);
      if (r4) {
        var o3 = iv(r4, 2), i3 = o3[0], a3 = o3[1];
        if (a3) return i3 !== n3 && ($v.set(e11, n3), Hv.set(e11, [n3, a3])), a3;
      }
    }
    var s3 = Vw(e11, n3, t2, t2);
    Kw(s3);
    var u3 = t2.getConfig().skipCacheTypes, l3 = void 0 === u3 ? ["list-item"] : u3;
    return Kh.isElement(e11) && l3.includes(e11.type) || Hv.set(e11, [n3, s3]), s3;
  });
  var d2 = Lv.get(e10);
  if (null == d2 && (d2 = true), d2) {
    var f2 = function(e11) {
      return fm('<div\n        id="'.concat(e11, '"\n        data-slate-editor\n        data-slate-node="value"\n        suppressContentEditableWarning\n        role="textarea"\n        spellCheck="true"\n        autoCorrect="true"\n        autoCapitalize="true"\n    ></div>'));
    }(i2);
    o2.append(f2), e10.$textArea = f2, r3 = f2[0], (h2 = fw([yw, Ow, Fw, Cw, Aw, vw]))(r3, l2), Lv.set(e10, false), Mv.set(e10, h2);
  } else {
    var p2 = jv.get(e10), h2 = Mv.get(e10);
    if (null == p2 || null == h2) return;
    r3 = p2.elm, h2(p2, l2);
  }
  if (null != r3 || null != (r3 = oy(i2))) {
    var g2;
    if ((d2 ? u2 : t2.isFocused()) && r3.focus({ preventScroll: true }), d2) {
      var v2 = (g2 = r3) && g2.ownerDocument && g2.ownerDocument.defaultView || null;
      v2 && Yv.set(t2, v2);
    }
    Vv.set(t2, r3), qv.set(t2, r3), Wv.set(r3, t2), jv.set(e10, l2);
  }
}
var Xw = 1, Zw = function() {
  function e10(e11) {
    var t2 = this;
    this.id = Xw++, this.$textArea = null, this.$progressBar = fm('<div class="w-e-progress-bar"></div>'), this.$maxLengthInfo = fm('<div class="w-e-max-length-info"></div>'), this.isComposing = false, this.isUpdatingSelection = false, this.isDraggingInternally = false, this.latestElement = null, this.showPlaceholder = false, this.$placeholder = null, this.latestEditorSelection = null, this.onDOMSelectionChange = kC(function() {
      var e12 = t2.editorInstance;
      !function(e13, t3) {
        var n3 = e13.isComposing, r4 = e13.isUpdatingSelection, o3 = e13.isDraggingInternally;
        if (!(t3.getConfig().readOnly || n3 || r4 || o3)) {
          var i2 = zy.findDocumentOrShadowRoot(t3), a2 = i2.activeElement, s2 = zy.toDOMNode(t3, t3), u2 = i2.getSelection();
          if (a2 !== s2) return Xv.delete(t3), void Wg.deselect(t3);
          if (e13.latestElement = a2, Xv.set(t3, true), !u2) return Wg.deselect(t3);
          var l2 = u2.anchorNode, c3 = u2.focusNode, d2 = FC(t3, l2) || IC(t3, l2), f2 = FC(t3, c3) || IC(t3, c3);
          if (d2 && f2) {
            var p2 = zy.toSlateRange(t3, u2, { exactMatch: false, suppressThrow: false });
            Wg.select(t3, p2);
          }
        }
      }(t2, e12);
    }, 100);
    var n2 = fm(e11);
    if (0 === n2.length) throw new Error("Cannot find textarea DOM by selector '".concat(e11, "'"));
    this.$box = n2;
    var r3 = fm('<div class="w-e-text-container"></div>');
    r3.append(this.$progressBar), r3.append(this.$maxLengthInfo), n2.append(r3);
    var o2 = fm('<div class="w-e-scroll"></div>');
    r3.append(o2), this.$scroll = o2, this.$textAreaContainer = r3, Km(function() {
      var e12 = t2.editorInstance, o3 = zy.getWindow(e12);
      o3.document.addEventListener("selectionchange", t2.onDOMSelectionChange), e12.on(yv, function() {
        o3.document.removeEventListener("selectionchange", t2.onDOMSelectionChange);
      }), r3.on("click", function() {
        return e12.hidePanelOrModal();
      }), e12.on(bv, t2.changeViewState.bind(t2));
      var i2 = e12.getConfig(), a2 = i2.onChange, s2 = i2.scroll;
      a2 && e12.on(bv, function() {
        return a2(e12);
      }), s2 || (n2.css("position", "relative"), r3.addClass("no-scroll")), t2.onFocusAndOnBlur(), e12.on(bv, t2.changeMaxLengthInfo.bind(t2)), t2.bindEvent();
    });
  }
  return Object.defineProperty(e10.prototype, "editorInstance", { get: function() {
    var e11 = Nv.get(this);
    if (null == e11) throw new Error("Can not get editor instance");
    return e11;
  }, enumerable: false, configurable: true }), e10.prototype.bindEvent = function() {
    var e11 = this, t2 = this.$textArea, n2 = this.$scroll, r3 = this.editorInstance;
    null != t2 && (gv(ew, function(n3, o2) {
      t2.on(o2, function(t3) {
        n3(t3, e11, r3);
      });
    }), r3.getConfig().scroll && (n2.css("overflow-y", "auto"), n2.on("scroll", kC(function() {
      r3.emit(Ev);
    }, 100))));
  }, e10.prototype.onFocusAndOnBlur = function() {
    var e11 = this, t2 = this.editorInstance, n2 = t2.getConfig(), r3 = n2.onBlur, o2 = n2.onFocus;
    this.latestEditorSelection = t2.selection, t2.on(bv, function() {
      null == e11.latestEditorSelection && null != t2.selection ? setTimeout(function() {
        return o2 && o2(t2);
      }) : null != e11.latestEditorSelection && null == t2.selection && setTimeout(function() {
        return r3 && r3(t2);
      }), e11.latestEditorSelection = t2.selection;
    });
  }, e10.prototype.changeMaxLengthInfo = function() {
    var e11 = this.editorInstance, t2 = e11.getConfig().maxLength;
    if (t2) {
      var n2 = t2 - zy.getLeftLengthOfMaxLength(e11);
      this.$maxLengthInfo[0].innerHTML = "".concat(n2, "/").concat(t2);
    }
  }, e10.prototype.changeProgress = function(e11) {
    var t2 = this.$progressBar;
    t2.css("width", "".concat(e11, "%")), e11 >= 100 && setTimeout(function() {
      t2.hide(), t2.css("width", "0"), t2.show();
    }, 1e3);
  }, e10.prototype.changeViewState = function() {
    var e11 = this, t2 = this.editorInstance;
    Yw(this, t2), function(e12, t3) {
      var n2, r3 = t3.getConfig().placeholder;
      if (r3) {
        var o2 = t3.isEmpty();
        if (o2 && !e12.showPlaceholder && !e12.isComposing) {
          if (null == e12.$placeholder) {
            var i2 = fm('<div class="w-e-text-placeholder">'.concat(r3, "</div>"));
            e12.$textAreaContainer.append(i2), e12.$placeholder = i2;
          }
          return e12.$placeholder.show(), void (e12.showPlaceholder = true);
        }
        !o2 && e12.showPlaceholder && (null === (n2 = e12.$placeholder) || void 0 === n2 || n2.hide(), e12.showPlaceholder = false);
      }
    }(this, t2), Km(function() {
      $C(e11, t2);
    });
  }, e10.prototype.destroy = function() {
    this.$textAreaContainer.remove();
  }, e10;
}();
function Jw(e10, t2, n2, r3) {
  if ($v.set(e10, t2), Uv.set(e10, n2), Kh.isElement(e10)) {
    var o2 = e10.children;
    if ((void 0 === o2 ? [] : o2).forEach(function(t3, n3) {
      return Jw(t3, n3, e10, r3);
    }), eg.isVoid(r3, e10)) {
      var i2 = iv(ag.texts(e10), 1), a2 = iv(i2[0], 1)[0];
      $v.set(a2, 0), Uv.set(a2, e10);
    }
  }
}
var Qw = { en: "Textarea height < 300px. This may cause modal and hoverbar position error", zh: "编辑区域高度 < 300px 这可能会导致 modal hoverbar 定位异常" };
function eD(e10) {
  var t2 = e10.selector, n2 = void 0 === t2 ? "" : t2, r3 = e10.config, o2 = void 0 === r3 ? {} : r3, i2 = e10.content, a2 = e10.html, s2 = e10.plugins, u2 = void 0 === s2 ? [] : s2, l2 = function(e11) {
    return [Qb, _b2, em, Ib, sE, Jb, eE, Xg].reduce(function(e12, t3) {
      return t3(e12);
    }, e11);
  }(/* @__PURE__ */ (() => {
    var e11 = { children: [], operations: [], selection: null, marks: null, isInline: () => false, isVoid: () => false, onChange: () => {
    }, apply: (t3) => {
      for (var n3 of eg.pathRefs(e11)) dg.transform(n3, t3);
      for (var r4 of eg.pointRefs(e11)) gg.transform(r4, t3);
      for (var o3 of eg.rangeRefs(e11)) bg.transform(o3, t3);
      var i3, a3, s3 = ch.get(e11) || [], u3 = dh.get(e11) || /* @__PURE__ */ new Set(), l3 = (e12) => {
        if (e12) {
          var t4 = e12.join(",");
          a3.has(t4) || (a3.add(t4), i3.push(e12));
        }
      };
      if (cg.operationCanTransformPath(t3)) for (var c4 of (i3 = [], a3 = /* @__PURE__ */ new Set(), s3)) l3(cg.transform(c4, t3));
      else i3 = s3, a3 = u3;
      var d3 = e11.getDirtyPaths(t3);
      for (var f3 of d3) l3(f3);
      ch.set(e11, i3), dh.set(e11, a3), Wg.transform(e11, t3), e11.operations.push(t3), eg.normalize(e11), "set_selection" === t3.type && (e11.marks = null), fh.get(e11) || (fh.set(e11, true), Promise.resolve().then(() => {
        fh.set(e11, false), e11.onChange(), e11.operations = [];
      }));
    }, addMark: (t3, n3) => {
      var { selection: r4 } = e11;
      if (r4) if (yg.isExpanded(r4)) Wg.setNodes(e11, { [t3]: n3 }, { match: Og.isText, split: true });
      else {
        var o3 = yh(yh({}, eg.marks(e11) || {}), {}, { [t3]: n3 });
        e11.marks = o3, fh.get(e11) || e11.onChange();
      }
    }, deleteBackward: (t3) => {
      var { selection: n3 } = e11;
      n3 && yg.isCollapsed(n3) && Wg.delete(e11, { unit: t3, reverse: true });
    }, deleteForward: (t3) => {
      var { selection: n3 } = e11;
      n3 && yg.isCollapsed(n3) && Wg.delete(e11, { unit: t3 });
    }, deleteFragment: (t3) => {
      var { selection: n3 } = e11;
      n3 && yg.isExpanded(n3) && Wg.delete(e11, { reverse: "backward" === t3 });
    }, getFragment: () => {
      var { selection: t3 } = e11;
      return t3 ? ag.fragment(e11, t3) : [];
    }, insertBreak: () => {
      Wg.splitNodes(e11, { always: true });
    }, insertSoftBreak: () => {
      Wg.splitNodes(e11, { always: true });
    }, insertFragment: (t3) => {
      Wg.insertFragment(e11, t3);
    }, insertNode: (t3) => {
      Wg.insertNodes(e11, t3);
    }, insertText: (t3) => {
      var { selection: n3, marks: r4 } = e11;
      if (n3) {
        if (r4) {
          var o3 = yh({ text: t3 }, r4);
          Wg.insertNodes(e11, o3);
        } else Wg.insertText(e11, t3);
        e11.marks = null;
      }
    }, normalizeNode: (t3) => {
      var [n3, r4] = t3;
      if (!Og.isText(n3)) if (Kh.isElement(n3) && 0 === n3.children.length) Wg.insertNodes(e11, { text: "" }, { at: r4.concat(0), voids: true });
      else for (var o3 = !eg.isEditor(n3) && Kh.isElement(n3) && (e11.isInline(n3) || 0 === n3.children.length || Og.isText(n3.children[0]) || e11.isInline(n3.children[0])), i3 = 0, a3 = 0; a3 < n3.children.length; a3++, i3++) {
        var s3 = ag.get(e11, r4);
        if (!Og.isText(s3)) {
          var u3 = n3.children[a3], l3 = s3.children[i3 - 1], c4 = a3 === n3.children.length - 1;
          (Og.isText(u3) || Kh.isElement(u3) && e11.isInline(u3)) !== o3 ? (Wg.removeNodes(e11, { at: r4.concat(i3), voids: true }), i3--) : Kh.isElement(u3) ? e11.isInline(u3) && (null != l3 && Og.isText(l3) ? c4 && (Wg.insertNodes(e11, { text: "" }, { at: r4.concat(i3 + 1), voids: true }), i3++) : (Wg.insertNodes(e11, { text: "" }, { at: r4.concat(i3), voids: true }), i3++)) : null != l3 && Og.isText(l3) && (Og.equals(u3, l3, { loose: true }) ? (Wg.mergeNodes(e11, { at: r4.concat(i3), voids: true }), i3--) : "" === l3.text ? (Wg.removeNodes(e11, { at: r4.concat(i3 - 1), voids: true }), i3--) : "" === u3.text && (Wg.removeNodes(e11, { at: r4.concat(i3), voids: true }), i3--));
        }
      }
    }, removeMark: (t3) => {
      var { selection: n3 } = e11;
      if (n3) if (yg.isExpanded(n3)) Wg.unsetNodes(e11, t3, { match: Og.isText, split: true });
      else {
        var r4 = yh({}, eg.marks(e11) || {});
        delete r4[t3], e11.marks = r4, fh.get(e11) || e11.onChange();
      }
    }, getDirtyPaths: (e12) => {
      switch (e12.type) {
        case "insert_text":
        case "remove_text":
        case "set_node":
          var { path: t3 } = e12;
          return cg.levels(t3);
        case "insert_node":
          var { node: n3, path: r4 } = e12, o3 = cg.levels(r4), i3 = Og.isText(n3) ? [] : Array.from(ag.nodes(n3), (e13) => {
            var [, t4] = e13;
            return r4.concat(t4);
          });
          return [...o3, ...i3];
        case "merge_node":
          var { path: a3 } = e12;
          return [...cg.ancestors(a3), cg.previous(a3)];
        case "move_node":
          var { path: s3, newPath: u3 } = e12;
          if (cg.equals(s3, u3)) return [];
          var l3 = [], c4 = [];
          for (var d3 of cg.ancestors(s3)) {
            var f3 = cg.transform(d3, e12);
            l3.push(f3);
          }
          for (var p3 of cg.ancestors(u3)) {
            var h3 = cg.transform(p3, e12);
            c4.push(h3);
          }
          var g3 = c4[c4.length - 1], v6 = u3[u3.length - 1], m2 = g3.concat(v6);
          return [...l3, ...c4, m2];
        case "remove_node":
          var { path: y2 } = e12;
          return [...cg.ancestors(y2)];
        case "split_node":
          var { path: b2 } = e12;
          return [...cg.levels(b2), cg.next(b2)];
        default:
          return [];
      }
    } };
    return e11;
  })());
  if (n2 && function(e11, t3) {
    return Cy(e11, "data-w-e-textarea", t3);
  }(l2, n2)) throw new Error("Repeated create editor by selector '".concat(n2, "'"));
  var c3 = function(e11) {
    void 0 === e11 && (e11 = {});
    var t3 = pv(vv), n3 = {}, r4 = e11.MENU_CONF, o3 = void 0 === r4 ? {} : r4;
    return gv(t3, function(e12, t4) {
      n3[t4] = tv(tv({}, e12), o3[t4] || {});
    }), delete e11.MENU_CONF, tv({ scroll: true, readOnly: false, autoFocus: true, decorate: function() {
      return [];
    }, maxLength: 0, MENU_CONF: n3, hoverbarKeys: {}, customAlert: function(e12, t4) {
      window.alert("".concat(t4, ":\n").concat(e12));
    } }, e11);
  }(o2);
  Rv.set(l2, c3);
  var d2 = c3.hoverbarKeys, f2 = void 0 === d2 ? {} : d2;
  if (u2.forEach(function(e11) {
    l2 = e11(l2);
  }), function(e11, t3) {
    var n3 = t3.html, r4 = t3.content;
    null != n3 ? e11.children = wy(e11, n3) : r4 && r4.length && (e11.children = r4), 0 === e11.children.length && (e11.children = [{ type: "paragraph", children: [{ text: "" }] }]);
  }(l2, { html: a2, content: i2 }), n2) {
    var p2 = new Zw(n2);
    Ov.set(l2, p2), Nv.set(p2, l2), p2.changeViewState(), Km(function() {
      var e11 = p2.$scroll;
      null != e11 && e11.height() < 300 && console.warn("".concat(Qw.zh, "\n").concat(Qw.en), { element: e11, height: e11.height() });
    });
    var h2 = void 0;
    Object.keys(f2).length > 0 && (h2 = new BC(), kv.set(h2, l2), Fv.set(l2, h2)), l2.on(bv, function() {
      l2.hidePanelOrModal();
    }), l2.on(Ev, function() {
      l2.hidePanelOrModal();
    });
  } else l2.children.forEach(function(e11, t3) {
    return Jw(e11, t3, l2, l2);
  });
  var g2 = c3.onCreated, v2 = c3.onDestroyed;
  return g2 && l2.on(mv, function() {
    return g2(l2);
  }), v2 && l2.on(yv, function() {
    return v2(l2);
  }), Km(function() {
    return l2.emit(mv);
  }), l2;
}
var tD = function() {
  function e10(e11, t2) {
    var n2 = this;
    this.$toolbar = fm('<div class="w-e-bar w-e-bar-show w-e-toolbar"></div>'), this.menus = {}, this.toolbarItems = [], this.config = {}, this.lngListen = function() {
    }, this.changeToolbarState = lE(function() {
      n2.toolbarItems.forEach(function(e12) {
        e12.changeMenuState();
      });
    }, 200), this.config = t2;
    var r3 = fm(e11);
    if (0 === r3.length) throw new Error("Cannot find toolbar DOM by selector '".concat(e11, "'"));
    this.$box = r3;
    var o2 = this.$toolbar;
    o2.on("mousedown", function(e12) {
      return e12.preventDefault();
    }, { passive: false }), r3.append(o2), Km(function() {
      n2.initToolbar(), n2.lngListen = oC(function() {
        return n2.initToolbar();
      }), n2.getEditorInstance().on(bv, n2.changeToolbarState);
    });
  }
  return e10.prototype.getMenus = function() {
    return this.menus;
  }, e10.prototype.getConfig = function() {
    return this.config;
  }, e10.prototype.initToolbar = function() {
    this.menus = {};
    var e11 = this.$toolbar;
    null == e11 || e11.empty(), this.registerItems(), this.changeToolbarState();
  }, e10.prototype.registerItems = function() {
    var e11 = this, t2 = "", n2 = this.$toolbar, r3 = this.config, o2 = r3.toolbarKeys, i2 = void 0 === o2 ? [] : o2, a2 = r3.insertKeys, s2 = void 0 === a2 ? { index: 0, keys: [] } : a2, u2 = r3.excludeKeys, l2 = void 0 === u2 ? [] : u2, c3 = pv(i2), d2 = [];
    d2 = Array.isArray(s2) ? s2 : [s2];
    var f2 = 0;
    d2.forEach(function(e12) {
      var t3 = e12.index + f2;
      if (e12.replaceFn && c3[t3]) {
        var n3 = e12.replaceFn(c3[t3]);
        if (!n3) throw new Error("This function needs to return the menu configuration：string | IMenuGroup");
        c3[t3] = n3;
      }
      e12.keys.length > 0 && ("string" == typeof e12.keys && (e12.keys = [e12.keys]), e12.keys.forEach(function(e13, n4) {
        c3.splice(t3 + n4, 0, e13);
      }), f2 += e12.keys.length);
    });
    var p2 = c3.filter(function(e12) {
      var t3 = "string" == typeof e12 ? e12 : e12.key;
      return !l2.includes(t3);
    }), h2 = p2.length;
    p2.forEach(function(r4, o3) {
      if ("|" === r4) {
        if (0 === o3) return;
        if (o3 + 1 === h2) return;
        if ("|" === t2) return;
        var i3 = uC();
        return n2.append(i3), void (t2 = r4);
      }
      if ("string" == typeof r4) return e11.registerSingleItem(r4, e11), void (t2 = r4);
      e11.registerGroup(r4), t2 = "group";
    });
  }, e10.prototype.registerGroup = function(e11) {
    var t2 = this, n2 = this.$toolbar, r3 = function(e12) {
      return new wC(e12);
    }(e11), o2 = e11.menuKeys, i2 = void 0 === o2 ? [] : o2, a2 = this.config.excludeKeys, s2 = void 0 === a2 ? [] : a2;
    i2.forEach(function(e12) {
      s2.includes(e12) || t2.registerSingleItem(e12, r3);
    }), n2.append(r3.$elem);
  }, e10.prototype.registerSingleItem = function(e11, t2) {
    var n2 = this.getEditorInstance(), r3 = t2 instanceof wC, o2 = this.menus, i2 = o2[e11];
    if (null == i2) {
      var a2 = Av[e11];
      if (null == a2) throw new Error("Not found menu item factory by key '".concat(e11, "'"));
      if ("function" != typeof a2) throw new Error("Menu item factory (key='".concat(e11, "') is not a function"));
      i2 = a2(), o2[e11] = i2;
    } else console.warn("Duplicated toolbar menu key '".concat(e11, "'\n重复注册了菜单栏 menu '").concat(e11, "'"));
    var s2 = n2.getMenuConfig(e11);
    s2 && void 0 !== s2.iconSvg && (i2.iconSvg = s2.iconSvg);
    var u2 = AC(e11, i2, r3);
    (this.toolbarItems.push(u2), Iv.set(u2, n2), r3) ? t2.appendBarItem(u2) : t2.$toolbar.append(u2.$elem);
  }, e10.prototype.getEditorInstance = function() {
    var e11 = Bv.get(this);
    if (null == e11) throw new Error("Can not get editor instance");
    return e11;
  }, e10.prototype.destroy = function() {
    var e11;
    this.$toolbar.remove(), null === (e11 = this.lngListen) || void 0 === e11 || e11.call(this), this.menus = {}, this.toolbarItems = [];
  }, e10;
}();
function nD(e10, t2) {
  if (null == e10) throw new Error("Cannot create toolbar, because editor is null");
  var n2 = t2.selector, r3 = t2.config, o2 = void 0 === r3 ? {} : r3;
  if (function(e11, t3) {
    return Cy(e11, "data-w-e-toolbar", t3);
  }(e10, n2)) throw new Error("Repeated create toolbar by selector '".concat(n2, "'"));
  var i2 = tv({ toolbarKeys: [], excludeKeys: [], insertKeys: { index: 0, keys: [] }, modalAppendToBody: false }, o2 || {}), a2 = new tD(n2, i2);
  return Bv.set(a2, e10), Tv.set(e10, a2), a2;
}
var rD, oD, iD, aD, sD, uD = { exports: {} }, lD = {};
function cD() {
  if (iD) return lD;
  iD = 1, Object.defineProperty(lD, "__esModule", { value: true }), lD.justErrorsLogger = lD.debugLogger = void 0;
  const e10 = function() {
    if (oD) return rD;
    function e11(e12) {
      return e12 < 10 ? `0${e12}` : e12.toString();
    }
    return oD = 1, rD = function() {
      const t3 = /* @__PURE__ */ new Date();
      return `${e11(t3.getHours())}:${e11(t3.getMinutes())}:${e11(t3.getSeconds())}`;
    };
  }(), t2 = { debug: () => {
  }, warn: () => {
  }, error: function() {
    for (var t3 = arguments.length, n3 = new Array(t3), r3 = 0; r3 < t3; r3++) n3[r3] = arguments[r3];
    return console.error(`[Uppy] [${e10()}]`, ...n3);
  } };
  lD.justErrorsLogger = t2;
  const n2 = { debug: function() {
    for (var t3 = arguments.length, n3 = new Array(t3), r3 = 0; r3 < t3; r3++) n3[r3] = arguments[r3];
    return console.debug(`[Uppy] [${e10()}]`, ...n3);
  }, warn: function() {
    for (var t3 = arguments.length, n3 = new Array(t3), r3 = 0; r3 < t3; r3++) n3[r3] = arguments[r3];
    return console.warn(`[Uppy] [${e10()}]`, ...n3);
  }, error: function() {
    for (var t3 = arguments.length, n3 = new Array(t3), r3 = 0; r3 < t3; r3++) n3[r3] = arguments[r3];
    return console.error(`[Uppy] [${e10()}]`, ...n3);
  } };
  return lD.debugLogger = n2, lD;
}
function dD() {
  if (sD) return aD;
  sD = 1;
  return aD = { nanoid: (e10 = 21) => {
    let t2 = "", n2 = 0 | e10;
    for (; n2--; ) t2 += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64 * Math.random() | 0];
    return t2;
  }, customAlphabet: (e10, t2 = 21) => (n2 = t2) => {
    let r3 = "", o2 = 0 | n2;
    for (; o2--; ) r3 += e10[Math.random() * e10.length | 0];
    return r3;
  } }, aD;
}
var fD, pD, hD, gD, vD, mD, yD, bD, ED, CD, wD, DD, SD, AD, xD, OD, ND, BD, TD, kD, FD, ID, PD, _D2, RD, LD, MD, jD, HD, zD, $D, UD = {};
function VD() {
  return pD ? fD : (pD = 1, fD = function(e10) {
    if ("number" != typeof e10 || isNaN(e10)) throw new TypeError("Expected a number, got " + typeof e10);
    var t2 = e10 < 0, n2 = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    if (t2 && (e10 = -e10), e10 < 1) return (t2 ? "-" : "") + e10 + " B";
    var r3 = Math.min(Math.floor(Math.log(e10) / Math.log(1024)), n2.length - 1);
    e10 = Number(e10 / Math.pow(1024, r3));
    var o2 = n2[r3];
    return e10 >= 10 || e10 % 1 == 0 ? (t2 ? "-" : "") + e10.toFixed(0) + " " + o2 : (t2 ? "-" : "") + e10.toFixed(1) + " " + o2;
  });
}
function WD() {
  if (gD) return hD;
  function e10(e11, t2) {
    this.text = e11 = e11 || "", this.hasWild = ~e11.indexOf("*"), this.separator = t2, this.parts = e11.split(t2);
  }
  return gD = 1, e10.prototype.match = function(e11) {
    var t2, n2, r3 = true, o2 = this.parts, i2 = o2.length;
    if ("string" == typeof e11 || e11 instanceof String) if (this.hasWild || this.text == e11) {
      for (n2 = (e11 || "").split(this.separator), t2 = 0; r3 && t2 < i2; t2++) "*" !== o2[t2] && (r3 = t2 < n2.length && o2[t2] === n2[t2]);
      r3 = r3 && n2;
    } else r3 = false;
    else if ("function" == typeof e11.splice) for (r3 = [], t2 = e11.length; t2--; ) this.match(e11[t2]) && (r3[r3.length] = e11[t2]);
    else if ("object" == typeof e11) for (var a2 in r3 = {}, e11) this.match(a2) && (r3[a2] = e11[a2]);
    return r3;
  }, hD = function(t2, n2, r3) {
    var o2 = new e10(t2, r3 || /[\/\.]/);
    return void 0 !== n2 ? o2.match(n2) : o2;
  }, hD;
}
function GD() {
  if (yD) return UD;
  yD = 1, Object.defineProperty(UD, "__esModule", { value: true }), UD.defaultOptions = UD.RestrictionError = UD.Restricter = void 0;
  const e10 = VD(), t2 = function() {
    if (mD) return vD;
    mD = 1;
    var e11 = WD(), t3 = /[\/\+\.]/;
    return vD = function(n3, r3) {
      function o2(r4) {
        var o3 = e11(r4, n3, t3);
        return o3 && o3.length >= 2;
      }
      return r3 ? o2(r3.split(";")[0]) : o2;
    };
  }();
  UD.defaultOptions = { maxFileSize: null, minFileSize: null, maxTotalFileSize: null, maxNumberOfFiles: null, minNumberOfFiles: null, allowedFileTypes: null, requiredMetaFields: [] };
  class n2 extends Error {
    constructor() {
      super(...arguments), this.isRestriction = true;
    }
  }
  UD.RestrictionError = n2, "undefined" == typeof AggregateError && (globalThis.AggregateError = class extends Error {
    constructor(e11, t3) {
      super(t3), this.errors = e11;
    }
  });
  return UD.Restricter = class {
    constructor(e11, t3) {
      this.i18n = t3, this.getOpts = () => {
        const t4 = e11();
        if (null != t4.restrictions.allowedFileTypes && !Array.isArray(t4.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
        return t4;
      };
    }
    validate(r3, o2) {
      const { maxFileSize: i2, minFileSize: a2, maxTotalFileSize: s2, maxNumberOfFiles: u2, allowedFileTypes: l2 } = this.getOpts().restrictions;
      if (u2) {
        const e11 = o2.filter((e12) => !e12.isGhost);
        if (e11.length + 1 > u2) throw new n2(`${this.i18n("youCanOnlyUploadX", { smart_count: u2 })}`);
      }
      if (l2) {
        if (!l2.some((e11) => e11.includes("/") ? !!r3.type && t2(r3.type.replace(/;.*?$/, ""), e11) : !("." !== e11[0] || !r3.extension) && r3.extension.toLowerCase() === e11.slice(1).toLowerCase())) {
          const e11 = l2.join(", ");
          throw new n2(this.i18n("youCanOnlyUploadFileTypes", { types: e11 }));
        }
      }
      if (s2 && null != r3.size) {
        const t3 = o2.reduce((e11, t4) => e11 + t4.size, r3.size);
        if (t3 > s2) throw new n2(this.i18n("exceedsSize", { size: e10(s2), file: r3.name }));
      }
      if (i2 && null != r3.size && r3.size > i2) throw new n2(this.i18n("exceedsSize", { size: e10(i2), file: r3.name }));
      if (a2 && null != r3.size && r3.size < a2) throw new n2(this.i18n("inferiorSize", { size: e10(a2) }));
    }
    validateMinNumberOfFiles(e11) {
      const { minNumberOfFiles: t3 } = this.getOpts().restrictions;
      if (Object.keys(e11).length < t3) throw new n2(this.i18n("youHaveToAtLeastSelectX", { smart_count: t3 }));
    }
    getMissingRequiredMetaFields(e11) {
      const t3 = new n2(this.i18n("missingRequiredMetaFieldOnFile", { fileName: e11.name })), { requiredMetaFields: r3 } = this.getOpts().restrictions, o2 = Object.prototype.hasOwnProperty, i2 = [];
      for (const t4 of r3) o2.call(e11.meta, t4) && "" !== e11.meta[t4] || i2.push(t4);
      return { missingFields: i2, error: t3 };
    }
  }, UD;
}
function qD() {
  if (ED) return bD;
  return ED = 1, bD = function(e10, t2) {
    return Object.prototype.hasOwnProperty.call(e10, t2);
  };
}
function KD() {
  if (wD) return CD;
  function e10(e11, t3) {
    if (!Object.prototype.hasOwnProperty.call(e11, t3)) throw new TypeError("attempted to use private field on non-instance");
    return e11;
  }
  wD = 1;
  var t2 = 0;
  function n2(e11) {
    return "__private_" + t2++ + "_" + e11;
  }
  const r3 = qD();
  function o2(e11, t3, n3) {
    const r4 = [];
    return e11.forEach((e12) => "string" != typeof e12 ? r4.push(e12) : t3[Symbol.split](e12).forEach((e13, t4, o3) => {
      "" !== e13 && r4.push(e13), t4 < o3.length - 1 && r4.push(n3);
    })), r4;
  }
  /**
  	 * Takes a string with placeholder variables like `%{smart_count} file selected`
  	 * and replaces it with values from options `{smart_count: 5}`
  	 *
  	 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
  	 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
  	 *
  	 * @param {string} phrase that needs interpolation, with placeholders
  	 * @param {object} options with values that will be used to replace placeholders
  	 * @returns {any[]} interpolated
  	 */
  function i2(e11, t3) {
    const n3 = /\$/g;
    let r4 = [e11];
    if (null == t3) return r4;
    for (const e12 of Object.keys(t3)) if ("_" !== e12) {
      let i3 = t3[e12];
      "string" == typeof i3 && (i3 = n3[Symbol.replace](i3, "$$$$")), r4 = o2(r4, new RegExp(`%\\{${e12}\\}`, "g"), i3);
    }
    return r4;
  }
  var a2 = n2("apply");
  function s2(e11) {
    if (null == e11 || !e11.strings) return;
    const t3 = this.locale;
    this.locale = { ...t3, strings: { ...t3.strings, ...e11.strings } }, this.locale.pluralize = e11.pluralize || t3.pluralize;
  }
  return CD = class {
    constructor(t3) {
      Object.defineProperty(this, a2, { value: s2 }), this.locale = { strings: {}, pluralize: (e11) => 1 === e11 ? 0 : 1 }, Array.isArray(t3) ? t3.forEach(e10(this, a2)[a2], this) : e10(this, a2)[a2](t3);
    }
    translate(e11, t3) {
      return this.translateArray(e11, t3).join("");
    }
    translateArray(e11, t3) {
      if (!r3(this.locale.strings, e11)) throw new Error(`missing string: ${e11}`);
      const n3 = this.locale.strings[e11];
      if ("object" == typeof n3) {
        if (t3 && void 0 !== t3.smart_count) {
          return i2(n3[this.locale.pluralize(t3.smart_count)], t3);
        }
        throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
      }
      return i2(n3, t3);
    }
  }, CD;
}
function YD() {
  return SD || (SD = 1, DD = function() {
    var e10 = {}, t2 = e10._fns = {};
    return e10.emit = function(e11, n2, r3, o2, i2, a2, s2) {
      var u2 = function(e12) {
        var n3 = t2[e12] ? t2[e12] : [], r4 = e12.indexOf(":"), o3 = -1 === r4 ? [e12] : [e12.substring(0, r4), e12.substring(r4 + 1)], i3 = Object.keys(t2), a3 = 0, s3 = i3.length;
        for (; a3 < s3; a3++) {
          var u3 = i3[a3];
          if ("*" === u3 && (n3 = n3.concat(t2[u3])), 2 === o3.length && o3[0] === u3) {
            n3 = n3.concat(t2[u3]);
            break;
          }
        }
        return n3;
      }(e11);
      u2.length && function(e12, t3, n3) {
        var r4 = 0, o3 = t3.length;
        for (; r4 < o3 && t3[r4]; r4++) t3[r4].event = e12, t3[r4].apply(t3[r4], n3);
      }(e11, u2, [n2, r3, o2, i2, a2, s2]);
    }, e10.on = function(e11, n2) {
      t2[e11] || (t2[e11] = []), t2[e11].push(n2);
    }, e10.once = function(t3, n2) {
      this.on(t3, function r3() {
        n2.apply(this, arguments), e10.off(t3, r3);
      });
    }, e10.off = function(e11, t3) {
      var n2 = [];
      if (e11 && t3) for (var r3 = this._fns[e11], o2 = 0, i2 = r3 ? r3.length : 0; o2 < i2; o2++) r3[o2] !== t3 && n2.push(r3[o2]);
      n2.length ? this._fns[e11] = n2 : delete this._fns[e11];
    }, e10;
  }), DD;
}
function XD() {
  if (xD) return AD;
  xD = 1;
  var e10 = 0;
  function t2(t3) {
    return "__private_" + e10++ + "_" + t3;
  }
  var n2 = t2("publish");
  class r3 {
    constructor() {
      Object.defineProperty(this, n2, { value: o2 }), this.state = {}, this.callbacks = [];
    }
    getState() {
      return this.state;
    }
    setState(e11) {
      const t3 = { ...this.state }, r4 = { ...this.state, ...e11 };
      this.state = r4, function(e12, t4) {
        if (!Object.prototype.hasOwnProperty.call(e12, t4)) throw new TypeError("attempted to use private field on non-instance");
        return e12;
      }(this, n2)[n2](t3, r4, e11);
    }
    subscribe(e11) {
      return this.callbacks.push(e11), () => {
        this.callbacks.splice(this.callbacks.indexOf(e11), 1);
      };
    }
  }
  function o2() {
    for (var e11 = arguments.length, t3 = new Array(e11), n3 = 0; n3 < e11; n3++) t3[n3] = arguments[n3];
    this.callbacks.forEach((e12) => {
      e12(...t3);
    });
  }
  return r3.VERSION = "2.1.1", AD = function() {
    return new r3();
  };
}
function ZD() {
  if (ND) return OD;
  return ND = 1, OD = function(e10) {
    const t2 = e10.lastIndexOf(".");
    return -1 === t2 || t2 === e10.length - 1 ? { name: e10, extension: void 0 } : { name: e10.slice(0, t2), extension: e10.slice(t2 + 1) };
  };
}
function JD() {
  return TD ? BD : (TD = 1, BD = { md: "text/markdown", markdown: "text/markdown", mp4: "video/mp4", mp3: "audio/mp3", svg: "image/svg+xml", jpg: "image/jpeg", png: "image/png", gif: "image/gif", heic: "image/heic", heif: "image/heif", yaml: "text/yaml", yml: "text/yaml", csv: "text/csv", tsv: "text/tab-separated-values", tab: "text/tab-separated-values", avi: "video/x-msvideo", mks: "video/x-matroska", mkv: "video/x-matroska", mov: "video/quicktime", dicom: "application/dicom", doc: "application/msword", docm: "application/vnd.ms-word.document.macroenabled.12", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", dot: "application/msword", dotm: "application/vnd.ms-word.template.macroenabled.12", dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template", xla: "application/vnd.ms-excel", xlam: "application/vnd.ms-excel.addin.macroenabled.12", xlc: "application/vnd.ms-excel", xlf: "application/x-xliff+xml", xlm: "application/vnd.ms-excel", xls: "application/vnd.ms-excel", xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12", xlsm: "application/vnd.ms-excel.sheet.macroenabled.12", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", xlt: "application/vnd.ms-excel", xltm: "application/vnd.ms-excel.template.macroenabled.12", xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template", xlw: "application/vnd.ms-excel", txt: "text/plain", text: "text/plain", conf: "text/plain", log: "text/plain", pdf: "application/pdf", zip: "application/zip", "7z": "application/x-7z-compressed", rar: "application/x-rar-compressed", tar: "application/x-tar", gz: "application/gzip", dmg: "application/x-apple-diskimage" });
}
function QD() {
  if ($D) return zD;
  $D = 1;
  var e10 = dD(), t2 = cD(), n2 = GD();
  let r3, o2;
  function i2(e11, t3) {
    if (!Object.prototype.hasOwnProperty.call(e11, t3)) throw new TypeError("attempted to use private field on non-instance");
    return e11;
  }
  var a2 = 0;
  function s2(e11) {
    return "__private_" + a2++ + "_" + e11;
  }
  const u2 = KD(), l2 = YD(), c3 = TC(), d2 = XD(), f2 = function() {
    if (FD) return kD;
    FD = 1;
    const e11 = ZD(), t3 = JD();
    return kD = function(n3) {
      var r4;
      if (n3.type) return n3.type;
      const o3 = n3.name ? null == (r4 = e11(n3.name).extension) ? void 0 : r4.toLowerCase() : null;
      return o3 && o3 in t3 ? t3[o3] : "application/octet-stream";
    };
  }(), p2 = ZD(), h2 = function() {
    if (PD) return ID;
    function e11(e12) {
      let t3 = "";
      return e12.replace(/[^A-Z0-9]/gi, (e13) => (t3 += `-${function(e14) {
        return e14.charCodeAt(0).toString(32);
      }(e13)}`, "/")) + t3;
    }
    return PD = 1, ID = function(t3) {
      let n3 = "uppy";
      return "string" == typeof t3.name && (n3 += `-${e11(t3.name.toLowerCase())}`), void 0 !== t3.type && (n3 += `-${t3.type}`), t3.meta && "string" == typeof t3.meta.relativePath && (n3 += `-${e11(t3.meta.relativePath.toLowerCase())}`), void 0 !== t3.data.size && (n3 += `-${t3.data.size}`), void 0 !== t3.data.lastModified && (n3 += `-${t3.data.lastModified}`), n3;
    };
  }(), g2 = (RD || (RD = 1, _D2 = function(e11) {
    if (null == e11 && "undefined" != typeof navigator && (e11 = navigator.userAgent), !e11) return true;
    const t3 = /Edge\/(\d+\.\d+)/.exec(e11);
    if (!t3) return true;
    const n3 = t3[1];
    let [r4, o3] = n3.split(".");
    return r4 = parseInt(r4, 10), o3 = parseInt(o3, 10), r4 < 15 || 15 === r4 && o3 < 15063 || r4 > 18 || 18 === r4 && o3 >= 18218;
  }), _D2), v2 = MD ? LD : (MD = 1, LD = function(e11, t3) {
    return t3.name ? t3.name : "image" === e11.split("/")[0] ? `${e11.split("/")[0]}.${e11.split("/")[1]}` : "noname";
  }), m2 = HD ? jD : (HD = 1, jD = { strings: { addBulkFilesFailed: { 0: "Failed to add %{smart_count} file due to an internal error", 1: "Failed to add %{smart_count} files due to internal errors" }, youCanOnlyUploadX: { 0: "You can only upload %{smart_count} file", 1: "You can only upload %{smart_count} files" }, youHaveToAtLeastSelectX: { 0: "You have to select at least %{smart_count} file", 1: "You have to select at least %{smart_count} files" }, exceedsSize: "%{file} exceeds maximum allowed size of %{size}", missingRequiredMetaField: "Missing required meta fields", missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}", inferiorSize: "This file is smaller than the allowed size of %{size}", youCanOnlyUploadFileTypes: "You can only upload: %{types}", noMoreFilesAllowed: "Cannot add more files", noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists", companionError: "Connection with Companion failed", authAborted: "Authentication aborted", companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}", failedToUpload: "Failed to upload %{file}", noInternetConnection: "No Internet connection", connectedToInternet: "Connected to the Internet", noFilesFound: "You have no files or folders here", selectX: { 0: "Select %{smart_count}", 1: "Select %{smart_count}" }, allFilesFromFolderNamed: "All files from folder %{name}", openFolderNamed: "Open folder %{name}", cancel: "Cancel", logOut: "Log out", filter: "Filter", resetFilter: "Reset filter", loading: "Loading...", authenticateWithTitle: "Please authenticate with %{pluginName} to select files", authenticateWith: "Connect to %{pluginName}", signInWithGoogle: "Sign in with Google", searchImages: "Search for images", enterTextToSearch: "Enter text to search for images", search: "Search", emptyFolderAdded: "No files were added from empty folder", folderAlreadyAdded: 'The folder "%{folder}" was already added', folderAdded: { 0: "Added %{smart_count} file from %{folder}", 1: "Added %{smart_count} files from %{folder}" } } });
  var y2 = s2("plugins"), b2 = s2("restricter"), E2 = s2("storeUnsubscribe"), C2 = s2("emitter"), w2 = s2("preProcessors"), D2 = s2("uploaders"), S2 = s2("postProcessors"), A2 = s2("informAndEmit"), x2 = s2("checkRequiredMetaFieldsOnFile"), O2 = s2("checkRequiredMetaFields"), N2 = s2("assertNewUploadAllowed"), B2 = s2("checkAndCreateFileStateObject"), T2 = s2("startIfAutoProceed"), k2 = s2("addListeners"), F2 = s2("updateOnlineStatus"), I2 = s2("createUpload"), P2 = s2("getUpload"), _2 = s2("removeUpload"), R2 = s2("runUpload");
  r3 = Symbol.for("uppy test: getPlugins"), o2 = Symbol.for("uppy test: createUpload");
  class L2 {
    constructor(e11) {
      Object.defineProperty(this, R2, { value: K2 }), Object.defineProperty(this, _2, { value: q2 }), Object.defineProperty(this, P2, { value: G2 }), Object.defineProperty(this, I2, { value: W2 }), Object.defineProperty(this, k2, { value: V2 }), Object.defineProperty(this, T2, { value: U2 }), Object.defineProperty(this, B2, { value: $2 }), Object.defineProperty(this, N2, { value: z2 }), Object.defineProperty(this, O2, { value: H2 }), Object.defineProperty(this, x2, { value: j2 }), Object.defineProperty(this, A2, { value: M2 }), Object.defineProperty(this, y2, { writable: true, value: /* @__PURE__ */ Object.create(null) }), Object.defineProperty(this, b2, { writable: true, value: void 0 }), Object.defineProperty(this, E2, { writable: true, value: void 0 }), Object.defineProperty(this, C2, { writable: true, value: l2() }), Object.defineProperty(this, w2, { writable: true, value: /* @__PURE__ */ new Set() }), Object.defineProperty(this, D2, { writable: true, value: /* @__PURE__ */ new Set() }), Object.defineProperty(this, S2, { writable: true, value: /* @__PURE__ */ new Set() }), Object.defineProperty(this, F2, { writable: true, value: this.updateOnlineStatus.bind(this) }), this.defaultLocale = m2;
      const r4 = { id: "uppy", autoProceed: false, allowMultipleUploads: true, allowMultipleUploadBatches: true, debug: false, restrictions: n2.defaultOptions, meta: {}, onBeforeFileAdded: (e12) => e12, onBeforeUpload: (e12) => e12, store: d2(), logger: t2.justErrorsLogger, infoTimeout: 5e3 };
      this.opts = { ...r4, ...e11, restrictions: { ...r4.restrictions, ...e11 && e11.restrictions } }, e11 && e11.logger && e11.debug ? this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning") : e11 && e11.debug && (this.opts.logger = t2.debugLogger), this.log(`Using Core v${this.constructor.VERSION}`), this.i18nInit(), this.calculateProgress = c3(this.calculateProgress.bind(this), 500, { leading: true, trailing: true }), this.store = this.opts.store, this.setState({ plugins: {}, files: {}, currentUploads: {}, allowNewUpload: true, capabilities: { uploadProgress: g2(), individualCancellation: true, resumableUploads: false }, totalProgress: 0, meta: { ...this.opts.meta }, info: [], recoveredState: null }), i2(this, b2)[b2] = new n2.Restricter(() => this.opts, this.i18n), i2(this, E2)[E2] = this.store.subscribe((e12, t3, n3) => {
        this.emit("state-update", e12, t3, n3), this.updateAll(t3);
      }), this.opts.debug && "undefined" != typeof window && (window[this.opts.id] = this), i2(this, k2)[k2]();
    }
    emit(e11) {
      for (var t3 = arguments.length, n3 = new Array(t3 > 1 ? t3 - 1 : 0), r4 = 1; r4 < t3; r4++) n3[r4 - 1] = arguments[r4];
      i2(this, C2)[C2].emit(e11, ...n3);
    }
    on(e11, t3) {
      return i2(this, C2)[C2].on(e11, t3), this;
    }
    once(e11, t3) {
      return i2(this, C2)[C2].once(e11, t3), this;
    }
    off(e11, t3) {
      return i2(this, C2)[C2].off(e11, t3), this;
    }
    updateAll(e11) {
      this.iteratePlugins((t3) => {
        t3.update(e11);
      });
    }
    setState(e11) {
      this.store.setState(e11);
    }
    getState() {
      return this.store.getState();
    }
    get state() {
      return this.getState();
    }
    setFileState(e11, t3) {
      if (!this.getState().files[e11]) throw new Error(`Can’t set state for ${e11} (the file could have been removed)`);
      this.setState({ files: { ...this.getState().files, [e11]: { ...this.getState().files[e11], ...t3 } } });
    }
    i18nInit() {
      const e11 = new u2([this.defaultLocale, this.opts.locale]);
      this.i18n = e11.translate.bind(e11), this.i18nArray = e11.translateArray.bind(e11), this.locale = e11.locale;
    }
    setOptions(e11) {
      this.opts = { ...this.opts, ...e11, restrictions: { ...this.opts.restrictions, ...e11 && e11.restrictions } }, e11.meta && this.setMeta(e11.meta), this.i18nInit(), e11.locale && this.iteratePlugins((e12) => {
        e12.setOptions();
      }), this.setState();
    }
    resetProgress() {
      const e11 = { percentage: 0, bytesUploaded: 0, uploadComplete: false, uploadStarted: null }, t3 = { ...this.getState().files }, n3 = {};
      Object.keys(t3).forEach((r4) => {
        const o3 = { ...t3[r4] };
        o3.progress = { ...o3.progress, ...e11 }, n3[r4] = o3;
      }), this.setState({ files: n3, totalProgress: 0 }), this.emit("reset-progress");
    }
    addPreProcessor(e11) {
      i2(this, w2)[w2].add(e11);
    }
    removePreProcessor(e11) {
      return i2(this, w2)[w2].delete(e11);
    }
    addPostProcessor(e11) {
      i2(this, S2)[S2].add(e11);
    }
    removePostProcessor(e11) {
      return i2(this, S2)[S2].delete(e11);
    }
    addUploader(e11) {
      i2(this, D2)[D2].add(e11);
    }
    removeUploader(e11) {
      return i2(this, D2)[D2].delete(e11);
    }
    setMeta(e11) {
      const t3 = { ...this.getState().meta, ...e11 }, n3 = { ...this.getState().files };
      Object.keys(n3).forEach((t4) => {
        n3[t4] = { ...n3[t4], meta: { ...n3[t4].meta, ...e11 } };
      }), this.log("Adding metadata:"), this.log(e11), this.setState({ meta: t3, files: n3 });
    }
    setFileMeta(e11, t3) {
      const n3 = { ...this.getState().files };
      if (!n3[e11]) return void this.log("Was trying to set metadata for a file that has been removed: ", e11);
      const r4 = { ...n3[e11].meta, ...t3 };
      n3[e11] = { ...n3[e11], meta: r4 }, this.setState({ files: n3 });
    }
    getFile(e11) {
      return this.getState().files[e11];
    }
    getFiles() {
      const { files: e11 } = this.getState();
      return Object.values(e11);
    }
    getObjectOfFilesPerState() {
      const { files: e11, totalProgress: t3, error: n3 } = this.getState(), r4 = Object.values(e11), o3 = r4.filter((e12) => {
        let { progress: t4 } = e12;
        return !t4.uploadComplete && t4.uploadStarted;
      }), i3 = r4.filter((e12) => !e12.progress.uploadStarted), a3 = r4.filter((e12) => e12.progress.uploadStarted || e12.progress.preprocess || e12.progress.postprocess), s3 = r4.filter((e12) => e12.progress.uploadStarted), u3 = r4.filter((e12) => e12.isPaused), l3 = r4.filter((e12) => e12.progress.uploadComplete), c4 = r4.filter((e12) => e12.error), d3 = o3.filter((e12) => !e12.isPaused), f3 = r4.filter((e12) => e12.progress.preprocess || e12.progress.postprocess);
      return { newFiles: i3, startedFiles: a3, uploadStartedFiles: s3, pausedFiles: u3, completeFiles: l3, erroredFiles: c4, inProgressFiles: o3, inProgressNotPausedFiles: d3, processingFiles: f3, isUploadStarted: s3.length > 0, isAllComplete: 100 === t3 && l3.length === r4.length && 0 === f3.length, isAllErrored: !!n3 && c4.length === r4.length, isAllPaused: 0 !== o3.length && u3.length === o3.length, isUploadInProgress: o3.length > 0, isSomeGhost: r4.some((e12) => e12.isGhost) };
    }
    validateRestrictions(e11, t3) {
      void 0 === t3 && (t3 = this.getFiles());
      try {
        return i2(this, b2)[b2].validate(e11, t3), { result: true };
      } catch (e12) {
        return { result: false, reason: e12.message };
      }
    }
    checkIfFileAlreadyExists(e11) {
      const { files: t3 } = this.getState();
      return !(!t3[e11] || t3[e11].isGhost);
    }
    addFile(e11) {
      i2(this, N2)[N2](e11);
      const { files: t3 } = this.getState();
      let n3 = i2(this, B2)[B2](t3, e11);
      return t3[n3.id] && t3[n3.id].isGhost && (n3 = { ...t3[n3.id], data: e11.data, isGhost: false }, this.log(`Replaced the blob in the restored ghost file: ${n3.name}, ${n3.id}`)), this.setState({ files: { ...t3, [n3.id]: n3 } }), this.emit("file-added", n3), this.emit("files-added", [n3]), this.log(`Added file: ${n3.name}, ${n3.id}, mime type: ${n3.type}`), i2(this, T2)[T2](), n3.id;
    }
    addFiles(e11) {
      i2(this, N2)[N2]();
      const t3 = { ...this.getState().files }, n3 = [], r4 = [];
      for (let o3 = 0; o3 < e11.length; o3++) try {
        let r5 = i2(this, B2)[B2](t3, e11[o3]);
        t3[r5.id] && t3[r5.id].isGhost && (r5 = { ...t3[r5.id], data: e11[o3].data, isGhost: false }, this.log(`Replaced blob in a ghost file: ${r5.name}, ${r5.id}`)), t3[r5.id] = r5, n3.push(r5);
      } catch (e12) {
        e12.isRestriction || r4.push(e12);
      }
      if (this.setState({ files: t3 }), n3.forEach((e12) => {
        this.emit("file-added", e12);
      }), this.emit("files-added", n3), n3.length > 5 ? this.log(`Added batch of ${n3.length} files`) : Object.keys(n3).forEach((e12) => {
        this.log(`Added file: ${n3[e12].name}
 id: ${n3[e12].id}
 type: ${n3[e12].type}`);
      }), n3.length > 0 && i2(this, T2)[T2](), r4.length > 0) {
        let e12 = "Multiple errors occurred while adding files:\n";
        if (r4.forEach((t4) => {
          e12 += `
 * ${t4.message}`;
        }), this.info({ message: this.i18n("addBulkFilesFailed", { smart_count: r4.length }), details: e12 }, "error", this.opts.infoTimeout), "function" == typeof AggregateError) throw new AggregateError(r4, e12);
        {
          const t4 = new Error(e12);
          throw t4.errors = r4, t4;
        }
      }
    }
    removeFiles(e11, t3) {
      const { files: n3, currentUploads: r4 } = this.getState(), o3 = { ...n3 }, i3 = { ...r4 }, a3 = /* @__PURE__ */ Object.create(null);
      function s3(e12) {
        return void 0 === a3[e12];
      }
      e11.forEach((e12) => {
        n3[e12] && (a3[e12] = n3[e12], delete o3[e12]);
      }), Object.keys(i3).forEach((e12) => {
        const t4 = r4[e12].fileIDs.filter(s3);
        if (0 === t4.length) return void delete i3[e12];
        const { capabilities: n4 } = this.getState();
        if (t4.length !== r4[e12].fileIDs.length && !n4.individualCancellation) throw new Error("individualCancellation is disabled");
        i3[e12] = { ...r4[e12], fileIDs: t4 };
      });
      const u3 = { currentUploads: i3, files: o3 };
      0 === Object.keys(o3).length && (u3.allowNewUpload = true, u3.error = null, u3.recoveredState = null), this.setState(u3), this.calculateTotalProgress();
      const l3 = Object.keys(a3);
      l3.forEach((e12) => {
        this.emit("file-removed", a3[e12], t3);
      }), l3.length > 5 ? this.log(`Removed ${l3.length} files`) : this.log(`Removed files: ${l3.join(", ")}`);
    }
    removeFile(e11, t3) {
      void 0 === t3 && (t3 = null), this.removeFiles([e11], t3);
    }
    pauseResume(e11) {
      if (!this.getState().capabilities.resumableUploads || this.getFile(e11).uploadComplete) return;
      const t3 = !(this.getFile(e11).isPaused || false);
      return this.setFileState(e11, { isPaused: t3 }), this.emit("upload-pause", e11, t3), t3;
    }
    pauseAll() {
      const e11 = { ...this.getState().files };
      Object.keys(e11).filter((t3) => !e11[t3].progress.uploadComplete && e11[t3].progress.uploadStarted).forEach((t3) => {
        const n3 = { ...e11[t3], isPaused: true };
        e11[t3] = n3;
      }), this.setState({ files: e11 }), this.emit("pause-all");
    }
    resumeAll() {
      const e11 = { ...this.getState().files };
      Object.keys(e11).filter((t3) => !e11[t3].progress.uploadComplete && e11[t3].progress.uploadStarted).forEach((t3) => {
        const n3 = { ...e11[t3], isPaused: false, error: null };
        e11[t3] = n3;
      }), this.setState({ files: e11 }), this.emit("resume-all");
    }
    retryAll() {
      const e11 = { ...this.getState().files }, t3 = Object.keys(e11).filter((t4) => e11[t4].error);
      if (t3.forEach((t4) => {
        const n4 = { ...e11[t4], isPaused: false, error: null };
        e11[t4] = n4;
      }), this.setState({ files: e11, error: null }), this.emit("retry-all", t3), 0 === t3.length) return Promise.resolve({ successful: [], failed: [] });
      const n3 = i2(this, I2)[I2](t3, { forceAllowNewUpload: true });
      return i2(this, R2)[R2](n3);
    }
    cancelAll(e11) {
      let { reason: t3 = "user" } = void 0 === e11 ? {} : e11;
      if (this.emit("cancel-all", { reason: t3 }), "user" === t3) {
        const { files: e12 } = this.getState(), t4 = Object.keys(e12);
        t4.length && this.removeFiles(t4, "cancel-all"), this.setState({ totalProgress: 0, error: null, recoveredState: null });
      }
    }
    retryUpload(e11) {
      this.setFileState(e11, { error: null, isPaused: false }), this.emit("upload-retry", e11);
      const t3 = i2(this, I2)[I2]([e11], { forceAllowNewUpload: true });
      return i2(this, R2)[R2](t3);
    }
    reset() {
      this.cancelAll(...arguments);
    }
    logout() {
      this.iteratePlugins((e11) => {
        e11.provider && e11.provider.logout && e11.provider.logout();
      });
    }
    calculateProgress(e11, t3) {
      if (null == e11 || !this.getFile(e11.id)) return void this.log(`Not setting progress for a file that has been removed: ${null == e11 ? void 0 : e11.id}`);
      const n3 = Number.isFinite(t3.bytesTotal) && t3.bytesTotal > 0;
      this.setFileState(e11.id, { progress: { ...this.getFile(e11.id).progress, bytesUploaded: t3.bytesUploaded, bytesTotal: t3.bytesTotal, percentage: n3 ? Math.round(t3.bytesUploaded / t3.bytesTotal * 100) : 0 } }), this.calculateTotalProgress();
    }
    calculateTotalProgress() {
      const e11 = this.getFiles().filter((e12) => e12.progress.uploadStarted || e12.progress.preprocess || e12.progress.postprocess);
      if (0 === e11.length) return this.emit("progress", 0), void this.setState({ totalProgress: 0 });
      const t3 = e11.filter((e12) => null != e12.progress.bytesTotal), n3 = e11.filter((e12) => null == e12.progress.bytesTotal);
      if (0 === t3.length) {
        const t4 = 100 * e11.length, r5 = n3.reduce((e12, t5) => e12 + t5.progress.percentage, 0), o4 = Math.round(r5 / t4 * 100);
        return void this.setState({ totalProgress: o4 });
      }
      let r4 = t3.reduce((e12, t4) => e12 + t4.progress.bytesTotal, 0);
      const o3 = r4 / t3.length;
      r4 += o3 * n3.length;
      let i3 = 0;
      t3.forEach((e12) => {
        i3 += e12.progress.bytesUploaded;
      }), n3.forEach((e12) => {
        i3 += o3 * (e12.progress.percentage || 0) / 100;
      });
      let a3 = 0 === r4 ? 0 : Math.round(i3 / r4 * 100);
      a3 > 100 && (a3 = 100), this.setState({ totalProgress: a3 }), this.emit("progress", a3);
    }
    updateOnlineStatus() {
      void 0 === window.navigator.onLine || window.navigator.onLine ? (this.emit("is-online"), this.wasOffline && (this.emit("back-online"), this.info(this.i18n("connectedToInternet"), "success", 3e3), this.wasOffline = false)) : (this.emit("is-offline"), this.info(this.i18n("noInternetConnection"), "error", 0), this.wasOffline = true);
    }
    getID() {
      return this.opts.id;
    }
    use(e11, t3) {
      if ("function" != typeof e11) {
        throw new TypeError(`Expected a plugin class, but got ${null === e11 ? "null" : typeof e11}. Please verify that the plugin was imported and spelled correctly.`);
      }
      const n3 = new e11(this, t3), r4 = n3.id;
      if (!r4) throw new Error("Your plugin must have an id");
      if (!n3.type) throw new Error("Your plugin must have a type");
      const o3 = this.getPlugin(r4);
      if (o3) {
        const e12 = `Already found a plugin named '${o3.id}'. Tried to use: '${r4}'.
Uppy plugins must have unique \`id\` options. See https://uppy.io/docs/plugins/#id.`;
        throw new Error(e12);
      }
      return e11.VERSION && this.log(`Using ${r4} v${e11.VERSION}`), n3.type in i2(this, y2)[y2] ? i2(this, y2)[y2][n3.type].push(n3) : i2(this, y2)[y2][n3.type] = [n3], n3.install(), this;
    }
    getPlugin(e11) {
      for (const t3 of Object.values(i2(this, y2)[y2])) {
        const n3 = t3.find((t4) => t4.id === e11);
        if (null != n3) return n3;
      }
    }
    [r3](e11) {
      return i2(this, y2)[y2][e11];
    }
    iteratePlugins(e11) {
      Object.values(i2(this, y2)[y2]).flat(1).forEach(e11);
    }
    removePlugin(e11) {
      this.log(`Removing plugin ${e11.id}`), this.emit("plugin-remove", e11), e11.uninstall && e11.uninstall();
      const t3 = i2(this, y2)[y2][e11.type], n3 = t3.findIndex((t4) => t4.id === e11.id);
      -1 !== n3 && t3.splice(n3, 1);
      const r4 = { plugins: { ...this.getState().plugins, [e11.id]: void 0 } };
      this.setState(r4);
    }
    close(e11) {
      let { reason: t3 } = void 0 === e11 ? {} : e11;
      this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`), this.cancelAll({ reason: t3 }), i2(this, E2)[E2](), this.iteratePlugins((e12) => {
        this.removePlugin(e12);
      }), "undefined" != typeof window && window.removeEventListener && (window.removeEventListener("online", i2(this, F2)[F2]), window.removeEventListener("offline", i2(this, F2)[F2]));
    }
    hideInfo() {
      const { info: e11 } = this.getState();
      this.setState({ info: e11.slice(1) }), this.emit("info-hidden");
    }
    info(e11, t3, n3) {
      void 0 === t3 && (t3 = "info"), void 0 === n3 && (n3 = 3e3);
      const r4 = "object" == typeof e11;
      this.setState({ info: [...this.getState().info, { type: t3, message: r4 ? e11.message : e11, details: r4 ? e11.details : null }] }), setTimeout(() => this.hideInfo(), n3), this.emit("info-visible");
    }
    log(e11, t3) {
      const { logger: n3 } = this.opts;
      switch (t3) {
        case "error":
          n3.error(e11);
          break;
        case "warning":
          n3.warn(e11);
          break;
        default:
          n3.debug(e11);
      }
    }
    restore(e11) {
      return this.log(`Core: attempting to restore upload "${e11}"`), this.getState().currentUploads[e11] ? i2(this, R2)[R2](e11) : (i2(this, _2)[_2](e11), Promise.reject(new Error("Nonexistent upload")));
    }
    [o2]() {
      return i2(this, I2)[I2](...arguments);
    }
    addResultData(e11, t3) {
      if (!i2(this, P2)[P2](e11)) return void this.log(`Not setting result for an upload that has been removed: ${e11}`);
      const { currentUploads: n3 } = this.getState(), r4 = { ...n3[e11], result: { ...n3[e11].result, ...t3 } };
      this.setState({ currentUploads: { ...n3, [e11]: r4 } });
    }
    upload() {
      var e11;
      null != (e11 = i2(this, y2)[y2].uploader) && e11.length || this.log("No uploader type plugins are used", "warning");
      let { files: t3 } = this.getState();
      const r4 = this.opts.onBeforeUpload(t3);
      return false === r4 ? Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false")) : (r4 && "object" == typeof r4 && (t3 = r4, this.setState({ files: t3 })), Promise.resolve().then(() => i2(this, b2)[b2].validateMinNumberOfFiles(t3)).catch((e12) => {
        throw i2(this, A2)[A2](e12), e12;
      }).then(() => {
        if (!i2(this, O2)[O2](t3)) throw new n2.RestrictionError(this.i18n("missingRequiredMetaField"));
      }).catch((e12) => {
        throw e12;
      }).then(() => {
        const { currentUploads: e12 } = this.getState(), n3 = Object.values(e12).flatMap((e13) => e13.fileIDs), r5 = [];
        Object.keys(t3).forEach((e13) => {
          const t4 = this.getFile(e13);
          t4.progress.uploadStarted || -1 !== n3.indexOf(e13) || r5.push(t4.id);
        });
        const o3 = i2(this, I2)[I2](r5);
        return i2(this, R2)[R2](o3);
      }).catch((e12) => {
        throw this.emit("error", e12), this.log(e12, "error"), e12;
      }));
    }
  }
  function M2(e11, t3) {
    const { message: n3, details: r4 = "" } = e11;
    e11.isRestriction ? this.emit("restriction-failed", t3, e11) : this.emit("error", e11), this.info({ message: n3, details: r4 }, "error", this.opts.infoTimeout), this.log(`${n3} ${r4}`.trim(), "error");
  }
  function j2(e11) {
    const { missingFields: t3, error: n3 } = i2(this, b2)[b2].getMissingRequiredMetaFields(e11);
    return !(t3.length > 0) || (this.setFileState(e11.id, { missingRequiredMetaFields: t3 }), this.log(n3.message), this.emit("restriction-failed", e11, n3), false);
  }
  function H2(e11) {
    let t3 = true;
    for (const n3 of Object.values(e11)) i2(this, x2)[x2](n3) || (t3 = false);
    return t3;
  }
  function z2(e11) {
    const { allowNewUpload: t3 } = this.getState();
    if (false === t3) {
      const t4 = new n2.RestrictionError(this.i18n("noMoreFilesAllowed"));
      throw i2(this, A2)[A2](t4, e11), t4;
    }
  }
  function $2(e11, t3) {
    const r4 = f2(t3), o3 = v2(r4, t3), a3 = p2(o3).extension, s3 = Boolean(t3.isRemote), u3 = h2({ ...t3, type: r4 });
    if (this.checkIfFileAlreadyExists(u3)) {
      const e12 = new n2.RestrictionError(this.i18n("noDuplicates", { fileName: o3 }));
      throw i2(this, A2)[A2](e12, t3), e12;
    }
    const l3 = t3.meta || {};
    l3.name = o3, l3.type = r4;
    const c4 = Number.isFinite(t3.data.size) ? t3.data.size : null;
    let d3 = { source: t3.source || "", id: u3, name: o3, extension: a3 || "", meta: { ...this.getState().meta, ...l3 }, type: r4, data: t3.data, progress: { percentage: 0, bytesUploaded: 0, bytesTotal: c4, uploadComplete: false, uploadStarted: null }, size: c4, isRemote: s3, remote: t3.remote || "", preview: t3.preview };
    const g3 = this.opts.onBeforeFileAdded(d3, e11);
    if (false === g3) {
      const e12 = new n2.RestrictionError("Cannot add the file because onBeforeFileAdded returned false.");
      throw this.emit("restriction-failed", t3, e12), e12;
    }
    "object" == typeof g3 && null !== g3 && (d3 = g3);
    try {
      const t4 = Object.keys(e11).map((t5) => e11[t5]);
      i2(this, b2)[b2].validate(d3, t4);
    } catch (e12) {
      throw i2(this, A2)[A2](e12, d3), e12;
    }
    return d3;
  }
  function U2() {
    this.opts.autoProceed && !this.scheduledAutoProceed && (this.scheduledAutoProceed = setTimeout(() => {
      this.scheduledAutoProceed = null, this.upload().catch((e11) => {
        e11.isRestriction || this.log(e11.stack || e11.message || e11);
      });
    }, 4));
  }
  function V2() {
    const e11 = (e12, t3, n3) => {
      let r4 = e12.message || "Unknown error";
      e12.details && (r4 += ` ${e12.details}`), this.setState({ error: r4 }), null != t3 && t3.id in this.getState().files && this.setFileState(t3.id, { error: r4, response: n3 });
    };
    this.on("error", e11), this.on("upload-error", (t3, n3, r4) => {
      if (e11(n3, t3, r4), "object" == typeof n3 && n3.message) {
        const e12 = new Error(n3.message);
        e12.details = n3.message, n3.details && (e12.details += ` ${n3.details}`), e12.message = this.i18n("failedToUpload", { file: null == t3 ? void 0 : t3.name }), i2(this, A2)[A2](e12);
      } else i2(this, A2)[A2](n3);
    }), this.on("upload", () => {
      this.setState({ error: null });
    }), this.on("upload-started", (e12) => {
      null != e12 && this.getFile(e12.id) ? this.setFileState(e12.id, { progress: { uploadStarted: Date.now(), uploadComplete: false, percentage: 0, bytesUploaded: 0, bytesTotal: e12.size } }) : this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
    }), this.on("upload-progress", this.calculateProgress), this.on("upload-success", (e12, t3) => {
      if (null == e12 || !this.getFile(e12.id)) return void this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
      const n3 = this.getFile(e12.id).progress;
      this.setFileState(e12.id, { progress: { ...n3, postprocess: i2(this, S2)[S2].size > 0 ? { mode: "indeterminate" } : null, uploadComplete: true, percentage: 100, bytesUploaded: n3.bytesTotal }, response: t3, uploadURL: t3.uploadURL, isPaused: false }), null == e12.size && this.setFileState(e12.id, { size: t3.bytesUploaded || n3.bytesTotal }), this.calculateTotalProgress();
    }), this.on("preprocess-progress", (e12, t3) => {
      null != e12 && this.getFile(e12.id) ? this.setFileState(e12.id, { progress: { ...this.getFile(e12.id).progress, preprocess: t3 } }) : this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
    }), this.on("preprocess-complete", (e12) => {
      if (null == e12 || !this.getFile(e12.id)) return void this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
      const t3 = { ...this.getState().files };
      t3[e12.id] = { ...t3[e12.id], progress: { ...t3[e12.id].progress } }, delete t3[e12.id].progress.preprocess, this.setState({ files: t3 });
    }), this.on("postprocess-progress", (e12, t3) => {
      null != e12 && this.getFile(e12.id) ? this.setFileState(e12.id, { progress: { ...this.getState().files[e12.id].progress, postprocess: t3 } }) : this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
    }), this.on("postprocess-complete", (e12) => {
      if (null == e12 || !this.getFile(e12.id)) return void this.log(`Not setting progress for a file that has been removed: ${null == e12 ? void 0 : e12.id}`);
      const t3 = { ...this.getState().files };
      t3[e12.id] = { ...t3[e12.id], progress: { ...t3[e12.id].progress } }, delete t3[e12.id].progress.postprocess, this.setState({ files: t3 });
    }), this.on("restored", () => {
      this.calculateTotalProgress();
    }), this.on("dashboard:file-edit-complete", (e12) => {
      e12 && i2(this, x2)[x2](e12);
    }), "undefined" != typeof window && window.addEventListener && (window.addEventListener("online", i2(this, F2)[F2]), window.addEventListener("offline", i2(this, F2)[F2]), setTimeout(i2(this, F2)[F2], 3e3));
  }
  function W2(t3, n3) {
    void 0 === n3 && (n3 = {});
    const { forceAllowNewUpload: r4 = false } = n3, { allowNewUpload: o3, currentUploads: i3 } = this.getState();
    if (!o3 && !r4) throw new Error("Cannot create a new upload: already uploading.");
    const a3 = (0, e10.nanoid)();
    return this.emit("upload", { id: a3, fileIDs: t3 }), this.setState({ allowNewUpload: false !== this.opts.allowMultipleUploadBatches && false !== this.opts.allowMultipleUploads, currentUploads: { ...i3, [a3]: { fileIDs: t3, step: 0, result: {} } } }), a3;
  }
  function G2(e11) {
    const { currentUploads: t3 } = this.getState();
    return t3[e11];
  }
  function q2(e11) {
    const t3 = { ...this.getState().currentUploads };
    delete t3[e11], this.setState({ currentUploads: t3 });
  }
  async function K2(e11) {
    let { currentUploads: t3 } = this.getState(), n3 = t3[e11];
    const r4 = n3.step || 0, o3 = [...i2(this, w2)[w2], ...i2(this, D2)[D2], ...i2(this, S2)[S2]];
    try {
      for (let i3 = r4; i3 < o3.length && n3; i3++) {
        const r5 = o3[i3], a4 = { ...n3, step: i3 };
        this.setState({ currentUploads: { ...t3, [e11]: a4 } }), await r5(a4.fileIDs, e11), t3 = this.getState().currentUploads, n3 = t3[e11];
      }
    } catch (t4) {
      throw i2(this, _2)[_2](e11), t4;
    }
    if (n3) {
      n3.fileIDs.forEach((e12) => {
        const t4 = this.getFile(e12);
        t4 && t4.progress.postprocess && this.emit("postprocess-complete", t4);
      });
      const r5 = n3.fileIDs.map((e12) => this.getFile(e12)), o4 = r5.filter((e12) => !e12.error), i3 = r5.filter((e12) => e12.error);
      await this.addResultData(e11, { successful: o4, failed: i3, uploadID: e11 }), t3 = this.getState().currentUploads, n3 = t3[e11];
    }
    let a3;
    return n3 && (a3 = n3.result, this.emit("complete", a3), i2(this, _2)[_2](e11)), null == a3 && this.log(`Not setting result for an upload that has been removed: ${e11}`), a3;
  }
  return L2.VERSION = "2.3.4", zD = L2;
}
var eS, tS, nS, rS, oS, iS, aS, sS, uS, lS, cS, dS, fS, pS = {}, hS = [], gS = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, vS = Array.isArray;
function mS(e10, t2) {
  for (var n2 in t2) e10[n2] = t2[n2];
  return e10;
}
function yS(e10) {
  e10 && e10.parentNode && e10.parentNode.removeChild(e10);
}
function bS(e10, t2, n2) {
  var r3, o2, i2, a2 = {};
  for (i2 in t2) "key" == i2 ? r3 = t2[i2] : "ref" == i2 ? o2 = t2[i2] : a2[i2] = t2[i2];
  if (arguments.length > 2 && (a2.children = arguments.length > 3 ? eS.call(arguments, 2) : n2), "function" == typeof e10 && null != e10.defaultProps) for (i2 in e10.defaultProps) void 0 === a2[i2] && (a2[i2] = e10.defaultProps[i2]);
  return ES(e10, a2, r3, o2, null);
}
function ES(e10, t2, n2, r3, o2) {
  var i2 = { type: e10, props: t2, key: n2, ref: r3, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == o2 ? ++nS : o2, __i: -1, __u: 0 };
  return null == o2 && null != tS.vnode && tS.vnode(i2), i2;
}
function CS(e10) {
  return e10.children;
}
function wS(e10, t2) {
  this.props = e10, this.context = t2;
}
function DS(e10, t2) {
  if (null == t2) return e10.__ ? DS(e10.__, e10.__i + 1) : null;
  for (var n2; t2 < e10.__k.length; t2++) if (null != (n2 = e10.__k[t2]) && null != n2.__e) return n2.__e;
  return "function" == typeof e10.type ? DS(e10) : null;
}
function SS(e10) {
  var t2, n2;
  if (null != (e10 = e10.__) && null != e10.__c) {
    for (e10.__e = e10.__c.base = null, t2 = 0; t2 < e10.__k.length; t2++) if (null != (n2 = e10.__k[t2]) && null != n2.__e) {
      e10.__e = e10.__c.base = n2.__e;
      break;
    }
    return SS(e10);
  }
}
function AS(e10) {
  (!e10.__d && (e10.__d = true) && oS.push(e10) && !xS.__r++ || iS != tS.debounceRendering) && ((iS = tS.debounceRendering) || aS)(xS);
}
function xS() {
  for (var e10, t2, n2, r3, o2, i2, a2, s2 = 1; oS.length; ) oS.length > s2 && oS.sort(sS), e10 = oS.shift(), s2 = oS.length, e10.__d && (n2 = void 0, r3 = void 0, o2 = (r3 = (t2 = e10).__v).__e, i2 = [], a2 = [], t2.__P && ((n2 = mS({}, r3)).__v = r3.__v + 1, tS.vnode && tS.vnode(n2), PS(t2.__P, n2, r3, t2.__n, t2.__P.namespaceURI, 32 & r3.__u ? [o2] : null, i2, null == o2 ? DS(r3) : o2, !!(32 & r3.__u), a2), n2.__v = r3.__v, n2.__.__k[n2.__i] = n2, RS(i2, n2, a2), r3.__e = r3.__ = null, n2.__e != o2 && SS(n2)));
  xS.__r = 0;
}
function OS(e10, t2, n2, r3, o2, i2, a2, s2, u2, l2, c3) {
  var d2, f2, p2, h2, g2, v2, m2, y2 = r3 && r3.__k || hS, b2 = t2.length;
  for (u2 = NS(n2, t2, y2, u2, b2), d2 = 0; d2 < b2; d2++) null != (p2 = n2.__k[d2]) && (f2 = -1 == p2.__i ? pS : y2[p2.__i] || pS, p2.__i = d2, v2 = PS(e10, p2, f2, o2, i2, a2, s2, u2, l2, c3), h2 = p2.__e, p2.ref && f2.ref != p2.ref && (f2.ref && jS(f2.ref, null, p2), c3.push(p2.ref, p2.__c || h2, p2)), null == g2 && null != h2 && (g2 = h2), (m2 = !!(4 & p2.__u)) || f2.__k === p2.__k ? u2 = BS(p2, u2, e10, m2) : "function" == typeof p2.type && void 0 !== v2 ? u2 = v2 : h2 && (u2 = h2.nextSibling), p2.__u &= -7);
  return n2.__e = g2, u2;
}
function NS(e10, t2, n2, r3, o2) {
  var i2, a2, s2, u2, l2, c3 = n2.length, d2 = c3, f2 = 0;
  for (e10.__k = new Array(o2), i2 = 0; i2 < o2; i2++) null != (a2 = t2[i2]) && "boolean" != typeof a2 && "function" != typeof a2 ? (u2 = i2 + f2, (a2 = e10.__k[i2] = "string" == typeof a2 || "number" == typeof a2 || "bigint" == typeof a2 || a2.constructor == String ? ES(null, a2, null, null, null) : vS(a2) ? ES(CS, { children: a2 }, null, null, null) : null == a2.constructor && a2.__b > 0 ? ES(a2.type, a2.props, a2.key, a2.ref ? a2.ref : null, a2.__v) : a2).__ = e10, a2.__b = e10.__b + 1, s2 = null, -1 != (l2 = a2.__i = TS(a2, n2, u2, d2)) && (d2--, (s2 = n2[l2]) && (s2.__u |= 2)), null == s2 || null == s2.__v ? (-1 == l2 && (o2 > c3 ? f2-- : o2 < c3 && f2++), "function" != typeof a2.type && (a2.__u |= 4)) : l2 != u2 && (l2 == u2 - 1 ? f2-- : l2 == u2 + 1 ? f2++ : (l2 > u2 ? f2-- : f2++, a2.__u |= 4))) : e10.__k[i2] = null;
  if (d2) for (i2 = 0; i2 < c3; i2++) null != (s2 = n2[i2]) && !(2 & s2.__u) && (s2.__e == r3 && (r3 = DS(s2)), HS(s2, s2));
  return r3;
}
function BS(e10, t2, n2, r3) {
  var o2, i2;
  if ("function" == typeof e10.type) {
    for (o2 = e10.__k, i2 = 0; o2 && i2 < o2.length; i2++) o2[i2] && (o2[i2].__ = e10, t2 = BS(o2[i2], t2, n2, r3));
    return t2;
  }
  e10.__e != t2 && (r3 && (t2 && e10.type && !t2.parentNode && (t2 = DS(e10)), n2.insertBefore(e10.__e, t2 || null)), t2 = e10.__e);
  do {
    t2 = t2 && t2.nextSibling;
  } while (null != t2 && 8 == t2.nodeType);
  return t2;
}
function TS(e10, t2, n2, r3) {
  var o2, i2, a2, s2 = e10.key, u2 = e10.type, l2 = t2[n2], c3 = null != l2 && !(2 & l2.__u);
  if (null === l2 && null == e10.key || c3 && s2 == l2.key && u2 == l2.type) return n2;
  if (r3 > (c3 ? 1 : 0)) {
    for (o2 = n2 - 1, i2 = n2 + 1; o2 >= 0 || i2 < t2.length; ) if (null != (l2 = t2[a2 = o2 >= 0 ? o2-- : i2++]) && !(2 & l2.__u) && s2 == l2.key && u2 == l2.type) return a2;
  }
  return -1;
}
function kS(e10, t2, n2) {
  "-" == t2[0] ? e10.setProperty(t2, null == n2 ? "" : n2) : e10[t2] = null == n2 ? "" : "number" != typeof n2 || gS.test(t2) ? n2 : n2 + "px";
}
function FS(e10, t2, n2, r3, o2) {
  var i2, a2;
  e: if ("style" == t2) if ("string" == typeof n2) e10.style.cssText = n2;
  else {
    if ("string" == typeof r3 && (e10.style.cssText = r3 = ""), r3) for (t2 in r3) n2 && t2 in n2 || kS(e10.style, t2, "");
    if (n2) for (t2 in n2) r3 && n2[t2] == r3[t2] || kS(e10.style, t2, n2[t2]);
  }
  else if ("o" == t2[0] && "n" == t2[1]) i2 = t2 != (t2 = t2.replace(uS, "$1")), a2 = t2.toLowerCase(), t2 = a2 in e10 || "onFocusOut" == t2 || "onFocusIn" == t2 ? a2.slice(2) : t2.slice(2), e10.l || (e10.l = {}), e10.l[t2 + i2] = n2, n2 ? r3 ? n2.u = r3.u : (n2.u = lS, e10.addEventListener(t2, i2 ? dS : cS, i2)) : e10.removeEventListener(t2, i2 ? dS : cS, i2);
  else {
    if ("http://www.w3.org/2000/svg" == o2) t2 = t2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if ("width" != t2 && "height" != t2 && "href" != t2 && "list" != t2 && "form" != t2 && "tabIndex" != t2 && "download" != t2 && "rowSpan" != t2 && "colSpan" != t2 && "role" != t2 && "popover" != t2 && t2 in e10) try {
      e10[t2] = null == n2 ? "" : n2;
      break e;
    } catch (e11) {
    }
    "function" == typeof n2 || (null == n2 || false === n2 && "-" != t2[4] ? e10.removeAttribute(t2) : e10.setAttribute(t2, "popover" == t2 && 1 == n2 ? "" : n2));
  }
}
function IS(e10) {
  return function(t2) {
    if (this.l) {
      var n2 = this.l[t2.type + e10];
      if (null == t2.t) t2.t = lS++;
      else if (t2.t < n2.u) return;
      return n2(tS.event ? tS.event(t2) : t2);
    }
  };
}
function PS(e10, t2, n2, r3, o2, i2, a2, s2, u2, l2) {
  var c3, d2, f2, p2, h2, g2, v2, m2, y2, b2, E2, C2, w2, D2, S2, A2, x2, O2 = t2.type;
  if (null != t2.constructor) return null;
  128 & n2.__u && (u2 = !!(32 & n2.__u), i2 = [s2 = t2.__e = n2.__e]), (c3 = tS.__b) && c3(t2);
  e: if ("function" == typeof O2) try {
    if (m2 = t2.props, y2 = "prototype" in O2 && O2.prototype.render, b2 = (c3 = O2.contextType) && r3[c3.__c], E2 = c3 ? b2 ? b2.props.value : c3.__ : r3, n2.__c ? v2 = (d2 = t2.__c = n2.__c).__ = d2.__E : (y2 ? t2.__c = d2 = new O2(m2, E2) : (t2.__c = d2 = new wS(m2, E2), d2.constructor = O2, d2.render = zS), b2 && b2.sub(d2), d2.props = m2, d2.state || (d2.state = {}), d2.context = E2, d2.__n = r3, f2 = d2.__d = true, d2.__h = [], d2._sb = []), y2 && null == d2.__s && (d2.__s = d2.state), y2 && null != O2.getDerivedStateFromProps && (d2.__s == d2.state && (d2.__s = mS({}, d2.__s)), mS(d2.__s, O2.getDerivedStateFromProps(m2, d2.__s))), p2 = d2.props, h2 = d2.state, d2.__v = t2, f2) y2 && null == O2.getDerivedStateFromProps && null != d2.componentWillMount && d2.componentWillMount(), y2 && null != d2.componentDidMount && d2.__h.push(d2.componentDidMount);
    else {
      if (y2 && null == O2.getDerivedStateFromProps && m2 !== p2 && null != d2.componentWillReceiveProps && d2.componentWillReceiveProps(m2, E2), !d2.__e && null != d2.shouldComponentUpdate && false === d2.shouldComponentUpdate(m2, d2.__s, E2) || t2.__v == n2.__v) {
        for (t2.__v != n2.__v && (d2.props = m2, d2.state = d2.__s, d2.__d = false), t2.__e = n2.__e, t2.__k = n2.__k, t2.__k.some(function(e11) {
          e11 && (e11.__ = t2);
        }), C2 = 0; C2 < d2._sb.length; C2++) d2.__h.push(d2._sb[C2]);
        d2._sb = [], d2.__h.length && a2.push(d2);
        break e;
      }
      null != d2.componentWillUpdate && d2.componentWillUpdate(m2, d2.__s, E2), y2 && null != d2.componentDidUpdate && d2.__h.push(function() {
        d2.componentDidUpdate(p2, h2, g2);
      });
    }
    if (d2.context = E2, d2.props = m2, d2.__P = e10, d2.__e = false, w2 = tS.__r, D2 = 0, y2) {
      for (d2.state = d2.__s, d2.__d = false, w2 && w2(t2), c3 = d2.render(d2.props, d2.state, d2.context), S2 = 0; S2 < d2._sb.length; S2++) d2.__h.push(d2._sb[S2]);
      d2._sb = [];
    } else do {
      d2.__d = false, w2 && w2(t2), c3 = d2.render(d2.props, d2.state, d2.context), d2.state = d2.__s;
    } while (d2.__d && ++D2 < 25);
    d2.state = d2.__s, null != d2.getChildContext && (r3 = mS(mS({}, r3), d2.getChildContext())), y2 && !f2 && null != d2.getSnapshotBeforeUpdate && (g2 = d2.getSnapshotBeforeUpdate(p2, h2)), A2 = c3, null != c3 && c3.type === CS && null == c3.key && (A2 = LS(c3.props.children)), s2 = OS(e10, vS(A2) ? A2 : [A2], t2, n2, r3, o2, i2, a2, s2, u2, l2), d2.base = t2.__e, t2.__u &= -161, d2.__h.length && a2.push(d2), v2 && (d2.__E = d2.__ = null);
  } catch (e11) {
    if (t2.__v = null, u2 || null != i2) if (e11.then) {
      for (t2.__u |= u2 ? 160 : 128; s2 && 8 == s2.nodeType && s2.nextSibling; ) s2 = s2.nextSibling;
      i2[i2.indexOf(s2)] = null, t2.__e = s2;
    } else {
      for (x2 = i2.length; x2--; ) yS(i2[x2]);
      _S(t2);
    }
    else t2.__e = n2.__e, t2.__k = n2.__k, e11.then || _S(t2);
    tS.__e(e11, t2, n2);
  }
  else null == i2 && t2.__v == n2.__v ? (t2.__k = n2.__k, t2.__e = n2.__e) : s2 = t2.__e = MS(n2.__e, t2, n2, r3, o2, i2, a2, u2, l2);
  return (c3 = tS.diffed) && c3(t2), 128 & t2.__u ? void 0 : s2;
}
function _S(e10) {
  e10 && e10.__c && (e10.__c.__e = true), e10 && e10.__k && e10.__k.forEach(_S);
}
function RS(e10, t2, n2) {
  for (var r3 = 0; r3 < n2.length; r3++) jS(n2[r3], n2[++r3], n2[++r3]);
  tS.__c && tS.__c(t2, e10), e10.some(function(t3) {
    try {
      e10 = t3.__h, t3.__h = [], e10.some(function(e11) {
        e11.call(t3);
      });
    } catch (e11) {
      tS.__e(e11, t3.__v);
    }
  });
}
function LS(e10) {
  return "object" != typeof e10 || null == e10 || e10.__b && e10.__b > 0 ? e10 : vS(e10) ? e10.map(LS) : mS({}, e10);
}
function MS(e10, t2, n2, r3, o2, i2, a2, s2, u2) {
  var l2, c3, d2, f2, p2, h2, g2, v2 = n2.props, m2 = t2.props, y2 = t2.type;
  if ("svg" == y2 ? o2 = "http://www.w3.org/2000/svg" : "math" == y2 ? o2 = "http://www.w3.org/1998/Math/MathML" : o2 || (o2 = "http://www.w3.org/1999/xhtml"), null != i2) {
    for (l2 = 0; l2 < i2.length; l2++) if ((p2 = i2[l2]) && "setAttribute" in p2 == !!y2 && (y2 ? p2.localName == y2 : 3 == p2.nodeType)) {
      e10 = p2, i2[l2] = null;
      break;
    }
  }
  if (null == e10) {
    if (null == y2) return document.createTextNode(m2);
    e10 = document.createElementNS(o2, y2, m2.is && m2), s2 && (tS.__m && tS.__m(t2, i2), s2 = false), i2 = null;
  }
  if (null == y2) v2 === m2 || s2 && e10.data == m2 || (e10.data = m2);
  else {
    if (i2 = i2 && eS.call(e10.childNodes), v2 = n2.props || pS, !s2 && null != i2) for (v2 = {}, l2 = 0; l2 < e10.attributes.length; l2++) v2[(p2 = e10.attributes[l2]).name] = p2.value;
    for (l2 in v2) if (p2 = v2[l2], "children" == l2) ;
    else if ("dangerouslySetInnerHTML" == l2) d2 = p2;
    else if (!(l2 in m2)) {
      if ("value" == l2 && "defaultValue" in m2 || "checked" == l2 && "defaultChecked" in m2) continue;
      FS(e10, l2, null, p2, o2);
    }
    for (l2 in m2) p2 = m2[l2], "children" == l2 ? f2 = p2 : "dangerouslySetInnerHTML" == l2 ? c3 = p2 : "value" == l2 ? h2 = p2 : "checked" == l2 ? g2 = p2 : s2 && "function" != typeof p2 || v2[l2] === p2 || FS(e10, l2, p2, v2[l2], o2);
    if (c3) s2 || d2 && (c3.__html == d2.__html || c3.__html == e10.innerHTML) || (e10.innerHTML = c3.__html), t2.__k = [];
    else if (d2 && (e10.innerHTML = ""), OS("template" == t2.type ? e10.content : e10, vS(f2) ? f2 : [f2], t2, n2, r3, "foreignObject" == y2 ? "http://www.w3.org/1999/xhtml" : o2, i2, a2, i2 ? i2[0] : n2.__k && DS(n2, 0), s2, u2), null != i2) for (l2 = i2.length; l2--; ) yS(i2[l2]);
    s2 || (l2 = "value", "progress" == y2 && null == h2 ? e10.removeAttribute("value") : null != h2 && (h2 !== e10[l2] || "progress" == y2 && !h2 || "option" == y2 && h2 != v2[l2]) && FS(e10, l2, h2, v2[l2], o2), l2 = "checked", null != g2 && g2 != e10[l2] && FS(e10, l2, g2, v2[l2], o2));
  }
  return e10;
}
function jS(e10, t2, n2) {
  try {
    if ("function" == typeof e10) {
      var r3 = "function" == typeof e10.__u;
      r3 && e10.__u(), r3 && null == t2 || (e10.__u = e10(t2));
    } else e10.current = t2;
  } catch (e11) {
    tS.__e(e11, n2);
  }
}
function HS(e10, t2, n2) {
  var r3, o2;
  if (tS.unmount && tS.unmount(e10), (r3 = e10.ref) && (r3.current && r3.current != e10.__e || jS(r3, null, t2)), null != (r3 = e10.__c)) {
    if (r3.componentWillUnmount) try {
      r3.componentWillUnmount();
    } catch (e11) {
      tS.__e(e11, t2);
    }
    r3.base = r3.__P = null;
  }
  if (r3 = e10.__k) for (o2 = 0; o2 < r3.length; o2++) r3[o2] && HS(r3[o2], t2, n2 || "function" != typeof e10.type);
  n2 || yS(e10.__e), e10.__c = e10.__ = e10.__e = void 0;
}
function zS(e10, t2, n2) {
  return this.constructor(e10, n2);
}
function $S(e10, t2, n2) {
  var r3, o2, i2, a2;
  t2 == document && (t2 = document.documentElement), tS.__ && tS.__(e10, t2), o2 = (r3 = "function" == typeof n2) ? null : n2 && n2.__k || t2.__k, i2 = [], a2 = [], PS(t2, e10 = (!r3 && n2 || t2).__k = bS(CS, null, [e10]), o2 || pS, pS, t2.namespaceURI, !r3 && n2 ? [n2] : o2 ? null : t2.firstChild ? eS.call(t2.childNodes) : null, i2, !r3 && n2 ? n2 : o2 ? o2.__e : t2.firstChild, r3, a2), RS(i2, e10, a2);
}
eS = hS.slice, tS = { __e: function(e10, t2, n2, r3) {
  for (var o2, i2, a2; t2 = t2.__; ) if ((o2 = t2.__c) && !o2.__) try {
    if ((i2 = o2.constructor) && null != i2.getDerivedStateFromError && (o2.setState(i2.getDerivedStateFromError(e10)), a2 = o2.__d), null != o2.componentDidCatch && (o2.componentDidCatch(e10, r3 || {}), a2 = o2.__d), a2) return o2.__E = o2;
  } catch (t3) {
    e10 = t3;
  }
  throw e10;
} }, nS = 0, rS = function(e10) {
  return null != e10 && null == e10.constructor;
}, wS.prototype.setState = function(e10, t2) {
  var n2;
  n2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = mS({}, this.state), "function" == typeof e10 && (e10 = e10(mS({}, n2), this.props)), e10 && mS(n2, e10), null != e10 && this.__v && (t2 && this._sb.push(t2), AS(this));
}, wS.prototype.forceUpdate = function(e10) {
  this.__v && (this.__e = true, e10 && this.__h.push(e10), AS(this));
}, wS.prototype.render = CS, oS = [], aS = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, sS = function(e10, t2) {
  return e10.__v.__b - t2.__v.__b;
}, xS.__r = 0, uS = /(PointerCapture)$|Capture$/i, lS = 0, cS = IS(false), dS = IS(true), fS = 0;
var US, VS, WS, GS, qS, KS, YS, XS, ZS, JS, QS, eA = Object.freeze({ __proto__: null, Component: wS, Fragment: CS, cloneElement: function(e10, t2, n2) {
  var r3, o2, i2, a2, s2 = mS({}, e10.props);
  for (i2 in e10.type && e10.type.defaultProps && (a2 = e10.type.defaultProps), t2) "key" == i2 ? r3 = t2[i2] : "ref" == i2 ? o2 = t2[i2] : s2[i2] = void 0 === t2[i2] && null != a2 ? a2[i2] : t2[i2];
  return arguments.length > 2 && (s2.children = arguments.length > 3 ? eS.call(arguments, 2) : n2), ES(e10.type, s2, r3 || e10.key, o2 || e10.ref, null);
}, createContext: function(e10) {
  function t2(e11) {
    var n2, r3;
    return this.getChildContext || (n2 = /* @__PURE__ */ new Set(), (r3 = {})[t2.__c] = this, this.getChildContext = function() {
      return r3;
    }, this.componentWillUnmount = function() {
      n2 = null;
    }, this.shouldComponentUpdate = function(e12) {
      this.props.value != e12.value && n2.forEach(function(e13) {
        e13.__e = true, AS(e13);
      });
    }, this.sub = function(e12) {
      n2.add(e12);
      var t3 = e12.componentWillUnmount;
      e12.componentWillUnmount = function() {
        n2 && n2.delete(e12), t3 && t3.call(e12);
      };
    }), e11.children;
  }
  return t2.__c = "__cC" + fS++, t2.__ = e10, t2.Provider = t2.__l = (t2.Consumer = function(e11, t3) {
    return e11.children(t3);
  }).contextType = t2, t2;
}, createElement: bS, createRef: function() {
  return { current: null };
}, h: bS, hydrate: function e8(t2, n2) {
  $S(t2, n2, e8);
}, get isValidElement() {
  return rS;
}, get options() {
  return tS;
}, render: $S, toChildArray: function e9(t2, n2) {
  return n2 = n2 || [], null == t2 || "boolean" == typeof t2 || (vS(t2) ? t2.some(function(t3) {
    e9(t3, n2);
  }) : n2.push(t2)), n2;
} }), tA = E(eA);
function nA() {
  if (GS) return WS;
  GS = 1;
  const e10 = VS ? US : (VS = 1, US = function(e11) {
    return (null == e11 ? void 0 : e11.nodeType) === Node.ELEMENT_NODE;
  });
  return WS = function(t2, n2) {
    return void 0 === n2 && (n2 = document), "string" == typeof t2 ? n2.querySelector(t2) : e10(t2) ? t2 : null;
  };
}
function rA() {
  if (XS) return YS;
  XS = 1;
  const e10 = KD();
  return YS = class {
    constructor(e11, t2) {
      void 0 === t2 && (t2 = {}), this.uppy = e11, this.opts = t2;
    }
    getPluginState() {
      const { plugins: e11 } = this.uppy.getState();
      return e11[this.id] || {};
    }
    setPluginState(e11) {
      const { plugins: t2 } = this.uppy.getState();
      this.uppy.setState({ plugins: { ...t2, [this.id]: { ...t2[this.id], ...e11 } } });
    }
    setOptions(e11) {
      this.opts = { ...this.opts, ...e11 }, this.setPluginState(), this.i18nInit();
    }
    i18nInit() {
      const t2 = new e10([this.defaultLocale, this.uppy.locale, this.opts.locale]);
      this.i18n = t2.translate.bind(t2), this.i18nArray = t2.translateArray.bind(t2), this.setPluginState();
    }
    addTarget() {
      throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {
    }
    uninstall() {
    }
    render() {
      throw new Error("Extend the render method to add your plugin to a DOM element");
    }
    update() {
    }
    afterUpdate() {
    }
  };
}
function oA() {
  if (JS) return ZS;
  JS = 1;
  var e10 = tA;
  function t2(e11, t3) {
    if (!Object.prototype.hasOwnProperty.call(e11, t3)) throw new TypeError("attempted to use private field on non-instance");
    return e11;
  }
  var n2 = 0;
  function r3(e11) {
    return "__private_" + n2++ + "_" + e11;
  }
  const o2 = nA(), i2 = KS ? qS : (KS = 1, qS = function(e11) {
    for (var t3; e11 && !e11.dir; ) e11 = e11.parentNode;
    return null == (t3 = e11) ? void 0 : t3.dir;
  }), a2 = rA();
  var s2 = r3("updateUI");
  class u2 extends a2 {
    constructor() {
      super(...arguments), Object.defineProperty(this, s2, { writable: true, value: void 0 });
    }
    mount(n3, r4) {
      const a3 = r4.id, l2 = o2(n3);
      if (l2) {
        this.isTargetDOMEl = true;
        const r5 = document.createElement("div");
        return r5.classList.add("uppy-Root"), t2(this, s2)[s2] = /* @__PURE__ */ function(e11) {
          let t3 = null, n4 = null;
          return function() {
            for (var r6 = arguments.length, o3 = new Array(r6), i3 = 0; i3 < r6; i3++) o3[i3] = arguments[i3];
            return n4 = o3, t3 || (t3 = Promise.resolve().then(() => (t3 = null, e11(...n4)))), t3;
          };
        }((t3) => {
          this.uppy.getPlugin(this.id) && ((0, e10.render)(this.render(t3), r5), this.afterUpdate());
        }), this.uppy.log(`Installing ${a3} to a DOM element '${n3}'`), this.opts.replaceTargetContent && (l2.innerHTML = ""), (0, e10.render)(this.render(this.uppy.getState()), r5), this.el = r5, l2.appendChild(r5), r5.dir = this.opts.direction || i2(r5) || "ltr", this.onMount(), this.el;
      }
      let c3;
      if ("object" == typeof n3 && n3 instanceof u2) c3 = n3;
      else if ("function" == typeof n3) {
        const e11 = n3;
        this.uppy.iteratePlugins((t3) => {
          t3 instanceof e11 && (c3 = t3);
        });
      }
      if (c3) return this.uppy.log(`Installing ${a3} to ${c3.id}`), this.parent = c3, this.el = c3.addTarget(r4), this.onMount(), this.el;
      this.uppy.log(`Not installing ${a3}`);
      let d2 = `Invalid target option given to ${a3}.`;
      throw d2 += "function" == typeof n3 ? " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly." : "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.", new Error(d2);
    }
    update(e11) {
      var n3, r4;
      null != this.el && (null == (n3 = (r4 = t2(this, s2))[s2]) || n3.call(r4, e11));
    }
    unmount() {
      var e11;
      this.isTargetDOMEl && (null == (e11 = this.el) || e11.remove());
      this.onUnmount();
    }
    onMount() {
    }
    onUnmount() {
    }
  }
  return ZS = u2;
}
var iA, aA, sA, uA, lA, cA, dA, fA, pA, hA, gA = (QS || (QS = 1, function(e10, t2) {
  Object.defineProperty(t2, "__esModule", { value: true }), t2.Uppy = t2.UIPlugin = t2.BasePlugin = void 0, Object.defineProperty(t2, "debugLogger", { enumerable: true, get: function() {
    return n2.debugLogger;
  } });
  var n2 = cD();
  e10.exports = QD();
  const r3 = oA();
  t2.UIPlugin = r3;
  const o2 = rA();
  t2.BasePlugin = o2;
  const i2 = QD();
  t2.Uppy = i2;
  const a2 = oA(), s2 = rA();
  i2.Uppy = i2, i2.UIPlugin = a2, i2.BasePlugin = s2, i2.debugLogger = n2.debugLogger;
}(uD, uD.exports)), uD.exports), vA = b(gA), mA = {};
function yA() {
  if (aA) return iA;
  aA = 1;
  class e10 extends Error {
    constructor(e11, t2) {
      void 0 === t2 && (t2 = null), super("This looks like a network error, the endpoint might be blocked by an internet provider or a firewall."), this.cause = e11, this.isNetworkError = true, this.request = t2;
    }
  }
  return iA = e10;
}
function bA() {
  if (hA) return pA;
  let e10;
  function t2(e11, t3) {
    if (!Object.prototype.hasOwnProperty.call(e11, t3)) throw new TypeError("attempted to use private field on non-instance");
    return e11;
  }
  hA = 1;
  var n2 = 0;
  function r3(e11) {
    return "__private_" + n2++ + "_" + e11;
  }
  const o2 = function() {
    if (uA) return sA;
    uA = 1;
    const e11 = yA();
    return sA = function() {
      return fetch(...arguments).catch((t3) => {
        throw "AbortError" === t3.name ? t3 : new e11(t3);
      });
    }, sA;
  }(), i2 = function() {
    if (cA) return lA;
    cA = 1;
    const e11 = qD();
    class t3 extends Error {
      constructor(t4, n3) {
        void 0 === n3 && (n3 = {}), super(t4), this.cause = n3.cause, this.cause && e11(this.cause, "isNetworkError") && (this.isNetworkError = this.cause.isNetworkError);
      }
    }
    return lA = t3;
  }(), a2 = function() {
    if (fA) return dA;
    fA = 1;
    class e11 extends Error {
      constructor() {
        super("Authorization required"), this.name = "AuthError", this.isAuthError = true;
      }
    }
    return dA = e11;
  }();
  async function s2(e11) {
    if (401 === e11.status) throw new a2();
    const t3 = e11.json();
    if (e11.status < 200 || e11.status > 300) {
      let n3 = `Failed request with status: ${e11.status}. ${e11.statusText}`;
      try {
        const e12 = await t3;
        n3 = e12.message ? `${n3} message: ${e12.message}` : n3, n3 = e12.requestId ? `${n3} request-Id: ${e12.requestId}` : n3;
      } finally {
        throw new Error(n3);
      }
    }
    return t3;
  }
  var u2 = r3("companionHeaders"), l2 = r3("getPostResponseFunc"), c3 = r3("getUrl"), d2 = r3("errorHandler");
  e10 = Symbol.for("uppy test: getCompanionHeaders");
  class f2 {
    constructor(e11, n3) {
      Object.defineProperty(this, d2, { value: h2 }), Object.defineProperty(this, c3, { value: p2 }), Object.defineProperty(this, u2, { writable: true, value: void 0 }), Object.defineProperty(this, l2, { writable: true, value: (e12) => (t3) => e12 ? t3 : this.onReceiveResponse(t3) }), this.uppy = e11, this.opts = n3, this.onReceiveResponse = this.onReceiveResponse.bind(this), this.allowedHeaders = ["accept", "content-type", "uppy-auth-token"], this.preflightDone = false, t2(this, u2)[u2] = null == n3 ? void 0 : n3.companionHeaders;
    }
    setCompanionHeaders(e11) {
      t2(this, u2)[u2] = e11;
    }
    [e10]() {
      return t2(this, u2)[u2];
    }
    get hostname() {
      const { companion: e11 } = this.uppy.getState(), t3 = this.opts.companionUrl;
      return (e11 && e11[t3] ? e11[t3] : t3).replace(/\/$/, "");
    }
    headers() {
      return Promise.resolve({ ...f2.defaultHeaders, ...t2(this, u2)[u2] });
    }
    onReceiveResponse(e11) {
      const t3 = this.uppy.getState().companion || {}, n3 = this.opts.companionUrl, { headers: r4 } = e11;
      return r4.has("i-am") && r4.get("i-am") !== t3[n3] && this.uppy.setState({ companion: { ...t3, [n3]: r4.get("i-am") } }), e11;
    }
    preflight(e11) {
      return this.preflightDone ? Promise.resolve(this.allowedHeaders.slice()) : fetch(t2(this, c3)[c3](e11), { method: "OPTIONS" }).then((e12) => (e12.headers.has("access-control-allow-headers") && (this.allowedHeaders = e12.headers.get("access-control-allow-headers").split(",").map((e13) => e13.trim().toLowerCase())), this.preflightDone = true, this.allowedHeaders.slice())).catch((e12) => (this.uppy.log(`[CompanionClient] unable to make preflight request ${e12}`, "warning"), this.preflightDone = true, this.allowedHeaders.slice()));
    }
    preflightAndHeaders(e11) {
      return Promise.all([this.preflight(e11), this.headers()]).then((e12) => {
        let [t3, n3] = e12;
        return Object.keys(n3).forEach((e13) => {
          t3.includes(e13.toLowerCase()) || (this.uppy.log(`[CompanionClient] excluding disallowed header ${e13}`), delete n3[e13]);
        }), n3;
      });
    }
    get(e11, n3) {
      return this.preflightAndHeaders(e11).then((n4) => o2(t2(this, c3)[c3](e11), { method: "get", headers: n4, credentials: this.opts.companionCookiesRule || "same-origin" })).then(t2(this, l2)[l2](n3)).then(s2).catch(t2(this, d2)[d2]("get", e11));
    }
    post(e11, n3, r4) {
      const i3 = "post";
      return this.preflightAndHeaders(e11).then((r5) => o2(t2(this, c3)[c3](e11), { method: i3, headers: r5, credentials: this.opts.companionCookiesRule || "same-origin", body: JSON.stringify(n3) })).then(t2(this, l2)[l2](r4)).then(s2).catch(t2(this, d2)[d2](i3, e11));
    }
    delete(e11, n3, r4) {
      const i3 = "delete";
      return this.preflightAndHeaders(e11).then((t3) => o2(`${this.hostname}/${e11}`, { method: i3, headers: t3, credentials: this.opts.companionCookiesRule || "same-origin", body: n3 ? JSON.stringify(n3) : null })).then(t2(this, l2)[l2](r4)).then(s2).catch(t2(this, d2)[d2](i3, e11));
    }
  }
  function p2(e11) {
    return /^(https?:|)\/\//.test(e11) ? e11 : `${this.hostname}/${e11}`;
  }
  function h2(e11, n3) {
    return (r4) => {
      var o3;
      return null != (o3 = r4) && o3.isAuthError || (r4 = new i2(`Could not ${e11} ${t2(this, c3)[c3](n3)}`, { cause: r4 })), Promise.reject(r4);
    };
  }
  return f2.VERSION = "2.2.2", f2.defaultHeaders = { Accept: "application/json", "Content-Type": "application/json", "Uppy-Versions": `@uppy/companion-client=${f2.VERSION}` }, pA = f2;
}
var EA, CA, wA, DA, SA, AA, xA, OA, NA = {};
function BA() {
  if (EA) return NA;
  return EA = 1, Object.defineProperty(NA, "__esModule", { value: true }), NA.getItem = function(e10) {
    return Promise.resolve(localStorage.getItem(e10));
  }, NA.removeItem = function(e10) {
    return new Promise((t2) => {
      localStorage.removeItem(e10), t2();
    });
  }, NA.setItem = function(e10, t2) {
    return new Promise((n2) => {
      localStorage.setItem(e10, t2), n2();
    });
  }, NA;
}
function TA() {
  if (OA) return mA;
  OA = 1, Object.defineProperty(mA, "__esModule", { value: true }), mA.Socket = mA.SearchProvider = mA.RequestClient = mA.Provider = void 0;
  const e10 = bA();
  mA.RequestClient = e10;
  const t2 = function() {
    if (wA) return CA;
    wA = 1;
    var e11 = BA();
    const t3 = bA();
    return CA = class extends t3 {
      constructor(e12, t4) {
        super(e12, t4), this.provider = t4.provider, this.id = this.provider, this.name = this.opts.name || this.id.split("-").map((e13) => e13.charAt(0).toUpperCase() + e13.slice(1)).join(" "), this.pluginId = this.opts.pluginId, this.tokenKey = `companion-${this.pluginId}-auth-token`, this.companionKeysParams = this.opts.companionKeysParams, this.preAuthToken = null;
      }
      headers() {
        return Promise.all([super.headers(), this.getAuthToken()]).then((e12) => {
          let [t4, n3] = e12;
          const r4 = {};
          return n3 && (r4["uppy-auth-token"] = n3), this.companionKeysParams && (r4["uppy-credentials-params"] = btoa(JSON.stringify({ params: this.companionKeysParams }))), { ...t4, ...r4 };
        });
      }
      onReceiveResponse(e12) {
        e12 = super.onReceiveResponse(e12);
        const t4 = this.uppy.getPlugin(this.pluginId), n3 = t4.getPluginState().authenticated ? 401 !== e12.status : e12.status < 400;
        return t4.setPluginState({ authenticated: n3 }), e12;
      }
      setAuthToken(e12) {
        return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, e12);
      }
      getAuthToken() {
        return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
      }
      async ensurePreAuth() {
        if (this.companionKeysParams && !this.preAuthToken && (await this.fetchPreAuthToken(), !this.preAuthToken)) throw new Error("Could not load authentication data required for third-party login. Please try again later.");
      }
      authUrl(e12) {
        void 0 === e12 && (e12 = {});
        const t4 = new URLSearchParams(e12);
        return this.preAuthToken && t4.set("uppyPreAuthToken", this.preAuthToken), `${this.hostname}/${this.id}/connect?${t4}`;
      }
      fileUrl(e12) {
        return `${this.hostname}/${this.id}/get/${e12}`;
      }
      async fetchPreAuthToken() {
        if (this.companionKeysParams) try {
          const e12 = await this.post(`${this.id}/preauth/`, { params: this.companionKeysParams });
          this.preAuthToken = e12.token;
        } catch (e12) {
          this.uppy.log(`[CompanionClient] unable to fetch preAuthToken ${e12}`, "warning");
        }
      }
      list(e12) {
        return this.get(`${this.id}/list/${e12 || ""}`);
      }
      logout() {
        return this.get(`${this.id}/logout`).then((e12) => Promise.all([e12, this.uppy.getPlugin(this.pluginId).storage.removeItem(this.tokenKey)])).then((e12) => {
          let [t4] = e12;
          return t4;
        });
      }
      static initPlugin(t4, n3, r4) {
        if (t4.type = "acquirer", t4.files = [], r4 && (t4.opts = { ...r4, ...n3 }), n3.serverUrl || n3.serverPattern) throw new Error("`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`");
        if (n3.companionAllowedHosts) {
          const e12 = n3.companionAllowedHosts;
          if (!("string" == typeof e12 || Array.isArray(e12) || e12 instanceof RegExp)) throw new TypeError(`${t4.id}: the option "companionAllowedHosts" must be one of string, Array, RegExp`);
          t4.opts.companionAllowedHosts = e12;
        } else /^(?!https?:\/\/).*$/i.test(n3.companionUrl) ? t4.opts.companionAllowedHosts = `https://${n3.companionUrl.replace(/^\/\//, "")}` : t4.opts.companionAllowedHosts = new URL(n3.companionUrl).origin;
        t4.storage = t4.opts.storage || e11;
      }
    }, CA;
  }();
  mA.Provider = t2;
  const n2 = function() {
    if (SA) return DA;
    SA = 1;
    const e11 = bA();
    return DA = class extends e11 {
      constructor(e12, t3) {
        super(e12, t3), this.provider = t3.provider, this.id = this.provider, this.name = this.opts.name || this.id.split("-").map((e13) => e13.charAt(0).toUpperCase() + e13.slice(1)).join(" "), this.pluginId = this.opts.pluginId;
      }
      fileUrl(e12) {
        return `${this.hostname}/search/${this.id}/get/${e12}`;
      }
      search(e12, t3) {
        return this.get(`search/${this.id}/list?q=${encodeURIComponent(e12)}${t3 ? `&${t3}` : ""}`);
      }
    }, DA;
  }();
  mA.SearchProvider = n2;
  const r3 = function() {
    if (xA) return AA;
    let e11, t3;
    function n3(e12, t4) {
      if (!Object.prototype.hasOwnProperty.call(e12, t4)) throw new TypeError("attempted to use private field on non-instance");
      return e12;
    }
    xA = 1;
    var r4 = 0;
    function o2(e12) {
      return "__private_" + r4++ + "_" + e12;
    }
    const i2 = YD();
    var a2 = o2("queued"), s2 = o2("emitter"), u2 = o2("isOpen"), l2 = o2("socket"), c3 = o2("handleMessage");
    return e11 = Symbol.for("uppy test: getSocket"), t3 = Symbol.for("uppy test: getQueued"), AA = class {
      constructor(e12) {
        Object.defineProperty(this, a2, { writable: true, value: [] }), Object.defineProperty(this, s2, { writable: true, value: i2() }), Object.defineProperty(this, u2, { writable: true, value: false }), Object.defineProperty(this, l2, { writable: true, value: void 0 }), Object.defineProperty(this, c3, { writable: true, value: (e13) => {
          try {
            const t4 = JSON.parse(e13.data);
            this.emit(t4.action, t4.payload);
          } catch (e14) {
            console.log(e14);
          }
        } }), this.opts = e12, e12 && false === e12.autoOpen || this.open();
      }
      get isOpen() {
        return n3(this, u2)[u2];
      }
      [e11]() {
        return n3(this, l2)[l2];
      }
      [t3]() {
        return n3(this, a2)[a2];
      }
      open() {
        n3(this, l2)[l2] = new WebSocket(this.opts.target), n3(this, l2)[l2].onopen = () => {
          for (n3(this, u2)[u2] = true; n3(this, a2)[a2].length > 0 && n3(this, u2)[u2]; ) {
            const e12 = n3(this, a2)[a2].shift();
            this.send(e12.action, e12.payload);
          }
        }, n3(this, l2)[l2].onclose = () => {
          n3(this, u2)[u2] = false;
        }, n3(this, l2)[l2].onmessage = n3(this, c3)[c3];
      }
      close() {
        var e12;
        null == (e12 = n3(this, l2)[l2]) || e12.close();
      }
      send(e12, t4) {
        n3(this, u2)[u2] ? n3(this, l2)[l2].send(JSON.stringify({ action: e12, payload: t4 })) : n3(this, a2)[a2].push({ action: e12, payload: t4 });
      }
      on(e12, t4) {
        n3(this, s2)[s2].on(e12, t4);
      }
      emit(e12, t4) {
        n3(this, s2)[s2].emit(e12, t4);
      }
      once(e12, t4) {
        n3(this, s2)[s2].once(e12, t4);
      }
    }, AA;
  }();
  return mA.Socket = r3, mA;
}
var kA, FA, IA, PA, _A2, RA, LA, MA, jA, HA, zA, $A, UA, VA, WA, GA, qA, KA = {};
function YA() {
  if (kA) return KA;
  function e10(e11, t3) {
    if (!Object.prototype.hasOwnProperty.call(e11, t3)) throw new TypeError("attempted to use private field on non-instance");
    return e11;
  }
  kA = 1, Object.defineProperty(KA, "__esModule", { value: true }), KA.internalRateLimitedQueue = KA.RateLimitedQueue = void 0;
  var t2 = 0;
  function n2(e11) {
    return "__private_" + t2++ + "_" + e11;
  }
  var r3 = n2("activeRequests"), o2 = n2("queuedHandlers"), i2 = n2("paused"), a2 = n2("pauseTimer"), s2 = n2("downLimit"), u2 = n2("upperLimit"), l2 = n2("rateLimitingTimer"), c3 = n2("call"), d2 = n2("queueNext"), f2 = n2("next"), p2 = n2("queue"), h2 = n2("dequeue"), g2 = n2("resume"), v2 = n2("increaseLimit");
  function m2(t3) {
    e10(this, r3)[r3] += 1;
    let n3, o3 = false;
    try {
      n3 = t3();
    } catch (t4) {
      throw e10(this, r3)[r3] -= 1, t4;
    }
    return { abort: () => {
      o3 || (o3 = true, e10(this, r3)[r3] -= 1, n3(), e10(this, d2)[d2]());
    }, done: () => {
      o3 || (o3 = true, e10(this, r3)[r3] -= 1, e10(this, d2)[d2]());
    } };
  }
  function y2() {
    queueMicrotask(() => e10(this, f2)[f2]());
  }
  function b2() {
    if (e10(this, i2)[i2] || e10(this, r3)[r3] >= this.limit) return;
    if (0 === e10(this, o2)[o2].length) return;
    const t3 = e10(this, o2)[o2].shift(), n3 = e10(this, c3)[c3](t3.fn);
    t3.abort = n3.abort, t3.done = n3.done;
  }
  function E2(t3, n3) {
    void 0 === n3 && (n3 = {});
    const r4 = { fn: t3, priority: n3.priority || 0, abort: () => {
      e10(this, h2)[h2](r4);
    }, done: () => {
      throw new Error("Cannot mark a queued request as done: this indicates a bug");
    } }, i3 = e10(this, o2)[o2].findIndex((e11) => r4.priority > e11.priority);
    return -1 === i3 ? e10(this, o2)[o2].push(r4) : e10(this, o2)[o2].splice(i3, 0, r4), r4;
  }
  function C2(t3) {
    const n3 = e10(this, o2)[o2].indexOf(t3);
    -1 !== n3 && e10(this, o2)[o2].splice(n3, 1);
  }
  KA.RateLimitedQueue = class {
    constructor(t3) {
      Object.defineProperty(this, h2, { value: C2 }), Object.defineProperty(this, p2, { value: E2 }), Object.defineProperty(this, f2, { value: b2 }), Object.defineProperty(this, d2, { value: y2 }), Object.defineProperty(this, c3, { value: m2 }), Object.defineProperty(this, r3, { writable: true, value: 0 }), Object.defineProperty(this, o2, { writable: true, value: [] }), Object.defineProperty(this, i2, { writable: true, value: false }), Object.defineProperty(this, a2, { writable: true, value: void 0 }), Object.defineProperty(this, s2, { writable: true, value: 1 }), Object.defineProperty(this, u2, { writable: true, value: void 0 }), Object.defineProperty(this, l2, { writable: true, value: void 0 }), Object.defineProperty(this, g2, { writable: true, value: () => this.resume() }), Object.defineProperty(this, v2, { writable: true, value: () => {
        if (e10(this, i2)[i2]) e10(this, l2)[l2] = setTimeout(e10(this, v2)[v2], 0);
        else {
          e10(this, s2)[s2] = this.limit, this.limit = Math.ceil((e10(this, u2)[u2] + e10(this, s2)[s2]) / 2);
          for (let t4 = e10(this, s2)[s2]; t4 <= this.limit; t4++) e10(this, d2)[d2]();
          e10(this, u2)[u2] - e10(this, s2)[s2] > 3 ? e10(this, l2)[l2] = setTimeout(e10(this, v2)[v2], 2e3) : e10(this, s2)[s2] = Math.floor(e10(this, s2)[s2] / 2);
        }
      } }), this.limit = "number" != typeof t3 || 0 === t3 ? 1 / 0 : t3;
    }
    run(t3, n3) {
      return !e10(this, i2)[i2] && e10(this, r3)[r3] < this.limit ? e10(this, c3)[c3](t3) : e10(this, p2)[p2](t3, n3);
    }
    wrapPromiseFunction(e11, t3) {
      var n3 = this;
      return function() {
        for (var r4 = arguments.length, o3 = new Array(r4), i3 = 0; i3 < r4; i3++) o3[i3] = arguments[i3];
        let a3;
        const s3 = new Promise((r5, i4) => {
          a3 = n3.run(() => {
            let t4, n4;
            try {
              n4 = Promise.resolve(e11(...o3));
            } catch (e12) {
              n4 = Promise.reject(e12);
            }
            return n4.then((e12) => {
              t4 ? i4(t4) : (a3.done(), r5(e12));
            }, (e12) => {
              t4 ? i4(t4) : (a3.done(), i4(e12));
            }), () => {
              t4 = new Error("Cancelled");
            };
          }, t3);
        });
        return s3.abort = () => {
          a3.abort();
        }, s3;
      };
    }
    resume() {
      e10(this, i2)[i2] = false, clearTimeout(e10(this, a2)[a2]);
      for (let t3 = 0; t3 < this.limit; t3++) e10(this, d2)[d2]();
    }
    pause(t3) {
      void 0 === t3 && (t3 = null), e10(this, i2)[i2] = true, clearTimeout(e10(this, a2)[a2]), null != t3 && (e10(this, a2)[a2] = setTimeout(e10(this, g2)[g2], t3));
    }
    rateLimit(t3) {
      clearTimeout(e10(this, l2)[l2]), this.pause(t3), this.limit > 1 && Number.isFinite(this.limit) && (e10(this, u2)[u2] = this.limit - 1, this.limit = e10(this, s2)[s2], e10(this, l2)[l2] = setTimeout(e10(this, v2)[v2], t3));
    }
    get isPaused() {
      return e10(this, i2)[i2];
    }
  };
  const w2 = Symbol("__queue");
  return KA.internalRateLimitedQueue = w2, KA;
}
function XA() {
  return WA ? VA : (WA = 1, VA = { strings: { timedOut: "Upload stalled for %{seconds} seconds, aborting." } });
}
var ZA = function() {
  if (qA) return GA;
  qA = 1;
  var e10 = dD(), t2 = TA(), n2 = YA();
  const r3 = rA(), o2 = function() {
    if (IA) return FA;
    IA = 1;
    const e11 = TC();
    return FA = e11(function(e12, t3, n3) {
      const { progress: r4, bytesUploaded: o3, bytesTotal: i3 } = t3;
      r4 && (e12.uppy.log(`Upload progress: ${r4}`), e12.uppy.emit("upload-progress", n3, { uploader: e12, bytesUploaded: o3, bytesTotal: i3 }));
    }, 300, { leading: true, trailing: true });
  }(), i2 = _A2 ? PA : (_A2 = 1, PA = function(e11) {
    const t3 = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i.exec(e11)[1];
    return `${/^http:\/\//i.test(e11) ? "ws" : "wss"}://${t3}`;
  }), a2 = LA ? RA : (LA = 1, RA = function(e11) {
    const t3 = [], n3 = [];
    function r4(e12) {
      t3.push(e12);
    }
    function o3(e12) {
      n3.push(e12);
    }
    return Promise.all(e11.map((e12) => e12.then(r4, o3))).then(() => ({ successful: t3, failed: n3 }));
  }), s2 = function() {
    if (jA) return MA;
    function e11(e12, t4) {
      if (!Object.prototype.hasOwnProperty.call(e12, t4)) throw new TypeError("attempted to use private field on non-instance");
      return e12;
    }
    jA = 1;
    var t3 = 0;
    function n3(e12) {
      return "__private_" + t3++ + "_" + e12;
    }
    var r4 = n3("emitter"), o3 = n3("events");
    return MA = class {
      constructor(t4) {
        Object.defineProperty(this, r4, { writable: true, value: void 0 }), Object.defineProperty(this, o3, { writable: true, value: [] }), e11(this, r4)[r4] = t4;
      }
      on(t4, n4) {
        return e11(this, o3)[o3].push([t4, n4]), e11(this, r4)[r4].on(t4, n4);
      }
      remove() {
        for (const [t4, n4] of e11(this, o3)[o3].splice(0)) e11(this, r4)[r4].off(t4, n4);
      }
    }, MA;
  }(), u2 = function() {
    if (zA) return HA;
    function e11(e12, t4) {
      if (!Object.prototype.hasOwnProperty.call(e12, t4)) throw new TypeError("attempted to use private field on non-instance");
      return e12;
    }
    zA = 1;
    var t3 = 0;
    function n3(e12) {
      return "__private_" + t3++ + "_" + e12;
    }
    var r4 = n3("aliveTimer"), o3 = n3("isDone"), i3 = n3("onTimedOut"), a3 = n3("timeout");
    return HA = class {
      constructor(t4, n4) {
        Object.defineProperty(this, r4, { writable: true, value: void 0 }), Object.defineProperty(this, o3, { writable: true, value: false }), Object.defineProperty(this, i3, { writable: true, value: void 0 }), Object.defineProperty(this, a3, { writable: true, value: void 0 }), e11(this, a3)[a3] = t4, e11(this, i3)[i3] = n4;
      }
      progress() {
        e11(this, o3)[o3] || e11(this, a3)[a3] > 0 && (clearTimeout(e11(this, r4)[r4]), e11(this, r4)[r4] = setTimeout(e11(this, i3)[i3], e11(this, a3)[a3]));
      }
      done() {
        e11(this, o3)[o3] || (clearTimeout(e11(this, r4)[r4]), e11(this, r4)[r4] = null, e11(this, o3)[o3] = true);
      }
    };
  }(), l2 = yA(), c3 = UA ? $A : (UA = 1, $A = function(e11) {
    return !!e11 && (0 !== e11.readyState && 4 !== e11.readyState || 0 === e11.status);
  }), d2 = XA();
  function f2(e11, t3) {
    let n3 = t3;
    return n3 || (n3 = new Error("Upload error")), "string" == typeof n3 && (n3 = new Error(n3)), n3 instanceof Error || (n3 = Object.assign(new Error("Upload error"), { data: n3 })), c3(e11) ? (n3 = new l2(n3, e11), n3) : (n3.request = e11, n3);
  }
  function p2(e11) {
    return e11.data.slice(0, e11.data.size, e11.meta.type);
  }
  class h2 extends r3 {
    constructor(e11, t3) {
      super(e11, t3), this.type = "uploader", this.id = this.opts.id || "XHRUpload", this.title = "XHRUpload", this.defaultLocale = d2;
      const r4 = { formData: true, fieldName: t3.bundle ? "files[]" : "file", method: "post", metaFields: null, responseUrlFieldName: "url", bundle: false, headers: {}, timeout: 3e4, limit: 5, withCredentials: false, responseType: "", getResponseData(t4) {
        let n3 = {};
        try {
          n3 = JSON.parse(t4);
        } catch (t5) {
          e11.log(t5);
        }
        return n3;
      }, getResponseError(e12, t4) {
        let n3 = new Error("Upload error");
        return c3(t4) && (n3 = new l2(n3, t4)), n3;
      }, validateStatus: (e12) => e12 >= 200 && e12 < 300 };
      if (this.opts = { ...r4, ...t3 }, this.i18nInit(), this.handleUpload = this.handleUpload.bind(this), n2.internalRateLimitedQueue in this.opts ? this.requests = this.opts[n2.internalRateLimitedQueue] : this.requests = new n2.RateLimitedQueue(this.opts.limit), this.opts.bundle && !this.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
      this.uploaderEvents = /* @__PURE__ */ Object.create(null);
    }
    getOptions(e11) {
      const t3 = this.uppy.getState().xhrUpload, { headers: n3 } = this.opts, r4 = { ...this.opts, ...t3 || {}, ...e11.xhrUpload || {}, headers: {} };
      return "function" == typeof n3 ? r4.headers = n3(e11) : Object.assign(r4.headers, this.opts.headers), t3 && Object.assign(r4.headers, t3.headers), e11.xhrUpload && Object.assign(r4.headers, e11.xhrUpload.headers), r4;
    }
    addMetadata(e11, t3, n3) {
      (Array.isArray(n3.metaFields) ? n3.metaFields : Object.keys(t3)).forEach((n4) => {
        e11.append(n4, t3[n4]);
      });
    }
    createFormDataUpload(e11, t3) {
      const n3 = new FormData();
      this.addMetadata(n3, e11.meta, t3);
      const r4 = p2(e11);
      return e11.name ? n3.append(t3.fieldName, r4, e11.meta.name) : n3.append(t3.fieldName, r4), n3;
    }
    createBundledUpload(e11, t3) {
      const n3 = new FormData(), { meta: r4 } = this.uppy.getState();
      return this.addMetadata(n3, r4, t3), e11.forEach((e12) => {
        const t4 = this.getOptions(e12), r5 = p2(e12);
        e12.name ? n3.append(t4.fieldName, r5, e12.name) : n3.append(t4.fieldName, r5);
      }), n3;
    }
    upload(t3, n3, r4) {
      const o3 = this.getOptions(t3);
      return this.uppy.log(`uploading ${n3} of ${r4}`), new Promise((n4, r5) => {
        this.uppy.emit("upload-started", t3);
        const i3 = o3.formData ? this.createFormDataUpload(t3, o3) : t3.data, a3 = new XMLHttpRequest();
        let l3;
        this.uploaderEvents[t3.id] = new s2(this.uppy);
        const c4 = new u2(o3.timeout, () => {
          a3.abort(), l3.done();
          const e11 = new Error(this.i18n("timedOut", { seconds: Math.ceil(o3.timeout / 1e3) }));
          this.uppy.emit("upload-error", t3, e11), r5(e11);
        }), d3 = (0, e10.nanoid)();
        a3.upload.addEventListener("loadstart", () => {
          this.uppy.log(`[XHRUpload] ${d3} started`);
        }), a3.upload.addEventListener("progress", (e11) => {
          this.uppy.log(`[XHRUpload] ${d3} progress: ${e11.loaded} / ${e11.total}`), c4.progress(), e11.lengthComputable && this.uppy.emit("upload-progress", t3, { uploader: this, bytesUploaded: e11.loaded, bytesTotal: e11.total });
        }), a3.addEventListener("load", () => {
          if (this.uppy.log(`[XHRUpload] ${d3} finished`), c4.done(), l3.done(), this.uploaderEvents[t3.id] && (this.uploaderEvents[t3.id].remove(), this.uploaderEvents[t3.id] = null), o3.validateStatus(a3.status, a3.responseText, a3)) {
            const e12 = o3.getResponseData(a3.responseText, a3), r6 = e12[o3.responseUrlFieldName], i5 = { status: a3.status, body: e12, uploadURL: r6 };
            return this.uppy.emit("upload-success", t3, i5), r6 && this.uppy.log(`Download ${t3.name} from ${r6}`), n4(t3);
          }
          const e11 = o3.getResponseData(a3.responseText, a3), i4 = f2(a3, o3.getResponseError(a3.responseText, a3)), s3 = { status: a3.status, body: e11 };
          return this.uppy.emit("upload-error", t3, i4, s3), r5(i4);
        }), a3.addEventListener("error", () => {
          this.uppy.log(`[XHRUpload] ${d3} errored`), c4.done(), l3.done(), this.uploaderEvents[t3.id] && (this.uploaderEvents[t3.id].remove(), this.uploaderEvents[t3.id] = null);
          const e11 = f2(a3, o3.getResponseError(a3.responseText, a3));
          return this.uppy.emit("upload-error", t3, e11), r5(e11);
        }), a3.open(o3.method.toUpperCase(), o3.endpoint, true), a3.withCredentials = o3.withCredentials, "" !== o3.responseType && (a3.responseType = o3.responseType), l3 = this.requests.run(() => {
          this.uppy.emit("upload-started", t3);
          const e11 = this.getOptions(t3);
          return Object.keys(e11.headers).forEach((t4) => {
            a3.setRequestHeader(t4, e11.headers[t4]);
          }), a3.send(i3), () => {
            c4.done(), a3.abort();
          };
        }), this.onFileRemove(t3.id, () => {
          l3.abort(), r5(new Error("File removed"));
        }), this.onCancelAll(t3.id, (e11) => {
          let { reason: t4 } = e11;
          "user" === t4 && l3.abort(), r5(new Error("Upload cancelled"));
        });
      });
    }
    uploadRemote(e11) {
      const n3 = this.getOptions(e11);
      return new Promise((r4, a3) => {
        this.uppy.emit("upload-started", e11);
        const u3 = {};
        (Array.isArray(n3.metaFields) ? n3.metaFields : Object.keys(e11.meta)).forEach((t3) => {
          u3[t3] = e11.meta[t3];
        });
        new (e11.remote.providerOptions.provider ? t2.Provider : t2.RequestClient)(this.uppy, e11.remote.providerOptions).post(e11.remote.url, { ...e11.remote.body, endpoint: n3.endpoint, size: e11.data.size, fieldname: n3.fieldName, metadata: u3, httpMethod: n3.method, useFormData: n3.formData, headers: n3.headers }).then((u4) => {
          const { token: l3 } = u4, c4 = i2(e11.remote.companionUrl), d3 = new t2.Socket({ target: `${c4}/api/${l3}`, autoOpen: false });
          let f3;
          this.uploaderEvents[e11.id] = new s2(this.uppy), this.onFileRemove(e11.id, () => {
            d3.send("cancel", {}), f3.abort(), r4(`upload ${e11.id} was removed`);
          }), this.onCancelAll(e11.id, function(t3) {
            let { reason: n4 } = void 0 === t3 ? {} : t3;
            "user" === n4 && (d3.send("cancel", {}), f3.abort()), r4(`upload ${e11.id} was canceled`);
          }), this.onRetry(e11.id, () => {
            d3.send("pause", {}), d3.send("resume", {});
          }), this.onRetryAll(e11.id, () => {
            d3.send("pause", {}), d3.send("resume", {});
          }), d3.on("progress", (t3) => o2(this, t3, e11)), d3.on("success", (t3) => {
            const o3 = n3.getResponseData(t3.response.responseText, t3.response), i3 = o3[n3.responseUrlFieldName], a4 = { status: t3.response.status, body: o3, uploadURL: i3 };
            return this.uppy.emit("upload-success", e11, a4), f3.done(), this.uploaderEvents[e11.id] && (this.uploaderEvents[e11.id].remove(), this.uploaderEvents[e11.id] = null), r4();
          }), d3.on("error", (t3) => {
            const r5 = t3.response, o3 = r5 ? n3.getResponseError(r5.responseText, r5) : Object.assign(new Error(t3.error.message), { cause: t3.error });
            this.uppy.emit("upload-error", e11, o3), f3.done(), this.uploaderEvents[e11.id] && (this.uploaderEvents[e11.id].remove(), this.uploaderEvents[e11.id] = null), a3(o3);
          }), f3 = this.requests.run(() => (d3.open(), e11.isPaused && d3.send("pause", {}), () => d3.close()));
        }).catch((t3) => {
          this.uppy.emit("upload-error", e11, t3), a3(t3);
        });
      });
    }
    uploadBundle(e11) {
      return new Promise((t3, n3) => {
        const { endpoint: r4 } = this.opts, { method: o3 } = this.opts, i3 = this.uppy.getState().xhrUpload, a3 = this.createBundledUpload(e11, { ...this.opts, ...i3 || {} }), s3 = new XMLHttpRequest(), l3 = (t4) => {
          e11.forEach((e12) => {
            this.uppy.emit("upload-error", e12, t4);
          });
        }, c4 = new u2(this.opts.timeout, () => {
          s3.abort();
          const e12 = new Error(this.i18n("timedOut", { seconds: Math.ceil(this.opts.timeout / 1e3) }));
          l3(e12), n3(e12);
        });
        s3.upload.addEventListener("loadstart", () => {
          this.uppy.log("[XHRUpload] started uploading bundle"), c4.progress();
        }), s3.upload.addEventListener("progress", (t4) => {
          c4.progress(), t4.lengthComputable && e11.forEach((e12) => {
            this.uppy.emit("upload-progress", e12, { uploader: this, bytesUploaded: t4.loaded / t4.total * e12.size, bytesTotal: e12.size });
          });
        }), s3.addEventListener("load", (r5) => {
          if (c4.done(), this.opts.validateStatus(r5.target.status, s3.responseText, s3)) {
            const n4 = this.opts.getResponseData(s3.responseText, s3), o5 = { status: r5.target.status, body: n4 };
            return e11.forEach((e12) => {
              this.uppy.emit("upload-success", e12, o5);
            }), t3();
          }
          const o4 = this.opts.getResponseError(s3.responseText, s3) || new Error("Upload error");
          return o4.request = s3, l3(o4), n3(o4);
        }), s3.addEventListener("error", () => {
          c4.done();
          const e12 = this.opts.getResponseError(s3.responseText, s3) || new Error("Upload error");
          return l3(e12), n3(e12);
        }), this.uppy.on("cancel-all", function(e12) {
          let { reason: t4 } = void 0 === e12 ? {} : e12;
          "user" === t4 && (c4.done(), s3.abort());
        }), s3.open(o3.toUpperCase(), r4, true), s3.withCredentials = this.opts.withCredentials, "" !== this.opts.responseType && (s3.responseType = this.opts.responseType), Object.keys(this.opts.headers).forEach((e12) => {
          s3.setRequestHeader(e12, this.opts.headers[e12]);
        }), s3.send(a3), e11.forEach((e12) => {
          this.uppy.emit("upload-started", e12);
        });
      });
    }
    uploadFiles(e11) {
      const t3 = e11.map((t4, n3) => {
        const r4 = parseInt(n3, 10) + 1, o3 = e11.length;
        return t4.error ? Promise.reject(new Error(t4.error)) : t4.isRemote ? this.uploadRemote(t4, r4, o3) : this.upload(t4, r4, o3);
      });
      return a2(t3);
    }
    onFileRemove(e11, t3) {
      this.uploaderEvents[e11].on("file-removed", (n3) => {
        e11 === n3.id && t3(n3.id);
      });
    }
    onRetry(e11, t3) {
      this.uploaderEvents[e11].on("upload-retry", (n3) => {
        e11 === n3 && t3();
      });
    }
    onRetryAll(e11, t3) {
      this.uploaderEvents[e11].on("retry-all", () => {
        this.uppy.getFile(e11) && t3();
      });
    }
    onCancelAll(e11, t3) {
      var n3 = this;
      this.uploaderEvents[e11].on("cancel-all", function() {
        n3.uppy.getFile(e11) && t3(...arguments);
      });
    }
    handleUpload(e11) {
      if (0 === e11.length) return this.uppy.log("[XHRUpload] No files to upload!"), Promise.resolve();
      0 !== this.opts.limit || this.opts[n2.internalRateLimitedQueue] || this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning"), this.uppy.log("[XHRUpload] Uploading...");
      const t3 = e11.map((e12) => this.uppy.getFile(e12));
      if (this.opts.bundle) {
        if (t3.some((e12) => e12.isRemote)) throw new Error("Can’t upload remote files when the `bundle: true` option is set");
        if ("function" == typeof this.opts.headers) throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
        return this.uploadBundle(t3);
      }
      return this.uploadFiles(t3).then(() => null);
    }
    install() {
      if (this.opts.bundle) {
        const { capabilities: e11 } = this.uppy.getState();
        this.uppy.setState({ capabilities: { ...e11, individualCancellation: false } });
      }
      this.uppy.addUploader(this.handleUpload);
    }
    uninstall() {
      if (this.opts.bundle) {
        const { capabilities: e11 } = this.uppy.getState();
        this.uppy.setState({ capabilities: { ...e11, individualCancellation: true } });
      }
      this.uppy.removeUploader(this.handleUpload);
    }
  }
  return h2.VERSION = "2.1.3", GA = h2;
}(), JA = b(ZA);
function QA(e10) {
  var t2 = e10.server, n2 = void 0 === t2 ? "" : t2, r3 = e10.fieldName, o2 = void 0 === r3 ? "" : r3, i2 = e10.maxFileSize, a2 = void 0 === i2 ? 10485760 : i2, s2 = e10.maxNumberOfFiles, u2 = void 0 === s2 ? 100 : s2, l2 = e10.meta, c3 = void 0 === l2 ? {} : l2, d2 = e10.metaWithUrl, f2 = void 0 !== d2 && d2, p2 = e10.headers, h2 = void 0 === p2 ? {} : p2, g2 = e10.withCredentials, v2 = void 0 !== g2 && g2, m2 = e10.timeout, y2 = void 0 === m2 ? 1e4 : m2, b2 = e10.onBeforeUpload, E2 = void 0 === b2 ? function(e11) {
    return e11;
  } : b2, C2 = e10.onSuccess, w2 = void 0 === C2 ? function(e11, t3) {
  } : C2, D2 = e10.onError, S2 = void 0 === D2 ? function(e11, t3, n3) {
    console.error("".concat(e11.name, " upload error"), t3, n3);
  } : D2, A2 = e10.onProgress, x2 = void 0 === A2 ? function(e11) {
  } : A2;
  if (!n2) throw new Error("Cannot get upload server address\n没有配置上传地址");
  if (!o2) throw new Error("Cannot get fieldName\n没有配置 fieldName");
  var O2 = n2;
  f2 && (O2 = function(e11, t3) {
    var n3 = iv(e11.split("#"), 2), r4 = n3[0], o3 = n3[1], i3 = [];
    gv(t3, function(e12, t4) {
      i3.push("".concat(t4, "=").concat(e12));
    });
    var a3 = i3.join("&");
    return r4 = r4.indexOf("?") > 0 ? "".concat(r4, "&").concat(a3) : "".concat(r4, "?").concat(a3), o3 ? "".concat(r4, "#").concat(o3) : r4;
  }(O2, c3));
  var N2 = new vA(tv({ onBeforeUpload: E2, restrictions: { maxFileSize: a2, maxNumberOfFiles: u2 }, meta: c3 }, e10.uppyConfig)).use(JA, tv({ endpoint: O2, headers: h2, formData: true, fieldName: o2, bundle: true, withCredentials: v2, timeout: y2 }, e10.xhrConfig));
  return N2.on("complete", function(e11) {
    var t3 = e11.successful[0], n3 = t3.response, r4 = (null != n3 ? n3 : {}).body, o3 = void 0 === r4 ? {} : r4;
    try {
      w2(t3, o3);
    } catch (e12) {
      console.error("wangEditor upload file - onSuccess error", e12);
    }
  }), N2.on("progress", function(e11) {
    e11 < 1 || x2(e11);
  }), N2.on("upload-error", function(e11, t3, n3) {
    try {
      S2(e11, t3, n3);
    } catch (e12) {
      console.error("wangEditor upload file - onError error", e12);
    }
  }), N2.on("restriction-failed", function(e11, t3) {
    try {
      S2(e11, t3);
    } catch (e12) {
      console.error("wangEditor upload file - onError error", e12);
    }
  }), N2;
}
tC("en", { editor: { more: "More", justify: "Justify", indent: "Indent", image: "Image", video: "Video" } }), tC("zh-CN", { editor: { more: "更多", justify: "对齐", indent: "缩进", image: "图片", video: "视频" } });
var ex, tx, nx, rx, ox, ix, ax, sx, ux, lx, cx, dx, fx, px, hx, gx = {};
function vx() {
  if (tx) return ex;
  tx = 1;
  var e10 = S();
  return ex = Array.isArray || function(t2) {
    return "Array" === e10(t2);
  };
}
function mx() {
  if (rx) return nx;
  rx = 1;
  var e10 = D(), t2 = C(), n2 = me(), r3 = Tr(), o2 = zt(), i2 = An(), a2 = function() {
  }, s2 = o2("Reflect", "construct"), u2 = /^\s*(?:class|function)\b/, l2 = e10(u2.exec), c3 = !u2.test(a2), d2 = function(e11) {
    if (!n2(e11)) return false;
    try {
      return s2(a2, [], e11), true;
    } catch (e12) {
      return false;
    }
  }, f2 = function(e11) {
    if (!n2(e11)) return false;
    switch (r3(e11)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return false;
    }
    try {
      return c3 || !!l2(u2, i2(e11));
    } catch (e12) {
      return true;
    }
  };
  return f2.sham = true, nx = !s2 || t2(function() {
    var e11;
    return d2(d2.call) || !d2(Object) || !d2(function() {
      e11 = true;
    }) || e11;
  }) ? f2 : d2;
}
function yx() {
  if (ix) return ox;
  ix = 1;
  var e10 = vx(), t2 = mx(), n2 = ye(), r3 = ve()("species"), o2 = Array;
  return ox = function(i2) {
    var a2;
    return e10(i2) && (a2 = i2.constructor, (t2(a2) && (a2 === o2 || e10(a2.prototype)) || n2(a2) && null === (a2 = a2[r3])) && (a2 = void 0)), void 0 === a2 ? o2 : a2;
  }, ox;
}
function bx() {
  if (sx) return ax;
  sx = 1;
  var e10 = yx();
  return ax = function(t2, n2) {
    return new (e10(t2))(0 === n2 ? 0 : n2);
  };
}
function Ex() {
  if (dx) return cx;
  dx = 1;
  var e10 = C();
  return cx = function(t2, n2) {
    var r3 = [][t2];
    return !!r3 && e10(function() {
      r3.call(null, n2 || function() {
        return 1;
      }, 1);
    });
  };
}
function Cx() {
  if (px) return fx;
  px = 1;
  var e10 = function() {
    if (lx) return ux;
    lx = 1;
    var e11 = Go(), t3 = D(), n2 = A(), r3 = ce(), o2 = Jt(), i2 = bx(), a2 = t3([].push), s2 = function(t4) {
      var s3 = 1 === t4, u2 = 2 === t4, l2 = 3 === t4, c3 = 4 === t4, d2 = 6 === t4, f2 = 7 === t4, p2 = 5 === t4 || d2;
      return function(h2, g2, v2, m2) {
        for (var y2, b2, E2 = r3(h2), C2 = n2(E2), w2 = o2(C2), D2 = e11(g2, v2), S2 = 0, A2 = m2 || i2, x2 = s3 ? A2(h2, w2) : u2 || f2 ? A2(h2, 0) : void 0; w2 > S2; S2++) if ((p2 || S2 in C2) && (b2 = D2(y2 = C2[S2], S2, E2), t4)) if (s3) x2[S2] = b2;
        else if (b2) switch (t4) {
          case 3:
            return true;
          case 5:
            return y2;
          case 6:
            return S2;
          case 2:
            a2(x2, y2);
        }
        else switch (t4) {
          case 4:
            return false;
          case 7:
            a2(x2, y2);
        }
        return d2 ? -1 : l2 || c3 ? c3 : x2;
      };
    };
    return ux = { forEach: s2(0), map: s2(1), filter: s2(2), some: s2(3), every: s2(4), find: s2(5), findIndex: s2(6), filterReject: s2(7) };
  }().forEach, t2 = Ex()("forEach");
  return fx = t2 ? [].forEach : function(t3) {
    return e10(this, t3, arguments.length > 1 ? arguments[1] : void 0);
  }, fx;
}
!function() {
  if (hx) return gx;
  hx = 1;
  var e10 = B(), t2 = ci(), n2 = di(), r3 = Cx(), o2 = ln(), i2 = function(e11) {
    if (e11 && e11.forEach !== r3) try {
      o2(e11, "forEach", r3);
    } catch (t3) {
      e11.forEach = r3;
    }
  };
  for (var a2 in t2) t2[a2] && i2(e10[a2] && e10[a2].prototype);
  i2(n2);
}();
tC("en", { common: { ok: "OK", delete: "Delete", enter: "Enter" }, blockQuote: { title: "Quote" }, codeBlock: { title: "Code block" }, color: { color: "Font color", bgColor: "Back color", default: "Default color", clear: "Clear back color" }, divider: { title: "Divider" }, emotion: { title: "Emotion" }, fontSize: { title: "Font size", default: "Default" }, fontFamily: { title: "Font family", default: "Default" }, fullScreen: { title: "Full screen", cancelTitle: "Cancel full screen" }, header: { title: "Header", text: "Text" }, image: { netImage: "Net image", delete: "Delete image", edit: "Edit image", editSize: "Edit size", viewLink: "View link", src: "Image src", desc: "Description", link: "Image link", ok: "Ok", width: "Width", height: "Height" }, indent: { decrease: "Decrease", increase: "Increase" }, justify: { left: "Left", right: "Right", center: "Center", justify: "Justify" }, lineHeight: { title: "Line height", default: "Default" }, link: { insert: "Insert link", text: "Link text", url: "Link source", unLink: "Unlink", edit: "Edit link", view: "View link" }, textStyle: { bold: "Bold", clear: "Clear styles", code: "Inline code", italic: "Italic", sub: "Sub", sup: "Sup", through: "Through", underline: "Underline" }, undo: { undo: "undo", redo: "Redo" }, todo: { todo: "Todo" }, formatPainter: { title: "Format Painter" } }), tC("zh-CN", { common: { ok: "确定", delete: "删除", enter: "回车" }, blockQuote: { title: "引用" }, codeBlock: { title: "代码块" }, color: { color: "文字颜色", bgColor: "背景色", default: "默认颜色", clear: "清除背景色" }, divider: { title: "分割线" }, emotion: { title: "表情" }, fontSize: { title: "字号", default: "默认字号" }, fontFamily: { title: "字体", default: "默认字体" }, fullScreen: { title: "全屏", cancelTitle: "取消全屏" }, header: { title: "标题", text: "正文" }, image: { netImage: "网络图片", delete: "删除图片", edit: "编辑图片", editSize: "修改尺寸", viewLink: "查看链接", src: "图片地址", desc: "图片描述", link: "图片链接", ok: "确定", width: "宽度", height: "高度" }, indent: { decrease: "减少缩进", increase: "增加缩进" }, justify: { left: "左对齐", right: "右对齐", center: "居中对齐", justify: "两端对齐" }, lineHeight: { title: "行高", default: "默认行高" }, link: { insert: "插入链接", text: "链接文本", url: "链接地址", unLink: "取消链接", edit: "修改链接", view: "查看链接" }, textStyle: { bold: "粗体", clear: "清除格式", code: "行内代码", italic: "斜体", sub: "下标", sup: "上标", through: "删除线", underline: "下划线" }, undo: { undo: "撤销", redo: "重做" }, todo: { todo: "待办" }, formatPainter: { title: "格式刷" } });
var wx = { type: "blockquote", elemToHtml: function(e10, t2) {
  return "<blockquote>".concat(t2, "</blockquote>");
} }, Dx = '<svg viewBox="0 0 1024 1024"><path d="M864 0a160 160 0 0 1 128 256l-64 64-224-224 64-64c26.752-20.096 59.968-32 96-32zM64 736l-64 288 288-64 592-592-224-224L64 736z m651.584-372.416l-448 448-55.168-55.168 448-448 55.168 55.168z"></path></svg>', Sx = '<svg viewBox="0 0 1024 1024"><path d="M924.402464 1023.068211H0.679665V99.345412h461.861399v98.909208H99.596867v725.896389h725.896389V561.206811h98.909208z" p-id="10909"></path><path d="M930.805104 22.977336l69.965436 69.965436-453.492405 453.492404-69.965435-69.901489z" p-id="10910"></path><path d="M1022.464381 304.030081h-98.917201V99.345412H709.230573V0.428211h313.233808z"></path></svg>', Ax = '<svg viewBox="0 0 1024 1024"><path d="M133.705143 335.433143V133.851429h201.581714a29.622857 29.622857 0 0 0 29.622857-29.549715V68.754286a29.622857 29.622857 0 0 0-29.622857-29.622857H61.732571A22.893714 22.893714 0 0 0 38.765714 62.025143V335.725714c0 16.310857 13.238857 29.622857 29.622857 29.622857h35.547429a29.842286 29.842286 0 0 0 29.696-29.842285zM690.980571 133.851429h201.581715v201.654857c0 16.310857 13.238857 29.549714 29.622857 29.549714h35.547428a29.622857 29.622857 0 0 0 29.549715-29.549714V61.952a22.893714 22.893714 0 0 0-22.820572-22.893714h-273.554285a29.622857 29.622857 0 0 0-29.549715 29.622857v35.547428c0 16.310857 13.238857 29.696 29.622857 29.696zM335.286857 892.781714H133.705143V691.2a29.622857 29.622857 0 0 0-29.622857-29.622857H68.534857a29.622857 29.622857 0 0 0-29.549714 29.622857v273.554286c0 12.653714 10.24 22.893714 22.820571 22.893714h273.554286a29.622857 29.622857 0 0 0 29.696-29.622857v-35.547429a29.769143 29.769143 0 0 0-29.769143-29.696z m557.348572-201.581714v201.581714H690.907429a29.622857 29.622857 0 0 0-29.622858 29.622857v35.547429c0 16.310857 13.238857 29.622857 29.622858 29.622857h273.554285c12.580571 0 22.893714-10.313143 22.893715-22.893714V691.2a29.622857 29.622857 0 0 0-29.622858-29.622857h-35.547428a29.622857 29.622857 0 0 0-29.696 29.622857z"></path></svg>', xx = function() {
  function e10() {
    this.title = iC("blockQuote.title"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M894.6 907.1H605.4c-32.6 0-59-26.4-59-59V608.2l-4-14.9c0-315.9 125.5-485.1 376.5-507.5v59.8C752.7 180.4 711.3 315.8 711.3 442.4v41.2l31.5 12.3h151.8c32.6 0 59 26.4 59 59v293.2c0 32.5-26.4 59-59 59z m-472 0H133.4c-32.6 0-59-26.4-59-59V608.2l-4-14.9c0-315.9 125.5-485.1 376.5-507.5v59.8C280.7 180.4 239.3 315.8 239.3 442.4v41.2l31.5 12.3h151.8c32.6 0 59 26.4 59 59v293.2c0 32.5-26.4 59-59 59z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return !!zy.getSelectedNodeByType(e11, "blockquote");
  }, e10.prototype.isDisabled = function(e11) {
    if (null == e11.selection) return true;
    var t2 = iv(eg.nodes(e11, { match: function(e12) {
      var t3 = zy.getNodeType(e12);
      return "paragraph" === t3 || "blockquote" === t3;
    }, universal: true, mode: "highest" }), 1);
    return !t2[0];
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = this.isActive(e11) ? "paragraph" : "blockquote";
      Wg.setNodes(e11, { type: n2 }, { mode: "highest" });
    }
  }, e10;
}(), Ox = { key: "blockquote", factory: function() {
  return new xx();
} };
function Nx(e10) {
  return 0 === fm("<div>".concat(e10, "</div>")).children().filter(function(e11) {
    return "BR" !== e11.tagName;
  }).length;
}
function Bx(e10) {
  return 0 === e10.length ? "" : e10[0].outerHTML;
}
function Tx(e10) {
  return e10.length ? e10[0].tagName.toLowerCase() : "";
}
function kx(e10, t2) {
  for (var n2 = "", r3 = (e10.attr("style") || "").split(";"), o2 = r3.length, i2 = 0; i2 < o2; i2 += 1) {
    var a2 = r3[i2];
    if (a2) {
      var s2 = a2.split(":");
      s2[0].trim() === t2 && (n2 = s2[1].trim());
    }
  }
  return n2;
}
Nm && (fm.fn.css = Nm), Pm && (fm.fn.append = Pm), _m2 && (fm.fn.prepend = _m2), pm && (fm.fn.addClass = pm), hm && (fm.fn.removeClass = hm), gm && (fm.fn.hasClass = gm), Cm && (fm.fn.on = Cm), wm && (fm.fn.off = wm), Wm && (fm.fn.focus = Wm), vm && (fm.fn.attr = vm), mm && (fm.fn.removeAttr = mm), xm && (fm.fn.hide = xm), Om && (fm.fn.show = Om), Lm && (fm.fn.parents = Lm), bm && (fm.fn.dataset = bm), Em && (fm.fn.val = Em), Fm && (fm.fn.text = Fm), km && (fm.fn.html = km), jm && (fm.fn.children = jm), Hm && (fm.fn.remove = Hm), Mm && (fm.fn.find = Mm), Dm && (fm.fn.width = Dm), Sm && (fm.fn.height = Sm), Tm && (fm.fn.filter = Tm), zm && (fm.fn.empty = zm);
var Fx = { selector: "blockquote:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  return 0 === (t2 = t2.filter(function(e11) {
    return !!Og.isText(e11) || !!n2.isInline(e11);
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]), { type: "blockquote", children: t2 };
} };
function Ix(e10) {
  e10.deleteBackward("character");
  Wg.insertNodes(e10, { type: "paragraph", children: [{ text: "" }] }, { mode: "highest" });
}
var Px = { type: "blockquote", renderElem: function(e10, t2, n2) {
  return Pw("blockquote", null, t2);
} }, _x2 = { renderElems: [Px], elemsToHtml: [wx], parseElemsHtml: [Fx], menus: [Ox], editorPlugin: function(e10) {
  var t2 = e10.insertBreak, n2 = e10.insertText, r3 = e10;
  return r3.insertBreak = function() {
    var o2 = r3.selection;
    if (null == o2) return t2();
    var i2 = iv(eg.nodes(e10, { match: function(e11) {
      return zy.checkNodeType(e11, "blockquote");
    }, universal: true }), 1), a2 = i2[0];
    if (!a2) return t2();
    var s2 = a2[0];
    if (zy.getParentNode(e10, s2)) {
      var u2 = zy.findPath(e10, s2), l2 = eg.end(e10, u2);
      if (hg.equals(l2, o2.focus)) {
        var c3 = eg.last(e10, l2.path), d2 = ag.string(c3[0]);
        if (d2 && "\n" === d2.slice(-1)) return void Ix(r3);
      }
      n2("\n");
    } else Ix(r3);
  }, r3;
} };
var Rx = { type: "code", elemToHtml: function(e10, t2) {
  return "<code>".concat(t2, "</code>");
} };
var Lx = { type: "pre", elemToHtml: function(e10, t2) {
  return "<pre>".concat(t2, "</pre>");
} }, Mx = function() {
  function e10() {
    this.title = iC("codeBlock.title"), this.iconSvg = '<svg viewBox="0 0 1280 1024"><path d="M832 736l96 96 320-320L928 192l-96 96 224 224zM448 288l-96-96L32 512l320 320 96-96-224-224zM701.312 150.528l69.472 18.944-192 704.032-69.472-18.944 192-704.032z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getSelectCodeElem = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "code");
    if (null == t2) return null;
    var n2 = zy.getParentNode(e11, t2);
    return null == n2 || "pre" !== zy.getNodeType(n2) ? null : t2;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.getSelectCodeElem(e11);
    if (null == t2) {
      var n2 = e11.getMenuConfig("codeSelectLang").codeLangs, r3 = (void 0 === n2 ? [] : n2).find(function(e12) {
        return e12.selected;
      });
      return (null == r3 ? void 0 : r3.value) || "";
    }
    return t2.language || "";
  }, e10.prototype.isActive = function(e11) {
    return !!this.getSelectCodeElem(e11);
  }, e10.prototype.isDisabled = function(e11) {
    if (null == e11.selection) return true;
    var t2 = zy.getSelectedElems(e11);
    return !!t2.some(function(t3) {
      return e11.isVoid(t3);
    }) || !t2.some(function(e12) {
      var t3 = zy.getNodeType(e12);
      return "pre" === t3 || "paragraph" === t3;
    });
  }, e10.prototype.exec = function(e11, t2) {
    this.isActive(e11) ? this.changeToPlainText(e11) : this.changeToCodeBlock(e11, t2.toString());
  }, e10.prototype.changeToPlainText = function(e11) {
    var t2 = this.getSelectCodeElem(e11);
    if (null != t2) {
      var n2 = ag.string(t2);
      Wg.removeNodes(e11, { mode: "highest" });
      var r3 = n2.split("\n").map(function(e12) {
        return { type: "paragraph", children: [{ text: e12 }] };
      });
      Wg.insertNodes(e11, r3, { mode: "highest" });
    }
  }, e10.prototype.changeToCodeBlock = function(e11, t2) {
    var n2, r3, o2 = [], i2 = eg.nodes(e11, { match: function(t3) {
      return e11.children.includes(t3);
    }, universal: true });
    try {
      for (var a2 = ov(i2), s2 = a2.next(); !s2.done; s2 = a2.next()) {
        var u2 = iv(s2.value, 1)[0];
        u2 && o2.push(ag.string(u2));
      }
    } catch (e12) {
      n2 = { error: e12 };
    } finally {
      try {
        s2 && !s2.done && (r3 = a2.return) && r3.call(a2);
      } finally {
        if (n2) throw n2.error;
      }
    }
    Wg.removeNodes(e11, { mode: "highest" });
    var l2 = { type: "pre", children: [{ type: "code", language: t2, children: [{ text: o2.join("\n") }] }] };
    Wg.insertNodes(e11, l2, { mode: "highest" });
  }, e10;
}();
var jx = { selector: "pre:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  return 0 === (t2 = t2.filter(function(e11) {
    return "code" === zy.getNodeType(e11);
  })).length && (t2 = [{ type: "code", language: "", children: [{ text: r3[0].textContent || "" }] }]), { type: "pre", children: t2.filter(function(e11) {
    return "code" === zy.getNodeType(e11);
  }) };
} };
var Hx = { type: "pre", renderElem: function(e10, t2, n2) {
  return Pw("pre", null, t2);
} }, zx = { type: "code", renderElem: function(e10, t2, n2) {
  return Pw("code", null, t2);
} }, $x = { menus: [{ key: "codeBlock", factory: function() {
  return new Mx();
} }], editorPlugin: function(e10) {
  var t2 = e10.insertBreak, n2 = e10.normalizeNode, r3 = e10.insertData, o2 = e10.handleTab, i2 = e10;
  return i2.insertBreak = function() {
    var e11 = zy.getSelectedNodeByType(i2, "code");
    if (null != e11) {
      var n3 = function(e12, t3) {
        var n4 = t3.selection;
        if (null == n4) return "";
        var r5 = ag.string(e12), o4 = n4.anchor.offset, i3 = r5.slice(0, o4).split("\n"), a2 = i3.length;
        return 0 === a2 ? "" : i3[a2 - 1];
      }(e11, i2);
      if (n3) {
        var r4 = n3.match(/^\s+/);
        if (null != r4 && null != r4[0]) {
          var o3 = r4[0];
          return void i2.insertText("\n".concat(o3));
        }
      }
      i2.insertText("\n");
    } else t2();
  }, e10.handleTab = function() {
    var t3 = e10.selection;
    if (t3) {
      var n3 = zy.getSelectedNodeByType(e10, "code");
      if (n3 && !yg.isCollapsed(t3)) {
        var r4 = iv([t3.anchor, t3.focus].sort(function(e11, t4) {
          return e11.offset - t4.offset;
        }), 2), i3 = r4[0], a2 = r4[1], s2 = n3.children[0].text, u2 = s2.split("\n"), l2 = s2.slice(0, i3.offset).split("\n").length - 1, c3 = s2.slice(0, a2.offset).split("\n").length - 1, d2 = u2.map(function(e11, t4) {
          return t4 >= l2 && t4 <= c3 ? "  ".concat(e11) : e11;
        }), f2 = d2.join("\n"), p2 = { anchor: { path: i3.path, offset: i3.offset + 2 }, focus: { path: a2.path, offset: a2.offset + 2 } };
        Wg.insertText(e10, f2, { at: { anchor: { path: i3.path, offset: 0 }, focus: { path: a2.path, offset: s2.length } } }), Wg.select(e10, p2);
      } else o2();
    }
  }, i2.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), r4 = t3[0], o3 = t3[1], a2 = zy.getNodeType(r4);
    ("code" === a2 && o3.length <= 1 && Wg.setNodes(i2, { type: "paragraph" }, { at: o3 }), "pre" === a2) && (zy.isLastNode(i2, r4) && Wg.insertNodes(i2, zy.genEmptyParagraph(), { at: [o3[0] + 1] }), "code" !== zy.getNodeType(r4.children[0]) && (Wg.unwrapNodes(i2), Wg.setNodes(i2, { type: "paragraph" }, { mode: "highest" })));
    return n2([r4, o3]);
  }, i2.insertData = function(e11) {
    if (null != zy.getSelectedNodeByType(i2, "code")) {
      var t3 = e11.getData("text/plain");
      eg.insertText(i2, t3);
    } else r3(e11);
  }, i2;
}, renderElems: [Hx, zx], elemsToHtml: [Rx, Lx], preParseHtml: [{ selector: "pre>code", preParseHtml: function(e10) {
  var t2 = fm(e10);
  if ("code" !== Tx(t2)) return e10;
  var n2 = t2.find("xmp");
  if (0 === n2.length) return e10;
  var r3 = n2.text();
  return n2.remove(), t2.text(r3), t2[0];
} }], parseElemsHtml: [{ selector: "pre:not([data-w-e-type])>code", parseElemHtml: function(e10, t2, n2) {
  return { type: "code", language: "", children: [{ text: fm(e10)[0].textContent || "" }] };
} }, jx] }, Ux = function() {
  function e10() {
    this.tag = "button", this.showDropPanel = true, this.$content = null;
  }
  return e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.mark, n2 = eg.marks(e11);
    return n2 && n2[t2] ? n2[t2] : "";
  }, e10.prototype.isActive = function(e11) {
    return !!this.getValue(e11);
  }, e10.prototype.isDisabled = function(e11) {
    if (null == e11.selection) return true;
    var t2 = iv(eg.nodes(e11, { match: function(t3) {
      return "pre" === zy.getNodeType(t3) || !!eg.isVoid(e11, t3);
    }, universal: true }), 1);
    return !!t2[0];
  }, e10.prototype.getPanelContentElem = function(e11) {
    var t2 = this.mark;
    if (null == this.$content) {
      var n2 = fm('<ul class="w-e-panel-content-color"></ul>');
      n2.on("click", "li", function(n3) {
        var r4 = n3.target;
        if (null != r4 && (n3.preventDefault(), null != e11.selection)) {
          var o3 = fm(r4).attr("data-value");
          "0" === o3 ? eg.removeMark(e11, t2) : eg.addMark(e11, t2, o3);
        }
      }), this.$content = n2;
    }
    var r3 = this.$content;
    if (null == r3) return document.createElement("ul");
    r3.empty();
    var o2 = this.getValue(e11), i2 = e11.getMenuConfig(t2).colors;
    (void 0 === i2 ? [] : i2).forEach(function(e12) {
      var t3 = fm('<div class="color-block" data-value="'.concat(e12, '"></div>'));
      t3.css("background-color", e12);
      var n3 = fm('<li data-value="'.concat(e12, '"></li>'));
      o2 === e12 && n3.addClass("active"), n3.append(t3), r3.append(n3);
    });
    var a2 = "";
    "color" === t2 && (a2 = iC("color.default")), "bgColor" === t2 && (a2 = iC("color.clear"));
    var s2 = fm('\n      <li data-value="0" class="clear">\n        '.concat('<svg viewBox="0 0 1024 1024"><path d="M236.8 128L896 787.2V128H236.8z m614.4 704L192 172.8V832h659.2zM192 64h704c38.4 0 64 25.6 64 64v704c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64z"></path></svg>', "\n        ").concat(a2, "\n      </li>\n    "));
    return r3.prepend(s2), r3[0];
  }, e10;
}(), Vx = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("color.bgColor"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M510.030769 315.076923l84.676923 196.923077h-177.230769l76.8-196.923077h15.753846zM945.230769 157.538462v708.923076c0 43.323077-35.446154 78.769231-78.769231 78.769231H157.538462c-43.323077 0-78.769231-35.446154-78.769231-78.769231V157.538462c0-43.323077 35.446154-78.769231 78.769231-78.769231h708.923076c43.323077 0 78.769231 35.446154 78.769231 78.769231z m-108.307692 643.938461L600.615385 216.615385c-5.907692-11.815385-15.753846-19.692308-29.538462-19.692308h-139.815385c-11.815385 0-23.630769 7.876923-27.56923 19.692308l-216.615385 584.861538c-3.938462 11.815385 3.938462 25.6 17.723077 25.6h80.738462c11.815385 0 23.630769-9.846154 27.56923-21.661538l63.015385-175.261539h263.876923l68.923077 175.261539c3.938462 11.815385 15.753846 21.661538 27.569231 21.661538h80.738461c13.784615 0 23.630769-13.784615 19.692308-25.6z"></path></svg>', t3.mark = "bgColor", t3;
  }
  return ev(t2, e10), t2;
}(Ux), Wx = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("color.color"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M64 864h896v96H64zM360.58 576h302.85l81.53 224h102.16L579.24 64H444.77L176.89 800h102.16l81.53-224zM512 159.96L628.49 480H395.52L512 159.96z"></path></svg>', t3.mark = "color", t3;
  }
  return ev(t2, e10), t2;
}(Ux), Gx = ["rgb(0, 0, 0)", "rgb(38, 38, 38)", "rgb(89, 89, 89)", "rgb(140, 140, 140)", "rgb(191, 191, 191)", "rgb(217, 217, 217)", "rgb(233, 233, 233)", "rgb(245, 245, 245)", "rgb(250, 250, 250)", "rgb(255, 255, 255)", "rgb(225, 60, 57)", "rgb(231, 95, 51)", "rgb(235, 144, 58)", "rgb(245, 219, 77)", "rgb(114, 192, 64)", "rgb(89, 191, 192)", "rgb(66, 144, 247)", "rgb(54, 88, 226)", "rgb(106, 57, 201)", "rgb(216, 68, 147)", "rgb(251, 233, 230)", "rgb(252, 237, 225)", "rgb(252, 239, 212)", "rgb(252, 251, 207)", "rgb(231, 246, 213)", "rgb(218, 244, 240)", "rgb(217, 237, 250)", "rgb(224, 232, 250)", "rgb(237, 225, 248)", "rgb(246, 226, 234)", "rgb(255, 163, 158)", "rgb(255, 187, 150)", "rgb(255, 213, 145)", "rgb(255, 251, 143)", "rgb(183, 235, 143)", "rgb(135, 232, 222)", "rgb(145, 213, 255)", "rgb(173, 198, 255)", "rgb(211, 173, 247)", "rgb(255, 173, 210)", "rgb(255, 77, 79)", "rgb(255, 122, 69)", "rgb(255, 169, 64)", "rgb(255, 236, 61)", "rgb(115, 209, 61)", "rgb(54, 207, 201)", "rgb(64, 169, 255)", "rgb(89, 126, 247)", "rgb(146, 84, 222)", "rgb(247, 89, 171)", "rgb(207, 19, 34)", "rgb(212, 56, 13)", "rgb(212, 107, 8)", "rgb(212, 177, 6)", "rgb(56, 158, 13)", "rgb(8, 151, 156)", "rgb(9, 109, 217)", "rgb(29, 57, 196)", "rgb(83, 29, 171)", "rgb(196, 29, 127)", "rgb(130, 0, 20)", "rgb(135, 20, 0)", "rgb(135, 56, 0)", "rgb(97, 71, 0)", "rgb(19, 82, 0)", "rgb(0, 71, 79)", "rgb(0, 58, 140)", "rgb(6, 17, 120)", "rgb(34, 7, 94)", "rgb(120, 6, 80)"];
var qx = { selector: "font", preParseHtml: function(e10) {
  var t2 = fm(e10);
  if ("font" !== Tx(t2)) return e10;
  var n2 = t2.attr("color") || "";
  return n2 && (t2.removeAttr("color"), t2.css("color", n2)), t2[0];
} };
function Kx(e10, t2) {
  null == e10.data && (e10.data = {});
  var n2 = e10.data;
  null == n2.style && (n2.style = {}), Object.assign(n2.style, t2);
}
var Yx = { renderStyle: function(e10, t2) {
  var n2 = e10, r3 = n2.color, o2 = n2.bgColor, i2 = t2;
  return r3 && Kx(i2, { color: r3 }), o2 && Kx(i2, { backgroundColor: o2 }), i2;
}, styleToHtml: function(e10, t2) {
  if (!Og.isText(e10)) return t2;
  var n2, r3 = e10, o2 = r3.color, i2 = r3.bgColor;
  return o2 || i2 ? ((Nx(t2) || "span" !== Tx(n2 = fm(t2))) && (n2 = fm("<span>".concat(t2, "</span>"))), o2 && n2.css("color", o2), i2 && n2.css("background-color", i2), Bx(n2)) : t2;
}, preParseHtml: [qx], parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Og.isText(t2)) return t2;
  var o2 = t2, i2 = kx(r3, "color");
  i2 && (o2.color = i2);
  var a2 = kx(r3, "background-color");
  return a2 || (a2 = kx(r3, "background")), a2 && (o2.bgColor = a2), o2;
}, menus: [{ key: "color", factory: function() {
  return new Wx();
}, config: { colors: Gx } }, { key: "bgColor", factory: function() {
  return new Vx();
}, config: { colors: Gx } }] }, Xx = function() {
  function e10() {
    this.title = iC("common.enter"), this.iconSvg = '<svg viewBox="0 0 1255 1024"><path d="M1095.111111 731.477333h-625.777778V1024L0 658.318222 469.333333 292.408889v292.636444h625.777778V0h156.444445v731.477333z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || !!yg.isExpanded(t2);
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = e11.selection;
    if (null != n2) {
      var r3 = [n2.anchor.path[0]];
      Wg.insertNodes(e11, { type: "paragraph", children: [{ text: "" }] }, { at: r3 }), e11.select(eg.start(e11, r3));
    }
  }, e10;
}(), Zx = { menus: [{ key: "enter", factory: function() {
  return new Xx();
} }] };
var Jx = { type: "divider", elemToHtml: function(e10, t2) {
  return "<hr/>";
} }, Qx = function() {
  function e10() {
    this.title = iC("divider.title"), this.iconSvg = '<svg viewBox="0 0 1092 1024"><path d="M0 51.2m51.2 0l989.866667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-989.866667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M0 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M819.2 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M409.6 460.8m51.2 0l170.666667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-170.666667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path><path d="M0 870.4m51.2 0l989.866667 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-989.866667 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !!zy.getSelectedElems(e11).some(function(t2) {
      if (e11.isVoid(t2)) return true;
      var n2 = zy.getNodeType(t2);
      return "table" === n2 || "pre" === n2;
    });
  }, e10.prototype.exec = function(e11, t2) {
    zy.isSelectedEmptyParagraph(e11) && Wg.removeNodes(e11, { mode: "highest" }), Wg.insertNodes(e11, { type: "divider", children: [{ text: "" }] }, { mode: "highest" });
  }, e10;
}();
var eO = { renderElems: [{ type: "divider", renderElem: function(e10, t2, n2) {
  return hw("div", { props: { contentEditable: false, className: "w-e-textarea-divider" }, dataset: { selected: zy.isNodeSelected(n2, e10) ? "true" : "" }, style: {}, on: { mousedown: function(e11) {
    return e11.preventDefault();
  } } }, [hw("hr")]);
} }], elemsToHtml: [Jx], parseElemsHtml: [{ selector: "hr:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  return { type: "divider", children: [{ text: "" }] };
} }], menus: [{ key: "divider", factory: function() {
  return new Qx();
} }], editorPlugin: function(e10) {
  var t2 = e10.isVoid, n2 = e10.normalizeNode, r3 = e10;
  return r3.isVoid = function(e11) {
    return "divider" === e11.type || t2(e11);
  }, r3.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), o2 = t3[0], i2 = t3[1];
    if ("divider" !== zy.getNodeType(o2)) return n2([o2, i2]);
    zy.isLastNode(r3, o2) && Wg.insertNodes(r3, zy.genEmptyParagraph(), { at: [i2[0] + 1] });
  }, r3;
} };
var tO = function() {
  function e10() {
    this.title = iC("emotion.title"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M512 1024C230.4 1024 0 793.6 0 512S230.4 0 512 0s512 230.4 512 512-230.4 512-512 512z m0-102.4c226.742857 0 409.6-182.857143 409.6-409.6S738.742857 102.4 512 102.4 102.4 285.257143 102.4 512s182.857143 409.6 409.6 409.6z m-204.8-358.4h409.6c0 113.371429-91.428571 204.8-204.8 204.8s-204.8-91.428571-204.8-204.8z m0-102.4c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8 76.8 32.914286 76.8 76.8-32.914286 76.8-76.8 76.8z m409.6 0c-43.885714 0-76.8-32.914286-76.8-76.8s32.914286-76.8 76.8-76.8c43.885714 0 76.8 32.914286 76.8 76.8s-32.914286 76.8-76.8 76.8z"></path></svg>', this.tag = "button", this.showDropPanel = true, this.$content = null;
  }
  return e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    if (null == e11.selection) return true;
    var t2 = iv(eg.nodes(e11, { match: function(t3) {
      return "pre" === zy.getNodeType(t3) || !!eg.isVoid(e11, t3);
    }, universal: true }), 1);
    return !!t2[0];
  }, e10.prototype.getPanelContentElem = function(e11) {
    if (null == this.$content) {
      var t2 = fm('<ul class="w-e-panel-content-emotion"></ul>');
      t2.on("click", "li", function(t3) {
        var n3 = t3.target;
        if (null != n3) {
          t3.preventDefault();
          var r4 = fm(n3).text();
          e11.insertText(r4);
        }
      }), this.$content = t2;
    }
    var n2 = this.$content;
    if (null == n2) return document.createElement("ul");
    n2.empty();
    var r3 = e11.getMenuConfig("emotion").emotions;
    return (void 0 === r3 ? [] : r3).forEach(function(e12) {
      var t3 = fm("<li>".concat(e12, "</li>"));
      n2.append(t3);
    }), n2[0];
  }, e10;
}(), nO = { menus: [{ key: "emotion", factory: function() {
  return new tO();
}, config: { emotions: "😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😛 😝 😜 🤓 😎 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 😢 😭 😤 😠 😡 😳 😱 😨 🤗 🤔 😶 😑 😬 🙄 😯 😴 😷 🤑 😈 🤡 💩 👻 💀 👀 👣 👐 🙌 👏 🤝 👍 👎 👊 ✊ 🤛 🤜 🤞 ✌️ 🤘 👌 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐 🖖 👋 🤙 💪 🖕 ✍️ 🙏".split(" ") } }] };
var rO = function() {
  function e10() {
    this.tag = "select", this.width = 80;
  }
  return e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.mark, n2 = eg.marks(e11);
    return n2 && n2[t2] ? n2[t2] : "";
  }, e10.prototype.isDisabled = function(e11) {
    if (null == e11.selection) return true;
    var t2 = iv(eg.nodes(e11, { match: function(t3) {
      return "pre" === zy.getNodeType(t3) || !!eg.isVoid(e11, t3);
    }, universal: true }), 1);
    return !!t2[0];
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.mark;
    t2 ? e11.addMark(n2, t2) : e11.removeMark(n2);
  }, e10;
}(), oO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("fontFamily.title"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M956.788364 152.110545h-24.110546l23.924364 9.029819 0.186182 121.018181h-65.070546l-86.574545-130.048H566.551273v650.14691l130.048 64.977454v65.163636h-390.050909v-65.163636l129.954909-64.977454V152.110545H198.283636L111.429818 282.065455H46.545455V69.259636C46.545455 33.792 82.664727 22.062545 98.955636 22.062545h812.683637c23.738182 0 45.056 15.173818 45.056 41.053091V169.425455v-17.221819z"></path></svg>', t3.mark = "fontFamily", t3.selectPanelWidth = 150, t3;
  }
  return ev(t2, e10), t2.prototype.getOptions = function(e11) {
    var t3 = [], n2 = e11.getMenuConfig(this.mark).fontFamilyList, r3 = void 0 === n2 ? [] : n2;
    t3.push({ text: iC("fontFamily.default"), value: "" }), r3.forEach(function(e12) {
      if ("string" == typeof e12) t3.push({ text: e12, value: e12, styleForRenderMenuList: { "font-family": e12 } });
      else if ("object" == typeof e12) {
        var n3 = e12.name, r4 = e12.value;
        t3.push({ text: n3, value: r4, styleForRenderMenuList: { "font-family": r4 } });
      }
    });
    var o2 = this.getValue(e11), i2 = false;
    return t3.forEach(function(e12) {
      e12.value === o2 ? (i2 = true, e12.selected = true) : e12.selected = void 0;
    }), i2 || "string" != typeof o2 || t3.push({ text: o2, value: o2, selected: true }), t3;
  }, t2;
}(rO), iO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("fontSize.title"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M64 512h384v128h-128V1024h-128V640h-128z m896-256H708.2496v768h-136.4992V256H320V128h640z"></path></svg>', t3.mark = "fontSize", t3;
  }
  return ev(t2, e10), t2.prototype.getOptions = function(e11) {
    var t3 = [], n2 = e11.getMenuConfig(this.mark).fontSizeList, r3 = void 0 === n2 ? [] : n2;
    t3.push({ text: iC("fontSize.default"), value: "" }), r3.forEach(function(e12) {
      if ("string" == typeof e12) t3.push({ text: e12, value: e12 });
      else if ("object" == typeof e12) {
        var n3 = e12.name, r4 = e12.value;
        t3.push({ text: n3, value: r4 });
      }
    });
    var o2 = this.getValue(e11), i2 = false;
    return t3.forEach(function(e12) {
      e12.value === o2 ? (i2 = true, e12.selected = true) : e12.selected = void 0;
    }), i2 || "string" != typeof o2 || t3.push({ text: o2, value: o2, selected: true }), t3;
  }, t2;
}(rO);
var aO = { 1: "12px", 2: "14px", 3: "16px", 4: "19px", 5: "24px", 6: "32px", 7: "48px" };
var sO = { renderStyle: function(e10, t2) {
  var n2 = e10, r3 = n2.fontSize, o2 = n2.fontFamily, i2 = t2;
  return r3 && Kx(i2, { fontSize: r3 }), o2 && Kx(i2, { fontFamily: o2 }), i2;
}, styleToHtml: function(e10, t2) {
  if (!Og.isText(e10)) return t2;
  var n2, r3 = e10, o2 = r3.fontSize, i2 = r3.fontFamily;
  return o2 || i2 ? ((Nx(t2) || "span" !== Tx(n2 = fm(t2))) && (n2 = fm("<span>".concat(t2, "</span>"))), o2 && n2.css("font-size", o2), i2 && n2.css("font-family", i2), Bx(n2)) : t2;
}, preParseHtml: [{ selector: "font", preParseHtml: function(e10) {
  var t2 = fm(e10);
  if ("font" !== Tx(t2)) return e10;
  var n2 = t2.attr("size") || "";
  n2 && (t2.removeAttr("size"), t2.css("font-size", aO[n2]));
  var r3 = t2.attr("face") || "";
  return r3 && (t2.removeAttr("face"), t2.css("font-family", r3)), t2[0];
} }], parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Og.isText(t2)) return t2;
  var o2 = t2, i2 = kx(r3, "font-size");
  i2 && (o2.fontSize = i2);
  var a2 = kx(r3, "font-family").replace(/"/g, "");
  return a2 && (o2.fontFamily = a2), o2;
}, menus: [{ key: "fontSize", factory: function() {
  return new iO();
}, config: { fontSizeList: ["12px", { name: "13px", value: "13px" }, "14px", "15px", "16px", "19px", { name: "22px", value: "22px" }, "24px", "29px", "32px", "40px", "48px"] } }, { key: "fontFamily", factory: function() {
  return new oO();
}, config: { fontFamilyList: ["黑体", { name: "仿宋", value: "仿宋" }, "楷体", "标楷体", "华文仿宋", "华文楷体", { name: "宋体", value: "宋体" }, "微软雅黑", "Arial", "Tahoma", "Verdana", "Times New Roman", "Courier New"] } }] };
var uO = function() {
  function e10() {
    this.title = iC("formatPainter.title"), this.iconSvg = '<svg viewBox="0 0 24 24"><path d="M8 19.997v-5h2v5h9v-7H5v7zm-4-9h16v-3h-6v-4h-4v4H4zm-1 10v-8H2v-6a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3h5a1 1 0 0 1 1 1v6h-1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1"/></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(t2) {
    return e10.attrs.isSelect;
  }, e10.prototype.isDisabled = function(e11) {
    return false;
  }, e10.prototype.setFormatHtml = function(t2) {
    var n2, r3;
    if (t2.getSelectionText().length) {
      if (e10.attrs.formatStyle) {
        !function(e11) {
          var t3 = eg.marks(e11);
          t3 && Object.keys(t3).forEach(function(t4) {
            e11.removeMark(t4);
          });
        }(t2);
        try {
          for (var o2 = ov(Object.entries(e10.attrs.formatStyle)), i2 = o2.next(); !i2.done; i2 = o2.next()) {
            var a2 = iv(i2.value, 2), s2 = a2[0], u2 = a2[1];
            t2.addMark(s2, u2);
          }
        } catch (e11) {
          n2 = { error: e11 };
        } finally {
          try {
            i2 && !i2.done && (r3 = o2.return) && r3.call(o2);
          } finally {
            if (n2) throw n2.error;
          }
        }
      }
      e10.attrs.formatStyle = null, e10.attrs.isSelect = false;
    }
  }, e10.prototype.exec = function(t2) {
    e10.attrs.isSelect ? (e10.attrs.isSelect = false, e10.attrs.formatStyle = null) : t2.getSelectionText().length && (e10.attrs.formatStyle = eg.marks(t2), e10.attrs.isSelect = true);
    t2.blur(), t2.focus();
  }, e10.attrs = { isSelect: false, formatStyle: null }, e10;
}();
var lO = { menus: [{ key: "formatPainter", factory: function() {
  return new uO();
} }], editorPlugin: function(e10) {
  var t2 = new uO(), n2 = e10.onChange, r3 = e10, o2 = function() {
    t2.setFormatHtml(r3), document.removeEventListener("mouseup", o2);
  };
  return r3.onChange = function() {
    n2(), uO.attrs.isSelect && (document.removeEventListener("mouseup", o2), document.addEventListener("mouseup", o2));
  }, r3;
} }, cO = function() {
  function e10() {
    this.title = iC("fullScreen.title"), this.iconSvg = Ax, this.tag = "button", this.alwaysEnable = true;
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return e11.isFullScreen;
  }, e10.prototype.isDisabled = function(e11) {
    return false;
  }, e10.prototype.getIcon = function(e11) {
    return e11.isFullScreen ? Ax : '<svg t="1723361745825" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8705" width="200" height="200"><path d="M703.926857 362.642286a42.642286 42.642286 0 0 1-42.642286-42.642286V128a42.642286 42.642286 0 1 1 85.357715 0v149.357714h149.357714c21.211429 0 38.765714 15.433143 42.057143 35.693715l0.585143 6.948571a42.642286 42.642286 0 0 1-42.642286 42.642286H703.926857zM703.926857 938.642286a42.642286 42.642286 0 0 1-42.642286-42.642286V704c0-23.552 19.090286-42.642286 42.642286-42.642286h192.073143a42.642286 42.642286 0 1 1 0 85.284572l-149.357714 0.073143v149.284571c0 21.211429-15.506286 38.765714-35.84 42.130286l-6.875429 0.512zM319.853714 938.642286a42.642286 42.642286 0 0 1-42.642285-42.642286v-149.284571H127.853714a42.642286 42.642286 0 0 1-42.130285-35.84l-0.585143-6.875429c0-23.552 19.163429-42.642286 42.715428-42.642286h192c23.552 0 42.715429 19.017143 42.715429 42.642286v192a42.642286 42.642286 0 0 1-42.715429 42.642286zM127.853714 362.642286a42.642286 42.642286 0 1 1 0-85.284572H277.211429V128c0-21.211429 15.433143-38.765714 35.766857-42.130286l6.875428-0.512c23.552 0 42.715429 19.017143 42.715429 42.642286v192a42.642286 42.642286 0 0 1-42.715429 42.642286H127.853714z" fill="#333333" p-id="8706"></path></svg>';
  }, e10.prototype.getTitle = function(e11) {
    return e11.isFullScreen ? iC("fullScreen.title") : iC("fullScreen.cancelTitle");
  }, e10.prototype.exec = function(e11, t2) {
    e11.isFullScreen ? e11.unFullScreen() : e11.fullScreen();
  }, e10;
}(), dO = { menus: [{ key: "fullScreen", factory: function() {
  return new cO();
} }] };
function fO(e10) {
  return function(t2, n2) {
    return "<h".concat(e10, ">").concat(n2, "</h").concat(e10, ">");
  };
}
var pO = { type: "header1", elemToHtml: fO(1) }, hO = { type: "header2", elemToHtml: fO(2) }, gO = { type: "header3", elemToHtml: fO(3) }, vO = { type: "header4", elemToHtml: fO(4) }, mO = { type: "header5", elemToHtml: fO(5) }, yO = { type: "header6", elemToHtml: fO(6) };
function bO(e10) {
  var t2 = iv(eg.nodes(e10, { match: function(e11) {
    return zy.getNodeType(e11).startsWith("header");
  }, universal: true }), 1), n2 = t2[0];
  if (null == n2) return "paragraph";
  var r3 = iv(n2, 1)[0];
  return zy.getNodeType(r3);
}
function EO(e10) {
  if (null == e10.selection) return true;
  var t2 = iv(eg.nodes(e10, { match: function(e11) {
    var t3 = zy.getNodeType(e11);
    return "paragraph" === t3 || !!t3.startsWith("header");
  }, universal: true, mode: "highest" }), 1);
  return !t2[0];
}
function CO(e10, t2) {
  t2 && Wg.setNodes(e10, { type: t2 });
}
var wO = function() {
  function e10() {
    this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return bO(e11);
  }, e10.prototype.isActive = function(e11) {
    return this.getValue(e11) === this.type;
  }, e10.prototype.isDisabled = function(e11) {
    return EO(e11);
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.type;
    CO(e11, t2 === n2 ? "paragraph" : n2);
  }, e10;
}(), DO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H1", t3.type = "header1", t3;
  }
  return ev(t2, e10), t2;
}(wO), SO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H2", t3.type = "header2", t3;
  }
  return ev(t2, e10), t2;
}(wO), AO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H3", t3.type = "header3", t3;
  }
  return ev(t2, e10), t2;
}(wO), xO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H4", t3.type = "header4", t3;
  }
  return ev(t2, e10), t2;
}(wO), OO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H5", t3.type = "header5", t3;
  }
  return ev(t2, e10), t2;
}(wO), NO = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "H6", t3.type = "header6", t3;
  }
  return ev(t2, e10), t2;
}(wO), BO = function() {
  function e10() {
    this.title = iC("header.title"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M960 960c-51.2 0-102.4-3.2-153.6-3.2-51.2 0-99.2 3.2-150.4 3.2-19.2 0-28.8-22.4-28.8-38.4 0-51.2 57.6-28.8 86.4-48 19.2-12.8 19.2-60.8 19.2-80v-224-19.2c-9.6-3.2-19.2-3.2-28.8-3.2H320c-9.6 0-19.2 0-28.8 3.2V780.8c0 22.4 0 80 22.4 92.8 28.8 19.2 96-6.4 96 44.8 0 16-9.6 41.6-28.8 41.6-54.4 0-105.6-3.2-160-3.2-48 0-96 3.2-147.2 3.2-19.2 0-28.8-22.4-28.8-38.4 0-51.2 51.2-28.8 80-48 19.2-12.8 19.2-60.8 19.2-83.2V294.4c0-28.8 3.2-115.2-22.4-131.2-25.6-16-86.4 9.6-86.4-41.6 0-16 6.4-41.6 28.8-41.6 51.2 0 105.6 3.2 156.8 3.2 48 0 96-3.2 144-3.2 19.2 0 28.8 22.4 28.8 41.6 0 48-57.6 25.6-83.2 41.6-19.2 12.8-19.2 73.6-19.2 92.8v201.6c6.4 3.2 16 3.2 22.4 3.2h400c6.4 0 12.8 0 22.4-3.2V256c0-22.4 0-80-19.2-92.8-28.8-16-86.4 6.4-86.4-41.6 0-16 9.6-41.6 28.8-41.6 51.2 0 99.2 3.2 150.4 3.2 48 0 99.2-3.2 147.2-3.2 19.2 0 28.8 22.4 28.8 41.6 0 51.2-57.6 25.6-86.4 41.6-19.2 12.8-19.2 70.4-19.2 92.8v537.6c0 19.2 0 67.2 19.2 80 28.8 19.2 89.6-6.4 89.6 44.8 0 19.2-6.4 41.6-28.8 41.6z"></path></svg>', this.tag = "select", this.width = 60;
  }
  return e10.prototype.getOptions = function(e11) {
    var t2 = [{ value: "header1", text: "H1", styleForRenderMenuList: { "font-size": "32px", "font-weight": "bold" } }, { value: "header2", text: "H2", styleForRenderMenuList: { "font-size": "24px", "font-weight": "bold" } }, { value: "header3", text: "H3", styleForRenderMenuList: { "font-size": "18px", "font-weight": "bold" } }, { value: "header4", text: "H4", styleForRenderMenuList: { "font-size": "16px", "font-weight": "bold" } }, { value: "header5", text: "H5", styleForRenderMenuList: { "font-size": "13px", "font-weight": "bold" } }, { value: "header6", text: "H6", styleForRenderMenuList: { "font-size": "11px", "font-weight": "bold" } }, { value: "paragraph", text: iC("header.text") }], n2 = this.getValue(e11).toString();
    return t2.forEach(function(e12) {
      e12.value === n2 ? e12.selected = true : e12.selected = void 0;
    }), t2;
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getValue = function(e11) {
    return bO(e11);
  }, e10.prototype.isDisabled = function(e11) {
    return EO(e11);
  }, e10.prototype.exec = function(e11, t2) {
    CO(e11, t2.toString());
  }, e10;
}(), TO = { key: "headerSelect", factory: function() {
  return new BO();
} }, kO = { key: "header1", factory: function() {
  return new DO();
} }, FO = { key: "header2", factory: function() {
  return new SO();
} }, IO = { key: "header3", factory: function() {
  return new AO();
} }, PO = { key: "header4", factory: function() {
  return new xO();
} }, _O = { key: "header5", factory: function() {
  return new OO();
} }, RO = { key: "header6", factory: function() {
  return new NO();
} };
function LO(e10) {
  return function(t2, n2, r3) {
    var o2 = fm(t2);
    return 0 === (n2 = n2.filter(function(e11) {
      return !!Og.isText(e11) || !!r3.isInline(e11);
    })).length && (n2 = [{ text: o2.text().replace(/\s+/gm, " ") }]), { type: "header".concat(e10), children: n2 };
  };
}
var MO = { selector: "h1:not([data-w-e-type])", parseElemHtml: LO(1) }, jO = { selector: "h2:not([data-w-e-type])", parseElemHtml: LO(2) }, HO = { selector: "h3:not([data-w-e-type])", parseElemHtml: LO(3) }, zO = { selector: "h4:not([data-w-e-type])", parseElemHtml: LO(4) }, $O = { selector: "h5:not([data-w-e-type])", parseElemHtml: LO(5) }, UO = { selector: "h6:not([data-w-e-type])", parseElemHtml: LO(6) };
function VO(e10) {
  return function(t2, n2, r3) {
    return Pw("h".concat(e10), null, n2);
  };
}
var WO = { renderElems: [{ type: "header1", renderElem: VO(1) }, { type: "header2", renderElem: VO(2) }, { type: "header3", renderElem: VO(3) }, { type: "header4", renderElem: VO(4) }, { type: "header5", renderElem: VO(5) }, { type: "header6", renderElem: VO(6) }], elemsToHtml: [pO, hO, gO, vO, mO, yO], parseElemsHtml: [MO, jO, HO, zO, $O, UO], menus: [TO, kO, FO, IO, PO, _O, RO], editorPlugin: function(e10) {
  var t2 = e10.insertBreak, n2 = e10;
  return n2.insertBreak = function() {
    var r3 = iv(eg.nodes(n2, { match: function(e11) {
      return zy.getNodeType(e11).startsWith("header");
    }, universal: true }), 1), o2 = r3[0];
    if (o2) if (zy.isSelectionAtLineEnd(e10, o2[1])) {
      Wg.insertNodes(n2, { type: "paragraph", children: [{ text: "" }] }, { mode: "highest" });
    } else t2();
    else t2();
  }, n2;
} };
var GO = { type: "image", elemToHtml: function(e10, t2) {
  var n2 = e10, r3 = n2.src, o2 = n2.alt, i2 = void 0 === o2 ? "" : o2, a2 = n2.href, s2 = void 0 === a2 ? "" : a2, u2 = n2.width, l2 = void 0 === u2 ? "" : u2, c3 = n2.height, d2 = void 0 === c3 ? "" : c3, f2 = n2.style, p2 = void 0 === f2 ? {} : f2, h2 = p2.width, g2 = void 0 === h2 ? "" : h2, v2 = p2.height, m2 = void 0 === v2 ? "" : v2, y2 = "";
  return g2 && (y2 += "width: ".concat(g2, ";")), m2 && (y2 += "height: ".concat(m2, ";")), '<img src="'.concat(r3, '" alt="').concat(i2, '" data-href="').concat(s2, '" width="').concat(l2, '" height="').concat(d2, '" style="').concat(y2, '"/>');
} };
var qO = function() {
  function e10() {
    this.title = iC("image.delete"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M826.8032 356.5312c-19.328 0-36.3776 15.6928-36.3776 35.0464v524.2624c0 19.328-16 34.56-35.328 34.56H264.9344c-19.328 0-35.5072-15.3088-35.5072-34.56V390.0416c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.6928-33.5104 35.0464V915.712c0 57.9328 44.6208 108.288 102.528 108.288H755.2c57.9328 0 108.0832-50.4576 108.0832-108.288V391.4752c-0.1024-19.2512-17.1264-34.944-36.48-34.944z" p-id="9577"></path><path d="M437.1712 775.7568V390.6048c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.616-33.5104 35.0464v385.152c0 19.328 14.1568 35.0464 33.5104 35.0464s33.5104-15.7184 33.5104-35.0464zM649.7024 775.7568V390.6048c0-19.328-17.0496-35.0464-36.3776-35.0464s-36.3776 15.616-36.3776 35.0464v385.152c0 19.328 17.0496 35.0464 36.3776 35.0464s36.3776-15.7184 36.3776-35.0464zM965.0432 217.0368h-174.6176V145.5104c0-57.9328-47.2064-101.76-104.6528-101.76h-350.976c-57.8304 0-105.3952 43.8528-105.3952 101.76v71.5264H54.784c-19.4304 0-35.0464 14.1568-35.0464 33.5104 0 19.328 15.616 33.5104 35.0464 33.5104h910.3616c19.328 0 35.0464-14.1568 35.0464-33.5104 0-19.3536-15.6928-33.5104-35.1488-33.5104z m-247.3728 0H297.3952V145.5104c0-19.328 18.2016-34.7648 37.4272-34.7648h350.976c19.1488 0 31.872 15.1296 31.872 34.7648v71.5264z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == zy.getSelectedNodeByType(e11, "image");
  }, e10.prototype.exec = function(e11, t2) {
    this.isDisabled(e11) || Wg.removeNodes(e11, { match: function(e12) {
      return zy.checkNodeType(e12, "image");
    } });
  }, e10;
}();
function KO(e10) {
  return void 0 === e10 && (e10 = "r"), "".concat(e10, "-").concat(qm());
}
function YO(e10) {
  return e10.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function XO(e10) {
  var t2 = e10.selection;
  if (null == t2) return true;
  if (!yg.isCollapsed(t2)) return true;
  var n2 = iv(eg.nodes(e10, { match: function(t3) {
    var n3 = zy.getNodeType(t3);
    return "code" === n3 || ("pre" === n3 || ("link" === n3 || ("list-item" === n3 || (!!n3.startsWith("header") || ("blockquote" === n3 || !!eg.isVoid(e10, t3))))));
  }, universal: true }), 1);
  return !!n2[0];
}
function ZO(e10, t2, n2) {
  return nv(this, arguments, void 0, function(e11, t3, n3, r3, o2) {
    var i2, a2;
    return void 0 === r3 && (r3 = ""), void 0 === o2 && (o2 = ""), rv(this, function(s2) {
      switch (s2.label) {
        case 0:
          return (i2 = t3.getMenuConfig(e11).checkImage) ? [4, i2(n3, r3, o2)] : [3, 2];
        case 1:
          if ("string" == typeof (a2 = s2.sent())) return t3.alert(a2, "error"), [2, false];
          if (null == a2) return [2, false];
          s2.label = 2;
        case 2:
          return [2, true];
      }
    });
  });
}
function JO(e10, t2, n2) {
  return nv(this, void 0, void 0, function() {
    var r3;
    return rv(this, function(o2) {
      switch (o2.label) {
        case 0:
          return (r3 = t2.getMenuConfig(e10).parseImageSrc) ? [4, r3(n2)] : [3, 2];
        case 1:
          return [2, o2.sent()];
        case 2:
          return [2, n2];
      }
    });
  });
}
function QO(e10, t2) {
  return nv(this, arguments, void 0, function(e11, t3, n2, r3) {
    var o2, i2, a2;
    return void 0 === n2 && (n2 = ""), void 0 === r3 && (r3 = ""), rv(this, function(s2) {
      switch (s2.label) {
        case 0:
          return [4, ZO("insertImage", e11, t3, n2, r3)];
        case 1:
          return s2.sent() ? [4, JO("insertImage", e11, t3)] : [2];
        case 2:
          return o2 = s2.sent(), i2 = { type: "image", src: YO(o2), href: r3, alt: n2, style: {}, children: [{ text: "" }] }, null === e11.selection && e11.restoreSelection(), zy.getSelectedNodeByType(e11, "image") && e11.move(1), XO(e11) ? [2] : (Wg.insertNodes(e11, i2), (a2 = e11.getMenuConfig("insertImage").onInsertedImage) && a2(i2), [2]);
      }
    });
  });
}
function eN() {
  return KO("w-e-edit-image");
}
var tN = function() {
  function e10() {
    this.title = iC("image.edit"), this.iconSvg = Dx, this.tag = "button", this.showModal = true, this.modalWidth = 300, this.$content = null, this.srcInputId = eN(), this.altInputId = eN(), this.hrefInputId = eN(), this.buttonId = eN();
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.getImageNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "image");
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "image"));
  }, e10.prototype.getModalPositionNode = function(e11) {
    return this.getImageNode(e11);
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = this, r3 = n2.srcInputId, o2 = n2.altInputId, i2 = n2.hrefInputId, a2 = n2.buttonId, s2 = this.getImageNode(e11);
    if (null == s2) throw new Error("Not found selected image node");
    var u2 = iv(vC(iC("image.src"), r3), 2), l2 = u2[0], c3 = fm(u2[1]), d2 = iv(vC(iC("image.desc"), o2), 2), f2 = d2[0], p2 = fm(d2[1]), h2 = iv(vC(iC("image.link"), i2), 2), g2 = h2[0], v2 = fm(h2[1]), m2 = iv(yC(a2, iC("common.ok")), 1)[0];
    if (null == this.$content) {
      var y2 = fm("<div></div>");
      y2.on("click", "#".concat(a2), function(n3) {
        n3.preventDefault();
        var a3 = y2.find("#".concat(r3)).val(), s3 = y2.find("#".concat(o2)).val(), u3 = y2.find("#".concat(i2)).val();
        t2.updateImage(e11, a3, s3, u3), e11.hidePanelOrModal();
      }), this.$content = y2;
    }
    var b2 = this.$content;
    b2.empty(), b2.append(l2), b2.append(f2), b2.append(g2), b2.append(m2);
    var E2 = s2, C2 = E2.src, w2 = E2.alt, D2 = void 0 === w2 ? "" : w2, S2 = E2.href, A2 = void 0 === S2 ? "" : S2;
    return c3.val(C2), p2.val(D2), v2.val(A2), setTimeout(function() {
      c3.focus();
    }), b2[0];
  }, e10.prototype.updateImage = function(e11, t2, n2, r3, o2) {
    void 0 === n2 && (n2 = ""), void 0 === r3 && (r3 = ""), void 0 === o2 && (o2 = {}), t2 && (e11.restoreSelection(), this.isDisabled(e11) || function(e12, t3) {
      nv(this, arguments, void 0, function(e13, t4, n3, r4, o3) {
        var i2, a2, s2, u2, l2, c3;
        return void 0 === n3 && (n3 = ""), void 0 === r4 && (r4 = ""), void 0 === o3 && (o3 = {}), rv(this, function(d2) {
          switch (d2.label) {
            case 0:
              return [4, ZO("editImage", e13, t4, n3, r4)];
            case 1:
              return d2.sent() ? [4, JO("editImage", e13, t4)] : [2];
            case 2:
              return i2 = d2.sent(), null == (a2 = zy.getSelectedNodeByType(e13, "image")) || (s2 = a2.style, u2 = { src: i2, alt: n3, href: r4, style: tv(tv({}, void 0 === s2 ? {} : s2), o3) }, Wg.setNodes(e13, u2, { match: function(e14) {
                return zy.checkNodeType(e14, "image");
              } }), l2 = zy.getSelectedNodeByType(e13, "image"), (c3 = e13.getMenuConfig("editImage").onUpdatedImage) && c3(l2)), [2];
          }
        });
      });
    }(e11, t2, n2, r3, o2));
  }, e10;
}();
function nN() {
  return KO("w-e-insert-image");
}
var rN = function() {
  function e10() {
    this.title = iC("image.editSize"), this.tag = "button", this.showModal = true, this.modalWidth = 320, this.$content = null, this.widthInputId = nN(), this.heightInputId = nN(), this.buttonId = nN();
  }
  return e10.prototype.getSelectedImageNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "image");
  }, e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedImageNode(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return this.getSelectedImageNode(e11);
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = t2.widthInputId, r3 = t2.heightInputId, o2 = t2.buttonId, i2 = iv(vC(iC("image.width"), n2, "auto"), 2), a2 = i2[0], s2 = fm(i2[1]), u2 = iv(vC(iC("image.height"), r3, "auto"), 2), l2 = u2[0], c3 = fm(u2[1]), d2 = iv(yC(o2, iC("image.ok")), 1)[0], f2 = this.getSelectedImageNode(e11);
    if (null == this.$content) {
      var p2 = fm("<div></div>");
      p2.on("click", "#".concat(o2), function(t3) {
        t3.preventDefault();
        var o3 = p2.find("#".concat(n2)).val().trim(), i3 = p2.find("#".concat(r3)).val().trim(), a3 = function(e12) {
          return /^\d+(\.\d+)?%$/.test(e12);
        }, s3 = function(e12) {
          return /^\d+(\.\d+)?$/.test(e12);
        }, u3 = function(e12) {
          return /^\d+(\.\d+)?px$/.test(e12);
        }, l3 = "auto", c4 = "auto";
        a3(o3) ? l3 = o3 : s3(o3) ? l3 = "".concat(parseInt(o3, 10), "px") : u3(o3) && (l3 = o3), a3(i3) ? c4 = i3 : s3(i3) ? c4 = "".concat(parseInt(i3, 10), "px") : u3(i3) && (c4 = i3);
        var d3 = f2.style, h3 = void 0 === d3 ? {} : d3;
        e11.restoreSelection();
        var g3 = tv(tv({}, h3), { style: { width: l3, height: c4 } });
        Wg.setNodes(e11, g3, { match: function(e12) {
          return zy.checkNodeType(e12, "image");
        } }), e11.hidePanelOrModal();
      }), this.$content = p2;
    }
    var h2 = this.$content;
    if (h2.empty(), h2.append(a2), h2.append(l2), h2.append(d2), null == f2) return h2[0];
    var g2 = f2.style, v2 = void 0 === g2 ? {} : g2, m2 = v2.width, y2 = void 0 === m2 ? "auto" : m2, b2 = v2.height, E2 = void 0 === b2 ? "auto" : b2;
    return s2.val(y2), c3.val(E2), setTimeout(function() {
      s2.focus();
    }), h2[0];
  }, e10;
}();
function oN() {
  return KO("w-e-insert-image");
}
var iN = function() {
  function e10() {
    this.title = iC("image.netImage"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>', this.tag = "button", this.showModal = true, this.modalWidth = 300, this.$content = null, this.srcInputId = oN(), this.altInputId = oN(), this.hrefInputId = oN(), this.buttonId = oN();
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return XO(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return null;
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = this, r3 = n2.srcInputId, o2 = n2.altInputId, i2 = n2.hrefInputId, a2 = n2.buttonId, s2 = iv(vC(iC("image.src"), r3), 2), u2 = s2[0], l2 = fm(s2[1]), c3 = iv(vC(iC("image.desc"), o2), 2), d2 = c3[0], f2 = fm(c3[1]), p2 = iv(vC(iC("image.link"), i2), 2), h2 = p2[0], g2 = fm(p2[1]), v2 = iv(yC(a2, iC("common.ok")), 1)[0];
    if (null == this.$content) {
      var m2 = fm("<div></div>");
      m2.on("click", "#".concat(a2), function(n3) {
        n3.preventDefault();
        var a3 = m2.find("#".concat(r3)).val().trim(), s3 = m2.find("#".concat(o2)).val().trim(), u3 = m2.find("#".concat(i2)).val().trim();
        t2.insertImage(e11, a3, s3, u3), e11.hidePanelOrModal();
      }), this.$content = m2;
    }
    var y2 = this.$content;
    return y2.empty(), y2.append(u2), y2.append(d2), y2.append(h2), y2.append(v2), l2.val(""), f2.val(""), g2.val(""), setTimeout(function() {
      l2.focus();
    }), y2[0];
  }, e10.prototype.insertImage = function(e11, t2, n2, r3) {
    void 0 === n2 && (n2 = ""), void 0 === r3 && (r3 = ""), t2 && (e11.restoreSelection(), this.isDisabled(e11) || QO(e11, t2, n2, r3));
  }, e10;
}(), aN = function() {
  function e10() {
    this.title = iC("image.viewLink"), this.iconSvg = Sx, this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "image");
    return t2 && t2.href || "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !this.getValue(e11);
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      if (!t2 || "string" != typeof t2) throw new Error("View image link failed, image.href is '".concat(t2, "'"));
      window.open(t2, "_blank");
    }
  }, e10;
}(), sN = function() {
  function e10() {
    this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getSelectedNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "image");
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedNode(e11);
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = this.getSelectedNode(e11);
      if (null != n2) {
        var r3 = zy.getHoverbar(e11);
        r3 && r3.hideAndClean();
        var o2 = n2.style, i2 = { style: tv(tv({}, void 0 === o2 ? {} : o2), { width: this.value, height: "" }) };
        Wg.setNodes(e11, i2, { match: function(e12) {
          return zy.checkNodeType(e12, "image");
        } });
      }
    }
  }, e10;
}(), uN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "30%", t3.value = "30%", t3;
  }
  return ev(t2, e10), t2;
}(sN), lN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "50%", t3.value = "50%", t3;
  }
  return ev(t2, e10), t2;
}(sN), cN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = "100%", t3.value = "100%", t3;
  }
  return ev(t2, e10), t2;
}(sN), dN = { onInsertedImage: function(e10) {
}, onUpdatedImage: function(e10) {
}, checkImage: function(e10, t2, n2) {
  return true;
}, parseImageSrc: function(e10) {
  return e10;
} };
function fN(e10, t2) {
  var n2 = zy.findKey(e10, t2).id;
  return "w-e-image-container-".concat(n2);
}
function pN(e10, t2, n2, r3) {
  var o2 = fm("body"), i2 = fN(e10, t2), a2 = r3.width, s2 = r3.height, u2 = 0, l2 = 0, c3 = 0, d2 = 0, f2 = false, p2 = null;
  var h2 = kC(function(e11) {
    e11.preventDefault();
    var t3 = e11.clientX, n3 = l2 + (f2 ? u2 - t3 : t3 - u2), r4 = c3 * (n3 / l2);
    n3 > d2 - 6 || null != p2 && (n3 <= 15 || r4 <= 15 || (p2.css("width", "".concat(n3, "px")), p2.css("height", "".concat(r4, "px"))));
  }, 100);
  function g2(n3) {
    if (o2.off("mousemove", h2), null != p2) {
      var r4 = p2.width().toFixed(2), i3 = p2.height().toFixed(2), a3 = { style: tv(tv({}, t2.style), { width: "".concat(r4, "px"), height: "".concat(i3, "px") }) };
      Wg.setNodes(e10, a3, { at: zy.findPath(e10, t2) }), o2.off("mouseup", g2);
    }
  }
  function v2(t3, n3) {
    p2 = function() {
      var e11 = fm("#".concat(i2));
      if (0 === e11.length) throw new Error("Cannot find image container elem");
      return e11;
    }(), u2 = t3, d2 = n3;
    var r4 = p2.find("img");
    if (0 === r4.length) throw new Error("Cannot find image elem");
    l2 = r4.width(), c3 = r4.height(), o2.on("mousemove", h2), o2.on("mouseup", g2);
    var a3 = zy.getHoverbar(e10);
    a3 && a3.hideAndClean();
  }
  var m2 = {};
  return a2 && (m2.width = a2), s2 && (m2.height = s2), m2.boxShadow = "0 0 0 1px #B4D5FF", Pw("div", { id: i2, style: m2, className: "w-e-image-container w-e-selected-image-container", on: { mousedown: function(n3) {
    var r4 = fm(n3.target);
    if (r4.hasClass("w-e-image-dragger")) {
      n3.preventDefault(), (r4.hasClass("left-top") || r4.hasClass("left-bottom")) && (f2 = true);
      var o3 = zy.getParentNode(e10, t2);
      if (null != o3) {
        var i3 = zy.toDOMNode(e10, o3), a3 = i3.getBoundingClientRect ? i3.getBoundingClientRect() : { width: 0 }, s3 = window.getComputedStyle(i3), u3 = parseFloat(s3.paddingLeft), l3 = parseFloat(s3.paddingRight), c4 = parseFloat(s3.borderLeftWidth), d3 = parseFloat(s3.borderRightWidth);
        v2(n3.clientX, a3.width - u3 - l3 - c4 - d3);
      }
    }
  } } }, n2, Pw("div", { className: "w-e-image-dragger left-top" }), Pw("div", { className: "w-e-image-dragger right-top" }), Pw("div", { className: "w-e-image-dragger left-bottom" }), Pw("div", { className: "w-e-image-dragger right-bottom" }));
}
var hN = { type: "image", renderElem: function(e10, t2, n2) {
  var r3 = e10, o2 = r3.src, i2 = r3.alt, a2 = void 0 === i2 ? "" : i2, s2 = r3.href, u2 = void 0 === s2 ? "" : s2, l2 = r3.style, c3 = void 0 === l2 ? {} : l2, d2 = c3.width, f2 = void 0 === d2 ? "" : d2, p2 = c3.height, h2 = void 0 === p2 ? "" : p2, g2 = zy.isNodeSelected(n2, e10), v2 = { maxWidth: "100%" };
  f2 && (v2.width = "100%"), h2 && (v2.height = "100%");
  var m2 = Pw("img", { style: v2, src: o2, alt: a2, "data-href": u2 }), y2 = n2.isDisabled();
  return g2 && !y2 ? pN(n2, e10, m2, { width: f2, height: h2 }) : function(e11, t3, n3, r4) {
    var o3 = r4.width, i3 = r4.height, a3 = {};
    return o3 && (a3.width = o3), i3 && (a3.height = i3), Pw("div", { id: fN(e11, t3), style: a3, className: "w-e-image-container" }, n3);
  }(n2, e10, m2, { width: f2, height: h2 });
} }, gN = { renderElems: [hN], elemsToHtml: [GO], parseElemsHtml: [{ selector: "img:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10), o2 = r3.attr("data-href") || "";
  return o2 = decodeURIComponent(o2), { type: "image", src: r3.attr("src") || "", alt: r3.attr("alt") || "", href: o2, style: { width: kx(r3, "width"), height: kx(r3, "height") }, width: r3.attr("width") || "", height: r3.attr("height") || "", children: [{ text: "" }] };
} }], menus: [{ key: "insertImage", factory: function() {
  return new iN();
}, config: dN }, { key: "deleteImage", factory: function() {
  return new qO();
} }, { key: "editImage", factory: function() {
  return new tN();
}, config: dN }, { key: "viewImageLink", factory: function() {
  return new aN();
} }, { key: "imageWidth30", factory: function() {
  return new uN();
} }, { key: "imageWidth50", factory: function() {
  return new lN();
} }, { key: "imageWidth100", factory: function() {
  return new cN();
} }, { key: "editorImageSizeMenu", factory: function() {
  return new rN();
} }], editorPlugin: function(e10) {
  var t2 = e10.isInline, n2 = e10.isVoid, r3 = e10;
  return r3.isInline = function(e11) {
    return "image" === e11.type || t2(e11);
  }, r3.isVoid = function(e11) {
    return "image" === e11.type || n2(e11);
  }, r3;
} }, vN = function() {
  function e10() {
    this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    var t2 = iv(eg.nodes(e11, { match: function(e12) {
      return !!e12.indent;
    }, universal: true }), 1), n2 = t2[0];
    return null == n2 ? "" : iv(n2, 1)[0].indent || "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getMatchNode = function(e11) {
    var t2 = iv(eg.nodes(e11, { match: function(e12) {
      var t3 = zy.getNodeType(e12);
      return "paragraph" === t3 || !!t3.startsWith("header");
    }, universal: true, mode: "highest" }), 1), n2 = t2[0];
    return null == n2 ? null : n2[0];
  }, e10;
}(), mN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("indent.decrease"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m256-512v384l-256-192z"></path></svg>', t3;
  }
  return ev(t2, e10), t2.prototype.isDisabled = function(e11) {
    var t3 = this.getMatchNode(e11);
    return null == t3 || !t3.indent;
  }, t2.prototype.exec = function(e11, t3) {
    Wg.setNodes(e11, { indent: null }, { match: function(e12) {
      return Kh.isElement(e12);
    } });
  }, t2;
}(vN), yN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("indent.increase"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>', t3.DEFAULT_INDENT_VALUE = "2em", t3;
  }
  return ev(t2, e10), t2.prototype.isDisabled = function(e11) {
    var t3 = this.getMatchNode(e11);
    return null == t3 || !!t3.indent;
  }, t2.prototype.getIndentValue = function(e11) {
    var t3 = this.getMatchNode(e11);
    if (!t3) return this.DEFAULT_INDENT_VALUE;
    var n2 = t3.children.filter(Og.isText)[0];
    if (!n2 || !n2.fontSize) return this.DEFAULT_INDENT_VALUE;
    var r3 = n2.fontSize, o2 = parseInt(n2.fontSize, 10), i2 = r3.replace("".concat(o2), "");
    return "".concat(2 * o2).concat(i2);
  }, t2.prototype.exec = function(e11, t3) {
    var n2 = this.getIndentValue(e11);
    Wg.setNodes(e11, { indent: n2 }, { match: function(e12) {
      return Kh.isElement(e12);
    }, mode: "highest" });
  }, t2;
}(vN);
var bN = { renderStyle: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.indent, r3 = t2;
  return n2 && Kx(r3, { textIndent: n2 }), r3;
}, styleToHtml: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.indent;
  if (!n2) return t2;
  var r3 = fm(t2);
  return r3.css("text-indent", n2), Bx(r3);
}, preParseHtml: [{ selector: "p,h1,h2,h3,h4,h5", preParseHtml: function(e10) {
  var t2 = fm(e10), n2 = kx(t2, "padding-left");
  return /^[1-9]\d*em$/.test(n2) && t2.css("text-indent", "2em"), /^[1-9]\d*px$/.test(n2) && parseInt(n2, 10) % 32 == 0 && t2.css("text-indent", "2em"), t2[0];
} }], parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Kh.isElement(t2)) return t2;
  var o2 = t2, i2 = kx(r3, "text-indent"), a2 = parseInt(i2, 10);
  return i2 && a2 > 0 && (o2.indent = i2), o2;
}, menus: [{ key: "indent", factory: function() {
  return new yN();
} }, { key: "delIndent", factory: function() {
  return new mN();
} }] }, EN = function() {
  function e10() {
    this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !!zy.getSelectedElems(e11).some(function(t2) {
      var n2 = t2.type;
      return !(!eg.isVoid(e11, t2) || !eg.isBlock(e11, t2) || "video" === n2) || !!["pre", "code"].includes(n2);
    });
  }, e10;
}(), CN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("justify.center"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M870.4 793.6v102.4H153.6v-102.4h716.8z m102.4-230.4v102.4H51.2v-102.4h921.6z m-102.4-230.4v102.4H153.6v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>', t3;
  }
  return ev(t2, e10), t2.prototype.exec = function(e11, t3) {
    Wg.setNodes(e11, { textAlign: "center" }, { match: function(t4) {
      return Kh.isElement(t4) && !e11.isInline(t4);
    } });
  }, t2;
}(EN), wN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("justify.justify"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z"></path></svg>', t3;
  }
  return ev(t2, e10), t2.prototype.exec = function(e11, t3) {
    Wg.setNodes(e11, { textAlign: "justify" }, { match: function(t4) {
      return Kh.isElement(t4) && !e11.isInline(t4);
    } });
  }, t2;
}(EN), DN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("justify.left"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>', t3;
  }
  return ev(t2, e10), t2.prototype.exec = function(e11, t3) {
    Wg.setNodes(e11, { textAlign: "left" }, { match: function(t4) {
      return Kh.isElement(t4) && !e11.isInline(t4);
    } });
  }, t2;
}(EN), SN = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("justify.right"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M972.8 793.6v102.4H256v-102.4h716.8z m0-230.4v102.4H51.2v-102.4h921.6z m0-230.4v102.4H256v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>', t3;
  }
  return ev(t2, e10), t2.prototype.exec = function(e11, t3) {
    Wg.setNodes(e11, { textAlign: "right" }, { match: function(t4) {
      return Kh.isElement(t4) && !e11.isInline(t4);
    } });
  }, t2;
}(EN);
var AN = { renderStyle: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.textAlign, r3 = t2;
  return n2 && Kx(r3, { textAlign: n2 }), r3;
}, styleToHtml: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.textAlign;
  if (!n2) return t2;
  var r3 = fm(t2);
  return r3.css("text-align", n2), Bx(r3);
}, parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Kh.isElement(t2)) return t2;
  var o2 = t2, i2 = kx(r3, "text-align");
  return i2 && (o2.textAlign = i2), o2;
}, menus: [{ key: "justifyLeft", factory: function() {
  return new DN();
} }, { key: "justifyRight", factory: function() {
  return new SN();
} }, { key: "justifyCenter", factory: function() {
  return new CN();
} }, { key: "justifyJustify", factory: function() {
  return new wN();
} }] };
var xN = function() {
  function e10() {
    this.title = iC("lineHeight.title"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M964 788a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526zM198.93 144.306c6.668-5.798 16.774-5.094 22.573 1.574l122.26 140.582a16 16 0 0 1 3.927 10.5c0 8.836-7.164 16-16 16h-61.8a8 8 0 0 0-8 8v390.077h69.819a16 16 0 0 1 10.502 3.928c6.666 5.8 7.37 15.906 1.57 22.573L221.476 878.123a16 16 0 0 1-1.57 1.57c-6.668 5.8-16.774 5.097-22.574-1.57L75.051 737.538a16 16 0 0 1-3.928-10.5c0-8.837 7.163-16 16-16h69.822V312.96H87.127a16 16 0 0 1-10.502-3.928c-6.666-5.8-7.37-15.906-1.57-22.573l122.303-140.582a16 16 0 0 1 1.572-1.572zM964 465a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z m0-323a8 8 0 0 1 8 8v98a8 8 0 0 1-8 8H438a8 8 0 0 1-8-8v-98a8 8 0 0 1 8-8h526z"></path></svg>', this.tag = "select", this.width = 80;
  }
  return e10.prototype.getOptions = function(e11) {
    var t2 = [], n2 = e11.getMenuConfig("lineHeight").lineHeightList, r3 = void 0 === n2 ? [] : n2;
    t2.push({ text: iC("lineHeight.default"), value: "" }), r3.forEach(function(e12) {
      t2.push({ text: e12, value: e12 });
    });
    var o2 = this.getValue(e11);
    return t2.forEach(function(e12) {
      e12.value === o2 ? e12.selected = true : e12.selected = void 0;
    }), t2;
  }, e10.prototype.getMatchNode = function(e11) {
    var t2 = iv(eg.nodes(e11, { match: function(e12) {
      var t3 = zy.getNodeType(e12);
      return !!t3.startsWith("header") || !!["paragraph", "blockquote", "list-item"].includes(t3);
    }, universal: true, mode: "highest" }), 1), n2 = t2[0];
    return null == n2 ? null : n2[0];
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.getMatchNode(e11);
    return null == t2 ? "" : Kh.isElement(t2) && t2.lineHeight || "";
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getMatchNode(e11);
  }, e10.prototype.exec = function(e11, t2) {
    Wg.setNodes(e11, { lineHeight: t2.toString() }, { mode: "highest" });
  }, e10;
}();
var ON = { renderStyle: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.lineHeight, r3 = t2;
  return n2 && Kx(r3, { lineHeight: n2 }), r3;
}, styleToHtml: function(e10, t2) {
  if (!Kh.isElement(e10)) return t2;
  var n2 = e10.lineHeight;
  if (!n2) return t2;
  var r3 = fm(t2);
  return r3.css("line-height", n2), Bx(r3);
}, parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Kh.isElement(t2)) return t2;
  var o2 = t2, i2 = n2.getMenuConfig("lineHeight").lineHeightList, a2 = void 0 === i2 ? [] : i2, s2 = kx(r3, "line-height");
  return s2 && a2.includes(s2) && (o2.lineHeight = s2), o2;
}, menus: [{ key: "lineHeight", factory: function() {
  return new xN();
}, config: { lineHeightList: ["1", "1.15", "1.5", "2", "2.5", "3"] } }] };
var NN = { type: "link", elemToHtml: function(e10, t2) {
  var n2 = e10, r3 = n2.url, o2 = n2.target, i2 = void 0 === o2 ? "_blank" : o2;
  return '<a href="'.concat(r3, '" target="').concat(i2, '">').concat(t2, "</a>");
} };
function BN(e10, t2, n2, r3) {
  return nv(this, void 0, void 0, function() {
    var o2, i2;
    return rv(this, function(a2) {
      switch (a2.label) {
        case 0:
          return (o2 = t2.getMenuConfig(e10).checkLink) ? [4, o2(n2, r3)] : [3, 2];
        case 1:
          if ("string" == typeof (i2 = a2.sent())) return t2.alert(i2, "error"), [2, false];
          if (null == i2) return [2, false];
          a2.label = 2;
        case 2:
          return [2, true];
      }
    });
  });
}
function TN(e10, t2, n2) {
  return nv(this, void 0, void 0, function() {
    var r3;
    return rv(this, function(o2) {
      switch (o2.label) {
        case 0:
          return (r3 = t2.getMenuConfig(e10).parseLinkUrl) ? [4, r3(n2)] : [3, 2];
        case 1:
          return [2, o2.sent()];
        case 2:
          return [2, n2];
      }
    });
  });
}
function kN(e10) {
  return null == e10.selection || !!zy.getSelectedElems(e10).some(function(t2) {
    var n2 = t2.type;
    return !!e10.isVoid(t2) || !!["pre", "code", "link"].includes(n2);
  });
}
function FN(e10, t2) {
  return { type: "link", url: YO(e10), children: t2 ? [{ text: t2 }] : [] };
}
function IN(e10, t2, n2) {
  return nv(this, void 0, void 0, function() {
    var r3, o2, i2, a2, s2;
    return rv(this, function(u2) {
      switch (u2.label) {
        case 0:
          return n2 ? (t2 || (t2 = n2), e10.restoreSelection(), kN(e10) ? [2] : [4, BN("insertLink", e10, t2, n2)]) : [2];
        case 1:
          return u2.sent() ? [4, TN("insertLink", e10, n2)] : [2];
        case 2:
          if (r3 = u2.sent(), null == (o2 = e10.selection)) return [2];
          if (yg.isCollapsed(o2)) {
            if ((a2 = zy.getLeftLengthOfMaxLength(e10)) <= 0) return [2];
            e10.insertText(" "), a2 < t2.length + 1 && (t2 = t2.slice(0, a2 - 1)), s2 = FN(r3, t2), Wg.insertNodes(e10, s2), e10.insertFragment([{ text: " " }]);
          } else if ((i2 = eg.string(e10, o2)) !== t2) {
            if ((a2 = zy.getLeftLengthOfMaxLength(e10)) <= 0) return [2];
            a2 < i2.length - t2.length && (t2 = t2.slice(0, a2)), e10.deleteFragment(), s2 = FN(r3, t2), Wg.insertNodes(e10, s2);
          } else s2 = FN(r3), Wg.wrapNodes(e10, s2, { split: true }), Wg.collapse(e10, { edge: "end" });
          return [2];
      }
    });
  });
}
function PN() {
  return KO("w-e-update-link");
}
var _N = function() {
  function e10() {
    this.title = iC("link.edit"), this.iconSvg = Dx, this.tag = "button", this.showModal = true, this.modalWidth = 300, this.$content = null, this.urlInputId = PN(), this.buttonId = PN();
  }
  return e10.prototype.getSelectedLinkElem = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "link");
    return null == t2 ? null : t2;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.getSelectedLinkElem(e11);
    return t2 && t2.url || "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedLinkElem(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "link");
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this.urlInputId, n2 = this.buttonId, r3 = iv(vC(iC("link.url"), t2), 2), o2 = r3[0], i2 = fm(r3[1]), a2 = iv(yC(n2, iC("common.ok")), 1)[0];
    if (null == this.$content) {
      var s2 = fm("<div></div>");
      s2.on("click", "#".concat(n2), function(n3) {
        n3.preventDefault(), e11.restoreSelection();
        var r4 = zy.getSelectedNodeByType(e11, "link"), o3 = r4 ? ag.string(r4) : "", i3 = s2.find("#".concat(t2)).val();
        !function(e12, t3, n4) {
          nv(this, void 0, void 0, function() {
            var r5, o4;
            return rv(this, function(i4) {
              switch (i4.label) {
                case 0:
                  return n4 ? [4, BN("editLink", e12, t3, n4)] : [2];
                case 1:
                  return i4.sent() ? [4, TN("editLink", e12, n4)] : [2];
                case 2:
                  return r5 = i4.sent(), o4 = { url: YO(r5) }, Wg.setNodes(e12, o4, { match: function(e13) {
                    return zy.checkNodeType(e13, "link");
                  } }), [2];
              }
            });
          });
        }(e11, o3, i3), e11.hidePanelOrModal();
      }), this.$content = s2;
    }
    var u2 = this.$content;
    u2.empty(), u2.append(o2), u2.append(a2);
    var l2 = this.getValue(e11);
    return i2.val(l2), setTimeout(function() {
      i2.focus();
    }), u2[0];
  }, e10;
}();
function RN() {
  return KO("w-e-insert-link");
}
var LN = function() {
  function e10() {
    this.title = iC("link.insert"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M440.224 635.776a51.84 51.84 0 0 1-36.768-15.232c-95.136-95.136-95.136-249.92 0-345.056l192-192C641.536 37.408 702.816 12.032 768 12.032s126.432 25.376 172.544 71.456c95.136 95.136 95.136 249.92 0 345.056l-87.776 87.776a51.968 51.968 0 1 1-73.536-73.536l87.776-87.776a140.16 140.16 0 0 0 0-197.984c-26.432-26.432-61.6-40.992-99.008-40.992s-72.544 14.56-99.008 40.992l-192 192a140.16 140.16 0 0 0 0 197.984 51.968 51.968 0 0 1-36.768 88.768z"></path><path d="M256 1012a242.4 242.4 0 0 1-172.544-71.456c-95.136-95.136-95.136-249.92 0-345.056l87.776-87.776a51.968 51.968 0 1 1 73.536 73.536l-87.776 87.776a140.16 140.16 0 0 0 0 197.984c26.432 26.432 61.6 40.992 99.008 40.992s72.544-14.56 99.008-40.992l192-192a140.16 140.16 0 0 0 0-197.984 51.968 51.968 0 1 1 73.536-73.536c95.136 95.136 95.136 249.92 0 345.056l-192 192A242.4 242.4 0 0 1 256 1012z"></path></svg>', this.tag = "button", this.showModal = true, this.modalWidth = 300, this.$content = null, this.textInputId = RN(), this.urlInputId = RN(), this.buttonId = RN();
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return kN(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return null;
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = e11.selection, n2 = this, r3 = n2.textInputId, o2 = n2.urlInputId, i2 = n2.buttonId, a2 = iv(vC(iC("link.text"), r3), 2), s2 = a2[0], u2 = fm(a2[1]), l2 = iv(vC(iC("link.url"), o2), 2), c3 = l2[0], d2 = fm(l2[1]), f2 = iv(yC(i2, iC("common.ok")), 1)[0];
    if (null == this.$content) {
      var p2 = fm("<div></div>");
      p2.on("click", "#".concat(i2), function(t3) {
        t3.preventDefault();
        var n3 = p2.find("#".concat(r3)).val(), i3 = p2.find("#".concat(o2)).val();
        IN(e11, n3, i3), e11.hidePanelOrModal();
      }), this.$content = p2;
    }
    var h2 = this.$content;
    if (h2.empty(), h2.append(s2), h2.append(c3), h2.append(f2), null == t2 || yg.isCollapsed(t2)) u2.val("");
    else {
      var g2 = eg.string(e11, t2);
      u2.val(g2);
    }
    return d2.val(""), setTimeout(function() {
      u2.focus();
    }), h2[0];
  }, e10;
}(), MN = function() {
  function e10() {
    this.title = iC("link.unLink"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M608.16328 811.815036c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.347563 89.347564c-118.525421 118.523421-311.38448 118.531421-429.919901 0-118.527421-118.529421-118.527421-311.39048 0-429.917901l89.349564-89.349563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.195613 79.195613c9.371954 9.371954 9.371954 24.56788 0 33.941834l-89.349563 89.347564c-56.143726 56.145726-56.143726 147.49928 0 203.645005 56.143726 56.143726 147.49928 56.145726 203.647005 0l89.347564-89.347563c9.371954-9.371954 24.56788-9.371954 33.941834 0l79.193613 79.195613z m-113.135447-520.429459c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.347564-89.347564c56.143726-56.149726 147.49928-56.145726 203.647006 0 56.143726 56.145726 56.143726 147.49928 0 203.645006l-89.349564 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.195613 79.195613c9.371954 9.371954 24.56788 9.371954 33.941834 0l89.349564-89.349563c118.529421-118.529421 118.529421-311.38848 0-429.917901-118.531421-118.527421-311.38848-118.527421-429.919901 0l-89.347563 89.347564c-9.371954 9.371954-9.371954 24.56788 0 33.941834l79.193613 79.195613z m469.653707 718.556492l45.253779-45.253779c18.745908-18.745908 18.745908-49.13776 0-67.881669L127.195629 14.062931c-18.745908-18.745908-49.13776-18.745908-67.881669 0L14.058181 59.31871c-18.745908 18.745908-18.745908 49.13776 0 67.881669l882.74169 882.74169c18.745908 18.743908 49.13776 18.743908 67.881669 0z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == zy.getSelectedNodeByType(e11, "link");
  }, e10.prototype.exec = function(e11, t2) {
    this.isDisabled(e11) || Wg.unwrapNodes(e11, { match: function(e12) {
      return zy.checkNodeType(e12, "link");
    } });
  }, e10;
}(), jN = function() {
  function e10() {
    this.title = iC("link.view"), this.iconSvg = Sx, this.tag = "button";
  }
  return e10.prototype.getSelectedLinkElem = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "link");
    return null == t2 ? null : t2;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.getSelectedLinkElem(e11);
    return t2 && t2.url || "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedLinkElem(e11);
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      if (!t2 || "string" != typeof t2) throw new Error("View link failed, link url is '".concat(t2, "'"));
      window.open(t2, "_blank");
    }
  }, e10;
}(), HN = { checkLink: function(e10, t2) {
  return true;
}, parseLinkUrl: function(e10) {
  return e10;
} }, zN = { key: "insertLink", factory: function() {
  return new LN();
}, config: HN }, $N = { key: "editLink", factory: function() {
  return new _N();
}, config: HN }, UN = { key: "unLink", factory: function() {
  return new MN();
} }, VN = { key: "viewLink", factory: function() {
  return new jN();
} };
var WN, GN, qN = { selector: "a:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  return 0 === (t2 = t2.filter(function(e11) {
    return !!Og.isText(e11) || !!n2.isInline(e11);
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]), { type: "link", url: r3.attr("href") || "", target: r3.attr("target") || "", children: t2 };
} };
var KN = b(function() {
  if (GN) return WN;
  GN = 1, WN = function(r3) {
    if ("string" != typeof r3) return false;
    var o2 = r3.match(e10);
    if (!o2) return false;
    var i2 = o2[1];
    if (!i2) return false;
    if (t2.test(i2) || n2.test(i2)) return true;
    return false;
  };
  var e10 = /^(?:\w+:)?\/\/(\S+)$/, t2 = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/, n2 = /^[^\s\.]+\.\S{2,}$/;
  return WN;
}());
var YN = { type: "link", renderElem: function(e10, t2, n2) {
  var r3 = e10, o2 = r3.url, i2 = r3.target;
  return Pw("a", { href: o2, target: void 0 === i2 ? "_blank" : i2 }, t2);
} }, XN = { renderElems: [YN], elemsToHtml: [NN], parseElemsHtml: [qN], menus: [zN, $N, UN, VN], editorPlugin: function(e10) {
  var t2 = e10.isInline, n2 = e10.insertData, r3 = e10.normalizeNode, o2 = e10;
  return o2.isInline = function(e11) {
    return "link" === e11.type || t2(e11);
  }, o2.insertData = function(e11) {
    var t3 = e11.getData("text/plain");
    if (KN(t3)) {
      if (/<img[^>]+>/.test(e11.getData("text/html"))) n2(e11);
      else if (!kN(o2)) {
        var r4 = o2.selection;
        if (null != r4) {
          var i2 = eg.string(o2, r4);
          IN(o2, i2, t3);
        }
      }
    } else n2(e11);
  }, o2.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), n3 = t3[0], i2 = t3[1];
    return "link" !== zy.getNodeType(n3) ? r3([n3, i2]) : "" === ag.string(n3) ? Wg.removeNodes(o2, { at: i2 }) : r3([n3, i2]);
  }, o2;
} };
var ZN = { selector: "p:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  return 0 === (t2 = t2.filter(function(e11) {
    return !!Og.isText(e11) || !!n2.isInline(e11);
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]), { type: "paragraph", children: t2 };
} };
function JN(e10) {
  var t2 = iv(eg.nodes(e10, { match: function(t3) {
    return e10.children[0] === t3;
  }, mode: "highest" }), 1), n2 = t2[0];
  if (null == n2) return false;
  var r3 = n2[0];
  if (!Kh.isElement(r3)) return false;
  if ("paragraph" === r3.type) return false;
  if ("" !== ag.string(r3)) return false;
  var o2 = r3.children, i2 = void 0 === o2 ? [] : o2;
  return !!Og.isText(i2[0]) && (Wg.setNodes(e10, { type: "paragraph" }), true);
}
var QN = { type: "paragraph", renderElem: function(e10, t2, n2) {
  return Pw("p", null, t2);
} }, eB = { renderElems: [QN], elemsToHtml: [{ type: "paragraph", elemToHtml: function(e10, t2) {
  return "" === t2 ? "<p><br></p>" : "<p>".concat(t2, "</p>");
} }], parseElemsHtml: [ZN], editorPlugin: function(e10) {
  var t2 = e10.deleteBackward, n2 = e10.deleteForward, r3 = e10;
  return r3.deleteBackward = function(e11) {
    JN(r3) || t2(e11);
  }, r3.deleteForward = function(e11) {
    JN(r3) || n2(e11);
  }, r3;
} };
function tB(e10, t2) {
  if (null == e10.selection) return true;
  var n2 = iv(eg.nodes(e10, { match: function(t3) {
    return "pre" === zy.getNodeType(t3) || !!eg.isVoid(e10, t3);
  }, universal: true }), 1);
  return !!n2[0];
}
function nB(e10, t2) {
  Object.keys(t2).forEach(function(t3) {
    "text" !== t3 && eg.removeMark(e10, t3);
  });
}
var rB = function() {
  function e10() {
    this.marksNeedToRemove = [], this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    var t2 = this.mark, n2 = eg.marks(e11);
    if (n2) return n2[t2];
    var r3 = iv(eg.nodes(e11, { match: function(e12) {
      return true === e12[t2];
    } }), 1);
    return !!r3[0];
  }, e10.prototype.isActive = function(e11) {
    return !!this.getValue(e11);
  }, e10.prototype.isDisabled = function(e11) {
    return tB(e11, this.mark);
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.mark, r3 = this.marksNeedToRemove;
    t2 ? e11.removeMark(n2) : (e11.addMark(n2, true), r3 && r3.forEach(function(t3) {
      return e11.removeMark(t3);
    }));
  }, e10;
}(), oB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "bold", t3.title = iC("textStyle.bold"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M707.872 484.64A254.88 254.88 0 0 0 768 320c0-141.152-114.848-256-256-256H192v896h384c141.152 0 256-114.848 256-256a256.096 256.096 0 0 0-124.128-219.36zM384 192h101.504c55.968 0 101.504 57.408 101.504 128s-45.536 128-101.504 128H384V192z m159.008 640H384v-256h159.008c58.464 0 106.016 57.408 106.016 128s-47.552 128-106.016 128z"></path></svg>', t3.hotkey = "mod+b", t3;
  }
  return ev(t2, e10), t2;
}(rB), iB = function() {
  function e10() {
    this.title = iC("textStyle.clear"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M969.382408 288.738615l-319.401123-270.852152a67.074236 67.074236 0 0 0-96.459139 5.74922l-505.931379 574.922021a68.35184 68.35184 0 0 0-17.886463 47.910169 74.101061 74.101061 0 0 0 24.274486 47.910168l156.50655 132.232065h373.060512L975.131628 383.281347a67.074236 67.074236 0 0 0-5.74922-96.459139z m-440.134747 433.746725H264.144729l-90.071117-78.572676c-5.74922-5.74922-12.137243-12.137243-12.137243-17.886463a36.411728 36.411728 0 0 1 5.749221-24.274485l210.804741-240.828447 265.102932 228.691204z m-439.495945 180.781036h843.218964a60.047411 60.047411 0 1 1 0 120.733624H89.751716a60.047411 60.047411 0 1 1 0-120.733624z m0 0"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return tB(e11);
  }, e10.prototype.exec = function(e11, t2) {
    var n2, r3, o2 = eg.nodes(e11, { match: function(e12) {
      return Og.isText(e12);
    }, universal: true });
    try {
      for (var i2 = ov(o2), a2 = i2.next(); !a2.done; a2 = i2.next()) {
        nB(e11, a2.value[0]);
      }
    } catch (e12) {
      n2 = { error: e12 };
    } finally {
      try {
        a2 && !a2.done && (r3 = i2.return) && r3.call(i2);
      } finally {
        if (n2) throw n2.error;
      }
    }
  }, e10;
}(), aB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "code", t3.title = iC("textStyle.code"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M576 736l96 96 320-320L672 192l-96 96 224 224zM448 288l-96-96L32 512l320 320 96-96-224-224z"></path></svg>', t3.hotkey = "mod+e", t3;
  }
  return ev(t2, e10), t2;
}(rB), sB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "italic", t3.title = iC("textStyle.italic"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M896 64v64h-128L448 896h128v64H128v-64h128L576 128h-128V64z"></path></svg>', t3.hotkey = "mod+i", t3;
  }
  return ev(t2, e10), t2;
}(rB), uB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "sub", t3.marksNeedToRemove = ["sup"], t3.title = iC("textStyle.sub"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M768 910.016v50.016h128v64h-192v-146.016l128-60V768h-128v-64h192v146.016zM676 256h-136L352 444 164 256H28l256 256-256 256h136L352 580 540 768h136l-256-256z"></path></svg>', t3.hotkey = "", t3;
  }
  return ev(t2, e10), t2;
}(rB), lB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "sup", t3.marksNeedToRemove = ["sub"], t3.title = iC("textStyle.sup"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M768 206.016v50.016h128v64h-192V174.016l128-60V64h-128V0h192v146.016zM676 256h-136L352 444 164 256H28l256 256-256 256h136L352 580 540 768h136l-256-256z"></path></svg>', t3.hotkey = "", t3;
  }
  return ev(t2, e10), t2;
}(rB), cB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "through", t3.title = iC("textStyle.through"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M1024 512v64h-234.496c27.52 38.496 42.496 82.688 42.496 128 0 70.88-36.672 139.04-100.576 186.976C672.064 935.488 594.144 960 512 960s-160.064-24.512-219.424-69.024C228.64 843.04 192 774.88 192 704h128c0 69.376 87.936 128 192 128s192-58.624 192-128-87.936-128-192-128H0v-64h299.52a385.984 385.984 0 0 1-6.944-5.024C228.64 459.04 192 390.88 192 320s36.672-139.04 100.576-186.976C351.936 88.512 429.856 64 512 64s160.064 24.512 219.424 69.024C795.328 180.96 832 249.12 832 320h-128c0-69.376-87.936-128-192-128s-192 58.624-192 128 87.936 128 192 128c78.976 0 154.048 22.688 212.48 64H1024z"></path></svg>', t3.hotkey = "mod+shift+x", t3;
  }
  return ev(t2, e10), t2;
}(rB), dB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.mark = "underline", t3.title = iC("textStyle.underline"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M704 64l128 0 0 416c0 159.072-143.264 288-320 288s-320-128.928-320-288l0-416 128 0 0 416c0 40.16 18.24 78.688 51.36 108.512 36.896 33.216 86.848 51.488 140.64 51.488s103.744-18.304 140.64-51.488c33.12-29.792 51.36-68.352 51.36-108.512l0-416zM192 832l640 0 0 128-640 0z"></path></svg>', t3.hotkey = "mod+u", t3;
  }
  return ev(t2, e10), t2;
}(rB);
function fB(e10, t2) {
  return 0 !== e10.length && (!!e10[0].matches(t2) || e10.find(t2).length > 0);
}
function pB(e10, t2) {
  var n2 = t2, r3 = e10, o2 = r3.bold, i2 = r3.italic, a2 = r3.underline, s2 = r3.code, u2 = r3.through, l2 = r3.sub, c3 = r3.sup;
  return o2 && (n2 = "<strong>".concat(n2, "</strong>")), s2 && (n2 = "<code>".concat(n2, "</code>")), i2 && (n2 = "<em>".concat(n2, "</em>")), a2 && (n2 = "<u>".concat(n2, "</u>")), u2 && (n2 = "<s>".concat(n2, "</s>")), l2 && (n2 = "<sub>".concat(n2, "</sub>")), c3 && (n2 = "<sup>".concat(n2, "</sup>")), n2;
}
var hB = { renderStyle: function(e10, t2) {
  var n2 = e10, r3 = n2.bold, o2 = n2.italic, i2 = n2.underline, a2 = n2.code, s2 = n2.through, u2 = n2.sub, l2 = n2.sup, c3 = t2;
  return r3 && (c3 = Pw("strong", null, c3)), a2 && (c3 = Pw("code", null, c3)), o2 && (c3 = Pw("em", null, c3)), i2 && (c3 = Pw("u", null, c3)), s2 && (c3 = Pw("s", null, c3)), u2 && (c3 = Pw("sub", null, c3)), l2 && (c3 = Pw("sup", null, c3)), c3;
}, menus: [{ key: "bold", factory: function() {
  return new oB();
} }, { key: "underline", factory: function() {
  return new dB();
} }, { key: "italic", factory: function() {
  return new sB();
} }, { key: "through", factory: function() {
  return new cB();
} }, { key: "code", factory: function() {
  return new aB();
} }, { key: "sub", factory: function() {
  return new uB();
} }, { key: "sup", factory: function() {
  return new lB();
} }, { key: "clearStyle", factory: function() {
  return new iB();
} }], styleToHtml: function(e10, t2) {
  if (!Og.isText(e10)) return t2;
  if (Nx(t2)) return pB(e10, t2);
  var n2 = fm(t2), r3 = n2.html();
  return r3 = pB(e10, r3), n2.html(r3), Bx(n2);
}, parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Og.isText(t2)) return t2;
  var o2 = t2;
  return fB(r3, "b,strong") && (o2.bold = true), fB(r3, "i,em") && (o2.italic = true), fB(r3, "u") && (o2.underline = true), fB(r3, "s,strike") && (o2.through = true), fB(r3, "sub") && (o2.sub = true), fB(r3, "sup") && (o2.sup = true), fB(r3, "code") && (o2.code = true), o2;
} };
var gB = { type: "todo", elemToHtml: function(e10, t2) {
  var n2 = e10.checked;
  return '<div data-w-e-type="todo"><input type="checkbox" disabled '.concat(n2 ? "checked" : "", ">").concat(t2, "</div>");
} }, vB = function() {
  function e10() {
    this.title = iC("todo.todo"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M278.755556 403.911111l-79.644445 79.644445L455.111111 739.555556l568.888889-568.888889-79.644444-79.644445L455.111111 580.266667l-176.355555-176.355556zM910.222222 910.222222H113.777778V113.777778h568.888889V0H113.777778C51.2 0 0 51.2 0 113.777778v796.444444c0 62.577778 51.2 113.777778 113.777778 113.777778h796.444444c62.577778 0 113.777778-51.2 113.777778-113.777778V455.111111h-113.777778v455.111111z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return !!zy.getSelectedNodeByType(e11, "todo");
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !!zy.getSelectedElems(e11).some(function(t2) {
      if (eg.isVoid(e11, t2) && eg.isBlock(e11, t2)) return true;
      var n2 = t2.type;
      return !!["pre", "table", "list-item"].includes(n2);
    });
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.isActive(e11);
    Wg.setNodes(e11, { type: n2 ? "paragraph" : "todo" });
  }, e10;
}();
var mB = { selector: 'div[data-w-e-type="todo"]', parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  0 === (t2 = t2.filter(function(e11) {
    return !!Og.isText(e11) || !!n2.isInline(e11);
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]);
  var o2 = false;
  return null != r3.find('input[type="checkbox"]').attr("checked") && (o2 = true), { type: "todo", checked: o2, children: t2 };
} };
var yB = { type: "todo", renderElem: function(e10, t2, n2) {
  var r3 = false;
  n2.isDisabled() && (r3 = true);
  var o2 = Pw("div", { style: { margin: "5px 0" } }, Pw("span", { contentEditable: false, style: { marginRight: "0.5em" } }, Pw("input", { type: "checkbox", checked: e10.checked, disabled: r3, on: { change: function(t3) {
    var r4 = zy.findPath(n2, e10), o3 = { checked: t3.target.checked };
    Wg.setNodes(n2, o3, { at: r4 });
  } } })), Pw("span", null, t2));
  return o2;
} }, bB = { renderElems: [yB], elemsToHtml: [gB], preParseHtml: [{ selector: "ul.w-e-todo", preParseHtml: function(e10) {
  var t2 = fm(e10).find("li"), n2 = fm('<div data-w-e-type="todo"></div>'), r3 = t2.find("input[type]");
  return n2.append(r3), t2.children()[0].remove(), n2[0].innerHTML += t2[0].innerHTML, n2[0];
} }], parseElemsHtml: [mB], menus: [{ key: "todo", factory: function() {
  return new vB();
} }], editorPlugin: function(e10) {
  var t2 = e10.deleteBackward, n2 = e10;
  return n2.deleteBackward = function(n3) {
    var r3 = e10.selection;
    if (r3 && yg.isCollapsed(r3)) {
      var o2 = zy.getSelectedNodeByType(e10, "todo");
      if (o2 && 0 === ag.string(o2).length) return void Wg.setNodes(e10, { type: "paragraph" }, { mode: "highest" });
    }
    t2(n3);
  }, n2;
} }, EB = function() {
  function e10() {
    this.title = iC("undo.redo"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M0.00032 576a510.72 510.72 0 0 0 173.344 384l84.672-96A383.136 383.136 0 0 1 128.00032 576C128.00032 363.936 299.93632 192 512.00032 192c106.048 0 202.048 42.976 271.52 112.48L640.00032 448h384V64l-149.984 149.984A510.272 510.272 0 0 0 512.00032 64C229.21632 64 0.00032 293.216 0.00032 576z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection;
  }, e10.prototype.exec = function(e11, t2) {
    "function" == typeof e11.redo && e11.redo();
  }, e10;
}(), CB = function() {
  function e10() {
    this.title = iC("undo.undo"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M512 64A510.272 510.272 0 0 0 149.984 213.984L0.032 64v384h384L240.512 304.48A382.784 382.784 0 0 1 512.032 192c212.064 0 384 171.936 384 384 0 114.688-50.304 217.632-130.016 288l84.672 96a510.72 510.72 0 0 0 173.344-384c0-282.784-229.216-512-512-512z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection;
  }, e10.prototype.exec = function(e11, t2) {
    "function" == typeof e11.undo && e11.undo();
  }, e10;
}(), wB = [hB, Yx, sO, bN, AN, ON, gN, eO, nO, XN, $x, _x2, WO, eB, bB, lO, { menus: [{ key: "redo", factory: function() {
  return new EB();
} }, { key: "undo", factory: function() {
  return new CB();
} }] }, dO, Zx];
tC("en", { listModule: { unOrderedList: "Unordered list", orderedList: "Ordered list" } }), tC("zh-CN", { listModule: { unOrderedList: "无序列表", orderedList: "有序列表" } });
var DB = /* @__PURE__ */ new WeakMap();
function SB(e10) {
  var t2, n2 = e10.children || [], r3 = n2.length;
  if (0 === r3) return "";
  for (var o2 = 0; o2 < r3 && !t2; o2 += 1) {
    var i2 = n2[o2];
    Og.isText(i2) && (t2 = i2);
  }
  return null == t2 ? "" : t2.color || "";
}
function AB(e10, t2, n2) {
  for (var r3 = t2.type, o2 = function(e11, t3) {
    var n3 = {};
    for (var r4 in e11) Object.prototype.hasOwnProperty.call(e11, r4) && t3.indexOf(r4) < 0 && (n3[r4] = e11[r4]);
    if (null != e11 && "function" == typeof Object.getOwnPropertySymbols) {
      var o3 = 0;
      for (r4 = Object.getOwnPropertySymbols(e11); o3 < r4.length; o3++) t3.indexOf(r4[o3]) < 0 && Object.prototype.propertyIsEnumerable.call(e11, r4[o3]) && (n3[r4[o3]] = e11[r4[o3]]);
    }
    return n3;
  }(t2, ["type"]), i2 = void 0 !== n2 ? n2 : o2.level || 0, a2 = zy.findPath(e10, t2); ; ) {
    if (0 === a2.length || 0 === a2[a2.length - 1]) return null;
    a2 = cg.previous(a2);
    var s2 = eg.node(e10, a2);
    if (!s2) return null;
    var u2 = iv(s2, 1)[0], l2 = u2.level, c3 = void 0 === l2 ? 0 : l2;
    if (zy.getNodeType(u2) !== r3) return null;
    if (c3 === i2) return u2;
  }
}
function xB(e10, t2, n2) {
  var r3 = AB(e10, t2, n2);
  return !!r3 && r3.ordered === t2.ordered;
}
var OB = [];
var NB = { type: "list-item", elemToHtml: function(e10, t2) {
  var n2 = "", r3 = "", o2 = e10.ordered, i2 = void 0 !== o2 && o2 ? "ol" : "ul", a2 = function(e11) {
    var t3 = DB.get(e11);
    if (null == t3) return 0;
    var n3 = e11, r4 = n3.type, o3 = n3.ordered, i3 = void 0 !== o3 && o3, a3 = n3.level, s3 = void 0 === a3 ? 0 : a3, u3 = zy.findPath(t3, e11);
    if (0 === u3[0]) return s3 + 1;
    var l3 = cg.previous(u3), c4 = eg.node(t3, l3);
    if (!c4) return 0;
    var d3 = iv(c4, 1)[0];
    if (zy.getNodeType(d3) !== r4) return s3 + 1;
    var f2 = d3, p2 = f2.ordered, h2 = void 0 !== p2 && p2, g2 = f2.level, v2 = void 0 === g2 ? 0 : g2;
    return v2 < s3 ? s3 - v2 : v2 > s3 ? xB(t3, e11) ? 0 : 1 : v2 === s3 ? h2 === i3 ? 0 : 1 : 0;
  }(e10);
  if (a2 > 0) for (var s2 = 0; s2 < a2; s2 += 1) n2 += "<".concat(i2, ">"), OB.push(i2);
  var u2 = function(e11) {
    var t3 = DB.get(e11);
    if (null == t3) return 0;
    var n3 = e11, r4 = n3.type, o3 = n3.ordered, i3 = void 0 !== o3 && o3, a3 = n3.level, s3 = void 0 === a3 ? 0 : a3, u3 = zy.findPath(t3, e11);
    if (u3[0] === t3.children.length - 1) return s3 + 1;
    var l3 = cg.next(u3), c4 = eg.node(t3, l3);
    if (!c4) return 0;
    var d3 = iv(c4, 1)[0];
    if (zy.getNodeType(d3) !== r4) return s3 + 1;
    var f2 = d3, p2 = f2.ordered, h2 = void 0 !== p2 && p2, g2 = f2.level, v2 = void 0 === g2 ? 0 : g2;
    return v2 < s3 ? xB(t3, d3) ? s3 - v2 : s3 - v2 + 1 : v2 > s3 ? 0 : v2 === s3 ? h2 === i3 ? 0 : 1 : 0;
  }(e10);
  if (u2 > 0) for (s2 = 0; s2 < u2; s2 += 1) {
    var l2 = OB.pop();
    r3 += "</".concat(l2, ">");
  }
  var c3 = SB(e10), d2 = c3 ? ' style="color:'.concat(c3, '"') : "";
  return { html: "<li".concat(d2, ">").concat(t2, "</li>"), prefix: n2, suffix: r3 };
} }, BB = function() {
  function e10() {
    this.type = "list-item", this.tag = "button";
  }
  return e10.prototype.getListNode = function(e11) {
    var t2 = this.type;
    return zy.getSelectedNodeByType(e11, t2);
  }, e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    var t2 = this.getListNode(e11);
    if (null == t2) return false;
    var n2 = t2.ordered;
    return (void 0 !== n2 && n2) === this.ordered;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !!zy.getSelectedElems(e11).some(function(t2) {
      if (eg.isVoid(e11, t2) && eg.isBlock(e11, t2)) return true;
      var n2 = t2.type;
      return !!["pre", "code", "table"].includes(n2);
    });
  }, e10.prototype.exec = function(e11, t2) {
    this.isActive(e11) ? Wg.setNodes(e11, { type: "paragraph", ordered: void 0, level: void 0 }) : Wg.setNodes(e11, { type: "list-item", ordered: this.ordered, indent: void 0 });
  }, e10;
}(), TB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.ordered = false, t3.title = iC("listModule.unOrderedList"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M384 64h640v128H384V64z m0 384h640v128H384v-128z m0 384h640v128H384v-128zM0 128a128 128 0 1 1 256 0 128 128 0 0 1-256 0z m0 384a128 128 0 1 1 256 0 128 128 0 0 1-256 0z m0 384a128 128 0 1 1 256 0 128 128 0 0 1-256 0z"></path></svg>', t3;
  }
  return ev(t2, e10), t2;
}(BB), kB = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.ordered = true, t3.title = iC("listModule.orderedList"), t3.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M384 832h640v128H384z m0-384h640v128H384z m0-384h640v128H384zM192 0v256H128V64H64V0zM128 526.016v50.016h128v64H64v-146.016l128-60V384H64v-64h192v146.016zM256 704v320H64v-64h128v-64H64v-64h128v-64H64v-64z"></path></svg>', t3;
  }
  return ev(t2, e10), t2;
}(BB), FB = { key: "bulletedList", factory: function() {
  return new TB();
} }, IB = { key: "numberedList", factory: function() {
  return new kB();
} };
function PB(e10) {
  return e10.length ? e10[0].tagName.toLowerCase() : "";
}
Pm && (fm.fn.append = Pm), vm && (fm.fn.attr = vm), Rm && (fm.fn.parent = Rm);
var _B2 = { selector: "li:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  0 === (t2 = t2.filter(function(e11) {
    return !!Og.isText(e11) || !!n2.isInline(e11);
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]);
  var o2 = function(e11) {
    return "ol" === PB(e11.parent());
  }(r3), i2 = function(e11) {
    for (var t3 = 0, n3 = e11.parent(), r4 = PB(n3); "ul" === r4 || "ol" === r4; ) r4 = PB(n3 = n3.parent()), t3 += 1;
    return t3 - 1;
  }(r3);
  return { type: "list-item", ordered: o2, level: i2, children: t2 };
} };
var RB = { selector: "ul:not([data-w-e-type]),ol:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  return t2.flat(1 / 0);
} };
function LB(e10) {
  return eg.nodes(e10, { at: e10.selection || void 0, match: function(t2) {
    return 1 === zy.findPath(e10, t2).length;
  } });
}
var MB = { type: "list-item", renderElem: function(e10, t2, n2) {
  DB.set(e10, n2);
  var r3 = e10, o2 = r3.level, i2 = void 0 === o2 ? 0 : o2, a2 = r3.ordered, s2 = void 0 !== a2 && a2, u2 = { margin: "5px 0 5px ".concat(20 * i2, "px"), display: "flex", alignItems: "flex-start" }, l2 = "";
  if (s2) {
    var c3 = function(e11, t3) {
      var n3 = t3, r4 = n3.type, o3 = n3.level, i3 = void 0 === o3 ? 0 : o3, a3 = n3.ordered, s3 = void 0 !== a3 && a3, u3 = 1, l3 = t3, c4 = zy.findPath(e11, l3);
      if (0 === c4[0]) return 1;
      for (; c4[0] > 0; ) {
        var d2 = cg.previous(c4), f2 = eg.node(e11, d2);
        if (null == f2) break;
        var p2 = f2[0], h2 = p2.level, g2 = void 0 === h2 ? 0 : h2, v2 = p2.type, m2 = p2.ordered;
        if (v2 !== r4) break;
        if (g2 < i3) break;
        if (g2 === i3) {
          if (m2 !== s3) break;
          u3 += 1;
        }
        l3 = p2, c4 = d2;
      }
      return u3;
    }(n2, e10);
    l2 = "".concat(c3, ".");
  } else l2 = function(e11) {
    void 0 === e11 && (e11 = 0);
    var t3 = "";
    switch (e11) {
      case 0:
        t3 = "•";
        break;
      case 1:
        t3 = "◦";
        break;
      default:
        t3 = "▪";
    }
    return t3;
  }(i2);
  return Pw("div", { style: u2 }, Pw("span", { contentEditable: false, style: { marginRight: "0.5em", color: SB(e10) }, "data-w-e-reserve": true }, l2), Pw("span", { style: { flex: "1", wordBreak: "break-word" } }, t2));
} }, jB = { renderElems: [MB], editorPlugin: function(e10) {
  var t2 = e10.deleteBackward, n2 = e10.handleTab, r3 = e10.normalizeNode, o2 = e10.insertBreak, i2 = e10;
  return i2.insertBreak = function() {
    var t3 = iv(eg.nodes(e10, { match: function(e11) {
      return zy.checkNodeType(e11, "list-item");
    }, universal: true }), 1), n3 = t3[0];
    return n3 ? "" !== n3[0].children[0].text ? o2() : void Wg.setNodes(i2, { type: "paragraph", ordered: void 0, level: void 0 }) : o2();
  }, i2.deleteBackward = function(n3) {
    var r4 = i2.selection;
    if (null != r4) if (yg.isExpanded(r4)) t2(n3);
    else {
      var o3 = zy.getSelectedNodeByType(i2, "list-item");
      if (null != o3) if (0 !== r4.focus.offset) t2(n3);
      else {
        var a2 = o3, s2 = a2.level, u2 = void 0 === s2 ? 0 : s2, l2 = a2.ordered, c3 = void 0 !== l2 && l2;
        if (u2 > 0) {
          var d2 = AB(e10, o3, u2 - 1);
          d2 && d2.ordered !== c3 ? Wg.setNodes(i2, { level: u2 - 1, ordered: !c3 }) : Wg.setNodes(i2, { level: u2 - 1 });
        } else Wg.setNodes(i2, { type: "paragraph", ordered: void 0, level: void 0 });
      }
      else t2(n3);
    }
    else t2(n3);
  }, i2.handleTab = function() {
    var e11, t3, r4, o3, a2 = i2.selection;
    if (null != a2) {
      if (yg.isCollapsed(a2)) {
        var s2 = zy.getSelectedNodeByType(i2, "list-item");
        if (null == s2) return void n2();
        if (0 === a2.focus.offset) {
          var u2 = s2.level, l2 = void 0 === u2 ? 0 : u2;
          return void Wg.setNodes(i2, { level: l2 + 1 });
        }
      }
      if (yg.isExpanded(a2)) {
        var c3 = 0, d2 = false;
        try {
          for (var f2 = ov(LB(i2)), p2 = f2.next(); !p2.done; p2 = f2.next()) {
            var h2 = iv(p2.value, 1)[0];
            "list-item" === zy.getNodeType(h2) ? c3 += 1 : d2 = true;
          }
        } catch (t4) {
          e11 = { error: t4 };
        } finally {
          try {
            p2 && !p2.done && (t3 = f2.return) && t3.call(f2);
          } finally {
            if (e11) throw e11.error;
          }
        }
        if (d2 || c3 <= 1) return void n2();
        try {
          for (var g2 = ov(LB(i2)), v2 = g2.next(); !v2.done; v2 = g2.next()) {
            var m2 = iv(v2.value, 2), y2 = (h2 = m2[0], m2[1]), b2 = h2.level;
            l2 = void 0 === b2 ? 0 : b2;
            Wg.setNodes(i2, { level: l2 + 1 }, { at: y2 });
          }
        } catch (e12) {
          r4 = { error: e12 };
        } finally {
          try {
            v2 && !v2.done && (o3 = g2.return) && o3.call(g2);
          } finally {
            if (r4) throw r4.error;
          }
        }
      } else n2();
    } else n2();
  }, i2.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), n3 = t3[0], o3 = t3[1], a2 = zy.getNodeType(n3);
    return "bulleted-list" !== a2 && "numbered-list" !== a2 || Wg.unwrapNodes(i2, { at: o3 }), r3([n3, o3]);
  }, i2;
}, menus: [FB, IB], elemsToHtml: [NB], parseElemsHtml: [RB, _B2] };
tC("en", { tableModule: { modal: { border: "Border", borderWidth: "Width", bgColor: "Back color", align: "Text Align", ok: "OK" }, color: { default: "Default color", clear: "Clear back color" }, borderStyle: { none: "None", solid: "Solid", dotted: "Dotted", dashed: "Dashed", double: "Double", groove: "Groove", ridge: "Ridge", inset: "Inset", outset: "Outset" }, deleteCol: "Delete column", deleteRow: "Delete row", deleteTable: "Delete table", widthAuto: "Fit width", insertCol: "Insert column", insertRow: "Insert row", insertTable: "Insert table", header: "Header", mergeCell: "merge cell", splitCell: "split cell", tableProperty: "Table property", cellProperty: "Cell property" } }), tC("zh-CN", { tableModule: { modal: { border: "边框", borderWidth: "宽度", bgColor: "背景色", align: "对齐方式", ok: "确定" }, color: { default: "默认颜色", clear: "清除背景色" }, borderStyle: { none: "无样式", solid: "实线", dotted: "点状虚线", dashed: "虚线", double: "双线", groove: "凹槽边框", ridge: "菱形边框", inset: "凹边框", outset: "凸边框" }, deleteCol: "删除列", deleteRow: "删除行", deleteTable: "删除表格", widthAuto: "适应宽度", insertCol: "插入列", insertRow: "插入行", insertTable: "插入表格", header: "表头", mergeCell: "合并单元格", splitCell: "拆分单元格", tableProperty: "表格属性", cellProperty: "单元格属性" } });
var HB = { type: "table", elemToHtml: function(e10, t2) {
  var n2 = e10, r3 = n2.width, o2 = void 0 === r3 ? "auto" : r3, i2 = n2.columnWidths, a2 = n2.height, s2 = void 0 === a2 ? "auto" : a2, u2 = null == i2 ? void 0 : i2.map(function(e11) {
    return "<col width=".concat(e11, "></col>");
  }).join(""), l2 = u2 ? '<colgroup contentEditable="false">'.concat(u2, "</colgroup>") : "";
  return '<table style="width: '.concat(o2, ";table-layout: fixed;height:").concat(s2, '">').concat(l2, "<tbody>").concat(t2, "</tbody></table>");
} }, zB = { type: "table-row", elemToHtml: function(e10, t2) {
  var n2 = e10.height, r3 = n2 ? ' style="height: '.concat(n2, 'px"') : "";
  return "<tr".concat(r3, ">").concat(t2, "</tr>");
} }, $B = { type: "table-cell", elemToHtml: function(e10, t2) {
  var n2 = e10, r3 = n2.colSpan, o2 = void 0 === r3 ? 1 : r3, i2 = n2.rowSpan, a2 = void 0 === i2 ? 1 : i2, s2 = n2.isHeader, u2 = void 0 !== s2 && s2, l2 = n2.width, c3 = void 0 === l2 ? "auto" : l2, d2 = n2.hidden;
  if (void 0 !== d2 && d2) return "";
  var f2 = u2 ? "th" : "td";
  return "<".concat(f2, ' colSpan="').concat(o2, '" rowSpan="').concat(a2, '" width="').concat(c3, '">').concat(t2, "</").concat(f2, ">");
} }, UB = '<svg viewBox="0 0 1024 1024"><path d="M236.8 128L896 787.2V128H236.8z m614.4 704L192 172.8V832h659.2zM192 64h704c38.4 0 64 25.6 64 64v704c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64z"></path></svg>', VB = { blocks: { td: "table-cell", th: "table-cell", content: "paragraph", tr: "table-row", table: "table", tbody: "table-body" } };
function WB(e10) {
  for (var t2 = [], n2 = 1; n2 < arguments.length; n2++) t2[n2 - 1] = arguments[n2];
  var r3 = VB, o2 = t2.map(function(e11) {
    var t3;
    return null === (t3 = null == r3 ? void 0 : r3.blocks) || void 0 === t3 ? void 0 : t3[e11];
  });
  return function(e11) {
    return function(e12) {
      return !eg.isEditor(e12) && Kh.isElement(e12) && "type" in e12;
    }(e11) && o2.includes(e11.type);
  };
}
function GB(e10, t2) {
  for (var n2 = iv(t2, 2), r3 = n2[0], o2 = n2[1], i2 = [], a2 = 2; a2 < arguments.length; a2++) i2[a2 - 2] = arguments[a2];
  var s2 = iv(ag.common(e10, r3, o2), 2), u2 = s2[0], l2 = s2[1];
  return !!WB.apply(void 0, av([e10], iv(i2), false))(u2, l2) || !!eg.above(e10, { match: WB.apply(void 0, av([e10], iv(i2), false)), at: l2 });
}
function qB(e10, t2) {
  var n2, r3;
  void 0 === t2 && (t2 = {});
  var o2 = [];
  try {
    for (var i2 = ov(function(e11, t3) {
      var n3, r4, o3, i3, a3, s3, u3, l3, c4, d3, f3, p3, h3, g3, v6, m3, y3, b3;
      return void 0 === t3 && (t3 = {}), rv(this, function(E3) {
        switch (E3.label) {
          case 0:
            if (n3 = iv(eg.nodes(e11, { match: WB(e11, "table"), at: t3.at }), 1), !(r4 = n3[0])) return [2, []];
            o3 = iv(r4, 2), i3 = o3[1], E3.label = 1;
          case 1:
            E3.trys.push([1, 6, 7, 8]), a3 = ov(eg.nodes(e11, { match: WB(e11, "table"), at: i3 })), s3 = a3.next(), E3.label = 2;
          case 2:
            if (s3.done) return [3, 5];
            u3 = iv(s3.value, 2), l3 = u3[1], c4 = [];
            try {
              for (y3 = void 0, d3 = ov(eg.nodes(e11, { match: WB(e11, "tr"), at: l3 })), f3 = d3.next(); !f3.done; f3 = d3.next()) p3 = iv(f3.value, 2), h3 = p3[1], c4.push(av([], iv(eg.nodes(e11, { match: WB(e11, "th", "td"), at: h3 })), false));
            } catch (e12) {
              y3 = { error: e12 };
            } finally {
              try {
                f3 && !f3.done && (b3 = d3.return) && b3.call(d3);
              } finally {
                if (y3) throw y3.error;
              }
            }
            return [4, c4];
          case 3:
            E3.sent(), E3.label = 4;
          case 4:
            return s3 = a3.next(), [3, 2];
          case 5:
            return [3, 8];
          case 6:
            return g3 = E3.sent(), v6 = { error: g3 }, [3, 8];
          case 7:
            try {
              s3 && !s3.done && (m3 = a3.return) && m3.call(a3);
            } finally {
              if (v6) throw v6.error;
            }
            return [7];
          case 8:
            return [2];
        }
      });
    }(e10, { at: t2.at })), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      for (var s2 = a2.value, u2 = [], l2 = 0, c3 = 0; c3 < s2.length; c3 += 1) s2[c3] && (l2 = Math.max(l2, s2[c3].length));
      for (c3 = 0; c3 < s2.length; c3 += 1) if (u2[c3] || (u2[c3] = []), s2[c3]) {
        for (var d2 = 0; d2 < s2[c3].length; d2 += 1) if (s2[c3][d2] && s2[c3][d2][0]) {
          for (var f2 = iv(s2[c3][d2], 1)[0], p2 = f2.rowSpan, h2 = void 0 === p2 ? 1 : p2, g2 = f2.colSpan, v2 = void 0 === g2 ? 1 : g2, m2 = d2; u2[c3] && u2[c3][m2]; ) m2 += 1;
          for (var y2 = 0; y2 < v2; y2 += 1) for (var b2 = 0; b2 < h2; b2 += 1) {
            var E2 = c3 + b2, C2 = m2 + y2;
            u2[E2] || (u2[E2] = []), u2[E2][C2] || (u2[E2][C2] = [s2[c3][d2], { rtl: y2 + 1, ltr: v2 - y2, ttb: b2 + 1, btt: h2 - b2 }]);
          }
        }
      }
      o2.push.apply(o2, av([], iv(u2), false));
    }
  } catch (e11) {
    n2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (r3 = i2.return) && r3.call(i2);
    } finally {
      if (n2) throw n2.error;
    }
  }
  return o2;
}
var KB = function() {
  function e10(e11, t2) {
    this.x = e11, this.y = t2;
  }
  return e10.valueOf = function(e11, t2) {
    return new this(e11, t2);
  }, e10.equals = function(e11, t2) {
    return e11.x === t2.x && e11.y === t2.y;
  }, e10;
}();
function YB(e10) {
  return e10.length ? e10[0].tagName.toLowerCase() : "";
}
function XB(e10, t2) {
  for (var n2 = "", r3 = (e10.attr("style") || "").split(";"), o2 = r3.length, i2 = 0; i2 < o2; i2 += 1) {
    var a2 = r3[i2];
    if (a2) {
      var s2 = a2.split(":");
      s2[0].trim() === t2 && (n2 = s2[1].trim());
    }
  }
  return n2;
}
Pm && fm.fn && (fm.fn.append = Pm), Cm && fm.fn && (fm.fn.on = Cm), Wm && fm.fn && (fm.fn.focus = Wm), vm && fm.fn && (fm.fn.attr = vm), Em && fm.fn && (fm.fn.val = Em), km && fm.fn && (fm.fn.html = km), bm && fm.fn && (fm.fn.dataset = bm), pm && fm.fn && (fm.fn.addClass = pm), hm && fm.fn && (fm.fn.removeClass = hm), jm && fm.fn && (fm.fn.children = jm), Bm && fm.fn && (fm.fn.each = Bm), Mm && fm.fn && (fm.fn.find = Mm), ym && fm.fn && (fm.fn.data = ym), xm && fm.fn && (fm.fn.hide = xm), Om && fm.fn && (fm.fn.show = Om);
var ZB = /* @__PURE__ */ new WeakMap(), JB = /* @__PURE__ */ new WeakMap(), QB = function() {
  function e10() {
    this.title = iC("tableModule.tableProperty"), this.iconSvg = '<svg viewBox="0 0 20 20"><path d="M8 2v5h4V2h1v5h5v1h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5H7v-5H2v-1h5V8H2V7h5V2h1zm4 6H8v4h4V8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM17 1a2 2 0 0 1 2 2v9.475l-.85-.124-.857-1.736a2.048 2.048 0 0 0-.292-.44L17 3H3v14h7.808l.402.392L10.935 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14z"/></svg>', this.tag = "button", this.showModal = true, this.modalWidth = 300, this.menu = "table", this.borderStyle = [{ value: "none", label: iC("tableModule.borderStyle.none") }, { value: "solid", label: iC("tableModule.borderStyle.solid") }, { value: "dotted", label: iC("tableModule.borderStyle.dotted") }, { value: "dashed", label: iC("tableModule.borderStyle.dashed") }, { value: "double", label: iC("tableModule.borderStyle.double") }, { value: "groove", label: iC("tableModule.borderStyle.groove") }, { value: "ridge", label: iC("tableModule.borderStyle.ridge") }, { value: "inset", label: iC("tableModule.borderStyle.inset") }, { value: "outset", label: iC("tableModule.borderStyle.outset") }], this.textAlignOptions = [{ value: "left", label: iC("justify.left"), svg: '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>' }, { value: "center", label: iC("justify.center"), svg: '<svg viewBox="0 0 1024 1024"><path d="M870.4 793.6v102.4H153.6v-102.4h716.8z m102.4-230.4v102.4H51.2v-102.4h921.6z m-102.4-230.4v102.4H153.6v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>' }, { value: "right", label: iC("justify.right"), svg: '<svg viewBox="0 0 1024 1024"><path d="M972.8 793.6v102.4H256v-102.4h716.8z m0-230.4v102.4H51.2v-102.4h921.6z m0-230.4v102.4H256v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>' }, { value: "justify", label: iC("justify.justify"), svg: '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z m0 192h1024v128H0z"></path></svg>' }];
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == zy.getSelectedNodeByType(e11, "table");
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.getModalContentNode = function(e11) {
    return iv(eg.nodes(e11, { match: WB(e11, "table") }), 1)[0];
  }, e10.prototype.getModalPositionNode = function(e11) {
    return null;
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = this.getModalContentNode(e11);
    if (!n2) return null;
    var r3 = iv(n2, 2), o2 = r3[0], i2 = r3[1], a2 = fm('<div>\n      <label class="babel-container">\n        <span>'.concat(iC("tableModule.modal.border"), '</span>\n        <span class="babel-container-border">\n          <select name="borderStyle">\n            ').concat(this.borderStyle.map(function(e12) {
      return '<option value="'.concat(e12.value, '">').concat(e12.label, "</option>");
    }).join(""), '\n          </select>\n          <span class="color-group" data-mark="color">\n            <span class="color-group-block"></span>\n            <input name="borderColor" type="hidden">\n          </span>\n          <input name="borderWidth" type="number" placeholder="').concat(iC("tableModule.modal.borderWidth"), '">\n        </span>\n      </label>\n      <div class="babel-container">\n        <span>').concat(iC("tableModule.modal.bgColor"), '</span>\n        <span class="babel-container-background">\n          <span class="color-group" data-mark="bgColor">\n            <span class="color-group-block"></span>\n            <input name="backgroundColor" type="hidden">\n          </span>\n        </span>\n      </div>\n      <label class="babel-container">\n        <span>').concat(iC("tableModule.modal.align"), '</span>\n        <span class="babel-container-align">\n          <select name="textAlign">\n            ').concat(this.textAlignOptions.map(function(e12) {
      return '<option value="'.concat(e12.value, '">').concat(e12.label, "</option>");
    }).join(""), '\n          </select>\n        </span>\n      </label>\n      <div class="button-container">\n        <button type="button">').concat(iC("tableModule.modal.ok"), "</button>\n      </div>\n    </div>"));
    a2.find("[name]").each(function(e12) {
      fm(e12).val(o2[fm(e12).attr("name")]);
    });
    var s2 = function(e12, t3) {
      t3 ? fm(".color-group-block", e12).css("background-color", t3).empty() : fm(".color-group-block", e12).css("background-color", "").html(UB);
    };
    return a2.find(".color-group").each(function(n3) {
      var r4 = fm('[type="hidden"]', n3).val() || "";
      s2(n3, r4);
      var o3 = fm(n3);
      o3.on("click", function() {
        a2.find(".color-group .w-e-drop-panel").hide();
        var i3 = o3.data("panel");
        i3 ? i3.show() : (i3 = t2.getPanelContentElem(e11, { mark: o3.data("mark"), selectedColor: r4, callback: function(e12) {
          fm('[type="hidden"]', n3).val(e12 || ""), s2(n3, e12), i3.hide();
        } }), o3.append(i3), o3.data("panel", i3));
      });
    }), a2.find("button").on("click", function() {
      var n3 = Array.from(a2.find("[name]")).reduce(function(e12, t3) {
        return e12[fm(t3).attr("name")] = fm(t3).val(), e12;
      }, {}), r4 = ZB.get(e11);
      "cell" === t2.menu && (null == r4 ? void 0 : r4.length) ? r4.forEach(function(t3) {
        t3.forEach(function(t4) {
          Wg.setNodes(e11, n3, { at: t4[0][1] });
        });
      }) : Wg.setNodes(e11, n3, { at: i2 }), setTimeout(function() {
        e11.focus();
      });
    }), a2[0];
  }, e10.prototype.getPanelContentElem = function(e11, t2) {
    var n2 = t2.mark, r3 = t2.selectedColor, o2 = t2.callback, i2 = fm('<ul class="w-e-panel-content-color"></ul>');
    i2.on("click", "li", function(e12) {
      var t3 = e12.target;
      if (t3) {
        e12.preventDefault(), e12.stopPropagation();
        var n3 = fm(t3).attr("data-value");
        o2(n3);
      }
    });
    var a2 = e11.getMenuConfig(n2).colors;
    (void 0 === a2 ? [] : a2).forEach(function(e12) {
      var t3 = fm('<div class="color-block" data-value="'.concat(e12, '"></div>'));
      t3.css("background-color", e12);
      var n3 = fm('<li data-value="'.concat(e12, '"></li>'));
      r3 === e12 && n3.addClass("active"), n3.append(t3), i2.append(n3);
    });
    var s2 = "";
    "color" === n2 && (s2 = iC("tableModule.color.default")), "bgColor" === n2 && (s2 = iC("tableModule.color.clear"));
    var u2 = fm('\n      <li data-value="" class="clear">\n        '.concat(UB, "\n        ").concat(s2, "\n      </li>\n    "));
    i2.prepend(u2);
    var l2 = fm('<div class="w-e-drop-panel"></div>');
    return l2.append(i2), l2;
  }, e10;
}(), eT = function(e10) {
  function t2() {
    var t3 = e10.apply(this, av([], iv(arguments), false)) || this;
    return t3.title = iC("tableModule.cellProperty"), t3.iconSvg = '<svg viewBox="0 0 20 20"><path d="m11.105 18-.17 1H2.5A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1h15A1.5 1.5 0 0 1 19 2.5v9.975l-.85-.124-.15-.302V8h-5v4h.021l-.172.351-1.916.28-.151.027c-.287.063-.54.182-.755.341L8 13v5h3.105zM2 12h5V8H2v4zm10-4H8v4h4V8zM2 2v5h5V2H2zm0 16h5v-5H2v5zM13 7h5V2h-5v5zM8 2v5h4V2H8z" opacity=".6"/><path d="m15.5 11.5 1.323 2.68 2.957.43-2.14 2.085.505 2.946L15.5 18.25l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L15.5 11.5zM13 6a1 1 0 0 1 1 1v3.172a2.047 2.047 0 0 0-.293.443l-.858 1.736-1.916.28-.151.027A1.976 1.976 0 0 0 9.315 14H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm-1 2H8v4h4V8z"/></svg>', t3.tag = "button", t3.showModal = true, t3.modalWidth = 300, t3.menu = "cell", t3;
  }
  return ev(t2, e10), t2.prototype.getModalContentNode = function(e11) {
    return iv(eg.nodes(e11, { match: WB(e11, "td") }), 1)[0];
  }, t2;
}(QB), tT = function() {
  function e10() {
    this.title = iC("tableModule.deleteCol"), this.iconSvg = '<svg viewBox="0 0 1048 1024"><path d="M327.68 510.976L393.216 445.44v-13.1072L327.68 366.7968V510.976z m327.68-78.4384l65.536-65.536V507.904L655.36 442.368v-9.8304z m393.216 484.9664V0H0v917.504h1048.576z m-65.536-131.072h-262.144v-52.4288l-13.1072 13.1072-52.4288-52.4288v91.7504H393.216v-91.7504l-52.4288 52.4288-13.1072-13.1072v52.4288H65.536V65.536H327.68v121.2416l36.0448-36.0448 29.4912 29.4912V62.2592h262.144V180.224l49.152-49.152 16.384 16.384V62.2592h262.144V786.432z m-294.912-108.1344l-160.5632-160.5632-167.1168 167.1168-78.6432-78.6432 167.1168-167.1168L288.3584 278.528l78.6432-78.6432 160.5632 160.5632 163.84-163.84 78.6432 78.6432-163.84 163.84 160.5632 160.5632-78.6432 78.6432z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "table-cell"));
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = iv(eg.nodes(e11, { match: function(e12) {
        return zy.checkNodeType(e12, "table-cell");
      }, universal: true }), 1), r3 = iv(n2[0], 2), o2 = r3[0], i2 = r3[1], a2 = zy.getParentNode(e11, o2), s2 = (null == a2 ? void 0 : a2.children.length) || 0;
      if (!a2 || s2 <= 1) Wg.removeNodes(e11, { mode: "highest" });
      else if (null != zy.getParentNode(e11, a2)) {
        var u2 = qB(e11), l2 = 0;
        e: for (var c3 = 0; c3 < u2.length; c3 += 1) for (var d2 = 0; d2 < u2[c3].length; d2 += 1) {
          var f2 = iv(u2[c3][d2], 1), p2 = iv(f2[0], 2)[1];
          if (cg.equals(i2, p2)) {
            l2 = d2;
            break e;
          }
        }
        eg.withoutNormalizing(e11, function() {
          for (var t3, n3, r4 = /* @__PURE__ */ new Set(), o3 = /* @__PURE__ */ new Set(), i3 = 0; i3 < u2.length; i3 += 1) if (u2[i3] && u2[i3][l2]) {
            var a3 = iv(u2[i3][l2], 2), s3 = iv(a3[0], 2)[1], c4 = a3[1], d3 = c4.rtl, f3 = c4.ltr, p3 = c4.ttb, h2 = c4.btt, g2 = s3.join(",");
            if (d3 > 1 || f3 > 1 || p3 > 1 || h2 > 1) {
              var v2 = i3 - (p3 - 1), m2 = l2 - (d3 - 1);
              if (v2 < 0 || v2 >= u2.length || !u2[v2] || !u2[v2][m2]) continue;
              var y2 = iv(u2[v2][m2], 1), b2 = iv(y2[0], 2), E2 = b2[0], C2 = b2[1], w2 = C2.join(",");
              if (!o3.has(w2)) {
                o3.add(w2);
                var D2 = E2.rowSpan, S2 = void 0 === D2 ? 1 : D2, A2 = E2.colSpan, x2 = void 0 === A2 ? 1 : A2, O2 = Math.max(x2 - 1, 1);
                Wg.setNodes(e11, { rowSpan: S2, colSpan: O2 }, { at: C2 });
              }
            } else r4.add(g2);
          }
          var N2 = Array.from(r4);
          N2.sort(function(e12, t4) {
            var n4 = e12.split(",").map(Number), r5 = t4.split(",").map(Number);
            return n4[n4.length - 2] !== r5[r5.length - 2] ? r5[r5.length - 2] - n4[n4.length - 2] : r5[r5.length - 1] - n4[n4.length - 1];
          });
          try {
            for (var B2 = ov(N2), T2 = B2.next(); !T2.done; T2 = B2.next()) {
              var k2 = T2.value.split(",").map(Number);
              try {
                eg.hasPath(e11, k2) && Wg.removeNodes(e11, { at: k2 });
              } catch (e12) {
                console.warn("删除单元格失败:", k2, e12);
              }
            }
          } catch (e12) {
            t3 = { error: e12 };
          } finally {
            try {
              T2 && !T2.done && (n3 = B2.return) && n3.call(B2);
            } finally {
              if (t3) throw t3.error;
            }
          }
          var F2 = iv(eg.nodes(e11, { match: function(e12) {
            return zy.checkNodeType(e12, "table");
          }, universal: true }), 1), I2 = F2[0];
          if (I2) {
            var P2 = iv(I2, 2), _2 = P2[0], R2 = P2[1], L2 = _2.columnWidths, M2 = av([], iv(void 0 === L2 ? [] : L2), false);
            M2.splice(l2, 1), Wg.setNodes(e11, { columnWidths: M2 }, { at: R2 });
          }
        });
      }
    }
  }, e10;
}(), nT = function() {
  function e10() {
    this.title = iC("tableModule.deleteRow"), this.iconSvg = '<svg viewBox="0 0 1048 1024"><path d="M907.6736 586.5472L747.1104 425.984l163.84-163.84-78.6432-78.6432-163.84 163.84L507.904 186.7776 429.2608 262.144l163.84 163.84-167.1168 167.1168 78.6432 78.6432 167.1168-167.1168 160.5632 160.5632 75.3664-78.6432zM0 917.504V0h1048.576v917.504H0z m983.04-327.68h-22.9376l-65.536-65.536H983.04V327.68h-91.7504l65.536-65.536h26.2144V65.536H65.536v196.608h317.8496l65.536 65.536H65.536v196.608h380.1088l-65.536 65.536H65.536v196.608H983.04v-196.608z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "table-row"));
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = iv(eg.nodes(e11, { match: function(e12) {
        return zy.checkNodeType(e12, "table-row");
      }, universal: true }), 1), r3 = iv(n2[0], 2), o2 = r3[0], i2 = r3[1], a2 = zy.getParentNode(e11, o2);
      if (((null == a2 ? void 0 : a2.children.length) || 0) <= 1) Wg.removeNodes(e11, { mode: "highest" });
      else {
        var s2 = iv(eg.nodes(e11, { match: function(e12) {
          return zy.checkNodeType(e12, "table-cell");
        }, universal: true }), 1), u2 = iv(s2[0], 2)[1], l2 = qB(e11), c3 = 0;
        e: for (var d2 = 0; d2 < l2.length; d2 += 1) for (var f2 = 0; f2 < l2[d2].length; f2 += 1) {
          var p2 = iv(l2[d2][f2], 1), h2 = iv(p2[0], 2)[1];
          if (cg.equals(u2, h2)) {
            c3 = d2;
            break e;
          }
        }
        eg.withoutNormalizing(e11, function() {
          for (var t3, n3, r4 = [], o3 = 0; o3 < l2[c3].length; o3 += 1) {
            var a3 = iv(l2[c3][o3], 2), s3 = iv(a3[0], 1)[0].hidden, u3 = a3[1], d3 = u3.ttb, f3 = u3.btt, p3 = u3.rtl;
            if (d3 > 1 || f3 > 1) {
              var h3 = c3 - (d3 - 1);
              if (h3 < 0 || h3 >= l2.length || !l2[h3] || !l2[h3][o3]) continue;
              var g2 = iv(l2[h3][o3], 1), v2 = iv(g2[0], 2), m2 = v2[0], y2 = v2[1], b2 = m2, E2 = b2.rowSpan, C2 = void 0 === E2 ? 1 : E2, w2 = b2.colSpan, D2 = void 0 === w2 ? 1 : w2;
              if (s3) Wg.setNodes(e11, { rowSpan: Math.max(C2 - 1, 1), colSpan: D2 }, { at: y2 });
              else if (1 === d3 && 1 === p3) {
                if (c3 + 1 < l2.length && C2 > 1) {
                  var S2 = { type: "table-cell", rowSpan: C2 - 1, colSpan: D2, hidden: false, children: b2.children.map(function(e12) {
                    return tv({}, e12);
                  }) };
                  b2.isHeader && (S2.isHeader = b2.isHeader), b2.width && (S2.width = b2.width), b2.backgroundColor && (S2.backgroundColor = b2.backgroundColor), b2.borderWidth && (S2.borderWidth = b2.borderWidth), b2.borderStyle && (S2.borderStyle = b2.borderStyle), b2.borderColor && (S2.borderColor = b2.borderColor), b2.textAlign && (S2.textAlign = b2.textAlign), r4.push({ cell: S2, columnIndex: o3 });
                } else Wg.setNodes(e11, { rowSpan: Math.max(C2 - 1, 1), colSpan: D2 }, { at: y2 });
              } else Wg.setNodes(e11, { rowSpan: Math.max(C2 - 1, 1), colSpan: D2 }, { at: y2 });
            }
          }
          if (Wg.removeNodes(e11, { at: i2 }), r4.length > 0) {
            var A2 = i2;
            try {
              r4.sort(function(e12, t4) {
                return e12.columnIndex - t4.columnIndex;
              });
              try {
                for (var x2 = ov(r4), O2 = x2.next(); !O2.done; O2 = x2.next()) {
                  var N2 = O2.value, B2 = N2.cell, T2 = N2.columnIndex;
                  try {
                    var k2 = av(av([], iv(A2), false), [T2], false);
                    Wg.insertNodes(e11, B2, { at: k2 });
                  } catch (t4) {
                    try {
                      var F2 = iv(eg.node(e11, A2), 1)[0].children.length, I2 = av(av([], iv(A2), false), [F2], false);
                      Wg.insertNodes(e11, B2, { at: I2 });
                    } catch (e12) {
                      console.warn("插入新单元格失败:", e12);
                    }
                  }
                }
              } catch (e12) {
                t3 = { error: e12 };
              } finally {
                try {
                  O2 && !O2.done && (n3 = x2.return) && n3.call(x2);
                } finally {
                  if (t3) throw t3.error;
                }
              }
            } catch (e12) {
              console.warn("插入新单元格失败:", e12);
            }
          }
        });
      }
    }
  }, e10;
}(), rT = function() {
  function e10() {
    this.title = iC("tableModule.deleteTable"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M826.8032 356.5312c-19.328 0-36.3776 15.6928-36.3776 35.0464v524.2624c0 19.328-16 34.56-35.328 34.56H264.9344c-19.328 0-35.5072-15.3088-35.5072-34.56V390.0416c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.6928-33.5104 35.0464V915.712c0 57.9328 44.6208 108.288 102.528 108.288H755.2c57.9328 0 108.0832-50.4576 108.0832-108.288V391.4752c-0.1024-19.2512-17.1264-34.944-36.48-34.944z" p-id="9577"></path><path d="M437.1712 775.7568V390.6048c0-19.328-14.1568-35.0464-33.5104-35.0464s-33.5104 15.616-33.5104 35.0464v385.152c0 19.328 14.1568 35.0464 33.5104 35.0464s33.5104-15.7184 33.5104-35.0464zM649.7024 775.7568V390.6048c0-19.328-17.0496-35.0464-36.3776-35.0464s-36.3776 15.616-36.3776 35.0464v385.152c0 19.328 17.0496 35.0464 36.3776 35.0464s36.3776-15.7184 36.3776-35.0464zM965.0432 217.0368h-174.6176V145.5104c0-57.9328-47.2064-101.76-104.6528-101.76h-350.976c-57.8304 0-105.3952 43.8528-105.3952 101.76v71.5264H54.784c-19.4304 0-35.0464 14.1568-35.0464 33.5104 0 19.328 15.616 33.5104 35.0464 33.5104h910.3616c19.328 0 35.0464-14.1568 35.0464-33.5104 0-19.3536-15.6928-33.5104-35.1488-33.5104z m-247.3728 0H297.3952V145.5104c0-19.328 18.2016-34.7648 37.4272-34.7648h350.976c19.1488 0 31.872 15.1296 31.872 34.7648v71.5264z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == zy.getSelectedNodeByType(e11, "table");
  }, e10.prototype.exec = function(e11, t2) {
    this.isDisabled(e11) || Wg.removeNodes(e11, { mode: "highest" });
  }, e10;
}(), oT = function() {
  function e10() {
    this.title = iC("tableModule.widthAuto"), this.iconSvg = '<svg viewBox="0 0 1228 1024"><path d="M862.514337 563.200461H404.581995v121.753478a13.311987 13.311987 0 0 1-6.655993 11.468789 10.23999 10.23999 0 0 1-12.083188-1.433599l-204.799795-179.199821a13.721586 13.721586 0 0 1 0-20.479979l204.799795-179.302221a10.23999 10.23999 0 0 1 12.185588-1.535998 13.209587 13.209587 0 0 1 6.553593 11.673588v115.097485h457.932342V319.693504a11.571188 11.571188 0 0 1 18.841582-10.239989l204.799795 179.19982a13.721586 13.721586 0 0 1 0 20.47998l-204.799795 179.199821a10.23999 10.23999 0 0 1-12.185588 1.535998 13.311987 13.311987 0 0 1-6.655994-11.571188V563.200461zM136.499064 14.951409v993.893406a15.257585 15.257585 0 0 1-15.155185 15.052785H15.155185A15.155185 15.155185 0 0 1 0 1008.844815V14.951409a15.257585 15.257585 0 0 1 15.155185-15.052785h106.086294a15.155185 15.155185 0 0 1 15.257585 15.155185zM1228.798771 14.951409v993.893406a15.257585 15.257585 0 0 1-15.155185 15.052785h-106.188693a15.155185 15.155185 0 0 1-15.155185-15.052785V14.951409a15.257585 15.257585 0 0 1 15.155185-15.052785h106.086293A15.155185 15.155185 0 0 1 1228.798771 15.053809z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return false;
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "table"));
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = zy.getSelectedNodeByType(e11, "table");
      if (n2) {
        var r3 = n2.columnWidths, o2 = void 0 === r3 ? [] : r3, i2 = zy.toDOMNode(e11, n2).querySelector(".table-container");
        if (i2 && 0 !== o2.length) {
          var a2 = i2.clientWidth, s2 = o2.reduce(function(e12, t3) {
            return e12 + t3;
          }, 0), u2 = o2.map(function(e12) {
            var t3 = e12 / s2;
            return Math.floor(t3 * a2);
          }), l2 = e11.getMenuConfig("insertTable").minWidth, c3 = parseInt(String(void 0 === l2 ? 60 : l2), 10) || 60, d2 = u2.map(function(e12) {
            return Math.max(c3, e12);
          }), f2 = d2.reduce(function(e12, t3) {
            return e12 + t3;
          }, 0);
          if (f2 > a2) {
            var p2 = a2 / f2, h2 = d2.map(function(e12) {
              return Math.max(c3, Math.floor(e12 * p2));
            });
            v2 = { width: "auto", columnWidths: h2 };
            Wg.setNodes(e11, v2, { mode: "highest" });
          } else {
            h2 = av([], iv(d2), false);
            var g2 = a2 - f2 - 1;
            g2 > 0 && h2.length > 0 && (h2[h2.length - 1] += g2);
            v2 = { width: "auto", columnWidths: h2 };
            Wg.setNodes(e11, v2, { mode: "highest" });
          }
        } else {
          var v2 = { width: "auto" };
          Wg.setNodes(e11, v2, { mode: "highest" });
        }
      }
    }
  }, e10;
}();
function iT(e10) {
  var t2 = e10.children || [];
  return 0 === t2.length ? [] : (t2[0] || {}).children || [];
}
function aT(e10) {
  return iT(e10).every(function(e11) {
    return !!e11.isHeader;
  });
}
var sT = function() {
  function e10() {
    this.title = iC("tableModule.insertCol"), this.iconSvg = '<svg viewBox="0 0 1048 1024"><path d="M327.68 193.3312v186.7776H140.9024v91.7504H327.68v186.7776h88.4736V471.8592h190.0544V380.1088H416.1536V193.3312zM0 917.504V0h1048.576v917.504H0zM655.36 65.536H65.536v720.896H655.36V65.536z m327.68 0h-262.144v196.608h262.144V65.536z m0 262.144h-262.144v196.608h262.144V327.68z m0 262.144h-262.144v196.608h262.144v-196.608z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    if (null == t2) return true;
    if (!yg.isCollapsed(t2)) return true;
    var n2 = zy.getSelectedNodeByType(e11, "table");
    if (null == n2) return true;
    try {
      var r3 = iv(eg.nodes(e11, { match: function(e12) {
        return zy.checkNodeType(e12, "table-cell");
      }, universal: true }), 1), o2 = r3[0];
      if (!o2) return true;
      for (var i2 = iv(o2, 2)[1], a2 = qB(e11), s2 = -1, u2 = 0; u2 < a2.length; u2 += 1) {
        for (var l2 = 0; l2 < a2[u2].length; l2 += 1) {
          var c3 = iv(a2[u2][l2], 1), d2 = iv(c3[0], 2)[1];
          if (cg.equals(i2, d2)) {
            s2 = l2;
            break;
          }
        }
        if (-1 !== s2) break;
      }
      if (-1 === s2) return true;
      var f2 = n2.columnWidths, p2 = (void 0 === f2 ? [] : f2)[s2];
      if (p2 && p2 < 20) return true;
    } catch (e12) {
      return true;
    }
    return false;
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = iv(eg.nodes(e11, { match: function(e12) {
        return zy.checkNodeType(e12, "table-cell");
      }, universal: true }), 1), r3 = iv(n2[0], 2), o2 = r3[0], i2 = r3[1], a2 = zy.getParentNode(e11, o2);
      if (null != a2) {
        var s2 = zy.getParentNode(e11, a2);
        if (null != s2) {
          for (var u2 = qB(e11), l2 = 0, c3 = 0; c3 < u2.length; c3 += 1) for (var d2 = 0; d2 < u2[c3].length; d2 += 1) {
            var f2 = iv(u2[c3][d2], 1), p2 = iv(f2[0], 2)[1];
            if (cg.equals(i2, p2)) {
              l2 = d2;
              break;
            }
          }
          eg.withoutNormalizing(e11, function() {
            for (var t3 = /* @__PURE__ */ new Set(), n3 = /* @__PURE__ */ new Set(), r4 = 0; r4 < u2.length; r4 += 1) if (u2[r4] && u2[r4][l2]) {
              var o3 = iv(u2[r4][l2], 2);
              iv(o3[0], 1);
              var i3 = o3[1], a3 = i3.rtl, c4 = i3.ltr, d3 = i3.ttb, f3 = i3.btt;
              if (a3 > 1 || c4 > 1 || d3 > 1 || f3 > 1) {
                var p3 = r4 - (d3 - 1), h2 = l2 - (a3 - 1);
                if (p3 < 0 || p3 >= u2.length || !u2[p3] || !u2[p3][h2]) continue;
                var g2 = iv(u2[p3][h2], 1), v2 = iv(g2[0], 2), m2 = v2[0], y2 = v2[1], b2 = y2.join(",");
                if (t3.has(b2)) n3.add(r4);
                else {
                  t3.add(b2);
                  var E2 = m2.rowSpan, C2 = void 0 === E2 ? 1 : E2, w2 = m2.colSpan, D2 = (void 0 === w2 ? 1 : w2) + 1;
                  m2.hidden || Wg.setNodes(e11, { colSpan: D2 }, { at: y2 });
                  for (var S2 = 0; S2 < C2; S2 += 1) n3.add(p3 + S2);
                }
              }
            }
            for (r4 = 0; r4 < u2.length; r4 += 1) if (!n3.has(r4) && u2[r4] && u2[r4][l2]) {
              var A2 = { type: "table-cell", children: [{ text: "" }] };
              0 === r4 && aT(s2) && (A2.isHeader = true);
              var x2 = iv(u2[r4][l2], 1), O2 = iv(x2[0], 2)[1];
              Wg.insertNodes(e11, A2, { at: O2 });
            }
            var N2 = iv(eg.nodes(e11, { match: function(e12) {
              return zy.checkNodeType(e12, "table");
            }, universal: true }), 1), B2 = N2[0];
            if (B2) {
              var T2 = iv(B2, 2), k2 = T2[0], F2 = T2[1], I2 = k2.columnWidths, P2 = void 0 === I2 ? [] : I2, _2 = av([], iv(P2), false), R2 = e11.getMenuConfig("insertTable").minWidth, L2 = void 0 === R2 ? 60 : R2, M2 = P2[l2] || parseInt(L2, 10) || 60, j2 = Math.floor(M2 / 2), H2 = M2 - j2;
              _2.splice(l2, 0, j2), _2[l2 + 1] = H2, Wg.setNodes(e11, { columnWidths: _2 }, { at: F2 });
            }
          });
        }
      }
    }
  }, e10;
}(), uT = function() {
  function e10() {
    this.title = iC("tableModule.insertRow"), this.iconSvg = '<svg viewBox="0 0 1048 1024"><path d="M707.7888 521.0112h-147.456v-147.456H488.2432v147.456h-147.456v68.8128h147.456v147.456h72.0896v-147.456h147.456zM0 917.504V0h1048.576v917.504H0zM327.68 65.536H65.536v196.608H327.68V65.536z m327.68 0H393.216v196.608h262.144V65.536z m327.68 0h-262.144v196.608h262.144V65.536z m0 258.8672H65.536v462.0288H983.04V324.4032z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "table"));
  }, e10.prototype.exec = function(e11, t2) {
    var n2;
    if (!this.isDisabled(e11)) {
      var r3 = iv(eg.nodes(e11, { match: function(e12) {
        return zy.checkNodeType(e12, "table-cell");
      }, universal: true }), 1), o2 = iv(r3[0], 2)[1], i2 = qB(e11), a2 = 0;
      e: for (var s2 = 0; s2 < i2.length; s2 += 1) for (var u2 = 0; u2 < i2[s2].length; u2 += 1) {
        var l2 = iv(i2[s2][u2], 1), c3 = iv(l2[0], 2)[1];
        if (cg.equals(o2, c3)) {
          a2 = s2;
          break e;
        }
      }
      var d2 = (null === (n2 = i2[a2]) || void 0 === n2 ? void 0 : n2.length) || 0;
      0 !== d2 && eg.withoutNormalizing(e11, function() {
        for (var t3 = a2 + 1, n3 = t3 >= 0 && t3 < i2.length, r4 = [], s3 = 0; n3 && s3 < i2[a2].length; s3 += 1) {
          var u3 = iv(i2[a2][s3], 2)[1], l3 = u3.ttb, c4 = u3.btt;
          if (l3 > 1 || c4 > 1) {
            var f2 = a2 - (l3 - 1);
            if (f2 < 0 || f2 >= i2.length || !i2[f2] || !i2[f2][s3]) continue;
            var p2 = iv(i2[f2][s3], 1), h2 = iv(p2[0], 2), g2 = h2[0], v2 = h2[1], m2 = g2.rowSpan || 1;
            r4.push(s3), g2.hidden || Wg.setNodes(e11, { rowSpan: m2 + 1 }, { at: v2 });
          }
        }
        for (var y2 = (e11.getMenuConfig("insertTable") || {}).minRowHeight, b2 = { type: "table-row", children: [], height: parseInt((void 0 === y2 ? 30 : y2).toString(), 10) || 30 }, E2 = 0; E2 < d2; E2 += 1) if (!r4.includes(E2)) {
          b2.children.push({ type: "table-cell", children: [{ text: "" }] });
        }
        var C2 = cg.parent(o2), w2 = cg.next(C2);
        Wg.insertNodes(e11, b2, { at: w2 });
      });
    }
  }, e10;
}();
var lT = function() {
  function e10() {
    this.title = iC("tableModule.insertTable"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M0 64v896h1024V64H0z m384 576v-192h256v192h-256z m256 64v192h-256v-192h256z m0-512v192h-256V192h256zM320 192v192H64V192h256z m-256 256h256v192H64v-192z m640 0h256v192h-256v-192z m0-64V192h256v192h-256zM64 704h256v192H64v-192z m640 192v-192h256v192h-256z"></path></svg>', this.tag = "button", this.showDropPanel = true, this.$content = null;
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || !!zy.getSelectedElems(e11).some(function(t3) {
      var n2 = zy.getNodeType(t3);
      return "pre" === n2 || ("table" === n2 || ("list-item" === n2 || !!e11.isVoid(t3)));
    }));
  }, e10.prototype.getPanelContentElem = function(e11) {
    var t2 = this;
    if (this.$content) return this.$content[0];
    for (var n2 = fm('<div class="w-e-panel-content-table"></div>'), r3 = fm("<span>0 &times; 0</span>"), o2 = fm("<table></table>"), i2 = 0; i2 < 10; i2 += 1) {
      for (var a2 = fm("<tr></tr>"), s2 = 0; s2 < 10; s2 += 1) {
        var u2 = fm("<td></td>");
        u2.attr("data-x", s2.toString()), u2.attr("data-y", i2.toString()), a2.append(u2), u2.on("mouseenter", function(e12) {
          var t3 = e12.target;
          if (null != t3) {
            var n3 = fm(t3).dataset(), i3 = n3.x, a3 = n3.y;
            r3[0].innerHTML = "".concat(i3 + 1, " &times; ").concat(a3 + 1), o2.children().each(function(e13) {
              fm(e13).children().each(function(e14) {
                var t4 = fm(e14), n4 = t4.dataset(), r4 = n4.x, o3 = n4.y;
                r4 <= i3 && o3 <= a3 ? t4.addClass("active") : t4.removeClass("active");
              });
            });
          }
        }), u2.on("click", function(n3) {
          n3.preventDefault();
          var r4 = n3.target;
          if (null != r4) {
            var o3 = fm(r4).dataset(), i3 = o3.x, a3 = o3.y;
            t2.insertTable(e11, a3 + 1, i3 + 1);
          }
        });
      }
      o2.append(a2);
    }
    return n2.append(o2), n2.append(r3), this.$content = n2, n2[0];
  }, e10.prototype.insertTable = function(e11, t2, n2) {
    var r3 = parseInt(t2, 10), o2 = parseInt(n2, 10);
    if (r3 && o2 && !(r3 <= 0 || o2 <= 0)) {
      if (zy.isSelectedEmptyParagraph(e11) && Wg.removeNodes(e11, { mode: "highest" }), 0 === e11.children.length) {
        Wg.insertNodes(e11, { type: "paragraph", children: [{ text: "" }] }, { mode: "highest" });
      }
      var i2 = function(e12, t3, n3) {
        for (var r4, o3 = [], i3 = e12.getMenuConfig("insertTable"), a2 = i3.minWidth, s2 = void 0 === a2 ? 60 : a2, u2 = i3.minRowHeight, l2 = void 0 === u2 ? 30 : u2, c3 = i3.tableFullWidth, d2 = i3.tableHeader, f2 = Array(n3).fill(parseInt(s2, 10) || 60), p2 = 0; p2 < t3; p2 += 1) {
          for (var h2 = [], g2 = 0; g2 < n3; g2 += 1) {
            var v2 = { type: "table-cell", children: [{ text: "" }] };
            0 === p2 && (v2.isHeader = null === (r4 = null == d2 ? void 0 : d2.selected) || void 0 === r4 || r4), h2.push(v2);
          }
          o3.push({ type: "table-row", children: h2, height: parseInt(l2, 10) || 30 });
        }
        return { type: "table", width: (null == c3 ? void 0 : c3.selected) ? "100%" : "auto", children: o3, columnWidths: f2 };
      }(e11, r3, o2);
      Wg.insertNodes(e11, i2, { mode: "highest" });
    }
  }, e10;
}(), cT = { isInTable: function(e10, t2) {
  return void 0 === t2 && (t2 = {}), !!iv(eg.nodes(e10, { match: WB(e10, "table"), at: t2.at }), 1)[0];
}, selection: function(e10) {
  var t2, n2, r3, o2, i2, a2, s2, u2;
  return rv(this, function(l2) {
    switch (l2.label) {
      case 0:
        t2 = ZB.get(e10), n2 = 0, l2.label = 1;
      case 1:
        if (!(t2 && n2 < t2.length)) return [3, 4];
        for (r3 = [], o2 = 0; o2 < t2[n2].length; o2 += 1) i2 = iv(t2[n2][o2], 2), a2 = i2[0], s2 = i2[1], u2 = s2.ltr, 1 === s2.ttb && r3.push(a2), o2 += u2 - 1;
        return [4, r3];
      case 2:
        l2.sent(), l2.label = 3;
      case 3:
        return n2 += 1, [3, 1];
      case 4:
        return [2];
    }
  });
}, unselect: function(e10) {
  JB.delete(e10), ZB.delete(e10);
}, isSelected: function(e10, t2) {
  var n2 = JB.get(e10);
  return !!n2 && n2.has(t2);
}, hasSelected: function(e10) {
  return ZB.has(e10);
} }, dT = function() {
  function e10() {
    this.title = iC("tableModule.mergeCell"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M482.2 508.4 331.3 389c-3-2.4-7.3-.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"/></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return !this.canMerge(e11);
  }, e10.prototype.exec = function(e11, t2) {
    this.isDisabled(e11) || (this.merge(e11), cT.unselect(e11));
  }, e10.prototype.canMerge = function(e11) {
    var t2 = ZB.get(e11);
    if (!t2 || !t2.length) return false;
    var n2 = iv(t2[t2.length - 1][t2[t2.length - 1].length - 1], 1), r3 = iv(n2[0], 2)[1], o2 = iv(t2[0][0], 1);
    return !!GB(e11, [iv(o2[0], 2)[1], r3], "table");
  }, e10.prototype.merge = function(e11) {
    if (this.canMerge(e11)) {
      var t2 = ZB.get(e11);
      if (t2 && t2.length) {
        var n2 = iv(t2[0][0], 1), r3 = iv(n2[0], 2)[1], o2 = iv(ag.children(e11, r3, { reverse: true }), 1), i2 = iv(o2[0], 2)[1];
        eg.withoutNormalizing(e11, function() {
          for (var n3, o3, a2, s2, u2, l2, c3 = /* @__PURE__ */ new Map(), d2 = [], f2 = 1 / 0, p2 = -1 / 0, h2 = 1 / 0, g2 = -1 / 0, v2 = 0; v2 < t2.length; v2 += 1) for (var m2 = 0; m2 < t2[v2].length; m2 += 1) {
            var y2 = iv(t2[v2][m2], 2), b2 = iv(y2[0], 2), E2 = b2[0], C2 = b2[1], w2 = y2[1].ttb, D2 = C2.join(",");
            if (1 === w2 && !c3.has(D2)) {
              c3.set(D2, { path: C2, x: v2, y: m2, element: E2 });
              var S2 = E2.rowSpan, A2 = void 0 === S2 ? 1 : S2, x2 = E2.colSpan, O2 = v2, N2 = v2 + A2 - 1, B2 = m2, T2 = m2 + (void 0 === x2 ? 1 : x2) - 1;
              f2 = Math.min(f2, O2), p2 = Math.max(p2, N2), h2 = Math.min(h2, B2), g2 = Math.max(g2, T2);
            }
          }
          var k2 = p2 - f2 + 1, F2 = g2 - h2 + 1;
          try {
            for (var I2 = ov(c3), P2 = I2.next(); !P2.done; P2 = I2.next()) {
              C2 = iv(P2.value, 2)[1].path;
              cg.equals(r3, C2) || d2.push(C2);
            }
          } catch (e12) {
            n3 = { error: e12 };
          } finally {
            try {
              P2 && !P2.done && (o3 = I2.return) && o3.call(I2);
            } finally {
              if (n3) throw n3.error;
            }
          }
          d2.sort(function(e12, t3) {
            for (var n4 = 0; n4 < Math.min(e12.length, t3.length); n4 += 1) if (e12[n4] !== t3[n4]) return t3[n4] - e12[n4];
            return t3.length - e12.length;
          });
          try {
            for (var _2 = ov(d2), R2 = _2.next(); !R2.done; R2 = _2.next()) {
              C2 = R2.value;
              try {
                if (!eg.hasPath(e11, C2)) continue;
                try {
                  for (var L2 = (u2 = void 0, ov(ag.children(e11, C2, { reverse: true }))), M2 = L2.next(); !M2.done; M2 = L2.next()) {
                    var j2 = iv(M2.value, 2)[1];
                    Wg.moveNodes(e11, { to: cg.next(i2), at: j2 });
                  }
                } catch (e12) {
                  u2 = { error: e12 };
                } finally {
                  try {
                    M2 && !M2.done && (l2 = L2.return) && l2.call(L2);
                  } finally {
                    if (u2) throw u2.error;
                  }
                }
                Wg.removeNodes(e11, { at: C2 });
              } catch (e12) {
              }
            }
          } catch (e12) {
            a2 = { error: e12 };
          } finally {
            try {
              R2 && !R2.done && (s2 = _2.return) && s2.call(_2);
            } finally {
              if (a2) throw a2.error;
            }
          }
          Wg.setNodes(e11, { rowSpan: k2, colSpan: F2 }, { at: r3 });
        });
      }
    }
  }, e10;
}(), fT = function() {
  function e10() {
    this.title = iC("tableModule.splitCell"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M362.667 494.933v53.334l25.6-25.6zm0-241.066L460.8 352V78.933H57.6v98.134h305.067zm0 535.466v57.6H57.6v98.134h403.2V691.2zM661.333 494.933v53.334l-25.6-25.6zm0-241.066L563.2 352V78.933h403.2v98.134H661.333zm0 535.466v57.6H966.4v98.134H563.2V691.2z"/><path d="M753.067 341.333 693.333 281.6 512 460.8 330.667 281.6l-59.734 59.733 181.334 181.334L270.933 704l59.734 59.733L512 582.4l181.333 181.333L753.067 704 571.733 522.667z"/></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = iv(eg.nodes(e11, { match: function(e12) {
      return zy.checkNodeType(e12, "table-cell");
    } }), 1), n2 = t2[0];
    if (!n2) return true;
    var r3 = iv(n2, 1)[0], o2 = r3.rowSpan, i2 = void 0 === o2 ? 1 : o2, a2 = r3.colSpan;
    return !(i2 > 1 || (void 0 === a2 ? 1 : a2) > 1);
  }, e10.prototype.exec = function(e11, t2) {
    this.isDisabled(e11) || this.split(e11);
  }, e10.prototype.split = function(e11, t2) {
    void 0 === t2 && (t2 = {});
    var n2 = iv(eg.nodes(e11, { match: WB(e11, "table", "th", "td"), at: t2.at }), 2), r3 = n2[0], o2 = n2[1];
    if (r3 && o2) {
      var i2 = aT(iv(r3, 1)[0]), a2 = iv(o2, 2), s2 = a2[0], u2 = a2[1], l2 = s2.rowSpan, c3 = void 0 === l2 ? 1 : l2, d2 = s2.colSpan, f2 = void 0 === d2 ? 1 : d2;
      1 === c3 && 1 === f2 || eg.withoutNormalizing(e11, function() {
        Wg.setNodes(e11, { rowSpan: 1, colSpan: 1 }, { at: u2 });
        for (var t3 = 1; t3 < f2; t3 += 1) {
          var n3 = { type: "table-cell", children: [{ text: "" }] };
          0 === u2[u2.length - 2] && i2 && (n3.isHeader = true);
          var r4 = u2.slice(0, -1), o3 = u2[u2.length - 1] + t3, a3 = av(av([], iv(r4), false), [o3], false);
          try {
            Wg.insertNodes(e11, n3, { at: a3 });
          } catch (t4) {
            try {
              var s3 = iv(eg.node(e11, r4), 1)[0].children.length, l3 = av(av([], iv(r4), false), [s3], false);
              Wg.insertNodes(e11, n3, { at: l3 });
            } catch (e12) {
              console.warn("插入同行单元格失败: ".concat(e12 instanceof Error ? e12.message : String(e12)));
            }
          }
        }
        for (var d3 = 1; d3 < c3; d3 += 1) {
          var p2 = u2[u2.length - 2] + d3, h2 = av(av([], iv(u2.slice(0, -2)), false), [p2], false);
          try {
            var g2 = iv(eg.node(e11, h2), 1)[0];
            if (!g2) {
              console.warn("目标行 ".concat(p2, " 不存在"));
              continue;
            }
            for (t3 = 0; t3 < f2; t3 += 1) {
              n3 = { type: "table-cell", children: [{ text: "" }] }, o3 = u2[u2.length - 1] + t3, a3 = av(av([], iv(h2), false), [o3], false);
              try {
                var v2 = g2.children.length;
                if (o3 >= v2) {
                  var m2 = av(av([], iv(h2), false), [v2], false);
                  Wg.insertNodes(e11, n3, { at: m2 });
                } else Wg.insertNodes(e11, n3, { at: a3 });
              } catch (t4) {
                try {
                  var y2 = g2.children.length;
                  l3 = av(av([], iv(h2), false), [y2], false);
                  Wg.insertNodes(e11, n3, { at: l3 });
                } catch (e12) {
                  console.warn("插入单元格到第".concat(d3, "行失败: ").concat(e12 instanceof Error ? e12.message : String(e12)));
                }
              }
            }
          } catch (e12) {
            console.warn("处理第".concat(d3, "行时出错: ").concat(e12 instanceof Error ? e12.message : String(e12)));
          }
        }
      });
    }
  }, e10;
}(), pT = function() {
  function e10() {
    this.title = iC("tableModule.header"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M704 128l-64 0L384 128 320 128 0 128l0 256 0 64 0 192 0 64 0 256 320 0 64 0 256 0 64 0 320 0 0-256 0-64L1024 448 1024 384 1024 128 704 128zM640 640 384 640 384 448l256 0L640 640zM64 448l256 0 0 192L64 640 64 448zM320 896 64 896l0-192 256 0L320 896zM640 896 384 896l0-192 256 0L640 896zM960 896l-256 0 0-192 256 0L960 896zM960 640l-256 0L704 448l256 0L960 640z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "table");
    return null != t2 && aT(t2);
  }, e10.prototype.isActive = function(e11) {
    return !!this.getValue(e11);
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || null == zy.getSelectedNodeByType(e11, "table"));
  }, e10.prototype.exec = function(e11, t2) {
    if (!this.isDisabled(e11)) {
      var n2 = !t2, r3 = zy.getSelectedNodeByType(e11, "table");
      if (null != r3) iT(r3).forEach(function(t3) {
        return Wg.setNodes(e11, { isHeader: n2 }, { at: zy.findPath(e11, t3) });
      });
    }
  }, e10;
}(), hT = { key: "insertTable", factory: function() {
  return new lT();
} }, gT = { key: "deleteTable", factory: function() {
  return new rT();
} }, vT = { key: "insertTableRow", factory: function() {
  return new uT();
} }, mT = { key: "deleteTableRow", factory: function() {
  return new nT();
} }, yT = { key: "insertTableCol", factory: function() {
  return new sT();
} }, bT = { key: "deleteTableCol", factory: function() {
  return new tT();
} }, ET = { key: "tableHeader", factory: function() {
  return new pT();
} }, CT = { key: "tableFullWidth", factory: function() {
  return new oT();
} }, wT = { key: "mergeTableCell", factory: function() {
  return new dT();
} }, DT = { key: "splitTableCell", factory: function() {
  return new fT();
} }, ST = { key: "setTableProperty", factory: function() {
  return new QB();
} }, AT = { key: "setTableCellProperty", factory: function() {
  return new eT();
} };
var xT = { selector: "td:not([data-w-e-type]),th:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  0 === (t2 = t2.filter(function(e11) {
    return "paragraph" === zy.getNodeType(e11) || (!!Og.isText(e11) || !!n2.isInline(e11));
  })).length && (t2 = [{ text: r3.text().replace(/\s+/gm, " ") }]);
  var o2 = parseInt(r3.attr("colSpan") || "1", 10), i2 = parseInt(r3.attr("rowSpan") || "1", 10), a2 = "none" === XB(r3, "display"), s2 = r3.attr("width") || "auto";
  return { type: "table-cell", isHeader: "th" === YB(r3), colSpan: o2, rowSpan: i2, width: s2, children: t2, hidden: a2 };
} };
var OT = { selector: "tr:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  for (var r3 = fm(e10), o2 = [], i2 = 0; i2 < t2.length; i2 += 1) {
    var a2 = t2[i2];
    if ("table-cell" === zy.getNodeType(a2)) {
      var s2 = a2;
      if (s2.hidden) continue;
      o2.push(s2);
    }
  }
  return { type: "table-row", height: parseInt(XB(r3, "height") || "0", 10) || void 0, children: o2 };
} };
var NT, BT = { selector: "table:not([data-w-e-type])", parseElemHtml: function(e10, t2, n2) {
  var r3, o2, i2 = fm(e10), a2 = "auto";
  "100%" === XB(i2, "width") && (a2 = "100%"), "100%" === i2.attr("width") && (a2 = "100%");
  var s2 = { type: "table", width: a2, height: parseInt(XB(i2, "height") || "0", 10), children: t2.filter(function(e11) {
    return "table-row" === zy.getNodeType(e11);
  }) }, u2 = (null === (r3 = i2.find("tr")[0]) || void 0 === r3 ? void 0 : r3.children) || [], l2 = (null === (o2 = i2.find("colgroup")[0]) || void 0 === o2 ? void 0 : o2.children) || null, c3 = t2[t2.length - 1].children.length;
  if (l2 && l2.length === c3) s2.columnWidths = Array.from(l2).map(function(e11) {
    return parseInt(e11.getAttribute("width"), 10);
  });
  else if (u2.length > 0) {
    var d2 = [];
    Array.from(u2).forEach(function(e11) {
      var t3 = parseInt(fm(e11).attr("colSpan") || "1", 10), n3 = parseInt(XB(fm(e11), "width") || "90", 10);
      d2.push(n3);
      for (var r4 = 1; r4 < t3; r4 += 1) d2.push(90);
    }), s2.columnWidths = d2;
  }
  return s2;
} }, TT = null === (NT = null === window || void 0 === window ? void 0 : window.getComputedStyle(document.documentElement)) || void 0 === NT ? void 0 : NT.getPropertyValue("--w-e-textarea-border-color");
function kT(e10) {
  var t2 = e10.selection;
  if (null == t2) return false;
  var n2 = iv(eg.nodes(e10, { match: function(e11) {
    return zy.checkNodeType(e11, "table-cell");
  } }), 1), r3 = n2[0];
  if (r3) {
    var o2 = iv(r3, 2)[1], i2 = eg.start(e10, o2);
    if (hg.equals(t2.anchor, i2)) return true;
  }
  return false;
}
function FT(e10, t2) {
  var n2 = t2.offset;
  if (0 === n2) return false;
  var r3 = eg.node(e10, t2);
  if (!Og.isText(r3[0])) return false;
  var o2 = ag.string(r3[0]);
  return !(n2 >= o2.length) && ("\n" === o2[n2 - 1] && "\r" === o2[n2]);
}
function IT(e10, t2, n2) {
  var r3 = e10.selection;
  if (null == r3 || "line" === t2) return false;
  var o2 = iv(eg.nodes(e10, { match: function(e11) {
    return zy.checkNodeType(e11, "table-cell");
  } }), 1), i2 = o2[0], a2 = r3.anchor;
  if ("backward" === n2 && 0 === r3.anchor.offset && (a2 = eg.before(e10, r3)), "forward" === n2 && eg.isEnd(e10, r3.anchor, r3.anchor.path) && (a2 = eg.after(e10, r3)), null == a2) return false;
  var s2 = eg.above(e10, { at: a2, match: function(e11) {
    return zy.checkNodeType(e11, "table-cell");
  } });
  if (null == s2 || null == i2 || !cg.equals(s2[1], i2[1])) return false;
  var u2 = eg.node(e10, a2);
  if (!Og.isText(u2[0]) || u2[0].text.length < 2) return false;
  var l2 = "backward" === n2 ? [a2.offset - 2, a2.offset] : [a2.offset, a2.offset + 2], c3 = ag.string(u2[0]);
  return "\n\r" === c3.slice.apply(c3, av([], iv(l2), false)) ? (Wg.insertText(e10, c3.slice(0, l2[0]) + c3.slice(l2[1]), { at: { anchor: eg.start(e10, a2.path), focus: eg.end(e10, a2.path) } }), true) : !!FT(e10, a2) && (Wg.insertText(e10, c3.slice(0, r3.anchor.offset - 1) + c3.slice(r3.anchor.offset + 1), { at: { anchor: eg.start(e10, a2.path), focus: eg.end(e10, a2.path) } }), true);
}
function PT(e10, t2) {
  var n2 = eg.nodes(e10, { at: t2, match: function(e11) {
    return "table" === zy.getNodeType(e11);
  } });
  return !!av([], iv(n2), false).find(function() {
    return true;
  });
}
function _T(e10) {
  var t2, n2;
  try {
    for (var r3 = ov(["paragraph", "header1", "header2", "header3", "header4", "header5", "header6", "blockquote", "list-item", "todo", "divider"]), o2 = r3.next(); !o2.done; o2 = r3.next()) {
      var i2 = o2.value;
      if (zy.getSelectedNodeByType(e10, i2)) return true;
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      o2 && !o2.done && (n2 = r3.return) && n2.call(r3);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return false;
}
var RT = { selector: "table", preParseHtml: function(e10) {
  var t2 = fm(e10);
  if ("table" !== YB(t2)) return e10;
  var n2 = t2.find("tbody");
  if (0 === n2.length) return e10;
  var r3 = t2.find("tr");
  t2.append(r3), n2.remove();
  for (var o2 = t2.find("td, th"), i2 = 0; i2 < o2.length; i2 += 1) {
    var a2 = (u2 = fm(o2[i2])).attr("style");
    if (a2) {
      /display\s*:\s*none/i.test(a2) && u2.remove();
    }
    u2.attr("width", "auto");
  }
  var s2 = t2.find("td, th");
  for (i2 = 0; i2 < s2.length; i2 += 1) {
    var u2, l2 = (u2 = fm(s2[i2])).html() || "";
    l2 = (l2 = (l2 = l2.replace(/<o:p[^>]*>[\s\S]*?<\/o:p>/gi, "")).replace(/<\/o:p>/gi, "")).replace(/<p[^>]*>([\s\S]*?)<\/p>/gi, function(e11, t3) {
      var n3 = t3.trim();
      return n3 && "&nbsp;" !== n3 ? t3 : "";
    }), u2.html(l2);
  }
  return t2[0];
} };
function LT(e10) {
  var t2, n2, r3 = [], o2 = 0;
  try {
    for (var i2 = ov(e10), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      o2 += a2.value, r3.push(o2);
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return r3;
}
function MT(e10) {
  var t2, n2, r3 = [], o2 = e10.reduce(function(e11, t3) {
    return e11 + t3;
  }, 0);
  try {
    for (var i2 = ov(e10), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      var s2 = a2.value;
      r3.push(s2 / o2);
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return r3;
}
var jT = null;
var HT = false, zT = false, $T = 0, UT = null, VT = fm(window);
VT.on("mousedown", function(e10) {
  var t2 = e10.target;
  if (t2.closest('[data-block-type="table-cell"]')) HT = true;
  else if ("DIV" === t2.tagName && t2.closest(".column-resizer-item")) {
    if (null === UT) return;
    zT = true;
    var n2 = e10.clientX;
    $T = n2, document.body.style.cursor = "col-resize", e10.preventDefault();
  }
  VT.on("mousemove", WT), VT.on("mouseup", GT);
});
var WT = kC(function(e10) {
  if (zT && null !== UT) {
    e10.preventDefault();
    var t2, n2 = e10.clientX, r3 = n2 - $T, o2 = iv(eg.nodes(UT, { match: WB(UT, "table") }), 1), i2 = iv(o2[0], 1)[0], a2 = i2.columnWidths, s2 = void 0 === a2 ? [] : a2, u2 = i2.resizingIndex, l2 = void 0 === u2 ? -1 : u2, c3 = zy.getSelectedNodeByType(UT, "table"), d2 = zy.toDOMNode(UT, c3).querySelector(".table");
    if (d2) t2 = function(e11, t3, n3, r4, o3) {
      var i3 = av([], iv(e11), false);
      if (t3 < 0 || t3 >= e11.length) return i3;
      var a3 = o3.getMenuConfig("insertTable").minWidth, s3 = parseInt((void 0 === a3 ? 60 : a3).toString(), 10) || 60, u3 = n3 - (0 === t3 ? 0 : r4[t3 - 1]), l3 = Math.max(s3, u3);
      return i3[t3] = Math.floor(100 * l3) / 100, i3;
    }(s2, l2, n2 - d2.getBoundingClientRect().left, LT(s2), UT);
    else t2 = function(e11, t3, n3, r4) {
      var o3 = av([], iv(e11), false), i3 = r4.getMenuConfig("insertTable").minWidth, a3 = parseInt((void 0 === i3 ? 60 : i3).toString(), 10) || 60, s3 = o3[t3], u3 = Math.max(a3, s3 + n3);
      return o3[t3] = Math.floor(100 * u3) / 100, o3;
    }(s2, l2, r3, UT);
    Wg.setNodes(UT, { columnWidths: t2 }, { mode: "highest" });
  }
}, 100);
function GT(e10) {
  HT = false, zT = false, UT = null, document.body.style.cursor = "", VT.off("mousemove", WT), VT.off("mouseup", GT);
}
function qT(e10, t2) {
  "mouseenter" === t2.type ? Wg.setNodes(e10, { isResizing: true }, { mode: "highest" }) : Wg.setNodes(e10, { isResizing: false }, { mode: "highest" });
}
function KT(e10) {
  var t2, n2, r3 = [], o2 = 0;
  try {
    for (var i2 = ov(e10), a2 = i2.next(); !a2.done; a2 = i2.next()) {
      o2 += a2.value, r3.push(o2);
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      a2 && !a2.done && (n2 = i2.return) && n2.call(i2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return r3;
}
var YT = false, XT = 0, ZT = null, JT = fm(window);
var QT = kC(function(e10) {
  if (YT && null !== ZT) {
    e10.preventDefault();
    var t2, n2 = e10.clientY, r3 = n2 - XT, o2 = iv(eg.nodes(ZT, { match: WB(ZT, "table") }), 1), i2 = iv(o2[0], 1)[0], a2 = i2.children, s2 = i2.resizingRowIndex, u2 = void 0 === s2 ? -1 : s2, l2 = a2.map(function(e11) {
      return e11.height || 30;
    }), c3 = zy.getSelectedNodeByType(ZT, "table"), d2 = zy.toDOMNode(ZT, c3).querySelector(".table");
    if (d2) t2 = function(e11, t3, n3, r4, o3) {
      var i3 = av([], iv(e11), false);
      if (t3 < 0 || t3 >= e11.length) return i3;
      var a3 = (o3.getMenuConfig("insertTable") || {}).minRowHeight, s3 = parseInt((void 0 === a3 ? 30 : a3).toString(), 10) || 30, u3 = n3 - (0 === t3 ? 0 : r4[t3 - 1]), l3 = Math.max(s3, u3);
      return i3[t3] = Math.floor(100 * l3) / 100, i3;
    }(l2, u2, n2 - d2.getBoundingClientRect().top, KT(l2), ZT);
    else t2 = function(e11, t3, n3, r4) {
      var o3 = av([], iv(e11), false), i3 = (r4.getMenuConfig("insertTable") || {}).minRowHeight, a3 = parseInt((void 0 === i3 ? 30 : i3).toString(), 10) || 30, s3 = o3[t3], u3 = Math.max(a3, s3 + n3);
      return o3[t3] = Math.floor(100 * u3) / 100, o3;
    }(l2, u2, r3, ZT);
    var f2 = zy.getSelectedNodeByType(ZT, "table");
    if (f2 && u2 >= 0 && u2 < t2.length) {
      var p2 = av(av([], iv(zy.findPath(ZT, f2)), false), [u2], false);
      try {
        Wg.setNodes(ZT, { height: t2[u2] }, { at: p2 });
      } catch (e11) {
        console.warn("更新行高度失败:", e11);
      }
    }
  }
}, 100);
function ek(e10) {
  YT = false, ZT = null, document.body.style.cursor = "", JT.off("mousemove", QT), JT.off("mouseup", ek);
}
function tk(e10, t2) {
  "mouseenter" === t2.type ? Wg.setNodes(e10, { isResizingRow: true }, { mode: "highest" }) : Wg.setNodes(e10, { isResizingRow: false }, { mode: "highest" });
}
JT.on("mousedown", function(e10) {
  var t2 = e10.target;
  if ("DIV" === t2.tagName && t2.closest(".row-resizer-item")) {
    if (null === ZT) return;
    YT = true;
    var n2 = e10.clientY;
    XT = n2, document.body.style.cursor = "row-resize", e10.preventDefault();
  }
  JT.on("mousemove", QT), JT.on("mouseup", ek);
});
var nk = { type: "table", renderElem: function(e10, t2, n2) {
  var r3 = function(e11, t3) {
    if (e11.isDisabled()) return false;
    var n3 = e11.selection;
    if (null == n3) return true;
    if (yg.isCollapsed(n3)) return true;
    var r4 = n3.anchor, o3 = n3.focus, i3 = zy.findPath(e11, t3), a3 = eg.start(e11, i3), s3 = eg.end(e11, i3), u3 = hg.compare(r4, s3) <= 0 && hg.compare(r4, a3) >= 0, l3 = hg.compare(o3, s3) <= 0 && hg.compare(o3, a3) >= 0;
    return !!(u3 && l3 && cg.equals(r4.path.slice(0, 3), o3.path.slice(0, 3)));
  }(n2, e10), o2 = e10, i2 = o2.width, a2 = void 0 === i2 ? "auto" : i2, s2 = o2.height, u2 = o2.columnWidths, l2 = void 0 === u2 ? [] : u2, c3 = o2.scrollWidth, d2 = void 0 === c3 ? 0 : c3, f2 = o2.isHoverCellBorder, p2 = o2.resizingIndex, h2 = o2.isResizing, g2 = o2.isHoverRowBorder, v2 = o2.resizingRowIndex, m2 = o2.isResizingRow, y2 = zy.isNodeSelected(n2, e10), b2 = iv(cT.selection(n2), 1)[0], E2 = MT(l2), C2 = Pw("div", { className: "table-container", "data-selected": y2, on: { mousedown: function(t3) {
    if ("DIV" === t3.target.tagName && t3.preventDefault(), !n2.isDisabled()) {
      t3.target.closest('[data-block-type="table-cell"]') && cT.unselect(n2);
      var r4 = zy.findPath(n2, e10), o3 = eg.start(n2, r4), i3 = n2.selection;
      if (null != i3) i3.anchor.path[0] !== r4[0] && "DIV" === t3.target.tagName && n2.select(o3);
      else n2.select(o3);
    }
  } } }, Pw("table", { width: a2, contentEditable: r3, className: "table ".concat(b2 ? "table-selection-none" : ""), style: { width: "100%" === a2 ? a2 : "".concat(l2.reduce(function(e11, t3) {
    return e11 + t3;
  }, 0), "px") }, on: { mousemove: lE(function(t3) {
    cT.hasSelected(n2) || (function(e11, t4, n3, r4) {
      if (!e11.isDisabled() && !HT && !zT) {
        var o3 = t4, i3 = o3.width, a3 = void 0 === i3 ? "auto" : i3, s3 = o3.columnWidths, u3 = void 0 === s3 ? [] : s3, l3 = o3.isHoverCellBorder, c4 = o3.resizingIndex, d3 = n3.clientX, f3 = n3.target;
        if (Jm(f3) && d3 > (g3 = f3.getBoundingClientRect()).x + 5 && d3 < g3.x + g3.width - 5) return void (l3 && Wg.setNodes(e11, { isHoverCellBorder: false, resizingIndex: -1 }, { mode: "highest" }));
        if (Jm(f3)) {
          var p3 = f3.closest(".table");
          if (p3) {
            for (var h3 = n3.clientX, g3 = p3.getBoundingClientRect(), v6 = "100%" === a3 ? MT(u3).map(function(e12) {
              return e12 * r4;
            }) : u3, m3 = LT(v6), y3 = 0; y3 < m3.length; y3 += 1) if (h3 - g3.x >= m3[y3] - 5 && h3 - g3.x < m3[y3] + 5) {
              if (c4 === y3) return;
              return void Wg.setNodes(e11, { isHoverCellBorder: true, resizingIndex: y3 }, { mode: "highest" });
            }
          }
        }
        true === l3 && Wg.setNodes(e11, { isHoverCellBorder: false, resizingIndex: -1 }, { mode: "highest" });
      }
    }(n2, e10, t3, d2), function(e11, t4, n3) {
      if (!e11.isDisabled() && !YT) {
        var r4 = t4, o3 = r4.children, i3 = r4.isHoverRowBorder, a3 = r4.resizingRowIndex, s3 = n3.target;
        if (Jm(s3)) {
          var u3 = s3.closest(".table");
          if (u3) {
            for (var l3 = n3.clientY, c4 = u3.getBoundingClientRect(), d3 = KT(o3.map(function(e12) {
              return e12.height || 30;
            })), f3 = 0; f3 < d3.length; f3 += 1) if (l3 - c4.y >= d3[f3] - 5 && l3 - c4.y < d3[f3] + 5) {
              if (a3 === f3) return;
              return void Wg.setNodes(e11, { isHoverRowBorder: true, resizingRowIndex: f3 }, { mode: "highest" });
            }
          }
        }
        true === i3 && Wg.setNodes(e11, { isHoverRowBorder: false, resizingRowIndex: -1 }, { mode: "highest" });
      }
    }(n2, e10, t3));
  }, 25) } }, Pw("colgroup", { contentEditable: false }, l2.map(function(e11) {
    return Pw("col", { width: e11 });
  })), Pw("tbody", null, t2)), Pw("div", { className: "column-resizer", contentEditable: false }, l2.map(function(e11, t3) {
    var r4 = e11;
    return "100%" === a2 && (r4 = E2[t3] * d2), Pw("div", { className: "column-resizer-item", style: { minWidth: "".concat(r4, "px") } }, Pw("div", { className: "resizer-line-hotzone ".concat(f2 && t3 === p2 ? "visible " : "").concat(h2 && t3 === p2 ? "highlight" : ""), style: { height: "".concat(s2, "px") }, on: { mouseenter: function(e12) {
      return qT(n2, e12);
    }, mouseleave: function(e12) {
      return qT(n2, e12);
    }, mousedown: function(e12) {
      return function(e13) {
        zT || (UT = e13);
      }(n2);
    } } }, Pw("div", { className: "resizer-line" })));
  })), Pw("div", { className: "row-resizer", contentEditable: false }, e10.children.map(function(e11, t3) {
    var r4 = l2.reduce(function(e12, t4) {
      return e12 + t4;
    }, 0), o3 = e11.height || 30;
    return Pw("div", { className: "row-resizer-item", style: { minHeight: "".concat(o3, "px") } }, Pw("div", { className: "resizer-line-hotzone-horizontal ".concat(g2 && t3 === v2 ? "visible " : "").concat(m2 && t3 === v2 ? "highlight" : ""), style: { width: "".concat(r4, "px") }, on: { mouseenter: function(e12) {
      return tk(n2, e12);
    }, mouseleave: function(e12) {
      return tk(n2, e12);
    }, mousedown: function(e12) {
      return function(e13) {
        YT || (ZT = e13);
      }(n2);
    } } }, Pw("div", { className: "resizer-line-horizontal" })));
  }))), w2 = hw("div", { hook: { insert: function(e11) {
    var t3 = e11.elm;
    return function(e12, t4) {
      if (Jm(t4)) {
        var n3 = t4.querySelector("table");
        n3 && (jT = new ResizeObserver(function(t5) {
          var n4 = iv(t5, 1)[0].contentRect;
          Wg.setNodes(e12, { scrollWidth: n4.width, height: n4.height }, { mode: "highest" });
        }), jT.observe(n3));
      }
    }(n2, t3);
  }, destroy: function() {
    jT && (null == jT || jT.disconnect(), jT = null);
  } } }, C2);
  return w2;
} }, rk = { type: "table-row", renderElem: function(e10, t2, n2) {
  var r3 = e10.height;
  return Pw("tr", { style: r3 ? { height: "".concat(r3, "px") } : {} }, t2);
} }, ok = { type: "table-cell", renderElem: function(e10, t2, n2) {
  var r3 = function(e11, t3) {
    var n3 = zy.getParentNode(e11, t3);
    if (null == n3) return false;
    var r4 = zy.getParentNode(e11, n3);
    return null != r4 && iT(r4).some(function(e12) {
      return e12 === t3;
    });
  }(n2, e10), o2 = e10, i2 = o2.colSpan, a2 = void 0 === i2 ? 1 : i2, s2 = o2.rowSpan, u2 = void 0 === s2 ? 1 : s2, l2 = o2.isHeader, c3 = void 0 !== l2 && l2, d2 = o2.hidden, f2 = void 0 !== d2 && d2, p2 = cT.isSelected(n2, e10);
  return Pw(r3 && c3 ? "th" : "td", { colSpan: a2, rowSpan: u2, "data-block-type": "table-cell", className: p2 ? "w-e-selected" : "", style: { display: f2 ? "none" : "" } }, t2);
} };
function ik(e10, t2) {
  null == e10.data && (e10.data = {});
  var n2 = e10.data;
  null == n2.style && (n2.style = {}), Object.assign(n2.style, t2);
}
var ak = { renderStyle: function(e10, t2) {
  var n2, r3;
  if (!Kh.isElement(e10)) return t2;
  var o2 = e10, i2 = o2.backgroundColor, a2 = o2.borderWidth, s2 = o2.borderStyle, u2 = o2.borderColor, l2 = o2.textAlign, c3 = {};
  if (i2 && (c3.backgroundColor = i2), a2) {
    /^\d+(\.\d+)?$/.test(a2) ? c3.borderWidth = "".concat(a2, "px") : c3.borderWidth = a2;
  }
  s2 && (c3.borderStyle = "none" === s2 ? "" : s2), u2 && (c3.borderColor = u2), l2 && (c3.textAlign = l2);
  var d2 = t2;
  return "table" === e10.type ? ik(null === (r3 = (null === (n2 = d2.children) || void 0 === n2 ? void 0 : n2[0]).children) || void 0 === r3 ? void 0 : r3[0], c3) : ik(d2, c3), d2;
}, styleToHtml: function(e10, t2) {
  if ("table" !== e10.type && "table-cell" !== e10.type) return t2;
  var n2 = e10.backgroundColor, r3 = e10.borderWidth, o2 = e10.borderStyle, i2 = e10.borderColor, a2 = e10.textAlign;
  if (!(n2 || r3 || o2 || i2 || a2)) return t2;
  var s2 = fm(t2);
  return n2 && s2.css("background-color", n2), r3 && s2.css("border-width", "".concat(r3, "px")), o2 && s2.css("border-style", "none" === o2 ? "" : o2), i2 && s2.css("border-color", i2), a2 && s2.css("text-align", a2), function(e11) {
    return 0 === e11.length ? "" : e11[0].outerHTML;
  }(s2);
}, parseStyleHtml: function(e10, t2, n2) {
  if (!["TABLE", "TD", "TH"].includes(e10.tagName)) return t2;
  var r3 = fm(e10), o2 = t2, i2 = XB(r3, "background-color");
  i2 || (i2 = XB(r3, "background")), i2 && (o2.backgroundColor = i2);
  var a2 = XB(r3, "border");
  a2 || "TD" !== e10.tagName || (a2 = "1px solid ".concat(TT));
  var s2, u2 = iv((null == a2 ? void 0 : a2.split(" ")) || [], 3), l2 = u2[0], c3 = u2[1], d2 = u2[2];
  (l2 = XB(r3, "border-width") || l2) && (o2.borderWidth = (s2 = l2.trim()) && "string" == typeof s2 && s2.includes("pt") ? s2.replace(/(\d+(\.\d+)?)\s*pt/g, function(e11, t3) {
    var n3 = (4 * parseFloat(t3) / 3).toFixed(2);
    return "".concat(n3, "px");
  }) : s2), (c3 = XB(r3, "border-style") || c3) && (o2.borderStyle = "none" === c3 ? "" : c3), (d2 = XB(r3, "border-color") || d2) && (o2.borderColor = d2);
  var f2 = XB(r3, "text-align");
  return (f2 = XB(r3, "text-align") || f2) && (o2.textAlign = f2), t2;
}, renderElems: [nk, rk, ok], elemsToHtml: [HB, zB, $B], preParseHtml: [RT], parseElemsHtml: [xT, OT, BT], menus: [hT, gT, vT, mT, yT, bT, ET, CT, wT, DT, ST, AT], editorPlugin: function(e10) {
  var t2 = e10.insertBreak, n2 = e10.deleteBackward, r3 = e10.deleteForward, o2 = e10.deleteFragment, i2 = e10.normalizeNode, a2 = e10.insertData, s2 = e10.handleTab, u2 = e10.selectAll, l2 = e10;
  l2.insertBreak = function() {
    null == zy.getSelectedNodeByType(l2, "table") ? t2() : l2.insertText("\n\r");
  }, l2.deleteBackward = function(e11) {
    if (!kT(l2) && !IT(l2, e11, "backward")) {
      var t3 = l2.selection;
      if (t3) {
        var r4 = eg.before(l2, t3), o3 = eg.above(l2, { at: t3, match: function(e12) {
          return zy.checkNodeType(e12, "table-cell");
        } });
        if (r4) {
          var i3 = PT(l2, r4);
          if (!o3 && i3 && _T(l2)) return;
        }
      }
      n2(e11);
    }
  }, l2.handleTab = function() {
    var t3;
    if (zy.getSelectedNodeByType(l2, "table")) {
      var n3 = eg.above(e10);
      zy.checkNodeType(n3[0], "table-cell") && Wg.select(e10, n3[1]);
      var r4 = eg.next(e10);
      if (r4) r4[0] && r4[0].text && (r4 = null !== (t3 = eg.above(e10, { at: r4[1] })) && void 0 !== t3 ? t3 : r4), Wg.select(e10, r4[1]);
      else {
        var o3 = l2.children || [], i3 = o3.length;
        if (zy.checkNodeType(o3[i3 - 1], "table")) {
          var a3 = zy.genEmptyParagraph();
          Wg.insertNodes(l2, a3, { at: [i3] }), l2.handleTab();
        }
      }
    } else s2();
  }, l2.deleteForward = function(e11) {
    if (!kT(l2) && !IT(l2, e11, "forward")) {
      var t3 = l2.selection;
      if (t3) {
        var n3 = eg.after(l2, t3), o3 = eg.above(l2, { at: t3, match: function(e12) {
          return zy.checkNodeType(e12, "table-cell");
        } });
        if (n3) {
          var i3 = PT(l2, n3);
          if (!o3 && i3 && _T(l2)) return;
        }
      }
      r3(e11);
    }
  }, l2.deleteFragment = function(e11) {
    var t3 = l2.selection;
    if (t3) {
      var n3, r4 = false, i3 = { anchor: t3.anchor, focus: t3.focus }, a3 = hg.isBefore(i3.anchor, i3.focus);
      if (FT(l2, t3.anchor)) (n3 = eg[a3 ? "before" : "after"](l2, t3.anchor)) && (i3.anchor = n3), r4 = true;
      if (FT(l2, t3.focus)) (n3 = eg[a3 ? "after" : "before"](l2, t3.focus)) && (i3.focus = n3), r4 = true;
      r4 && Wg.setSelection(l2, i3), o2(e11);
    }
  }, l2.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), n3 = t3[0], r4 = t3[1];
    if ("table" !== zy.getNodeType(n3)) return i2([n3, r4]);
    if (zy.isLastNode(l2, n3)) {
      var o3 = zy.genEmptyParagraph();
      Wg.insertNodes(l2, o3, { at: [r4[0] + 1] });
    }
  }, l2.insertData = function(e11) {
    if (null != zy.getSelectedNodeByType(l2, "table")) {
      var t3 = e11.getData("text/plain");
      "\n" === t3 || /<img[^>]+>/.test(e11.getData("text/html")) ? a2(e11) : eg.insertText(l2, t3);
    } else a2(e11);
  }, l2.selectAll = function() {
    var e11 = l2.selection;
    if (null != e11) {
      var t3 = zy.getSelectedNodeByType(l2, "table-cell");
      if (null != t3) {
        var n3 = e11.anchor, r4 = e11.focus;
        if (cg.equals(n3.path.slice(0, 3), r4.path.slice(0, 3))) if (0 !== ag.string(t3).length) {
          var o3 = zy.findPath(l2, t3), i3 = { anchor: eg.start(l2, o3), focus: eg.end(l2, o3) };
          l2.select(i3);
        } else u2();
        else u2();
      } else u2();
    } else u2();
  }, function(e11) {
    var t3 = e11.apply;
    e11.apply = function(n3) {
      if (!lg.isSelectionOperation(n3) || !n3.newProperties) return t3(n3);
      var r4 = tv(tv({}, e11.selection), n3.newProperties);
      if (!yg.isRange(r4)) return cT.unselect(e11), t3(n3);
      var o3 = function(e12) {
        return Kh.isElement(e12) && ("table-cell" === e12.type || "th" === e12.type || "td" === e12.type);
      }, i3 = iv(eg.nodes(e11, { match: o3, at: yg.start(r4), mode: "lowest" }), 1)[0], a3 = iv(eg.nodes(e11, { match: o3, at: yg.end(r4), mode: "lowest" }), 1)[0];
      if (!i3 || !a3) return cT.unselect(e11), t3(n3);
      var s3 = iv(i3, 2)[1], u3 = iv(a3, 2)[1];
      if (cg.equals(s3, u3) || !GB(e11, [s3, u3], "table")) return cT.unselect(e11), t3(n3);
      try {
        var l3 = qB(e11, { at: s3 });
        if (!l3 || 0 === l3.length) return cT.unselect(e11), t3(n3);
        for (var c4 = KB.valueOf(0, 0), d3 = KB.valueOf(0, 0), f3 = false, p2 = false, h2 = 0; h2 < l3.length; h2 += 1) if (l3[h2]) {
          for (var g2 = 0; g2 < l3[h2].length; g2 += 1) if (l3[h2][g2]) {
            var v2 = iv(l3[h2][g2], 1), m2 = iv(v2[0], 2)[1];
            cg.equals(s3, m2) && (c4.x = h2, c4.y = g2, f3 = true), cg.equals(u3, m2) && (d3.x = h2, d3.y = g2, p2 = true);
          }
        }
        if (!f3 || !p2) return cT.unselect(e11), t3(n3);
        for (var y2 = KB.valueOf(Math.min(c4.x, d3.x), Math.min(c4.y, d3.y)), b2 = KB.valueOf(Math.max(c4.x, d3.x), Math.max(c4.y, d3.y)); ; ) {
          var E2 = KB.valueOf(y2.x, y2.y), C2 = KB.valueOf(b2.x, b2.y);
          for (h2 = E2.x; h2 <= C2.x && h2 < l3.length; h2 += 1) if (l3[h2]) {
            for (g2 = E2.y; g2 <= C2.y && g2 < l3[h2].length; g2 += 1) if (l3[h2][g2]) {
              var w2 = iv(l3[h2][g2], 2)[1];
              if (w2) {
                var D2 = w2.rtl, S2 = w2.ltr, A2 = w2.btt, x2 = w2.ttb;
                E2.x = Math.min(E2.x, h2 - (x2 - 1)), E2.y = Math.min(E2.y, g2 - (D2 - 1)), C2.x = Math.max(C2.x, h2 + (A2 - 1)), C2.y = Math.max(C2.y, g2 + (S2 - 1));
              }
            }
          }
          if (KB.equals(y2, E2) && KB.equals(b2, C2)) break;
          y2 = E2, b2 = C2;
        }
        var O2 = [], N2 = /* @__PURE__ */ new WeakSet();
        for (h2 = y2.x; h2 <= b2.x && h2 < l3.length; h2 += 1) if (l3[h2]) {
          var B2 = [];
          for (g2 = y2.y; g2 <= b2.y && g2 < l3[h2].length; g2 += 1) if (l3[h2][g2]) {
            var T2 = iv(l3[h2][g2], 1), k2 = iv(T2[0], 1)[0];
            k2 && (N2.add(k2), B2.push(l3[h2][g2]));
          }
          B2.length > 0 && O2.push(B2);
        }
        ZB.set(e11, O2), JB.set(e11, N2);
      } catch (r5) {
        return cT.unselect(e11), t3(n3);
      }
      t3(n3);
    };
  }(l2), l2.getTableSelection = function() {
    return ZB.get(l2) || null;
  };
  var c3 = l2.addMark, d2 = l2.removeMark, f2 = tv({}, Wg);
  return l2.addMark = function(e11, t3) {
    var n3 = ZB.get(l2);
    if (n3 && n3.length > 0) {
      var r4 = l2.selection;
      n3.forEach(function(n4) {
        n4.forEach(function(n5) {
          var r5 = iv(n5[0], 2)[1], o3 = eg.start(l2, r5), i3 = eg.end(l2, r5);
          Wg.select(l2, { anchor: o3, focus: i3 }), c3(e11, t3);
        });
      }), r4 && Wg.select(l2, r4);
    } else c3(e11, t3);
  }, l2.removeMark = function(e11) {
    var t3 = ZB.get(l2);
    if (t3 && t3.length > 0) {
      var n3 = l2.selection;
      t3.forEach(function(t4) {
        t4.forEach(function(t5) {
          var n4 = iv(t5[0], 2)[1], r4 = eg.start(l2, n4), o3 = eg.end(l2, n4);
          Wg.select(l2, { anchor: r4, focus: o3 }), d2(e11);
        });
      }), n3 && Wg.select(l2, n3);
    } else d2(e11);
  }, Wg.setNodes = function(e11, t3, n3) {
    if (void 0 === n3 && (n3 = {}), e11 === l2) {
      var r4 = ZB.get(l2);
      if (r4 && r4.length > 0) return "hidden" in t3 || "rowSpan" in t3 || "colSpan" in t3 ? void f2.setNodes(e11, t3, n3) : void r4.forEach(function(r5) {
        r5.forEach(function(r6) {
          var o3 = iv(r6[0], 2)[1];
          f2.setNodes(e11, t3, tv(tv({}, n3), { at: o3 }));
        });
      });
    }
    f2.setNodes(e11, t3, n3);
  }, l2;
} };
function sk(e10) {
  return e10.length ? e10[0].tagName.toLowerCase() : "";
}
function uk(e10, t2, n2, r3) {
  void 0 === t2 && (t2 = "auto"), void 0 === n2 && (n2 = "auto"), void 0 === r3 && (r3 = {});
  var o2 = fm(e10), i2 = r3.width, a2 = void 0 === i2 ? "" : i2, s2 = r3.height, u2 = void 0 === s2 ? "" : s2, l2 = "";
  return a2 && (l2 += "width: ".concat(a2, ";")), u2 && (l2 += "height: ".concat(u2, ";")), o2.attr("width", t2), o2.attr("height", n2), o2.attr("style", l2), o2[0].outerHTML;
}
tC("en", { videoModule: { delete: "Delete", uploadVideo: "Upload video", insertVideo: "Insert video", videoSrc: "Video source", videoSrcPlaceHolder: "Video file url, or third-party <iframe>", videoPoster: "Video poster", videoPosterPlaceHolder: "Poster image url", ok: "Ok", editSize: "Edit size", edit: "Edit video", width: "Width", height: "Height" } }), tC("zh-CN", { videoModule: { delete: "删除视频", uploadVideo: "上传视频", insertVideo: "插入视频", videoSrc: "视频地址", videoSrcPlaceHolder: "视频文件 url 或第三方 <iframe>", videoPoster: "视频封面", videoPosterPlaceHolder: "封面图片 url", ok: "确定", editSize: "修改尺寸", edit: "编辑视频", width: "宽度", height: "高度" } }), Pm && (fm.fn.append = Pm), Cm && (fm.fn.on = Cm), Wm && (fm.fn.focus = Wm), vm && (fm.fn.attr = vm), Em && (fm.fn.val = Em), km && (fm.fn.html = km), Rm && (fm.fn.parent = Rm), gm && (fm.fn.hasClass = gm), zm && (fm.fn.empty = zm);
var lk = { type: "video", elemToHtml: function(e10, t2) {
  var n2 = e10, r3 = n2.src, o2 = void 0 === r3 ? "" : r3, i2 = n2.poster, a2 = void 0 === i2 ? "" : i2, s2 = n2.width, u2 = void 0 === s2 ? "auto" : s2, l2 = n2.height, c3 = void 0 === l2 ? "auto" : l2, d2 = n2.style, f2 = void 0 === d2 ? {} : d2, p2 = n2.textAlign, h2 = '<div data-w-e-type="video" data-w-e-is-void style="text-align: '.concat(void 0 === p2 ? "center" : p2, ';">\n');
  if (0 === o2.trim().indexOf("<iframe ")) {
    h2 += uk(o2, u2, c3, f2);
  } else {
    var g2 = f2.width, v2 = void 0 === g2 ? "" : g2, m2 = f2.height, y2 = void 0 === m2 ? "" : m2, b2 = "";
    v2 && (b2 += "width: ".concat(v2, ";")), y2 && (b2 += "height: ".concat(y2, ";")), h2 += '<video poster="'.concat(a2, '" controls="true" width="').concat(u2, '" height="').concat(c3, '" style="').concat(b2, '"><source src="').concat(o2, '" type="video/mp4"/></video>');
  }
  return h2 += "\n</div>";
} };
function ck(e10) {
  return void 0 === e10 && (e10 = "r"), "".concat(e10, "-").concat(qm());
}
function dk(e10) {
  var t2 = {};
  return e10.trim().split(";").forEach(function(e11) {
    if (e11) {
      var n2 = iv(e11.split(":"), 2), r3 = n2[0], o2 = n2[1];
      r3 && o2 && (t2[r3.trim()] = o2.trim());
    }
  }), t2;
}
function fk() {
  return ck("w-e-insert-video");
}
var pk = function() {
  function e10() {
    this.title = iC("videoModule.editSize"), this.tag = "button", this.showModal = true, this.modalWidth = 320, this.$content = null, this.widthInputId = fk(), this.heightInputId = fk(), this.buttonId = fk();
  }
  return e10.prototype.getSelectedVideoNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "video");
  }, e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedVideoNode(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return this.getSelectedVideoNode(e11);
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = t2.widthInputId, r3 = t2.heightInputId, o2 = t2.buttonId, i2 = iv(vC(iC("videoModule.width"), n2, "auto"), 2), a2 = i2[0], s2 = fm(i2[1]), u2 = iv(vC(iC("videoModule.height"), r3, "auto"), 2), l2 = u2[0], c3 = fm(u2[1]), d2 = iv(yC(o2, iC("videoModule.ok")), 1)[0], f2 = this.getSelectedVideoNode(e11);
    if (null == this.$content) {
      var p2 = fm("<div></div>");
      p2.on("click", "#".concat(o2), function(t3) {
        t3.preventDefault();
        var o3 = p2.find("#".concat(n2)).val().trim(), i3 = p2.find("#".concat(r3)).val().trim(), a3 = function(e12) {
          return /^\d+(\.\d+)?%$/.test(e12);
        }, s3 = function(e12) {
          return /^\d+(\.\d+)?$/.test(e12);
        }, u3 = "auto", l3 = "auto";
        a3(o3) ? u3 = o3 : s3(o3) && (u3 = "".concat(parseInt(o3, 10), "px")), a3(i3) ? l3 = i3 : s3(i3) && (l3 = "".concat(parseInt(i3, 10), "px"));
        var c4 = f2.style, d3 = void 0 === c4 ? {} : c4;
        e11.restoreSelection();
        var h3 = { style: tv(tv({}, d3), { width: u3, height: l3 }) };
        Wg.setNodes(e11, h3, { match: function(e12) {
          return zy.checkNodeType(e12, "video");
        } }), e11.hidePanelOrModal();
      }), this.$content = p2;
    }
    var h2 = this.$content;
    if (h2.empty(), h2.append(a2), h2.append(l2), h2.append(d2), null == f2) return h2[0];
    var g2 = f2.style, v2 = void 0 === g2 ? {} : g2, m2 = v2.width, y2 = void 0 === m2 ? "" : m2, b2 = v2.height, E2 = void 0 === b2 ? "" : b2;
    return s2.val(y2), c3.val(E2), setTimeout(function() {
      s2.focus();
    }), h2[0];
  }, e10;
}();
function hk() {
  return ck("w-e-edit-video");
}
var gk = function() {
  function e10() {
    this.title = iC("videoModule.edit"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M864 0a160 160 0 0 1 128 256l-64 64-224-224 64-64c26.752-20.096 59.968-32 96-32zM64 736l-64 288 288-64 592-592-224-224L64 736z m651.584-372.416l-448 448-55.168-55.168 448-448 55.168 55.168z"></path></svg>', this.tag = "button", this.showModal = true, this.modalWidth = 300, this.$content = null, this.srcInputId = hk(), this.posterInputId = hk(), this.buttonId = hk();
  }
  return e10.prototype.getSelectedVideoNode = function(e11) {
    return zy.getSelectedNodeByType(e11, "video");
  }, e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || null == this.getSelectedVideoNode(e11);
  }, e10.prototype.getModalPositionNode = function(e11) {
    return this.getSelectedVideoNode(e11);
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = this, r3 = n2.srcInputId, o2 = n2.posterInputId, i2 = n2.buttonId, a2 = iv(vC(iC("videoModule.videoSrc"), r3, iC("videoModule.videoSrcPlaceHolder")), 2), s2 = a2[0], u2 = a2[1], l2 = iv(vC(iC("videoModule.videoPoster"), o2, iC("videoModule.videoPosterPlaceHolder")), 2), c3 = l2[0], d2 = l2[1], f2 = fm(u2), p2 = fm(d2), h2 = iv(yC(i2, iC("videoModule.ok")), 1)[0];
    if (null == this.$content) {
      var g2 = fm("<div></div>");
      g2.on("click", "#".concat(i2), function(n3) {
        return nv(t2, void 0, void 0, function() {
          var t3, i3, a3, s3;
          return rv(this, function(u3) {
            return n3.preventDefault(), t3 = g2.find("#".concat(r3)).val().trim(), i3 = g2.find("#".concat(o2)).val().trim(), a3 = ck("video-"), s3 = { src: t3, poster: i3, key: a3 }, e11.restoreSelection(), Wg.setNodes(e11, s3, { match: function(e12) {
              return zy.checkNodeType(e12, "video");
            } }), e11.hidePanelOrModal(), [2];
          });
        });
      }), this.$content = g2;
    }
    var v2 = this.$content;
    v2.empty(), v2.append(s2), v2.append(c3), v2.append(h2);
    var m2 = this.getSelectedVideoNode(e11);
    if (null == m2) return v2[0];
    var y2 = m2.src, b2 = void 0 === y2 ? "" : y2, E2 = m2.poster, C2 = void 0 === E2 ? "" : E2;
    return f2.val(b2), p2.val(C2), setTimeout(function() {
      f2.focus();
    }), v2[0];
  }, e10;
}();
function vk(e10, t2) {
  return nv(this, arguments, void 0, function(e11, t3, n2, r3, o2) {
    var i2, a2, s2, u2, l2, c3, d2;
    return void 0 === n2 && (n2 = ""), void 0 === r3 && (r3 = ""), void 0 === o2 && (o2 = ""), rv(this, function(f2) {
      switch (f2.label) {
        case 0:
          return t3 ? (e11.restoreSelection(), i2 = e11.getMenuConfig("insertVideo"), a2 = i2.onInsertedVideo, s2 = i2.checkVideo, u2 = i2.parseVideoSrc, [4, s2(t3, n2)]) : [2];
        case 1:
          return "string" == typeof (l2 = f2.sent()) ? (e11.alert(l2, "error"), [2]) : null == l2 ? [2] : [4, u2(t3)];
        case 2:
          return 0 !== (c3 = f2.sent()).trim().indexOf("<iframe ") && (c3 = function(e12) {
            return e12.replace(/</g, "&lt;").replace(/>/g, "&gt;");
          }(c3)), d2 = { type: "video", src: c3, poster: n2, children: [{ text: "" }], style: { width: r3, height: o2 } }, Promise.resolve().then(function() {
            zy.isSelectedEmptyParagraph(e11) && Wg.removeNodes(e11, { mode: "highest" }), Wg.insertNodes(e11, d2, { mode: "highest" });
          }), a2(d2), [2];
      }
    });
  });
}
function mk() {
  return ck("w-e-insert-video");
}
var yk = function() {
  function e10() {
    this.title = iC("videoModule.insertVideo"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>', this.tag = "button", this.showModal = true, this.modalWidth = 320, this.$content = null, this.srcInputId = mk(), this.posterInputId = mk(), this.buttonId = mk();
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || !!zy.getSelectedElems(e11).some(function(t3) {
      var n2 = zy.getNodeType(t3);
      return "pre" === n2 || ("list-item" === n2 || !!e11.isVoid(t3));
    }));
  }, e10.prototype.getModalPositionNode = function(e11) {
    return null;
  }, e10.prototype.getModalContentElem = function(e11) {
    var t2 = this, n2 = this, r3 = n2.srcInputId, o2 = n2.posterInputId, i2 = n2.buttonId, a2 = iv(vC(iC("videoModule.videoSrc"), r3, iC("videoModule.videoSrcPlaceHolder")), 2), s2 = a2[0], u2 = a2[1], l2 = iv(vC(iC("videoModule.videoPoster"), o2, iC("videoModule.videoPosterPlaceHolder")), 2), c3 = l2[0], d2 = l2[1], f2 = fm(u2), p2 = fm(d2), h2 = iv(yC(i2, iC("videoModule.ok")), 1)[0];
    if (null == this.$content) {
      var g2 = fm("<div></div>");
      g2.on("click", "#".concat(i2), function(n3) {
        return nv(t2, void 0, void 0, function() {
          var t3, i3;
          return rv(this, function(a3) {
            switch (a3.label) {
              case 0:
                return n3.preventDefault(), t3 = g2.find("#".concat(r3)).val().trim(), i3 = g2.find("#".concat(o2)).val().trim(), [4, vk(e11, t3, i3)];
              case 1:
                return a3.sent(), e11.hidePanelOrModal(), [2];
            }
          });
        });
      }), this.$content = g2;
    }
    var v2 = this.$content;
    return v2.empty(), v2.append(s2), v2.append(c3), v2.append(h2), f2.val(""), p2.val(""), setTimeout(function() {
      f2.focus();
    }), v2[0];
  }, e10;
}();
function bk(e10) {
  return e10.getMenuConfig("uploadVideo");
}
var Ek = /* @__PURE__ */ new WeakMap();
function Ck(e10, t2) {
  return nv(this, void 0, void 0, function() {
    var n2, r3;
    return rv(this, function(o2) {
      switch (o2.label) {
        case 0:
          return n2 = function(e11) {
            var t3 = Ek.get(e11);
            if (null != t3) return t3;
            var n3 = bk(e11), r4 = n3.onSuccess, o3 = n3.onProgress, i2 = n3.onFailed, a2 = n3.customInsert, s2 = n3.onError;
            return t3 = QA(tv(tv({}, n3), { onProgress: function(t4) {
              e11.showProgressBar(t4), o3 && o3(t4);
            }, onSuccess: function(t4, n4) {
              if (a2) return a2(n4, function(t5, n5) {
                return vk(e11, t5, n5);
              }), void r4(t4, n4);
              var o4 = n4.errno, s3 = void 0 === o4 ? 1 : o4, u2 = n4.data, l2 = void 0 === u2 ? {} : u2;
              if (0 === s3) {
                var c3 = l2.url, d2 = void 0 === c3 ? "" : c3, f2 = l2.poster;
                vk(e11, d2, void 0 === f2 ? "" : f2), r4(t4, n4);
              } else i2(t4, n4);
            }, onError: function(e12, t4, n4) {
              s2(e12, t4, n4);
            } })), Ek.set(e11, t3), t3;
          }(e10), r3 = t2.map(function(e11) {
            return { name: e11.name, type: e11.type, size: e11.size, data: e11 };
          }), n2.addFiles(r3), [4, n2.upload()];
        case 1:
          return o2.sent(), [2];
      }
    });
  });
}
var wk = function() {
  function e10() {
    this.title = iC("videoModule.uploadVideo"), this.iconSvg = '<svg viewBox="0 0 1056 1024"><path d="M805.902261 521.819882a251.441452 251.441452 0 0 0-251.011972 246.600033 251.051015 251.051015 0 1 0 502.023944 8.823877 253.237463 253.237463 0 0 0-251.011972-255.42391z m59.463561 240.001647v129.898403h-116.701631v-129.898403h-44.041298l101.279368-103.504859 101.279368 103.504859z" p-id="6802"></path><path d="M788.254507 0.000781H99.094092A98.663439 98.663439 0 0 0 0.001171 99.093701v590.067495a98.663439 98.663439 0 0 0 99.092921 99.092921h411.7549a266.434235 266.434235 0 0 1-2.186448-41.815807 275.843767 275.843767 0 0 1 275.180024-270.729042 270.650955 270.650955 0 0 1 103.504859 19.834201V99.093701A101.51363 101.51363 0 0 0 788.254507 0.000781zM295.054441 640.747004V147.507894l394.146189 246.600033z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.getMenuConfig(e11), r3 = n2.allowedFileTypes, o2 = void 0 === r3 ? [] : r3, i2 = n2.customBrowseAndUpload;
    if (i2) i2(function(t3, n3) {
      return vk(e11, t3, n3);
    });
    else {
      var a2 = "";
      o2.length > 0 && (a2 = 'accept="'.concat(o2.join(", "), '"'));
      var s2 = fm("body"), u2 = fm('<input type="file" '.concat(a2, " multiple/>"));
      u2.hide(), s2.append(u2), u2.click(), u2.on("change", function() {
        var t3 = u2[0].files;
        !function(e12, t4) {
          nv(this, void 0, void 0, function() {
            var n3, r4, o3, i3, a3, s3, u3, l2, c3, d2, f2, p2;
            return rv(this, function(h2) {
              switch (h2.label) {
                case 0:
                  if (null == t4) return [2];
                  n3 = Array.prototype.slice.call(t4), r4 = [], o3 = bk(e12).customUpload, h2.label = 1;
                case 1:
                  h2.trys.push([1, 8, 9, 14]), i3 = true, a3 = sv(n3), h2.label = 2;
                case 2:
                  return [4, a3.next()];
                case 3:
                  return s3 = h2.sent(), (c3 = s3.done) ? [3, 7] : (p2 = s3.value, i3 = false, u3 = p2, o3 ? [4, o3(u3, function(t5, n4) {
                    return vk(e12, t5, n4);
                  }, e12)] : [3, 5]);
                case 4:
                  return h2.sent(), [3, 6];
                case 5:
                  r4.push(u3), h2.label = 6;
                case 6:
                  return i3 = true, [3, 2];
                case 7:
                  return [3, 14];
                case 8:
                  return l2 = h2.sent(), d2 = { error: l2 }, [3, 14];
                case 9:
                  return h2.trys.push([9, , 12, 13]), i3 || c3 || !(f2 = a3.return) ? [3, 11] : [4, f2.call(a3)];
                case 10:
                  h2.sent(), h2.label = 11;
                case 11:
                  return [3, 13];
                case 12:
                  if (d2) throw d2.error;
                  return [7];
                case 13:
                  return [7];
                case 14:
                  return r4.length > 0 ? [4, Ck(e12, r4)] : [3, 16];
                case 15:
                  h2.sent(), h2.label = 16;
                case 16:
                  return [2];
              }
            });
          });
        }(e11, t3);
      });
    }
  }, e10.prototype.isDisabled = function(e11) {
    var t2 = e11.selection;
    return null == t2 || (!yg.isCollapsed(t2) || !!zy.getSelectedElems(e11).some(function(t3) {
      var n2 = zy.getNodeType(t3);
      return "pre" === n2 || ("list-item" === n2 || !!e11.isVoid(t3));
    }));
  }, e10.prototype.getMenuConfig = function(e11) {
    return e11.getMenuConfig("uploadVideo");
  }, e10;
}();
function Dk(e10, t2, n2, r3, o2, i2) {
  return void 0 === t2 && (t2 = ""), void 0 === n2 && (n2 = "auto"), void 0 === r3 && (r3 = "auto"), void 0 === o2 && (o2 = {}), void 0 === i2 && (i2 = "center"), { type: "video", src: e10, poster: t2, width: n2, height: r3, style: o2, children: [{ text: "" }], textAlign: i2 };
}
var Sk = { selector: 'div[data-w-e-type="video"]', parseElemHtml: function(e10, t2, n2) {
  var r3 = fm(e10), o2 = "", i2 = "", a2 = "auto", s2 = "auto", u2 = {}, l2 = r3.find("iframe");
  if (l2.length > 0) return a2 = l2.attr("width") || "auto", s2 = l2.attr("height") || "auto", u2 = dk(u2 = l2.attr("style") || ""), Dk(o2 = l2[0].outerHTML, i2, a2, s2, u2, dk(r3.attr("style") || "")["text-align"] || "center");
  var c3 = r3.find("video");
  return (o2 = c3.attr("src") || "") || c3.length > 0 && (o2 = c3.find("source").attr("src") || ""), a2 = c3.attr("width") || "auto", s2 = c3.attr("height") || "auto", Dk(o2, i2 = c3.attr("poster") || "", a2, s2, u2 = dk(u2 = c3.attr("style") || ""), dk(r3.attr("style") || "")["text-align"] || "center");
} };
var Ak = { selector: "iframe,video,p", preParseHtml: function(e10) {
  var t2 = fm(e10), n2 = t2;
  if ("p" === sk(t2)) {
    var r3 = t2.children();
    if (1 === r3.length) {
      var o2 = r3[0], i2 = o2.tagName.toLowerCase();
      ["iframe", "video"].includes(i2) && (n2 = fm(o2));
    }
  }
  var a2 = sk(n2);
  if ("iframe" !== a2 && "video" !== a2) return n2[0];
  if ("video" === n2.parent().attr("data-w-e-type")) return n2[0];
  var s2 = fm('<div data-w-e-type="video" data-w-e-is-void style="text-align: center;"></div>');
  return s2.append(n2), s2[0];
} };
var xk = { type: "video", renderElem: function(e10, t2, n2) {
  var r3, o2 = e10, i2 = o2.src, a2 = void 0 === i2 ? "" : i2, s2 = o2.poster, u2 = void 0 === s2 ? "" : s2, l2 = o2.key, c3 = void 0 === l2 ? "" : l2, d2 = o2.width, f2 = void 0 === d2 ? "auto" : d2, p2 = o2.height, h2 = void 0 === p2 ? "auto" : p2, g2 = o2.style, v2 = void 0 === g2 ? {} : g2, m2 = o2.textAlign, y2 = void 0 === m2 ? "center" : m2, b2 = zy.isNodeSelected(n2, e10);
  if (0 === a2.trim().indexOf("<iframe ")) {
    r3 = Pw("div", { className: "w-e-textarea-video-container", "data-selected": b2 ? "true" : "", style: { textAlign: y2 }, innerHTML: uk(a2, f2, h2, v2) });
  } else {
    var E2 = Pw("video", { key: c3, poster: u2, controls: true, style: v2 }, Pw("source", { src: a2, type: "video/mp4" }), "Sorry, your browser doesn't support embedded videos.\n 抱歉，浏览器不支持 video 视频");
    "auto" !== f2 && (E2.data.width = f2), "auto" !== h2 && (E2.data.height = h2), r3 = Pw("div", { className: "w-e-textarea-video-container", "data-selected": b2 ? "true" : "", style: { textAlign: y2 } }, E2);
  }
  var C2 = hw("div", { props: { contentEditable: false }, on: { mousedown: function(e11) {
    return e11.preventDefault();
  } } }, r3);
  return C2;
} }, Ok = { renderElems: [xk], elemsToHtml: [lk], preParseHtml: [Ak], parseElemsHtml: [Sk], menus: [{ key: "insertVideo", factory: function() {
  return new yk();
}, config: { onInsertedVideo: function(e10) {
}, checkVideo: function(e10, t2) {
  return true;
}, parseVideoSrc: function(e10) {
  return e10;
} } }, { key: "uploadVideo", factory: function() {
  return new wk();
}, config: { server: "", fieldName: "wangeditor-uploaded-video", maxFileSize: 10485760, maxNumberOfFiles: 5, allowedFileTypes: ["video/*"], meta: {}, metaWithUrl: false, withCredentials: false, timeout: 3e4, onBeforeUpload: function(e10) {
  return e10;
}, onProgress: function(e10) {
}, onSuccess: function(e10, t2) {
}, onFailed: function(e10, t2) {
  console.error("'".concat(e10.name, "' upload failed"), t2);
}, onError: function(e10, t2, n2) {
  console.error("'".concat(e10.name, " upload error"), t2, n2);
} } }, { key: "editVideoSize", factory: function() {
  return new pk();
} }, { key: "editVideoSrc", factory: function() {
  return new gk();
} }], editorPlugin: function(e10) {
  var t2 = e10.isVoid, n2 = e10.normalizeNode, r3 = e10;
  return r3.isVoid = function(e11) {
    return "video" === e11.type || t2(e11);
  }, r3.normalizeNode = function(e11) {
    var t3 = iv(e11, 2), o2 = t3[0], i2 = t3[1];
    "video" === zy.getNodeType(o2) && (zy.isLastNode(r3, o2) && Wg.insertNodes(r3, zy.genEmptyParagraph(), { at: [i2[0] + 1] }));
    return n2([o2, i2]);
  }, r3;
} };
tC("en", { uploadImgModule: { uploadImage: "Upload Image", uploadError: "{{fileName}} upload error" } }), tC("zh-CN", { uploadImgModule: { uploadImage: "上传图片", uploadError: "{{fileName}} 上传出错" } });
Pm && (fm.fn.append = Pm), Cm && (fm.fn.on = Cm), Hm && (fm.fn.remove = Hm), Em && (fm.fn.val = Em), Vm && (fm.fn.click = Vm), xm && (fm.fn.hide = xm);
var Nk = /* @__PURE__ */ new WeakMap();
function Bk(e10) {
  return e10.getMenuConfig("uploadImage");
}
function Tk(e10, t2) {
  return nv(this, void 0, void 0, function() {
    return rv(this, function(n2) {
      return [2, new Promise(function(n3) {
        var r3 = new FileReader();
        r3.readAsDataURL(t2), r3.onload = function() {
          var o2 = r3.result;
          if (o2) {
            var i2 = o2.toString(), a2 = 0 === i2.indexOf("data:image") ? "" : i2;
            QO(e10, i2, t2.name, a2), n3("ok");
          }
        };
      })];
    });
  });
}
function kk(e10, t2) {
  return nv(this, void 0, void 0, function() {
    var n2, r3;
    return rv(this, function(o2) {
      switch (o2.label) {
        case 0:
          return n2 = function(e11) {
            var t3 = Nk.get(e11);
            if (null != t3) return t3;
            var n3 = Bk(e11), r4 = n3.onSuccess, o3 = n3.onProgress, i2 = n3.onFailed, a2 = n3.customInsert, s2 = n3.onError;
            return t3 = QA(tv(tv({}, n3), { onProgress: function(t4) {
              e11.showProgressBar(t4), o3 && o3(t4);
            }, onSuccess: function(t4, n4) {
              if (a2) return a2(n4, function(t5, n5, r5) {
                return QO(e11, t5, n5, r5);
              }), void r4(t4, n4);
              var o4 = n4.errno, s3 = void 0 === o4 ? 1 : o4, u2 = n4.data, l2 = void 0 === u2 ? {} : u2;
              if (0 === s3) {
                if (Array.isArray(l2)) l2.forEach(function(t5) {
                  var n5 = t5.url, r5 = void 0 === n5 ? "" : n5, o5 = t5.alt, i3 = void 0 === o5 ? "" : o5, a3 = t5.href;
                  QO(e11, r5, i3, void 0 === a3 ? "" : a3);
                });
                else {
                  var c3 = l2.url, d2 = void 0 === c3 ? "" : c3, f2 = l2.alt, p2 = void 0 === f2 ? "" : f2, h2 = l2.href;
                  QO(e11, d2, p2, void 0 === h2 ? "" : h2);
                }
                r4(t4, n4);
              } else i2(t4, n4);
            }, onError: function(e12, t4, n4) {
              s2(e12, t4, n4);
            } })), Nk.set(e11, t3), t3;
          }(e10), r3 = t2.map(function(e11) {
            return { name: e11.name, type: e11.type, size: e11.size, data: e11 };
          }), n2.addFiles(r3), [4, n2.upload()];
        case 1:
          return o2.sent(), [2];
      }
    });
  });
}
function Fk(e10, t2) {
  return nv(this, void 0, void 0, function() {
    var n2, r3, o2, i2, a2, s2, u2, l2, c3, d2, f2, p2, h2, g2, v2;
    return rv(this, function(m2) {
      switch (m2.label) {
        case 0:
          if (null == t2) return [2];
          n2 = Array.prototype.slice.call(t2), r3 = Bk(e10), o2 = r3.customUpload, i2 = r3.base64LimitSize, a2 = [], m2.label = 1;
        case 1:
          m2.trys.push([1, 10, 11, 16]), s2 = true, u2 = sv(n2), m2.label = 2;
        case 2:
          return [4, u2.next()];
        case 3:
          return l2 = m2.sent(), (p2 = l2.done) ? [3, 9] : (v2 = l2.value, s2 = false, d2 = (c3 = v2).size, i2 && d2 <= i2 ? [4, Tk(e10, c3)] : [3, 5]);
        case 4:
          return m2.sent(), [3, 8];
        case 5:
          return o2 ? [4, o2(c3, function(t3, n3, r4) {
            return QO(e10, t3, n3, r4);
          }, e10)] : [3, 7];
        case 6:
          return m2.sent(), [3, 8];
        case 7:
          a2.push(c3), m2.label = 8;
        case 8:
          return s2 = true, [3, 2];
        case 9:
          return [3, 16];
        case 10:
          return f2 = m2.sent(), h2 = { error: f2 }, [3, 16];
        case 11:
          return m2.trys.push([11, , 14, 15]), s2 || p2 || !(g2 = u2.return) ? [3, 13] : [4, g2.call(u2)];
        case 12:
          m2.sent(), m2.label = 13;
        case 13:
          return [3, 15];
        case 14:
          if (h2) throw h2.error;
          return [7];
        case 15:
          return [7];
        case 16:
          return a2.length > 0 ? [4, kk(e10, a2)] : [3, 18];
        case 17:
          m2.sent(), m2.label = 18;
        case 18:
          return [2];
      }
    });
  });
}
var Ik = function() {
  function e10() {
    this.title = iC("uploadImgModule.uploadImage"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M828.708571 585.045333a48.761905 48.761905 0 0 0-48.737523 48.761905v18.529524l-72.143238-72.167619a135.972571 135.972571 0 0 0-191.585524 0l-34.133334 34.133333-120.880762-120.953905a138.898286 138.898286 0 0 0-191.585523 0l-72.167619 72.167619V292.400762a48.786286 48.786286 0 0 1 48.761904-48.761905h341.23581a48.737524 48.737524 0 0 0 34.474667-83.285333 48.737524 48.737524 0 0 0-34.474667-14.287238H146.236952A146.212571 146.212571 0 0 0 0 292.400762v585.289143A146.358857 146.358857 0 0 0 146.236952 1024h584.996572a146.212571 146.212571 0 0 0 146.236952-146.310095V633.807238a48.786286 48.786286 0 0 0-48.761905-48.761905zM146.261333 926.45181a48.737524 48.737524 0 0 1-48.761904-48.761905v-174.128762l141.409523-141.458286a38.497524 38.497524 0 0 1 53.126096 0l154.526476 154.624 209.627428 209.724953H146.236952z m633.734096-48.761905c-0.073143 9.337905-3.145143 18.383238-8.777143 25.843809l-219.843048-220.94019 34.133333-34.133334a37.546667 37.546667 0 0 1 53.613715 0l140.873143 141.897143V877.714286zM1009.615238 160.231619L863.329524 13.897143a48.737524 48.737524 0 0 0-16.091429-10.24c-11.849143-4.87619-25.161143-4.87619-37.059047 0a48.761905 48.761905 0 0 0-16.067048 10.24l-146.236952 146.334476a49.005714 49.005714 0 0 0 69.217523 69.241905l62.902858-63.390476v272.627809a48.761905 48.761905 0 1 0 97.475047 0V166.083048l62.902857 63.390476a48.737524 48.737524 0 0 0 69.217524 0 48.761905 48.761905 0 0 0 0-69.241905z"></path></svg>', this.tag = "button";
  }
  return e10.prototype.getValue = function(e11) {
    return "";
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.isDisabled = function(e11) {
    return XO(e11);
  }, e10.prototype.getMenuConfig = function(e11) {
    return e11.getMenuConfig("uploadImage");
  }, e10.prototype.exec = function(e11, t2) {
    var n2 = this.getMenuConfig(e11), r3 = n2.allowedFileTypes, o2 = void 0 === r3 ? [] : r3, i2 = n2.customBrowseAndUpload;
    if (i2) i2(function(t3, n3, r4) {
      return QO(e11, t3, n3, r4);
    });
    else {
      var a2 = "";
      o2.length > 0 && (a2 = 'accept="'.concat(o2.join(", "), '"'));
      var s2 = fm("body"), u2 = fm('<input type="file" '.concat(a2, " multiple/>"));
      u2.hide(), s2.append(u2), u2.click(), u2.on("change", function() {
        var t3 = u2[0].files;
        Fk(e11, t3);
      });
    }
  }, e10;
}();
var Pk = { menus: [{ key: "uploadImage", factory: function() {
  return new Ik();
}, config: { server: "", fieldName: "wangeditor-uploaded-image", maxFileSize: 2097152, maxNumberOfFiles: 100, allowedFileTypes: ["image/*"], meta: {}, metaWithUrl: false, withCredentials: false, timeout: 1e4, onBeforeUpload: function(e10) {
  return e10;
}, onProgress: function(e10) {
}, onSuccess: function(e10, t2) {
}, onFailed: function(e10, t2) {
  console.error("'".concat(e10.name, "' upload failed"), t2);
}, onError: function(e10, t2, n2) {
  console.error("'".concat(e10.name, "' upload error"), n2);
}, base64LimitSize: 0 } }], editorPlugin: function(e10) {
  var t2 = e10.insertData, n2 = e10;
  return n2.insertData = function(r3) {
    if (XO(n2)) t2(r3);
    else if (r3.getData("text/plain")) t2(r3);
    else {
      var o2 = r3.files;
      if (o2.length <= 0) t2(r3);
      else Array.prototype.slice.call(o2).some(function(e11) {
        return "image" === iv(e11.type.split("/"), 1)[0];
      }) ? Fk(e10, o2) : t2(r3);
    }
  }, n2;
} };
tC("en", { highLightModule: { selectLang: "Language" } }), tC("zh-CN", { highLightModule: { selectLang: "选择语言" } });
var _k2, Rk = { exports: {} };
var Lk = (_k2 || (_k2 = 1, function(e10) {
  var t2 = function(e11) {
    var t3 = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, n2 = 0, r3 = {}, o2 = { manual: e11.Prism && e11.Prism.manual, disableWorkerMessageHandler: e11.Prism && e11.Prism.disableWorkerMessageHandler, util: { encode: function e12(t4) {
      return t4 instanceof i2 ? new i2(t4.type, e12(t4.content), t4.alias) : Array.isArray(t4) ? t4.map(e12) : t4.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
    }, type: function(e12) {
      return Object.prototype.toString.call(e12).slice(8, -1);
    }, objId: function(e12) {
      return e12.__id || Object.defineProperty(e12, "__id", { value: ++n2 }), e12.__id;
    }, clone: function e12(t4, n3) {
      var r4, i3;
      switch (n3 = n3 || {}, o2.util.type(t4)) {
        case "Object":
          if (i3 = o2.util.objId(t4), n3[i3]) return n3[i3];
          for (var a3 in r4 = {}, n3[i3] = r4, t4) t4.hasOwnProperty(a3) && (r4[a3] = e12(t4[a3], n3));
          return r4;
        case "Array":
          return i3 = o2.util.objId(t4), n3[i3] ? n3[i3] : (r4 = [], n3[i3] = r4, t4.forEach(function(t5, o3) {
            r4[o3] = e12(t5, n3);
          }), r4);
        default:
          return t4;
      }
    }, getLanguage: function(e12) {
      for (; e12; ) {
        var n3 = t3.exec(e12.className);
        if (n3) return n3[1].toLowerCase();
        e12 = e12.parentElement;
      }
      return "none";
    }, setLanguage: function(e12, n3) {
      e12.className = e12.className.replace(RegExp(t3, "gi"), ""), e12.classList.add("language-" + n3);
    }, currentScript: function() {
      if ("undefined" == typeof document) return null;
      if (document.currentScript && "SCRIPT" === document.currentScript.tagName) return document.currentScript;
      try {
        throw new Error();
      } catch (r4) {
        var e12 = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r4.stack) || [])[1];
        if (e12) {
          var t4 = document.getElementsByTagName("script");
          for (var n3 in t4) if (t4[n3].src == e12) return t4[n3];
        }
        return null;
      }
    }, isActive: function(e12, t4, n3) {
      for (var r4 = "no-" + t4; e12; ) {
        var o3 = e12.classList;
        if (o3.contains(t4)) return true;
        if (o3.contains(r4)) return false;
        e12 = e12.parentElement;
      }
      return !!n3;
    } }, languages: { plain: r3, plaintext: r3, text: r3, txt: r3, extend: function(e12, t4) {
      var n3 = o2.util.clone(o2.languages[e12]);
      for (var r4 in t4) n3[r4] = t4[r4];
      return n3;
    }, insertBefore: function(e12, t4, n3, r4) {
      var i3 = (r4 = r4 || o2.languages)[e12], a3 = {};
      for (var s3 in i3) if (i3.hasOwnProperty(s3)) {
        if (s3 == t4) for (var u3 in n3) n3.hasOwnProperty(u3) && (a3[u3] = n3[u3]);
        n3.hasOwnProperty(s3) || (a3[s3] = i3[s3]);
      }
      var l3 = r4[e12];
      return r4[e12] = a3, o2.languages.DFS(o2.languages, function(t5, n4) {
        n4 === l3 && t5 != e12 && (this[t5] = a3);
      }), a3;
    }, DFS: function e12(t4, n3, r4, i3) {
      i3 = i3 || {};
      var a3 = o2.util.objId;
      for (var s3 in t4) if (t4.hasOwnProperty(s3)) {
        n3.call(t4, s3, t4[s3], r4 || s3);
        var u3 = t4[s3], l3 = o2.util.type(u3);
        "Object" !== l3 || i3[a3(u3)] ? "Array" !== l3 || i3[a3(u3)] || (i3[a3(u3)] = true, e12(u3, n3, s3, i3)) : (i3[a3(u3)] = true, e12(u3, n3, null, i3));
      }
    } }, plugins: {}, highlightAll: function(e12, t4) {
      o2.highlightAllUnder(document, e12, t4);
    }, highlightAllUnder: function(e12, t4, n3) {
      var r4 = { callback: n3, container: e12, selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code' };
      o2.hooks.run("before-highlightall", r4), r4.elements = Array.prototype.slice.apply(r4.container.querySelectorAll(r4.selector)), o2.hooks.run("before-all-elements-highlight", r4);
      for (var i3, a3 = 0; i3 = r4.elements[a3++]; ) o2.highlightElement(i3, true === t4, r4.callback);
    }, highlightElement: function(t4, n3, r4) {
      var i3 = o2.util.getLanguage(t4), a3 = o2.languages[i3];
      o2.util.setLanguage(t4, i3);
      var s3 = t4.parentElement;
      s3 && "pre" === s3.nodeName.toLowerCase() && o2.util.setLanguage(s3, i3);
      var u3 = { element: t4, language: i3, grammar: a3, code: t4.textContent };
      function l3(e12) {
        u3.highlightedCode = e12, o2.hooks.run("before-insert", u3), u3.element.innerHTML = u3.highlightedCode, o2.hooks.run("after-highlight", u3), o2.hooks.run("complete", u3), r4 && r4.call(u3.element);
      }
      if (o2.hooks.run("before-sanity-check", u3), (s3 = u3.element.parentElement) && "pre" === s3.nodeName.toLowerCase() && !s3.hasAttribute("tabindex") && s3.setAttribute("tabindex", "0"), !u3.code) return o2.hooks.run("complete", u3), void (r4 && r4.call(u3.element));
      if (o2.hooks.run("before-highlight", u3), u3.grammar) if (n3 && e11.Worker) {
        var c4 = new Worker(o2.filename);
        c4.onmessage = function(e12) {
          l3(e12.data);
        }, c4.postMessage(JSON.stringify({ language: u3.language, code: u3.code, immediateClose: true }));
      } else l3(o2.highlight(u3.code, u3.grammar, u3.language));
      else l3(o2.util.encode(u3.code));
    }, highlight: function(e12, t4, n3) {
      var r4 = { code: e12, grammar: t4, language: n3 };
      if (o2.hooks.run("before-tokenize", r4), !r4.grammar) throw new Error('The language "' + r4.language + '" has no grammar.');
      return r4.tokens = o2.tokenize(r4.code, r4.grammar), o2.hooks.run("after-tokenize", r4), i2.stringify(o2.util.encode(r4.tokens), r4.language);
    }, tokenize: function(e12, t4) {
      var n3 = t4.rest;
      if (n3) {
        for (var r4 in n3) t4[r4] = n3[r4];
        delete t4.rest;
      }
      var o3 = new u2();
      return l2(o3, o3.head, e12), s2(e12, o3, t4, o3.head, 0), function(e13) {
        for (var t5 = [], n4 = e13.head.next; n4 !== e13.tail; ) t5.push(n4.value), n4 = n4.next;
        return t5;
      }(o3);
    }, hooks: { all: {}, add: function(e12, t4) {
      var n3 = o2.hooks.all;
      n3[e12] = n3[e12] || [], n3[e12].push(t4);
    }, run: function(e12, t4) {
      var n3 = o2.hooks.all[e12];
      if (n3 && n3.length) for (var r4, i3 = 0; r4 = n3[i3++]; ) r4(t4);
    } }, Token: i2 };
    function i2(e12, t4, n3, r4) {
      this.type = e12, this.content = t4, this.alias = n3, this.length = 0 | (r4 || "").length;
    }
    function a2(e12, t4, n3, r4) {
      e12.lastIndex = t4;
      var o3 = e12.exec(n3);
      if (o3 && r4 && o3[1]) {
        var i3 = o3[1].length;
        o3.index += i3, o3[0] = o3[0].slice(i3);
      }
      return o3;
    }
    function s2(e12, t4, n3, r4, u3, d3) {
      for (var f3 in n3) if (n3.hasOwnProperty(f3) && n3[f3]) {
        var p3 = n3[f3];
        p3 = Array.isArray(p3) ? p3 : [p3];
        for (var h2 = 0; h2 < p3.length; ++h2) {
          if (d3 && d3.cause == f3 + "," + h2) return;
          var g2 = p3[h2], v2 = g2.inside, m2 = !!g2.lookbehind, y2 = !!g2.greedy, b2 = g2.alias;
          if (y2 && !g2.pattern.global) {
            var E2 = g2.pattern.toString().match(/[imsuy]*$/)[0];
            g2.pattern = RegExp(g2.pattern.source, E2 + "g");
          }
          for (var C2 = g2.pattern || g2, w2 = r4.next, D2 = u3; w2 !== t4.tail && !(d3 && D2 >= d3.reach); D2 += w2.value.length, w2 = w2.next) {
            var S2 = w2.value;
            if (t4.length > e12.length) return;
            if (!(S2 instanceof i2)) {
              var A2, x2 = 1;
              if (y2) {
                if (!(A2 = a2(C2, D2, e12, m2)) || A2.index >= e12.length) break;
                var O2 = A2.index, N2 = A2.index + A2[0].length, B2 = D2;
                for (B2 += w2.value.length; O2 >= B2; ) B2 += (w2 = w2.next).value.length;
                if (D2 = B2 -= w2.value.length, w2.value instanceof i2) continue;
                for (var T2 = w2; T2 !== t4.tail && (B2 < N2 || "string" == typeof T2.value); T2 = T2.next) x2++, B2 += T2.value.length;
                x2--, S2 = e12.slice(D2, B2), A2.index -= D2;
              } else if (!(A2 = a2(C2, 0, S2, m2))) continue;
              O2 = A2.index;
              var k2 = A2[0], F2 = S2.slice(0, O2), I2 = S2.slice(O2 + k2.length), P2 = D2 + S2.length;
              d3 && P2 > d3.reach && (d3.reach = P2);
              var _2 = w2.prev;
              if (F2 && (_2 = l2(t4, _2, F2), D2 += F2.length), c3(t4, _2, x2), w2 = l2(t4, _2, new i2(f3, v2 ? o2.tokenize(k2, v2) : k2, b2, k2)), I2 && l2(t4, w2, I2), x2 > 1) {
                var R2 = { cause: f3 + "," + h2, reach: P2 };
                s2(e12, t4, n3, w2.prev, D2, R2), d3 && R2.reach > d3.reach && (d3.reach = R2.reach);
              }
            }
          }
        }
      }
    }
    function u2() {
      var e12 = { value: null, prev: null, next: null }, t4 = { value: null, prev: e12, next: null };
      e12.next = t4, this.head = e12, this.tail = t4, this.length = 0;
    }
    function l2(e12, t4, n3) {
      var r4 = t4.next, o3 = { value: n3, prev: t4, next: r4 };
      return t4.next = o3, r4.prev = o3, e12.length++, o3;
    }
    function c3(e12, t4, n3) {
      for (var r4 = t4.next, o3 = 0; o3 < n3 && r4 !== e12.tail; o3++) r4 = r4.next;
      t4.next = r4, r4.prev = t4, e12.length -= o3;
    }
    if (e11.Prism = o2, i2.stringify = function e12(t4, n3) {
      if ("string" == typeof t4) return t4;
      if (Array.isArray(t4)) {
        var r4 = "";
        return t4.forEach(function(t5) {
          r4 += e12(t5, n3);
        }), r4;
      }
      var i3 = { type: t4.type, content: e12(t4.content, n3), tag: "span", classes: ["token", t4.type], attributes: {}, language: n3 }, a3 = t4.alias;
      a3 && (Array.isArray(a3) ? Array.prototype.push.apply(i3.classes, a3) : i3.classes.push(a3)), o2.hooks.run("wrap", i3);
      var s3 = "";
      for (var u3 in i3.attributes) s3 += " " + u3 + '="' + (i3.attributes[u3] || "").replace(/"/g, "&quot;") + '"';
      return "<" + i3.tag + ' class="' + i3.classes.join(" ") + '"' + s3 + ">" + i3.content + "</" + i3.tag + ">";
    }, !e11.document) return e11.addEventListener ? (o2.disableWorkerMessageHandler || e11.addEventListener("message", function(t4) {
      var n3 = JSON.parse(t4.data), r4 = n3.language, i3 = n3.code, a3 = n3.immediateClose;
      e11.postMessage(o2.highlight(i3, o2.languages[r4], r4)), a3 && e11.close();
    }, false), o2) : o2;
    var d2 = o2.util.currentScript();
    function f2() {
      o2.manual || o2.highlightAll();
    }
    if (d2 && (o2.filename = d2.src, d2.hasAttribute("data-manual") && (o2.manual = true)), !o2.manual) {
      var p2 = document.readyState;
      "loading" === p2 || "interactive" === p2 && d2 && d2.defer ? document.addEventListener("DOMContentLoaded", f2) : window.requestAnimationFrame ? window.requestAnimationFrame(f2) : window.setTimeout(f2, 16);
    }
    return o2;
  }("undefined" != typeof window ? window : "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {});
  /**
  		 * Prism: Lightweight, robust, elegant syntax highlighting
  		 *
  		 * @license MIT <https://opensource.org/licenses/MIT>
  		 * @author Lea Verou <https://lea.verou.me>
  		 * @namespace
  		 * @public
  		 */
  e10.exports && (e10.exports = t2), void 0 !== y && (y.Prism = t2), t2.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: true }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: true }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: true, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: true, greedy: true, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: true }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: true }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: true, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, { pattern: /^(\s*)["']|["']$/, lookbehind: true }] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, t2.languages.markup.tag.inside["attr-value"].inside.entity = t2.languages.markup.entity, t2.languages.markup.doctype.inside["internal-subset"].inside = t2.languages.markup, t2.hooks.add("wrap", function(e11) {
    "entity" === e11.type && (e11.attributes.title = e11.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(t2.languages.markup.tag, "addInlined", { value: function(e11, n2) {
    var r3 = {};
    r3["language-" + n2] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: true, inside: t2.languages[n2] }, r3.cdata = /^<!\[CDATA\[|\]\]>$/i;
    var o2 = { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: r3 } };
    o2["language-" + n2] = { pattern: /[\s\S]+/, inside: t2.languages[n2] };
    var i2 = {};
    i2[e11] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
      return e11;
    }), "i"), lookbehind: true, greedy: true, inside: o2 }, t2.languages.insertBefore("markup", "cdata", i2);
  } }), Object.defineProperty(t2.languages.markup.tag, "addAttribute", { value: function(e11, n2) {
    t2.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + e11 + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: true, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: true, alias: [n2, "language-" + n2], inside: t2.languages[n2] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
  } }), t2.languages.html = t2.languages.markup, t2.languages.mathml = t2.languages.markup, t2.languages.svg = t2.languages.markup, t2.languages.xml = t2.languages.extend("markup", {}), t2.languages.ssml = t2.languages.xml, t2.languages.atom = t2.languages.xml, t2.languages.rss = t2.languages.xml, function(e11) {
    var t3 = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    e11.languages.css = { comment: /\/\*[\s\S]*?\*\//, atrule: { pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t3.source + ")*?" + /(?:;|(?=\s*\{))/.source), inside: { rule: /^@[\w-]+/, "selector-function-argument": { pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind: true, alias: "selector" }, keyword: { pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/, lookbehind: true } } }, url: { pattern: RegExp("\\burl\\((?:" + t3.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy: true, inside: { function: /^url/i, punctuation: /^\(|\)$/, string: { pattern: RegExp("^" + t3.source + "$"), alias: "url" } } }, selector: { pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t3.source + ")*(?=\\s*\\{)"), lookbehind: true }, string: { pattern: t3, greedy: true }, property: { pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, lookbehind: true }, important: /!important\b/i, function: { pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind: true }, punctuation: /[(){};:,]/ }, e11.languages.css.atrule.inside.rest = e11.languages.css;
    var n2 = e11.languages.markup;
    n2 && (n2.tag.addInlined("style", "css"), n2.tag.addAttribute("style", "css"));
  }(t2), t2.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind: true, greedy: true }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: true, greedy: true }], string: { pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: true }, "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind: true, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, boolean: /\b(?:false|true)\b/, function: /\b\w+(?=\()/, number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation: /[{}[\];(),.:]/ }, t2.languages.javascript = t2.languages.extend("clike", { "class-name": [t2.languages.clike["class-name"], { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind: true }], keyword: [{ pattern: /((?:^|\})\s*)catch\b/, lookbehind: true }, { pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind: true }], function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, number: { pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source), lookbehind: true }, operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/ }), t2.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, t2.languages.insertBefore("javascript", "keyword", { regex: { pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source), lookbehind: true, greedy: true, inside: { "regex-source": { pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind: true, alias: "language-regex", inside: t2.languages.regex }, "regex-delimiter": /^\/|\/$/, "regex-flags": /^[a-z]+$/ } }, "function-variable": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias: "function" }, parameter: [{ pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, lookbehind: true, inside: t2.languages.javascript }, { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind: true, inside: t2.languages.javascript }, { pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind: true, inside: t2.languages.javascript }, { pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, lookbehind: true, inside: t2.languages.javascript }], constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/ }), t2.languages.insertBefore("javascript", "string", { hashbang: { pattern: /^#!.*/, greedy: true, alias: "comment" }, "template-string": { pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy: true, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind: true, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: t2.languages.javascript } }, string: /[\s\S]+/ } }, "string-property": { pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind: true, greedy: true, alias: "property" } }), t2.languages.insertBefore("javascript", "operator", { "literal-property": { pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind: true, alias: "property" } }), t2.languages.markup && (t2.languages.markup.tag.addInlined("script", "javascript"), t2.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), t2.languages.js = t2.languages.javascript, function() {
    if (void 0 !== t2 && "undefined" != typeof document) {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
      var e11 = { js: "javascript", py: "python", rb: "ruby", ps1: "powershell", psm1: "powershell", sh: "bash", bat: "batch", h: "c", tex: "latex" }, n2 = "data-src-status", r3 = "loading", o2 = "loaded", i2 = "pre[data-src]:not([" + n2 + '="' + o2 + '"]):not([' + n2 + '="' + r3 + '"])';
      t2.hooks.add("before-highlightall", function(e12) {
        e12.selector += ", " + i2;
      }), t2.hooks.add("before-sanity-check", function(a3) {
        var s2 = a3.element;
        if (s2.matches(i2)) {
          a3.code = "", s2.setAttribute(n2, r3);
          var u2 = s2.appendChild(document.createElement("CODE"));
          u2.textContent = "Loading…";
          var l2 = s2.getAttribute("data-src"), c3 = a3.language;
          if ("none" === c3) {
            var d2 = (/\.(\w+)$/.exec(l2) || [, "none"])[1];
            c3 = e11[d2] || d2;
          }
          t2.util.setLanguage(u2, c3), t2.util.setLanguage(s2, c3);
          var f2 = t2.plugins.autoloader;
          f2 && f2.loadLanguages(c3), function(e12, t3, n3) {
            var r4 = new XMLHttpRequest();
            r4.open("GET", e12, true), r4.onreadystatechange = function() {
              4 == r4.readyState && (r4.status < 400 && r4.responseText ? t3(r4.responseText) : r4.status >= 400 ? n3("✖ Error " + r4.status + " while fetching file: " + r4.statusText) : n3("✖ Error: File does not exist or is empty"));
            }, r4.send(null);
          }(l2, function(e12) {
            s2.setAttribute(n2, o2);
            var r4 = function(e13) {
              var t3 = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(e13 || "");
              if (t3) {
                var n3 = Number(t3[1]), r5 = t3[2], o3 = t3[3];
                return r5 ? o3 ? [n3, Number(o3)] : [n3, void 0] : [n3, n3];
              }
            }(s2.getAttribute("data-range"));
            if (r4) {
              var i3 = e12.split(/\r\n?|\n/g), a4 = r4[0], l3 = null == r4[1] ? i3.length : r4[1];
              a4 < 0 && (a4 += i3.length), a4 = Math.max(0, Math.min(a4 - 1, i3.length)), l3 < 0 && (l3 += i3.length), l3 = Math.max(0, Math.min(l3, i3.length)), e12 = i3.slice(a4, l3).join("\n"), s2.hasAttribute("data-start") || s2.setAttribute("data-start", String(a4 + 1));
            }
            u2.textContent = e12, t2.highlightElement(u2);
          }, function(e12) {
            s2.setAttribute(n2, "failed"), u2.textContent = e12;
          });
        }
      }), t2.plugins.fileHighlight = { highlight: function(e12) {
        for (var n3, r4 = (e12 || document).querySelectorAll(i2), o3 = 0; n3 = r4[o3++]; ) t2.highlightElement(n3);
      } };
      var a2 = false;
      t2.fileHighlight = function() {
        a2 || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), a2 = true), t2.plugins.fileHighlight.highlight.apply(this, arguments);
      };
    }
  }();
}(Rk)), Rk.exports), Mk = b(Lk);
!function(e10) {
  var t2 = e10.util.clone(e10.languages.javascript), n2 = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, r3 = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, o2 = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
  function i2(e11, t3) {
    return e11 = e11.replace(/<S>/g, function() {
      return n2;
    }).replace(/<BRACES>/g, function() {
      return r3;
    }).replace(/<SPREAD>/g, function() {
      return o2;
    }), RegExp(e11, t3);
  }
  o2 = i2(o2).source, e10.languages.jsx = e10.languages.extend("markup", t2), e10.languages.jsx.tag.pattern = i2(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), e10.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, e10.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, e10.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, e10.languages.jsx.tag.inside.comment = t2.comment, e10.languages.insertBefore("inside", "attr-name", { spread: { pattern: i2(/<SPREAD>/.source), inside: e10.languages.jsx } }, e10.languages.jsx.tag), e10.languages.insertBefore("inside", "special-attr", { script: { pattern: i2(/=<BRACES>/.source), alias: "language-javascript", inside: { "script-punctuation": { pattern: /^=(?=\{)/, alias: "punctuation" }, rest: e10.languages.jsx } } }, e10.languages.jsx.tag);
  var a2 = function(e11) {
    return e11 ? "string" == typeof e11 ? e11 : "string" == typeof e11.content ? e11.content : e11.content.map(a2).join("") : "";
  }, s2 = function(t3) {
    for (var n3 = [], r4 = 0; r4 < t3.length; r4++) {
      var o3 = t3[r4], i3 = false;
      if ("string" != typeof o3 && ("tag" === o3.type && o3.content[0] && "tag" === o3.content[0].type ? "</" === o3.content[0].content[0].content ? n3.length > 0 && n3[n3.length - 1].tagName === a2(o3.content[0].content[1]) && n3.pop() : "/>" === o3.content[o3.content.length - 1].content || n3.push({ tagName: a2(o3.content[0].content[1]), openedBraces: 0 }) : n3.length > 0 && "punctuation" === o3.type && "{" === o3.content ? n3[n3.length - 1].openedBraces++ : n3.length > 0 && n3[n3.length - 1].openedBraces > 0 && "punctuation" === o3.type && "}" === o3.content ? n3[n3.length - 1].openedBraces-- : i3 = true), (i3 || "string" == typeof o3) && n3.length > 0 && 0 === n3[n3.length - 1].openedBraces) {
        var u2 = a2(o3);
        r4 < t3.length - 1 && ("string" == typeof t3[r4 + 1] || "plain-text" === t3[r4 + 1].type) && (u2 += a2(t3[r4 + 1]), t3.splice(r4 + 1, 1)), r4 > 0 && ("string" == typeof t3[r4 - 1] || "plain-text" === t3[r4 - 1].type) && (u2 = a2(t3[r4 - 1]) + u2, t3.splice(r4 - 1, 1), r4--), t3[r4] = new e10.Token("plain-text", u2, null, u2);
      }
      o3.content && "string" != typeof o3.content && s2(o3.content);
    }
  };
  e10.hooks.add("after-tokenize", function(e11) {
    "jsx" !== e11.language && "tsx" !== e11.language || s2(e11.tokens);
  });
}(Prism);
var jk;
jk || (jk = 1, function(e10) {
  e10.languages.typescript = e10.languages.extend("javascript", { "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind: true, greedy: true, inside: null }, builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/ }), e10.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e10.languages.typescript.parameter, delete e10.languages.typescript["literal-property"];
  var t2 = e10.languages.extend("typescript", {});
  delete t2["class-name"], e10.languages.typescript["class-name"].inside = t2, e10.languages.insertBefore("typescript", "function", { decorator: { pattern: /@[$\w\xA0-\uFFFF]+/, inside: { at: { pattern: /^@/, alias: "operator" }, function: /^[\s\S]+/ } }, "generic-function": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy: true, inside: { function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: t2 } } } }), e10.languages.ts = e10.languages.typescript;
}(Prism)), Prism.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: true }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: true }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: true, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: true, greedy: true, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: true }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: true }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: true, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, { pattern: /^(\s*)["']|["']$/, lookbehind: true }] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(e10) {
  "entity" === e10.type && (e10.attributes.title = e10.content.replace(/&amp;/, "&"));
}), Object.defineProperty(Prism.languages.markup.tag, "addInlined", { value: function(e10, t2) {
  var n2 = {};
  n2["language-" + t2] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: true, inside: Prism.languages[t2] }, n2.cdata = /^<!\[CDATA\[|\]\]>$/i;
  var r3 = { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: n2 } };
  r3["language-" + t2] = { pattern: /[\s\S]+/, inside: Prism.languages[t2] };
  var o2 = {};
  o2[e10] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
    return e10;
  }), "i"), lookbehind: true, greedy: true, inside: r3 }, Prism.languages.insertBefore("markup", "cdata", o2);
} }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", { value: function(e10, t2) {
  Prism.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + e10 + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: true, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: true, alias: [t2, "language-" + t2], inside: Prism.languages[t2] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
} }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml, Prism.languages.go = Prism.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind: true, greedy: true }, keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean: /\b(?:_|false|iota|nil|true)\b/, number: [/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/ }), Prism.languages.insertBefore("go", "string", { char: { pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/, greedy: true } }), delete Prism.languages.go["class-name"];
var Hk;
Hk || (Hk = 1, function(e10) {
  var t2 = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, n2 = [{ pattern: /\b(?:false|true)\b/i, alias: "boolean" }, { pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i, greedy: true, lookbehind: true }, { pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i, greedy: true, lookbehind: true }, /\b(?:null)\b/i, /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/], r3 = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, o2 = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, i2 = /[{}\[\](),:;]/;
  e10.languages.php = { delimiter: { pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i, alias: "important" }, comment: t2, variable: /\$+(?:\w+\b|(?=\{))/, package: { pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, lookbehind: true, inside: { punctuation: /\\/ } }, "class-name-definition": { pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i, lookbehind: true, alias: "class-name" }, "function-definition": { pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i, lookbehind: true, alias: "function" }, keyword: [{ pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i, alias: "type-casting", greedy: true, lookbehind: true }, { pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i, alias: "type-hint", greedy: true, lookbehind: true }, { pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i, alias: "return-type", greedy: true, lookbehind: true }, { pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i, alias: "type-declaration", greedy: true }, { pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i, alias: "type-declaration", greedy: true, lookbehind: true }, { pattern: /\b(?:parent|self|static)(?=\s*::)/i, alias: "static-context", greedy: true }, { pattern: /(\byield\s+)from\b/i, lookbehind: true }, /\bclass\b/i, { pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i, lookbehind: true }], "argument-name": { pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i, lookbehind: true }, "class-name": [{ pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i, greedy: true, lookbehind: true }, { pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i, greedy: true, lookbehind: true }, { pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i, greedy: true }, { pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i, alias: "class-name-fully-qualified", greedy: true, lookbehind: true, inside: { punctuation: /\\/ } }, { pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i, alias: "class-name-fully-qualified", greedy: true, inside: { punctuation: /\\/ } }, { pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, alias: "class-name-fully-qualified", greedy: true, lookbehind: true, inside: { punctuation: /\\/ } }, { pattern: /\b[a-z_]\w*(?=\s*\$)/i, alias: "type-declaration", greedy: true }, { pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i, alias: ["class-name-fully-qualified", "type-declaration"], greedy: true, inside: { punctuation: /\\/ } }, { pattern: /\b[a-z_]\w*(?=\s*::)/i, alias: "static-context", greedy: true }, { pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i, alias: ["class-name-fully-qualified", "static-context"], greedy: true, inside: { punctuation: /\\/ } }, { pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i, alias: "type-hint", greedy: true, lookbehind: true }, { pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i, alias: ["class-name-fully-qualified", "type-hint"], greedy: true, lookbehind: true, inside: { punctuation: /\\/ } }, { pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i, alias: "return-type", greedy: true, lookbehind: true }, { pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, alias: ["class-name-fully-qualified", "return-type"], greedy: true, lookbehind: true, inside: { punctuation: /\\/ } }], constant: n2, function: { pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i, lookbehind: true, inside: { punctuation: /\\/ } }, property: { pattern: /(->\s*)\w+/, lookbehind: true }, number: r3, operator: o2, punctuation: i2 };
  var a2 = { pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/, lookbehind: true, inside: e10.languages.php }, s2 = [{ pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/, alias: "nowdoc-string", greedy: true, inside: { delimiter: { pattern: /^<<<'[^']+'|[a-z_]\w*;$/i, alias: "symbol", inside: { punctuation: /^<<<'?|[';]$/ } } } }, { pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i, alias: "heredoc-string", greedy: true, inside: { delimiter: { pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i, alias: "symbol", inside: { punctuation: /^<<<"?|[";]$/ } }, interpolation: a2 } }, { pattern: /`(?:\\[\s\S]|[^\\`])*`/, alias: "backtick-quoted-string", greedy: true }, { pattern: /'(?:\\[\s\S]|[^\\'])*'/, alias: "single-quoted-string", greedy: true }, { pattern: /"(?:\\[\s\S]|[^\\"])*"/, alias: "double-quoted-string", greedy: true, inside: { interpolation: a2 } }];
  e10.languages.insertBefore("php", "variable", { string: s2, attribute: { pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im, greedy: true, inside: { "attribute-content": { pattern: /^(#\[)[\s\S]+(?=\]$)/, lookbehind: true, inside: { comment: t2, string: s2, "attribute-class-name": [{ pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i, alias: "class-name", greedy: true, lookbehind: true }, { pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i, alias: ["class-name", "class-name-fully-qualified"], greedy: true, lookbehind: true, inside: { punctuation: /\\/ } }], constant: n2, number: r3, operator: o2, punctuation: i2 } }, delimiter: { pattern: /^#\[|\]$/, alias: "punctuation" } } } }), e10.hooks.add("before-tokenize", function(t3) {
    /<\?/.test(t3.code) && e10.languages["markup-templating"].buildPlaceholders(t3, "php", /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g);
  }), e10.hooks.add("after-tokenize", function(t3) {
    e10.languages["markup-templating"].tokenizePlaceholders(t3, "php");
  });
}(Prism)), Prism.languages.c = Prism.languages.extend("clike", { comment: { pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: true }, string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: true }, "class-name": { pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind: true }, keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, function: /\b[a-z_]\w*(?=\s*\()/i, number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/ }), Prism.languages.insertBefore("c", "string", { char: { pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy: true } }), Prism.languages.insertBefore("c", "string", { macro: { pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind: true, greedy: true, alias: "property", inside: { string: [{ pattern: /^(#\s*include\s*)<[^>]+>/, lookbehind: true }, Prism.languages.c.string], char: Prism.languages.c.char, comment: Prism.languages.c.comment, "macro-name": [{ pattern: /(^#\s*define\s+)\w+\b(?!\()/i, lookbehind: true }, { pattern: /(^#\s*define\s+)\w+\b(?=\()/i, lookbehind: true, alias: "function" }], directive: { pattern: /^(#\s*)[a-z]+/, lookbehind: true, alias: "keyword" }, "directive-hash": /^#/, punctuation: /##|\\(?=[\r\n])/, expression: { pattern: /\S[\s\S]*/, inside: Prism.languages.c } } } }), Prism.languages.insertBefore("c", "function", { constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/ }), delete Prism.languages.c.boolean;
var zk;
zk || (zk = 1, Prism.languages.python = { comment: { pattern: /(^|[^\\])#.*/, lookbehind: true, greedy: true }, "string-interpolation": { pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i, greedy: true, inside: { interpolation: { pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/, lookbehind: true, inside: { "format-spec": { pattern: /(:)[^:(){}]+(?=\}$)/, lookbehind: true }, "conversion-option": { pattern: /![sra](?=[:}]$)/, alias: "punctuation" }, rest: null } }, string: /[\s\S]+/ } }, "triple-quoted-string": { pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i, greedy: true, alias: "string" }, string: { pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i, greedy: true }, function: { pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g, lookbehind: true }, "class-name": { pattern: /(\bclass\s+)\w+/i, lookbehind: true }, decorator: { pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m, lookbehind: true, alias: ["annotation", "punctuation"], inside: { punctuation: /\./ } }, keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/, builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/, boolean: /\b(?:False|None|True)\b/, number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i, operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/, punctuation: /[{}[\];(),.:]/ }, Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python, Prism.languages.py = Prism.languages.python);
var $k;
$k || ($k = 1, function(e10) {
  var t2 = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, n2 = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, r3 = { pattern: RegExp(/(^|[^\w.])/.source + n2 + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source), lookbehind: true, inside: { namespace: { pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/, inside: { punctuation: /\./ } }, punctuation: /\./ } };
  e10.languages.java = e10.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/, lookbehind: true, greedy: true }, "class-name": [r3, { pattern: RegExp(/(^|[^\w.])/.source + n2 + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source), lookbehind: true, inside: r3.inside }, { pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + n2 + /[A-Z]\w*\b/.source), lookbehind: true, inside: r3.inside }], keyword: t2, function: [e10.languages.clike.function, { pattern: /(::\s*)[a-z_]\w*/, lookbehind: true }], number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i, operator: { pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m, lookbehind: true }, constant: /\b[A-Z][A-Z_\d]+\b/ }), e10.languages.insertBefore("java", "string", { "triple-quoted-string": { pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/, greedy: true, alias: "string" }, char: { pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/, greedy: true } }), e10.languages.insertBefore("java", "class-name", { annotation: { pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/, lookbehind: true, alias: "punctuation" }, generics: { pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/, inside: { "class-name": r3, keyword: t2, punctuation: /[<>(),.:]/, operator: /[?&|]/ } }, import: [{ pattern: RegExp(/(\bimport\s+)/.source + n2 + /(?:[A-Z]\w*|\*)(?=\s*;)/.source), lookbehind: true, inside: { namespace: r3.inside.namespace, punctuation: /\./, operator: /\*/, "class-name": /\w+/ } }, { pattern: RegExp(/(\bimport\s+static\s+)/.source + n2 + /(?:\w+|\*)(?=\s*;)/.source), lookbehind: true, alias: "static", inside: { namespace: r3.inside.namespace, static: /\b\w+$/, punctuation: /\./, operator: /\*/, "class-name": /\w+/ } }], namespace: { pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
    return t2.source;
  })), lookbehind: true, inside: { punctuation: /\./ } } });
}(Prism));
var Uk;
Uk || (Uk = 1, function(e10) {
  var t2 = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, n2 = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return t2.source;
  });
  e10.languages.cpp = e10.languages.extend("c", { "class-name": [{ pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
    return t2.source;
  })), lookbehind: true }, /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/, /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i, /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/], keyword: t2, number: { pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i, greedy: true }, operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/, boolean: /\b(?:false|true)\b/ }), e10.languages.insertBefore("cpp", "string", { module: { pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
    return n2;
  }) + ")"), lookbehind: true, greedy: true, inside: { string: /^[<"][\s\S]+/, operator: /:/, punctuation: /\./ } }, "raw-string": { pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/, alias: "string", greedy: true } }), e10.languages.insertBefore("cpp", "keyword", { "generic-function": { pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i, inside: { function: /^\w+/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: e10.languages.cpp } } } }), e10.languages.insertBefore("cpp", "operator", { "double-colon": { pattern: /::/, alias: "punctuation" } }), e10.languages.insertBefore("cpp", "class-name", { "base-clause": { pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/, lookbehind: true, greedy: true, inside: e10.languages.extend("cpp", {}) } }), e10.languages.insertBefore("inside", "double-colon", { "class-name": /\b[a-z_]\w*\b(?!\s*::)/i }, e10.languages.cpp["base-clause"]);
}(Prism));
var Vk;
Vk || (Vk = 1, function(e10) {
  function t2(e11, t3) {
    return e11.replace(/<<(\d+)>>/g, function(e12, n3) {
      return "(?:" + t3[+n3] + ")";
    });
  }
  function n2(e11, n3, r4) {
    return RegExp(t2(e11, n3), "");
  }
  function r3(e11, t3) {
    for (var n3 = 0; n3 < t3; n3++) e11 = e11.replace(/<<self>>/g, function() {
      return "(?:" + e11 + ")";
    });
    return e11.replace(/<<self>>/g, "[^\\s\\S]");
  }
  var o2 = "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void", i2 = "class enum interface record struct", a2 = "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)", s2 = "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield";
  function u2(e11) {
    return "\\b(?:" + e11.trim().replace(/ /g, "|") + ")\\b";
  }
  var l2 = u2(i2), c3 = RegExp(u2(o2 + " " + i2 + " " + a2 + " " + s2)), d2 = u2(i2 + " " + a2 + " " + s2), f2 = u2(o2 + " " + i2 + " " + s2), p2 = r3(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), h2 = r3(/\((?:[^()]|<<self>>)*\)/.source, 2), g2 = /@?\b[A-Za-z_]\w*\b/.source, v2 = t2(/<<0>>(?:\s*<<1>>)?/.source, [g2, p2]), m2 = t2(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [d2, v2]), y2 = /\[\s*(?:,\s*)*\]/.source, b2 = t2(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [m2, y2]), E2 = t2(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [p2, h2, y2]), C2 = t2(/\(<<0>>+(?:,<<0>>+)+\)/.source, [E2]), w2 = t2(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [C2, m2, y2]), D2 = { keyword: c3, punctuation: /[<>()?,.:[\]]/ }, S2 = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, A2 = /"(?:\\.|[^\\"\r\n])*"/.source, x2 = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
  e10.languages.csharp = e10.languages.extend("clike", { string: [{ pattern: n2(/(^|[^$\\])<<0>>/.source, [x2]), lookbehind: true, greedy: true }, { pattern: n2(/(^|[^@$\\])<<0>>/.source, [A2]), lookbehind: true, greedy: true }], "class-name": [{ pattern: n2(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [m2]), lookbehind: true, inside: D2 }, { pattern: n2(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [g2, w2]), lookbehind: true, inside: D2 }, { pattern: n2(/(\busing\s+)<<0>>(?=\s*=)/.source, [g2]), lookbehind: true }, { pattern: n2(/(\b<<0>>\s+)<<1>>/.source, [l2, v2]), lookbehind: true, inside: D2 }, { pattern: n2(/(\bcatch\s*\(\s*)<<0>>/.source, [m2]), lookbehind: true, inside: D2 }, { pattern: n2(/(\bwhere\s+)<<0>>/.source, [g2]), lookbehind: true }, { pattern: n2(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [b2]), lookbehind: true, inside: D2 }, { pattern: n2(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [w2, f2, g2]), inside: D2 }], keyword: c3, number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i, operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/, punctuation: /\?\.?|::|[{}[\];(),.:]/ }), e10.languages.insertBefore("csharp", "number", { range: { pattern: /\.\./, alias: "operator" } }), e10.languages.insertBefore("csharp", "punctuation", { "named-parameter": { pattern: n2(/([(,]\s*)<<0>>(?=\s*:)/.source, [g2]), lookbehind: true, alias: "punctuation" } }), e10.languages.insertBefore("csharp", "class-name", { namespace: { pattern: n2(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [g2]), lookbehind: true, inside: { punctuation: /\./ } }, "type-expression": { pattern: n2(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [h2]), lookbehind: true, alias: "class-name", inside: D2 }, "return-type": { pattern: n2(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [w2, m2]), inside: D2, alias: "class-name" }, "constructor-invocation": { pattern: n2(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [w2]), lookbehind: true, inside: D2, alias: "class-name" }, "generic-method": { pattern: n2(/<<0>>\s*<<1>>(?=\s*\()/.source, [g2, p2]), inside: { function: n2(/^<<0>>/.source, [g2]), generic: { pattern: RegExp(p2), alias: "class-name", inside: D2 } } }, "type-list": { pattern: n2(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [l2, v2, g2, w2, c3.source, h2, /\bnew\s*\(\s*\)/.source]), lookbehind: true, inside: { "record-arguments": { pattern: n2(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [v2, h2]), lookbehind: true, greedy: true, inside: e10.languages.csharp }, keyword: c3, "class-name": { pattern: RegExp(w2), greedy: true, inside: D2 }, punctuation: /[,()]/ } }, preprocessor: { pattern: /(^[\t ]*)#.*/m, lookbehind: true, alias: "property", inside: { directive: { pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/, lookbehind: true, alias: "keyword" } } } });
  var O2 = A2 + "|" + S2, N2 = t2(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [O2]), B2 = r3(t2(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [N2]), 2), T2 = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, k2 = t2(/<<0>>(?:\s*\(<<1>>*\))?/.source, [m2, B2]);
  e10.languages.insertBefore("csharp", "class-name", { attribute: { pattern: n2(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [T2, k2]), lookbehind: true, greedy: true, inside: { target: { pattern: n2(/^<<0>>(?=\s*:)/.source, [T2]), alias: "keyword" }, "attribute-arguments": { pattern: n2(/\(<<0>>*\)/.source, [B2]), inside: e10.languages.csharp }, "class-name": { pattern: RegExp(m2), inside: { punctuation: /\./ } }, punctuation: /[:,]/ } } });
  var F2 = /:[^}\r\n]+/.source, I2 = r3(t2(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [N2]), 2), P2 = t2(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [I2, F2]), _2 = r3(t2(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [O2]), 2), R2 = t2(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [_2, F2]);
  function L2(t3, r4) {
    return { interpolation: { pattern: n2(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [t3]), lookbehind: true, inside: { "format-string": { pattern: n2(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [r4, F2]), lookbehind: true, inside: { punctuation: /^:/ } }, punctuation: /^\{|\}$/, expression: { pattern: /[\s\S]+/, alias: "language-csharp", inside: e10.languages.csharp } } }, string: /[\s\S]+/ };
  }
  e10.languages.insertBefore("csharp", "string", { "interpolation-string": [{ pattern: n2(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [P2]), lookbehind: true, greedy: true, inside: L2(P2, I2) }, { pattern: n2(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [R2]), lookbehind: true, greedy: true, inside: L2(R2, _2) }], char: { pattern: RegExp(S2), greedy: true } }), e10.languages.dotnet = e10.languages.cs = e10.languages.csharp;
}(Prism)), Prism.languages["visual-basic"] = { comment: { pattern: /(?:['‘’]|REM\b)(?:[^\r\n_]|_(?:\r\n?|\n)?)*/i, inside: { keyword: /^REM/i } }, directive: { pattern: /#(?:Const|Else|ElseIf|End|ExternalChecksum|ExternalSource|If|Region)(?:\b_[ \t]*(?:\r\n?|\n)|.)+/i, alias: "property", greedy: true }, string: { pattern: /\$?["“”](?:["“”]{2}|[^"“”])*["“”]C?/i, greedy: true }, date: { pattern: /#[ \t]*(?:\d+([/-])\d+\1\d+(?:[ \t]+(?:\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?))?|\d+[ \t]*(?:AM|PM)|\d+:\d+(?::\d+)?(?:[ \t]*(?:AM|PM))?)[ \t]*#/i, alias: "number" }, number: /(?:(?:\b\d+(?:\.\d+)?|\.\d+)(?:E[+-]?\d+)?|&[HO][\dA-F]+)(?:[FRD]|U?[ILS])?/i, boolean: /\b(?:False|Nothing|True)\b/i, keyword: /\b(?:AddHandler|AddressOf|Alias|And(?:Also)?|As|Boolean|ByRef|Byte|ByVal|Call|Case|Catch|C(?:Bool|Byte|Char|Date|Dbl|Dec|Int|Lng|Obj|SByte|Short|Sng|Str|Type|UInt|ULng|UShort)|Char|Class|Const|Continue|Currency|Date|Decimal|Declare|Default|Delegate|Dim|DirectCast|Do|Double|Each|Else(?:If)?|End(?:If)?|Enum|Erase|Error|Event|Exit|Finally|For|Friend|Function|Get(?:Type|XMLNamespace)?|Global|GoSub|GoTo|Handles|If|Implements|Imports|In|Inherits|Integer|Interface|Is|IsNot|Let|Lib|Like|Long|Loop|Me|Mod|Module|Must(?:Inherit|Override)|My(?:Base|Class)|Namespace|Narrowing|New|Next|Not(?:Inheritable|Overridable)?|Object|Of|On|Operator|Option(?:al)?|Or(?:Else)?|Out|Overloads|Overridable|Overrides|ParamArray|Partial|Private|Property|Protected|Public|RaiseEvent|ReadOnly|ReDim|RemoveHandler|Resume|Return|SByte|Select|Set|Shadows|Shared|short|Single|Static|Step|Stop|String|Structure|Sub|SyncLock|Then|Throw|To|Try|TryCast|Type|TypeOf|U(?:Integer|Long|Short)|Until|Using|Variant|Wend|When|While|Widening|With(?:Events)?|WriteOnly|Xor)\b/i, operator: /[+\-*/\\^<=>&#@$%!]|\b_(?=[ \t]*[\r\n])/, punctuation: /[{}().,:?]/ }, Prism.languages.vb = Prism.languages["visual-basic"], Prism.languages.vba = Prism.languages["visual-basic"], Prism.languages.sql = { comment: { pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/, lookbehind: true }, variable: [{ pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/, greedy: true }, /@[\w.$]+/], string: { pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/, greedy: true, lookbehind: true }, identifier: { pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/, greedy: true, lookbehind: true, inside: { punctuation: /^`|`$/ } }, function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i, keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i, boolean: /\b(?:FALSE|NULL|TRUE)\b/i, number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i, operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i, punctuation: /[;[\]()`,.]/ };
var Wk;
Wk || (Wk = 1, function(e10) {
  e10.languages.ruby = e10.languages.extend("clike", { comment: { pattern: /#.*|^=begin\s[\s\S]*?^=end/m, greedy: true }, "class-name": { pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/, lookbehind: true, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/, operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/, punctuation: /[(){}[\].,;]/ }), e10.languages.insertBefore("ruby", "operator", { "double-colon": { pattern: /::/, alias: "punctuation" } });
  var t2 = { pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/, lookbehind: true, inside: { content: { pattern: /^(#\{)[\s\S]+(?=\}$)/, lookbehind: true, inside: e10.languages.ruby }, delimiter: { pattern: /^#\{|\}$/, alias: "punctuation" } } };
  delete e10.languages.ruby.function;
  var n2 = "(?:" + [/([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source, /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source, /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source, /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source, /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source].join("|") + ")", r3 = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
  e10.languages.insertBefore("ruby", "keyword", { "regex-literal": [{ pattern: RegExp(/%r/.source + n2 + /[egimnosux]{0,6}/.source), greedy: true, inside: { interpolation: t2, regex: /[\s\S]+/ } }, { pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/, lookbehind: true, greedy: true, inside: { interpolation: t2, regex: /[\s\S]+/ } }], variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/, symbol: [{ pattern: RegExp(/(^|[^:]):/.source + r3), lookbehind: true, greedy: true }, { pattern: RegExp(/([\r\n{(,][ \t]*)/.source + r3 + /(?=:(?!:))/.source), lookbehind: true, greedy: true }], "method-definition": { pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/, lookbehind: true, inside: { function: /\b\w+$/, keyword: /^self\b/, "class-name": /^\w+/, punctuation: /\./ } } }), e10.languages.insertBefore("ruby", "string", { "string-literal": [{ pattern: RegExp(/%[qQiIwWs]?/.source + n2), greedy: true, inside: { interpolation: t2, string: /[\s\S]+/ } }, { pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/, greedy: true, inside: { interpolation: t2, string: /[\s\S]+/ } }, { pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i, alias: "heredoc-string", greedy: true, inside: { delimiter: { pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i, inside: { symbol: /\b\w+/, punctuation: /^<<[-~]?/ } }, interpolation: t2, string: /[\s\S]+/ } }, { pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i, alias: "heredoc-string", greedy: true, inside: { delimiter: { pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i, inside: { symbol: /\b\w+/, punctuation: /^<<[-~]?'|'$/ } }, string: /[\s\S]+/ } }], "command-literal": [{ pattern: RegExp(/%x/.source + n2), greedy: true, inside: { interpolation: t2, command: { pattern: /[\s\S]+/, alias: "string" } } }, { pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/, greedy: true, inside: { interpolation: t2, command: { pattern: /[\s\S]+/, alias: "string" } } }] }), delete e10.languages.ruby.string, e10.languages.insertBefore("ruby", "number", { builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/, constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/ }), e10.languages.rb = e10.languages.ruby;
}(Prism)), Prism.languages.swift = { comment: { pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/, lookbehind: true, greedy: true }, "string-literal": [{ pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source), lookbehind: true, greedy: true, inside: { interpolation: { pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: true, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\\($/, alias: "punctuation" }, punctuation: /\\(?=[\r\n])/, string: /[\s\S]+/ } }, { pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"), lookbehind: true, greedy: true, inside: { interpolation: { pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/, lookbehind: true, inside: null }, "interpolation-punctuation": { pattern: /^\)|\\#+\($/, alias: "punctuation" }, string: /[\s\S]+/ } }], directive: { pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"), alias: "property", inside: { "directive-name": /^#\w+/, boolean: /\b(?:false|true)\b/, number: /\b\d+(?:\.\d+)*\b/, operator: /!|&&|\|\||[<>]=?/, punctuation: /[(),]/ } }, literal: { pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/, alias: "constant" }, "other-directive": { pattern: /#\w+\b/, alias: "property" }, attribute: { pattern: /@\w+/, alias: "atrule" }, "function-definition": { pattern: /(\bfunc\s+)\w+/, lookbehind: true, alias: "function" }, label: { pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/, lookbehind: true, alias: "important" }, keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/, boolean: /\b(?:false|true)\b/, nil: { pattern: /\bnil\b/, alias: "constant" }, "short-argument": /\$\d+\b/, omit: { pattern: /\b_\b/, alias: "keyword" }, number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i, "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/, function: /\b[a-z_]\w*(?=\s*\()/i, constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/, operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/, punctuation: /[{}[\]();,.:\\]/ }, Prism.languages.swift["string-literal"].forEach(function(e10) {
  e10.inside.interpolation.inside = Prism.languages.swift;
}), function(e10) {
  var t2 = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", n2 = { pattern: /(^(["']?)\w+\2)[ \t]+\S.*/, lookbehind: true, alias: "punctuation", inside: null }, r3 = { bash: n2, environment: { pattern: RegExp("\\$" + t2), alias: "constant" }, variable: [{ pattern: /\$?\(\([\s\S]+?\)\)/, greedy: true, inside: { variable: [{ pattern: /(^\$\(\([\s\S]+)\)\)/, lookbehind: true }, /^\$\(\(/], number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/, operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/, punctuation: /\(\(?|\)\)?|,|;/ } }, { pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/, greedy: true, inside: { variable: /^\$\(|^`|\)$|`$/ } }, { pattern: /\$\{[^}]+\}/, greedy: true, inside: { operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/, punctuation: /[\[\]]/, environment: { pattern: RegExp("(\\{)" + t2), lookbehind: true, alias: "constant" } } }, /\$(?:\w+|[#?*!@$])/], entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/ };
  e10.languages.bash = { shebang: { pattern: /^#!\s*\/.*/, alias: "important" }, comment: { pattern: /(^|[^"{\\$])#.*/, lookbehind: true }, "function-name": [{ pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/, lookbehind: true, alias: "function" }, { pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/, alias: "function" }], "for-or-select": { pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/, alias: "variable", lookbehind: true }, "assign-left": { pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/, inside: { environment: { pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + t2), lookbehind: true, alias: "constant" } }, alias: "variable", lookbehind: true }, parameter: { pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/, alias: "variable", lookbehind: true }, string: [{ pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/, lookbehind: true, greedy: true, inside: r3 }, { pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/, lookbehind: true, greedy: true, inside: { bash: n2 } }, { pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/, lookbehind: true, greedy: true, inside: r3 }, { pattern: /(^|[^$\\])'[^']*'/, lookbehind: true, greedy: true }, { pattern: /\$'(?:[^'\\]|\\[\s\S])*'/, greedy: true, inside: { entity: r3.entity } }], environment: { pattern: RegExp("\\$?" + t2), alias: "constant" }, variable: r3.variable, function: { pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/, lookbehind: true }, keyword: { pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/, lookbehind: true }, builtin: { pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/, lookbehind: true, alias: "class-name" }, boolean: { pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/, lookbehind: true }, "file-descriptor": { pattern: /\B&\d\b/, alias: "important" }, operator: { pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/, inside: { "file-descriptor": { pattern: /^\d/, alias: "important" } } }, punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/, number: { pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/, lookbehind: true } }, n2.inside = e10.languages.bash;
  for (var o2 = ["comment", "function-name", "for-or-select", "assign-left", "parameter", "string", "environment", "function", "keyword", "builtin", "boolean", "file-descriptor", "operator", "punctuation", "number"], i2 = r3.variable[1].inside, a2 = 0; a2 < o2.length; a2++) i2[o2[a2]] = e10.languages.bash[o2[a2]];
  e10.languages.sh = e10.languages.bash, e10.languages.shell = e10.languages.bash;
}(Prism), function(e10) {
  var t2 = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function n2(e11) {
    return e11 = e11.replace(/<inner>/g, function() {
      return t2;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e11 + ")");
  }
  var r3 = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, o2 = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return r3;
  }), i2 = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
  e10.languages.markdown = e10.languages.extend("markup", {}), e10.languages.insertBefore("markdown", "prolog", { "front-matter-block": { pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind: true, greedy: true, inside: { punctuation: /^---|---$/, "front-matter": { pattern: /\S+(?:\s+\S+)*/, alias: ["yaml", "language-yaml"], inside: e10.languages.yaml } } }, blockquote: { pattern: /^>(?:[\t ]*>)*/m, alias: "punctuation" }, table: { pattern: RegExp("^" + o2 + i2 + "(?:" + o2 + ")*", "m"), inside: { "table-data-rows": { pattern: RegExp("^(" + o2 + i2 + ")(?:" + o2 + ")*$"), lookbehind: true, inside: { "table-data": { pattern: RegExp(r3), inside: e10.languages.markdown }, punctuation: /\|/ } }, "table-line": { pattern: RegExp("^(" + o2 + ")" + i2 + "$"), lookbehind: true, inside: { punctuation: /\||:?-{3,}:?/ } }, "table-header-row": { pattern: RegExp("^" + o2 + "$"), inside: { "table-header": { pattern: RegExp(r3), alias: "important", inside: e10.languages.markdown }, punctuation: /\|/ } } } }, code: [{ pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind: true, alias: "keyword" }, { pattern: /^```[\s\S]*?^```$/m, greedy: true, inside: { "code-block": { pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind: true }, "code-language": { pattern: /^(```).+/, lookbehind: true }, punctuation: /```/ } }], title: [{ pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias: "important", inside: { punctuation: /==+$|--+$/ } }, { pattern: /(^\s*)#.+/m, lookbehind: true, alias: "important", inside: { punctuation: /^#+|#+$/ } }], hr: { pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind: true, alias: "punctuation" }, list: { pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind: true, alias: "punctuation" }, "url-reference": { pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside: { variable: { pattern: /^(!?\[)[^\]]+/, lookbehind: true }, string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, punctuation: /^[\[\]!:]|[<>]/ }, alias: "url" }, bold: { pattern: n2(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^..)[\s\S]+(?=..$)/, lookbehind: true, inside: {} }, punctuation: /\*\*|__/ } }, italic: { pattern: n2(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^.)[\s\S]+(?=.$)/, lookbehind: true, inside: {} }, punctuation: /[*_]/ } }, strike: { pattern: n2(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind: true, greedy: true, inside: { content: { pattern: /(^~~?)[\s\S]+(?=\1$)/, lookbehind: true, inside: {} }, punctuation: /~~?/ } }, "code-snippet": { pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind: true, greedy: true, alias: ["code", "keyword"] }, url: { pattern: n2(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind: true, greedy: true, inside: { operator: /^!/, content: { pattern: /(^\[)[^\]]+(?=\])/, lookbehind: true, inside: {} }, variable: { pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind: true }, url: { pattern: /(^\]\()[^\s)]+/, lookbehind: true }, string: { pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind: true } } } }), ["url", "bold", "italic", "strike"].forEach(function(t3) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(n3) {
      t3 !== n3 && (e10.languages.markdown[t3].inside.content.inside[n3] = e10.languages.markdown[n3]);
    });
  }), e10.hooks.add("after-tokenize", function(e11) {
    "markdown" !== e11.language && "md" !== e11.language || function e12(t3) {
      if (t3 && "string" != typeof t3) for (var n3 = 0, r4 = t3.length; n3 < r4; n3++) {
        var o3 = t3[n3];
        if ("code" === o3.type) {
          var i3 = o3.content[1], a3 = o3.content[3];
          if (i3 && a3 && "code-language" === i3.type && "code-block" === a3.type && "string" == typeof i3.content) {
            var s3 = i3.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), u3 = "language-" + (s3 = (/[a-z][\w-]*/i.exec(s3) || [""])[0].toLowerCase());
            a3.alias ? "string" == typeof a3.alias ? a3.alias = [a3.alias, u3] : a3.alias.push(u3) : a3.alias = [u3];
          }
        } else e12(o3.content);
      }
    }(e11.tokens);
  }), e10.hooks.add("wrap", function(t3) {
    if ("code-block" === t3.type) {
      for (var n3 = "", r4 = 0, o3 = t3.classes.length; r4 < o3; r4++) {
        var i3 = t3.classes[r4], l2 = /language-(.+)/.exec(i3);
        if (l2) {
          n3 = l2[1];
          break;
        }
      }
      var c3 = e10.languages[n3];
      if (c3) t3.content = e10.highlight(function(e11) {
        var t4 = e11.replace(a2, "");
        return t4 = t4.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e12, t5) {
          var n4;
          if ("#" === (t5 = t5.toLowerCase())[0]) return n4 = "x" === t5[1] ? parseInt(t5.slice(2), 16) : Number(t5.slice(1)), u2(n4);
          var r5 = s2[t5];
          return r5 || e12;
        }), t4;
      }(t3.content), c3, n3);
      else if (n3 && "none" !== n3 && e10.plugins.autoloader) {
        var d2 = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(1e16 * Math.random());
        t3.attributes.id = d2, e10.plugins.autoloader.loadLanguages(n3, function() {
          var t4 = document.getElementById(d2);
          t4 && (t4.innerHTML = e10.highlight(t4.textContent, e10.languages[n3], n3));
        });
      }
    }
  });
  var a2 = RegExp(e10.languages.markup.tag.pattern.source, "gi"), s2 = { amp: "&", lt: "<", gt: ">", quot: '"' }, u2 = String.fromCodePoint || String.fromCharCode;
  e10.languages.md = e10.languages.markdown;
}(Prism), Prism.languages.lua = { comment: /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m, string: { pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/, greedy: true }, number: /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i, keyword: /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/, function: /(?!\d)\w+(?=\s*(?:[({]))/, operator: [/[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/, { pattern: /(^|[^.])\.\.(?!\.)/, lookbehind: true }], punctuation: /[\[\](){},;]|\.+|:+/ }, function(e10) {
  var t2 = { pattern: /((?:^|[^\\$])(?:\\{2})*)\$(?:\w+|\{[^{}]*\})/, lookbehind: true, inside: { "interpolation-punctuation": { pattern: /^\$\{?|\}$/, alias: "punctuation" }, expression: { pattern: /[\s\S]+/, inside: null } } };
  e10.languages.groovy = e10.languages.extend("clike", { string: { pattern: /'''(?:[^\\]|\\[\s\S])*?'''|'(?:\\.|[^\\'\r\n])*'/, greedy: true }, keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/, number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i, operator: { pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/, lookbehind: true }, punctuation: /\.+|[{}[\];(),:$]/ }), e10.languages.insertBefore("groovy", "string", { shebang: { pattern: /#!.+/, alias: "comment", greedy: true }, "interpolation-string": { pattern: /"""(?:[^\\]|\\[\s\S])*?"""|(["/])(?:\\.|(?!\1)[^\\\r\n])*\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/, greedy: true, inside: { interpolation: t2, string: /[\s\S]+/ } } }), e10.languages.insertBefore("groovy", "punctuation", { "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/ }), e10.languages.insertBefore("groovy", "function", { annotation: { pattern: /(^|[^.])@\w+/, lookbehind: true, alias: "punctuation" } }), t2.inside.expression.inside = e10.languages.groovy;
}(Prism), Prism.languages.abap = { comment: /^\*.*/m, string: /(`|')(?:\\.|(?!\1)[^\\\r\n])*\1/, "string-template": { pattern: /([|}])(?:\\.|[^\\|{\r\n])*(?=[|{])/, lookbehind: true, alias: "string" }, "eol-comment": { pattern: /(^|\s)".*/m, lookbehind: true, alias: "comment" }, keyword: { pattern: /(\s|\.|^)(?:\*-INPUT|\?TO|ABAP-SOURCE|ABBREVIATED|ABS|ABSTRACT|ACCEPT|ACCEPTING|ACCESSPOLICY|ACCORDING|ACOS|ACTIVATION|ACTUAL|ADD|ADD-CORRESPONDING|ADJACENT|AFTER|ALIAS|ALIASES|ALIGN|ALL|ALLOCATE|ALPHA|ANALYSIS|ANALYZER|AND|ANY|APPEND|APPENDAGE|APPENDING|APPLICATION|ARCHIVE|AREA|ARITHMETIC|AS|ASCENDING|ASIN|ASPECT|ASSERT|ASSIGN|ASSIGNED|ASSIGNING|ASSOCIATION|ASYNCHRONOUS|AT|ATAN|ATTRIBUTES|AUTHORITY|AUTHORITY-CHECK|AVG|BACK|BACKGROUND|BACKUP|BACKWARD|BADI|BASE|BEFORE|BEGIN|BETWEEN|BIG|BINARY|BINDING|BIT|BIT-AND|BIT-NOT|BIT-OR|BIT-XOR|BLACK|BLANK|BLANKS|BLOB|BLOCK|BLOCKS|BLUE|BOUND|BOUNDARIES|BOUNDS|BOXED|BREAK-POINT|BT|BUFFER|BY|BYPASSING|BYTE|BYTE-CA|BYTE-CN|BYTE-CO|BYTE-CS|BYTE-NA|BYTE-NS|BYTE-ORDER|C|CA|CALL|CALLING|CASE|CAST|CASTING|CATCH|CEIL|CENTER|CENTERED|CHAIN|CHAIN-INPUT|CHAIN-REQUEST|CHANGE|CHANGING|CHANNELS|CHAR-TO-HEX|CHARACTER|CHARLEN|CHECK|CHECKBOX|CIRCULAR|CI_|CLASS|CLASS-CODING|CLASS-DATA|CLASS-EVENTS|CLASS-METHODS|CLASS-POOL|CLEANUP|CLEAR|CLIENT|CLOB|CLOCK|CLOSE|CN|CNT|CO|COALESCE|CODE|CODING|COLLECT|COLOR|COLUMN|COLUMNS|COL_BACKGROUND|COL_GROUP|COL_HEADING|COL_KEY|COL_NEGATIVE|COL_NORMAL|COL_POSITIVE|COL_TOTAL|COMMENT|COMMENTS|COMMIT|COMMON|COMMUNICATION|COMPARING|COMPONENT|COMPONENTS|COMPRESSION|COMPUTE|CONCAT|CONCATENATE|COND|CONDENSE|CONDITION|CONNECT|CONNECTION|CONSTANTS|CONTEXT|CONTEXTS|CONTINUE|CONTROL|CONTROLS|CONV|CONVERSION|CONVERT|COPIES|COPY|CORRESPONDING|COS|COSH|COUNT|COUNTRY|COVER|CP|CPI|CREATE|CREATING|CRITICAL|CS|CURRENCY|CURRENCY_CONVERSION|CURRENT|CURSOR|CURSOR-SELECTION|CUSTOMER|CUSTOMER-FUNCTION|DANGEROUS|DATA|DATABASE|DATAINFO|DATASET|DATE|DAYLIGHT|DBMAXLEN|DD\/MM\/YY|DD\/MM\/YYYY|DDMMYY|DEALLOCATE|DECIMALS|DECIMAL_SHIFT|DECLARATIONS|DEEP|DEFAULT|DEFERRED|DEFINE|DEFINING|DEFINITION|DELETE|DELETING|DEMAND|DEPARTMENT|DESCENDING|DESCRIBE|DESTINATION|DETAIL|DIALOG|DIRECTORY|DISCONNECT|DISPLAY|DISPLAY-MODE|DISTANCE|DISTINCT|DIV|DIVIDE|DIVIDE-CORRESPONDING|DIVISION|DO|DUMMY|DUPLICATE|DUPLICATES|DURATION|DURING|DYNAMIC|DYNPRO|E|EACH|EDIT|EDITOR-CALL|ELSE|ELSEIF|EMPTY|ENABLED|ENABLING|ENCODING|END|END-ENHANCEMENT-SECTION|END-LINES|END-OF-DEFINITION|END-OF-FILE|END-OF-PAGE|END-OF-SELECTION|ENDAT|ENDCASE|ENDCATCH|ENDCHAIN|ENDCLASS|ENDDO|ENDENHANCEMENT|ENDEXEC|ENDFOR|ENDFORM|ENDFUNCTION|ENDIAN|ENDIF|ENDING|ENDINTERFACE|ENDLOOP|ENDMETHOD|ENDMODULE|ENDON|ENDPROVIDE|ENDSELECT|ENDTRY|ENDWHILE|ENGINEERING|ENHANCEMENT|ENHANCEMENT-POINT|ENHANCEMENT-SECTION|ENHANCEMENTS|ENTRIES|ENTRY|ENVIRONMENT|EQ|EQUAL|EQUIV|ERRORMESSAGE|ERRORS|ESCAPE|ESCAPING|EVENT|EVENTS|EXACT|EXCEPT|EXCEPTION|EXCEPTION-TABLE|EXCEPTIONS|EXCLUDE|EXCLUDING|EXEC|EXECUTE|EXISTS|EXIT|EXIT-COMMAND|EXP|EXPAND|EXPANDING|EXPIRATION|EXPLICIT|EXPONENT|EXPORT|EXPORTING|EXTEND|EXTENDED|EXTENSION|EXTRACT|FAIL|FETCH|FIELD|FIELD-GROUPS|FIELD-SYMBOL|FIELD-SYMBOLS|FIELDS|FILE|FILTER|FILTER-TABLE|FILTERS|FINAL|FIND|FIRST|FIRST-LINE|FIXED-POINT|FKEQ|FKGE|FLOOR|FLUSH|FONT|FOR|FORM|FORMAT|FORWARD|FOUND|FRAC|FRAME|FRAMES|FREE|FRIENDS|FROM|FUNCTION|FUNCTION-POOL|FUNCTIONALITY|FURTHER|GAPS|GE|GENERATE|GET|GIVING|GKEQ|GKGE|GLOBAL|GRANT|GREATER|GREEN|GROUP|GROUPS|GT|HANDLE|HANDLER|HARMLESS|HASHED|HAVING|HDB|HEAD-LINES|HEADER|HEADERS|HEADING|HELP-ID|HELP-REQUEST|HIDE|HIGH|HINT|HOLD|HOTSPOT|I|ICON|ID|IDENTIFICATION|IDENTIFIER|IDS|IF|IGNORE|IGNORING|IMMEDIATELY|IMPLEMENTATION|IMPLEMENTATIONS|IMPLEMENTED|IMPLICIT|IMPORT|IMPORTING|IN|INACTIVE|INCL|INCLUDE|INCLUDES|INCLUDING|INCREMENT|INDEX|INDEX-LINE|INFOTYPES|INHERITING|INIT|INITIAL|INITIALIZATION|INNER|INOUT|INPUT|INSERT|INSTANCES|INTENSIFIED|INTERFACE|INTERFACE-POOL|INTERFACES|INTERNAL|INTERVALS|INTO|INVERSE|INVERTED-DATE|IS|ISO|ITERATOR|ITNO|JOB|JOIN|KEEP|KEEPING|KERNEL|KEY|KEYS|KEYWORDS|KIND|LANGUAGE|LAST|LATE|LAYOUT|LE|LEADING|LEAVE|LEFT|LEFT-JUSTIFIED|LEFTPLUS|LEFTSPACE|LEGACY|LENGTH|LESS|LET|LEVEL|LEVELS|LIKE|LINE|LINE-COUNT|LINE-SELECTION|LINE-SIZE|LINEFEED|LINES|LIST|LIST-PROCESSING|LISTBOX|LITTLE|LLANG|LOAD|LOAD-OF-PROGRAM|LOB|LOCAL|LOCALE|LOCATOR|LOG|LOG-POINT|LOG10|LOGFILE|LOGICAL|LONG|LOOP|LOW|LOWER|LPAD|LPI|LT|M|MAIL|MAIN|MAJOR-ID|MAPPING|MARGIN|MARK|MASK|MATCH|MATCHCODE|MAX|MAXIMUM|MEDIUM|MEMBERS|MEMORY|MESH|MESSAGE|MESSAGE-ID|MESSAGES|MESSAGING|METHOD|METHODS|MIN|MINIMUM|MINOR-ID|MM\/DD\/YY|MM\/DD\/YYYY|MMDDYY|MOD|MODE|MODIF|MODIFIER|MODIFY|MODULE|MOVE|MOVE-CORRESPONDING|MULTIPLY|MULTIPLY-CORRESPONDING|NA|NAME|NAMETAB|NATIVE|NB|NE|NESTED|NESTING|NEW|NEW-LINE|NEW-PAGE|NEW-SECTION|NEXT|NO|NO-DISPLAY|NO-EXTENSION|NO-GAP|NO-GAPS|NO-GROUPING|NO-HEADING|NO-SCROLLING|NO-SIGN|NO-TITLE|NO-TOPOFPAGE|NO-ZERO|NODE|NODES|NON-UNICODE|NON-UNIQUE|NOT|NP|NS|NULL|NUMBER|NUMOFCHAR|O|OBJECT|OBJECTS|OBLIGATORY|OCCURRENCE|OCCURRENCES|OCCURS|OF|OFF|OFFSET|OLE|ON|ONLY|OPEN|OPTION|OPTIONAL|OPTIONS|OR|ORDER|OTHER|OTHERS|OUT|OUTER|OUTPUT|OUTPUT-LENGTH|OVERFLOW|OVERLAY|PACK|PACKAGE|PAD|PADDING|PAGE|PAGES|PARAMETER|PARAMETER-TABLE|PARAMETERS|PART|PARTIALLY|PATTERN|PERCENTAGE|PERFORM|PERFORMING|PERSON|PF|PF-STATUS|PINK|PLACES|POOL|POSITION|POS_HIGH|POS_LOW|PRAGMAS|PRECOMPILED|PREFERRED|PRESERVING|PRIMARY|PRINT|PRINT-CONTROL|PRIORITY|PRIVATE|PROCEDURE|PROCESS|PROGRAM|PROPERTY|PROTECTED|PROVIDE|PUBLIC|PUSHBUTTON|PUT|QUEUE-ONLY|QUICKINFO|RADIOBUTTON|RAISE|RAISING|RANGE|RANGES|RAW|READ|READ-ONLY|READER|RECEIVE|RECEIVED|RECEIVER|RECEIVING|RED|REDEFINITION|REDUCE|REDUCED|REF|REFERENCE|REFRESH|REGEX|REJECT|REMOTE|RENAMING|REPLACE|REPLACEMENT|REPLACING|REPORT|REQUEST|REQUESTED|RESERVE|RESET|RESOLUTION|RESPECTING|RESPONSIBLE|RESULT|RESULTS|RESUMABLE|RESUME|RETRY|RETURN|RETURNCODE|RETURNING|RIGHT|RIGHT-JUSTIFIED|RIGHTPLUS|RIGHTSPACE|RISK|RMC_COMMUNICATION_FAILURE|RMC_INVALID_STATUS|RMC_SYSTEM_FAILURE|ROLE|ROLLBACK|ROUND|ROWS|RTTI|RUN|SAP|SAP-SPOOL|SAVING|SCALE_PRESERVING|SCALE_PRESERVING_SCIENTIFIC|SCAN|SCIENTIFIC|SCIENTIFIC_WITH_LEADING_ZERO|SCREEN|SCROLL|SCROLL-BOUNDARY|SCROLLING|SEARCH|SECONDARY|SECONDS|SECTION|SELECT|SELECT-OPTIONS|SELECTION|SELECTION-SCREEN|SELECTION-SET|SELECTION-SETS|SELECTION-TABLE|SELECTIONS|SELECTOR|SEND|SEPARATE|SEPARATED|SET|SHARED|SHIFT|SHORT|SHORTDUMP-ID|SIGN|SIGN_AS_POSTFIX|SIMPLE|SIN|SINGLE|SINH|SIZE|SKIP|SKIPPING|SMART|SOME|SORT|SORTABLE|SORTED|SOURCE|SPACE|SPECIFIED|SPLIT|SPOOL|SPOTS|SQL|SQLSCRIPT|SQRT|STABLE|STAMP|STANDARD|START-OF-SELECTION|STARTING|STATE|STATEMENT|STATEMENTS|STATIC|STATICS|STATUSINFO|STEP-LOOP|STOP|STRLEN|STRUCTURE|STRUCTURES|STYLE|SUBKEY|SUBMATCHES|SUBMIT|SUBROUTINE|SUBSCREEN|SUBSTRING|SUBTRACT|SUBTRACT-CORRESPONDING|SUFFIX|SUM|SUMMARY|SUMMING|SUPPLIED|SUPPLY|SUPPRESS|SWITCH|SWITCHSTATES|SYMBOL|SYNCPOINTS|SYNTAX|SYNTAX-CHECK|SYNTAX-TRACE|SYSTEM-CALL|SYSTEM-EXCEPTIONS|SYSTEM-EXIT|TAB|TABBED|TABLE|TABLES|TABLEVIEW|TABSTRIP|TAN|TANH|TARGET|TASK|TASKS|TEST|TESTING|TEXT|TEXTPOOL|THEN|THROW|TIME|TIMES|TIMESTAMP|TIMEZONE|TITLE|TITLE-LINES|TITLEBAR|TO|TOKENIZATION|TOKENS|TOP-LINES|TOP-OF-PAGE|TRACE-FILE|TRACE-TABLE|TRAILING|TRANSACTION|TRANSFER|TRANSFORMATION|TRANSLATE|TRANSPORTING|TRMAC|TRUNC|TRUNCATE|TRUNCATION|TRY|TYPE|TYPE-POOL|TYPE-POOLS|TYPES|ULINE|UNASSIGN|UNDER|UNICODE|UNION|UNIQUE|UNIT|UNIT_CONVERSION|UNIX|UNPACK|UNTIL|UNWIND|UP|UPDATE|UPPER|USER|USER-COMMAND|USING|UTF-8|VALID|VALUE|VALUE-REQUEST|VALUES|VARY|VARYING|VERIFICATION-MESSAGE|VERSION|VIA|VIEW|VISIBLE|WAIT|WARNING|WHEN|WHENEVER|WHERE|WHILE|WIDTH|WINDOW|WINDOWS|WITH|WITH-HEADING|WITH-TITLE|WITHOUT|WORD|WORK|WRITE|WRITER|X|XML|XOR|XSD|XSTRLEN|YELLOW|YES|YYMMDD|Z|ZERO|ZONE)(?![\w-])/i, lookbehind: true }, number: /\b\d+\b/, operator: { pattern: /(\s)(?:\*\*?|<[=>]?|>=?|\?=|[-+\/=])(?=\s)/, lookbehind: true }, "string-operator": { pattern: /(\s)&&?(?=\s)/, lookbehind: true, alias: "keyword" }, "token-operator": [{ pattern: /(\w)(?:->?|=>|[~|{}])(?=\w)/, lookbehind: true, alias: "punctuation" }, { pattern: /[|{}]/, alias: "punctuation" }], punctuation: /[,.:()]/ };
var Gk = ["comment", "prolog", "doctype", "cdata", "punctuation", "namespace", "property", "tag", "boolean", "number", "constant", "symbol", "deleted", "selector", "attr-name", "string", "builtin", "inserted", "operator", "entity", "url", "string", "atrule", "attr-value", "keyword", "function", "class-name", "regex", "important", "variable", "bold", "italic", "entity", "char"];
function qk(e10) {
  return "string" == typeof e10 ? e10.length : "string" == typeof e10.content ? e10.content.length : e10.content.reduce(function(e11, t2) {
    return e11 + qk(t2);
  }, 0);
}
var Kk = function(e10) {
  var t2, n2, r3, o2 = iv(e10, 2), i2 = o2[0], a2 = o2[1], s2 = [], u2 = function(e11) {
    if (!Og.isText(e11)) return null;
    var t3 = zy.getParentNode(null, e11);
    if (t3 && "code" === zy.getNodeType(t3)) {
      var n3 = zy.getParentNode(null, t3);
      if (n3 && "pre" === zy.getNodeType(n3)) return t3;
    }
    return null;
  }(i2);
  if (null == u2) return s2;
  var l2 = u2.language, c3 = void 0 === l2 ? "" : l2;
  if (!c3) return s2;
  var d2 = function(e11, t3) {
    if (!t3) return [];
    var n3 = Mk.languages[t3];
    return n3 ? Mk.tokenize(e11.text, n3) : [];
  }(i2, c3), f2 = 0;
  try {
    for (var p2 = ov(d2), h2 = p2.next(); !h2.done; h2 = p2.next()) {
      var g2 = h2.value, v2 = f2 + qk(g2);
      "string" != typeof g2 && s2.push(((r3 = {})[g2.type] = true, r3.anchor = { path: a2, offset: f2 }, r3.focus = { path: a2, offset: v2 }, r3)), f2 = v2;
    }
  } catch (e11) {
    t2 = { error: e11 };
  } finally {
    try {
      h2 && !h2.done && (n2 = p2.return) && n2.call(p2);
    } finally {
      if (t2) throw t2.error;
    }
  }
  return s2;
};
var Yk = { type: "code", elemToHtml: function(e10, t2) {
  var n2 = e10.language, r3 = void 0 === n2 ? "" : n2, o2 = r3 ? 'class="language-'.concat(r3, '"') : "";
  return "<code ".concat(o2, ">").concat(t2, "</code>");
} };
var Xk = function() {
  function e10() {
    this.title = iC("highLightModule.selectLang"), this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M64 64v896h896V64H64z m487.6 698.8c0 87.2-51.2 127-125.8 127-67.4 0-106.4-34.8-126.4-77l68.6-41.4c13.2 23.4 25.2 43.2 54.2 43.2 27.6 0 45.2-10.8 45.2-53V475.4h84.2v287.4z m199.2 127c-78.2 0-128.8-37.2-153.4-86l68.6-39.6c18 29.4 41.6 51.2 83 51.2 34.8 0 57.2-17.4 57.2-41.6 0-28.8-22.8-39-61.4-56l-21-9c-60.8-25.8-101-58.4-101-127 0-63.2 48.2-111.2 123.2-111.2 53.6 0 92 18.6 119.6 67.4L800 580c-14.4-25.8-30-36-54.2-36-24.6 0-40.2 15.6-40.2 36 0 25.2 15.6 35.4 51.8 51.2l21 9c71.6 30.6 111.8 62 111.8 132.4 0 75.6-59.6 117.2-139.4 117.2z"></path></svg>', this.tag = "select", this.width = 95, this.selectPanelWidth = 115, this.defaultCodeLang = "";
  }
  return e10.prototype.getOptions = function(e11) {
    var t2 = this, n2 = [], r3 = e11.getMenuConfig("codeSelectLang").codeLangs, o2 = void 0 === r3 ? [] : r3;
    n2.push({ text: "plain text", value: "" }), o2.forEach(function(e12) {
      var r4 = e12.text, o3 = e12.value;
      e12.selected && (t2.defaultCodeLang = o3), n2.push({ text: r4, value: o3 });
    });
    var i2 = this.getValue(e11);
    return n2.forEach(function(e12) {
      e12.value === i2 ? e12.selected = true : e12.selected = void 0;
    }), n2;
  }, e10.prototype.isActive = function(e11) {
    return false;
  }, e10.prototype.getValue = function(e11) {
    var t2 = this.getSelectCodeElem(e11);
    if (null == t2) return this.defaultCodeLang;
    if (!Kh.isElement(t2)) return this.defaultCodeLang;
    var n2 = t2.language.toString(), r3 = e11.getMenuConfig("codeSelectLang").codeLangs;
    return (void 0 === r3 ? [] : r3).some(function(e12) {
      return e12.value === n2;
    }) ? n2 : this.defaultCodeLang;
  }, e10.prototype.isDisabled = function(e11) {
    return null == e11.selection || !this.getSelectCodeElem(e11);
  }, e10.prototype.exec = function(e11, t2) {
    if (null != this.getSelectCodeElem(e11)) {
      var n2 = { language: t2.toString() };
      Wg.setNodes(e11, n2, { match: function(e12) {
        return zy.checkNodeType(e12, "code");
      } });
    }
  }, e10.prototype.getSelectCodeElem = function(e11) {
    var t2 = zy.getSelectedNodeByType(e11, "code");
    if (null == t2) return null;
    var n2 = zy.getParentNode(e11, t2);
    return Kh.isElement(n2) ? "pre" !== n2.type ? null : t2 : null;
  }, e10;
}(), Zk = { key: "codeSelectLang", factory: function() {
  return new Xk();
}, config: { codeLangs: [{ text: "CSS", value: "css" }, { text: "HTML", value: "html" }, { text: "XML", value: "xml" }, { text: "Javascript", value: "javascript" }, { text: "Typescript", value: "typescript" }, { text: "JSX", value: "jsx" }, { text: "Go", value: "go" }, { text: "PHP", value: "php" }, { text: "C", value: "c" }, { text: "Python", value: "python" }, { text: "Java", value: "java" }, { text: "C++", value: "cpp" }, { text: "C#", value: "csharp" }, { text: "Visual Basic", value: "visual-basic" }, { text: "SQL", value: "sql" }, { text: "Ruby", value: "ruby" }, { text: "Swift", value: "swift" }, { text: "Bash", value: "bash" }, { text: "Lua", value: "lua" }, { text: "Groovy", value: "groovy" }, { text: "Markdown", value: "markdown" }, { text: "ABAP", value: "abap" }] } };
vm && (fm.fn.attr = vm);
var Jk = { renderStyle: function(e10, t2) {
  var n2 = e10, r3 = t2, o2 = "";
  return Gk.forEach(function(e11) {
    n2[e11] && (o2 = e11);
  }), o2 && function(e11, t3) {
    null == e11.data && (e11.data = {});
    var n3 = e11.data;
    null == n3.props && (n3.props = {}), Object.assign(n3.props, { className: t3 });
  }(r3, o2 = "token ".concat(o2)), r3;
}, parseStyleHtml: function(e10, t2, n2) {
  var r3 = fm(e10);
  if (!Kh.isElement(t2)) return t2;
  if ("code" !== zy.getNodeType(t2)) return t2;
  var o2 = t2, i2 = r3.attr("class") || "";
  return 0 === i2.indexOf("language-") ? o2.language = i2.split("-")[1] || "" : o2.language = i2.toLowerCase(), o2;
}, menus: [Zk], elemsToHtml: [Yk] }, Qk = function() {
  function e10() {
    throw new Error("不能实例化\nCan not construct a instance");
  }
  return e10.setEditorConfig = function(e11) {
    void 0 === e11 && (e11 = {}), this.editorConfig = tv(tv({}, this.editorConfig), e11);
  }, e10.setSimpleEditorConfig = function(e11) {
    void 0 === e11 && (e11 = {}), this.simpleEditorConfig = tv(tv({}, this.simpleEditorConfig), e11);
  }, e10.setToolbarConfig = function(e11) {
    void 0 === e11 && (e11 = {}), this.toolbarConfig = tv(tv({}, this.toolbarConfig), e11);
  }, e10.setSimpleToolbarConfig = function(e11) {
    void 0 === e11 && (e11 = {}), this.simpleToolbarConfig = tv(tv({}, this.simpleToolbarConfig), e11);
  }, e10.registerPlugin = function(e11) {
    this.plugins.push(e11);
  }, e10.registerMenu = function(e11, t2) {
    xv(e11, t2);
  }, e10.registerRenderElem = function(e11) {
    var t2, n2, r3;
    n2 = (t2 = e11).type, r3 = t2.renderElem, Mw[n2 || ""] = r3;
  }, e10.registerRenderStyle = function(e11) {
    !function(e12) {
      _w.push(e12);
    }(e11);
  }, e10.registerElemToHtml = function(e11) {
    !function(e12) {
      var t2 = e12.type, n2 = e12.elemToHtml;
      Oy[t2 || ""] = n2;
    }(e11);
  }, e10.registerStyleToHtml = function(e11) {
    !function(e12) {
      Sy.push(e12);
    }(e11);
  }, e10.registerPreParseHtml = function(e11) {
    var t2;
    t2 = e11, py.push(t2);
  }, e10.registerParseElemHtml = function(e11) {
    !function(e12) {
      var t2 = e12.selector, n2 = e12.parseElemHtml;
      gy[t2] = n2;
    }(e11);
  }, e10.registerParseStyleHtml = function(e11) {
    !function(e12) {
      hy.push(e12);
    }(e11);
  }, e10.registerModule = function(e11) {
    eF(e11);
  }, e10.editorConfig = {}, e10.simpleEditorConfig = {}, e10.toolbarConfig = {}, e10.simpleToolbarConfig = {}, e10.plugins = [], e10;
}();
function eF(e10) {
  var t2 = e10.menus, n2 = e10.renderElems, r3 = e10.renderStyle, o2 = e10.elemsToHtml, i2 = e10.styleToHtml, a2 = e10.preParseHtml, s2 = e10.parseElemsHtml, u2 = e10.parseStyleHtml, l2 = e10.editorPlugin;
  t2 && t2.forEach(function(e11) {
    return Qk.registerMenu(e11);
  }), n2 && n2.forEach(function(e11) {
    return Qk.registerRenderElem(e11);
  }), r3 && Qk.registerRenderStyle(r3), o2 && o2.forEach(function(e11) {
    return Qk.registerElemToHtml(e11);
  }), i2 && Qk.registerStyleToHtml(i2), a2 && a2.forEach(function(e11) {
    return Qk.registerPreParseHtml(e11);
  }), s2 && s2.forEach(function(e11) {
    return Qk.registerParseElemHtml(e11);
  }), u2 && Qk.registerParseStyleHtml(u2), l2 && Qk.registerPlugin(l2);
}
wB.forEach(function(e10) {
  return eF(e10);
}), eF(jB), eF(ak), eF(Ok), eF(Pk), eF(Jk);
var tF = '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>';
var nF = { link: { menuKeys: ["editLink", "unLink", "viewLink"] }, image: { menuKeys: ["imageWidth30", "imageWidth50", "imageWidth100", "editorImageSizeMenu", "editImage", "viewImageLink", "deleteImage"] }, pre: { menuKeys: ["enter", "codeBlock", "codeSelectLang"] }, table: { menuKeys: ["enter", "tableHeader", "tableFullWidth", "insertTableRow", "deleteTableRow", "insertTableCol", "deleteTableCol", "deleteTable", "mergeTableCell", "splitTableCell", "setTableProperty", "setTableCellProperty"] }, divider: { menuKeys: ["enter"] }, video: { menuKeys: ["enter", "editVideoSize", "editVideoSrc"] } };
var rF = { hoverbarKeys: tv(tv({}, nF), { text: { menuKeys: ["formatPainter", "headerSelect", "insertLink", "bulletedList", "|", "bold", "through", "color", "bgColor", "clearStyle"] } }) };
Qk.setEditorConfig(tv(tv({}, rF), { decorate: Kk }));
var oF = { hoverbarKeys: nF };
Qk.setSimpleEditorConfig(tv(tv({}, oF), { decorate: Kk }));
var iF = { toolbarKeys: ["headerSelect", "blockquote", "|", "bold", "underline", "italic", { key: "group-more-style", title: iC("editor.more"), iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path></svg>', menuKeys: ["through", "code", "sup", "sub", "clearStyle"] }, "color", "bgColor", "|", "fontSize", "fontFamily", "lineHeight", "|", "bulletedList", "numberedList", "todo", { key: "group-justify", title: iC("editor.justify"), iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>', menuKeys: ["justifyLeft", "justifyRight", "justifyCenter", "justifyJustify"] }, { key: "group-indent", title: iC("editor.indent"), iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>', menuKeys: ["indent", "delIndent"] }, "|", "emotion", "insertLink", { key: "group-image", title: iC("editor.image"), iconSvg: tF, menuKeys: ["insertImage", "uploadImage"] }, { key: "group-video", title: iC("editor.video"), iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>', menuKeys: ["insertVideo", "uploadVideo"] }, "insertTable", "codeBlock", "divider", "|", "undo", "redo", "|", "formatPainter", "fullScreen"] };
Qk.setToolbarConfig(iF);
var aF = { toolbarKeys: ["blockquote", "header1", "header2", "header3", "|", "bold", "underline", "italic", "through", "color", "bgColor", "clearStyle", "|", "bulletedList", "numberedList", "todo", "justifyLeft", "justifyRight", "justifyCenter", "|", "insertLink", { key: "group-image", title: iC("editor.image"), iconSvg: tF, menuKeys: ["insertImage", "uploadImage"] }, "insertVideo", "insertTable", "codeBlock", "|", "undo", "redo", "|", "fullScreen"] };
function sF(e10) {
  void 0 === e10 && (e10 = {});
  var t2 = e10.selector, n2 = void 0 === t2 ? "" : t2, r3 = e10.content, o2 = void 0 === r3 ? [] : r3, i2 = e10.html, a2 = e10.config, s2 = void 0 === a2 ? {} : a2, u2 = e10.mode, l2 = "simple" === (void 0 === u2 ? "default" : u2) ? Qk.simpleEditorConfig : Qk.editorConfig, c3 = tv(tv({}, l2.hoverbarKeys || {}), s2.hoverbarKeys || {});
  return eD({ selector: n2, config: tv(tv(tv({}, l2), s2), { hoverbarKeys: c3 }), content: o2, html: i2, plugins: Qk.plugins });
}
function uF(e10) {
  var t2 = e10.selector, n2 = e10.editor, r3 = e10.config, o2 = void 0 === r3 ? {} : r3, i2 = e10.mode, a2 = void 0 === i2 ? "default" : i2;
  if (!t2) throw new Error("Cannot find 'selector' when create toolbar");
  var s2 = "simple" === a2 ? Qk.simpleToolbarConfig : Qk.toolbarConfig;
  return nD(n2, { selector: t2, config: tv(tv({}, s2), o2) });
}
Qk.setSimpleToolbarConfig(aF);
var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp2(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp2(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
function genErrorInfo(fnName) {
  let info = `请使用 '@${fnName}' 事件，不要放在 props 中`;
  info += `
Please use '@${fnName}' event instead of props`;
  return info;
}
var _export_sfc = (sfc, props) => {
  for (const [key, val] of props) {
    sfc[key] = val;
  }
  return sfc;
};
const _sfc_main$1$1 = defineComponent({
  props: {
    mode: {
      type: String,
      default: "default"
    },
    defaultContent: {
      type: Array,
      default: []
    },
    defaultHtml: {
      type: String,
      default: ""
    },
    defaultConfig: {
      type: Object,
      default: {}
    },
    modelValue: {
      type: String,
      default: ""
    }
  },
  setup(props, context) {
    const box = ref(null);
    const editorRef = shallowRef(null);
    const curValue = ref("");
    const initEditor = () => {
      if (!box.value)
        return;
      const defaultContent = toRaw(props.defaultContent);
      sF({
        selector: box.value,
        mode: props.mode,
        content: defaultContent || [],
        html: props.defaultHtml || props.modelValue || "",
        config: __spreadProps(__spreadValues({}, props.defaultConfig), {
          onCreated(editor) {
            editorRef.value = editor;
            context.emit("onCreated", editor);
            if (props.defaultConfig.onCreated) {
              const info = genErrorInfo("onCreated");
              throw new Error(info);
            }
          },
          onChange(editor) {
            const editorHtml = editor.getHtml();
            curValue.value = editorHtml;
            context.emit("update:modelValue", editorHtml);
            context.emit("onChange", editor);
            if (props.defaultConfig.onChange) {
              const info = genErrorInfo("onChange");
              throw new Error(info);
            }
          },
          onDestroyed(editor) {
            context.emit("onDestroyed", editor);
            if (props.defaultConfig.onDestroyed) {
              const info = genErrorInfo("onDestroyed");
              throw new Error(info);
            }
          },
          onMaxLength(editor) {
            context.emit("onMaxLength", editor);
            if (props.defaultConfig.onMaxLength) {
              const info = genErrorInfo("onMaxLength");
              throw new Error(info);
            }
          },
          onFocus(editor) {
            context.emit("onFocus", editor);
            if (props.defaultConfig.onFocus) {
              const info = genErrorInfo("onFocus");
              throw new Error(info);
            }
          },
          onBlur(editor) {
            context.emit("onBlur", editor);
            if (props.defaultConfig.onBlur) {
              const info = genErrorInfo("onBlur");
              throw new Error(info);
            }
          },
          customAlert(info, type4) {
            context.emit("customAlert", info, type4);
            if (props.defaultConfig.customAlert) {
              const info2 = genErrorInfo("customAlert");
              throw new Error(info2);
            }
          },
          customPaste: (editor, event) => {
            if (props.defaultConfig.customPaste) {
              const info = genErrorInfo("customPaste");
              throw new Error(info);
            }
            let res;
            context.emit("customPaste", editor, event, (val) => {
              res = val;
            });
            return res;
          }
        })
      });
    };
    function setHtml(newHtml) {
      const editor = editorRef.value;
      if (editor == null)
        return;
      editor.setHtml(newHtml);
    }
    onMounted(() => {
      initEditor();
    });
    watch(() => props.modelValue, (newVal) => {
      if (newVal === curValue.value)
        return;
      setHtml(newVal);
    });
    return {
      box
    };
  }
});
const _hoisted_1$1$1 = {
  ref: "box",
  style: { "height": "100%" }
};
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1$1, null, 512);
}
var Editor = /* @__PURE__ */ _export_sfc(_sfc_main$1$1, [["render", _sfc_render$1]]);
const _sfc_main$p = defineComponent({
  props: {
    editor: {
      type: Object
    },
    mode: {
      type: String,
      default: "default"
    },
    defaultConfig: {
      type: Object,
      default: {}
    }
  },
  setup(props) {
    const selector = ref(null);
    const create = (editor) => {
      if (!selector.value)
        return;
      if (editor == null) {
        throw new Error("Not found instance of Editor when create <Toolbar/> component");
      }
      if (zy.getToolbar(editor))
        return;
      uF({
        editor,
        selector: selector.value || "<div></div>",
        mode: props.mode,
        config: props.defaultConfig
      });
    };
    watchEffect(() => {
      const { editor } = props;
      if (editor == null)
        return;
      create(editor);
    });
    return {
      selector
    };
  }
});
const _hoisted_1$b = { ref: "selector" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$b, null, 512);
}
var Toolbar = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render]]);
const _TemplateFieldButtonMenu = class _TemplateFieldButtonMenu {
  constructor() {
    __publicField(this, "tag");
    __publicField(this, "title");
    const { t: t2 } = useLocale();
    this.title = t2("Field");
    this.tag = "button";
  }
  exec(editor, value) {
    const config = editor.getMenuConfig(_TemplateFieldButtonMenu.menuKey);
    config.fieldFormVisible.value = !config.fieldFormVisible.value;
  }
  getValue(editor) {
    return false;
  }
  isActive(editor) {
    return false;
  }
  isDisabled(editor) {
    return false;
  }
};
__publicField(_TemplateFieldButtonMenu, "menuKey", "TemplateField");
__publicField(_TemplateFieldButtonMenu, "registered", false);
let TemplateFieldButtonMenu = _TemplateFieldButtonMenu;
const templateFieldButtonMenuConf = {
  key: TemplateFieldButtonMenu.menuKey,
  factory() {
    return new TemplateFieldButtonMenu();
  }
};
const _hoisted_1$a = { class: "template-fields" };
const _hoisted_2$4 = ["onClick"];
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "TemplateFieldSelector",
  props: {
    templateFields: { type: [Array, Function] }
  },
  emits: ["select"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const categorizedTemplateFields = ref();
    const { t: t2 } = useLocale();
    const ensureTemplateFields = async () => {
      if (isFunction$2(props.templateFields)) {
        categorizedTemplateFields.value = await props.templateFields();
      } else {
        categorizedTemplateFields.value = props.templateFields;
      }
    };
    onBeforeMount(ensureTemplateFields);
    onBeforeUpdate(ensureTemplateFields);
    return (_ctx, _cache) => {
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_tabs = resolveComponent("el-tabs");
      return openBlock(), createBlock(_component_el_tabs, { "tab-position": "left" }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(categorizedTemplateFields.value, (categorizedTemplateField) => {
            return openBlock(), createBlock(_component_el_tab_pane, {
              label: unref(t2)(categorizedTemplateField.categoryName)
            }, {
              default: withCtx(() => [
                createElementVNode("ul", _hoisted_1$a, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(categorizedTemplateField.fields, (field) => {
                    return openBlock(), createElementBlock("li", {
                      onClick: withModifiers(() => {
                        emit("select", categorizedTemplateField.categoryName === "FormData" ? `data.${field.value}` : field.value);
                      }, ["stop"])
                    }, toDisplayString(unref(t2)(field.text)), 9, _hoisted_2$4);
                  }), 256))
                ])
              ]),
              _: 2
            }, 1032, ["label"]);
          }), 256))
        ]),
        _: 1
      });
    };
  }
});
let initialized = false;
const useWangEditorLocale = () => {
  const vcLocale = useLocale();
  if (!initialized) {
    initialized = true;
    watch(vcLocale.lang, () => {
      const resource = rC(vcLocale.lang.value || "en");
      if (!resource && vcLocale.lang.value && vcLocale.locale.value) {
        tC(vcLocale.lang.value, vcLocale.locale.value.vc.WangEditor);
      }
      nC(vcLocale.lang.value || "en");
    }, { immediate: true });
  }
};
const _hoisted_1$9 = { style: { "width": "100%" } };
const _hoisted_2$3 = ["innerHTML"];
const _hoisted_3$1 = { style: { "border": "1px solid #ccc" } };
const mode = "default";
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  ...{
    name: "TemplateEditor"
  },
  __name: "TemplateEditor",
  props: /* @__PURE__ */ mergeModels({
    templateFields: { type: [Array, Function] },
    customTitle: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:valueText"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {
    if (!TemplateFieldButtonMenu.registered) {
      Qk.registerMenu(templateFieldButtonMenuConf);
      TemplateFieldButtonMenu.registered = true;
    }
    const templateContent = useModel(__props, "modelValue");
    const emit = __emit;
    const editorRef = shallowRef();
    const toolbarConfig = {
      insertKeys: {
        index: 0,
        keys: [TemplateFieldButtonMenu.menuKey]
      }
    };
    const fieldFormVisible = ref(false);
    const editorVisible = ref(false);
    const editorConfig = {
      placeholder: "请输入内容...",
      MENU_CONF: {}
    };
    editorConfig.MENU_CONF[TemplateFieldButtonMenu.menuKey] = {
      fieldFormVisible
    };
    const handleCreated = (editor) => {
      editorRef.value = editor;
    };
    const fieldSelect = (fieldName) => {
      editorRef.value.focus();
      editorRef.value.insertText("{{" + fieldName + "}}");
      fieldFormVisible.value = false;
    };
    const editTemplate = () => {
      editorVisible.value = true;
      valueHtml.value = templateContent.value || "";
    };
    const { formItem } = useFormItem();
    const confirm = () => {
      templateContent.value = html.value;
      editorVisible.value = false;
      if (formItem) {
        formItem.validate("change");
      }
    };
    const html = computed(() => {
      const doc = new DOMParser().parseFromString(valueHtml.value, "text/html");
      doc.querySelectorAll("table").forEach((table) => {
        table.style.borderCollapse = "collapse";
        table.querySelectorAll("td, th").forEach((cell) => {
          if (cell instanceof HTMLElement) {
            cell.style.border = "1px solid #e0e0e0";
          }
        });
      });
      return doc.body.innerHTML;
    });
    const cancel = () => {
      editorVisible.value = false;
      if (formItem) {
        formItem.validate("blur");
      }
    };
    const valueHtml = ref("");
    const { t: t2 } = useLocale();
    useWangEditorLocale();
    const change = (editor) => {
      const text = editor.getText();
      emit("update:valueText", text);
      console.log("html:" + editor.getHtml());
      console.log("text:" + text);
    };
    return (_ctx, _cache) => {
      const _component_el_button = resolveComponent("el-button");
      const _component_el_main = resolveComponent("el-main");
      const _component_el_footer = resolveComponent("el-footer");
      const _component_el_container = resolveComponent("el-container");
      const _component_el_dialog = resolveComponent("el-dialog");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$9, [
          createElementVNode("div", {
            class: "templateToolBar",
            onClick: withModifiers(editTemplate, ["stop"])
          }, [
            createVNode(_component_el_button, {
              size: "small",
              onClick: withModifiers(editTemplate, ["stop"]),
              type: "primary",
              icon: unref(edit_default)
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("Edit")), 1)
              ]),
              _: 1
            }, 8, ["icon"])
          ]),
          createElementVNode("div", {
            class: "templateContent",
            onClick: withModifiers(editTemplate, ["stop"]),
            innerHTML: templateContent.value
          }, null, 8, _hoisted_2$3)
        ]),
        createVNode(_component_el_dialog, {
          modelValue: editorVisible.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => editorVisible.value = $event),
          "append-to-body": true,
          title: unref(t2)(_ctx.customTitle ?? "TemplateEditor"),
          top: "2vh",
          width: "70%"
        }, {
          default: withCtx(() => [
            createVNode(_component_el_container, null, {
              default: withCtx(() => [
                createVNode(_component_el_main, { class: "wang-editor-container" }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_3$1, [
                      createVNode(unref(Toolbar), {
                        class: "wang-editor",
                        style: { "border-bottom": "1px solid #ccc" },
                        editor: editorRef.value,
                        defaultConfig: toolbarConfig,
                        mode
                      }, null, 8, ["editor"]),
                      createVNode(unref(Editor), {
                        style: { "overflow-y": "hidden", "height": "40vh" },
                        modelValue: valueHtml.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => valueHtml.value = $event),
                        defaultConfig: editorConfig,
                        mode,
                        onOnCreated: handleCreated,
                        onOnChange: change
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                createVNode(_component_el_footer, null, {
                  default: withCtx(() => [
                    createVNode(_component_el_button, {
                      type: "primary",
                      onClick: confirm
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("Confirm")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_button, {
                      type: "primary",
                      onClick: cancel
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(t2)("Cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "title"]),
        createVNode(_component_el_dialog, {
          modelValue: fieldFormVisible.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => fieldFormVisible.value = $event),
          draggable: true,
          "append-to-body": true
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$o, {
              "template-fields": _ctx.templateFields,
              onSelect: fieldSelect
            }, null, 8, ["template-fields"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 64);
    };
  }
});
const component$2 = /* @__PURE__ */ _export_sfc$1(_sfc_main$n, [["__scopeId", "data-v-6b94b3a9"]]);
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e10) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2) _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning = function warning2() {
};
if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && typeof window !== "undefined" && typeof document !== "undefined") {
  warning = function warning3(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e10) {
        return typeof e10 === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i2 = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x2) {
      if (x2 === "%%") {
        return "%";
      }
      if (i2 >= len) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i2++]);
        case "%d":
          return Number(args[i2++]);
        case "%j":
          try {
            return JSON.stringify(args[i2++]);
          } catch (_2) {
            return "[Circular]";
          }
          break;
        default:
          return x2;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value, type4) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors || []);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a2) {
    func(a2, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }
  next([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k2) {
    ret.push.apply(ret, objArr[k2] || []);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _this = _Error.call(this, "Async Validation Error") || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next = function next2(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });
    _pending["catch"](function(e10) {
      return e10;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next = function next2(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function(e10) {
    return e10;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue(value, path) {
  var v2 = value;
  for (var i2 = 0; i2 < path.length; i2++) {
    if (v2 == void 0) {
      return v2;
    }
    v2 = v2[path[i2]];
  }
  return v2;
}
function complementError(rule, source) {
  return function(oe2) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue(source, rule.fullFields);
    } else {
      fieldValue = source[oe2.field || rule.fullField];
    }
    if (isErrorObj(oe2)) {
      oe2.field = oe2.field || rule.fullField;
      oe2.fieldValue = fieldValue;
      return oe2;
    }
    return {
      message: typeof oe2 === "function" ? oe2() : oe2,
      fieldValue,
      field: oe2.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s2 in source) {
      if (source.hasOwnProperty(s2)) {
        var value = source[s2];
        if (typeof value === "object" && typeof target[s2] === "object") {
          target[s2] = _extends({}, target[s2], value);
        } else {
          target[s2] = value;
        }
      }
    }
  }
  return target;
}
var required$1 = function required(rule, value, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type4 || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
var whitespace = function whitespace2(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
var urlReg;
var getUrlRegex = function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b2 = function b3(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
  };
  var v42 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v42 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v42 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v42 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v42 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v42 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v42 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v42 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
  var v46Exact = new RegExp("(?:^" + v42 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v42 + "$");
  var v6exact = new RegExp("^" + v6 + "$");
  var ip2 = function ip3(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b2(options) + v42 + b2(options) + ")|(?:" + b2(options) + v6 + b2(options) + ")", "g");
  };
  ip2.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("" + b2(options) + v42 + b2(options), "g");
  };
  ip2.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("" + b2(options) + v6 + b2(options), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip2.v4().source;
  var ipv6 = ip2.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path = '(?:[/?#][^\\s"]*)?';
  var regex2 = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex2 + "$)", "i");
  return urlReg;
};
var pattern$2 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e10) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return typeof value === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern$2.hex);
  }
};
var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required$1(rule, value, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min2 = typeof rule.min === "number";
  var max2 = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key = "number";
  } else if (str) {
    key = "string";
  } else if (arr) {
    key = "array";
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min2 && !max2 && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max2 && !min2 && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min2 && max2 && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  "enum": enumerable$1,
  pattern: pattern$1
};
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var _boolean = function _boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value) ? "array" : typeof value;
  rules.required(rule, value, source, errors, options, type4);
  callback(errors);
};
var type2 = function type3(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var validators = {
  string,
  method: method2,
  number: number2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer2,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone2() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
var Schema = /* @__PURE__ */ function() {
  function Schema2(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }
  var _proto = Schema2.prototype;
  _proto.define = function define(rules2) {
    var _this = this;
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    Object.keys(rules2).forEach(function(name) {
      var item = rules2[name];
      _this.rules[name] = Array.isArray(item) ? item : [item];
    });
  };
  _proto.messages = function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  };
  _proto.validate = function validate2(source_, o2, oc2) {
    var _this2 = this;
    if (o2 === void 0) {
      o2 = {};
    }
    if (oc2 === void 0) {
      oc2 = function oc3() {
      };
    }
    var source = source_;
    var options = o2;
    var callback = oc2;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }
      return Promise.resolve(source);
    }
    function complete(results) {
      var errors = [];
      var fields = {};
      function add(e10) {
        if (Array.isArray(e10)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e10);
        } else {
          errors.push(e10);
        }
      }
      for (var i2 = 0; i2 < results.length; i2++) {
        add(results[i2]);
      }
      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function(z2) {
      var arr = _this2.rules[z2];
      var value = source[z2];
      arr.forEach(function(r3) {
        var rule = r3;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z2] = rule.transform(value);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        if (!rule.validator) {
          return;
        }
        rule.field = z2;
        rule.fullField = rule.fullField || z2;
        rule.type = _this2.getType(rule);
        series[z2] = series[z2] || [];
        series[z2].push({
          rule,
          value,
          source,
          field: z2
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullField(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }
      function cb2(e10) {
        if (e10 === void 0) {
          e10 = [];
        }
        var errorList = Array.isArray(e10) ? e10 : [e10];
        if (!options.suppressWarning && errorList.length) {
          Schema2.warning("async-validator:", errorList);
        }
        if (errorList.length && rule.message !== void 0) {
          errorList = [].concat(rule.message);
        }
        var filledErrors = errorList.map(complementError(rule, source));
        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }
        if (!deep) {
          doIt(filledErrors);
        } else {
          if (rule.required && !data.value) {
            if (rule.message !== void 0) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
            }
            return doIt(filledErrors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            Object.keys(data.value).map(function(key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function(field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema2(paredFieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function(errs) {
            var finalErrors = [];
            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb2, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb2, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error);
          if (!options.suppressValidatorError) {
            setTimeout(function() {
              throw error;
            }, 0);
          }
          cb2(error.message);
        }
        if (res === true) {
          cb2();
        } else if (res === false) {
          cb2(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb2(res);
        } else if (res instanceof Error) {
          cb2(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb2();
        }, function(e10) {
          return cb2(e10);
        });
      }
    }, function(results) {
      complete(results);
    }, source);
  };
  _proto.getType = function getType(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  };
  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf("message");
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || void 0;
  };
  return Schema2;
}();
Schema.register = function register2(type4, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator;
};
Schema.warning = warning;
Schema.messages = messages;
Schema.validators = validators;
const getFormItemRules = (propNames, rules2) => {
  var _a3;
  const names = propNames.split(".");
  if (names.length == 0) {
    return;
  }
  let rule = rules2[names[0]];
  if (names.length > 1) {
    for (let i2 = 1; i2 < names.length; i2++) {
      if (!rule) {
        return;
      }
      rule = (_a3 = rule.fields || rule.defaultField.fields) == null ? void 0 : _a3[names[i2]];
    }
  }
  return convertToFormItemRule(rule);
};
const convertToFormItemRule = (rule) => {
  if (!rule) {
    return;
  }
  if (Array.isArray(rule)) {
    return rule.map((item) => {
      return { ...item, trigger: ["blur", "change"] };
    });
  } else {
    return { ...rule, trigger: ["blur", "change"] };
  }
};
const getWebHookEventConfigFormRules = (t2) => {
  const rules2 = getWebHookEventConfigRules(t2);
  return {
    "extraProperties": { type: "object", required: true },
    "extraProperties.url": getFormItemRules("extraProperties.url", rules2),
    "extraProperties.encodingName": getFormItemRules("extraProperties.encodingName", rules2)
  };
};
const getStoredProcedureEventConfigFormRules = (t2) => {
  const rules2 = getStoredProcedureEventConfigRules(t2);
  return {
    "extraProperties": { required: true },
    "extraProperties.storedProcedureName": getFormItemRules("extraProperties.storedProcedureName", rules2)
  };
};
const getIntegrationEventConfigFormRules = (t2) => {
  const rules2 = getIntegrationEventConfigRules(t2);
  return {
    "eventName": getFormItemRules("eventName", rules2)
  };
};
const getWebHookEventConfigRules = (t2) => {
  return {
    triggerDescriptor: {
      type: "object",
      fields: {
        componentCode: [{ required: true, message: t2("EventType_Validator_required") }]
      }
    },
    extraProperties: {
      type: "object",
      required: true,
      fields: {
        url: [{ required: true, message: t2("Url_validator_required") }],
        encodingName: [
          { required: true, message: t2("EncodingName_validator_required") }
        ]
      }
    }
  };
};
const getIntegrationEventConfigRules = (t2) => {
  return {
    triggerDescriptor: {
      type: "object",
      fields: {
        componentCode: [{
          required: true,
          message: t2("EventType_Validator_required")
        }]
      }
    },
    eventName: [{ required: true, message: t2("EventName_validator_required") }, {
      min: 1,
      max: 50,
      message: t2("EventName_validator_min_max")
    }]
  };
};
const getStoredProcedureEventConfigRules = (t2) => {
  return {
    triggerDescriptor: {
      type: "object",
      fields: {
        componentCode: [{
          required: true,
          message: t2("EventType_Validator_required")
        }]
      }
    },
    extraProperties: {
      type: "object",
      required: true,
      fields: {
        storedProcedureName: [{
          required: true,
          message: t2("StoredProcedureName_validator_required")
        }, { min: 1, max: 50, message: t2("StoredProcedureName_validator_min_max") }]
      }
    }
  };
};
const getEventConfigRules = (componentCode, t2) => {
  switch (componentCode) {
    case "StoredProcedure":
      return getStoredProcedureEventConfigRules(t2);
    case "WebHook":
      return getWebHookEventConfigRules(t2);
    default:
      return getIntegrationEventConfigRules(t2);
  }
};
const routePolicyCodes = [
  RoutePolicyDescriptorCodes.AlwaysTrue,
  RoutePolicyDescriptorCodes.Standard,
  RoutePolicyDescriptorCodes.ProportionalVoting,
  RoutePolicyDescriptorCodes.FixedQuorumDecision,
  RoutePolicyDescriptorCodes.Countersign,
  RoutePolicyDescriptorCodes.OrSign
];
const getRoutePolicySettingRule = (componentCode, t2) => {
  switch (componentCode) {
    case RoutePolicyDescriptorCodes.ProportionalVoting:
      return {
        percentage: [{ type: "number", required: true, message: t2("Percentage_validator_required") }],
        routeCondition: [{ required: true, message: t2("Condition_validator_required") }]
      };
    case RoutePolicyDescriptorCodes.FixedQuorumDecision:
      return {
        quorumThreshold: [
          { required: true, message: t2("QuorumThreshold_validator_required") },
          {
            type: "number",
            min: 1,
            message: t2("QuorumThreshold_validator_min")
          }
        ],
        routeCondition: [{ required: true, message: t2("Condition_validator_required") }]
      };
    case RoutePolicyDescriptorCodes.Standard:
    case RoutePolicyDescriptorCodes.Countersign:
    case RoutePolicyDescriptorCodes.OrSign:
      return { routeCondition: [{ required: true, message: t2("Condition_validator_required") }] };
    default:
      return void 0;
  }
};
const getRoutePolicyRule = (componentCode, t2) => {
  const rules2 = {
    componentCode: [{ required: true, type: "enum", enum: routePolicyCodes, message: t2("ComponentCode_validator_enum") }]
  };
  const settingsRules = getRoutePolicySettingRule(componentCode, t2);
  if (settingsRules) {
    rules2.settings = { type: "object", required: true, fields: settingsRules };
  }
  return rules2;
};
const getRoutePolicyFormRule = (componentCode, t2) => {
  const rules2 = getRoutePolicyRule(componentCode, t2);
  switch (componentCode) {
    case RoutePolicyDescriptorCodes.ProportionalVoting:
      return {
        "componentCode": getFormItemRules("componentCode", rules2),
        "settings.percentage": getFormItemRules("settings.percentage", rules2),
        "settings.routeCondition": getFormItemRules("settings.routeCondition", rules2)
      };
    case RoutePolicyDescriptorCodes.FixedQuorumDecision:
      return {
        "componentCode": getFormItemRules("componentCode", rules2),
        "settings.quorumThreshold": getFormItemRules("settings.quorumThreshold", rules2),
        "settings.routeCondition": getFormItemRules("settings.routeCondition", rules2)
      };
    case RoutePolicyDescriptorCodes.Standard:
    case RoutePolicyDescriptorCodes.Countersign:
    case RoutePolicyDescriptorCodes.OrSign:
      return {
        "componentCode": getFormItemRules("componentCode", rules2),
        "settings.routeCondition": getFormItemRules("settings.routeCondition", rules2)
      };
    default:
      return { "componentCode": getFormItemRules("componentCode", rules2) };
  }
};
const templateEditorValidator = (rule, value, callback, t2) => {
  if (isNullOrUndefinedOrWhiteSpace(value)) {
    const message = t2("subject_validator_required");
    callback(message);
  }
  if (value === "<p><br></p>") {
    const message = t2("subject_validator_required");
    callback(message);
  }
  callback();
};
async function executeValidator(newRules, value, options, callback) {
  await new Schema(newRules).validate(value, options, (errors, fields) => {
    if (Array.isArray(errors) && errors.length > 0) {
      callback(errors[0].message);
      return;
    }
    callback();
  });
}
const validateEventTriggerDefinitionDto = async (rule, value, callback, source, options, t2) => {
  const rules2 = getEventConfigRules(value.triggerDescriptor.componentCode, t2);
  await executeValidator(rules2, value, options, callback);
};
const validateHandlerFinderDescriptor = async (rule, value, callback, source, options, t2) => {
  const rules2 = getHandlerFinderRules(value.componentCode, t2);
  if (!rules2) {
    callback();
    return;
  }
  await executeValidator(rules2, value, options, callback);
};
const validateRoutePolicyDescriptor = async (rule, value, callback, source, options, t2) => {
  const rules2 = getRoutePolicyRule(value.componentCode, t2);
  if (!rules2) {
    callback(t2("componentCode_validator_required"));
    return;
  }
  await executeValidator(rules2, value, options, callback);
};
const getNodeGeneralRules = (flowDesignerModel, t2) => {
  return {
    "code": [
      { required: true, message: t2("Code_Validator_Required") },
      {
        min: 1,
        max: 50,
        message: t2("Code_validator_min_max")
      },
      {
        validator: (rule, value, callback) => {
          const errorKey = flowDesignerModel == null ? void 0 : flowDesignerModel.validateCode(value);
          if (!isNullOrUndefinedOrWhiteSpace(errorKey)) {
            const message = t2(errorKey);
            callback(message);
            return;
          }
          callback();
        }
      }
    ],
    name: [{ required: true, min: 1, max: 50, message: t2("Name_validator_min_max"), trigger: ["blur", "change"] }],
    descriptions: [{
      max: 250,
      message: t2("Description_validator_max")
    }]
  };
};
const getSubjectFormatSettingDtoRules = (t2) => {
  return {
    enabled: { type: "boolean", required: true },
    subjectSpecification: {
      type: "object",
      required: true,
      fields: {
        allowedRepeatPriority: { type: "boolean", required: true },
        items: {
          type: "array",
          min: 1,
          message: t2("SubjectFormatSettingItem_validator_required"),
          defaultField: {
            type: "object",
            fields: getPriorityConditionSpecificationDtoRules(t2, () => {
              return {
                required: true,
                validator: (rule, value, callback) => {
                  templateEditorValidator(rule, value, callback, t2);
                },
                message: t2("SubjectFormating_validator_required")
              };
            })
          }
        }
      }
    }
  };
};
const getEventTriggerGroupDefinitionRules = (t2) => {
  return {
    triggerTiming: { type: "enum", enum: triggerTimingArray, message: t2("TriggerTiming_validator_Enum") },
    eventTriggerDefinitions: {
      type: "array",
      min: 1,
      max: 1,
      defaultField: {
        asyncValidator: (rule, value, callback, source, options) => {
          return validateEventTriggerDefinitionDto(rule, value, callback, source, options, t2);
        }
      }
    }
  };
};
const getPriorityConditionSpecificationDtoRules = (t2, valueRuleCreate) => {
  return {
    priority: { type: "number", required: true, message: t2("Priority_validator_required") },
    triggerTiming: { type: "enum", enum: triggerTimingArray, message: t2("TriggerTiming_validator_Enum") },
    value: valueRuleCreate()
  };
};
const getNodeOwnerDescriptorDtoRules = (t2) => {
  return {
    allowedToBeMutilpeHandlers: {
      type: "boolean",
      required: true,
      message: t2("allowedToBeMultiple_validator_required")
    },
    all: { type: "boolean", required: true, message: t2("all_validator_required") },
    handlerFinderDescriptors: {
      type: "array",
      required: true,
      message: t2("handlerFinderDescriptors_validator_required"),
      min: 1,
      defaultField: {
        asyncValidator: (rule, value, callback, source, options) => {
          return validateHandlerFinderDescriptor(rule, value, callback, source, options, t2);
        }
      }
    }
  };
};
const getProcessNodeHandlerDescriptorDtoRules = (t2) => {
  return {
    allowedToBeMutilpeHandlers: {
      type: "boolean",
      required: true,
      message: t2("allowedToBeMultiple_validator_required")
    },
    allowedToBeEmpty: { type: "boolean", required: true, message: t2("allowedToBeEmpty_validator_required") },
    all: { type: "boolean", required: true, message: t2("all_validator_required") },
    handlerFinderDescriptors: {
      type: "array",
      required: true,
      message: t2("handlerFinderDescriptors_validator_required"),
      min: 1,
      defaultField: {
        asyncValidator: (rule, value, callback, source, options) => {
          return validateHandlerFinderDescriptor(rule, value, callback, source, options, t2);
        }
      }
    }
  };
};
const getCarbonCopySettingsDtoRules = (t2) => {
  return {
    enabled: { type: "boolean", required: true, message: t2("Enabled_validator_required") },
    ccSpecification: {
      type: "object",
      fields: {
        allowedRepeatPriority: {
          type: "boolean",
          required: true,
          message: t2("allowedRepeatPriority_validator_required")
        },
        items: {
          type: "array",
          min: 1,
          message: t2("Items_validator_required"),
          defaultField: {
            type: "object",
            fields: getPriorityConditionSpecificationDtoRules(t2, () => {
              return { type: "object", required: true, fields: getProcessNodeHandlerDescriptorDtoRules(t2) };
            })
          }
        }
      }
    }
  };
};
const getNotificationSettingsDtoRules = (t2) => {
  return {
    enabled: { type: "boolean", required: true, message: t2("Enabled_validator_required") },
    notificationSettingSpecification: {
      type: "object",
      required: true,
      fields: {
        allowedRepeatPriority: {
          type: "boolean",
          required: true,
          message: t2("allowedRepeatPriority_validator_required")
        },
        items: {
          type: "array",
          min: 1,
          message: t2("Items_validator_required"),
          defaultField: {
            type: "object",
            fields: getPriorityConditionSpecificationDtoRules(t2, () => {
              return {
                type: "object",
                fields: getNotificationSettingItemDtoRules(t2)
              };
            })
          }
        }
      },
      message: t2("notificationSettingSpecification_validator_required")
    }
  };
};
const getNotificationSettingItemDtoRules = (t2) => {
  return {
    enabled: { type: "boolean", required: true, message: t2("Enabled_validator_required") },
    notificationDescriptor: {
      type: "object",
      required: true,
      fields: {
        componentCode: {
          type: "enum",
          required: true,
          enum: ["EmailNotification"],
          message: t2("notification_componentCode_validator_enum")
        },
        settings: {
          type: "object",
          required: true,
          fields: {
            subjectTemplate: [{
              required: true,
              validator: (rule, value, callback) => {
                templateEditorValidator(rule, value, callback, t2);
              },
              message: t2("SubjectTemplate_validator_required")
            }],
            emailBodyTemplate: [{
              required: true,
              validator: (rule, value, callback) => {
                templateEditorValidator(rule, value, callback, t2);
              },
              message: t2("EmailBodyTemplate_validator_required")
            }]
          }
        }
      }
    }
  };
};
const getNodeDefinitionValidatorRule = (flowDesignerModel, t2) => {
  return {
    ...getNodeGeneralRules(flowDesignerModel, t2),
    subjectFormatSetting: {
      type: "object",
      fields: getSubjectFormatSettingDtoRules(t2)
    },
    nodeType: { required: true, message: t2("nodeType_validator_required") },
    eventDefinitions: {
      type: "array",
      defaultField: { type: "object", fields: getEventTriggerGroupDefinitionRules(t2) }
    },
    ownerFinderDescriptor: {
      type: "object",
      fields: getNodeOwnerDescriptorDtoRules(t2)
    },
    carbonCopySettings: {
      type: "object",
      fields: getCarbonCopySettingsDtoRules(t2)
    },
    notificationSettings: {
      type: "object",
      fields: getNotificationSettingsDtoRules(t2)
    }
  };
};
const getRouteDefinitionValidatorRule = (t2) => {
  return {
    code: { required: true },
    processNodeDefinitionCode: { required: true },
    nextProcessNodeDefinitionCode: { required: true },
    routePolicyDescriptor: {
      asyncValidator: (rule, value, callback, source, options) => {
        return validateRoutePolicyDescriptor(rule, value, callback, source, options, t2);
      }
    },
    eventDefinitions: {
      type: "array",
      defaultField: {
        type: "object",
        fields: getEventTriggerGroupDefinitionRules(t2)
      }
    }
  };
};
const getNodeGeneralFormRules = (flowDesignerModel, t2) => {
  const rules2 = getNodeGeneralRules(flowDesignerModel, t2);
  return {
    "code": getFormItemRules("code", rules2),
    name: getFormItemRules("name", rules2),
    descriptions: getFormItemRules("descriptions", rules2)
  };
};
const getSubjectFormatSettingItemFormRules = (t2) => {
  let rules2 = getSubjectFormatSettingDtoRules(t2);
  rules2 = rules2.subjectSpecification.fields.items.defaultField.fields;
  return {
    triggerTiming: getFormItemRules("triggerTiming", rules2),
    value: getFormItemRules("value", rules2)
  };
};
const getCcTriggerTimingFormRules = (t2) => {
  return {
    triggerTiming: [{
      type: "enum",
      enum: triggerTimingArray,
      trigger: ["change", "blur"],
      message: t2("TriggerTiming_validator_Enum")
    }]
  };
};
const getNotificationItemFormRule = (t2) => {
  let rules2 = getNotificationSettingsDtoRules(t2);
  rules2 = rules2.notificationSettingSpecification.fields.items.defaultField.fields;
  return {
    triggerTiming: getFormItemRules("triggerTiming", rules2),
    "value.notificationDescriptor.settings.subjectTemplate": getFormItemRules("value.notificationDescriptor.settings.subjectTemplate", rules2),
    "value.notificationDescriptor.settings.emailBodyTemplate": getFormItemRules("value.notificationDescriptor.settings.emailBodyTemplate", rules2)
  };
};
const getEventDefinitionFormRules = (t2) => {
  const rules2 = getEventTriggerGroupDefinitionRules(t2);
  return {
    "eventTriggerDefinitions": { type: "array", min: 1, max: 1 },
    "eventTriggerDefinitions[0].triggerDescriptor.componentCode": [{
      required: true,
      message: t2("EventType_Validator_required"),
      trigger: ["blur", "change"]
    }],
    "triggerTiming": getFormItemRules("triggerTiming", rules2)
  };
};
const useFlowTemplateFields = (fields) => {
  const flowModel = injectFlowDesignerModel();
  const formItems = computed(() => {
    var _a3, _b3;
    const formSchema = (_b3 = flowModel == null ? void 0 : flowModel.value) == null ? void 0 : _b3.getFormSchema((_a3 = flowModel == null ? void 0 : flowModel.value) == null ? void 0 : _a3.activeNodeId);
    return getFormFieldItemsForDisplay(formSchema);
  });
  return computedAsync(async () => {
    let categorizedTemplateFields = [];
    if (isFunction$2(fields)) {
      categorizedTemplateFields = await fields();
    } else {
      categorizedTemplateFields = fields;
    }
    if (Array.isArray(formItems.value)) {
      const templateFields = formItems.value.map((item) => {
        return { text: item.label, value: item.value };
      });
      categorizedTemplateFields.push({ categoryName: "FormData", fields: templateFields });
    }
    return categorizedTemplateFields;
  });
};
const _hoisted_1$8 = { style: { "height": "100%", "overflow": "auto" } };
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "SubjectFormatSettingConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const initialize = () => {
      var _a3;
      if (!((_a3 = model.value) == null ? void 0 : _a3.subjectSpecification)) {
        model.value.subjectSpecification = {
          allowedRepeatPriority: true,
          items: []
        };
      }
    };
    watch(model, initialize, { immediate: true });
    const { addFormInstance, removeFormInstance, validator } = useFormInstanceArrayWrapper();
    const removeSubjectFormatSetting = (index2) => {
      var _a3, _b3, _c3;
      (_c3 = (_b3 = (_a3 = model.value) == null ? void 0 : _a3.subjectSpecification) == null ? void 0 : _b3.items) == null ? void 0 : _c3.splice(index2, 1);
      removeFormInstance(index2);
    };
    const addSubjectFormatSetting = () => {
      model.value.subjectSpecification.items.push({
        priority: 0,
        condition: "",
        triggerTiming: "",
        value: ""
      });
    };
    const conditionOptions = computed(() => getFlowConditionOptions(props.formSchema));
    const { t: t2 } = useLocale();
    const { subjectTemplateFields } = injectFlowDesignerConfig();
    const templateFields = useFlowTemplateFields(subjectTemplateFields);
    __expose({ formValidator: validator });
    const formRules = getSubjectFormatSettingItemFormRules(t2);
    return (_ctx, _cache) => {
      var _a3;
      const _component_el_checkbox = resolveComponent("el-checkbox");
      const _component_el_divider = resolveComponent("el-divider");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_link = resolveComponent("el-link");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_row = resolveComponent("el-row");
      const _component_el_card = resolveComponent("el-card");
      const _component_el_button = resolveComponent("el-button");
      return openBlock(), createElementBlock("div", _hoisted_1$8, [
        createVNode(_component_el_checkbox, {
          modelValue: model.value.enabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.enabled = $event)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("Enable")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        createVNode(_component_el_divider),
        (openBlock(true), createElementBlock(Fragment, null, renderList((_a3 = model.value) == null ? void 0 : _a3.subjectSpecification.items, (item, index2) => {
          return openBlock(), createBlock(_component_el_card, {
            shadow: "never",
            class: "el-card-margin-bottom"
          }, {
            default: withCtx(() => {
              var _a4;
              return [
                createVNode(_component_el_form, {
                  "label-width": "auto",
                  model: (_a4 = model.value) == null ? void 0 : _a4.subjectSpecification.items[index2],
                  ref_for: true,
                  ref: (formInstance) => unref(addFormInstance)(formInstance, index2),
                  rules: unref(formRules)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_form_item, {
                      label: unref(t2)("TriggerTiming"),
                      prop: "triggerTiming"
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$q, {
                          modelValue: item.triggerTiming,
                          "onUpdate:modelValue": ($event) => item.triggerTiming = $event
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    createVNode(_component_el_form_item, {
                      label: unref(t2)("Condition")
                    }, {
                      default: withCtx(() => [
                        createVNode(component$3, {
                          "condition-options": conditionOptions.value,
                          modelValue: item.condition,
                          "onUpdate:modelValue": ($event) => item.condition = $event
                        }, null, 8, ["condition-options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label"]),
                    createVNode(_component_el_form_item, {
                      label: unref(t2)("Subject"),
                      prop: "value"
                    }, {
                      default: withCtx(() => [
                        createVNode(component$2, {
                          "template-fields": unref(templateFields),
                          modelValue: item.value,
                          "onUpdate:modelValue": ($event) => item.value = $event,
                          "custom-title": "Subject"
                        }, null, 8, ["template-fields", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]),
                  _: 2
                }, 1032, ["model", "rules"]),
                createVNode(_component_el_row, { justify: "end" }, {
                  default: withCtx(() => [
                    createVNode(_component_el_col, { span: 4 }, {
                      default: withCtx(() => [
                        createVNode(_component_el_link, {
                          onClick: () => removeSubjectFormatSetting(index2)
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(t2)("DeleteSubjectFormat")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ];
            }),
            _: 2
          }, 1024);
        }), 256)),
        createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = () => addSubjectFormatSetting())
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("AddSubjectFormat")), 1)
          ]),
          _: 1
        })
      ]);
    };
  }
});
const _hoisted_1$7 = { class: "approver_content" };
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "NodeHandlerDescriptorConfig",
  props: /* @__PURE__ */ mergeModels({
    allowedToBeEmpty: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const initialize = () => {
      if (!model.value) {
        model.value = {
          allowedToBeMutilpeHandlers: false,
          handlerFinderDescriptors: [],
          allowedToBeEmpty: false,
          all: true
        };
        if (!props.allowedToBeEmpty) {
          model.value.allowedToBeEmpty = false;
        }
      }
    };
    onBeforeUpdate(initialize);
    const {
      addComponentInstance,
      removeComponentInstance,
      removeComponentInstanceIf,
      validator
    } = useFormValidatorMapWrapper();
    const toggleSelectFinder = (selected, code) => {
      var _a3;
      if ((_a3 = model.value) == null ? void 0 : _a3.allowedToBeMutilpeHandlers) {
        if (!selected) {
          model.value.handlerFinderDescriptors.removeIf((item) => item.componentCode == code);
          removeComponentInstance(code);
        } else {
          model.value.handlerFinderDescriptors.push({ componentCode: code, settings: {} });
        }
      } else {
        if (selected) {
          model.value.handlerFinderDescriptors = [{ componentCode: code, settings: {} }];
        } else {
          model.value.handlerFinderDescriptors = [];
        }
      }
    };
    const toggleAllowedToBeMultipleHandlers = (checked) => {
      var _a3, _b3;
      if (!checked) {
        if (((_a3 = model.value) == null ? void 0 : _a3.handlerFinderDescriptors) && ((_b3 = model.value) == null ? void 0 : _b3.handlerFinderDescriptors.length) > 1) {
          model.value.handlerFinderDescriptors = [model.value.handlerFinderDescriptors[0]];
          removeComponentInstanceIf((key) => {
            var _a4;
            return key != ((_a4 = model.value) == null ? void 0 : _a4.handlerFinderDescriptors[0].componentCode);
          });
        }
      }
    };
    const { t: t2 } = useLocale();
    const formRules = computed(() => {
      if (!props.allowedToBeEmpty) {
        return { handlerFinderDescriptors: [{
          type: "array",
          required: true,
          min: 1,
          message: t2("HandlerFinderDescriptors_validator_min"),
          trigger: ["blur", "change"]
        }] };
      }
    });
    const formInstance = ref();
    const nameFormValidator = useNamedFormValidator("nodeHandlerC", formInstance);
    const formValidator = useMultipleFormValidator(nameFormValidator, validator);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_checkbox = resolveComponent("el-checkbox");
      const _component_el_divider = resolveComponent("el-divider");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1$7, [
          createVNode(_component_el_checkbox, {
            modelValue: model.value.allowedToBeMutilpeHandlers,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.allowedToBeMutilpeHandlers = $event),
            onChange: toggleAllowedToBeMultipleHandlers
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("AllowMultipleApprovers")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _ctx.allowedToBeEmpty && model.value.hasOwnProperty("allowedToBeEmpty") ? (openBlock(), createBlock(_component_el_checkbox, {
            key: 0,
            modelValue: model.value.allowedToBeEmpty,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.allowedToBeEmpty = $event)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("AllowedToBeEmpty")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])) : createCommentVNode("", true),
          createVNode(_component_el_checkbox, {
            modelValue: model.value.all,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.all = $event)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t2)("All")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          createVNode(_component_el_divider, { style: { "margin": "0 !important" } }),
          createVNode(_component_el_form, {
            ref_key: "formInstance",
            ref: formInstance,
            model: model.value,
            rules: formRules.value
          }, {
            default: withCtx(() => [
              createVNode(_component_el_form_item, { prop: "handlerFinderDescriptors" }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(getAllHandlerFinderDescriptorCodes)(), (code) => {
                    var _a3, _b3;
                    return openBlock(), createBlock(_component_el_checkbox, {
                      "model-value": (_b3 = (_a3 = model.value) == null ? void 0 : _a3.handlerFinderDescriptors) == null ? void 0 : _b3.some((i2) => i2.componentCode == code),
                      onChange: (value) => toggleSelectFinder(value, code),
                      label: unref(t2)(code)
                    }, null, 8, ["model-value", "onChange", "label"]);
                  }), 256))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        createVNode(unref(lo$2), {
          modelValue: model.value.handlerFinderDescriptors,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => model.value.handlerFinderDescriptors = $event)
        }, {
          default: withCtx(() => {
            var _a3;
            return [
              (openBlock(true), createElementBlock(Fragment, null, renderList((_a3 = model.value) == null ? void 0 : _a3.handlerFinderDescriptors, (finderDescriptors) => {
                return openBlock(), createElementBlock("div", {
                  key: finderDescriptors.componentCode
                }, [
                  (openBlock(), createBlock(resolveDynamicComponent(unref(finderMap).get(finderDescriptors.componentCode)), {
                    ref_for: true,
                    ref: (comp) => {
                      unref(addComponentInstance)(comp, finderDescriptors.componentCode);
                    },
                    modelValue: finderDescriptors.settings,
                    "onUpdate:modelValue": ($event) => finderDescriptors.settings = $event
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                ]);
              }), 128))
            ];
          }),
          _: 1
        }, 8, ["modelValue"])
      ], 64);
    };
  }
});
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "CarbonCopySettingsConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const removeCarbonCopySetting = (index2) => {
      var _a3, _b3, _c3;
      (_c3 = (_b3 = (_a3 = model.value) == null ? void 0 : _a3.ccSpecification) == null ? void 0 : _b3.items) == null ? void 0 : _c3.splice(index2, 1);
      formInstanceArrayWrapper.removeFormInstance(index2);
      componentInstanceArrayWrapper.removeComponentInstance(index2);
    };
    const addCarbonCopySetting = () => {
      var _a3;
      if (!model.value) {
        model.value = {
          enabled: true,
          ccSpecification: { allowedRepeatPriority: true, items: [] }
        };
      }
      if (!((_a3 = model.value) == null ? void 0 : _a3.ccSpecification)) {
        model.value.ccSpecification = { allowedRepeatPriority: true, items: [] };
      }
      model.value.ccSpecification.items.push({
        priority: 0,
        condition: "",
        triggerTiming: "NodeInstanceFinishedEvent",
        value: {
          allowedToBeMutilpeHandlers: false,
          all: false,
          allowedToBeEmpty: false,
          handlerFinderDescriptors: []
        }
      });
    };
    const conditionOptions = computed(() => getFlowConditionOptions(props.formSchema));
    const { t: t2 } = useLocale();
    const formInstanceArrayWrapper = useNamedFormInstanceArrayWrapper("cc_triggerTiming");
    const componentInstanceArrayWrapper = useNamedFormValidatorArrayWrapper("cc_handler");
    const formValidator = useNamedMultipleFormValidator("cc", formInstanceArrayWrapper.validator, componentInstanceArrayWrapper.validator);
    const ccTriggerTimingRules = getCcTriggerTimingFormRules(t2);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      var _a3, _b3;
      const _component_el_checkbox = resolveComponent("el-checkbox");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_card = resolveComponent("el-card");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_el_checkbox, {
          modelValue: model.value.enabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.enabled = $event)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("Enable")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList((_b3 = (_a3 = model.value) == null ? void 0 : _a3.ccSpecification) == null ? void 0 : _b3.items, (item, index2) => {
          return openBlock(), createBlock(_component_el_card, {
            shadow: "never",
            class: "el-card-margin-bottom"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_form, {
                model: item,
                "label-width": "auto",
                ref_for: true,
                ref: (comp) => unref(formInstanceArrayWrapper).addFormInstance(comp, index2),
                rules: unref(ccTriggerTimingRules)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("TriggerTiming"),
                    prop: "triggerTiming"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$q, {
                        modelValue: item.triggerTiming,
                        "onUpdate:modelValue": ($event) => item.triggerTiming = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("Condition")
                  }, {
                    default: withCtx(() => [
                      createVNode(component$3, {
                        modelValue: item.condition,
                        "onUpdate:modelValue": ($event) => item.condition = $event,
                        "condition-options": conditionOptions.value
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "condition-options"])
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]),
                _: 2
              }, 1032, ["model", "rules"]),
              createVNode(_sfc_main$l, {
                ref_for: true,
                ref: (comp) => {
                  unref(componentInstanceArrayWrapper).addComponentInstance(comp, index2);
                },
                modelValue: item.value,
                "onUpdate:modelValue": ($event) => item.value = $event,
                "allowed-to-be-empty": true
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              createVNode(_component_el_col, {
                span: 24,
                style: { "text-align": "right" }
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_button, {
                    type: "primary",
                    text: "",
                    onClick: () => removeCarbonCopySetting(index2)
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("DeleteCC")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024);
        }), 256)),
        createVNode(_component_el_col, {
          span: 24,
          style: { "text-align": "right" }
        }, {
          default: withCtx(() => [
            createVNode(_component_el_button, {
              type: "primary",
              text: "",
              onClick: addCarbonCopySetting
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("AddCC")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "NotificationSettingsConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const removeNotificationSetting = (index2) => {
      var _a3, _b3, _c3;
      (_c3 = (_b3 = (_a3 = model.value) == null ? void 0 : _a3.notificationSettingSpecification) == null ? void 0 : _b3.items) == null ? void 0 : _c3.splice(index2, 1);
      removeFormInstance(index2);
    };
    const addNotificationSetting = () => {
      var _a3;
      if (!((_a3 = model.value) == null ? void 0 : _a3.notificationSettingSpecification)) {
        model.value.notificationSettingSpecification = { allowedRepeatPriority: true, items: [] };
      }
      model.value.notificationSettingSpecification.items.push({
        priority: 0,
        condition: "",
        triggerTiming: "",
        value: {
          enabled: true,
          notificationDescriptor: {
            componentCode: "EmailNotification",
            settings: {
              subjectTemplate: "",
              emailBodyTemplate: ""
            }
          }
        }
      });
    };
    const conditionOptions = computed(() => getFlowConditionOptions(props.formSchema));
    const { t: t2 } = useLocale();
    const { emailTemplateFields } = injectFlowDesignerConfig();
    const templateFields = useFlowTemplateFields(emailTemplateFields);
    const { validator, addFormInstance, removeFormInstance } = useFormInstanceArrayWrapper();
    __expose({ formValidator: validator });
    const formRules = getNotificationItemFormRule(t2);
    return (_ctx, _cache) => {
      var _a3, _b3;
      const _component_el_checkbox = resolveComponent("el-checkbox");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_link = resolveComponent("el-link");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_row = resolveComponent("el-row");
      const _component_el_card = resolveComponent("el-card");
      const _component_el_button = resolveComponent("el-button");
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_el_checkbox, {
          modelValue: model.value.enabled,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.enabled = $event)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(t2)("Enable")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (openBlock(true), createElementBlock(Fragment, null, renderList((_b3 = (_a3 = model.value) == null ? void 0 : _a3.notificationSettingSpecification) == null ? void 0 : _b3.items, (item, index2) => {
          return openBlock(), createBlock(_component_el_card, {
            shadow: "never",
            class: "el-card-margin-bottom"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_form, {
                model: item,
                "label-width": "auto",
                ref_for: true,
                ref: (formInstance) => unref(addFormInstance)(formInstance, index2),
                rules: unref(formRules)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("TriggerTiming"),
                    prop: "triggerTiming"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$q, {
                        modelValue: item.triggerTiming,
                        "onUpdate:modelValue": ($event) => item.triggerTiming = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("Condition")
                  }, {
                    default: withCtx(() => [
                      createVNode(component$3, {
                        "condition-options": conditionOptions.value,
                        modelValue: item.condition,
                        "onUpdate:modelValue": ($event) => item.condition = $event
                      }, null, 8, ["condition-options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("subject"),
                    prop: "value.notificationDescriptor.settings.subjectTemplate"
                  }, {
                    default: withCtx(() => [
                      createVNode(component$2, {
                        "model-value": item.value.notificationDescriptor.settings.subjectTemplate,
                        "template-fields": unref(templateFields),
                        "custom-title": "subject",
                        "onUpdate:valueText": (text) => item.value.notificationDescriptor.settings.subjectTemplate = text
                      }, null, 8, ["model-value", "template-fields", "onUpdate:valueText"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("EmailBody"),
                    prop: "value.notificationDescriptor.settings.emailBodyTemplate"
                  }, {
                    default: withCtx(() => [
                      createVNode(component$2, {
                        modelValue: item.value.notificationDescriptor.settings.emailBodyTemplate,
                        "onUpdate:modelValue": ($event) => item.value.notificationDescriptor.settings.emailBodyTemplate = $event,
                        "template-fields": unref(templateFields),
                        "custom-title": "EmailBody"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "template-fields"])
                    ]),
                    _: 2
                  }, 1032, ["label"])
                ]),
                _: 2
              }, 1032, ["model", "rules"]),
              createVNode(_component_el_row, { justify: "end" }, {
                default: withCtx(() => [
                  createVNode(_component_el_col, { span: 4 }, {
                    default: withCtx(() => [
                      createVNode(_component_el_link, {
                        onClick: () => removeNotificationSetting(index2)
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(t2)("DeleteNotification")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024);
        }), 256)),
        createVNode(_component_el_row, { justify: "end" }, {
          default: withCtx(() => [
            createVNode(_component_el_col, { span: 4 }, {
              default: withCtx(() => [
                createVNode(_component_el_button, { onClick: addNotificationSetting }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(t2)("AddNotification")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "FormPermissionConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const props = __props;
    const viewItemsRef = ref([]);
    const initialize = () => {
      const items = getAllItems(props.formSchema);
      viewItemsRef.value = items.map((item) => {
        return { propertyName: item.value, disabled: false, readonly: false, hidden: false, label: item.label };
      });
      initializeComponentOptions();
    };
    const initializeComponentOptions = () => {
      var _a3;
      (_a3 = viewItemsRef.value) == null ? void 0 : _a3.forEach((item) => {
        var _a4, _b3;
        const options = (_b3 = (_a4 = model.value) == null ? void 0 : _a4.componentOptions) == null ? void 0 : _b3.find((i2) => i2.propertyName == item.propertyName);
        if (options) {
          item.disabled = options.disabled || options.readonly;
          item.readonly = options.readonly;
          item.hidden = options.hidden;
        } else {
          item.disabled = false;
          item.readonly = false;
          item.hidden = false;
        }
      });
    };
    const allEditable = computed(() => viewItemsRef.value.all((i2) => !i2.disabled && !i2.hidden && !i2.readonly));
    const checkedAllEditable = () => {
      viewItemsRef.value.forEach((i2) => {
        i2.disabled = false;
        i2.readonly = false;
        i2.hidden = false;
      });
    };
    const allReadonly = computed(() => viewItemsRef.value.all((i2) => i2.readonly));
    const allHidden = computed(() => viewItemsRef.value.all((i2) => i2.hidden));
    const checkedAllReadonly = () => {
      viewItemsRef.value.forEach((i2) => {
        i2.disabled = true;
        i2.readonly = true;
        i2.hidden = false;
      });
    };
    const checkedAllHide = () => {
      viewItemsRef.value.forEach((i2) => {
        i2.disabled = false;
        i2.readonly = false;
        i2.hidden = true;
      });
    };
    watch(() => props.formSchema, initialize, { immediate: true, deep: true });
    watch(viewItemsRef, () => {
      model.value.componentOptions = viewItemsRef.value.filter((item) => item.disabled != false || item.readonly != false || item.hidden != false);
    }, { deep: true });
    watch(model, initializeComponentOptions, { deep: true });
    const { t: t2 } = useLocale();
    const editable = (row) => {
      row.readonly = false;
      row.disabled = false;
      row.hidden = false;
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = resolveComponent("el-table-column");
      const _component_el_radio = resolveComponent("el-radio");
      const _component_el_table = resolveComponent("el-table");
      return openBlock(), createBlock(_component_el_table, {
        data: viewItemsRef.value,
        style: { "width": "100%", "height": "100%", "overflow": "auto" }
      }, {
        default: withCtx(() => [
          createVNode(_component_el_table_column, {
            label: unref(t2)("FormField")
          }, {
            default: withCtx((scope) => [
              createElementVNode("span", null, toDisplayString(unref(t2)(scope.row.label)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_table_column, {
            label: unref(t2)("Editable")
          }, {
            header: withCtx(() => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": allEditable.value,
                label: unref(t2)("Edit"),
                onClick: checkedAllEditable
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Editable")), 1)
                ]),
                _: 1
              }, 8, ["model-value", "label"])
            ]),
            default: withCtx((scope) => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": !scope.row.disabled && !scope.row.readonly && !scope.row.hidden,
                onClick: () => editable(scope.row)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Editable")), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "onClick"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_table_column, {
            label: unref(t2)("Read-Only")
          }, {
            header: withCtx(() => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": allReadonly.value,
                onClick: checkedAllReadonly
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Read-Only")), 1)
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            default: withCtx(({ row }) => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": row.readonly || row.disabled,
                onClick: () => {
                  row.readonly = true;
                  row.disabled = true;
                  row.hidden = false;
                }
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Read-Only")), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "onClick"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_table_column, {
            label: unref(t2)("Hide")
          }, {
            header: withCtx(() => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": allHidden.value,
                onClick: checkedAllHide
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Hide")), 1)
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            default: withCtx(({ row }) => [
              createVNode(_component_el_radio, {
                value: true,
                "model-value": row.hidden,
                onClick: () => {
                  row.readonly = false;
                  row.hidden = true;
                  row.disabled = false;
                }
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Hide")), 1)
                ]),
                _: 2
              }, 1032, ["model-value", "onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]);
    };
  }
});
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "JsonObjectEditor",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const keyValues = ref([]);
    const initialize = () => {
      if (model.value) {
        keyValues.value = [];
        Object.keys(model.value).forEach((key) => {
          keyValues.value.push({ key, value: model.value[key] });
        });
      } else {
        keyValues.value = [];
      }
    };
    watch(model, initialize, { immediate: true });
    const removeKeyValue = (index2) => {
      var _a3;
      (_a3 = keyValues.value) == null ? void 0 : _a3.splice(index2, 1);
    };
    const addKeyValue = () => {
      var _a3;
      (_a3 = keyValues.value) == null ? void 0 : _a3.push({ key: "", value: "" });
    };
    watch(keyValues, () => {
      for (let i2 = 0; i2 < keyValues.value.length; i2++) {
        if (isNullOrUndefinedOrWhiteSpace(keyValues.value[i2].key)) {
          continue;
        }
        model.value[keyValues.value[i2].key] = keyValues.value[i2].value;
      }
    }, { deep: true });
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      const _component_el_input = resolveComponent("el-input");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_icon = resolveComponent("el-icon");
      const _component_el_row = resolveComponent("el-row");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_button = resolveComponent("el-button");
      return openBlock(), createBlock(_component_el_row, null, {
        default: withCtx(() => [
          createVNode(_component_el_col, { span: 24 }, {
            default: withCtx(() => [
              createVNode(_component_el_form, { ref: "formRef" }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(keyValues.value, (item, index2) => {
                    return openBlock(), createBlock(_component_el_form_item, { key: index2 }, {
                      default: withCtx(() => [
                        createVNode(_component_el_row, { gutter: 10 }, {
                          default: withCtx(() => [
                            createVNode(_component_el_col, { span: 10 }, {
                              default: withCtx(() => [
                                createVNode(_component_el_input, {
                                  modelValue: item.key,
                                  "onUpdate:modelValue": ($event) => item.key = $event,
                                  placeholder: unref(t2)("ParameterName")
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _: 2
                            }, 1024),
                            createVNode(_component_el_col, {
                              span: 2,
                              style: { "text-align": "center" }
                            }, {
                              default: withCtx(() => _cache[0] || (_cache[0] = [
                                createTextVNode(" = ")
                              ])),
                              _: 1,
                              __: [0]
                            }),
                            createVNode(_component_el_col, { span: 10 }, {
                              default: withCtx(() => [
                                createVNode(_component_el_input, {
                                  modelValue: item.value,
                                  "onUpdate:modelValue": ($event) => item.value = $event,
                                  placeholder: unref(t2)("ParameterValue")
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _: 2
                            }, 1024),
                            createVNode(_component_el_col, { span: 2 }, {
                              default: withCtx(() => [
                                createVNode(_component_el_icon, {
                                  onClick: ($event) => removeKeyValue(index2)
                                }, {
                                  default: withCtx(() => [
                                    createVNode(unref(remove_default))
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024);
                  }), 128))
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          createVNode(_component_el_col, {
            span: 4,
            offset: 20
          }, {
            default: withCtx(() => [
              createVNode(_component_el_button, {
                type: "primary",
                onClick: addKeyValue,
                link: ""
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Add")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
});
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "IntegrationEventConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    var _a3;
    const props = __props;
    const model = useModel(__props, "modelValue");
    if (!((_a3 = model.value) == null ? void 0 : _a3.extraProperties)) {
      model.value.extraProperties = {};
    }
    const initialize = () => {
      var _a4;
      if (!((_a4 = model.value) == null ? void 0 : _a4.extraProperties)) {
        model.value.extraProperties = {};
      }
      model.value.triggerDescriptor = {
        componentCode: "IntegrationEvent",
        settings: void 0
      };
    };
    watch(model, initialize, { immediate: true });
    const { t: t2 } = useLocale();
    const formRules = getIntegrationEventConfigFormRules(t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    const conditionOptions = computed(() => getFlowConditionOptions(props.formSchema));
    return (_ctx, _cache) => {
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        "label-width": "auto",
        model: model.value,
        ref_key: "formInstance",
        ref: formInstance,
        rules: unref(formRules)
      }, {
        default: withCtx(() => [
          createVNode(_component_el_form_item, {
            label: unref(t2)("TriggerCondition")
          }, {
            default: withCtx(() => [
              createVNode(component$3, {
                "condition-options": conditionOptions.value,
                modelValue: model.value.triggerCondition,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.triggerCondition = $event)
              }, null, 8, ["condition-options", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("EventName"),
            prop: "eventName"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_input, {
                modelValue: model.value.eventName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.eventName = $event)
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("ExtraProperties")
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$h, {
                modelValue: model.value.extraProperties,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.extraProperties = $event)
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
});
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "StoredProcedureEventConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    var _a3;
    const model = useModel(__props, "modelValue");
    if (!((_a3 = model.value) == null ? void 0 : _a3.extraProperties)) {
      model.value.extraProperties = {};
    }
    const initialize = () => {
      var _a4;
      if (!((_a4 = model.value) == null ? void 0 : _a4.extraProperties)) {
        model.value.extraProperties = {};
      }
      model.value.triggerDescriptor = {
        componentCode: "StoredProcedure",
        settings: void 0
      };
    };
    watch(model, initialize, { immediate: true });
    const { t: t2 } = useLocale();
    const flowDesignerModel = injectFlowDesignerModel();
    const conditionOptions = computed(() => getFlowConditionOptions(flowDesignerModel == null ? void 0 : flowDesignerModel.value.getFormSchema(flowDesignerModel == null ? void 0 : flowDesignerModel.value.activeNodeId)));
    const formRules = getStoredProcedureEventConfigFormRules(t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        model: model.value,
        ref_key: "formInstance",
        ref: formInstance,
        rules: unref(formRules)
      }, {
        default: withCtx(() => [
          createVNode(_component_el_form_item, {
            label: unref(t2)("TriggerCondition")
          }, {
            default: withCtx(() => [
              createVNode(component$3, {
                "condition-options": conditionOptions.value,
                modelValue: model.value.triggerCondition,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.triggerCondition = $event)
              }, null, 8, ["condition-options", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("StoredProcedureName"),
            prop: "extraProperties.storedProcedureName"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_input, {
                modelValue: model.value.extraProperties.storedProcedureName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.extraProperties.storedProcedureName = $event)
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
});
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "WebHookEventConfig",
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3;
      if (!((_a3 = model.value) == null ? void 0 : _a3.extraProperties)) {
        model.value.extraProperties = {
          url: "",
          header: {},
          httpMethod: "POST"
        };
      }
      if (!((_c3 = (_b3 = model.value) == null ? void 0 : _b3.extraProperties) == null ? void 0 : _c3.url)) {
        model.value.extraProperties.url = "";
      }
      if (!((_e3 = (_d3 = model.value) == null ? void 0 : _d3.extraProperties) == null ? void 0 : _e3.header)) {
        model.value.extraProperties.header = {};
      }
      if (!((_g3 = (_f3 = model.value) == null ? void 0 : _f3.extraProperties) == null ? void 0 : _g3.httpMethod)) {
        model.value.extraProperties.httpMethod = "POST";
      }
      if (!((_h3 = model.value) == null ? void 0 : _h3.extraProperties.mediaType)) {
        model.value.extraProperties.mediaType = "application/json";
      }
      model.value.triggerDescriptor = {
        componentCode: "WebHook",
        settings: void 0
      };
    };
    watch(model, initialize, { immediate: true });
    const encodingNames = [
      { label: "Unicode(UTF-8)", value: "utf-8" },
      { label: "Unicode(UTF-16LE)", value: "utf-16le" },
      { label: "中文(简体)(GBK)", value: "gbk" },
      { label: "中文(繁体)(Big5)", value: "big5" },
      { label: "中文(简体)(GB18030)", value: "gb18030" },
      { label: "阿拉伯语(ISO-8859-6)", value: "iso-8859-6" },
      { label: "阿拉伯语(Windows-1256)", value: "windows-1256" },
      { label: "北欧语言(ISO-8859-10)", value: "iso-8859-10" },
      { label: "波罗的海周边语言(ISO-8859-4)", value: "iso-8859-4" },
      { label: "波罗的海周边语言(ISO-8859-13)", value: "iso-8859-13" },
      { label: "波罗的海周边语言(Windows-1257)", value: "windows-1257" },
      { label: "韩语(EUC-KR)", value: "euc-kr" },
      { label: "凯尔特语(ISO-8859-14)", value: "iso-8859-14" },
      { label: "罗马尼亚语(ISO-8859-16)", value: "iso-8859-16" },
      { label: "南欧语言(ISO-8859-3)", value: "iso-8859-3" },
      { label: "日语(EUC-JP)", value: "euc-jp" },
      { label: "日语(ISO-2022-JP)", value: "iso-2022-jp" },
      { label: "日语(Shift_JIS)", value: "shift_jis" },
      { label: "泰语(Windows-874)", value: "windows-874" },
      { label: "土耳其语(Windows-1254)", value: "windows-1254" },
      { label: "西里尔语(1BM866)", value: "1bm866" },
      { label: "西里尔语(ISO-8859-5)", value: "iso-8859-5" },
      { label: "西里尔语(KOI8-R)", value: "koi8-r" },
      { label: "西里尔语(K0I8-U)", value: "k0i8-u" },
      { label: "西里尔语(Windows-1251)", value: "windows-1251" },
      { label: "西欧语言(IS0-8859-15)", value: "is0-8859-15" },
      { label: "西欧语言(Macintosh)", value: "macintosh" },
      { label: "西欧语言(Windows-1252)", value: "windows-1252" },
      { label: "希伯来语(ISO-8859-8)", value: "iso-8859-8" },
      { label: "希伯来语(ISO-8859-8-I)", value: "iso-8859-8-i" },
      { label: "希伯来语(Windows-1255)", value: "windows-1255" },
      { label: "希腊语(IS0-8859-7)", value: "is0-8859-7" },
      { label: "希腊语(Windows-1253)", value: "windows-1253" },
      { label: "越南语(Windows-1258)", value: "windows-1258" },
      { label: "中欧语言(IS0-8859-2)", value: "is0-8859-2" },
      { label: "中欧语言(Windows-1250)", value: "windows-1250" }
    ];
    const mediaTypes = [
      { label: "JSON", value: "application/json" },
      { label: "XML", value: "application/xml" },
      { label: "form-data", value: "multipart/form-data" },
      { label: "x-www-form-urlencoded", value: "application/x-www-form-urlencoded" },
      { label: "javascript", value: "application/javascript" },
      { label: "txt", value: "text/plain" },
      { label: "html", value: "text/html" }
    ];
    const { t: t2 } = useLocale();
    const formRules = getWebHookEventConfigFormRules(t2);
    const formInstance = ref();
    const formValidator = useFormValidator(formInstance);
    __expose({ formValidator });
    return (_ctx, _cache) => {
      const _component_el_option = resolveComponent("el-option");
      const _component_el_select = resolveComponent("el-select");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        model: model.value,
        "label-width": "auto",
        ref_key: "formInstance",
        ref: formInstance,
        rules: unref(formRules)
      }, {
        default: withCtx(() => [
          createVNode(_component_el_form_item, {
            label: "URL",
            prop: "extraProperties.url"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_input, {
                modelValue: model.value.extraProperties.url,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.extraProperties.url = $event)
              }, {
                prepend: withCtx(() => [
                  createVNode(_component_el_select, {
                    style: { "width": "100px" },
                    modelValue: model.value.extraProperties.httpMethod,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.extraProperties.httpMethod = $event)
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_option, {
                        label: "Post",
                        value: "POST"
                      }),
                      createVNode(_component_el_option, {
                        label: "Get",
                        value: "GET"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          createVNode(_component_el_form_item, {
            label: unref(t2)("CustomHeader")
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$h, {
                modelValue: model.value.extraProperties.header,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.extraProperties.header = $event)
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("CodingFormat"),
            prop: "extraProperties.encodingName"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_select, {
                style: { "width": "100%" },
                modelValue: model.value.extraProperties.encodingName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => model.value.extraProperties.encodingName = $event)
              }, {
                default: withCtx(() => [
                  (openBlock(), createElementBlock(Fragment, null, renderList(encodingNames, (item, index2) => {
                    return createVNode(_component_el_option, {
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("MediaType")
          }, {
            default: withCtx(() => [
              createVNode(_component_el_select, {
                style: { "width": "100%" },
                modelValue: model.value.extraProperties.mediaType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => model.value.extraProperties.mediaType = $event)
              }, {
                default: withCtx(() => [
                  (openBlock(), createElementBlock(Fragment, null, renderList(mediaTypes, (item, index2) => {
                    return createVNode(_component_el_option, {
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]);
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_form_item, {
            label: unref(t2)("RequestSubject")
          }, {
            default: withCtx(() => [
              createVNode(_component_el_input, {
                modelValue: model.value.extraProperties.contentPath,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => model.value.extraProperties.contentPath = $event),
                placeholder: unref(t2)("RequestSubject") + "(JSONPath)"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
});
const _hoisted_1$6 = { class: "anglemark" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "EventDefinitionsConfigs",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      var _a3;
      if ((_a3 = model.value) == null ? void 0 : _a3.some((item) => item.eventTriggerDefinitions.length > 1)) {
        const oldGroups = [...model.value];
        const groups = [];
        for (let i2 = 0; i2 < oldGroups.length; i2++) {
          const triggerTiming = oldGroups[i2].triggerTiming;
          if (!isNullOrUndefinedOrEmptyArray(oldGroups[i2].eventTriggerDefinitions)) {
            for (let j2 = 0; i2 < oldGroups[i2].eventTriggerDefinitions.length; j2++) {
              groups.push({ triggerTiming, eventTriggerDefinitions: [oldGroups[i2].eventTriggerDefinitions[j2]] });
            }
          }
        }
        model.value = groups;
      }
    };
    watch(model, initialize, { immediate: true });
    const getEventConfig = (triggerDescriptor) => {
      switch (triggerDescriptor.componentCode) {
        case "StoredProcedure":
          return _sfc_main$f;
        case "WebHook":
          return _sfc_main$e;
        default:
          return _sfc_main$g;
      }
    };
    const addEventDefinition = () => {
      var _a3;
      (_a3 = model.value) == null ? void 0 : _a3.push({
        triggerTiming: TriggerTimingConstants.Finished,
        eventTriggerDefinitions: [
          {
            triggerCondition: "",
            eventName: "",
            extraProperties: {},
            triggerType: 0,
            triggerDescriptor: { componentCode: "IntegrationEvent", settings: void 0 }
          }
        ]
      });
    };
    const removeEventDefinition = (index2) => {
      var _a3;
      (_a3 = model.value) == null ? void 0 : _a3.splice(index2, 1);
      removeFormInstance(index2);
      removeComponentInstance(index2);
    };
    const { t: t2 } = useLocale();
    const { addFormInstance, removeFormInstance, validator } = useNamedFormInstanceArrayWrapper("eventDefinitions");
    const {
      addComponentInstance,
      removeComponentInstance,
      validator: settingsValidator
    } = useNamedFormValidatorArrayWrapper("eventDefinitions.settings");
    const formValidator = useMultipleFormValidator(validator, settingsValidator);
    __expose({ formValidator });
    const formRules = getEventDefinitionFormRules(t2);
    return (_ctx, _cache) => {
      const _component_el_radio = resolveComponent("el-radio");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_card = resolveComponent("el-card");
      return openBlock(), createElementBlock(Fragment, null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(model.value, (item, index2) => {
          return openBlock(), createBlock(_component_el_card, { shadow: "never" }, {
            default: withCtx(() => [
              createElementVNode("span", _hoisted_1$6, toDisplayString(index2 + 1), 1),
              createVNode(_component_el_form, {
                "label-width": "auto",
                model: item,
                ref_for: true,
                ref: (comp) => unref(addFormInstance)(comp, index2),
                rules: unref(formRules)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("EventType"),
                    prop: "eventTriggerDefinitions[0].triggerDescriptor.componentCode"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: item.eventTriggerDefinitions[0].triggerDescriptor.componentCode,
                        "onUpdate:modelValue": ($event) => item.eventTriggerDefinitions[0].triggerDescriptor.componentCode = $event
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio, {
                            label: unref(t2)("EventBus"),
                            value: "IntegrationEvent"
                          }, null, 8, ["label"]),
                          createVNode(_component_el_radio, {
                            label: unref(t2)("StoredProcedure"),
                            value: "StoredProcedure"
                          }, null, 8, ["label"]),
                          createVNode(_component_el_radio, {
                            label: unref(t2)("WebHook"),
                            value: "WebHook"
                          }, null, 8, ["label"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("TriggerTiming"),
                    prop: "triggerTiming"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$q, {
                        modelValue: item.triggerTiming,
                        "onUpdate:modelValue": ($event) => item.triggerTiming = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"]),
                  (openBlock(), createBlock(resolveDynamicComponent(getEventConfig(item.eventTriggerDefinitions[0].triggerDescriptor)), {
                    ref_for: true,
                    ref: (comp) => unref(addComponentInstance)(comp, index2),
                    "form-schema": _ctx.formSchema,
                    modelValue: item.eventTriggerDefinitions[0],
                    "onUpdate:modelValue": ($event) => item.eventTriggerDefinitions[0] = $event
                  }, null, 8, ["form-schema", "modelValue", "onUpdate:modelValue"]))
                ]),
                _: 2
              }, 1032, ["model", "rules"]),
              createVNode(_component_el_col, {
                span: 24,
                style: { "text-align": "right" }
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_button, {
                    type: "primary",
                    text: "",
                    onClick: () => removeEventDefinition(index2)
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("DeleteEvent")), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024);
        }), 256)),
        createVNode(_component_el_col, {
          span: 24,
          style: { "text-align": "right" }
        }, {
          default: withCtx(() => [
            createVNode(_component_el_button, {
              type: "primary",
              text: "",
              onClick: addEventDefinition
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("AddEvent")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "NodeConfig",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const initialize = () => {
      var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j2;
      if (((_a3 = model.value) == null ? void 0 : _a3.code) === void 0) {
        model.value.code = "";
      }
      if (((_b3 = model.value) == null ? void 0 : _b3.name) === void 0) {
        model.value.name = "";
      }
      if (((_c3 = model.value) == null ? void 0 : _c3.descriptions) === void 0) {
        model.value.descriptions = "";
      }
      if (((_d3 = model.value) == null ? void 0 : _d3.subjectFormatSetting) === void 0) {
        model.value.subjectFormatSetting = {
          enabled: true,
          subjectSpecification: {
            allowedRepeatPriority: true,
            items: []
          }
        };
      }
      if (((_e3 = model.value) == null ? void 0 : _e3.ownerFinderDescriptor) === void 0) {
        model.value.ownerFinderDescriptor = {
          all: true,
          allowedToBeMutilpeHandlers: false,
          handlerFinderDescriptors: []
        };
      }
      if (((_f3 = model.value) == null ? void 0 : _f3.carbonCopySettings) === void 0) {
        model.value.carbonCopySettings = {
          enabled: true,
          ccSpecification: { allowedRepeatPriority: true, items: [] }
        };
      }
      if (((_g3 = model.value) == null ? void 0 : _g3.notificationSettings) == void 0) {
        model.value.notificationSettings = {
          enabled: true,
          notificationSettingSpecification: {
            allowedRepeatPriority: true,
            items: []
          }
        };
      }
      if (((_h3 = model.value) == null ? void 0 : _h3.viewOptions) == void 0) {
        model.value.viewOptions = { componentOptions: [] };
      }
      if (((_i3 = model.value) == null ? void 0 : _i3.extraData) == void 0) {
        model.value.extraData = {};
      }
      if (((_j2 = model.value) == null ? void 0 : _j2.eventDefinitions) == void 0) {
        model.value.eventDefinitions = [];
      }
    };
    watch(model, initialize, { immediate: true });
    const { t: t2 } = useLocale();
    onErrorCaptured((event) => {
      console.log(event);
      debugger;
    });
    const subjectFormatSettingConfigRef = ref();
    const formInstance = ref();
    const approverSettingsConfigRef = ref();
    const carbonCopySettingsConfigRef = ref();
    const notificationSettingsConfigRef = ref();
    const eventDefinitionsConfigsRef = ref();
    const childFormValidators = computed(() => {
      var _a3, _b3, _c3, _d3, _e3;
      return [
        (_a3 = subjectFormatSettingConfigRef.value) == null ? void 0 : _a3.formValidator.withScrollToError(async () => {
          activeTabName.value = "tabGeneral";
          subjectFormatCollapse.value.pushIfNotExists("collapseItemSubjectFormatting");
        }),
        (_b3 = approverSettingsConfigRef.value) == null ? void 0 : _b3.formValidator.withNameSuffix("_approve").withScrollToError(async () => {
          activeTabName.value = "tabApproverSettings";
        }),
        (_c3 = carbonCopySettingsConfigRef.value) == null ? void 0 : _c3.formValidator.withScrollToError(async () => {
          if (model.value.nodeType != "initialNode") {
            activeTabName.value = "tabApproverSettings";
            ccSettingsCollapse.value.pushIfNotExists("ccSettingsCollapseItem");
          } else {
            activeTabName.value = "tabCCSettings";
          }
        }),
        (_d3 = notificationSettingsConfigRef.value) == null ? void 0 : _d3.formValidator.withScrollToError(async () => {
          activeTabName.value = "tabNotificationSettings";
        }),
        (_e3 = eventDefinitionsConfigsRef.value) == null ? void 0 : _e3.formValidator.withScrollToError(async () => {
          activeTabName.value = "tabAdvancedSettings";
          advancedSettingCollapse.value.pushIfNotExists("eventSettingsCollapseItem");
        })
      ];
    });
    const flowDesignerModel = injectFlowDesignerModel();
    const activeTabName = ref("tabGeneral");
    const subjectFormatCollapse = ref([]);
    const ccSettingsCollapse = ref([]);
    const advancedSettingCollapse = ref([]);
    const resetUI = () => {
      activeTabName.value = "tabGeneral";
      subjectFormatCollapse.value = [];
      ccSettingsCollapse.value = [];
      advancedSettingCollapse.value = [];
    };
    const formValidator = useMultipleFormValidator(
      useFormValidator(formInstance).withScrollToError(async () => {
        activeTabName.value = "tabGeneral";
      }),
      childFormValidators
    );
    __expose({ formValidator, resetUI });
    const generalFormRules = computed(() => flowDesignerModel.value == void 0 ? void 0 : getNodeGeneralFormRules(flowDesignerModel.value, t2));
    return (_ctx, _cache) => {
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_collapse_item = resolveComponent("el-collapse-item");
      const _component_el_collapse = resolveComponent("el-collapse");
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_tabs = resolveComponent("el-tabs");
      return openBlock(), createBlock(_component_el_tabs, {
        modelValue: activeTabName.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => activeTabName.value = $event)
      }, {
        default: withCtx(() => [
          createVNode(_component_el_tab_pane, {
            label: unref(t2)("General"),
            class: "tabPaneClass",
            name: "tabGeneral"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_form, {
                ref_key: "formInstance",
                ref: formInstance,
                model: model.value,
                "label-width": "auto",
                rules: generalFormRules.value
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("Code"),
                    prop: "code"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: model.value.code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => model.value.code = $event),
                        maxlength: "50",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    prop: "name",
                    label: unref(t2)("Name")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: model.value.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => model.value.name = $event),
                        maxlength: "50",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: unref(t2)("Descriptions"),
                    prop: "descriptions"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        type: "textarea",
                        autosize: { minRows: 3, maxRows: 10 },
                        modelValue: model.value.descriptions,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.descriptions = $event),
                        maxlength: "250",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              createVNode(_component_el_collapse, {
                modelValue: subjectFormatCollapse.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => subjectFormatCollapse.value = $event)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_collapse_item, {
                    title: unref(t2)("SubjectFormatting"),
                    name: "collapseItemSubjectFormatting"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$m, {
                        "form-schema": _ctx.formSchema,
                        ref_key: "subjectFormatSettingConfigRef",
                        ref: subjectFormatSettingConfigRef,
                        modelValue: model.value.subjectFormatSetting,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => model.value.subjectFormatSetting = $event)
                      }, null, 8, ["form-schema", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          model.value.nodeType != "initialNode" ? (openBlock(), createBlock(_component_el_tab_pane, {
            key: 0,
            label: unref(t2)("ApproverSettings"),
            name: "tabApproverSettings"
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$l, {
                ref_key: "approverSettingsConfigRef",
                ref: approverSettingsConfigRef,
                modelValue: model.value.ownerFinderDescriptor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => model.value.ownerFinderDescriptor = $event),
                "allowed-to-be-empty": false
              }, null, 8, ["modelValue"]),
              createVNode(_component_el_collapse, {
                modelValue: ccSettingsCollapse.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ccSettingsCollapse.value = $event)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_collapse_item, {
                    title: unref(t2)("CCSettings"),
                    name: "ccSettingsCollapseItem"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$k, {
                        ref_key: "carbonCopySettingsConfigRef",
                        ref: carbonCopySettingsConfigRef,
                        "form-schema": _ctx.formSchema,
                        modelValue: model.value.carbonCopySettings,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => model.value.carbonCopySettings = $event)
                      }, null, 8, ["form-schema", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])) : (openBlock(), createBlock(_component_el_tab_pane, {
            key: 1,
            label: unref(t2)("CCSettings"),
            name: "tabCCSettings"
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$k, {
                ref_key: "carbonCopySettingsConfigRef",
                ref: carbonCopySettingsConfigRef,
                "form-schema": _ctx.formSchema,
                modelValue: model.value.carbonCopySettings,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => model.value.carbonCopySettings = $event)
              }, null, 8, ["form-schema", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"])),
          createVNode(_component_el_tab_pane, {
            label: unref(t2)("NotificationSettings"),
            name: "tabNotificationSettings"
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$j, {
                ref_key: "notificationSettingsConfigRef",
                ref: notificationSettingsConfigRef,
                "form-schema": _ctx.formSchema,
                modelValue: model.value.notificationSettings,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => model.value.notificationSettings = $event)
              }, null, 8, ["form-schema", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_tab_pane, {
            label: unref(t2)("FormPermissionSetting"),
            name: "tabFormPermissionSettings"
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$i, {
                "form-schema": _ctx.formSchema,
                modelValue: model.value.viewOptions,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => model.value.viewOptions = $event)
              }, null, 8, ["form-schema", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_tab_pane, {
            label: unref(t2)("AdvancedSetting"),
            name: "tabAdvancedSettings"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_collapse, {
                modelValue: advancedSettingCollapse.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => advancedSettingCollapse.value = $event)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_collapse_item, {
                    title: unref(t2)("EventSettings"),
                    name: "eventSettingsCollapseItem"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$d, {
                        "form-schema": _ctx.formSchema,
                        ref_key: "eventDefinitionsConfigsRef",
                        ref: eventDefinitionsConfigsRef,
                        modelValue: model.value.eventDefinitions,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => model.value.eventDefinitions = $event)
                      }, null, 8, ["form-schema", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  createVNode(_component_el_collapse_item, {
                    title: unref(t2)("AdditionalData"),
                    name: "collapseAdditionalData"
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$h, {
                        modelValue: model.value.extraData,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => model.value.extraData = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "routeConfigs",
  props: /* @__PURE__ */ mergeModels({
    formSchema: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const model = useModel(__props, "modelValue");
    const formRules = ref();
    const { t: t2 } = useLocale();
    const initialize = () => {
      var _a3, _b3, _c3, _d3;
      if (!model.value.routePolicyDescriptor) {
        model.value.routePolicyDescriptor = createDefaultRoutePolicyDescriptor(RoutePolicyDescriptorCodes.Standard);
      }
      if (((_b3 = (_a3 = model.value) == null ? void 0 : _a3.routePolicyDescriptor) == null ? void 0 : _b3.componentCode) === RoutePolicyDescriptorCodes.AlwaysTrue) {
        model.value.routePolicyDescriptor = createDefaultRoutePolicyDescriptor(RoutePolicyDescriptorCodes.Standard);
      }
      if (!model.value.eventDefinitions) {
        model.value.eventDefinitions = [];
      }
      if (!((_c3 = model.value) == null ? void 0 : _c3.extraData)) {
        model.value.extraData = {};
      }
      if (((_d3 = model.value) == null ? void 0 : _d3.routePolicyDescriptor.componentCode) === RoutePolicyDescriptorCodes.ProportionalVoting) {
        percentage.value = model.value.routePolicyDescriptor.settings.percentage * 100;
      }
      formRules.value = getRoutePolicyFormRule(model.value.routePolicyDescriptor.componentCode, t2);
    };
    const percentage = ref(0);
    watch(model, initialize, { immediate: true });
    watch(percentage, () => {
      var _a3;
      if (((_a3 = model.value) == null ? void 0 : _a3.routePolicyDescriptor.componentCode) === RoutePolicyDescriptorCodes.ProportionalVoting) {
        model.value.routePolicyDescriptor.settings.percentage = percentage.value / 100;
      }
    });
    const props = __props;
    const componentCodeChange = (componentCode) => {
      var _a3, _b3;
      if (componentCode != ((_b3 = (_a3 = model.value) == null ? void 0 : _a3.routePolicyDescriptor) == null ? void 0 : _b3.componentCode)) {
        model.value.routePolicyDescriptor = createDefaultRoutePolicyDescriptor(componentCode);
        if (componentCode === RoutePolicyDescriptorCodes.ProportionalVoting) {
          percentage.value = model.value.routePolicyDescriptor.settings.percentage * 100;
        }
        formRules.value = getRoutePolicyFormRule(componentCode, t2);
      }
    };
    const formInstance = ref();
    const eventDefinitionsConfigsRef = ref();
    const eventDefinitionValidator = computed(() => {
      var _a3;
      return (_a3 = eventDefinitionsConfigsRef.value) == null ? void 0 : _a3.formValidator.withScrollToError(async () => {
        activeTabName.value = "tabEventSettings";
      });
    });
    const activeTabName = ref("tabCondition");
    const formValidator = useMultipleFormValidator(
      useNamedFormValidator("routeCondition", formInstance).withScrollToError(async () => {
        activeTabName.value = "tabCondition";
      }),
      eventDefinitionValidator
    );
    const resetUI = () => {
      activeTabName.value = "tabCondition";
    };
    __expose({ formValidator, resetUI });
    const conditionOptions = computed(() => getFlowConditionOptions(props.formSchema));
    return (_ctx, _cache) => {
      const _component_el_radio = resolveComponent("el-radio");
      const _component_el_radio_group = resolveComponent("el-radio-group");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_input_number = resolveComponent("el-input-number");
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_tabs = resolveComponent("el-tabs");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        model: model.value.routePolicyDescriptor,
        "label-width": "auto",
        ref_key: "formInstance",
        ref: formInstance,
        "validate-on-rule-change": false,
        "status-icon": false,
        rules: formRules.value
      }, {
        default: withCtx(() => [
          createVNode(_component_el_form_item, { prop: "componentCode" }, {
            default: withCtx(() => [
              createVNode(_component_el_radio_group, {
                "model-value": model.value.routePolicyDescriptor.componentCode,
                onChange: componentCodeChange
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_radio, {
                    value: unref(RoutePolicyDescriptorCodes).Standard
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("Parallel")), 1)
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  createVNode(_component_el_radio, {
                    value: unref(RoutePolicyDescriptorCodes).Countersign
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("Countersign")), 1)
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  createVNode(_component_el_radio, {
                    value: unref(RoutePolicyDescriptorCodes).OrSign
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("OrSign")), 1)
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  createVNode(_component_el_radio, {
                    value: unref(RoutePolicyDescriptorCodes).FixedQuorumDecision
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("FixedQuorumDecision")), 1)
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  createVNode(_component_el_radio, {
                    value: unref(RoutePolicyDescriptorCodes).ProportionalVoting
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("ProportionalVoting")), 1)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }, 8, ["model-value"])
            ]),
            _: 1
          }),
          createVNode(_component_el_tabs, {
            modelValue: activeTabName.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => activeTabName.value = $event)
          }, {
            default: withCtx(() => [
              createVNode(_component_el_tab_pane, {
                label: unref(t2)("ConditionSetting"),
                name: "tabCondition"
              }, {
                default: withCtx(() => [
                  model.value.routePolicyDescriptor.componentCode == "ProportionalVoting" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 0,
                    label: unref(t2)("Percentage"),
                    prop: "settings.percentage"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        min: "1",
                        max: "100",
                        type: "number",
                        modelValue: percentage.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => percentage.value = $event),
                        clearable: "",
                        onChange: _cache[1] || (_cache[1] = (value) => {
                          if (value > 100) {
                            percentage.value = 100;
                          }
                          if (value < 0) {
                            percentage.value = 0;
                          }
                        })
                      }, {
                        append: withCtx(() => _cache[7] || (_cache[7] = [
                          createTextVNode(" % ")
                        ])),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  model.value.routePolicyDescriptor.componentCode == "FixedQuorumDecision" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 1,
                    label: unref(t2)("QuorumThreshold"),
                    prop: "settings.quorumThreshold"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        min: "1",
                        modelValue: model.value.routePolicyDescriptor.settings.quorumThreshold,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => model.value.routePolicyDescriptor.settings.quorumThreshold = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  createVNode(_component_el_form_item, {
                    prop: "settings.routeCondition",
                    label: unref(t2)("Condition")
                  }, {
                    default: withCtx(() => [
                      createVNode(component$3, {
                        "condition-options": conditionOptions.value,
                        modelValue: model.value.routePolicyDescriptor.settings.routeCondition,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => model.value.routePolicyDescriptor.settings.routeCondition = $event)
                      }, null, 8, ["condition-options", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_component_el_tab_pane, {
                label: unref(t2)("EventSettings"),
                name: "tabEventSettings"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$d, {
                    ref_key: "eventDefinitionsConfigsRef",
                    ref: eventDefinitionsConfigsRef,
                    "form-schema": _ctx.formSchema,
                    modelValue: model.value.eventDefinitions,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => model.value.eventDefinitions = $event)
                  }, null, 8, ["form-schema", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_component_el_tab_pane, {
                label: unref(t2)("AdvancedSetting"),
                name: "tabAdvancedSetting"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$h, {
                    modelValue: model.value.extraData,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => model.value.extraData = $event)
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
});
const alwaysTrue = {
  componentCode: "AwaysTrue",
  settings: void 0
};
const createAlwaysTrue = () => alwaysTrue;
class ProcessDefinitionViewModel {
  constructor() {
    __publicField(this, "id");
    __publicField(this, "code", "");
    __publicField(this, "name", "");
    __publicField(this, "descriptions", "");
    __publicField(this, "enabled", true);
    __publicField(this, "settings", {});
    __publicField(this, "groupId", "");
    __publicField(this, "published", false);
    __publicField(this, "viewDescriptor", { viewSettings: {}, dataDefinition: {} });
    __publicField(this, "eventDefinitions", []);
    __publicField(this, "processNodeDefinitions", []);
    __publicField(this, "processRouteDefinitions", []);
    __publicField(this, "extraProperties", {});
  }
  // withCode(code:string):ProcessDefinitionViewModel {
  //   this.code = code;
  //   return this;
  // }
  // withName(name:string):ProcessDefinitionViewModel {
  //   this.name = name;
  //   return this;
  // }
  // withDescription(description:string):ProcessDefinitionViewModel {
  //   this.descriptions = description;
  //   return this;
  // }
  // withEnabled(enabled:boolean):ProcessDefinitionViewModel {
  //   this.enabled = enabled;
  //   return this;
  // }
  // withViewDescriptor(viewDescriptor:ViewDescriptor):ProcessDefinitionViewModel {
  //   this.viewDescriptor = viewDescriptor;
  //   return this;
  // }
  static deepClone(data) {
    if (!data) {
      return data;
    }
    return JSON.parse(JSON.stringify(data));
  }
  static create(processDefinitionOutput) {
    if (processDefinitionOutput) {
      return ProcessDefinitionViewModel.fromProcessDefinitionOutput(processDefinitionOutput);
    } else {
      return new ProcessDefinitionViewModel();
    }
  }
  static fromProcessDefinitionOutput(processDefinitionOutput) {
    const viewModel = new ProcessDefinitionViewModel();
    viewModel.id = processDefinitionOutput.id;
    viewModel.code = processDefinitionOutput.code;
    viewModel.name = processDefinitionOutput.name;
    viewModel.descriptions = processDefinitionOutput.descriptions;
    viewModel.enabled = processDefinitionOutput.enabled;
    viewModel.settings = processDefinitionOutput.settings;
    viewModel.groupId = processDefinitionOutput.groupId;
    viewModel.published = processDefinitionOutput.published;
    viewModel.viewDescriptor = ProcessDefinitionViewModel.deepClone(processDefinitionOutput.viewDescriptor);
    viewModel.eventDefinitions = ProcessDefinitionViewModel.deepClone(processDefinitionOutput.eventDefinitions);
    viewModel.processNodeDefinitions = ProcessDefinitionViewModel.deepClone(processDefinitionOutput.processNodeDefinitions);
    viewModel.processRouteDefinitions = ProcessDefinitionViewModel.deepClone(processDefinitionOutput.processRouteDefinitions);
    viewModel.extraProperties = ProcessDefinitionViewModel.deepClone(processDefinitionOutput.extraProperties);
    return viewModel;
  }
  get isNew() {
    return isNullOrUndefinedOrWhiteSpace(this.id) || this.id == "-1";
  }
  mapToCreateProcessDefinitionInput() {
    return this;
  }
  mapToUpdateProcessDefinitionInput() {
    return {
      ...this,
      id: this.id
    };
  }
  getNextRouteDefinitions(prevNodeCode) {
    var _a3;
    return (_a3 = this.processRouteDefinitions) == null ? void 0 : _a3.filter((r3) => r3.processNodeDefinitionCode === prevNodeCode);
  }
  getStartNodeDefinitionOrUndefined() {
    return this.processNodeDefinitions.singleOrUndefined((n2) => n2.nodeType == "initialNode");
  }
  getNodeDefinitionByCode(code) {
    var _a3;
    return (_a3 = this.processNodeDefinitions) == null ? void 0 : _a3.find((n2) => n2.code === code);
  }
}
function convertToValidateFieldsError(errors) {
  if (!errors || errors.length == 0) {
    return;
  }
  const fieldWithError = {};
  for (let i2 = 0; i2 < errors.length; i2++) {
    if (!errors[i2].field) {
      continue;
    }
    if (!fieldWithError.hasOwnProperty(errors[i2].field)) {
      fieldWithError[errors[i2].field] = [errors[i2]];
    } else {
      fieldWithError[errors[i2].field].push(errors[i2]);
    }
  }
  return fieldWithError;
}
const connectedEdgeErrors = {
  nodeEdgeError: "Node_edge_error",
  //节点必须要有边
  conditionEdgesError: "Condition_edges_error",
  //条件一进一出
  userNodeEdgeError: "UserNode_edge_error",
  initialNodeEdgeError: "InitialNode_edge_error"
};
const validateNodeConnectedEdges = (graph, node, t2) => {
  const edges = graph.getConnectedEdges(node);
  const errorMessages = [];
  if (edges.length == 0) {
    errorMessages.push(t2(connectedEdgeErrors.nodeEdgeError));
  } else {
    if (isConditionNode$1(node)) {
      if (edges.length !== 2) {
        errorMessages.push(t2(connectedEdgeErrors.conditionEdgesError));
      }
    } else if (!isStartNode(node)) {
      if (!edges.some((e10) => e10.getTargetCellId() === node.id)) {
        errorMessages.push(t2(connectedEdgeErrors.userNodeEdgeError));
      }
    } else {
      if (!edges.some((e10) => e10.getSourceCellId() == node.id)) {
        errorMessages.push(t2(connectedEdgeErrors.initialNodeEdgeError));
      }
    }
  }
  return errorMessages;
};
const validateNode = async (graph, node, flowDesignerModel, t2) => {
  let name = "";
  let fieldErrors = [];
  const errorMessages = [];
  const edgeMessages = validateNodeConnectedEdges(graph, node, t2);
  if (isConditionNode$1(node)) {
    const routeDefinition = flowDesignerModel.getValidRouteDefinitionByGraphNode(node);
    if (!routeDefinition) {
      errorMessages.push(t2("Route_NotDefinition_Error"));
    } else {
      const rules2 = getRouteDefinitionValidatorRule(t2);
      const validator = new Schema(rules2);
      await validator.validate(routeDefinition, (errors, fields) => {
        fieldErrors = errors;
      }).catch((reason) => {
        console.log(fieldErrors);
        console.log(routeDefinition);
      });
      name = routeDefinition.code;
    }
  } else {
    const nodeDefinition = flowDesignerModel.getValidNodeDefinition(node.id);
    if (!nodeDefinition) {
      errorMessages.push(t2("Node_NotDefinition_Error"));
    } else {
      const rules2 = getNodeDefinitionValidatorRule(flowDesignerModel, t2);
      const validator = new Schema(rules2);
      await validator.validate(nodeDefinition, (errors, fields) => {
        fieldErrors = errors;
      }).catch((reason) => {
        console.log(fieldErrors);
        console.log(nodeDefinition);
      });
      name = nodeDefinition.name;
    }
  }
  if (errorMessages.length > 0 || edgeMessages.length > 0 || Array.isArray(fieldErrors) && fieldErrors.length > 0) {
    return {
      id: node.id,
      name,
      edgeMessages,
      messages: errorMessages,
      validateFieldsError: convertToValidateFieldsError(fieldErrors)
    };
  }
};
const validateAllNodes = async (flowDesignerModel, t2) => {
  const results = [];
  const graph = flowDesignerModel.flowDesignerViewModel.graph;
  if (graph) {
    const graphNodes = graph.getNodes();
    for (let i2 = 0; i2 < graphNodes.length; i2++) {
      const validationResult = await validateNode(graph, graphNodes[i2], flowDesignerModel, t2).catch((reason) => console.error(reason));
      if (validationResult) {
        results.push(validationResult);
      }
    }
  } else {
    const nodeMetadataArray = flowDesignerModel.flowDesignerViewModel.nodeMetadataArray;
    if (nodeMetadataArray) {
      for (let i2 = 0; i2 < nodeMetadataArray.length; i2++) {
      }
    }
  }
  return results;
};
const isInvalidNode = (nodeValidationResult) => {
  if (nodeValidationResult.messages && nodeValidationResult.messages.length > 0) {
    return true;
  }
  if (nodeValidationResult.edgeMessages && nodeValidationResult.edgeMessages.length > 0) {
    return true;
  }
  if (nodeValidationResult.validateFieldsError) {
    const keys = Object.keys(nodeValidationResult.validateFieldsError);
    for (const key of keys) {
      if (nodeValidationResult.validateFieldsError[key] && nodeValidationResult.validateFieldsError[key].length > 0) {
        return true;
      }
    }
  }
  return false;
};
const appendFieldsError = (validateFieldError, fieldName, newFieldError) => {
  if (!newFieldError) {
    return;
  }
  Object.keys(newFieldError).forEach((key) => {
    validateFieldError[`${fieldName ? fieldName + "." : ""}${key}`] = newFieldError[key];
  });
};
class FlowGraphValidator {
  constructor(flowDesignerModel, t2, name) {
    __publicField(this, "name");
    __publicField(this, "_flowDesignerModel");
    __publicField(this, "t");
    __publicField(this, "_scrollToErrorFn");
    this.name = name || "FlowGraphValidator";
    this._flowDesignerModel = flowDesignerModel;
    this.t = t2;
  }
  clearValidate() {
    this._flowDesignerModel.setFlowValidationResults([]);
  }
  scrollToError(validationResult) {
    var _a3;
    return ((_a3 = this._scrollToErrorFn) == null ? void 0 : _a3.call(this, this, validationResult)) || Promise.resolve();
  }
  async validate() {
    const validationResults = await validateAllNodes(this._flowDesignerModel, this.t);
    const validationResult = {
      name: this.name,
      isValid: true,
      validator: this,
      invalidFields: {}
    };
    if (validationResults) {
      for (let i2 = 0; i2 < validationResults.length; i2++) {
        if (isInvalidNode(validationResults[i2])) {
          validationResult.isValid = false;
          const messages2 = [];
          if (validationResults[i2].messages && validationResults[i2].messages.length > 0) {
            messages2.push(...validationResults[i2].messages.map((m2) => {
              return { message: m2 };
            }));
          }
          if (validationResults[i2].edgeMessages && validationResults[i2].edgeMessages.length > 0) {
            messages2.push(...validationResults[i2].edgeMessages.map((m2) => {
              return { message: m2 };
            }));
          }
          if (messages2 && messages2.length > 0) {
            validationResult.invalidFields[validationResults[i2].id] = messages2;
          }
          appendFieldsError(validationResult.invalidFields, validationResults[i2].id, validationResults[i2].validateFieldsError);
          this._flowDesignerModel.setNodeValidationResult(validationResults[i2]);
        }
      }
    }
    validationResult.validationResults = { validationResults };
    return Promise.resolve(validationResult);
  }
  withNameSuffix(suffix) {
    return new FlowGraphValidator(this._flowDesignerModel, this.t, `${this.name}${suffix}`);
  }
  withScrollToError(scrollToError) {
    this._scrollToErrorFn = scrollToError;
    return this;
  }
}
const getValidEventDefinitions = (eventDefinitions) => {
  if (!eventDefinitions) {
    return eventDefinitions;
  }
  eventDefinitions = eventDefinitions.filter((e10) => e10.eventTriggerDefinitions && e10.eventTriggerDefinitions.length > 0);
  return eventDefinitions.length > 0 ? eventDefinitions : void 0;
};
const getValidCarbonCopySettings = (carbonCopySettings) => {
  if (!carbonCopySettings) {
    return void 0;
  }
  return carbonCopySettings.ccSpecification.items.length > 0 ? carbonCopySettings : void 0;
};
const getValidNotificationSettings = (notificationSettings) => {
  if (!notificationSettings) {
    return void 0;
  }
  return notificationSettings.notificationSettingSpecification.items.length > 0 ? notificationSettings : void 0;
};
const getValidSubjectFormatSetting = (subjectFormatSetting) => {
  if (!subjectFormatSetting) {
    return void 0;
  }
  return subjectFormatSetting.subjectSpecification.items.length > 0 ? subjectFormatSetting : void 0;
};
const getValidNodeDefinition = (nodeDefinition) => {
  if (!nodeDefinition) {
    return void 0;
  }
  return {
    subjectFormatSetting: getValidSubjectFormatSetting(nodeDefinition.subjectFormatSetting),
    nodeType: nodeDefinition.nodeType,
    code: nodeDefinition.code,
    name: nodeDefinition.name,
    extraData: nodeDefinition.extraData,
    settings: nodeDefinition.settings,
    eventDefinitions: getValidEventDefinitions(nodeDefinition.eventDefinitions),
    viewDescriptor: nodeDefinition.viewDescriptor,
    viewOptions: nodeDefinition.viewOptions,
    ownerFinderDescriptor: nodeDefinition.ownerFinderDescriptor,
    carbonCopySettings: getValidCarbonCopySettings(nodeDefinition.carbonCopySettings),
    notificationSettings: getValidNotificationSettings(nodeDefinition.notificationSettings),
    descriptions: nodeDefinition.descriptions
  };
};
const getValidRouteDefinition = (routeDefinition) => {
  if (!routeDefinition) {
    return void 0;
  }
  return {
    code: routeDefinition.code,
    processNodeDefinitionCode: routeDefinition.processNodeDefinitionCode,
    nextProcessNodeDefinitionCode: routeDefinition.nextProcessNodeDefinitionCode,
    extraData: routeDefinition.extraData,
    eventDefinitions: getValidEventDefinitions(routeDefinition.eventDefinitions),
    routePolicyDescriptor: routeDefinition.routePolicyDescriptor
  };
};
const getConditionPrevAndNextIds = (graph, node) => {
  var _a3, _b3;
  const edges = graph.getConnectedEdges(node);
  const prevNodeId = (_a3 = edges == null ? void 0 : edges.find((e10) => e10.getTargetCellId() == node.id)) == null ? void 0 : _a3.getSourceCellId();
  const nextNodeId = (_b3 = edges == null ? void 0 : edges.find((e10) => e10.getSourceCellId() == node.id)) == null ? void 0 : _b3.getTargetCellId();
  return { prevNodeId, nextNodeId };
};
const convertToFlowDesignerViewModel = (processDefinition) => {
  const viewModel = {
    code: processDefinition.code,
    name: processDefinition.name,
    descriptions: processDefinition.descriptions,
    groupId: processDefinition.groupId,
    enabled: processDefinition.enabled,
    published: processDefinition.published,
    processDefinitionId: processDefinition.id,
    edgeMetadataArray: [],
    nodeMetadataArray: [],
    routeDefinitionMap: /* @__PURE__ */ new Map(),
    nodeDefinitionMap: /* @__PURE__ */ new Map(),
    nodeFormSchemaMap: /* @__PURE__ */ new Map(),
    formSchema: {},
    extraProperties: processDefinition.extraProperties || {}
  };
  viewModel.formSchema = convertViewDescriptorToFormSchema(processDefinition.viewDescriptor);
  const firstNodeDefinition = processDefinition.getStartNodeDefinitionOrUndefined();
  if (!firstNodeDefinition) {
    return viewModel;
  }
  const routeDefinitionCodes = [];
  toFlowDesignViewModelRecursive(processDefinition, firstNodeDefinition, void 0, void 0, viewModel, routeDefinitionCodes);
  return viewModel;
};
const getGraphNodeIdByNodeDefinitionCode = (flowDesignerViewModel, code) => {
  let key;
  for (const kv2 of flowDesignerViewModel.nodeDefinitionMap) {
    if (kv2[1].code == code) {
      key = kv2[0];
      break;
    }
  }
  return key;
};
const toFlowDesignViewModelRecursive = (processDefinition, nodeDefinition, prevGraphNodeId, prevGraphNodeDefinitionCode, viewModel, routeDefinitionCodes) => {
  var _a3, _b3, _c3, _d3, _e3, _f3, _g3, _h3, _i3, _j2, _k3, _l3, _m3, _n3, _o3, _p3;
  if (!nodeDefinition) {
    return;
  }
  let nodeId = getGraphNodeIdByNodeDefinitionCode(viewModel, nodeDefinition.code);
  if (!nodeId) {
    const nodeMetadata = (_c3 = (_b3 = (_a3 = processDefinition.extraProperties) == null ? void 0 : _a3.graphMetadata) == null ? void 0 : _b3.nodeMap) == null ? void 0 : _c3[`n:${nodeDefinition.code}`];
    const node = convertNodeDefinitionToGraphNode(nodeDefinition, nodeMetadata);
    (_d3 = viewModel.nodeMetadataArray) == null ? void 0 : _d3.push(node);
    viewModel.nodeDefinitionMap.set(node.id, nodeDefinition);
    if (nodeDefinition.viewDescriptor) {
      viewModel.nodeFormSchemaMap.set(node.id, convertViewDescriptorToFormSchema(nodeDefinition.viewDescriptor));
    }
    nodeId = node.id;
  }
  if (prevGraphNodeId) {
    const edgeMetadata = (_g3 = (_f3 = (_e3 = processDefinition.extraProperties) == null ? void 0 : _e3.graphMetadata) == null ? void 0 : _f3.edgeMap) == null ? void 0 : _g3[`${prevGraphNodeDefinitionCode}-n:${nodeDefinition.code}`];
    const edge = createEdge$1(prevGraphNodeId, nodeId, edgeMetadata);
    (_h3 = viewModel.edgeMetadataArray) == null ? void 0 : _h3.push(edge);
  }
  const nextRouteDefinitions = processDefinition.getNextRouteDefinitions(nodeDefinition.code);
  if (nextRouteDefinitions && nextRouteDefinitions.length > 0) {
    for (let i2 = 0; i2 < nextRouteDefinitions.length; i2++) {
      if (routeDefinitionCodes.includes(nextRouteDefinitions[i2].code)) {
        continue;
      } else {
        routeDefinitionCodes.push(nextRouteDefinitions[i2].code);
      }
      const nextNodeDefinition = processDefinition.getNodeDefinitionByCode(nextRouteDefinitions[i2].nextProcessNodeDefinitionCode);
      if (nextNodeDefinition) {
        const nodeMetadata = (_k3 = (_j2 = (_i3 = processDefinition.extraProperties) == null ? void 0 : _i3.graphMetadata) == null ? void 0 : _j2.nodeMap) == null ? void 0 : _k3[`r:${nextRouteDefinitions[i2].code}`];
        const nextConditionNode = convertRouteDefinitionToGraphNode(nextRouteDefinitions[i2], nodeMetadata);
        if (nextConditionNode !== void 0) {
          (_l3 = viewModel.nodeMetadataArray) == null ? void 0 : _l3.push(nextConditionNode);
          viewModel.routeDefinitionMap.set(nextConditionNode.id, nextRouteDefinitions[i2]);
          const edgeMetadata = (_o3 = (_n3 = (_m3 = processDefinition.extraProperties) == null ? void 0 : _m3.graphMetadata) == null ? void 0 : _n3.edgeMap) == null ? void 0 : _o3[`n:${nodeDefinition.code}-r:${nextRouteDefinitions[i2].code}`];
          const edge = createEdge$1(nodeId, nextConditionNode.id, edgeMetadata);
          (_p3 = viewModel.edgeMetadataArray) == null ? void 0 : _p3.push(edge);
          toFlowDesignViewModelRecursive(processDefinition, nextNodeDefinition, nextConditionNode.id, `r:${nextRouteDefinitions[i2].code}`, viewModel, routeDefinitionCodes);
        } else {
          toFlowDesignViewModelRecursive(processDefinition, nextNodeDefinition, nodeId, `n:${nodeDefinition.code}`, viewModel, routeDefinitionCodes);
        }
      }
    }
  }
};
const createEdge$1 = (prevNodeId, nextNodeId, edgeMetadata) => {
  const metadata = createEdgeMetadata();
  if (edgeMetadata) {
    return {
      ...metadata,
      id: generateShortUUID(),
      source: { cell: prevNodeId, port: (edgeMetadata == null ? void 0 : edgeMetadata.sourcePort) || "top" },
      target: { cell: nextNodeId, port: (edgeMetadata == null ? void 0 : edgeMetadata.targetPort) || "top" },
      vertices: edgeMetadata == null ? void 0 : edgeMetadata.vertices
    };
  } else {
    return {
      ...metadata,
      id: generateShortUUID(),
      source: { cell: prevNodeId, port: "bottom" },
      target: { cell: nextNodeId, port: "top" }
    };
  }
};
class FlowDesignerModel {
  constructor(processDefinition) {
    __publicField(this, "activeNodeId", "");
    __publicField(this, "_flowDesignerViewModel");
    __publicField(this, "_oldProcessDefinitionViewModel");
    __publicField(this, "_nodeValidationResults");
    __publicField(this, "getValidateErrorMessages", (nodeId) => {
      const maxShowErrors = 5;
      const messages2 = [];
      const validationResult = this._nodeValidationResults.get(nodeId);
      if (!validationResult) {
        return [];
      }
      if ((validationResult == null ? void 0 : validationResult.edgeMessages) && validationResult.edgeMessages.length > 0) {
        for (let i2 = 0; i2 < validationResult.edgeMessages.length; i2++) {
          if (messages2.length <= maxShowErrors) {
            messages2.push(validationResult.edgeMessages[i2]);
          } else {
            return messages2;
          }
        }
      }
      if ((validationResult == null ? void 0 : validationResult.messages) && validationResult.messages.length > 0) {
        for (let i2 = 0; i2 < validationResult.messages.length; i2++) {
          if (messages2.length <= maxShowErrors) {
            messages2.push(validationResult.messages[i2]);
          } else {
            return messages2;
          }
        }
      }
      if (validationResult == null ? void 0 : validationResult.validateFieldsError) {
        const keys = Object.keys(validationResult == null ? void 0 : validationResult.validateFieldsError);
        for (const key of keys) {
          const validateErrors = validationResult.validateFieldsError[key];
          for (let i2 = 0; i2 < validateErrors.length; i2++) {
            if (!isNullOrUndefinedOrWhiteSpace(validateErrors[i2].message)) {
              if (messages2.length <= maxShowErrors) {
                messages2.push(validateErrors[i2].message);
              } else {
                return messages2;
              }
            }
          }
        }
      }
      return messages2;
    });
    const processDefinitionViewModel = ProcessDefinitionViewModel.create(processDefinition);
    this._oldProcessDefinitionViewModel = processDefinitionViewModel;
    const flowDesignerViewModel = convertToFlowDesignerViewModel(processDefinitionViewModel);
    this._flowDesignerViewModel = ref(flowDesignerViewModel);
    this._nodeValidationResults = reactive(/* @__PURE__ */ new Map());
  }
  hasValidateErrors(nodeId) {
    const nodeValidationResult = this._nodeValidationResults.get(nodeId);
    if (!nodeValidationResult) {
      return false;
    }
    return isInvalidNode(nodeValidationResult);
  }
  getValidationResult(nodeId) {
    return this._nodeValidationResults.get(nodeId);
  }
  setNodeValidationResult(nodeValidationResult) {
    this._nodeValidationResults.set(nodeValidationResult.id, nodeValidationResult);
  }
  setFlowValidationResults(nodeValidationResults) {
    this._nodeValidationResults.clear();
    for (let i2 = 0; i2 < nodeValidationResults.length; i2++) {
      this.setNodeValidationResult(nodeValidationResults[i2]);
    }
  }
  clearNodeValidationResult(nodeId) {
    this._nodeValidationResults.delete(nodeId);
  }
  useProcessDefinition(processDefinition) {
    const processDefinitionViewModel = ProcessDefinitionViewModel.create(processDefinition);
    this._oldProcessDefinitionViewModel = processDefinitionViewModel;
    this._flowDesignerViewModel.value = convertToFlowDesignerViewModel(processDefinitionViewModel);
  }
  get flowDesignerViewModel() {
    return this._flowDesignerViewModel.value;
  }
  set flowDesignerViewModel(value) {
    this._flowDesignerViewModel.value = value;
  }
  get formSchema() {
    return this.flowDesignerViewModel.formSchema;
  }
  set formSchema(formSchema) {
    this.flowDesignerViewModel.formSchema = formSchema;
  }
  getOrCreateNodeDefinition(id2, nodeType) {
    if (!this.flowDesignerViewModel.nodeDefinitionMap.has(id2)) {
      this.flowDesignerViewModel.nodeDefinitionMap.set(id2, this.initialDefaultProcessNodeDefinition(nodeType));
    }
    return this.flowDesignerViewModel.nodeDefinitionMap.get(id2);
  }
  getOrCreateRouteDefinition(id2) {
    if (!this.flowDesignerViewModel.routeDefinitionMap.has(id2)) {
      this.flowDesignerViewModel.routeDefinitionMap.set(id2, {
        code: "",
        processNodeDefinitionCode: "",
        nextProcessNodeDefinitionCode: "",
        routePolicyDescriptor: createAlwaysTrue(),
        extraData: {}
      });
    }
    return this.flowDesignerViewModel.routeDefinitionMap.get(id2);
  }
  getFormSchema(id2) {
    const nodeFormSchema = this.flowDesignerViewModel.nodeFormSchemaMap.get(id2);
    return nodeFormSchema || this.flowDesignerViewModel.formSchema;
  }
  getActiveFormSchema() {
    const nodeFormSchema = this.flowDesignerViewModel.nodeFormSchemaMap.get(this.activeNodeId);
    return nodeFormSchema || this.flowDesignerViewModel.formSchema;
  }
  getActiveGraphCell() {
    var _a3;
    return (_a3 = this.flowDesignerViewModel.graph) == null ? void 0 : _a3.getCellById(this.activeNodeId);
  }
  initialDefaultProcessNodeDefinition(nodeType) {
    const code = "node-" + generateShortUUID();
    const handlerFinderDescriptors = nodeType == "initialNode" ? [{ componentCode: "ProcessStarter", settings: {} }] : [];
    return {
      code,
      name: code,
      ownerFinderDescriptor: { handlerFinderDescriptors, all: false, allowedToBeMutilpeHandlers: false },
      nodeType,
      extraData: {},
      settings: {}
    };
  }
  setActiveNodeDefinition(nodeDefinition) {
    this.flowDesignerViewModel.nodeDefinitionMap.set(this.activeNodeId, nodeDefinition);
  }
  setActiveRouteDefinition(routeDefinition) {
    this.flowDesignerViewModel.routeDefinitionMap.set(this.activeNodeId, routeDefinition);
  }
  getProcessDefinitionViewModel() {
    if (!this.flowDesignerViewModel.graph) {
      const result = this._oldProcessDefinitionViewModel;
      result.code = this.flowDesignerViewModel.code;
      result.name = this.flowDesignerViewModel.name;
      result.groupId = this.flowDesignerViewModel.groupId;
      result.descriptions = this.flowDesignerViewModel.descriptions;
      result.viewDescriptor = convertFormSchemaToViewDescriptor(this.flowDesignerViewModel.formSchema);
      return result;
    }
    this.flowDesignerViewModel.graphNodes = this.flowDesignerViewModel.graph.getNodes();
    this.flowDesignerViewModel.graphEdges = this.flowDesignerViewModel.graph.getEdges();
    const nodeDefinitions = [];
    const firstGraphNode = this.getStartGraphNode();
    if (!firstGraphNode) {
      return void 0;
    }
    const routeDefinitions = [];
    const edges = [];
    const nodeMetadataMap = /* @__PURE__ */ new Map();
    const edgeMetadataMap = /* @__PURE__ */ new Map();
    this.toDefinitionsRecursive(edges, firstGraphNode, nodeDefinitions, routeDefinitions, nodeMetadataMap, edgeMetadataMap);
    const processDefinitionViewModel = ProcessDefinitionViewModel.create();
    processDefinitionViewModel.id = this._flowDesignerViewModel.value.processDefinitionId;
    processDefinitionViewModel.code = this._flowDesignerViewModel.value.code;
    processDefinitionViewModel.name = this._flowDesignerViewModel.value.name;
    processDefinitionViewModel.descriptions = this._flowDesignerViewModel.value.descriptions;
    processDefinitionViewModel.groupId = this._flowDesignerViewModel.value.groupId;
    processDefinitionViewModel.enabled = this._flowDesignerViewModel.value.enabled;
    processDefinitionViewModel.published = this._flowDesignerViewModel.value.published;
    processDefinitionViewModel.viewDescriptor = convertFormSchemaToViewDescriptor(this._flowDesignerViewModel.value.formSchema);
    processDefinitionViewModel.processNodeDefinitions = nodeDefinitions;
    processDefinitionViewModel.processRouteDefinitions = routeDefinitions;
    processDefinitionViewModel.settings = void 0;
    processDefinitionViewModel.extraProperties = this._flowDesignerViewModel.value.extraProperties || {};
    processDefinitionViewModel.extraProperties["graphMetadata"] = {};
    processDefinitionViewModel.extraProperties["graphMetadata"]["nodeMap"] = Object.fromEntries(nodeMetadataMap);
    processDefinitionViewModel.extraProperties["graphMetadata"]["edgeMap"] = Object.fromEntries(edgeMetadataMap);
    return processDefinitionViewModel;
  }
  validateCode(code) {
    this.flowDesignerViewModel.nodeDefinitionMap.keys();
    const nodeDefinitions = this.flowDesignerViewModel.nodeDefinitionMap.values();
    let count = 0;
    for (const nodeDefinition of nodeDefinitions) {
      if (nodeDefinition.code == code) {
        count++;
      }
      if (count > 1) {
        return "code_validator_duplicateCodeError";
      }
    }
  }
  getValidNodeDefinition(nodeId) {
    const nodeDefinition = this.flowDesignerViewModel.nodeDefinitionMap.get(nodeId);
    return getValidNodeDefinition(nodeDefinition);
  }
  getValidRouteDefinition(routeId) {
    const routeDefinition = this.flowDesignerViewModel.routeDefinitionMap.get(routeId);
    return getValidRouteDefinition(routeDefinition);
  }
  getValidRouteDefinitionByGraphNode(graphNode) {
    var _a3, _b3, _c3;
    const routeDefinition = this.flowDesignerViewModel.routeDefinitionMap.get(graphNode.id);
    const graph = (_a3 = this._flowDesignerViewModel.value) == null ? void 0 : _a3.graph;
    if (routeDefinition && graph) {
      graph == null ? void 0 : graph.getConnectedEdges(graphNode);
      const { prevNodeId, nextNodeId } = getConditionPrevAndNextIds(graph, graphNode);
      if (prevNodeId == void 0 || nextNodeId == void 0) {
        return void 0;
      }
      routeDefinition.processNodeDefinitionCode = ((_b3 = this._flowDesignerViewModel.value.nodeDefinitionMap.get(prevNodeId)) == null ? void 0 : _b3.code) || "";
      routeDefinition.nextProcessNodeDefinitionCode = ((_c3 = this._flowDesignerViewModel.value.nodeDefinitionMap.get(nextNodeId)) == null ? void 0 : _c3.code) || "";
      routeDefinition.code = `${routeDefinition.processNodeDefinitionCode}-${routeDefinition.nextProcessNodeDefinitionCode}`;
    }
    return getValidRouteDefinition(routeDefinition);
  }
  getStartGraphNode() {
    var _a3, _b3;
    return (_b3 = (_a3 = this._flowDesignerViewModel.value) == null ? void 0 : _a3.graphNodes) == null ? void 0 : _b3.singleOrUndefined((n2) => isStartNode(n2));
  }
  getNextEdges(nodeId) {
    var _a3;
    return (_a3 = this._flowDesignerViewModel.value.graphEdges) == null ? void 0 : _a3.filter((e10) => e10.getSourceCellId() == nodeId);
  }
  getNextNodes(nodeId) {
    var _a3, _b3;
    return (_b3 = (_a3 = this._flowDesignerViewModel.value.graphEdges) == null ? void 0 : _a3.filter((e10) => {
      var _a4;
      return ((_a4 = e10.getSourceNode()) == null ? void 0 : _a4.id) == nodeId;
    })) == null ? void 0 : _b3.map((e10) => e10.getTargetNode());
  }
  toDefinitionsRecursive(edges, graphNode, nodeDefinitions, routeDefinitions, nodeMetadataMap, edgeMetadataMap) {
    const isCondition = isConditionNode$1(graphNode);
    let nodeDefinitionId = "";
    if (!isCondition) {
      let nodeDefinition = this.getValidNodeDefinition(graphNode.id);
      if (!nodeDefinition) {
        throw new Error(`Node ${graphNode.id} not found`);
      }
      nodeDefinitionId = `n:${nodeDefinition.code}`;
      if (!nodeDefinitions.some((n2) => n2.code == nodeDefinition.code)) {
        nodeMetadataMap.set(nodeDefinitionId, {
          x: graphNode.position().x,
          y: graphNode.position().y,
          angle: graphNode.angle()
        });
        nodeDefinitions.push(nodeDefinition);
      }
    } else {
      let routeDefinition = this.getValidRouteDefinitionByGraphNode(graphNode);
      if (routeDefinition) {
        nodeDefinitionId = `r:${routeDefinition.code}`;
        if (!routeDefinitions.some((r3) => r3.code == routeDefinition.code)) {
          nodeMetadataMap.set(nodeDefinitionId, {
            x: graphNode.position().x,
            y: graphNode.position().y,
            angle: graphNode.angle()
          });
          routeDefinitions.push(routeDefinition);
        }
      }
    }
    const nextEdges = this.getNextEdges(graphNode.id);
    if (nextEdges == void 0 || nextEdges.length == 0) {
      return;
    }
    let nextNode;
    for (let i2 = 0; i2 < nextEdges.length; i2++) {
      if (edges.some((e10) => e10.id == nextEdges[i2].id)) {
        continue;
      } else {
        edges.push(nextEdges[i2]);
      }
      nextNode = nextEdges[i2].getTargetNode();
      if (!nextNode) {
        continue;
      }
      if (isConditionNode$1(nextNode)) {
        const routeDefinition = this.getValidRouteDefinition(nextNode.id);
        const { prevNodeId, nextNodeId } = getConditionPrevAndNextIds(this._flowDesignerViewModel.value.graph, nextNode);
        if (prevNodeId == void 0 || nextNodeId == void 0) {
          throw Error("");
        }
        this._flowDesignerViewModel.value.nodeDefinitionMap.get(prevNodeId);
        this._flowDesignerViewModel.value.nodeDefinitionMap.get(nextNodeId);
        edgeMetadataMap.set(`${nodeDefinitionId}-r:${routeDefinition.code}`, {
          vertices: nextEdges[i2].vertices,
          sourcePort: nextEdges[i2].getSourcePortId(),
          targetPort: nextEdges[i2].getTargetPortId()
        });
      } else {
        const nodeDefinition = this._flowDesignerViewModel.value.nodeDefinitionMap.get(nextNode.id);
        edgeMetadataMap.set(`${nodeDefinitionId}-n:${nodeDefinition.code}`, {
          vertices: nextEdges[i2].vertices,
          sourcePort: nextEdges[i2].getSourcePortId(),
          targetPort: nextEdges[i2].getTargetPortId()
        });
        if (!isCondition) {
          const preNodeDefinition = this._flowDesignerViewModel.value.nodeDefinitionMap.get(graphNode.id);
          const nextNodeDefinition = this._flowDesignerViewModel.value.nodeDefinitionMap.get(nextNode.id);
          const routeDefinitionCode = `${preNodeDefinition.code}-${nextNodeDefinition.code}`;
          if (!routeDefinitions.some((r3) => r3.code == routeDefinitionCode)) {
            routeDefinitions.push({
              code: `${preNodeDefinition.code}-${nextNodeDefinition.code}`,
              processNodeDefinitionCode: preNodeDefinition.code,
              nextProcessNodeDefinitionCode: nextNodeDefinition.code,
              routePolicyDescriptor: createAlwaysTrue(),
              extraData: void 0
            });
          }
        }
      }
      this.toDefinitionsRecursive(edges, nextNode, nodeDefinitions, routeDefinitions, nodeMetadataMap, edgeMetadataMap);
    }
  }
}
const _hoisted_1$5 = { style: { "flex": "auto" } };
const _hoisted_2$2 = { style: { "flex": "auto" } };
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "FlowDesigner",
  props: {
    processDefinition: {},
    config: {},
    readonly: { type: Boolean }
  },
  emits: ["create", "update", "cancel"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const nodeConfigVisible = ref(false);
    const loadNodeConfig = ref(false);
    const routeConfigVisible = ref(false);
    const loadRouteConfig = ref(false);
    const tempNodeDefinition = ref();
    const tempRouteDefinition = ref();
    const flowDesignerModel = computed(() => new FlowDesignerModel(props.processDefinition));
    provideFlowDesignerModel(flowDesignerModel);
    provideFlowDesignerConfig(props.config);
    const openRouteConfigDialog = (node) => {
      var _a3, _b3, _c3;
      flowDesignerModel.value.activeNodeId = node.id;
      const routeDefinition = toRaw(flowDesignerModel.value.getOrCreateRouteDefinition(node.id));
      tempRouteDefinition.value = JSON.parse(JSON.stringify(routeDefinition));
      (_a3 = routeConfigRef.value) == null ? void 0 : _a3.resetUI();
      (_c3 = (_b3 = routeConfigRef.value) == null ? void 0 : _b3.formValidator) == null ? void 0 : _c3.clearValidate();
      routeConfigVisible.value = true;
      loadRouteConfig.value = true;
    };
    const openNodeConfigDialog = (node) => {
      var _a3, _b3, _c3;
      flowDesignerModel.value.activeNodeId = node.id;
      const nodeType = isStartNode(node) ? "initialNode" : "userNode";
      const nodeDefinition = toRaw(flowDesignerModel.value.getOrCreateNodeDefinition(node.id, nodeType));
      tempNodeDefinition.value = JSON.parse(JSON.stringify(nodeDefinition));
      (_a3 = nodeConfigRef.value) == null ? void 0 : _a3.resetUI();
      (_c3 = (_b3 = nodeConfigRef.value) == null ? void 0 : _b3.formValidator) == null ? void 0 : _c3.clearValidate();
      nodeConfigVisible.value = true;
      loadNodeConfig.value = true;
    };
    const nodeDblClick = (node) => {
      if (isConditionNode$1(node)) {
        openRouteConfigDialog(node);
      } else {
        openNodeConfigDialog(node);
      }
    };
    const nodeConfigRef = shallowRef();
    const routeConfigRef = shallowRef();
    const confirmNodeConfig = async () => {
      var _a3;
      try {
        const validationResult = await nodeConfigRef.value.formValidator.validate();
        if (!validationResult.isValid) {
          await nodeConfigRef.value.formValidator.scrollToError(validationResult);
          return;
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
      if (tempNodeDefinition.value) {
        flowDesignerModel.value.setActiveNodeDefinition(toRaw(tempNodeDefinition.value));
      }
      nodeConfigVisible.value = false;
      const activeNode = flowDesignerModel.value.getActiveGraphCell();
      const errorMessages = validateNodeConnectedEdges(flowDesignerModel.value.flowDesignerViewModel.graph, activeNode, t2);
      if (errorMessages.length > 0) {
        flowDesignerModel.value.setNodeValidationResult({ id: activeNode.id, name: ((_a3 = tempNodeDefinition.value) == null ? void 0 : _a3.name) || "", edgeMessages: errorMessages });
      } else {
        flowDesignerModel.value.clearNodeValidationResult(activeNode.id);
      }
    };
    const confirmRouteConfig = async () => {
      var _a3;
      const validationResult = await routeConfigRef.value.formValidator.validate();
      if (!validationResult.isValid) {
        routeConfigRef.value.formValidator.scrollToError(validationResult);
        return;
      }
      if (tempRouteDefinition.value) {
        flowDesignerModel.value.setActiveRouteDefinition(tempRouteDefinition.value);
      }
      routeConfigVisible.value = false;
      const activeNode = flowDesignerModel.value.getActiveGraphCell();
      const errorMessages = validateNodeConnectedEdges(flowDesignerModel.value.flowDesignerViewModel.graph, activeNode, t2);
      if (errorMessages.length > 0) {
        flowDesignerModel.value.setNodeValidationResult({ id: activeNode.id, name: ((_a3 = tempNodeDefinition.value) == null ? void 0 : _a3.name) || "", edgeMessages: errorMessages });
      } else {
        flowDesignerModel.value.clearNodeValidationResult(activeNode.id);
      }
    };
    const cancelNodeConfig = async () => {
      nodeConfigVisible.value = false;
      const activeNode = flowDesignerModel.value.getActiveGraphCell();
      const nodeValidationResult = await validateNode(flowDesignerModel.value.flowDesignerViewModel.graph, activeNode, flowDesignerModel.value, t2);
      if (!nodeValidationResult) {
        flowDesignerModel.value.clearNodeValidationResult(activeNode.id);
      } else {
        flowDesignerModel.value.setNodeValidationResult(nodeValidationResult);
      }
    };
    const cancelRouteConfig = async () => {
      routeConfigVisible.value = false;
      const activeNode = flowDesignerModel.value.getActiveGraphCell();
      const nodeValidationResult = await validateNode(flowDesignerModel.value.flowDesignerViewModel.graph, activeNode, flowDesignerModel.value, t2);
      if (!nodeValidationResult) {
        flowDesignerModel.value.clearNodeValidationResult(activeNode.id);
      } else {
        flowDesignerModel.value.setNodeValidationResult(nodeValidationResult);
      }
    };
    const { t: t2 } = useLocale();
    const activeTab = ref("general");
    const generalFormRef = shallowRef();
    const validator = new MultipleFormValidator(
      "flowDesigner",
      [
        new FormValidator("flowDesignerGeneral", generalFormRef).withScrollToError(async () => {
          activeTab.value = "general";
          return;
        }),
        new FlowGraphValidator(flowDesignerModel.value, t2, "flowDesignerGraph").withScrollToError(async (formValidator, validationResult) => {
          activeTab.value = "flowGraphDesigner";
          validationResult.invalidFields;
        })
      ]
    );
    const confirm = async () => {
      var _a3;
      const validationResult = await validator.validate();
      if (!validationResult.isValid) {
        (_a3 = validationResult.validator) == null ? void 0 : _a3.scrollToError(validationResult);
        return;
      }
      const processDefinitionViewModel = flowDesignerModel.value.getProcessDefinitionViewModel();
      if (processDefinitionViewModel) {
        if (processDefinitionViewModel.isNew) {
          const createProcessDefinitionInput = processDefinitionViewModel.mapToCreateProcessDefinitionInput();
          emit("create", createProcessDefinitionInput);
        } else {
          const updateProcessDefinitionInput = processDefinitionViewModel.mapToUpdateProcessDefinitionInput();
          emit("update", updateProcessDefinitionInput);
        }
      }
    };
    const cancel = () => {
      flowDesignerModel.value.useProcessDefinition(props.processDefinition);
      emit("cancel");
    };
    const flowGroups = computedAsync(async () => await props.config.getFlowGroupItems());
    const generalFormRules = {
      "code": [
        { required: true, message: t2("Code_Validator_Required") },
        { min: 1, max: 50, message: (a2) => t2("Code_validator_min") }
      ],
      "name": [
        { required: true, message: t2("Name_Validator_Required") },
        { min: 1, max: 50, message: t2("Name_Validator_Min") }
      ],
      "groupId": [
        { required: true, message: t2("Group_Validator_Required") }
      ],
      "descriptions": [
        { max: 100, message: t2("Descriptions_Validator_Max") }
      ]
    };
    const validateNodeEdges = (graph, node, t22) => {
      const errorMessages = validateNodeConnectedEdges(flowDesignerModel.value.flowDesignerViewModel.graph, node, t22);
      const validationResult = flowDesignerModel.value.getValidationResult(node.id);
      if (errorMessages && errorMessages.length > 0) {
        if (validationResult) {
          validationResult.edgeMessages = errorMessages;
        } else {
          flowDesignerModel.value.setNodeValidationResult({ id: node.id, name: "", edgeMessages: errorMessages });
        }
      } else {
        if (validationResult) {
          validationResult.edgeMessages = errorMessages;
        }
      }
    };
    const edgeConnected = (isNew, edge) => {
      if (isNew) {
        validateEdgesConnection(edge);
      }
    };
    const validateEdgesConnection = (edge) => {
      const graph = flowDesignerModel.value.flowDesignerViewModel.graph;
      let sourceNode = edge.getSourceNode();
      let targetNode = edge.getTargetCell();
      if (!sourceNode) {
        const sourceCellId = edge.getSourceCellId();
        if (sourceCellId) {
          sourceNode = graph == null ? void 0 : graph.getCellById(sourceCellId);
        }
      }
      if (!targetNode) {
        const targetCellId = edge.getTargetCellId();
        if (targetCellId) {
          targetNode = graph == null ? void 0 : graph.getCellById(targetCellId);
        }
      }
      if (sourceNode && targetNode) {
        validateNodeEdges(flowDesignerModel.value.flowDesignerViewModel.graph, sourceNode, t2);
        validateNodeEdges(flowDesignerModel.value.flowDesignerViewModel.graph, targetNode, t2);
      }
    };
    const edgeDeleted = (edge) => {
      validateEdgesConnection(edge);
    };
    return (_ctx, _cache) => {
      const _component_el_button = resolveComponent("el-button");
      const _component_el_col = resolveComponent("el-col");
      const _component_el_input = resolveComponent("el-input");
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_switch = resolveComponent("el-switch");
      const _component_el_option = resolveComponent("el-option");
      const _component_el_select = resolveComponent("el-select");
      const _component_el_form = resolveComponent("el-form");
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_drawer = resolveComponent("el-drawer");
      const _component_el_tabs = resolveComponent("el-tabs");
      const _component_el_row = resolveComponent("el-row");
      return openBlock(), createBlock(_component_el_row, { style: { "height": "100%" } }, {
        default: withCtx(() => [
          !_ctx.readonly ? (openBlock(), createBlock(_component_el_col, {
            key: 0,
            span: 4,
            offset: 20,
            class: "tab-buttons"
          }, {
            default: withCtx(() => [
              !flowDesignerModel.value.flowDesignerViewModel.published ? (openBlock(), createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: withModifiers(confirm, ["stop"])
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Confirm")), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true),
              createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: withModifiers(cancel, ["stop"])
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Cancel")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", true),
          createVNode(_component_el_col, {
            span: 24,
            style: { "height": "100%" }
          }, {
            default: withCtx(() => [
              createVNode(_component_el_tabs, {
                class: "flow-designer-tab",
                type: "card",
                modelValue: activeTab.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => activeTab.value = $event)
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_tab_pane, {
                    label: unref(t2)("General"),
                    name: "general"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_form, {
                        ref_key: "generalFormRef",
                        ref: generalFormRef,
                        rules: generalFormRules,
                        "label-width": "auto",
                        model: flowDesignerModel.value.flowDesignerViewModel
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_form_item, {
                            label: unref(t2)("Code"),
                            prop: "code"
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_input, {
                                "show-word-limit": "",
                                modelValue: flowDesignerModel.value.flowDesignerViewModel.code,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => flowDesignerModel.value.flowDesignerViewModel.code = $event),
                                maxlength: "50"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          createVNode(_component_el_form_item, {
                            label: unref(t2)("Enabled")
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_switch, {
                                modelValue: flowDesignerModel.value.flowDesignerViewModel.enabled,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => flowDesignerModel.value.flowDesignerViewModel.enabled = $event),
                                "active-text": unref(t2)("Enabled"),
                                "inactive-text": unref(t2)("Disabled")
                              }, null, 8, ["modelValue", "active-text", "inactive-text"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          createVNode(_component_el_form_item, {
                            label: unref(t2)("Name"),
                            prop: "name"
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_input, {
                                "show-word-limit": "",
                                modelValue: flowDesignerModel.value.flowDesignerViewModel.name,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => flowDesignerModel.value.flowDesignerViewModel.name = $event),
                                maxlength: "50"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          createVNode(_component_el_form_item, {
                            label: unref(t2)("Group"),
                            prop: "groupId"
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_select, {
                                modelValue: flowDesignerModel.value.flowDesignerViewModel.groupId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => flowDesignerModel.value.flowDesignerViewModel.groupId = $event)
                              }, {
                                default: withCtx(() => [
                                  (openBlock(true), createElementBlock(Fragment, null, renderList(unref(flowGroups), (item) => {
                                    return openBlock(), createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]);
                                  }), 256))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          createVNode(_component_el_form_item, {
                            label: unref(t2)("Descriptions"),
                            prop: "descriptions"
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_input, {
                                type: "textarea",
                                modelValue: flowDesignerModel.value.flowDesignerViewModel.descriptions,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => flowDesignerModel.value.flowDesignerViewModel.descriptions = $event),
                                "show-word-limit": "",
                                maxlength: "100",
                                autosize: {
                                  minRows: 3,
                                  maxRows: 10
                                }
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_tab_pane, {
                    label: unref(t2)("FormDesigner"),
                    name: "formDesigner",
                    lazy: true
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$F, {
                        modelValue: flowDesignerModel.value.formSchema,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => flowDesignerModel.value.formSchema = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_tab_pane, {
                    label: unref(t2)("FlowGraphDesigner"),
                    name: "flowGraphDesigner",
                    lazy: true,
                    style: { "height": "100%" }
                  }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$s, {
                        onNodeClick: nodeDblClick,
                        onEdgeConnected: edgeConnected,
                        onEdgeDeleted: edgeDeleted
                      }),
                      loadNodeConfig.value ? (openBlock(), createBlock(_component_el_drawer, {
                        key: 0,
                        "z-index": 5,
                        "with-header": false,
                        size: "50%",
                        modelValue: nodeConfigVisible.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => nodeConfigVisible.value = $event),
                        "before-close": cancelNodeConfig
                      }, {
                        default: withCtx(() => [
                          createVNode(_sfc_main$c, {
                            ref_key: "nodeConfigRef",
                            ref: nodeConfigRef,
                            modelValue: tempNodeDefinition.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => tempNodeDefinition.value = $event),
                            "form-schema": flowDesignerModel.value.formSchema
                          }, null, 8, ["modelValue", "form-schema"])
                        ]),
                        footer: withCtx(() => [
                          createElementVNode("div", _hoisted_1$5, [
                            createVNode(_component_el_button, {
                              type: "primary",
                              onClick: confirmNodeConfig
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(unref(t2)("Confirm")), 1)
                              ]),
                              _: 1
                            }),
                            createVNode(_component_el_button, { onClick: cancelNodeConfig }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString(unref(t2)("Cancel")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true),
                      loadRouteConfig.value ? (openBlock(), createBlock(_component_el_drawer, {
                        key: 1,
                        "with-header": false,
                        size: "50%",
                        modelValue: routeConfigVisible.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => routeConfigVisible.value = $event),
                        "before-close": cancelRouteConfig
                      }, {
                        default: withCtx(() => [
                          createVNode(_sfc_main$b, {
                            ref_key: "routeConfigRef",
                            ref: routeConfigRef,
                            modelValue: tempRouteDefinition.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => tempRouteDefinition.value = $event),
                            formSchema: flowDesignerModel.value.formSchema
                          }, null, 8, ["modelValue", "formSchema"])
                        ]),
                        footer: withCtx(() => [
                          createElementVNode("div", _hoisted_2$2, [
                            createVNode(_component_el_button, {
                              type: "primary",
                              onClick: confirmRouteConfig
                            }, {
                              default: withCtx(() => _cache[11] || (_cache[11] = [
                                createTextVNode("confirm")
                              ])),
                              _: 1,
                              __: [11]
                            }),
                            createVNode(_component_el_button, { onClick: cancelRouteConfig }, {
                              default: withCtx(() => _cache[12] || (_cache[12] = [
                                createTextVNode("cancel")
                              ])),
                              _: 1,
                              __: [12]
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
});
const component$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$a, [["__scopeId", "data-v-4487cf00"]]);
const VcFlowDesigner = withInstall(component$1);
const _hoisted_1$4 = { class: "svg-icon" };
const _hoisted_2$1 = ["xlink:href"];
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "SvgIcon",
  props: {
    name: {},
    prefix: {}
  },
  setup(__props) {
    const props = __props;
    const svgHref = computed(() => "#" + (props.prefix || "icon-vantis-svg") + "-" + props.name);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1$4, [
        createElementVNode("use", { "xlink:href": svgHref.value }, null, 8, _hoisted_2$1)
      ]);
    };
  }
});
const SvgIcon = /* @__PURE__ */ _export_sfc$1(_sfc_main$9, [["__scopeId", "data-v-05427caf"]]);
const VcSvgIcon = withInstall(SvgIcon);
const VcUpload = withInstall(_sfc_main$O);
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  ...{
    name: "ConfigProvider"
  },
  __name: "ConfigProvider",
  props: {
    locale: {},
    hasPermission: { type: Function },
    downBaseUrl: {},
    axiosInstance: { type: [Function, Object] },
    axiosRequestConfig: {},
    permissionOptions: {}
  },
  setup(__props) {
    const props = __props;
    provideVantisGlobalConfig(props);
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});
const ConfigProvider = withInstall(_sfc_main$8);
const flowGraphNodeInstanceKey = Symbol("flowGraphInstances");
const processDefinitionKey = Symbol("processDefinition:readonly");
const formSchemaGetter = Symbol("formSchema:readonly");
const injectNodeInstancesRef = () => {
  return inject(flowGraphNodeInstanceKey);
};
const provideNodeInstancesRef = (nodeInstancesRef) => {
  return provide(flowGraphNodeInstanceKey, nodeInstancesRef);
};
const injectProcessDefinition = () => {
  return inject(processDefinitionKey);
};
const provideProcessDefinition = (processDefinition) => {
  return provide(processDefinitionKey, processDefinition);
};
const provideGetFormSchemaFunc = (func) => {
  return provide(formSchemaGetter, func);
};
const injectGetFormSchemaFunc = () => {
  return inject(formSchemaGetter);
};
const _hoisted_1$3 = { class: "node-box__title" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "UserNodeView",
  setup(__props) {
    const getNode = inject("getNode");
    const node = getNode();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const nodeDefinition = node.data.nodeDefinition;
    const { t: t2 } = useLocale();
    const getFormSchema = injectGetFormSchemaFunc();
    const ownerDescriptorFriendlyStrings = computed(() => {
      const nodeDefinition2 = node.data.nodeDefinition;
      const formSchema = getFormSchema(nodeDefinition2);
      return getNodeOwnerDescriptorFriendlyString(nodeDefinition2, formSchema, t2);
    });
    watch(ownerDescriptorFriendlyStrings, (newValue) => {
      nextTick(() => {
        resizeNodeToContainerSize();
      });
    });
    const container = ref();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "graph-node-box graph-node-box--user",
        ref_key: "container",
        ref: container
      }, [
        createElementVNode("div", _hoisted_1$3, [
          createElementVNode("span", null, toDisplayString(unref(nodeDefinition).name), 1)
        ]),
        createVNode(unref(ElRow), { class: "node-box__context" }, {
          default: withCtx(() => [
            createVNode(unref(ElCol), {
              span: 20,
              class: "node-box__context__text"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(ownerDescriptorFriendlyStrings.value, (item) => {
                  return openBlock(), createElementBlock("p", null, toDisplayString(item), 1);
                }), 256))
              ]),
              _: 1
            }),
            createVNode(unref(ElCol), { span: 4 }, {
              default: withCtx(() => [
                createVNode(unref(ElIcon), { class: "node-box__context__arrow" }, {
                  default: withCtx(() => [
                    createVNode(unref(arrow_right_default))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
});
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "ConditionView",
  setup(__props) {
    const { t: t2 } = useLocale();
    const getNode = inject("getNode");
    const node = getNode();
    const routeDefinition = node.data.routeDefinition;
    const container = ref();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const getFormSchema = injectGetFormSchemaFunc();
    const friendlyConditionString = computedAsync(async () => {
      var _a3;
      const formSchema = getFormSchema(routeDefinition.processNodeDefinitionCode);
      const conditionOptions = getFlowConditionOptions(formSchema);
      return await getFriendlyConditionString((_a3 = routeDefinition.routePolicyDescriptor.settings) == null ? void 0 : _a3.routeCondition, conditionOptions, t2);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "container",
        ref: container,
        class: "graph-node-box graph-node-box--condition"
      }, [
        createVNode(unref(ElRow), null, {
          default: withCtx(() => [
            createVNode(unref(ElCol), { class: "node-box__title" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)(unref(routeDefinition).routePolicyDescriptor.componentCode)), 1)
              ]),
              _: 1
            }),
            unref(routeDefinition).routePolicyDescriptor.componentCode == unref(RoutePolicyDescriptorCodes).ProportionalVoting ? (openBlock(), createBlock(unref(ElCol), {
              key: 0,
              class: "node-box__context",
              span: 24
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("Percentage")) + ":" + toDisplayString(unref(routeDefinition).routePolicyDescriptor.settings.percentage * 100) + "% ", 1)
              ]),
              _: 1
            })) : createCommentVNode("", true),
            unref(routeDefinition).routePolicyDescriptor.componentCode == unref(RoutePolicyDescriptorCodes).FixedQuorumDecision ? (openBlock(), createBlock(unref(ElCol), {
              key: 1,
              class: "node-box__context",
              span: 24
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t2)("QuorumThreshold")) + ":" + toDisplayString(unref(routeDefinition).routePolicyDescriptor.settings.quorumThreshold), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true),
            createVNode(unref(ElCol), {
              span: 24,
              class: "node-box__context__text"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(friendlyConditionString)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
});
class ProcessNodeState {
}
__publicField(ProcessNodeState, "none", "None");
__publicField(ProcessNodeState, "waiting", "Waiting");
__publicField(ProcessNodeState, "saved", "Saved");
__publicField(ProcessNodeState, "paused", "Paused");
__publicField(ProcessNodeState, "finished", "Finished");
__publicField(ProcessNodeState, "autoFinished", "AutoFinished");
var dayjs_min = { exports: {} };
(function(module, exports) {
  !function(t2, e10) {
    module.exports = e10();
  }(commonjsGlobal, function() {
    var t2 = 1e3, e10 = 6e4, n2 = 36e5, r3 = "millisecond", i2 = "second", s2 = "minute", u2 = "hour", a2 = "day", o2 = "week", c3 = "month", f2 = "quarter", h2 = "year", d2 = "date", l2 = "Invalid Date", $2 = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y2 = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M2 = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(t3) {
      var e11 = ["th", "st", "nd", "rd"], n3 = t3 % 100;
      return "[" + t3 + (e11[(n3 - 20) % 10] || e11[n3] || e11[0]) + "]";
    } }, m2 = function(t3, e11, n3) {
      var r4 = String(t3);
      return !r4 || r4.length >= e11 ? t3 : "" + Array(e11 + 1 - r4.length).join(n3) + t3;
    }, v2 = { s: m2, z: function(t3) {
      var e11 = -t3.utcOffset(), n3 = Math.abs(e11), r4 = Math.floor(n3 / 60), i3 = n3 % 60;
      return (e11 <= 0 ? "+" : "-") + m2(r4, 2, "0") + ":" + m2(i3, 2, "0");
    }, m: function t3(e11, n3) {
      if (e11.date() < n3.date()) return -t3(n3, e11);
      var r4 = 12 * (n3.year() - e11.year()) + (n3.month() - e11.month()), i3 = e11.clone().add(r4, c3), s3 = n3 - i3 < 0, u3 = e11.clone().add(r4 + (s3 ? -1 : 1), c3);
      return +(-(r4 + (n3 - i3) / (s3 ? i3 - u3 : u3 - i3)) || 0);
    }, a: function(t3) {
      return t3 < 0 ? Math.ceil(t3) || 0 : Math.floor(t3);
    }, p: function(t3) {
      return { M: c3, y: h2, w: o2, d: a2, D: d2, h: u2, m: s2, s: i2, ms: r3, Q: f2 }[t3] || String(t3 || "").toLowerCase().replace(/s$/, "");
    }, u: function(t3) {
      return void 0 === t3;
    } }, g2 = "en", D2 = {};
    D2[g2] = M2;
    var p2 = "$isDayjsObject", S2 = function(t3) {
      return t3 instanceof _2 || !(!t3 || !t3[p2]);
    }, w2 = function t3(e11, n3, r4) {
      var i3;
      if (!e11) return g2;
      if ("string" == typeof e11) {
        var s3 = e11.toLowerCase();
        D2[s3] && (i3 = s3), n3 && (D2[s3] = n3, i3 = s3);
        var u3 = e11.split("-");
        if (!i3 && u3.length > 1) return t3(u3[0]);
      } else {
        var a3 = e11.name;
        D2[a3] = e11, i3 = a3;
      }
      return !r4 && i3 && (g2 = i3), i3 || !r4 && g2;
    }, O2 = function(t3, e11) {
      if (S2(t3)) return t3.clone();
      var n3 = "object" == typeof e11 ? e11 : {};
      return n3.date = t3, n3.args = arguments, new _2(n3);
    }, b2 = v2;
    b2.l = w2, b2.i = S2, b2.w = function(t3, e11) {
      return O2(t3, { locale: e11.$L, utc: e11.$u, x: e11.$x, $offset: e11.$offset });
    };
    var _2 = function() {
      function M3(t3) {
        this.$L = w2(t3.locale, null, true), this.parse(t3), this.$x = this.$x || t3.x || {}, this[p2] = true;
      }
      var m3 = M3.prototype;
      return m3.parse = function(t3) {
        this.$d = function(t4) {
          var e11 = t4.date, n3 = t4.utc;
          if (null === e11) return /* @__PURE__ */ new Date(NaN);
          if (b2.u(e11)) return /* @__PURE__ */ new Date();
          if (e11 instanceof Date) return new Date(e11);
          if ("string" == typeof e11 && !/Z$/i.test(e11)) {
            var r4 = e11.match($2);
            if (r4) {
              var i3 = r4[2] - 1 || 0, s3 = (r4[7] || "0").substring(0, 3);
              return n3 ? new Date(Date.UTC(r4[1], i3, r4[3] || 1, r4[4] || 0, r4[5] || 0, r4[6] || 0, s3)) : new Date(r4[1], i3, r4[3] || 1, r4[4] || 0, r4[5] || 0, r4[6] || 0, s3);
            }
          }
          return new Date(e11);
        }(t3), this.init();
      }, m3.init = function() {
        var t3 = this.$d;
        this.$y = t3.getFullYear(), this.$M = t3.getMonth(), this.$D = t3.getDate(), this.$W = t3.getDay(), this.$H = t3.getHours(), this.$m = t3.getMinutes(), this.$s = t3.getSeconds(), this.$ms = t3.getMilliseconds();
      }, m3.$utils = function() {
        return b2;
      }, m3.isValid = function() {
        return !(this.$d.toString() === l2);
      }, m3.isSame = function(t3, e11) {
        var n3 = O2(t3);
        return this.startOf(e11) <= n3 && n3 <= this.endOf(e11);
      }, m3.isAfter = function(t3, e11) {
        return O2(t3) < this.startOf(e11);
      }, m3.isBefore = function(t3, e11) {
        return this.endOf(e11) < O2(t3);
      }, m3.$g = function(t3, e11, n3) {
        return b2.u(t3) ? this[e11] : this.set(n3, t3);
      }, m3.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, m3.valueOf = function() {
        return this.$d.getTime();
      }, m3.startOf = function(t3, e11) {
        var n3 = this, r4 = !!b2.u(e11) || e11, f3 = b2.p(t3), l3 = function(t4, e12) {
          var i3 = b2.w(n3.$u ? Date.UTC(n3.$y, e12, t4) : new Date(n3.$y, e12, t4), n3);
          return r4 ? i3 : i3.endOf(a2);
        }, $3 = function(t4, e12) {
          return b2.w(n3.toDate()[t4].apply(n3.toDate("s"), (r4 ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e12)), n3);
        }, y3 = this.$W, M4 = this.$M, m4 = this.$D, v6 = "set" + (this.$u ? "UTC" : "");
        switch (f3) {
          case h2:
            return r4 ? l3(1, 0) : l3(31, 11);
          case c3:
            return r4 ? l3(1, M4) : l3(0, M4 + 1);
          case o2:
            var g3 = this.$locale().weekStart || 0, D3 = (y3 < g3 ? y3 + 7 : y3) - g3;
            return l3(r4 ? m4 - D3 : m4 + (6 - D3), M4);
          case a2:
          case d2:
            return $3(v6 + "Hours", 0);
          case u2:
            return $3(v6 + "Minutes", 1);
          case s2:
            return $3(v6 + "Seconds", 2);
          case i2:
            return $3(v6 + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m3.endOf = function(t3) {
        return this.startOf(t3, false);
      }, m3.$set = function(t3, e11) {
        var n3, o3 = b2.p(t3), f3 = "set" + (this.$u ? "UTC" : ""), l3 = (n3 = {}, n3[a2] = f3 + "Date", n3[d2] = f3 + "Date", n3[c3] = f3 + "Month", n3[h2] = f3 + "FullYear", n3[u2] = f3 + "Hours", n3[s2] = f3 + "Minutes", n3[i2] = f3 + "Seconds", n3[r3] = f3 + "Milliseconds", n3)[o3], $3 = o3 === a2 ? this.$D + (e11 - this.$W) : e11;
        if (o3 === c3 || o3 === h2) {
          var y3 = this.clone().set(d2, 1);
          y3.$d[l3]($3), y3.init(), this.$d = y3.set(d2, Math.min(this.$D, y3.daysInMonth())).$d;
        } else l3 && this.$d[l3]($3);
        return this.init(), this;
      }, m3.set = function(t3, e11) {
        return this.clone().$set(t3, e11);
      }, m3.get = function(t3) {
        return this[b2.p(t3)]();
      }, m3.add = function(r4, f3) {
        var d3, l3 = this;
        r4 = Number(r4);
        var $3 = b2.p(f3), y3 = function(t3) {
          var e11 = O2(l3);
          return b2.w(e11.date(e11.date() + Math.round(t3 * r4)), l3);
        };
        if ($3 === c3) return this.set(c3, this.$M + r4);
        if ($3 === h2) return this.set(h2, this.$y + r4);
        if ($3 === a2) return y3(1);
        if ($3 === o2) return y3(7);
        var M4 = (d3 = {}, d3[s2] = e10, d3[u2] = n2, d3[i2] = t2, d3)[$3] || 1, m4 = this.$d.getTime() + r4 * M4;
        return b2.w(m4, this);
      }, m3.subtract = function(t3, e11) {
        return this.add(-1 * t3, e11);
      }, m3.format = function(t3) {
        var e11 = this, n3 = this.$locale();
        if (!this.isValid()) return n3.invalidDate || l2;
        var r4 = t3 || "YYYY-MM-DDTHH:mm:ssZ", i3 = b2.z(this), s3 = this.$H, u3 = this.$m, a3 = this.$M, o3 = n3.weekdays, c4 = n3.months, f3 = n3.meridiem, h3 = function(t4, n4, i4, s4) {
          return t4 && (t4[n4] || t4(e11, r4)) || i4[n4].slice(0, s4);
        }, d3 = function(t4) {
          return b2.s(s3 % 12 || 12, t4, "0");
        }, $3 = f3 || function(t4, e12, n4) {
          var r5 = t4 < 12 ? "AM" : "PM";
          return n4 ? r5.toLowerCase() : r5;
        };
        return r4.replace(y2, function(t4, r5) {
          return r5 || function(t5) {
            switch (t5) {
              case "YY":
                return String(e11.$y).slice(-2);
              case "YYYY":
                return b2.s(e11.$y, 4, "0");
              case "M":
                return a3 + 1;
              case "MM":
                return b2.s(a3 + 1, 2, "0");
              case "MMM":
                return h3(n3.monthsShort, a3, c4, 3);
              case "MMMM":
                return h3(c4, a3);
              case "D":
                return e11.$D;
              case "DD":
                return b2.s(e11.$D, 2, "0");
              case "d":
                return String(e11.$W);
              case "dd":
                return h3(n3.weekdaysMin, e11.$W, o3, 2);
              case "ddd":
                return h3(n3.weekdaysShort, e11.$W, o3, 3);
              case "dddd":
                return o3[e11.$W];
              case "H":
                return String(s3);
              case "HH":
                return b2.s(s3, 2, "0");
              case "h":
                return d3(1);
              case "hh":
                return d3(2);
              case "a":
                return $3(s3, u3, true);
              case "A":
                return $3(s3, u3, false);
              case "m":
                return String(u3);
              case "mm":
                return b2.s(u3, 2, "0");
              case "s":
                return String(e11.$s);
              case "ss":
                return b2.s(e11.$s, 2, "0");
              case "SSS":
                return b2.s(e11.$ms, 3, "0");
              case "Z":
                return i3;
            }
            return null;
          }(t4) || i3.replace(":", "");
        });
      }, m3.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m3.diff = function(r4, d3, l3) {
        var $3, y3 = this, M4 = b2.p(d3), m4 = O2(r4), v6 = (m4.utcOffset() - this.utcOffset()) * e10, g3 = this - m4, D3 = function() {
          return b2.m(y3, m4);
        };
        switch (M4) {
          case h2:
            $3 = D3() / 12;
            break;
          case c3:
            $3 = D3();
            break;
          case f2:
            $3 = D3() / 3;
            break;
          case o2:
            $3 = (g3 - v6) / 6048e5;
            break;
          case a2:
            $3 = (g3 - v6) / 864e5;
            break;
          case u2:
            $3 = g3 / n2;
            break;
          case s2:
            $3 = g3 / e10;
            break;
          case i2:
            $3 = g3 / t2;
            break;
          default:
            $3 = g3;
        }
        return l3 ? $3 : b2.a($3);
      }, m3.daysInMonth = function() {
        return this.endOf(c3).$D;
      }, m3.$locale = function() {
        return D2[this.$L];
      }, m3.locale = function(t3, e11) {
        if (!t3) return this.$L;
        var n3 = this.clone(), r4 = w2(t3, e11, true);
        return r4 && (n3.$L = r4), n3;
      }, m3.clone = function() {
        return b2.w(this.$d, this);
      }, m3.toDate = function() {
        return new Date(this.valueOf());
      }, m3.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, m3.toISOString = function() {
        return this.$d.toISOString();
      }, m3.toString = function() {
        return this.$d.toUTCString();
      }, M3;
    }(), k2 = _2.prototype;
    return O2.prototype = k2, [["$ms", r3], ["$s", i2], ["$m", s2], ["$H", u2], ["$W", a2], ["$M", c3], ["$y", h2], ["$D", d2]].forEach(function(t3) {
      k2[t3[1]] = function(e11) {
        return this.$g(e11, t3[0], t3[1]);
      };
    }), O2.extend = function(t3, e11) {
      return t3.$i || (t3(e11, _2, O2), t3.$i = true), O2;
    }, O2.locale = w2, O2.isDayjs = S2, O2.unix = function(t3) {
      return O2(1e3 * t3);
    }, O2.en = D2[g2], O2.Ls = D2, O2.p = {}, O2;
  });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
const dayjs = /* @__PURE__ */ getDefaultExportFromCjs(dayjs_minExports);
const permissionProps = {
  permissionCode: {
    type: String,
    required: false,
    validator(value, props) {
      if (isNullOrUndefinedOrWhiteSpace(value)) {
        return !isNullOrUndefinedOrWhiteSpace(props.resourceCode);
      }
      return true;
    }
  },
  resourceCode: {
    type: String,
    required: false,
    validator(value, props) {
      if (isNullOrUndefinedOrWhiteSpace(value)) {
        return !isNullOrUndefinedOrWhiteSpace(props.permissionCode);
      }
      return true;
    }
  },
  operator: {
    type: Number
  },
  data: {
    type: null,
    required: false
  },
  hasPermission: {
    type: Function
  },
  getPermissionCode: {
    type: Function
  },
  showDenied: {
    type: Boolean
  },
  deniedComponent: {
    type: [String, Object]
  }
};
const _hoisted_1$2 = { key: 2 };
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  ...{
    name: "Permission"
  },
  __name: "Permission",
  props: permissionProps,
  setup(__props) {
    var _a3;
    const vGlobalConfig = injectVantisGlobalConfig();
    const permissionOptions = (_a3 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a3.permissionOptions;
    const props = __props;
    const getPermissionCode = async () => {
      if (!isNullOrUndefinedOrWhiteSpace(props.permissionCode)) {
        return props.permissionCode;
      }
      if (!isNullOrUndefinedOrWhiteSpace(props.resourceCode)) {
        const getPermissionCode2 = props.getPermissionCode || (permissionOptions == null ? void 0 : permissionOptions.getPermissionCode);
        if (getPermissionCode2) {
          return await getPermissionCode2(props.permissionCode, props.operator, props.data);
        }
      }
    };
    const hasPermission = computedAsync(async () => {
      var _a4;
      const permissionCode = await getPermissionCode();
      if (isNullOrUndefinedOrWhiteSpace(permissionCode)) {
        console.error("没有获取到有效permissionCode，判定为没有权限！");
        return false;
      }
      const hasPermission2 = props.hasPermission || (permissionOptions == null ? void 0 : permissionOptions.hasPermission) || ((_a4 = vGlobalConfig == null ? void 0 : vGlobalConfig.value) == null ? void 0 : _a4.hasPermission);
      if (hasPermission2) {
        return await hasPermission2(permissionCode, props.data);
      }
      console.error("没有找到hasPermission方法，判定为没有权限！");
      return false;
    }, void 0);
    const actualDeniedComponent = computed(() => props.deniedComponent || (permissionOptions == null ? void 0 : permissionOptions.deniedComponent));
    return (_ctx, _cache) => {
      return unref(hasPermission) ? renderSlot(_ctx.$slots, "default", { key: 0 }) : unref(hasPermission) === false && !!_ctx.$slots.denied ? renderSlot(_ctx.$slots, "denied", { key: 1 }) : unref(hasPermission) === false && (_ctx.showDenied || !!_ctx.deniedComponent) ? (openBlock(), createElementBlock("div", _hoisted_1$2, [
        (openBlock(), createBlock(resolveDynamicComponent(actualDeniedComponent.value)))
      ])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$1 = { class: "instance-node__header" };
const _hoisted_2 = { class: "instance-node__body" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "instance-node__footer" };
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "InstanceNode",
  emits: ["editNodeInstance", "showNodeInstance"],
  setup(__props, { emit: __emit }) {
    const getNode = inject("getNode");
    const node = getNode();
    const container = ref();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    const emit = __emit;
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const vcGlobalConfig = injectVantisGlobalConfig();
    const nodeInstances = injectNodeInstancesRef();
    const nodeInstance = computed(() => {
      return nodeInstances == null ? void 0 : nodeInstances.value.find((i2) => i2.nodeId == node.data.nodeId);
    });
    const nodeClass = computed(() => {
      var _a3;
      let className = "";
      let nodeState = (_a3 = nodeInstance.value) == null ? void 0 : _a3.processNodeState;
      switch (nodeState) {
        case ProcessNodeState.autoFinished:
          className = "instance-node instance-node--autoFinished";
          break;
        case ProcessNodeState.finished:
          className = "instance-node instance-node--finished";
          break;
        case ProcessNodeState.paused:
          className = "instance-node instance-node--paused";
          break;
        case ProcessNodeState.saved:
          className = "instance-node instance-node--saved";
          break;
        case ProcessNodeState.waiting:
          className = "instance-node instance-node--waiting";
          break;
      }
      return className;
    });
    const processDefinition = injectProcessDefinition();
    const processNodeDefinition = computed(() => {
      var _a3;
      return (_a3 = processDefinition == null ? void 0 : processDefinition.processNodeDefinitions) == null ? void 0 : _a3.find((n2) => {
        var _a4;
        return n2.code == ((_a4 = nodeInstance.value) == null ? void 0 : _a4.nodeDefinitionCode);
      });
    });
    const showNodeInstance = () => {
      emit("showNodeInstance", nodeInstance.value);
    };
    const editNodeInstance = () => {
      emit("editNodeInstance", nodeInstance.value);
    };
    const { t: t2 } = useLocale();
    const formatDate = (date4) => {
      if (!date4) {
        return "";
      }
      return dayjs(date4).format("YYYY-MM-DD HH:mm");
    };
    const hasPermission = computed(() => {
      var _a3, _b3, _c3;
      return ((_b3 = (_a3 = vcGlobalConfig == null ? void 0 : vcGlobalConfig.value) == null ? void 0 : _a3.permissionOptions) == null ? void 0 : _b3.hasPermission) || ((_c3 = vcGlobalConfig == null ? void 0 : vcGlobalConfig.value) == null ? void 0 : _c3.hasPermission);
    });
    const canEdit = async (nodeInstance2) => {
      if (!hasPermission.value) {
        return false;
      }
      if (nodeInstance2.processNodeState == ProcessNodeState.waiting) {
        return await hasPermission.value("process.data.edit", nodeInstance2);
      }
      return false;
    };
    computedAsync(async () => {
      if (!nodeInstance.value) {
        return false;
      }
      return await canEdit(nodeInstance.value);
    });
    onErrorCaptured((error) => {
      console.error(error);
      return false;
    });
    return (_ctx, _cache) => {
      var _a3;
      const _component_el_descriptions_item = resolveComponent("el-descriptions-item");
      const _component_el_descriptions = resolveComponent("el-descriptions");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_button_group = resolveComponent("el-button-group");
      return nodeInstance.value != void 0 ? (openBlock(), createElementBlock("div", {
        key: 0,
        ref_key: "container",
        ref: container,
        class: normalizeClass(nodeClass.value)
      }, [
        createElementVNode("div", _hoisted_1$1, [
          createElementVNode("span", null, toDisplayString((_a3 = processNodeDefinition.value) == null ? void 0 : _a3.name), 1)
        ]),
        createElementVNode("div", _hoisted_2, [
          createVNode(_component_el_descriptions, { column: 1 }, {
            default: withCtx(() => [
              createVNode(_component_el_descriptions_item, {
                label: unref(t2)("Owner")
              }, {
                default: withCtx(() => {
                  var _a4;
                  return [
                    createTextVNode(toDisplayString((_a4 = nodeInstance.value.owner) == null ? void 0 : _a4.name), 1)
                  ];
                }),
                _: 1
              }, 8, ["label"]),
              createVNode(_component_el_descriptions_item, {
                label: unref(t2)("subject")
              }, {
                default: withCtx(() => [
                  createElementVNode("div", {
                    innerHTML: nodeInstance.value.subject
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_component_el_descriptions_item, {
                label: unref(t2)("FinishTime")
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(formatDate(nodeInstance.value.finishedTime)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              createVNode(_component_el_descriptions_item, {
                label: unref(t2)("State")
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)(nodeInstance.value.processNodeState)), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        createElementVNode("div", _hoisted_4, [
          createVNode(_component_el_button_group, null, {
            default: withCtx(() => [
              createVNode(_component_el_button, {
                type: "primary",
                onClick: showNodeInstance
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t2)("Details")), 1)
                ]),
                _: 1
              }),
              nodeInstance.value.processNodeState == unref(ProcessNodeState).waiting ? (openBlock(), createBlock(_sfc_main$5, {
                key: 0,
                data: nodeInstance.value,
                "permission-code": "process.data.edit"
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_button, {
                    onClick: editNodeInstance,
                    type: "primary"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(t2)("Approve")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])) : createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 2)) : createCommentVNode("", true);
    };
  }
});
const getRouteDefinitionByCode = (processGraph, code) => {
  return processGraph.processDefinitionOutput.processRouteDefinitions.firstOrUndefined((r3) => r3.code == code);
};
const getNodeDefinitionByCode = (processGraph, code) => {
  if (code === void 0) {
    return void 0;
  }
  return processGraph.processDefinitionOutput.processNodeDefinitions.firstOrUndefined((n2) => n2.code == code);
};
const getStartNodeDefinition = (processGraph) => {
  var _a3, _b3;
  return (_b3 = (_a3 = processGraph.processDefinitionOutput) == null ? void 0 : _a3.processNodeDefinitions) == null ? void 0 : _b3.singleOrUndefined((n2) => n2.nodeType == "initialNode");
};
const toFlowGraphViewModel = (processGraphOutput, options) => {
  const graphNodes = [];
  const graphEdges = [];
  if (!processGraphOutput) {
    return { graphNodes, graphEdges };
  }
  const lastNodeDataArray = [];
  if (processGraphOutput.nodeInstances && processGraphOutput.nodeInstances.length > 0) {
    const firstNodeInstance = processGraphOutput.nodeInstances.find((p2) => p2.previousNodeIds == void 0 || p2.previousNodeIds.length == 0) ?? processGraphOutput.nodeInstances[0];
    graphNodes.push(createFirstInstanceNode(firstNodeInstance));
    fromInstanceToFlowGraphViewModel(processGraphOutput, firstNodeInstance, lastNodeDataArray, graphNodes, graphEdges);
  } else {
    if (!(options == null ? void 0 : options.showOnlyInstances)) {
      const startNodeDefinition = getStartNodeDefinition(processGraphOutput);
      if (startNodeDefinition) {
        graphNodes.push(createFirstUserNodeView(startNodeDefinition));
        lastNodeDataArray.push({ nodeId: graphNodes[0].id, nodeDefinitionCode: startNodeDefinition.code });
      }
    }
  }
  if (!(options == null ? void 0 : options.showOnlyInstances)) {
    for (let i2 = 0; i2 < lastNodeDataArray.length; i2++) {
      fromProcessDefinitionToFlowGraphViewModel(processGraphOutput, lastNodeDataArray[i2].nodeId, lastNodeDataArray[i2].nodeDefinitionCode, graphNodes, graphEdges);
    }
  }
  return { graphNodes, graphEdges };
};
const tryPushEdge = (sourceId, targetId, graphEdges) => {
  const edge = createEdge(sourceId, targetId);
  if (graphEdges.some((e10) => e10.id == edge.id)) {
    return false;
  }
  graphEdges.push(edge);
  return true;
};
const ensurePushInstanceNode = (nodeInstance, graphNodes) => {
  const node = graphNodes.find((n2) => n2.id == nodeInstance.nodeId);
  if (node) {
    return node.id;
  } else {
    const graphNode = createInstanceNode(nodeInstance);
    graphNodes.push(graphNode);
    return nodeInstance.nodeId;
  }
};
const ensurePushUserNodeView = (nodeDefinition, graphNodes) => {
  const graphNode = createUserNodeView(nodeDefinition);
  if (graphNodes.some((n2) => n2.id == graphNode.id)) {
    return graphNode.id;
  }
  graphNodes.push(graphNode);
  return graphNode.id;
};
const fromInstanceToFlowGraphViewModel = (processGraphOutput, prevNodeInstance, lastNodeDataArray, graphNodes, graphEdges) => {
  const nextNodeInstances = processGraphOutput.nodeInstances.filter((n2) => {
    var _a3;
    return (_a3 = n2.previousNodeIds) == null ? void 0 : _a3.some((i2) => i2 === prevNodeInstance.nodeId);
  });
  if (nextNodeInstances.length == 0) {
    if (!lastNodeDataArray.some((i2) => i2.nodeId == prevNodeInstance.nodeId)) {
      lastNodeDataArray.push({ nodeId: prevNodeInstance.nodeId, nodeDefinitionCode: prevNodeInstance.nodeDefinitionCode });
    }
    return;
  }
  for (let i2 = 0; i2 < nextNodeInstances.length; i2++) {
    const nodeId = ensurePushInstanceNode(nextNodeInstances[i2], graphNodes);
    const routeDefinition = getRouteDefinitionByCode(processGraphOutput, nextNodeInstances[i2].routeDefinitionCode);
    if (routeDefinition) {
      tryPushEdge(prevNodeInstance.nodeId, nodeId, graphEdges);
    } else {
      if (!tryPushEdge(prevNodeInstance.nodeId, nodeId, graphEdges)) ;
    }
    fromInstanceToFlowGraphViewModel(processGraphOutput, nextNodeInstances[i2], lastNodeDataArray, graphNodes, graphEdges);
  }
};
const fromProcessDefinitionToFlowGraphViewModel = (processGraphOutput, prevNodeId, prevNodeDefinitionCode, graphNodes, graphEdges) => {
  const routeDefinitions = processGraphOutput.processDefinitionOutput.processRouteDefinitions.filter((r3) => r3.processNodeDefinitionCode == prevNodeDefinitionCode);
  if (routeDefinitions.length == 0) {
    return;
  }
  for (let i2 = 0; i2 < routeDefinitions.length; i2++) {
    const nodeDefinition = getNodeDefinitionByCode(processGraphOutput, routeDefinitions[i2].nextProcessNodeDefinitionCode);
    if (!nodeDefinition) {
      continue;
    }
    const userNodeId = ensurePushUserNodeView(nodeDefinition, graphNodes);
    if (!tryPushEdge(prevNodeId, userNodeId, graphEdges)) {
      continue;
    }
    fromProcessDefinitionToFlowGraphViewModel(processGraphOutput, userNodeId, nodeDefinition.code, graphNodes, graphEdges);
  }
};
const createFirstInstanceNode = (nodeInstance) => {
  return {
    id: nodeInstance.nodeId,
    shape: "instance-node",
    data: { nodeId: nodeInstance.nodeId, isInitialNode: true }
  };
};
const createInstanceNode = (nodeInstance) => {
  return {
    id: nodeInstance.nodeId,
    shape: "instance-node",
    data: { nodeId: nodeInstance.nodeId, isInitialNode: false }
  };
};
const createEdge = (sourceId, targetId) => {
  return {
    id: `${sourceId}-${targetId}`,
    source: sourceId,
    target: targetId
  };
};
const createUserNodeView = (nodeDefinition) => {
  return {
    id: nodeDefinition.code,
    shape: "user-node-view",
    data: { nodeDefinition }
  };
};
const createFirstUserNodeView = (nodeDefinition) => {
  return {
    id: nodeDefinition.code,
    shape: "initial-node-view",
    data: { nodeDefinition }
  };
};
const getNodeFormSchema = (processDefinition, nodeDefinitionCode) => {
  const nodeDefinition = processDefinition.processNodeDefinitions.find((p2) => p2.code === nodeDefinitionCode);
  if (nodeDefinition) {
    if (nodeDefinition.viewDescriptor) {
      return convertViewDescriptorToFormSchema(nodeDefinition.viewDescriptor);
    }
    const viewDescriptor = processDefinition.viewDescriptor;
    return convertViewDescriptorToFormSchema(viewDescriptor);
  }
  return void 0;
};
const getPendingFormSchema = (processDefinition, nodeDefinitionCode) => {
  var _a3;
  const nodeDefinition = processDefinition.processNodeDefinitions.find((p2) => p2.code === nodeDefinitionCode);
  let viewOptions = void 0;
  if (nodeDefinition) {
    if (nodeDefinition.viewDescriptor) {
      return convertViewDescriptorToFormSchema(nodeDefinition.viewDescriptor);
    }
    viewOptions = nodeDefinition.viewOptions;
  }
  const viewDescriptor = processDefinition.viewDescriptor;
  const formSchema = convertViewDescriptorToFormSchema(viewDescriptor);
  const hiddenProperties = viewOptions == null ? void 0 : viewOptions.componentOptions.filter((v2) => v2.hidden == true).map((o2) => o2.propertyName);
  if ((_a3 = formSchema.formConfig) == null ? void 0 : _a3.defaultModel) {
    if (hiddenProperties && hiddenProperties.length > 0) {
      for (let name of hiddenProperties) {
        formSchema.formConfig.defaultModel[name] = void 0;
      }
    }
  }
  if (hiddenProperties && hiddenProperties.length > 0) {
    formSchema.widgets = formSchema.widgets.filter((w2) => !hiddenProperties.includes(w2.__vModel__));
  }
  if (viewOptions && viewOptions.componentOptions && viewOptions.componentOptions.length > 0) {
    for (let componentOption of viewOptions.componentOptions) {
      const fieldSchema = formSchema.widgets.find((w2) => w2.__vModel__ == componentOption.propertyName);
      if (!fieldSchema) {
        continue;
      }
      fieldSchema.readonly = fieldSchema.__config__.readonly || componentOption.readonly;
      fieldSchema.disabled = fieldSchema.__config__.disabled || componentOption.disabled || componentOption.readonly;
    }
  }
  return formSchema;
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "InitialNodeView",
  setup(__props) {
    const getNode = inject("getNode");
    const node = getNode();
    const resizeNodeToContainerSize = () => {
      const divElement = container.value;
      const height = divElement.offsetHeight;
      const width2 = divElement.offsetWidth;
      node.size(width2, height);
    };
    onUpdated(() => {
      resizeNodeToContainerSize();
    });
    onMounted(() => {
      resizeNodeToContainerSize();
    });
    const container = ref();
    onErrorCaptured((error) => {
      console.log(error);
    });
    const { t: t2 } = useLocale();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "graph-node-box graph-node-box--initial",
        ref_key: "container",
        ref: container
      }, [
        _cache[1] || (_cache[1] = createElementVNode("div", { class: "node-box__title" }, [
          createElementVNode("span", null, "t('Initiator')")
        ], -1)),
        createVNode(unref(ElRow), { class: "node-box__context" }, {
          default: withCtx(() => [
            createVNode(unref(ElCol), {
              span: 20,
              class: "node-box__context__text"
            }, {
              default: withCtx(() => _cache[0] || (_cache[0] = [
                createTextVNode(" Applicant ")
              ])),
              _: 1,
              __: [0]
            }),
            createVNode(unref(ElCol), { span: 4 }, {
              default: withCtx(() => [
                createVNode(unref(ElIcon), { class: "node-box__context__arrow" }, {
                  default: withCtx(() => [
                    createVNode(unref(arrow_right_default))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 512);
    };
  }
});
const content = `.x6-widget-minimap {
  position: relative;
  display: table-cell;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  background-color: #fff;
  user-select: none;
}
.x6-widget-minimap .x6-graph {
  display: inline-block;
  box-shadow: 0 0 4px 0 #eee;
  cursor: pointer;
}
.x6-widget-minimap .x6-graph > svg {
  pointer-events: none;
  shape-rendering: optimizespeed;
}
.x6-widget-minimap .x6-graph .x6-node * {
  /* stylelint-disable-next-line */
  vector-effect: initial;
}
.x6-widget-minimap-viewport {
  position: absolute;
  box-sizing: content-box !important;
  margin: -2px 0 0 -2px;
  border: 2px solid #31d0c6;
  cursor: move;
}
.x6-widget-minimap-viewport-zoom {
  position: absolute;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 12px;
  height: 12px;
  margin: 0 -6px -6px 0;
  background-color: #fff;
  border: 2px solid #31d0c6;
  border-radius: 50%;
  cursor: nwse-resize;
}
`;
var __decorate = function(decorators, target, key, desc) {
  var c3 = arguments.length, r3 = c3 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r3 = Reflect.decorate(decorators, target, key, desc);
  else for (var i2 = decorators.length - 1; i2 >= 0; i2--) if (d2 = decorators[i2]) r3 = (c3 < 3 ? d2(r3) : c3 > 3 ? d2(target, key, r3) : d2(target, key)) || r3;
  return c3 > 3 && r3 && Object.defineProperty(target, key, r3), r3;
};
class MiniMap extends View {
  get scroller() {
    return this.graph.getPlugin("scroller");
  }
  get graphContainer() {
    if (this.scroller) {
      return this.scroller.container;
    }
    return this.graph.container;
  }
  constructor(options) {
    super();
    this.name = "minimap";
    this.options = Object.assign(Object.assign({}, Util.defaultOptions), options);
    CssLoader.ensure(this.name, content);
  }
  init(graph) {
    this.graph = graph;
    this.updateViewport = FunctionExt.debounce(this.updateViewport.bind(this), 0);
    this.container = document.createElement("div");
    Dom.addClass(this.container, this.prefixClassName(ClassName.root));
    const graphContainer = document.createElement("div");
    this.container.appendChild(graphContainer);
    this.viewport = document.createElement("div");
    Dom.addClass(this.viewport, this.prefixClassName(ClassName.viewport));
    if (this.options.scalable) {
      this.zoomHandle = document.createElement("div");
      Dom.addClass(this.zoomHandle, this.prefixClassName(ClassName.zoom));
      Dom.appendTo(this.zoomHandle, this.viewport);
    }
    Dom.append(this.container, this.viewport);
    Dom.css(this.container, {
      width: this.options.width,
      height: this.options.height,
      padding: this.options.padding
    });
    if (this.options.container) {
      this.options.container.appendChild(this.container);
    }
    this.sourceGraph = this.graph;
    const targetGraphOptions = Object.assign(Object.assign({}, this.options.graphOptions), { container: graphContainer, model: this.sourceGraph.model, interacting: false, grid: false, background: false, embedding: false });
    this.targetGraph = this.options.createGraph ? this.options.createGraph(targetGraphOptions) : new Graph$2(targetGraphOptions);
    this.updatePaper(this.sourceGraph.options.width, this.sourceGraph.options.height);
    this.startListening();
  }
  startListening() {
    if (this.scroller) {
      Dom.Event.on(this.graphContainer, `scroll${this.getEventNamespace()}`, this.updateViewport);
    } else {
      this.sourceGraph.on("translate", this.onTransform, this);
      this.sourceGraph.on("scale", this.onTransform, this);
      this.sourceGraph.on("model:updated", this.onModelUpdated, this);
    }
    this.sourceGraph.on("resize", this.updatePaper, this);
    this.delegateEvents({
      mousedown: "startAction",
      touchstart: "startAction",
      [`mousedown .${this.prefixClassName("graph")}`]: "scrollTo",
      [`touchstart .${this.prefixClassName("graph")}`]: "scrollTo"
    });
  }
  stopListening() {
    if (this.scroller) {
      Dom.Event.off(this.graphContainer, this.getEventNamespace());
    } else {
      this.sourceGraph.off("translate", this.onTransform, this);
      this.sourceGraph.off("scale", this.onTransform, this);
      this.sourceGraph.off("model:updated", this.onModelUpdated, this);
    }
    this.sourceGraph.off("resize", this.updatePaper, this);
    this.undelegateEvents();
  }
  onRemove() {
    this.stopListening();
    this.targetGraph.dispose(false);
  }
  onTransform(options) {
    if (options.ui || this.targetGraphTransforming || !this.scroller) {
      this.updateViewport();
    }
  }
  onModelUpdated() {
    this.targetGraph.zoomToFit();
  }
  updatePaper(w2, h2) {
    let width2;
    let height;
    if (typeof w2 === "object") {
      width2 = w2.width;
      height = w2.height;
    } else {
      width2 = w2;
      height = h2;
    }
    const origin = this.sourceGraph.options;
    const scale = this.sourceGraph.transform.getScale();
    const maxWidth = this.options.width - 2 * this.options.padding;
    const maxHeight = this.options.height - 2 * this.options.padding;
    width2 /= scale.sx;
    height /= scale.sy;
    this.ratio = Math.min(maxWidth / width2, maxHeight / height);
    const ratio = this.ratio;
    const x2 = origin.x * ratio / scale.sx;
    const y2 = origin.y * ratio / scale.sy;
    width2 *= ratio;
    height *= ratio;
    this.targetGraph.resize(width2, height);
    this.targetGraph.translate(x2, y2);
    if (this.scroller) {
      this.targetGraph.scale(ratio, ratio);
    } else {
      this.targetGraph.zoomToFit();
    }
    this.updateViewport();
    return this;
  }
  updateViewport() {
    const sourceGraphScale = this.sourceGraph.transform.getScale();
    const targetGraphScale = this.targetGraph.transform.getScale();
    let origin = null;
    if (this.scroller) {
      origin = this.scroller.clientToLocalPoint(0, 0);
    } else {
      origin = this.graph.graphToLocal(0, 0);
    }
    const position2 = Dom.position(this.targetGraph.container);
    const translation = this.targetGraph.translate();
    translation.ty = translation.ty || 0;
    this.geometry = {
      top: position2.top + origin.y * targetGraphScale.sy + translation.ty,
      left: position2.left + origin.x * targetGraphScale.sx + translation.tx,
      width: this.graphContainer.clientWidth * targetGraphScale.sx / sourceGraphScale.sx,
      height: this.graphContainer.clientHeight * targetGraphScale.sy / sourceGraphScale.sy
    };
    Dom.css(this.viewport, this.geometry);
  }
  startAction(evt) {
    const e10 = this.normalizeEvent(evt);
    const action = e10.target === this.zoomHandle ? "zooming" : "panning";
    const { tx: tx2, ty: ty2 } = this.sourceGraph.translate();
    const eventData = {
      action,
      clientX: e10.clientX,
      clientY: e10.clientY,
      scrollLeft: this.graphContainer.scrollLeft,
      scrollTop: this.graphContainer.scrollTop,
      zoom: this.sourceGraph.zoom(),
      scale: this.sourceGraph.transform.getScale(),
      geometry: this.geometry,
      translateX: tx2,
      translateY: ty2
    };
    this.targetGraphTransforming = true;
    this.delegateDocumentEvents(Util.documentEvents, eventData);
  }
  doAction(evt) {
    const e10 = this.normalizeEvent(evt);
    const clientX = e10.clientX;
    const clientY = e10.clientY;
    const data = e10.data;
    switch (data.action) {
      case "panning": {
        const scale = this.sourceGraph.transform.getScale();
        const rx2 = (clientX - data.clientX) * scale.sx;
        const ry2 = (clientY - data.clientY) * scale.sy;
        if (this.scroller) {
          this.graphContainer.scrollLeft = data.scrollLeft + rx2 / this.ratio;
          this.graphContainer.scrollTop = data.scrollTop + ry2 / this.ratio;
        } else {
          this.sourceGraph.translate(data.translateX - rx2 / this.ratio, data.translateY - ry2 / this.ratio);
        }
        break;
      }
      case "zooming": {
        const startScale = data.scale;
        const startGeometry = data.geometry;
        const delta = 1 + (data.clientX - clientX) / startGeometry.width / startScale.sx;
        if (data.frameId) {
          cancelAnimationFrame(data.frameId);
        }
        data.frameId = requestAnimationFrame(() => {
          this.sourceGraph.zoom(delta * data.zoom, {
            absolute: true,
            minScale: this.options.minScale,
            maxScale: this.options.maxScale
          });
        });
        break;
      }
    }
  }
  stopAction() {
    this.undelegateDocumentEvents();
    this.targetGraphTransforming = false;
  }
  scrollTo(evt) {
    const e10 = this.normalizeEvent(evt);
    let x2;
    let y2;
    const ts2 = this.targetGraph.translate();
    ts2.ty = ts2.ty || 0;
    if (e10.offsetX == null) {
      const offset = Dom.offset(this.targetGraph.container);
      x2 = e10.pageX - offset.left;
      y2 = e10.pageY - offset.top;
    } else {
      x2 = e10.offsetX;
      y2 = e10.offsetY;
    }
    const cx2 = (x2 - ts2.tx) / this.ratio;
    const cy2 = (y2 - ts2.ty) / this.ratio;
    this.sourceGraph.centerPoint(cx2, cy2);
  }
  dispose() {
    this.remove();
    CssLoader.clean(this.name);
  }
}
__decorate([
  View.dispose()
], MiniMap.prototype, "dispose", null);
var ClassName;
(function(ClassName2) {
  ClassName2.root = "widget-minimap";
  ClassName2.viewport = `${ClassName2.root}-viewport`;
  ClassName2.zoom = `${ClassName2.viewport}-zoom`;
})(ClassName || (ClassName = {}));
var Util;
(function(Util2) {
  Util2.defaultOptions = {
    width: 300,
    height: 200,
    padding: 10,
    scalable: true,
    minScale: 0.01,
    maxScale: 16,
    graphOptions: {},
    createGraph: (options) => new Graph$2(options)
  };
  Util2.documentEvents = {
    mousemove: "doAction",
    touchmove: "doAction",
    mouseup: "stopAction",
    touchend: "stopAction"
  };
})(Util || (Util = {}));
const _hoisted_1 = { style: { "width": "100%", "height": "100%" } };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "FlowGraphRender",
  props: {
    processGraphOutput: {},
    getNodeFormData: { type: Function },
    onSubmit: { type: [Object, Function] },
    showOnlyInstances: { type: Boolean }
  },
  emits: ["submitSuccessfully", "submitFailed"],
  setup(__props, { emit: __emit }) {
    var _a3;
    const props = __props;
    const emit = __emit;
    const nodeInstancesRef = ref();
    const edges = shallowRef([]);
    const nodes = shallowRef([]);
    const dagreLayout = new DagreLayout({
      type: "dagre",
      rankdir: "LR",
      nodesepFunc: (d2) => {
        return 100;
      },
      ranksepFunc: (d2) => {
        return 100;
      }
    });
    let graph = void 0;
    watch([() => props.processGraphOutput, () => props.showOnlyInstances], () => {
      var _a4;
      const { graphEdges, graphNodes } = toFlowGraphViewModel(props.processGraphOutput, { showOnlyInstances: props.showOnlyInstances });
      edges.value = graphEdges;
      nodes.value = graphNodes;
      nodeInstancesRef.value = (_a4 = props.processGraphOutput) == null ? void 0 : _a4.nodeInstances;
      if (graph) {
        renderGraph();
      }
    }, { deep: true, immediate: true });
    const getFormSchema = (nodeCode) => {
      return getNodeFormSchema(props.processGraphOutput.processDefinitionOutput, nodeCode);
    };
    const appContext = (_a3 = getCurrentInstance()) == null ? void 0 : _a3.appContext;
    const elementGlobalConfig = useGlobalConfig();
    const vcGlobalConfig = injectVantisGlobalConfig();
    const registerCustomShape = () => {
      const setup = () => {
        if (appContext) {
          const instance = getCurrentInstance();
          instance.appContext = appContext;
        }
        provideGetFormSchemaFunc(getFormSchema);
        provideGlobalConfig(elementGlobalConfig);
        provideNodeInstancesRef(nodeInstancesRef);
        provideProcessDefinition(props.processGraphOutput.processDefinitionOutput);
        if (vcGlobalConfig) {
          provideVantisGlobalConfig(vcGlobalConfig);
        }
      };
      registerVueNode({ config: { shape: "user-node-view", width: 230, height: 71, component: _sfc_main$7 }, setup });
      registerVueNode({ config: { shape: "condition-view", width: 230, height: 71, component: _sfc_main$6 }, setup });
      registerVueNode({ config: { shape: "initial-node-view", width: 230, height: 71, component: _sfc_main$3 }, setup });
      registerVueNode({
        config: { shape: "instance-node", width: 220, height: 71, component: _sfc_main$4 },
        setup,
        buildProps: () => {
          return {
            onEditNodeInstance: async (nodeInstanceItem) => {
              activeNodeInstance.value = nodeInstanceItem;
              formModel.value = await props.getNodeFormData(nodeInstanceItem.nodeId);
              formDisabled.value = false;
              formVisible.value = true;
            },
            onShowNodeInstance: async (nodeInstanceItem) => {
              activeNodeInstance.value = nodeInstanceItem;
              formModel.value = await props.getNodeFormData(nodeInstanceItem.nodeId);
              formDisabled.value = true;
              formVisible.value = true;
            }
          };
        }
      });
    };
    registerCustomShape();
    const container = ref();
    const formVisible = ref(false);
    const formDisabled = ref(false);
    const activeNodeInstance = ref();
    const formSchema = computed(() => {
      return getPendingFormSchema(props.processGraphOutput.processDefinitionOutput, activeNodeInstance.value.nodeDefinitionCode);
    });
    const formModel = ref();
    const submitSuccessfully = (submitBody, purpose, response) => {
      formVisible.value = false;
      emit("submitSuccessfully", submitBody, purpose, response);
    };
    const submitBodyBuild = (data) => {
      var _a4;
      return { processNodeInstanceId: (_a4 = activeNodeInstance.value) == null ? void 0 : _a4.nodeId, data };
    };
    const submitFailed = (submitBody, purpose, response, error) => {
      emit("submitFailed", submitBody, purpose, response, error);
    };
    const renderGraph = () => {
      if (edges.value.length == 0 && nodes.value.length == 0) {
        return;
      }
      const layoutModel = dagreLayout.layout({ edges: edges.value, nodes: nodes.value });
      graph.fromJSON(layoutModel);
    };
    onMounted(() => {
      graph = new Graph$2({
        container: container.value,
        grid: true,
        panning: true,
        autoResize: true,
        mousewheel: {
          enabled: true,
          zoomAtMousePosition: true,
          modifiers: "ctrl",
          minScale: 0.5,
          maxScale: 3
        },
        connecting: {
          router: "manhattan",
          connector: {
            name: "jumpover",
            args: {
              radius: 8
            }
          },
          anchor: "orth",
          connectionPoint: "boundary",
          allowBlank: false,
          allowMulti: false,
          snap: {
            radius: 20
          }
        },
        background: {
          color: "#F2F7FA"
        }
      });
      graph.use(
        new MiniMap({
          container: miniMapContainer.value,
          width: 200,
          height: 200,
          padding: 10
        })
      );
      graph.on("edge:mouseenter", (context) => {
        context.edge.attr("line/stroke", "red");
        context.edge.toFront();
      });
      graph.on("edge:mouseleave", (context) => {
        context.edge.attr("line/stroke", "black");
      });
      renderGraph();
    });
    const miniMapContainer = ref();
    return (_ctx, _cache) => {
      const _component_el_dialog = resolveComponent("el-dialog");
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", {
            ref_key: "miniMapContainer",
            ref: miniMapContainer,
            class: "mini-map"
          }, null, 512),
          createElementVNode("div", {
            ref_key: "container",
            ref: container
          }, null, 512)
        ]),
        activeNodeInstance.value != void 0 ? (openBlock(), createBlock(_component_el_dialog, {
          key: 0,
          style: { "width": "80%" },
          modelValue: formVisible.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => formVisible.value = $event),
          draggable: true
        }, {
          default: withCtx(() => [
            (openBlock(), createBlock(component$4, {
              key: activeNodeInstance.value.nodeId,
              "form-schema": formSchema.value,
              modelValue: formModel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formModel.value = $event),
              disabled: formDisabled.value,
              onSubmitSuccessfully: submitSuccessfully,
              onSubmitFailed: submitFailed,
              "on-submit": props.onSubmit,
              "submit-body-build": submitBodyBuild,
              style: { "height": "70vh", "overflow-y": "auto" }
            }, null, 8, ["form-schema", "modelValue", "disabled", "on-submit"]))
          ]),
          _: 1
        }, 8, ["modelValue"])) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const component = /* @__PURE__ */ _export_sfc$1(_sfc_main$2, [["__scopeId", "data-v-e490751b"]]);
const VcFlowGraphRender = withInstall(component);
const VcFormRender = withInstall(component$4);
const TemplateEditor = withInstall(component$2);
const VcConditionEditor = withInstall(component$3);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "EditTable",
  props: {
    dataSource: { default: () => [] },
    draggable: { type: Boolean }
  },
  setup(__props, { expose: __expose }) {
    const props = __props;
    const formModel = ref({
      model: []
    });
    const form = ref();
    const formProps = ref(/* @__PURE__ */ new Set());
    const tableData = computed(() => formModel.value.model.map(({ data }) => data));
    const resultData = computed(() => {
      return formModel.value.model.reduce((resultData2, model) => {
        if (model.isNew) {
          return resultData2;
        }
        resultData2.push({
          ...model.data
        });
        return resultData2;
      }, []);
    });
    const convertFormModel = (data) => data.map(
      (row) => ({
        data: { ...row },
        formData: { ...row },
        isEditing: false,
        isNew: false
      })
    );
    watch(() => props.dataSource, async () => {
      if (isFunction$2(props.dataSource)) {
        const data = props.dataSource();
        if (isPromise(data)) {
          const initData = await data;
          formModel.value.model = convertFormModel(initData);
        } else {
          formModel.value.model = convertFormModel(data);
        }
      } else if (Array.isArray(props.dataSource)) {
        formModel.value.model = convertFormModel(props.dataSource);
      }
    }, { immediate: true });
    const generateValidateFields = (index2) => Array.from(formProps.value).map((prop) => `model.${index2}.formData.${prop}`);
    const startEditable = (index2) => {
      formModel.value.model[index2].isEditing = true;
    };
    const deleteRow = (index2) => {
      formModel.value.model.splice(index2, 1);
    };
    const addRow = (row = {}) => {
      formModel.value.model.push({
        data: { ...row },
        formData: { ...row },
        isEditing: true,
        isNew: true
      });
    };
    const changeRowIndex = (oldIndex, newIndex) => {
      const item = formModel.value.model[oldIndex];
      formModel.value.model.splice(oldIndex, 1);
      formModel.value.model.splice(newIndex, 0, item);
    };
    const cancelEditable = (index2) => {
      if (!form.value) {
        return;
      }
      form.value.resetFields && form.value.resetFields(generateValidateFields(index2));
      const formModelItem = formModel.value.model[index2];
      formModelItem.formData = { ...formModelItem.data };
      if (formModelItem.isNew) {
        formModel.value.model.splice(index2, 1);
      } else {
        formModelItem.isEditing = false;
      }
    };
    const saveEditable = (index2) => {
      if (!form.value) {
        return;
      }
      form.value.validateField && form.value.validateField(generateValidateFields(index2), (validated) => {
        if (!validated) {
          return;
        }
        const formModelItem = formModel.value.model[index2];
        formModelItem.data = { ...formModelItem.formData };
        formModelItem.isEditing = false;
        formModelItem.isNew = false;
      });
    };
    const editActions = {
      addRow,
      deleteRow,
      startEditable,
      cancelEditable,
      saveEditable,
      changeRowIndex
    };
    const saveAllEditable = async () => {
      if (!form.value) {
        return;
      }
      if (!form.value.validate) {
        return;
      }
      return await form.value.validate((validated) => {
        if (!validated) {
          return;
        }
        formModel.value.model.filter((f2) => f2.isEditing || f2.isNew).forEach((formModelItem) => {
          formModelItem.data = { ...formModelItem.formData };
          formModelItem.isEditing = false;
          formModelItem.isNew = false;
        });
      });
    };
    provide("formModel", formModel);
    provide("formProps", formProps);
    provide("editActions", editActions);
    __expose({
      resultData,
      editActions,
      saveAllEditable
    });
    return (_ctx, _cache) => {
      const _component_el_table = resolveComponent("el-table");
      const _component_el_form = resolveComponent("el-form");
      return openBlock(), createBlock(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formModel.value
      }, {
        default: withCtx(() => [
          _ctx.draggable ? (openBlock(), createBlock(unref(lo$2), {
            key: 0,
            modelValue: formModel.value.model,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => formModel.value.model = $event),
            sort: true,
            target: "tbody",
            animation: 150,
            handle: ".el-table__row"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_table, mergeProps(_ctx.$attrs, { data: tableData.value }), {
                empty: withCtx(() => [
                  renderSlot(_ctx.$slots, "empty")
                ]),
                append: withCtx(() => [
                  renderSlot(_ctx.$slots, "append")
                ]),
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
              }, 16, ["data"])
            ]),
            _: 3
          }, 8, ["modelValue"])) : (openBlock(), createBlock(_component_el_table, mergeProps({ key: 1 }, _ctx.$attrs, { data: tableData.value }), {
            empty: withCtx(() => [
              renderSlot(_ctx.$slots, "empty")
            ]),
            append: withCtx(() => [
              renderSlot(_ctx.$slots, "append")
            ]),
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16, ["data"]))
        ]),
        _: 3
      }, 8, ["model"]);
    };
  }
});
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "EditTableColumn",
  props: {
    prop: { default: "" },
    label: { default: "" },
    width: {},
    rules: {}
  },
  setup(__props) {
    const props = __props;
    const defaultEditActions = {
      addRow: () => {
      },
      deleteRow: () => {
      },
      startEditable: () => {
      },
      cancelEditable: () => {
      },
      saveEditable: () => {
      },
      changeRowIndex: () => {
      }
    };
    const editActions = inject("editActions");
    const formModel = inject("formModel");
    const formProps = inject("formProps");
    watchEffect(() => {
      var _a3;
      if (props.prop) {
        (_a3 = formProps == null ? void 0 : formProps.value) == null ? void 0 : _a3.add(props.prop);
      }
    });
    const getEditModel = (index2) => {
      var _a3;
      if (!formModel || !((_a3 = formModel.value) == null ? void 0 : _a3.model)) {
        return {
          isEditing: false,
          isNew: false,
          formData: {},
          data: {}
        };
      }
      return formModel.value.model[index2];
    };
    const getEditRow = (index2) => getEditModel(index2).formData;
    const isEditing = (index2) => getEditModel(index2).isEditing ?? false;
    const calculateColumnDefaultValue = (scope) => {
      var _a3;
      return (_a3 = scope.row) == null ? void 0 : _a3[props.prop];
    };
    return (_ctx, _cache) => {
      const _component_el_form_item = resolveComponent("el-form-item");
      const _component_el_table_column = resolveComponent("el-table-column");
      return openBlock(), createBlock(_component_el_table_column, mergeProps(_ctx.$attrs, {
        prop: _ctx.prop,
        label: _ctx.label,
        width: _ctx.width
      }), {
        default: withCtx((scope) => [
          isEditing(scope.$index) ? (openBlock(), createBlock(_component_el_form_item, {
            key: 0,
            prop: `model.${scope.$index}.formData.${_ctx.prop}`,
            rules: _ctx.rules
          }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "edit", {
                $index: scope.$index,
                row: getEditRow(scope.$index),
                column: scope.column,
                actions: unref(editActions) ?? defaultEditActions
              }, () => [
                createTextVNode(toDisplayString(calculateColumnDefaultValue(scope)), 1)
              ])
            ]),
            _: 2
          }, 1032, ["prop", "rules"])) : renderSlot(_ctx.$slots, "default", {
            key: 1,
            $index: scope.$index,
            row: scope.row,
            column: scope.column,
            actions: unref(editActions) ?? defaultEditActions
          }, () => [
            createTextVNode(toDisplayString(calculateColumnDefaultValue(scope)), 1)
          ])
        ]),
        header: withCtx(() => [
          renderSlot(_ctx.$slots, "header")
        ]),
        _: 3
      }, 16, ["prop", "label", "width"]);
    };
  }
});
const EditTable = withInstall(_sfc_main$1);
const vcEditTableColumn = withInstall(_sfc_main);
const VcPermission = withInstall(_sfc_main$5);
const components2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ConfigProvider,
  EditTable,
  ProcessNodeState,
  TemplateEditor,
  VcConditionEditor,
  VcDataSource,
  VcFlowDesigner,
  VcFlowGraphRender,
  VcFormDesigner,
  VcFormRender,
  VcPermission,
  VcSvgIcon,
  VcUpload,
  buildComponent,
  convertFormSchemaToViewDescriptor,
  convertViewDescriptorToFormSchema,
  createDataSource,
  dataSourceManager,
  getFlowConditionOptions,
  registerHandlerFinderDefinition,
  vcEditTableColumn
}, Symbol.toStringTag, { value: "Module" }));
const install = (app) => {
  for (let n2 in components2) {
    if (components2[n2].install) {
      app.use(components2[n2]);
    }
  }
};
export {
  EditTable as A,
  vcEditTableColumn as B,
  ConfigProvider as C,
  VcPermission as D,
  ElementPlusIcons as E,
  IconWrapper as I,
  ProcessNodeState as P,
  TemplateEditor as T,
  VcFormDesigner as V,
  _sfc_main$J as _,
  _export_sfc$1 as a,
  _sfc_main$1 as b,
  close_default as c,
  dataSourceManager as d,
  _sfc_main as e,
  install as f,
  getFormFieldsItems as g,
  buildComponent as h,
  injectFormSchema as i,
  VcDataSource as j,
  createDataSource as k,
  lo$2 as l,
  VcFlowDesigner as m,
  registerHandlerFinderDefinition as n,
  operation_default as o,
  getFlowConditionOptions as p,
  convertViewDescriptorToFormSchema as q,
  remove_default as r,
  setting_default as s,
  convertFormSchemaToViewDescriptor as t,
  useLocale as u,
  VcSvgIcon as v,
  VcUpload as w,
  VcFlowGraphRender as x,
  VcFormRender as y,
  VcConditionEditor as z
};
//# sourceMappingURL=index-vf3Tgbxd.js.map
